'use strict';
// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module unless amdModuleId is set
        define([], function () {
            return (factory());
        });
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        factory();
    }
}(this, function () {

    /**
     * @ngdoc overview
     * @name pascalprecht.translate
     *
     * @description
     * The main module which holds everything together.
     */
    runTranslate.$inject = ['$translate'];
    $translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
    $translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
    translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
    translateAttrDirective.$inject = ['$translate', '$rootScope'];
    translateCloakDirective.$inject = ['$translate', '$rootScope'];
    translateFilterFactory.$inject = ['$parse', '$translate'];
    $translationCache.$inject = ['$cacheFactory'];
    angular.module('pascalprecht.translate', ['ng'])
        .run(runTranslate);

    function runTranslate($translate) {

var key = $translate.storageKey(),
            storage = $translate.storage();

        var fallbackFromIncorrectStorageValue = function () {
            var preferred = $translate.preferredLanguage();
            if (angular.isString(preferred)) {
                $translate.use(preferred);
                // $translate.use() will also remember the language.
                // So, we don't need to call storage.put() here.
            } else {
                storage.put(key, $translate.use());
            }
        };

        fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

        if (storage) {
            if (!storage.get(key)) {
                fallbackFromIncorrectStorageValue();
            } else {
                $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
            }
        } else if (angular.isString($translate.preferredLanguage())) {
            $translate.use($translate.preferredLanguage());
        }
    }

    runTranslate.displayName = 'runTranslate';

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateSanitizationProvider
     *
     * @description
     *
     * Configurations for $translateSanitization
     */
    angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

    function $translateSanitizationProvider() {

var $sanitize,
            $sce,
            currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
            hasConfiguredStrategy = false,
            hasShownNoStrategyConfiguredWarning = false,
            strategies;

        /**
         * Definition of a sanitization strategy function
         * @callback StrategyFunction
         * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
         * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
         * @return {string|object}
         */

        /**
         * @ngdoc property
         * @name strategies
         * @propertyOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Following strategies are built-in:
         * <dl>
         *   <dt>sanitize</dt>
         *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
         *   <dt>escape</dt>
         *   <dd>Escapes HTML in the translation</dd>
         *   <dt>sanitizeParameters</dt>
         *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
         *   <dt>escapeParameters</dt>
         *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
         *   <dt>escaped</dt>
         *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
         * </dl>
         *
         */

        strategies = {
            sanitize: function (value, mode/*, context*/) {
                if (mode === 'text') {
                    value = htmlSanitizeValue(value);
                }
                return value;
            },
            escape: function (value, mode/*, context*/) {
                if (mode === 'text') {
                    value = htmlEscapeValue(value);
                }
                return value;
            },
            sanitizeParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlSanitizeValue);
                }
                return value;
            },
            escapeParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlEscapeValue);
                }
                return value;
            },
            sce: function (value, mode, context) {
                if (mode === 'text') {
                    value = htmlTrustValue(value);
                } else if (mode === 'params') {
                    if (context !== 'filter') {
                        // do html escape in filter context #1101
                        value = mapInterpolationParameters(value, htmlEscapeValue);
                    }
                }
                return value;
            },
            sceParameters: function (value, mode/*, context*/) {
                if (mode === 'params') {
                    value = mapInterpolationParameters(value, htmlTrustValue);
                }
                return value;
            }
        };
        // Support legacy strategy name 'escaped' for backwards compatibility.
        // TODO should be removed in 3.0
        strategies.escaped = strategies.escapeParameters;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Adds a sanitization strategy to the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @param {StrategyFunction} strategyFunction - strategy function
         * @returns {object} this
         */
        this.addStrategy = function (strategyName, strategyFunction) {
            strategies[strategyName] = strategyFunction;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Removes a sanitization strategy from the list of known strategies.
         *
         * @param {string} strategyName - unique key for a strategy
         * @returns {object} this
         */
        this.removeStrategy = function (strategyName) {
            delete strategies[strategyName];
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
         * @methodOf pascalprecht.translate.$translateSanitizationProvider
         *
         * @description
         * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
         *
         * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
         * @returns {object} this
         */
        this.useStrategy = function (strategy) {
            hasConfiguredStrategy = true;
            currentStrategy = strategy;
            return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translateSanitization
         * @requires $injector
         * @requires $log
         *
         * @description
         * Sanitizes interpolation parameters and translated texts.
         *
         */
        this.$get = ['$injector', '$log', function ($injector, $log) {

            var cachedStrategyMap = {};

            var applyStrategies = function (value, mode, context, selectedStrategies) {
                angular.forEach(selectedStrategies, function (selectedStrategy) {
                    if (angular.isFunction(selectedStrategy)) {
                        value = selectedStrategy(value, mode, context);
                    } else if (angular.isFunction(strategies[selectedStrategy])) {
                        value = strategies[selectedStrategy](value, mode, context);
                    } else if (angular.isString(strategies[selectedStrategy])) {
                        if (!cachedStrategyMap[strategies[selectedStrategy]]) {
                            try {
                                cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
                            } catch (e) {
                                cachedStrategyMap[strategies[selectedStrategy]] = function () {
                                };
                                throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
                            }
                        }
                        value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
                    } else {
                        throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
                    }
                });
                return value;
            };

            // TODO: should be removed in 3.0
            var showNoStrategyConfiguredWarning = function () {
                if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
                    $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
                    hasShownNoStrategyConfiguredWarning = true;
                }
            };

            if ($injector.has('$sanitize')) {
                $sanitize = $injector.get('$sanitize');
            }
            if ($injector.has('$sce')) {
                $sce = $injector.get('$sce');
            }

            return {
                /**
                 * @ngdoc function
                 * @name pascalprecht.translate.$translateSanitization#useStrategy
                 * @methodOf pascalprecht.translate.$translateSanitization
                 *
                 * @description
                 * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
                 *
                 * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
                 */
                useStrategy: (function (self) {
                    return function (strategy) {
                        self.useStrategy(strategy);
                    };
                })(this),

                /**
                 * @ngdoc function
                 * @name pascalprecht.translate.$translateSanitization#sanitize
                 * @methodOf pascalprecht.translate.$translateSanitization
                 *
                 * @description
                 * Sanitizes a value.
                 *
                 * @param {string|object} value The value which should be sanitized.
                 * @param {string} mode The current sanitization mode, either 'params' or 'text'.
                 * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
                 * @param {string} [context] The context of this call: filter, service. Default is service
                 * @returns {string|object} sanitized value
                 */
                sanitize: function (value, mode, strategy, context) {
                    if (!currentStrategy) {
                        showNoStrategyConfiguredWarning();
                    }

                    if (!strategy && strategy !== null) {
                        strategy = currentStrategy;
                    }

                    if (!strategy) {
                        return value;
                    }

                    if (!context) {
                        context = 'service';
                    }

                    var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
                    return applyStrategies(value, mode, context, selectedStrategies);
                }
            };
        }];

        var htmlEscapeValue = function (value) {
            var element = angular.element('<div></div>');
            element.text(value); // not chainable, see #1044
            return element.html();
        };

        var htmlSanitizeValue = function (value) {
            if (!$sanitize) {
                throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
            }
            return $sanitize(value);
        };

        var htmlTrustValue = function (value) {
            if (!$sce) {
                throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
            }
            return $sce.trustAsHtml(value);
        };

        var mapInterpolationParameters = function (value, iteratee, stack) {
            if (angular.isDate(value)) {
                return value;
            } else if (angular.isObject(value)) {
                var result = angular.isArray(value) ? [] : {};

                if (!stack) {
                    stack = [];
                } else {
                    if (stack.indexOf(value) > -1) {
                        throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
                    }
                }

                stack.push(value);
                angular.forEach(value, function (propertyValue, propertyKey) {

                    /* Skipping function properties. */
                    if (angular.isFunction(propertyValue)) {
                        return;
                    }

                    result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
                });
                stack.splice(-1, 1); // remove last

                return result;
            } else if (angular.isNumber(value)) {
                return value;
            } else if (value === true || value === false) {
                return value;
            } else if (!angular.isUndefined(value) && value !== null) {
                return iteratee(value);
            } else {
                return value;
            }
        };
    }

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateProvider
     * @description
     *
     * $translateProvider allows developers to register translation-tables, asynchronous loaders
     * and similar to configure translation behavior directly inside of a module.
     *
     */
    angular.module('pascalprecht.translate')
        .constant('pascalprechtTranslateOverrider', {})
        .provider('$translate', $translate);

    function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

var $translationTable = {},
            $preferredLanguage,
            $availableLanguageKeys = [],
            $languageKeyAliases,
            $fallbackLanguage,
            $fallbackWasString,
            $uses,
            $nextLang,
            $storageFactory,
            $storageKey = $STORAGE_KEY,
            $storagePrefix,
            $missingTranslationHandlerFactory,
            $interpolationFactory,
            $interpolatorFactories = [],
            $loaderFactory,
            $cloakClassName = 'translate-cloak',
            $loaderOptions,
            $notFoundIndicatorLeft,
            $notFoundIndicatorRight,
            $postCompilingEnabled = false,
            $forceAsyncReloadEnabled = false,
            $allowNamespaces = true,
            $nestedObjectDelimeter = '.',
            $isReady = false,
            $keepContent = false,
            loaderCache,
            directivePriority = 0,
            statefulFilter = true,
            postProcessFn,
            uniformLanguageTagResolver = 'default',
            languageTagResolver = {
                'default': function (tag) {
                    return (tag || '').split('-').join('_');
                },
                java: function (tag) {
                    var temp = (tag || '').split('-').join('_');
                    var parts = temp.split('_');
                    return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
                },
                bcp47: function (tag) {
                    var temp = (tag || '').split('_').join('-');
                    var parts = temp.split('-');

                    switch (parts.length) {
                        case 1: // language only
                            parts[0] = parts[0].toLowerCase();
                            break;
                        case 2: // language-script or language-region
                            parts[0] = parts[0].toLowerCase();
                            if (parts[1].length === 4) { // parts[1] is script
                                parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                            } else { // parts[1] is region
                                parts[1] = parts[1].toUpperCase();
                            }
                            break;
                        case 3: // language-script-region
                            parts[0] = parts[0].toLowerCase();
                            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
                            parts[2] = parts[2].toUpperCase();
                            break;
                        default:
                            return temp;
                    }

                    return parts.join('-');
                },
                'iso639-1': function (tag) {
                    var temp = (tag || '').split('_').join('-');
                    var parts = temp.split('-');
                    return parts[0].toLowerCase();
                }
            },
            translationIdsList = [];

        var version = '2.19.0';

        // tries to determine the browsers language
        var getFirstBrowserLanguage = function () {

            // internal purpose only
            if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
                return pascalprechtTranslateOverrider.getLocale();
            }

            var nav = $windowProvider.$get().navigator,
                browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
                i,
                language;

            // support for HTML 5.1 "navigator.languages"
            if (angular.isArray(nav.languages)) {
                for (i = 0; i < nav.languages.length; i++) {
                    language = nav.languages[i];
                    if (language && language.length) {
                        return language;
                    }
                }
            }

            // support for other well known properties in browsers
            for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
                language = nav[browserLanguagePropertyKeys[i]];
                if (language && language.length) {
                    return language;
                }
            }

            return null;
        };
        getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

        // tries to determine the browsers locale
        var getLocale = function () {
            var locale = getFirstBrowserLanguage() || '';
            if (languageTagResolver[uniformLanguageTagResolver]) {
                locale = languageTagResolver[uniformLanguageTagResolver](locale);
            }
            return locale;
        };
        getLocale.displayName = 'angular-translate/service: getLocale';

        /**
         * @name indexOf
         * @private
         *
         * @description
         * indexOf polyfill. Kinda sorta.
         *
         * @param {array} array Array to search in.
         * @param {string} searchElement Element to search for.
         *
         * @returns {int} Index of search element.
         */
        var indexOf = function (array, searchElement) {
            for (var i = 0, len = array.length; i < len; i++) {
                if (array[i] === searchElement) {
                    return i;
                }
            }
            return -1;
        };

        /**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */
        var trim = function () {
            return this.toString().replace(/^\s+|\s+$/g, '');
        };

        /**
         * @name lowercase
         * @private
         *
         * @description
         * Return the lowercase string only if the type is string
         *
         * @returns {string} The string all in lowercase
         */
        var lowercase = function (string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };

        var negotiateLocale = function (preferred) {
            if (!preferred) {
                return;
            }

            var avail = [],
                locale = lowercase(preferred),
                i = 0,
                n = $availableLanguageKeys.length;

            for (; i < n; i++) {
                avail.push(lowercase($availableLanguageKeys[i]));
            }

            // Check for an exact match in our list of available keys
            i = indexOf(avail, locale);
            if (i > -1) {
                return $availableLanguageKeys[i];
            }

            if ($languageKeyAliases) {
                var alias;
                for (var langKeyAlias in $languageKeyAliases) {
                    if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
                        var hasWildcardKey = false;
                        var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
                            lowercase(langKeyAlias) === lowercase(preferred);

                        if (langKeyAlias.slice(-1) === '*') {
                            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
                        }
                        if (hasExactKey || hasWildcardKey) {
                            alias = $languageKeyAliases[langKeyAlias];
                            if (indexOf(avail, lowercase(alias)) > -1) {
                                return alias;
                            }
                        }
                    }
                }
            }

            // Check for a language code without region
            var parts = preferred.split('_');

            if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
                return parts[0];
            }

            // If everything fails, return undefined.
            return;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translations
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a new translation table for specific language key.
         *
         * To register a translation table for specific language, pass a defined language
         * key as first parameter.
         *
         * <pre>
         *  // register translation table for language: 'de_DE'
         *  $translateProvider.translations('de_DE', {
         *    'GREETING': 'Hallo Welt!'
         *  });
         *
         *  // register another one
         *  $translateProvider.translations('en_US', {
         *    'GREETING': 'Hello world!'
         *  });
         * </pre>
         *
         * When registering multiple translation tables for for the same language key,
         * the actual translation table gets extended. This allows you to define module
         * specific translation which only get added, once a specific module is loaded in
         * your app.
         *
         * Invoking this method with no arguments returns the translation table which was
         * registered with no language key. Invoking it with a language key returns the
         * related translation table.
         *
         * @param {string} langKey A language key.
         * @param {object} translationTable A plain old JavaScript object that represents a translation table.
         *
         */
        var translations = function (langKey, translationTable) {

            if (!langKey && !translationTable) {
                return $translationTable;
            }

            if (langKey && !translationTable) {
                if (angular.isString(langKey)) {
                    return $translationTable[langKey];
                }
            } else {
                if (!angular.isObject($translationTable[langKey])) {
                    $translationTable[langKey] = {};
                }
                angular.extend($translationTable[langKey], flatObject(translationTable));
            }
            return this;
        };

        this.translations = translations;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#cloakClassName
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the class name for `translate-cloak` directive.
         * Default class name is `translate-cloak`.
         *
         * @param {string} name translate-cloak class name
         */
        this.cloakClassName = function (name) {
            if (!name) {
                return $cloakClassName;
            }
            $cloakClassName = name;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#allowNamespaces
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Let's you disable namespaces, if you don't need nested translation
         * object files. Disabling namespaces can improve performance.
         *
         * Default value is `true`. Namespaces are enabled by default.
         *
         * @param {boolean} namespacesEnabled - namespaces are enabled or not
         */
        this.allowNamespaces = function (namespacesEnabled) {
            if (namespacesEnabled === undefined) {
                return $allowNamespaces;
            }
            $allowNamespaces = namespacesEnabled;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         *
         * Let's you change the delimiter for namespaced translations.
         * Default delimiter is `.`.
         *
         * @param {string} delimiter namespace separator
         */
        this.nestedObjectDelimeter = function (delimiter) {
            if (!delimiter) {
                return $nestedObjectDelimeter;
            }
            $nestedObjectDelimeter = delimiter;
            return this;
        };

        /**
         * @name flatObject
         * @private
         *
         * @description
         * Flats an object. This function is used to flatten given translation data with
         * namespaces, so they are later accessible via dot notation.
         */
        var flatObject = function (data, path, result, prevKey) {
            var key, keyWithPath, keyWithShortPath, val;

            if (!path) {
                path = [];
            }
            if (!result) {
                result = {};
            }
            if (!$allowNamespaces) {
                return data;
            }
            for (key in data) {
                if (!Object.prototype.hasOwnProperty.call(data, key)) {
                    continue;
                }
                val = data[key];
                if (angular.isObject(val)) {
                    flatObject(val, path.concat(key), result, key);
                } else {
                    keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
                    if (path.length && key === prevKey) {
                        // Create shortcut path (foo.bar == foo.bar.bar)
                        keyWithShortPath = '' + path.join($nestedObjectDelimeter);
                        // Link it to original path
                        result[keyWithShortPath] = '@:' + keyWithPath;
                    }
                    result[keyWithPath] = val;
                }
            }
            return result;
        };
        flatObject.displayName = 'flatObject';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#addInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Adds interpolation services to angular-translate, so it can manage them.
         *
         * @param {object} factory Interpolation service factory
         */
        this.addInterpolation = function (factory) {
            $interpolatorFactories.push(factory);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use interpolation functionality of messageformat.js.
         * This is useful when having high level pluralization and gender selection.
         */
        this.useMessageFormatInterpolation = function () {
            return this.useInterpolation('$translateMessageFormatInterpolation');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useInterpolation
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which interpolation style to use as default, application-wide.
         * Simply pass a factory/service name. The interpolation service has to implement
         * the correct interface.
         *
         * @param {string} factory Interpolation service name.
         */
        this.useInterpolation = function (factory) {
            $interpolationFactory = factory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Simply sets a sanitation strategy type.
         *
         * @param {string} value Strategy type.
         */
        this.useSanitizeValueStrategy = function (value) {
            $translateSanitizationProvider.useStrategy(value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#preferredLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which of the registered translation tables to use for translation
         * at initial startup by passing a language key. Similar to `$translateProvider#use`
         * only that it says which language to **prefer**.
         * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
         *
         * @param {string} langKey A language key.
         */
        this.preferredLanguage = function (langKey) {
            if (langKey) {
                setupPreferredLanguage(langKey);
                return this;
            }
            return $preferredLanguage;
        };
        var setupPreferredLanguage = function (langKey) {
            if (langKey) {
                $preferredLanguage = langKey;
            }
            return $preferredLanguage;
        };
        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found. E.g. when
         * setting the indicator as 'X' and one tries to translate a translation id
         * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
         *
         * Internally this methods sets a left indicator and a right indicator using
         * `$translateProvider.translationNotFoundIndicatorLeft()` and
         * `$translateProvider.translationNotFoundIndicatorRight()`.
         *
         * **Note**: These methods automatically add a whitespace between the indicators
         * and the translation id.
         *
         * @param {string} indicator An indicator, could be any string.
         */
        this.translationNotFoundIndicator = function (indicator) {
            this.translationNotFoundIndicatorLeft(indicator);
            this.translationNotFoundIndicatorRight(indicator);
            return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found left to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorLeft = function (indicator) {
            if (!indicator) {
                return $notFoundIndicatorLeft;
            }
            $notFoundIndicatorLeft = indicator;
            return this;
        };

        /**
         * ngdoc function
         * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets an indicator which is used when a translation isn't found right to the
         * translation id.
         *
         * @param {string} indicator An indicator.
         */
        this.translationNotFoundIndicatorRight = function (indicator) {
            if (!indicator) {
                return $notFoundIndicatorRight;
            }
            $notFoundIndicatorRight = indicator;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#fallbackLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which of the registered translation tables to use when missing translations
         * at initial startup by passing a language key. Similar to `$translateProvider#use`
         * only that it says which language to **fallback**.
         *
         * @param {string||array} langKey A language key.
         *
         */
        this.fallbackLanguage = function (langKey) {
            fallbackStack(langKey);
            return this;
        };

        var fallbackStack = function (langKey) {
            if (langKey) {
                if (angular.isString(langKey)) {
                    $fallbackWasString = true;
                    $fallbackLanguage = [langKey];
                } else if (angular.isArray(langKey)) {
                    $fallbackWasString = false;
                    $fallbackLanguage = langKey;
                }
                if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                    $fallbackLanguage.push($preferredLanguage);
                }

                return this;
            } else {
                if ($fallbackWasString) {
                    return $fallbackLanguage[0];
                } else {
                    return $fallbackLanguage;
                }
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#use
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Set which translation table to use for translation by given language key. When
         * trying to 'use' a language which isn't provided, it'll throw an error.
         *
         * You actually don't have to use this method since `$translateProvider#preferredLanguage`
         * does the job too.
         *
         * @param {string} langKey A language key.
         */
        this.use = function (langKey) {
            if (langKey) {
                if (!$translationTable[langKey] && (!$loaderFactory)) {
                    // only throw an error, when not loading translation data asynchronously
                    throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
                }
                $uses = langKey;
                return this;
            }
            return $uses;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#resolveClientLocale
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
         *
         * @returns {string} the current client/browser language key
         */
        this.resolveClientLocale = function () {
            return getLocale();
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#storageKey
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells the module which key must represent the choosed language by a user in the storage.
         *
         * @param {string} key A key for the storage.
         */
        var storageKey = function (key) {
            if (!key) {
                if ($storagePrefix) {
                    return $storagePrefix + $storageKey;
                }
                return $storageKey;
            }
            $storageKey = key;
            return this;
        };

        this.storageKey = storageKey;

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useUrlLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
         *
         * @param {string} url Url
         * @param {Object=} options Optional configuration object
         */
        this.useUrlLoader = function (url, options) {
            return this.useLoader('$translateUrlLoader', angular.extend({url: url}, options));
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
         *
         * @param {Object=} options Optional configuration object
         */
        this.useStaticFilesLoader = function (options) {
            return this.useLoader('$translateStaticFilesLoader', options);
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoader
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use any other service as loader.
         *
         * @param {string} loaderFactory Factory name to use
         * @param {Object=} options Optional configuration object
         */
        this.useLoader = function (loaderFactory, options) {
            $loaderFactory = loaderFactory;
            $loaderOptions = options || {};
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLocalStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
         *
         */
        this.useLocalStorage = function () {
            return this.useStorage('$translateLocalStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useCookieStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
         */
        this.useCookieStorage = function () {
            return this.useStorage('$translateCookieStorage');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useStorage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use custom service as storage layer.
         */
        this.useStorage = function (storageFactory) {
            $storageFactory = storageFactory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#storagePrefix
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets prefix for storage key.
         *
         * @param {string} prefix Storage key prefix
         */
        this.storagePrefix = function (prefix) {
            if (!prefix) {
                return prefix;
            }
            $storagePrefix = prefix;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to use built-in log handler when trying to translate
         * a translation Id which doesn't exist.
         *
         * This is actually a shortcut method for `useMissingTranslationHandler()`.
         *
         */
        this.useMissingTranslationHandlerLog = function () {
            return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Expects a factory name which later gets instantiated with `$injector`.
         * This method can be used to tell angular-translate to use a custom
         * missingTranslationHandler. Just build a factory which returns a function
         * and expects a translation id as argument.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.useMissingTranslationHandler('customHandler');
         *  });
         *
         *  app.factory('customHandler', function (dep1, dep2) {
         *    return function (translationId) {
         *      // something with translationId and dep1 and dep2
         *    };
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.useMissingTranslationHandler = function (factory) {
            $missingTranslationHandlerFactory = factory;
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#usePostCompiling
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If post compiling is enabled, all translated values will be processed
         * again with AngularJS' $compile.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.usePostCompiling(true);
         *  });
         * </pre>
         *
         * @param {string} factory Factory name
         */
        this.usePostCompiling = function (value) {
            $postCompilingEnabled = !(!value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#forceAsyncReload
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If force async reload is enabled, async loader will always be called
         * even if $translationTable already contains the language key, adding
         * possible new entries to the $translationTable.
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.forceAsyncReload(true);
         *  });
         * </pre>
         *
         * @param {boolean} value - valid values are true or false
         */
        this.forceAsyncReload = function (value) {
            $forceAsyncReloadEnabled = !(!value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate which language tag should be used as a result when determining
         * the current browser language.
         *
         * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
         *
         * <pre>
         * $translateProvider
         *   .uniformLanguageTag('bcp47')
         *   .determinePreferredLanguage()
         * </pre>
         *
         * The resolver currently supports:
         * * default
         *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_us
         * * java
         *     like default, but the second part will be always in uppercase
         *     en-US => en_US
         *     en_US => en_US
         *     en-us => en_US
         * * BCP 47 (RFC 4646 & 4647)
         *     EN => en
         *     en-US => en-US
         *     en_US => en-US
         *     en-us => en-US
         *     sr-latn => sr-Latn
         *     sr-latn-rs => sr-Latn-RS
         *
         * See also:
         * * http://en.wikipedia.org/wiki/IETF_language_tag
         * * http://www.w3.org/International/core/langtags/
         * * http://tools.ietf.org/html/bcp47
         *
         * @param {string|object} options - options (or standard)
         * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
         */
        this.uniformLanguageTag = function (options) {

            if (!options) {
                options = {};
            } else if (angular.isString(options)) {
                options = {
                    standard: options
                };
            }

            uniformLanguageTagResolver = options.standard;

            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Tells angular-translate to try to determine on its own which language key
         * to set as preferred language. When `fn` is given, angular-translate uses it
         * to determine a language key, otherwise it uses the built-in `getLocale()`
         * method.
         *
         * The `getLocale()` returns a language key in the format `[lang]_[country]` or
         * `[lang]` depending on what the browser provides.
         *
         * Use this method at your own risk, since not all browsers return a valid
         * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
         *
         * @param {Function=} fn Function to determine a browser's locale
         */
        this.determinePreferredLanguage = function (fn) {

            var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

            if (!$availableLanguageKeys.length) {
                $preferredLanguage = locale;
            } else {
                $preferredLanguage = negotiateLocale(locale) || locale;
            }

            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a set of language keys the app will work with. Use this method in
         * combination with
         * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
         * When available languages keys are registered, angular-translate
         * tries to find the best fitting language key depending on the browsers locale,
         * considering your language key convention.
         *
         * @param {object} languageKeys Array of language keys the your app will use
         * @param {object=} aliases Alias map.
         */
        this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
            if (languageKeys) {
                $availableLanguageKeys = languageKeys;
                if (aliases) {
                    $languageKeyAliases = aliases;
                }
                return this;
            }
            return $availableLanguageKeys;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#useLoaderCache
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Registers a cache for internal $http based loaders.
         * {@link pascalprecht.translate.$translationCache $translationCache}.
         * When false the cache will be disabled (default). When true or undefined
         * the cache will be a default (see $cacheFactory). When an object it will
         * be treat as a cache object itself: the usage is $http({cache: cache})
         *
         * @param {object} cache boolean, string or cache-object
         */
        this.useLoaderCache = function (cache) {
            if (cache === false) {
                // disable cache
                loaderCache = undefined;
            } else if (cache === true) {
                // enable cache using AJS defaults
                loaderCache = true;
            } else if (typeof (cache) === 'undefined') {
                // enable cache using default
                loaderCache = '$translationCache';
            } else if (cache) {
                // enable cache using given one (see $cacheFactory)
                loaderCache = cache;
            }
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#directivePriority
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Sets the default priority of the translate directive. The standard value is `0`.
         * Calling this function without an argument will return the current value.
         *
         * @param {number} priority for the translate-directive
         */
        this.directivePriority = function (priority) {
            if (priority === undefined) {
                // getter
                return directivePriority;
            } else {
                // setter with chaining
                directivePriority = priority;
                return this;
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#statefulFilter
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
         * have to explicit define this behavior.
         * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
         * meaning being stateful.
         * Calling this function without an argument will return the current value.
         *
         * @param {boolean} state - defines the state of the filter
         */
        this.statefulFilter = function (state) {
            if (state === undefined) {
                // getter
                return statefulFilter;
            } else {
                // setter with chaining
                statefulFilter = state;
                return this;
            }
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#postProcess
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * The post processor will be intercept right after the translation result. It can modify the result.
         *
         * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
         */
        this.postProcess = function (fn) {
            if (fn) {
                postProcessFn = fn;
            } else {
                postProcessFn = undefined;
            }
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateProvider#keepContent
         * @methodOf pascalprecht.translate.$translateProvider
         *
         * @description
         * If keepContent is set to true than translate directive will always use innerHTML
         * as a default translation
         *
         * Example:
         * <pre>
         *  app.config(function ($translateProvider) {
         *    $translateProvider.keepContent(true);
         *  });
         * </pre>
         *
         * @param {boolean} value - valid values are true or false
         */
        this.keepContent = function (value) {
            $keepContent = !(!value);
            return this;
        };

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translate
         * @requires $interpolate
         * @requires $log
         * @requires $rootScope
         * @requires $q
         *
         * @description
         * The `$translate` service is the actual core of angular-translate. It expects a translation id
         * and optional interpolate parameters to translate contents.
         *
         * <pre>
         *  $translate('HEADLINE_TEXT').then(function (translation) {
         *    $scope.translatedText = translation;
         *  });
         * </pre>
         *
         * @param {string|array} translationId A token which represents a translation id
         *                                     This can be optionally an array of translation ids which
         *                                     results that the function returns an object where each key
         *                                     is the translation id and the value the translation.
         * @param {object=} [interpolateParams={}] An object hash for dynamic values
         * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
         * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
         *                                        as default text in case it is not found in any configured language
         * @param {string=} [forceLanguage=false] A language to be used instead of the current language
         * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
         * @returns {object} promise
         */
        this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

            var Storage,
                defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
                pendingLoader = false,
                interpolatorHashMap = {},
                langPromises = {},
                fallbackIndex,
                startFallbackIteration;

            var collectTranslationId = function (translationId) {
                if (!translationIdsList.find(function (existingId) {
                    return existingId === translationId;
                })) {
                    translationIdsList.push(translationId);
                    $rootScope.$emit('translationIdCollected', {translationId: translationId});
                }
            }

            var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {

                collectTranslationId(translationId);

                if (!$uses && $preferredLanguage) {
                    $uses = $preferredLanguage;
                }
                var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
                    (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

                // Check forceLanguage is present
                if (forceLanguage) {
                    loadTranslationsIfMissing(forceLanguage);
                }

                // Duck detection: If the first argument is an array, a bunch of translations was requested.
                // The result is an object.
                if (angular.isArray(translationId)) {
                    // Inspired by Q.allSettled by Kris Kowal
                    // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
                    // This transforms all promises regardless resolved or rejected
                    var translateAll = function (translationIds) {
                        var results = {}; // storing the actual results
                        var promises = []; // promises to wait for
                        // Wraps the promise a) being always resolved and b) storing the link id->value
                        var translate = function (translationId) {
                            var deferred = $q.defer();
                            var regardless = function (value) {
                                results[translationId] = value;
                                deferred.resolve([translationId, value]);
                            };
                            // we don't care whether the promise was resolved or rejected; just store the values
                            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
                            return deferred.promise;
                        };
                        for (var i = 0, c = translationIds.length; i < c; i++) {
                            promises.push(translate(translationIds[i]));
                        }
                        // wait for all (including storing to results)
                        return $q.all(promises).then(function () {
                            // return the results
                            return results;
                        });
                    };
                    return translateAll(translationId);
                }

                var deferred = $q.defer();

                // trim off any whitespace
                if (translationId) {
                    translationId = trim.apply(translationId);
                } else {
                    throw new TypeError('translationId must be a not empty string');
                }

                var promiseToWaitFor = (function () {
                    var promise = langPromises[uses] || langPromises[$preferredLanguage];

                    fallbackIndex = 0;

                    if ($storageFactory && !promise) {
                        // looks like there's no pending promise for $preferredLanguage or
                        // $uses. Maybe there's one pending for a language that comes from
                        // storage.
                        var langKey = Storage.get($storageKey);
                        promise = langPromises[langKey];

                        if ($fallbackLanguage && $fallbackLanguage.length) {
                            var index = indexOf($fallbackLanguage, langKey);
                            // maybe the language from storage is also defined as fallback language
                            // we increase the fallback language index to not search in that language
                            // as fallback, since it's probably the first used language
                            // in that case the index starts after the first element
                            fallbackIndex = (index === 0) ? 1 : 0;

                            // but we can make sure to ALWAYS fallback to preferred language at least
                            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
                                $fallbackLanguage.push($preferredLanguage);
                            }
                        }
                    }
                    return promise;
                }());

                if (!promiseToWaitFor) {
                    // no promise to wait for? okay. Then there's no loader registered
                    // nor is a one pending for language that comes from storage.
                    // We can just translate.
                    determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                } else {
                    var promiseResolved = function () {
                        // $uses may have changed while waiting
                        if (!forceLanguage) {
                            uses = $uses;
                        }
                        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                    };
                    promiseResolved.displayName = 'promiseResolved';

                    promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
                }
                return deferred.promise;
            };

            /**
             * @name applyNotFoundIndicators
             * @private
             *
             * @description
             * Applies not fount indicators to given translation id, if needed.
             * This function gets only executed, if a translation id doesn't exist,
             * which is why a translation id is expected as argument.
             *
             * @param {string} translationId Translation id.
             * @returns {string} Same as given translation id but applied with not found
             * indicators.
             */
            var applyNotFoundIndicators = function (translationId) {
                // applying notFoundIndicators
                if ($notFoundIndicatorLeft) {
                    translationId = [$notFoundIndicatorLeft, translationId].join(' ');
                }
                if ($notFoundIndicatorRight) {
                    translationId = [translationId, $notFoundIndicatorRight].join(' ');
                }
                return translationId;
            };

            /**
             * @name useLanguage
             * @private
             *
             * @description
             * Makes actual use of a language by setting a given language key as used
             * language and informs registered interpolators to also use the given
             * key as locale.
             *
             * @param {string} key Locale key.
             */
            var useLanguage = function (key) {
                $uses = key;

                // make sure to store new language key before triggering success event
                if ($storageFactory) {
                    Storage.put($translate.storageKey(), $uses);
                }

                $rootScope.$emit('$translateChangeSuccess', {language: key});

                // inform default interpolator
                defaultInterpolator.setLocale($uses);

                var eachInterpolator = function (interpolator, id) {
                    interpolatorHashMap[id].setLocale($uses);
                };
                eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

                // inform all others too!
                angular.forEach(interpolatorHashMap, eachInterpolator);
                $rootScope.$emit('$translateChangeEnd', {language: key});
            };

            /**
             * @name loadAsync
             * @private
             *
             * @description
             * Kicks off registered async loader using `$injector` and applies existing
             * loader options. When resolved, it updates translation tables accordingly
             * or rejects with given language key.
             *
             * @param {string} key Language key.
             * @return {Promise} A promise.
             */
            var loadAsync = function (key) {
                if (!key) {
                    throw 'No language key specified for loading.';
                }

                var deferred = $q.defer();

                $rootScope.$emit('$translateLoadingStart', {language: key});
                pendingLoader = true;

                var cache = loaderCache;
                if (typeof (cache) === 'string') {
                    // getting on-demand instance of loader
                    cache = $injector.get(cache);
                }

                var loaderOptions = angular.extend({}, $loaderOptions, {
                    key: key,
                    $http: angular.extend({}, {
                        cache: cache
                    }, $loaderOptions.$http)
                });

                var onLoaderSuccess = function (data) {
                    var translationTable = {};
                    $rootScope.$emit('$translateLoadingSuccess', {language: key});

                    if (angular.isArray(data)) {
                        angular.forEach(data, function (table) {
                            angular.extend(translationTable, flatObject(table));
                        });
                    } else {
                        angular.extend(translationTable, flatObject(data));
                    }
                    pendingLoader = false;
                    deferred.resolve({
                        key: key,
                        table: translationTable
                    });
                    $rootScope.$emit('$translateLoadingEnd', {language: key});
                };
                onLoaderSuccess.displayName = 'onLoaderSuccess';

                var onLoaderError = function (key) {
                    $rootScope.$emit('$translateLoadingError', {language: key});
                    deferred.reject(key);
                    $rootScope.$emit('$translateLoadingEnd', {language: key});
                };
                onLoaderError.displayName = 'onLoaderError';

                $injector.get($loaderFactory)(loaderOptions)
                    .then(onLoaderSuccess, onLoaderError);

                return deferred.promise;
            };

            if ($storageFactory) {
                Storage = $injector.get($storageFactory);

                if (!Storage.get || !Storage.put) {
                    throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
                }
            }

            // if we have additional interpolations that were added via
            // $translateProvider.addInterpolation(), we have to map'em
            if ($interpolatorFactories.length) {
                var eachInterpolationFactory = function (interpolatorFactory) {
                    var interpolator = $injector.get(interpolatorFactory);
                    // setting initial locale for each interpolation service
                    interpolator.setLocale($preferredLanguage || $uses);
                    // make'em recognizable through id
                    interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
                };
                eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

                angular.forEach($interpolatorFactories, eachInterpolationFactory);
            }

            /**
             * @name getTranslationTable
             * @private
             *
             * @description
             * Returns a promise that resolves to the translation table
             * or is rejected if an error occurred.
             *
             * @param langKey
             * @returns {Q.promise}
             */
            var getTranslationTable = function (langKey) {
                var deferred = $q.defer();
                if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
                    deferred.resolve($translationTable[langKey]);
                } else if (langPromises[langKey]) {
                    var onResolve = function (data) {
                        translations(data.key, data.table);
                        deferred.resolve(data.table);
                    };
                    onResolve.displayName = 'translationTableResolver';
                    langPromises[langKey].then(onResolve, deferred.reject);
                } else {
                    deferred.reject();
                }
                return deferred.promise;
            };

            /**
             * @name getFallbackTranslation
             * @private
             *
             * @description
             * Returns a promise that will resolve to the translation
             * or be rejected if no translation was found for the language.
             * This function is currently only used for fallback language translation.
             *
             * @param langKey The language to translate to.
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {Q.promise}
             */
            var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var deferred = $q.defer();

                var onResolve = function (translationTable) {
                    if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                        Interpolator.setLocale(langKey);
                        var translation = translationTable[translationId];
                        if (translation.substr(0, 2) === '@:') {
                            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
                                .then(deferred.resolve, deferred.reject);
                        } else {
                            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
                            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

                            deferred.resolve(interpolatedValue);

                        }
                        Interpolator.setLocale($uses);
                    } else {
                        deferred.reject();
                    }
                };
                onResolve.displayName = 'fallbackTranslationResolver';

                getTranslationTable(langKey).then(onResolve, deferred.reject);

                return deferred.promise;
            };

            /**
             * @name getFallbackTranslationInstant
             * @private
             *
             * @description
             * Returns a translation
             * This function is currently only used for fallback language translation.
             *
             * @param langKey The language to translate to.
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy sanitize strategy override
             *
             * @returns {string} translation
             */
            var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var result, translationTable = $translationTable[langKey];

                if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
                    Interpolator.setLocale(langKey);
                    result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
                    result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
                    // workaround for TrustedValueHolderType
                    if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
                        var result2 = result.$$unwrapTrustedValue();
                        if (result2.substr(0, 2) === '@:') {
                            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                        }
                    } else if (result.substr(0, 2) === '@:') {
                        return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
                    }
                    Interpolator.setLocale($uses);
                }

                return result;
            };


            /**
             * @name translateByHandler
             * @private
             *
             * Translate by missing translation handler.
             *
             * @param translationId
             * @param interpolateParams
             * @param defaultTranslationText
             * @param sanitizeStrategy sanitize strategy override
             *
             * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
             * absent
             */
            var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
                // If we have a handler factory - we might also call it here to determine if it provides
                // a default text for a translationid that can't be found anywhere in our tables
                if ($missingTranslationHandlerFactory) {
                    return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
                } else {
                    return translationId;
                }
            };

            /**
             * @name resolveForFallbackLanguage
             * @private
             *
             * Recursive helper function for fallbackTranslation that will sequentially look
             * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
             *
             * @param fallbackLanguageIndex
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param defaultTranslationText
             * @param sanitizeStrategy
             * @returns {Q.promise} Promise that will resolve to the translation.
             */
            var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                var deferred = $q.defer();

                if (fallbackLanguageIndex < $fallbackLanguage.length) {
                    var langKey = $fallbackLanguage[fallbackLanguageIndex];
                    getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
                        function (data) {
                            deferred.resolve(data);
                        },
                        function () {
                            // Look in the next fallback language for a translation.
                            // It delays the resolving by passing another promise to resolve.
                            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
                        }
                    );
                } else {
                    // No translation found in any fallback language
                    // if a default translation text is set in the directive, then return this as a result
                    if (defaultTranslationText) {
                        deferred.resolve(defaultTranslationText);
                    } else {
                        var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

                        // if no default translation is set and an error handler is defined, send it to the handler
                        // and then return the result if it isn't undefined
                        if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
                            deferred.resolve(missingTranslationHandlerTranslation);
                        } else {
                            deferred.reject(applyNotFoundIndicators(translationId));
                        }
                    }
                }
                return deferred.promise;
            };

            /**
             * @name resolveForFallbackLanguageInstant
             * @private
             *
             * Recursive helper function for fallbackTranslation that will sequentially look
             * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
             *
             * @param fallbackLanguageIndex
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {string} translation
             */
            var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                var result;

                if (fallbackLanguageIndex < $fallbackLanguage.length) {
                    var langKey = $fallbackLanguage[fallbackLanguageIndex];
                    result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
                    if (!result && result !== '') {
                        result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
                    }
                }
                return result;
            };

            /**
             * Translates with the usage of the fallback languages.
             *
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param defaultTranslationText
             * @param sanitizeStrategy
             * @returns {Q.promise} Promise, that resolves to the translation.
             */
            var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
                // Start with the fallbackLanguage with index 0
                return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
            };

            /**
             * Translates with the usage of the fallback languages.
             *
             * @param translationId
             * @param interpolateParams
             * @param Interpolator
             * @param sanitizeStrategy
             * @returns {String} translation
             */
            var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
                // Start with the fallbackLanguage with index 0
                return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
            };

            var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

                var deferred = $q.defer();

                var table = uses ? $translationTable[uses] : $translationTable,
                    Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

                // if the translation id exists, we can just interpolate it
                if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                    var translation = table[translationId];

                    // If using link, rerun $translate with linked translationId and return it
                    if (translation.substr(0, 2) === '@:') {

                        $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
                            .then(deferred.resolve, deferred.reject);
                    } else {
                        //
                        var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
                        resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
                        deferred.resolve(resolvedTranslation);
                    }
                } else {
                    var missingTranslationHandlerTranslation;
                    // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                    if ($missingTranslationHandlerFactory && !pendingLoader) {
                        missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
                    }

                    // since we couldn't translate the inital requested translation id,
                    // we try it now with one or more fallback languages, if fallback language(s) is
                    // configured.
                    if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                        fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
                            .then(function (translation) {
                                deferred.resolve(translation);
                            }, function (_translationId) {
                                deferred.reject(applyNotFoundIndicators(_translationId));
                            });
                    } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        if (defaultTranslationText) {
                            deferred.resolve(defaultTranslationText);
                        } else {
                            deferred.resolve(missingTranslationHandlerTranslation);
                        }
                    } else {
                        if (defaultTranslationText) {
                            deferred.resolve(defaultTranslationText);
                        } else {
                            deferred.reject(applyNotFoundIndicators(translationId));
                        }
                    }
                }
                return deferred.promise;
            };

            var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

                var result, table = uses ? $translationTable[uses] : $translationTable,
                    Interpolator = defaultInterpolator;

                // if the interpolation id exists use custom interpolator
                if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
                    Interpolator = interpolatorHashMap[interpolationId];
                }

                // if the translation id exists, we can just interpolate it
                if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
                    var translation = table[translationId];

                    // If using link, rerun $translate with linked translationId and return it
                    if (translation.substr(0, 2) === '@:') {
                        result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
                    } else {
                        result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
                        result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
                    }
                } else {
                    var missingTranslationHandlerTranslation;
                    // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
                    if ($missingTranslationHandlerFactory && !pendingLoader) {
                        missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                    }

                    // since we couldn't translate the inital requested translation id,
                    // we try it now with one or more fallback languages, if fallback language(s) is
                    // configured.
                    if (uses && $fallbackLanguage && $fallbackLanguage.length) {
                        fallbackIndex = 0;
                        result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
                    } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        result = missingTranslationHandlerTranslation;
                    } else {
                        result = applyNotFoundIndicators(translationId);
                    }
                }

                return result;
            };

            var clearNextLangAndPromise = function (key) {
                if ($nextLang === key) {
                    $nextLang = undefined;
                }
                langPromises[key] = undefined;
            };

            var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
                var fn = postProcessFn;

                if (fn) {

                    if (typeof (fn) === 'string') {
                        // getting on-demand instance
                        fn = $injector.get(fn);
                    }
                    if (fn) {
                        return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
                    }
                }

                return resolvedTranslation;
            };

            var loadTranslationsIfMissing = function (key) {
                if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
                    langPromises[key] = loadAsync(key).then(function (translation) {
                        translations(translation.key, translation.table);
                        return translation;
                    });
                }
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#preferredLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key for the preferred language.
             *
             * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
             *
             * @return {string} preferred language key
             */
            $translate.preferredLanguage = function (langKey) {
                if (langKey) {
                    setupPreferredLanguage(langKey);
                }
                return $preferredLanguage;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#cloakClassName
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the configured class name for `translate-cloak` directive.
             *
             * @return {string} cloakClassName
             */
            $translate.cloakClassName = function () {
                return $cloakClassName;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#allowNamespaces
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns if namespaces are enabled
             *
             * @return {boolean} allowNamespaces value
             */
            $translate.allowNamespaces = function () {
                return $allowNamespaces;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#nestedObjectDelimeter
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the configured delimiter for nested namespaces.
             *
             * @return {string} nestedObjectDelimeter
             */
            $translate.nestedObjectDelimeter = function () {
                return $nestedObjectDelimeter;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#fallbackLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key for the fallback languages or sets a new fallback stack.
             * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
             *
             * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
             *
             * @return {string||array} fallback language key
             */
            $translate.fallbackLanguage = function (langKey) {
                if (langKey !== undefined && langKey !== null) {
                    fallbackStack(langKey);

                    // as we might have an async loader initiated and a new translation language might have been defined
                    // we need to add the promise to the stack also. So - iterate.
                    if ($loaderFactory) {
                        if ($fallbackLanguage && $fallbackLanguage.length) {
                            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                                if (!langPromises[$fallbackLanguage[i]]) {
                                    langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
                                }
                            }
                        }
                    }
                    $translate.use($translate.use());
                }
                if ($fallbackWasString) {
                    return $fallbackLanguage[0];
                } else {
                    return $fallbackLanguage;
                }

            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#useFallbackLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Sets the first key of the fallback language stack to be used for translation.
             * Therefore all languages in the fallback array BEFORE this key will be skipped!
             *
             * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
             * get back to the whole stack
             */
            $translate.useFallbackLanguage = function (langKey) {
                if (langKey !== undefined && langKey !== null) {
                    if (!langKey) {
                        startFallbackIteration = 0;
                    } else {
                        var langKeyPosition = indexOf($fallbackLanguage, langKey);
                        if (langKeyPosition > -1) {
                            startFallbackIteration = langKeyPosition;
                        }
                    }

                }

            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#proposedLanguage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the language key of language that is currently loaded asynchronously.
             *
             * @return {string} language key
             */
            $translate.proposedLanguage = function () {
                return $nextLang;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#storage
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns registered storage.
             *
             * @return {object} Storage
             */
            $translate.storage = function () {
                return Storage;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#negotiateLocale
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns a language key based on available languages and language aliases. If a
             * language key cannot be resolved, returns undefined.
             *
             * If no or a falsy key is given, returns undefined.
             *
             * @param {string} [key] Language key
             * @return {string|undefined} Language key or undefined if no language key is found.
             */
            $translate.negotiateLocale = negotiateLocale;

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#use
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Tells angular-translate which language to use by given language key. This method is
             * used to change language at runtime. It also takes care of storing the language
             * key in a configured store to let your app remember the choosed language.
             *
             * When trying to 'use' a language which isn't available it tries to load it
             * asynchronously with registered loaders.
             *
             * Returns promise object with loaded language file data or string of the currently used language.
             *
             * If no or a falsy key is given it returns the currently used language key.
             * The returned string will be ```undefined``` if setting up $translate hasn't finished.
             * @example
             * $translate.use("en_US").then(function(data){
             *   $scope.text = $translate("HELLO");
             * });
             *
             * @param {string=} key Language key
             * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
             */
            $translate.use = function (key) {
                if (!key) {
                    return $uses;
                }

                var deferred = $q.defer();
                deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

                $rootScope.$emit('$translateChangeStart', {language: key});

                // Try to get the aliased language key
                var aliasedKey = negotiateLocale(key);
                // Ensure only registered language keys will be loaded
                if ($availableLanguageKeys.length > 0 && !aliasedKey) {
                    return $q.reject(key);
                }

                if (aliasedKey) {
                    key = aliasedKey;
                }

                // if there isn't a translation table for the language we've requested,
                // we load it asynchronously
                $nextLang = key;
                if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
                    langPromises[key] = loadAsync(key).then(function (translation) {
                        translations(translation.key, translation.table);
                        deferred.resolve(translation.key);
                        if ($nextLang === key) {
                            useLanguage(translation.key);
                        }
                        return translation;
                    }, function (key) {
                        $rootScope.$emit('$translateChangeError', {language: key});
                        deferred.reject(key);
                        $rootScope.$emit('$translateChangeEnd', {language: key});
                        return $q.reject(key);
                    });
                    langPromises[key]['finally'](function () {
                        clearNextLangAndPromise(key);
                    })['catch'](angular.noop); // we don't care about errors (clearing)
                } else if (langPromises[key]) {
                    // we are already loading this asynchronously
                    // resolve our new deferred when the old langPromise is resolved
                    langPromises[key].then(function (translation) {
                        if ($nextLang === translation.key) {
                            useLanguage(translation.key);
                        }
                        deferred.resolve(translation.key);
                        return translation;
                    }, function (key) {
                        // find first available fallback language if that request has failed
                        if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
                            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
                        } else {
                            return deferred.reject(key);
                        }
                    });
                } else {
                    deferred.resolve(key);
                    useLanguage(key);
                }

                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#resolveClientLocale
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
             *
             * @returns {string} the current client/browser language key
             */
            $translate.resolveClientLocale = function () {
                return getLocale();
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#storageKey
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the key for the storage.
             *
             * @return {string} storage key
             */
            $translate.storageKey = function () {
                return storageKey();
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isPostCompilingEnabled
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether post compiling is enabled or not
             *
             * @return {bool} storage key
             */
            $translate.isPostCompilingEnabled = function () {
                return $postCompilingEnabled;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether force async reload is enabled or not
             *
             * @return {boolean} forceAsyncReload value
             */
            $translate.isForceAsyncReloadEnabled = function () {
                return $forceAsyncReloadEnabled;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isKeepContent
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether keepContent or not
             *
             * @return {boolean} keepContent value
             */
            $translate.isKeepContent = function () {
                return $keepContent;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#refresh
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
             * the module will drop all existent translation tables and load new version of those which
             * are currently in use.
             *
             * Refresh means that the module will drop target translation table and try to load it again.
             *
             * In case there are no loaders registered the refresh() method will throw an Error.
             *
             * If the module is able to refresh translation tables refresh() method will broadcast
             * $translateRefreshStart and $translateRefreshEnd events.
             *
             * @example
             * // this will drop all currently existent translation tables and reload those which are
             * // currently in use
             * $translate.refresh();
             * // this will refresh a translation table for the en_US language
             * $translate.refresh('en_US');
             *
             * @param {string} langKey A language key of the table, which has to be refreshed
             *
             * @return {promise} Promise, which will be resolved in case a translation tables refreshing
             * process is finished successfully, and reject if not.
             */
            $translate.refresh = function (langKey) {
                if (!$loaderFactory) {
                    throw new Error('Couldn\'t refresh translation table, no loader registered!');
                }

                $rootScope.$emit('$translateRefreshStart', {language: langKey});

                var deferred = $q.defer(), updatedLanguages = {};

                //private helper
                function loadNewData(languageKey) {
                    var promise = loadAsync(languageKey);
                    //update the load promise cache for this language
                    langPromises[languageKey] = promise;
                    //register a data handler for the promise
                    promise.then(function (data) {
                            //clear the cache for this language
                            $translationTable[languageKey] = {};
                            //add the new data for this language
                            translations(languageKey, data.table);
                            //track that we updated this language
                            updatedLanguages[languageKey] = true;
                        },
                        //handle rejection to appease the $q validation
                        angular.noop);
                    return promise;
                }

                //set up post-processing
                deferred.promise.then(
                    function () {
                        for (var key in $translationTable) {
                            if ($translationTable.hasOwnProperty(key)) {
                                //delete cache entries that were not updated
                                if (!(key in updatedLanguages)) {
                                    delete $translationTable[key];
                                }
                            }
                        }
                        if ($uses) {
                            useLanguage($uses);
                        }
                    },
                    //handle rejection to appease the $q validation
                    angular.noop
                )['finally'](
                    function () {
                        $rootScope.$emit('$translateRefreshEnd', {language: langKey});
                    }
                );

                if (!langKey) {
                    // if there's no language key specified we refresh ALL THE THINGS!
                    var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
                    if ($uses && languagesToReload.indexOf($uses) === -1) {
                        languagesToReload.push($uses);
                    }
                    $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

                } else if ($translationTable[langKey]) {
                    //just refresh the specified language cache
                    loadNewData(langKey).then(deferred.resolve, deferred.reject);

                } else {
                    deferred.reject();
                }

                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#instant
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns a translation instantly from the internal state of loaded translation. All rules
             * regarding the current language, the preferred language of even fallback languages will be
             * used except any promise handling. If a language was not found, an asynchronous loading
             * will be invoked in the background.
             *
             * @param {string|array} translationId A token which represents a translation id
             *                                     This can be optionally an array of translation ids which
             *                                     results that the function's promise returns an object where
             *                                     each key is the translation id and the value the translation.
             * @param {object=} [interpolateParams={}] Params
             * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
             * @param {string=} [forceLanguage=false] A language to be used instead of the current language
             * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
             *
             * @return {string|object} translation
             */
            $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
                collectTranslationId(translationId);

                // we don't want to re-negotiate $uses
                var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
                    (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

                // Detect undefined and null values to shorten the execution and prevent exceptions
                if (translationId === null || angular.isUndefined(translationId)) {
                    return translationId;
                }

                // Check forceLanguage is present
                if (forceLanguage) {
                    loadTranslationsIfMissing(forceLanguage);
                }

                // Duck detection: If the first argument is an array, a bunch of translations was requested.
                // The result is an object.
                if (angular.isArray(translationId)) {
                    var results = {};
                    for (var i = 0, c = translationId.length; i < c; i++) {
                        results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
                    }
                    return results;
                }

                // We discarded unacceptable values. So we just need to verify if translationId is empty String
                if (angular.isString(translationId) && translationId.length < 1) {
                    return translationId;
                }

                // trim off any whitespace
                if (translationId) {
                    translationId = trim.apply(translationId);
                }

                var result, possibleLangKeys = [];
                if ($preferredLanguage) {
                    possibleLangKeys.push($preferredLanguage);
                }
                if (uses) {
                    possibleLangKeys.push(uses);
                }
                if ($fallbackLanguage && $fallbackLanguage.length) {
                    possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
                }
                for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
                    var possibleLangKey = possibleLangKeys[j];
                    if ($translationTable[possibleLangKey]) {
                        if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
                            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
                        }
                    }
                    if (typeof result !== 'undefined') {
                        break;
                    }
                }

                if (!result && result !== '') {
                    if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
                        result = applyNotFoundIndicators(translationId);
                    } else {
                        // Return translation of default interpolator if not found anything.
                        result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

                        // looks like the requested translation id doesn't exists.
                        // Now, if there is a registered handler for missing translations and no
                        // asyncLoader is pending, we execute the handler
                        var missingTranslationHandlerTranslation;
                        if ($missingTranslationHandlerFactory && !pendingLoader) {
                            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
                        }

                        if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
                            result = missingTranslationHandlerTranslation;
                        }
                    }
                }

                return result;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#versionInfo
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the current version information for the angular-translate library
             *
             * @return {string} angular-translate version
             */
            $translate.versionInfo = function () {
                return version;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#loaderCache
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns the defined loaderCache.
             *
             * @return {boolean|string|object} current value of loaderCache
             */
            $translate.loaderCache = function () {
                return loaderCache;
            };

            // internal purpose only
            $translate.directivePriority = function () {
                return directivePriority;
            };

            // internal purpose only
            $translate.statefulFilter = function () {
                return statefulFilter;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#isReady
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns whether the service is "ready" to translate (i.e. loading 1st language).
             *
             * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
             *
             * @return {boolean} current value of ready
             */
            $translate.isReady = function () {
                return $isReady;
            };

            var $onReadyDeferred = $q.defer();
            $onReadyDeferred.promise.then(function () {
                $isReady = true;
            });

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#onReady
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
             *
             * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
             *
             * @param {Function=} fn Function to invoke when service is ready
             * @return {object} Promise resolved when service is ready
             */
            $translate.onReady = function (fn) {
                var deferred = $q.defer();
                if (angular.isFunction(fn)) {
                    deferred.promise.then(fn);
                }
                if ($isReady) {
                    deferred.resolve();
                } else {
                    $onReadyDeferred.promise.then(deferred.resolve);
                }
                return deferred.promise;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * This function simply returns the registered language keys being defined before in the config phase
             * With this, an application can use the array to provide a language selection dropdown or similar
             * without any additional effort
             *
             * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
             */
            $translate.getAvailableLanguageKeys = function () {
                if ($availableLanguageKeys.length > 0) {
                    return $availableLanguageKeys;
                }
                return null;
            };

            /**
             * @ngdoc function
             * @name pascalprecht.translate.$translate#getTranslationTable
             * @methodOf pascalprecht.translate.$translate
             *
             * @description
             * Returns translation table by the given language key.
             *
             * Unless a language is provided it returns a translation table of the current one.
             * Note: If translation dictionary is currently downloading or in progress
             * it will return null.
             *
             * @param {string} langKey A token which represents a translation id
             *
             * @return {object} a copy of angular-translate $translationTable
             */
            $translate.getTranslationTable = function (langKey) {
                langKey = langKey || $translate.use();
                if (langKey && $translationTable[langKey]) {
                    return angular.copy($translationTable[langKey]);
                }
                return null;
            };

            $translate.getTranslationIdsList = function () {
                return translationIdsList;
            };

            $translate.emptyTransactionIdsList = function () {
                translationIdsList = [];
            };

            // Whenever $translateReady is being fired, this will ensure the state of $isReady
            var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
                $onReadyDeferred.resolve();
                globalOnReadyListener(); // one time only
                globalOnReadyListener = null;
            });
            var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
                $onReadyDeferred.resolve();
                globalOnChangeListener(); // one time only
                globalOnChangeListener = null;
            });

            if ($loaderFactory) {

                // If at least one async loader is defined and there are no
                // (default) translations available we should try to load them.
                if (angular.equals($translationTable, {})) {
                    if ($translate.use()) {
                        $translate.use($translate.use());
                    }
                }

                // Also, if there are any fallback language registered, we start
                // loading them asynchronously as soon as we can.
                if ($fallbackLanguage && $fallbackLanguage.length) {
                    var processAsyncResult = function (translation) {
                        translations(translation.key, translation.table);
                        $rootScope.$emit('$translateChangeEnd', {language: translation.key});
                        return translation;
                    };
                    for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
                        var fallbackLanguageId = $fallbackLanguage[i];
                        if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
                            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
                        }
                    }
                }
            } else {
                $rootScope.$emit('$translateReady', {language: $translate.use()});
            }

            return $translate;
        }];
    }

    $translate.displayName = 'displayName';

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateDefaultInterpolation
     * @requires $interpolate
     *
     * @description
     * Uses angular's `$interpolate` services to interpolate strings against some values.
     *
     * Be aware to configure a proper sanitization strategy.
     *
     * See also:
     * * {@link pascalprecht.translate.$translateSanitization}
     *
     * @return {object} $translateDefaultInterpolation Interpolator service
     */
    angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

    function $translateDefaultInterpolation($interpolate, $translateSanitization) {

var $translateInterpolator = {},
            $locale,
            $identifier = 'default';

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Sets current locale (this is currently not use in this interpolation).
         *
         * @param {string} locale Language key or locale.
         */
        $translateInterpolator.setLocale = function (locale) {
            $locale = locale;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Returns an identifier for this interpolation service.
         *
         * @returns {string} $identifier
         */
        $translateInterpolator.getInterpolationIdentifier = function () {
            return $identifier;
        };

        /**
         * @deprecated will be removed in 3.0
         * @see {@link pascalprecht.translate.$translateSanitization}
         */
        $translateInterpolator.useSanitizeValueStrategy = function (value) {
            $translateSanitization.useStrategy(value);
            return this;
        };

        /**
         * @ngdoc function
         * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
         * @methodOf pascalprecht.translate.$translateDefaultInterpolation
         *
         * @description
         * Interpolates given value agains given interpolate params using angulars
         * `$interpolate` service.
         *
         * Since AngularJS 1.5, `value` must not be a string but can be anything input.
         *
         * @param {string} value translation
         * @param {object} [interpolationParams={}] interpolation params
         * @param {string} [context=undefined] current context (filter, directive, service)
         * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
         * @param {string} translationId current translationId
         *
         * @returns {string} interpolated string
         */
        $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
            interpolationParams = interpolationParams || {};
            interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

            var interpolatedText;
            if (angular.isNumber(value)) {
                // numbers are safe
                interpolatedText = '' + value;
            } else if (angular.isString(value)) {
                // strings must be interpolated (that's the job here)
                interpolatedText = $interpolate(value)(interpolationParams);
                interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
            } else {
                // neither a number or a string, cant interpolate => empty string
                interpolatedText = '';
            }

            return interpolatedText;
        };

        return $translateInterpolator;
    }

    $translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

    angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc directive
         * @name pascalprecht.translate.directive:translate
         * @requires $interpolate,
         * @requires $compile,
         * @requires $parse,
         * @requires $rootScope
         * @restrict AE
         *
         * @description
         * Translates given translation id either through attribute or DOM content.
         * Internally it uses $translate service to translate the translation id. It possible to
         * pass an optional `translate-values` object literal as string into translation id.
         *
         * @param {string=} translate Translation id which could be either string or interpolated string.
         * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
         * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
         * @param {string=} translate-default will be used unless translation was successful
         * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
         * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
         * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
         *
         * @example
         <example module="ngView">
         <file name="index.html">
         <div ng-controller="TranslateCtrl">

         <pre translate="TRANSLATION_ID"></pre>
         <pre translate>TRANSLATION_ID</pre>
         <pre translate translate-attr-title="TRANSLATION_ID"></pre>
         <pre translate="{{translationId}}"></pre>
         <pre translate>{{translationId}}</pre>
         <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
         <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
         <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
         <pre translate translate-values="{{values}}">WITH_VALUES</pre>
         <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
         <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

         </div>
         </file>
         <file name="script.js">
         angular.module('ngView', ['pascalprecht.translate'])

         .config(function ($translateProvider) {

         $translateProvider.translations('en',{
         'TRANSLATION_ID': 'Hello there!',
         'WITH_VALUES': 'The following value is dynamic: {{value}}',
         'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
         }).preferredLanguage('en');

         });

         angular.module('ngView').controller('TranslateCtrl', function ($scope) {
         $scope.translationId = 'TRANSLATION_ID';

         $scope.values = {
         value: 78
         };
         });
         </file>
         <file name="scenario.js">
         it('should translate', function () {
         inject(function ($rootScope, $compile) {
         $rootScope.translationId = 'TRANSLATION_ID';

         element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
         $rootScope.$digest();
         expect(element.text()).toBe('Hello there!');

         element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
         $rootScope.$digest();
         expect(element.text()).toBe('Hello there!');

         element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
         $rootScope.$digest();
         expect(element.text()).toBe('Hello there!');

         element = $compile('<p translate>{{translationId}}</p>')($rootScope);
         $rootScope.$digest();
         expect(element.text()).toBe('Hello there!');

         element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
         $rootScope.$digest();
         expect(element.attr('title')).toBe('Hello there!');

         element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
         $rootScope.$digest();
         expect(element.text()).toBe('The interpolation key is camel cased: Hello');
         });
         });
         </file>
         </example>
         */
        .directive('translate', translateDirective);

    function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

/**
         * @name trim
         * @private
         *
         * @description
         * trim polyfill
         *
         * @returns {string} The string stripped of whitespace from both ends
         */
        var trim = function () {
            return this.toString().replace(/^\s+|\s+$/g, '');
        };

        /**
         * @name lowercase
         * @private
         *
         * @description
         * Return the lowercase string only if the type is string
         *
         * @returns {string} The string all in lowercase
         */
        var lowercase = function (string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        };

        return {
            restrict: 'AE',
            scope: true,
            priority: $translate.directivePriority(),
            compile: function (tElement, tAttr) {

                var translateValuesExist = (tAttr.translateValues) ?
                    tAttr.translateValues : undefined;

                var translateInterpolation = (tAttr.translateInterpolation) ?
                    tAttr.translateInterpolation : undefined;

                var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
                    tAttr.translateSanitizeStrategy : undefined;

                var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

                var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
                    watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

                return function linkFn(scope, iElement, iAttr) {

                    scope.interpolateParams = {};
                    scope.preText = '';
                    scope.postText = '';
                    scope.translateNamespace = getTranslateNamespace(scope);
                    var translationIds = {};

                    var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
                        // initial setup
                        if (iAttr.translateValues) {
                            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
                        }
                        // initially fetch all attributes if existing and fill the params
                        if (translateValueExist) {
                            for (var attr in tAttr) {
                                if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                                    var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                                    interpolateParams[attributeName] = tAttr[attr];
                                }
                            }
                        }
                    };

                    // Ensures any change of the attribute "translate" containing the id will
                    // be re-stored to the scope's "translationId".
                    // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
                    var observeElementTranslation = function (translationId) {

                        // Remove any old watcher
                        if (angular.isFunction(observeElementTranslation._unwatchOld)) {
                            observeElementTranslation._unwatchOld();
                            observeElementTranslation._unwatchOld = undefined;
                        }

                        if (angular.equals(translationId, '') || !angular.isDefined(translationId)) {
                            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');

                            // Resolve translation id by inner html if required
                            var interpolateMatches = iElementText.match(interpolateRegExp);
                            // Interpolate translation id if required
                            if (angular.isArray(interpolateMatches)) {
                                scope.preText = interpolateMatches[1];
                                scope.postText = interpolateMatches[3];
                                translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
                                var watcherMatches = iElementText.match(watcherRegExp);
                                if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                                    observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                                        translationIds.translate = newValue;
                                        updateTranslations();
                                    });
                                }
                            } else {
                                // do not assigne the translation id if it is empty.
                                translationIds.translate = !iElementText ? undefined : iElementText;
                            }
                        } else {
                            translationIds.translate = translationId;
                        }
                        updateTranslations();
                    };

                    var observeAttributeTranslation = function (translateAttr) {
                        iAttr.$observe(translateAttr, function (translationId) {
                            translationIds[translateAttr] = translationId;
                            updateTranslations();
                        });
                    };

                    // initial setup with values
                    initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

                    var firstAttributeChangedEvent = true;
                    iAttr.$observe('translate', function (translationId) {
                        if (typeof translationId === 'undefined') {
                            // case of element "<translate>xyz</translate>"
                            observeElementTranslation('');
                        } else {
                            // case of regular attribute
                            if (translationId !== '' || !firstAttributeChangedEvent) {
                                translationIds.translate = translationId;
                                updateTranslations();
                            }
                        }
                        firstAttributeChangedEvent = false;
                    });

                    for (var translateAttr in iAttr) {
                        if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
                            observeAttributeTranslation(translateAttr);
                        }
                    }

                    iAttr.$observe('translateDefault', function (value) {
                        scope.defaultText = value;
                        updateTranslations();
                    });

                    if (translateSanitizeStrategyExist) {
                        iAttr.$observe('translateSanitizeStrategy', function (value) {
                            scope.sanitizeStrategy = $parse(value)(scope.$parent);
                            updateTranslations();
                        });
                    }

                    if (translateValuesExist) {
                        iAttr.$observe('translateValues', function (interpolateParams) {
                            if (interpolateParams) {
                                scope.$parent.$watch(function () {
                                    angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
                                });
                            }
                        });
                    }

                    if (translateValueExist) {
                        var observeValueAttribute = function (attrName) {
                            iAttr.$observe(attrName, function (value) {
                                var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
                                scope.interpolateParams[attributeName] = value;
                            });
                        };
                        for (var attr in iAttr) {
                            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                                observeValueAttribute(attr);
                            }
                        }
                    }

                    // Master update function
                    var updateTranslations = function () {
                        for (var key in translationIds) {
                            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
                                updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
                            }
                        }
                    };

                    // Put translation processing function outside loop
                    var updateTranslation = function (translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
                        if (translationId) {
                            // if translation id starts with '.' and translateNamespace given, prepend namespace
                            if (translateNamespace && translationId.charAt(0) === '.') {
                                translationId = translateNamespace + translationId;
                            }

                            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
                                .then(function (translation) {
                                    applyTranslation(translation, scope, true, translateAttr);
                                }, function (translationId) {
                                    applyTranslation(translationId, scope, false, translateAttr);
                                });
                        } else {
                            // as an empty string cannot be translated, we can solve this using successful=false
                            applyTranslation(translationId, scope, false, translateAttr);
                        }
                    };

                    var applyTranslation = function (value, scope, successful, translateAttr) {
                        if (!successful) {
                            if (typeof scope.defaultText !== 'undefined') {
                                value = scope.defaultText;
                            }
                        }
                        if (translateAttr === 'translate') {
                            // default translate into innerHTML
                            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
                                iElement.empty().append(scope.preText + value + scope.postText);
                            }
                            var globallyEnabled = $translate.isPostCompilingEnabled();
                            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
                            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
                            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
                                $compile(iElement.contents())(scope);
                            }
                        } else {
                            // translate attribute
                            var attributeName = iAttr.$attr[translateAttr];
                            if (attributeName.substr(0, 5) === 'data-') {
                                // ensure html5 data prefix is stripped
                                attributeName = attributeName.substr(5);
                            }
                            attributeName = attributeName.substr(15);
                            iElement.attr(attributeName, value);
                        }
                    };

                    if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
                        scope.$watch('interpolateParams', updateTranslations, true);
                    }

                    // Replaced watcher on translateLanguage with event listener
                    scope.$on('translateLanguageChanged', updateTranslations);

                    // Ensures the text will be refreshed after the current language was changed
                    // w/ $translate.use(...)
                    var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

                    // ensure translation will be looked up at least one
                    if (iElement.text().length) {
                        if (iAttr.translate) {
                            observeElementTranslation(iAttr.translate);
                        } else {
                            observeElementTranslation('');
                        }
                    } else if (iAttr.translate) {
                        // ensure attribute will be not skipped
                        observeElementTranslation(iAttr.translate);
                    }
                    updateTranslations();
                    scope.$on('$destroy', unbind);
                };
            }
        };
    }

    /**
     * Returns the scope's namespace.
     * @private
     * @param scope
     * @returns {string}
     */
    function getTranslateNamespace(scope) {
if (scope.translateNamespace) {
            return scope.translateNamespace;
        }
        if (scope.$parent) {
            return getTranslateNamespace(scope.$parent);
        }
    }

    translateDirective.displayName = 'translateDirective';

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc directive
         * @name pascalprecht.translate.directive:translate-attr
         * @restrict A
         *
         * @description
         * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
         * Internally it uses `translate` service to translate translation id. It possible to
         * pass an optional `translate-values` object literal as string into translation id.
         *
         * @param {string=} translate-attr Object literal mapping attributes to translation ids.
         * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
         * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
         *
         * @example
         <example module="ngView">
         <file name="index.html">
         <div ng-controller="TranslateCtrl">

         <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

         </div>
         </file>
         <file name="script.js">
         angular.module('ngView', ['pascalprecht.translate'])

         .config(function ($translateProvider) {

         $translateProvider.translations('en',{
         'TRANSLATION_ID': 'Hello there!',
         'WITH_VALUES': 'The following value is dynamic: {{value}}',
         }).preferredLanguage('en');

         });

         angular.module('ngView').controller('TranslateCtrl', function ($scope) {
         $scope.translationId = 'TRANSLATION_ID';

         $scope.values = {
         value: 78
         };
         });
         </file>
         <file name="scenario.js">
         it('should translate', function () {
         inject(function ($rootScope, $compile) {
         $rootScope.translationId = 'TRANSLATION_ID';

         element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
         $rootScope.$digest();
         expect(element.attr('placeholder)).toBe('Hello there!');
         expect(element.attr('title)).toBe('The following value is dynamic: 5');
         });
         });
         </file>
         </example>
         */
        .directive('translateAttr', translateAttrDirective);

    function translateAttrDirective($translate, $rootScope) {

return {
            restrict: 'A',
            priority: $translate.directivePriority(),
            link: function linkFn(scope, element, attr) {

                var translateAttr,
                    translateValues,
                    translateSanitizeStrategy,
                    previousAttributes = {};

                // Main update translations function
                var updateTranslations = function () {
                    angular.forEach(translateAttr, function (translationId, attributeName) {
                        if (!translationId) {
                            return;
                        }
                        previousAttributes[attributeName] = true;

                        // if translation id starts with '.' and translateNamespace given, prepend namespace
                        if (scope.translateNamespace && translationId.charAt(0) === '.') {
                            translationId = scope.translateNamespace + translationId;
                        }
                        $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
                            .then(function (translation) {
                                element.attr(attributeName, translation);
                            }, function (translationId) {
                                element.attr(attributeName, translationId);
                            });
                    });

                    // Removing unused attributes that were previously used
                    angular.forEach(previousAttributes, function (flag, attributeName) {
                        if (!translateAttr[attributeName]) {
                            element.removeAttr(attributeName);
                            delete previousAttributes[attributeName];
                        }
                    });
                };

                // Watch for attribute changes
                watchAttribute(
                    scope,
                    attr.translateAttr,
                    function (newValue) {
                        translateAttr = newValue;
                    },
                    updateTranslations
                );
                // Watch for value changes
                watchAttribute(
                    scope,
                    attr.translateValues,
                    function (newValue) {
                        translateValues = newValue;
                    },
                    updateTranslations
                );
                // Watch for sanitize strategy changes
                watchAttribute(
                    scope,
                    attr.translateSanitizeStrategy,
                    function (newValue) {
                        translateSanitizeStrategy = newValue;
                    },
                    updateTranslations
                );

                if (attr.translateValues) {
                    scope.$watch(attr.translateValues, updateTranslations, true);
                }

                // Replaced watcher on translateLanguage with event listener
                scope.$on('translateLanguageChanged', updateTranslations);

                // Ensures the text will be refreshed after the current language was changed
                // w/ $translate.use(...)
                var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

                updateTranslations();
                scope.$on('$destroy', unbind);
            }
        };
    }

    function watchAttribute(scope, attribute, valueCallback, changeCallback) {
if (!attribute) {
            return;
        }
        if (attribute.substr(0, 2) === '::') {
            attribute = attribute.substr(2);
        } else {
            scope.$watch(attribute, function (newValue) {
                valueCallback(newValue);
                changeCallback();
            }, true);
        }
        valueCallback(scope.$eval(attribute));
    }

    translateAttrDirective.displayName = 'translateAttrDirective';

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc directive
         * @name pascalprecht.translate.directive:translateCloak
         * @requires $translate
         * @restrict A
         *
         * $description
         * Adds a `translate-cloak` class name to the given element where this directive
         * is applied initially and removes it, once a loader has finished loading.
         *
         * This directive can be used to prevent initial flickering when loading translation
         * data asynchronously.
         *
         * The class name is defined in
         * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
         *
         * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
         *                                  or hiding the cloak. Basically it relies on the translation
         *                                  resolve.
         */
        .directive('translateCloak', translateCloakDirective);

    function translateCloakDirective($translate, $rootScope) {

return {
            compile: function (tElement) {
                var applyCloak = function (element) {
                        element.addClass($translate.cloakClassName());
                    },
                    removeCloak = function (element) {
                        element.removeClass($translate.cloakClassName());
                    };
                applyCloak(tElement);

                return function linkFn(scope, iElement, iAttr) {
                    //Create bound functions that incorporate the active DOM element.
                    var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
                    if (iAttr.translateCloak && iAttr.translateCloak.length) {
                        // Register a watcher for the defined translation allowing a fine tuned cloak
                        iAttr.$observe('translateCloak', function (translationId) {
                            $translate(translationId).then(iRemoveCloak, iApplyCloak);
                        });
                        $rootScope.$on('$translateChangeSuccess', function () {
                            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
                        });
                    } else {
                        $translate.onReady(iRemoveCloak);
                    }
                };
            }
        };
    }

    translateCloakDirective.displayName = 'translateCloakDirective';

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc directive
         * @name pascalprecht.translate.directive:translateNamespace
         * @restrict A
         *
         * @description
         * Translates given translation id either through attribute or DOM content.
         * Internally it uses `translate` filter to translate translation id. It is possible to
         * pass an optional `translate-values` object literal as string into translation id.
         *
         * @param {string=} translate namespace name which could be either string or interpolated string.
         *
         * @example
         <example module="ngView">
         <file name="index.html">
         <div translate-namespace="CONTENT">

         <div>
         <h1 translate>.HEADERS.TITLE</h1>
         <h1 translate>.HEADERS.WELCOME</h1>
         </div>

         <div translate-namespace=".HEADERS">
         <h1 translate>.TITLE</h1>
         <h1 translate>.WELCOME</h1>
         </div>

         </div>
         </file>
         <file name="script.js">
         angular.module('ngView', ['pascalprecht.translate'])

         .config(function ($translateProvider) {

         $translateProvider.translations('en',{
         'TRANSLATION_ID': 'Hello there!',
         'CONTENT': {
         'HEADERS': {
         TITLE: 'Title'
         }
         },
         'CONTENT.HEADERS.WELCOME': 'Welcome'
         }).preferredLanguage('en');

         });

         </file>
         </example>
         */
        .directive('translateNamespace', translateNamespaceDirective);

    function translateNamespaceDirective() {

return {
            restrict: 'A',
            scope: true,
            compile: function () {
                return {
                    pre: function (scope, iElement, iAttrs) {
                        scope.translateNamespace = _getTranslateNamespace(scope);

                        if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
                            scope.translateNamespace += iAttrs.translateNamespace;
                        } else {
                            scope.translateNamespace = iAttrs.translateNamespace;
                        }
                    }
                };
            }
        };
    }

    /**
     * Returns the scope's namespace.
     * @private
     * @param scope
     * @returns {string}
     */
    function _getTranslateNamespace(scope) {
if (scope.translateNamespace) {
            return scope.translateNamespace;
        }
        if (scope.$parent) {
            return _getTranslateNamespace(scope.$parent);
        }
    }

    translateNamespaceDirective.displayName = 'translateNamespaceDirective';

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc directive
         * @name pascalprecht.translate.directive:translateLanguage
         * @restrict A
         *
         * @description
         * Forces the language to the directives in the underlying scope.
         *
         * @param {string=} translate language that will be negotiated.
         *
         * @example
         <example module="ngView">
         <file name="index.html">
         <div>

         <div>
         <h1 translate>HELLO</h1>
         </div>

         <div translate-language="de">
         <h1 translate>HELLO</h1>
         </div>

         </div>
         </file>
         <file name="script.js">
         angular.module('ngView', ['pascalprecht.translate'])

         .config(function ($translateProvider) {

         $translateProvider
         .translations('en',{
         'HELLO': 'Hello world!'
         })
         .translations('de',{
         'HELLO': 'Hallo Welt!'
         })
         .preferredLanguage('en');

         });

         </file>
         </example>
         */
        .directive('translateLanguage', translateLanguageDirective);

    function translateLanguageDirective() {

return {
            restrict: 'A',
            scope: true,
            compile: function () {
                return function linkFn(scope, iElement, iAttrs) {

                    iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
                        scope.translateLanguage = newTranslateLanguage;
                    });

                    scope.$watch('translateLanguage', function () {
                        scope.$broadcast('translateLanguageChanged');
                    });
                };
            }
        };
    }

    translateLanguageDirective.displayName = 'translateLanguageDirective';

    angular.module('pascalprecht.translate')
        /**
         * @ngdoc filter
         * @name pascalprecht.translate.filter:translate
         * @requires $parse
         * @requires pascalprecht.translate.$translate
         * @function
         *
         * @description
         * Uses `$translate` service to translate contents. Accepts interpolate parameters
         * to pass dynamized values though translation.
         *
         * @param {string} translationId A translation id to be translated.
         * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
         *
         * @returns {string} Translated text.
         *
         * @example
         <example module="ngView">
         <file name="index.html">
         <div ng-controller="TranslateCtrl">

         <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
         <pre>{{ translationId | translate }}</pre>
         <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
         <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

         </div>
         </file>
         <file name="script.js">
         angular.module('ngView', ['pascalprecht.translate'])

         .config(function ($translateProvider) {

         $translateProvider.translations('en', {
         'TRANSLATION_ID': 'Hello there!',
         'WITH_VALUES': 'The following value is dynamic: {{value}}'
         });
         $translateProvider.preferredLanguage('en');

         });

         angular.module('ngView').controller('TranslateCtrl', function ($scope) {
         $scope.translationId = 'TRANSLATION_ID';

         $scope.values = {
         value: 78
         };
         });
         </file>
         </example>
         */
        .filter('translate', translateFilterFactory);

    function translateFilterFactory($parse, $translate) {

var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
            if (!angular.isObject(interpolateParams)) {
                var ctx = this || {
                    '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
                };
                interpolateParams = $parse(interpolateParams)(ctx);
            }

            return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
        };

        if ($translate.statefulFilter()) {
            translateFilter.$stateful = true;
        }

        return translateFilter;
    }

    translateFilterFactory.displayName = 'translateFilterFactory';

    angular.module('pascalprecht.translate')

        /**
         * @ngdoc object
         * @name pascalprecht.translate.$translationCache
         * @requires $cacheFactory
         *
         * @description
         * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
         * can load translation tables directly into the cache by consuming the
         * `$translationCache` service directly.
         *
         * @return {object} $cacheFactory object.
         */
        .factory('$translationCache', $translationCache);

    function $translationCache($cacheFactory) {

return $cacheFactory('translations');
    }

    $translationCache.displayName = '$translationCache';
    return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/accountSettings/accountSettings.mod.js
/* global angular: false */

var IthApiStatusesProfileConst = {
    OK: 'OK',
    PROFILE_NOT_EXISTS: 'PROFILE_NOT_EXISTS',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    USER_NOT_EXISTS: 'USER_NOT_EXISTS',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    INCORRECT_CREDENTIALS: 'INCORRECT_CREDENTIALS',
};

/**
 * apiClients
 */
angular
    .module('accountSettings', ['auth'])
    .constant('API_STATUSES_PROFILE', IthApiStatusesProfileConst);
;

// Source: ../shared/public_html/assets/js/auth/auth.mod.js
/* global angular: false */

var IthApiStatusesUsersConst = {
    OK: 'OK',
    INCORRECT_CREDENTIALS:'INCORRECT_CREDENTIALS',
    NOT_ACTIVATED: 'NOT_ACTIVATED',
    ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
    USER_EXISTS: 'USER_EXISTS',
    USER_NOT_EXISTS: 'USER_NOT_EXISTS',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    PASSWORD_ALREADY_CHANGED: 'PASSWORD_ALEADY_CHANGED'
};

/**
 * Auth module
 */
angular
    .module('auth', [])
    .constant('API_STATUSES_USERS', IthApiStatusesUsersConst);
;

// Source: ../shared/public_html/assets/js/automated-checkin/automated-checkin.mod.js
(function(angular) {
angular.module('ITH.Flights.AutomatedCheckin', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/abTesting/ab-test.mod.js
(function(angular) {
angular.module('ITH.Shared.AbTest', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/base.mod.js
(function(angular, fly, JSAppConfig) {

    var callback = fly.XMLHttpRequest.createXhrCallback(location.origin + '/.*');
    callback.setHeader('NGAUTHTOKEN', JSAppConfig.NGAUTHTOKEN);
    fly.XMLHttpRequest.addCallback(callback);

    /**
     * Main application module
     */
    angular.module('base',
        [
            // Angular core modules
            'ngSanitize',
            'ngTouch',
            'ngAnimate',
            'ngStorage',
            'ngCookies',
            'ngMessages',
            'duScroll',
            'ui.router',

            // Cache buster
            'cacheBuster',

            // AngularJS UI for Bootstrap
            'ui.bootstrap',

            // Google module
            'google',

            // Rafal's slider module
            'rzModule',

            // Static page module
            'staticPage',

            // Search form module
            'searchForm',

            // Angular loading bar module
            'angular-loading-bar',

            // Translation module
            'pascalprecht.translate',

            // AngularJS Parallax
            'ngParallax',

            // Analytics module for AngularJS
            'angulartics',
            'angulartics.google.analytics',

            'auth',
            'user',

            'ITH.Shared.Utils.Stencil',

            // New UI calendar
            'ITH.Base.Calendar',
            'ITH.Base.PriceCalendar',
            'ITH.Base.Ui',

            // New checkin module
            'ITH.Checkin',

            // Including generated templates
            'templates-main',

            'ui.tinymce',
            'ITH.Widgets.SegmentTypeCarrierImage',
            'ITH.Base.Notification',

            // RODO clauses for forms collecting user information
            'ITH.Base.Rodo',

            'ITH.Base.Newsletter',
            //Feature tests
            'ITH.Shared.FlightCancelHelp',

            'ITH.Shared.Zammad'
        ])

        .constant('stateNames', {
            HOMEPAGE: 'homepage',
            FLIGHT_DETAILS: 'flight_details',
            SEARCH_RESULTS: 'search_results',
            SEARCH_RESULTS_2: 'search_results2',
            RANDOM_SEARCH_RESULTS: 'random_search_results',
            MY_BOOKINGS: 'myBookings',
            PASSENGERS: 'passengers',
            PREFERENCES: 'preferences',
            SEARCH_HISTORY: 'searchHistory',
            CASH_BACK: 'cashBack',
            CHECK_IN: 'checkIn',
            NG_PAYMENT: 'ngPayment',
            NG_PAYMENT_2: 'ngPayment2',
            NG_PAYMENT_3: 'ngPayment3',
            BILETE_AVION: 'bilete-avion',
            LANDING_PAGE: 'landing_page',
            PAX_DETAILS: 'pax_details',
            THANK_YOU: 'thank_you'
        })

        /* Set up default location settings and add fallback to 404 */
        .config(['$urlRouterProvider', '$locationProvider', '$compileProvider', 'appConfigProvider', '$uiViewScrollProvider', function($urlRouterProvider,
            $locationProvider,
            $compileProvider,
            appConfig, $uiViewScrollProvider) {
appConfig = appConfig.$get[0]();
            history.scrollRestoration = 'manual';

            // Enable HTML5 mode
            $locationProvider.html5Mode({enabled: true, requireBase: false}).hashPrefix('!');

            // Disable debug data on production
            if(appConfig.isEnvProd()) {
                $compileProvider.debugInfoEnabled(false);
            }

            $uiViewScrollProvider.useAnchorScroll();

            // This was causing IE9 to go on an endless refresh loop on homepage
            // $urlRouterProvider.otherwise(function ($injector, $location) {
            //   window.location = $location.path();
            // });
        }])

        .config(['datepickerConfig', 'datepickerPopupConfig', function(datepickerConfig, datepickerPopupConfig) {
angular.extend(datepickerConfig, {
                maxMode: 'day',
                showWeeks: false,
                formatDay: 'd',
                startingDay: 1
            });

            angular.extend(datepickerPopupConfig, {
                showButtonBar: false,
                startingDay: 1,
                showWeeks: false,
                datepickerPopup: 'dd MMM yyyy',
                appendToBody: true
            });
        }])

        .config(['appConfigProvider', '$translateProvider', function(appConfig, $translateProvider) {
appConfig = appConfig.$get[0]();
            var langCode = appConfig.getLanguageCode();

            /* Sanitize Translations */
            $translateProvider.useSanitizeValueStrategy(null);

            /* Manage translations in the app */
            if(_js_app_config_._js_langs_) {
                $translateProvider.translations(langCode, _js_app_config_._js_langs_);
            }
            else {
                $translateProvider.useUrlLoader('/api/langs/get/' + appConfig.getJsCacheBuster());
            }

            /* Set preferred translate language */
            $translateProvider.preferredLanguage(langCode);

            /* Set moment.js language */
            var langMap = {
                dk: 'da',
                no: 'nn',
                gb: 'en-gb',
                sg: 'en',
                ru: 'ru'
            };
            moment.locale((langMap[langCode]) ? langMap[langCode] : langCode);
        }])

        .config(['$animateProvider', function($animateProvider) {
            //Disable ngAnimate by css class
            //Example: <span ng-if="checked" class="ng-animate-disabled"></span>
            $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
        }])

        .run(['$rootScope', 'rzsliderDirective', 'RzSlider', 'AuthService', 'UserSessionData', 'JwtTokenService', 'TermsAndConditionsService', 'UsersServiceClient', function($rootScope, rzsliderDirective, RzSlider, AuthService, UserSessionData, JwtTokenService, TermsAndConditionsService, UsersServiceClient) {
            $rootScope.UserSessionData = UserSessionData;

            var token = JwtTokenService.getAuthJwtToken();

            if (token) {
                UsersServiceClient
                    .getSystemData(token)
                    .then(function (systemData) {
                        UserSessionData.setData(JwtTokenService.getDataFromAuthJwtToken(), systemData.data);
                        $rootScope.$emit('userLogged', true);

                        if (!UserSessionData.isTermsAndConditionsAccepted() && !TermsAndConditionsService.shouldHideModal()) {
                            TermsAndConditionsService.proposeToAccept();
                        }
                    });
            }

            var bindEvents = RzSlider.prototype.bindEvents;

            if(_user_) {
                AuthService.setAuthData(_user_, false);
            }

            // Change template
            rzsliderDirective.templateUrl = 'rzSliderTpl.html';

            // Click event
            RzSlider.prototype.bindEvents = function() {
                var self = this;

                bindEvents.apply(this);

                angular.element([this.fullBar[0], this.selBar[0]]).bind('click', function(event) {
                    angular.element((self.maxH.rzsl - event.offsetX < event.offsetX - self.minH.rzsl) && self.range ? self.maxH : self.minH).triggerHandler('mousedown');
                    self.onMove(self, event);
                    self.onEnd(function() {
                    }, event);
                    angular.element(document).triggerHandler('mouseup');
                    angular.element(document).triggerHandler('touchend');
                });
            };
        }])

        .config(['$urlMatcherFactoryProvider', function($urlMatcherFactory) {
            function valToString(val) {
                return val != null ? val.toString() : val;
            }

            function valFromString(val) {
                return val != null ? val.toString() : val;
            }

            function regexpMatches(val) { /*jshint validthis:true */
                return this.pattern.test(val);
            }

            $urlMatcherFactory.type('StaticPageParams', {
                encode: valToString,
                decode: valFromString,
                is: regexpMatches,
                pattern: /(?:.*)?/
            });
        }])

        .run(['$rootScope', '$state', '$location', '$translate', '$window', 'PageLoading', 'TranslationCollectionService', 'StaticPageHelper',
            function ($rootScope, $state, $location, $translate, $window, PageLoading, TranslationCollectionService, StaticPageHelper) {
$rootScope.insuranceOn = _js_app_config_.insuranceStatus;

                if(_js_app_config_.device.mobile && !_js_app_config_.device.tablet) {
                    $rootScope.deviceMobile = true;
                } else {
                    if(_js_app_config_.device.tablet && _js_app_config_.device.mobile) {
                        $rootScope.deviceTablet = true;
                    } else {
                        if(!_js_app_config_.device.tablet && !_js_app_config_.device.mobile) {
                            $rootScope.deviceDesktop = true;
                        }
                    }
                }
                if(_js_app_config_.device.mobile && !_js_app_config_.device.tablet && _js_app_config_.device.orientation == 'landscape') {
                    $rootScope.deviceMobileLandscape = true;
                } else {
                    if(_js_app_config_.device.tablet && _js_app_config_.device.mobile && _js_app_config_.device.orientation == 'landscape') {
                        $rootScope.deviceTabletLandscape = true;
                    }
                }

                $rootScope.$on('translationIdCollected', function () {
                    TranslationCollectionService.sendCollectedTranslationIds();
                });

                $rootScope.$on('$locationChangeStart', function (event, next, current) {
                    if (next !== current) { // if SPA router page changes
                        TranslationCollectionService.resetSentTranslationIdsList();
                        $translate.emptyTransactionIdsList();
                    }
                });

                $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                    if(StaticPageHelper.isStaticPage(toState.name)) {
                        $rootScope.autoscroll = true;
                    }
                });

                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    if (typeof newrelic == 'object') {
                        newrelic.setCustomAttribute('angularViews', JSON.stringify(toState.views));
                    }

                    if (fromState.name != '' && StaticPageHelper.isStaticPage(toState.name)) {
                        PageLoading.on();
                        $window.location.reload();
                    }
                });

                /**
                 * Returns first part of the current url path for easy detection of different headers on the navbar
                 *
                 * @return {String} containing the first part of the url after the domain
                 */
                $rootScope.currentPath = function() {
                    $rootScope.userBarCurrent = '';
                    var controllerName = $location.path().split('/')[1];

                    if(controllerName) {
                        return controllerName.trim();
                    }

                    // TODO: what happens when we return empty string here. Angi ?
                    return '';
                };

                $rootScope.currentLang = $translate.proposedLanguage();
                $rootScope.autoscroll = true;
                $rootScope.$state = $state;

                //load validation messages for ng-include-messages
                //$templateRequest('/tpl/show/jsShared/templates/base/directives/errors/validationMessages')

                $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
                    var navbar = toState.views.navbar;

                    if(navbar) {
                        $rootScope.navbar = {
                            templateUrl: navbar.templateUrl,
                            controller: navbar.controller
                        };
                    }
                });
            }])

        .config(['$provide', function($provide) {
            $provide.decorator('tooltipPopupDirective', ['$delegate', function($delegate) {
                var directive = $delegate[0];
                directive.templateUrl = '/tpl/show/jsShared/templates/base/directives/tooltips/tooltipGeneral';
                return $delegate;
            }]);
        }])

        .run(['LocationTranslator', function (LocationTranslator) {
            LocationTranslator.load();
        }])

        .value('duScrollOffset', 0)
        .value('duScrollDuration', 1000);

})(angular, fly, _js_app_config_);
;

// Source: ../shared/public_html/assets/js/base/calendar/calendar.mod.js
(function(angular) {
angular.module('ITH.Base.Calendar', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter/newsletter.mod.js
(function(angular) {
/**
     * Module that handles pages related to newsletter system
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    angular.module('ITH.Base.Newsletter', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/notification/notification.mod.js
/**
 * Notification module
 */
angular.module('ITH.Base.Notification', []);;

// Source: ../shared/public_html/assets/js/base/price-calendar/ith-price-calendar.mod.js
(function(angular) {
angular.module('ITH.Base.PriceCalendar', [
    'flight'
  ]);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo.mod.js
(function(angular) {
/**
     * Module responsible for showing EU regulations clauses on pax details
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    angular.module('ITH.Base.Rodo', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/ui.mod.js
(function(angular) {
angular.module('ITH.Base.Ui', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/basket/basket.mod.js
/* global angular: false */

/**
 * Basket module
 */
angular.module('basket', []);

;

// Source: ../shared/public_html/assets/js/billing/billing.mod.js
/* global angular: false */

/**
 * Billing module
 */
angular.module('billing', []);
;

// Source: ../shared/public_html/assets/js/book/book.mod.js
/* global angular: false */

/**
 * Booking module
 */
angular.module('book', [
    'billing',
    'ITH.Shared.Form',
    'ngMask',
    'ITH.Funnel.Refunds',
    'ITH.Funnel.FastRefund',
    'ITH.Funnel.CFAR',
    'ibe-luggage',
    'ITH.Funnel.Seats'
]);
;

// Source: ../shared/public_html/assets/js/cacheBuster/cacheBuster.mod.js
/*global _template_cache_buster: false */

(function () {
/**
   * @name        cacheBuster
   * @description Intercepts $http and adds a cachebuster parameter to the request
   */
  angular.module('cacheBuster', [])

  /**
   * Provider decorator
   */
    .config(["$provide", function ($provide) {
      return $provide.decorator("$http", ["$delegate", function ($delegate) {
        var get = $delegate.get;

        $delegate.get = function (url, config) {
          // url = appendSuffix(url);
          return get(url, config);
        };

        return $delegate;
      }]);
    }])

    .config(["$provide", function ($provide) {
      return $provide.decorator("$templateCache", ["$delegate", function ($delegate) {
        var put = $delegate.put;

        $delegate.put = function (url, content) {
          // url = appendSuffix(url);
          return put(url, content);
        };

        return $delegate;
      }]);
    }]);

  /**
   * Append suffix to url
   *
   * @param {String} url
   * @return {String}
   */
  function appendSuffix(url) {
    if (_template_cache_buster !== '__local__' && url.indexOf('template/')) //when at the beginning, for a reason?
    {
      if (url.indexOf("?v=") == -1) {
        url += (url.indexOf("?") === -1 ? "?" : "&");
        url += "v=" + _template_cache_buster;
        url += "&abv="+_js_app_config_.ab_version;
      }
    }

    return url;
  }

})();
;

// Source: ../shared/public_html/assets/js/calendar/calendar.mod.js
/* global angular: false */

/**
 * Big flex calendar module
 */
angular.module('calendar', ['ui.bootstrap.datepicker', 'base', 'search']);
;

// Source: ../shared/public_html/assets/js/checkin/checkin.mod.js
(function(angular) {
/**
     * Module that handles check-in inside profiles.
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    angular.module('ITH.Checkin', [
        'flightDetails',
        'insurance',
        'ITH.Shared.Form'
    ]);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/city-helper.mod.js
/* global angular: false */

/**
 * city hepler module
 *
 * @namespace
 */
angular.module('cityHelper', []);
;

// Source: ../shared/public_html/assets/js/dbStates/dbStates.mod.js
/* global angular: false */

/**
 * States module
 */
angular.module('dbStates', [
  'base',
  'ui.router',
  'oc.lazyLoad'
])

  .config(['$stateProvider', 'appConfigProvider', function ($stateProvider, appConfig) {
    appConfig = appConfig.$get[0]();
    var routes = appConfig.getRoutes();


    /**
     * Fix for broken URL generation for `flight_details` state.
     * This state's `url` param is `"\/flightDetails\/get\/{requestId}\/{priceGroupId}\/{fsId}\/{depLegId}{slashRetLegId:(?:\/)?}{retLegId:(?:[^\/]+)?}{pax:(?:.*)?}"`.
     * UI Router fails to generate correct URL out of standard params. It generates something like:
     * `/flightDetails/get/xgxgiax58lpj6tq59253nxsanykwus5s/VFZGQDk1ZjJhMDZlLTdmMjktNDgyMy1iNWQyLWE4YmY2MDQ5YmI5Mw==/M2UzMDk4YjVlYWI5MGVkMWE2ZWU0ZmVjMjUzYmQ5NzM=/VFZGQEowMVY4TFZJSTBBMU1COFQ=%252FVFZGQFRRUzdVNUdTOTBZQUxXNlM=%252F%3Ftab=1`
     * Instead:
     * `/flightDetails/get/c24d6fe48d4d9eb194c8b61dfc920522/VFZGQDk1ZjJhMDZlLTdmMjktNDgyMy1iNWQyLWE4YmY2MDQ5YmI5Mw==/M2UzMDk4YjVlYWI5MGVkMWE2ZWU0ZmVjMjUzYmQ5NzM=/VFZGQEowMVY4TFZJSTBBMU1COFQ=/VFZGQFRRUzdVNUdTOTBZQUxXNlM=/%3Ftab=1`
     * Note that `/` are encoded to `%252F`.
     * This hack overrides `flight_details` state's URL-matcher's `format` function to decode slashes back.
     * https://github.com/angular-ui/ui-router/blob/0.4.2/src/urlMatcherFactory.js#L338
     *
     * This `decorator` method change the way `url` state param is processed upon states configuration.
     * Old (default) logic is under `parent` argument. It creates UI Router's UrlMatcher object, that expose
     * URL-related functions. One of them is `format`. It generates URL from state params. It's the one we
     * override for `flight_details`.
     */
    $stateProvider.decorator('url', function (state, parent) {
      var matcher = parent(state);
      if (state.name !== 'flight_details' || !angular.isObject(matcher) || !angular.isFunction(matcher.format)) {
        return matcher;
      }
      var old = matcher.format;
      matcher.format = function () {
        return old.apply(this, arguments).replace(/%252F/g, '/');
      };
      return matcher;
    });

    // ADD DB ROUTES
    _.each(routes, function (route) {
      // Delete property that is not needed by ui-router state
      delete route.index;

      // Go over views and clean up / update them to match ui-router requirements
      _.each(route.views, function (r) {
        // Delete property if it's not set
        if (!r.templateUrl) {
          r.templateUrl = '/tpl/show/jsShared/templates/base/loading/fullPageLoader';
        }
      });

      if (route.hasOwnProperty('site_sections') && route.site_sections.length > 0) {
        route.resolve = {};

        _.each(route.site_sections, function (siteSection) {
          var files = appConfig.getLazyFiles(siteSection);

          /**
           * NPBW-456 - we don't want funnel as a separate package anymore
           * In order to remove this 'if' every entry with 'funnel' in it must me cleaned in db (administration/routes)
           */
          if(siteSection === 'funnel'){
            return false;
          }

          route.resolve['lazyload_' + siteSection] = ['$ocLazyLoad', function ($ocLazyLoad) {
            var promise = $ocLazyLoad.load(files);

            promise.then(angular.noop, function (failureReason) {
              console.error(failureReason);
            });

            return promise;
          }];
        });
      }

      // Add DB route as state
      $stateProvider.state(route);
    });
  }]);
;

// Source: ../shared/public_html/assets/js/discounts/discount.mod.js
/* global angular: false */

/**
 * Discounts module
 */
angular.module('discount', []);

;

// Source: ../shared/public_html/assets/js/faq/faq.mod.js
/* global angular: false */

/**
 * FAQ module
 */
angular.module('faq', []);
;

// Source: ../shared/public_html/assets/js/flight/flight.mod.js
/* global angular: false */

/**
 * Flight module
 */
angular.module('flight', [
  'basket',
  'book',
  'discount',
  'search',
  'ITH.Widgets.SegmentAlertComponent',
  'ITH.Widgets.SegmentRefuelAlert',
  'ITH.Flyhacks.Flight.PaxReconfiguration',
  'ITH.insurance',
  'ITH.Shared.Flight.PriceTrends',
  'ITH.Shared.AbTest'
]);

;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/loading-carousel/loading-carousel.mod.js
/**
 * Pax reconfiguration loading carousel module.
 */
angular.module('ITH.Flyhacks.Flight.LoadingCarousel', []);;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/pax-reconfiguration.mod.js
/**
 * Pax reconfiguration module.
 */
angular.module('ITH.Flyhacks.Flight.PaxReconfiguration', [
    'ITH.Flyhacks.Flight.LoadingCarousel'
]);;

// Source: ../shared/public_html/assets/js/flight/price-trends/price-trends.mod.js
(function(angular) {
angular.module('ITH.Shared.Flight.PriceTrends', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/flightDetails.mod.js
/* global angular: false */

/**
 * Flight details module
 *
 * @namespace
 */
angular.module('flightDetails', [
    'ITH.Flights.AutomatedCheckin',
    'ibe-luggage'
]);
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/ibe-luggage.mod.js
(function(angular) {
angular.module('ibe-luggage', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/form.mod.js
/* global angular: false */

/**
 * Form
 */
angular.module('ITH.Shared.Form', []);
;

// Source: ../shared/public_html/assets/js/funnel/ancillaries/ancillaries.mod.js
(function(angular) {
angular.module('ITH.Funnel.Ancillaries', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/cfar/cfar.mod.js
(function (angular) {
angular.module('ITH.Funnel.CFAR', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock.mod.js
(function (angular) {
angular.module('ITH.Funnel.FareLock', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fast-refund/fast-refund.mod.js
(function(angular) {
angular.module('ITH.Funnel.FastRefund', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/funnel.mod.js
(function(angular) {
var FunnelModuleRun = function ($location, AppConfig) {
        if (window.Worker) {
            // Instantiate shelf cache cleanup worker
            var assetsPath = '/assets/v-' + AppConfig.getJsCacheBuster() + '/js/dist/workers/';
            var shelfCacheWorker = new Worker(assetsPath + 'shelf-cache.worker.js');

            if ($location.search().hasOwnProperty('shelfCacheFlush')) {
                shelfCacheWorker.postMessage('flush');
            }
        }
    };

    FunnelModuleRun.$inject = [
        '$location',
        'appConfig'
    ];

    /**
     * Funnel module
     */
    angular
        .module('funnel', [
            'base',
            'sticky',
            'ITH.Shared.Form',
            'ITH.Funnel.BillingSwitch',
            'ITH.Funnel.BillingSwitchVolaWrapper',
            'ITH.Funnel.BillingSwitchFruWrapper',
            'ITH.Funnel.BillingRadio',
            'ITH.Funnel.UiCheckboxForm',
            'ITH.Funnel.TermsAndConditionsText',
            'ITH.Funnel.Refunds',
            'ITH.Funnel.FastRefund',
            'ITH.Funnel.CFAR',
            'ITH.Funnel.FareLock',
            'ITH.Funnel.Seats',
            'ITH.Funnel.Ancillaries',
            'ITH.Shared.Common.PaymentStatus',
            'ITH.Shared.Common.PaymentTokenize',
            'ITH.Shared.Common.PaymentApi',
            'ITH.Shared.Common.Fingerprint',
            'ITH.Shared.Common.Monitoring',
            'google'
        ])
        .run(FunnelModuleRun);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance.mod.js
/*
* Module short description
* handle for new insurance logic (php adapter)
* @author John Doe <dominik.kajzar@fru.pl>
*/
angular.module('ITH.insurance', ['ITH.Shared.Flight.PriceTrends']);
;

// Source: ../shared/public_html/assets/js/funnel/refunds/refunds.mod.js
angular.module('ITH.Funnel.Refunds',[]);
;

// Source: ../shared/public_html/assets/js/funnel/seats/seats.mod.js
(function(angular) {
angular.module('ITH.Funnel.Seats', []);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/terms-and-conditions-text/termsAndConditionsText.mod.js


/**
 * Text and conditions  module
 */
angular.module('ITH.Funnel.TermsAndConditionsText', [

]);;

// Source: ../shared/public_html/assets/js/google/google.mod.js
/**
 * Google module that includes Analytics and AdWords functionalities
 */
angular.module('google', [])


/**
 * contant for package
 */
.constant('pkg.analytics', {
    // OFFER DETAILS
    CB_HELPER_ADULT             : 'ADT',
    CB_HELPER_CHILD             : 'CHD',
    CB_HELPER_ATTRACTION_TAB    : 'tourist-attractions',
    CB_HELPER_TRANSPORT_TAB     : 'public-transport',
    CB_CALENDAR_PAGE_1          : '/virtual/packages/details/date1_pick',
    CB_CALENDAR_TITLE_1         : 'CityBreak Details Date 1 pick',
    CB_CALENDAR_PAGE_2          : '/virtual/packages/details/date2_pick',
    CB_CALENDAR_TITLE_2         : 'CityBreak Details Date 2 pick',
    CB_GALLERY_BUTTON           : 'cb_gallery_button',
    CB_MONTH_BAR                : 'cb_month_bar',
    CB_MONTH_ARROW              : 'cb_month_arrow',
    CB_SEARCH_RESULTS           : 'cb_search_results',
    CB_GALLERY_OPEN             : 'cb_gallery_open',
    CB_GALLERY_NEXT             : 'cb_gallery_next',
    CB_GALLERY_SMALL_NEXT       : 'cb_gallery_small_next',
    CB_INFORMATION              : 'cb_information',
    CB_CHANGE_DATE              : 'cb_change_date',
    CB_COUPON_ENTER             : 'cb_coupon_enter',
    CB_COUPON_USED              : 'cb_coupon_used',
    CB_FORM_ERROR               : 'cb_form_error',
    CB_CHOOSE_DATES             : 'cb_choose_dates',
    CB_MORE_OPINIONS            : 'cb_more_opinions',
    CB_PAX_CONFIG               : 'cb_pax_config',
    CB_ADD_ADULT                : 'cb_add_adult',
    CB_ADD_CHILDREN             : 'cb_add_children',
    CB_ADD_ROOM                 : 'cb_add_room',
    CB_                         : 'cb_',
    //SEARCH PANEL
    CB_SEARCH_DEPARTURE_FIELD               : 'cb_search_departure_field',
    CB_SEARCH_DEPARTURE_CLICKED             : 'cb_search_departure_clicked',
    CB_SEARCH_DEPARTURE_CHOSEN              : 'cb_search_departure_chosen',
    CB_SEARCH_DEPARTURE_CLOSE               : 'cb_search_departure_close',
    CB_SEARCH_DESTINATION_FIELD             : 'cb_search_destination_field',
    CB_SEARCH_DESTINATION_CATEGORY_CLICK    : 'cb_search_destination_category_click',
    CB_SEARCH_DESTINATION_ADDED_CHECKBOX    : 'cb_search_destination_added_checkbox',
    CB_SEARCH_DESTINATION_ADDED_TYPING      : 'cb_search_destination_added_typing',
    CB_SEARCH_DESTINATION_CHOSEN            : 'cb_search_destination_chosen',
    CB_SEARCH_DESTINATION_CLOSE             : 'cb_search_destination_close',
    CB_SEARCH_PERIOD_FIELD                  : 'cb_search_period_field',
    CB_SEARCH_PERIOD_CATEGORY               : 'cb_search_period_category',
    CB_SEARCH_PERIOD_MONTH                  : 'cb_search_period_month',
    CB_SEARCH_PERIOD_ALLMONTHS              : 'cb_search_period_allmonths',
    CB_SEARCH_PERIOD_RESETMONTHS            : 'cb_search_period_resetmonths',
    CB_SEARCH_PERIODMONTHS_CHOSEN           : 'cb_search_periodmonths_chosen',
    CB_SEARCH_PERIOD_DEPARTUREAFTER         : 'cb_search_period_departureafter',
    CB_SEARCH_PERIOD_RETURNBEFORE           : 'cb_search_period_returnbefore',
    CB_SEARCH_PERIOD_DATERANGE_CHOSEN       : 'cb_search_period_daterange_chosen',
    CB_SEARCH_PERIOD_CLOSE                  : 'cb_search_period_close',
    CB_SEARCH_BUTTON                        : 'cb_search_button'
})

;

// Source: ../shared/public_html/assets/js/insurance/insurance.mod.js
/* global angular: false */

/**
 * Booking module
 */
angular.module('insurance', []);
;

// Source: ../shared/public_html/assets/js/landingPages/landingPages.mod.js
/* global angular: false */

/**
 * Landing pages module
 */
angular.module('landingPages', []);
;

// Source: ../shared/public_html/assets/js/search/search.mod.js
/* global angular: false */

/**
 * Vacations module
 */
angular.module('search', []);
;

// Source: ../shared/public_html/assets/js/searchForm/searchForm.mod.js
/* global angular: false */

angular.module('searchForm.package', []);
angular.module('searchForm.hotel', []);

angular.module('searchForm', [
  'searchForm.package',
  'searchForm.hotel'
])

/**
 * The params type
 * @type {{single: number, mk: number, mv: number, sd: number}}
 */
.value('paramTypes', {
  /**
   * Single value
   */
  single: 1,

  /**
   * Multiple keys
   */
  mk: 2,

  /**
   * Multiple values
   */
  mv: 3,

  /**
   * Single date value
   */
  sd: 4
});
;

// Source: ../shared/public_html/assets/js/searchOptions/searchOptions.mod.js
/* global angular: false */

/**
 * Vacations module
 */
angular.module('searchOptions', []);

;

// Source: ../shared/public_html/assets/js/staticPage/staticPage.mod.js
/* global angular: false */

/**
 * Static page module
 */
angular.module('staticPage', []);;

// Source: ../shared/public_html/assets/js/user/user.mod.js
/* global angular: false */

/**
 * User module
 */
angular.module('user', ['auth', 'accountSettings']);;

// Source: ../shared/public_html/assets/js/vacation/vacation.mod.js
/* global angular: false */

/**
 * Vacations module
 */
angular.module('vacation', []);

;

// Source: ../shared/public_html/assets/js/widgets/segment-alert/segment.alert.mod.js
/**
 * Segment Alert Component
 */


angular.module('ITH.Widgets.SegmentAlertComponent', [
    'ngSanitize'

]);





;

// Source: ../shared/public_html/assets/js/widgets/segment-refuel-alert/segment-refuel-alert.mod.js
/**
 * Segment refuel Component
 */


angular.module('ITH.Widgets.SegmentRefuelAlert', []);





;

// Source: ../shared/public_html/assets/js/widgets/segment-type-carrier-image/segment-type-carrier-image.mod.js
/**
 * Segment Alert Component
 */


angular.module('ITH.Widgets.SegmentTypeCarrierImage', []);





;

// Source: ../shared/public_html/assets/js/widgets/toggle/toggle.mod.js
/**
 * Module short description
 * Toggle switch
 * @author Dominik Kajzar <dominik.kajzar@fru.pl>
 */
angular.module('ITH.Widgets.Toggle', [

]);
;

// Source: ../shared/public_html/assets/js/zammad/zammad.mod.js
(function(angular) {
angular.module('ITH.Shared.Zammad', ['ITH.Shared.Form']);

}(angular));
;

// Source: ../shared/public_html/assets/js/_modern_bundle/bundle.js
!function(){"use strict";function t(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function e(t,e,n){if(o())return Reflect.construct.apply(null,arguments);var r=[null];r.push.apply(r,e);var i=new(t.bind.apply(t,r));return n&&c(i,n.prototype),i}function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,u(r.key),r)}}function r(t,e,r){return e&&n(t.prototype,e),r&&n(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function i(t,e,n){return(e=u(e))in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function o(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(t){}return(o=function(){return!!t})()}function s(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function a(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?s(Object(n),!0).forEach((function(e){i(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function c(t,e){return(c=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function u(t){var e=function(t,e){if("object"!=typeof t||!t)return t;var n=t[Symbol.toPrimitive];if(void 0!==n){var r=n.call(t,e||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)}(t,"string");return"symbol"==typeof e?e:e+""}function p(t,n){var r=angular.module(t,n);return{directive:function(t,e){(e=i(e)).prototype.compile||(e.prototype.compile=function(){});var n=(s=e.prototype.compile,function(){return s.apply(this,arguments)});var s;a=e.prototype,c="compile",u=function(){return function(){if(n.apply(this,arguments),e.prototype.link)return e.prototype.link.bind(this)}},a[c]=u(a[c]);var a,c,u;var p=o(e);return r.directive(t,p),this},controller:function(t,e){return r.controller(t,e),this},component:function(t,e){return r.component(t,e),this},service:function(t,e){return r.service(t,e),this},provider:function(t,e){return r.provider(t,e),this},factory:function(t,e){var n=o(e=i(e));return r.factory(t,n),this}};function i(t){var e;if(t.constructor===Array){var n=t.slice(0,t.length-1);(e=t[t.length-1]).$inject=n}else e=t;return e}function o(t){var n=(t.$inject||[]).slice();return n.push((function(){for(var n=arguments.length,r=new Array(n),i=0;i<n;i++)r[i]=arguments[i];var o=e(t,r);for(var s in o)o[s]=o[s];return o})),n}}function l(){return window._js_app_config_}var h=function(){return r((function e(){t(this,e),this.restrict="A",this.scope={event:"@ithStOn",callback:"&ithStCallback"}}),[{key:"link",value:function(t,e){e[0].addEventListener(t.event,(function(e){t.callback({event:e})}))}}])}();p("ITH.Shared.Utils.Stencil",[]).directive("ithStOn",h);var d={PENDING:0,SUCCESS:1,ERROR:-1,DISABLED:-2,INIT:-3,EXPIRED:-4},f={PAYMENT_STATUS:{url:"api/paymentStatus/check?abv="+l().ab_version,method:"GET",respParser:function(t){var e,n=t.response,r=(n.status||"").toUpperCase();return(e=Object.keys(d).includes(r)?d[r]:d.DISABLED)===d.INIT&&(e=d.PENDING),n.status=e,n}}},v=function(){function e(n,r,i){t(this,e),this.$timeout=n,this.$q=r,this.api=i,this.status=d.PENDING,this.redirectUrl="",this.paymentToken="",this.pendingAttempts=0,this.maxPendingAttempts=20,this.paymentLifetime=0,this.errorMessage=null}return e.$inject=["$timeout","$q","ApiTools"],r(e,[{key:"statuses",get:function(){return d}},{key:"statusInterval",get:function(){return 3e3}},{key:"maxPaymentLifetime",get:function(){return 1200}},{key:"setStatus",value:function(t){this.status=t}},{key:"getStatus",value:function(){return this.status}},{key:"isPending",value:function(){return this.status===d.PENDING}},{key:"isSuccess",value:function(){return this.status===d.SUCCESS}},{key:"isError",value:function(){return this.status===d.ERROR}},{key:"isDisabled",value:function(){return this.status===d.DISABLED}},{key:"isExpired",value:function(){return this.status===d.EXPIRED}},{key:"getRedirectUrl",value:function(){return this.redirectUrl}},{key:"getErrorMessage",value:function(){return this.errorMessage}},{key:"fetchStatus",value:function(t){var e=this,n=t.reservationNumber,r=f.PAYMENT_STATUS.url+"&reservationNumber=".concat(n);return this.api.fetch(this,a(a({},f.PAYMENT_STATUS),{},{url:r}),{reservationNumber:n}).then((function(t){return e.redirectUrl=t.redirectUrl,e.paymentToken=t.paymentToken||"",e.pendingAttempts+=1,e.paymentLifetime=t.lifetime,e.errorMessage=t.errorMessage,t.status}),(function(t){return d.DISABLED}))}},{key:"initPaymentDeadlineCountdown",value:function(t){var e=1e3*t-Date.now();e<0&&(e=0),this.$timeout(function(){this.isSuccess()||this.isPending()||this.setStatus(d.EXPIRED)}.bind(this),e)}},{key:"redirectAfterDelay",value:function(){this.$timeout(function(){this.isPending()&&this.getRedirectUrl()&&(window.location.href=this.getRedirectUrl())}.bind(this),1e4)}}])}();p("ITH.Shared.Common.PaymentStatus",[]).service("PaymentStatusService",v);var y=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("IdleTokenizer. Credit Card data isn't tokenized.")},t.prototype.parseToken=function(t){return this.$q.reject("IdleTokenizer. Token data isn't tokenized.")},t}(),_=function(){function t(t){this.scriptSrc="https://js.paymentsos.com/v2/latest/token.min.js",this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){var e=document.createElement("script"),n=t.environment,r=t.publicKey;return this.credential=t,e.src=this.scriptSrc,document.body.appendChild(e),this.$q((function(t,i){e.onload=e.onreadystatechange=function(e){window.POS.setEnvironment(n),window.POS.setPublicKey(r),t(e)},e.onerror=i}))},t.prototype._transformDate=function(t){var e=t.split("-");return e[1]+"-"+e[0]},t.prototype.tokenize=function(t){var e=this,n={token_type:"credit_card",holder_name:t.full_name,expiration_date:this._transformDate(t.expiration),card_number:t.number,credit_card_cvv:t.cvc};return this.$q((function(r,i){window.POS.tokenize(n,function(e,n,r){return function(i){var o=JSON.parse(i);o.bin_number||(o.bin_number=t.number.replace(/[^0-9]/g,"").slice(0,6)),o.token?n({bin:o.bin_number,card_token:o.token,cvc:o.encrypted_cvv,gatewayParams:e.params,validationType:e.type}):r(new Error("PaymentTokenize TokenPayU failed: "+i))}}(e.credential,r,i))}))},t.prototype.parseToken=function(t){return this.$q.reject("PayUTokenizer. Token data isn't tokenized.")},t}(),g=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.getBin=function(t){return t.replace(/[^0-9]/g,"").slice(0,6)},t.prototype.tokenize=function(t){return this.cardData=t,this.$q.resolve({bin:this.getBin(t.number),gatewayParams:this.credential.params,validationType:this.credential.type})},t.prototype.parseToken=function(t){return this.$q.reject("MobilPayTokenizer. Token data isn't tokenized.")},t}(),m=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("GooglePayTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({signedMessage:e.signedMessage,protocolVersion:e.protocolVersion,signature:e.signature,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),b=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("ApplePayTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({data:e.data,version:e.version,signature:e.signature,ephemeralPublicKey:e.header.ephemeralPublicKey,publicKeyHash:e.header.publicKeyHash,transactionId:e.header.transactionId,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),E=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("BlikAuthCodeTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({authorizationCode:e.authorizationCode,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),S=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("PayByLinkTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({bankCode:e.bankCode,languageCode:e.languageCode,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),w=function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("TransferTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({type:e.type,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),k={IdleTokenizer:y,TokenPayU:_,GooglePayToken:m,BlikAuthCode:E,PayByLinkToken:S,ApplePayToken:b,MobilPay:g,PaymentInitFlow:w,CreditCardInstallmentsToken:function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.tokenize=function(t){return this.$q.reject("CreditCardInstallmentsTokenizer. Credit Card data isn't supported.")},t.prototype.parseToken=function(t){var e=JSON.parse(t);return this.$q.resolve({installments:e.installments,gatewayParams:this.credential.params,validationType:this.credential.type})},t}(),RevolutCard:function(){function t(t){this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){return this.credential=t,this.$q.resolve()},t.prototype.getBin=function(t){return t.replace(/[^0-9]/g,"").slice(0,6)},t.prototype.tokenize=function(t){return this.cardData=t,this.$q.resolve({bin:this.getBin(t.number),gatewayParams:this.credential.params,validationType:this.credential.type})},t.prototype.parseToken=function(t){return this.$q.reject("RevolutTokenizer. Token data isn't tokenized.")},t}(),ApplePayRevolutWidgetToken:w,GooglePayRevolutWidgetToken:w,RevolutPayToken:w},x=function(){function t(t){this.strategy=null,this.strategyInitialized=!1,this.credentials=[],this.$q=t}return t.$inject=["$q"],t.prototype.init=function(t){var e=this;return t.type||(t.type="IdleTokenizer"),k[t.type]?(this.strategy=new k[t.type](this.$q),this.strategy.init(t).then((function(){e.strategyInitialized=!0}))):this.$q.reject(new TypeError("Wrong driver. Please enter valid driver type."))},t.prototype.setCredentials=function(t){this.credentials=t},t.prototype.getCredentials=function(){return this.credentials},t.prototype.findCredential=function(t){return 0===this.credentials.length?{}:this.credentials.find((function(e){var n=e.conditions;return n.currency===t.currency&&n.paymentType===t.paymentType}))||{}},t.prototype.hasCredential=function(t){return 0!==this.credentials.length&&void 0!==this.credentials.find((function(e){var n=e.conditions;return n.currency===t.currency&&n.paymentType===t.paymentType}))},t.prototype.tokenize=function(t){return!1===this.strategyInitialized?this.$q.reject(new Error("PaymentTokenize is not initialized")):this.strategy.tokenize(t)},t.prototype.parseToken=function(t){return!1===this.strategyInitialized?this.$q.reject(new Error("PaymentTokenize is not initialized")):this.strategy.parseToken(t)},t}();p("ITH.Shared.Common.PaymentTokenize",[]).service("PaymentTokenize",x);var T=r(["$stateParams",function e(n){t(this,e),this.hash=n.hash}]),O="email_sent",j="client_accepted",I="reimbursement_success",R="coupon_sent",C="error",P="coupon",N="reimbursement",D={CHECK:{url:"api/flightCancelHelp/checkOption?abv="+l().ab_version,method:"POST",respParser:function(t){return t.response}},CHOOSE:{url:"api/flightCancelHelp/chooseOption?abv="+l().ab_version,method:"POST",respParser:function(t){return t.response}}},q={error:{status:"error",headline:"Something went wrong",text:"Please call our Customer Care."},optionSavedCoupon:{status:"success",headline:"Choice saved",text:"Your <strong>coupon</strong> should be in your inbox."},optionSavedRefund:{status:"success",headline:"Choice saved",text:"Wait for further instruction. We will send them to your e-mail."},alreadySavedCoupon:{status:"info",headline:"Already saved",text:"Your <strong>coupon</strong> should be in your inbox."},alreadySavedRefund:{status:"info",headline:"Already saved",text:"Reimbursement success. You money should be on your account"},alreadySavedRefundWait:{status:"info",headline:"Already saved",text:"Reimbursement waiting. We will let you know..."}},A=function(){function e(n,r){t(this,e),this.$timeout=n,this.service=r,this.state={pnr:"",flightFrom:"",flightTo:"",status:O,price:0},this.info={status:"",headline:"",text:""},this.isLoading=!0,this.isSaving=!1,this.showInfo=!1}return e.$inject=["$timeout","FlightCancelHelpService"],r(e,[{key:"$onInit",value:function(){var t=this;this.service.init(this.hash).then((function(e){switch(console.log("check",e),e.status){case O:t.state=angular.merge({},e);break;case R:t.setInfo("alreadySavedCoupon")();break;case j:t.setInfo("alreadySavedRefundWait")();break;case I:t.setInfo("alreadySavedRefund")();break;default:t.setInfo("error")()}})).catch(this.setInfo("error").bind(this)).finally((function(){t.isLoading=!1}))}},{key:"shouldShowOptions",value:function(){return!1===this.isLoading&&!1===this.showInfo}},{key:"setInfo",value:function(t){var e=this;return function(){e.showInfo=!0,e.info=angular.merge({},q[t])}}},{key:"setCouponSentInfo",value:function(){}},{key:"choose",value:function(t){var e=t===P?"optionSavedCoupon":"optionSavedRefund";this.isSaving=!0,this.service.choose(this.hash,t).then(this.setInfo(e).bind(this)).catch(this.setInfo("error").bind(this)).finally(this.setSaved.bind(this))}},{key:"setSaved",value:function(){this.showInfo=!0,this.isSaving=!1}}])}(),$='<div class="row" ng-if="$ctrl.isSaving === false">\n    <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12 flight-cancel-help__action">\n        <div class="flight-cancel-help__btn flight-cancel-help__btn--outline btn btn-block btn-outline" ng-click="$ctrl.choose(\''.concat(N,'\')">\n            <span class="flight-cancel-help__btn-text">Refund</span>\n            <span class="flight-cancel-help__btn-icon">\n                <i class="icon-creditcard icon-xxlarge"></i>\n            </span>\n        </div>\n        <p class="flight-cancel-help__action-desc">This is dependent on the airline and the process may take up to 30 days</p>\n    </div>\n    <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12 flight-cancel-help__action">\n        <div class="flight-cancel-help__btn btn btn-block btn-primary" ng-click="$ctrl.choose(\'').concat(P,'\')">\n            <span class="flight-cancel-help__btn-text">Coupon for <strong>{{$ctrl.state.price}}</strong></span>\n            <span class="flight-cancel-help__btn-icon" ng-include="\'/assets/img/orderSummaryIcons/flexible_outline.svg\'"></span>\n        </div>\n        <p class="flight-cancel-help__action-desc">valid for 2 years<br>All airlines, all routes<br>You get more than before — XY% more<br>If you want to give it to someone — go ahead<br>etc.</p>\n    </div>\n</div>'),U='<ist-panel ng-if="$ctrl.shouldShowOptions()" class="flight-cancel-help">\n    <div class="flight-cancel-help__message">\n        <h4 class="flight-cancel-help__message-title">Flight Cancel Help for reservation no. <strong>{{$ctrl.state.pnr}}</strong></h4>\n        <h4 class="flight-cancel-help__message-route">{{$ctrl.state.flightFrom}} - {{$ctrl.state.flightTo}}</h4>\n        <p class="flight-cancel-help__message-text flight-cancel-help__message-text--space">Some elaborate explanation. Praesent sed rhoncus nunc. Nulla posuere sed erat vitae hendrerit. Donec quis tristique risus. Morbi dignissim lectus ut ex tincidunt elementum. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla facilisi. Donec ac scelerisque felis. Donec non magna in enim aliquet congue. Nam venenatis mauris neque, ut rutrum sem suscipit at. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam ac elit congue, ornare dolor eleifend, hendrerit nisi.</p>\n        <p class="flight-cancel-help__message-text">Due to cancellation of your flight, we offer you two options</p>\n        '.concat('<div class="flight-cancel-help__saving" ng-if="$ctrl.isSaving">\n<ist-status-indicator status="loading"></ist-status-indicator>\n<p class="flight-cancel-help__saving-text">Saving data...</p>\n</div>'," \n        ").concat($,"\n    </div>\n</ist-panel>"),L=function(){return r((function e(){t(this,e)}),null,[{key:"selector",get:function(){return"ithFlightCancelHelp"}},{key:"bindings",get:function(){return{hash:"<"}}},{key:"controller",get:function(){return"FlightCancelHelpController"}},{key:"template",get:function(){return"".concat('<ist-status-panel ng-if="$ctrl.isLoading" class="flight-cancel-help">\n    <span slot="text">Loading data...</span>\n</ist-status-panel>'," ").concat('<ist-status-panel status="{{$ctrl.info.status}}" ng-if="$ctrl.showInfo" class="flight-cancel-help">\n    <span slot="headline" ng-if="$ctrl.info.headline">{{$ctrl.info.headline}}</span>\n    <span slot="text" ng-if="$ctrl.info.text" ng-bind-html="$ctrl.info.text"></span>\n</ist-status-panel>'," ").concat(U)}}])}(),H=function(){function e(n,r,i){t(this,e),this.$q=n,this.api=i,this.priceFilter=r("flPrice")}return e.$inject=["$q","$filter","ApiTools"],r(e,[{key:"init",value:function(t){var e=this;return console.log("init with hash",t),this.$q((function(n,r){e.api.fetch(e,D.CHECK,{hash:t}).then((function(t){n(a(a({},t),{},{price:e.priceFilter(t.price,2)}))}),(function(){r({status:C})}))}))}},{key:"choose",value:function(t,e){var n=this;return console.log("chosen option",t,e),this.$q((function(r,i){n.api.fetch(n,D.CHOOSE,{hash:t,chosenOption:e}).then((function(){r({chosenOption:option})}),(function(){i({status:C})}))}))}}])}();p("ITH.Shared.FlightCancelHelp",[]).service("FlightCancelHelpService",H).component(L.selector,L).controller("FlightCancelHelpController",A).controller("FlightCancelHelpRouteCtrl",T);
/*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
var M=function(t,e){return(M=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)};function F(t,e){function n(){this.constructor=t}M(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}var z,B,Y,W,G=function(){return(G=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)};function J(t){var e="function"==typeof Symbol&&Symbol.iterator,n=e&&t[e],r=0;if(n)return n.call(t);if(t&&"number"==typeof t.length)return{next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function X(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var r,i,o=n.call(t),s=[];try{for(;(void 0===e||e-- >0)&&!(r=o.next()).done;)s.push(r.value)}catch(t){i={error:t}}finally{try{r&&!r.done&&(n=o.return)&&n.call(o)}finally{if(i)throw i.error}}return s}function V(){for(var t=[],e=0;e<arguments.length;e++)t=t.concat(X(arguments[e]));return t}function K(){var t=window,e=t._js_app_config_||{},n=t.navigator,r=t.screen;return{applicationVersion:e.appVer||"",mobile:e.device&&e.device.modal||!1,language:e.language_code||"",affiliate:e.affiliateId||0,userId:e.user&&e.user.id||0,sessionId:e.gaSession||"",referer:t.document.referrer||e.referer||"",domain:t.location.hostname||"",platform:n.platform||"",userAgent:n.userAgent||"",screenResolution:r.width+"x"+r.height,clientTimezone:(new Date).getTimezoneOffset(),doNotTrack:n.doNotTrack&&n.doNotTrack.toString()||"",adBlockUse:!t.google_tag_manager}}function Z(t){switch(Object.prototype.toString.call(t)){case"[object Error]":case"[object Exception]":case"[object DOMException]":return!0;default:return at(t,Error)}}function Q(t){return"[object ErrorEvent]"===Object.prototype.toString.call(t)}function tt(t){return"[object DOMError]"===Object.prototype.toString.call(t)}function et(t){return"[object String]"===Object.prototype.toString.call(t)}function nt(t){return null===t||"object"!=typeof t&&"function"!=typeof t}function rt(t){return"[object Object]"===Object.prototype.toString.call(t)}function it(t){return"undefined"!=typeof Event&&at(t,Event)}function ot(t){return"undefined"!=typeof Element&&at(t,Element)}function st(t){return Boolean(t&&t.then&&"function"==typeof t.then)}function at(t,e){try{return t instanceof e}catch(t){return!1}}function ct(t){try{for(var e=t,n=[],r=0,i=0,o=" > ".length,s=void 0;e&&r++<5&&!("html"===(s=ut(e))||r>1&&i+n.length*o+s.length>=80);)n.push(s),i+=s.length,e=e.parentNode;return n.reverse().join(" > ")}catch(t){return"<unknown>"}}function ut(t){var e,n,r,i,o,s=t,a=[];if(!s||!s.tagName)return"";if(a.push(s.tagName.toLowerCase()),s.id&&a.push("#"+s.id),(e=s.className)&&et(e))for(n=e.split(/\s+/),o=0;o<n.length;o++)a.push("."+n[o]);var c=["type","name","title","alt"];for(o=0;o<c.length;o++)r=c[o],(i=s.getAttribute(r))&&a.push("["+r+'="'+i+'"]');return a.join("")}!function(t){t.Ok="ok",t.Exited="exited",t.Crashed="crashed",t.Abnormal="abnormal"}(z||(z={})),function(t){t.Fatal="fatal",t.Error="error",t.Warning="warning",t.Log="log",t.Info="info",t.Debug="debug",t.Critical="critical"}(B||(B={})),function(t){t.fromString=function(e){switch(e){case"debug":return t.Debug;case"info":return t.Info;case"warn":case"warning":return t.Warning;case"error":return t.Error;case"fatal":return t.Fatal;case"critical":return t.Critical;case"log":default:return t.Log}}}(B||(B={})),function(t){t.Unknown="unknown",t.Skipped="skipped",t.Success="success",t.RateLimit="rate_limit",t.Invalid="invalid",t.Failed="failed"}(Y||(Y={})),function(t){t.fromHttpCode=function(e){return e>=200&&e<300?t.Success:429===e?t.RateLimit:e>=400&&e<500?t.Invalid:e>=500?t.Failed:t.Unknown}}(Y||(Y={})),function(t){t.Explicit="explicitly_set",t.Sampler="client_sampler",t.Rate="client_rate",t.Inheritance="inheritance"}(W||(W={}));var pt=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(t,e){return t.__proto__=e,t}:function(t,e){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n]);return t});var lt=function(t){function e(e){var n=this.constructor,r=t.call(this,e)||this;return r.message=e,r.name=n.prototype.constructor.name,pt(r,n.prototype),r}return F(e,t),e}(Error),ht=/^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/,dt=function(){function t(t){"string"==typeof t?this._fromString(t):this._fromComponents(t),this._validate()}return t.prototype.toString=function(t){void 0===t&&(t=!1);var e=this,n=e.host,r=e.path,i=e.pass,o=e.port,s=e.projectId;return e.protocol+"://"+e.user+(t&&i?":"+i:"")+"@"+n+(o?":"+o:"")+"/"+(r?r+"/":r)+s},t.prototype._fromString=function(t){var e=ht.exec(t);if(!e)throw new lt("Invalid Dsn");var n=X(e.slice(1),6),r=n[0],i=n[1],o=n[2],s=void 0===o?"":o,a=n[3],c=n[4],u=void 0===c?"":c,p="",l=n[5],h=l.split("/");if(h.length>1&&(p=h.slice(0,-1).join("/"),l=h.pop()),l){var d=l.match(/^\d+/);d&&(l=d[0])}this._fromComponents({host:a,pass:s,path:p,projectId:l,port:u,protocol:r,user:i})},t.prototype._fromComponents=function(t){this.protocol=t.protocol,this.user=t.user,this.pass=t.pass||"",this.host=t.host,this.port=t.port||"",this.path=t.path||"",this.projectId=t.projectId},t.prototype._validate=function(){var t=this;if(["protocol","user","host","projectId"].forEach((function(e){if(!t[e])throw new lt("Invalid Dsn: "+e+" missing")})),!this.projectId.match(/^\d+$/))throw new lt("Invalid Dsn: Invalid projectId "+this.projectId);if("http"!==this.protocol&&"https"!==this.protocol)throw new lt("Invalid Dsn: Invalid protocol "+this.protocol);if(this.port&&isNaN(parseInt(this.port,10)))throw new lt("Invalid Dsn: Invalid port "+this.port)},t}(),ft=function(){function t(){this._hasWeakSet="function"==typeof WeakSet,this._inner=this._hasWeakSet?new WeakSet:[]}return t.prototype.memoize=function(t){if(this._hasWeakSet)return!!this._inner.has(t)||(this._inner.add(t),!1);for(var e=0;e<this._inner.length;e++){if(this._inner[e]===t)return!0}return this._inner.push(t),!1},t.prototype.unmemoize=function(t){if(this._hasWeakSet)this._inner.delete(t);else for(var e=0;e<this._inner.length;e++)if(this._inner[e]===t){this._inner.splice(e,1);break}},t}();function vt(t){try{return t&&"function"==typeof t&&t.name||"<anonymous>"}catch(t){return"<anonymous>"}}function yt(t,e){return void 0===e&&(e=0),"string"!=typeof t||0===e||t.length<=e?t:t.substr(0,e)+"..."}function _t(t,e){if(!Array.isArray(t))return"";for(var n=[],r=0;r<t.length;r++){var i=t[r];try{n.push(String(i))}catch(t){n.push("[value cannot be serialized]")}}return n.join(e)}function gt(t,e){return!!et(t)&&(n=e,"[object RegExp]"===Object.prototype.toString.call(n)?e.test(t):"string"==typeof e&&-1!==t.indexOf(e));var n}function mt(t,e,n){if(e in t){var r=t[e],i=n(r);if("function"==typeof i)try{i.prototype=i.prototype||{},Object.defineProperties(i,{__sentry_original__:{enumerable:!1,value:r}})}catch(t){}t[e]=i}}function bt(t){if(Z(t)){var e=t,n={message:e.message,name:e.name,stack:e.stack};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}if(it(t)){var i=t,o={};o.type=i.type;try{o.target=ot(i.target)?ct(i.target):Object.prototype.toString.call(i.target)}catch(t){o.target="<unknown>"}try{o.currentTarget=ot(i.currentTarget)?ct(i.currentTarget):Object.prototype.toString.call(i.currentTarget)}catch(t){o.currentTarget="<unknown>"}for(var r in"undefined"!=typeof CustomEvent&&at(t,CustomEvent)&&(o.detail=i.detail),i)Object.prototype.hasOwnProperty.call(i,r)&&(o[r]=i);return o}return t}function Et(t){return function(t){return~-encodeURI(t).split(/%..|./).length}(JSON.stringify(t))}function St(t,e,n){void 0===e&&(e=3),void 0===n&&(n=102400);var r=xt(t,e);return Et(r)>n?St(t,e-1,n):r}function wt(t,e){return"domain"===e&&t&&"object"==typeof t&&t._events?"[Domain]":"domainEmitter"===e?"[DomainEmitter]":"undefined"!=typeof global&&t===global?"[Global]":"undefined"!=typeof window&&t===window?"[Window]":"undefined"!=typeof document&&t===document?"[Document]":rt(n=t)&&"nativeEvent"in n&&"preventDefault"in n&&"stopPropagation"in n?"[SyntheticEvent]":"number"==typeof t&&t!=t?"[NaN]":void 0===t?"[undefined]":"function"==typeof t?"[Function: "+vt(t)+"]":"symbol"==typeof t?"["+String(t)+"]":"bigint"==typeof t?"[BigInt: "+String(t)+"]":t;var n}function kt(t,e,n,r){if(void 0===n&&(n=1/0),void 0===r&&(r=new ft),0===n)return function(t){var e=Object.prototype.toString.call(t);if("string"==typeof t)return t;if("[object Object]"===e)return"[Object]";if("[object Array]"===e)return"[Array]";var n=wt(t);return nt(n)?n:e}(e);if(null!=e&&"function"==typeof e.toJSON)return e.toJSON();var i=wt(e,t);if(nt(i))return i;var o=bt(e),s=Array.isArray(e)?[]:{};if(r.memoize(e))return"[Circular ~]";for(var a in o)Object.prototype.hasOwnProperty.call(o,a)&&(s[a]=kt(a,o[a],n-1,r));return r.unmemoize(e),s}function xt(t,e){try{return JSON.parse(JSON.stringify(t,(function(t,n){return kt(t,n,e)})))}catch(t){return"**non-serializable**"}}function Tt(t,e){void 0===e&&(e=40);var n=Object.keys(bt(t));if(n.sort(),!n.length)return"[object has no keys]";if(n[0].length>=e)return yt(n[0],e);for(var r=n.length;r>0;r--){var i=n.slice(0,r).join(", ");if(!(i.length>e))return r===n.length?i:yt(i,e)}return""}function Ot(t){var e,n;if(rt(t)){var r=t,i={};try{for(var o=J(Object.keys(r)),s=o.next();!s.done;s=o.next()){var a=s.value;void 0!==r[a]&&(i[a]=Ot(r[a]))}}catch(t){e={error:t}}finally{try{s&&!s.done&&(n=o.return)&&n.call(o)}finally{if(e)throw e.error}}return i}return Array.isArray(t)?t.map(Ot):t}function jt(){return"[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0)}function It(t,e){return t.require(e)}var Rt=["cookies","data","headers","method","query_string","url"];var Ct={};function Pt(){return jt()?global:"undefined"!=typeof window?window:"undefined"!=typeof self?self:Ct}function Nt(){var t=Pt(),e=t.crypto||t.msCrypto;if(void 0!==e&&e.getRandomValues){var n=new Uint16Array(8);e.getRandomValues(n),n[3]=4095&n[3]|16384,n[4]=16383&n[4]|32768;var r=function(t){for(var e=t.toString(16);e.length<4;)e="0"+e;return e};return r(n[0])+r(n[1])+r(n[2])+r(n[3])+r(n[4])+r(n[5])+r(n[6])+r(n[7])}return"xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,(function(t){var e=16*Math.random()|0;return("x"===t?e:3&e|8).toString(16)}))}function Dt(t){if(!t)return{};var e=t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);if(!e)return{};var n=e[6]||"",r=e[8]||"";return{host:e[4],path:e[5],protocol:e[2],relative:e[5]+n+r}}function qt(t){if(t.message)return t.message;if(t.exception&&t.exception.values&&t.exception.values[0]){var e=t.exception.values[0];return e.type&&e.value?e.type+": "+e.value:e.type||e.value||t.event_id||"<unknown>"}return t.event_id||"<unknown>"}function At(t){var e=Pt();if(!("console"in e))return t();var n=e.console,r={};["debug","info","warn","error","log","assert"].forEach((function(t){t in e.console&&n[t].__sentry_original__&&(r[t]=n[t],n[t]=n[t].__sentry_original__)}));var i=t();return Object.keys(r).forEach((function(t){n[t]=r[t]})),i}function $t(t,e,n){t.exception=t.exception||{},t.exception.values=t.exception.values||[],t.exception.values[0]=t.exception.values[0]||{},t.exception.values[0].value=t.exception.values[0].value||e||"",t.exception.values[0].type=t.exception.values[0].type||n||"Error"}function Ut(t,e){void 0===e&&(e={});try{t.exception.values[0].mechanism=t.exception.values[0].mechanism||{},Object.keys(e).forEach((function(n){t.exception.values[0].mechanism[n]=e[n]}))}catch(t){}}var Lt=Pt(),Ht="Sentry Logger ",Mt=function(){function t(){this._enabled=!1}return t.prototype.disable=function(){this._enabled=!1},t.prototype.enable=function(){this._enabled=!0},t.prototype.log=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this._enabled&&At((function(){Lt.console.log(Ht+"[Log]: "+t.join(" "))}))},t.prototype.warn=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this._enabled&&At((function(){Lt.console.warn(Ht+"[Warn]: "+t.join(" "))}))},t.prototype.error=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this._enabled&&At((function(){Lt.console.error(Ht+"[Error]: "+t.join(" "))}))},t}();Lt.__SENTRY__=Lt.__SENTRY__||{};var Ft=Lt.__SENTRY__.logger||(Lt.__SENTRY__.logger=new Mt);function zt(){if(!("fetch"in Pt()))return!1;try{return new Headers,new Request(""),new Response,!0}catch(t){return!1}}function Bt(t){return t&&/^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString())}function Yt(){if(!zt())return!1;try{return new Request("_",{referrerPolicy:"origin"}),!0}catch(t){return!1}}var Wt,Gt=Pt(),Jt={},Xt={};function Vt(t){if(!Xt[t])switch(Xt[t]=!0,t){case"console":!function(){if(!("console"in Gt))return;["debug","info","warn","error","log","assert"].forEach((function(t){t in Gt.console&&mt(Gt.console,t,(function(e){return function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];Zt("console",{args:n,level:t}),e&&Function.prototype.apply.call(e,Gt.console,n)}}))}))}();break;case"dom":!function(){if(!("document"in Gt))return;Gt.document.addEventListener("click",ie("click",Zt.bind(null,"dom")),!1),Gt.document.addEventListener("keypress",oe(Zt.bind(null,"dom")),!1),["EventTarget","Node"].forEach((function(t){var e=Gt[t]&&Gt[t].prototype;e&&e.hasOwnProperty&&e.hasOwnProperty("addEventListener")&&(mt(e,"addEventListener",(function(t){return function(e,n,r){return n&&n.handleEvent?("click"===e&&mt(n,"handleEvent",(function(t){return function(e){return ie("click",Zt.bind(null,"dom"))(e),t.call(this,e)}})),"keypress"===e&&mt(n,"handleEvent",(function(t){return function(e){return oe(Zt.bind(null,"dom"))(e),t.call(this,e)}}))):("click"===e&&ie("click",Zt.bind(null,"dom"),!0)(this),"keypress"===e&&oe(Zt.bind(null,"dom"))(this)),t.call(this,e,n,r)}})),mt(e,"removeEventListener",(function(t){return function(e,n,r){try{t.call(this,e,n.__sentry_wrapped__,r)}catch(t){}return t.call(this,e,n,r)}})))}))}();break;case"xhr":!function(){if(!("XMLHttpRequest"in Gt))return;var t=[],e=[],n=XMLHttpRequest.prototype;mt(n,"open",(function(n){return function(){for(var r=[],i=0;i<arguments.length;i++)r[i]=arguments[i];var o=this,s=r[1];o.__sentry_xhr__={method:et(r[0])?r[0].toUpperCase():r[0],url:r[1]},et(s)&&"POST"===o.__sentry_xhr__.method&&s.match(/sentry_key/)&&(o.__sentry_own_request__=!0);var a=function(){if(4===o.readyState){try{o.__sentry_xhr__&&(o.__sentry_xhr__.status_code=o.status)}catch(t){}try{var n=t.indexOf(o);if(-1!==n){t.splice(n);var i=e.splice(n)[0];o.__sentry_xhr__&&void 0!==i[0]&&(o.__sentry_xhr__.body=i[0])}}catch(t){}Zt("xhr",{args:r,endTimestamp:Date.now(),startTimestamp:Date.now(),xhr:o})}};return"onreadystatechange"in o&&"function"==typeof o.onreadystatechange?mt(o,"onreadystatechange",(function(t){return function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];return a(),t.apply(o,e)}})):o.addEventListener("readystatechange",a),n.apply(o,r)}})),mt(n,"send",(function(n){return function(){for(var r=[],i=0;i<arguments.length;i++)r[i]=arguments[i];return t.push(this),e.push(r),Zt("xhr",{args:r,startTimestamp:Date.now(),xhr:this}),n.apply(this,r)}}))}();break;case"fetch":!function(){if(!function(){if(!zt())return!1;var t=Pt();if(Bt(t.fetch))return!0;var e=!1,n=t.document;if(n&&"function"==typeof n.createElement)try{var r=n.createElement("iframe");r.hidden=!0,n.head.appendChild(r),r.contentWindow&&r.contentWindow.fetch&&(e=Bt(r.contentWindow.fetch)),n.head.removeChild(r)}catch(t){Ft.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ",t)}return e}())return;mt(Gt,"fetch",(function(t){return function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r={args:e,fetchData:{method:Qt(e),url:te(e)},startTimestamp:Date.now()};return Zt("fetch",G({},r)),t.apply(Gt,e).then((function(t){return Zt("fetch",G(G({},r),{endTimestamp:Date.now(),response:t})),t}),(function(t){throw Zt("fetch",G(G({},r),{endTimestamp:Date.now(),error:t})),t}))}}))}();break;case"history":!function(){if(!function(){var t=Pt(),e=t.chrome,n=e&&e.app&&e.app.runtime,r="history"in t&&!!t.history.pushState&&!!t.history.replaceState;return!n&&r}())return;var t=Gt.onpopstate;function e(t){return function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r=e.length>2?e[2]:void 0;if(r){var i=Wt,o=String(r);Wt=o,Zt("history",{from:i,to:o})}return t.apply(this,e)}}Gt.onpopstate=function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r=Gt.location.href,i=Wt;if(Wt=r,Zt("history",{from:i,to:r}),t)return t.apply(this,e)},mt(Gt.history,"pushState",e),mt(Gt.history,"replaceState",e)}();break;case"error":se=Gt.onerror,Gt.onerror=function(t,e,n,r,i){return Zt("error",{column:r,error:i,line:n,msg:t,url:e}),!!se&&se.apply(this,arguments)};break;case"unhandledrejection":ce=Gt.onunhandledrejection,Gt.onunhandledrejection=function(t){return Zt("unhandledrejection",t),!ce||ce.apply(this,arguments)};break;default:Ft.warn("unknown instrumentation type:",t)}}function Kt(t){t&&"string"==typeof t.type&&"function"==typeof t.callback&&(Jt[t.type]=Jt[t.type]||[],Jt[t.type].push(t.callback),Vt(t.type))}function Zt(t,e){var n,r;if(t&&Jt[t])try{for(var i=J(Jt[t]||[]),o=i.next();!o.done;o=i.next()){var s=o.value;try{s(e)}catch(e){Ft.error("Error while triggering instrumentation handler.\nType: "+t+"\nName: "+vt(s)+"\nError: "+e)}}}catch(t){n={error:t}}finally{try{o&&!o.done&&(r=i.return)&&r.call(i)}finally{if(n)throw n.error}}}function Qt(t){return void 0===t&&(t=[]),"Request"in Gt&&at(t[0],Request)&&t[0].method?String(t[0].method).toUpperCase():t[1]&&t[1].method?String(t[1].method).toUpperCase():"GET"}function te(t){return void 0===t&&(t=[]),"string"==typeof t[0]?t[0]:"Request"in Gt&&at(t[0],Request)?t[0].url:String(t[0])}var ee,ne,re=0;function ie(t,e,n){return void 0===n&&(n=!1),function(r){ee=void 0,r&&ne!==r&&(ne=r,re&&clearTimeout(re),n?re=setTimeout((function(){e({event:r,name:t})})):e({event:r,name:t}))}}function oe(t){return function(e){var n;try{n=e.target}catch(t){return}var r=n&&n.tagName;r&&("INPUT"===r||"TEXTAREA"===r||n.isContentEditable)&&(ee||ie("input",t)(e),clearTimeout(ee),ee=setTimeout((function(){ee=void 0}),1e3))}}var se=null;var ae,ce=null;!function(t){t.PENDING="PENDING",t.RESOLVED="RESOLVED",t.REJECTED="REJECTED"}(ae||(ae={}));var ue=function(){function t(t){var e=this;this._state=ae.PENDING,this._handlers=[],this._resolve=function(t){e._setResult(ae.RESOLVED,t)},this._reject=function(t){e._setResult(ae.REJECTED,t)},this._setResult=function(t,n){e._state===ae.PENDING&&(st(n)?n.then(e._resolve,e._reject):(e._state=t,e._value=n,e._executeHandlers()))},this._attachHandler=function(t){e._handlers=e._handlers.concat(t),e._executeHandlers()},this._executeHandlers=function(){if(e._state!==ae.PENDING){var t=e._handlers.slice();e._handlers=[],t.forEach((function(t){t.done||(e._state===ae.RESOLVED&&t.onfulfilled&&t.onfulfilled(e._value),e._state===ae.REJECTED&&t.onrejected&&t.onrejected(e._value),t.done=!0)}))}};try{t(this._resolve,this._reject)}catch(t){this._reject(t)}}return t.resolve=function(e){return new t((function(t){t(e)}))},t.reject=function(e){return new t((function(t,n){n(e)}))},t.all=function(e){return new t((function(n,r){if(Array.isArray(e))if(0!==e.length){var i=e.length,o=[];e.forEach((function(e,s){t.resolve(e).then((function(t){o[s]=t,0===(i-=1)&&n(o)})).then(null,r)}))}else n([]);else r(new TypeError("Promise.all requires an array as input."))}))},t.prototype.then=function(e,n){var r=this;return new t((function(t,i){r._attachHandler({done:!1,onfulfilled:function(n){if(e)try{return void t(e(n))}catch(t){return void i(t)}else t(n)},onrejected:function(e){if(n)try{return void t(n(e))}catch(t){return void i(t)}else i(e)}})}))},t.prototype.catch=function(t){return this.then((function(t){return t}),t)},t.prototype.finally=function(e){var n=this;return new t((function(t,r){var i,o;return n.then((function(t){o=!1,i=t,e&&e()}),(function(t){o=!0,i=t,e&&e()})).then((function(){o?r(i):t(i)}))}))},t.prototype.toString=function(){return"[object SyncPromise]"},t}(),pe=function(){function t(t){this._limit=t,this._buffer=[]}return t.prototype.isReady=function(){return void 0===this._limit||this.length()<this._limit},t.prototype.add=function(t){var e=this;return this.isReady()?(-1===this._buffer.indexOf(t)&&this._buffer.push(t),t.then((function(){return e.remove(t)})).then(null,(function(){return e.remove(t).then(null,(function(){}))})),t):ue.reject(new lt("Not adding Promise due to buffer limit reached."))},t.prototype.remove=function(t){return this._buffer.splice(this._buffer.indexOf(t),1)[0]},t.prototype.length=function(){return this._buffer.length},t.prototype.drain=function(t){var e=this;return new ue((function(n){var r=setTimeout((function(){t&&t>0&&n(!1)}),t);ue.all(e._buffer).then((function(){clearTimeout(r),n(!0)})).then(null,(function(){n(!0)}))}))},t}(),le={nowSeconds:function(){return Date.now()/1e3}};var he=jt()?function(){try{return It(module,"perf_hooks").performance}catch(t){return}}():function(){var t=Pt().performance;if(t&&t.now)return{now:function(){return t.now()},timeOrigin:Date.now()-t.now()}}(),de=void 0===he?le:{nowSeconds:function(){return(he.timeOrigin+he.now())/1e3}},fe=le.nowSeconds.bind(le),ve=de.nowSeconds.bind(de),ye=(function(){var t=Pt().performance;if(t)t.timeOrigin?t.timeOrigin:t.timing&&t.timing.navigationStart||Date.now()}(),function(){function t(){this._notifyingListeners=!1,this._scopeListeners=[],this._eventProcessors=[],this._breadcrumbs=[],this._user={},this._tags={},this._extra={},this._contexts={}}return t.clone=function(e){var n=new t;return e&&(n._breadcrumbs=V(e._breadcrumbs),n._tags=G({},e._tags),n._extra=G({},e._extra),n._contexts=G({},e._contexts),n._user=e._user,n._level=e._level,n._span=e._span,n._session=e._session,n._transactionName=e._transactionName,n._fingerprint=e._fingerprint,n._eventProcessors=V(e._eventProcessors)),n},t.prototype.addScopeListener=function(t){this._scopeListeners.push(t)},t.prototype.addEventProcessor=function(t){return this._eventProcessors.push(t),this},t.prototype.setUser=function(t){return this._user=t||{},this._session&&this._session.update({user:t}),this._notifyScopeListeners(),this},t.prototype.getUser=function(){return this._user},t.prototype.setTags=function(t){return this._tags=G(G({},this._tags),t),this._notifyScopeListeners(),this},t.prototype.setTag=function(t,e){var n;return this._tags=G(G({},this._tags),((n={})[t]=e,n)),this._notifyScopeListeners(),this},t.prototype.setExtras=function(t){return this._extra=G(G({},this._extra),t),this._notifyScopeListeners(),this},t.prototype.setExtra=function(t,e){var n;return this._extra=G(G({},this._extra),((n={})[t]=e,n)),this._notifyScopeListeners(),this},t.prototype.setFingerprint=function(t){return this._fingerprint=t,this._notifyScopeListeners(),this},t.prototype.setLevel=function(t){return this._level=t,this._notifyScopeListeners(),this},t.prototype.setTransactionName=function(t){return this._transactionName=t,this._notifyScopeListeners(),this},t.prototype.setTransaction=function(t){return this.setTransactionName(t)},t.prototype.setContext=function(t,e){var n;return null===e?delete this._contexts[t]:this._contexts=G(G({},this._contexts),((n={})[t]=e,n)),this._notifyScopeListeners(),this},t.prototype.setSpan=function(t){return this._span=t,this._notifyScopeListeners(),this},t.prototype.getSpan=function(){return this._span},t.prototype.getTransaction=function(){var t,e,n,r,i=this.getSpan();return(null===(t=i)||void 0===t?void 0:t.transaction)?null===(e=i)||void 0===e?void 0:e.transaction:(null===(r=null===(n=i)||void 0===n?void 0:n.spanRecorder)||void 0===r?void 0:r.spans[0])?i.spanRecorder.spans[0]:void 0},t.prototype.setSession=function(t){return t?this._session=t:delete this._session,this._notifyScopeListeners(),this},t.prototype.getSession=function(){return this._session},t.prototype.update=function(e){if(!e)return this;if("function"==typeof e){var n=e(this);return n instanceof t?n:this}return e instanceof t?(this._tags=G(G({},this._tags),e._tags),this._extra=G(G({},this._extra),e._extra),this._contexts=G(G({},this._contexts),e._contexts),e._user&&Object.keys(e._user).length&&(this._user=e._user),e._level&&(this._level=e._level),e._fingerprint&&(this._fingerprint=e._fingerprint)):rt(e)&&(e=e,this._tags=G(G({},this._tags),e.tags),this._extra=G(G({},this._extra),e.extra),this._contexts=G(G({},this._contexts),e.contexts),e.user&&(this._user=e.user),e.level&&(this._level=e.level),e.fingerprint&&(this._fingerprint=e.fingerprint)),this},t.prototype.clear=function(){return this._breadcrumbs=[],this._tags={},this._extra={},this._user={},this._contexts={},this._level=void 0,this._transactionName=void 0,this._fingerprint=void 0,this._span=void 0,this._session=void 0,this._notifyScopeListeners(),this},t.prototype.addBreadcrumb=function(t,e){var n=G({timestamp:fe()},t);return this._breadcrumbs=void 0!==e&&e>=0?V(this._breadcrumbs,[n]).slice(-e):V(this._breadcrumbs,[n]),this._notifyScopeListeners(),this},t.prototype.clearBreadcrumbs=function(){return this._breadcrumbs=[],this._notifyScopeListeners(),this},t.prototype.applyToEvent=function(t,e){var n;if(this._extra&&Object.keys(this._extra).length&&(t.extra=G(G({},this._extra),t.extra)),this._tags&&Object.keys(this._tags).length&&(t.tags=G(G({},this._tags),t.tags)),this._user&&Object.keys(this._user).length&&(t.user=G(G({},this._user),t.user)),this._contexts&&Object.keys(this._contexts).length&&(t.contexts=G(G({},this._contexts),t.contexts)),this._level&&(t.level=this._level),this._transactionName&&(t.transaction=this._transactionName),this._span){t.contexts=G({trace:this._span.getTraceContext()},t.contexts);var r=null===(n=this._span.transaction)||void 0===n?void 0:n.name;r&&(t.tags=G({transaction:r},t.tags))}return this._applyFingerprint(t),t.breadcrumbs=V(t.breadcrumbs||[],this._breadcrumbs),t.breadcrumbs=t.breadcrumbs.length>0?t.breadcrumbs:void 0,this._notifyEventProcessors(V(_e(),this._eventProcessors),t,e)},t.prototype._notifyEventProcessors=function(t,e,n,r){var i=this;return void 0===r&&(r=0),new ue((function(o,s){var a=t[r];if(null===e||"function"!=typeof a)o(e);else{var c=a(G({},e),n);st(c)?c.then((function(e){return i._notifyEventProcessors(t,e,n,r+1).then(o)})).then(null,s):i._notifyEventProcessors(t,c,n,r+1).then(o).then(null,s)}}))},t.prototype._notifyScopeListeners=function(){var t=this;this._notifyingListeners||(this._notifyingListeners=!0,this._scopeListeners.forEach((function(e){e(t)})),this._notifyingListeners=!1)},t.prototype._applyFingerprint=function(t){t.fingerprint=t.fingerprint?Array.isArray(t.fingerprint)?t.fingerprint:[t.fingerprint]:[],this._fingerprint&&(t.fingerprint=t.fingerprint.concat(this._fingerprint)),t.fingerprint&&!t.fingerprint.length&&delete t.fingerprint},t}());function _e(){var t=Pt();return t.__SENTRY__=t.__SENTRY__||{},t.__SENTRY__.globalEventProcessors=t.__SENTRY__.globalEventProcessors||[],t.__SENTRY__.globalEventProcessors}function ge(t){_e().push(t)}var me=function(){function t(t){this.errors=0,this.sid=Nt(),this.timestamp=Date.now(),this.started=Date.now(),this.duration=0,this.status=z.Ok,t&&this.update(t)}return t.prototype.update=function(t){void 0===t&&(t={}),t.user&&(t.user.ip_address&&(this.ipAddress=t.user.ip_address),t.did||(this.did=t.user.id||t.user.email||t.user.username)),this.timestamp=t.timestamp||Date.now(),t.sid&&(this.sid=32===t.sid.length?t.sid:Nt()),t.did&&(this.did=""+t.did),"number"==typeof t.started&&(this.started=t.started),"number"==typeof t.duration?this.duration=t.duration:this.duration=this.timestamp-this.started,t.release&&(this.release=t.release),t.environment&&(this.environment=t.environment),t.ipAddress&&(this.ipAddress=t.ipAddress),t.userAgent&&(this.userAgent=t.userAgent),"number"==typeof t.errors&&(this.errors=t.errors),t.status&&(this.status=t.status)},t.prototype.close=function(t){t?this.update({status:t}):this.status===z.Ok?this.update({status:z.Exited}):this.update()},t.prototype.toJSON=function(){return Ot({sid:""+this.sid,init:!0,started:new Date(this.started).toISOString(),timestamp:new Date(this.timestamp).toISOString(),status:this.status,errors:this.errors,did:"number"==typeof this.did||"string"==typeof this.did?""+this.did:void 0,duration:this.duration,attrs:Ot({release:this.release,environment:this.environment,ip_address:this.ipAddress,user_agent:this.userAgent})})},t}(),be=function(){function t(t,e,n){void 0===e&&(e=new ye),void 0===n&&(n=3),this._version=n,this._stack=[{}],this.getStackTop().scope=e,this.bindClient(t)}return t.prototype.isOlderThan=function(t){return this._version<t},t.prototype.bindClient=function(t){this.getStackTop().client=t,t&&t.setupIntegrations&&t.setupIntegrations()},t.prototype.pushScope=function(){var t=ye.clone(this.getScope());return this.getStack().push({client:this.getClient(),scope:t}),t},t.prototype.popScope=function(){return!(this.getStack().length<=1)&&!!this.getStack().pop()},t.prototype.withScope=function(t){var e=this.pushScope();try{t(e)}finally{this.popScope()}},t.prototype.getClient=function(){return this.getStackTop().client},t.prototype.getScope=function(){return this.getStackTop().scope},t.prototype.getStack=function(){return this._stack},t.prototype.getStackTop=function(){return this._stack[this._stack.length-1]},t.prototype.captureException=function(t,e){var n=this._lastEventId=Nt(),r=e;if(!e){var i=void 0;try{throw new Error("Sentry syntheticException")}catch(t){i=t}r={originalException:t,syntheticException:i}}return this._invokeClient("captureException",t,G(G({},r),{event_id:n})),n},t.prototype.captureMessage=function(t,e,n){var r=this._lastEventId=Nt(),i=n;if(!n){var o=void 0;try{throw new Error(t)}catch(t){o=t}i={originalException:t,syntheticException:o}}return this._invokeClient("captureMessage",t,e,G(G({},i),{event_id:r})),r},t.prototype.captureEvent=function(t,e){var n=this._lastEventId=Nt();return this._invokeClient("captureEvent",t,G(G({},e),{event_id:n})),n},t.prototype.lastEventId=function(){return this._lastEventId},t.prototype.addBreadcrumb=function(t,e){var n=this.getStackTop(),r=n.scope,i=n.client;if(r&&i){var o=i.getOptions&&i.getOptions()||{},s=o.beforeBreadcrumb,a=void 0===s?null:s,c=o.maxBreadcrumbs,u=void 0===c?100:c;if(!(u<=0)){var p=fe(),l=G({timestamp:p},t),h=a?At((function(){return a(l,e)})):l;null!==h&&r.addBreadcrumb(h,Math.min(u,100))}}},t.prototype.setUser=function(t){var e=this.getScope();e&&e.setUser(t)},t.prototype.setTags=function(t){var e=this.getScope();e&&e.setTags(t)},t.prototype.setExtras=function(t){var e=this.getScope();e&&e.setExtras(t)},t.prototype.setTag=function(t,e){var n=this.getScope();n&&n.setTag(t,e)},t.prototype.setExtra=function(t,e){var n=this.getScope();n&&n.setExtra(t,e)},t.prototype.setContext=function(t,e){var n=this.getScope();n&&n.setContext(t,e)},t.prototype.configureScope=function(t){var e=this.getStackTop(),n=e.scope,r=e.client;n&&r&&t(n)},t.prototype.run=function(t){var e=Se(this);try{t(this)}finally{Se(e)}},t.prototype.getIntegration=function(t){var e=this.getClient();if(!e)return null;try{return e.getIntegration(t)}catch(e){return Ft.warn("Cannot retrieve integration "+t.id+" from the current Hub"),null}},t.prototype.startSpan=function(t){return this._callExtensionMethod("startSpan",t)},t.prototype.startTransaction=function(t,e){return this._callExtensionMethod("startTransaction",t,e)},t.prototype.traceHeaders=function(){return this._callExtensionMethod("traceHeaders")},t.prototype.startSession=function(t){this.endSession();var e=this.getStackTop(),n=e.scope,r=e.client,i=r&&r.getOptions()||{},o=i.release,s=i.environment,a=new me(G(G({release:o,environment:s},n&&{user:n.getUser()}),t));return n&&n.setSession(a),a},t.prototype.endSession=function(){var t=this.getStackTop(),e=t.scope,n=t.client;if(e){var r=e.getSession&&e.getSession();r&&(r.close(),n&&n.captureSession&&n.captureSession(r),e.setSession())}},t.prototype._invokeClient=function(t){for(var e,n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];var i=this.getStackTop(),o=i.scope,s=i.client;s&&s[t]&&(e=s)[t].apply(e,V(n,[o]))},t.prototype._callExtensionMethod=function(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];var r=Ee(),i=r.__SENTRY__;if(i&&i.extensions&&"function"==typeof i.extensions[t])return i.extensions[t].apply(this,e);Ft.warn("Extension method "+t+" couldn't be found, doing nothing.")},t}();function Ee(){var t=Pt();return t.__SENTRY__=t.__SENTRY__||{extensions:{},hub:void 0},t}function Se(t){var e=Ee(),n=Te(e);return Oe(e,t),n}function we(){var t=Ee();return xe(t)&&!Te(t).isOlderThan(3)||Oe(t,new be),jt()?function(t){try{var e=ke();if(!e)return Te(t);if(!xe(e)||Te(e).isOlderThan(3)){var n=Te(t).getStackTop();Oe(e,new be(n.client,ye.clone(n.scope)))}return Te(e)}catch(e){return Te(t)}}(t):Te(t)}function ke(){var t=Ee().__SENTRY__;return t&&t.extensions&&t.extensions.domain&&t.extensions.domain.active}function xe(t){return!!(t&&t.__SENTRY__&&t.__SENTRY__.hub)}function Te(t){return t&&t.__SENTRY__&&t.__SENTRY__.hub||(t.__SENTRY__=t.__SENTRY__||{},t.__SENTRY__.hub=new be),t.__SENTRY__.hub}function Oe(t,e){return!!t&&(t.__SENTRY__=t.__SENTRY__||{},t.__SENTRY__.hub=e,!0)}function je(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];var r=we();if(r&&r[t])return r[t].apply(r,V(e));throw new Error("No hub defined or "+t+" was not found on the hub, please open a bug report.")}function Ie(t,e){var n;try{throw new Error("Sentry syntheticException")}catch(t){n=t}return je("captureException",t,{captureContext:e,originalException:t,syntheticException:n})}function Re(t){je("configureScope",t)}function Ce(t){je("withScope",t)}function Pe(t,e){return je("startTransaction",G({},t),e)}var Ne=function(){function t(t){this.dsn=t,this._dsnObject=new dt(t)}return t.prototype.getDsn=function(){return this._dsnObject},t.prototype.getBaseApiEndpoint=function(){var t=this._dsnObject,e=t.protocol?t.protocol+":":"",n=t.port?":"+t.port:"";return e+"//"+t.host+n+(t.path?"/"+t.path:"")+"/api/"},t.prototype.getStoreEndpoint=function(){return this._getIngestEndpoint("store")},t.prototype.getStoreEndpointWithUrlEncodedAuth=function(){return this.getStoreEndpoint()+"?"+this._encodedAuth()},t.prototype.getEnvelopeEndpointWithUrlEncodedAuth=function(){return this._getEnvelopeEndpoint()+"?"+this._encodedAuth()},t.prototype.getStoreEndpointPath=function(){var t=this._dsnObject;return(t.path?"/"+t.path:"")+"/api/"+t.projectId+"/store/"},t.prototype.getRequestHeaders=function(t,e){var n=this._dsnObject,r=["Sentry sentry_version=7"];return r.push("sentry_client="+t+"/"+e),r.push("sentry_key="+n.user),n.pass&&r.push("sentry_secret="+n.pass),{"Content-Type":"application/json","X-Sentry-Auth":r.join(", ")}},t.prototype.getReportDialogEndpoint=function(t){void 0===t&&(t={});var e=this._dsnObject,n=this.getBaseApiEndpoint()+"embed/error-page/",r=[];for(var i in r.push("dsn="+e.toString()),t)if("dsn"!==i)if("user"===i){if(!t.user)continue;t.user.name&&r.push("name="+encodeURIComponent(t.user.name)),t.user.email&&r.push("email="+encodeURIComponent(t.user.email))}else r.push(encodeURIComponent(i)+"="+encodeURIComponent(t[i]));return r.length?n+"?"+r.join("&"):n},t.prototype._getEnvelopeEndpoint=function(){return this._getIngestEndpoint("envelope")},t.prototype._getIngestEndpoint=function(t){return""+this.getBaseApiEndpoint()+this._dsnObject.projectId+"/"+t+"/"},t.prototype._encodedAuth=function(){var t,e={sentry_key:this._dsnObject.user,sentry_version:"7"};return t=e,Object.keys(t).map((function(e){return encodeURIComponent(e)+"="+encodeURIComponent(t[e])})).join("&")},t}(),De=[];function qe(t){var e={};return function(t){var e=t.defaultIntegrations&&V(t.defaultIntegrations)||[],n=t.integrations,r=[];if(Array.isArray(n)){var i=n.map((function(t){return t.name})),o=[];e.forEach((function(t){-1===i.indexOf(t.name)&&-1===o.indexOf(t.name)&&(r.push(t),o.push(t.name))})),n.forEach((function(t){-1===o.indexOf(t.name)&&(r.push(t),o.push(t.name))}))}else"function"==typeof n?(r=n(e),r=Array.isArray(r)?r:[r]):r=V(e);var s=r.map((function(t){return t.name}));return-1!==s.indexOf("Debug")&&r.push.apply(r,V(r.splice(s.indexOf("Debug"),1))),r}(t).forEach((function(t){e[t.name]=t,function(t){-1===De.indexOf(t.name)&&(t.setupOnce(ge,we),De.push(t.name),Ft.log("Integration installed: "+t.name))}(t)})),e}var Ae,$e=function(){function t(t,e){this._integrations={},this._processing=0,this._backend=new t(e),this._options=e,e.dsn&&(this._dsn=new dt(e.dsn))}return t.prototype.captureException=function(t,e,n){var r=this,i=e&&e.event_id;return this._process(this._getBackend().eventFromException(t,e).then((function(t){return r._captureEvent(t,e,n)})).then((function(t){i=t}))),i},t.prototype.captureMessage=function(t,e,n,r){var i=this,o=n&&n.event_id,s=nt(t)?this._getBackend().eventFromMessage(String(t),e,n):this._getBackend().eventFromException(t,n);return this._process(s.then((function(t){return i._captureEvent(t,n,r)})).then((function(t){o=t}))),o},t.prototype.captureEvent=function(t,e,n){var r=e&&e.event_id;return this._process(this._captureEvent(t,e,n).then((function(t){r=t}))),r},t.prototype.captureSession=function(t){t.release?this._sendSession(t):Ft.warn("Discarded session because of missing release")},t.prototype.getDsn=function(){return this._dsn},t.prototype.getOptions=function(){return this._options},t.prototype.flush=function(t){var e=this;return this._isClientProcessing(t).then((function(n){return e._getBackend().getTransport().close(t).then((function(t){return n&&t}))}))},t.prototype.close=function(t){var e=this;return this.flush(t).then((function(t){return e.getOptions().enabled=!1,t}))},t.prototype.setupIntegrations=function(){this._isEnabled()&&(this._integrations=qe(this._options))},t.prototype.getIntegration=function(t){try{return this._integrations[t.id]||null}catch(e){return Ft.warn("Cannot retrieve integration "+t.id+" from the current Client"),null}},t.prototype._updateSessionFromEvent=function(t,e){var n,r,i,o=!1,s=!1,a=e.exception&&e.exception.values;if(a){s=!0;try{for(var c=J(a),u=c.next();!u.done;u=c.next()){var p=u.value.mechanism;if(p&&!1===p.handled){o=!0;break}}}catch(t){n={error:t}}finally{try{u&&!u.done&&(r=c.return)&&r.call(c)}finally{if(n)throw n.error}}}var l=e.user;if(!t.userAgent){var h=e.request?e.request.headers:{};for(var d in h)if("user-agent"===d.toLowerCase()){i=h[d];break}}t.update(G(G({},o&&{status:z.Crashed}),{user:l,userAgent:i,errors:t.errors+Number(s||o)}))},t.prototype._sendSession=function(t){this._getBackend().sendSession(t)},t.prototype._isClientProcessing=function(t){var e=this;return new ue((function(n){var r=0,i=setInterval((function(){0==e._processing?(clearInterval(i),n(!0)):(r+=1,t&&r>=t&&(clearInterval(i),n(!1)))}),1)}))},t.prototype._getBackend=function(){return this._backend},t.prototype._isEnabled=function(){return!1!==this.getOptions().enabled&&void 0!==this._dsn},t.prototype._prepareEvent=function(t,e,n){var r=this,i=this.getOptions().normalizeDepth,o=void 0===i?3:i,s=G(G({},t),{event_id:t.event_id||(n&&n.event_id?n.event_id:Nt()),timestamp:t.timestamp||fe()});this._applyClientOptions(s),this._applyIntegrationsMetadata(s);var a=e;n&&n.captureContext&&(a=ye.clone(a).update(n.captureContext));var c=ue.resolve(s);return a&&(c=a.applyToEvent(s,n)),c.then((function(t){return"number"==typeof o&&o>0?r._normalizeEvent(t,o):t}))},t.prototype._normalizeEvent=function(t,e){if(!t)return null;var n=G(G(G(G(G({},t),t.breadcrumbs&&{breadcrumbs:t.breadcrumbs.map((function(t){return G(G({},t),t.data&&{data:xt(t.data,e)})}))}),t.user&&{user:xt(t.user,e)}),t.contexts&&{contexts:xt(t.contexts,e)}),t.extra&&{extra:xt(t.extra,e)});return t.contexts&&t.contexts.trace&&(n.contexts.trace=t.contexts.trace),n},t.prototype._applyClientOptions=function(t){var e=this.getOptions(),n=e.environment,r=e.release,i=e.dist,o=e.maxValueLength,s=void 0===o?250:o;"environment"in t||(t.environment="environment"in e?n:"production"),void 0===t.release&&void 0!==r&&(t.release=r),void 0===t.dist&&void 0!==i&&(t.dist=i),t.message&&(t.message=yt(t.message,s));var a=t.exception&&t.exception.values&&t.exception.values[0];a&&a.value&&(a.value=yt(a.value,s));var c=t.request;c&&c.url&&(c.url=yt(c.url,s))},t.prototype._applyIntegrationsMetadata=function(t){var e=t.sdk,n=Object.keys(this._integrations);e&&n.length>0&&(e.integrations=n)},t.prototype._sendEvent=function(t){this._getBackend().sendEvent(t)},t.prototype._captureEvent=function(t,e,n){return this._processEvent(t,e,n).then((function(t){return t.event_id}),(function(t){Ft.error(t)}))},t.prototype._processEvent=function(t,e,n){var r=this,i=this.getOptions(),o=i.beforeSend,s=i.sampleRate;if(!this._isEnabled())return ue.reject(new lt("SDK not enabled, will not send event."));var a="transaction"===t.type;return!a&&"number"==typeof s&&Math.random()>s?ue.reject(new lt("Discarding event because it's not included in the random sample (sampling rate = "+s+")")):this._prepareEvent(t,n,e).then((function(t){if(null===t)throw new lt("An event processor returned null, will not send event.");if(e&&e.data&&!0===e.data.__sentry__||a||!o)return t;var n=o(t,e);if(void 0===n)throw new lt("`beforeSend` method has to return `null` or a valid event.");return st(n)?n.then((function(t){return t}),(function(t){throw new lt("beforeSend rejected with "+t)})):n})).then((function(t){if(null===t)throw new lt("`beforeSend` returned `null`, will not send event.");var e=n&&n.getSession&&n.getSession();return!a&&e&&r._updateSessionFromEvent(e,t),r._sendEvent(t),t})).then(null,(function(t){if(t instanceof lt)throw t;throw r.captureException(t,{data:{__sentry__:!0},originalException:t}),new lt("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: "+t)}))},t.prototype._process=function(t){var e=this;this._processing+=1,t.then((function(t){return e._processing-=1,t}),(function(t){return e._processing-=1,t}))},t}(),Ue=function(){function t(){}return t.prototype.sendEvent=function(t){return ue.resolve({reason:"NoopTransport: Event has been skipped because no Dsn is configured.",status:Y.Skipped})},t.prototype.close=function(t){return ue.resolve(!0)},t}(),Le=function(){function t(t){this._options=t,this._options.dsn||Ft.warn("No DSN provided, backend will not do anything."),this._transport=this._setupTransport()}return t.prototype.eventFromException=function(t,e){throw new lt("Backend has to implement `eventFromException` method")},t.prototype.eventFromMessage=function(t,e,n){throw new lt("Backend has to implement `eventFromMessage` method")},t.prototype.sendEvent=function(t){this._transport.sendEvent(t).then(null,(function(t){Ft.error("Error while sending event: "+t)}))},t.prototype.sendSession=function(t){this._transport.sendSession?this._transport.sendSession(t).then(null,(function(t){Ft.error("Error while sending session: "+t)})):Ft.warn("Dropping session because custom transport doesn't implement sendSession")},t.prototype.getTransport=function(){return this._transport},t.prototype._setupTransport=function(){return new Ue},t}();function He(t,e){return{body:JSON.stringify({sent_at:(new Date).toISOString()})+"\n"+JSON.stringify({type:"session"})+"\n"+JSON.stringify(t),type:"session",url:e.getEnvelopeEndpointWithUrlEncodedAuth()}}function Me(t,e){var n=t.tags||{},r=n.__sentry_samplingMethod,i=n.__sentry_sampleRate,o=function(t,e){var n={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(n[r]=t[r]);if(null!=t&&"function"==typeof Object.getOwnPropertySymbols){var i=0;for(r=Object.getOwnPropertySymbols(t);i<r.length;i++)e.indexOf(r[i])<0&&Object.prototype.propertyIsEnumerable.call(t,r[i])&&(n[r[i]]=t[r[i]])}return n}(n,["__sentry_samplingMethod","__sentry_sampleRate"]);t.tags=o;var s="transaction"===t.type,a={body:JSON.stringify(t),type:t.type||"event",url:s?e.getEnvelopeEndpointWithUrlEncodedAuth():e.getStoreEndpointWithUrlEncodedAuth()};if(s){var c=JSON.stringify({event_id:t.event_id,sent_at:(new Date).toISOString()})+"\n"+JSON.stringify({type:t.type,sample_rates:[{id:r,rate:i}]})+"\n"+a.body;a.body=c}return a}var Fe=function(){function t(){this.name=t.id}return t.prototype.setupOnce=function(){Ae=Function.prototype.toString,Function.prototype.toString=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n=this.__sentry_original__||this;return Ae.apply(n,t)}},t.id="FunctionToString",t}(),ze=[/^Script error\.?$/,/^Javascript error: Script error\.? on line 0$/],Be=function(){function t(e){void 0===e&&(e={}),this._options=e,this.name=t.id}return t.prototype.setupOnce=function(){ge((function(e){var n=we();if(!n)return e;var r=n.getIntegration(t);if(r){var i=n.getClient(),o=i?i.getOptions():{},s=r._mergeOptions(o);if(r._shouldDropEvent(e,s))return null}return e}))},t.prototype._shouldDropEvent=function(t,e){return this._isSentryError(t,e)?(Ft.warn("Event dropped due to being internal Sentry Error.\nEvent: "+qt(t)),!0):this._isIgnoredError(t,e)?(Ft.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: "+qt(t)),!0):this._isDeniedUrl(t,e)?(Ft.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: "+qt(t)+".\nUrl: "+this._getEventFilterUrl(t)),!0):!this._isAllowedUrl(t,e)&&(Ft.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: "+qt(t)+".\nUrl: "+this._getEventFilterUrl(t)),!0)},t.prototype._isSentryError=function(t,e){if(!e.ignoreInternal)return!1;try{return t&&t.exception&&t.exception.values&&t.exception.values[0]&&"SentryError"===t.exception.values[0].type||!1}catch(t){return!1}},t.prototype._isIgnoredError=function(t,e){return!(!e.ignoreErrors||!e.ignoreErrors.length)&&this._getPossibleEventMessages(t).some((function(t){return e.ignoreErrors.some((function(e){return gt(t,e)}))}))},t.prototype._isDeniedUrl=function(t,e){if(!e.denyUrls||!e.denyUrls.length)return!1;var n=this._getEventFilterUrl(t);return!!n&&e.denyUrls.some((function(t){return gt(n,t)}))},t.prototype._isAllowedUrl=function(t,e){if(!e.allowUrls||!e.allowUrls.length)return!0;var n=this._getEventFilterUrl(t);return!n||e.allowUrls.some((function(t){return gt(n,t)}))},t.prototype._mergeOptions=function(t){return void 0===t&&(t={}),{allowUrls:V(this._options.whitelistUrls||[],this._options.allowUrls||[],t.whitelistUrls||[],t.allowUrls||[]),denyUrls:V(this._options.blacklistUrls||[],this._options.denyUrls||[],t.blacklistUrls||[],t.denyUrls||[]),ignoreErrors:V(this._options.ignoreErrors||[],t.ignoreErrors||[],ze),ignoreInternal:void 0===this._options.ignoreInternal||this._options.ignoreInternal}},t.prototype._getPossibleEventMessages=function(t){if(t.message)return[t.message];if(t.exception)try{var e=t.exception.values&&t.exception.values[0]||{},n=e.type,r=void 0===n?"":n,i=e.value,o=void 0===i?"":i;return[""+o,r+": "+o]}catch(e){return Ft.error("Cannot extract message for event "+qt(t)),[]}return[]},t.prototype._getEventFilterUrl=function(t){try{if(t.stacktrace){var e=t.stacktrace.frames;return e&&e[e.length-1].filename||null}if(t.exception){var n=t.exception.values&&t.exception.values[0].stacktrace&&t.exception.values[0].stacktrace.frames;return n&&n[n.length-1].filename||null}return null}catch(e){return Ft.error("Cannot extract url for event "+qt(t)),null}},t.id="InboundFilters",t}(),Ye=/^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,We=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i,Ge=/^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,Je=/(\S+) line (\d+)(?: > eval line \d+)* > eval/i,Xe=/\((\S*)(?::(\d+))(?::(\d+))\)/,Ve=/Minified React error #\d+;/i;function Ke(t){var e=null,n=0;t&&("number"==typeof t.framesToPop?n=t.framesToPop:Ve.test(t.message)&&(n=1));try{if(e=function(t){if(!t||!t.stacktrace)return null;for(var e,n=t.stacktrace,r=/ line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i,i=/ line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i,o=n.split("\n"),s=[],a=0;a<o.length;a+=2){var c=null;(e=r.exec(o[a]))?c={url:e[2],func:e[3],args:[],line:+e[1],column:null}:(e=i.exec(o[a]))&&(c={url:e[6],func:e[3]||e[4],args:e[5]?e[5].split(","):[],line:+e[1],column:+e[2]}),c&&(!c.func&&c.line&&(c.func="?"),s.push(c))}if(!s.length)return null;return{message:Qe(t),name:t.name,stack:s}}(t))return Ze(e,n)}catch(t){}try{if(e=function(t){if(!t||!t.stack)return null;for(var e,n,r,i=[],o=t.stack.split("\n"),s=0;s<o.length;++s){if(n=Ye.exec(o[s])){var a=n[2]&&0===n[2].indexOf("native");n[2]&&0===n[2].indexOf("eval")&&(e=Xe.exec(n[2]))&&(n[2]=e[1],n[3]=e[2],n[4]=e[3]),r={url:n[2]&&0===n[2].indexOf("address at ")?n[2].substr("address at ".length):n[2],func:n[1]||"?",args:a?[n[2]]:[],line:n[3]?+n[3]:null,column:n[4]?+n[4]:null}}else if(n=Ge.exec(o[s]))r={url:n[2],func:n[1]||"?",args:[],line:+n[3],column:n[4]?+n[4]:null};else{if(!(n=We.exec(o[s])))continue;n[3]&&n[3].indexOf(" > eval")>-1&&(e=Je.exec(n[3]))?(n[1]=n[1]||"eval",n[3]=e[1],n[4]=e[2],n[5]=""):0!==s||n[5]||void 0===t.columnNumber||(i[0].column=t.columnNumber+1),r={url:n[3],func:n[1]||"?",args:n[2]?n[2].split(","):[],line:n[4]?+n[4]:null,column:n[5]?+n[5]:null}}!r.func&&r.line&&(r.func="?"),i.push(r)}if(!i.length)return null;return{message:Qe(t),name:t.name,stack:i}}(t))return Ze(e,n)}catch(t){}return{message:Qe(t),name:t&&t.name,stack:[],failed:!0}}function Ze(t,e){try{return G(G({},t),{stack:t.stack.slice(e)})}catch(e){return t}}function Qe(t){var e=t&&t.message;return e?e.error&&"string"==typeof e.error.message?e.error.message:e:"No error message"}function tn(t){var e=nn(t.stack),n={type:t.name,value:t.message};return e&&e.length&&(n.stacktrace={frames:e}),void 0===n.type&&""===n.value&&(n.value="Unrecoverable error caught"),n}function en(t){return{exception:{values:[tn(t)]}}}function nn(t){if(!t||!t.length)return[];var e=t,n=e[0].func||"",r=e[e.length-1].func||"";return-1===n.indexOf("captureMessage")&&-1===n.indexOf("captureException")||(e=e.slice(1)),-1!==r.indexOf("sentryWrapped")&&(e=e.slice(0,-1)),e.slice(0,50).map((function(t){return{colno:null===t.column?void 0:t.column,filename:t.url||e[0].url,function:t.func||"?",in_app:!0,lineno:null===t.line?void 0:t.line}})).reverse()}function rn(t,e,n){var r,i;if(void 0===n&&(n={}),Q(t)&&t.error)return r=en(Ke(t=t.error));if(tt(t)||(i=t,"[object DOMException]"===Object.prototype.toString.call(i))){var o=t,s=o.name||(tt(o)?"DOMError":"DOMException"),a=o.message?s+": "+o.message:s;return $t(r=on(a,e,n),a),"code"in o&&(r.tags=G(G({},r.tags),{"DOMException.code":""+o.code})),r}return Z(t)?r=en(Ke(t)):rt(t)||it(t)?(Ut(r=function(t,e,n){var r={exception:{values:[{type:it(t)?t.constructor.name:n?"UnhandledRejection":"Error",value:"Non-Error "+(n?"promise rejection":"exception")+" captured with keys: "+Tt(t)}]},extra:{__serialized__:St(t)}};if(e){var i=nn(Ke(e).stack);r.stacktrace={frames:i}}return r}(t,e,n.rejection),{synthetic:!0}),r):($t(r=on(t,e,n),""+t,void 0),Ut(r,{synthetic:!0}),r)}function on(t,e,n){void 0===n&&(n={});var r={message:t};if(n.attachStacktrace&&e){var i=nn(Ke(e).stack);r.stacktrace={frames:i}}return r}var sn=function(){function t(t){this.options=t,this._buffer=new pe(30),this._rateLimits={},this._api=new Ne(this.options.dsn),this.url=this._api.getStoreEndpointWithUrlEncodedAuth()}return t.prototype.sendEvent=function(t){throw new lt("Transport Class has to implement `sendEvent` method")},t.prototype.close=function(t){return this._buffer.drain(t)},t.prototype._handleResponse=function(t){var e=t.requestType,n=t.response,r=t.headers,i=t.resolve,o=t.reject,s=Y.fromHttpCode(n.status);this._handleRateLimit(r)&&Ft.warn("Too many requests, backing off until: "+this._disabledUntil(e)),s!==Y.Success?o(n):i({status:s})},t.prototype._disabledUntil=function(t){return this._rateLimits[t]||this._rateLimits.all},t.prototype._isRateLimited=function(t){return this._disabledUntil(t)>new Date(Date.now())},t.prototype._handleRateLimit=function(t){var e,n,r,i,o=Date.now(),s=t["x-sentry-rate-limits"],a=t["retry-after"];if(s){try{for(var c=J(s.trim().split(",")),u=c.next();!u.done;u=c.next()){var p=u.value.split(":",2),l=parseInt(p[0],10),h=1e3*(isNaN(l)?60:l);try{for(var d=(r=void 0,J(p[1].split(";"))),f=d.next();!f.done;f=d.next()){var v=f.value;this._rateLimits[v||"all"]=new Date(o+h)}}catch(t){r={error:t}}finally{try{f&&!f.done&&(i=d.return)&&i.call(d)}finally{if(r)throw r.error}}}}catch(t){e={error:t}}finally{try{u&&!u.done&&(n=c.return)&&n.call(c)}finally{if(e)throw e.error}}return!0}return!!a&&(this._rateLimits.all=new Date(o+function(t,e){if(!e)return 6e4;var n=parseInt(""+e,10);if(!isNaN(n))return 1e3*n;var r=Date.parse(""+e);return isNaN(r)?6e4:r-t}(o,a)),!0)},t}(),an=Pt(),cn=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return F(e,t),e.prototype.sendEvent=function(t){return this._sendRequest(Me(t,this._api),t)},e.prototype.sendSession=function(t){return this._sendRequest(He(t,this._api),t)},e.prototype._sendRequest=function(t,e){var n=this;if(this._isRateLimited(t.type))return Promise.reject({event:e,type:t.type,reason:"Transport locked till "+this._disabledUntil(t.type)+" due to too many requests.",status:429});var r={body:t.body,method:"POST",referrerPolicy:Yt()?"origin":""};return void 0!==this.options.fetchParameters&&Object.assign(r,this.options.fetchParameters),void 0!==this.options.headers&&(r.headers=this.options.headers),this._buffer.add(new ue((function(e,i){an.fetch(t.url,r).then((function(r){var o={"x-sentry-rate-limits":r.headers.get("X-Sentry-Rate-Limits"),"retry-after":r.headers.get("Retry-After")};n._handleResponse({requestType:t.type,response:r,headers:o,resolve:e,reject:i})})).catch(i)})))},e}(sn),un=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return F(e,t),e.prototype.sendEvent=function(t){return this._sendRequest(Me(t,this._api),t)},e.prototype.sendSession=function(t){return this._sendRequest(He(t,this._api),t)},e.prototype._sendRequest=function(t,e){var n=this;return this._isRateLimited(t.type)?Promise.reject({event:e,type:t.type,reason:"Transport locked till "+this._disabledUntil(t.type)+" due to too many requests.",status:429}):this._buffer.add(new ue((function(e,r){var i=new XMLHttpRequest;for(var o in i.onreadystatechange=function(){if(4===i.readyState){var o={"x-sentry-rate-limits":i.getResponseHeader("X-Sentry-Rate-Limits"),"retry-after":i.getResponseHeader("Retry-After")};n._handleResponse({requestType:t.type,response:i,headers:o,resolve:e,reject:r})}},i.open("POST",t.url),n.options.headers)n.options.headers.hasOwnProperty(o)&&i.setRequestHeader(o,n.options.headers[o]);i.send(t.body)})))},e}(sn),pn=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return F(e,t),e.prototype.eventFromException=function(t,e){return function(t,e,n){var r=rn(e,n&&n.syntheticException||void 0,{attachStacktrace:t.attachStacktrace});return Ut(r,{handled:!0,type:"generic"}),r.level=B.Error,n&&n.event_id&&(r.event_id=n.event_id),ue.resolve(r)}(this._options,t,e)},e.prototype.eventFromMessage=function(t,e,n){return void 0===e&&(e=B.Info),function(t,e,n,r){void 0===n&&(n=B.Info);var i=on(e,r&&r.syntheticException||void 0,{attachStacktrace:t.attachStacktrace});return i.level=n,r&&r.event_id&&(i.event_id=r.event_id),ue.resolve(i)}(this._options,t,e,n)},e.prototype._setupTransport=function(){if(!this._options.dsn)return t.prototype._setupTransport.call(this);var e=G(G({},this._options.transportOptions),{dsn:this._options.dsn});return this._options.transport?new this._options.transport(e):zt()?new cn(e):new un(e)},e}(Le),ln=0;function hn(){return ln>0}function dn(){ln+=1,setTimeout((function(){ln-=1}))}function fn(t,e,n){if(void 0===e&&(e={}),"function"!=typeof t)return t;try{if(t.__sentry__)return t;if(t.__sentry_wrapped__)return t.__sentry_wrapped__}catch(e){return t}var r=function(){var r=Array.prototype.slice.call(arguments);try{n&&"function"==typeof n&&n.apply(this,arguments);var i=r.map((function(t){return fn(t,e)}));return t.handleEvent?t.handleEvent.apply(this,i):t.apply(this,i)}catch(t){throw dn(),Ce((function(n){n.addEventProcessor((function(t){var n=G({},t);return e.mechanism&&($t(n,void 0,void 0),Ut(n,e.mechanism)),n.extra=G(G({},n.extra),{arguments:r}),n})),Ie(t)})),t}};try{for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&(r[i]=t[i])}catch(t){}t.prototype=t.prototype||{},r.prototype=t.prototype,Object.defineProperty(t,"__sentry_wrapped__",{enumerable:!1,value:r}),Object.defineProperties(r,{__sentry__:{enumerable:!1,value:!0},__sentry_original__:{enumerable:!1,value:t}});try{Object.getOwnPropertyDescriptor(r,"name").configurable&&Object.defineProperty(r,"name",{get:function(){return t.name}})}catch(t){}return r}function vn(t){if(void 0===t&&(t={}),t.eventId)if(t.dsn){var e=document.createElement("script");e.async=!0,e.src=new Ne(t.dsn).getReportDialogEndpoint(t),t.onLoad&&(e.onload=t.onLoad),(document.head||document.body).appendChild(e)}else Ft.error("Missing dsn option in showReportDialog call");else Ft.error("Missing eventId option in showReportDialog call")}var yn,_n=function(){function t(e){this.name=t.id,this._onErrorHandlerInstalled=!1,this._onUnhandledRejectionHandlerInstalled=!1,this._options=G({onerror:!0,onunhandledrejection:!0},e)}return t.prototype.setupOnce=function(){Error.stackTraceLimit=50,this._options.onerror&&(Ft.log("Global Handler attached: onerror"),this._installGlobalOnErrorHandler()),this._options.onunhandledrejection&&(Ft.log("Global Handler attached: onunhandledrejection"),this._installGlobalOnUnhandledRejectionHandler())},t.prototype._installGlobalOnErrorHandler=function(){var e=this;this._onErrorHandlerInstalled||(Kt({callback:function(n){var r=n.error,i=we(),o=i.getIntegration(t),s=r&&!0===r.__sentry_own_request__;if(o&&!hn()&&!s){var a=i.getClient(),c=nt(r)?e._eventFromIncompleteOnError(n.msg,n.url,n.line,n.column):e._enhanceEventWithInitialFrame(rn(r,void 0,{attachStacktrace:a&&a.getOptions().attachStacktrace,rejection:!1}),n.url,n.line,n.column);Ut(c,{handled:!1,type:"onerror"}),i.captureEvent(c,{originalException:r})}},type:"error"}),this._onErrorHandlerInstalled=!0)},t.prototype._installGlobalOnUnhandledRejectionHandler=function(){var e=this;this._onUnhandledRejectionHandlerInstalled||(Kt({callback:function(n){var r=n;try{"reason"in n?r=n.reason:"detail"in n&&"reason"in n.detail&&(r=n.detail.reason)}catch(t){}var i=we(),o=i.getIntegration(t),s=r&&!0===r.__sentry_own_request__;if(!o||hn()||s)return!0;var a=i.getClient(),c=nt(r)?e._eventFromRejectionWithPrimitive(r):rn(r,void 0,{attachStacktrace:a&&a.getOptions().attachStacktrace,rejection:!0});c.level=B.Error,Ut(c,{handled:!1,type:"onunhandledrejection"}),i.captureEvent(c,{originalException:r})},type:"unhandledrejection"}),this._onUnhandledRejectionHandlerInstalled=!0)},t.prototype._eventFromIncompleteOnError=function(t,e,n,r){var i,o=Q(t)?t.message:t;if(et(o)){var s=o.match(/^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i);s&&(i=s[1],o=s[2])}var a={exception:{values:[{type:i||"Error",value:o}]}};return this._enhanceEventWithInitialFrame(a,e,n,r)},t.prototype._eventFromRejectionWithPrimitive=function(t){return{exception:{values:[{type:"UnhandledRejection",value:"Non-Error promise rejection captured with value: "+String(t)}]}}},t.prototype._enhanceEventWithInitialFrame=function(t,e,n,r){t.exception=t.exception||{},t.exception.values=t.exception.values||[],t.exception.values[0]=t.exception.values[0]||{},t.exception.values[0].stacktrace=t.exception.values[0].stacktrace||{},t.exception.values[0].stacktrace.frames=t.exception.values[0].stacktrace.frames||[];var i=isNaN(parseInt(r,10))?void 0:r,o=isNaN(parseInt(n,10))?void 0:n,s=et(e)&&e.length>0?e:function(){try{return document.location.href}catch(t){return""}}();return 0===t.exception.values[0].stacktrace.frames.length&&t.exception.values[0].stacktrace.frames.push({colno:i,filename:s,function:"?",in_app:!0,lineno:o}),t},t.id="GlobalHandlers",t}(),gn=["EventTarget","Window","Node","ApplicationCache","AudioTrackList","ChannelMergerNode","CryptoOperation","EventSource","FileReader","HTMLUnknownElement","IDBDatabase","IDBRequest","IDBTransaction","KeyOperation","MediaController","MessagePort","ModalWindow","Notification","SVGElementInstance","Screen","TextTrack","TextTrackCue","TextTrackList","WebSocket","WebSocketWorker","Worker","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestUpload"],mn=function(){function t(e){this.name=t.id,this._options=G({XMLHttpRequest:!0,eventTarget:!0,requestAnimationFrame:!0,setInterval:!0,setTimeout:!0},e)}return t.prototype.setupOnce=function(){var t=Pt();(this._options.setTimeout&&mt(t,"setTimeout",this._wrapTimeFunction.bind(this)),this._options.setInterval&&mt(t,"setInterval",this._wrapTimeFunction.bind(this)),this._options.requestAnimationFrame&&mt(t,"requestAnimationFrame",this._wrapRAF.bind(this)),this._options.XMLHttpRequest&&"XMLHttpRequest"in t&&mt(XMLHttpRequest.prototype,"send",this._wrapXHR.bind(this)),this._options.eventTarget)&&(Array.isArray(this._options.eventTarget)?this._options.eventTarget:gn).forEach(this._wrapEventTarget.bind(this))},t.prototype._wrapTimeFunction=function(t){return function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r=e[0];return e[0]=fn(r,{mechanism:{data:{function:vt(t)},handled:!0,type:"instrument"}}),t.apply(this,e)}},t.prototype._wrapRAF=function(t){return function(e){return t.call(this,fn(e,{mechanism:{data:{function:"requestAnimationFrame",handler:vt(t)},handled:!0,type:"instrument"}}))}},t.prototype._wrapEventTarget=function(t){var e=Pt(),n=e[t]&&e[t].prototype;n&&n.hasOwnProperty&&n.hasOwnProperty("addEventListener")&&(mt(n,"addEventListener",(function(e){return function(n,r,i){try{"function"==typeof r.handleEvent&&(r.handleEvent=fn(r.handleEvent.bind(r),{mechanism:{data:{function:"handleEvent",handler:vt(r),target:t},handled:!0,type:"instrument"}}))}catch(t){}return e.call(this,n,fn(r,{mechanism:{data:{function:"addEventListener",handler:vt(r),target:t},handled:!0,type:"instrument"}}),i)}})),mt(n,"removeEventListener",(function(t){return function(e,n,r){var i,o=n;try{var s=null===(i=o)||void 0===i?void 0:i.__sentry_wrapped__;s&&t.call(this,e,s,r)}catch(t){}return t.call(this,e,o,r)}})))},t.prototype._wrapXHR=function(t){return function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r=this,i=["onload","onerror","onprogress","onreadystatechange"];return i.forEach((function(t){t in r&&"function"==typeof r[t]&&mt(r,t,(function(e){var n={mechanism:{data:{function:t,handler:vt(e)},handled:!0,type:"instrument"}};return e.__sentry_original__&&(n.mechanism.data.handler=vt(e.__sentry_original__)),fn(e,n)}))})),t.apply(this,e)}},t.id="TryCatch",t}(),bn=function(){function t(e){this.name=t.id,this._options=G({console:!0,dom:!0,fetch:!0,history:!0,sentry:!0,xhr:!0},e)}return t.prototype.addSentryBreadcrumb=function(t){this._options.sentry&&we().addBreadcrumb({category:"sentry."+("transaction"===t.type?"transaction":"event"),event_id:t.event_id,level:t.level,message:qt(t)},{event:t})},t.prototype.setupOnce=function(){var t=this;this._options.console&&Kt({callback:function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];t._consoleBreadcrumb.apply(t,V(e))},type:"console"}),this._options.dom&&Kt({callback:function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];t._domBreadcrumb.apply(t,V(e))},type:"dom"}),this._options.xhr&&Kt({callback:function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];t._xhrBreadcrumb.apply(t,V(e))},type:"xhr"}),this._options.fetch&&Kt({callback:function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];t._fetchBreadcrumb.apply(t,V(e))},type:"fetch"}),this._options.history&&Kt({callback:function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];t._historyBreadcrumb.apply(t,V(e))},type:"history"})},t.prototype._consoleBreadcrumb=function(t){var e={category:"console",data:{arguments:t.args,logger:"console"},level:B.fromString(t.level),message:_t(t.args," ")};if("assert"===t.level){if(!1!==t.args[0])return;e.message="Assertion failed: "+(_t(t.args.slice(1)," ")||"console.assert"),e.data.arguments=t.args.slice(1)}we().addBreadcrumb(e,{input:t.args,level:t.level})},t.prototype._domBreadcrumb=function(t){var e;try{e=t.event.target?ct(t.event.target):ct(t.event)}catch(t){e="<unknown>"}0!==e.length&&we().addBreadcrumb({category:"ui."+t.name,message:e},{event:t.event,name:t.name})},t.prototype._xhrBreadcrumb=function(t){if(t.endTimestamp){if(t.xhr.__sentry_own_request__)return;var e=t.xhr.__sentry_xhr__||{},n=e.method,r=e.url,i=e.status_code,o=e.body;we().addBreadcrumb({category:"xhr",data:{method:n,url:r,status_code:i},type:"http"},{xhr:t.xhr,input:o})}else;},t.prototype._fetchBreadcrumb=function(t){t.endTimestamp&&(t.fetchData.url.match(/sentry_key/)&&"POST"===t.fetchData.method||(t.error?we().addBreadcrumb({category:"fetch",data:t.fetchData,level:B.Error,type:"http"},{data:t.error,input:t.args}):we().addBreadcrumb({category:"fetch",data:G(G({},t.fetchData),{status_code:t.response.status}),type:"http"},{input:t.args,response:t.response})))},t.prototype._historyBreadcrumb=function(t){var e=Pt(),n=t.from,r=t.to,i=Dt(e.location.href),o=Dt(n),s=Dt(r);o.path||(o=i),i.protocol===s.protocol&&i.host===s.host&&(r=s.relative),i.protocol===o.protocol&&i.host===o.host&&(n=o.relative),we().addBreadcrumb({category:"navigation",data:{from:n,to:r}})},t.id="Breadcrumbs",t}(),En=function(){function t(e){void 0===e&&(e={}),this.name=t.id,this._key=e.key||"cause",this._limit=e.limit||5}return t.prototype.setupOnce=function(){ge((function(e,n){var r=we().getIntegration(t);return r?r._handler(e,n):e}))},t.prototype._handler=function(t,e){if(!(t.exception&&t.exception.values&&e&&at(e.originalException,Error)))return t;var n=this._walkErrorTree(e.originalException,this._key);return t.exception.values=V(n,t.exception.values),t},t.prototype._walkErrorTree=function(t,e,n){if(void 0===n&&(n=[]),!at(t[e],Error)||n.length+1>=this._limit)return n;var r=tn(Ke(t[e]));return this._walkErrorTree(t[e],e,V([r],n))},t.id="LinkedErrors",t}(),Sn=Pt(),wn=function(){function t(){this.name=t.id}return t.prototype.setupOnce=function(){ge((function(e){var n,r,i;if(we().getIntegration(t)){if(!Sn.navigator&&!Sn.location&&!Sn.document)return e;var o=(null===(n=e.request)||void 0===n?void 0:n.url)||(null===(r=Sn.location)||void 0===r?void 0:r.href),s=(Sn.document||{}).referrer,a=(Sn.navigator||{}).userAgent,c=G(G(G({},null===(i=e.request)||void 0===i?void 0:i.headers),s&&{Referer:s}),a&&{"User-Agent":a}),u=G(G({},o&&{url:o}),{headers:c});return G(G({},e),{request:u})}return e}))},t.id="UserAgent",t}(),kn=function(t){function e(e){return void 0===e&&(e={}),t.call(this,pn,e)||this}return F(e,t),e.prototype.showReportDialog=function(t){void 0===t&&(t={}),Pt().document&&(this._isEnabled()?vn(G(G({},t),{dsn:t.dsn||this.getDsn()})):Ft.error("Trying to call showReportDialog with Sentry Client disabled"))},e.prototype._prepareEvent=function(e,n,r){return e.platform=e.platform||"javascript",e.sdk=G(G({},e.sdk),{name:"sentry.javascript.browser",packages:V(e.sdk&&e.sdk.packages||[],[{name:"npm:@sentry/browser",version:"5.30.0"}]),version:"5.30.0"}),t.prototype._prepareEvent.call(this,e,n,r)},e.prototype._sendEvent=function(e){var n=this.getIntegration(bn);n&&n.addSentryBreadcrumb(e),t.prototype._sendEvent.call(this,e)},e}($e),xn=[new Be,new Fe,new mn,new bn,new _n,new En,new wn];function Tn(){var t,e,n,r=(void 0===t&&(t=we()),null===(n=null===(e=t)||void 0===e?void 0:e.getScope())||void 0===n?void 0:n.getTransaction());r&&(Ft.log("[Tracing] Transaction: "+yn.InternalError+" -> Global error occured"),r.setStatus(yn.InternalError))}!function(t){t.Ok="ok",t.DeadlineExceeded="deadline_exceeded",t.Unauthenticated="unauthenticated",t.PermissionDenied="permission_denied",t.NotFound="not_found",t.ResourceExhausted="resource_exhausted",t.InvalidArgument="invalid_argument",t.Unimplemented="unimplemented",t.Unavailable="unavailable",t.InternalError="internal_error",t.UnknownError="unknown_error",t.Cancelled="cancelled",t.AlreadyExists="already_exists",t.FailedPrecondition="failed_precondition",t.Aborted="aborted",t.OutOfRange="out_of_range",t.DataLoss="data_loss"}(yn||(yn={})),function(t){t.fromHttpCode=function(e){if(e<400)return t.Ok;if(e>=400&&e<500)switch(e){case 401:return t.Unauthenticated;case 403:return t.PermissionDenied;case 404:return t.NotFound;case 409:return t.AlreadyExists;case 413:return t.FailedPrecondition;case 429:return t.ResourceExhausted;default:return t.InvalidArgument}if(e>=500&&e<600)switch(e){case 501:return t.Unimplemented;case 503:return t.Unavailable;case 504:return t.DeadlineExceeded;default:return t.InternalError}return t.UnknownError}}(yn||(yn={}));var On=function(){function t(t){void 0===t&&(t=1e3),this.spans=[],this._maxlen=t}return t.prototype.add=function(t){this.spans.length>this._maxlen?t.spanRecorder=void 0:this.spans.push(t)},t}(),jn=function(t){function e(e,n){var r=t.call(this,e)||this;return r._measurements={},r._hub=we(),at(n,be)&&(r._hub=n),r.name=e.name?e.name:"",r._trimEnd=e.trimEnd,r.transaction=r,r}return F(e,t),e.prototype.setName=function(t){this.name=t},e.prototype.initSpanRecorder=function(t){void 0===t&&(t=1e3),this.spanRecorder||(this.spanRecorder=new On(t)),this.spanRecorder.add(this)},e.prototype.setMeasurements=function(t){this._measurements=G({},t)},e.prototype.finish=function(e){var n=this;if(void 0===this.endTimestamp){if(this.name||(Ft.warn("Transaction has no name, falling back to `<unlabeled transaction>`."),this.name="<unlabeled transaction>"),t.prototype.finish.call(this,e),!0===this.sampled){var r=this.spanRecorder?this.spanRecorder.spans.filter((function(t){return t!==n&&t.endTimestamp})):[];this._trimEnd&&r.length>0&&(this.endTimestamp=r.reduce((function(t,e){return t.endTimestamp&&e.endTimestamp?t.endTimestamp>e.endTimestamp?t:e:t})).endTimestamp);var i={contexts:{trace:this.getTraceContext()},spans:r,start_timestamp:this.startTimestamp,tags:this.tags,timestamp:this.endTimestamp,transaction:this.name,type:"transaction"};return Object.keys(this._measurements).length>0&&(Ft.log("[Measurements] Adding measurements to transaction",JSON.stringify(this._measurements,void 0,2)),i.measurements=this._measurements),this._hub.captureEvent(i)}Ft.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.")}},e}(function(){function t(t){if(this.traceId=Nt(),this.spanId=Nt().substring(16),this.startTimestamp=ve(),this.tags={},this.data={},!t)return this;t.traceId&&(this.traceId=t.traceId),t.spanId&&(this.spanId=t.spanId),t.parentSpanId&&(this.parentSpanId=t.parentSpanId),"sampled"in t&&(this.sampled=t.sampled),t.op&&(this.op=t.op),t.description&&(this.description=t.description),t.data&&(this.data=t.data),t.tags&&(this.tags=t.tags),t.status&&(this.status=t.status),t.startTimestamp&&(this.startTimestamp=t.startTimestamp),t.endTimestamp&&(this.endTimestamp=t.endTimestamp)}return t.prototype.child=function(t){return this.startChild(t)},t.prototype.startChild=function(e){var n=new t(G(G({},e),{parentSpanId:this.spanId,sampled:this.sampled,traceId:this.traceId}));return n.spanRecorder=this.spanRecorder,n.spanRecorder&&n.spanRecorder.add(n),n.transaction=this.transaction,n},t.prototype.setTag=function(t,e){var n;return this.tags=G(G({},this.tags),((n={})[t]=e,n)),this},t.prototype.setData=function(t,e){var n;return this.data=G(G({},this.data),((n={})[t]=e,n)),this},t.prototype.setStatus=function(t){return this.status=t,this},t.prototype.setHttpStatus=function(t){this.setTag("http.status_code",String(t));var e=yn.fromHttpCode(t);return e!==yn.UnknownError&&this.setStatus(e),this},t.prototype.isSuccess=function(){return this.status===yn.Ok},t.prototype.finish=function(t){this.endTimestamp="number"==typeof t?t:ve()},t.prototype.toTraceparent=function(){var t="";return void 0!==this.sampled&&(t=this.sampled?"-1":"-0"),this.traceId+"-"+this.spanId+t},t.prototype.getTraceContext=function(){return Ot({data:Object.keys(this.data).length>0?this.data:void 0,description:this.description,op:this.op,parent_span_id:this.parentSpanId,span_id:this.spanId,status:this.status,tags:Object.keys(this.tags).length>0?this.tags:void 0,trace_id:this.traceId})},t.prototype.toJSON=function(){return Ot({data:Object.keys(this.data).length>0?this.data:void 0,description:this.description,op:this.op,parent_span_id:this.parentSpanId,span_id:this.spanId,start_timestamp:this.startTimestamp,status:this.status,tags:Object.keys(this.tags).length>0?this.tags:void 0,timestamp:this.endTimestamp,trace_id:this.traceId})},t}());function In(){var t=this.getScope();if(t){var e=t.getSpan();if(e)return{"sentry-trace":e.toTraceparent()}}return{}}function Rn(t,e,n){var r,i,o=t.getClient(),s=o&&o.getOptions()||{};return o&&function(t){return"tracesSampleRate"in t||"tracesSampler"in t}(s)?void 0!==e.sampled?(e.tags=G(G({},e.tags),{__sentry_samplingMethod:W.Explicit}),e):("function"==typeof s.tracesSampler?(i=s.tracesSampler(n),e.tags=G(G({},e.tags),{__sentry_samplingMethod:W.Sampler,__sentry_sampleRate:String(Number(i))})):void 0!==n.parentSampled?(i=n.parentSampled,e.tags=G(G({},e.tags),{__sentry_samplingMethod:W.Inheritance})):(i=s.tracesSampleRate,e.tags=G(G({},e.tags),{__sentry_samplingMethod:W.Rate,__sentry_sampleRate:String(Number(i))})),function(t){if(isNaN(t)||"number"!=typeof t&&"boolean"!=typeof t)return Ft.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got "+JSON.stringify(t)+" of type "+JSON.stringify(typeof t)+"."),!1;if(t<0||t>1)return Ft.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got "+t+"."),!1;return!0}(i)?i?(e.sampled=Math.random()<i,e.sampled?(e.initSpanRecorder(null===(r=s._experiments)||void 0===r?void 0:r.maxSpans),Ft.log("[Tracing] starting "+e.op+" transaction - "+e.name),e):(Ft.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = "+Number(i)+")"),e)):(Ft.log("[Tracing] Discarding transaction because "+("function"==typeof s.tracesSampler?"tracesSampler returned 0 or false":"a negative sampling decision was inherited or tracesSampleRate is set to 0")),e.sampled=!1,e):(Ft.warn("[Tracing] Discarding transaction because of invalid sample rate."),e.sampled=!1,e)):(e.sampled=!1,e)}function Cn(t){var e={transactionContext:t,parentSampled:t.parentSampled};if(jt()){var n=ke();if(n){var r=It(module,"http").IncomingMessage,i=n.members.find((function(t){return at(t,r)}));i&&(e.request=function(t,e){if(void 0===e&&(e=Rt),!jt())throw new Error("Can't get node request data outside of a node environment");var n={},r=t.headers||t.header||{},i=t.method,o=t.hostname||t.host||r.host||"<no host>",s="https"===t.protocol||t.secure||(t.socket||{}).encrypted?"https":"http",a=t.originalUrl||t.url||"",c=s+"://"+o+a;return e.forEach((function(e){switch(e){case"headers":n.headers=r;break;case"method":n.method=i;break;case"url":n.url=c;break;case"cookies":n.cookies=t.cookies||It(module,"cookie").parse(r.cookie||"");break;case"query_string":n.query_string=It(module,"url").parse(a||"",!1).query;break;case"data":if("GET"===i||"HEAD"===i)break;void 0!==t.body&&(n.data=et(t.body)?t.body:JSON.stringify(xt(t.body)));break;default:({}).hasOwnProperty.call(t,e)&&(n[e]=t[e])}})),n}(i))}}else{var o=Pt();"location"in o&&(e.location=G({},o.location))}return e}function Pn(t,e){return Rn(this,new jn(t,this),G(G({},Cn(t)),e))}var Nn,Dn=window._js_app_config_||{},qn=window.location.hostname.split(".").slice(0,-1).pop()||"vola";function An(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,i={name:t},o=Pe(i),s=o.startChild({op:"ngHttpCall"});Re((function(t){return t.setSpan(o)}));var a=function(e){var i=e.status;if(!r||r(i)){var a=200<=i&&i<300,c=i>=0?yn.fromHttpCode(i):yn.Unavailable;if(s.finish(),o.setHttpStatus(i),o.setStatus(c),n){var u=n(e);for(var p in u)o.setData(p,u[p])}a||Ie(new Error("Failed ".concat(t,": ").concat(i))),o.sampled=!0,o.finish()}};return e.then(a,a),e}!function(t){if(void 0===t&&(t={}),void 0===t.defaultIntegrations&&(t.defaultIntegrations=xn),void 0===t.release){var e=Pt();e.SENTRY_RELEASE&&e.SENTRY_RELEASE.id&&(t.release=e.SENTRY_RELEASE.id)}void 0===t.autoSessionTracking&&(t.autoSessionTracking=!1),function(t,e){!0===e.debug&&Ft.enable();var n=we(),r=new t(e);n.bindClient(r)}(kn,t),t.autoSessionTracking&&function(){var t=Pt(),e=we(),n="complete"===document.readyState,r=!1,i=function(){r&&n&&e.endSession()},o=function(){n=!0,i(),t.removeEventListener("load",o)};e.startSession(),n||t.addEventListener("load",o);try{var s=new PerformanceObserver((function(t,e){t.getEntries().forEach((function(t){"first-contentful-paint"===t.name&&t.startTime<a&&(e.disconnect(),r=!0,i())}))})),a="hidden"===document.visibilityState?0:1/0;document.addEventListener("visibilitychange",(function(t){a=Math.min(a,t.timeStamp)}),{once:!0}),s.observe({type:"paint",buffered:!0})}catch(t){r=!0,i()}}()}({dsn:"https://11ddd19a723b4e9bb5c2350297439670@o443540.ingest.sentry.io/5422535",defaultIntegrations:!1,release:Dn.app_version,environment:qn+"_"+Dn.env_name+"_"+Dn.ab_version}),(Nn=Ee()).__SENTRY__&&(Nn.__SENTRY__.extensions=Nn.__SENTRY__.extensions||{},Nn.__SENTRY__.extensions.startTransaction||(Nn.__SENTRY__.extensions.startTransaction=Pn),Nn.__SENTRY__.extensions.traceHeaders||(Nn.__SENTRY__.extensions.traceHeaders=In)),Kt({callback:Tn,type:"error"}),Kt({callback:Tn,type:"unhandledrejection"});var $n=Object.freeze({__proto__:null,ngHttpResponseMetric:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=function(e){var r={name:t};n&&(r.data=n(e));var i=e.status>0?e.status:503,o=503!==i?yn.fromHttpCode(i):yn.Unavailable,s=Pe(r);s.startChild({op:"httpResponse"}).finish(),s.setHttpStatus(i),s.setStatus(o),s.sampled=!0,s.finish()};return e.then(r,r),e},ngHttpCall:An});function Un(){var t=window._js_app_config_||{};return{affiliate:t.affiliateName.toUpperCase(),code:t.market,language:t.language_code.toUpperCase(),currency:t.currency_code.toUpperCase()}}var Ln=function(){function t(t){this.api=t}return t.$inject=["ApiTools"],t.prototype.initPurchase=function(t,e,n){var r=this,i=this._mapPaymentMethod(e,n),o=K(),s={url:t.baseUrl+"/public/payments/init-purchase",method:"POST",data:G(G({},t.request),{payment_method:i,fingerprint:JSON.stringify(o),browser_attributes:{accept_header:"application/json",java_enabled:navigator.javaEnabled&&navigator.javaEnabled(),language:navigator.language,color_depth:window.screen&&window.screen.colorDepth&&window.screen.colorDepth.toString(),screen_height:window.screen&&window.screen.height&&window.screen.height.toString(),screen_width:window.screen&&window.screen.width&&window.screen.width.toString(),timezone:o.clientTimezone.toString(),user_agent:o.userAgent},meta:{market:Un()}}),headers:{Signature:t.sig,Authorization:"Bearer "+t.bearer,Accept:"application/json","Content-Type":"application/json"},retry:{attempts:5,delay:2500,until:function(t){return t&&t.config&&t.status&&(200<=t.status&&t.status<300||t.status>=500)}}},a=this.api.http(s);return An("initPurchaseCall",a,(function(t){return r._paymentSummary(s,t)})),a.then((function(t){return t.data.data}),(function(t){if(t instanceof Error)throw t;var e=r._paymentSummary(s,t);throw new Error("initPurchase exception: "+JSON.stringify(e))}))},t.prototype._mapPaymentMethod=function(t,e){switch(e){case"GooglePayToken":return{type:"google_pay",protocol_version:t.getProtocolVersion(),signed_message:t.getSignedMessage(),signature:t.getSignature()};case"GooglePayRevolutWidgetToken":return{type:"google_pay_revolut_widget"};case"ApplePayToken":return{type:"apple_pay",version:t.getVersion(),data:t.getData(),signature:t.getSignature(),ephemeral_public_key:t.getEphemeralPublicKey(),public_key_hash:t.getPublicKeyHash(),transaction_id:t.getTransactionId()};case"ApplePayRevolutWidgetToken":return{type:"apple_pay_revolut_widget"};case"BlikAuthCode":return{type:"blik_code",authorization_code:t.getAuthCode()};case"TokenPayU":return{type:"card_token",card_token:t.getToken(),bin:t.getBin(),cvv:t.getCvv()};case"PayByLinkToken":return{type:"pbl",bank_name:t.getBankCode(),language:t.getLanguageCode()};case"MobilPay":return{type:"credit_card",card_number:t.getNumber(),expiration_month:t.getExpirationMonth(),expiration_year:t.getExpirationYear(),cardholder_name:t.getFullName(),cvv:t.getCvc()};case"PaymentInitFlow":return{type:t.getPaymentInitFlowType()};case"CreditCardInstallmentsToken":return{type:"credit_card_installments",installments:t.getInstallments()};case"RevolutCard":return{type:"credit_card",card_number:t.getNumber(),expiration_month:t.getExpirationMonth(),expiration_year:t.getExpirationYear(),cardholder_name:t.getFullName(),cvv:t.getCvc(),country_code:t.getCountryCode(),zip_code:t.getZipCode()};case"RevolutPayToken":return{type:"revolut_pay"};default:return{type:""}}},t.prototype._paymentSummary=function(t,e){var n=e.status;return{status:n,response:200<=n&&n<300?"_hidden_":e.data,url:t.url,paymentId:t.data.id,gatewayConfigId:t.data.gateway_config_id,paymentType:t.data.payment_method.type,pnr:t.data.order_details.order_description,orderId:t.data.order_details.order_id,signature:t.headers.Signature,order_details:t.data.order_details}},t}();p("ITH.Shared.Common.PaymentApi",[]).service("PaymentApi",Ln),p("ITH.Shared.Common.Fingerprint",[]).service("fingerprint",K),p("ITH.Shared.Common.Market",[]).service("market",Un),p("ITH.Shared.Common.Monitoring",[]).service("Monitoring",(function(){return $n}))}();
//# sourceMappingURL=bundle.js.map
;

// Source: ../shared/public_html/assets/js/accountSettings/clients/ProfileServiceClient.js
/* global angular: false */
(function (angular) {
var ProfileServiceClient = function ($http, AppConfig) {
        const USERS_SERVICE_HOST = AppConfig.getUsersServiceHost();

        var endpoints = {
            getProfile: {url: USERS_SERVICE_HOST + '/v1/profileWithDocument', method: 'GET'},
            getPassengers: {url: USERS_SERVICE_HOST + '/v1/passengersWithDocument', method: 'GET'},
            setProfile: {url: USERS_SERVICE_HOST + '/v1/profileWithDocument', method: 'POST'},
            setProfilePersonalDetailsOnly: {url: USERS_SERVICE_HOST + '/v1/profile', method: 'POST'},
            setProfileDocsOnly: {url: USERS_SERVICE_HOST + '/v1/documents', method: 'POST'},
            setLanguage: {url: USERS_SERVICE_HOST + '/v1/users/language', method: 'POST'},
            setPassenger: {url: USERS_SERVICE_HOST + '/v1/passengersWithDocument', method: 'POST'},
            deletePassenger: {url: USERS_SERVICE_HOST + '/v1/passengers/delete', method: 'POST'},
            setBilling: {url: USERS_SERVICE_HOST + '/v1/billings', method: 'POST'},
            getBillings: {url: USERS_SERVICE_HOST + '/v1/billings', method: 'GET'},
            deleteBilling: {url: USERS_SERVICE_HOST + '/v1/billings/delete', method: 'POST'},
            changePassword: {url: USERS_SERVICE_HOST + '/v1/users/password', method: 'POST'},
            deleteAccount: {url: USERS_SERVICE_HOST + '/v1/users/delete', method: 'POST'}
        };

        this.send = function (request, data, token, queryParams) {
            var req = JSON.parse(JSON.stringify(request));

            if (data !== null) {
                req.data = data;
            }

            if (token !== null) {
                req.headers = {
                    'Authorization': 'Bearer ' + token
                };
            }

            if (queryParams) {
                req.url = req.url + queryParams;
            }

            return $http(req);
        };

        this.getBillings = function (token) {
            return this.send(endpoints.getBillings, null, token);
        };

        this.setBilling = function (
            token,
            id,
            type,
            companyName,
            nip,
            country,
            address,
            city,
            postcode,
            firstName,
            lastName
        ) {
            var data = {
                id: id,
                type: type,
                'company_name': companyName,
                nip: nip,
                country: country,
                address: address,
                city: city,
                postcode: postcode,
                'first_name': firstName,
                'last_name': lastName
            };

            return this.send(endpoints.setBilling, data, token);
        };

        this.deleteBilling = function (token, billingId) {
            var data = {
                id: billingId
            };

            return this.send(endpoints.deleteBilling, data, token);
        };

        this.deleteAccount = function (token, email) {
            var data = {
                email: email
            };

            return this.send(endpoints.deleteAccount, data, token);
        };

        this.deletePassenger = function (token, id) {
            var data = {
                id: id
            };

            return this.send(endpoints.deletePassenger, data, token);
        };

        this.getProfile = function (token, queryParams) {
            return this.send(endpoints.getProfile, null, token, queryParams);
        };

        this.getPassengers = function (token, queryParams) {
            return this.send(endpoints.getPassengers, null, token, queryParams);
        };

        this.setPassenger = function (
            token,
            id,
            gender,
            firstName,
            lastName,
            birthDate,
            docType,
            country,
            nationality,
            docNumber,
            releaseDate,
            expirationDate,
            email
        ) {
            var data = {
                id: id,
                gender: gender,
                first_name: firstName,
                last_name: lastName,
                birth_date: birthDate,
                type: docType,
                country: country,
                nationalities: [nationality],
                doc_number: docNumber,
                release_date: releaseDate,
                expiration_date: expirationDate,
                email: email
            };

            return this.send(endpoints.setPassenger, data, token);
        };

        this.setProfile = function (
            token,
            gender,
            firstName,
            lastName,
            phonePrefix,
            phone,
            birthDate,
            docType,
            country,
            nationality,
            docNumber,
            releaseDate,
            expirationDate
        ) {
            var data = {
                gender: gender,
                first_name: firstName,
                last_name: lastName,
                phone_prefix: phonePrefix,
                phone: phone,
                birth_date: birthDate,
                type: docType,
                country: country,
                nationalities: [nationality],
                doc_number: docNumber,
                release_date: releaseDate,
                expiration_date: expirationDate
            };

            return this.send(endpoints.setProfile, data, token);
        };

        this.setProfilePersonalDetailsOnly = function (
            token,
            gender,
            firstName,
            lastName,
            phonePrefix,
            phone,
            birthDate,
            nationality
        ) {
            var data = {
                gender: gender,
                first_name: firstName,
                last_name: lastName,
                phone_prefix: phonePrefix,
                phone: phone,
                birth_date: birthDate,
                nationalities: [nationality]
            };

            return this.send(endpoints.setProfilePersonalDetailsOnly, data, token);
        };

        this.setProfileDocsOnly = function (
            token,
            id,
            docType,
            country,
            docNumber,
            releaseDate,
            expirationDate,
            docId
        ) {
            var data = {
                id: docId,
                passenger_id: id,
                type: docType,
                country: country,
                doc_number: docNumber,
                release_date: releaseDate,
                expiration_date: expirationDate
            };

            return this.send(endpoints.setProfileDocsOnly, data, token);
        };

        this.setLanguage = function (token, language) {
            var data = {language: language};

            return this.send(endpoints.setLanguage, data, token);
        };

        this.changePassword = function (token, oldPassword, newPassword) {
            var data = {
                old_password: oldPassword,
                new_password: newPassword
            };

            return this.send(endpoints.changePassword, data, token);
        };
    };

    ProfileServiceClient.$inject = ['$http', 'appConfig'];

    angular
        .module('accountSettings')
        .service('ProfileServiceClient', ProfileServiceClient);
}(angular));
;

// Source: ../shared/public_html/assets/js/accountSettings/services/ProfileSettingsService.js
(function (angular) {
var IthProfileSettingsService = function (ProfileServiceClient, API_STATUSES_PROFILE, JwtTokenService, AuthGuard, AuthService2) {
        this.getPassengers = function () {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.getPassengers(token)
                .then(function (response) {
                    return {
                        status: API_STATUSES_PROFILE.OK,
                        response: response.data
                    };
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return {
                        status: API_STATUSES_PROFILE.UNEXPECTED_ERROR,
                        response: null
                    };
                });
        };

        this.setPassenger = function (Person) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Document = Person.getIdCard();

            return ProfileServiceClient.setPassenger(
                token,
                Person.getId(),
                Person.getGender(),
                Person.getFirstName(),
                Person.getLastName(),
                Person.getBirthDate(),
                Document.getDocumentType(),
                Document.getIssuingCountry(),
                Person.getNationality(),
                Document.getNumber(),
                Document.getIssueDate(),
                Document.getExpDate()
            ).then(function (response) {
                return {
                    response: response.data,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.deleteAccount = function (email) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.deleteAccount(token, email)
                .then(function () {
                    return API_STATUSES_PROFILE.OK;
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    if (response.status === 422) {
                        return API_STATUSES_PROFILE.INCORRECT_CREDENTIALS;
                    }

                    return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
                });
        };

        this.deletePassenger = function (id) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.deletePassenger(token, id)
                .then(function () {
                    return API_STATUSES_PROFILE.OK;
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
                });
        };

        this.getProfile = function () {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.getProfile(token)
                .then(function (response) {
                    var status = response.data.document ? API_STATUSES_PROFILE.OK : API_STATUSES_PROFILE.PROFILE_NOT_EXISTS;

                    return {
                        status: status,
                        response: response.data
                    };
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return {
                        status: API_STATUSES_PROFILE.UNEXPECTED_ERROR,
                        response: null
                    };
                });
        };

        this.setProfile = function (Person) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Document = Person.getIdCard();
            var Phone = Person.getPhone();

            return ProfileServiceClient.setProfile(
                token,
                Person.getGender(),
                Person.getFirstName(),
                Person.getLastName(),
                Phone.getPrefix(),
                Phone.getNumber(),
                Person.getBirthDate(),
                Document.getDocumentType(),
                Document.getIssuingCountry(),
                Person.getNationality(),
                Document.getNumber(),
                Document.getIssueDate(),
                Document.getExpDate()
            ).then(function () {
                return API_STATUSES_PROFILE.OK;
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.setProfilePersonalDetailsOnly = function (Person) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Phone = Person.getPhone();

            return ProfileServiceClient.setProfilePersonalDetailsOnly(
                token,
                Person.getGender(),
                Person.getFirstName(),
                Person.getLastName(),
                Phone.getPrefix(),
                Phone.getNumber(),
                Person.getBirthDate(),
                Person.getNationality()
            ).then(function (response) {
                return {
                    response: response,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.setProfileDocsOnly = function (Person) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Document = Person.getIdCard();

            return ProfileServiceClient.setProfileDocsOnly(
                token,
                Person.getId(),
                Document.getDocumentType(),
                Document.getIssuingCountry(),
                Document.getNumber(),
                Document.getIssueDate(),
                Document.getExpDate(),
                Document.getDocumentId()
            ).then(function (response) {
                return {
                    response: response,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.setLanguage = function (language) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.setLanguage(
                token,
                language
            ).then(function (response) {
                return {
                    response: response,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.changePassword = function (oldPassword, newPassword) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.changePassword(token, oldPassword, newPassword)
                .then(function () {
                    return API_STATUSES_PROFILE.OK;
                }).catch(function (response) {
                    if (response.status === 404) {
                        return API_STATUSES_PROFILE.USER_NOT_EXISTS;
                    }

                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
                });
        };

        this.getBillings = function () {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.getBillings(token)
                .then(function (response) {
                    return {
                        status: API_STATUSES_PROFILE.OK,
                        response: response.data
                    };
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return {
                        status: API_STATUSES_PROFILE.UNEXPECTED_ERROR,
                        response: null
                    };
                });
        };

        this.setPersonalBilling = function (BillingPerson) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Address = BillingPerson.getAddress();

            return ProfileServiceClient.setBilling(
                token,
                BillingPerson.getId(),
                'person',
                null,
                null,
                Address.getCountry(),
                Address.getStreet(),
                Address.getCity(),
                Address.getZipCode(),
                BillingPerson.getFirstName(),
                BillingPerson.getLastName()
            ).then(function (response) {
                return {
                    response: response.data,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.setCompanyBilling = function (Company) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();
            var Address = Company.getAddress();

            return ProfileServiceClient.setBilling(
                token,
                Company.getId(),
                'company',
                Company.getName(),
                Company.getVatNumber(),
                Address.getCountry(),
                Address.getStreet(),
                Address.getCity(),
                Address.getZipCode(),
                null,
                null
            ).then(function (response) {
                return {
                    response: response.data,
                    status: API_STATUSES_PROFILE.OK
                };
            }).catch(function (response) {
                if (AuthGuard.isSessionExpired(response.status)) {
                    return AuthGuard.redirectToMainPage();
                }

                return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
            });
        };

        this.deleteBilling = function (billingId) {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_PROFILE.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.deleteBilling(token, billingId)
                .then(function () {
                    return API_STATUSES_PROFILE.OK;
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return API_STATUSES_PROFILE.UNEXPECTED_ERROR;
                });
        };
    };

    IthProfileSettingsService.$inject = ['ProfileServiceClient', 'API_STATUSES_PROFILE', 'JwtTokenService', 'AuthGuard', 'AuthService2'];

    angular
        .module('accountSettings')
        .service('ProfileSettingsService', IthProfileSettingsService);

}(angular));
;

// Source: ../shared/public_html/assets/js/angular-translate-loader-url/angular-translate-loader-url.js
/*!
 * angular-translate - v2.8.1 - 2015-10-01
 * 
 * Copyright (c) 2015 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateUrlLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical dynamic url pattern:
 * "locale.php?lang=en_US", "locale.php?lang=de_DE", "locale.php?language=nl_NL" etc.
 * Prefixing the specified url, the current requested, language id will be applied
 * with "?{queryParameter}={key}".
 * Using this service, the response of these urls must be an object of
 * key-value pairs.
 *
 * @param {object} options Options object, which gets the url, key and
 * optional queryParameter ('lang' is used by default).
 */
.factory('$translateUrlLoader', $translateUrlLoader);

function $translateUrlLoader($q, $http) {

return function (options) {

    if (!options || !options.url) {
      throw new Error('Couldn\'t use urlLoader since no url is given!');
    }

    var requestParams = {};

    requestParams[options.queryParameter || 'lang'] = options.key;

    return $http(angular.extend({
      url: options.url,
      params: requestParams,
      method: 'GET'
    }, options.$http))
      .then(function(result) {
        return result.data;
      }, function () {
        return $q.reject(options.key);
      });
  };
}
$translateUrlLoader.$inject = ['$q', '$http'];

$translateUrlLoader.displayName = '$translateUrlLoader';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-handler-log/angular-translate-handler-log.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateMissingTranslationHandlerLog.$inject = ['$log'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateMissingTranslationHandlerLog
 * @requires $log
 *
 * @description
 * Uses angular's `$log` service to give a warning when trying to translate a
 * translation id which doesn't exist.
 *
 * @returns {function} Handler function
 */
.factory('$translateMissingTranslationHandlerLog', $translateMissingTranslationHandlerLog);

function $translateMissingTranslationHandlerLog ($log) {

return function (translationId) {
    $log.warn('Translation for ' + translationId + ' doesn\'t exist');
  };
}

$translateMissingTranslationHandlerLog.displayName = '$translateMissingTranslationHandlerLog';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-handler-log/angular-translate-handler-log.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(n,t){"function"==typeof define&&define.amd?define([],function(){return t()}):"object"==typeof module&&module.exports?module.exports=t():t()}(0,function(){function n(t){"use strict";return function(n){t.warn("Translation for "+n+" doesn't exist")}}return n.$inject=["$log"],angular.module("pascalprecht.translate").factory("$translateMissingTranslationHandlerLog",n),n.displayName="$translateMissingTranslationHandlerLog","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-interpolation-messageformat/angular-translate-interpolation-messageformat.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["messageformat"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("messageformat"));
  } else {
    factory(root["MessageFormat"]);
  }
}(this, function (MessageFormat) {

angular.module('pascalprecht.translate')

/**
 * @ngdoc property
 * @name pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
 * @requires TRANSLATE_MF_INTERPOLATION_CACHE
 *
 * @description
 * Uses MessageFormat.js to interpolate strings against some values.
 */
.constant('TRANSLATE_MF_INTERPOLATION_CACHE', '$translateMessageFormatInterpolation')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider
 *
 * @description
 * Configurations for $translateMessageFormatInterpolation
 */
.provider('$translateMessageFormatInterpolation', $translateMessageFormatInterpolationProvider);

function $translateMessageFormatInterpolationProvider() {

var configurer;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider#messageFormatConfigurer
   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolationProvider
   *
   * @description
   * Defines an optional configurer for the MessageFormat instance.
   *
   * Note: This hook will be called whenever a new instance of MessageFormat will be created.
   *
   * @param {function} fn callback with the instance as argument
   */
  this.messageFormatConfigurer = function (fn) {
    configurer = fn;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateMessageFormatInterpolation
   * @requires pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
   *
   * @description
   * Uses MessageFormat.js to interpolate strings against some values.
   *
   * Be aware to configure a proper sanitization strategy.
   *
   * See also:
   * * {@link pascalprecht.translate.$translateSanitization}
   * * {@link https://github.com/SlexAxton/messageformat.js}
   *
   * @return {object} $translateMessageFormatInterpolation Interpolator service
   */
  this.$get = ['$translateSanitization', '$cacheFactory', 'TRANSLATE_MF_INTERPOLATION_CACHE', function ($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE) {
    return $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, configurer);
  }];

}

function $translateMessageFormatInterpolation($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE, messageFormatConfigurer) {

var $translateInterpolator = {},
      $cache = $cacheFactory.get(TRANSLATE_MF_INTERPOLATION_CACHE),
      // instantiate with default locale (which is 'en')
      $mf = new MessageFormat('en'),
      $identifier = 'messageformat';

  if (angular.isFunction(messageFormatConfigurer)) {
    messageFormatConfigurer($mf);
  }

  if (!$cache) {
    // create cache if it doesn't exist already
    $cache = $cacheFactory(TRANSLATE_MF_INTERPOLATION_CACHE);
  }

  $cache.put('en', $mf);

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateMessageFormatInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $mf = $cache.get(locale);
    if (!$mf) {
      $mf = new MessageFormat(locale);
      if (angular.isFunction(messageFormatConfigurer)) {
        messageFormatConfigurer($mf);
      }
      $cache.put(locale, $mf);
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateMessageFormatInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateMessageFormatInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateMessageFormatInterpolation
   *
   * @description
   * Interpolates given string against given interpolate params using MessageFormat.js.
   *
   * @returns {string} interpolated string.
   */
  $translateInterpolator.interpolate = function (string, interpolationParams, context, sanitizeStrategy) {
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy);

    var compiledFunction = $cache.get('mf:' + string);

    // if given string wasn't compiled yet, we do so now and never have to do it again
    if (!compiledFunction) {

      // Ensure explicit type if possible
      // MessageFormat checks the actual type (i.e. for amount based conditions)
      for (var key in interpolationParams) {
        if (interpolationParams.hasOwnProperty(key)) {
          // ensure number
          var number = parseInt(interpolationParams[key], 10);
          if (angular.isNumber(number) && ('' + number) === interpolationParams[key]) {
            interpolationParams[key] = number;
          }
        }
      }

      compiledFunction = $mf.compile(string);
      $cache.put('mf:' + string, compiledFunction);
    }

    var interpolatedText = compiledFunction(interpolationParams);
    return $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy);
  };

  return $translateInterpolator;
}

$translateMessageFormatInterpolation.displayName = '$translateMessageFormatInterpolation';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-interpolation-messageformat/angular-translate-interpolation-messageformat.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define(["messageformat"],function(t){return e(t)}):"object"==typeof module&&module.exports?module.exports=e(require("messageformat")):e(t.MessageFormat)}(this,function(r){function i(u,t,e,n){"use strict";var a={},c=t.get(e),f=new r("en");return angular.isFunction(n)&&n(f),c||(c=t(e)),c.put("en",f),a.setLocale=function(t){(f=c.get(t))||(f=new r(t),angular.isFunction(n)&&n(f),c.put(t,f))},a.getInterpolationIdentifier=function(){return"messageformat"},a.useSanitizeValueStrategy=function(t){return u.useStrategy(t),this},a.interpolate=function(t,e,n,a){e=e||{},e=u.sanitize(e,"params",a);var r=c.get("mf:"+t);if(!r){for(var i in e)if(e.hasOwnProperty(i)){var o=parseInt(e[i],10);angular.isNumber(o)&&""+o===e[i]&&(e[i]=o)}r=f.compile(t),c.put("mf:"+t,r)}var s=r(e);return u.sanitize(s,"text",a)},a}return angular.module("pascalprecht.translate").constant("TRANSLATE_MF_INTERPOLATION_CACHE","$translateMessageFormatInterpolation").provider("$translateMessageFormatInterpolation",function(){"use strict";var a;this.messageFormatConfigurer=function(t){a=t},this.$get=["$translateSanitization","$cacheFactory","TRANSLATE_MF_INTERPOLATION_CACHE",function(t,e,n){return i(t,e,n,a)}]}),i.displayName="$translateMessageFormatInterpolation","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-partial/angular-translate-loader-partial.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translatePartialLoaderProvider
 *
 * @description
 * By using a $translatePartialLoaderProvider you can configure a list of a needed
 * translation parts directly during the configuration phase of your application's
 * lifetime. All parts you add by using this provider would be loaded by
 * angular-translate at the startup as soon as possible.
 */
  .provider('$translatePartialLoader', $translatePartialLoader);

function $translatePartialLoader() {

/**
   * @constructor
   * @name Part
   *
   * @description
   * Represents Part object to add and set parts at runtime.
   */
  function Part(name, priority, urlTemplate) {
    this.name = name;
    this.isActive = true;
    this.tables = {};
    this.priority = priority || 0;
    this.langPromises = {};
    this.urlTemplate = urlTemplate;
  }

  /**
   * @name parseUrl
   * @method
   *
   * @description
   * Returns a parsed url template string and replaces given target lang
   * and part name it.
   *
   * @param {string|function} urlTemplate - Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   * @param {string} targetLang - Language key for language to be used.
   * @return {string} Parsed url template string
   */
  Part.prototype.parseUrl = function (urlTemplate, targetLang) {
    if (angular.isFunction(urlTemplate)) {
      return urlTemplate(this.name, targetLang);
    }
    return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
  };

  Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

    //locals
    var self = this;
    var lastLangPromise = this.langPromises[lang];
    var deferred = $q.defer();

    //private helper helpers
    var fetchData = function () {
      return $http(
        angular.extend({
            method : 'GET',
            url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
          },
          $httpOptions)
      );
    };

    //private helper
    var handleNewData = function (data) {
      self.tables[lang] = data;
      deferred.resolve(data);
    };

    //private helper
    var rejectDeferredWithPartName = function () {
      deferred.reject(self.name);
    };

    //private helper
    var tryGettingThisTable = function () {
      //data fetching logic
      fetchData().then(
        function (result) {
          handleNewData(result.data);
        },
        function (errorResponse) {
          if (errorHandler) {
            errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
          } else {
            rejectDeferredWithPartName();
          }
        });
    };

    //loading logic
    if (!this.tables[lang]) {
      //let's try loading the data
      if (!lastLangPromise) {
        //this is the first request - just go ahead and hit the server
        tryGettingThisTable();
      } else {
        //this is an additional request after one or more unfinished or failed requests
        //chain the deferred off the previous request's promise so that this request conditionally executes
        //if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
        lastLangPromise.then(deferred.resolve, tryGettingThisTable);
      }
      //retain a reference to the last promise so we can continue the chain if another request is made before any succeed
      //you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
      this.langPromises[lang] = deferred.promise;
    }
    else {
      //the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
      //this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
      deferred.resolve(this.tables[lang]);
    }
    return deferred.promise;
  };

  var parts = {};

  function hasPart(name) {
    return Object.prototype.hasOwnProperty.call(parts, name);
  }

  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  function isPartAvailable(name) {
    if (!isStringValid(name)) {
      throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
    }

    return (hasPart(name) && parts[name].isActive);
  }

  function deepExtend(dst, src) {
    for (var property in src) {
      if (src[property] && src[property].constructor &&
        src[property].constructor === Object) {
        dst[property] = dst[property] || {};
        deepExtend(dst[property], src[property]);
      } else {
        dst[property] = src[property];
      }
    }
    return dst;
  }

  function getPrioritizedParts() {
    var prioritizedParts = [];
    for (var part in parts) {
      if (parts[part].isActive) {
        prioritizedParts.push(parts[part]);
      }
    }
    prioritizedParts.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return prioritizedParts;
  }


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Registers a new part of the translation table to be loaded once the
   * `angular-translate` gets into runtime phase. It does not actually load any
   * translation data, but only registers a part to be loaded in the future.
   *
   * @param {string} name A name of the part to add
   * @param {int} [priority=0] Sets the load priority of this part.
   * @param {string|function} urlTemplate Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param
   * of the wrong type. Please, note that the `name` param has to be a
   * non-empty **string**.
   */
  this.addPart = function (name, priority, urlTemplate) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t add part, part name has to be a string!');
    }

    if (!hasPart(name)) {
      parts[name] = new Part(name, priority, urlTemplate);
    }
    parts[name].isActive = true;

    return this;
  };

  /**
   * @ngdocs function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Sets a translation table to the specified part. This method does not make the
   * specified part available, but only avoids loading this part from the server.
   *
   * @param {string} lang A language of the given translation table
   * @param {string} part A name of the target part
   * @param {object} table A translation table to set to the specified part
   *
   * @return {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass params
   * of the wrong type. Please, note that the `lang` and `part` params have to be a
   * non-empty **string**s and the `table` param has to be an object.
   */
  this.setPart = function (lang, part, table) {
    if (!isStringValid(lang)) {
      throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
    }
    if (!isStringValid(part)) {
      throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
    }
    if (typeof table !== 'object' || table === null) {
      throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
    }

    if (!hasPart(part)) {
      parts[part] = new Part(part);
      parts[part].isActive = false;
    }

    parts[part].tables[lang] = table;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Removes the previously added part of the translation data. So, `angular-translate` will not
   * load it at the startup.
   *
   * @param {string} name A name of the part to delete
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.deletePart = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t delete part, first arg has to be string.');
    }

    if (hasPart(name)) {
      parts[name].isActive = false;
    }

    return this;
  };


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Checks if the specific part is available. A part becomes available after it was added by the
   * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
   * asks the loader to that.
   *
   * @param {string} name A name of the part to check
   *
   * @returns {boolean} Returns **true** if the part is available now and **false** if not.
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.isPartAvailable = isPartAvailable;

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translatePartialLoader
   *
   * @requires $q
   * @requires $http
   * @requires $injector
   * @requires $rootScope
   * @requires $translate
   *
   * @description
   *
   * @param {object} options Options object
   *
   * @throws {TypeError}
   */
  this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
    function ($rootScope, $injector, $q, $http, $log) {

      /**
       * @ngdoc event
       * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
       * @eventOf pascalprecht.translate.$translatePartialLoader
       * @eventType broadcast on root scope
       *
       * @description
       * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
       * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
       * you get this event the translation table is not longer current and has to be updated.
       *
       * @param {string} name A name of the part which is a reason why the event was fired
       */

      var service = function (options) {
        if (!isStringValid(options.key)) {
          throw new TypeError('Unable to load data, a key is not a non-empty string.');
        }

        if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
          throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
        }

        var errorHandler = options.loadFailureHandler;
        if (errorHandler !== undefined) {
          if (!angular.isString(errorHandler)) {
            throw new Error('Unable to load data, a loadFailureHandler is not a string.');
          } else {
            errorHandler = $injector.get(errorHandler);
          }
        }

        var loaders = [],
          prioritizedParts = getPrioritizedParts();

        angular.forEach(prioritizedParts, function (part) {
          loaders.push(
            part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
          );
          part.urlTemplate = part.urlTemplate || options.urlTemplate;
        });

        // workaround for #1781
        var structureHasBeenChangedWhileLoading = false;
        var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          structureHasBeenChangedWhileLoading = true;
        });

        return $q.all(loaders)
          .then(function () {
            dirtyCheckEventCloser();
            if (structureHasBeenChangedWhileLoading) {
              if (!options.__retries) {
                // the part structure has been changed while loading (the origin ones)
                // this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
                // TODO maybe we can optimize this with the actual list of missing parts
                options.__retries = (options.__retries || 0) + 1;
                return service(options);
              } else {
                // the part structure has been changed again while loading (retried one)
                // because this could an infinite loop, this will not load another one again
                $log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
                  'while loading translations. You should consider using promises of $translate.use(lang) and ' +
                  '$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
                  'if possible.');
              }
            }
            var table = {};
            prioritizedParts = getPrioritizedParts();
            angular.forEach(prioritizedParts, function (part) {
              deepExtend(table, part.tables[options.key]);
            });
            return table;
          }, function () {
            dirtyCheckEventCloser();
            return $q.reject(options.key);
          });
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#addPart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Registers a new part of the translation table. This method does not actually perform any xhr
       * requests to get translation data. The new parts will be loaded in order of priority from the server next time
       * `angular-translate` asks the loader to load translations.
       *
       * @param {string} name A name of the part to add
       * @param {int} [priority=0] Sets the load priority of this part.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case the new part affected somehow on the loaders
       * state. This way it means that there are a new translation data available to be loaded from
       * the server.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.addPart = function (name, priority, urlTemplate) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t add part, first arg has to be a string');
        }

        if (!hasPart(name)) {
          parts[name] = new Part(name, priority, urlTemplate);
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        } else if (!parts[name].isActive) {
          parts[name].isActive = true;
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#deletePart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Deletes the previously added part of the translation data. The target part could be deleted
       * either logically or physically. When the data is deleted logically it is not actually deleted
       * from the browser, but the loader marks it as not active and prevents it from affecting on the
       * translations. If the deleted in such way part is added again, the loader will use the
       * previously loaded data rather than loading it from the server once more time. But if the data
       * is deleted physically, the loader will completely remove all information about it. So in case
       * of recycling this part will be loaded from the server again.
       *
       * @param {string} name A name of the part to delete
       * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
       * translation data physically. If the `removeData` if set to **false** the loaded data will not be
       * deleted physically and might be reused in the future to prevent an additional xhr requests.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case a part deletion process affects somehow on the
       * loaders state. This way it means that some part of the translation data is now deprecated and
       * the translation table has to be recompiled with the remaining translation parts.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
       * wrong type. Please, note that the `name` param has to be a non-empty **string** and
       * the `removeData` param has to be either **undefined** or **boolean**.
       */
      service.deletePart = function (name, removeData) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t delete part, first arg has to be string');
        }

        if (removeData === undefined) {
          removeData = false;
        } else if (typeof removeData !== 'boolean') {
          throw new TypeError('Invalid type of a second argument, a boolean expected.');
        }

        if (hasPart(name)) {
          var wasActive = parts[name].isActive;
          if (removeData) {
            var $translate = $injector.get('$translate');
            var cache = $translate.loaderCache();
            if (typeof(cache) === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }
            // Purging items from cache...
            if (typeof(cache) === 'object') {
              angular.forEach(parts[name].tables, function (value, key) {
                cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
              });
            }
            delete parts[name];
          } else {
            parts[name].isActive = false;
          }
          if (wasActive) {
            $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
          }
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if the registered translation part is loaded into the translation table.
       *
       * @param {string} name A name of the part
       * @param {string} lang A key of the language
       *
       * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
       */
      service.isPartLoaded = function (name, lang) {
        return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Gets names of the parts that were added with the `addPart`.
       *
       * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
       */
      service.getRegisteredParts = function () {
        var registeredParts = [];
        angular.forEach(parts, function (p) {
          if (p.isActive) {
            registeredParts.push(p.name);
          }
        });
        return registeredParts;
      };


      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if a target translation part is available. The part becomes available just after it was
       * added by the `addPart` method. Part's availability does not mean that it was loaded from the
       * server, but only that it was added to the loader. The available part might be loaded next
       * time the loader is called.
       *
       * @param {string} name A name of the part to delete
       *
       * @returns {boolean} Returns **true** if the part is available now and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.isPartAvailable = isPartAvailable;

      return service;

    }];

}

$translatePartialLoader.displayName = '$translatePartialLoader';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-partial/angular-translate-loader-partial.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){function t(){"use strict";function a(t,e,r){this.name=t,this.isActive=!0,this.tables={},this.priority=e||0,this.langPromises={},this.urlTemplate=r}a.prototype.parseUrl=function(t,e){return angular.isFunction(t)?t(this.name,e):t.replace(/\{part\}/g,this.name).replace(/\{lang\}/g,e)},a.prototype.getTable=function(e,t,r,a,n,i){var o=this,s=this.langPromises[e],l=t.defer(),u=function(t){o.tables[e]=t,l.resolve(t)},c=function(){l.reject(o.name)},p=function(){r(angular.extend({method:"GET",url:o.parseUrl(o.urlTemplate||n,e)},a)).then(function(t){u(t.data)},function(t){i?i(o.name,e,t).then(u,c):c()})};return this.tables[e]?l.resolve(this.tables[e]):(s?s.then(l.resolve,p):p(),this.langPromises[e]=l.promise),l.promise};var n={};function i(t){return Object.prototype.hasOwnProperty.call(n,t)}function f(t){return angular.isString(t)&&""!==t}function t(t){if(!f(t))throw new TypeError("Invalid type of a first argument, a non-empty string expected.");return i(t)&&n[t].isActive}function d(){var t=[];for(var e in n)n[e].isActive&&t.push(n[e]);return t.sort(function(t,e){return t.priority-e.priority}),t}this.addPart=function(t,e,r){if(!f(t))throw new TypeError("Couldn't add part, part name has to be a string!");return i(t)||(n[t]=new a(t,e,r)),n[t].isActive=!0,this},this.setPart=function(t,e,r){if(!f(t))throw new TypeError("Couldn't set part.`lang` parameter has to be a string!");if(!f(e))throw new TypeError("Couldn't set part.`part` parameter has to be a string!");if("object"!=typeof r||null===r)throw new TypeError("Couldn't set part. `table` parameter has to be an object!");return i(e)||(n[e]=new a(e),n[e].isActive=!1),n[e].tables[t]=r,this},this.deletePart=function(t){if(!f(t))throw new TypeError("Couldn't delete part, first arg has to be string.");return i(t)&&(n[t].isActive=!1),this},this.isPartAvailable=t,this.$get=["$rootScope","$injector","$q","$http","$log",function(o,s,l,u,c){var p=function(r){if(!f(r.key))throw new TypeError("Unable to load data, a key is not a non-empty string.");if(!f(r.urlTemplate)&&!angular.isFunction(r.urlTemplate))throw new TypeError("Unable to load data, a urlTemplate is not a non-empty string or not a function.");var e=r.loadFailureHandler;if(void 0!==e){if(!angular.isString(e))throw new Error("Unable to load data, a loadFailureHandler is not a string.");e=s.get(e)}var a=[],t=d();angular.forEach(t,function(t){a.push(t.getTable(r.key,l,u,r.$http,r.urlTemplate,e)),t.urlTemplate=t.urlTemplate||r.urlTemplate});var n=!1,i=o.$on("$translatePartialLoaderStructureChanged",function(){n=!0});return l.all(a).then(function(){if(i(),n){if(!r.__retries)return r.__retries=(r.__retries||0)+1,p(r);c.warn("The partial loader has detected a multiple structure change (with addPort/removePart) while loading translations. You should consider using promises of $translate.use(lang) and $translate.refresh(). Also parts should be added/removed right before an explicit refresh if possible.")}var e={};return t=d(),angular.forEach(t,function(t){!function t(e,r){for(var a in r)r[a]&&r[a].constructor&&r[a].constructor===Object?(e[a]=e[a]||{},t(e[a],r[a])):e[a]=r[a];return e}(e,t.tables[r.key])}),e},function(){return i(),l.reject(r.key)})};return p.addPart=function(t,e,r){if(!f(t))throw new TypeError("Couldn't add part, first arg has to be a string");return i(t)?n[t].isActive||(n[t].isActive=!0,o.$emit("$translatePartialLoaderStructureChanged",t)):(n[t]=new a(t,e,r),o.$emit("$translatePartialLoaderStructureChanged",t)),p},p.deletePart=function(r,t){if(!f(r))throw new TypeError("Couldn't delete part, first arg has to be string");if(void 0===t)t=!1;else if("boolean"!=typeof t)throw new TypeError("Invalid type of a second argument, a boolean expected.");if(i(r)){var e=n[r].isActive;if(t){var a=s.get("$translate").loaderCache();"string"==typeof a&&(a=s.get(a)),"object"==typeof a&&angular.forEach(n[r].tables,function(t,e){a.remove(n[r].parseUrl(n[r].urlTemplate,e))}),delete n[r]}else n[r].isActive=!1;e&&o.$emit("$translatePartialLoaderStructureChanged",r)}return p},p.isPartLoaded=function(t,e){return angular.isDefined(n[t])&&angular.isDefined(n[t].tables[e])},p.getRegisteredParts=function(){var e=[];return angular.forEach(n,function(t){t.isActive&&e.push(t.name)}),e},p.isPartAvailable=t,p}]}return angular.module("pascalprecht.translate").provider("$translatePartialLoader",t),t.displayName="$translatePartialLoader","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(e,i){"function"==typeof define&&define.amd?define([],function(){return i()}):"object"==typeof module&&module.exports?module.exports=i():i()}(0,function(){function e(n,a){"use strict";return function(r){if(!(r&&(angular.isArray(r.files)||angular.isString(r.prefix)&&angular.isString(r.suffix))))throw new Error("Couldn't load static files, no files and prefix or suffix specified!");r.files||(r.files=[{prefix:r.prefix,suffix:r.suffix}]);for(var e=function(e){if(!e||!angular.isString(e.prefix)||!angular.isString(e.suffix))throw new Error("Couldn't load static file, no prefix or suffix specified!");var i=[e.prefix,r.key,e.suffix].join("");return angular.isObject(r.fileMap)&&r.fileMap[i]&&(i=r.fileMap[i]),a(angular.extend({url:i,method:"GET"},r.$http)).then(function(e){return e.data},function(){return n.reject(r.key)})},i=[],t=r.files.length,f=0;f<t;f++)i.push(e({prefix:r.files[f].prefix,key:r.key,suffix:r.files[f].suffix}));return n.all(i).then(function(e){for(var i=e.length,r={},t=0;t<i;t++)for(var f in e[t])r[f]=e[t][f];return r})}}return e.$inject=["$q","$http"],angular.module("pascalprecht.translate").factory("$translateStaticFilesLoader",e),e.displayName="$translateStaticFilesLoader","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-url/angular-translate-loader-url.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateUrlLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateUrlLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical dynamic url pattern:
 * "locale.php?lang=en_US", "locale.php?lang=de_DE", "locale.php?language=nl_NL" etc.
 * Prefixing the specified url, the current requested, language id will be applied
 * with "?{queryParameter}={key}".
 * Using this service, the response of these urls must be an object of
 * key-value pairs.
 *
 * @param {object} options Options object, which gets the url, key and
 * optional queryParameter ('lang' is used by default).
 */
.factory('$translateUrlLoader', $translateUrlLoader);

function $translateUrlLoader($q, $http) {

return function (options) {

    if (!options || !options.url) {
      throw new Error('Couldn\'t use urlLoader since no url is given!');
    }

    var requestParams = {};

    requestParams[options.queryParameter || 'lang'] = options.key;

    return $http(angular.extend({
      url: options.url,
      params: requestParams,
      method: 'GET'
    }, options.$http))
      .then(function(result) {
        return result.data;
      }, function () {
        return $q.reject(options.key);
      });
  };
}

$translateUrlLoader.displayName = '$translateUrlLoader';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-loader-url/angular-translate-loader-url.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(e,t){"function"==typeof define&&define.amd?define([],function(){return t()}):"object"==typeof module&&module.exports?module.exports=t():t()}(0,function(){function e(r,n){"use strict";return function(e){if(!e||!e.url)throw new Error("Couldn't use urlLoader since no url is given!");var t={};return t[e.queryParameter||"lang"]=e.key,n(angular.extend({url:e.url,params:t,method:"GET"},e.$http)).then(function(e){return e.data},function(){return r.reject(e.key)})}}return e.$inject=["$q","$http"],angular.module("pascalprecht.translate").factory("$translateUrlLoader",e),e.displayName="$translateUrlLoader","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-storage-cookie/angular-translate-storage-cookie.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateCookieStorageFactory.$inject = ['$injector'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateCookieStorage
 * @requires $cookieStore
 *
 * @description
 * Abstraction layer for cookieStore. This service is used when telling angular-translate
 * to use cookieStore as storage.
 *
 */
  .factory('$translateCookieStorage', $translateCookieStorageFactory);

function $translateCookieStorageFactory($injector) {

// Since AngularJS 1.4, $cookieStore is deprecated
  var delegate;
  if (angular.version.major === 1 && angular.version.minor >= 4) {
    var $cookies = $injector.get('$cookies');
    delegate = {
      get : function (key) {
        return $cookies.get(key);
      },
      put : function (key, value) {
        $cookies.put(key, value, { samesite: 'lax' });
      }
    };
  } else {
    var $cookieStore = $injector.get('$cookieStore');
    delegate = {
      get : function (key) {
        return $cookieStore.get(key);
      },
      put : function (key, value) {
        $cookieStore.put(key, value);
      }
    };
  }

  var $translateCookieStorage = {

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#get
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Returns an item from cookieStorage by given name.
     *
     * @param {string} name Item name
     * @return {string} Value of item name
     */
    get : function (name) {
      return delegate.get(name);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#set
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @deprecated use #put
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    set : function (name, value) {
      delegate.put(name, value);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#put
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    put : function (name, value) {
      delegate.put(name, value);
    }
  };

  return $translateCookieStorage;
}

$translateCookieStorageFactory.displayName = '$translateCookieStorage';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-storage-cookie/angular-translate-storage-cookie.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){function t(t){"use strict";var n;if(1===angular.version.major&&4<=angular.version.minor){var o=t.get("$cookies");n={get:function(t){return o.get(t)},put:function(t,e){o.put(t,e,{samesite:"lax"})}}}else{var r=t.get("$cookieStore");n={get:function(t){return r.get(t)},put:function(t,e){r.put(t,e)}}}return{get:function(t){return n.get(t)},set:function(t,e){n.put(t,e)},put:function(t,e){n.put(t,e)}}}return t.$inject=["$injector"],angular.module("pascalprecht.translate").factory("$translateCookieStorage",t),t.displayName="$translateCookieStorage","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-storage-local/angular-translate-storage-local.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateLocalStorageFactory.$inject = ['$window', '$translateCookieStorage'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateLocalStorage
 * @requires $window
 * @requires $translateCookieStorage
 *
 * @description
 * Abstraction layer for localStorage. This service is used when telling angular-translate
 * to use localStorage as storage.
 *
 */
.factory('$translateLocalStorage', $translateLocalStorageFactory);

function $translateLocalStorageFactory($window, $translateCookieStorage) {

// Setup adapter
  var localStorageAdapter = (function(){
    var langKey;
    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#get
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Returns an item from localStorage by given name.
       *
       * @param {string} name Item name
       * @return {string} Value of item name
       */
      get: function (name) {
        if(!langKey) {
          langKey = $window.localStorage.getItem(name);
        }

        return langKey;
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#set
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @deprecated use #put
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      set: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#put
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      put: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      }
    };
  }());

  var hasLocalStorageSupport = 'localStorage' in $window;
  if (hasLocalStorageSupport) {
    var testKey = 'pascalprecht.translate.storageTest';
    try {
      // this check have to be wrapped within a try/catch because on
      // a SecurityError: Dom Exception 18 on iOS
      if ($window.localStorage !== null) {
        $window.localStorage.setItem(testKey, 'foo');
        $window.localStorage.removeItem(testKey);
        hasLocalStorageSupport = true;
      } else {
        hasLocalStorageSupport = false;
      }
    } catch (e){
      hasLocalStorageSupport = false;
    }
  }
  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
  return $translateLocalStorage;
}

$translateLocalStorageFactory.displayName = '$translateLocalStorageFactory';
return 'pascalprecht.translate';

}));
;

// Source: ../shared/public_html/assets/js/angular-translate/dist/angular-translate-storage-local/angular-translate-storage-local.min.js
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){function t(a,t){"use strict";var o,e={get:function(t){return o||(o=a.localStorage.getItem(t)),o},set:function(t,e){o=e,a.localStorage.setItem(t,e)},put:function(t,e){o=e,a.localStorage.setItem(t,e)}},r="localStorage"in a;if(r){var n="pascalprecht.translate.storageTest";try{r=null!==a.localStorage&&(a.localStorage.setItem(n,"foo"),a.localStorage.removeItem(n),!0)}catch(t){r=!1}}return r?e:t}return t.$inject=["$window","$translateCookieStorage"],angular.module("pascalprecht.translate").factory("$translateLocalStorage",t),t.displayName="$translateLocalStorageFactory","pascalprecht.translate"});;

// Source: ../shared/public_html/assets/js/auth/clients/UsersServiceClient.js
/* global angular: false */
(function (angular) {
var UsersServiceClient = function ($http, AppConfig) {
        const USERS_SERVICE_HOST = AppConfig.getUsersServiceHost();

        var endpoints = {
            login: {url: '/api/auth/login', method: 'POST'},
            logout: {url: USERS_SERVICE_HOST + '/v1/sessions/logout', method: 'GET'},
            register: {url: USERS_SERVICE_HOST + '/v1/users/register', method: 'POST'},
            resetPassword: {url: USERS_SERVICE_HOST + '/v1/users/password/reset', method: 'POST'},
            checkResetPasswordToken: {url: USERS_SERVICE_HOST + '/v1/users/password/token/check/', method: 'GET'},
            setNewPassword: {url: USERS_SERVICE_HOST + '/v1/users/password/new', method: 'POST'},
            acceptTAC: {url: USERS_SERVICE_HOST + '/v1/users/terms/accept', method: 'POST'},
            verifyEmail: {url: USERS_SERVICE_HOST + '/v1/users/confirm/resend', method: 'POST'},
            getSystemData: {url: USERS_SERVICE_HOST + '/v1/users/system', method: 'GET'}
        };

        this.getMeta = function () {
            return {
                market: {
                    code: AppConfig.getMarket(),
                    language: AppConfig.getLanguageCode()
                }
            };
        };

        this.send = function (request, data, token) {
            if (data !== null) {
                request.data = data;
            }

            if (token !== null) {
                request.headers = {
                    'Authorization': 'Bearer ' + token
                };
            }

            return $http(request);
        };

        this.login = function (email, password, validMinutes) {
            var data = {
                email: email,
                password: password,
                valid_minutes: validMinutes
            };

            return this.send(endpoints.login, data, null);
        };

        this.logout = function (token) {
            return this.send(endpoints.logout, null, token);
        };

        this.register = function (email, password, termsAndConditions, newsletter) {
            var data = {
                email: email,
                password: password,
                terms_and_conditions: termsAndConditions,
                newsletter: newsletter,
                meta: this.getMeta()
            };

            return this.send(endpoints.register, data, null);
        };

        this.resetPassword = function (email) {
            var data = {
                email: email,
                meta: this.getMeta()
            };

            return this.send(endpoints.resetPassword, data, null);
        };

        this.checkResetPasswordToken = function (resetPasswordToken) {
            var endpoint = JSON.parse(JSON.stringify(endpoints.checkResetPasswordToken));
            endpoint.url = endpoint.url + resetPasswordToken;

            return this.send(endpoint, null, null);
        };

        this.setNewPassword = function (token, password) {
            var data = {
                reset_password_token: token,
                new_password: password
            };

            return this.send(endpoints.setNewPassword, data, null);
        };

        this.acceptTermsAndConditions = function (token) {
            return this.send(endpoints.acceptTAC, {}, token);
        };

        this.verifyEmail = function (email, token) {
            var data = {
                email: email,
                meta: this.getMeta()
            };

            return this.send(endpoints.verifyEmail, data, token);
        };

        this.getSystemData = function (token) {
            return this.send(endpoints.getSystemData, {}, token);
        };
    };

    UsersServiceClient.$inject = ['$http', 'appConfig'];

    angular
        .module('auth')
        .service('UsersServiceClient', UsersServiceClient);
}(angular));
;

// Source: ../shared/public_html/assets/js/auth/services/AuthGuard.js
(function (angular) {
var IthAuthGuardService = function (JwtTokenService, UserSessionData) {
        this.redirectToMainPage = function () {
            if (!this.userIsOnMainPage()) {
                window.location = location.protocol + '//' + location.host;
            }
        };

        this.userIsOnMainPage = function () {
            return window.location.href === (location.protocol + '//' + location.host) ||
                window.location.href === (location.protocol + '//' + location.host + '/');
        };

        this.checkAuth = function () {
            if (JwtTokenService.getAuthJwtToken() === null) {
                UserSessionData.clearData();
                this.redirectToMainPage();
                return false;
            }

            return true;
        };

        this.isSessionExpired = function (statusCode) {
            return statusCode === 429;
        };
    };

    IthAuthGuardService.$inject = ['JwtTokenService', 'UserSessionData'];

    angular
        .module('auth')
        .service('AuthGuard', IthAuthGuardService);

}(angular));
;

// Source: ../shared/public_html/assets/js/auth/services/AuthService.js
(function (angular) {
/**
     * @name IthAuthService
     *
     * @description Authentication Service
     */
    var IthAuthService = function (ApiTools, $rootScope, $modal) {
function authParser(response) {
            return response;
        }

        var endpoints = {
            login: { url: '/profile/login', method: 'POST', respParser: authParser },
            logout: { url: '/profile/logout', method: 'POST', respParser: authParser },
            regenerateToken: { url: '/profile/regenerate_token', method: 'POST', respParser: authParser },
            setPassword: { url: '/profile/set_password', method: 'POST', respParser: authParser },
            sessionRestore: { url: '/login/login', method: 'POST', respParser: authParser },
            validateToken: { url: '/profile/validateToken', method: 'POST', respParser: authParser },
            facebookConnect: { url: '/profile/facebookConnect', method: 'POST', respParser: authParser }
        };

        var authData = {
            login: '',
            token: '',
            loggedIn: false,
            hasPassword: false,
            expire: '',
            fbAvatars: false,
            email: false,
            personal: false,
            phone: false
        };

        /**
         * Storage Key in web storage
         *
         * @type {String}
         */
        var error = 0;

        /**
         * Login Function
         *
         * @param {Object} data for e.x { email:xxx, pass:xxx}
         * @return {Promise}
         */
        this.login = function (data) {
            var self = this;

            return ApiTools.fetch(this, endpoints.login, {
                username: data.email,
                remember_me: data.keep,
                password: data.pass
            }).then(function (response) {
                self.setAuthData(response.response, 0);
                return response;
            });
        };

        this.modalLogin = function () {
            $modal.open({
                templateUrl: 'loginModal.html',
                controller: 'userModalCtrl',
                windowClass: 'loginModal enabled-window-back-btn'
            });
        };

        /**
         * Set Auth Data
         *
         * @param response
         * @param json
         */
        this.setAuthData = function (response, json) {
            if (json && response) {
                response = JSON.parse(response);
            }

            if (response && response.login) {
                authData = {
                    login: response.login,
                    token: false,
                    loggedIn: 1,
                    expire: false,
                    hasPassword: response.hasPassword,
                    passwordChangeWarning: response.passwordChangeWarning,
                    isAgent: response.isAgent,
                    fbAvatars: (response.fbAvatars ? response.fbAvatars : false),
                    newsletterToken: response.newsletterToken,
                    email: response.email,
                    personal: response.personal,
                    phone: response.phone
                };

                $rootScope.auth = authData;
                $rootScope.auth.error = 0;
                $rootScope.$emit('userLogged', true);

                return true;
            }

            if (!$rootScope.auth) {
                $rootScope.auth = {};
                $rootScope.auth.error = 1;
            }

            return false;
        };

        this.checkIsLoggedIn = function () {
            return $rootScope.auth && $rootScope.auth.loggedIn;
        };

        this.isAgent = function () {
            return this.checkIsLoggedIn() && $rootScope.auth.isAgent === true;
        };

        /**
         * loginError
         * @returns {Number}
         */
        this.loginError = function () {
            return error;
        };

        /**
         * Logout function
         */
        this.logout = function () {
            authData = {
                login: '',
                token: '',
                loggedIn: false,
                expire: '',
                fbAvatars: false,
                newsletterToken: false,
                email: false,
                personal: false,
                phone: false
            };

            $rootScope.auth = authData;
            $rootScope.$emit('userLoggedOut', true);
            $rootScope.lastSearches = [];
            return ApiTools.fetch(this, endpoints.logout, {});
        };

        /**
         * Regenerate token by pressing password.
         *
         * @param data
         * @returns {Promise}
         */
        this.regenerateToken = function (data) {
            var self = this;
            return ApiTools.fetch(this, endpoints.regenerateToken, data).then(function (response) {
                self.setAuthData(response.userObj, 0);
                return response;
            });
        };

        /**
         * Set new password.
         *
         * @param data
         * @returns {Promise}
         */
        this.setPassword = function (data) {
            var self = this;

            return ApiTools.fetch(this, endpoints.setPassword, data).then(function (response) {
                self.setAuthData(response.userObj, 0);
                return response;
            });
        };

        /**
         * Method displaying modal window with login form
         * @returns {modalInstance}
         */
        this.showLoginModal = function () {
            return $modal.open({
                templateUrl: 'loginModal.html',
                controller: 'userModalCtrl',
                size: 'md'
            });
        };

        /**
         * Method displaying modal window with register form
         * @returns {modalInstance}
         */
        this.showRegisterModal = function () {
            return $modal.open({
                templateUrl: 'registerModal.html',
                controller: 'userModalCtrl',
                size: 'md',
                backdrop: 'static'
            });
        };

        /**
         * Method displaying modal window with forgot password form
         * @returns {modalInstance}
         */
        this.showForgotPasswordModal = function () {
            return $modal.open({
                templateUrl: 'forgotPassModal.html',
                controller: 'userModalCtrl',
                size: 'md',
                backdrop: 'static'
            });
        };
    };

    IthAuthService.$inject = ['ApiTools', '$rootScope', '$modal'];

    angular
        .module('auth')
        .service('AuthService', IthAuthService);

}(angular));
;

// Source: ../shared/public_html/assets/js/auth/services/AuthService2.js
(function (angular) {
var IthAuthService2 = function (UsersServiceClient, $rootScope, API_STATUSES_USERS, JwtTokenService, AuthGuard, UserSessionData, AppConfig) {
        const SESSION_VALID_MINUTES = 60;
        const USERS_SERVICE_HOST = AppConfig.getUsersServiceHost();

        this.login = function (data) {
            var responseObj = {
                status: API_STATUSES_USERS.UNEXPECTED_ERROR,
                passwordChangeWarning: false
            };

            return UsersServiceClient.login(data.email, data.pass, SESSION_VALID_MINUTES)
                .then(function (response) {
                    var token = response.data.token;

                    return UsersServiceClient
                        .getSystemData(token)
                        .then(function (systemData) {
                            JwtTokenService.setAuthJwtToken(token);
                            UserSessionData.setData(JwtTokenService.getDataFromAuthJwtToken(), systemData.data);
                            responseObj.status = API_STATUSES_USERS.OK;
                            responseObj.passwordChangeWarning = response.data.password_change_warning;
                            $rootScope.$emit('userLogged', true);

                            return responseObj;
                        })
                        .catch(function () {
                            return responseObj;
                        })
                })
                .catch(function (response) {
                    if (response.status === 404) {
                        responseObj.status = API_STATUSES_USERS.INCORRECT_CREDENTIALS;
                        return responseObj;
                    }

                    if (response.status === 422) {
                        responseObj.status = API_STATUSES_USERS.NOT_ACTIVATED;
                        return responseObj;
                    }

                    if (response.status === 423) {
                        responseObj.status = API_STATUSES_USERS.ACCOUNT_BLOCKED;
                        return responseObj;
                    }

                    return responseObj;
                });
        };

        this.logout = function () {
            if (!AuthGuard.checkAuth()) {
                return API_STATUSES_USERS.SESSION_EXPIRED;
            }

            var token = JwtTokenService.getAuthJwtToken();

            return UsersServiceClient.logout(token)
                .then(function () {
                    JwtTokenService.setAuthJwtToken(null);
                    UserSessionData.clearData();
                    AuthGuard.redirectToMainPage();
                }).catch(function (response) {
                    if (AuthGuard.isSessionExpired(response.status)) {
                        return AuthGuard.redirectToMainPage();
                    }

                    return API_STATUSES_USERS.UNEXPECTED_ERROR;
                });
        };

        this.register = function (email, password, termsAndConditions, newsletter) {
            return UsersServiceClient.register(email, password, termsAndConditions, newsletter)
                .then(function () {
                    return API_STATUSES_USERS.OK;
                }).catch(function (response) {
                    if (response.status === 422) {
                        return API_STATUSES_USERS.USER_EXISTS;
                    }

                    return API_STATUSES_USERS.UNEXPECTED_ERROR;
                });
        };

        this.resetPassword = function (email) {
            return UsersServiceClient.resetPassword(email)
                .then(function () {
                    return API_STATUSES_USERS.OK;
                }).catch(function (response) {
                    if (response.status === 404) {
                        return API_STATUSES_USERS.USER_NOT_EXISTS;
                    }

                    return API_STATUSES_USERS.UNEXPECTED_ERROR;
                });
        };

        this.checkResetPasswordToken = function (resetPasswordToken) {
            return UsersServiceClient.checkResetPasswordToken(resetPasswordToken)
                .then(function () {
                    return API_STATUSES_USERS.OK;
                }).catch(function (response) {

                    if (response.status === 409) {
                        return API_STATUSES_USERS.PASSWORD_ALREADY_CHANGED;
                    }

                    if (response.status === 422) {
                        return API_STATUSES_USERS.TOKEN_EXPIRED;
                    }

                    if (response.status === 404) {
                        return API_STATUSES_USERS.TOKEN_NOT_FOUND;
                    }

                    return API_STATUSES_USERS.UNEXPECTED_ERROR;
                });
        };

        this.setNewPassword = function (resetPasswordToken, newPassword) {
            return UsersServiceClient.setNewPassword(resetPasswordToken, newPassword)
                .then(function () {
                    return API_STATUSES_USERS.OK;
                }).catch(function (response) {
                    if (response.status === 409) {
                        return API_STATUSES_USERS.PASSWORD_ALREADY_CHANGED;
                    }

                    if (response.status === 422) {
                        return API_STATUSES_USERS.TOKEN_EXPIRED;
                    }

                    if (response.status === 404) {
                        return API_STATUSES_USERS.TOKEN_NOT_FOUND;
                    }

                    return API_STATUSES_USERS.UNEXPECTED_ERROR;
                });
        };

        /**
         * @param {'facebook' | 'google' | 'apple'} provider
         */
        this.redirectToSocialLoginUrl = function (provider) {
            var url = new URL(USERS_SERVICE_HOST + '/auth/' + provider);

            url.searchParams.set('language', AppConfig.getLanguageCode());
            url.searchParams.set('market', AppConfig.getMarket());

            window.location = url.href;
        };
    };

    IthAuthService2.$inject = ['UsersServiceClient', '$rootScope', 'API_STATUSES_USERS', 'JwtTokenService', 'AuthGuard', 'UserSessionData', 'appConfig'];

    angular
        .module('auth')
        .service('AuthService2', IthAuthService2);

}(angular));
;

// Source: ../shared/public_html/assets/js/auth/services/JwtTokenService.js
(function (angular) {
var IthJwtTokenService = function (Cookies, AppConfig) {
        this.getAuthJwtToken = function () {
            return AppConfig.getAuthToken();
        };

        this.setAuthJwtToken = function (token) {
              AppConfig.setAuthToken(token);
        };

        this.getDataFromAuthJwtToken = function () {
            var token = this.getAuthJwtToken();

            if (token === undefined || token === null) {
                return null;
            }

            var base64Data = token.split('.')[1];
            return parseJwt(base64Data);
        };

        var parseJwt = function (base64Data) {
            var base64 = base64Data.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        };
    };

    IthJwtTokenService.$inject = ['$cookies', 'appConfig'];

    angular
        .module('auth')
        .service('JwtTokenService', IthJwtTokenService);

}(angular));
;

// Source: ../shared/public_html/assets/js/auth/services/UserSessionData.js
(function(angular) {
var UserSessionData = function () {
        this.data = {
            token: null,
            tokenExpired: null,
            email: null,
            firstName: null,
            isTermsAndConditionsAccepted: null,
            language: null
        };

        this.setData = function (token, systemData) {
            this.data.token = token.token;
            this.data.tokenExpired = token.token_expired;
            this.data.email = systemData.email;
            this.data.firstName = systemData.first_name;
            this.data.isTermsAndConditionsAccepted = Boolean(systemData.acceptance_terms_date);
            this.data.language = systemData.language;
        };

        this.setFirstName = function (firstName) {
            this.data.firstName = firstName;
        }

        this.getEmail = function () {
            return this.data.email;
        };

        this.getFirstName = function () {
            return this.data.firstName;
        };

        this.getLanguage = function () {
            return this.data.language;
        };

        this.setLanguage = function (language) {
            this.data.language = language;
        };

        this.isTermsAndConditionsAccepted = function () {
            return this.data.isTermsAndConditionsAccepted;
        };

        this.isLogged = function () {
            return (this.data.token !== null && this.data.tokenExpired !== null);
        };

        this.clearData = function () {
            this.data = {
                token: null,
                tokenExpired: null,
                email: null,
                firstName: null,
                isTermsAndConditionsAccepted: null,
                language: null
            };
        };
    };

    UserSessionData.$inject = [];

    angular
        .module('auth')
        .service('UserSessionData', UserSessionData);

}(angular));
;

// Source: ../shared/public_html/assets/js/automated-checkin/automated-checkin.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        var templateName = 'fd-box';

        if ($attrs.zone === 'ty') {
            templateName = 'ty-box';
        }

        return '/tpl/show/jsShared/templates/flights/automated-checkin/' + templateName;
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    var IthAutomatedCheckinComponent = {
        templateUrl: templateUrl,
        bindings: {
            booking: '<',
            zone: '@'
        },
        controller: 'AutomatedCheckinController'
    };

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .component('ithAutomatedCheckin', IthAutomatedCheckinComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/automated-checkin/automated-checkin.controller.js
(function(angular, underscore) {
var IthAutomatedCheckinController = function (Dictionaries, AutomatedCheckinHelper) {
        /**
         * Self reference
         *
         * @type {IthAutomatedCheckinController}
         */
        var self = this;

        /**
         * Checks if this component should be visible
         *
         * @returns {Boolean}
         */
        this.isVisible = function () {
            return AutomatedCheckinHelper.isCheckinAvailable(this.booking);
        };

        this.toggle = function () {
            if (this.booking.paidCheckin.isSelected()) {
                this.booking.paidCheckin.toggle(false);
                return;
            }

            this.booking.paidCheckin.toggle(true);
        };

        /**
         * Checks if flights have free checkin
         *
         * @returns {Boolean}
         */
        this.hasFreeCheckin = function () {
            return this.booking.paidCheckinRules.hasFreeCheckin;
        };

        /**
         * Checks if flights have paid checkin
         *
         * @returns {Boolean}
         */
        this.hasPaidCheckin = function () {
            return this.booking.paidCheckinRules.hasPaidCheckin;
        };

        /**
         * Checks if user has bought check-in
         */
        this.userHasBoughtCheckin = function () {
            return (
                this.booking.paidCheckin.selected ||
                this.booking.ticketType.isCheckinIncluded()
            );
        };

        /**
         * Checks if airline checkin rules are available
         *
         * @returns {Boolean}
         */
        this.isLoading = function () {
            return this.booking.paidCheckinRules.checkinAirlineRules.length === 0;
        };

        /**
         * Determines if action pane should be visible
         *
         * @returns {Boolean}
         */
        this.showActionPane = function () {
            return !this.isLoading() && this.hasPaidCheckin();
        };

        /**
         * Determines if attention box should be visible
         *
         * @returns {Boolean}
         */
        this.showAttentionBox = function () {
            return (
                this.booking.paidCheckinRules.airportPaidRules.length > 0 ||
                this.booking.paidCheckinRules.onlyAirportMandatoryRules.length > 0
            );
        };

        /**
         * Determines if attention box should be visible
         *
         * @returns {Boolean}
         */
        this.hasOnlyAirportRule = function () {
            return this.booking.paidCheckinRules.onlyAirportMandatoryRules.length > 0;
        };

        /**
         * Maps carrier code from rule to carrier name from dictionary
         *
         * @param {Object[]} rules
         * @returns {String[]}
         */
        this.translateCarrierArray = function (rules) {
            return underscore.map(rules, function (rule) {
                return self.translateCarrier(rule.airline);
            });
        };

        /**
         * Returns attention message count
         *
         * @returns {Number}
         */
        this.getAttentionMessageCount = function () {
            return this.booking.paidCheckinRules.airportPaidRules.length + this.booking.paidCheckinRules.onlyAirportMandatoryRules.length;
        };

        /**
         * Returns carrier name by code
         *
         * @param {String} carrierCode
         * @returns {String}
         */
        this.translateCarrier = function (carrierCode) {
            return Dictionaries.getCarrierNameByCode(carrierCode);
        };

        /**
         * Returns city name by airport code
         *
         * @param {String} airportCode
         * @returns {String}
         */
        this.translateCity = function (airportCode) {
            return Dictionaries.getCityNameByAirportCode(airportCode, false);
        };

        /**
         * Data for modal
         *
         * @type {Object}
         */
        this.modalData = {
            rules: this.booking.paidCheckinRules,
            translateCarrierArray: function (array) {
                return self.translateCarrierArray(array);
            }
        };
    };

    IthAutomatedCheckinController.$inject = [
        'Dictionaries',
        'AutomatedCheckinHelper'
    ];

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .controller('AutomatedCheckinController', IthAutomatedCheckinController);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/automated-checkin/automated-checkin.helper.js
(function (angular, underscore) {
var IthAutomatedCheckinHelper = function (CheckinAirlineRuleModel) {
        /**
         * Returns payload for check-in service rules endpoint
         *
         * @param {FlightDetails} flightDetails
         * @returns {Object}
         */
        this.getRulesPayload = function (flightDetails) {
            var airlines = {};
            aggregateLeg(flightDetails.getDepLeg(), airlines);

            if (!flightDetails.isOneWay()) {
                aggregateLeg(flightDetails.getRetLeg(), airlines);
            }

            var result = [];

            angular.forEach(Object.keys(airlines), function (airlineCode) {
                var entry = {};
                entry[airlineCode] = airlines[airlineCode];
                result.push(entry);
            });

            return result;
        };

        /**
         * Aggregates leg airlines
         *
         * @param {Leg} leg
         * @param {Object} airlines
         */
        var aggregateLeg = function (leg, airlines) {
            angular.forEach(leg.getSegments(), function (segment) {
                if (!airlines.hasOwnProperty(segment.getCarrier())) {
                    airlines[segment.getCarrier()] = [];
                }

                airlines[segment.getCarrier()].push(segment.getDepAirportCode() + '-' + segment.getArrAirportCode());
            });
        };

        /**
         * Parse array of rules coming from API and return a list of models
         *
         * @param {Object[]}
         * @returns {CheckinAirlineRuleModel[]}
         */
        this.parseAirlineRules = function (rulesArray) {
            var modelArray = [];

            underscore.each(rulesArray, function (rule) {
                modelArray.push(new CheckinAirlineRuleModel(rule));
            });

            return modelArray;
        };

        /**
         * Checks if airline rules include free checkin
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {Boolean}
         */
        this.hasFreeCheckin = function (airlineRules) {
            return this.getOnlineFreeRules(airlineRules).length > 0;
        };

        /**
         * Checks if airline rules include free checkin
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {Boolean}
         */
        this.hasPaidCheckin = function (airlineRules) {
            return this.getOnlinePaidRules(airlineRules).length > 0;
        };

        /**
         * Returns list of rules that have paid airport checkin
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {CheckinAirlineRuleModel[]}
         */
        this.getAirportPaidRules = function (airlineRules) {
            return underscore.filter(airlineRules, function (rule) {
                return rule.paid_airport_check_in === true && rule.paid === true;
            });
        };

        /**
         * Returns list of rules that have free online checkin
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {CheckinAirlineRuleModel[]}
         */
        this.getOnlineFreeRules = function (airlineRules) {
            return underscore.filter(airlineRules, function (rule) {
                return rule.paid === false && underscore.contains(rule.online_check_in_allowed, true);
            });
        };

        /**
         * Returns list of rules that have paid online checkin
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {CheckinAirlineRuleModel[]}
         */
        this.getOnlinePaidRules = function (airlineRules) {
            return underscore.filter(airlineRules, function (rule) {
                return rule.paid === true;
            });
        };

        /**
         * Returns list of rules where airport check-in is mandatory
         *
         * @param {CheckinAirlineRuleModel[]} airlineRules
         * @returns {CheckinAirlineRuleModel[]}
         */
        this.getAirportMandatoryRules = function (airlineRules) {
            var airportMandatory = [];

            underscore.forEach(airlineRules, function (rule) {
                underscore.forEach(Object.keys(rule.online_check_in_allowed), function (route) {
                    if (rule.online_check_in_allowed[route] === false) {
                        var routeSplit = route.split('-');

                        airportMandatory.push({
                            hash: rule.airline + routeSplit[0] + routeSplit[1],
                            airlineCode: rule.airline,
                            fromCode: routeSplit[0],
                            toCode: routeSplit[1]
                        });
                    }
                });
            });

            return airportMandatory;
        };

        this.isCheckinAvailable = function (booking) {
            return (
                booking.paidCheckinRules.checkinAirlineRules.length > 0 &&
                booking.getFlightDetails().additionalServices.paidCheckin !== null &&
                booking.paidCheckinRules.onlyAirportMandatoryRules.length < booking.getFlightDetails().getSegmentCount()
            );
        };
    };

    IthAutomatedCheckinHelper.$inject = [
        'CheckinAirlineRuleModel'
    ];

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .service('AutomatedCheckinHelper', IthAutomatedCheckinHelper);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/automated-checkin/checkin-airline-rule.model.js
(function(angular) {
var IthCheckinAirlineRuleModel = function () {
        /**
         * @constructor
         * @param {Object} airlineRuleData
         */
        var CheckinAirlineRule = function (airlineRuleData) {
            this.airline = airlineRuleData.airline;
            this.mandatory = airlineRuleData.mandatory;
            this.paid = airlineRuleData.paid;
            this.paid_airport_check_in = airlineRuleData.paid_airport_check_in;
            this.online_check_in_allowed = airlineRuleData.online_check_in_allowed;
        };

        CheckinAirlineRule.prototype.constructor = CheckinAirlineRule;

        return CheckinAirlineRule;
    };

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .factory('CheckinAirlineRuleModel', IthCheckinAirlineRuleModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/automated-checkin/checkin-service.api.js
(function(angular) {
/**
     * Service that makes requests to the checkin service endpoints
     */
    var IthCheckinServiceApi = function ($http, AppConfig) {
        /**
         * Returns airline rules based on airline code array
         *
         * @param {String[]} airlineCodeArray
         * @returns {Promise}
         */
        this.getAirlineRules = function (airlineCodeArray) {
            return $http({
                method: 'POST',
                url: AppConfig.getCheckinServiceConfig().serviceUrl + '/v3/public/airline-rules',
                data: { airlines: airlineCodeArray },
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json'
                }
            });
        };
    };

    IthCheckinServiceApi.$inject = [
        '$http',
        'appConfig'
    ];

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .service('CheckinApi', IthCheckinServiceApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/automated-checkin/ith-frola-checkin-logo.component.js
(function (angular) {
var IthFrolaCheckinLogoComponent = {
        template: '<ith-product-logo image-name="check-in" show-affiliate-name="false" name="{{ \'LANGM_JS_CHECKIN_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.Flights.AutomatedCheckin')
        .component('ithFrolaCheckinLogo', IthFrolaCheckinLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/abTesting/ab-test-switcher.component.js
(function(angular) {
var IthAbTestSwitcherComponent = {
        template:
            '<div>' +
                '<div ng-if="$ctrl.isSlotActive($ctrl.slotA)" ng-transclude="featureA"></div>' +
                '<div ng-if="$ctrl.isSlotActive($ctrl.slotB)" ng-transclude="featureB"></div>' +
                '<div ng-if="$ctrl.isSlotActive($ctrl.slotC)" ng-transclude="featureC"></div>' +
            '</div>'
        ,
        controller: 'AbTestSwitcherController',
        transclude: {
            featureA: 'featureA',
            featureB: 'featureB',
            featureC: 'featureC'
        },
        bindings: {
            featureName: '@',
            slotA: '@',
            slotB: '@',
            slotC: '@',
            defaultSlot: '@'
        }
    };

    angular
        .module('ITH.Shared.AbTest')
        .component('ithAbTestSwitcher', IthAbTestSwitcherComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/abTesting/ab-test-switcher.controller.js
(function(angular) {
var IthAbTestSwitcherController = function (AppConfig) {
        /**
         * Controller self reference
         *
         * @type {IthAbTestSwitcherController}
         */
        var ctrl = this;

        /**
         * On init hook
         */
        this.$onInit = function () {
            if (!this.defaultSlot || ![this.slotA, this.slotB, this.slotC].includes(this.defaultSlot)) {
                // Make slot B the default one (in case no value is matched)
                this.defaultSlot = this.slotB;
            }
        };

        /**
         * Checks to see slot is active
         *
         * @param   {String} slotName
         * @returns {Bool}
         */
        this.isSlotActive = function (slotName) {
            return isMatchingSlot(slotName) || isDefaultSlot(slotName);
        };

        /**
         * Checks to see if A/B test value is matching slot name
         *
         * @param   {String} slotName
         * @returns {Bool}
         * @private
         */
        var isMatchingSlot = function (slotName) {
            return (
                AppConfig.getAbConfig().hasOwnProperty(ctrl.featureName) &&
                AppConfig.getAbConfig()[ctrl.featureName] === slotName
            );
        };

        /**
         * Checks to see if this slot is the default (fallback) slot
         *
         * @param   {String} slotName
         * @returns {Bool}
         * @private
         */
        var isDefaultSlot = function (slotName) {
            return (
                !isMatchingSlot(ctrl.slotA) &&
                !isMatchingSlot(ctrl.slotB) &&
                !isMatchingSlot(ctrl.slotC) &&
                ctrl.defaultSlot === slotName
            );
        };
    };

    IthAbTestSwitcherController.$inject = [
        'appConfig'
    ];

    angular
        .module('ITH.Shared.AbTest')
        .controller('AbTestSwitcherController', IthAbTestSwitcherController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-calendar-weekdays.component.js
(function(angular) {
/**
   * @name        IthCalendarWeekdays
   * @description Component that renders days of the week in a calendar view.
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthCalendarWeekdaysConfig = {
    bindings: {
      outside: '@'
    },
    templateUrl: '/tpl/show/jsShared/templates/base/calendar-component/ui-simple-calendar-weekdays',
    controller: 'IthCalendarWeekdaysController'
  };

  angular
    .module('ITH.Base.Calendar')
    .component('ithCalendarWeekdays', IthCalendarWeekdaysConfig);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-datepicker-legend.component.js
(function (angular) {

    angular.module('base').component('ithDatepickerLegend', {
        template: '<div class="datepicker-legend" translate>LANGM_JS_DATEPICKER_DIRECT_MARKER</div>'
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-double-calendar.component.js
(function(angular) {
/**
   * Template url for template overrides
   */
  var templateUrl = function ($attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/base/calendar-component/ui-double-calendar';
  };

  templateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        IthDoubleCalendarComponent
   * @description Component that renders two calendar components side by side
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthDoubleCalendarComponent = {
    bindings: {
      startDate: '=',
      endDate: '=?',
      tripLength: '=?',
      multipleSelect: '<?',
      price: '<?',
      priceStart: '<?',
      priceEnd: '<?',
      showWeekDays: '<?',
      rangeStart: '<?',
      rangeEnd: '<?',
      minDate: '<?',
      maxDate: '<?',
      rangeChange: '@',
      onInit: '&?',
      onMoveMonth: '&?',
      onCellClick: '&?',
      externalData: '<?'
    },
    controller: 'IthDoubleCalendarController',
    templateUrl: templateUrl
  };

  angular
    .module('ITH.Base.Calendar')
    .component('ithDoubleCalendar', IthDoubleCalendarComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-scroll-calendar.component.js
(function(angular) {
var IthScrollCalendarTemplateUrl = function ($attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/base/calendar-component/ui-scroll-calendar';
  };

  IthScrollCalendarTemplateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        IthScrollCalendarComponent
   * @description Component that renders a calendar with months one below another
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthScrollCalendarComponent = {
    bindings: {
      startDate: '=',
      endDate: '=?',
      tripLength: '=?',
      rangeStart: '<?',
      rangeEnd: '<?',
      minDate: '<?',
      maxDate: '<?',
      multipleSelect: '<?',
      oneWay: '<?',
      price: '<?',
      rangeChange: '@',
      onInit: '&?',
      onMoveMonth: '&?',
      onCellClick: '&?',
      externalData: '<?',
      selecting: '<',
      newDatePicker: '<'
    },
    templateUrl: IthScrollCalendarTemplateUrl,
    controller: 'IthScrollCalendarController'
  };

  angular
    .module('ITH.Base.Calendar')
    .component('ithScrollCalendar', IthScrollCalendarComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-simple-calendar.component.js
(function(angular) {
/**
   * Template url for template overrides
   */
  var IthSimpleCalendarTemplateUrl = function ($element, $attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/base/calendar-component/ui-simple-calendar';
  };

  IthSimpleCalendarTemplateUrl.$inject = [
    '$element',
    '$attrs'
  ];

  /**
   * @name        IthSimpleCalendarComponent
   * @description Component that renders a simple calendar
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthSimpleCalendarComponent = {
    bindings: {
      /**
       * Date for calendar init
       * @type {Date}
       */
      initDate: '<',

      /**
       * Selected calendar date
       * @type {Date}
       */
      selectedDate: '<',

      startDate: '<',
      endDate: '<',
      multipleSelect: '<',

      // TODO: refactor this (these should not be in this component)
      price: '<?',
      rangeChange: '@',

      /**
       * Show or hide week days
       * @type {Boolean}
       */
      showWeekDays: '<?',

      /**
       * Show left arrow button
       * @type {Boolean}
       */
      showLeftArrow: '<?',

      /**
       * Show right arrow
       * @type {Boolean}
       */
      showRightArrow: '<?',

      /**
       * Callback for left arrow click
       * @type {Function}
       */
      leftArrowClick: '&',

      /**
       * Callback for right arrow click
       * @type {Function}
       */
      rightArrowClick: '&',

      /**
       * Date when the displayed range starts
       * @type {String}
       */
      rangeStart: '<',

      /**
       * Date when the displayed range ends
       * @type {String}
       */
      rangeEnd: '<',

      minDate: '<',
      maxDate: '<',

      /**
       * Callback for cell click (optional)
       * @type {Function}
       */
      onCellClick: '&?',

      /**
       * Callback for cell hover (optional)
       * @type {String}
       */
      onCellHover: '&?',

      /**
       * Callback for when mouse leaves the calendar (optional)
       * @type {String}
       */
      onCalendarLeave: '&?',

      onCalendarUpdate: '&',

      externalData: '<?'
    },
    templateUrl: IthSimpleCalendarTemplateUrl,
    controller: 'IthSimpleCalendarController'
  };

  angular
    .module('ITH.Base.Calendar')
    .component('ithSimpleCalendar', IthSimpleCalendarComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/components/ith-single-calendar.component.js
(function(angular) {
var templateUrl = function ($attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/base/calendar-component/ui-single-calendar';
  };

  templateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        IthSingleCalendarComponent
   * @description Component that renders a simple calendar
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthSingleCalendarComponent = {
    bindings: {
      startDate: '=',
      endDate: '=?',
      multipleSelect: '<?',
      price: '<?',
      priceStart: '<?',
      priceEnd: '<?',
      showWeekDays: '<?',
      rangeStart: '<?',
      rangeEnd: '<?',
      minDate: '<?',
      maxDate: '<?',
      rangeChange: '@',
      onInit: '&?',
      onMoveMonth: '&?',
      onCellClick: '&?',
      externalData: '<?'
    },
    controller: 'IthSingleCalendarController',
    templateUrl: templateUrl
  };

  angular
    .module('ITH.Base.Calendar')
    .component('ithSingleCalendar', IthSingleCalendarComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/controllers/ith-calendar-weekdays.controller.js
(function(angular) {
/**
   * @name        IthCalendarWeekdaysController
   * @description Binds calendar week days to template.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthCalendarWeekdaysController = function () {
    this.$onInit = function () {
      // Sunday first weekdays (because we have outdated momentjs library)
      var weekdays = moment.weekdaysShort();
      var sun = weekdays.shift();
      weekdays.push(sun);

      // Set monday first weekdays
      this.weekDays = weekdays;
    };
  };

  angular
    .module('ITH.Base.Calendar')
    .controller('IthCalendarWeekdaysController', IthCalendarWeekdaysController);

}(angular));;

// Source: ../shared/public_html/assets/js/base/calendar/controllers/ith-double-calendar.controller.js
(function(angular) {
/**
   * @name        IthScrollCalendarController
   * @description Handles data inside the double calendars.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthDoubleCalendarController = function (CalendarHelper, TripLengthHelper) {
    /**
     * View model
     *
     * @type {Object}
     */
    var ctrl = this;

    /**
     * Default range start (cached value from init)
     *
     * @type {Date}
     */
    var _defRangeStart;

    /**
     * Default range end (cached value from init)
     *
     * @type {Date}
     */
    var _defRangeEnd;

    /**
     * Default min date (cached value from init)
     *
     * @type {Date}
     */
    var _prevMinDate;

    /**
     * Indicates which date user is selecting when multiple option is on
     * Possible values: start, end
     *
     * @type {String}
     */
    var _whichDate = 'start';

    /**
     * Method responsible for setting defaults for parameters
     */
    var _setDefaults = function () {
      ctrl.leftCalendarDate = CalendarHelper.getMinCalendarDate(ctrl.startDate, ctrl.minDate);
      ctrl.rightCalendarDate = CalendarHelper.getMinCalendarDate(ctrl.startDate, ctrl.minDate);

      // Add one month to the right calendar
      ctrl.rightCalendarDate.setMonth(ctrl.rightCalendarDate.getMonth() + 1);

      ctrl.multipleSelect = (ctrl.multipleSelect === null) ? false : !!ctrl.multipleSelect;
      ctrl.price = (ctrl.price === null) ? false : !!ctrl.price;

      if (ctrl.multipleSelect) {
        ctrl.rangeChange = 'start';
      }

      // Default range start and end
      _defRangeStart = ctrl.rangeStart;
      _defRangeEnd = ctrl.rangeEnd;
    };

    /**
     * Method called when start date is changed
     *
     * @param {Date} newValue A new value for start date
     */
    var _startDateChangeCallback = function (newValue) {
      // Set default range start
      _defRangeStart = newValue;
      _adjustReturnCalendarDate(newValue);
    };

    /**
     * Sets return calendar date the same as departure date
     *
     * @param {Date} newValue
     */
    var _adjustReturnCalendarDate = function (newValue) {
      if (ctrl.rangeChange === 'end' && newValue !== null && newValue instanceof Date) {
        _switchMonths(newValue);
      }
    };

    /**
     * Method called when end date is changed
     *
     * @param {Date} newValue A new value for end date
     */
    var _endDateChangeCallback = function (newValue) {
      // Set default range end
      _defRangeEnd = newValue;
    };

    /**
     * Switches left and right calendar dates
     *
     * @param {Date} newDate
     */
    var _switchMonths = function (newDate) {
      ctrl.leftCalendarDate = CalendarHelper.getMinCalendarDate(newDate, ctrl.minDate);
      ctrl.rightCalendarDate = CalendarHelper.getMinCalendarDate(newDate, ctrl.minDate);
      ctrl.rightCalendarDate.setMonth(ctrl.rightCalendarDate.getMonth() + 1);
    };

    /**
     * Updates start and end dates
     *
     * @param {CalendarCellModel} cell
     */
    var _updateDates = function (cell) {
      if (ctrl.multipleSelect) {
        if (_whichDate === 'start') {
          ctrl.startDate = cell.date;
          ctrl.endDate = null;
        } else if (_whichDate === 'end') {
          ctrl.endDate = cell.date;
        }
      } else {
        ctrl.startDate = cell.date;
      }

      // Set selected date
      // TODO: remember both dates?
      ctrl.selectedDate = cell.date;
    };

    /**
     * Updates start and end ranges
     *
     * @param {CalendarCellModel} cell
     */
    var _updateRange = function (cell) {
      if (ctrl.multipleSelect) {
        if (_whichDate === 'start') {
          ctrl.rangeStart = cell.date;
          _defRangeStart = cell.date;
          ctrl.rangeChange = 'end';
        } else if (_whichDate === 'end') {
          if (ctrl.price) {
            // For price calendar you can select different return dates after selecting departure
            ctrl.rangeChange = 'end';
          } else {
            ctrl.rangeChange = 'start';
          }

          ctrl.rangeStart = ctrl.startDate;
          ctrl.rangeEnd = cell.date;

          _defRangeStart = ctrl.startDate;
          _defRangeEnd = ctrl.endDate;
        }
      }

      // Adjust ranges
      if (ctrl.rangeChange === 'start') {
        ctrl.rangeStart = cell.date;
        _defRangeStart = cell.date;
      } else if (ctrl.rangeChange === 'end') {
        ctrl.rangeEnd = cell.date;
        _defRangeEnd = cell.date;
      }
    };

    /**
     * Updates min and max dates according to a selected cell
     *
     * @param {CalendarCellModel} cell
     */
    var _updateMinMaxDates = function (cell) {
      if (ctrl.multipleSelect && !ctrl.price) {
        if (_whichDate === 'start') {
          _prevMinDate = ctrl.minDate;
          ctrl.minDate = cell.date;
        } else if (_whichDate === 'end') {
          if (ctrl.price !== true) {
            ctrl.minDate = _prevMinDate;
          }
        }
      }
    };

    /**
     * Updates which date will be selected next (start or end) according to
     * private _whichDate variable
     */
    var _updateWhichDate = function () {
      if (ctrl.multipleSelect) {
        if (_whichDate === 'start') {
          // Prepare calendar to select end date
          _whichDate = 'end';
        } else if (_whichDate === 'end') {
          if (ctrl.price) {
            // For price calendar you can select different return dates after
            // selecting departure
            _whichDate = 'end';
          } else {
            // Normal datepicker resets to selecting a departure date after
            // selecting return
            _whichDate = 'start';
          }
        }
      } else {
        _whichDate = ctrl.rangeChange;
      }
    };

    /**
     * Updates trip length
     */
    var _updateTripLength = function () {
      ctrl.tripLength = TripLengthHelper.getLength(ctrl.rangeStart, ctrl.rangeEnd);
    };

    /**
     * Component init hook
     */
    ctrl.$onInit = function () {
      _setDefaults();

      if (ctrl.onInit !== undefined) {
        // Send new dates to outside
        ctrl.onInit({ value: [ctrl.leftCalendarDate, ctrl.rightCalendarDate] });
      }
    };

    /**
     * Component changes hook
     */
    ctrl.$onChanges = function (changes) {
      // React to range start change
      if (changes.hasOwnProperty('rangeStart')) {
        _startDateChangeCallback(changes.rangeStart.currentValue);
      }

      // React to range end change
      if (changes.hasOwnProperty('rangeEnd')) {
        _endDateChangeCallback(changes.rangeEnd.currentValue);
      }
    };

    /**
     * Method called by child calendar on update
     *
     * @return {Void}
     */
    ctrl.resetRange = function () {
      if (ctrl.multipleSelect) {
        ctrl.rangeStart = ctrl.startDate;
        ctrl.rangeEnd = ctrl.endDate;
        _defRangeStart = ctrl.rangeStart;
        _defRangeEnd = ctrl.rangeEnd;

        if (ctrl.startDate === null && ctrl.endDate === null) {
          _whichDate = 'start';
          ctrl.rangeChange = 'start';
          ctrl.minDate = _prevMinDate;
          // Call
          if (ctrl.onInit !== undefined) {
            // Send new dates to outside
            ctrl.onInit({
              value: [ctrl.leftCalendarDate, ctrl.rightCalendarDate]
            });
          }
          return;
        }

        if (ctrl.rangeChange === 'end') {
          ctrl.selectedDate = ctrl.startDate;
        } else {
          ctrl.selectedDate = ctrl.endDate;
        }
      } else {
        ctrl.selectedDate = ctrl.startDate;
      }
    };

    /**
     * Navigates one month at a time back or forth
     *
     * @param {Number} direction Direction in which the calendar moves (-1/1)
     */
    ctrl.moveMonth = function (direction) {
      var newMonth = new Date(ctrl.leftCalendarDate);
      newMonth.setMonth(newMonth.getMonth() + direction);
      _switchMonths(newMonth);

      if (ctrl.onMoveMonth !== undefined) {
        // Send new dates to outside
        ctrl.onMoveMonth({ value: [ctrl.leftCalendarDate, ctrl.rightCalendarDate] });
      }
    };

    /**
     * Cell click handler
     *
     * @param {CalendarCellModel} cell Object representing a calendar cell
     */
    ctrl.cellClick = function (cell) {
      if (cell.disabled) {
        return;
      }

      // Update min/max dates
      _updateMinMaxDates(cell);

      // Update date(s)
      _updateDates(cell);

      // Update range
      _updateRange(cell);

      _updateWhichDate(cell);

      if (ctrl.onCellClick !== undefined) {
        // Call cell click callback
        ctrl.onCellClick({
          whichDate: _whichDate,
          cell: cell
        });
      }
    };

    /**
     * Cell hover handler
     *
     * @param  {CalendarCellModel} cell Object representing a calendar cell
     */
    ctrl.onCellHover = function (cell) {
      if (ctrl.rangeChange === 'start') {
        ctrl.rangeStart = cell.date;
      } else {
        ctrl.rangeEnd = cell.date;
        _updateTripLength();
      }
    };

    /**
     * Calendar mouse leave handler triggered when user moves the cursor out of the caneldar
     * to refresh the cells
     */
    ctrl.onCalendarLeave = function () {
      ctrl.rangeStart = _defRangeStart;
      ctrl.rangeEnd = _defRangeEnd;
      _updateTripLength();
    };
  };

  IthDoubleCalendarController.$inject = [
    'CalendarHelper',
    'TripLengthHelper'
  ];

  angular
    .module('ITH.Base.Calendar')
    .controller('IthDoubleCalendarController', IthDoubleCalendarController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/controllers/ith-scroll-calendar.controller.js
(function(angular) {
/**
   * @name        IthScrollCalendarController
   * @description Handles data inside the scroll calendars
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthScrollCalendarController = function (CalendarHelper, $timeout, $rootScope) {
    /**
     * View model
     * @type {Object}
     */
    var ctrl = this;

    /**
     * Default range start (cached value from init)
     * @type {Date}
     */
    var _defRangeStart;

    /**
     * Default range end (cached value from init)
     * @type {Date}
     */
    var _defRangeEnd;

    /**
     * Type of calendar selection
     * @enum {String}
     */
    var SelectDateEnum = {
      START: 'start',
      END: 'end'
    };

    /**
     * Indicates which date user is selecting when multiple option is on
     * @type {SelectDateEnum}
     */
    var _whichDate = SelectDateEnum.START;

    /**
     * Switcher for component init
     * @type {Boolean}
     */
    var _isInitiated = false;

    /**
     * Function called on controller init hook
     */
    var _onInit = function () {
      _isInitiated = true;

      // Always hide week days and arrows on scroll calendars
      ctrl.showWeekDays = false;
      ctrl.showLeftArrow = false;
      ctrl.showRightArrow = false;
      ctrl.multipleSelect = (ctrl.multipleSelect === null) ? false : !!ctrl.multipleSelect;
      ctrl.oneWay = (ctrl.oneWay === null) ? false : !!ctrl.oneWay;
      ctrl.price = (ctrl.price === null) ? false : !!ctrl.price;

      // Init dates
      ctrl.initDates = [];
      for (var i = 0; i <= 11; i++) {
        var initDate = CalendarHelper.getFirstDayOfMonth(new Date());
        initDate.setMonth(initDate.getMonth() + i);
        ctrl.initDates.push(initDate);
      }

      _defRangeStart = ctrl.rangeStart;
      _defRangeEnd = ctrl.rangeEnd;

      $rootScope.datepicker = {
        showTooltip: false,
        selection: '',
        promise: null
      };

      if (ctrl.onInit !== undefined) {
        // Send new dates to outside
        ctrl.onInit({ value: ctrl.initDates });
      }
    };

    /**
     * Component changes hook
     * @param {Object} changes Object containing binding changes
     */
    var _onChanges = function (changes) {
      if (changes.hasOwnProperty('selecting')) {

        _whichDate = changes.selecting.currentValue === ctrl.newDatePicker.selectModes.DEPARTURE
          ? SelectDateEnum.START
          : SelectDateEnum.END;

        ctrl.rangeChange = _whichDate;

        if (_whichDate === SelectDateEnum.START) {
          ctrl.minDate = new Date();
        } else {
          ctrl.minDate = ctrl.startDate !== null ? ctrl.startDate : new Date();
        }
      }

      // React to range start change
      if (changes.hasOwnProperty('rangeStart')) {
        _defRangeStart = changes.rangeStart.currentValue;
      }

      // React to range end change
      if (changes.hasOwnProperty('rangeEnd')) {
        _defRangeEnd = changes.rangeEnd.currentValue;
      }

      // React to one way change
      if (changes.hasOwnProperty('oneWay')) {
        if (!_isInitiated) {
          return;
        }

        if (changes.oneWay.currentValue === true) {
          // One way flight, set default min date
          ctrl.minDate = new Date();
          _whichDate = SelectDateEnum.START;
        } else {
          // Round trip flight
          if (this.startDate === null) {
            _whichDate = SelectDateEnum.START;
            ctrl.minDate = new Date();
          } else {
            _whichDate = SelectDateEnum.END;
            ctrl.minDate = ctrl.startDate;
          }
        }
      }

      if (changes.hasOwnProperty('multiple')) {
        if (!_isInitiated) {
          return;
        }

        if (changes.multipleSelect.currentValue === true) {
          if (ctrl.startDate === null || (ctrl.startDate !== null && ctrl.endDate !== null)) {
            _whichDate = SelectDateEnum.START;
            ctrl.minDate = new Date();
          } else {
            _whichDate = SelectDateEnum.END;
            ctrl.minDate = ctrl.startDate;
          }
        } else {
          _whichDate = SelectDateEnum.START;
          ctrl.minDate = new Date();
          ctrl.endDate = null;
        }
      }
    };

    /**
     * Method called when range is reset
     */
    var _resetRange = function () {
      var newChange = true;
      if (ctrl.rangeStart === null && ctrl.rangeEnd === null) {
        newChange = false;
      }

      ctrl.rangeStart = ctrl.startDate;
      ctrl.rangeEnd = ctrl.endDate;

      _defRangeStart = ctrl.rangeStart;
      _defRangeEnd = ctrl.rangeEnd;

      if (ctrl.startDate === null && ctrl.endDate === null) {
        _whichDate = SelectDateEnum.START;
        ctrl.rangeChange = SelectDateEnum.START;
        ctrl.newDatePicker.selecting = ctrl.newDatePicker.selectModes.DEPARTURE;
        ctrl.minDate = new Date();

        // Call onInit for reinitialisation
        if (ctrl.onInit !== undefined && newChange) {
          // Send new dates to outside
          ctrl.onInit({
            value: ctrl.initDates
          });
        }
        return;
      }
    };

    /**
     * Updates dates according to a cell model
     * @param {CalendarCellModel} cell
     */
    var _updateDates = function (cell) {
      if (!ctrl.oneWay) {
        if (_whichDate === SelectDateEnum.START) {
          ctrl.startDate = cell.date;
          ctrl.endDate = null;
        } else if (_whichDate === SelectDateEnum.END) {
          if (cell.date.getTime() < ctrl.startDate.getTime()) {
            ctrl.startDate = cell.date;
            _whichDate = SelectDateEnum.START;
          } else {
            ctrl.endDate = cell.date;
          }
        }
      } else {
        ctrl.startDate = cell.date;
      }

      // Set selected date
      // TODO: remember both dates?
      //ctrl.selectedDate = cell.date;
    };

    /**
     * Updates range according to a selected cell
     * @param {CalendarCellModel} cell
     */
    var _updateRange = function (cell) {
      if (!ctrl.oneWay) {
        if (_whichDate === SelectDateEnum.START) {
          ctrl.rangeStart = cell.date;
          _defRangeStart = cell.date;
          ctrl.rangeChange = SelectDateEnum.END;
          ctrl.newDatePicker.selecting = ctrl.newDatePicker.selectModes.RETURN;
        } else if (_whichDate === SelectDateEnum.END) {
          if (ctrl.price) {
            // For price calendar you can select different return dates after selecting departure
            ctrl.rangeChange = SelectDateEnum.END;
            ctrl.newDatePicker.selecting = ctrl.newDatePicker.selectModes.RETURN;
          } else {
            ctrl.rangeChange = SelectDateEnum.START;
            ctrl.newDatePicker.selecting = ctrl.newDatePicker.selectModes.DEPARTURE;
          }

          ctrl.rangeStart = ctrl.startDate;
          ctrl.rangeEnd = cell.date;

          _defRangeStart = ctrl.startDate;
          _defRangeEnd = ctrl.endDate;
        }
      }

      // Adjust ranges
      if (ctrl.rangeChange === SelectDateEnum.START) {
        ctrl.rangeStart = cell.date;
        _defRangeStart = cell.date;
      } else if (ctrl.rangeChange === SelectDateEnum.END) {
        ctrl.rangeEnd = cell.date;
        _defRangeEnd = cell.date;
      }
    };

    /**
     * Updates min and max dates according to a selected cell
     * @param {CalendarCellModel} cell
     */
    var _updateMinMaxDates = function (cell) {
      if (ctrl.multipleSelect) {
        if (ctrl.oneWay) {
          // Don't update min and max dates for one way
          ctrl.minDate = new Date();
        } else if (_whichDate === SelectDateEnum.START) {
          ctrl.minDate = cell.date;
        } else if (_whichDate === SelectDateEnum.END) {
          if (ctrl.price !== true) {
            ctrl.minDate = new Date();
          }
        }
      }
    };

    /**
     * Updates which date will be selected next (start or end) according to
     * private _whichDate variable
     */
    var _updateWhichDate = function () {
      if (ctrl.multipleSelect) {
        if (_whichDate === SelectDateEnum.START && !ctrl.newDatePicker.oneWay) {
          // Prepare calendar to select end date
          _whichDate = SelectDateEnum.END;
        }
      }
    };

    /**
     * Cell click handler
     * @param {CalendarCellModel} cell Object representing a calendar cell
     */
    var _cellClick = function (cell) {
      $rootScope.datepicker.showTooltip = false;
      $timeout(function () {
        $rootScope.datepicker.showTooltip = true;
      }, 10);
      $rootScope.datepicker.selection = _whichDate;

      if ($rootScope.datepicker.promise !== null) {
        $timeout.cancel($rootScope.datepicker.promise);
      }

      $rootScope.datepicker.promise = $timeout(function () {
        $rootScope.datepicker.showTooltip = false;
        $rootScope.datepicker.selection = '';
      }, 3000);

      if (cell.disabled) {
        return;
      }

      // Update min/max dates
      _updateMinMaxDates(cell);

      // Update date(s)
      _updateDates(cell);

      var _currentSelection = _whichDate;

      // Update range
      _updateRange(cell);

      _updateWhichDate(cell);

      if (ctrl.onCellClick !== undefined) {
        // Call cell click callback
        ctrl.onCellClick({
          whichDate: _currentSelection,
          cell: cell
        });
      }
    };

    /**
     * Cell hover handler
     * @param  {CalendarCellModel} cell Object representing a calendar cell
     */
    var _cellHover = function (cell) {
      if (ctrl.rangeChange === SelectDateEnum.START) {
        ctrl.rangeStart = cell.date;
      } else if (ctrl.rangeChange === SelectDateEnum.END) {
        ctrl.rangeEnd = cell.date;
      }
    };

    /**
     * Calendar mouse leave handler triggered when user moves the cursor out of the caneldar
     * to refresh the cells
     */
    var _onCalendarLeave = function () {
      ctrl.rangeStart = _defRangeStart;
      ctrl.rangeEnd = _defRangeEnd;
    };

    // Controller hooks
    ctrl.$onInit = _onInit;
    ctrl.$onChanges = _onChanges;

    // Public methods
    ctrl.resetRange = _resetRange;
    ctrl.cellClick = _cellClick;
    ctrl.cellHover = _cellHover;
    ctrl.onCalendarLeave = _onCalendarLeave;
  };

  IthScrollCalendarController.$inject = [
    'CalendarHelper',
    '$timeout',
    '$rootScope'
  ];

  angular
    .module('ITH.Base.Calendar')
    .controller('IthScrollCalendarController', IthScrollCalendarController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/controllers/ith-simple-calendar.controller.js
(function(angular) {
/**
   * Simple calendar controller
   *
   * @param  {CalendarHelper} CalendarHelper Helper service for dates and other useful methods
   */
  var IthSimpleCalendarController = function (CalendarHelper, $scope) {
    var ctrl = this;
    var _initDateStart;
    var isInitilized = false;

    /**
     * Refreshes calendar data
     * @return {Object} Object containing all data necessary for calendar UI
     */
    var _regenerate = function () {
      return CalendarHelper.generateCalendarData(ctrl.initDate, ctrl.selectedDate, ctrl.rangeStart, ctrl.rangeEnd, ctrl.minDate, ctrl.maxDate);
    };

    /**
     * Component init hook
     */
    ctrl.$onInit = function () {
      // Bindings and defaults
      ctrl.multipleSelect = (ctrl.multipleSelect === undefined) ? false : !!ctrl.multipleSelect;
      ctrl.showWeekDays = (ctrl.showWeekDays === undefined) ? true : !!ctrl.showWeekDays;
      ctrl.showLeftArrow = (ctrl.showLeftArrow === undefined) ? true : !!ctrl.showLeftArrow;
      ctrl.showRightArrow = (ctrl.showRightArrow === undefined) ? true : !!ctrl.showRightArrow;
      ctrl.calendarData = _regenerate();
      isInitilized = true;
    };

    /**
     * Component changes hook
     */
    ctrl.$onChanges = function (changes) {
      ctrl.calendarData = _regenerate();

      if (isInitilized && (changes.hasOwnProperty('startDate') || changes.hasOwnProperty('endDate'))) {
        // Update range in parent
        ctrl.onCalendarUpdate();
      }
    };

    /**
     * Click handler for the cell
     */
    ctrl.click = function (cell) {
      $scope.$emit('standard-calendar-cell-clicked');
      ctrl.onCellClick({ value: cell });
    };

    /**
     * Hover handler for the cell
     * @param  {CalendarCellModel} cell    Model cotaining data for the hovered cell
     */
    ctrl.hover = function (cell) {
      ctrl.onCellHover({ value: cell });
    };

    ctrl.onCellLeave = function () {
      // Do nothing for now
    };

    ctrl.leave = function () {
      ctrl.onCalendarLeave();
    };

    /**
     * Checks if left arrow should be visible
     * @return {Boolean}
     */
    ctrl.isLeftArrowVisible = function () {
      var _minDateStart;

      if (ctrl.minDate !== undefined) {
        // Find first day of current displayed month
        _initDateStart = CalendarHelper.getFirstDayOfMonth(ctrl.initDate);

        // Find first day of minDate month
        _minDateStart = CalendarHelper.getFirstDayOfMonth(ctrl.minDate);
      }

      return ctrl.showLeftArrow && (ctrl.minDate === undefined || _minDateStart.getTime() < _initDateStart.getTime());
    };

    /**
     * Checks if right arrow should be visible
     * @return {Boolean}
     */
    ctrl.isRightArrowVisible = function () {
      var _maxDateStart;

      if (ctrl.maxDate !== undefined) {
        // Find first day of current displayed month
        _initDateStart = CalendarHelper.getFirstDayOfMonth(ctrl.initDate);

        // Find first day of minDate month
        _maxDateStart = CalendarHelper.getFirstDayOfMonth(ctrl.maxDate);
      }

      return ctrl.showRightArrow && (ctrl.maxDate === undefined || _maxDateStart.getTime() > _initDateStart.getTime());
    };
  };

  IthSimpleCalendarController.$inject = ['CalendarHelper', '$scope'];

  angular
    .module('ITH.Base.Calendar')
    .controller('IthSimpleCalendarController', IthSimpleCalendarController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/controllers/ith-single-calendar.controller.js
(function(angular) {
/**
   * @name        IthSingleCalendarController
   * @description Handles data inside the single calendar
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthSingleCalendarController = function (CalendarHelper) {
    var vm = this;

    var _defRangeStart;
    var _defRangeEnd;
    var _prevMinDate;

    /**
     * Indicates which date user is selecting when multiple option is on
     * Possible values: start, end
     * @type {String}
     */
    var _whichDate = 'start';

    /**
     * Component init hook
     */
    var _onInit = function () {
      vm.initDate = (vm.startDate === null) ? CalendarHelper.getFirstDayOfMonth(new Date()) : CalendarHelper.getFirstDayOfMonth(vm.startDate);
      vm.multipleSelect = (vm.multipleSelect === null) ? false : !!vm.multipleSelect;
      vm.price = (vm.price === null) ? false : !!vm.price;
      vm.priceStart = (vm.priceStart === null) ? false : !!vm.priceStart;
      vm.priceEnd = (vm.priceEnd === null) ? false : !!vm.priceEnd;

      _defRangeStart = vm.rangeStart;
      _defRangeEnd = vm.rangeEnd;

      if (vm.onInit !== undefined) {
        // Send new dates to outside
        vm.onInit({ value: [vm.initDate] });
      }
    };

    /**
     * Component changes hook
     */
    var _onChanges = function (changes) {
      // React to range start change
      if (changes.hasOwnProperty('rangeStart')) {
        _defRangeStart = changes.rangeStart.currentValue;
      }

      // React to range end change
      if (changes.hasOwnProperty('rangeEnd')) {
        _defRangeEnd = changes.rangeEnd.currentValue;
      }
    };

    var _resetRange = function () {
      if (vm.multipleSelect) {
        vm.rangeStart = vm.startDate;
        vm.rangeEnd = vm.endDate;
        _defRangeStart = vm.rangeStart;
        _defRangeEnd = vm.rangeEnd;

        if (vm.rangeChange === 'end') {
          vm.selectedDate = vm.startDate;
        } else {
          vm.selectedDate = vm.endDate;
        }
      } else {
        vm.selectedDate = vm.startDate;
      }
    };

    /**
     * Navigates one month at a time back or forth
     * @param  {Number} direction Direction in which the calendar moves (-1/1)
     */
    var _moveMonth = function (direction) {
      vm.initDate = CalendarHelper.getFirstDayOfMonth(new Date(vm.initDate));
      vm.initDate.setMonth(vm.initDate.getMonth() + direction);

      if (vm.onMoveMonth !== undefined) {
        // Send new dates to outside
        vm.onMoveMonth({ value: [vm.initDate] });
      }
    };

    var _updateDates = function (cell) {
      if (vm.multipleSelect) {
        if (_whichDate === 'start') {
          vm.startDate = cell.date;
          vm.endDate = null;
        } else if (_whichDate === 'end') {
          vm.endDate = cell.date;
        }
      } else {
        vm.startDate = cell.date;
      }

      // Set selected date
      // TODO: remember both dates?
      vm.selectedDate = cell.date;
    };

    var _updateRange = function (cell) {
      if (vm.multipleSelect) {
        if (_whichDate === 'start') {
          vm.rangeStart = cell.date;
          _defRangeStart = cell.date;
          vm.rangeChange = 'end';
        } else if (_whichDate === 'end') {
          if (vm.price) {
            // For price calendar you can select different return dates after selecting departure
            vm.rangeChange = 'end';
          } else {
            vm.rangeChange = 'start';
          }

          vm.rangeStart = vm.startDate;
          vm.rangeEnd = cell.date;

          _defRangeStart = vm.startDate;
          _defRangeEnd = vm.endDate;
        }
      }

      // Adjust ranges
      if (vm.rangeChange === 'start') {
        vm.rangeStart = cell.date;
        _defRangeStart = cell.date;
      } else if (vm.rangeChange === 'end') {
        vm.rangeEnd = cell.date;
        _defRangeEnd = cell.date;
      }
    };

    var _updateMinMaxDates = function (cell) {
      if (vm.multipleSelect && !vm.price) {
        if (_whichDate === 'start') {
          _prevMinDate = vm.minDate;
          vm.minDate = cell.date;
        } else if (_whichDate === 'end') {
          if (vm.price !== true) {
            vm.minDate = _prevMinDate;
          }
        }
      }
    };

    var _updateWhichDate = function (cell) {
      if (vm.multipleSelect) {
        if (_whichDate === 'start') {
          // Prepare calendar to select end date
          _whichDate = 'end';
        } else if (_whichDate === 'end') {
          if (vm.price) {
            // For price calendar you can select different return dates after
            // selecting departure
            _whichDate = 'end';
          } else {
            // Normal datepicker resets to selecting a departure date after
            // selecting return
            _whichDate = 'start';
          }
        }
      } else {
        // Single
        _whichDate = this.rangeChange;
      }
    };

    /**
     * Cell click handler
     * @param  {CalendarCellModel} cell Object representing a calendar cell
     */
    var _cellClick = function (cell) {
      if (cell.disabled) {
        return;
      }

      var _currentSelection = _whichDate;

      // Update min/max dates
      _updateMinMaxDates(cell);

      // Update date(s)
      _updateDates(cell);

      // Update range
      _updateRange(cell);

      _updateWhichDate(cell);

      if (vm.onCellClick !== undefined) {
        // Call cell click callback
        vm.onCellClick({
          whichDate: _currentSelection,
          cell: cell
        });
      }
    };

    /**
     * Cell hover handler
     * @param  {CalendarCellModel} cell Object representing a calendar cell
     */
    var _cellHover = function (cell) {
      if (vm.rangeChange === 'start') {
        vm.rangeStart = cell.date;
      } else if (vm.rangeChange === 'end') {
        vm.rangeEnd = cell.date;
      }
    };

    /**
     * Calendar mouse leave handler
     * @description Triggered when user moves the cursor out of the caneldar to
     * refresh the cells
     */
    var _onCalendarLeave = function () {
      vm.rangeStart = _defRangeStart;
      vm.rangeEnd = _defRangeEnd;
    };

    // Controller hooks
    vm.$onInit = _onInit;
    vm.$onChanges = _onChanges;

    // Public methods
    vm.resetRange = _resetRange;
    vm.moveMonth = _moveMonth;
    vm.cellClick = _cellClick;
    vm.cellHover = _cellHover;
    vm.onCalendarLeave = _onCalendarLeave;
  };

  IthSingleCalendarController.$inject = ['CalendarHelper'];
  
  angular
    .module('ITH.Base.Calendar')
    .controller('IthSingleCalendarController', IthSingleCalendarController);

}(angular));;

// Source: ../shared/public_html/assets/js/base/calendar/helpers/ith-scroll-calendar.helper.js
(function(angular) {
var ScrollCalendarHelperService = function ($filter, $document) {
    /**
     * Scrolls calendar months to the departure month
     *
     * @param {Date} startDate
     */
    this.scrollToSelection = function (startDate) {
      if (startDate !== null) {
        // Find id of the calendar where start date is selected
        var startMonthId = $filter('date')(startDate, 'MMyyyy');
        var startMonth = $document[0].getElementById(startMonthId);
        var bounds = startMonth.getBoundingClientRect();
        var scrollPos = bounds.top - 140; // Top padding on mobile

        // Scroll parent to that position
        $document[0].getElementById('scrollCalendarWrapper').scrollTop = (scrollPos > 0) ? scrollPos : 0;
      }
    };
  };

  ScrollCalendarHelperService.$inject = [
    '$filter',
    '$document'
  ];

  angular
    .module('ITH.Base.Calendar')
    .service('ScrollCalendarHelper', ScrollCalendarHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/helpers/ith-simple-calendar.helper.js
(function(angular) {
var CalendarHelperService = function (CalendarCellModel) {
    /**
     * Generates calendar data
     *
     * @param  {Date|String} initDate     Date that represents the calendar month
     * @param  {Date|String} selectedDate Selected calendar date (any date)
     * @param  {Date|String} rangeStart   Date when range starts
     * @param  {Date|String} rangeEnd     Date when range ends
     * @return {Object}                   Object containing calendar data
     */
        this.generateCalendarData = function(initDate, selectedDate, rangeStart, rangeEnd, minDate, maxDate) {
            var calendarData = {
                month: '',
                monthName: '',
                year: '',
                weeks: []
            };

            var _targetDate = this.getZeroHourDate(initDate);
            var _selectedDate = this.getZeroHourDate(selectedDate);
            var _today = this.getZeroHourDate(new Date());

            if (minDate !== undefined) {
                minDate = this.getZeroHourDate(minDate);
            }

            if (maxDate !== undefined) {
                maxDate = this.getZeroHourDate(maxDate);
            }

            // test if input date is correct, instead use current month
            var _month = _targetDate.getMonth() + 1;
            var _year = _targetDate.getFullYear();
            var _logical_month = _month - 1;

            calendarData.month = moment(_targetDate).format('M');
            calendarData.monthName = moment(_targetDate).format('MMMM');
            calendarData.year = _year;

            // get first day of month and first week day
            var first_day = new Date(_year, _logical_month, 1);
            var first_day_weekday = first_day.getDay() === 0 ? 7 : first_day.getDay();

            // find number of days in month
            var month_length = new Date(_year, _month, 0).getDate();
            var previous_month_length = new Date(_year, _logical_month, 0).getDate();

            // define default day variables
            var day = 1; // current month days
            var prev = 1; // previous month days
            var next = 1; // next month days
            var _week;
            var _isToday;
            var _isSelected;
            var _cellDate;
            var _isDisabled;

            // weeks loop (rows)
            for (var i = 0; i < 9; i++) {
                _week = [];

                // weekdays loop (cells)
                for (var j = 1; j <= 7; j++) {
                    _cellDate = new Date(_year, _logical_month, day, 0, 0, 0, 0);
                    if (day <= month_length && (i > 0 || j >= first_day_weekday)) {
                        // current month
                        _isToday = _cellDate.getTime() === _today.getTime();
                        _isSelected = _cellDate.getTime() === _selectedDate.getTime();
                        _isDisabled = ((minDate !== undefined && _cellDate.getTime() < minDate.getTime()) || (maxDate !== undefined && _cellDate.getTime() > maxDate.getTime())) ? true : false;

                        _week.push(new CalendarCellModel({
                            day: day,
                            isSelected: _isSelected,
                            today: _isToday,
                            date: _cellDate,
                            disabled: _isDisabled,
                            current: true
                        }, rangeStart, rangeEnd));
                        day++;
                    } else {
                        //not current month
                        if (day <= month_length) {
                            // previous month
                            _week.push(new CalendarCellModel({
                                day: previous_month_length - first_day_weekday + prev + 1,
                                date: _cellDate,
                                disabled: true,
                                current: false
                            }));
                            prev++;
                        } else {
                            // next month
                            _week.push(new CalendarCellModel({
                                day: next,
                                date: _cellDate,
                                disabled: true,
                                current: false
                            }));
                            next++;
                        }
                    }
                }

                // Create week entry
                calendarData.weeks.push(_week);

                // stop making rows if it's the end of month
                if (day > month_length) {
                    break;
                }
            }

            return calendarData;
        };

        /**
     * Returns first day of month
     *
     * @param   {Date} date
     * @returns {Date}
     */
        this.getFirstDayOfMonth = function (date) {
            return moment(date).startOf('month').toDate();
        };

        /**
     * Returns date at midnight
     *
     * @param   {Date} date
     * @returns {Date}
     */
        this.getZeroHourDate = function (date) {
            var newDate = new Date(date);
            newDate.setHours(0, 0, 0, 0);
            return newDate;
        };

        /**
     * Returns midnight timestamp for a date
     *
     * @param   {Date}   date
     * @returns {Number}
     */
        this.getZeroHourTime = function (date) {
            return this.getZeroHourDate(date).getTime();
        };

        /**
     * Checks if a date is between two dates (in range)
     *
     * @param   {Date} candidateDate
     * @param   {Date} minDate
     * @param   {Date} maxDate
     * @returns {Boolean}
     */
        this.isDateInRange = function (candidateDate, minDate, maxDate) {
            var _zeroHourCandidateDate = this.getZeroHourTime(this.getFirstDayOfMonth(candidateDate));
            var _zeroHourMinDate = this.getZeroHourTime(this.getFirstDayOfMonth(minDate));
            var _zeroHourMaxDate = this.getZeroHourTime(this.getFirstDayOfMonth(maxDate));

            return _zeroHourCandidateDate >= _zeroHourMinDate && _zeroHourCandidateDate <= _zeroHourMaxDate;
        };

        /**
     * Returns correct date according to start date and min date
     *
     * @param   {Date} startDate
     * @param   {Date} minDate
     * @returns {Date} Current date / start date / end date
     */
        this.getMinCalendarDate = function (startDate, minDate) {
            var now = this.getZeroHourDate(new Date());

            if (startDate === null) {
                if (minDate === null || now.getTime() >= minDate.getTime()) {
                    // Current date
                    return this.getFirstDayOfMonth(now);
                } else {
                    // Min date
                    return this.getFirstDayOfMonth(minDate);
                }
            } else if (minDate === null || startDate.getTime() >= minDate.getTime()) {
                // Start date
                return this.getFirstDayOfMonth(startDate);
            } else {
                // Min date
                return this.getFirstDayOfMonth(minDate);
            }
        };

        /**
     * Returns month number with a leading zero
     *
     * @param   {Date}   date
     * @returns {String}
     */
        this.getLeadZeroMonth = function (date) {
            return ('0' + (date.getMonth()+1)).slice(-2);
        };
    };

    CalendarHelperService.$inject = [
        'CalendarCellModel'
    ];

    angular
        .module('ITH.Base.Calendar')
        .service('CalendarHelper', CalendarHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/calendar/models/ith-calendar-cell.model.js
(function(angular, moment) {
/**
   * @name        CalendarCellModel
   * @description Handles data inside a calendar cell.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
    var calendarCellFactory = function () {
        /**
         * Calendar cell model constructor
         *
         * @param {Object} cellData
         * @param {Date}   rangeStart
         * @param {Date}   rangeEnd
         * @constructor
         * @interface
         */
        var CalendarCellModel = function (cellData, rangeStart, rangeEnd) {
            this.moment = moment(cellData.date);
            this.day = cellData.day;
            this.today = cellData.today || false;
            this.date = cellData.date;
            this.backendDate = this.moment.format('YYYY-MM-DD');
            this.hash = this.moment.format('YYYYMMDD');

            this.dateObj = {
                year: this.moment.format('YYYY'),
                month: this.moment.format('MM'),
                day: this.moment.format('DD')
            };

            this.disabled = cellData.disabled || false;
            this.current = cellData.current || false;

            this.isSelected = cellData.isSelected || false;
            this.isRangeStart = false;
            this.isRangeEnd = false;
            this.isInRange = false;

            if (rangeStart !== undefined) {
                rangeStart = new Date(rangeStart);
                rangeStart.setHours(0, 0, 0, 0);

                if (rangeStart.getTime() === this.date.getTime()) {
                    this.isRangeStart = true;
                }
            }

            if (rangeEnd !== undefined) {
                rangeEnd = new Date(rangeEnd);
                rangeEnd.setHours(0, 0, 0, 0);

                if (rangeEnd.getTime() === this.date.getTime()) {
                    this.isRangeEnd = true;
                }
            }

            if (rangeStart !== undefined && rangeEnd !== undefined && this.date.getTime() > rangeStart.getTime() && this.date.getTime() < rangeEnd.getTime()) {
                this.isInRange = true;
            }
        };

        CalendarCellModel.prototype.constructor = CalendarCellModel;

        return CalendarCellModel;
    };

    angular
        .module('ITH.Base.Calendar')
        .factory('CalendarCellModel', calendarCellFactory);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/base/components/close-button.component.js
angular.module('base').component('ithCloseButton', {
    template: '\
        <button class="ith-close-button">\
            <svg-icon id="modal-close"></svg-icon>\
        </button>\
    '
});
;

// Source: ../shared/public_html/assets/js/base/components/countdown/countdown.component.js
(function (angular) {

    var template = '\
        <span class="countdown">\
            <span class="countdown__element" ng-repeat="data in $ctrl.templateData">\
                <span class="countdown__element__value">{{ data.value }}</span>\
                <span class="countdown__element__unit">{{ data.unit }}</span>\
            </span>\
        </span>\
    ';

    var controller = function ($interval) {
        var stopTime = null;

        this.templateData = [];

        this.update = function () {
            var now = moment();
            var limit = moment(this.limitDateTime);

            var days = 0;
            var hours = 0;
            var minutes = 0;
            var seconds = 0;

            days = limit.diff(now, 'days');

            if (days < 0) {
                days = 0;
            }

            hours = limit.diff(now, 'hours') - limit.diff(now, 'days') * 24;

            if (hours < 10) {
                if (hours < 0) {
                    hours = 0;
                }

                hours = '0' + hours;
            }

            minutes = limit.diff(now, 'minutes') - limit.diff(now, 'hours') * 60;

            if (minutes < 10) {
                if (minutes < 0) {
                    minutes = 0;
                }

                minutes = '0' + minutes;
            }

            seconds = limit.diff(now, 'seconds') - limit.diff(now, 'minutes') * 60;

            if (seconds < 10) {
                if (seconds < 0) {
                    seconds = 0;
                }

                seconds = '0' + seconds;
            }

            var newTemplateData = [];

            if (!this.hideDays) {
                newTemplateData.push({
                    value: days,
                    unit: this.daysUnit
                });
            }

            if (!this.hideHours) {
                newTemplateData.push({
                    value: hours,
                    unit: this.hoursUnit
                });
            }

            if (!this.hideMinutes) {
                newTemplateData.push({
                    value: minutes,
                    unit: this.minutesUnit
                });
            }

            newTemplateData.push({
                value: seconds,
                unit: this.secondsUnit
            });

            this.templateData = newTemplateData;
        };

        this.$onInit = function () {
            this.hideDays = this.hideDays ? this.hideDays : false;
            this.hideHours = this.hideHours ? this.hideHours : false;
            this.hideMinutes = this.hideMinutes ? this.hideMinutes : false;

            this.daysUnit = this.daysUnit ? this.daysUnit : 'd';
            this.hoursUnit = this.hoursUnit ? this.hoursUnit : 'h';
            this.minutesUnit = this.minutesUnit ? this.minutesUnit : 'm';
            this.secondsUnit = this.secondsUnit ? this.secondsUnit : 's';

            this.update();
            stopTime = $interval(this.update.bind(this), 1000);
        };

        this.$onDestroy = function () {
            $interval.cancel(stopTime);
        };
    };

    controller.$inject = ['$interval'];

    angular.module('base').component('countdown', {
        controller: controller,
        template: template,
        bindings: {
            limitDateTime: '<',
            hideDays: '<?',
            hideHours: '<?',
            hideMinutes: '<?',
            daysUnit: '@?',
            hoursUnit: '@?',
            minutesUnit: '@?',
            secondsUnit: '@?'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ieftinuarie-countdown-modal.controller.js
(function (angular) {
var controller = function ($modalInstance) {
        this.closeModal = function () {
            $modalInstance.dismiss();
        }
    };

    controller.$inject = [
        '$modalInstance'
    ];

    angular
        .module('base')
        .controller('IthIeftinuarieCountdownModalController', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/base/components/ieftinuarie-countdown.component.js
(function (angular, moment, window) {
var template = '\
        <div ng-if="$ctrl.isVola || $ctrl.isGovola" class="ieftinuarie-wrapper" ng-click="$ctrl.clickHandler()">\
            \
            <div class="ieftinuarie-left-section">\
                <div>\
                    <svg-icon id="revolut"></svg-icon>\
                    <p class="ieftinuarie-left-section__heading" translate>LANGM_JS_JAN_COUNTDOWN_HEADING_LEFT</p>\
                    <p class="ieftinuarie-left-section__description" translate>LANGM_JS_JAN_COUNTDOWN_DESCRIPTION_LEFT</p>\
                </div>\
                \
                <button type="button" class="ieftinuarie-left-section__button">\
                    <span translate>LANGM_JS_JAN_COUNTDOWN_BUTTON_LEFT</span>\
                    <svg-icon id="caret"></svg-icon>\
                </button>\
            </div>\
            \
            <div class="ieftinuarie-countdown">\
                <div>\
                    <div class="ieftinuarie-countdown__content">\
                        <div class="ieftinuarie-countdown__content__heading" translate>LANGM_JS_JAN_COUNTDOWN_HEADING</div>\
                    </div>\
                    <div class="ieftinuarie-countdown__duration">\
                        <span>\
                            <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.days"></span>\
                            <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_DAYS</span>\
                        </span>\
                        <span class="ieftinuarie-countdown__duration__separator">:</span>\
                        <span>\
                            <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.hours"></span>\
                            <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_HOURS</span>\
                        </span>\
                        <span class="ieftinuarie-countdown__duration__separator">:</span>\
                        <span>\
                            <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.minutes"></span>\
                            <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_MINUTES</span>\
                        </span>\
                    </div>\
                </div>\
            </div>\
        </div>\
        \
        <div ng-if="$ctrl.isFru" class="ieftinuarie-wrapper ieftinuarie-wrapper--fru">\
            \
            <div class="ieftinuarie-countdown">\
                <div class="ieftinuarie-countdown__content">\
                    <div class="ieftinuarie-countdown__content__heading" translate>LANGM_JS_JAN_COUNTDOWN_HEADING</div>\
                </div>\
                <div class="ieftinuarie-countdown__duration">\
                    <span>\
                        <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.days"></span>\
                        <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_DAYS</span>\
                    </span>\
                    <span class="ieftinuarie-countdown__duration__separator">:</span>\
                    <span>\
                        <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.hours"></span>\
                        <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_HOURS</span>\
                    </span>\
                    <span class="ieftinuarie-countdown__duration__separator">:</span>\
                    <span>\
                        <span class="ieftinuarie-countdown__duration__value" ng-bind="$ctrl.minutes"></span>\
                        <span class="ieftinuarie-countdown__duration__name" translate>LANGM_JS_JAN_COUNTDOWN_MINUTES</span>\
                    </span>\
                </div>\
            </div>\
        </div>\
        ';

    var controller = function ($interval, $modal, appConfig) {
        var stopTime = null;
        var limit = moment([2025, 1, 1]);

        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.isVola = appConfig.isVola();
        this.isGovola = appConfig.isGovola();
        this.isFru = appConfig.isFru();

        this.update = function () {
            var now = moment();

            this.days = limit.diff(now, 'days');
            this.hours = limit.diff(now, 'hours') - limit.diff(now, 'days') * 24;

            if (this.hours < 10) {
                this.hours = '0' + this.hours;
            }

            this.minutes = limit.diff(now, 'minutes') - limit.diff(now, 'hours') * 60;

            if (this.minutes < 10) {
                this.minutes = '0' + this.minutes;
            }

            this.seconds = limit.diff(now, 'seconds') - limit.diff(now, 'minutes') * 60;

            if (this.seconds < 10) {
                this.seconds = '0' + this.seconds;
            }
        };

        this.scrollToTop = function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        };

        this.clickHandler = function () {
            $modal.open({
                templateUrl: 'ithIeftinuarieCountdown.html',
                controller: 'IthIeftinuarieCountdownModalController',
                controllerAs: '$ctrl',
                size: 'md',
                windowClass: 'ieftinuarie-modal-wrapper',
            });
        };

        this.$onInit = function () {
            this.update();
            stopTime = $interval(this.update.bind(this), 1000);
        };

        this.$onDestroy = function () {
            $interval.cancel(stopTime);
        };
    };

    controller.$inject = [
        '$interval',
        '$modal',
        'appConfig'
    ];

    angular
        .module('base')
        .component('ithIeftinuarieCountdown', {
            template: template,
            controller: controller
        });

}(angular, moment, window));
;

// Source: ../shared/public_html/assets/js/base/components/ieftinuarie-fru-form.component.js
(function (angular) {

    var template = '\
        <div>\
            <ng-form name="contestForm" class="ieftinuarie-contest-form" ng-if="$ctrl.currentViewState === $ctrl.viewStates.FORM">\
                <div class="ieftinuarie-contest-form__line">\
                    <ith-name-input-field\
                        element-id="jan-firstName"\
                        name="firstName"\
                        label="{{ \'LANGM_JS_CAMPAIGN_FORM_FIRST_NAME\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_CAMPAIGN_FORM_FIRST_NAME_PLACEHOLDER\' | translate }}"\
                        form="contestForm"\
                        model="$ctrl.user.firstName"\
                        backend-error="$ctrl.errors.first_name"\
                        disabled="$ctrl.submitting">\
                    </ith-name-input-field>\
                    \
                    <ith-name-input-field\
                        element-id="jan-lastName"\
                        name="lastName"\
                        label="{{ \'LANGM_JS_CAMPAIGN_FORM_LAST_NAME\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_CAMPAIGN_FORM_LAST_NAME_PLACEHOLDER\' | translate }}"\
                        form="contestForm"\
                        model="$ctrl.user.lastName"\
                        backend-error="$ctrl.errors.last_name"\
                        disabled="$ctrl.submitting">\
                    </ith-name-input-field>\
                </div>\
                \
                <div class="ieftinuarie-contest-form__line">\
                    <ith-email-input-field\
                        element-id="jan-email"\
                        name="email"\
                        label="{{ \'LANGM_JS_CAMPAIGN_FORM_EMAIL_ADDRESS\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_CAMPAIGN_FORM_EMAIL_ADDRESS_PLACEHOLDER\' | translate }}"\
                        form="contestForm"\
                        model="$ctrl.user.email"\
                        backend-error="$ctrl.errors.email"\
                        disabled="$ctrl.submitting">\
                    </ith-email-input-field>\
                    \
                    <ith-input-field\
                        name="booking_number"\
                        type="text"\
                        label="{{ \'LANGM_JS_CAMPAIGN_FORM_BOOKING_NUMBER\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_CAMPAIGN_FORM_BOOKING_NUMBER_PLACEHOLDER\' | translate }}"\
                        form="contestForm"\
                        model="$ctrl.user.bookingNumber"\
                        required="true"\
                        min-length="5"\
                        max-length="6"\
                        backend-error="$ctrl.errors.pnr"\
                        pattern="\'^[A-Za-z0-9]+\'"\
                        disabled="$ctrl.submitting">\
                    </ith-input-field>\
                </div>\
                \
                <ith-textarea-field\
                    name="message"\
                    label="{{ \'LANGM_JS_CAMPAIGN_FORM_MESSAGE_LABEL\' | translate }}"\
                    placeholder="{{ \'LANGM_JS_CAMPAIGN_FORM_MESSAGE_PLACEHOLDER\' | translate }}"\
                    form="contestForm"\
                    model="$ctrl.user.message"\
                    backend-error="$ctrl.errors.message"\
                    required="true"\
                    rows="9"\
                    disabled="$ctrl.submitting">\
                </ith-textarea-field>\
                \
                <ith-checkbox-field\
                    form="contestForm"\
                    name="terms"\
                    model="$ctrl.user.terms"\
                    disabled="$ctrl.submitting">\
                    <div ng-repeat="consent in $ctrl.consents">\
                        <small class="disclaimer-text" ng-bind-html="consent"></small>\
                    </div>\
                </ith-checkbox-field>\
                \
                <button class="btn btn-lg btn-primary btn-block" ng-click="$ctrl.submit(contestForm)">\
                    <span ng-if="$ctrl.submitting" class="spin-loader ng-animate-disabled"></span>\
                    <span ng-if="!$ctrl.submitting" translate>LANGM_JS_CAMPAIGN_FORM_SUBMIT</span>\
                </button>\
            </ng-form>\
            \
            <div ng-if="$ctrl.currentViewState === $ctrl.viewStates.SUCCESS">\
                <ith-status-notification status="success">\
                    <pane-title translate>LANGM_JS_CAMPAIGN_FORM_SUCCESS_TITLE</pane-title>\
                    <pane-text translate translate-values="{ name: $ctrl.user.firstName }">LANGM_JS_CAMPAIGN_FORM_SUCCESS_DESC</pane-text>\
                </ith-status-notification>\
            </div>\
        </div>\
    ';

    var controller = function ($timeout, $http) {
        var endpoints = {
            consents: '/api/coupons/getGiveawayConsents',
            participate: 'api/coupons/participateInGiveaway'
        };

        var ctrl = this;

        this.viewStates = {
            FORM: 1,
            SUCCESS: 2
        };

        this.consents = [];

        this.currentViewState = this.viewStates.FORM;

        this.user = {
            firstName: '',
            lastName: '',
            email: '',
            bookingNumber: '',
            message: '',
            terms: false
        };

        this.errors = {};
        this.submitting = false;

        this.submit = function (form) {
            form.$setSubmitted(true);

            if (form.$invalid || this.user.terms === false) {
                return;
            }

            this.submitting = true;

            $http({
                method: 'POST',
                url: endpoints.participate,
                data: {
                    email: this.user.email,
                    terms_accepted: this.user.terms,
                    pnr: this.user.bookingNumber,
                    message: this.user.message,
                    first_name: this.user.firstName,
                    last_name: this.user.lastName
                }
            }).then(function () {
                ctrl.currentViewState = ctrl.viewStates.SUCCESS;
            }).catch(function (error) {
                ctrl.errors = error.data.response.errors;
            }).finally(function () {
                ctrl.submitting = false;
            });
        };

        this.$onInit = function () {
            $http({
                method: 'GET',
                url: endpoints.consents
            }).then(function (response) {
                ctrl.consents = response.data.response.checkbox;
            });
        };
    };

    controller.$inject = ['$timeout', '$http'];

    angular
        .module('base')
        .component('ithIeftinuarieFruForm', {
            template: template,
            controller: controller
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ieftinuarie-revolving-header.component.js
(function (angular) {

    var template = '\
        <div class="ieftinuarie-revolving-header">\
            <div class="ieftinuarie-revolving-header__messages">\
                <div\
                    class="ieftinuarie-revolving-header__messages__message ng-animate"\
                    ng-repeat="message in $ctrl.messages"\
                    ng-show="$ctrl.isActive($index)"\
                    ng-bind="message">\
                </div>\
            </div>\
            <svg width="25px" height="36px" viewBox="0 0 25 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">\
                    <g id="V1" transform="translate(-176, -162)" stroke="#FFFFFF" stroke-width="3">\
                        <g id="Header">\
                            <path d="M188.5,164 L188.5,196 M177.5,185 L188.5,196 M199.5,185 L188.5,196" id="Combined-Shape"></path>\
                        </g>\
                    </g>\
                </g>\
            </svg>\
        </div>\
    ';

    var controller = function ($interval, $translate) {
        this.activeElement = 0;

        this.messages = [
            $translate.instant('LANGM_JS_JSN_REVOLVING_MSG_1'),
            $translate.instant('LANGM_JS_JSN_REVOLVING_MSG_2'),
            $translate.instant('LANGM_JS_JSN_REVOLVING_MSG_3'),
            $translate.instant('LANGM_JS_JSN_REVOLVING_MSG_4')
        ];

        this.isActive = function (index) {
            return index === this.activeElement;
        };

        this.$onInit = function () {
            this.activeElement = 0;

            $interval(function () {
                this.activeElement++;

                if (this.activeElement === this.messages.length) {
                    this.activeElement = 0;
                }
            }.bind(this), 2000);
        };
    };

    controller.$inject = ['$interval', '$translate'];

    angular
        .module('base')
        .component('ieftinuarieDynamicHeader', {
            template: template,
            controller: controller
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ieftinuarie-search.header.component.js
(function (angular) {

    var template = '\
        <div class="ieftinuarie-search-header">\
            <div class="container">\
                <p class="ieftinuarie-search-header__heading" translate>LANGM_JS_CHEAPANUARY</p>\
                <p class="ieftinuarie-search-header__description">\
                    <span translate>LANGM_JS_CHEAPANUARY_UP_TO</span>\
                    <span class="ieftinuarie-search-header__description-discount" translate>\
                        LANGM_JS_CHEAPANUARY_DISCOUNT\
                    </span>\
                    <span translate>LANGM_JS_CHEAPANUARY_CHEAPER_FLIGHTS</span>\
                </p>\
            </div>\
        </div>\
    ';

    angular.module('base').component('ieftinuarieSearchHeader', {
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ith-coupon-form.component.js
(function(angular) {
var template = '\
        <div class="coupon-form">\
            <ng-form name="couponForm" id="couponForm">\
                <div class="basicBox coupon-form--closed" ng-if="$ctrl.shouldShowInitialMessage()">\
                    <div class="basicBox__container">\
                        <div>\
                            <svg-icon id="discount"></svg-icon>\
                            <span translate>LANGM_JS_COUPON_BOX_INITIAL_MESSAGE</span>\
                        </div>\
                        <button class="btn btn-outline" ng-click="$ctrl.open()" translate>LANGM_JS_COUPON_BOX_OPEN_FORM_CTA</button>\
                    </div>\
                </div>\
                <div class="basicBox coupon-form--opened" ng-if="!$ctrl.shouldShowInitialMessage()">\
                    <div class="heading" translate>LANGM_JS_COUPON_BOX_TITLE</div>\
                    <div class="basicBox__container">\
                        <div class="fd-form" ng-if="$ctrl.shouldShowForm()">\
                            <div class="fd-form__wrapper">\
                                <ith-input-field\
                                    name="couponCode"\
                                    type="text"\
                                    label="{{ \'LANGM_JS_COUPON_CODE_LABEL\' | translate }}"\
                                    placeholder="{{ \'LANGM_JS_COUPON_CODE_PLACEHOLDER\' | translate }}"\
                                    form="couponForm"\
                                    model="$ctrl.formData.code.value"\
                                    backend-error="$ctrl.formData.code.error"\
                                    required="true"\
                                    disabled="$root.orderInProgress || $ctrl.states.submitting">\
                                </ith-input-field>\
                                <ith-email-input-field\
                                    ng-if="$ctrl.states.ownershipError"\
                                    element-id="contactEmail"\
                                    name="customerEmail"\
                                    placeholder="{{ \'LANGM_JS_COUPON_EMAIL_PLACEHOLDER\' | translate }}"\
                                    label="{{ \'LANGM_JS_COUPON_EMAIL_LABEL\' | translate }}"\
                                    form="couponForm"\
                                    model="$ctrl.formData.email.value"\
                                    backend-error="$ctrl.formData.email.error"\
                                    required="true"\
                                    ng-disabled="$root.orderInProgress || $ctrl.states.submitting">\
                                </ith-email-input-field>\
                                <button class="btn btn-outline btn-lg btn-block" ng-disabled="$root.orderInProgress || $ctrl.states.submitting" ng-click="$ctrl.submit()" translate>\
                                    <span ng-if="$ctrl.states.submitting" class="spin-loader ng-animate-disabled"></span>\
                                    <span ng-if="!$ctrl.states.submitting" translate>LANGM_JS_COUPON_FORM_BTN</span>\
                                </button>\
                            </div>\
                        </div>\
                        <ith-alert-box ng-if="$ctrl.shouldShowSuccess()" type="success">\
                            <div translate>LANGM_JS_COUPON_ADDED_SUCCESS</div>\
                        </ith-alert-box>\
                    </div>\
                </div>\
            </ng-form>\
        </div>\
    ';

    var controller = function ($scope, $rootScope, $stateParams, CouponServ) {
        this.formSubmitUnregister = null;

        this.formData = {
            code: {
                value: '',
                error: null
            },
            email: {
                value: '',
                error: null
            }
        };

        this.states = {
            submitting: false,
            ownershipError: false,
            opened: false
        };

        this.shouldShowInitialMessage = function () {
            return this.states.opened === false;
        };

        this.shouldShowForm = function () {
            return !this.shouldShowInitialMessage() && this.booking.basket.getDiscount().getTotalCouponsDiscount() === 0;
        };

        this.shouldShowSuccess = function () {
            return !this.shouldShowInitialMessage() && this.booking.basket.getDiscount().getTotalCouponsDiscount() > 0;
        };

        this.open = function () {
            this.states.opened = true;
            this.formData.email.value = this.booking.contactDetails.getEmail();
        };

        this.submit = function () {
            var self = this;
            $scope.couponForm.$setSubmitted();
            if ($scope.couponForm.$valid) {
                this.states.submitting = true;
                this.formData.code.error = null;
                this.formData.email.error = null;

                CouponServ
                    .addCoupon(
                        this.formData.code.value,
                        this.formData.code.email,
                        angular.copy($stateParams),
                        this.booking.basket.getDiscount().getCodes()
                    )
                    .then(function (response) {
                        self.states.submitting = true;

                        if (response.discount) {
                            if (!response.campaign.insurance || (response.campaign.insurance && self.booking.getInsurance().isSet())) {
                                response.discount_code = self.formData.code.value;
                                response.owner = self.formData.code.email;

                                var answer = self.booking.basket.addCoupon(response, 1);

                                if (!answer.success && answer.error) {
                                    self.formData.code.error = answer.error;
                                }
                            }

                            self.formData.code.value = '';
                        }
                    })
                    .catch (function (response) {
                        self.states.ownershipError = false;

                        if (response.response) {
                            var errors = [];

                            angular.forEach(response.response, function (element) {
                                errors.push(element.msg);

                                if (element.error === 'LANGM_COUPON_VALIDATION_OWNERSHIP') {
                                    // Allow user to prefill email address for coupon ownership
                                    self.states.ownershipError = true;
                                }
                            });

                            if (self.states.ownershipError) {
                                self.formData.email.error = errors[0];
                            }

                            if (!self.states.ownershipError) {
                                self.formData.code.error = errors[0];
                            }
                        }
                    })
                    .finally(function () {
                        self.states.submitting = false;
                    });
            }
        };

        this.$onInit = function () {
            var self = this;

            this.formSubmitUnregister = $rootScope.$on('bookingFormSubmit', function () {
                self.states.opened = false;
            });
        };

        this.$onDestroy = function () {
            this.formSubmitUnregister();
        };
    };

    controller.$inject = ['$scope', '$rootScope', '$stateParams', 'dsc.CouponServ'];

    var IthCouponFormComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('base')
        .component('ithCouponForm', IthCouponFormComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ith-event-broadcast-link.component.js
(function(angular) {
var IthEventBroadcastLinkComponent = {
        template: '<a href="javascript:void(0)" ng-click="$ctrl.onClick()"><ng-transclude></ng-transclude></a>',
        controller: ['$rootScope', function ($rootScope) {
            this.onClick = function () {
                $rootScope.$broadcast(this.event);
            };
        }],
        bindings: {
            event: '@'
        },
        transclude: true
    };

    angular
        .module('base')
        .component('ithEventLink', IthEventBroadcastLinkComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/ith-video-embed.component.js
(function (angular, navigator) {

    var template = '\
        <div class="video-embed">\
            <div class="video-embed__left-section">\
                <img \
                    class="video-embed__promo-image"\
                    ng-src="{{ $ctrl.imagePromoSrc }}" \
                    alt=""\
                >\
                <p class="video-embed__title" ng-bind-html="$ctrl.text"></p>\
            </div>\
            \
            <div class="video-embed__wrapper" ng-if="!$ctrl.isLoaded" ng-click="$ctrl.loadPlayer()">\
                <img class="video-embed__thumbnail video-embed__display-element" src="{{ $ctrl.thumbSrc }}">\
                <button class="video-embed__play">\
                    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="63" viewBox="0 0 63 63" fill="none">\
                        <circle cx="31.5" cy="31.5" r="26.5" fill="#FFC52A"/>\
                        <circle cx="31.5" cy="31.5" r="29" stroke="#FFC52A" stroke-opacity="0.5" stroke-width="5"/>\
                        <path d="M36 31.5L29.25 37.1292L29.25 25.8708L36 31.5Z" fill="black"/>\
                    </svg>\
                </button>\
            </div>\
            <iframe\
                class="video-embed__display-element"\
                ng-if="$ctrl.isLoaded"\
                src="{{ $ctrl.getIframeSrc() }}"\
                frameborder="0"\
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"\
                allowfullscreen="true">\
            </iframe>\
        </div>\
    ';

    var controller = function ($sce) {
        this.isLoaded = false;
        this.autoplay = true;

        this.loadPlayer = function () {
            this.isLoaded = true;
        };

        this.$onInit = function () {
            if (/Mobi|Android/i.test(navigator.userAgent)) {
                /* Load on mobile devices, there is no autoplay */
                this.autoplay = false;
                this.loadPlayer();
            }
        };

        this.getIframeSrc = function () {
            var src = this.iframeSrc;

            if (!this.autoplay) {
                src = src
                    .split('&autoplay=1').join('')
                    .split('&autoplay=true').join('');
            }

            return $sce.trustAsResourceUrl(src);
        };
    };

    controller.$inject = ['$sce'];

    angular.module('base').component('ithVideoEmbed', {
        controller: controller,
        template: template,
        bindings: {
            iframeSrc: '@',
            thumbSrc: '@',
            imagePromoSrc: '@',
            text: '@'
        }
    });

}(angular, navigator));
;

// Source: ../shared/public_html/assets/js/base/components/lead-offers-new.component.js
(function (angular) {
var template = '\
        <div class="lead-offers-new">\
            <div class="explore-mode-results">\
                <a \
                    ng-repeat="item in $ctrl.results" \
                    class="explore-mode-results__item" \
                    ng-href="{{ item.landingPageUrl }}"\
                >\
                \
                    <img \
                        class="explore-mode-results__item-image-placeholder"\
                        ng-src="/assets/img/ui/image-placeholder.svg" \
                        alt=""\
                    >\
                    <div \
                        class="explore-mode-results__item-background-holder"\
                        style="background-image:url({{ $ctrl.getImageUrl(item.destinationImages, $index, false) }})"\
                    ></div>\
                    <div \
                        class="explore-mode-results__item-background-holder explore-mode-results__item-background-holder--mobile"\
                        style="background-image:url({{ $ctrl.getImageUrl(item.destinationImages, $index, true) }})"\
                    ></div>\
                    \
                    <div class="explore-mode-results__item-footer">\
                        <div>\
                            <p class="explore-mode-results__item-location">\
                                {{ $ctrl.getCityName(item.destinationCity) }}\
                            </p>\
                            <p class="explore-mode-results__item-price">\
                                <span \
                                    class="explore-mode-results__item-price-from" \
                                    translate\
                                >\
                                    LANGM_JS_FROM_PRICE\
                                </span>\
                                <span class="explore-mode-results__item-price-amount">\
                                    {{ $ctrl.getPrice(item.price.value.amount, item.price.value.currency) }}\
                                </span>\
                            </p>\
                        </div>\
                       <svg-icon id="caret"></svg-icon>\
                    </div>\
                </a>\
            </div>\
        </div>\
    ';

    var controller = function (AppConfig, $http,PriceFormatterService) {
        var ctrl = this;

        this.results = [];
        this.translations = {};

        this.getCityName = function (code) {
            return this.translations.cities[code] || code;
        };

        this.getPrice = function (amount, currency) {
            return PriceFormatterService.formatPrice(amount, currency);
        };

        this.getImageUrl = function (urlObj, itemIndex, isMobile) {
            if (!isMobile) {
                if (itemIndex === 0) {
                    return urlObj.desktop.square.big;
                }

                if (itemIndex === 1 || itemIndex === 4 || itemIndex === 9) {
                    return urlObj.desktop.rectangle.big;
                }

                return urlObj.desktop.square.medium;
            }

            // for now desktop images are used for mobile due to bad quality of mobile images...
            return urlObj.desktop.rectangle.big;
        };

        this.getTodayDate = function () {
            return moment().format('YYYY-MM-DD');
        };

        this.getFutureDate = function () {
            return moment().add(3, 'month').format('YYYY-MM-DD');
        };

        this.buildUrl = function () {
            var baseUrl = AppConfig.getShelfConfig().api;
            var prefix = baseUrl.match('https:') ? '' : 'https:';
            var url = new URL(prefix + baseUrl + '/offers');

            url.searchParams.set('outboundRange.from', this.getTodayDate());
            url.searchParams.set('outboundRange.to', this.getFutureDate());
            url.searchParams.set('inboundRange.from', this.getTodayDate());
            url.searchParams.set('inboundRange.to', this.getFutureDate());
            url.searchParams.set('stayTime.min', '3');
            url.searchParams.set('stayTime.max', '7');
            url.searchParams.set('entryType', 'CHEAPEST');
            url.searchParams.set('grouping', 'DESTINATION_COUNTRY');
            url.searchParams.set('limit', '7');
            url.searchParams.set('addImages', 'true');
            url.searchParams.set('origins', 'country:' + AppConfig.getDefaultCountryCode());
            url.searchParams.set('destinations', 'country:*');

            return url.href;
        };

        this.getOffers = function () {
            return $http({
                method: 'GET',
                url: ctrl.buildUrl(),
                headers: {
                    'Accept-Language': AppConfig.getLanguageCode(),
                    'Slot': AppConfig.getAbConfig().ibe_slot_version
                }
            });
        };

        this.$onInit = function () {
            this.getOffers()
                .then(function (response) {
                    ctrl.results = response.data.cells;
                    ctrl.translations = response.data.translations;
                });
        };
    };

    controller.$inject = [
        'appConfig',
        '$http',
        'PriceFormatterService'
    ];

    angular
        .module('base')
        .component('leadOffersNew', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/navigation/backdrop.component.js
(function (angular) {

    var template = '\
        <div class="navigation-backdrop"></div>\
    ';

    angular
        .module('base')
        .component('backdrop', {
            template: template
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/navigation/close-button-section.component.js
(function (angular) {

    var template = '\
        <div class="close-button-section">\
            <button ng-click="$ctrl.onCloseButtonClick()" class="close-button-section__close-btn">\
                <svg-icon id="close-icon" class="size--25"></svg-icon>\
            </button>\
        </div>\
    ';

    angular
        .module('base')
        .component('closeButtonSection', {
            template: template,
            bindings: {
                onCloseButtonClick: '&',
            },
            controller: function () {

            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/navigation/menu-footer.component.js
(function (angular) {

    var template = '\
        <div class="navigation-menu-content__footer">\
            <p class="navigation-menu-content__footer-text1" translate>LANGM_JS_MENU_FOOTER_TEXT_1</p>\
            <a class="navigation-menu-link navigation-menu-content__footer-link"  href="{{ $ctrl.contactHref }}">\
                <svg-icon id="chat" class="size--25"></svg-icon>\
                <span translate>LANGM_JS_HELP_AND_SUPPORT</span>\
            </a>\
        </div>\
    ';

    angular
        .module('base')
        .component('menuFooter', {
            template: template,
            bindings: {
                contactHref: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/navigation/nav-accordion.js
(function (angular) {

    var template = '\
    <div class="nav-accordion">\
        <button\
            ng-click="$ctrl.onClick($event)"\
            class="nav-accordion__trigger">\
            <div class="nav-accordion__trigger-left">\
                <svg-icon ng-if="$ctrl.icon" id="{{ $ctrl.icon }}" class="size--25"></svg-icon>\
                {{ $ctrl.text }}\
            </div>\
            <div class="nav-accordion__trigger-right">\
                <svg-icon id="caret-navbar" class="size--25"></svg-icon>\
            </div>\
        </button>\
        <div class="nav-accordion__content">\
            <ng-transclude></ng-transclude>\
        </div>\
    </div>\
    ';

    angular
        .module('base')
        .component('navAccordion', {
            template: template,
            bindings: {
                text: '@',
                icon: '@?'
            },
            transclude: true,
            controller: function () {
                this.onClick = function (event) {
                    var triggerElement = event.target.closest('.nav-accordion__trigger');
                    var contentElement = triggerElement.nextElementSibling;
                    var isOpen = contentElement.style.maxHeight;

                    triggerElement.classList.toggle('nav-accordion__trigger--active');

                    if (isOpen) {
                        contentElement.style.maxHeight = null;
                    } else {
                        contentElement.style.maxHeight = contentElement.scrollHeight + 'px';
                    }
                };
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/responsive-info-button.component.js
(function(angular) {
var template = '\
        <article>\
            <span class="btn question-mark hidden-xs"\
                tooltip-placement="top"\
                tooltip-class="cc-tooltip"\
                tooltip-trigger="mouseenter"\
                tooltip-enable="true"\
                tooltip="{{ $ctrl.content }}">\
            </span>\
            <span class="btn question-mark visible-xs" ng-click="$ctrl.open()"></span>\
            <ith-responsive-tooltip id="{{ $ctrl.id }}">\
                <content ng-bind-html="$ctrl.content"></content>\
            </ith-responsive-tooltip>\
        </article>\
    ';

    var controller = function ($rootScope) {
        this.open = function () {
            $rootScope.$broadcast('rTooltip:open', this.id);
        };
    };

    controller.$inject = ['$rootScope'];

    var IthResponsiveInfoButtonComponent = {
        template: template,
        controller: controller,
        bindings: {
            content: '@',
            id: '@'
        }
    };

    angular
        .module('base')
        .component('ithResponsiveInfoButton', IthResponsiveInfoButtonComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/responsive-tooltip.component.js
(function(angular) {
var controller = function ($scope, $rootScope, $element, $document, $timeout, ModalHelper) {
        /**
         * Self reference
         *
         * @type {controller}
         */
        var ctrl = this;

        /**
         * Is visible
         */
        this.isVisible = false;


        this.isContentVisible = false;

        /**
         * Unregister events
         */
        this.events = {
            unregisterOpenHandler: null,
            unregisterCloseHandler: null,
            unregisterLocationHandler: null
        };

        /**
         * Click handler
         *
         * @param {Event} e
         */
        var clickHandler = function (e) {
            var elementFound = false;
            var thisElement = $element[0];

            angular.forEach(e.composedPath(), function (pathElement) {
                if (pathElement === thisElement) {
                    elementFound = true;
                }
            });

            if (!elementFound) {
                $scope.$evalAsync(function () {
                    ctrl.isVisible = false;
                });
                $document.off('click', clickHandler);
            }
        };

        /**
         * Open event handler
         *
         * @param {Event} e
         * @param {String} id
         */
        var openHandler = function (e, id) {
            if (id !== ctrl.id) {
                return;
            }

            if (ctrl.isVisible) {
                closeHandler(null, id);
                return;
            }

            ctrl.isVisible = true;

            $timeout(function () {
                ctrl.isContentVisible = true;
            }, 10);

            ModalHelper.lockBodyScroll();

            setTimeout(function () {
                $document.on('click', clickHandler);
            }, 10);
        };

        /**
         * Close event handler
         *
         * @param {Event} e
         * @param {String} id
         */
        var closeHandler = function (e, id) {
            if (id !== ctrl.id) {
                return;
            }

            ctrl.isVisible = false;
            ctrl.isContentVisible = false;
            ModalHelper.unlockBodyScroll();
            $document.off('click', clickHandler);
        };

        /**
         * Unsets events
         */
        this.unsetEvents = function () {
            this.events.unregisterOpenHandler();
            this.events.unregisterCloseHandler();
            this.events.unregisterLocationHandler();
        };

        /**
         * On init hook
         */
        this.$onInit = function () {
            $document.find('body').append($element);

            this.events.unregisterOpenHandler = $rootScope.$on('rTooltip:open', openHandler);
            this.events.unregisterCloseHandler = $rootScope.$on('rTooltip:close', closeHandler);
            this.events.unregisterLocationHandler = $scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
                var newUrlClean = newUrl.split('#')[0];
                var oldUrlClean = oldUrl.split('#')[0];

                if (newUrlClean !== oldUrlClean) {
                    closeHandler();
                    ctrl.unsetEvents();
                    $element.remove();
                }
            });
        };

        /**
         * Destroy hook
         */
        this.$onDestroy = function () {
            closeHandler();
            this.unsetEvents();
            $element.remove();
        };

        /**
         * Close the modal
         */
        this.close = function () {
            closeHandler(null, this.id);
        };
    };

    controller.$inject = ['$scope', '$rootScope', '$element', '$document', '$timeout', 'ModalHelper'];

    var template = '\
        <div class="ith-responsive-tooltip" ng-if="$ctrl.isVisible">\
            <div class="ith-responsive-tooltip__backdrop fade-in-anim" ng-click="$ctrl.close()" ng-if="$ctrl.isContentVisible"></div>\
            <div class="ith-responsive-tooltip__wrapper fade-in-anim slide-down-anim" ng-if="$ctrl.isContentVisible">\
                <div class="ith-responsive-tooltip__title" ng-if="!($ctrl.showCloseX === false && !$ctrl.title)">\
                    <h3 class="ith-responsive-tooltip__title__text">{{ :: $ctrl.title }}</h3>\
                    <ith-close-button ng-if="$ctrl.showCloseX !== false" ng-click="$ctrl.close()"></ith-close-button>\
                </div>\
                <div class="ith-responsive-tooltip__content" ng-transclude="content"></div>\
                <div class="ith-responsive-tooltip__footer">\
                    <div ng-transclude="footer"></div>\
                    <button ng-if="$ctrl.showCloseButton !== false" class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.close()" translate>LANGM_JS_CLOSE</button>\
                </div>\
            </div>\
        </div>\
    ';

    angular.module('base').component('ithResponsiveTooltip', {
        bindings: {
            id: '@',
            title: '@',
            showCloseButton: '<?',
            showCloseX: '<?'
        },
        transclude: {
            content: 'content',
            footer: '?footer'
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/responsive-tooltip.service.js
(function() {
var ResponsiveTooltipService = function ($rootScope) {
        /**
         *
         */
        this.openEventName = 'rTooltip:open';

        /**
         *
         */
        this.closeEventName = 'rTooltip:close';

        /**
         *
         * @param {string} id
         */
        this.open = function (id) {
            $rootScope.$broadcast(this.openEventName, id);
        };

        /**
         *
         * @param {string} id
         */
        this.close = function (id) {
            $rootScope.$broadcast(this.closeEventName, id);
        };
    };

    ResponsiveTooltipService.$inject = ['$rootScope'];

    angular
        .module('base')
        .service('ResponsiveTooltipService', ResponsiveTooltipService);

}());
;

// Source: ../shared/public_html/assets/js/base/components/reverse-directions.component.js
(function (angular) {

    var template = '\
        <button class="reverse-directions" tabindex="-1">\
            <svg-icon id="switch"></svg-icon>\
        </button>\
    ';

    angular
        .module('base')
        .component('reverseLocations', {
            template: template
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/review.component.js
(function(angular) {
var template = '\
        <div class="ith-reviews__review">\
            <svg-icon class="ith-reviews__review__icon" id="quotes"></svg-icon>\
            <strong class="ith-reviews__review__name">{{ :: $ctrl.review.name }}</strong>\
            <div class="ith-reviews__review__stars">\
                <svg-icon ng-repeat="star in [1, 2, 3, 4, 5]" id="star" ng-class="$ctrl.getClass($index)"></svg-icon>\
            </div>\
            <div class="ith-reviews__review__text" ng-bind-html="::$ctrl.review.text"></div>\
        </div>\
    \
    ';

    var IthReviewComponent = {
        template: template,
        bindings: {
            review: '<'
        },
        controller: function () {
            this.getClass = function (index) {
                return {
                    'review-star': true,
                    'review-star--gray': index > this.review.stars
                };
            };
        }
    };

    angular.module('base').component('ithReview', IthReviewComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/reviews.component.js
(function(angular) {
var template = '\
        <div class="ith-reviews">\
            <h2>{{ $ctrl.title }}</h2>\
            <div\
                class="ith-reviews__wrapper"\
                ng-mousedown="$ctrl.onMouseDown($event)"\
                ng-mousemove="$ctrl.onMouseMove($event)"\
                ng-mouseup="$ctrl.onMouseUp($event)"\
                ng-mouseout="$ctrl.onMouseOut($event)"\
                ng-touchstart="$ctrl.onTouchStart($event)"\
                ng-touchmove="$ctrl.onTouchMove($event)"\
                ng-touchend="$ctrl.onTouchEnd($event)"\
            >\
                <div class="ith-reviews__wrapper__list ng-animate-disabled" style="transform: translateX({{ $ctrl.offsetX }}px)" id="listModel" ng-class="$ctrl.getClassMap()">\
                    <div>\
                        <ith-review\
                            ng-repeat="review in $ctrl.reviews track by $index"\
                            review="review">\
                        </ith-reivew>\
                    </div>\
                    <div>\
                        <ith-review\
                            ng-repeat="review in $ctrl.reviews track by $index"\
                            review="review">\
                        </ith-reivew>\
                    </div>\
                </div>\
            </div>\
            <div class="ith-reviews__navigation">\
                <button class="ith-reviews__navigation__arrow ith-reviews__navigation__arrow--left" ng-click="$ctrl.shiftOffset(1)">\
                    <svg-icon id="caret"></svg-icon>\
                </button>\
                <span class="ith-reviews__navigation__dots">\
                    <button\
                        class="ith-reviews__navigation__dot"\
                        ng-repeat="review in $ctrl.reviews track by $index"\
                        ng-click="$ctrl.jumpToSlide($index)"\
                        ng-class="{ \'ith-reviews__navigation__dot--active\': $ctrl.isSlideActive($index) }"\
                    ><span></span></button>\
                </span>\
                <button class="ith-reviews__navigation__arrow ith-reviews__navigation__arrow--right" ng-click="$ctrl.shiftOffset(-1)">\
                    <svg-icon id="caret"></svg-icon>\
                </button>\
            </div>\
        </div>\
    \
    ';

    var IthReviewsComponent = {
        bindings: {
            title: '@',
            reviews: '<'
        },
        template: template,
        controller: ['$timeout', function ($timeout) {
            this.isDragging = false;
            this.snapOffset = 0;
            this.offsetX = 0;
            this.dragStartX = 0;
            this.dragStartY = 0;
            this.dragStartOffsetX = 0;
            this.dragDirection = 1;
            this.dragAmount = 0;
            this.isAnimated = true;

            var self = this;
            var listWidth = 0;
            var itemWidth = 0;

            this.jumpToSlide = function (index) {
                cacheWidths();
                this.isAnimated = true;
                this.offsetX = -index * itemWidth;
            };

            this.isSlideActive = function (index) {
                var absIndex = Math.abs(Math.round(this.getOffsetIndex()));

                if (absIndex > this.reviews.length - 1) {
                    absIndex = 0;
                }

                return absIndex === index;
            };

            this.shiftOffset = function (direction) {
                cacheWidths();
                $timeout(function () {
                    self.isAnimated = false;
                }, 30);

                var newOffset = self.offsetX + direction * itemWidth;

                if (newOffset > 0) {
                    $timeout(function () {
                        self.offsetX -= listWidth;
                    }, 50);
                }
                else if (newOffset < -listWidth) {
                    $timeout(function () {
                        self.offsetX += listWidth;
                    }, 50);
                }

                $timeout(function () {
                    self.isAnimated = true;
                }, 70);

                $timeout(function () {
                    self.offsetX = self.offsetX + direction * itemWidth;
                }, 100);
            };

            this.getClassMap = function () {
                return {
                    'ith-reviews__wrapper__list--dragging': this.isDragging,
                    'ith-reviews__wrapper__list--animated': this.isAnimated
                };
            };

            // Touch events
            this.onTouchStart = function ($event) {
                this.dragStart(
                    $event.touches[0].clientX,
                    $event.touches[0].clientY
                );
            };

            this.onTouchMove = function ($event) {
                var xOffset = Math.abs(this.dragStartX - $event.touches[0].clientX);
                var yOffset = Math.abs(this.dragStartY - $event.touches[0].clientY);

                if (xOffset > yOffset) {
                    $event.preventDefault();
                    this.drag($event.touches[0].clientX);
                }
            };

            this.onTouchEnd = function ($event) {
                this.dragEnd();
            };

            // Mouse events
            this.onMouseDown = function ($event) {
                this.dragStart($event.clientX, $event.clientY);
            };

            this.onMouseMove = function ($event) {
                this.drag($event.clientX);
            };

            this.onMouseUp = function ($event) {
                this.dragEnd();
            };

            this.onMouseOut = function ($event) {
                if (document.querySelector('.ith-reviews__wrapper__list').contains($event.fromElement)) {
                    return;
                }
                this.dragEnd();
            };

            this.dragStart = function (clientX, clientY) {
                cacheWidths();
                this.isAnimated = false;
                this.isDragging = true;
                this.dragStartOffsetX = clientX - this.offsetX;
                this.dragStartX = clientX;
                this.dragStartY = clientY;
                this.dragAmount = 0;
            };

            this.drag = function (clientX) {
                if (this.isDragging) {
                    this.offsetX = getClampedOffset(clientX - this.dragStartOffsetX);
                    this.dragDirection = this.dragStartX > clientX ? -1 : 1;
                    this.dragAmount = Math.abs(this.dragStartX - clientX);
                }
            };

            this.dragEnd = function () {
                this.isDragging = false;
                slideInPlace();
            };

            this.getOffsetIndex = function () {
                return this.offsetX / itemWidth;
            };

            this.$onInit = function () {
                $timeout(cacheWidths, 100);

                window.onresize = function () {
                    $timeout(function () {
                        self.jumpToSlide(
                            Math.abs(Math.round(self.getOffsetIndex()))
                        );
                    }, 100);
                };
            };

            var slideInPlace = function () {
                self.isAnimated = true;

                $timeout(function () {
                    var offsetIndex = self.dragDirection == 1
                        ? Math.ceil(self.getOffsetIndex())
                        : Math.floor(self.getOffsetIndex());

                    if (self.dragAmount < itemWidth / 6) {
                        offsetIndex = Math.round(self.getOffsetIndex());
                    }

                    self.offsetX = offsetIndex * itemWidth;
                }, 50);
            };

            var getClampedOffset = function (offset) {
                if (offset > 0) {
                    offset -= listWidth;
                }
                else if (offset < -listWidth) {
                    offset += listWidth;
                }

                return offset;
            };

            var cacheWidths = function () {
                var list = document.querySelector('.ith-reviews__wrapper__list');

                if (!list) {
                    return;
                }

                listWidth = list.clientWidth / 2;
                var itemElement = document.querySelector('.ith-reviews__review');
                var itemMargin = parseInt(window.getComputedStyle(itemElement).marginLeft);

                itemWidth = itemElement.clientWidth + itemMargin * 2;
            };
        }]
    };

    angular.module('base').component('ithReviews', IthReviewsComponent);

}(angular));


(function (angular) {
    var ngDragEventDirectives = {};

    angular.forEach(
        'mousedown mousemove mouseup mouseout touchstart touchmove touchend'.split(' '),
        function (eventName) {
            var directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

            ngDragEventDirectives[directiveName] = ['$parse', '$rootScope', function ($parse, $rootScope) {
                return {
                    restrict: 'A',
                    compile: function ($element, attr) {
                        var fn = $parse(attr[directiveName], null, true);

                        return function ngDragEventHandler(scope, element) {
                            element.on(eventName, function (event) {
                                var callback = function () {
                                    fn(scope, { $event: event });
                                };

                                scope.$apply(callback);
                            });
                        };
                    }
                };
            }];
        }
    );

    angular
        .module('base')
        .directive(ngDragEventDirectives);
}(angular));
;

// Source: ../shared/public_html/assets/js/base/components/selected-location.component.js
(function (angular) {

    var template = '\
        <button class="selected-location" ng-style="$ctrl.getStyleMap()" ng-show="$ctrl.loc.airportName || $ctrl.loc.cityName || $ctrl.loc.countryName">\
            <span class="selected-location__name">{{ $ctrl.loc.airportName || $ctrl.loc.cityName || $ctrl.loc.countryName }}</span>\
            <span class="selected-location__remove" ng-click="$ctrl.click($event, $ctrl.loc)">\
                <svg-icon id="xmark" class="size--10"></svg-icon>\
            </span>\
        </button>\
    ';

    angular
        .module('base')
        .component('selectedLocation', {
            template: template,
            bindings: {
                cth: '<',
                onLocationClick: '&',
                loc: '<',
                index: '<'
            },
            controller: function () {
                this.click = function ($event, location) {
                    $event.stopPropagation();
                    this.onLocationClick({
                        location: location,
                        flightType: this.cth.getFlightType()
                    });
                };

                this.getStyleMap = function () {
                    return {
                        opacity: this.index === this.cth.locationHighlight.getHighlightIndex() ? 0.5 : 1
                    };
                };
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/ChangeLangModalCtrl.js
(function(angular) {
/**
     * @name        ChangeLangModalCtrl
     * @description Controller for managing changing lang and currency.
     */
    var ChangeLangModalCtrl = function ($scope, $modalInstance, selectedData, appConfig, Base64, $http) {
        $scope.selectedLang     = selectedData.language;
        $scope.selectedCurrency = selectedData.currency;

        var langs      = appConfig.getAnotherLanguages();
        var currencies = appConfig.getCurrencies();

        $scope.langOptions     = langs.language;
        $scope.currencyOptions = currencies.currency;

        /**
         * Callback, with redirect / reload logic, runs on server response.
         *
         * @param urlToRedirect
         */
        var onSuccess = function(urlToRedirect) {
            if (appConfig.getLanguageCode() != $scope.selectedLang && urlToRedirect != null && urlToRedirect != false) {
                window.location.href = urlToRedirect;
            } else {
                window.location.reload();
            }
        };

        $scope.ok = function () {
            $scope.selectedData = {
                language: $scope.selectedLang,
                currency: $scope.selectedCurrency
            };

            var baseEncodedUrl = Base64.encode(window.location.href);
            var changeLanguageUrl = "api/changeLanguage/change/" + $scope.selectedLang + '/' + $scope.selectedCurrency + '/' + baseEncodedUrl + '/' + appConfig.isStaticPage()+ '/' + appConfig.isLandingPage();

            $http.get(changeLanguageUrl).success(onSuccess);
            $modalInstance.close($scope.selectedData);
        };

        $scope.close = function () {
            $modalInstance.dismiss();
        }

    };

    ChangeLangModalCtrl.$inject = [
        '$scope',
        '$modalInstance',
        'selectedData',
        'appConfig',
        'Base64',
        '$http',
        'UserService'
    ];

    angular.module('base').controller('ChangeLangModalCtrl', ChangeLangModalCtrl);
})(angular);

;

// Source: ../shared/public_html/assets/js/base/controllers/DynamicCssCtrl.js
(function(angular) {
/**
     * @name        DynamicCssController
     * @description Controller that injects css dynamically
     * @constructor
     */
    var DynamicCssController = function ($rootScope, CssService) {
        // State change event hook
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            //TODO: add mobile files when CO-11
            CssService.load(toState.name);
        });
    };

    DynamicCssController.$inject = [
        '$rootScope',
        'CssService'
    ];

    angular
        .module('base')
        .controller('DynamicCssCtrl', DynamicCssController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/FaBlockCtrl.js
angular.module('base')

/**
 * @name        ConfirmCtrl
 * @description Controls the FareAlerts confirmation
 */
.controller('FaBlockCtrl',
['$scope', '$stateParams', 'FareAlertsSrv', '$window',
function ($scope, $stateParams, FareAlertsSrv, $window) {
var
    /**
     * @type {String}
     */
    _uId,

    /**
     * @type {String}
     */
    _profileUrl,

    /**
     * @type {String|Boolean}
     */
    hash = $stateParams.hash ? $stateParams.hash : false,

    /**
     * @type {Object}
     */
    _bBox = {
      show: false,
      alreadyBlocked: false
    };

  $scope.bBox = _bBox;

  var _loadProfile = function (hash) {
    _bBox.loading = true;

    FareAlertsSrv.getData('profileData', {hash: hash}).then
    (
      function success(resp) {
        $scope.email = resp.email;

        _uId = resp.token;
        _profileUrl = resp.profileUrl;

        if (resp.blocked) {
          _bBox.alreadyBlocked = true;
        }

        _bBox.show = true;
        _bBox.loading = false;
      }
    );
  };

  $scope.blockFareAlert = function () {
    _bBox.loading = true;

    FareAlertsSrv.getData('blockAlerts', {hash: hash}).then
    (
      function success(resp) {
        $scope.email = resp.email;

        _uId = resp.token;
        _loadProfile(hash);
        _bBox.loading = false;
      }
    );
  };

  $scope.goBack = function () {
    $window.history.back();
  };

  $scope.goToFaProfile = function () {
    if (_uId) {
      window.location.href = _profileUrl;
    }
  };

  _loadProfile(hash);

}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/FaConfirmCtrl.js
angular.module('base')

/**
 * @name        ConfirmCtrl
 * @description Controls the FareAlerts confirmation
 */
.controller('FaConfirmCtrl',
['$scope', '$stateParams', 'FareAlertsSrv', '$window',
function($scope, $stateParams, FareAlertsSrv, $window)
{
var hash = $stateParams.hash ? $stateParams.hash : false;

  $scope.goBack = function()
  {
    $window.history.back();
  };

  if(hash)
  {
    $scope.showLoading = true;

    FareAlertsSrv.getData('profileData', {hash:hash}).then(function success(resp)
    {
      $scope.uId    = resp.token;
      $scope.email  = resp.email;
      $scope.showLoading = false;
    });
  }
}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/FareAlertsCreateCtrl.js
angular.module('base')


/**
 * @name        basic FareAlertsCtrl
 * @description Manages the fare alert page
 */
.controller('basicFareAlertsCtrl',
  ['$scope', 'FareAlertsSrv', 'CollectionGrouper',
    function basicFareAlertsCtrl($scope, FareAlertsSrv, CollectionGrouper)
    {
/**
       * Show group months label
       *
       * @param elements
       *
       * @returns {*}
       */
      $scope.showGroupMonths = function(elements)
      {
        var
          el = elements.split(','),
          monthsGrouper = new CollectionGrouper('months');


        // Delete empty values
        for (var key in el)
        {
          if (el[key] == ''||el[key]=='NaN')
          {
            el.splice(key, 1);
          }
        }
        monthsGrouper.setSelectedElements(el);
        return monthsGrouper.getLabel();
      };

      /**
       * Delete fare alert
       *
       * @param {int} id
       */
      $scope.delete = function(id)
      {
        FareAlertsSrv.deleteAlert({id:id, uId:$scope.formData.uId}).then(function success()
        {
          var hash = $scope.hash || '';
          $scope.getProfileData(hash);
        });
      };

    }
  ]
)


/**
 * @name        FareAlertsCreateCtrl
 * @description Create new fare alert
 */
.controller('FareAlertsCreateCtrl',
['$scope','FareAlertsLib',
function($scope, FaLib)
{
FaLib.showResetButton(false);
  FaLib.autoResetForm(true);
  FaLib.showFaProfile(false);
  FaLib.showEmailInput(true);
}])


/**
 * @name        FareAlertsActivateCtrl
 * @description Activate fare alerts
 */
.controller('FareAlertsActivateCtrl',
['$scope','FareAlertsSrv', '$location','$stateParams', '$controller',
function($scope, FaSrv, $location, $stateParams, $controller)
{
angular.extend(this, $controller('basicFareAlertsCtrl', {$scope: $scope}));

  $scope.hash              = $stateParams.hash || '';
  $scope.isShowActivateBox = true;

  // Accept InActive Alerts
  $scope.acceptInActiveAlerts = function()
  {
    FaSrv.getData('acceptInActiveAlerts', {token:$scope.hash})
      .then(function success(resp)
      {
        if(resp.url) $location.path( resp.url );
      });
  };

  /**
   * Remove InActive Alerts
   */
  $scope.removeInActiveAlerts = function()
  {
    FaSrv.getData('removeInActiveAlerts', {token:$scope.hash})
      .then(function success(resp)
      {
        if(resp.url) $scope.loadPage( resp.url );
      });
  };

  /**
   * Redirect to page
   *
   * @param {String} destUrl
   */
  $scope.loadPage = function (destUrl)
  {
    window.location.href = destUrl;
  };
}])

/**
* @name        FareAlertsCtrl
* @description Fare alerts profile
*/
.controller('FareAlertsCtrl',
['$scope', '$rootScope', '$stateParams', 'FareAlertsSrv', 'FareAlertsLib', '$filter', '$timeout', '$controller', 'PageLoading',
function FareAlertsCtrl($scope, $rootScope, $stateParams, FareAlertsSrv, FareAlertsLib, $filter, $timeout, $controller, PageLoading)
{
angular.extend(this, $controller('basicFareAlertsCtrl', {$scope: $scope}));

  $scope.uId     = $stateParams.uId;
  $scope.faId    = $stateParams.faId;
  $scope.faSetId = $stateParams.faSetId;
  $scope.hash    = $stateParams.hash ? $stateParams.hash : '';
  PageLoading.on();
  
  $timeout(function()
  {
    PageLoading.off();
  });

  /**
   * wait for userbar init
   */
  var $unwatch = $rootScope.$watch('profileMenuSwitch', function()
  {
    if ( angular.isFunction($rootScope.profileMenuSwitch) )
    {
      $unwatch();
      $rootScope.userBarCurrent = 'fareAlerts';
      $rootScope.profileMenuSwitch('DEFAULT_USER_BAR'); //show userBar
    }
  });

  /**
   * Unlock Fare Alerts & Get Profile data
   */
  $scope.unlockFareAlerts = function()
  {
    FareAlertsSrv.getData('unlockFareAlerts', {token:$scope.formData.uId})
      .then(function success()
      {

        var alert_msg = $filter('translate')('LANGM_JS_FAM_THANK_PROFILE_WAS_UNLOCKED', {});
        if(!FareAlertsLib.isAlertExists(alert_msg, $scope.alerts)) {
          $scope.addAlert('success', alert_msg);
        }

        $scope.getProfileData();
      });
  };

  /**
   * Redirect to page
   * @param {String} destUrl
   */
  $scope.loadPage = function (destUrl ,target)
  {
    if(target)
    {
      window.open(destUrl, target);
    }
     else
    {
      window.location.href = destUrl;
    }
  };

}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/NgStaticPageCtrl.js
(function (angular) {
angular.module('base')
        .controller('NgStaticPageCtrl', function () {
            // Empty
        });

})(angular);
;

// Source: ../shared/public_html/assets/js/base/controllers/RefundClaim.controller.js
(function(angular) {
/**
     * Possible refund page states
     * @type {Object}
     */
    var REFUND_PAGE_STATES = {
        PRELOADING: 'preloading',
        INFO: 'info',
        SUCCESS: 'success',
        TERMS_ALREADY_ACCEPTED: 'terms_already_accepted',
        ERROR: 'error'
    };

    /**
    * @name        RefundClaimController
    * @description Handles data inside the refund claim page.
    * @constructor
    * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
    */
    var RefundClaimController = function ($state, $window, $filter, RefundClaimApi, REFUND_PAGE_STATES) {
        /**
         * Self reference
         * @type {RefundClaimController}
         */
        var ctrl = this;

        /**
         * Refund page states
         * @type {Object}
         */
        this.pageStates = REFUND_PAGE_STATES;

        /**
         * Current page state
         * @type {String}
         */
        this.currentState = REFUND_PAGE_STATES.PRELOADING;

        /**
         * Switch for saving user data
         * @type {Boolean}
         */
        this.saving = false;

        /**
         * Voucher details object
         * @type {Object}
         */
        this.voucherDetails = {};

        /**
         * Validation error
         * @type {Boolean}
         */
        this.validationError = false;

        /**
         * Form data
         * @type {Object}
         */
        this.formData = {
            terms_accepted: false
        };

        /**
         * Info page title
         * @type {String}
         */
        this.infoTitle = '';

        /**
         * Info page content
         * @type {String}
         */
        this.infoContent = '';

        /**
         * Info page content
         * @type {Array}
         */
        this.consents = [];

        /**
         * Thank You page title
         * @type {String}
         */
        this.confirmTitle = '';

        /**
         * Thank You page content
         * @type {String}
         */
        this.confirmContent = '';

        /**
         * Init hook
         */
        this.$onInit = function () {
            this.currentState = REFUND_PAGE_STATES.PRELOADING;

            RefundClaimApi
                .loadInitialData($state.params.hash)
                .then(function (successResponse) {
                    ctrl.voucherDetails = successResponse.data.response;
                    var content = ctrl.voucherDetails.content.info;
                    setState(REFUND_PAGE_STATES.INFO, content.title);
                    ctrl.infoTitle = content.title;
                    ctrl.infoContent = content.content;
                    ctrl.consents = (ctrl.voucherDetails.consents || []).map(function (consent) {
                        return {
                            text: consent,
                            accepted: false,
                            error: false,
                        };
                    });
                })
                .catch(function (error) {
                    var errorCode = error.data.response.error_code || '';

                    // TODO: handle this
                    var claim = error.data.response.claim;

                    switch (errorCode) {
                        case 'cancel_help_error_2':
                            setState(REFUND_PAGE_STATES.TERMS_ALREADY_ACCEPTED);
                            break;

                        default:
                            setState(REFUND_PAGE_STATES.ERROR);
                            break;
                    }
                })
                .finally(function () {
                    $window.scrollTo(0, 0);
                });
        };

        /**
         * Submits user's choice
         *
         * @param {String} claim
         */
        this.submit = function (claim) {
            if (!this.userAgreedTerms()) {
                return;
            }

            this.saving = true;

            RefundClaimApi
                .saveData($state.params.hash, {
                    terms_accepted: true,
                    claim: claim
                })
                .then(function (success) {
                    var content = success.data.response.content.confirm;
                    setState(REFUND_PAGE_STATES.SUCCESS, content.title);
                    ctrl.confirmTitle = content.title;
                    ctrl.confirmContent = content.content;
                })
                .catch(function (error) {
                    ctrl.validationError = true;
                })
                .finally(function () {
                    ctrl.saving = false;
                    $window.scrollTo(0, 0);
                });
        };

        /**
         * Checks if user agreed the terms
         * @returns {Boolean}
         */
        this.userAgreedTerms = function () {
            var allAccepted = true;

            ctrl.consents.forEach(function (consent) {
                consent.error = !consent.accepted;
                allAccepted &= !!consent.accepted;
            });

            return allAccepted;
        };

        /**
         * Returns total voucher value
         * @returns {String}
         */
        this.getVoucherValue = function () {
            return $filter('flPrice')(this.voucherDetails.price + this.voucherDetails.extra);
        };

        /**
         * Returns voucher price
         * @returns {String}
         */
        this.getVoucherPrice = function () {
            return $filter('flPrice')(this.voucherDetails.price);
        };

        /**
         * Returns voucher extra
         * @returns {String}
         */
        this.getVoucherExtra = function () {
            return $filter('flPrice')(this.voucherDetails.extra);
        };

        /**
         * Returns origin city
         * @returns {String}
         */
        this.getOriginCity = function () {
            return this.voucherDetails.departure;
        };

        /**
         * Returns destination city
         * @returns {String}
         */
        this.getDestinationCity = function () {
            return this.voucherDetails.destination;
        };

        /**
         * Returns variables for text boxes
         * @returns {Object}
         */
        this.getTextBoxVariables = function () {
            return {
                voucherValue: ctrl.getVoucherValue(),
                voucherPrice: ctrl.getVoucherPrice(),
                voucherExtra: ctrl.getVoucherExtra(),
                originCity: ctrl.getOriginCity(),
                destinationCity: ctrl.getDestinationCity()
            };
        };

        this.$onInit();

        /**
         * @param state
         * @param title
         */
        function setState(state, title) {
            ctrl.currentState = state;
            title = title || $filter('translate')(findTitle(state), ctrl.getTextBoxVariables());
            document.querySelector('title').innerHTML = stripHtml(title);
        }

        /**
         * @param state
         * @return {string}
         */
        function findTitle(state) {
            switch (state) {
                case REFUND_PAGE_STATES.INFO:
                    return 'LANGM_JS_FROLA_VOUCHERS_LP_TITLE';
                case REFUND_PAGE_STATES.SUCCESS:
                case REFUND_PAGE_STATES.TERMS_ALREADY_ACCEPTED:
                    return 'LANGM_JS_FROLA_VOUCHERS_LP_THANK_YOU_TITLE';
                case REFUND_PAGE_STATES.ERROR:
                    return 'LANGM_JS_FROLA_VOUCHERS_LP_ERROR_TITLE';
            }
        }

        /**
         * @param html
         * @return {string}
         */
        function stripHtml(html) {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        }
    };

    RefundClaimController.$inject = [
        '$state',
        '$window',
        '$filter',
        'RefundClaimApi',
        'REFUND_PAGE_STATES'
    ];

    angular
        .module('base')
        .controller('RefundClaimCtrl', RefundClaimController)
        .constant('REFUND_PAGE_STATES', REFUND_PAGE_STATES);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/SomeCtrl.js
angular.module('base')

  /**
   * @name        SomeCtrl
   * @description Some test controller
   */
  .controller('SomeCtrl',
    ['$scope', 'FeedbackService',
      function($scope, FeedbackService)
      {
var data = {};

        $scope.setPrice = function(name,price){
          data.name = name;
          data.price = Math.round(price);
        };

        this.getData = function(){
          return data;
        }

      }]);
;

// Source: ../shared/public_html/assets/js/base/controllers/StaticCollapseCtrl.js
angular.module('base')
.controller('StaticCollapseCtrl',['$scope',function($scope){
  $scope.isCollapsed1 = $scope.isCollapsed2 = $scope.isCollapsed3 = true;
}]);;

// Source: ../shared/public_html/assets/js/base/controllers/ViewportCtrl.js
(function(angular, _js_app_config_) {
/**
     * @name        ViewportCtrl
     * @description Controls the meta viewport content
     * @constructor
     */
    var ViewportCtrl = function($scope, $rootScope, $window) {
        /**
         * Viewport settings
         * @type {Object}
         * @private
         */
        var viewports = {
            mobileUp: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
            tabletUp: 'width={{value}}'
        };

        /**
         * The last state in routes, it influences the way we show pages on devices
         * @type {String}
         * @private
         */
        var _lastState = '';

        /**
         * Changes the meta viewport
         * @private
         */
        function _calculateViewport() {
            /**
             * Pages that should work on mobile
             * @type {Array}
             */
            var mobilePages = [
                'homepage',
                'landingPages',
                'landingPagesNonParams',
                'flight_details',
                'thank_you',
                'lpNoParams',
                'ngStaticPageShow',
                'insStandalone',
                'faqHome',
                'faqShow',
                'search_results',
                'search_results2',
                'ngPayment2',
                'myBookings',
                'passengers',
                'preferences',
                'searchHistory',
                'cashBack',
                'fareAlertProfile',
                'setPassword',
                'checkin_standalone',
                'hotel_search_results',
                'hotel_details_page',
                'hotel_booking',
                'hotel_confirmation',
                'package_search_results',
                'package_details'
            ];

            /**
             * Calculated viewport width
             */
            var vpWidth;

            if(_js_app_config_.device.mobile && mobilePages.indexOf(_lastState) !== -1) {
                // Use mobile up viewport
                $scope.viewportContent = viewports.mobileUp;
            } else {
                // Use tablet up viewport
                vpWidth = $window.outerWidth;

                if(vpWidth < 768) {
                    vpWidth = 768;
                }

                // Update viewport
                $scope.viewportContent = viewports.tabletUp.replace('{{value}}', vpWidth);
            }
        }

        /**
         * Called when browser is resized or device turned
         * @private
         */
        function _onResize() {
            _calculateViewport();
        }

        /**
         * Binds to browser resize event
         * @private
         */
        function _bind() {
            angular.element($window).bind('resize orientationchange', _onResize);
        }

        /**
         * Cleans up bindings on destroy
         * @private
         */
        function _unbind() {
            angular.element($window).unbind('resize orientationchange', _onResize);
        }

        // State change event hook
        $rootScope.$on('$stateChangeStart', function(event, toState) {
            _lastState = toState.name;
            _calculateViewport();
        });

        // Destroy event hook, cleans up bindings on destroy
        $scope.$on('$destroy', _unbind);

        // Init
        _bind();
    };

    ViewportCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$window'
    ];

    angular.module('base')
        .controller('ViewportCtrl', ViewportCtrl);

})(angular, _js_app_config_);
;

// Source: ../shared/public_html/assets/js/base/controllers/customModal.js
angular.module('base')
/**
 * @name        customModalCtrl
 * @description Controller for modal
 */
.controller('customModalCtrl',
['$scope', '$modalInstance',
function($scope, $modalInstance)
{
/**
   * Hide modal
   */
  $scope.hide = function()
  {
    $modalInstance.dismiss('cancel');
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/flightsFormErrorsModal.js
angular.module('base')
/**
 * @name        flightsFormErrorsModalCtrl
 * @description Controller for errors modal in flights form
 */
.controller('flightsFormErrorsModalCtrl',
['$scope', '$modalInstance', 'errors',
function($scope, $modalInstance, errors)
{
/**
   * Errors data
   *
   * @type {Object}
   */
  $scope.errors = errors;

  /**
   * Hide modal
   */
  $scope.hide = function()
  {
    $modalInstance.dismiss('cancel');
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/ith-cfar-claim.component.js
(function (angular) {
angular
        .module('base')
        .component('ithCfarClaim', {
            templateUrl: '/tpl/show/jsShared/templates/cfar/claim',
            controller: 'CfarClaimCtrl'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/ith-cfar-claim.controller.js
(function(angular) {
/**
     *
     * @param {*} $filter
     * @param {*} CfarApi
     */
    var CfarClaimController = function ($filter, CfarApi) {
        /**
         * Page states
         *
         * @type {Object}
         */
        this.states = {
            /**
             * Initial state
             */
            FORM: 'initial',

            /**
             * CFAR available
             */
            AVAILABLE: 'available',

            /**
             * Cancelled state
             */
            CANCELLED: 'cancelled',

            /**
             * Rebooked state
             */
            REBOOKED: 'rebooked',

            /**
             * CFAR not available state
             */
            NOT_AVAILABLE: 'not-available'
        };

        /**
         * Current page state
         *
         * @type {String}
         */
        this.currentState = this.states.FORM;

        /**
         * Cfar price
         *
         * @type {Number}
         */
        this.cfarPrice = 0;

        /**
         * Claim amount
         *
         * @type {Number}
         */
        this.claimAmount = 0;

        /**
         * Backend error label
         *
         * @type {String}
         */
        this.backendErrorLabel = null;

        /**
         * Was there a request error?
         *
         * @type {Boolean}
         */
        this.requestError = false;

        /**
         *
         */
        this.responseVariables = {
            deadline: ''
        };

        /**
         * Payload for claim endpoint
         *
         * @type {Object}
         */
        this.payload = {
            /**
             * Reservation number
             *
             * @type {String}
             */
            reservationNumber: '',

            /**
             * User's email address
             *
             * @type {String}
             */
            email: ''
        };

        /**
         * Loading state
         *
         * @type {Boolean}
         */
        this.isLoading = false;

        /**
         * Form submit
         */
        this.submit = function (ngForm) {
            if (ngForm.$invalid) {
                return;
            }

            this.isLoading = true;
            var self = this;

            CfarApi
                .getClaimDetails(
                    this.payload.reservationNumber,
                    this.payload.email
                )
                .then(function (success) {
                    var code = success.data.http_code;

                    if (code === 400) {
                        self.requestError = true;
                    }

                    if (code === 200) {
                        self.cfarPrice = success.data.response.cfarPrice;
                        self.claimAmount = success.data.response.claimAmount;
                        self.currentState = self.states.AVAILABLE;
                    }

                    if (code === 422) {
                        self.backendErrorLabel = success.data.response.label;
                        self.currentState = self.states.NOT_AVAILABLE;

                        if (success.data.response.variables && success.data.response.variables.deadline_date) {
                            self.responseVariables.deadline = success.data.response.variables.deadline_date;
                        }
                    }
                })
                .catch(function () {
                    self.requestError = true;
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        /**
         * Returns error titie lang based on bakend error label
         *
         * @returns {String}
         */
        this.getErrorTitleLang = function () {
            return 'LANGM_JS_CFAR_LP_' + this.backendErrorLabel;
        };

        /**
         * Returns error content based on backend error label
         *
         * @returns {String}
         */
        this.getErrorDescriptionTextBox = function () {
            return 'cfar_lp_' + this.backendErrorLabel.toLowerCase();
        };

        /**
         * Changes state to form state
         */
        this.backToForm = function () {
            this.currentState = this.states.FORM;
        };

        /**
         * Returns text box variables
         *
         * @returns {Object}
         */
        this.getTextBoxVariables = function () {
            return {
                cfarPrice: $filter('flPrice')(this.cfarPrice, 2),
                claimAmount: $filter('flPrice')(this.claimAmount, 2),
                reservationNumber: this.payload.reservationNumber,
                deadline: $filter('date')(new Date(this.responseVariables.deadline).getTime(), 'dd MMMM yyyy, HH:mm')
            };
        };

        /**
         * Makes final request to cancel the reservation
         */
        this.cancelReservation = function () {
            var self = this;
            self.isLoading = true;

            makeApiRequest(this.payload, false)
                .then(function () {
                    self.currentState = self.states.CANCELLED;
                })
                .catch(function () {
                    self.requestError = true;
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        /**
         * Makes final request to rebook the reservation
         */
        this.rebookReservation = function () {
            var self = this;
            self.isLoading = true;

            makeApiRequest(this.payload, true)
                .then(function () {
                    self.currentState = self.states.REBOOKED;
                })
                .catch(function () {
                    self.requestError = true;
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        var makeApiRequest = function (payload, isRebook) {
            return CfarApi.claim(
                payload.reservationNumber,
                payload.email,
                isRebook
            );
        };
    };

    CfarClaimController.$inject = ['$filter', 'CfarApi'];

    angular
        .module('base')
        .controller('CfarClaimCtrl', CfarClaimController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/ith-fare-confirm.controller.js
(function (angular, moment) {
/**
     * @name        FareConfirmController
     * @constructor
     */
    var FareConfirmController = function ($state, $location, $interval, $q, $filter, Socket, UUID, AncillariesApi, AncillariesApiPayload, FareLockApi, PageLoading, FlightDetails, FARE_LOCK_STATES, FareLockDatalayerHelper) {
        /**
         * @type {object}
         */
        this.states = FARE_LOCK_STATES;

        /**
         * Self reference
         * @type {FareConfirmController}
         */
        var ctrl = this;

        /**
         * Socket id for pusher communication
         *
         * @type {String}
         */
        this.socketId = '';

        /**
         *
         */
        this.isRedirecting = false;

        /**
         * Current page state
         *
         * @type {String}
         */
        this.currentState = this.states.LOADING;

        /**
         * Thank You page content
         * @type {String}
         */
        this.content = null;

        ctrl.templateVars = {};

        /**
         * @type {FlightDetails}
         */
        this.flightDetails = FlightDetails;

        /**
         * @type {string}
         */
        this.uuid = $state.params.uuid;

        this.timeLeft = {
            hours: 0,
            minutes: 0,
            seconds: 0
        };

        this.dependenciesLoaded = 0;

        PageLoading.on();

        var updateTimeLeft = function () {
            var now = moment().utc();
            var limit = moment(ctrl.content.expiryDate).utc();

            ctrl.timeLeft.hours = limit.diff(now, 'hours');
            ctrl.timeLeft.minutes = limit.diff(now, 'minutes') - limit.diff(now, 'hours') * 60;
            ctrl.timeLeft.seconds = limit.diff(now, 'seconds') - limit.diff(now, 'minutes') * 60;

            if (now.isAfter(limit)) {
                ctrl.currentState = ctrl.states.EXPIRED;
            }
        };

        var initSocket = function () {
            var deferred = $q.defer();

            Socket.init().then(function () {
                ctrl.socketId = UUID.v4();
                deferred.resolve();

                Socket.subscribe(ctrl.socketId, 'search_completed', function (message) {
                    ctrl.onDependencyLoaded();

                    switch (message.type) {
                        case 'fare_lock':
                            ctrl.currentState = message.data.status;
                            ctrl.content = message.data;

                            ctrl.templateVars = {
                                until: $filter('date')(ctrl.content.expiryDate, 'dd.MM.yyyy HH:mm'),
                                maxDiff: $filter('flPrice')(
                                    parseFloat(ctrl.content.coveredAmount.amount) - parseFloat(ctrl.content.flightPrice.amount),
                                    2
                                ),
                                price: $filter('flPrice')(ctrl.content.price.amount, 2)
                            };

                            if (ctrl.currentState === ctrl.states.CONFIRMED) {
                                $interval(updateTimeLeft, 1000);
                            }

                            Socket.unsubscribe();
                            break;

                        default:
                            console.error('Ancillaries web socket responsed with unimplemented type', message.type);
                            break;
                    }
                });

                var payload = new AncillariesApiPayload(ctrl.socketId, null, null, null, null);
                payload.addFareLock(ctrl.uuid);
                AncillariesApi.initFareConfirm(payload);
            });

            return deferred.promise;
        };

        this.getTimeLeft = function () {
            return Object
                .values(this.timeLeft)
                .map(function (value) {
                    return value < 10 ? '0' + value : value;
                })
                .join(':');
        };

        this.goToThankYouPage = function () {
            ctrl.isRedirecting = true;
            $location.path(ctrl.flightDetails.reservation.confirmation_page);
        };

        this.goToFlightDetails = function () {
            if (this.isRedirecting) {
                return;
            }

            this.isRedirecting = true;

            FareLockDatalayerHelper.onContinueToBookingEvent();

            FareLockApi
                .prepareOffer(ctrl.uuid, $location.search().debughttpcode)
                .then(function (response) {
                    $location.path(response.data.response.redirectUrl);
                })
                .catch(function (error) {
                    var errorCode = error.data.response.error_code || 400;

                    switch (errorCode) {
                        case 404:
                            // not found, should we create zammad? or allow to chose other similar flight?
                            ctrl.currentState = ctrl.states.NOT_FOUND;
                            break;

                        case 409:
                            // already used
                            ctrl.currentState = ctrl.states.ALREADY_USED;
                            break;

                        case 422:
                        default:
                            // wrong fare lock status PLEASE RELOAD (only confirmed should allow to trigger redirect to FD)
                            $state.reload();
                            break;
                    }
                })
                .finally(function () {
                    ctrl.isRedirecting = false;
                });
        };

        this.onDependencyLoaded = function () {
            this.dependenciesLoaded++;

            if (this.dependenciesLoaded > 1) {
                PageLoading.off();
            }
        };

        this.$onInit = function () {
            initSocket();

            FareLockApi
                .getFlightInformation(this.uuid)
                .then(function (response) {
                    ctrl.flightDetails.srvSet(response.data.response);
                    ctrl.onDependencyLoaded();
                });
        };

        this.$onInit();
    };

    FareConfirmController.$inject = [
        '$state',
        '$location',
        '$interval',
        '$q',
        '$filter',
        'Socket',
        'UUID',
        'AncillariesApi',
        'AncillariesApiPayload',
        'FareLockApi',
        'PageLoading',
        'fdt.FlightDetails',
        'FARE_LOCK_STATES',
        'FareLockDatalayerHelper'
    ];

    angular
        .module('base')
        .controller('FareConfirmCtrl', FareConfirmController);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/base/controllers/newsletterRegisterCtrl.js
angular.module('base')

/**
 * @name        ConfirmCtrl
 * @description Controls the FareAlerts confirmation
 */
.controller('NewsletterRegisterCtrl',
['$scope', 'NewsletterSrv', '$timeout', '$filter', 'RodoService',
function($scope, NewsletterSrv, $timeout, $filter, RodoService)
{
$scope.newsletter = {
    messages: {},
    message: '',
    terms: {
      agree: false,
      error: false
    },
    form: {
      nl_place_name: 'newsletter-register'
    },
    error: false,
    submitting: false
  };

  $scope.newsletter.save = function() {
    $scope.newsletter.submitting = true;

    if (RodoService.isEnabled('nlRegister') && RodoService.getSettings().nlSubscribeConsent && !$scope.newsletter.terms.agree) {
      // User must agree terms to continue
      $scope.newsletter.terms.error = true;
      $scope.newsletter.submitting = false;
      return;
    }

    $scope.newsletter.terms.error = false;

    NewsletterSrv
      .addToNewsletter($scope.newsletter.form)
      .then(function success(response) {
        response = angular.fromJson(response);
        var success = /^SUCCESS/;

        if(response && success.test(response.nl_status)) {
          $scope.newsletter.error = false;
          $scope.newsletter.message = $filter('translate')('LANGM_JS_NEWSLETTER_REGISTER_SUCCESS');
        } else {
          $scope.newsletter.error = true;
          $scope.newsletter.message = $filter('translate')('LANGM_JS_NEWSLETTER_REGISTER_ERROR');
        }
      }, function error(response) {
        $scope.newsletter.error = true;
        $scope.newsletter.message = $filter('translate')('LANGM_JS_NEWSLETTER_REGISTER_ERROR');
      })
      .finally(function () {
        $scope.newsletter.submitting = false;
      });
  };

}]);
;

// Source: ../shared/public_html/assets/js/base/controllers/paymentCtrl.js
angular.module('base').controller('paymentCtrl',
    ['$location', '$rootScope', '$scope', '$sce', '$stateParams', '$timeout', 'PaymentPage', 'bok.CreditCard', '$modal', '$exceptionHandler', 'PageLoading', 'bok.ZoozArgs', 'bok.ZoozServ',
        'PaymentTokenize', 'appConfig', 'ErrorLogService', 'PaymentApi',
        function ($location, $rootScope, $scope, $sce, $stateParams, $timeout, PaymentPage, CreditCard, $modal, $exceptionHandler,
                  PageLoadingService, ZoozArgs, ZoozServ, PaymentTokenize, appConfig, ErrorLogService, PaymentApi) {
$scope.inProcess = false;
            $scope.model = new CreditCard();
            $scope.paymentError = false;

            $scope.errorBasketForCurrencySwitch = {
                getTotalPrice: function() {
                    if(typeof $scope.details === 'undefined') {
                        return 0;
                    } else {
                        return $scope.details.currency === 'RON' ?
                            ($scope.details.amount / $scope.exchangeInfo.rate) :
                            $scope.details.amount;
                    }
                },
                getTotalRonPrice: function() {
                    if(typeof $scope.exchangeInfo === 'undefined') {
                        return 0;
                    } else {
                        return (this.getTotalPrice() * $scope.exchangeInfo.rate);
                    }
                },
                getTotalPriceCurrency: function (currency) {
                    if (typeof $scope.exchangeInfo === 'undefined') {
                        return 0;
                    } else {
                        return (this.getTotalPrice() * $scope.exchangeInfo.rate);
                    }
                }
            };


            PageLoadingService.on();
            /**
             * Load Check in
             */
            $scope.loadPayment = function() {
                var data = {};
                data.id = $stateParams.reqId;
                data.ngData = 1;

                PaymentPage.index(data, $location.search())
                    .then(function success(response) {
                        if(response.redirect) {
                            window.location.href = response.redirect;
                        }
                        $scope.message = response.message;
                        $scope.details = response.details;
                        $scope.exchangeInfo = response.exchangeInfo;

                        var credentials = response.credentials ? response.credentials : [];
                        PaymentTokenize.setCredentials(credentials);

                        if(!$scope.exchangeInfo) {
                            $scope.model.setDisableCurrencySwitch(true);
                        } else {
                            $scope.model.setDisableCurrencySwitch(response.standaloneIns);
                        }

                    }, function() {
                        $scope.paymentError = true;
                    }).finally(function() {
                    PageLoadingService.off();
                });
            };

            var isCardValid = function(ccForm) {
                var form = ccForm.creditCardForm;

                form.$setDirty(true);
                form.$setSubmitted(true);

                var errorCount = 0;

                for(var k in form.$error) {
                    errorCount++;
                }

                return !errorCount;
            };

            /**
             * Make Payment
             */
            $scope.cardPayment = function(model, ccForm) {
                $rootScope.$broadcast('form-submit:validate');

                if(!isCardValid(ccForm)) {
                    $scope.inProcess = false;
                    return;
                }

                var
                    data = {
                        id: $stateParams.reqId,
                        ngData: 1
                    },
                    name = ($scope.model.fullName) ? $scope.model.fullName.split(' ') : ['', ''];

                var expDate = $scope.model.newExp.split('/');

                data.payment = {};
                data.payment.details = {};

                var credentials = PaymentTokenize.findCredential({
                    currency: getCreditCardCurrency(),
                    paymentType: 'CC'
                });

                PaymentTokenize.init(credentials)
                  .then(function() {
                      return PaymentTokenize.tokenize({
                          full_name: $scope.model.fullName,
                          expiration: '20' + expDate[1] + '-' + expDate[0] + '-01',
                          number: ($scope.model.number) ? $scope.model.number.replace(/ /gi, '') : '',
                          cvc: $scope.model.cvc
                      });
                  })
                  .then(function(tokenized) {
                      data.payment.details = angular.merge({}, tokenized, {
                          type: $scope.model.id,
                          gatewayParams: credentials.params,
                          validationType: tokenized.validationType,
                      });

                      if(!$scope.model.getDisableCurrencySwitch()) {
                          data.payment.details.currency = $scope.model.currency;
                      }

                      $scope.model.tokenize(tokenized);
                  })
                  .catch(function(error) {
                      if (!(error instanceof TypeError) && error instanceof Error) {
                          // dont log 'Wrong driver' tokenization problem
                          // @see PaymentTokenize.init
                          ErrorLogService.sendErrorLog(error);
                      }
                      if (!appConfig.isEnvProd()) {
                          console.trace('PaymentTokenize', error);
                      }

                      data.payment.details.number = ($scope.model.number) ? $scope.model.number.split(' ') : '';
                      data.payment.details.cvc = $scope.model.cvc;
                      data.payment.details.firstName = name[0];
                      data.payment.details.lastName = name[1];
                      data.payment.details.type = $scope.model.id;
                      data.payment.details.validationType = CreditCard.VALIDATION_NUMBER;

                      if(!$scope.model.getDisableCurrencySwitch()) {
                          data.payment.details.currency = $scope.model.currency;
                      }

                      data.payment.details.expDate = {
                          0: parseInt(expDate[0], 10),
                          1: parseInt('20' + expDate[1], 10)
                      };
                  })
                  .finally(function() {
                      processPayment(data);
                  });

                $scope.model.errors = {};
                $scope.inProcess = true;
            };

            /**
             * @returns {string}
             */
            function getCreditCardCurrency() {
                return $scope.model.getCurrencyCode() || appConfig.getCurrencyCode();
            }

            function processPayment(data) {
                PaymentPage.index(data)
                    .then(function success(response) {
                            if ($scope.model.tokenized) {
                                if (response.version === data.payment.details.validationType) {
                                    microserviceFlow(response);
                                } else {
                                    $scope.inProcess = false;
                                    $exceptionHandler(new Error('Payment error: validation type does not match response version'));
                                }
                            } else {
                                if (response.bookingResponse.paymentForm) {
                                    // Submit form
                                    $rootScope.$broadcast('paymentGatewayZooz', {
                                        url: $sce.trustAsResourceUrl(response.bookingResponse.paymentForm.url),
                                        method: "post",
                                        data: response.bookingResponse.paymentForm.fields,
                                        id: "PAEnrollForm"
                                    });
                                } else {
                                    if (response.bookingResponse.redirectLink) {
                                        window.location.href = response.bookingResponse.redirectLink;
                                    } else {
                                        if (response.payment.modal) {

                                            var modalData = {
                                                bookingResponse: {
                                                    html: response.payment.modal
                                                }
                                            };

                                            $scope.saferPayModal(modalData);
                                        } else {
                                            if (response.payment.errors.payment.details) {
                                                $scope.model.errors = response.payment.errors.payment.details;
                                            }

                                            $scope.inProcess = false;
                                        }
                                    }
                                }
                            }
                        },
                        function (response) {
                            paymentError(response);
                        });
            }

            function microserviceFlow(response) {
                var redirectLink = response.redirectLink;
                $scope.openPaymentProcessingModal({bookingResponse: {html: response.payment.modal}});

                return PaymentApi
                    .initPurchase(response.bookingResponse.paymentServiceParams, $scope.model, response.version)
                    .then(function (response) {
                        handleInitPurchaseResponse(response, redirectLink);
                    }).catch(function (error) {
                        $scope.paymentProcessingModal.close();
                        $scope.inProcess = false;
                        $exceptionHandler(error instanceof Error ? error : new Error('Payment error'));
                    });
            }

            function handleInitPurchaseResponse(initPurchaseResponse, redirectLink) {
                if (initPurchaseResponse.redirect_type === 'form') {
                    submitForm(initPurchaseResponse.redirect_attributes, initPurchaseResponse.redirect_url);
                } else if (initPurchaseResponse.redirect_url) {
                    window.location.href = initPurchaseResponse.redirect_url;  // 3DS
                } else {
                    window.location.href = redirectLink;
                }
            }

            function submitForm(redirectAttributes, redirectUrl) {
                var formAttributes = redirectAttributes.reduce(function (attributes, current) {
                    attributes[current.name] = current.value;
                    return attributes;
                }, {});

                $timeout(function () {
                    $rootScope.$broadcast('paymentGatewayMicroservice',
                        {
                            url: $sce.trustAsResourceUrl(redirectUrl),
                            method: "post",
                            data: formAttributes,
                            id: "cardPaymentGatewayMicroservice"
                        });
                }, 2000);
            }

            function paymentError(response) {
                if (response.response.expiredLink === true) {
                    $scope.paymentError = true;
                } else {
                    if (response.payment.errors.payment.details) {
                        $scope.model.errors = response.payment.errors.payment.details;
                    }
                    $scope.inProcess = false;

                    $exceptionHandler(new Error('Payment problem ', response.payment.errors));
                }
            }

            /**
             * Saferpay modal
             */
            $scope.saferPayModal = function (response) {
                $modal.open({
                    templateUrl: '/tpl/show/templates/components/modals/funnel/saferPay',
                    controller: 'saferPayCtrl',
                    backdrop: 'static',
                    resolve: {
                        items: function () {
                            return response;
                        }
                    }
                });
            };

            $scope.openPaymentProcessingModal = function (response) {
                $scope.paymentProcessingModal = $modal.open({
                    templateUrl: '/tpl/show/templates/components/modals/funnel/paymentProcessing',
                    controller: 'paymentProcessingCtrl',
                    backdrop: 'static',
                    resolve: {
                        items: function () {
                            return response;
                        }
                    }
                });
            };

            $scope.loadPayment();

        }]);
;

// Source: ../shared/public_html/assets/js/base/controllers/paymentEpError.js
angular.module('base').controller('paymentEpError',
    ['$scope', '$stateParams', 'PaymentPage', 'bok.CreditCard', '$modal', '$timeout', 'thy.ThankYouServ', 'appConfig', 'bok.BookingServ', 'bok.FlightBooking', 'bas.Basket', '$location',
        function ($scope, $stateParams, PaymentPage, CreditCard, $modal, $timeout, ThankYouServ, appConfig, BookingServ, FlightBooking, Basket, $location) {
var token = $stateParams.hash;
            $scope.statuses = {
                showBasket: false,
                error: false
            };

            PageLoadingService.on();

            $scope.pageData = {};
            $scope.controllerName = $scope.controllerName || 'Order';
            $scope.flightBooking = FlightBooking;

            ThankYouServ.getConfirmation({token: token, controller: $scope.controllerName}).then
            (
                function success(response) {
                    $scope.pageData = ThankYouServ.prepareData(response);
                    PageLoadingService.off();
                    $timeout(
                        function () {

                        }
                    );
                },
                function error(response){
                    PageLoadingService.off();
                }
            );

        }]);
;

// Source: ../shared/public_html/assets/js/base/controllers/paymentModalCtrl.js
(function(angular) {
var PaymentModalController = function($location, $sce, $rootScope, $scope, $stateParams, PaymentPage, CreditCard,
                                          $modal, $timeout, ThankYouServ, $modalInstance, getMessage, $filter, PaymentTokenize,
                                          ErrorLogService, appConfig, PaymentApi, $exceptionHandler) {

        $scope.inProcess = false;
        $scope.model = new CreditCard();
        $scope.paymentInfo = getMessage;

        if(_.isObject(getMessage.flightBooking)) {
            $scope.price = $filter('flPrice')(getMessage.flightBooking.basket.getTotalPrice(), 2);
            $scope.basket = getMessage.flightBooking.basket;
        }

        if (getMessage.disableCurrencySwitch) {
          $scope.model.setDisableCurrencySwitch(true);
        }

        /**
         * Close Modal
         * @type {*}
         */
        $scope.closeModal = function() {
            $modalInstance.close();
        };

        /**
         * @returns {string}
         */
        function getCreditCardCurrency() {
            return $scope.model.getCurrencyCode() || appConfig.getCurrencyCode();
        }

        function sendTransaction() {
            var data = {};

            if($scope.ccForm.$invalid) {
                $scope.ccForm.creditCardForm.$setSubmitted();
                $scope.inProcess = false;
                return;
            }

            if($stateParams.reqId) {
                data.id = $stateParams.reqId;
            }

            if(getMessage.hash) {
                data.id = getMessage.hash;
            }

            data.ngData = 1;
            data.payment = {};
            data.payment.details = {};

            var credentials = PaymentTokenize.findCredential({
                currency: getCreditCardCurrency(),
                paymentType: 'CC'
            });

            var name = $scope.model.fullName.split(" ");
            var expDate = $scope.model.newExp.split('/');

            PaymentTokenize.init(credentials)
              .then(function() {
                  return PaymentTokenize.tokenize({
                      full_name: $scope.model.fullName,
                      expiration: '20' + expDate[1] + '-' + expDate[0] + '-01',
                      number: ($scope.model.number) ? $scope.model.number.replace(/ /gi, '') : '',
                      cvc: $scope.model.cvc
                  });
              })
              .then(function(tokenized) {
                  data.payment.details = angular.merge({}, tokenized, {
                      type: $scope.model.id,
                      gatewayParams: credentials.params,
                      validationType: tokenized.validationType,
                  });

                  if(!$scope.model.getDisableCurrencySwitch()) {
                      data.payment.details.currency = $scope.model.currency;
                  }

                  $scope.model.tokenize(tokenized);
              })
              .catch(function(error) {
                  if (!(error instanceof TypeError) && error instanceof Error) {
                      // dont log 'Wrong driver' tokenization problem
                      // @see PaymentTokenize.init
                      ErrorLogService.sendErrorLog(error);
                  }
                  if (!appConfig.isEnvProd()) {
                      console.trace('PaymentTokenize', error);
                  }

                  data.payment.details.number = ($scope.model.number) ? $scope.model.number.split(' ') : '';
                  data.payment.details.cvc = $scope.model.cvc;
                  data.payment.details.firstName = name[0];
                  data.payment.details.lastName = name[1];
                  data.payment.details.type = $scope.model.id;
                  data.payment.details.validationType = CreditCard.VALIDATION_NUMBER;

                  if(!$scope.model.getDisableCurrencySwitch()) {
                      data.payment.details.currency = $scope.model.currency;
                  }

                  data.payment.details.expDate = {
                      0: parseInt(expDate[0], 10),
                      1: parseInt('20' + expDate[1], 10)
                  };
              })
              .finally(function() {
                  processPayment(data);
              });
        }

        function processPayment(data) {
            PaymentPage
              .transaction(data)
              .then(function PaymentPageSuccess(response) {
                  if ($scope.model.tokenized) {
                      if (response.version === data.payment.details.validationType) {
                          microserviceFlow(response);
                      } else {
                          $scope.inProcess = false;
                          $exceptionHandler(new Error('Payment error: validation type does not match response version'));
                      }
                  } else {
                      if (response.paymentForm) {
                          // Submit form
                          $rootScope.$broadcast('paymentGatewayZooz', {
                              url: $sce.trustAsResourceUrl(response.paymentForm.url),
                              method: "post",
                              data: response.paymentForm.fields,
                              id: "PAEnrollForm"
                          });
                      } else {
                          if (response.redirectLink) {
                              $location.path(response.redirectLink);
                          } else {
                              if (response.message_content) {
                                  $scope.message_content = response.message_content;

                                  $timeout(function () {
                                      document.getElementById("payment").submit();
                                  }, 2000);
                              } else {
                                  if (response.errors.payment.details) {
                                      $scope.model.errors = response.errors.payment.details;
                                  }

                                  $scope.inProcess = false;
                              }
                          }
                      }
                  }
              }, function (response) {
                  paymentError(response);
              });
        }

        function microserviceFlow(response) {
            var redirectLink = response.redirectLink;
            return PaymentApi
              .initPurchase(response.paymentServiceParams, $scope.model, response.version)
              .then(function (response) {
                  handleInitPurchaseResponse(response, redirectLink);
              }).catch(function (error) {
                  $scope.inProcess = false;
                  $exceptionHandler(error instanceof Error ? error : new Error('Payment error'));
                  $scope.closeModal();
              });
        }

        function handleInitPurchaseResponse(initPurchaseResponse, redirectLink) {
            if (initPurchaseResponse.redirect_type === 'form') {
                submitForm(initPurchaseResponse.redirect_attributes, initPurchaseResponse.redirect_url);
            } else if (initPurchaseResponse.redirect_url) {
                window.location.href = initPurchaseResponse.redirect_url;  // 3DS
            } else {
                window.location.href = redirectLink;
            }
        }

        function submitForm(redirectAttributes, redirectUrl) {
            var formAttributes = redirectAttributes.reduce(function (attributes, current) {
                attributes[current.name] = current.value;
                return attributes;
            }, {});

            $timeout(function () {
                $rootScope.$broadcast('paymentGatewayMicroservice',
                  {
                      url: $sce.trustAsResourceUrl(redirectUrl),
                      method: "post",
                      data: formAttributes,
                      id: "cardPaymentGatewayMicroservice"
                  });
            }, 2000);
        }

        function paymentError(response) {
            if (response.response.expiredLink === true) {
                $scope.paymentError = true;
            } else {
                if (response.payment.errors.payment.details) {
                    $scope.model.errors = response.payment.errors.payment.details;
                }
                $scope.inProcess = false;

                $exceptionHandler(new Error('Payment problem ', response.payment.errors));
            }
        }

        /**
         * Make Payment
         */
        $scope.cardPayment = function() {
            $scope.model.errors = {};
            $scope.inProcess = true;

            $rootScope.$broadcast('form-submit:validate');

            sendTransaction();
        };
    };

    PaymentModalController.$inject = [
        '$location',
        '$sce',
        '$rootScope',
        '$scope',
        '$stateParams',
        'PaymentPage',
        'bok.CreditCard',
        '$modal',
        '$timeout',
        'thy.ThankYouServ',
        '$modalInstance',
        'getMessage',
        '$filter',
        'PaymentTokenize',
        'ErrorLogService',
        'appConfig',
        'PaymentApi',
        '$exceptionHandler'
    ];

    angular.module('base').controller('paymentModalCtrl', PaymentModalController);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/controllers/paymentTransactionCtrl.js
(function (angular) {
/**
   * @name        paymentTransactionCtrl
   * @description payment transaction for insurance.
   */

  var paymentTransactionCtrl = function ($rootScope,
                                         $scope,
                                         $sce,
                                         $stateParams,
                                         PaymentPage,
                                         CreditCard,
                                         $modal,
                                         $timeout,
                                         ThankYouServ,
                                         appConfig,
                                         BookingServ,
                                         FlightBooking,
                                         Basket,
                                         $location,
                                         PageLoadingService,
                                         TextBoxService,
                                         PaymentStatusService,
                                         PaymentTokenize,
                                         CheckinApi,
                                         AutomatedCheckinHelper) {

    var paymentButtonName = appConfig.getPaymentButton();
    var addInsurance = $location.search();

    var bookingSuccess = function (response) {
      $scope.flightBooking = FlightBooking;
      FlightBooking.setFlightDetails(response.flightDetails || {});
      $scope.cashBack = $scope.flightBooking.flightDetails.getCashBack();
      $scope.statuses.showBasket = true;

      // Set flight data
      $scope.departureDataSet = $scope.flightBooking.flightDetails.getDepLeg();
      $scope.arrivalDataSet = $scope.flightBooking.flightDetails.isRoundTrip() ? $scope.flightBooking.flightDetails.getRetLeg() : null;

      // Set check-in data in booking
      CheckinApi
        .getAirlineRules(
          AutomatedCheckinHelper.getRulesPayload(
            $scope.flightBooking.getFlightDetails()
          )
        )
        .then(function (success) {
          $scope.flightBooking.paidCheckinRules.setRules(
            success.data.data.rules
          );
        });

      // luggageDetails.initSharedLuggagesIfMissing(function () {
      //   return {
      //     paxes: $scope.flightBooking.basket.dataProvider.getPaxes(),
      //     unitOpts: $scope.flightBooking.flightDetails.unitOpts
      //   };
      // });
    };

    /**
     * Allow user to do his payment
     *
     * @param response
     */
    var enablePaymentForm = function (response) {
      $scope.paymentData = response;

      ThankYouServ.getConfirmation({
        token: response.hash,
        controller: 'Order',
        insurance: addInsurance.addIns
      }).then(function success(response) {
        $scope.pageData = ThankYouServ.prepareData(response);

        $timeout(function () {
          var paymentButton = document.getElementById(paymentButtonName);
          if (_.isObject(paymentButton)) {
            paymentButton.addEventListener('click', $scope.redirectToPayment, false);
          }
        }, 1);

        PageLoadingService.off();
      });
    };

    /**
     * When payment link is expired we show some error message
     */
    var showPaymentLinkExpiredMessage = function () {
      $scope.expiredPaymentLink = true;
      TextBoxService.getByName('payment_link_expired_message').then(function (response) {
        $scope.pageData.content = response.text;
      }, function () {
        $scope.pageData.content = 'add payment_link_expired_message text box';
      }).finally(function () {
        PageLoadingService.off();
      });
    };

    var handlePaymentLinkUnavailable = function () {
      $scope.expiredPaymentLink = true;
      TextBoxService.getByName('payment_link_unavailable_message').then(function (response) {
        $scope.pageData.content = response.text;
      }, function () {
        $scope.pageData.content = 'add payment_link_unavailable_message text box';
      }).finally(function () {
        PageLoadingService.off();
      });
    };

    $scope.statuses = {
      showBasket: false,
      error: false
    };

    $scope.expiredPaymentLink = false;

    PageLoadingService.on();

    $scope.redirectToPayment = function () {
      var paymentType = $scope.paymentData.choosed_payment_type;

      if (addInsurance.addIns) {
        paymentType = 'EP';
      }

      if (paymentType === 'EP' || paymentType === 'PP' || paymentType === 'BT') {
        $modal.open({
          templateUrl: '/tpl/show/templates/components/modals/funnel/ePayments-hyb',
          controller: 'ePaymentsCtrl',
          backdrop: 'static',
          size: 'custom-md',
          resolve: {
            ModalArgs: function () {
              return {
                flightBooking: $scope.flightBooking,
                price: $scope.pageData.paymentPrice
              };

            }

          }
        });
      }
      else if (_.indexOf(['CC','CC2'], paymentType) !== -1) {
        $modal.open({
          templateUrl: '/tpl/show/jsShared/templates/payment/modal',
          controller: 'paymentModalCtrl',
          backdrop: 'static',
          size: 'cards-md',
          resolve: {
            getMessage: function () {
              $scope.paymentData.flightBooking = $scope.flightBooking;
              return $scope.paymentData;
            }
          }
        });
      } else if (paymentType === 'CC3') {
        $scope.paymentButtonIsLoading = true;

        var data = {};
        data.id = $stateParams.reqId;

        PaymentPage.getPaymentLink(data).then(
            function success(response) {
              if (response.expiredLink) {
                showPaymentLinkExpiredMessage();
                return;
              }

              if (null === response.paymentLink) {
                handlePaymentLinkUnavailable();
                return;
              }

              window.location.href = response.paymentLink;
            }, function error(response) {
              handlePaymentLinkUnavailable();
            }
        );
      } else if (paymentType === 'CC4') { // RO CC installments payment link
        var data = {};
        data.id = $stateParams.reqId;

        $modal.open({
          templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/payment/creditCardGatewayRedirect',
          scope: $scope,
          size: 'custom-md'
        });

        PaymentPage.installments(data).then(function PaymentCC4PageSuccess(response) {
          $rootScope.$broadcast('paymentGatewayZooz', {
            url: $sce.trustAsResourceUrl(response.paymentForm.url),
            method: "post",
            data: response.paymentForm.fields,
            id: "PAEnrollForm"
          });
        }, _.noop);
      }
    };

    $scope.pageData = {};
    $scope.paymentData = {};

    $scope.paymentStatuses = PaymentStatusService.statuses;
    $scope.getPaymentStatus = function getPaymentStatus() {
      return PaymentStatusService.statuses.DISABLED;
    };

    $scope.getPaymentStatusAsync = function getPaymentStatusAsync() {
      return false;
    };

    /**
     * Indicates whether booking status should be displayed
     *
     * @returns {boolean}
     */
    $scope.showBookingStatus = function showBookingStatus() {
      return true;
    };

    /**
     * Indicates whether payment status should be displayed
     *
     * @returns {boolean}
     */
    $scope.showPaymentStatus = function showPaymentStatus() {
      return false;
    };

    /**
     * Indicates whether payment retry component should be displayed
     *
     * @returns {boolean}
     */
    $scope.showPaymentRetryForm = function showPaymentRetryForm() {
      return false;
    };

    /**
     * Load transaction
     */
    $scope.loadTransaction = function () {
      var data = {
        id: $stateParams.reqId,
        ngData: 1
      };

      PaymentPage.transaction(data)
        .then(function success(response) {
          var credentials = response.credentials ? response.credentials : [];
          PaymentTokenize.setCredentials(credentials);

          if (response.expiredLink) {
            showPaymentLinkExpiredMessage();
          } else {
            BookingServ.getFromHash(response.hash)
              .then(function (bookingResponse) {
                bookingSuccess(bookingResponse);
                enablePaymentForm(response);
              }, function (failure) {
                $scope.statuses.error = true;
              });
          }
        });
    };

    $scope.loadTransaction();
  };

  paymentTransactionCtrl.$inject = [
    '$rootScope',
    '$scope',
    '$sce',
    '$stateParams',
    'PaymentPage',
    'bok.CreditCard',
    '$modal',
    '$timeout',
    'thy.ThankYouServ',
    'appConfig',
    'bok.BookingServ',
    'bok.FlightBooking',
    'bas.Basket',
    '$location',
    'PageLoading',
    'TextBox',
    'PaymentStatusService',
    'PaymentTokenize',
    'CheckinApi',
    'AutomatedCheckinHelper'
  ];

  angular.module('base').controller('paymentTransactionCtrl', paymentTransactionCtrl);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/controllers/searchform.controller.js
(function(angular) {
/**
   * @name SearchFormController
   * @description Controller for search form.
   * @constructor
   */
  var SearchFormController = function($rootScope, $scope, SearchFormLocationService, AppConfig) {

    /**
     * Search form loaded.
     *
     * @type {Boolean}
     */
    $scope.loaded = true;

    /**
     * App config reference
     *
     * @type {Object}
     */
    $scope.AppConfig = AppConfig;

    /**
     * Display loading animation.
     *
     * @type {Boolean}
     */
    $rootScope.waitForLoaded = false;

    /**
     * Selects a search form tab by redirecting to corresponding homepage.
     *
     * @param {number} $id  Id of the tab
     * @param {string} $url Url for redirection
     */
    $scope.selectWithRedirect = function($id, $url) {
      if (SearchFormLocationService.redirect($url)) {
        return;
      }
      if (angular.isFunction($scope.select)) {
        $scope.select($id);
      }
    };
  };

  SearchFormController.$inject = [
    '$rootScope',
    '$scope',
    'SearchFormLocationService',
    'appConfig'
  ];

  angular.module('base').controller('SearchFormController', SearchFormController);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/controllers/static-page-content.controller.js
(function (angular) {
var controller = function ($rootScope, StaticPageHelper) {
        this.isVisible = true;

        this.$onInit = function () {
            var ctrl = this;

            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                if (StaticPageHelper.isStaticPage(fromState.name) || StaticPageHelper.isHomepage(fromState.name)) {
                    ctrl.isVisible = false;
                }
            });
        };
    };

    controller.$inject = ['$rootScope', 'StaticPageHelper'];

    angular.module('base').controller('StaticPageContentController', controller);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/controllers/userFeedbackCtrl.js
angular.module('base')
  /**
   * @name UserFeedbackCtrl
   * @description Controller for support userFeedback modal
   */
  .controller('UserFeedbackCtrl',['$scope', '$timeout', '$modalInstance', '$filter', 'hideParam', 'FeedbackService',
  function($scope, $timeout, $modalInstance, $filter, hideParam, FeedbackService){
/**
     * All data form forms which will be send to backend
     *
     * @type {Object}
     */
    var data = {
      contact_topic_id: 30,
      message: '',
      mark: '',
      phone: '',
      name: '',
      email: ''
    };

    /**
     * Variables with placeholders for inputs from userFeedback modal
     */
    $scope.textAreaPlaceholder = $filter('translate')('LANGM_JS_MODAL_FEEDBACK_BOX_1_PH');
    $scope.contactPlaceholder = $filter('translate')('LANGM_JS_MODAL_FEEDBACK_BOX_2_CONTACT_PH');
    $scope.namePlaceholder = $filter('translate')('LANGM_JS_MODAL_FEEDBACK_BOX_2_NAME_PH');

    $scope.visibleBox = 1;
    $scope.mark = null;
    $scope.user = {};
    $scope.vaildContactInput = $scope.vaildNameInput = true;

    var contactInput,nameInput;

    $timeout(function(){
      contactInput = angular.element(document.getElementById('contact-feedback'));
      nameInput = angular.element(document.getElementById('name-feedback'));

      contactInput.on('blur', function(){
        $scope.vaildContactInput = vaildContact($scope.user.contact);
      });
    },500);

    /**
     * Set mark from param as selected
     * @param markNumber
     */
    $scope.choose = function(markNumber){
      $scope.mark = markNumber;
    };

    /**
     * Get mark & message from first modal box and show box nr 2
     */
    $scope.getFirstFeedback = function(){
      data.message = $scope.user.message || '';
      data.mark = $scope.mark || 1;

      $scope.visibleBox = 2;
    };

    /**
     * Get mark & message from first modal box and show box nr 3 d
     */
    $scope.getContactDetails = function(){
      $scope.vaildForm = vaildContact($scope.user.contact);
      data.name = $scope.user.name || '';
      sendFeedbackToBackend();
      $scope.visibleBox = 3;
    };

    /**
     * Closing feedbackModal
     */
    $scope.closeFeedbackModal = function(){
      $modalInstance.dismiss();
    };

    /**
     * Send feedback to backend when user close modal
     */
    $modalInstance.result.finally(function(){
      sendFeedbackToBackend();
    });

    /**
     * Send feedback to backend
     */
    var sendFeedbackToBackend = function(){
      if($scope.visibleBox === 2){
        FeedbackService.sendFeedback($scope.data);
      }
    };

    /**
     * Check that user fill phone number or mail
     * @param contactData
     */
    var vaildContact = function(contactData){

      if(!contactData){
        return false;
      }

      var mailRegex = /(^\w[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,})/,
          phoneRegex = /^(\+?[0-9\-]+)$/,
          matches;

      matches = mailRegex.exec(contactData);
      if(matches){
        data.email = matches[0];
        return true;
      }

      matches = phoneRegex.exec(contactData.replace(/ /g, ''));
      if(matches){
        data.phone = matches[0];
        return true;
      }

      return false;
    };

    //Setter & getter
    this.getDataObj = function(){
      return data;
    };

    this.getVaildContact = function(){
      return vaildContact;
    };

  }]);;

// Source: ../shared/public_html/assets/js/base/controllers/wgslider.controller.js
(function(angular) {
/**
   * @name WgSliderController
   * @description Controller for jumbotron.
   * @constructor
   * @author Piotr Slosarz <piotr.slosarz@fru.pl>
   */
  var WgSliderController = function($scope, WgSliderService) {
    
    /**
     * Slides.
     * 
     * @type {Array}
     */
    $scope.slides = [];
    
    /**
     * Parameters.
     * 
     * @type {Array}
     */
    $scope.params = [];
    
    /**
     * Index of currently active slide.
     * 
     * @type {number}
     */
    $scope.currentActive = 1;

    /**
     * Action initialize jumbotron.
     *
     * @param {Object} element 
     */
    this.init = function (element) {
      $scope.slides = WgSliderService.collectSlidesFromDOM(element);
      $scope.params = WgSliderService.collectParamsFromDOM(element);
      WgSliderService.collectPreLoader(element);
    };
  };

  WgSliderController.$inject = [
    '$scope',
    'WgSliderService'
  ];

  angular.module('base').controller('WgSliderController', WgSliderController);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/customValidation.js
// (function(){

//   function simpleRegexHelper(regex, name, valueExtraCondition){

//     return {
//       require: 'ngModel',
//       link: function (scope, element, attrs, ctrl) {

//         var simpleRegexFn = function (viewValue) {
//           var valueCondition = typeof valueExtraCondition !== 'undefined' && _.isFunction(valueExtraCondition) ?  valueExtraCondition(viewValue) : false; //extra condition for value

//           // Set validity of the form element
//           ctrl.$setValidity(name, true);

//             if (regex.test(viewValue) || valueCondition) {
//               ctrl.$setValidity(name, true);
//             } else {
//               ctrl.$setValidity(name, false);
//               // if invalid, return undefined
//               // (no model update happens)
//             }
//           return viewValue;
//         };

//         ctrl.$parsers.unshift(simpleRegexFn);
//         ctrl.$formatters.unshift(simpleRegexFn);
//       }
//     };
//   }

//   var PHONE_REGEX = /^[0-9\s+-]*$/;
//   var PASSWORD_REGEX = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
//   var ID_CARD_REGEX = /^[a-zA-Z0-9\s]*$/;
//   var ID_CARD_MASKED_REGEX = /^[a-zA-Z0-9*\s]*$/;
//   var VAT_REGEX = /^[a-zA-Z0-9\s-]*$/;
//   var POSTAL_CODE_REGEX = /^[a-zA-Z0-9\s-]*$/;
//   var ADDRESS_REGEX = /^[^!@#$^'&%*()+=~|:<>?[\]\\{}]{2,255}$/;
//   var BASIC_TEXT_REGEX = /^[^!@#$^'&%*()+=~|:<>?,[\].\\/{}0-9]{2,255}$/;
//   var EMAIL_REGEX = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
//   var FULLNAME_REGEX = /^[a-zA-Z]{2,100} [a-zA-Z]{2,100}$/;

//   var expirationDateExtraCondition = function(value){
//     return value ? value.length != 5 : false;
//   };

//   // todo pk add regexp for ccv
//   // var CCV = //;

//   angular.module('base')

//     /**
//      * @name        customEmail
//      * @description Execute an angular expression when we click out of the current element.
//      */
//     .directive('customemail',
//       [function ()
//       {
//         'use strict';

//         return {
//           require:  'ngModel',
//           restrict: '',
//           priority: 2,
//           link:     function (scope, elm, attrs, ctrl)
//                     {
//                       if (ctrl && ctrl.$validators.email)
//                       {
//                         // this will overwrite the default Angular email validator
//                         ctrl.$validators.email = function (modelValue)
//                         {
//                           return true;
//                         };
//                       }
//                       ctrl.$parsers.unshift(function (viewValue) {

//                         if (EMAIL_REGEX.test(viewValue)) {
//                           ctrl.$setValidity("customemail", true);
//                           return viewValue;
//                         } else {
//                           ctrl.$setValidity("customemail", false);
//                           // if invalid, return undefined
//                           // (no model update happens)
//                           return viewValue;
//                         }
//                       })
//                     }
//       }}])

//         .directive('phone', function(){ return simpleRegexHelper(PHONE_REGEX,"phone")})
//         .directive('password', function(){ return simpleRegexHelper(PASSWORD_REGEX,"password")})
//         .directive('idcard', function(){ return simpleRegexHelper(ID_CARD_REGEX,"idcard")})
//         .directive('idcardmasked', function(){ return simpleRegexHelper(ID_CARD_MASKED_REGEX,"idcardmasked")})
//         .directive('vatnumber', function(){ return simpleRegexHelper(VAT_REGEX,"vatnumber")})
//         .directive('postalcode', function(){ return simpleRegexHelper(POSTAL_CODE_REGEX,"postalcode")})
//         .directive('address', function(){ return simpleRegexHelper(ADDRESS_REGEX,"address")})
//         .directive('basictext', function(){ return simpleRegexHelper(BASIC_TEXT_REGEX,"basictext")})
//         .directive('fullName', function(){ return simpleRegexHelper(FULLNAME_REGEX,"fullname")})
//         .directive('expirationDate', ['ValidationUtils', function(ValidationUtils){ return simpleRegexHelper(ValidationUtils.getStrictExpirationRegex(),"expirationDate", expirationDateExtraCondition)}])
// })();
;

// Source: ../shared/public_html/assets/js/base/directives/afterRender.js
angular.module('base')

/**
 * @name        afterRender
 * @description
 */
.directive('afterRender', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
return {
      restrict: 'A',
      replace: false,
      priority: 1,
      link: function (scope, element, attr)
      {
        var $timer, unWatch;

        var addGif = function(info)
        {
          info = info || '';
          var time = moment().unix();
          var rand = Math.random();
          var gif = document.createElement('img');

          gif.setAttribute('src', '/assets/img/rv.gif');
          gif.setAttribute('class', 'rv-gif');
          document.getElementsByTagName('body')[0].appendChild(gif);
        };

        var defaultFn = function() {
          if(typeof dataLayer != 'undefined')// && _.findIndex(dataLayer, {event: 'gtm.load'}) != -1)
          {
            addGif();
            dataLayer.push({
              'event': 'ApplicationLoaded'
            });
            unWatch();
            $rootScope.ApplicationLoaded = true;
          }
          else
          {
            addGif('dataLayerUndefined');
          }
        };

        var cleaner = function()
        {
          if (attr.arUnlockScroll)
          {
            document.removeEventListener('touchmove', blockTouchMove);
          }
        };

        var $timerFn = function(){
          if ($timer) $timeout.cancel($timer);
          $timer = $timeout(function()
          {
            if (scope.$$phase || scope.$root.$$phase)
            {
              $timerFn();
              return;
            }
            switch (attr.afterRender) {
              case 'remove':
                unWatch();
                element.remove();
                cleaner();
                break;
              default:
                defaultFn();
            }
          }, 100);
        };
        unWatch = scope.$watch(function()
        {
          $timerFn();
        }, angular.noop);

      }
    };
  }
]);
;

// Source: ../shared/public_html/assets/js/base/directives/baseAutoSubmitForm.js
(function (angular) {

    var template = '\
        <form target="{{ $ctrl.formData.target }}" action="{{ $ctrl.formData.url }}" method="{{ $ctrl.formData.method }}" id="{{ $ctrl.formData.id }}">\
            <input ng-repeat="(key, val) in $ctrl.formData.data" type="hidden" name="{{ key }}" value="{{ val }}">\
        </form>\
    ';

    var controller = function ($scope, $timeout) {
        var ctrl = this;

        /**
         * List of form auto submit event names
         * @type {string[]}
         */
        var eventList = [
            'paymentGateway',
            'paymentGatewayZooz',
            'paymentGatewayMicroservice'
        ];

        /**
         * List of event listener cancellation functions
         * @type {function[]}
         */
        var eventCancellationList = [];

        /**
         * Key value pair of data needed for form submit
         * @type {object}
         */
        ctrl.formData = {};

        /**
         * Handles an auto submit form event
         * @param {Event} event
         * @param {object} data
         */
        var eventHandler = function (event, data) {
            if (!data.target) {
                // Form will autosubmit on the same page by default
                data.target = '_self';
            }

            // Set form data
            ctrl.formData = data;

            // Submit form
            $timeout(function () {
                document.getElementById(ctrl.formData.id).submit();
            });
        };

        ctrl.$onInit = function () {
            angular.forEach(eventList, function (eventName) {
                eventCancellationList.push(
                    $scope.$on(eventName, eventHandler)
                );
            });
        };

        ctrl.$onDestroy = function () {
            angular.forEach(eventCancellationList, function (cancellationFn) {
                cancellationFn();
            });
        };
    };

    controller.$inject = ['$scope', '$timeout'];

    angular.module('base').component('autoSubmitForm', {
        template: template,
        controller: controller
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/baseBackendValid.js
angular.module('base')

/**
 * @name        baseBackendValid
 * @description Restores backend validation to input on change
 */
.directive('baseBackendValid', function baseBackendValid() {
return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      /**
       * Reference to the model
       *
       * @type {String}
       */
      model: '=ngModel',

      /**
       * Reference to the error property
       *
       * @type {String}
       */
      backendError: '=baseBackendValid',

      /**
       * Reference to a form element (optional)
       *
       * This is needed in case of a form group of elements. Date selection
       * is composed of 3 selects but we cannot add validation to all
       * of the selects because they form a group (a date selection).
       * On change we choose to update validity to the main one.
       *
       * @type {Object}
       */
      frontendError: '=frontendValid'
    },

    link: function (scope, element, attrs, ctrl) {
      // Set parsers
      ctrl.$parsers.unshift(backendValidator);

      // Set formatters
      ctrl.$formatters.unshift(backendValidator);

      /**
       * Sets validation for backend to true on form element change
       *
       * @param  {String|Object} value
       *
       * @return {String|Object}
       */
      function backendValidator(value) {
        // Make sure we kick in only when user writes something in the field
        if (!value || value.length == 0) {
          return value;
        }

        if (ctrl.$dirty || attrs.type == "hidden") {
          // Set validity of the form element to true
          ctrl.$setValidity('backend', true);

          // Set backend error to null
          scope.backendError = null;
        }

        // Is frontend error set?
        if (scope.frontendError) {
          // Make it valid
          scope.frontendError.$setValidity('backend', true);
        }

        // Return value
        return value;
      }
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/baseCapitalize.js
angular.module('base')

/**
 * @name        baseCapitalize
 * @description Parses model text and returns the capitalized version
 * @todo        Check if this can be replaced by a filter
 */
.directive('baseCapitalize', ['$timeout', function baseCapitalize($timeout) {
return {
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      var capitalize = function (inputValue) {
        if (angular.isUndefined(inputValue)) {
          return '';
        }

        var capitalized = inputValue.toUpperCase();
        if (capitalized !== inputValue) {
          ctrl.$setViewValue(capitalized);
          $timeout(function(){
            ctrl.$render();
          }, 100);
        }

        return capitalized;
      };

      ctrl.$parsers.push(capitalize);
      capitalize(scope[attrs.ngModel]);
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/baseUiCheckbox.js
angular.module('base')

/**
 * @name        baseUiCheckbox
 * @description UI checkbox directive
 */
.directive('baseUiCheckbox', function baseUiCheckbox() {
return {
    require: 'ngModel',
    restrict: 'E',
    template: '<span class="boolean" ng-class="{ on: checked, disabled: disabled }"><span class="toggler"></span> <ng-transclude></ng-transclude></span>',
    replace: true,
    transclude: true,
    scope: {
      disabled: '=?'
    },
    link: function (scope, elem, attrs, modelCtrl) {
      scope.disabled = scope.disabled || false;

      //Todo: performance

      // Update element when model changes
      scope.$watch(function () {
        modelCtrl.$setViewValue(modelCtrl.$modelValue);
        return modelCtrl.$modelValue;
      }, function (newVal, oldVal) {
        scope.checked = scope.disabled ? false : modelCtrl.$modelValue;
      }, true);

      // On click swap value and trigger onChange function
      elem.bind('click', function () {
        if (!scope.disabled) {
          scope.$apply(function () {
            modelCtrl.$setViewValue(!modelCtrl.$modelValue);
          });
        }
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/baseUiRadio.js
angular.module('base')

/**
 * @name        baseUiRadio
 * @description UI radio directive
 */
.directive('baseUiRadio', function baseUiRadio() {
return {
    restrict: 'E',
    require: '?ngModel',
    template: '<label class="ui-radio cursorPointer" ng-click="toggle()" vo-touch="toggle()" vo-touch-event="touchstart" ng-class="{ on: isSelected(), disabled:isDisabled() }"><span class="toggler"></span> <span class="ui-radio-label" translate="{{::label}}"></span></label>',
    replace: true,
    scope: {
      label: '=',
      value: '=',
      disabled: '='
    },
    link: function (scope, element, attrs, ngModel) {
      /**
       * Toggle activation of current radio
       */
      scope.toggle = function () {

        if(scope.disabled)
        {
          return;
        }

        _.defer(function()
        {
          ngModel.$setViewValue(scope.value);
          //ngModel.$modelValue = scope.value;
          scope.$apply();
        });
      };

      /**
       * checks if this radio is selected
       *
       * @return {Boolean}
       */
      scope.isSelected = function () {
        return ngModel.$viewValue == scope.value;
      };

      /**
       * Returns TRUE if radio is disabled
       *
       * @returns {*}
       */
      scope.isDisabled = function () {
       return scope.disabled;
      };

    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/baseUiSwitch.js
angular.module('base')

/**
 * @name        baseUiSwitch
 * @description UI switch dirtective
 */
.directive('baseUiSwitch', function baseUiSwitch() {
return {
    restrict: 'E',
    template: '<span class="ui-switch" ng-click="toggle()" ng-swipe-left="toggle(false)" ng-swipe-right="toggle(true)" ng-class="{ on: model }"><span class="toggler"></span></span>',
    replace: true,
    scope: {
      model: '=?ngModel',
      callback: '&ngCallback'
    },
    link: function (scope) {
      scope.toggle = function (action) {
        action = action || !scope.model;
        scope.model = action;

        if (scope.callback && typeof(scope.callback) == 'function') {
          // Trigger callback
          scope.callback({model: scope.model});
        }
      };
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/baseWhenScrolled.js
angular.module('base')

/**
 * @name        baseWhenScrolled
 * @description If window scrolled to end of this element, do something
 */
.directive('baseWhenScrolled', ['$window', function baseWhenScrolled($window) {
/**
   * Returns true if window is scrolled to end of this element
   *
   * @param element
   * @returns {Boolean}
   */
  var scrolledToElement = function (element) {
    return element.getBoundingClientRect().top + element.clientHeight <= window.innerHeight;
  };

  /**
   * Call function "fn" if window is scrolled to end of "element"
   *
   * @param {Function} fn
   * @param {element} element
   */
  var callWhenScrolled = function (fn, element) {
    if (scrolledToElement(element)) {
      fn();
    }
  };

  return {
    restrict: 'A',
    scope: {
      /**
       * If window scrolled to end of this element, function will be called
       *
       * @type {Function}
       */
      fn: '&baseWhenScrolled'
    },
    link: function (scope, element) {
      var cb = function () {
        callWhenScrolled(scope.fn, element[0]);
      };

      angular.element($window).on('scroll', cb);

      scope.$on('$destroy', function () {
        angular.element($window).off('scroll', cb);
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/cardImage.js
angular.module('base')

/**
 * @name        cardImage
 * @description Product card image
 */
.directive('cardImage',
[
function cardImage () {
var langs = {
    package: 'LANGM_JS_PACKAGES_NO_PHOTO',
    hotel: 'LANGM_JS_HOTELS_NO_PHOTO'
  };

  var link = function (scope, elem, attrs) {
    scope.noImageCaption = langs[attrs.type];
  };

  return {
    restrict: 'E',
    replace: true,
    link: link,
    scope: {
      type: '@',
      label: '=',
      image: '=',
      imageLink: '=',
      imageAlt: '=',
      imageWidth: '@',
      imageHeight: '@',
      target: '@'
    },
    templateUrl: '/tpl/show/jsShared/templates/base/directives/productCard/cardImage'
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/cashBack/cashBack.js
angular.module('base')

.controller('cashBackDirectiveCtrl', ['$scope', '$location', 'CashBackService', '$timeout', '$rootScope','appConfig', '$localStorage',
  function ($scope, $location, CashBackService, $timeout, $rootScope, appConfig, $localStorage) {
$scope.key = 'cashbackCheck';
    $scope.config = appConfig.getCashbackSettings();
    $scope.showLoading = false;

    /**
     * Show hide logic
     * @returns {Boolean}
     */
    $scope.showHideLogic = function ()
    {
      if (!$localStorage) return false;

      var check = $localStorage[$scope.key];
      if (check && check == $scope.config.campaign_id) {
        return true;
      }
      return false;
    };

    /**
     * Set Lock
     */
    $scope.lock = function ()
    {
      if (!$localStorage) return false;

      $localStorage[$scope.key] = $scope.config.campaign_id;
      $localStorage.$apply();
    };


    $scope.hide = $scope.showHideLogic();

    /**
     * Send Cash Back
     * @param isValid
     * @param data
     */
    $scope.cashBackSend  = function (isValid, data) {
      $scope.showLoading = true;
      $scope.emailError  = 0;
      if (isValid && data !== undefined) {


        var dataToSend =
        {
          email: data.email,
          campaign_id: $scope.config.campaign_id,
          source: $scope.config.source,
          nl_place_name: 'frontPage'
        };

        CashBackService.getCoupon(dataToSend).then(
          function success(resp) {
            if (resp.nl_status != 'ERRORS') {
              $scope.nl_status = resp.nl_status;
              $scope.lock();
              $scope.showLoading = false;
              $timeout(function () {
                $scope.hide = true;
              }, 4000);
            }
            else {
              $scope.emailError = 1;
              $scope.showLoading = false;
            }

          },
          function error(resp) {

            if (resp.nl_status != 'ERRORS') {
              $scope.nl_status = resp.nl_status;
              $scope.lock();
              $scope.showLoading = false;
              $timeout(function () {
                $scope.hide = true;
              }, 4000);
            }
            else {
              $scope.showLoading = false;
              $scope.emailError = 1;
            }
          }
        );
      }
      else {
        $scope.showLoading = false;
      }
    };
  }]
);
;

// Source: ../shared/public_html/assets/js/base/directives/cashBack/cashBackBox.js
angular.module('base')

/**
 * @name        cashBackBox
 * @description Vola CashBack box directive
 */
.directive('cashBackBox',
['$rootScope', 'AuthService',
function cashBackBox($rootScope, AuthService) {
var TEMPLATE_DEFAULT_URL = '/tpl/show/jsShared/templates/flights/flightDetails/pax/cashBack/cashBackBox';

  if ($rootScope.affiliate == 'flyhacks')
  {
    TEMPLATE_DEFAULT_URL = '/tpl/show/jsShared/templates/flights/flightDetails/pax/cashBack/cashBackBox-hyb';
  }

  return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (el, attr) {
      return attr.templateUrl || TEMPLATE_DEFAULT_URL;
    },
    controller: ['$scope', function ($scope)
    {
      $scope.isLogged = function ()
      {
        return AuthService.checkIsLoggedIn();
      };
    }]
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/changeLang.js
angular.module('base')
  /**
   * @name changeLang
   * @description Directive for changing lang and currency
   */
  .directive('changeLang', function(){
return {
      restrict: 'A',
      replace: true,
      controller: ['$scope', 'ChangeLanguage', function($scope, ChangeLanguage){

        var ChangeLanguageObj = new ChangeLanguage();

        this.open = function(){
          ChangeLanguageObj.showChangeLangModal();
        };

        this.getChangeLanguageObj = function(){
          return ChangeLanguageObj;
        }

      }],
      link: function(scope, elem, attr, outerCtrl){
        var ChangeLanguageObj = outerCtrl.getChangeLanguageObj();

        scope.data = ChangeLanguageObj.getData();

        scope.open = function(){
          outerCtrl.open();
        }
      }
    }

  });;

// Source: ../shared/public_html/assets/js/base/directives/cityBreaks/cityBreaks.js
angular.module('base')

/**
 * @name        cityBreaks
 * @description
 */
.directive('cityBreaks', function () {
return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/cityBreaks/cityBreaks',
    replace: true,
    controller: ['$scope', '$location', function ($scope, $location) {

      $scope.settings = {
        tripLengthMin: 1,
        tripLengthMax: 40
      };

      $scope.formData = {
        flight_from: null,
        flight_from_code: '',
        trip_length_min: 1,
        trip_length_max: 7,
        travel_period: ''
      };

      $scope.tripLength =
      {
        setFrom: function (item) {
          $scope.formData.trip_length_min = item;
          if ($scope.formData.trip_length_max < $scope.formData.trip_length_min) {
            $scope.formData.trip_length_max = $scope.formData.trip_length_min;
          }
        },

        setTo: function (item) {
          $scope.formData.trip_length_max = item;
        },

        getFrom: function () {
          return parseInt($scope.formData.trip_length_min);
        }
      };
    }]
  };
});

;

// Source: ../shared/public_html/assets/js/base/directives/cityBreaks/cityBreaksHelper.js
angular.module('base')

/**
 * @name        packagesForm
 * @description Search form directive
 */
  .directive('cityBreakHelper',
  ['$location', 'pkg.SearchMemoryService', 'pkg.SearchFormService',
    function ($location,SearchMemoryService, SearchFormService) {
return {
        restrict: 'E',
        replace: true,
        templateUrl: '/tpl/show/jsShared/templates/base/directives/cityBreaks/cityBreakHelper',
        scope: {
          onChange: '&?',
          loadTags: '=?'
        },
        controller : ['$scope',function($scope){
          $scope.setActiveTag = function(){
            if ($scope.loadTags){
             SearchMemoryService.saveSearchUrl($scope.loadTags);
            }
          };

          $scope.clearDuplicate = function(array,value){
            for(var i = array.length - 1; i >= 0; i--)
            {
              if(array[i] === value)
              {
                array.splice(i, 1);
              }
            }
          };

          $scope.checkDestinations = function(){
            var inputCityBreak = {
                from : [],
                destination : []
            };

            var destinations = SearchFormService.getSelectedDestinations();
            if(destinations)
            {
              angular.forEach(destinations,function(v,k){

                if(v.showInSearch())
                {
                  $scope.clearDuplicate(inputCityBreak.from,v.id);
                  inputCityBreak.from.push(v.id);

                  angular.forEach(v.departures,function(dep){
                    $scope.clearDuplicate(inputCityBreak.destination,dep);
                    inputCityBreak.destination.push(dep);
                  });
                }

              });

              $scope.$parent.formData.inputCityBreak = inputCityBreak;
            }
            if (angular.isFunction($scope.onChange)) {
              $scope.onChange();
            }
          };

          $scope.setActiveTag();
        }],
        link: function (scope) {

          scope.SearchFormService = SearchFormService;
          SearchFormService.loadPanel();
          scope.type ='cb';
          scope.layout = 'navbar';

          /**
           * The form lang
           */
          scope.formLang = {
            btnSearch: 'LANGM_JS_PACKAGES_SEARCH_PANEL_BTN_SPECIAL'
          };

          /**
           * Form status
           * @type {Object}
           */
          var formStatus = {
            default: {
              type: scope.type,
              layout: scope.layout,
              departures: {
                isOpen: false
              },
              destinations: {
                isOpen: false
              },
              periods: {
                isOpen: false
              }
            },
            navbar: {
              type: scope.type,
              layout: scope.layout,
              departures: {},
              destinations: {
                isOpen: false
              },
              periods: {}
            }
          };

          scope.formStatus = formStatus[scope.layout];

        }
      };
    }]);

;

// Source: ../shared/public_html/assets/js/base/directives/clickOut.js
angular.module('base')

/**
 * @name        clickOut
 * @description Execute an angular expression when we click out of the current element.
 */
.directive('clickOut',
['$window', '$parse',
function clickOut($window, $parse) {
return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var clickOutHandler = $parse(attrs.clickOut);

      angular.element($window).on('click', function (event) {
        if (element[0].contains(event.target) || element[0] == event.target) {
          return;
        }
        clickOutHandler(scope, {$event: event});
        scope.$apply();
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/compile.js
angular.module('base')

/**
 * @name        compile
 * @description appends compiled source
 */
.directive('compile', ['$compile', function ($compile) {
return function (scope, element, attrs) {
    scope.$watch(
      function (scope) {
        return scope.$eval(attrs.compile);
      },
      function (value) {
        var html = value;

        if (value && value.hasOwnProperty('$$unwrapTrustedValue')) {
          html = value.$$unwrapTrustedValue();
        }

        element.html(html);
        $compile(element.contents())(scope);
      }
    );
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/contactForm/careerForm.js
angular.module('base')

  .controller('careerFormCtrl', ['$scope', '$attrs', 'ContactFormSrv','$filter', function ($scope, $attrs, ContactFormSrv,$filter)
  {
var resetForm = function (form)
    {
      if (form)
      {
        form.$setPristine();
        form.$setUntouched();
      }
      $scope.career = {};
    };

    $scope.phonePattern = /[0-9 \+]{5,20}/;
    $scope.stringPattern = /([a-zA-Z]){3,20}/;

    $scope.header = $attrs.header;
    $scope.messageStatus = false;
    $scope.messageError = false;
    $scope.showLoading = false;

    $scope.attachments = function()
    {
      if($scope.files && $scope.files.length >0)
      {
        return true;
      }

      return false;
    };

    $scope.sendMessage = function (form)
    {
      if(!$scope.attachments())
      {
        $scope.messageError = $filter('translate')('LANGM_JS_CAREER_FORM_ATTACHMENTS_ERROR');
        return false;
      }
      $scope.showLoading = true;

      var captcha = document.getElementById("g-recaptcha-response");
      var formData = {
        name: $scope.career.name,
        surname : $scope.career.surname,
        email: $scope.career.email,
        phone: $scope.career.phone,
        message: $scope.career.msg,
        topic_id: $scope.career.topic_id,
        recaptcha : captcha ? captcha.value : null
      };

      ContactFormSrv.sendCareerForm(formData)
        .then(function success(resp)
        {
          $scope.messageError = false;
          $scope.messageStatus = true;
          $scope.showLoading = false;
          resetForm(form);
        },
        function error(resp)
        {
          angular.forEach(resp.response, function (v, i)
          {
            $scope.messageError = v.msg;
          });

          if(resp.response.error)
          {
            $scope.messageError= resp.response.error;
          }

          $scope.showLoading = false;

        }
      );
    };
  }])

/**
 * @name        careerForm
 * @description Directive for show city helpers
 *
 */
  .directive('careerForm', [function ()
  {
return {
      restrict: 'A',
      controller: 'careerFormCtrl'
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/contactForm/companyContactForm.js
angular.module('base')

.controller('companyFormCtrl', ['$scope', 'ContactFormSrv', function($scope, ContactFormSrv) {
$scope.messageStatus = false;
  $scope.messageError = false;
  $scope.showLoading = false;

  var resetForm = function (form) {
    if (form)
    {
      form.$setPristine();
      form.$setUntouched();
    }
    $scope.contact = {};
  };

  $scope.sendMessage = function (isValid,form) {
    if(!isValid)
    {
      return false;
    }

    var formData = {
      name: $scope.contact.name,
      email: $scope.contact.email,
      phone: $scope.contact.phone,
      company: $scope.contact.company,
      topic_id: $scope.contact.topic_id
    };

    $scope.showLoading = true;
    ContactFormSrv.sendCompanyForm(formData).then(
      function success(resp) {
        $scope.messageError = false;
        $scope.messageStatus = true;
        $scope.showLoading = false;
        resetForm(form);
      },
      function error(resp) {
        angular.forEach(resp.response, function (k) {
          $scope.messageError = k.msg;
        });
        $scope.showLoading = false;
      }
    );
  };
}])

/**
 * @name        companyContactForm
 * @description Directive for show city helpers
 */
.directive('companyContactForm', [function () {
return {
    restrict: 'A',
    controller: 'companyFormCtrl'
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/contactForm/contactForm.js
angular.module('base')

.controller('contactFormCtrl', ['$scope', '$attrs', 'ContactFormSrv','$timeout','liveChatServ', function($scope, $attrs, ContactFormSrv,$timeout,liveChatServ) {
// Enable live chat on this page
  liveChatServ.checkPage('contact');

  var resetForm = function (form) {
    if (form)
    {
      form.$setPristine();
      form.$setUntouched();
    }

    var initTopic = $scope.contact.initTopicId || null;
    $scope.contact = {
      contact_topic_id : initTopic
    };
    $scope.contact.initTopicId = initTopic;
  };

  $scope.header = $attrs.header;
  $scope.messageStatus = false;
  $scope.messageError = false;

  $scope.sendMessage = function (form) {
    var formData = {
      name: $scope.contact.name,
      email: $scope.contact.email,
      phone: $scope.contact.phone,
      message: $scope.contact.msg,
      contact_topic_id: parseInt($scope.contact.contact_topic_id)
    };

    form.$setSubmitted();
    if (form.$valid)
    {
      $scope.showLoading = true;
      ContactFormSrv.sendFormMessage(formData)
        .then(function success(resp)
          {
            $scope.messageError = false;
            $scope.messageStatus = true;
            $timeout(function(){
              $scope.messageStatus = false;
            }, 10000);
            $scope.showLoading = false;
            resetForm(form);
          },
          function error(resp)
          {
            angular.forEach(resp.response, function (v)
            {
              $scope.messageError = v.msg;
            });
            $scope.showLoading = false;
          }
        );
    }
  };
}])

/**
 * @name        contactForm
 * @description Directive for show city helpers
 *
 */
.directive('contactForm', [function () {
return {
    restrict: 'A',
    controller: 'contactFormCtrl'
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/customAutocomplete.js
angular.module('base')

/**
 * @name        customAutocomplete
 * @description Wrapper for filters tabs
 */
.directive('customAutocomplete', ['$timeout', function ($timeout) {
return {
    restrict: 'A',
    replace: false,
    compile: function (tElement, tAttrs) {
      return {
        pre: function (scope, iElement, iAttrs, controller, transcludeFn) {

        },
        post: function (scope, iElement, iAttrs, controller, transcludeFn) {
          iElement.attr('autocomplete', iAttrs['customAutocomplete']);
          iElement.attr('aria-autocomplete', iAttrs['customAutocomplete'])
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/customToggleSwitch/toggleSwitch.js
(function(angular) {
var template =
        '<div class="switch-tabs">\
            <span class="switch-tab" ng-class="{\'switch-tab--active\': $ctrl.model === $ctrl.falseValue }" ng-click="$ctrl.select($ctrl.falseValue)">{{$ctrl.onLabel}}</span>\
            <span class="switch-tab" ng-class="{\'switch-tab--active\': $ctrl.model === $ctrl.trueValue }" ng-click="$ctrl.select($ctrl.trueValue)">{{$ctrl.offLabel}}</span>\
        </div>';

    var IthToggleSwitchComponent = {
        template: template,
        controller: function () {
            this.select = function (value) {
                this.model = value;
            };
        },
        bindings: {
            model: '=',
            onLabel: '@',
            offLabel: '@',
            trueValue: '<',
            falseValue: '<'
        }
    };

    angular
        .module('base')
        .component('toggleSwitch', IthToggleSwitchComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/disableAnimate.js
angular.module('base')

/**
 * @name        disableAnimate
 * @description disable animate on element
 */
.directive('disableAnimate', ['$animate', function ($animate) {
  return function (scope, element) {
    $animate.enabled(false, element);
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/disableOnDesktop.js
(function () {
angular.module('base')
  .directive('disableOnDesktop', ['$rootScope', function ($rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) 
      {
        var statics = ['homepage', 'ngStaticPageShow', 'landingPages', 'lpNoParams'];

        var stateChangeFn = function(event, toState, toParams, fromState, fromParams)
        {
          if (statics.indexOf(toState.name) == -1)
          {
            element.attr('disable-on-desktop', 'false');
            return;
          }
          
          element.attr('disable-on-desktop', 'true');
        };
        var $unbind = $rootScope.$on('$stateChangeStart', stateChangeFn);

        var destroyFn = function () { $unbind(); };
        scope.$on('$destroy', destroyFn);
      }
    };
  }]);
  
})();;

// Source: ../shared/public_html/assets/js/base/directives/disabledElement.js
angular.module('base')

/**
 * @name        disableElement
 * @description prevent element click mice
 */
    .directive('disabledElement', function () {
        return {
            restrict: 'A',

            link: function (scope, element, attrs) {

                scope.$parent.$watch(attrs.disabledElement, function (newVal) {

                    if (newVal)
                        element.css('pointerEvents', 'none');


                    else
                        element.css('pointerEvents', 'all');


                });

            }

        }
    });
;

// Source: ../shared/public_html/assets/js/base/directives/dropdownBox.js
angular.module('base')

/**
 * @name        dropdownBox
 * @description
 */
.directive('dropdownBox',
['$document', 'appConfig', '$modal', '$timeout', function ($document, appConfig, $modal, $timeout) {
var link = function (scope, element, attrs) {

    var dropdownBoxElement = angular.element( element[0].querySelector('.dropdown-box') );

    var modalInstance = null;

    var openModal = function ()
    {
      modalInstance = $modal.open({
        template: dropdownBoxElement[0].outerHTML,
        controller: function ()
        {
        },
        windowClass: '',
        resolve: {
          getMessage: function () {
            return 1;
          }
        }
      });
    };

    var $closeTimer = null;

    var stopCloseTimer = function ()
    {
      if ($closeTimer)
      {
        clearTimeout($closeTimer);
      }
    };

    var closeModal = function ()
    {
      modalInstance.$close();
    };

    var touchEvent = function ($event)
    {
      openModal();
    };

    var touchEventDocument = function ($event)
    {
      closeModal();
    };

    var showBox = function ()
    {
      dropdownBoxElement.css('display', 'block');
      dropdownBoxElement.css('opacity', '1');
      stopCloseTimer();
    };

    var mouseenterEvent = function ($event)
    {
      _.defer(function ()
      {
        showBox();
      });
    };

    var mouseleaveEvent = function ($event)
    {
      $closeTimer = $timeout(function ()
      {
        dropdownBoxElement.css('opacity', '0');

        $timeout(function ()
        {
          dropdownBoxElement.css('display', 'none');
        }, 250);
      }, 500);
    };

    /**
     * initialize touch events on element & bind modal
     */
    var touchInit = function ()
    {
      dropdownBoxElement
        .addClass('dropdown-box-modal')
      ;
      
      element.bind('touchend', touchEvent);
    };

    /**
     * Initialize mouse events on element & bind box shows / hides
     */
    var mouseInit = function ()
    {
      element.bind('mouseenter', mouseenterEvent);
      element.bind('mouseleave', mouseleaveEvent);
      dropdownBoxElement.bind('mouseenter', mouseenterEvent);
      dropdownBoxElement.bind('mouseleave', mouseleaveEvent);
    };

    if(appConfig.isMobile() || appConfig.isTablet()) {
      touchInit();
    } else {
      mouseInit();
    }

    scope.$on('$destroy', function ()
    {
      element.unbind('mouseenter', mouseenterEvent);
      element.unbind('mouseleave', mouseleaveEvent);
      element.unbind('touchend', touchEvent);
      dropdownBoxElement.unbind('mouseenter', mouseleaveEvent);
      dropdownBoxElement.unbind('mouseleave', mouseleaveEvent);
      $document.unbind('touchend', touchEventDocument)
    });
  };

  return {
    restrict: 'A',
    link: link
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/directives/equals.js
angular.module('base')

/**
 * @name        clickOut
 * @description Execute an angular expression when we click out of the current element.
 */
    .directive('equals', ['$timeout', function clickOnce($timeout) {
return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function (scope, elem, attrs, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model

                // watch own value and re-validate on change
                scope.$watch(attrs.ngModel, function () {
                    validate();
                });

                // observe the other value and re-validate on change
                attrs.$observe('equals', function (val) {
                    validate();
                });

                var validate = function () {
                    // values
                    var val1 = ngModel.$viewValue;
                    var val2 = attrs.equals;

                    // set validity
                    ngModel.$setValidity('equals', !val1 || !val2 || val1 === val2);
                };
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/events.js
(function () {
angular.forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste touchstart touchend'.split(' '), function (eventName) {
    var directiveName = 'base' + capitalizeFirstLetter(eventName);

    angular.module('base')

    /**
     * @description When we cause event on this element, specified function will be called.
     * baseClick, baseMouseenter directives are faster than ngClick, ngMouseenter etc., because it doesn't call $apply method.
     *
     * Example:
     * <span base-click="yourFunction();"></span>
     */
    .directive(directiveName, ['$parse', function ($parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var
            attrFn,
            fn,
            param;

          if (/\(/.test(attrs[directiveName])) {
            attrFn = $parse(attrs[directiveName], null, true);
            fn = function (event) {
              attrFn(scope, {$event: event});
            }
          }
          else {
            attrFn = scope[attrs[directiveName]];
            param = scope[attrs[directiveName + 'Param']];
            fn = function() {
              attrFn.call(null, param);
            };
          }

          angular.element(element).bind(eventName, fn);

          scope.$on('$destroy', function () {
            angular.element(element).unbind(eventName, fn);
          });
        }
      };
    }]);
  });

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

})();;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/faChart.js
angular.module('base')

/**
 * @name        faChart
 * @description
 */
.directive('faChart', function () {
return {
    restrict: 'A',
    templateUrl: function (el, attr) { return attr.templateUrl; },
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/faContentWrapper.js
angular.module('base')

/**
 * @name        faContentWrapper
 * @description
 */
.directive('faContentWrapper', ['$state', function ($state) {
return {
    restrict: 'A',
    transclude: true,
    templateUrl: function (el, attr) {
      return attr.templateUrl;
    },
    replace: true,
    link: function ($scope) {
      if ($state.current.name == 'fare_alerts_activate') {
        $scope.isShowActivateBox = true;
      }
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/faInactive.js
angular.module('base')

/**
 * @name        faInactive
 * @description
 */
.directive('faInactive', function () {
return {
    restrict: 'A',
    templateUrl: function (el, attr) { return attr.templateUrl; },
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/faOffers.js
angular.module('base')

/**
 * @name        faOffers
 * @description
 */
.directive('faOffers', function () {
return {
    restrict: 'A',
    templateUrl: function (el, attr) { return attr.templateUrl; },
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/faProfile.js
angular.module('base')

/**
 * @name        faProfile
 * @description
 */
.directive('faProfile', function () {
return {
    restrict: 'A',
    templateUrl: function (el, attr) { return attr.templateUrl; },
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/fareAlertFpBox.js
angular.module('base')

.controller('fareAlertFpBoxCtrl', ['$scope', '$location', 'FareAlertsSrv', '$rootScope', 'RodoService', 'goo.Remarketing',
  function($scope, $location, FareAlertsSrv, $rootScope, RodoService, Remarketing) {
$scope.showFABoxLoading = false;
    $scope.nlSubscribeProp = false;
    $scope.nlSubscribeHasError = false;

    $scope.resetErrors = function() {
      $scope.errors = null;
    };

    this.$onInit = function () {
      if ($rootScope.auth && $rootScope.auth.email) {
        $scope.email = $rootScope.auth.email;
      } else {
        $scope.email = '';
      }
    };

    $scope.faSaveUser = function (isValid) {
      if (RodoService.isEnabled('fareAlertsBox') && RodoService.getSettings().fareAlertsConsent && !$scope.nlSubscribeProp) {
        $scope.nlSubscribeHasError = true;
        return;
      }

      $scope.nlSubscribeHasError = false;

      if (typeof ga != 'undefined') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Flight Search Filter',
          eventAction: 'Create fare alert',
          eventLabel: '1',
          nonInteraction: true
        });
      }

      Remarketing.trackFareAlert();

      if(!isValid) {
        return;
      }

      $scope.showFABoxLoading = true;
      FareAlertsSrv.saveUser($scope.email).then(function success(response) {
          if (response.confirmation_link) {
            $location.path('/' + response.confirmation_link);
          }
          else if (response.profileUrl) {
            $location.path('/' + response.profileUrl);
          }
          else if (response.error) {
            $scope.showFABoxLoading = false; //only if errors
            $scope.errors = response.error;
          }
        }
      );
    };
  }]
)

/**
 * @name        fareAlertFpBox
 * @description
 */
.directive('fareAlertFpBox', function () {
return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/fareAlerts/fareAlertFpBox-hyb',
    replace: true,
    scope: {
      additionalTitle: '@'
    },
    controller: 'fareAlertFpBoxCtrl'
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/lineAreaChart.js
angular.module('base')

/**
 * @name        lineAreaChart
 * @description directive for price watch chart
 */
.directive('lineAreaChart',
['$timeout',
function lineAreaChart($timeout) {
return {
    restrict: 'A',
    template: "<div id='priceWatchChart' class='ct-chart'></div>",
    replace: true,
    scope: {
      chartData: '=ngModel',
      chartReload: '=?',
      pointLabelFormatter: '@'
    },
    compile: function compile(tElement, tAttrs, transclude) {
      return {
        post: function postLink($scope, element, attrs) {

          $scope.chart = null;

          //leave only necessary for the future
          $scope.options = {
            // Options for X-Axis
            axisY: {
              // If labels should be shown or not
              showLabel: 0,
              // If the axis grid should be drawn or not
              showGrid: 0
            },
            // If the line chart should draw an area
            showArea: true,
            // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
            lineSmooth: false,
            // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
            low: 0,
            // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
            height: '150px',
            // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
            high: undefined,
            // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
            chartPadding: {
              top: 15,
              right: 0,
              bottom: 0,
              left: 0
            },
            // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
            //also when is set to true and you have only one point javascript throw error
            fullWidth: true,
            // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
            reverseData: false,
            plugins: [],

            seriesBarDistance: 30,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value.slice(0, 3);
              }
            }
          };

          function isInternetExplorer()
          {
            if (navigator.appName == 'Microsoft Internet Explorer')
            {
              var ua = navigator.userAgent;
              var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
              if (re.exec(ua) != null)
                return true;
            }
            else if (navigator.appName == 'Netscape')
            {
              var ua = navigator.userAgent;
              var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
              if (re.exec(ua) != null)
              {
                //var i = parseFloat( RegExp.$1 );
                return true;
              }
            }
            return false;
          }

          $scope.responsiveOptions = [
            /*['screen and (min-width: 1px)', {
              seriesBarDistance: 30,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value.slice(0, 3);
                }
              }
            }]*/
          ];

          //sets big points with stroke
          function setBigPoints(data) {
            if (data.type === 'point') {
              data.group.elem('circle', {
                cx: data.x,
                cy: data.y,
                r: 12
              }, 'ct-circle-outside');

              data.group.elem('circle', {
                cx: data.x,
                cy: data.y,
                r: 7
              }, 'ct-circle-inside');
            }
          }

          //sets short vertical axis visible only below points
          function setVerticalAxis(chart) {
            var gridData = null, pointData = null;
            chart.on('draw', function (data) {
              if (data.type === 'grid' && data.axis.units.dir == "horizontal") {
                gridData = data;
              }
              if (data.type === 'point') {
                pointData = data;
              }

              if (gridData && pointData) {
                /**
                 * remove old, drawing new vertical lines
                 */
                data.group.elem('line', {
                  x1: pointData.x,
                  x2: pointData.x,
                  y1: pointData.y + 4,
                  y2: gridData.y2
                }, 'verticalPointAxis');
                var oldGridLines = document.getElementsByClassName(chart.options.classNames.horizontal);
                for (var i = 0; i < oldGridLines.length; i++) {
                  var elem = oldGridLines[i];
                  if (elem.tagName == "line") {
                    elem.parentNode.removeChild(elem);
                  }
                }
              }
            });
          }

          //align labels
          function setLabelsPosition(data) {
            if (data.type === 'label' && data.axis.units.pos === 'x') {
              var barWidth = data.axis.stepLength;
              var
                defaultPosition = data.index * data.axis.stepLength
                ;
              if (isInternetExplorer())
              {
                barWidth = 20;
              }
              data.element.attr({
                x: Math.round(defaultPosition - ( barWidth / 2)) + $scope.options.chartPadding.left+40
              });
            }
          }

          //set chart animation
          function setAnimation(data) {
            if (data.type === 'line' || data.type === 'area') {
              data.element.animate({
                d: {
                  begin: 2000 * data.index,
                  dur: 2000,
                  from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                  to: data.path.clone().stringify(),
                  easing: Chartist.Svg.Easing.easeOutQuint
                }
              });
            }
          }

          //set label for point using format pattern from scope.pointLabelFormatter
          function setPointLabels(data) {
            if (data.type === 'point' && $scope.pointLabelFormatter.length > 0) {
              var options = {
                labelClass: 'ct-label',
                labelOffset: {
                  x: 0,
                  y: -20
                },
                textAnchor: 'middle',
                labelInterpolationFnc: Chartist.noop
              };

              data.group.elem('text', {
                x: data.x + options.labelOffset.x,
                y: data.y + options.labelOffset.y,
                style: 'text-anchor: ' + options.textAnchor
              }, options.labelClass).text($scope.pointLabelFormatter.replace(/\{value\}/g, data.value));
            }
          }

          function properChartData() {
            return typeof $scope.chartData === 'object' && Object.getOwnPropertyNames($scope.chartData).length != 0 && $scope.chartData.labels && $scope.chartData.series;
          }

          $scope.blockChartRefresh = false;

          var isRefreshBlocking = function(withTimer){
            if (withTimer)
            {
              toggleLockTimer();
            }
            return $scope.blockChartRefresh;
          };

          var toggleRefresh = function() {
            $scope.blockChartRefresh = !$scope.blockChartRefresh;
          };

          var $timer;
          var toggleLockTimer = function(){
            if ($timer) clearTimeout($timer);
            $timer = $timeout(function(){
              toggleRefresh();
            }, 300);
          };

          var getLabelsCount = function(){
            return ($scope.chartData && $scope.chartData.labels)? $scope.chartData.labels.length : 0;
          };

          var sizeRefresh = function(){
            var wrapperWidth = element[0].clientWidth - 40,
              left = 0,
              right = 0;

            switch (getLabelsCount() - 1)
            {
              case 0:
                left = Math.round(wrapperWidth/3);
                right = left;
                left += left/2;
                break;
              case 1:
                left = Math.round(wrapperWidth/3);
                right = left;
                break;
              case 2:
                left = Math.round(wrapperWidth/5);
                right = left;
                break;
              default:
                left = 0;
                right = 0;
                break;
            }

            $scope.options.chartPadding.left = left;
            $scope.options.chartPadding.right = right+40;
          };

          var refreshFullWidth = function() {
            $scope.options.fullWidth = (getLabelsCount() > 1)? true : false;
          };

          var rebuildChart = function(){
            refreshFullWidth();
            sizeRefresh();

            try {

              $scope.chart = new Chartist.Line('#priceWatchChart', $scope.chartData, $scope.options, $scope.responsiveOptions);

              setVerticalAxis($scope.chart);
              $scope.chart.on('draw', function (data)
              {
                setBigPoints(data);
                setLabelsPosition(data);
                setAnimation(data);
                setPointLabels(data);

                if (!isRefreshBlocking(true))
                {
                  toggleRefresh();
                  sizeRefresh();
                  rebuildChart();
                }
              });

            } catch (e) {

            }



          };

          //sets chart
          $scope.setChart = function () {
            rebuildChart();
          };

          //update chart (useful for charts in hidden elements)
          $scope.updateChart = function () {
            document.getElementById("priceWatchChart").__chartist__.update();
          };

          $scope.$watch('chartReload', function (newValue, oldValue) {
            if ($scope.chartReload && properChartData()) {
              $timeout(function () {
                $scope.setChart();
                $scope.updateChart();
              }, 50);
            }
          });

          $scope.$watch('chartData', function () {
            if (properChartData()) {
              $scope.setChart();
            }
            else {
              if ($scope.chart && $scope.chart.svg && $scope.chart.svg._node.parentNode) {
                $scope.chart.svg.remove();
              }
            }
          });
        }
      };
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/directives/fareAlerts/priceWatch.js
angular.module('base')

/**
 * @name        priceWatch
 * @description Price watch directive
 */
.directive('priceWatch', ['Preloader', function priceWatch() {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },

    controller: ['$scope', '$location', '$timeout', 'FareAlertsSrv', 'FareAlertsLib', '$filter', '$attrs', '$stateParams', 'sch.SearchQueryParams', '$rootScope', '$document', '$modal', 'RodoService',
      function ($scope, $location, $timeout, FareAlertsSrv, FaLib, $filter, $attrs, $stateParams, sqp, $rootScope, $document, $modal, RodoService) {
        var
          temp,
          params = //ugly fix SearchQueryParams
          {
            departure_date: $stateParams.depDate || sqp.departure_date,
            return_date: $stateParams.arrDate || sqp.return_date,
            flight_from_code: $stateParams.depCode || sqp.flight_from_code,
            flight_to_code: $stateParams.arrCode || sqp.flight_to_code,
            matrix_min_price: sqp.getMatrixMinPrice(),
            roundtrip: parseInt($stateParams.ow) !== 1
          },

          dateDiffDays = 0;

        if (params.roundtrip) {
          // dateDiffDays = moment.utc(moment(params.return_date, "YYYY-MM-DD").diff(moment(params.departure_date, "YYYY-MM-DD"))).format("DD");
          //It was changed, because it was problem with days > 31.

          temp = moment(params.return_date, "YYYY-MM-DD").diff(moment(params.departure_date, "YYYY-MM-DD"));
          temp = moment.duration(temp);

          dateDiffDays = Math.floor(temp.asHours() / 24);
        }

        var
          showPriceWatch = true,
          updateControl,
          moveToProfile = true,
          resultsPwBox = ($attrs.faType == 'results-tab'),
          defaultArgs =
          {
            formData: {
              travel_period: params.departure_date != undefined ? $filter('date')(params.departure_date, 'M') : '',
              flight_from_code: params.flight_from_code != undefined ? params.flight_from_code : '',
              flight_to_code: params.flight_to_code != undefined ? params.flight_to_code : '',
              matrix_min_price: params.matrix_min_price || '',//sqp.getMatrixMinPrice(),
              trip_length_min: ( parseInt(dateDiffDays) - 3) > 0 && parseInt(dateDiffDays) <= 40 ? parseInt(dateDiffDays) - 3 : 1,
              trip_length_max: (parseInt(dateDiffDays) + 3) < 40 ? parseInt(dateDiffDays) + 3 : 40,
              round_trip: params.roundtrip
            }
          };

        $scope.alerts = [];
        $scope.formData = {};
        $scope.chartData = {};
        $scope.chartLoaded = false;
        $scope.fareAlertsData = {};
        $scope.showPriceWatchLoading = false;
        $scope.travel_period = '';
        $scope.tripRange = null;
        $scope.placeholder = $filter('translate')('LANGM_JS_FAF_PRICE_PLACEHOLDER');
        $scope.email_placeholder = $filter('translate')('LANGM_JS_FAF_EMAIL_PLACEHOLDER');
        $scope.propover_content = $filter('translate')('LANGM_JS_FAF_TOOLTIP_INFO');

        if (resultsPwBox) {
          FaLib.showResetButton(false);
          FaLib.showEmailInput(true);
          FaLib.forceSetArgs(false);
          FaLib.autoResetForm(false);
          moveToProfile = false;
          showPriceWatch = !FaLib.isAlreadyCreated(defaultArgs.formData);

          $scope.$evalAsync(function () {
            $scope.tripRange = {
              min: $scope.formData.trip_length_min,
              max: $scope.formData.trip_length_max
            };

            $timeout(function () { //scope refresh
              $scope.$broadcast('cityHelper.reload');
              $scope.$broadcast('monthpicker.reload');
              $scope.$broadcast('tripLength.reload', {
                min: $scope.formData.trip_length_min,
                max: $scope.formData.trip_length_max
              });
            });
          });
        }

        $scope.settings =
        {
          uId: $stateParams.uId || undefined,
          show: showPriceWatch,
          showResetButton: FaLib.isShowResetButton(),
          showEmailInput: FaLib.isShowEmailInput(),
          autoResetForm: FaLib.isAutoResetForm(),
          showUnlockBox: FaLib.isShowUnlockBox(),
          tripLengthMin: /*defaultArgs.formData.trip_length_min ||*/ 1,
          tripLengthMax: /*defaultArgs.formData.trip_length_max ||*/ 40,
          tripLengthValues: _.range(1, 40),
          priceLengthMax: FaLib.getPriceLengthMax(),
          showFaProfile: FaLib.isShowFaProfile()
        };

        $scope.scrollTo = function (id) {
          //$location.hash(id);
          //$anchorScroll();
          $document.scrollToElement(angular.element(document.getElementsByClassName('new-fare-alerts')));
        };

        $scope.addAlert = function (type, msg, once) {
          if (once && _.where($scope.alerts, {type: type, msg: msg}).length) { /* Nothing */
          } else {
            if ($scope.alerts.length >= 5) // Store max 6 messages
            {
              var indexToRemove = 0, numberToRemove = 1;
              $scope.alerts.splice(indexToRemove, numberToRemove);
            }

            $scope.alerts.push({type: type, msg: msg});
          }
        };

        $scope.closeAlert = function (index) {
          $scope.alerts.splice(index, 1);
        };

        /**
         * Action: update
         * update ChartData
         **/
        $scope.update = function () {
          if (updateControl) {
            clearTimeout(updateControl);
          }
          //reduce request number
          if (!_.isEmpty($scope.formData.flight_from_code) && !_.isEmpty($scope.formData.flight_to_code)) {
            updateControl = setTimeout(function () {
              $scope.loadChartData();
            }, 500);
          }
        };

        /**
         * Action: resetForm
         * Reset Form Fields
         **/
        $scope.resetForm = function ($event) {
          if ($event) $event.preventDefault();

          FaLib.setDefaultValues($scope);
          $scope.settings.showResetButton = false;
          $scope.chartData = {};
          $scope.tripRange = {
            min: $scope.formData.trip_length_min,
            max: $scope.formData.trip_length_max
          };

          $timeout(function () { //scope refresh
            $scope.$broadcast('cityHelper.reload');
            $scope.$broadcast('monthpicker.reload');
            $scope.$broadcast('tripLength.reload', {
              min: $scope.formData.trip_length_min,
              max: $scope.formData.trip_length_max
            });
          });

          $scope.loadChartData();
        };

        var isTheSameCity = function() {
          if ($scope.formData.flight_from_code !== $scope.formData.flight_to_code) {
            return false;
          }
          showModalWithError( $filter('translate')('LANGM_JS_FAF_THE_SAME_CITY_ERROR') );
          return true;
        };

        var showModalWithError = function(message) {
          $modal.open({
            templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsFormErrors',
            controller: 'flightsFormErrorsModalCtrl',
            windowClass: 'flight-modal-message',
            resolve: {
              errors: function () {
                return {
                  custom: [message]
                };
              }
            }
          });
        };

        var isValidCitySet = function()
        {
          if (!$scope.formData.flight_from) {
            showModalWithError( $filter('translate')('LANGM_JS_FAF_CITY_FROM_ERROR') );
            return false;
          }
          if (!$scope.formData.flight_to) {
            showModalWithError( $filter('translate')('LANGM_JS_FAF_CITY_TO_ERROR') );
            return false;
          }
          return true;
        };

        var isCitiesValid = function () {
          return !isTheSameCity() && ($scope.pwIgnoreCh || isValidCitySet());
        };

        $scope.nlAgreeTerms = false;
        $scope.nlAgreeTermsError = false;

        /**
         * Action: Create
         * Create fare alert
         */
        $scope.saveAlert = function (options) {
          if (!$scope.nlAgreeTerms && RodoService.getSettings().fareAlertsConsent) {
            $scope.nlAgreeTermsError = true;
            return;
          }

          $scope.nlAgreeTermsError = false;
          $scope.showPriceWatchLoading = true;
          if (!isCitiesValid()) {
            $scope.showPriceWatchLoading = false;
            return;
          }
          $scope.formData.errors = undefined;

          $scope.formData.moveToProfile = moveToProfile;

          FareAlertsSrv.saveAlert($scope.formData).then
          (
            function success(resp) {
              var alert_msg;

              // Add inactive item
              if (resp.blocked) {

                alert_msg = $filter('translate')('LANGM_JS_FAM_THANK_YOU_ADDED_ITEM_INACTIVE', $scope.formData);
                if(!FaLib.isAlertExists(alert_msg, $scope.alerts)) {
                  $scope.addAlert('warning', alert_msg);
                }

                FaLib.setAsCreatedFor($scope.formData);

                if (resultsPwBox) $scope.formData.okMessage = $filter('translate')('LANGM_JS_FAM_THANK_YOU_FOR_ADDED', $scope.formData);

              }
              else if ($scope.formData.id) // Edit item
              {

                alert_msg = $filter('translate')('LANGM_JS_FAM_THANK_YOU_UPDATED_ITEM_SUCCESS', $scope.formData);
                if(!FaLib.isAlertExists(alert_msg, $scope.alerts)) {
                  $scope.addAlert('success', alert_msg);
                }

              }
              else if (resp.errors) // Errors found
              {
                console.log('resp',resp)
                console.log('$scope.formData',$scope.formData)
                console.log('$scope.faForm',$scope.faForm)
                $scope.formData.errors = resp.errors;
              }
              else if (resp.redirectUrl && !$stateParams.uId) // Move to page
              {
                window.location.href = resp.redirectUrl;
              }
              else // Add active item
              {

                alert_msg = $filter('translate')('LANGM_JS_FAM_THANK_YOU_ADDED_ITEM_SUCCESS', $scope.formData);
                if(!FaLib.isAlertExists(alert_msg, $scope.alerts)) {
                  $scope.addAlert('success', alert_msg);
                }

                FaLib.setAsCreatedFor($scope.formData);

                if (resultsPwBox) $scope.formData.okMessage = $filter('translate')('LANGM_JS_FAM_THANK_YOU_FOR_ADDED', $scope.formData);

              }

              // Reset form fields
              if (options.resetForm && !$scope.formData.errors) {
                $scope.resetForm();
              }

              // Get profile data with fare alerts
              if (!$scope.formData.errors && !$scope.settings.showEmailInput) {
                $scope.getProfileData($scope.hash);
              }

              $timeout(function () {
                $scope.showPriceWatchLoading = false;
              });
            }
          );
        };

        $scope.refresh = function(){
          $scope.tripRange = {
            min: $scope.formData.trip_length_min,
            max: $scope.formData.trip_length_max
          };
          $timeout(function () { //scope refresh
            $scope.$broadcast('cityHelper.reload');
            $scope.$broadcast('monthpicker.reload');
            $scope.$broadcast('tripLength.reload', {
              min: $scope.formData.trip_length_min,
              max: $scope.formData.trip_length_max
            });
          });
        };

        /**
         * Action: Edit
         * Edit fare alert
         **/
        $scope.edit = function (id, noLoading) {
          $scope.settings.showResetButton = true;
          $scope.formData.errors = undefined;

          if (noLoading == undefined) $scope.showPriceWatchLoading = true;

          FareAlertsSrv.getData('fareAlertById', {id:id, token:$stateParams.uId}).then
          (
            function success(resp) {
              if (resp.values) {
                if (resp.values.max_price == 999999) {
                  resp.values.max_price = '';
                }

                /**
                 * Todo: Scroll to fa form
                 */
                $scope.scrollTo('new-fare-alerts'); // Scroll to adding form
                $scope.formData = $scope.populateFormData($scope.formData, resp.values);
                $scope.refresh();
                $scope.loadChartData();

              }
            }
          );
        };

        /**
         * Action: Set
         * Set fare alert
         **/
        $scope.set = function (id) {
          $scope.showPriceWatchLoading = true;
          FareAlertsSrv.getData('setFareAlert', id).then
          (
            function success(resp) {
              if (resp) {
                $scope.formData = $scope.populateFormData($scope.formData, resp);
                $scope.refresh();
                $scope.loadChartData();
              }
            }
          );
        };

        /**
         * Populate form values
         * @param formData
         * @param values
         * @returns {*}
         */
        $scope.populateFormData = function (formData, values) {
          formData.id = values.id || '';
          formData.from = null;
          formData.from_name = values.from_name;
          formData.to = null;
          formData.to_name = values.to_name;
          formData.flight_from_code = values.from_code;
          formData.flight_from = values.from_code;
          formData.flight_to_code = values.to_code;
          formData.flight_to = values.to_code;
          formData.max_price = values.max_price;
          formData.trip_length_min = values.trip_length_min[0];
          formData.trip_length_max = values.trip_length_max[0];
          formData.travel_period = values.travel_period.join(',');

          return formData;
        };

        /**
         * Set fare alert
         */
        if ($scope.faSetId != undefined) {
          $scope.set($scope.faSetId);
        }

        /**
         * Load Chart data by from/to code
         */
        $scope.loadChartData = function () {
          var frCode = $scope.formData.flight_from_code,
            toCode = $scope.formData.flight_to_code;

          if (!FaLib.validCode(frCode) || !FaLib.validCode(toCode)) return;

          FareAlertsSrv.getData('loadChartByParams', {from_code: frCode, to_code: toCode}).then
          (
            function success(resp) {
              $scope.chartData = resp.chart_data;
              $scope.showPriceWatchLoading = false;
              $timeout(function(){
                $scope.chartLoaded = true;
              }, 500);

            }
          );
        };

        /**
         * Load profile
         *
         * @param hash
         */
        $scope.getProfileData = function (hash) {
          var args = hash ? {hash: hash} : {token: $stateParams.uId};
          $scope.formData.showPriceWatchLoading = true;
          FareAlertsSrv.getData('profileData', args).then
          (
            function success(resp) {
              $scope.uId = resp.token;
              $scope.email = resp.email;
              $scope.formData.uId = $scope.uId || undefined;

              $scope.settings.showUnlockBox = resp.blocked;
            }
          );

          /**
           * Edit fare alert
           */
          if ($scope.faId != undefined) {
            $scope.edit($scope.faId, 1);
          }

          FareAlertsSrv.getProfile(hash).then
          (
            function success(resp) {
              $scope.fareAlertsData = resp;

              if (resp.headerMessage) {
                var typeMsg = resp.typeMessage ? resp.typeMessage : 'warning';
                $scope.addAlert(typeMsg, resp.headerMessage, true);
              }
              $scope.formData.showPriceWatchLoading = false;
            }
          );
        };

        // Set default form values
        FaLib.setDefaultValues($scope, defaultArgs.formData);

        /**
         * Action: Profile
         * Get the profile data
         **/
        if (!$scope.settings.showEmailInput) {
          $scope.getProfileData($scope.hash);
        }

        // Is email address is available
        if ($scope.settings.showEmailInput) {
          // Is User logged - disabled prefill momentarily due to GDRP law changes
          if (false && $rootScope.auth && $rootScope.auth.email) {
            $scope.formData.email = $rootScope.auth.email;
          }
          else {
            $scope.formData.email = '';
          }
        }

        // Mapping to formData from tripLengthSelector
        $scope.tripLengthUpdate = function (data) {
          $scope.formData.trip_length_min = data.tripMin;
          $scope.formData.trip_length_max = data.tripMax;
        };

        var blockResetEvent = false;
        var broadcastResetEvent = function($id)
        {
          if (blockResetEvent) {
            blockResetEvent = false;
            return;
          }

          blockResetEvent = true;
          $scope.$broadcast('cityHelper-'+$id+'.reset');
          $timeout(function ()
          {
            blockResetEvent = false;
          }, 50);
        };
        /**
         * city change envents
         */
        var cityFromChangeDestructor = $scope.$on('cityHelper-from', function (event, args)
        {
          broadcastResetEvent('pw-to');
          if (angular.isObject($scope.formData.flight_from) && angular.isDefined($scope.formData.flight_from.city_code)) {
            $scope.formData.flight_from_code = $scope.formData.flight_from.city_code;
            $scope.update();
          }
        });

        var cityToChangeDestructor = $scope.$on('cityHelper-to', function (event, args)
        {
          broadcastResetEvent('pw-from');
          if (angular.isObject($scope.formData.flight_to) && angular.isDefined($scope.formData.flight_to.city_code)) {
            $scope.formData.flight_to_code = $scope.formData.flight_to.city_code;
            $scope.update();
          }
        });

        var tripLengthSelectorChangeDestructor = $scope.$on('tripLength.change', function () {
          $scope.$evalAsync(function () //scope must refresh first
          {
            $scope.formData.trip_length_min = parseInt($scope.tripRange.min);
            $scope.formData.trip_length_max = parseInt($scope.tripRange.max);
          });
        });

        var matrixUpdatedDest = $rootScope.$on('matrixUpdated', function (e, obj) {
          $scope.formData.max_price = ( params.roundtrip ) ? obj.min_price : obj.min_price * 2;
        });

        /**
         * Destructors
         */
        $scope.$on('$destroy', function () {
          cityFromChangeDestructor();
          cityToChangeDestructor();
          tripLengthSelectorChangeDestructor();
          matrixUpdatedDest();
        });
      }],
      link: function(scope, element, attrs)
      {
        scope.pwIgnoreCh = scope.$eval(attrs.pwIgnoreCh) || false;
      }
  };

}]);
;

// Source: ../shared/public_html/assets/js/base/directives/fixedMenu/fixedMenu.js
angular.module('base')

/**
 * @name        fixedMenu
 * @description
 */
.directive('fixedMenu', ['$document', '$window', function ($document, $window) {
return {
    restrict: 'A',
    scope: false,
    controller: ['$scope', '$element', function (scope, $element) {

      var
        box = $document[0].getElementById('sp-menu'),
        windowOffset = 0,
        wrapperHeight = 0,
        wrapperOffset = 0,
        boxHeight = 0;

      $document.bind('scroll', function () {

        windowOffset = $window.pageYOffset;
        boxHeight = box.offsetHeight;
        wrapperOffset = $element[0].offsetTop;
        wrapperHeight = $element[0].offsetHeight;

        scope.$apply(function () {

          if ((windowOffset >= wrapperOffset) && windowOffset <= (wrapperHeight + wrapperOffset)) {
            scope.fixed = true;
            scope.bottom = false;
          }

          if (windowOffset >= (wrapperHeight + wrapperOffset - boxHeight)) {
            scope.fixed = false;
            scope.bottom = true;
          }

          if ((windowOffset < wrapperOffset)) {
            scope.fixed = false;
            scope.bottom = false;
          }
        });
      });
    }]
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/footer/baseFooterOld.js
angular.module('base')

/**
 * @name        baseFooterOld
 * @description Directive for base footer
 */
.directive('baseFooterOld', ['$location', function ($location) {
return {
    restrict: 'A',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    transclude: true,
    controller: ['$scope', function ($scope) {
      $scope.forceDisplay = false;

      $scope.$on('footer-updated', function (event, footerObject) {
        $scope.forceDisplay = footerObject.displayLinks;
      });
    }],

    link: function ($scope) {
      $scope.isHomepageFooter = function () {
        return $location.path() == "/" || $scope.forceDisplay;
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/footer/footerLinksMap.js
(function (angular) {
var IthLanguageSelectDirective = function ($location, LangSrv, appConfig) {
        var directiveLink = function ($scope) {
            /**
             * Changes url to proper language subdomain
             * @param  {String} langVersion Language version key (en/ro/pl/ua/vn)
             * @return {void}
             */
            $scope.changeLanguageVersion = function (langVersion) {
                if ($scope.isLanguageVersion(langVersion)) {
                    return;
                }

                LangSrv
                    .getTranslatedUrl({
                        lang: langVersion,
                        url: $location.url()
                    })
                    .then(function success(redirectUrl) {
                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                        }
                    });
            };

            /**
             * Checks if current language version mathes the parameter
             * @param  {String} langVersion Language version key (en/ro/pl/ua/vn)
             * @return {Boolean}
             */
            $scope.isLanguageVersion = function (langVersion) {
                if (appConfig.getUriPrefix() === langVersion) {
                    return true;
                }

                return appConfig.getLanguageCode() === langVersion;
            };
        };

        return {
            restrict: 'A',
            link: directiveLink
        };
    };

    IthLanguageSelectDirective.$inject = [
        '$location',
        'LangSrv',
        'appConfig'
    ];

    angular
        .module('base')
        .directive('ithLanguageSelect', IthLanguageSelectDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/footer/footerSeo.js
angular.module('base')
/**
 * @name footerSeo
 * @description Directive for footer SEO component.
 */
    .directive('footerSeo', ['$state', function ($state) {
return {
            restrict: 'E',
            scope: {
                contentLoaded: '<',
                contentToLoad: '=',
                contentVisible: '='
            },
            link: function(scope) {

                /**
                 * List of excluded states.
                 * Footer SEO should be hidden in those states.
                 *
                 * @type {string[]}
                 */
                var excluded = [
                    'search_results',
                    'flight_details',
                    'thank_you',
                    'hotel_search_results',
                    'hotel_details_page',
                    'hotel_booking',
                    'package_search_results',
                    'package_details'
                ];

                /**
                 * Check if footer SEO should be visible.
                 *
                 * @returns {boolean}
                 */
                function shouldBeVisible() {
                    return (excluded.indexOf($state.current.name) === -1);
                }

                /**
                 * Indicates whether footer SEO content is visible.
                 *
                 * @type {boolean}
                 */
                scope.contentVisible = false;

                /**
                 * URL of template with content to load from backend.
                 *
                 * @type {string}
                 */
                scope.contentToLoad = '';

                /**
                 * Footer SEO visibility change after each state change.
                 */
                scope.$on('$stateChangeSuccess', function () {
                    if (shouldBeVisible()) {
                        if (scope.contentLoaded) {
                            scope.contentVisible = true;
                        } else {
                            scope.contentToLoad = 'tpl/show/jsShared/templates/base/directives/footer/footerSeoContent-hyb';
                            scope.contentLoaded = true;
                            scope.contentVisible = true;
                        }
                    } else {
                        scope.contentVisible = false;
                    }
                });
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/footer/search-footer.component.js
(function(angular) {
angular
        .module('base')
        .component('ithSearchFooter', {
            template: '<div class="footerSearch"><div class="container" translate>LANGM_JS_FS_PAGE_FOOTER</div></div>'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/footer/smallFooterOld.js
angular.module('base')

/**
 * @name        smallFooterOld
 * @description Directive for base footer
 */
.directive('smallFooterOld', function () {
return {
    restrict: 'EA',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/formElements.js
(function ()
{
/*  var PARENT_CLASS = {
    $valid: 'vola-child-valid',
    $invalid: 'vola-child-invalid',
    $touched: 'vola-child-touched',
    $untouched: 'vola-child-untouched',
    $dirty: 'vola-child-dirty',
    $pristine: 'vola-child-pristine',
    $pending: 'vola-child-pending'
  };

  /!**
   * default refresh function after validation
   * @param element
   * @param controller
   * @returns {{isRefreshPossible: Function, execute: Function}}
   *!/
  var defaultRefresh = function( element, controller )
  {
    return {
      /!**
       * @returns {boolean}
       *!/
      isRefreshPossible: function()
      {
        var parent = element.parent();

        return !!parent;
      },

      /!**
       * method using for refresh wrapper class
       *!/
      execute: function()
      {
        var parent = element.parent();

        angular.forEach(controller.vola_lastStatus, function ($e, $i)
        {
          if (controller[$i] === $e) return true;

          controller.vola_lastStatus[$i] = controller[$i];

          if (controller.vola_lastStatus[$i])
          {
            parent.addClass(PARENT_CLASS[$i]);
          }
          else
          {
            parent.removeClass(PARENT_CLASS[$i]);
          }
        });
      }
    };
  };

  /!**
   * definition for directives input, select
   *!/
  var definition = function($timeout, $q) {
    return {
      restrict: 'E',
      require: '?ngModel',
      link: function(scope, elm, attr, ctrl)
      {
        if ( !ctrl || attr.disableFormElements || attr.disableFe ) return;

        /!**
         * function running when value is changed
         *!/
        var $refresh,
          deffered = $q.defer();

        /!**
         * additional statuses in controller, use for control addClass and removeClass
         *
         * @type {{$valid: null, $invalid: null, $touched: null, $untouched: null, $dirty: null, $pristine: null, $pending: null}}
         *!/
        ctrl.vola_lastStatus =
        {
          $valid: null,
          $invalid: null,
          $touched: null,
          $untouched: null,
          $dirty: null,
          $pristine: null,
          $pending: null
        };

        /!**
         * strategy - if refreshFunction is not existing, do defaultRefresh
         *!/
        if ( attr.refreshFunction )
        {
          $timeout(function()
          {
            var refreshFunction = scope.$eval(attr.refreshFunction);

            if ( angular.isFunction(refreshFunction) )
            {
              $refresh = refreshFunction( elm, ctrl );
            }
            deffered.resolve();
          });
        }
        else
        {
          $refresh = defaultRefresh( elm, ctrl );
          deffered.resolve();
        }

        /!**
         * if refresh possible init and wait for change
         *!/
        deffered.promise.then(function()
        {
          if ( $refresh && $refresh.isRefreshPossible() )
          {
            $refresh.execute();
            ctrl.$viewChangeListeners.push( $refresh.execute );
          }
        });
      }
    };
  };

  angular.module('base')
  /!**
   * @name        input
   * @description additional functionality for angular input
   *!/
    .directive('input', ['$timeout', '$q', function($timeout, $q)
    {
      return definition($timeout, $q);
    }])

  /!**
   * @name        select
   * @description additional functionality for angular select
   *!/
    .directive('select', ['$timeout', '$q', function($timeout, $q)
    {
      return definition($timeout, $q);
    }])
  ;*/

})();
;

// Source: ../shared/public_html/assets/js/base/directives/formErrors/ith-booking-form-helper.service.js
(function(angular) {
var IthBookingFormHelperService = function () {
        /**
         *
         */
        this.getChildForm = function (bookingForm, name) {
            if (name === 'creditCardForm') {
                if (!bookingForm.hasOwnProperty('paymentInfo') || !bookingForm.paymentInfo.hasOwnProperty('creditCardForm')) {
                    return null;
                }

                return bookingForm.paymentInfo.creditCardForm;
            }
            if (name === 'blikCodeForm') {
                if (!bookingForm.hasOwnProperty('paymentInfo') || !bookingForm.paymentInfo.hasOwnProperty('blikCodeForm')) {
                    return null;
                }
                return bookingForm.paymentInfo.blikCodeForm;
            }

            if (name === 'pblForm') {
                if (!bookingForm.hasOwnProperty('paymentInfo') || !bookingForm.paymentInfo.hasOwnProperty('pblForm')) {
                    return null;
                }
                return bookingForm.paymentInfo.pblForm;
            }

            if (!bookingForm.hasOwnProperty(name)) {
                return null;
            }

            return bookingForm[name];
        };

        /**
         *
         */
        this.areAllFormsValid = function (forms) {
            var valid = true;

            angular.forEach(forms, function (form) {
                if (!form.$valid) {
                    valid = false;
                }
            });

            return valid;
        };

        /**
         *
         */
        this.areAllFormsSubmitted = function (forms) {
            var submitted = true;

            angular.forEach(forms, function (form) {
                if (!form.$submitted) {
                    submitted = false;
                }
            });

            return submitted;
        };

        /**
         *
         */
        this.getFirstStepForms = function (bookingForm, paxCount) {
            var forms = [];

            var contactInfoForm = this.getChildForm(bookingForm, 'contactInfo');

            if (contactInfoForm) {
                forms.push(contactInfoForm);
            }

            for (var i = 0; i < paxCount; i++) {
                var paxForm = this.getChildForm(bookingForm, 'passengerDetails' + i);

                if (paxForm) {
                    forms.push(paxForm);
                }
            }

            return forms;
        };

        /**
         *
         */
        this.getLastStepForms = function (bookingForm, paxCount) {
            var forms = [];

            var editContactInfoForm = this.getChildForm(bookingForm, 'editContactInfo');
            var billingPersonForm = this.getChildForm(bookingForm, 'billingPerson');
            var billingCompanyForm = this.getChildForm(bookingForm, 'billingCompany');
            var creditCardForm = this.getChildForm(bookingForm, 'creditCardForm');
            var blikCodeForm = this.getChildForm(bookingForm, 'blikCodeForm');
            var pblForm = this.getChildForm(bookingForm, 'pblForm');

            for (var i = 0; i < paxCount; i++) {
                var paxForm = this.getChildForm(bookingForm, 'editPassengerDetails' + i);
                if (paxForm) forms.push(paxForm);
            }

            if (editContactInfoForm) forms.push(editContactInfoForm);
            if (billingPersonForm) forms.push(billingPersonForm);
            if (billingCompanyForm) forms.push(billingCompanyForm);
            if (creditCardForm) forms.push(creditCardForm);
            if (blikCodeForm) forms.push(blikCodeForm);
            if (pblForm) forms.push(pblForm);

            return forms;
        };
    };

    angular
        .module('base')
        .service('BookingFormHelper', IthBookingFormHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/formErrors/ith-form-error-item.component.js
(function(angular) {
var template = '\
        <div ng-show="$ctrl.form[$ctrl.name].$invalid" class="ith-form-error-item ng-animate-disabled">\
            <span class="ith-form-error-item__label">{{ $ctrl.label }}:</span>\
            <label class="ith-form-error-item__link" for="{{ $ctrl.elementId }}"><field-validation\
                form="$ctrl.form"\
                name="{{ $ctrl.name }}"\
                backend-error="$ctrl.backendError">\
            </field-validation></label>\
        </div>\
    ';

    angular
        .module('base')
        .component('ithFormErrorItem', {
            template: template,
            bindings: {
                elementId: '@',
                form: '<',
                name: '@',
                label: '@',
                backendError: '<?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/formErrors/ith-form-errors-generator.component.js
(function (angular) {
var controller = function (BookingFormHelper) {
        /**
         *
         */
        this.isVisible = function () {
            var firstStepForms = BookingFormHelper.getFirstStepForms(
                this.bookingForm,
                this.booking.paxes.length
            );

            var lastStepForms = BookingFormHelper.getLastStepForms(
                this.bookingForm,
                this.booking.paxes.length
            );

            var firstStepFormsInvalid = (
                this.steps.isFirstStep() &&
                BookingFormHelper.areAllFormsSubmitted(firstStepForms) &&
                !BookingFormHelper.areAllFormsValid(firstStepForms)
            );

            var lastStepFormsInvalid = (
                this.steps.isLastStep() &&
                BookingFormHelper.areAllFormsSubmitted(lastStepForms) &&
                !BookingFormHelper.areAllFormsValid(lastStepForms)
            );

            return firstStepFormsInvalid || lastStepFormsInvalid;
        };

        this.getChildFormName = function (name) {
            if (this.steps.isLastStep()) {
                if (name === 'contactInfo') {
                    name = 'editContactInfo';
                }

                if (name.includes('passengerDetails')) {
                    name = name.split('passengerDetails').join('editPassengerDetails');
                }
            }

            return name;
        };

        /**
         *
         */
        this.getChildForm = function (name) {
            return BookingFormHelper.getChildForm(
                this.bookingForm,
                this.getChildFormName(name)
            );
        };

        /**
         *
         */
        this.shouldShowForm = function (name) {
            return (
                this.getChildForm(name) !== null &&
                this.getChildForm(name).$invalid &&
                this.getChildForm(name).$submitted
            );
        };

        /**
         *
         */
        this.shouldShowCardNotProcessed = function () {
            return this.booking.hasBackendErrors && this.steps.isLastStep() && (
                this.booking.payment.type === 'GP' ||
                this.booking.payment.type === 'GP2' ||
                this.booking.payment.type === 'AP' ||
                this.booking.payment.type === 'AP2' ||
                this.booking.payment.type === 'CC' ||
                this.booking.payment.type === 'RP'
            );
        };
    };

    controller.$inject = ['BookingFormHelper'];

    angular
        .module('base')
        .component('ithFormErrorsGenerator', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/booking-errors',
            bindings: {
                bookingForm: '<',
                booking: '<',
                steps: '<'
            },
            controller: controller
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/forms/birthdateFormControl.js
angular.module('base')

/**
 * @name        birthdateFormControl
 * @description Wrapper for filters tabs
 */
.directive('birthdateFormControl', ['ValidationUtils', function (ValidationUtils) {
return {
    restrict: 'EA',
    replace: true,
    scope: {
      date: '=dateObj',
      birthDateSelect: '=birthDateSelect',
      errors: '=errors',
      disabledProp: '=?disabledProp'
    },
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    require: '^form',
    link: function ($scope, iElement, iAttrs, controller) {
      try {
        $scope.form = controller;
      }
      catch (e) {
        // TODO: handle / log this
        console.error(e);
      }

      $scope.vutils = ValidationUtils;
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/forms/disableFrontValidation.js
angular.module('base')

/**
 * @name        disableFrontValidation
 * @description Disable front form validation (only for form controls)
 */
.directive('disableFrontValidation', [function () {
return {
    restrict: 'A',
    replace: false,
    require: '^form',
    compile: function (tElement, tAttrs) {
      return {
        pre: function (scope, iElement, iAttrs, controller, transcludeFn) {
          controller.disableFrontValidation = true;
        },
        post: function (scope, iElement, iAttrs, controller, transcludeFn) {

        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/forms/formControl.js
angular.module('base')

/**
 * @name        formControl
 * @description Wrapper for filters tabs
 */
.directive('formControl', ['formControl', '$compile', '$translate', function (formControl, $compile, $translate) {
return {
    restrict: 'EA',
    replace: false,
    transclude: 'element',
    require: '^form',
    compile: function (tElement, tAttrs) {
      return {
        pre: function (scope, iElement, iAttrs, controller, transcludeFn) {

          try {
            scope.config = JSON.parse(iAttrs.config);

            /**
             * remove front validation if "disable-front-validation" directive set to form
             */
            if(controller.disableFrontValidation){
              scope.config.validators = {};
            }

            if (!scope.config.form) {
              scope.config.form = {};
            }
            scope.config.form.name = controller.$name;

            var control = new formControl();

            control.setFormControlConfig(scope.config);

            var element = iElement.parent().append(angular.element(control.getBuiltFormGroup()));
            $compile(element)(scope);
          }
          catch (e) {
            // TODO: handle / log this
            console.error(e);
          }
        },
        post: function (scope, iElement, iAttrs, controller, transcludeFn) {
          scope.getValidationMessage = function (customMessage, defaultLang) {
            return $translate.instant(defaultLang);
          };
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/forms/formControlStatus.js
/*
angular.module('base')

/!**
 * @name        formControlStatus
 * @description Wrapper for filters tabs
 *!/
.directive('formControlStatus', ['$timeout', function ($timeout) {
return {
    restrict: 'A',
    replace: false,
    require: '^form',
    link: function (scope, element, attrs, formController) {

      function eventHandler() {
        if ( (formController[attrs.name] && formController[attrs.name].$invalid && formController[attrs.name].$dirty) || (formController[attrs.name] && formController[attrs.name].$invalid && formController.$submitted) ) {
          formController[attrs.name].wasInvalid = true;
        }
      }

      function bindOnChange() {
        element.bind("change", function () {
          eventHandler();
        });
      }

      if (formController) {
        try {
          formController[attrs.name].wasInvalid = false;

          var events = formController[attrs.name].$options ? formController[attrs.name].$options.updateOn.split(" ") : [];
          var eventsObj = {};

          _.each(events, function (event) {
            eventsObj[event] = formController[attrs.name].$options.debounce[event] || 500;
          });

          _.forEach(eventsObj, function (value, key) {
            element.bind(key, function () {
              $timeout(function () {
                eventHandler();
              }, value);
            });
          });

          //console.log(formController);

          //if there is no options or there are assigned options and updateOnDefault also if keyup wasn't handled before todo decide about default ng-model-options
          if ( (!formController[attrs.name].$options || (formController[attrs.name].$options && formController[attrs.name].$options.updateOnDefault)) && !eventsObj.keyup) {
            var defaultDebounce = formController[attrs.name].$options ? formController[attrs.name].$options.debounce['default'] || 500 : 500;
            element.bind("keyup", function () {
              $timeout(function () {
                eventHandler();
              }, defaultDebounce);
            });
          }

          if (!eventsObj.change) {
            bindOnChange();
          }
        }
        catch (e) {
          bindOnChange();

          // TODO: handle / log this
          console.error(e);
        }
      }
    }
  };
}]);
*/
;

// Source: ../shared/public_html/assets/js/base/directives/forms/formState.js
angular.module('base')

/**
 * @name        formState
 * @description Wrapper for filters tabs
 */
.directive('formState', ['$timeout', function ($timeout) {
return {
    restrict: 'A',
    replace: false,
    require: '^form',
    link: function (scope, element, attrs, formController) {

      function setErrorSuccess(state){
        formController[attrs.name]['showErrorSuccess'] = state;
      }

       if(formController[attrs.name].$valid){
        setErrorSuccess(true);
      }
      element.bind("blur change", function(){
        setErrorSuccess(true);
      });

      element.bind("keyup keypress", function(){
        if(formController[attrs.name]['showErrorSuccess'] /*&& formController[attrs.name].$invalid*/){
          setErrorSuccess(false);
        }
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/forms/number.js
angular.module('base')

/**
 * @name        integer
 * @description Converts ng-model value to integer
 */
.directive('integer', function () {
return {
    require: 'ngModel',
    link: function (scope, ele, attr, ctrl) {
      ctrl.$parsers.unshift(function (viewValue) {
        return parseInt(viewValue, 10);
      });
    }
  };
})

/**
 * @name        integer
 * @description Converts ng-model value to float
 */
.directive('float', function () {
  return {
    require: 'ngModel',
    link: function (scope, ele, attr, ctrl) {
      ctrl.$parsers.unshift(function (viewValue) {
        return parseFloat(viewValue);
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/forms/numberConverter.js
angular.module('base')

/**
 * @name        numberConverter
 * @description Convert to number
 */
  .directive('numberConverter', function() {
    return {
      priority: 1,
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {

        function toView(value) {
          return parseInt(value); // convert to number
        }

        ngModel.$formatters.push(toView);
      }
    };
  });

;

// Source: ../shared/public_html/assets/js/base/directives/forms/passportExpirationDateFormControl.js
angular.module('base')

/**
 * @name        passportExpirationDateFormControl
 * @description Wrapper for filters tabs
 */
.directive('passportExpirationDateFormControl', ['ValidationUtils', function (ValidationUtils) {
return {
    restrict: 'EA',
    replace: true,
    scope: {
      date: '=dateObj',
      passportExpiration: '=passportExpiration',
      errors: '=errors',
      disabledProp: '=?disabledProp'
    },
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    require: '^form',
    link: function ($scope, iElement, iAttrs, controller) {
      $scope.vutils = ValidationUtils;

      if(!controller){
        throw new Error("form controller error, form: " + controller)
      }
      $scope.form = controller;
    }
  };
}]);;

// Source: ../shared/public_html/assets/js/base/directives/forms/paxDateFormControl.js
angular.module('base')

/**
 * @name        paxDateFormControl
 * @description Wrapper for filters tabs
 */
.directive('paxDateFormControl', ['ValidationUtils', function (ValidationUtils) {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    require: '^form',
    link: function ($scope, iElement, iAttrs, controller) {
      try {
        $scope.form = controller;
      }
      catch (e) {
        // TODO: handle / log this
        console.error(e);
        throw new Error(e);
      }

      $scope.vutils = ValidationUtils;
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/forms/storeFormData.js
angular.module('base')

/**
 * @name        storeFormData
 * @description updates form data from local storage
 */
    .directive('storeFormData', ['$timeout', function ($timeout) {
return {
            restrict: 'A',
            replace: false,
            require: ['^form', '^ngModel'],

            link: function ($scope, element, attributes, ctrl) {
                element.bind('change', function () {
                    $timeout(function () {
                        if (element[0].validity.valid && ctrl[1].$valid) {
                            $scope.$emit('storeFormData', true);
                        }
                    }, 0);
                });
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/gallery.js
angular.module('base')

/**
 * @name        gallery
 * @description
 */
.directive('gallery', function () {
var ctrl = ['$scope','goo.PackageAnalytics' , function GalleryController($scope,PackageAnalytics) {
    this.pictures = $scope.pictures;

    /**
     * Flag that tells the gallery to resize the pics or not
     *
     * @type {string|boolean}
     */
    this.resizePictures = ($scope.resizePictures !== undefined) ? $scope.resizePictures : true;

    /**
     * Open gallery popup with given picture active
     * @param {Picture} picture
     */
    this.launchPopup = function (picture) {
      PackageAnalytics.eventGalleryOpen();
      this.onLaunchPopup(picture);
    };

    /**
     * Get picture DOM element at given index
     * @param {Number} index
     * @returns {Object}
     */
    this.getSlideElement = function (element, index) {
      var slideElements = element[0].querySelectorAll('.gallery-slide');
      return slideElements[index];
    };
  }];

  var link = function (scope, elem, attrs, ctrl) {
    scope.layout = attrs.layout || 'collage';

    scope.$on('popupFirstPicture', function () {
      ctrl.launchPopup(ctrl.pictures[0]);
    });

    if(scope.layout == 'collage') {
      scope.$on('openCollageGallery', function () {
        ctrl.launchPopup(ctrl.pictures[0]);
      });
    }
  };

  return {
    restrict: 'E',
    scope: {
      pictures: '=',
      infiniteScrollPopup: '=',
      resizePictures: '='
    },
    templateUrl: '/tpl/show/jsShared/templates/base/directives/gallery/gallery-hyb',
    controller: ctrl,
    link: link
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/galleryCollage.js
angular.module('base')

/**
* @name        galleryCollage
* @description
*/
.directive('galleryCollage', ['$timeout', '$window', 'StyleHelper', 'goo.PackageAnalytics', 'ProcessedImageService',
function galleryCollage($timeout, $window, StyleHelper, PackageAnalytics, ProcessedImageService) {
return {
    restrict: 'E',
    replace: true,
    scope: {},
    require: '^gallery',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/gallery/galleryCollage-hyb';
    },
    link: function (scope, element, attrs, ctrl) {
      var
        /**
         * Current slide page
         * @type {Number}
         */
        _currentPage = 1,

        /**
         * Width of one slide in frontend
         * @type {Number}
         */
        _slideWidth = 0,

        /**
         * The strip that holds all the pictures
         * @type {DOMElement}
         */
        strip = element[0].querySelector('.gallery-strip');


      /**
       * Processed image service
       * NOTE: it helps to build the images paths
       *
       * @type {any}
       */
      scope.ProcessedImageService = ProcessedImageService;

      /**
       * Slide the gallery
       *
       * @param index
       */
      scope.slideToPage = function(index) {

        if (((scope.slides[index].index+1) == _currentPage)) { // Don't scroll curent pic
          return;
        }

        if (scope.slides.hasOwnProperty(index-1) && ((scope.slides[index-1].index+1) == _currentPage)) { // Scroll to left
          scope.move(1);
          return;
        }

        scope.move(-1); // Default scroll to right
      };

      /**
       * Get current slide number
       *
       * @returns {Number}
       */
      scope.getCurrentPage = function () {
        return _currentPage;
      };

      /**
       * Navigate relative to active page
       * @param {Number} direction -1 for left, 1 for right
       */
      scope.move = function (direction) {
        PackageAnalytics.eventGallerySmallNext(direction);
        _currentPage += direction;

        if (_currentPage < 1) {
          // First page
          element.removeClass('gallery-animated');
          _currentPage = _getTotalPages() + 1;
          _repaintSlide(direction);
        }
        else if (_currentPage > _getTotalPages()) {
          // Last page
          element.removeClass('gallery-animated');
          _currentPage = 0;
          _repaintSlide(direction);
        }
        else {
          // Middle pages
          element.addClass('gallery-animated');
          _updateStripPos();
        }
      };

      /**
       * Checks if navigation should be displayed
       * @returns {Boolean}
       */
      scope.showNav = function () {
        return _getTotalPages() > 1;
      };

      /**
       * Triggers a repaint and slides the gallery
       * @param {Number} direction
       *
       * @private
       */
      var _repaintSlide = function (direction) {
        _updateStripPos();

        $timeout(function () {
          element.addClass('gallery-animated');
          _currentPage += direction;
          _updateStripPos();
        }, 20);
      };

      /**
       * Returns total number of pages
       * @return {Number}
       *
       * @private
       */
      var _getTotalPages = function () {
        return scope.slides.length - 4;
      };

      /**
       * Duplicates first and last slide to create infinite scrolling behaviour
       * Runs only on initialization
       */
      var _init = function () {
        _bind();
        // Break down the slides in groups
        var slideGroups = _getSlides(parseInt(attrs.groupSize) || 4);

        if (slideGroups.length > 1) {
          // Create 'fake' slide references
          var
            firstSlide = slideGroups[0],
            secondSlide = slideGroups[1],
            beforeLastSlide = slideGroups[slideGroups.length - 2],
            lastSlide = slideGroups[slideGroups.length - 1];

          // Add 'fake' slides
          slideGroups.push(firstSlide);
          slideGroups.push(secondSlide);
          slideGroups.unshift(lastSlide);
          slideGroups.unshift(beforeLastSlide);
        }

        // Update public slide array
        scope.slides = slideGroups;

        $timeout(function () {
          // Trigger function after initialization
          _onResize();
        });
      };

      /**
       * Updates the slider width in pixels
       * @private
       */
      var _updateSlideWidth = function () {
        var slide = angular.element(element[0].querySelector('.gallery-slide'));
        if (slide[0] != undefined) {
          _slideWidth = slide[0].clientWidth;
        }
      };

      /**
       * Updates x position of the gallery holder (makes it slide)
       * @private
       */
      var _updateStripPos = function () {

        // Calculate new position
        var newPos = (scope.slides.length > 1) ? ((-1 * _slideWidth * _currentPage) - _slideWidth) : 0;

        // Setup new style
        var newStyle = 'translate(' + newPos + 'px, 0)';

        // Apply the new style
        StyleHelper.applyStyle(strip, newStyle);
      };

      /**
       * Get slides
       * @param {Number} groupSize
       * @returns {Array}
       *
       * @private
       */
      var _getSlides = function (groupSize) {
        var
          slides = [],
          slideCount = Math.ceil(ctrl.pictures.length / groupSize);

        for (var i = 0; i < slideCount; i++) {
          var p = ctrl.pictures.slice(i * groupSize, (i + 1) * groupSize);

          // Check if there is more than 1 slide, it's the last slide and it only contains one picture
          if (groupSize > 1 && slideCount > 1 && i == slideCount - 1 && p.length == 1) {
            // Bring one photo from previous slide
            // This way we won't have a slide with only one photo (for circular scrolling)
            p.push(slides[i - 1].pictures.pop());
          }

          slides.push({pictures: p, index: i, active: false});
        }

        return slides;
      };

      /**
       * Function called on browser resize event
       * @private
       */
      var _onResize = function () {
        _updateSlideWidth();
        _updateStripPos();
      };

      /**
       * Binds to browser resize event
       * @private
       */
      var _bind = function () {
        // Listen for scroll and touch move events
        angular.element($window).bind('resize', _onResize);
      };

      /**
       * Cleans up bindings on destroy
       * @private
       */
      var _cleanup = function () {
        angular.element($window).unbind('resize', _onResize);
      };

      // Clean up bindings on destroy
      scope.$on('$destroy', _cleanup);

      // Init
      _init();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/galleryCollagePicture.js
angular.module('base')

/**
 * @name        galleryCollagePicture
 * @description
 */
.directive('galleryCollagePicture', ['ProcessedImageService', 'appConfig', function galleryCollagePicture(ProcessedImageService, appConfig) {
return {
    restrict: 'E',
    replace: true,
    scope: {picture: '=', tier: '='},
    template: '<div class="{{ ::tierClass }}" ng-click="launchPopup(picture);"><div class="img" style="background-image: url(\'{{ ::src }}\');"></div></div>',
    require: '^gallery',
    link: function (scope, element, attrs, ctrl) {
      /**
       * Open gallery popup with given picture active
       * @param {Picture} picture
       */
      scope.launchPopup = function (picture) {
        ctrl.launchPopup(picture);
      };

      var tierSizes = {
        1: {width: 450, height: 335},
        2: {width: 450, height: 160},
        3: {width: 220, height: 160}
      };

      var size = tierSizes[scope.tier];

      scope.tierClass = 'tier' + scope.tier;

      if(ctrl.resizePictures)
      {
        scope.src = ProcessedImageService.getSrc(scope.picture, 'fill', size.width, size.height);
      }
      else
      {
        //TODO get entire media url from config
        scope.src = appConfig.getMediaUrl() + '/media/img/' + scope.picture.path + '/' + scope.picture.filename;
      }
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/galleryList.js
angular.module('base')

/**
 * @name        galleryList
 * @description
 */
.directive('galleryList', [function galleryList() {
return {
    restrict: 'E',
    replace: true,
    require: '^gallery',
    template: '<processed-image ng-repeat="picture in pictures" picture="picture" ng-click="launchPopup(picture);" method="resize" image-height="64"></processed-image>',

    link: function (scope, element, attrs, ctrl) {
      scope.pictures = ctrl.pictures;

      /**
       * Open gallery popup with given picture active
       * @param {Picture} picture
       */
      scope.launchPopup = function (picture) {
        ctrl.launchPopup(picture);
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/galleryLoader.js
angular.module('base')

/**
 * @name        galleryLoader
 * @description
 */
.directive('galleryLoader', ['GalleryService', function (GalleryService) {
var link = function (scope, elem, attrs, ctrl) {
    scope.pictures = [];

    GalleryService.getImages(attrs.galleryId).then(function success(pictures) {
      scope.pictures = pictures;
    });
  };

  return {
    restrict: 'E',
    scope: {
      galleryId: '@'
    },
    template: '<gallery ng-if="pictures.length > 0" pictures="pictures"></gallery>',
    link: link
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/gallery/galleryPopup.js
angular.module('base')

/**
* @name        galleryPopup
* @description
*/
.directive('galleryPopup', ['$timeout', '$document', '$q', '$window', 'StyleHelper', 'goo.PackageAnalytics', function galleryPopup($timeout, $document, $q, $window, StyleHelper, PackageAnalytics) {
return {
    restrict: 'E',
    replace: true,
    scope: {
      wrap: '='
    },
    require: '^gallery',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/gallery/galleryPopup',

    link: function (scope, element, attrs, ctrl) {

      var
        /**
         * Index of the currently selected image in the gallery popup
         * @type {Number}
         */
        currentPage = 0,

        /**
         * DOM element holding the popup gallery images
         * @type {DOMElement}
         */
        strip = element[0].querySelector('.gallery-strip'),

        /**
         * Internal switch of allowing keyboard events
         * @type {Boolean}
         */
        allowKeyboard = true;

      /**
       * Tells if gallery popup is visible or not
       * @type {Boolean}
       */
      scope.popupShown = false;

      /**
       * Tells if gallery popup should use animation
       * @type {Boolean}
       */
      scope.animated = true;

      /**
       * Resize the pictures
       *
       * @type {string|*|string|boolean}
       */
      scope.resizePictures = ctrl.resizePictures;

      /**
       * Array of picture slides in the gallery
       * @type {Object[]}
       */
      scope.slides = [];

      /**
       * Open gallery popup with given picture active
       * @param {string} picture The picture filename
       */
      ctrl.onLaunchPopup = function (picture) {
        scope.popupShown = true;
        scope.jumpToPicture(_findIndexByPicture(picture));
      };

      /**
       * Sets the current slide to the index value
       * @param {Number} index
       */
      scope.jumpToPicture = function (index) {
        $timeout(function () {
          scope.setPage(index);
        }, 100);
      };

      /**
       * Close gallery popup
       */
      scope.closePopup = function () {
        scope.popupShown = false;
      };

      /**
       * Navigate relative to active page
       * @param {Number} direction -1 for left, 1 for right
       */
      scope.move = function (direction) {
        if(allowKeyboard === false) {
          return;
        }
        PackageAnalytics.eventGalleryNext(direction);
        var newIndex = currentPage + direction;

        // Restrict the range
        if (newIndex < 0) newIndex = scope.slides.length - 1;
        if (newIndex >= scope.slides.length) newIndex = 0;

        if (scope.hasPage(newIndex)) {
          // Jump to the new page by index
          scope.animated = true;
          scope.setPage(newIndex);
        }
      };

      /**
       * Checks if a page exists by index
       * @param {Number} index The page index we want to check
       * @returns {Boolean}
       */
      scope.hasPage = function (index) {
        return index >= 0 && index < scope.slides.length;
      };

      /**
       * Checks if there are multiple slides to show navigation
       * @return {Boolean}
       */
      scope.hasNav = function () {
        return scope.slides.length > 1;
      };

      /**
       * Activate picture slide at given index
       * @param {Number} index
       */
      scope.setPage = function (index) {
        currentPage = index;
        allowKeyboard = false;

        _scrollStrip({
          // Infinite scrolling behaviour
          transitionEnd: function() {
            var currentSlide = _getSlideByIndex(index);

            // When css transition is finished and current slide is fake, then go to non fake slide
            if (currentSlide.isFake) {
              scope.animated = false;

              // Go to non fake slide with disabled css transition
              scope.setPage(scope.slides.filter(function(slide) {
                return !slide.isFake && slide.picture.filename === currentSlide.picture.filename && slide.picture.path === currentSlide.picture.path;
              })[0].index);

              // Refresh DOM
              scope.$digest();

              _.defer(function()
              {
                scope.animated = true;
                allowKeyboard = true;

                // Refresh DOM
                scope.$digest();
              });
            } else {
              allowKeyboard = true;
            }
          }
        });
      };

      /**
       * Checks if an index is the currently selected index
       * @param {Number} index
       */
      scope.isActive = function (index) {
        return currentPage == index;
      };

      /**
       * Checks if a photo has caption
       * @param {Number} index
       */
      scope.hasCaption = function (index) {
        return scope.slides[index].picture.description != '';
      };

      /**
       * Scroll the gallery strip to currently selected index
       *
       * @param {Object} [params]
       * @param {Function} [params.transitionEnd]
       *
       * @private
       */
      var _scrollStrip = function (params) {
        var el = ctrl.getSlideElement(element, currentPage);
        var newPos = ((window.innerWidth - el.clientWidth) / 2 - el.offsetLeft);
        var newStyle = 'translate(' + newPos + 'px, 0)';

        // Default values of params
        params = _.extend({
          transitionEnd: function(){}
        }, params);

        strip.addEventListener('transitionend', function transitionEndCallback() {
          strip.removeEventListener('transitionend', transitionEndCallback, false);
          params.transitionEnd();
        }, false);

        // Apply the new styles
        StyleHelper.applyStyle(strip, newStyle);
      };

      /**
       * Return the index of a picture in slides
       *
       * @param {String} picture The picture filename
       * @returns {Number} The picture index in slides
       *
       * @private
       */
      var _findIndexByPicture = function (picture) {
        var slide = _.find(scope.slides, function (s) {
          return s.picture === picture;
        });

        return slide.index;
      };

      /**
       * Returns slide by index
       *
       * @param {Number} index
       * @returns {Object}
       *
       * @private
       */
      var _getSlideByIndex = function(index) {
        return scope.slides.filter(function(slide) {
          return slide.index === index;
        })[0];
      };

      /**
       * Adds fake slides to create infinite scrolling behaviour
       *
       * @param {Number} quantity - Quantity of slides to append and prepend
       *
       * @private
       */
      var _addFakeSlides = function(quantity) {
        var length = scope.slides.length, i = 0;

        if (length >= quantity) {
          // Create fake slides
          scope.slides = angular.copy(scope.slides.slice(-quantity, length))
            .concat(scope.slides)
            .concat(angular.copy(scope.slides.slice(0, quantity)));

          // Mark fake slides
          scope.slides.slice(0, quantity).concat(scope.slides.slice(-quantity, scope.slides.length)).forEach(function(slide) {
            slide.isFake = true;
          });

          // Make indexes unique
          i = 0;
          scope.slides.forEach(function(slide) {
            slide.index = i++;
          });
        }
      };

      /**
       * Builds the slides on initialization
       * @private
       */
      var _init = function () {

        _appendToBody(); // Append to body the element

        // Bind recalculation to window resize
        _bind();

        // Push the slides
        _.each(ctrl.pictures, function (p, i) {
          scope.slides.push({picture: p, index: i});
        });

        if (scope.wrap) {
          _addFakeSlides(2);
        }
      };

      /**
       * Appends the gallery to body DOM element
       */
      var _appendToBody = function () {
        $timeout(function () {
          $document.find('body').append(element);
        }, 1000);
      };

      /**
       * Binds to browser resize event and keyboard events
       * @private
       */
      var _bind = function () {

        // Listen for scroll and touch move events
        angular.element($window).bind('resize', _scrollStrip);

        // Bind keyboard events
        $document.bind('keydown', function (evt) {
          _keyHandler(evt);
        });
      };

      /**
       * Handles key press events
       * @param {KeyboardEvent} evt Browser keyboard event
       */
      var _keyHandler = function (evt) {

        var keyCode = evt.which || evt.keyCode;

        switch (keyCode) {
          case 39:
            scope.$apply(function () {
              scope.move(1);
            });
            evt.preventDefault();
            break;
          case 37:
            scope.$apply(function () {
              scope.move(-1);
            });
            evt.preventDefault();
            break;
          case 27:
            scope.$apply(function () {
              scope.closePopup();
            });
            evt.preventDefault();
            break;
        }
      };

      /**
       * Cleans up bindings on destroy
       * @private
       */
      var _cleanup = function () {
        element.remove();
        angular.element($window).unbind('resize', _scrollStrip);
      };

      // Clean up bindings on destroy
      scope.$on('$destroy', _cleanup);

      _init();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/helpers/templateSimple.js
angular.module('base')

/**
 * @name        templateSimple
 * @description Directive for simple partial, requires only template url
 */
.directive('templateSimple', function () {
return {
    restrict: 'A',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/icon-link.component.js
(function (angular) {

    angular.module('base').component('ithIconLink', {
        template: '<span class="iconLink"><ith-icon-text icon-id="{{ $ctrl.iconId }}"><a><ng-transclude></ng-transclude></a></ith-icon-text></span>',
        transclude: true,
        bindings: {
            iconId: '@'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/icon-text.component.js
(function (angular) {

    angular.module('base').component('ithIconText', {
        template: '<span class="iconText"><svg-icon id="{{ $ctrl.iconId }}"></svg-icon><ng-transclude></ng-transclude></span>',
        transclude: true,
        bindings: {
            iconId: '@'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/imageInhibitor.js
angular.module('base')

/**
 * @name        imageInhibitor
 * @description Wrapper for filters tabs
 */
.directive('imageInhibitor', ['$timeout', function ($timeout) {
return {
    restrict: 'A',
    replace: false,
    compile: function (tElement, tAttrs) {
      return {
        pre: function (scope, iElement, iAttrs, controller, transcludeFn) {
          iElement.attr('imagetimeout', false);
        },
        post: function (scope, iElement, iAttrs, controller, transcludeFn) {
          if(iAttrs.imgSrc){
            try{
              var id = _.uniqueId();

              var imgConfig = {
                src: iAttrs.imgSrc,
                class: 'hidden',
                id: id
              };

              var img = new BOB("img", imgConfig).s();
              iElement.after(angular.element(img));

              var imgElem = document.getElementById(id);
              angular.element(imgElem).on('load error', function(event){
                var sheet = document.getElementById('hpJumboStyleSheet');
                if(sheet){
                  sheet.parentNode.removeChild(sheet);
                  iElement.attr('imagetimeout', true);
                }
              })
            }
            catch(e){
              iElement.attr('imagetimeout', true);
            }
          }
          else{
            iElement.attr('imagetimeout', true);
          }
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/includeReplace.js
angular.module('base')

/**
 * @name        includeReplace
 * @description replaces parent of included element
 */
.directive('includeReplace', function () {
return {
    require: 'ngInclude',
    restrict: 'A',
    link: function (scope, el) {
      el.replaceWith(el.children());
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/inlineDropdown/inlineDropdown.js
angular.module('base')

/**
* @name        inlineDropdown
* @description
*/
.directive('inlineDropdown', ['appConfig', '$timeout', function inlineDropdown(AppConfig, $timeout) {
var link = function (scope, element, attrs) {
    var valueProp = attrs.valueProp || 'id';
    var nameProp = attrs.nameProp || 'name';
    scope.nameProp = nameProp;

    scope.status = {
      open: false
    };

    /**
     * Detect mobile devices / tablets
     * @returns {Boolean}
     */
    scope.isMobile = function()
    {
      return AppConfig.isTablet() || AppConfig.isMobile();
    };

    /**
     * Update dropdown's selection text
     * @param {*} value
     */
    var setLabelForValue = function (value) {
      var selectedOption = _.find(scope.options, function (option) {
        return option[valueProp] === value;
      });

      if (selectedOption) {
        scope.selection = selectedOption[nameProp];
      }
    };

    /**
     * Select an option
     * @param {Object} option
     */
    scope.select = function (option) {
      scope.model = option[valueProp];

      $timeout(function()
      {
        scope.status.open = !scope.closeAfterSelect;
        scope.$apply();
      });
    };

    /**
     * Update dropdown's selection text any time the model changes
     */
    scope.$watch('model', function (newValue) {
      setLabelForValue(newValue);
    });

    /**
     * Update dropdown's selection text the first time the options change
     * and then unbind the watch
     */
    var unbind = scope.$watchCollection('options', function (newValue) {
      if (newValue) {
        setLabelForValue(scope.model);
        unbind();
      }
    });

    setLabelForValue(scope.model);
  };

  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=',
      options: '=',
      nameProp: '@',
      valueProp: '@',
      closeAfterSelect: '=?'
    },
    templateUrl: '/tpl/show/jsShared/templates/base/directives/inlineDropdown/inlineDropdown',
    link: link
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/ith-hamburger-icon.component.js
(function(angular) {
/**
     * @name        IthHamburgerIconComponent
     * @description Component that renders an animated hamburger menu
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthHamburgerIconComponent = {
        bindings: {
            state: '<'
        },
        template: '<span class="hamburger-icon" ng-class="{ \'hamburger-icon__close\': $ctrl.state }"><span></span></span>'
    };

    angular
        .module('base')
        .component('ithHamburgerIcon', IthHamburgerIconComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/leadOffers/leadOffer.js
angular.module('base')

/**
 * @name        leadOfferWrapper
 * @description Wrapper for many lead offers
 */
.controller('leadOfferSnippetController', ['$scope', '$filter', function ($scope, $filter) {
$scope.$filter = $filter;
  $scope.displayLoader = false;

  $scope.hasNarrowSkin = function () {
    return $scope.$parent.leadOffers.settings.skin == 'LO_NARROW_SKIN';
  };

  $scope.getSkinClass = function () {

    var cName;

    switch ($scope.$parent.leadOffers.settings.skin) {
      case 'LO_NARROW_SKIN':
        cName = 'leadOfferNarrow';
        break;

      case 'LO_PG_SKIN':
        cName = 'leadOfferPG';
        break;

      default:
        cName = 'leadOffer';
        break;
    }

    return cName;
  };

  $scope.isFlightOffer = function () {
    if($scope.offer)
    {

      return $scope.offer.productId == 1;
    }

    return 0;
  };

  $scope.hasDetails = function () {
    return !angular.isUndefined($scope.offer.details);
  };

  $scope.getSkin = function () {
    var skin, settingSkin = false;

    if($scope.$parent.leadOffers.hasOwnProperty('settings') && $scope.$parent.leadOffers.settings)
    {
      settingSkin = $scope.$parent.leadOffers.settings.skin;
    }

    switch (settingSkin) {
      case 'LO_NARROW_SKIN':
        skin = '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferNarrow-hyb';
        break;
      case 'LO_PG_SKIN':
        skin = '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferPG-hyb';
        break;
      default:
        skin = '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOffer-hyb';
        break;
    }

    return skin;
  };

  $scope.getDiscount = function () {
    return $scope.offer.price.discount + '%';
  };

  $scope.$on('load-offers', function(event, eventData){
    $scope.displayLoader = eventData.displayLoader;
  });

}])

/**
 * @name        leadOffer
 * @description Single lead offer directive
 */
.directive('leadOffer', function () {
  return {
    restrict: 'A',
    controller: 'leadOfferSnippetController',
    template: '<div ng-include="getSkin()" include-replace></div>',
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/leadOffers/leadOfferCountdown.js
angular.module('base')

/**+9
 * @name        leadOfferCountdown
 * @description Expiration date countdown
 */
.directive('leadOfferCountdown', function () {
return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferCountdown',
    scope: {
      expTime: '@'
    },
    link: function (scope, element, attrs) {
      scope.showCounter = true;
      var timeToEnd = (moment(scope.expTime).unix() * 1000 - (new Date()).getTime() );
      var duration = moment.duration(timeToEnd, 'milliseconds');

      var interval = setInterval(function () {
        duration = moment.duration(duration.asMilliseconds() - 1000, 'milliseconds');
        var timeToEnd = duration._data;
        if (duration._data.seconds < 0) {
          window.clearInterval(interval);
          scope.$parent.leadOffersDisplay = 0;
          scope.$apply();
        }
        scope.days = timeFormat(timeToEnd.days);
        scope.hours = timeFormat(timeToEnd.hours);
        scope.minutes = timeFormat(timeToEnd.minutes);
        scope.seconds = timeFormat(timeToEnd.seconds);
        scope.$digest();

      }, 1000);

      function timeFormat(number) {
        if (number <= 0) {
          return "00";
        }
        var string = "" + number;
        if (string.length == 2) {
          return "" + string;
        }
        return "0" + string;
      }

      scope.$on('$destroy', function () {
        clearInterval(interval);
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/leadOffers/leadOfferLoader.js
angular.module('base')

/**
 * @name        leadOfferLoader
 * @description Single lead offer loader
 */
  .controller('leadOfferLoaderCtrl', ['$scope', function ($scope) {
$scope.displayLoader = false;

    $scope.$on('load-offers', function(event, eventData){
      $scope.displayLoader = eventData.displayLoader;
    });

  }])

/**
 * @name        leadOfferLoader
 * @description Single lead offer loader directive
 */
  .directive('leadOfferLoader', function () {
    return {
      restrict: 'A',
      controller: 'leadOfferLoaderCtrl',
      templateUrl: '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferLoader',
      replace: true
    };
  });
;

// Source: ../shared/public_html/assets/js/base/directives/leadOffers/leadOfferWrapper.js
angular.module('base')

/**
 * @name        leadOfferWrapper
 * @description Wrapper for many lead offers
 */
  .controller('leadOfferWrapperController', ['$scope','$attrs', 'LeadOffers', 'WarmUpSrv', function ($scope,$attrs,LeadOffers, WarmUpSrv)
  {
$scope.formData = {
      month: null,
      lpFlightRange: {min: 1, max: 40},
      inputCityBreak: {
        from: [],
        destination: []
      },
      fromTags: [],
      toTags: []
    };
    $scope.phpInit = true;
    $scope.leadOffersDisplay = true;

    var oldFormData = {};

    $scope.initWithWarmUpCache = function ()
    {
      var leadOffers = WarmUpSrv.getByKey($attrs.src || $scope.src);
      if (leadOffers)
      {
        $scope.leadOffers = leadOffers;
        $scope.leadOffersDisplay = leadOffers.display;
      }
      else
      {
        $scope.getLeadOffers({});
      }
    };

    $scope.getLeadOffers = function(params){

      var eventData = {displayLoader: true};
      $scope.$broadcast('load-offers', eventData);

      oldFormData = angular.copy(params);
      params.tripLengthFrom = $scope.formData.lpFlightRange.min;
      params.tripLengthTo = $scope.formData.lpFlightRange.max;

      LeadOffers.getLeadOffers($attrs.src || $scope.src, params).then(
        function (leadOffers)
        {
          $scope.leadOffers = leadOffers;
          $scope.leadOffersDisplay = leadOffers.display;
          $scope.phpInit = false;
          var eventData = {displayLoader: false};
          $scope.$broadcast('load-offers', eventData);
        },
        function (failure)
        {
          // TODO: handle / log this
          console.log("something went wrong", failure);
        }
      );
    };

    $scope.getOneLeadOffer = function(offerNumber){
      if($scope.leadOffers && $scope.leadOffers.leadOffers[offerNumber])
      {
        return $scope.leadOffers.leadOffers[offerNumber];
      }
    };

    function equals(formTags, oldFormTags)
    {
      if (formTags.length !== oldFormTags.length) {
        return false;
      }

      var str1 = false, str2 = false;
      angular.forEach(formTags, function (v) {
        str1 += v.name;
      });

      angular.forEach(oldFormTags, function (v) {
        str2 += v.name;
      });

      if (str1 && str2 && str1 !== str2) {
        return false;
      }

      return true;
    }

    function reInitCondition()
    {
      if (($scope.formData.month !== oldFormData.month ||
        ($scope.formData.lpFlightRange.min != oldFormData.lpFlightRange.min ) ||
        ($scope.formData.lpFlightRange.max != oldFormData.lpFlightRange.max ) ||
        ($scope.formData.fromTags != undefined && !equals($scope.formData.fromTags,oldFormData.fromTags)) ||
        ($scope.formData.toTags != undefined && !equals($scope.formData.toTags,oldFormData.toTags)) ||
        ($scope.formData.inputCityBreak.from != undefined && $scope.formData.inputCityBreak.from.length !== oldFormData.inputCityBreak.from.length)))
      {
        return true;
      }
      return false;
    }

    $scope.getLeadOffersWithFilters = function () {
      _.defer(function () {
        if (reInitCondition()) {
          $scope.getLeadOffers($scope.formData);
        }
      }, 500);
    };

    $scope.initWithWarmUpCache();

  }])

  .directive('leadOfferWrapper', ['TemplateHelperSrv', function leadOfferWrapper(TemplateHelperSrv)
  {
    return {
      restrict: 'A',
      replace: false,
      templateUrl : '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferWrapper-hyb',
      controller: 'leadOfferWrapperController',
      scope: {
        model: '=?ngModel',
        callback: '&ngCallback',
        src: '@'
      },
      link: function (scope, element, attrs, ctrl, transcludeFn)
      {
        TemplateHelperSrv.run({
          scope: scope,
          element: element,
          templateUrl: '/tpl/show/jsShared/templates/base/directives/leadOffer/leadOfferWrapper-hyb',
          transcludeFn: transcludeFn
        });
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/liveChat/enableChat.js
angular.module('base')

/**
 * @name        enableChat
 * @description Enable chat on static pages
 * enable-chat="contact"
 */
    .directive('enableChat', ['liveChatServ', function (liveChatServ) {
return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.enableChat) {
                    liveChatServ.checkPage(attrs.enableChat);
                }
            }
        };
    }]);;

// Source: ../shared/public_html/assets/js/base/directives/liveChat/liveChat.js
angular.module('base')
    /**
     * @name liveChat
     * @description Directive for Live chat Module
     */
    .directive('liveChat', function () {
return {
            restrict: 'E',
            templateUrl: '/tpl/show/jsShared/templates/base/directives/liveChat',
            replace: true,
            controller: ['$scope', '$rootScope', 'liveChatServ', function ($scope, $rootScope, liveChatServ) {

                $scope.liveChatServ = liveChatServ;

                /**
                 *
                 */
                $scope.openChat = function () {
                    if(_js_app_config_.liveChatId){
                        document.getElementById('_' + _js_app_config_.liveChatId).click();
                    }
                };

                /**
                 * Force Livechat on static Pages
                 */
                $scope.forceChat = function () {
                    $scope.hideBtn = true;
                };

                /**
                 * Observe $stateChangeStart and get name of page
                 */
                $rootScope.$on('$stateChangeStart', function (event, toState) {
                    liveChatServ.checkPage(toState.name);
                });

            }]
        }

    });;

// Source: ../shared/public_html/assets/js/base/directives/loadReload.js
angular.module('base')

  /**
   * @name        loadReload
   * @description
   */
  .directive('loadReload', ['$compile', '$q', '$ocLazyLoad', 'appConfig',
  function ($compile, $q, $ocLazyLoad, AppConfig) {
return {
      priority:100,
      link: function (scope, element, attrs) {
        if (!AppConfig.isSpecial()) return;
        var deferred = $q.defer();

        /**
         * lazyLoad config name:module name[item type:item name]
         * config[5] == ''
         */
        var config = attrs.loadReload.split(/[:\[\]]{1}/);

        if (config.length != 5) return;

        var isExist = false;
        if ($ocLazyLoad.isLoaded( config[1]))
        {
          angular.module(config[1])._invokeQueue.forEach(function(e){
            if (e[1] == config[2] && e[2][0] == config[3]) isExist = true;
          });
        }

        deferred.promise.then(function(){
          /**
           * do only if did $ocLazyLoad.load
           */
          //if (element.parent().attr('load-reload-rebuild'))
          //{
            element
              .append( $compile(element.html())(scope) );
          //}
        });

        if (isExist) {
          deferred.resolve();
          return;
        }

        $ocLazyLoad
          .load( AppConfig.getLazyFiles(config[0]) )
          .then(function()
          {
            element.parent().attr('load-reload-rebuild', true);
            deferred.resolve();
          })
        ;
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/metaViewport.js
angular.module('base')

/**
 * @name        metaViewport
 * @description Dynamically changes the viewport meta tag
 */
.directive('metaViewport', function metaViewport() {
return {
    restrict: 'A',
    require: '?ngModel',
    link: function (scope, elem, attrs, ctrl) {
      // Watch for viewport change
      scope.$watch(attrs.ngModel, function (newValue) {
        // Set new viewport on change
        elem.attr('content', newValue);
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/mobileSideMenu.js
angular.module('base')

  /**
   * @name mobileSideMenu
   * @description menu uses ont textbox with menu on mobile and tablet resolutions
   */
  .directive('mobileSideMenu',['$location', '$timeout', '$anchorScroll' ,function($location,$timeout,$anchorScroll){
return {
      restrict: 'A',
      controller: ['$scope', '$element', '$attrs',function($scope,$element,$attrs){
        var desktopMenu = $element[0].querySelector('#sp-menu');
        $scope.data = {
          allLinks: []
        };

        angular.element(document).ready(function () {
          var links = desktopMenu.getElementsByTagName('a');

          angular.forEach(links, function(element){
            $scope.data.allLinks.push({text: element.text,hash: element.hash});
          });
          $scope.data.selectedLink = $scope.data.allLinks[0] || null;
        });

        $scope.change = function(){
          var id = $scope.data.selectedLink.hash;
          $location.hash(id.substr(1, id.length));
          $anchorScroll.yOffset = 100;
          $anchorScroll();
        }
      }]
    }

  }]);;

// Source: ../shared/public_html/assets/js/base/directives/modelFlag.js
angular.module('base')

/**
 * @name        modelFlag
 * @description model flag directive
 */
.directive('modelFlag', function modelFlag() {
var link = function (scope, elem, attrs) {
    elem.bind('click', function () {

      if (scope.disabled) return;

      scope.$apply(function () {
        scope.model[scope.flagName] = !scope.model[scope.flagName];
        scope.onChange();
      });
    });
  };

  return {
    restrict: 'E',
    template: '<span class="boolean" ng-class="{ on: model[flagName], disabled: disabled }"><span class="toggler"></span> <ng-transclude></ng-transclude></span>',
    replace: true,
    transclude: true,
    scope: {
      disabled: '=?',
      model: '=',
      flagName: '@',
      onChange: '&'
    },
    link: link
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/navbar/baseNavbar.js
angular.module('base')

  .controller('baseNavbarCtrl', ['$scope', '$window', '$rootScope', '$state', '$document', '$timeout', 'appConfig', '$location', '$element', 'AuthService', 'AuthService2', 'AuthGuard', 'ModalHelper', 'UserSessionData', 'LANG_NAMES',
  function ($scope, $window, $rootScope, $state, $document, $timeout, AppConfig, $location, $element, AuthService, AuthService2, AuthGuard, ModalHelper, UserSessionData, LANG_NAMES) {
  this.element = $element;

  /**
   * App config reference
   *
   * @type {AppConfig}
   */
  $scope.appConfig = AppConfig;
  $scope.isLinksModalShown = false;
  $scope.isLanguageListShown = false;
  $scope.isHamburgerMenuShown = false;
  $scope.isUserMenuShown = false;
  $scope.activeLanguageFlag = AppConfig.getActiveLanguageFlag();
  $scope.activeLanguage = 'English';
  $scope.navLinks = [];
  $scope.UserSessionData = UserSessionData;

  /**
   * Checks if steps should be shown in the navbar
   *
   * @returns {Boolean}
   */
  $scope.shouldShowSteps = function () {
    return $state.current.name === 'flight_details';
  };

  $scope.showLinksModal = function (e) {
    e.stopPropagation();
    $scope.isLinksModalShown = true;
    ModalHelper.lockBodyScroll();
  };

  $scope.hideLinksModal = function () {
    $scope.isLinksModalShown = false;
    ModalHelper.unlockBodyScroll();
  };

  $scope.showLanguageList = function () {
    $scope.isLanguageListShown = true;
  };

  $scope.hideLanguageList = function () {
    $scope.isLanguageListShown = false;
  };

  $scope.showHamburgerMenu = function () {
    $scope.isHamburgerMenuShown = true;
    lockHamburgerScrollToggle(true);
  };

  $scope.hideHamburgerMenu = function () {
    $scope.isHamburgerMenuShown = false;
    lockHamburgerScrollToggle(false);
  };

  $scope.navLinkClickHandler = function () {
    $scope.hideHamburgerMenu();
    $scope.hideLinksModal();
  };

  $rootScope.isNavbarFixed = function() {
    var notFixedStates = [
      'flight_details',
      'pax_details',
      'landingPages',
      'lpNoParams',
      'escapes escapes_hp',
      'escapes escapes_details',
      'search_results',
      'search_results2'
    ];

    return notFixedStates.indexOf( $state.current.name ) == -1;
  };

  var setActiveLink = function () {
    ($location.url() == '/') ? $scope.activeLink = '/' : $scope.activeLink = $location.url().replace('/', '');
  };

  setActiveLink();

  /**
   * Opens the login form
   */
  $scope.loginForm = function () {
    AuthService.showLoginModal();
    $scope.hideHamburgerMenu();
  };

  $scope.signupForm = function () {
    AuthService.showRegisterModal();
    $scope.hideHamburgerMenu();
  }

  $scope.logout = function () {
    AuthService2.logout().then(function() {
      AuthService.logout().then(function() {
        $scope.navLinkClickHandler();
        AuthGuard.redirectToMainPage();
      });
    });
  }

  this.notFixedNavBarStates = [
    { name: 'landingPages' },
    { name: 'search_results' }
  ];

  $scope.isHomepage = function (){
    var govolaHomePages = [
      '/uk-en', '/hu-hu', '/gr-el', '/hr-hr', '/it-it', '/cz-cs', '/bg-bg', '/eu-en', '/al-sq', '/si-sl', 'sk-sk',
      '/uk-en/', '/hu-hu/', '/gr-el/', '/hr-hr/', '/it-it/', '/cz-cs/', '/bg-bg/', '/eu-en/', '/al-sq/', '/si-sl/', 'sk-sk/',
    ];

    var isGovolaHomePage = !!govolaHomePages.find(function (pathName) {
        return pathName === window.location.pathname.toLowerCase();
    });

    return $state.current.name === 'homepage' || isGovolaHomePage;
  }

  $rootScope.shouldHideNavbarOnMobile = $scope.isHomepage();
  /**
   * BEA-1397 - UX Pack feature test END
   */

  this.isNavBarFixed = function (state) {
    var stateNavBarPosition = _.find(this.notFixedNavBarStates, {'name': state.name});
    return stateNavBarPosition == undefined;
  };

  function handleLanguageMenuVisibility($event) {
    var parentSelector = '.navbar__lang-holder';

    $scope.$evalAsync(function () {
      if (!$event.target.closest(parentSelector)) {
        $scope.hideLanguageList();
      }
    });
  }

  function handleHamburgerMenuVisibility($event) {
    var parentSelector = '#hamburger-holder';

    $scope.$evalAsync(function () {
      if (!$event.target.closest(parentSelector) && $scope.isHamburgerMenuShown) {
        $scope.hideHamburgerMenu();
      }
    });
  }

  function handleLinksMenuVisibility($event) {
    var parentSelector = '.nav-links-modal__link-holder';

    $scope.$evalAsync(function () {
      if (!$event.target.closest(parentSelector) && $scope.isLinksModalShown) {
        $scope.hideLinksModal();
      }
    });
  }

  function shouldRenderServicesMobileButton() {
    return AppConfig.getLanguageCode() !== 'pl';
  }

  function setActiveLanguage() {
    $scope.activeLanguage = LANG_NAMES[AppConfig.getLanguageCode() || 'en'];
  }

  $scope.fixedNavbar = this.isNavBarFixed($state.current);

  $rootScope.$on("$stateChangeSuccess", function () {
    setActiveLink();
  });

  this.$onInit = function () {
    document.addEventListener('click', handleLanguageMenuVisibility);
    document.addEventListener('click', handleHamburgerMenuVisibility);
    document.addEventListener('click', handleLinksMenuVisibility);

    setActiveLanguage();

    // functionality to close menus on link click
    setTimeout(function () {
      $scope.navLinks = Array.from(document.getElementsByClassName('navigation-menu-link'));
      $scope.navLinks.forEach(function (link) {
        link.addEventListener('click', $scope.navLinkClickHandler);
      });
    },1000);
  }

  this.$onDestroy = function () {
    document.removeEventListener('click', handleLanguageMenuVisibility);
    document.removeEventListener('click', handleHamburgerMenuVisibility);
    document.removeEventListener('click', handleLinksMenuVisibility);
    $scope.navLinks.forEach(function (link) {
      link.removeEventListener('click', $scope.navLinkClickHandler)
    });
  };

  /**
   * Method called on hamburger toggle
   */
  $scope.hamburgerOnToggle = lockHamburgerScrollToggle;

  /**
   * Toggles the body scroll ability when hamburger menu is opened on mobile
   */
  function lockHamburgerScrollToggle(value) {
    var isMobileScreen = $window.matchMedia('(max-width: 767px)').matches;

    if (value && isMobileScreen) {
      // We lock scroll only on mobile resolution
      ModalHelper.lockBodyScroll();
    }

    if (!value) {
      ModalHelper.unlockBodyScroll();
    }
  }

  $scope.isAgent = function () {
    return _js_app_config_.user != null && typeof _js_app_config_.user == 'object' && _js_app_config_.user.agent == true;
  };

  $scope.goToApp = function () {
    window.location.href = 'https://itunes.apple.com/app/apple-store/id1116960779?mt=8';
    $scope.closeFABar();
  };
}])

/**
 * @name        baseNavbar
 * @description Directive for navbar
 */
.directive('baseNavbar', function () {
return {
    restrict: 'A',
    controller: 'baseNavbarCtrl',
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/navbar/ngStaticPageNavBar.js
angular.module('base')

/**
 * @name        ngStaticPageNavBarCtrl
 * @description Controller
 */
.controller('ngStaticPageNavBarCtrl', ['$scope', '$stateParams', 'sch.SearchQueryParams', 'NgStaticPage',
function ($scope, $stateParams, SearchQueryParams, NgStaticPage) {
var pageToLoad = $stateParams.params;

  NgStaticPage.getNgStaticPage(pageToLoad).then(
    function (ngStaticPage) {
      $scope.ngStaticPage = ngStaticPage;
      $scope.searchQueryParams = SearchQueryParams;

      $scope.getTemplate = function () {
        var tmpl = '/tpl/show/jsShared/templates/navbar/home-hyb';

        if ($scope.ngStaticPage.settings.header == 'HEADER_1') {
          tmpl = '/tpl/show/jsShared/templates/navbar/searchResults';
        }

        return tmpl;
      };
    },

    function (failure) {
      console.log("something went wrong", failure);
    }
  );
}])

/**
 * @name        leadOffer
 * @description Single lead offer directive
 */
.directive('ngStaticPageNavBar', function () {
  return {
    restrict: 'A',
    controller: 'ngStaticPageNavBarCtrl',
    template: '<div ng-include="getTemplate()" include-replace></div>',
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/navbar/searchResultsNavbar.js
angular.module('base')

/**
 * @name        searchResultsNavbar
 * @description Controller for search results navbar partial
 */
.controller('searchResultsNavbarCtrl', ['$scope', 'sch.SearchQueryParams', function ($scope, SearchQueryParams) {
$scope.searchQueryParams = SearchQueryParams;
}]);

;

// Source: ../shared/public_html/assets/js/base/directives/navbar/simpleNavbar.js
angular.module('base')

/**
 * @name        simpleNavbar
 * @description Directive for simple navbar partial, requires only template url
 */
.directive('simpleNavbar', function () {
return {
    restrict: 'A',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    replace: true
  };
});

;

// Source: ../shared/public_html/assets/js/base/directives/newsletter/newsletter.js
(function(angular) {
/**
   * Controller for the newsletter directive
   */
  var NewsletterDirectiveCtrl = function (
    $scope,
    $timeout,
    $modal,
    CashBackService,
    appConfig,
    WarmUpSrv,
    RodoService,
    Remarketing
  ) {
    var nl = this;

    $scope.NsKey = 'newsletterCheck';
    /*that same config, exist options use getNewsletterSettings*/
    $scope.config = appConfig.getNewsletterSettings();
    $scope.showLoading = false;
    $scope.emailExistInDb = false;
    $scope.emailMessage = false;

    /**
     * Newsletter terms error.
     *
     * @type {Boolean}
     */
    $scope.nlTermsError = false;

    /**
     * Newsletter data object.
     *
     * @type {Object}
     */
    $scope.newsletterData = {
      email: '',
      agreeTerms: false
    };

    $scope.modalData = {
      showModal: false,
      onClose: true
    };
    /**
     * Show hide logic
     * @returns {Boolean}
     */
    $scope.showHideLogic = function () {
      var check = localStorage.getItem($scope.NsKey);

      return check && check == $scope.config.campaign_id;
    };

    $scope.newsletterHide = $scope.showHideLogic();

    /**
     * Set Lock
     */
    $scope.lock = function () {
      localStorage.setItem($scope.NsKey, $scope.config.campaign_id);
    };

    $scope.nlStatus = function (resp) {
      $scope.showLoading = false;

      if (resp.email_exists) {
        $scope.emailExistInDb = true;
        $scope.newsletterData.exist_email = $scope.newsletterData.email;
        return;
      }

      if (resp.nl_status && resp.nl_status != 'ERRORS') {
        $scope.news_status = resp.nl_status;
        $scope.lock();
        Remarketing.trackCouponSent();

        $timeout(function () {
          $scope.newsletterHide = true;
        }, 4000);
      }
      else {
        $scope.emailMessage = true;
      }
    };
    /**
     * Send Newsletter
     * @param {Boolean} formIsValid
     * @param {Object}  data
     */
    $scope.newsletterSend = function (formIsValid, data) {
      // Check if RODO is enabled and if user agrees with terms
      if (RodoService.isEnabled('nlComponent') && RodoService.getSettings().nlSubscribeConsent && !data.agreeTerms) {
        // Cannot proceed without agreeing terms
        $scope.nlTermsError = true;
        return;
      } else {
        // Reset newsletter terms error
        $scope.nlTermsError = false;
      }

      $scope.showLoading = true;
      $scope.emailValidError = 0;
      $scope.emailMessage = false;
      $scope.emailExistInDb = false;

      if (formIsValid) {
        var dataToSend = {
          email: data.email,
          campaign_id: $scope.config.campaign_id,
          source: $scope.config.source,
          nl_place_name: 'frontPage'
        };

        CashBackService.getCoupon(dataToSend).then(
          function success(resp) {
            $scope.nlStatus(resp);
          },
          function error(resp) {
            $scope.nlStatus(resp);
          }
        );
      } else {
        $scope.showLoading = false;
      }
    };

    nl.isShowModal = function () {
      return $scope.modalData.showModal;
    };

    nl.refreshModalRender = function () {
      var showOnDevice = appConfig.isMobile() && !appConfig.isTablet() ? false : true;
      if (nl.isShowModal() && showOnDevice) {
        $scope.modalInstance = $modal.open({
          templateUrl: 'nDbModal.html',
          windowTemplateUrl: 'nDbModalWindow.html',
          controller: 'newsletterModalCtrl',
          windowClass: 'newsletter-modal',
          backdrop: 'static',
          scope: $scope,
          keyboard: false,
          resolve: {
            getMessage: function () {
              return 1;
            }
          }
        });
      }
    };

    $scope.initModal = function () {
      var modelConfigData = WarmUpSrv.getByKey('newsletterModal');

      if (!modelConfigData) {
        return false;
      }

      $scope.modalData = modelConfigData;

      var timeoutFn = function () {
        nl.refreshModalRender();
        //google tracking
        if (window.JSNS && window.JSNS.ga_track) {
          JSNS.ga_track.track_newsletter_modal();
        }
      };

      $timeout(timeoutFn, $scope.modalData.delayTime);
    };
  };

  NewsletterDirectiveCtrl.$inject = [
    '$scope',
    '$timeout',
    '$modal',
    'CashBackService',
    'appConfig',
    'WarmUpSrv',
    'RodoService',
    'goo.Remarketing'
  ];

  /**
   * @name        newsletter
   * @description directive for newsletter zone
   */
  var NewsletterDirective = function () {
    return {
      restrict: 'A',
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/newsletter/newsletter-hyb';
      },
      replace: true,
      controller: 'newsletterDirectiveCtrl'
    };
  };

  angular
    .module('base')
    .directive('newsletter', NewsletterDirective)
    .controller('newsletterDirectiveCtrl', NewsletterDirectiveCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/newsletter/newsletterModal.js
angular.module('base')

.controller('newsletterModalCtrl', ['$scope', 'CashBackService', '$timeout', 'appConfig', 'WarmUpSrv' ,'$filter',
function (scope, CashBackService, $timeout, appConfig, WarmUpSrv, $filter) {
var nl = this;

  scope.configData = {};
  scope.formData = {
    submitted : false
  };
  scope.showLoading = false;
  scope.submitted = false;

  nl.getSource = function(key){
    if (scope.configData.source[key]) {
      return scope.configData.source[key];
    }

    return false;
  };

  scope.closeModal = function () {
    scope.formData.hideModelBox = true;
    scope.modalInstance.close();
  };

  scope.signUpNew = function(fbEmail, valid){
    var data = scope.configData.mTags || {};
    data.email = fbEmail || scope.formData.email;
    data.source = fbEmail ? nl.getSource('facebook') : nl.getSource('default');

    scope.formData.submitted = fbEmail ? false : true;

    if (!data.email || (!valid && !fbEmail)) {
      return;
    }

    if (fbEmail) {
      data.facebook = 'singup';
      scope.formData.email = fbEmail;
    }

    scope.showLoading = true;
    CashBackService.addToNewsletter(data).then(function (response) {
      if (response && response.nl_status) {
        nl.showAlert(response.nl_status);
      }

      nl.gaTrack();
    }).finally(function(){
      $timeout(function () {
        scope.closeModal();
        if (scope.configData.redirectUrl) {
          window.location.href = scope.configData.redirectUrl;
        }

      }, 5000);
    });

  };

  scope.loadingText = function (email) {
    var text = $filter('translate')('LANGM_JS_MODAL_SENDING_DATA');

    return text.replace('%email%', email);
  };

  scope.hideFbButton = function () {
    if (scope.configData.hideFbButton) {
      return true;
    }

    return false;
  };

  nl.gaTrack = function(){
    if (window.JSNS && window.JSNS.ga_track) {
      // Send page view to GA
      JSNS.ga_track.track_page_view(scope.configData.gaLinkStr);
      JSNS.ga_track.send_page_views();

      JSNS.ga_track.track_newsletter_invitation();
      JSNS.ga_track.send_events();
    }
  };

  nl.showAlert = function (key) {
    if (scope.configData.alerts[key]) {
      scope.formData.message = scope.configData.alerts[key];
    }

    $timeout(function () {
      scope.formData.message = false;
    }, 5000);
  };

  scope.singUpWithFb = function () {

  };

  (function(){
    scope.configData = WarmUpSrv.getByKey('newsletterModal');
    if (scope.configData.femail) {
      scope.formData.email = scope.configData.femail;
    }
  })();

}]);

;

// Source: ../shared/public_html/assets/js/base/directives/ngStaticPage/ngStaticPageForcedBreadcrumbs.js
angular.module('base')

/**
 * @name        ngStaticPageForcedBreadcrumbs
 * @description
 */
.directive('ngStaticPageForcedBreadcrumbs', function () {
return {
    restrict: 'A',
    replace: true,
    controller: 'NgStaticPageCtrl',
    templateUrl: function (elem, attrs) {
      return '/tpl/show/jsShared/templates/ngStaticPage/navbars/forcedBreadcrumbs-hyb';
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/obfuscateValue.js
angular.module('base')

    .directive('obfuscateValue', ['Tools', function (Tools) {
return {
            restrict: "A",
            priority: 1,
            require: "?ngModel",
            link: function (scope, element, attrs, controller) {

                attrs.$observe('ngBind', function () {
                    element.text(Tools.getObfuscatedValue(element.text()));
                });

                if (controller) {
                    controller.$formatters.push(
                        function (value) {
                            return Tools.getObfuscatedValue(value);
                        }
                    );

                    controller.$parsers.shift(
                        function (value) {
                            element.text(Tools.getObfuscatedValue(value));
                            return value;
                        }
                    );
                }
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/onClickOutside.js
angular.module('base')

/**
 * @name        ngClickOutside
 * @description Attribute directive that does something when clicking outside of an element
 *
 * @example
 * <button ng-click="toggleMenu()" on-click-outside="closeMenu()"></button>
 */
.directive('onClickOutside', ['$document',
  function onClickOutside($document) {
return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.on('click', function() {
        _unbind();
        _bind();
      });

      scope.$on('$destroy', function() {
        _unbind();
      });

      /**
       * Method called on click event
       */
      var _clickElsewhere = function (event) {
        var isChild = element[0].contains(event.target);
        var isSelf = element[0] == event.target;

        if (!isChild && !isSelf) {
          // Callback
          scope.$apply(attr.onClickOutside);

          // Unbind the event
          _unbind();
        }
      };

      /**
       * Binds the click elsewhere method to the click event
       */
      var _bind = function() {
        $document.on('click touchstart', _clickElsewhere);
      };

      /**
       * Unbinds the click elsewhere to the click event
       */
      var _unbind = function() {
        $document.off('click touchstart', _clickElsewhere);
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/onEvent.js
(function(angular) {
/**
     * Directive name
     *
     * @type {String}
     */
    var dirName = 'ev';

    /**
     * Directive that listens for events
     * Usage: listen for events from stencil components
     */
    var onEventDirective = function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                /**
                 * Calls a method from angular world
                 *
                 * @type {Function}
                 */
                var expressionHandler = $parse(attrs.call);

                /**
                 * Function called on event
                 *
                 * @param {Event} event
                 */
                var fn = function (event) {
                    console.log('Event triggered!');
                    expressionHandler(scope, { $event: event });
                };

                angular.element(element).bind(attrs[dirName], fn);

                scope.$on('$destroy', function () {
                    angular.element(element).unbind(attrs[dirName], fn);
                });
            }
        };
    };

    onEventDirective.$inject = [
        '$parse'
    ];

    angular
        .module('base')
        .directive(dirName, onEventDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/openModal.js
angular.module('base')

/**
 * @name        openModal
 * @description
 */
.directive('openModal',
['pkg.ModalService',
function openModal(ModalService) {
var link = function (scope, element, attrs) {
    element.bind('click', function () {
      var data = scope.$eval(attrs.modalData);
      var options = scope.$eval(attrs.modalOptions);
      var tpl = attrs.modalTpl;

      ModalService.open(data, tpl, options);
    });
  };

  return {
    restrict: 'A',
    link: link
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/directives/pageLoading.js
angular.module('base')

/**
 * @name        pageLoading
 * @description
 */
.directive('pageLoading', ['PageLoading',
function pageLoading(PageLoading) {
return {
    restrict: 'E',
    scope: false,
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/base/loading/fullPageLoader',
    link: function (scope, el) {
      var
        /**
         * Prefix of the LANG
         * @type {String}
         */
        _langPrefix = "LANGM_JS_PAGE_LOADING_";

      /**
       * Returns a random lang whenever the loader is displayed
       * @return {String}
       */
      scope.getLoadingLang = function () {
        return _langPrefix + PageLoading.getLangIndex();
      };

      /**
       * Return true if page loading should be displayed
       * @return {boolean}
       */
      scope.isLoading = function () {
        return PageLoading.isLoading();
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/paxSelector/FlightPaxModalCtrl.js
(function(angular) {
/**
     * @name        IthFlightPaxModalController
     * @description Handles data inside the pax select modal.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthFlightPaxModalController = function ($scope, FlightPaxModel) {
        /**
         * Pax model backup
         *
         * @type {Object}
         */
        this.modelBackup = angular.copy(FlightPaxModel.model);

        /**
         * Pax model reference
         *
         * @type {FlightPaxModel}
         */
        this.paxModel = FlightPaxModel;

        /**
         * Closes the pax modal by ignoring any change in pax
         */
        this.cancel = function () {
            FlightPaxModel.model = this.modelBackup;
            FlightPaxModel.update();
            $scope.$dismiss('cancel');
        };

        /**
         * Closes the modal by saving changes in pax
         */
        this.continue = function () {
            FlightPaxModel.update();
            this.close();
        };

        /**
         * Resets the pax model to default values
         */
        this.reset = function () {
            FlightPaxModel.reset();
        };

        /**
         * Closes the modal
         */
        this.close = function () {
            $scope.$dismiss('done');
        };
    };

    IthFlightPaxModalController.$inject = [
        '$scope',
        'FlightPaxModel'
    ];

    angular
        .module('base')
        .controller('FlightPaxModalCtrl', IthFlightPaxModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/paxSelector/FlightPaxModel.js
(function(angular) {
var FlightPaxModel = function ($filter, $window, PaxTypeModel, appConfig, SearchQueryParams, SearchHistory) {
    /**
     * Self reference
     * @type {Object}
     */
    var self = this;

    /**
     * Updates summary in the pax model
     * @return {Void}
     */
    var _updateSummary = function () {
      var tmp = 0, arr = [];

      angular.forEach(self.model.group, function (paxType) {
        tmp += paxType.count;

        if (paxType.count > 0) {
          var
            langPlural = $filter('langPluralize')(paxType.lang, paxType.count),
            finalText = paxType.count + ' ' + $filter('translate')(langPlural);
          arr.push(finalText);
        }
      });

      // Update total pax count
      self.model.summary = tmp;

      // Update pax text summary
      self.model.textSummary = arr.join(' \u2022 ');

      // Validate pax setup
      self.paxValid(self.model);
    };

    /**
     * Returns true (valid) or false (invalid)
     * @param {Object} data
     * @return bool
     */
    this.paxValid = function (data) {
      var _root = data !== undefined ? data : this.model;
      var group = _root.group;
      var checkedGroup = 0;
      var totalPax = 0;
      var MAX_PAX_GROUP = 5;

      angular.forEach(_root.group, function (v) {
        if (v.count > 0) {
          checkedGroup += 1;
        }

        totalPax += v.count;
      });

      if (group.infants.count > group.adults.count) {
        return $filter('translate')('LANGM_JS_PM_TOO_MUCH_INFANTS');
      }

      if (group.children.count > 0 && group.adults.count === 0) {
        return $filter('translate')('LANGM_JS_PAX_ERROR_ONE_CHILD_BUT');
      }

      if (group.youths.count > 0 && group.adults.count === 0) {
        return $filter('translate')('LANGM_JS_PAX_ERROR_ONE_YOUTH_PASSENGER_BUT');
      }

      if (totalPax > 9) {
        return $filter('translate')('LANGM_JS_PAX_ERROR_SELECTED_MORE_THAN_9_PEOPLE');
      }

      if (totalPax < 1) {
        return $filter('translate')('LANGM_JS_PAX_ERROR_NUMBER_OF_PAX');
      }

      if (checkedGroup > MAX_PAX_GROUP) {
        return $filter('translate')('LANGM_JS_PAX_ERROR_SELECTED_MORE_THAN_MAX');
      }

      return false;
    };

    /**
     * PAX model available for injection
     * @type {Object}
     */
    this.model = {
      group: {
        adults: new PaxTypeModel(1, 'LANGM_JS_FLIGHT_SEARCH_ADULTS', 'LANGM_JS_PAX_ADT_AGE', 1, 9),
        children: new PaxTypeModel(2, 'LANGM_JS_FLIGHT_SEARCH_CHILDREN', 'LANGM_JS_FLIGHT_SEARCH_YEAR', 0, 5),
        infants: new PaxTypeModel(3, 'LANGM_JS_FLIGHT_SEARCH_INFANTS', 'LANGM_JS_FLIGHT_SEARCH_MONTH', 0, 5),
        youths: new PaxTypeModel(4, 'LANGM_JS_FLIGHT_SEARCH_YOUTH', 'LANGM_JS_FLIGHT_SEARCH_YOUTH_AGE', 0, 5)
      },
      summary: 0,
      textSummary: ''
    };

    /**
     * Returns the total count of paxes
     * @return {Number}
     */
    this.getTotalCount = function () {
      return this.model.summary;
    };

    /**
     * Returns the pax setup in pretty format
     * @return {String}
     */
    this.getSummary = function () {
      return this.model.textSummary;
    };

    /**
     * Returns the pax amount in pluralized format
     * @return {String}
     */
    this.getSummaryShort = function () {
      var langPlural = $filter('langPluralize')('LANGM_JS_FLIGHT_SEARCH_PASSENGERS', this.getTotalCount());
      return this.getTotalCount() + ' ' + $filter('translate')(langPlural);
    };

    /**
     * Parser for pax from url
     *
     * @param type
     * @returns {*}
     */
    this.parseUrl = function (type) {
      var url = $window.location.href;
      var match;
      var regex;

      switch (type) {
      case 'adults': regex = /\/ad\/([0-9])/g; break;
      case 'children': regex = /\/ch\/([0-9])/g; break;
      case 'infants': regex = /\/inf\/([0-9])/g; break;
      case 'youths': regex = /\/yo\/([0-9])/g; break;
      default: regex = /\/ad\/([0-9])/g;
      }

      match = regex.exec(url);

      if (match) {
        return match[1];
      }

      return false;
    };

    /**
     *
     */
    this.init = function () {
      var param;
      var history = SearchHistory.get();

      angular.forEach(this.model.group, function (v, key) {
        param = this.parseUrl(key);

        if (param) {
          this.model.group[key].count = parseInt(param, 10) || 0;
        } else {
          return history[key];
        }
      }, this);

      _updateSummary();
    };

    /**
     * Resets pax setup to default (1 adult)
     */
    this.reset = function () {
      angular.forEach(this.model.group, function (pax, key) {
        pax.count = (key === 'adults') ? 1 : 0;
      });
    };

    this.getTotal = function () {
      var total = 0;
      angular.forEach(this.model.group, function (paxGroup) {
        total += paxGroup.count;
      });

      return total;
    };

    this.update = function () {
      _updateSummary();
    };

    this.range = function (key) {
      var max = this.model.group[key].max || 0;
      return [0, max];
    };

    return this;
  };

  FlightPaxModel.$inject = [
    '$filter',
    '$window',
    'PaxTypeModel',
    'appConfig',
    'sch.SearchQueryParams',
    'SearchHistory'
  ];

  angular
    .module('base')
    .service('FlightPaxModel', FlightPaxModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/paxSelector/ith-pax-configurator.component.js
(function (angular) {

    angular.module('base').component('ithPaxConfigurator', {
        bindings: {
            flightPaxModel: '<'
        },
        template: '\
            <div class="pax-categ" ng-repeat="(key, paxType) in $ctrl.flightPaxModel.model.group track by paxType.id">\
                <div class="pax-categ__text">\
                    <div class="title" translate>{{ :: paxType.lang }}</div>\
                    <small class="sub-title" translate>{{ :: paxType.subLang }}</small>\
                </div>\
                \
                <div class="pax-categ__buttons">\
                    <div class="pax-categ__button" ng-class="{ \'pax-categ__button--disabled\': paxType.getCount() === 0 }" ng-click="paxType.remove(); $ctrl.flightPaxModel.update();">\
                        <svg-icon class="size--16" id="minus"></svg-icon>\
                    </div>\
                    <span ng-bind="paxType.getCount()"></span>\
                    <div class="pax-categ__button" ng-class="{ \'pax-categ__button--disabled\': paxType.getCount() == paxType.getMax() }" ng-click="paxType.add(); $ctrl.flightPaxModel.update();">\
                        <svg-icon class="size--16" id="plus"></svg-icon>\
                    </div>\
                </div>\
            </div>\
        '
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/paxSelector/paxFlight.js
angular.module('base')

    /**
     * @name        paxFlight
     * @description
     */
    .directive('paxFlight',
        [
            '$rootScope', 'MobileDismissableModal', '$sessionStorage', 'appConfig', 'FlightPaxModel', '$document',
            function ($rootScope, MobileDismissableModal, $sessionStorage, AppConfig, FlightPaxModel, $document) {
return {
                    restrict: 'A',
                    replace: true,
                    templateUrl: '/tpl/show/jsShared/templates/base/directives/paxSelector/paxFlight',
                    controller: ['$scope', function ($scope) {
                        /**
                         * Object holding statuses
                         * @type {Object}
                         */
                        $scope.status = {
                            isopen: !!$sessionStorage.openPaxDropdown
                        };

                        /**
                         * Model instance of flight pax setup
                         * @type {FlightPaxModel}
                         */
                        $scope.flightPaxModel = FlightPaxModel;

                        /**
                         * Opens a modal for pax selection (mobile only)
                         */
                        $scope.openPaxModal = function () {
                            if (!AppConfig.isMobile() || AppConfig.isTablet()) {
                                $scope.$evalAsync(function () {
                                    $scope.status.isopen = !$scope.status.isopen;
                                });
                            } else {
                                MobileDismissableModal.open({
                                    templateUrl: '/tpl/show/jsShared/templates/base/directives/paxSelector/paxFlightModal',
                                    controller: 'FlightPaxModalCtrl',
                                    controllerAs: 'vm',
                                    windowClass: 'flight-form-modal__pax-select mobile-modal-with-navbar enabled-window-back-btn',
                                    backdrop: false,
                                    animation: false
                                }, 'paxes');
                            }
                        };

                        /**
                         * Closes the pax selector dropdown
                         * @return {[type]} [description]
                         */
                        $scope.closeDropdown = function () {
                            $scope.$evalAsync(function () {
                                $scope.status.isopen = false;
                            });
                        };

                        /**
                         * Event causing the pax selector to be displayed
                         */
                        $rootScope.$on('openPaxDropdown', function (event, args) {
                            if (AppConfig.isTablet() || !AppConfig.isMobile()) {
                                // Tablet and up
                                $scope.$evalAsync(function () {
                                    $scope.status.isopen = args;
                                });
                            } else {
                                // Mobile only
                                if (args) {
                                    $scope.openPaxModal();
                                }
                            }
                        });
                    }],
                    link: function (scope, el) {
                        FlightPaxModel.init();

                        // No other way because it's not a an input also no wrapper
                        $document.on('click', function(e) {
                            if (el !== e.target && !el[0].contains(e.target) && scope.status.isopen) {
                                scope.$evalAsync(function () {
                                    scope.status.isopen = false;
                                });
                            }
                        });
                        $document.on('keydown', function (e) {
                            if ((e.which || e.keyCode) === 27 && scope.status.isopen) {
                                scope.$evalAsync(function () {
                                    scope.status.isopen = false;
                                });
                            }
                        });
                    }
                };
            }]);
;

// Source: ../shared/public_html/assets/js/base/directives/paxSelector/paxTypeModel.js
angular
  .module('base')
  .factory('PaxTypeModel', [function () {
/**
     * Instantiates a new pax type
     * @constructor
     */
    var PaxTypeModel = function (id, lang, subLang, count, max) {
      /**
       * Unique id of this pax type (for ng-repeat track by)
       * @type {Number}
       */
      this.id = id;

      /**
       * Lang decribing this pax type
       * @type {String}
       */
      this.lang = lang;

      /**
       * Lang describing age range of this pax type
       * @type {String}
       */
      this.subLang = subLang;

      /**
       * Count for this pax type
       * @type {Number}
       */
      this.count = count;

      /**
       * Max count allowed for this pax type
       * @type {Number}
       */
      this.max = max;
    };

    PaxTypeModel.prototype = {
      /**
       * Increments count value
       */
      add: function () {
        if (this.count < this.max) {
          this.count += 1;
        }
      },

      /**
       * Decrements count value
       */
      remove: function () {
        if (this.count > 0) {
          this.count -= 1;
        }
      },

      /**
       * Returns total pax type count
       * @return {Number}
       */
      getCount: function () {
        return this.count;
      },

      /**
       * Returns max allowed number for this pax type
       * @return {Number}
       */
      getMax: function () {
        return this.max;
      }
    };

    return PaxTypeModel;
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/preloader.js
(function(angular) {
var IthPreloader = {
        template: '<div class="ith-preloader__wrapper"><ist-status-indicator size="{{$ctrl.size}}"></ist-status-indicator><ng-transclude></ng-transclude></div>',
        transclude: true,
        controller: function () {
            this.$onInit = function () {
                this.size = this.size || 32;
            };
        },
        bindings: {
            size: '<'
        }
    };

    angular
        .module('base')
        .component('ithPreloader', IthPreloader);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/processedImage.js
angular.module('base')

/**
 * @name        processedImage
 * @description Generates a processed image element
 */
.directive('processedImage', ['ProcessedImageService', '$sanitize', function (ProcessedImageService, $sanitize) {
return {
    restrict: 'E',
    replace: true,
    scope: {
      picture: '=',
      method: '@',
      imageAlt: '=',
      imageWidth: '=',
      imageHeight: '='
    },
    template: '<img>',

    link: function ($scope, elem, attrs) {
      var width = $scope.imageWidth || 0;
      var height = $scope.imageHeight || 0;

      var src = ProcessedImageService.getSrc($scope.picture, $scope.method, width, height);
      attrs.$set('src', src);
      attrs.$set('alt', $sanitize($scope.imageAlt));
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/RangeDatepicker.js
angular.module('base')

/**
 * @name base.RangeDatepicker
 *
 * @description
 */
.factory('RangeDatepicker', ['$timeout', '$stateParams', '$state', 'appConfig', '$document', 'sch.SearchQueryParams', '$q', '$modal', 'TripLengthServ',
function RangeDatepickerFactory($timeout, $stateParams, $state, appConfig, $document, SearchQueryParams, $q, $modal, TripLengthServ) {
/**
   * dropdowns scope reference list
   * @type {RangeDatepicker[]}
   * @private
   */
  var dropdowns = [],

    today = (function(){
      var date = new Date();

      date.setHours(0,0,0,0);

      return date;
    })(),

    /**
     * @class RangeDatepicker
     * @constructor
     * @param {Object} params
     * @param {Scope} params.scope
     * @param {Object} [params.range]
     * @param {Date} [params.range.start]
     * @param {Date} [params.range.end]
     * @param {Date} [params.minDate]
     * @param {Date} [params.maxDate]
     */
    RangeDatepicker = function (params) {
      var self = this;
      /**
       * if true rangedatepicker has opened dropdown
       * @type {Boolean}
       */
      this.dropdownOpened = false;

      /**
       * if true rangedatepicker has opened modal
       * @type {Boolean}
       */
      this.modalOpened = false;

      this.scope = params.scope;

      if(appConfig.isRoundTrip() === 'RT')
      {
        this.roundtrip = true;
      }
      else if(appConfig.isRoundTrip() === 'OW')
      {
        this.roundtrip = false;
      }
      else
      {
        this.roundtrip = !SearchQueryParams.oneway;
      }

      this.showsStartDate = false;

      dropdowns.push(this);

      this.state = appConfig.isSearchResultPage();
      this.isInsurance = params.isInsurance || false;
      /**
       * false if user do search before and false if no search before but dates provided forcefully
       * @type {Boolean}
       */
      this.noDepartureDateEntry = (params.scope.searchDateDeparture) ? false : ((!this.state) ? appConfig.isFirstEntry() : false); //set to false to show data when first search

      // Override on mobile
      if (appConfig.isMobile() && !appConfig.isTablet()) {
        this.noDepartureDateEntry = false;
      }

      /**
       * false if user do search before and false if no search before but dates provided forcefully
       * @type {Boolean}
       */
      this.noReturnDateEntry = (params.scope.searchDateArrival) ? false : ((!this.state) ? appConfig.isFirstEntry() : false); //set to false to show data when first search

      // Override on mobile
      if (appConfig.isMobile() && !appConfig.isTablet()) {
        this.noReturnDateEntry = false;
      }

      /**
       * if scope.range empty or undefined create new object
       */
      if (!params.range) {
        this.range = {
          start: this.noDepartureDateEntry ? null : this.initDepDate(),
          end: this.noReturnDateEntry ? null : this.initRetDate()
        };
      }
      else {
        this.range = params.range;
      }

      if(!this.state){

        if (!this.range.start) {
          this.range.start = this.initDepDate();
        }

        if (!this.range.end) {
          this.range.end = this.initRetDate();
        }
      } else {
        if (!this.range.start) {
          this.range.start = this.noDepartureDateEntry ? null : this.initDepDate();
        }

        if (!this.range.end) {
          this.range.end = this.noReturnDateEntry ? null : this.initRetDate();
        }
      }

      this.range.endCache = angular.copy(this.range.end);
      this.lastRange = angular.copy(this.range);

      /**
       * min date for date range
       * @type {Date}
       */
      this.minDate = params.minDate || new Date();


      this.maxDays = params.maxDays || false;

      /**
       * min date for start of range
       * @type {Date}
       */
      this.minStartDate = new Date(this.minDate);

      /**
       * min date for end of range
       * @type {Date}
       */
      this.minEndDate = new Date(this.range.start || this.minStartDate);

      /**
       * Min trip length in days, 0 means the same day
       * @type {Number}
       */
      this.minTripLength = params.minTripLength || 0;

      if (this.minTripLength > 0) {
        this.minEndDate.setDate(this.minEndDate.getDate() + this.minTripLength);
      }
      /**
       * max date for date range
       * @type {Date}
       */
      this.maxDate = params.maxDate || (function() {
        var date = new Date();

        date.setDate(date.getDate() + 329); //+329 days, like on production

        return date;
      })();
      this.maxSelectDate = angular.copy(this.maxDate);
      /**
       * @type {Date|null}
       */
      this.dateHovered = null;

      /* after set date we need calculate period */
      this.updateTravelPeriod();
      this.scope.$on('$destroy', function () {
        self.destroy();
      });

      // Angular UI Bootstrap controllers
      this.ctrls = {
        first: {},
        second: {}
      };

      /**
       * @type {HTMLElement|null}
       */
      this.startHTMLElement = null;

      /**
       * @type {HTMLElement|null}
       */
      this.endHTMLElement = null;

      /**
       * @type {HTMLElement|null}
       */
      this.dropdownHTMLElement = null;

      /**
       * @type {boolean}
       */
      this.noResultForm = false;

      /**
       * @type {HTMLElement|null}
       */
      this.dropdownParentHTMLElement = null;

      /**
       * It's resolved when there is HTML element for dropdown
       *
       * @type {Deferred}
       */
      this.HTMLElementRendered = $q.defer();

      this.canGoBack = false;
      this.canGoNext = false;

      this.cellsCache = [];

      /**
       * Is departure datepicker visible?
       * @type {Boolean}
       */
      this.selectingDeparture = false;

      /**
       * Is return datepicker visible?
       * @type {Boolean}
       */
      this.selectingReturn = false;

      /**
       * Trip length service
       * @type {TripLengthServ}
       */
      this.tripLength = TripLengthServ;
    };


  function documentClick() {
    $document.unbind('click', documentClick);
    _.defer(function () {
      for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].hide();
      }
    });
  }

  RangeDatepicker.prototype = /** @lends RangeDatepicker.prototype */  {
    setStartTripMaxDate:function(){
      return this.maxSelectDate;
    },
    setEndTripMaxDate:function(){
      return moment(this.range.start).add(this.maxDays - 1, 'days').toDate();
    },
    showStartDate: function() {
      this.showsStartDate = true;
      this.minDate = this.minStartDate;
      this.open();
      this.moveDropdown(this.startHTMLElement);
      this.waitForHTMLElement().then((function() {
        this.goToDate(this.range.start);
      }).bind(this));
    },

    showEndDate: function() {
      this.showsStartDate = false;
      this.minDate = this.minEndDate;
      if(this.maxDays) {
        this.maxDate = this.showsStartDate ? this.setStartTripMaxDate(): this.setEndTripMaxDate();
      }
      this.open();
      this.moveDropdown(this.endHTMLElement);
      this.waitForHTMLElement().then((function() {
        this.goToDate(this.range.end || this.range.start);
      }).bind(this));
    },

    toggleStartDatepicker: function () {
      this.clearCellsCache();

      if (this.showsStartDate) {
        this.hide();
      } else {
        this.showStartDate();
      }
    },

    toggleEndDatepicker: function() {
      this.clearCellsCache();

      if (!this.showsStartDate && this.isOpened()) {
        this.hide();
      } else {
        this.showEndDate();
      }
    },

    onSelect: function() {
      if (this.isForStartDate()) {
        this.noDepartureDateEntry = false;
      }else {
        this.noReturnDateEntry = false;
      }
    },

    isModal: function() {
      return (appConfig.isMobile() && !appConfig.isTablet()) || (this.noResultForm && !appConfig.isTablet() && appConfig.isMobile());
    },

    isOpened: function() {
      return this.modalOpened || this.dropdownOpened;
    },

    openModal: function() {
      var self = this;

      this.modalOpened = true;
      this.dateHovered = null;

      // Set correct modal template url      
      var modalUrl = '/tpl/show/jsShared/templates/base/directives/datepicker/rangeDatepickerModal';

      if (this.isInsurance) {
        modalUrl = '/tpl/show/jsShared/templates/base/directives/datepicker/rangeInsuranceDatepickerModal';
      }

      $modal.open({
        templateUrl: modalUrl,
        controller: ['$scope', '$modalInstance', 'ScrollCalendarHelper', 'data', function ($scope, $modalInstance, ScrollCalendarHelper, data) {
          var initialStartDate = data.rangeDatepicker.range.start;
          var initialEndDate = data.rangeDatepicker.range.end;

          $timeout(function () {
            // Scroll calendar to selected month
            ScrollCalendarHelper.scrollToSelection(initialStartDate);
          }, 300, false);

          /**
           * rangeDatepicker reference
           */
          $scope.rangeDatepicker = data.rangeDatepicker;          
          $scope.rangeDatepicker.$modalInstance = $modalInstance;
          $scope.onSelect = function() {
            $scope.rangeDatepicker.onSelect();
          };

          /**
           * Sets dates in range date picker and closes the modal
           */          
          $scope.continue = function () {
            data.rangeDatepicker = $scope.rangeDatepicker;
            $scope.rangeDatepicker.onSelect();
            $scope.rangeDatepicker.showsStartDate = false;
            $scope.rangeDatepicker.modalOpened = false;
            $modalInstance.close();
          };

          /**
           * Resets the date range in the date picker
           */
          $scope.reset = function () {
            $scope.rangeDatepicker.range.start = null;
            $scope.rangeDatepicker.range.end = null;
          };

          /**
           * Checks if dates are reset (are equal to null)
           *
           *  @returns {Boolean}
           */           
          $scope.isReset = function () {
            return $scope.rangeDatepicker.range.start === null && $scope.rangeDatepicker.range.end === null;
          };

          /**
           * Closes the modal without changing dates in the date range
           */           
          $scope.back = function () {
            // Revert to previous dates
            $scope.rangeDatepicker.range.start = initialStartDate;
            $scope.rangeDatepicker.range.end = initialEndDate;
            $scope.rangeDatepicker.onSelect();
            $scope.rangeDatepicker.modalOpened = false;
            $scope.rangeDatepicker.showsStartDate = false;
            $modalInstance.dismiss('cancel');
          };

          _.defer(function () {
            $scope.rangeDatepicker.dropdownHTMLElement = document.querySelectorAll('.range-datepicker-modal-message')[0];
          });
        }],
        windowClass: 'range-datepicker-modal-message mobile-modal-with-navbar',
        animation: false,
        resolve: {
          data: function () {
            return {
              rangeDatepicker: self.scope.rangeDatepicker,
              isStartDate: self.isForStartDate()
            };
          }
        }
      }).result.then(function(){}, function() {
        // Hide rangedatepicker
        self.hide();
      });
    },

    openDropdown: function() {
      this.dropdownOpened = true;
      _.defer(function () {
        $document.bind('click', documentClick);
      });
    },

    open: function () {
      var self = this;

      this.waitForHTMLElement().then((function() {
        if (this.isForStartDate()) {
          angular.element(this.dropdownHTMLElement).removeClass('end-date').addClass('start-date');
          this.selectingDeparture = true;
          this.selectingReturn = false;
        }
        else {
          angular.element(this.dropdownHTMLElement).removeClass('start-date').addClass('end-date');
          this.selectingDeparture = false;
          this.selectingReturn = true;
        }
      }).bind(this));

      if (!self.isOpened()) {
        if (this.isModal()) {
          this.openModal();
        } else {
          this.openDropdown();
        }
      }
    },

    setNoResultForm: function (state){
      this.noResultForm = state;
    },

    clickDatepickerPopup: function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    },

    hide: function () {
      $document.unbind('click', documentClick);
      _.defer((function() {
        this.showsStartDate = false;
        this.dropdownOpened = false;
        this.modalOpened = false;
        if (this.$modalInstance) {
          this.$modalInstance.dismiss('cancel');
        }
        this.scope.$digest();
      }).bind(this));
    },

    /**
     * @param {Number} value
     */
    moveMonth: function (value) {
      var date;

      date = this.ctrls.first.activeDate;
      date.setMonth(date.getMonth() + value);
      this.goToDate(date);
      _.defer((function() {
        this.clearCellsCache();
      }).bind(this));
    },

    /**
     * Returns angular ui bootstrap controllers
     *
     * @returns {Object[]}
     */
    getUibCtrls: function() {
      return [this.ctrls.first, this.ctrls.second].filter(function(ctrl) {
        return !angular.isUndefined(ctrl.activeDate);
      });
    },

    /**
     * @param {Date} [date]
     */
    goToDate: function(date) {
      date = date || new Date();
      this.getUibCtrls().forEach(function (ctrl, index)
      {
        ctrl.activeDate.setFullYear(date.getFullYear(), date.getMonth() + index, 1);
        ctrl.refreshView();
      });
    },

    goToStartDate: function() {
      this.goToDate(this.range.start);
    },

    goToEndDate: function() {
      this.goToDate(this.range.end);
    },

    /**
     * Returns true if the current datepicker is for start date
     * @return {Boolean}
     */
    isForStartDate: function() {
      return this.showsStartDate;
    },

    /**
     * Returns true if the current datepicker is for end date
     * @return {Boolean}
     */
    isForEndDate: function () {
      return ! this.showsStartDate;
    },

    /**
     * Returns true if user is currently selecting departure date
     * @return {Boolean}
     */
    isDepartureDatepicker: function () {
      return this.selectingDeparture;
    },

    /**
     * Returns true if user is currently selecting return date
     * @return {Boolean}
     */
    isReturnDatepicker: function () {
      return this.selectingReturn;
    },

    /**
     * Sets the start date
     * @param {Date} date
     */
    setStartDate: function(date) {
      date.setHours(0,0,0,0);

      var minEndDate;

      if (this.minTripLength) {
        minEndDate = angular.copy(date);
        minEndDate.setDate(minEndDate.getDate() + this.minTripLength);
      } else {
        minEndDate = date;
      }

      this.clearCellsCache();
      if(this.maxDays) {
        this.maxDate = this.showsStartDate ? this.setStartTripMaxDate(): this.setEndTripMaxDate();
      }

      this.lastRange.start = angular.copy(this.range.start);
      this.range.start = date;
      this.minEndDate = minEndDate;
      this.valid();

      this.setMinRageEndDate();
      this.updateTravelPeriod();
    },
    /**
     * set end range date when minEndDate is set.
     */
    setMinRageEndDate:function(){
      if ((this.minEndDate && this.range.end) && this.minEndDate | 0 >= this.range.end) {
        this.range.end = angular.copy(this.minEndDate);
      }
    },
    /**
     * Sets the end date
     * @param {Date} date
     */
    setEndDate: function(date) {
      date.setHours(0,0,0,0);
      this.clearCellsCache();
      this.maxDate = this.showsStartDate ?  this.setStartTripMaxDate(): this.setEndTripMaxDate();

      this.lastRange.end = angular.copy(this.range.end);
      this.range.end = date;
      this.valid();
      this.updateTravelPeriod();
    },

    /**
     * Unsets the end date
     */
    unsetEndDate: function () {
      this.range.end = null;
      this.noReturnDateEntry = true;
      this.updateTravelPeriod();
    },

    /**
     * Sets datepicker to one way select mode
     */
    setOneWay: function () {
      this.roundtrip = false;
    },

    /**
     * Sets datepicker to round trip select mode
     */
    setRoundTrip: function () {
      this.roundtrip = true;
    },

    /**
     * Returns the timestamp for the start date range
     * @return {Date}
     */
    getStartTimestamp: function () {
      return !this.hoveredIsNull() && this.isForStartDate() ?  this.dateHovered : (this.range.start || today);
    },

    /**
     * Returns the timestamp for the end date range
     * @return {Date}
     */
    getEndTimestamp: function () {
      return this.hoveredIsNull() || this.isForStartDate() && this.range.end >= this.getStartTimestamp() ? this.range.end : this.dateHovered;
    },

    /**
     * Returns true if the current cell is equal to the departure date
     * @param  {Object}  dt Date cell object
     * @return {Boolean}
     */
    isEdgeStart: function (dt) {
      if (dt.secondary) {
        return false;
      }

      var boolCheck =
        this.getStartTimestamp().getDate() == dt.date.getDate() &&
        this.getStartTimestamp().getMonth() == dt.date.getMonth() &&
        this.getStartTimestamp().getFullYear() == dt.date.getFullYear();

      return boolCheck;
    },

    /**
     * Returns true if the current cell is equal to the return date
     * @param  {Object}  dt Date cell object
     * @return {Boolean}
     */
    isEdgeEnd: function (dt) {
      if (!this.roundtrip || this.getEndTimestamp() == null || dt.secondary) {
        return false;
      }

      var boolCheck =
        this.getEndTimestamp().getDate() == dt.date.getDate() &&
        this.getEndTimestamp().getMonth() == dt.date.getMonth() &&
        this.getEndTimestamp().getFullYear() == dt.date.getFullYear();

      return boolCheck;
    },

    /**
     * Returns true if cell is between departure and return date
     * @param  {[type]}  dt Date cell object
     * @return {Boolean}
     */
    isRange: function (dt) {
      if (!this.roundtrip || dt.date == null || this.getStartTimestamp() == null || this.getEndTimestamp() == null || dt.secondary) {
        return false;
      }
      return dt.date.getTime() > this.getStartTimestamp().getTime() && dt.date.getTime() < this.getEndTimestamp().getTime();
    },

    /**
     * Returns cells cache
     * @returns void
     */
    clearCellsCache: function() {
      this.cellsCache = [];
    },

    /**
     * Returns true if cells cache is empty
     * @return {Boolean}
     */
    isCacheEmpty: function() {
      return !this.cellsCache.length;
    },

    /**
     * Returns the cells cache
     * @return {Array}
     */
    getCache: function(){
      return this.cellsCache;
    },

    /**
     * @returns {{ date: Date }[]}
     */
    getCells: function() {
      var self = this;
      var cells = [];

      this.getUibCtrls().forEach(function(ctrl) {
        if (!ctrl.scope) {
          return;
        }

        ctrl.scope.rows.forEach(function(row) {
          cells = cells.concat(row);
        });
      });

      cells =  cells.filter(function(dt) {
        return !dt.secondary;
      });
      return cells;
    },

    /**
     *
     * @returns {Promise | Array}
     */
    rebuildCache: function(){
      var self = this,
          deferred = $q.defer(),
          element = this.dropdownHTMLElement;

      _.defer(function() {
        self.cellsCache = self.getCells();
      });
      var $refreshWaiter = setInterval(function() {
        var dt;

        if (self.cellsCache.length == 0) return;

        clearInterval($refreshWaiter);
        for (var i in self.cellsCache) {
          dt = self.cellsCache[i];
          dt.date.setHours(0,0,0,0);
          dt.timestamp = +dt.date;
          dt.cellElement = angular.element(element.querySelectorAll('[id="' + self.cellsCache[i].uid + '"]'));
        }
        deferred.resolve(self.cellsCache);
      }, 30);

      return deferred.promise;
    },

    /**
     * Returns true if specified  date < return date  and  date > departure date
     *
     * @param {Date} date
     * @returns {Boolean}
     */
    inRange: function (date) {
      var range = this.range;

      if (range.start && (this.dateHovered || range.end)) {
        return dateDiff(date, range.start) > 0 && dateDiff(date, (this.dateHovered || range.end)) < 0;
      }
    },

    /**
     * Returns true if specified date === departure date
     *
     * @param {Date} date
     * @returns {Boolean}
     */
    isStartDate: function (date) {
      var start = this.range.start;

      if (start) {
        return equal(start, date);
      }
      return false;
    },

    /**
     * Returns true if specified date === return date
     *
     * @param {Date} date
     * @returns {Boolean}
     */
    isEndDate: function (date) {
      var end = this.range.end;

      if (end) {
        return equal(end, date);
      }
      return false;
    },

    /**
     * Returns true if specified date is the same as hovered day
     *
     * @param {Date} date
     * @returns {Boolean}
     */
    isHovered: function (date) {
      if (this.dateHovered) {
        return equal(this.dateHovered, date);
      }
      return false;
    },

    /**
     * Marks day as hovered
     *
     * @param {Date} date
     */
    markAsHovered: function (date) {
      date.setHours(0, 0, 0, 0);
      this.dateHovered = date;
      if (!this.isForStartDate()) {
        this.updateTravelPeriod({ start: this.range.start, end: date });
      } else {
        this.updateTravelPeriod({start: date, end: this.range.end });
      }
    },

    /**
     * Reset hovered day
     */
    resetHovered: function () {
      this.dateHovered = null;
      this.updateTravelPeriod();
    },

    /**
     * Returns true if hovered day is null
     *
     * @param {Date} date
     * @returns {Boolean}
     */
    hoveredIsNull: function () {
      return this.dateHovered === null;
    },

    /**
     * start or end
     * @param date
     * @returns {Boolean|*|boolean}
     */
    isRangeBorder: function (date) {
      return this.isStartDate(date) || this.isEndDate(date) && this.hoveredIsNull() || this.isHovered(date);
    },

    /**
     * Cell range start check
     * @param  {Date}    date
     * @return {Boolean}
     */
    isRangeStart: function (date) {
      return this.isStartDate(date) || this.isDepartureDatepicker() && !this.isEndDate(date);
    },

    /**
     * Cell range end check
     * @param  {Date}    date
     * @return {Boolean}
     */
    isRangeEnd: function (date) {
      return this.roundtrip && this.isEndDate(date) && !this.isStartDate(date) || this.isReturnDatepicker() && !this.isStartDate(date);
    },

    /**
     * When  return date < departure date  set return date the same as departure date
     */
    valid: function () {
      var range = this.range;
      if (range.start != null && range.end != null && range.end < range.start) {
        this.setEndDate(angular.copy(range.start));
      }
    },

    setFirstCtrl: function(ctrl) {
      this.ctrls.first = ctrl;
    },

    setSecondCtrl: function(ctrl) {
      this.ctrls.second = ctrl;
    },

    /**
     * @param {HTMLElement} element
     */
    setStartHTMLElement: function(element) {
      this.startHTMLElement = element;
    },

    /**
     * @param {HTMLElement} element
     */
    setEndHTMLElement: function(element) {
      this.endHTMLElement = element;
    },

    /**
     * @param {HTMLElement} element
     */
    setDropdownHTMLElement: function(element) {
      this.dropdownHTMLElement = element;
      this.dropdownParentHTMLElement = findRelativeParent(this.dropdownHTMLElement);
      this.HTMLElementRendered.resolve();
    },

    removeDropdownHTMLElement: function() {
      this.dropdownHTMLElement = null;
      this.dropdownParentHTMLElement = null;
      this.HTMLElementRendered = $q.defer();
    },

    /**
     * @returns {Promise}
     */
    waitForHTMLElement: function() {
      return this.HTMLElementRendered.promise;
    },

    /**
     * Moves dropdown to specified element
     *
     * @param {HTMLElement} element
     */
    moveDropdown: function(element) {
      if (!element) {
        return;
      }

      this.waitForHTMLElement().then((function() {
        var
          viewportOffset = element.getBoundingClientRect(),
          parentOffset = this.dropdownParentHTMLElement.getBoundingClientRect();
        var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        var leftPosition = viewportOffset.left - parentOffset.left - this.dropdownHTMLElement.clientWidth/2 + element.clientWidth/2;
        var diff = width - leftPosition - this.dropdownHTMLElement.clientWidth ;
        if(diff<0){
          var newLeftPosition = leftPosition + diff;
          leftPosition =  newLeftPosition;
        }
        angular.element(this.dropdownHTMLElement).css({
          left: leftPosition + 'px',
          top: viewportOffset.top - parentOffset.top + element.clientHeight + 5 + 'px'
        });
      }).bind(this));
    },

    refreshNavVisibility: function() {
      var active = this.ctrls.first.activeDate;

      this.canGoBack = new Date(active.getFullYear(), active.getMonth(), 1) > new Date(this.minDate.getFullYear(), this.minDate.getMonth(), 1);
      this.canGoNext = new Date(active.getFullYear(), active.getMonth(), 1) < new Date(this.maxDate.getFullYear(), this.maxDate.getMonth() - 1, 1);
    },

    initDepDate: function() {
      if (this.state){
        return new Date(SearchQueryParams.getDateFromLink('dep'));
      }
      return this.initDate(SearchQueryParams.getDepDate(), this.noDepartureDateEntry);
    },

    initRetDate: function() {
      if (this.state){
        return new Date(SearchQueryParams.getDateFromLink('ret'));
      }
      return this.initDate(SearchQueryParams.getRetDate(), this.noReturnDateEntry);
    },

    /**
     * @param {Date|String} date
     * @param {Boolean} noDateEntry
     * @returns {Date}
     */
    initDate: function (date, noDateEntry) {

      var
        today,
        tempDate;

      today = new Date();
      //set 00:00, if init date will be without in format dd/mm/yyyy
      today.setHours(0);
      today.setMinutes(0);

      if (noDateEntry) {
        return today;
      }
      tempDate = new Date(date);

      //date validation
      if (isNaN(tempDate.getTime()) || tempDate < today || tempDate > this.maxDate) {
        tempDate = new Date();
        tempDate.setHours(0);
        tempDate.setMinutes(0);
        return tempDate;
      }

      tempDate = new Date(date);
      tempDate.setHours(0);
      tempDate.setMinutes(0);
      return tempDate;
    },

    /**
     * @param {Object} [range]
     * @param {Date} [range.start]
     * @param {Date} [range.end]
     */
    updateTravelPeriod: function (range) {
      range = _.extend({
        start: this.range.start,
        end: this.range.end
      }, range);

      if(typeof TripLengthServ.setTripLength(parseInt((range.end - range.start)/1000/60/60/24) + 1) != "undefined"){
        TripLengthServ.setTripLength(parseInt((range.end - range.start)/1000/60/60/24) + 1)
      }else{
        TripLengthServ.setTripLength(0);
      }
    },

    setEndFromCache: function ($event, range) {
      range = range || this.range;

      if (range.endCache > range.start) {
        range.end = range.endCache;
      }
      else {
        range.end = range.start;
      }

      this.updateTravelPeriod(range);
    },

    destroy: function () {
      for (var i = 0; i < dropdowns.length; i++) {
        if (dropdowns[i].scope.$id === this.scope.$id) {
          dropdowns.splice(i, 1);
        }
      }
    }

  };

  /**
   * @param {HTMLElement} element
   * @returns {HTMLElement}
   */
  function findRelativeParent(element) {
    var parent = element.parentElement, style;

    do {
      if (parent) {
        style = getComputedStyle(parent);

        if (style.position === 'relative' || style.position === 'absolute') {
          return parent;
        }
      }

      if (parent) {
        parent = parent.parentElement;
      }
    } while (parent);

    return document.body;
  }

  /**
   * Return true if date1 === date2
   *
   * @param {Date} date1
   * @param {Date} date2
   * @return {Boolean}
   */
  function equal(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
  }

  /**
   * Returns difference between date1 and date2 as the number of milliseconds
   *
   * @param {Date} date1
   * @param {Date} date2
   * @returns {Number}
   */
  function dateDiff(date1, date2) {
    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())).getTime() - (new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())).getTime();
  }

  RangeDatepicker.prototype.constructor = RangeDatepicker;

  return RangeDatepicker;
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/TripLengthServ.js
angular.module('base')

  /**
   * @name base.TripLengthServ
   * @description Keeps track of trip length for selected flight dates
   */
  .service('TripLengthServ', [function TripLengthServ() {
    /**
     * Number of days between departure and return dates
     * @type {Number}
     */
    var _tripLength = 0;

    /**
     * Sets a new value for trip length
     * @param {Number} newTripLength
     */
    this.setTripLength = function (newTripLength) {
      if (newTripLength < 0) {
        newTripLength = 0;
      }
      _tripLength = newTripLength;
    };

    /**
     * Returns the current trip length
     * @return {Number}
     */
    this.getTripLength = function () {
      return _tripLength;
    };

    return this;
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDatepicker.js
angular.module('base')

/**
 * @name        baseRangeDatepicker
 * @description UI BaseRangeDatepicker directive
 */
.directive('baseRangeDatepicker', ['datepickerDirective', 'appConfig', function (datepickerDirective, appConfig) {
var definition = angular.copy(datepickerDirective[0]);
  var oldLink = angular.copy(definition.link);
  var templateUrl = '/tpl/show/jsShared/templates/base/directives/datepicker/rangeDatepicker';

  var newLink = function (scope, element, attrs, ctrls) {
    var rangeDatepickerCtrl = ctrls[0],
      rangeDatepicker = scope.rangeDatepicker,
      startDate = rangeDatepicker.range.start,
      endDate = rangeDatepicker.range.end;

    scope.type = attrs.type;

    switch (attrs.type) {
      case 'second':
        rangeDatepicker.setSecondCtrl(rangeDatepickerCtrl);
        break;
      case 'first':
      case 'none':
        rangeDatepicker.setFirstCtrl(rangeDatepickerCtrl);
        break;
    }

    if (attrs.type === 'second' || attrs.type === 'none') {
      if (rangeDatepicker.isForStartDate()) {
        rangeDatepicker.goToStartDate();
      }
      else {
        rangeDatepicker.goToDate(rangeDatepicker.range.end || rangeDatepicker.range.start);
      }
    }

    scope.select = function (date) {
      if (rangeDatepicker.isForStartDate()) {
        rangeDatepicker.setStartDate(moment(date).toDate());
        scope.onSelect();

        if (rangeDatepicker.roundtrip && (scope.multiselect == 'yes' || appConfig.isTablet() || !appConfig.isMobile())) {
          rangeDatepicker.showsStartDate = false;
          rangeDatepicker.showEndDate();
          if (appConfig.isMobile() && !appConfig.isTablet()) {
            // Reset return date only on mobile after selecting departure
            rangeDatepicker.unsetEndDate();
          }
        } else {
          rangeDatepicker.hide();
        }
      }
      else {
        rangeDatepicker.setEndDate(new Date(moment(date).format('YYYY-MM-DD')));
        scope.onSelect();
        rangeDatepicker.hide();
      }
      rangeDatepicker.resetHovered();
    };

    scope.dayOnMouseOver = !appConfig.isMobile() && !appConfig.isTablet() ? function (dt) {
      rangeDatepicker.markAsHovered(new Date(moment(dt.date).format('YYYY-MM-DD')));
    } : function(){};

  };

  angular.extend(definition, {
    compile: function ($element, $attrs, linker) {
      return function ($scope, $element, $attrs, ctrl) {
        oldLink($scope, $element, $attrs, ctrl);
        newLink($scope, $element, $attrs, ctrl);
      };
    },
    templateUrl: templateUrl
  });

  angular.extend(definition.scope, {
    onSelect: '&',
    rangeDatepicker: '=',
    multiselect: '@'
  });

  return definition;
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDatepickerDropdown.js
angular.module('base')

/**
 * @name        baseRangeDatepickerDropdown
 * @description UI baseRangeDatepickerDropdown directive
 */
.directive('baseRangeDatepickerDropdown', function () {
return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      /**
       * @type {RangeDatepicker}
       */
      var rangeDatepicker = scope[attrs.baseRangeDatepickerDropdown],
        startDate = rangeDatepicker.range.start,
        endDate = rangeDatepicker.range.end;

      rangeDatepicker.setDropdownHTMLElement(element[0]);
      rangeDatepicker.updateTravelPeriod();

      rangeDatepicker.setStartDate(new Date(moment(startDate).format('YYYY-MM-DD')));
      if(endDate){
         rangeDatepicker.setEndDate(new Date(moment(endDate).format('YYYY-MM-DD')));
      }

      scope.$on('$destroy', function() {
        rangeDatepicker.removeDropdownHTMLElement();
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDatepickerEnd.js
angular.module('base')

/**
 * @name        baseRangeDatepickerEnd
 * @description UI baseRangeDatepickerEnd directive
 */
.directive('baseRangeDatepickerEnd', function () {
return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      _.defer(function()
      {
        scope[attrs.baseRangeDatepickerEnd].setEndHTMLElement(element[0]);
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDatepickerStart.js
angular.module('base')

/**
 * @name        baseRangeDatepickerStart
 * @description UI baseRangeDatepickerStart directive
 */
.directive('baseRangeDatepickerStart', function () {
return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      _.defer(function(){
        scope[attrs.baseRangeDatepickerStart].setStartHTMLElement(element[0]);
        if(attrs.setNoResultForm){
          scope[attrs.baseRangeDatepickerStart].setNoResultForm(true);
        }
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDatepickerWrapper.js
angular.module('base')

/**
 * @name        baseRangeDatepickerWrapper
 * @description UI BaseRangeDatepickerWrapper directive
 */
.directive('baseRangeDatepickerWrapper', function () {
return {
    restrict: 'EA',
    scope: {
      /**
       * @type {RangeDatepicker}
       */
      rangeDatepicker: '=',
      dateFormat: '@?',
      onSelect: '&',
      multiselect: '@'
    },
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/datepicker/rangeDatepickerWrapper';
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeDaypicker.js
angular.module('base')

/**
 * @name        baseRangeDaypicker
 * @description UI BaseRangeDaypicker directive
 */
.directive('baseRangeDaypicker', ['daypickerDirective', '$timeout', function (daypickerDirective, $timeout)
  {
var rangeDaypicker = angular.copy(daypickerDirective[0]);
    var oldLink = angular.copy(rangeDaypicker.link);

    var newLink = function (scope, element, attrs, ctrls)
    {
      var rangeDatepicker = scope.rangeDatepicker;

      var setSubTitle = function ()
      {
        var title = scope.title.split(' ');
        scope.titleMonth = title[0];
        scope.titleYear = title[1];
      };

      ctrls.scope = scope;

      _.defer(function ()
      {
        setSubTitle();
        rangeDatepicker.refreshNavVisibility();
        scope.$digest();
      });

      var _refreshViewOld = ctrls._refreshView;
      ctrls._refreshView = function ()
      {
        _refreshViewOld();
        setSubTitle();
        rangeDatepicker.refreshNavVisibility();
      };
    };

  angular.extend(rangeDaypicker, {
    compile: function ($element, $attrs, linker) {
      return function ($scope, $element, $attrs, ctrl) {
        oldLink($scope, $element, $attrs, ctrl);
        newLink($scope, $element, $attrs, ctrl);
      };
    },
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    }
  });

  return rangeDaypicker;
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/baseRangeMonthpicker.js
angular.module('base')

/**
 * @name        baseRangeMonthpicker
 * @description UI BaseRangeDaypicker directive
 */
.directive('baseRangeMonthpicker', ['CollectionGrouper', '$modal', '$timeout', 'appConfig', function (CollectionGrouper, $modal, $timeout, AppConfig) {
return {
    restrict: 'A',
    require: 'ngModel',
    replace: true,
    transclude: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    scope: {
      travelPeriod: '@',
      multiSelect: '=?',
      actual : '=?',
      checked: '=?',
      sort : '=?'
    },
    controller: ['$scope', function ($scope) {
      $scope.status = {
        isopen: false
      };
    }],

    link: function (scope, element, attrs, ngModel) {
      var monthsGrouper = new CollectionGrouper('months');
      var monthChangeDestructor;
      scope.toggleItem = function (item) {
        if (scope.multiSelect == false) {
          monthsGrouper.clearSelectedElements();
          monthsGrouper.toggleItem(item);
          ngModel.$setViewValue(item.value);
        }
        else {
          monthsGrouper.toggleItem(item);
          ngModel.$setViewValue(monthsGrouper.getSelectedElementsValues().join(','));
        }
      };

      scope.clearElements = function()
      {
        //console.log('months',monthsGrouper.getItems);
        monthsGrouper.clearSelectedElements();
      };

      scope.hasSelected = function()
      {
        return (monthsGrouper.getSelectedElementsValues().length)?false:true;
      };

      scope.allSelected = function()
      {
        return (monthsGrouper.getSelectedElementsValues().length==12)?true:false;
      };

      scope.selectAll= function()
      {
        monthsGrouper.selectAll();
        ngModel.$setViewValue(monthsGrouper.getSelectedElementsValues().join(','));
      };

      scope.isMobile = function()
      {
        return AppConfig.isTablet() || AppConfig.isMobile();
      };

      scope.getValue = function (index) {
        return monthsGrouper.getValue(index);
      };

      scope.isActive = function (item) {
        return monthsGrouper.isActive(item);
      };

      scope.getName = function (i) {
        return monthsGrouper.getName(i);
      };

      scope.getItems = function () {
        return monthsGrouper.getSortItems();
      };

      scope.isLabelEmpty = function () {
        return monthsGrouper.isLabelEmpty();
      };

      scope.getLabel = function () {
        return monthsGrouper.getLabel();
      };

      scope.reload = function () {
        monthsGrouper.setSelectedElements(ngModel.$viewValue);
        scope.$apply();
      };

      scope.showModal = function()
      {
        if ( !scope.isMobile() ) return;
        $modal.open({
          templateUrl: '/tpl/show/jsShared/templates/base/directives/datepicker/rangeMonthPickerModal',
          controller: ['$scope', '$modalInstance', 'items', 'monthsGrouper', 'model', 'multiSelect',
            function($scope, $modalInstance, items, monthsGrouper, model, multiSelect)
            {
              $scope.getItems = function()
              {
                return items;
              };

              $scope.isActive = function(item)
              {
                return monthsGrouper.isActive(item);
              };

              $scope.isMultiSelect = function()
              {
                return $scope.multiSelect;
              };

              $scope.toggleItem = function (item) {
                if ($scope.multiSelect == false) {
                  monthsGrouper.clearSelectedElements();
                  monthsGrouper.toggleItem(item);
                  model.$setViewValue(item.value);
                }
                else {
                  monthsGrouper.toggleItem(item);
                  model.$setViewValue(monthsGrouper.getSelectedElementsValues().join(','));
                }
              };

              /**
               * Hide modal
               */
              $scope.hide = function()
              {
                $modalInstance.dismiss('cancel');
              };
            }
          ],
          //windowClass: 'flight-modal-message',
          resolve: {
            items: function () {
              return scope.getItems();
            },
            monthsGrouper: function()
            {
              return monthsGrouper;
            },
            model: function()
            {
              return ngModel;
            },
            multiSelect: function()
            {
              return scope.multiSelect;
            }
          }
        });
      };

      scope.checkedAllPeriod = function ()
      {
        if (scope.checked)
        {
          for (var i = 1; i < 13; i++)
          {
            var item = {
              value: i
            };
            monthsGrouper.toggleItem(item);
          }
          ngModel.$setViewValue(monthsGrouper.getSelectedElementsValues().join(','));
        }
      };

      scope.checkedActualPeriod = function () {
        var item = {
          value: new Date().getMonth() + 1
        };
        monthsGrouper.toggleItem(item);
        ngModel.$setViewValue(item.value);
      };

      var destructor = scope.$on('monthpicker.reload', function () {
        scope.reload();
      });

      scope.$on('$destroy', function () {
        if (angular.isFunction(destructor)) {
          destructor();
        }
      });

      (function () {
        monthsGrouper.setSelectedElements(scope.travelPeriod);
        scope.checkedAllPeriod();

        if (scope.actual == true) {
          scope.checkedActualPeriod();
        }

      })();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rangeDatepicker/rangeTravelPeriod.js
angular.module('base')

/**
 * @name        rangeTravelPeriod
 * @description UI BaseRangeDaypicker directive
 */
.directive('rangeTravelPeriod', ['TripLengthServ', function (TripLengthServ) {
return {
    restrict: 'A',
    replace: true,
    template: '<span ng-show="tripLengthSrv.getTripLength() > 0">(<span ng-bind="tripLengthSrv.getTripLength()"></span> <span translate="LANGM_JS_PACKAGES_SEARCH_PANEL_TRAVEL_TIME_DAYS"></span>)</span>',
    link: function (scope) {
      scope.tripLengthSrv = TripLengthServ;
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rateBarChart/packageMonths.js
angular.module('base')

/**
 * @name        packageMonths
 * @description Package rate calendar month navigation
 */
.directive('packageMonths', ['$rootScope', function packageMonths($rootScope) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/base/directives/rateBarChart/packageMonths',
    scope: {
      onChange: '=',
      rateBars: '=',
      callback: '='
    },
    link: function (scope, elem, attrs, ctrl) {
      var select = function (month) {
        _.each(scope.rateBars, function (m) {
          m.selected = false;
        });

        $rootScope.$emit('closeDetails');
        month.selected = true;
      };

      scope.clicked = function (month) {
        if (month.selected) {
          return;
        }

        select(month);

        if(scope.callback) {
          scope.callback(month);
        }

        if (typeof scope.onChange === 'function') {
          scope.onChange(month);
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/rateBarChart/rateBars.js
angular.module('base')

/**
 * @name        rateBars
 * @description Rate months bar chart
 */
.directive('rateBars', ['$filter', 'goo.Remarketing', function rateBars($filter, Remarketing) {
var link = function (scope) {
      scope.langNoPrice = scope.langNoPrice || $filter('translate')('LANGM_JS_PACKAGES_RATE_BARS_NO_PRICE');

      scope.clicked = function (month) {
        if (month.price > 0 && angular.isFunction(scope.onClick)) {
          Remarketing.trackMonthBarClick();
          scope.onClick(month);
        }
      };
    };

    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/tpl/show/jsShared/templates/base/directives/rateBars',
      scope: {
        bars: '=',
        onClick: '=',
        langNoPrice: '@'
      },
      link: link
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/reCaptcha/reCaptcha.js
angular.module('base')

  .controller('reCaptchaCtrl', ['$scope', 'ReCaptchaSrv', function ($scope, ReCaptchaSrv)
  {
ReCaptchaSrv.load();

  }])

/**
 * @name        reCaptcha
 *
 */
  .directive('reCaptcha', [function ()
  {
return {
      restrict: 'A',
      controller: 'reCaptchaCtrl'
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/scroll/scroll.js
angular.module('base')

/**
 * @name        scroll
 * @description directive for scrolling
 */
.directive('scroll', ['$window', function ($window) {
return {
    restrict: 'A',
    link: function (scope, element, attr) {
      var fixed = false;

      angular.element($window).bind('scroll', function () {
        if (this.pageYOffset > 400) {
          if (!fixed) {
            fixed = true;

            scope.$broadcast('fixedChange', true);
          }
        }
        else {
          if (fixed) {
            fixed = false;
            scope.$broadcast('fixedChange', false);
          }
        }
      });
    }
  };
}]);;

// Source: ../shared/public_html/assets/js/base/directives/scrollTo.js
angular.module('base')

/**
 * @name        scrollTo
 * @description Make scroll to hash
 *
 * need to have destination attribute;
 * optional attribute is offset
 */
  .directive('scrollTo', ['$location', '$anchorScroll', function ($location, $anchorScroll)
  {
return {
      restrict: 'A',
      scope: false,
      controller: ['$scope','$element','$attrs',function ($scope, $element, $attrs)
      {

        $scope.formReady = true;

        var id = $attrs.destination,
            offset = $attrs.offset || 0,
            minScreenHeight = parseInt($attrs.minScreenHeight),
            screenHeight = window.innerHeight,
            enable = true;

        if(minScreenHeight){
          enable = minScreenHeight > screenHeight;
        }

        if(enable){
          $element.bind('click', function ()
          {

            if($attrs.animate) {

              console.log(offset);

              var frame = function(){
                if(document.body.scrollTop >= offsetTop){
                  clearInterval(interval);
                }
                else{
                  document.body.scrollTop = startPosition + position;
                  position += 6;
                }
              };

              var offsetTop = document.getElementById(id).offsetTop - offset,
                startPosition = document.body.scrollTop,
                position = 0,
                interval = setInterval(frame, 5);

            }
            else{
              $location.hash(id);
              if(offset){
                $anchorScroll.yOffset = parseInt(offset);
              }
              $anchorScroll();
              $location.hash('');
            }
          });
        }


        $scope.$on('$destroy', function ()
        {
          $element.unbind('click');
        });
      }]
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/auto-close-picker.directive.js
(function (angular) {
/**
     * Auto close new datepicker on outside click
     *
     * @param  {Object} $document             HTML Document
     * @param  {Object} FlightRangeDatePicker Datepicker service
     * @return {Object}                       Directive definition
     */
    var AutoClosePickerDirective = function ($document, $rootScope, FlightRangeDatePicker) {
        /**
         * Directive link function
         */
        var _directiveLink = function ($scope, $element) {
            /**
             * Tracks the mouse event timestamp
             * @type {Number}
             */
            $rootScope.lastPickerClickTimeStamp = 0;

            /**
             * Tracks where the last click / tap was made
             * @type {Boolean}
             */
            var _clickInside = false;

            /**
             * Events targeted for this behaviour
             * @type {String}
             */
            var _events = 'click touchstart';

            /**
             * Function that binds all needed events
             */
            var _bind = function () {
                $element.on(_events, _onInsideClick);
                $document.on(_events, _onOutsideClick);
            };

            /**
             * Function that unbinds all needed events
             */
            var _unbind = function () {
                $element.off(_events, _onInsideClick);
                $document.off(_events, _onOutsideClick);
                $rootScope.lastPickerClickTimeStamp = 0;
            };

            /**
             * Function triggered when clicking inside the element
             * @param {MouseEvent} e The click mouse event
             */
            var _onInsideClick = function (e) {
                $rootScope.lastPickerClickTimeStamp = e.timeStamp;
                _clickInside = true;
            };

            /**
             * Function triggered when clicking anywhere on the document
             * @param {MouseEvent} e The click mouse event
             */
            var _onOutsideClick = function (e) {
                if (!_clickInside && e.timeStamp > $rootScope.lastPickerClickTimeStamp && FlightRangeDatePicker.tooltipOpen) {
                    $scope.$evalAsync(function () {
                        FlightRangeDatePicker.closeTooltip();
                    });
                }

                _clickInside = false;
            };

            $scope.$on('$destroy', _unbind);

            $scope.$watch(
                function () {
                    return FlightRangeDatePicker.tooltipOpen;
                },
                function (newValue) {
                    if (newValue) {
                        _bind();
                    }
                    else {
                        _unbind();
                    }
                }
            );
        };

        return {
            restrict: 'A',
            link: _directiveLink
        };
    };

    AutoClosePickerDirective.$inject = [
        '$document',
        '$rootScope',
        'FlightRangeDatePicker'
    ];

    angular
        .module('base')
        .directive('autoClosePicker', AutoClosePickerDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/dates-type-switcher.component.js
(function (angular) {
var template = '\
        <div class="dates-type-switcher">\
            <div class="dates-type-switcher__inner">\
                <button \
                    type="button"\
                    class="dates-type-switcher__btn"\
                    ng-class="{ \'dates-type-switcher__btn--active\': $ctrl.datePickerInstance.isStandardMode() }"\
                    ng-click="$ctrl.datePickerInstance.setStandardMode()" \
                    translate\
                >\
                    LANGM_JS_SPECIFIC_DATES\
                </button>\
                \
                <button \
                    type="button"\
                    class="dates-type-switcher__btn"\
                    ng-class="{ \'dates-type-switcher__btn--active\': $ctrl.datePickerInstance.isFlexMode() }"\
                    ng-click="$ctrl.datePickerInstance.setFlexMode()" \
                    translate\
                >\
                    LANGM_JS_FLEXIBLE_DATES\
                </button>\
            </div>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [];

    angular
        .module('base')
        .component('datesTypeSwitcher', {
            template: template,
            controller: controller,
            bindings: {
                datePickerInstance: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-day-picker.component.js
(function (angular) {
var template = '\
        <div class="flexible-dates-day-picker">\
            <div class="flexible-dates-day-picker__controls">\
                <button \
                    type="button"\
                    class="flexible-dates-day-picker__btn"\
                    ng-click="$ctrl.onDecrease()"\
                    ng-disabled="$ctrl.isDecreaseDisabled" \
                >\
                    <svg-icon id="minus"></svg-icon>\
                </button>\
                \
                <span class="flexible-dates-day-picker__days-amount">\
                    {{ $ctrl.daysAmount }}\
                </span>\
                \
                <button \
                    type="button"\
                    class="flexible-dates-day-picker__btn"\
                    ng-click="$ctrl.onIncrease()"\
                    ng-disabled="$ctrl.isIncreaseDisabled" \
                >\
                    <svg-icon id="plus"></svg-icon>\
                </button>\
            </div>\
            \
            <p class="flexible-dates-day-picker__label">\
                {{ $ctrl.text }}\
            </p>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('base')
        .component('flexibleDatesDayPicker', {
            template: template,
            controller: controller,
            bindings: {
                text: '@',
                daysAmount: '<',
                isDecreaseDisabled: '<',
                isIncreaseDisabled: '<',
                onIncrease: '&',
                onDecrease: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-days-picker.component.js
(function (angular) {
var template = '\
        <div class="flexible-dates-days-picker">\
            <p \
                class="flexible-dates-days-picker__description"\
                translate\
            >\
                LANGM_JS_FLEXIBLE_DATES_DAYS_DESC\
            </p>\
            <div class="flexible-dates-days-picker__days-container">\
                <flexible-dates-day-picker\
                    days-amount="$ctrl.datePickerInstance.flexDaysFromAmount" \
                    text="{{ \'LANGM_JS_FLEXIBLE_DATES_FROM\' | translate }}" \
                    is-decrease-disabled="!$ctrl.canDecreaseDaysFrom()" \
                    is-increase-disabled="!$ctrl.canIncreaseDaysFrom()" \
                    on-increase="$ctrl.increaseFromClickHandler()" \
                    on-decrease="$ctrl.decreaseFromClickHandler()" \
                ></flexible-dates-day-picker>\
                <flexible-dates-day-picker\
                    days-amount="$ctrl.datePickerInstance.flexDaysToAmount" \
                    text="{{ \'LANGM_JS_FLEXIBLE_DATES_TO\' | translate }}" \
                    is-decrease-disabled="!$ctrl.canDecreaseDaysTo()" \
                    is-increase-disabled="!$ctrl.canIncreaseDaysTo()" \
                    on-increase="$ctrl.increaseToClickHandler()" \
                    on-decrease="$ctrl.decreaseToClickHandler()" \
                ></flexible-dates-day-picker>\
            </div>\
        </div>\
    ';

    var controller = function ($scope) {
        var ctrl = this;
        var dp = this.datePickerInstance;

        this.canDecreaseDaysFrom = function () {
            return dp.flexDaysFromAmount > 1;
        };

        this.canIncreaseDaysFrom = function () {
            return dp.flexDaysFromAmount < dp.flexDaysToAmount;
        };

        this.canDecreaseDaysTo = function () {
            return dp.flexDaysToAmount > dp.flexDaysFromAmount;
        };

        this.canIncreaseDaysTo = function () {
            return dp.flexDaysToAmount < 31;
        };

        this.increaseFromClickHandler = function () {
            if (ctrl.canIncreaseDaysFrom()) {
                dp.flexDaysFromAmount++;
                $scope.$emit('flex-days-amount-changed');
            }
        };

        this.decreaseFromClickHandler = function () {
            if (ctrl.canDecreaseDaysFrom()) {
                dp.flexDaysFromAmount--;
                $scope.$emit('flex-days-amount-changed');
            }
        };

        this.increaseToClickHandler = function () {
            if (ctrl.canIncreaseDaysTo()) {
                dp.flexDaysToAmount++;
                $scope.$emit('flex-days-amount-changed');
            }
        };

        this.decreaseToClickHandler = function () {
            if (ctrl.canDecreaseDaysTo()) {
                dp.flexDaysToAmount--;
                $scope.$emit('flex-days-amount-changed');
            }
        };
    };

    controller.$inject = [
        '$scope'
    ];

    angular
        .module('base')
        .component('flexibleDatesDaysPicker', {
            template: template,
            controller: controller,
            bindings: {
                datePickerInstance: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-footer-mobile.component.js
(function (angular) {
var template = '\
        <div class="flexible-dates-footer-mobile container footer-calendar">\
            <ng-transclude></ng-transclude>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('base')
        .component('flexibleDatesFooterMobile', {
            template: template,
            controller: controller,
            transclude: true,
            bindings: {

            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-info.component.js
(function (angular) {
var template = '\
        <p class="flexible-dates-info">\
            <span translate>LANGM_JS_TRAVEL_IN</span>\
            <span \
                ng-if="!$ctrl.datePickerInstance.isFlexDateSelected()" \
                class="flexible-dates-info__select-months"\
                translate\
            >\
                LANGM_JS_SELECT_MONTHS\
            </span>\
            <b ng-if="$ctrl.datePickerInstance.isFlexDateSelected()">\
                <span>{{ $ctrl.datePickerInstance.flexDepartureDate | moment:\'MMM\' }}</span>\
                <span ng-if="$ctrl.datePickerInstance.flexReturnDate"> - {{$ctrl.datePickerInstance.flexReturnDate | moment:\'MMM\' }}</span>\
            </b>\
            <span ng-if="!$ctrl.datePickerInstance.oneWay">\
                <span translate>LANGM_JS_TRAVEL_FOR</span>\
                <b>\
                    <span>{{ $ctrl.datePickerInstance.flexDaysFromAmount }}-{{ $ctrl.datePickerInstance.flexDaysToAmount }}</span>\
                    <span translate>LANGM_JS_FLEXIBLE_DATES_DAYS</span>\
                </b>\
            </span>\
        </p>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('base')
        .component('flexibleDatesInfo', {
            template: template,
            controller: controller,
            bindings: {
                datePickerInstance: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-picker-item.component.js
(function (angular) {
var template = '\
        <div \
            class="flexible-dates-picker-item"\
            ng-class="{\
                \'flexible-dates-picker-item--start\': $ctrl.indicateStartSelected,\
                \'flexible-dates-picker-item--end\': $ctrl.indicateEndSelected,\
                \'flexible-dates-picker-item--in-range\': $ctrl.indicateInRange,\
                \'flexible-dates-picker-item--show-arrows\': $ctrl.showArrows,\
                \'flexible-dates-picker-item--same-month\': $ctrl.indicateSameMonthSelected\
            }"\
        >\
            <span class="flexible-dates-picker-item__year">{{ $ctrl.year }}</span>\
            <span class="flexible-dates-picker-item__month">{{ $ctrl.month }}</span>\
            <span \
                class="flexible-dates-picker-item__price"\
                ng-class="{ \'flexible-dates-picker-item__price--highlighted\': $ctrl.indicateLowestPrice }"\
            >\
                <span ng-if="$ctrl.price">\
                    <span>~</span>\
                    <span>{{ $ctrl.price }}</span>\
                </span>\
                <span ng-if="!$ctrl.price">...</span>\
            </span>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('base')
        .component('flexibleDatesPickerItem', {
            template: template,
            controller: controller,
            bindings: {
                year: '<',
                month: '<',
                price: '<',
                indicateStartSelected: '<',
                indicateEndSelected: '<',
                indicateInRange: '<',
                showArrows: '<',
                indicateLowestPrice: '<',
                indicateSameMonthSelected: '<',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flex/flexible-dates-picker.component.js
(function (angular) {
var template = '\
        <div class="flexible-dates-picker">\
        \
        <flexible-dates-info date-picker-instance="$ctrl.datePickerInstance"></flexible-dates-info>\
        \
           <div class="flexible-dates-picker__months-holder">\
               <flexible-dates-picker-item \
                    ng-repeat="cell in $ctrl.cells"\
                    year="cell.year" \
                    month="cell.month" \
                    price="cell.price" \
                    indicate-lowest-price="cell.isLowestPrice"\
                    indicate-start-selected="$ctrl.indicateStartSelected(cell.id)"\
                    indicate-end-selected="$ctrl.indicateEndSelected(cell.id)"\
                    indicate-in-range="$ctrl.isInRange(cell.id)" \
                    indicate-same-month-selected="$ctrl.indicateSameMonthSelected(cell.id)"\
                    show-arrows="$ctrl.showArrows()" \
                    ng-click="$ctrl.cellClickHandler($index)" \
               ></flexible-dates-picker-item>\
           </div>\
           \
           <flexible-dates-days-picker \
                ng-if="!$ctrl.datePickerInstance.oneWay"\
                date-picker-instance="$ctrl.datePickerInstance"\
            ></flexible-dates-days-picker>\
        </div>\
    ';

    var controller = function ($translate, $http, $scope, appConfig, PriceFormatterService) {
        var ctrl = this;

        this.monthNames = [
            $translate.instant('LANGM_JS_JANUARY'),
            $translate.instant('LANGM_JS_FEBRUARY'),
            $translate.instant('LANGM_JS_MARCH'),
            $translate.instant('LANGM_JS_APRIL'),
            $translate.instant('LANGM_JS_MAY'),
            $translate.instant('LANGM_JS_JUNE'),
            $translate.instant('LANGM_JS_JULY'),
            $translate.instant('LANGM_JS_AUGUST'),
            $translate.instant('LANGM_JS_SEPTEMBER'),
            $translate.instant('LANGM_JS_OCTOBER'),
            $translate.instant('LANGM_JS_NOVEMBER'),
            $translate.instant('LANGM_JS_DECEMBER'),];

        this.cells = [];

        var dp = this.datePickerInstance;

        function getId(date) {
            if (!date) {
                return null;
            }

            return moment(date).format('YYYY-MM');
        }

        this.buildCellsWithDates = function () {
            var now = new Date();

            for (var i = 0; i < 12; i++) {
                var future = new Date(now.getFullYear(), now.getMonth() + i, i === 0 ? now.getDate() : 1);
                var month = ctrl.monthNames[future.getMonth()];
                var year = future.getFullYear();

                ctrl.cells.push({
                    month: month,
                    year: year,
                    startDateOfMonth: future,
                    endDateOfMonth: new Date(year, future.getMonth() + 1, 0),
                    id: getId(future)
                });
            }
        };

        this.indicateStartSelected = function (cellId) {
            return getId(dp.flexDepartureDate) === cellId;
        };

        this.indicateEndSelected = function (cellId) {
            return getId(dp.flexReturnDate) === cellId;
        };

        this.indicateSameMonthSelected = function (cellId) {
            return getId(dp.flexDepartureDate) === cellId && getId(dp.flexReturnDate) === cellId;
        };

        this.showArrows = function () {
            return this.isEndSelected() && this.isStartSelected() && (getId(dp.flexDepartureDate) !== getId(dp.flexReturnDate));
        };

        this.isInRange = function (cellId) {
            return cellId > getId(dp.flexDepartureDate) && cellId < getId(dp.flexReturnDate);
        };

        this.isStartSelected = function () {
            return dp.flexDepartureDate;
        };

        this.isEndSelected = function () {
            return dp.flexReturnDate;
        };

        this.cellClickHandler = function (elIndex) {
            $scope.$emit('flex-calendar-cell-clicked');

            if (!ctrl.isStartSelected()) {
                dp.flexDepartureDate = ctrl.cells[elIndex].startDateOfMonth;
                dp.departureDate = null;

                return;
            }

            if (ctrl.isStartSelected() && !ctrl.isEndSelected()) {
                var startCell = ctrl.cells.find(function (cell) {
                    return cell.id === getId(dp.flexDepartureDate);
                });

                if (ctrl.cells[elIndex].id < startCell.id) {
                    dp.flexReturnDate = startCell.endDateOfMonth;
                    dp.flexDepartureDate = ctrl.cells[elIndex].startDateOfMonth;
                } else {
                    dp.flexReturnDate = ctrl.cells[elIndex].endDateOfMonth;
                }

                return;
            }


            if (ctrl.isStartSelected() && ctrl.isEndSelected()) {
                dp.flexDepartureDate = ctrl.cells[elIndex].startDateOfMonth;
                dp.flexReturnDate = null;
            }
        };

        this.buildLocations = function (locations) {
            var result = '';

            locations
                .sort(function (a, b) {
                    return a.type - b.type;
                })
                .forEach(function (location) {
                    if (location.isAirport()) {
                        result += (result ? ',' : '') + 'airport:' + location.airportCode;
                    }
                    if (location.isCity()) {
                        result += (result ? ',' : '') + 'city:' + location.cityCode;
                    }
                    if (location.isCountry()) {
                        result += (result ? ',' : '') + 'country:' + location.countryCode;
                    }
                });

            return result;
        };

        this.buildUrl = function () {
            var baseUrl = appConfig.getShelfConfig().api;
            var prefix = baseUrl.match('https:') ? '' : 'https:';
            var url = new URL(prefix + baseUrl + '/statistics');

            url.searchParams.set('origins', this.buildLocations(this.locationsFrom));
            url.searchParams.set('destinations', this.buildLocations(this.locationsTo));
            url.searchParams.set('tripType', 'ROUND_TRIP');

            return url.href;
        };

        this.getPrices = function () {
            return $http({
                method: 'GET',
                url: this.buildUrl(),
                headers: {
                    'Accept': 'application/json',
                    'slot': appConfig.getAbConfig().ibe_slot_version
                }
            });
        };

        this.parseResponse = function (response) {
            var currency = response.data.currencyUnit;
            var parsedCells = response.data.statistics.map(function (cell) {
                return {
                    id: cell.month,
                    priceFormatted: PriceFormatterService.formatPrice(
                        Math.round(cell.price.median),
                        currency
                    ),
                    price: cell.price.median
                };
            });

            var allPrices = parsedCells.map(function (cell) {
                return cell.price;
            });

            parsedCells.forEach(function (cell) {
                cell.isLowestPrice = cell.price === Math.min.apply(null, allPrices);
            });

            return parsedCells;
        };

        this.setPrices = function (parsedCells) {
            ctrl.cells.forEach(function (cell) {
                var newCell = parsedCells.find(function (c) {
                    return c.id === cell.id;
                });

                if (newCell) {
                    cell.price = newCell.priceFormatted;
                    cell.isLowestPrice = newCell.isLowestPrice;
                } else {
                    cell.price = null;
                    cell.isLowestPrice = false;
                }
            });
        };

        this.applyPriceMatrix = function () {
            if (!ctrl.locationsFrom.length || !ctrl.locationsTo.length) {
                return;
            }

            ctrl
                .getPrices()
                .then(function (response) {
                    ctrl.setPrices(ctrl.parseResponse(response));
                });
        };

        this.$onInit = function () {
            this.buildCellsWithDates();
            this.applyPriceMatrix();
        };

        $scope.$on('flex-days-amount-changed', function () {
            // do nothing
        });
    };

    controller.$inject = [
        '$translate',
        '$http',
        '$scope',
        'appConfig',
        'PriceFormatterService'
    ];

    angular
        .module('base')
        .component('flexibleDatesPicker', {
            template: template,
            controller: controller,
            bindings: {
                locationsFrom: '<',
                locationsTo: '<',
                datePickerInstance: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flight-range-date-picker.model.js
(function (angular) {
var sendRetEvent = true;

    /**
     * @name        FlightRangeDatePicker
     * @description Service that keeps track of all settings related to date selection in the flight search form.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var FlightRangeDatePickerService = function ($timeout, SearchQueryParams, AppConfig, TripLengthHelper) {
        /**
         * Decides if datepicker tooltip is open or not
         *
         * @type {Boolean}
         */
        this.tooltipOpen = false;

        /**
         * Flight departure date
         *
         * @type {Date}
         */
        this.departureDate = null;

        /**
         * Flight return date
         *
         * @type {Date}
         */
        this.returnDate = null;

        /**
         * Datepicker minimum date
         *
         * @type {Date}
         */
        this.minDate = null;

        /**
         * Datepicker maximum date
         *
         * @type {Date}
         */
        this.maxDate = null;

        /**
         * One way date selection
         *
         * @type {Boolean}
         */
        this.oneWay = false;

        /**
         * Available modes for the datepicker
         *
         * @type {Object}
         */
        this.modes = {
            DATEPICKER_MODE: 'datepicker',
            FAREPICKER_MODE: 'farepicker'
        };

        /**
         * Available selecting modes for date picker (departure and return)
         *
         * @type {Object}
         */
        this.selectModes = {
            DEPARTURE: 'dep',
            RETURN: 'ret'
        };

        /**
         * Active picker mode
         *
         * @type {String}
         */
        this.mode = this.modes.FAREPICKER_MODE;

        /**
         * Switch for departure select or return select
         *
         * @type {String}
         */
        this.selecting = this.selectModes.DEPARTURE;

        /**
         * Property that shows if data was modified by user
         *
         * @type {Boolean}
         */
        this.dirty = false;

        this.dateMode = 'standard';
        this.flexDepartureDate = null;
        this.flexReturnDate = null;
        this.FLEX_DAYS_FROM_DEFAULT = 3;
        this.FLEX_DAYS_TO_DEFAULT = 10;
        this.flexDaysFromAmount = this.FLEX_DAYS_FROM_DEFAULT;
        this.flexDaysToAmount = this.FLEX_DAYS_TO_DEFAULT;

        this.setFlexMode = function () {
            this.dateMode = 'flex';
            this.selecting = this.selectModes.DEPARTURE;
        };

        this.setStandardMode = function () {
            this.dateMode = 'standard';

            if (this.oneWay || !this.departureDate) {
                this.selecting = this.selectModes.DEPARTURE;

                return;
            }

            if (!this.oneWay && this.departureDate && !this.returnDate) {
                this.selecting = this.selectModes.RETURN;

                return;
            }

            if (!this.oneWay && this.departureDate && this.returnDate) {
                this.selecting = this.selectModes.DEPARTURE;
            }
        };

        this.isFlexMode = function () {
            return this.dateMode === 'flex';
        };

        this.isStandardMode = function () {
            return this.dateMode === 'standard';
        };

        this.resetFlexDates = function () {
            this.flexDepartureDate = null;
            this.flexReturnDate = null;
        };

        this.isFlexDateSelected = function () {
            return !!this.flexDepartureDate;
        };

        this.isStandardDateSelected = function () {
            return !!this.departureDate;
        };

        /**
         * Method called on initialisation
         */
        this.init = function () {
            if ((AppConfig.isTablet() || !AppConfig.isMobile()) && !AppConfig.isSearchResultPage() && AppConfig.isFirstEntry() && SearchQueryParams.getBaseSearchUrl() === '') {
                // No dates in search panel for first time users (not applying to mobile)
                this.departureDate = null;
                this.returnDate = null;
            } else {
                // Set dep / ret dates
                this.departureDate = (AppConfig.isSearchResultPage()) ? new Date(SearchQueryParams.getDateFromLink('dep')) : null;
                this.returnDate = SearchQueryParams.isOneWay() ? null : (AppConfig.isSearchResultPage()) ? new Date(SearchQueryParams.getDateFromLink('ret')) : null;
            }

            // Set min / max dates
            this.minDate = new Date(AppConfig.getMinDate());
            this.maxDate = new Date(AppConfig.getMaxDate());
            this.dirty = false;
        };

        /**
         * Toggles the departure visibility on desktop
         */
        this.toggleDeparture = function () {
            this.selecting = this.selectModes.DEPARTURE;
            this.tooltipOpen = true;
            sendRetEvent = true;
        };

        /**
         * Toggles the return datepicker visibility on desktop
         */
        this.toggleReturn = function () {
            this.selecting = this.selectModes.RETURN;
            this.oneWay = false;
            this.tooltipOpen = true;
            sendRetEvent = false;

            if (typeof newrelic !== 'undefined') {
                var interaction = newrelic.interaction().setName('SearchPanelUsedDateRet')
                    .setAttribute('frontApp', 'Angular')
                    .setAttribute('group', 'SearchActions');
                interaction.save();
                interaction.end();
            }
        };

        /**
         * Closes the picker tooltip on desktop
         */
        this.closeTooltip = function () {
            this.tooltipOpen = false;
        };

        /**
         * Method triggered after selecting departure date from calendar
         * It selts return date to null to assume a one way search.
         */
        this.afterDepartureSelect = function () {
            var self = this;

            this.dirty = true;
            this.returnDate = null;

            if (this.isOneWay()) {
                $timeout(function () {
                    // Hide tooltip with delay to allow updates in calendar before closing
                    self.tooltipOpen = false;
                });
            } else {
                this.tooltipOpen = true;
                this.selecting = this.selectModes.RETURN;
            }
        };

        /**
         * Method triggered after selecting return date from calendar
         * It sets date selection to round trip and closes the tooltip on desktop
         */
        this.afterReturnSelect = function () {
            var self = this;
            this.oneWay = false;

            if (typeof newrelic !== 'undefined' && sendRetEvent === true) {
                var interaction = newrelic.interaction()
                    .setName('SearchPanelUsedDateRetFromDep')
                    .setAttribute('frontApp', 'Angular')
                    .setAttribute('group', 'SearchActions');
                interaction.save();
                interaction.end();
            }

            $timeout(function () {
                // Close tooltip with a bit of delay
                self.tooltipOpen = false;
                self.selecting = self.selectModes.DEPARTURE;
            });
        };

        /**
         * Method triggered after selection from a multiple selection calendar
         */
        this.multipleAfterSelect = function () {
            var self = this;
            $timeout(function () {
                if (self.departureDate !== null && self.returnDate !== null) {
                    self.oneWay = false;
                }
            });
        };

        /**
         * Resets return date and sets the flight to one way
         */
        this.makeOneWay = function () {
            this.returnDate = null;
            this.oneWay = true;
            this.minDate = new Date();

            if (this.tooltipOpen && this.selecting === this.selectModes.RETURN) {
                this.closeTooltip();
            }
        };

        /**
         * Sets the flight to one way
         */
        this.makeRoundTrip = function () {
            this.oneWay = false;
        };

        /**
         * Checks if date selection is one way
         *
         * @returns {Boolean}
         */
        this.isOneWay = function () {
            return this.oneWay;
        };

        /**
         * Resets both dates
         *
         * @returns {Void}
         */
        this.resetDates = function () {
            this.departureDate = null;
            this.returnDate = null;
        };

        /**
         * Returns number of days between two dates
         *
         * @return {Number}
         */
        this.getTripLength = function () {
            if (this.isOneWay()) {
                return false;
            }
            return TripLengthHelper.getLength(this.departureDate, this.returnDate);
        };

        // Call init
        this.init();

        return this;
    };

    FlightRangeDatePickerService.$inject = [
        '$timeout',
        'sch.SearchQueryParams',
        'appConfig',
        'TripLengthHelper'
    ];

    angular
        .module('base')
        .service('FlightRangeDatePicker', FlightRangeDatePickerService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flights-date-picker.component.js
(function(angular) {
/**
   * @name        FlightsDatePickerComponent
   * @description Renders a datepicker tooltip in the search panel.
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var FlightsDatePickerConfig = {
    bindings: {
      departurePlace: '<',
      destinationPlace: '<'
    },
    controller: 'IthFlightsDatePickerController',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsDatePicker'
  };

  angular
    .module('base')
    .component('flightsDatePicker', FlightsDatePickerConfig);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flights-date-picker.controller.js
(function(angular) {
/**
   * @name        FlightsDatePickerController
   * @description Controller for the search panel datepicker tooltip.
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var FlightsDatePickerController = function (FlightRangeDatePicker) {
    /**
     * Range datepicker reference
     *
     * @type {FlightRangeDatePicker}
     */
    this.newDatePicker = FlightRangeDatePicker;

    /**
     * Total price for price calendar
     *
     * @type {Number}
     */
    this.totalPrice = 0;

    /**
     * Trip length updated by calendar
     *
     * @type {Number}
     */
    this.tripLength = 0;

    /**
     * Multiple interaction type in the calendars
     *
     * @type {Boolean}
     */
    this.multiple = false;
  };

  FlightsDatePickerController.$inject = [
    'FlightRangeDatePicker'
  ];

  angular
    .module('base')
    .controller('IthFlightsDatePickerController', FlightsDatePickerController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flights-form-focusable.component.js
(function (angular) {

    angular
        .module('base')
        .component('ithFlightsFormFocusable', {
            transclude: true,
            bindings: {
                label: '@',
                isFocused: '<'
            },
            template: '\
                <div class="flights-form-focusable" ng-class="{ \'flights-form-focusable--focused\': $ctrl.isFocused }">\
                    <label class="flights-form-focusable__label">{{ :: $ctrl.label }}</label>\
                    <span></span>\
                </div>\
            ',
            controller: ['$element', '$transclude', '$compile', function ($element, $transclude, $compile) {
                $transclude(function (clone, scope) {
                    $element.find('span').replaceWith($compile(clone)(scope));
                });
            }]
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flights-form.controller.js
(function (angular, history, moment) {
/**
     * @name        IthFlightsFormController
     * @description Handles the search form.
     * @constructor
     */
    var IthFlightsFormController = function (
        $rootScope,
        $scope,
        $location,
        $sessionStorage,
        $modal,
        SearchQueryParams,
        AppConfig,
        $filter,
        $timeout,
        FlightPaxModel,
        FlightRangeDatePicker,
        IthSearchFormTrigger,
        CityHelperHandler,
        CITY_HELPER,
        ModalHelper,
        LocationHistory,
        SearchHistory,
        CityHelperLocation,
        CthUtils,
        MobileDismissableModal,
        BookingComLinkGenerator
    ) {
        /**
         * Lexical scope handler
         *
         * @type {IthFlightsFormController}
         */
        var ctrl = this;

        /**
         * @param {{code: string, type: 'a' | 'c'}[]} [locations]
         * @returns {CityHelperLocation[] | []}
         */
        var parseLocations = function (locations) {
            return locations.map(function (loc) {
                var instance = new CityHelperLocation({
                    type: loc.type
                });
                instance.setCodeByType(loc.code);

                return instance;
            });
        };

        var parseHistoryLocation = function (cities, airports, countries) {
            var values = [];

            cities.split(',').forEach(function (loc) {
                if (loc === '') return;

                values.push(new CityHelperLocation({
                    cityCode: loc,
                    type: 'c'
                }));
            });

            airports.split(',').map(function (loc) {
                if (loc === '') return;

                values.push(new CityHelperLocation({
                    airportCode: loc,
                    type: 'a'
                }));
            });

            if (countries && AppConfig.getNextGenSearchAbTest()) {
                countries.split(',').forEach(function (loc) {
                    if (loc === '') return;

                    values.push(new CityHelperLocation({
                        countryCode: loc,
                        type: 'country'
                    }));
                });
            }

            return values;
        };

        var searchHistory = SearchHistory.get();

        var fromLocations = ($scope.from[0].code !== '' && $scope.from[0].code !== null && $scope.from[0].code !== undefined)
            ? parseLocations($scope.from)
            : parseHistoryLocation(searchHistory.fromCities, searchHistory.fromAirports);

        var toLocations = ($scope.to[0].code !== '' && $scope.to[0].code !== null && $scope.to[0].code !== undefined)
            ? parseLocations($scope.to)
            : parseHistoryLocation(searchHistory.toCities, searchHistory.toAirports, searchHistory.toCountries);

        FlightPaxModel.model.group.adults.count = searchHistory.adults;
        FlightPaxModel.model.group.children.count = searchHistory.children;
        FlightPaxModel.model.group.youths.count = searchHistory.youths;
        FlightPaxModel.model.group.infants.count = searchHistory.infants;

        /**
         * css selectors (used in template)
         */
        this.directionHolderFromId = CITY_HELPER.DIRECTION_HOLDER_ID_FROM;
        this.directionHolderToId = CITY_HELPER.DIRECTION_HOLDER_ID_TO;
        this.directionInnerFromId = CITY_HELPER.DIRECTION_INNER_ID_FROM;
        this.directionInnerToId = CITY_HELPER.DIRECTION_INNER_ID_TO;

        this.errorModalInstance = null;

        /**
         * Flights city helper instance
         *
         * @type {CityHelperHandler}
         */
        this.cityHelperFrom = new CityHelperHandler(
            fromLocations,
            CITY_HELPER.FLIGHT_TYPE_FROM
        );

        /**
         * Flights city helper instance
         *
         * @type {CityHelperHandler}
         */
        this.cityHelperTo = new CityHelperHandler(
            toLocations,
            CITY_HELPER.FLIGHT_TYPE_TO
        );

        if (AppConfig.getNextGenSearchAbTest()) {
            this.cityHelperTo.setAllowCountries();
        }

        /**
         * Deduplicate flights from IBE
         *
         * @type {Boolean}
         */
        this.searchDeduplicatedFlights = SearchQueryParams.getSearchDeduplicatedFlights();

        /**
         * Range datepicker instance
         *
         * @type {FlightRangeDatePicker}
         */
        this.newDatePicker = FlightRangeDatePicker;
        this.newDatePicker.init();

        if (this.defaultDateStart !== undefined) {
            this.newDatePicker.departureDate = this.defaultDateStart;
        }

        var areSearchHistoryDatesInThePast = (
            moment(searchHistory.departureDate).isBefore(moment(), 'day') ||
            moment(searchHistory.returnDate).isBefore(moment(), 'day')
        );

        if (searchHistory.departureDate !== null && !areSearchHistoryDatesInThePast) {
            this.newDatePicker.departureDate = new Date(searchHistory.departureDate);
        }

        if (this.defaultDateEnd !== undefined) {
            this.newDatePicker.returnDate = this.defaultDateEnd;
        }

        if (searchHistory.returnDate !== null && !areSearchHistoryDatesInThePast) {
            this.newDatePicker.returnDate = new Date(searchHistory.returnDate);
        }

        if (searchHistory.oneWay) {
            this.newDatePicker.makeOneWay();
        }

        // if the last search was flex
        if (searchHistory.isFlex && AppConfig.getNextGenSearchAbTest()) {
            this.newDatePicker.setFlexMode();
            this.newDatePicker.resetDates();
            this.newDatePicker.flexDaysFromAmount = searchHistory.flexDaysFrom || this.newDatePicker.FLEX_DAYS_FROM_DEFAULT;
            this.newDatePicker.flexDaysToAmount = searchHistory.flexDaysTo || this.newDatePicker.FLEX_DAYS_TO_DEFAULT;
            this.newDatePicker.flexDepartureDate = searchHistory.departureDate;
            this.newDatePicker.flexReturnDate = searchHistory.returnDate;
        }

        /**
         * Open errors modal
         */
        var openErrorsModal = function () {
            if (ctrl.errorModalInstance !== null) {
                ctrl.errorModalInstance.close();
            }

            if (typeof dataLayer != 'undefined') {
                dataLayer.push({'event': 'flightValidation'});
            }

            ctrl.errorModalInstance = $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsFormErrors',
                controller: 'flightsFormErrorsModalCtrl',
                windowClass: 'flight-modal-message',
                resolve: {
                    errors: function () {
                        return ctrl.errors;
                    }
                }
            });

            ctrl.errorModalInstance.result.finally(function () {
                ctrl.errorModalInstance = null;
            });
        };

        /**
         * Clear array of errors
         */
        var resetErrors = function () {
            angular.forEach(ctrl.errors, function (value, key) {
                ctrl.errors[key] = false;
            });
        };

        /**
         * Object holding error messages
         *
         * @type {Object}
         */
        this.errorMessages = {
            cityInvalid: $filter('translate')('LANGM_JS_CHOOSE_CITIES'),
            depTheSameAsArr: $filter('translate')('LANGM_JS_CITIES_CAN_NOT_BE_IDENTICAL'),
            dateDepartureInvalid: $filter('translate')('LANGM_JS_CHOOSE_DATE_DEPARTURE'),
            dateReturnInvalid: $filter('translate')('LANGM_JS_CHOOSE_DATE_RETURN'),
            locationLimitExceeded: $filter('translate')('LANGM_JS_LOCATIONS_LIMIT_EXCEEDED'),
            locationsEmpty: $filter('translate')('LANGM_JS_LOCATIONS_EMPTY')
        };

        /**
         * Object holding errors
         *
         * @type {Object}
         */
        this.errors = {
            custom: false
        };

        /**
         * Switch for departure city helper on mobile
         *
         * @type {Boolean}
         */
        this.mobileDepChOpen = false;

        /**
         * Switch for return city helper on mobile
         *
         * @type {Boolean}
         */
        this.mobileRetChOpen = false;

        var cityHelperFromCache = [];
        var cityHelperToCache = [];

        var unregisterMobileCityHelperLocationChange = null;

        // booking.com search
        this.isSearchBookingComFeatureEnabled = AppConfig.getIsBookingComSearchEnabled() && $location.path() === '/';
        this.searchBookingComModel = this.isSearchBookingComFeatureEnabled;

        /**
         * Opens the mobile city helper modal
         *
         * @param  {String} route One of 'dep' or 'ret'
         */
        this.openMobileCityHelper = function (route) {
            cityHelperFromCache = this.cityHelperFrom.locations.map(function (location) {
                return location;
            });

            cityHelperToCache = this.cityHelperTo.locations.map(function (location) {
                return location;
            });

            var inputElement = document.getElementById('cityHelperInput-' + route);

            this.mobileDepChOpen = route === 'dep' ? true : false;
            this.mobileRetChOpen = !this.mobileDepChOpen;
            inputElement.focus();
            ModalHelper.lockBodyScroll();
            $location.hash('city-helper');

            $timeout(function () {
                unregisterMobileCityHelperLocationChange = $rootScope.$on('$locationChangeStart', function () {
                    ctrl.closeMobileCityHelper('cancel');
                    inputElement.blur();
                });
            });
        };

        /**
         * Closes the mobile city helper modal
         */
        this.closeMobileCityHelper = function (type) {
            if (type === 'cancel') {
                this.cityHelperFrom.locations = cityHelperFromCache;
                this.cityHelperTo.locations = cityHelperToCache;
            }

            this.mobileDepChOpen = false;
            this.mobileRetChOpen = false;
            ModalHelper.unlockBodyScroll();
            unregisterMobileCityHelperLocationChange();

            if ($location.hash() === 'city-helper') {
                history.back();
            } else {
                $location.hash('');
            }
        };

        /**
         * Method called from city helper modal component on selection
         *
         * @param {Object} loc City helper item loc
         * @param {String} flightType One of 'dep' or 'ret'
         */
        this.selectLocation = function (loc, flightType) {
            var cityHelper = (flightType === CITY_HELPER.FLIGHT_TYPE_FROM) ? this.cityHelperFrom : this.cityHelperTo;
            var postLocPresenceHandler = function () {
                if (!loc.isAirport() || cityHelper.isAirportTheOnlyOne()) {
                    cityHelper.emptyInputValue();
                    cityHelper.search();
                }
            };

            if (cityHelper.isLocationPresent(loc)) {
                cityHelper.removeLocation(loc);
                postLocPresenceHandler();

                return;
            }

            if (this.isFreeSpaceAvailable(cityHelper.locations)) {
                cityHelper.addLocation(loc);
                postLocPresenceHandler();
            } else {
                this.errors.custom = this.errorMessages.locationLimitExceeded;
                openErrorsModal();
            }
        };

        /**
         * Toggler for search bar
         */
        this.toggleSearchBar = function () {
            IthSearchFormTrigger.toggle();
        };

        /**
         * Checks if search bar is visible or not
         *
         * @return {Boolean}
         */
        this.isSearchBarVisible = function () {
            return $rootScope.searchBarVisible;
        };

        /**
         * Shows the departure date calendar and closes other interactive elements
         */

        this.departureDateClick = function () {
            // Mobile
            if (AppConfig.isMobile() && !AppConfig.isTablet()) {
                this.toggleDatepickerModal(ctrl.newDatePicker.selectModes.DEPARTURE);

                return;
            }

            // Tablet / desktop
            $timeout(function () {
                ctrl.newDatePicker.toggleDeparture();
            }, 1);
        };

        /**
         * Shows the return date calendar and closes other interactive elements
         */
        this.returnDateClick = function () {
            // Mobile
            if (AppConfig.isMobile() && !AppConfig.isTablet()) {
                this.toggleDatepickerModal(ctrl.newDatePicker.selectModes.RETURN);

                return;
            }

            // Tablet / desktop
            if (ctrl.newDatePicker.isStandardMode() && !this.newDatePicker.departureDate) {
                $timeout(function () {
                    ctrl.newDatePicker.toggleDeparture();
                });

                return;
            }

            $timeout(function () {
                ctrl.newDatePicker.toggleReturn();
            }, 1);
        };

        /**
         * Toggles the datepicker modal on and off
         */
        this.toggleDatepickerModal = function (whichDate) {
            if (whichDate === this.newDatePicker.selectModes.RETURN && this.newDatePicker.departureDate === null) {
                whichDate = this.newDatePicker.selectModes.DEPARTURE;
            }

            MobileDismissableModal.open({
                templateUrl: '/tpl/show/jsShared/templates/base/directives/datepicker/rangeDatepickerModal',
                controller: 'MobileDatepickerModalController',
                controllerAs: 'vm',
                windowClass: 'range-datepicker-modal-message mobile-modal-with-navbar enabled-window-back-btn',
                animation: false,
                resolve: {
                    searchCityFrom: ctrl.cityHelperFrom,
                    searchCityTo: ctrl.cityHelperTo,
                    whichDate: {t: whichDate}
                }
            }, 'datepicker');
        };

        /**
         * Hides the interactive elements related to search panel
         */
        this.hideInteractiveElements = function () {
            this.hidePaxSelect();
        };

        /**
         * Go to results page
         *
         * @param {MouseEvent} evt Click mouse event
         */
        this.search = function (evt) {
            if (this.isLocationsTheSame()) {
                this.errors.custom = this.errorMessages.depTheSameAsArr;
                openErrorsModal();

                return;
            }

            if (this.isLocationsEmpty()) {
                this.errors.custom = this.errorMessages.locationsEmpty;
                openErrorsModal();

                return;
            }

            if ((this.newDatePicker.isStandardMode() && !this.newDatePicker.isStandardDateSelected()) || (this.newDatePicker.isFlexMode() && !this.newDatePicker.isFlexDateSelected())) {
                this.newDatePicker.selecting = 'dep';
                this.newDatePicker.tooltipOpen = true;
                evt.stopPropagation();

                return;
            }


            if (this.newDatePicker.flexDepartureDate && !this.newDatePicker.flexReturnDate) {
                // setting ret date as the last day of the dep month
                var depFlexDate = new Date(this.newDatePicker.flexDepartureDate);

                this.newDatePicker.flexReturnDate = new Date(depFlexDate.getFullYear(), depFlexDate.getMonth() + 1, 0);
            }

            var errorMessage = FlightPaxModel.paxValid();
            if (errorMessage) {
                this.errors.custom = errorMessage;
                openErrorsModal();

                return;
            }

            $scope.$emit('search-button-clicked-emit');

            var departureDate = !this.newDatePicker.departureDate
                ? null
                : moment(this.newDatePicker.departureDate).format('YYYY-MM-DD');
            var returnDate = (this.newDatePicker.oneWay || this.newDatePicker.returnDate === null)
                ? null
                : moment(this.newDatePicker.returnDate).format('YYYY-MM-DD');
            var flexDepartureDate = !this.newDatePicker.flexDepartureDate
                ? null
                : moment(this.newDatePicker.flexDepartureDate).format('YYYY-MM-DD');
            var flexReturnDate = !this.newDatePicker.flexReturnDate
                ? null
                : moment(this.newDatePicker.flexReturnDate).format('YYYY-MM-DD');

            if (departureDate && returnDate === null) {
                this.newDatePicker.makeOneWay();
            }

            resetErrors();

            $rootScope.openPaxDropdown = false;
            $sessionStorage.openPaxDropdown = $rootScope.openPaxDropdown;

            SearchQueryParams
                .setDepCityCode(this.cityHelperFrom.buildCitiesQueryString())
                .setDepAirportCode(this.cityHelperFrom.buildAirportsQueryString())
                .setDesCityCode(this.cityHelperTo.buildCitiesQueryString())
                .setDesAirportCode(this.cityHelperTo.buildAirportsQueryString())
                .setDesCountryCode(this.cityHelperTo.buildCountriesQueryString())
                .setAdults(FlightPaxModel.model.group.adults.count)
                .setChildren(FlightPaxModel.model.group.children.count)
                .setInfants(FlightPaxModel.model.group.infants.count)
                .setYouths(FlightPaxModel.model.group.youths.count)
                .setDepDate(flexDepartureDate || departureDate)
                .setRetDate(flexReturnDate || returnDate)
                .setFlexDays(
                    this.newDatePicker.isFlexMode() && !this.newDatePicker.oneWay
                        ? this.newDatePicker.flexDaysFromAmount
                        : null,
                    this.newDatePicker.isFlexMode() && !this.newDatePicker.oneWay
                        ? this.newDatePicker.flexDaysToAmount
                        : null
                )
                .setIsFlex(this.newDatePicker.isFlexMode())
                .setOneWay(this.newDatePicker.oneWay)
                .setSearchDeduplicatedFlights(this.searchDeduplicatedFlights);

            LocationHistory.add(this.cityHelperFrom.locations, this.cityHelperFrom.getFlightType());
            LocationHistory.add(this.cityHelperTo.locations, this.cityHelperTo.getFlightType());

            AppConfig.setFirstEntryToFalse();

            if (ctrl.searchBookingComModel) {
                window.open(SearchQueryParams.generateUrl());
                window.open(BookingComLinkGenerator.getUrl({
                    departureDate: departureDate,
                    returnDate: returnDate,
                    adultsCount: FlightPaxModel.model.group.adults.count + FlightPaxModel.model.group.youths.count,
                    childrenCount: FlightPaxModel.model.group.children.count + FlightPaxModel.model.group.infants.count,
                    destinationCityName: ctrl.cityHelperTo.locations[0].cityName,
                    destinationCountryName: ctrl.cityHelperTo.locations[0].countryName,
                    destinationAirportCode: ctrl.cityHelperTo.locations[0].airportCode
                }), '_self');
            } else {
                $location.url(SearchQueryParams.generateUrl());
            }


            // Close mobile search form
            IthSearchFormTrigger.close();
        };

        /**
         * Hides the pax selector
         */
        this.hidePaxSelect = function () {
            var paxOpenEl = document.querySelector('#paxSelect.open');
            setTimeout(function () {
                angular.element(paxOpenEl).triggerHandler('click');
            }, 0);
        };

        /**
         * Displays a city helper version based on device
         *
         * @param  {Event}  $e   Event coming from template
         * @param  {String} type String determining the way (from/to)
         */
        this.showCityHelper = function ($e, type) {
            var isFrom = (type === 'from');
            var cityHelper = isFrom ? this.cityHelperFrom : this.cityHelperTo;

            if (AppConfig.isMobile() && !AppConfig.isTablet()) {
                // On mobile we trigger special modal
                var cWay = isFrom ? 'dep' : 'ret';

                this.openMobileCityHelper(cWay);
                $e.stopPropagation();
                return;
            }

            // tablet and desktop
            cityHelper.show();
            CthUtils.focusInput(isFrom);
            CthUtils.scrollToInput(isFrom);
        };

        this.isAgent = function () {
            return AppConfig.isAgent();
        };

        this.removeLocation = function (location, flightType) {
            flightType === CITY_HELPER.FLIGHT_TYPE_FROM
                ? this.cityHelperFrom.removeLocation(location)
                : this.cityHelperTo.removeLocation(location);
        };

        this.reverseLocations = function () {
            var currentFromLocations = this.cityHelperFrom.locations;
            var currentToLocations = this.cityHelperTo.locations;

            this.cityHelperFrom.locations = currentToLocations;
            this.cityHelperTo.locations = currentFromLocations;
            this.cityHelperFrom.updatePopular();
            this.cityHelperTo.updatePopular();
        };

        this.isLocationsTheSame = function () {
            var cityHelperFrom = this.cityHelperFrom;
            var cityHelperTo = this.cityHelperTo;

            return cityHelperFrom.locations.some(function (fromLocation) {
                return (
                    cityHelperTo.locations.find(function (toLocation) {
                        return fromLocation.cityCode === toLocation.cityCode;
                    })
                );
            });
        };

        this.isFreeSpaceAvailable = function (locations) {
            return locations.length < CITY_HELPER.LOCATIONS_ALLOWED_AMOUNT;
        };

        this.isLocationsEmpty = function () {
            return !this.cityHelperFrom.locations.length || !this.cityHelperTo.locations.length;
        };

        this.$onInit = function () {
            this.cityHelperFrom.setOpposing(this.cityHelperTo);
            this.cityHelperTo.setOpposing(this.cityHelperFrom);
        };

        $scope.$on('standard-calendar-cell-clicked', function () {
            ctrl.newDatePicker.resetFlexDates();
        });

        $scope.$on('flex-calendar-cell-clicked', function () {
            ctrl.newDatePicker.resetDates();
            ctrl.newDatePicker.toggleDeparture();
        });

        $scope.$on('flex-days-amount-changed', function () {
            ctrl.newDatePicker.toggleReturn();
        });
    };

    IthFlightsFormController.$inject = [
        '$rootScope',
        '$scope',
        '$location',
        '$sessionStorage',
        '$modal',
        'sch.SearchQueryParams',
        'appConfig',
        '$filter',
        '$timeout',
        'FlightPaxModel',
        'FlightRangeDatePicker',
        'IthSearchFormTrigger',
        'CityHelperHandler',
        'CITY_HELPER',
        'ModalHelper',
        'LocationHistory',
        'SearchHistory',
        'CityHelperLocation',
        'CthUtils',
        'MobileDismissableModal',
        'BookingComLinkGenerator'
    ];

    angular
        .module('base')
        .controller('IthFlightsFormController', IthFlightsFormController);

}(angular, history, moment));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/flights-form.directive.js
(function (angular) {
/**
   * @name        IthFlightsFormDirective
   * @description Handles flight search form.
   */
  var IthFlightsFormDirective = function () {
    return {
      restrict: 'A',
      replace: true,
      controller: 'IthFlightsFormController',
      controllerAs: '$ctrl',
      scope: {
        defaultDateStart: '@',
        defaultDateEnd: '@',
        from: '<',
        to: '<'
      },
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/searchForm/flightsForm';
      }
    };
  };

  angular
    .module('base')
    .directive('flightsForm', IthFlightsFormDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/mobile-datepicker-modal-input.component.js
(function (angular) {

    angular.module('base').component('mobileDatepickerModalInput', {
        templateUrl: '/tpl/show/jsShared/templates/base/directives/datepicker/mobile-datepicker-input',
        controller: function () {
            this.getValue = function () {
                return this.isDeparture ? this.newDatePicker.departureDate : this.newDatePicker.returnDate;
            };

            this.reset = function () {
                if (this.isDeparture) {
                    this.newDatePicker.departureDate = null;
                }

                this.newDatePicker.returnDate = null;
            };
        },
        bindings: {
            isDeparture: '<',
            newDatePicker: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/mobile-datepicker-modal.controller.js
(function(angular) {
/**
   * @name        MobileDatepickerModalController
   * @description Handles data inside the datepicker modal on mobile
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
    var MobileDatepickerModalController = function ($timeout, $modalInstance, FlightRangeDatePicker, searchCityFrom, searchCityTo, whichDate, ScrollCalendarHelper, AppConfig, $scope) {
        var self = this;

        /**
     * Function called on initialisation
     */
        var _init = function () {
            // Trigger scroll method after a short while without invoking apply
            $timeout(function () {
                var scrollTo = (self.newDatePicker.selecting === self.newDatePicker.selectModes.RETURN && self.newDatePicker.returnDate !== null)
                    ? self.newDatePicker.returnDate
                    : self.newDatePicker.departureDate;

                ScrollCalendarHelper.scrollToSelection(scrollTo);
            }, 50, false);
        };

        /**
     * Flight range datepicker instance
     */
        this.newDatePicker = angular.copy(FlightRangeDatePicker);
        this.newDatePicker.selecting = whichDate.t;

        /**
     *
     */
        this.departurePlace = searchCityFrom;

        /**
     *
     */
        this.destinationPlace = searchCityTo;

        /**
     * App config reference
     *
     * @type {AppConfig}
     */
        this.appConfig = AppConfig;

        /**
     * Total price for selected dates
     *
     * @type {Number}
     */
        this.totalPrice = 0;


        this.multiple = true;

        /**
     * Checks if total price should be displayed in template
     *
     * @returns {Boolean}
     */
        this.showTotalPrice = function () {
            if (this.totalPrice === false || this.totalPrice === 0) {
                return false;
            }
            return (this.newDatePicker.departureDate !== null && (this.newDatePicker.oneWay || this.newDatePicker.returnDate !== null));
        };

        /**
     * Closes the modal instance
     */
        this.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        /**
     * Propagates chosen dates and closes modal
     */
        this.continue = function () {
            // Set dirty
            this.newDatePicker.dirty = true;

            // Propagate to parent class
            FlightRangeDatePicker.departureDate = this.newDatePicker.departureDate;
            FlightRangeDatePicker.returnDate = this.newDatePicker.returnDate;
            FlightRangeDatePicker.oneWay = this.newDatePicker.oneWay;
            FlightRangeDatePicker.dirty = this.newDatePicker.dirty;
            FlightRangeDatePicker.dateMode = this.newDatePicker.dateMode;
            FlightRangeDatePicker.flexDepartureDate = this.newDatePicker.flexDepartureDate;
            FlightRangeDatePicker.flexReturnDate = this.newDatePicker.flexReturnDate;
            FlightRangeDatePicker.flexDaysFromAmount = this.newDatePicker.flexDaysFromAmount;
            FlightRangeDatePicker.flexDaysToAmount = this.newDatePicker.flexDaysToAmount;

            $modalInstance.close();
        };

        /**
     * Resets date selection
     */
        this.reset = function () {
            this.newDatePicker.resetDates();
        };

        /**
     * Checks if date selection was reset
     */
        this.isReset = function () {
            return this.newDatePicker.departureDate === null && this.newDatePicker.returnDate === null;
        };

        this.isResetFlex = function () {
            return this.newDatePicker.flexDepartureDate === null && this.newDatePicker.flexReturnDate === null;
        };

        this.switchSelectingDeparture = function () {
            this.newDatePicker.selecting = this.newDatePicker.selectModes.DEPARTURE;
        };

        this.switchSelectingReturn = function () {
            if (this.newDatePicker.departureDate === null) {
                return;
            }

            this.newDatePicker.selecting = this.newDatePicker.selectModes.RETURN;
        };

        _init();

        $scope.$on('standard-calendar-cell-clicked', function () {
            self.newDatePicker.resetFlexDates();
        })

        $scope.$on('flex-calendar-cell-clicked', function () {
            self.newDatePicker.resetDates();
            self.newDatePicker.makeRoundTrip();
        })
    };

    MobileDatepickerModalController.$inject = [
        '$timeout',
        '$modalInstance',
        'FlightRangeDatePicker',
        'searchCityFrom',
        'searchCityTo',
        'whichDate',
        'ScrollCalendarHelper',
        'appConfig',
        '$scope'
    ];

    angular
        .module('base')
        .controller('MobileDatepickerModalController', MobileDatepickerModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/mobile-dismissable-modal.component.js
(function (angular, history) {

    var MobileDismissableModalService = function ($modal, $location, $rootScope, $timeout) {
        /**
         * Opens a modal and closes it on back button
         *
         * @param {object} modalData
         * @param {string} modalId
         * @returns {$modalInstance}
         */
        this.open = function (modalData, modalId) {
            var modalInstance = $modal.open(modalData);
            $location.hash(modalId);
            var unregisterMobileModalLocationChange;

            modalInstance.result.finally(function () {
                unregisterMobileModalLocationChange();
                if ($location.hash() === modalId) {
                    history.back();
                } else {
                    $location.hash('');
                }
            });

            $timeout(function () {
                unregisterMobileModalLocationChange = $rootScope.$on('$locationChangeStart', function () {
                    modalInstance.dismiss('cancel');
                });
            });

            return modalInstance;
        };
    };

    MobileDismissableModalService.$inject = ['$modal', '$location', '$rootScope', '$timeout'];

    angular
        .module('base')
        .service('MobileDismissableModal', MobileDismissableModalService);

}(angular, history));
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/searchform.directive.js
(function(angular) {
/**
   * @name SearchFormDirective
   * @description Directive for search form.
   * @constructor
   */
  var SearchFormDirective = function () {
    return {
      restrict: 'A',
      replace: false,
      priority: 100,
      transclude: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/searchForm/searchForm';
      },
      scope: {
        defaultActiveTab: '=',
        defaultCityCodeFrom: '@?',
        defaultCityCodeTo: '@?'
      },
      controller: 'SearchFormController'
    };
  };

  angular.module('base').directive('searchForm', SearchFormDirective);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/directives/searchForm/trip-length.helper.js
(function(angular, moment) {
/**
   * @name        TripLengthHelper
   * @description Service that counts the days between two dates
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var _tripLengthHelper = function () {
    /**
     * Returns number of days between two dates
     *
     * @param   {Date}   startDate
     * @param   {Date}   endDate
     * @returns {Number} 
     */
    this.getLength = function (startDate, endDate) {
      if (startDate === null || endDate === null) {
        return false;
      }
      var a = moment(startDate);
      var b = moment(endDate);

      return b.diff(a, 'days') + 1;
    };

    return this;
  };

  angular
    .module('base')
    .service('TripLengthHelper', _tripLengthHelper);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/base/directives/searchHeader.js
angular.module('base')

/**
 * @name        searchHeader
 * @description
 */
  .directive('searchHeader', function () {
return {
      restrict: 'E',
      templateUrl: '/tpl/show/jsShared/templates/base/directives/searchHeader',
      replace: true,
      scope: {
        image: '=',
        tabIndex: '=',
        title: '=',
        subTitle: '='
      },
      controller: ['$scope', function ($scope) {
        if (!_.isEmpty($scope.image)) {
          $scope.style = 'background-image: none; background-color: #275cbd;';
        } else {
          $scope.style = 'background-image: url(' + $scope.image + ');';
        }
      }]
    };
  });
;

// Source: ../shared/public_html/assets/js/base/directives/selectionOffers/selectionOffer.js
angular.module('base')

/**
 * @name        selectionOfferController
 * @description Controller for selection offers
 */
.controller('selectionOfferController', ['$scope', 'ApiTools', '$timeout', function ($scope, ApiTools, $timeout) {
$scope.showFormLoading  = false;
    $scope.sentEmailSuccess = false;
    $scope.sentEmailError   = '';
    $scope.offers           = {};
    $scope.result           = {};
    $scope.default_option   = '';
    $scope.default_pax      = '';

    var resetForm = function (form) {
        if (form)
        {
            form.$setPristine();
            form.$setUntouched();
        }

        $scope.offer.user_phone = '';
        $scope.offer.user_email = '';
        $scope.offer.option     = $scope.default_option;
        $scope.offer.pax        = $scope.default_pax;
    };

    //save default (ng-init) values of select
    $scope.$watch('offer.option', function ()
    {
        if ( $scope.default_option == '' )
        {
            $scope.default_option = $scope.offer.option;
        }
    });
    $scope.$watch('offer.pax', function ()
    {
        if ( $scope.default_pax == '' )
        {
            $scope.default_pax = $scope.offer.pax;
        }
    });


    $scope.makeRequest = function (form)
    {
        var formData = {
            static_page_module_id:  $scope.static_page_module_id,
            option:                 $scope.offer.option,
            pax:                    $scope.offer.pax,
            user_email:             $scope.offer.user_email,
            user_phone:             $scope.offer.user_phone
        };

        var endpoint = {
            url: '/api/packages/selectionOffer/sendMail',
            method: 'POST',
            respParser: packageSelectionOfferParser
        };

        form.$setSubmitted();
        if (form.$valid)
        {
            $scope.showFormLoading = true;

            var promise = ApiTools.fetch(this, endpoint, formData);

            promise.then(
                function success(response)
                {
                    $scope.result = angular.copy(formData);

                    $scope.sentEmailSuccess = true;
                    $scope.showFormLoading  = false;
                    $scope.sentEmailError   = '';

                    //hide notification after 5sec
                    $timeout(function(){
                        $scope.sentEmailSuccess = false;
                    }, 5000);

                    resetForm(form);
                },
                function error(response)
                {
                    $scope.showFormLoading  = false;
                    $scope.sentEmailError   = response.response[0].msg;
                    console.warn(response);

                    //hide notification after 5sec
                    $timeout(function(){
                        $scope.sentEmailError = '';
                    }, 5000);
                }
            );
        }

        function packageSelectionOfferParser(response)
        {
            return true;
        }
    };
}])

/**
 * @name        selectionOffer
 * @description selection offer directive
 */
.directive('selectionOffer', function () {
    return {
        restrict: 'A',
        controller: 'selectionOfferController',
        //template: '<div include-replace></div>',
        replace: true
    };
});
;

// Source: ../shared/public_html/assets/js/base/directives/seoArea/regularLinks.js
angular.module('base')

/**
 * @name        regularLinks
 * @description directive for links
 */
.directive('regularLinks', ['Tools', function (Tools) {
var link = function(scope, elem, attrs) {
    scope.chunkedlinks = [];

    scope.$watch('links', function () {
      scope.chunkedlinks = angular.isArray(scope.links) ? Tools.chunk(scope.links, 6) : [];
    });
  };

  return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/seoArea/links-hyb',
    link: link,
    scope: {
      links: '=?ngModel'
    },
    replace: true
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/seoArea/seoLinks.js
angular.module('base')

/**
 * @name        seoLinks
 * @description directive for links
 */
.directive('seoLinks', ['Links', 'Tools', function (Links, Tools) {
var link = function(scope, elem, attrs) {
    var promise = attrs.source === 'airlines' ? Links.getAirlines() : Links.getCountries();

    promise.then(
      function (links) {
        scope.chunkedlinks = Tools.chunk(links.links, 6);
      },
      function (failure) {
        console.log('something went wrong', failure);
      });
  };

  return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/seoArea/links-hyb',
    link: link,
    replace: true
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/spinner.js
angular.module('base')

/**
 * @name        spinner
 * @description Display a loading spinner with optional text
 */
.directive('spinner',  function spinner() {
return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div><div class="loading-spinner loading-spinner-default"></div> <ng-transclude translate></ng-transclude></div>'
  };
});

;

// Source: ../shared/public_html/assets/js/base/directives/stars.js
angular.module('base')

/**
 * @name        stars
 * @description Product stars display
 */
.directive('stars', function stars() {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) { return attr.templateUrl || '/tpl/show/jsShared/templates/base/directives/stars'; },
    link: function (scope, elem, attrs) {
      scope.range = [];
      scope.value = parseInt(attrs.value);

      for (var i = 0; i < scope.value; i++)
        scope.range.push(i);
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/stickTo.js
angular.module('base')

  .directive('stickTo',['$window','$document',function($window,$document){
return{
      restrict: 'A',
      link: function(scope,element,attrs){

        var raw = element[0],
          offsetTop = raw.offsetTop,
          customClass = attrs.customClass || '';

        angular.element($window).bind("scroll", function ()
        {
          if ($window.pageYOffset >= offsetTop)
          {
            element.css('position', 'fixed')
              .css('top', '0')
              .css('left', '0')
              .css('margin-top', '0')
              .css('z-index', '1020')
              .css('width', '100%');
            element.addClass(customClass);
          }
          else
          {
            element.css('position', '')
              .css('top', '')
              .css('left', '')
              .css('margin-top', '')
              .css('z-index', '')
              .css('width', '');
            element.removeClass(customClass);
          }
        });

        scope.$on('$destruct', function () {
          angular.element($window).unbind("scroll");
        });
      }
    }
  }]);;

// Source: ../shared/public_html/assets/js/base/directives/sticky-sidebar.js
(function (angular) {
/**
     * @name        StickySidebarDirective
     * @description Makes a sidebar element sticky on top when smaller than
     *              screen height and on both top and bottom when bigger than
     *              screen height.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var StickySidebarDirective = function ($window, $document) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                /**
                 * Top starting position for sidebar
                 * @type {Number}
                 */
                scope.initialSidebarTop = parseInt(attrs['topMargin'], 10);

                /**
                 * Last vertical scroll position
                 * @type {Number}
                 */
                scope.lastScrollTop = $window.scrollY;

                /**
                 * True if last scroll was in downward direction
                 * @type {Boolean}
                 */
                scope.wasScrollingDown = true;

                /**
                 * Sidebar parent node cached
                 * @type {HTMLElement}
                 */
                scope.sidebarParentNode = element.parent()[0];

                /**
                 * Updates sidebar's top value
                 * @param {Number} topValue
                 */
                var updateTopValue = function (topValue) {
                    element.css('top', topValue + 'px');
                };

                /**
                 * Scroll handler method
                 */
                var scrollHandler = function () {
                    scope.initialSidebarTop = document.querySelector('#stickySidebarParent').offsetTop;

                    /**
                     * Window height
                     * @type {Number}
                     */
                    var windowHeight = $window.innerHeight;

                    /**
                     * Height of the sidebar element
                     * @type {Number}
                     */
                    var sidebarHeight = element[0].offsetHeight;

                    /**
                     * Height of content on the left side
                     * @type {Number}
                     */
                    var leftContentHeight = document.querySelector('.pax-details-layout').offsetHeight;

                    /**
                     * Amount of scroll from top of page
                     * @type {Number}
                     */
                    var scrollTop = $window.scrollY;

                    /**
                     * Height from page top to bottom of screen
                     * @type {Number}
                     */
                    var scrollBottom = scrollTop + windowHeight;

                    /**
                     * Height from page top to sidebar
                     * @type {Number}
                     */
                    var sidebarTop = element[0].getBoundingClientRect().top + $window.scrollY;

                    /**
                     * Height from top of page to sidebar bottom
                     * @type {Number}
                     */
                    var sidebarBottom = sidebarTop + sidebarHeight;

                    /**
                     * Delta position of sidebar element
                     * @type {Number}
                     */
                    var heightDelta = Math.abs(windowHeight - sidebarHeight);

                    /**
                     * Scroll delta
                     * @type {Number}
                     */
                    var scrollDelta = scope.lastScrollTop - scrollTop;

                    /**
                     * Check if scroll is in downwards direction
                     * @type {Boolean}
                     */
                    var isScrollingDown = (scrollTop > scope.lastScrollTop);

                    /**
                     * Check if window is larger than sidebar
                     * @type {Boolean}
                     */
                    var isWindowLarger = (windowHeight > sidebarHeight);

                    /**
                     * Check if scroll is past page bottom
                     * @type {Boolean}
                     */
                    var isPageAtBottom = (sidebarHeight + scrollTop >= scope.sidebarParentNode.offsetHeight + scope.sidebarParentNode.offsetTop);

                    /**
                     * Max bottom position where sidebar should snap in place
                     * @type {Number}
                     */
                    var bottomSnapPosition = scope.sidebarParentNode.offsetHeight + scope.sidebarParentNode.offsetTop - sidebarHeight - scrollTop;

                    /**
                     * Get current sidebar top value
                     * @type {Number}
                     */
                    var currentTop = parseInt(element.css('top'), 10);

                    /**
                     * Sidebar scroll amount
                     * @type {Number}
                     */
                    var scrolledTop = currentTop + scrollDelta;

                    /**
                     * Check if sidebar should be dragged from bottom
                     * @type {Boolean}
                     */
                    var dragBottomDown = (sidebarBottom <= scrollBottom) && isScrollingDown;

                    /**
                     * Check if sidebar should be dragged from top
                     * @type {Boolean}
                     */
                    var dragTopUp = (sidebarTop >= scrollTop && !isScrollingDown);

                    /**
                     * Check if sidebar should follow user
                     * @returns {Boolean}
                     */
                    var shouldFollow = (
                        (leftContentHeight > sidebarHeight + 100) && (
                            (isWindowLarger && scrollTop > scope.initialSidebarTop) ||
                            (!isWindowLarger && scrollTop > scope.initialSidebarTop + heightDelta)
                        )
                    );

                    /**
                     * Check if sidebar should snap back in place
                     * @returns {Boolean}
                     */
                    var shouldSnap = !isScrollingDown && scrollTop <= scope.initialSidebarTop;

                    if (shouldFollow) {
                        element.addClass('fixed');
                    }

                    if (!shouldFollow && shouldSnap) {
                        element.removeClass('fixed');
                    }

                    if (dragBottomDown && isWindowLarger) {
                        updateTopValue(isPageAtBottom ? bottomSnapPosition : 0);
                    } else if (dragBottomDown && !isWindowLarger) {
                        updateTopValue(isPageAtBottom ? bottomSnapPosition : -heightDelta);
                    } else if (dragTopUp) {
                        updateTopValue(isPageAtBottom ? bottomSnapPosition : 0);
                    } else if (element.hasClass('fixed')) {
                        if (isWindowLarger) {
                            updateTopValue(bottomSnapPosition);
                        } else {
                            updateTopValue(scrolledTop);
                        }
                    }

                    // Cache scroll values
                    scope.lastScrollTop = scrollTop;
                    scope.wasScrollingDown = isScrollingDown;
                };

                $document.on('scroll', scrollHandler);
                scope.$on('$destroy', function () {
                    $document.off('scroll', scrollHandler);
                });
            }
        };
    };

    StickySidebarDirective.$inject = [
        '$window',
        '$document'
    ];

    angular
        .module('base')
        .directive('stickySidebar', StickySidebarDirective);
}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/stopEvent.js
angular.module('base')

/**
 * @name        stopEvent
 * @description
 */
.directive('stopEvent', function () {
return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.on(attr.stopEvent, function (e) {
        e.stopPropagation();
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/svgIcon.js
(function(angular) {
/**
   * @name        base.svgIcon
   * @description Displays SVG icons
   */
  var IthSvgIconComponent = {
    controller: function () {
      this.getIconUrl = function () {
        return '/tpl/show/jsShared/templates/base/directives/ui/svg-icons/' + this.id;
      };
    },
    template: '<span class="icon" ng-include="$ctrl.getIconUrl()"></span>',
    bindings: {
      id: '@'
    }
  };

  angular
    .module('base')
    .component('svgIcon', IthSvgIconComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/tableRsponsive.js
angular.module('base')

/**
 * @name        tableResponsive
 * @description
 */
.directive('tableResponsive', ['$compile', function($compile) {

  var wrapperTemplate = ['<div class="table-responsive-wrapper">', '</div>'];
  var rowTemplate = [
    '<div class="row space-vertical-small">',
    '</div>'
  ];
  var cellTemplate = [
    '<div class="col-xs-5 col-xs-height">', '</div>',
    '<div class="col-xs-7 col-xs-height">', '</div>'
  ];

  return {
    restrict: 'C',
    replace:false,
    link: function (scope, element, attrs) {
      if (element.hasClass('table-responsive-rendered')) return;
      element.addClass('table-responsive-rendered');

      var ths = element.find('table').find('thead').find('tr').find('th');
      if (!ths.length)
      {
        ths = element.find('table').find('thead').find('tr').find('td');
      }

      var trs = element.find('table').find('tbody').find('tr');
      var thsCount = trs.eq(0).find('td').length;
      var trsCount = trs.length;
      var newElementWrapper = angular.element( wrapperTemplate.join('') );

      var lastTh = '';
      for(var i=1; i<thsCount; i++) {
        lastTh = ths.eq(i).html() || lastTh;
        var temp = angular
          .element(rowTemplate[0]
            + cellTemplate[0] + ths.eq(0).html() + cellTemplate[1]
            + cellTemplate[2] + lastTh + cellTemplate[3]
            + rowTemplate[1]);
        newElementWrapper.append(temp);

        for(var j=0; j<trsCount; j++)
        {
          var tds = trs.eq(j).find('td');
          temp = angular
            .element(rowTemplate[0]
              + cellTemplate[0] + tds.eq(0).html() + cellTemplate[1]
              + cellTemplate[2] + tds.eq(i).html() + cellTemplate[3]
              + rowTemplate[1]);
          newElementWrapper.append(temp);
        }
      }

      element.append(newElementWrapper);

    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/tabs.js
/**
 * Todo: refactor, need change copy of ui.bootstrap.tabs to directive extend
 */

/**
 * @ngdoc overview
 * @name base.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */
angular.module('base')

.controller('TabsetAutoController', ['$scope', 'TabsHandler', function TabsetAutoController($scope, TabsHandler) {
var self = this;

    /**
     * The default active tab
     *
     * @type {number}
     */
    this.defaultActiveTab = -1;

    this.tabsHandler = new TabsHandler();
    this.tabsHandler = this.tabsHandler.reset();

    $scope.tabs = this.tabsHandler.tabs;

    this.select = function (tab) {
      this.tabsHandler.select(tab);
    };

    this.addTab = function addTab(tab) {
      this.tabsHandler.addTab(tab);
    };

    this.removeTab = function removeTab(tab) {
      this.tabsHandler.addTab(tab);
    };

    this.selectById = function selectById(id) {
      this.tabsHandler.selectById(id);
    };

    $scope.$on('$destroy', function () {
      self.tabsHandler.setDestroyed(true);
    });

}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
 */
.directive('tabsetAuto', ['$parse', function ($parse) {
return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    priority: 150,
    scope: {
      type: '@',
      defaultActiveTab: '@',
      selectedTab: '=',
    },
    templateUrl: function (element, attrs) {
      return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/tabs/tabset';
    }, //'template/tabs/tabset.html',
    controller: 'TabsetAutoController',
    link: function (scope, element, attrs, ctrl) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
      scope.navtabs = angular.isDefined(attrs.navtabs) ? scope.$parent.$eval(attrs.navtabs) : false;

      ctrl.defaultActiveTab = parseInt(scope.defaultActiveTab) || 0;

      if (ctrl.tabsHandler.tabs.length && ctrl.tabsHandler.selectedTab === null) {
        ctrl.selectById(ctrl.defaultActiveTab); // Activate tab
      }

      var unsubscribeSelectedTab = scope.$watch('selectedTab', function(value, oldValue){
        if(value !== oldValue){
          ctrl.selectById(value);
        }
      });

      scope.$on('$destroy', function() {
        unsubscribeSelectedTab();
      });
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {String=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {String=} select An expression to evaluate when the tab is selected.
 * @param {Boolean=} active A binding, telling whether or not this tab is selected.
 * @param {Boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 */
.directive('tabAuto', ['$parse', '$log', function ($parse, $log) {
return {
    require: '^tabsetAuto',
    restrict: 'EA',
    replace: true,
    priority: 150,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl || '/tpl/show/jsShared/templates/base/directives/tabs/tab';
    },
    transclude: true,
    scope: {
      active: '=?',
      heading: '@',
      hidden: '<?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
      //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function () {
      //Empty controller so other directives can require being 'under' a tab
    },
    compile: function (elm, attrs, transclude) {
      return function postLink(scope, elm, attrs, tabsetCtrl) {

        tabsetCtrl.__tabs_counter__ = tabsetCtrl.__tabs_counter__ || 0;

        scope.disabled = false;

        if (attrs.disable) {
          scope.$parent.$watch($parse(attrs.disable), function (value) {
            scope.disabled = !!value;
          });
        }

        // Deprecation support of "disabled" parameter
        // fix(tab): IE9 disabled attr renders grey text on enabled tab #2677
        // This code is duplicated from the lines above to make it easy to remove once
        // the feature has been completely deprecated
        if (attrs.disabled) {
          $log.warn('Use of "disabled" attribute has been deprecated, please use "disable"');
          scope.$parent.$watch($parse(attrs.disabled), function (value) {
            scope.disabled = !!value;
          });
        }

        if (attrs.id) {
          scope.id = parseInt(attrs.id);
        } else {
          scope.id = tabsetCtrl.__tabs_counter__;
        }
        tabsetCtrl.__tabs_counter__++;

        scope.select = function () {
          if (!scope.disabled) {
            scope.active = true;
            tabsetCtrl.select(scope);
          }
        };

        tabsetCtrl.addTab(scope);

        if (!scope.disabled && tabsetCtrl.defaultActiveTab == scope.id) {
          tabsetCtrl.selectById(tabsetCtrl.defaultActiveTab); // Activate tab
        }

        scope.$on('$destroy', function () {
          tabsetCtrl.removeTab(scope);
        });

        //We need to transclude later, once the content container is ready.
        //when this link happens, we're inside a tab heading.
        scope.$transcludeFn = transclude;
      };
    }
  };
}])

.directive('tabHeadingTranscludeAuto', [function () {
return {
    restrict: 'A',
    require: '^tabAuto',
    priority: 150,
    link: function (scope, elm, attrs, tabCtrl) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
}])

.directive('tabContentTranscludeAuto', [function () {
return {
    restrict: 'A',
    priority: 150,
    link: function (scope, elm, attrs) {
      var tab = scope.$eval(attrs.tabContentTranscludeAuto);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };
  function isTabHeading(node) {
    return node.tagName && (
        node.hasAttribute('tab-heading-auto') ||
        node.hasAttribute('data-tab-heading-auto') ||
        node.tagName.toLowerCase() === 'tab-heading-auto' ||
        node.tagName.toLowerCase() === 'data-tab-heading-auto'
      );
  }
}])

.directive('tabsetMini', [function(){
var getLis = function(element) {
    return element.find('ul').find('li');
  };

  var getContects = function(element) {
    return angular.element( element[0].querySelectorAll('.tab-pane') );
  };

  return {
    restrict: 'A',
    priority: 1000,

    controller: ['$scope', 'TabsHandler', function($scope, TabsHandler)
    {
      this.tabsHandler = new TabsHandler();
      this.tabsHandler = this.tabsHandler.reset();
      $scope.tabs = this.tabsHandler.tabs;

      $scope.selectRefresh = function(element, $id) {
        ctrl.tabsHandler.selectById($id);
      };
    }],

    link: function(scope, element, attrs, ctrl)
    {
      var defaultActiveTab = scope.$eval(attrs.defaultActiveTab);

      var tabs = getLis(element);

      _.each(tabs, function (tab, index) {
        ctrl.tabsHandler.addTab({id: index, title: tab.innerText, onSelect:_.noop, onDeselect:_.noop});
      });

      scope.select = function($id) {
        ctrl.tabsHandler.selectById($id);
      };

      if (angular.isNumber(defaultActiveTab)) {
        ctrl.tabsHandler.selectById(defaultActiveTab);
      } else {
        ctrl.tabsHandler.selectById(0);
      }
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/templates/templateUrl.js
angular.module('base')

/**
 * @name        templateUrl
 * @description Template url directive
 */

.directive('templateUrl',
[ '$templateRequest',
function ($templateRequest) {
return {
    restrict: 'EA',
    compile: function() {
      return {
        pre: function(scope, iElement, iAttrs, controller) {
          if(!iAttrs.disableAnimation)
          {
            iElement.attr('loaded', false);
          }
        },
        post: function(scope, iElement, iAttrs, controller) {
          if(!iAttrs.disableAnimation)
          {
            if(iAttrs.templateUrl.search("/") != -1) //todo
            {
              $templateRequest(iAttrs.templateUrl).then(function(success){
                  //console.info(iAttrs.templateUrl, " loaded")
                  iElement.attr('loaded', true);
                },
                function(error){
                  console.error(error);
                  throw new Error(error);
                });
            }
            else{
              iElement.attr('loaded', true);
            }
          }
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/testimonials/testimonial.js
angular.module('base')

/**
 * @name        testimonial
 * @description Single testimonial directive
 */
.directive('testimonial', function () {
return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/base/directives/testimonials/testimonial',
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/textAnimation.js
(function () {
angular.module('base')
  .directive('textAnimation', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) 
      {
        var animationElement = (attrs.textAnimation)? element[0].querySelector(attrs.textAnimation) : null ;
        animationElement = animationElement ? animationElement : element[0];

        var textAnimation = new fly.textAnimation( animationElement );

        var caret = element[0].querySelector('.text-animation-caret');

        textAnimation
          .init(caret)
          .clearTextContent();

        textAnimation.animate(150);


        textAnimation.$wait(function ()
        {
          $timeout(function ()
          {
            angular.element(caret).remove();
          }, 2000);
        });
      }
    };
  }]);
  
})();;

// Source: ../shared/public_html/assets/js/base/directives/textBox/textBox.js
angular.module('base')

.controller('textBoxController', ['$scope', 'TextBox', function ($scope, TextBox) {
TextBox.getTextBox($scope.src).then(
    function (textBox) {
      $scope.textBox = textBox;
    },

    function (failure) {
      console.log('something went wrong', failure);
    }
  );
}])

/**
 * @name        textBox
 * @description displays text box
 */
.directive('textBox', [function textBox() {
return {
    restrict: 'A',
    replace: true,
    controller: 'textBoxController',

    scope: {
      model: '=?ngModel',
      callback: '&ngCallback',
      src: '@'
    },

    templateUrl: function (elem, attrs) {
      return '/tpl/show/jsShared/templates/base/directives/textBox/textBox-hyb';
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/textBox/textBoxBody.js
(function(angular) {
/**
     * @name        textBoxBodyDirective
     * @description displays text box content
     */
    var textBoxBodyDirective = function (TextBox, $filter, $compile) {
        var link = function (scope, elem, attrs) {
            // Json parse text box variables
            var variables = attrs.textBoxVariables !== undefined ? JSON.parse(attrs.textBoxVariables) : {};

            /**
             * Compiles text box content to recognize directives and dynamic elements.
             *
             * @param {String} content
             */
            var compileContent = function (content) {
                elem.html(content);
                $compile(elem.contents())(scope);
            };

            if (attrs.hasOwnProperty('showLoader') && JSON.parse(attrs.showLoader) === true) {
                // Show a loader
                compileContent('<ith-preloader></ith-preloader>');
            }

            TextBox.getByName(attrs.textBoxBody)
                .then(function (response) {
                    if (!_.isEmpty(response.text)) {
                        compileContent($filter('translate')(response.text, variables));
                    }
                })
                .catch(function () {
                    compileContent(attrs.textBoxBody);
                });
        };

        return {
            restrict: 'A',
            link: link
        };
    };

    textBoxBodyDirective.$inject = [
        'TextBox',
        '$filter',
        '$compile'
    ];

    angular
        .module('base')
        .directive('textBoxBody', textBoxBodyDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/directives/textBox/textBoxWithMenu.js
angular.module('base')

/**
 * @name        textBoxWithMenu
 * @description displays text box with menu
 */
.controller('textBoxWithMenuController', ['$scope', '$element', 'TextBox', '$document', '$window', '$location', '$timeout',
function ($scope, $element, TextBox, $document, $window, $location, $timeout) {
/**
   * Variables for menu
   */
  var wrapper = $element,
    menu = $document[0].getElementById('sp-menu'),
    wrapperOffset = 0,
    wrapperHeight = 0,
    menuHeight = 0,
    windowOffset = 0;


  /**
   * Scrolling when have #tag on link
   *
   */
  $timeout(function () {
    if ($location.hash()) {

      var hash = $location.hash();
      var hashPosition = angular.element(document.getElementById(hash));
      if (hashPosition) {
        $document.scrollToElementAnimated(hashPosition);
      }
    }
  }, 1000, true);

  /**
   * Scroll menu
   */
  angular.element($window).bind("scroll", function () {


    windowOffset = $window.pageYOffset;
    wrapperOffset = wrapper[0].offsetTop;
    wrapperHeight = wrapper[0].offsetHeight;
    menuHeight = menu.offsetHeight + 180;

    $scope.$apply(function () {
      if ((windowOffset >= wrapperOffset) && windowOffset <= (wrapperHeight + wrapperOffset - menuHeight)) {
        $scope.fixed = true;
        $scope.bottom = false;
      }
      if (windowOffset >= (wrapperHeight + wrapperOffset - menuHeight)) {
        $scope.fixed = false;
        $scope.bottom = true;
      }
      if ((windowOffset < wrapperOffset)) {
        $scope.fixed = false;
        $scope.bottom = false;
      }
    });
  });

  $scope.$on('$destruct', function () {
    angular.element($window).unbind("scroll");
  });
}])

.directive('textBoxWithMenu', function textBoxWithMenu() {
  return {
    restrict: 'A',
    replace: true,
    controller: 'textBoxWithMenuController',

    scope: {
      model: '=?ngModel',
      callback: '&ngCallback',
      menu: '@',
      content: '@'
    },

    templateUrl: function (elem, attrs) {
      return '/tpl/show/jsShared/templates/base/directives/textBox/textBoxWithMenu-hyb';
    },

    link: function (scope, element, attr) {
      scope.fixed = false;
      scope.$on('fixedChange', function (event, data) {
        scope.fixed = data;
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/tracking/trackEvent.js
angular.module('base')

/**
 * @name        Track Event
 * @description Execute an angular expression when we click out of the current element.
 */
    .directive('trackEvent', ['$timeout', function trackEvent($timeout) {
return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('click', function () {
                    if(attrs.trackEvent && typeof dataLayer != 'undefined')
                    {
                        dataLayer.push(
                            {
                                'event':attrs.trackEvent
                            }
                        );
                    }

                });
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/tracking/trackEventGa.js
angular.module('base')

    /**
     * @name        Track Event
     * @description Execute an angular expression when we click element.
     */
    .directive('trackEventGa', ['$timeout','$rootScope', function trackRender($timeout,$rootScope) {
return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('click', function () {
                    if (attrs.trackEventGa && typeof ga != 'undefined') {
                        $timeout(function () {
                            if($rootScope.isCalendarPage){
                                var data = scope.$eval(attrs.trackEventGa);
                                ga('send', data);
                            }
                        });
                    }
                });

            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/tracking/trackRender.js
angular.module('base')

/**
 * @name        Track Event
 * @description Execute an angular expression when we click out of the current element.
 */
    .directive('trackRender', ['$timeout', function trackRender($timeout) {
return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                    if(attrs.trackRender && typeof dataLayer != 'undefined')
                    {

                        dataLayer.push(
                            {
                                'event':attrs.trackRender
                            }
                        );
                    }
            }
        };
    }]);
;

// Source: ../shared/public_html/assets/js/base/directives/travelDesk/travelDesk.js
angular.module('base')

  /**
   * @name        inputTags
   * @description directive for inputTags zone
   */
  .directive('travelDesk', ['WarmUpSrv', '$timeout', function (WarmUpSrv, $timeout) {
return {
      restrict: 'A',
      replace: false,
      controller: ['$scope', function ($scope) {
        $scope.showTravel = false;
        $scope.travelData = {
          delegationId: '',
          delegationDescription: '',
          travelDeskRedirectionUrl: '/',
          travelDeskBlankImageUrl: ''
        };

        $scope.clearCache = function () {
          WarmUpSrv.clearKey('travelDesk');
        };

        $scope.loadData = function () {
          var data = WarmUpSrv.getByKey('travelDesk');
          if (data) {
            for (var k in $scope.travelData) {
              $scope.travelData[k] = data[k];
            }

            $scope.showTravel = true;
          }
        };
      }],
      link: function (scope) {
        scope.loadData();
      },
      template: function(){
        if (WarmUpSrv.getByKey('travelDesk')) {
          return '<div ng-include="\'/tpl/show/jsShared/templates/base/directives/travelDesk/travelDesk\'"></div>';
        }
        return '<div></div>'
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/directives/travelDesk/travelDeskDisplayElement.js
angular.module('base')

/**
 * @name        inputTags
 * @description directive for inputTags zone
 */
.directive('travelDeskDisplayElement', ['WarmUpSrv', function (WarmUpSrv) {
return {
    restrict: 'A',
    replace: true,
    controller: ['$scope', function ($scope) {
      $scope.display = true;
      $scope.displayElement = function(){
        var data = WarmUpSrv.getByKey('travelDesk');
        if(data)
        {
          $scope.display = false;
        }
      };
    }],
    link: function (scope, element) {
      scope.displayElement();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/tripLenghtSelector/tripLengthSelector.js
angular.module('base')

/**
 * @name        tripLengthSelector
 * @description Box for choosing trip lenght
 */
.directive('tripLengthSelector', ['$timeout', function ($timeout) {
return {
    restrict: 'A',
    require: '^ngModel',

    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },

    scope: {
      /**
       * min value for trip days range
       */
      tripMin: '@',

      /**
       * max value fro trip days range
       */
      tripMax: '@',

      /**
       * callback after model update
       */
      postUpdate: '&',

      /**
       * unique ID for instance
       */
      uniqueId: '@',

      /**
       * default selected min value
       */
      defTrimMin: '@',

      /**
       * default selected max value
       */
      defTrimMax: '@',
      /**
       * @type {{trip_length_from: Number, trip_length_to: Number}}
       */
      tripLengthValue: '=?tripLength'
    },
    link: function (scope, element, attrs, ngModel) {
      var data = {};

      scope.formData = {
        trip_length_min: 0,
        trip_length_max: 0
      };

      $timeout(function() //wait for scope refresh
      {
        scope.tripMin = parseInt(scope.tripMin) || 1;
        scope.tripMax = parseInt(scope.tripMax) || 40;

        scope.formData.trip_length_min = parseInt(scope.defTrimMin) || scope.tripMin;
        scope.formData.trip_length_max = parseInt(scope.defTrimMax) || scope.tripMax;

        ngModel.$setViewValue({ min: scope.formData.trip_length_min, max: scope.formData.trip_length_max});

        if (typeof(scope.tripLengthValue) != "undefined") {
          reload({
            min: scope.tripLengthValue.trip_length_from,
            max: scope.tripLengthValue.trip_length_to
          });
        }

        scope.tripLength.refreshOptions();
      });

      var setModel = function () {
        scope.tripLength.refreshOptions();
        data = data || {};
        data.min = scope.formData.trip_length_min;
        data.max = scope.formData.trip_length_max;

        ngModel.$setViewValue(data);

        scope.$parent.$broadcast('tripLength.change');

        if (angular.isFunction(scope.postUpdate)) {
          scope.postUpdate({
            param: data
          });
        }
      };

      scope.status = {
        fromIsOpen: false,
        toIsOpen: false
      };

      scope.tripLength =
      {
        getFrom: function () {
          return parseInt(scope.formData.trip_length_min);
        },

        getTo: function () {
          return parseInt(scope.formData.trip_length_max);
        },

        setFrom: function (value) {
          scope.formData.trip_length_min = parseInt(value);

          if (scope.formData.trip_length_min >= scope.formData.trip_length_max) {
            //MAX must be > than MIN
            scope.formData.trip_length_max = scope.formData.trip_length_min + 1;
          }

          setModel();
        },

        setTo: function (value) {
          scope.formData.trip_length_max = parseInt(value);
          setModel();
        },

        getMin: function () {
          var value = parseInt(scope.tripMin);

          if (isNaN(value)) {
            value = scope.formData.trip_length_min;
          }

          return value;
        },

        getMax: function () {
          var value = parseInt(scope.tripMax);

          if (isNaN(value)) {
            value = scope.formData.trip_length_max;
          }

          return value;
        },

        refreshOptions: function()
        {
          scope.options = [];
          scope.options[0] = _.range(scope.tripLength.getMin(), scope.tripLength.getMax());
          scope.options[1] = _.range(scope.tripLength.getFrom() + 1, scope.tripLength.getMax() + 1);

          scope.$apply();
        },

        refreshFrom: function()
        {
          $timeout(function()
          {
            scope.tripLength.setFrom( scope.formData.trip_length_min );
          });
        },

        refreshTo: function()
        {
          $timeout(function()
          {
            scope.tripLength.setTo( scope.formData.trip_length_max );
          });
        }
      };

      /**
       * Reload values
       *
       * @param {Object} [obj={}]
       * @param {Number} [obj.min]
       * @param {Number} [obj.max]
       */
      function reload(obj) {
        $timeout(function() { //wait for scope refresh
          obj = obj || {};
          data = ngModel.$viewValue;
          scope.formData.trip_length_min = parseInt(obj.min) || parseInt(data.min) || 0;
          scope.formData.trip_length_max = parseInt(obj.max) || parseInt(data.max) || 0;

          scope.tripLength.refreshOptions();
        });
      }

      var tripLengthChangeDestructor = scope.$on('tripLength.reload', function (e, obj) {
        reload(obj);
      });

      if (scope.uniqueId && scope.uniqueId.length > 0) {
        var thisReloadDestructor = scope.$on('tripLength-' + scope.uniqueId + '.reload', function (e, obj) {
          reload(obj);
        });
      }

      scope.$on('$destroy', function () {
        if (angular.isFunction(tripLengthChangeDestructor)) {
          tripLengthChangeDestructor();
        }

        if (angular.isFunction(thisReloadDestructor)) {
          thisReloadDestructor();
        }
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/uiSref.js
angular.module('base')

/**
 * @name        uiSref
 * @description iOs href problem resolver
 */
.directive('uiSref', ['$location', 'RoutingService', 'appConfig', function ($location, RoutingService, AppConfig) {
return {
      restrict: 'A',
      replace: false,
      link: function (scope, element, attr) {
        var eventType = ((AppConfig.isMobile() || AppConfig.isTablet()))? 'touchend' : 'click';

        var eventHandle = function ($event) {
          if (!attr.href || !attr.href.length) return;

          //$event.stopPropagation();
          $event.preventDefault();

          RoutingService.doRedirect(attr.href, 'en');
        };
        angular
          .element(element)
          .bind(eventType, eventHandle);

        scope.$on('$destroy', function () {
          angular
            .element(element)
            .unbind(eventType, eventHandle);
        });
      }
    };
  }]
);
;

// Source: ../shared/public_html/assets/js/base/directives/uploader/uploader.js
angular.module('base')

.controller('fileUploaderCtrl', ['$scope', 'UploaderSrv','$timeout', function($scope, UploaderSrv,$timeout) {
var uploadUrl = "/api/uploads/file/"+$scope.upload;
    $scope.files = [];
    $scope.uploadError = false;
    $scope.uploadSuccess = false;

    $scope.uploadFile = function(event) {
      $scope.$apply(function($scope)
      {
        for (var i = 0; i < event.target.files.length; i++)
        {
          $scope.uploadError = false;
          $scope.uploadSuccess = false;

          UploaderSrv.uploadFile(event.target.files[i], uploadUrl).then(function success(resp)
          {
            $scope.updateFilesData(resp);
            $scope.uploadSuccess = true;

            if($scope.$parent.messageError)
            {
              $scope.$parent.messageError = false;
            }

            $timeout(function(){
              $scope.uploadSuccess = false;
            },4000);

          }, function error(resp)
          {
            $scope.uploadError = true;
            $timeout(function(){
              $scope.uploadError = false;
            },4000);
          });
        }
        $scope.progressVisible = false;
      });
    };

    $scope.removeFile = function(id){
        if (id != undefined) {
          var formData = {
            name : $scope.files[id].name
          };

          UploaderSrv.removeFile(formData).then(function success(resp){
            $scope.files.splice(id, 1);
          });

        }
    };

    $scope.updateFilesData = function(resp)
    {
      $scope.files = [];
      angular.forEach(resp.basket,function(k){
        $scope.files.push(k);
      });
      $scope.$parent.files = $scope.files;
    };

    $scope.loadUploadFiles = function()
    {
      UploaderSrv.showBasket().then(function success(resp){
        $scope.updateFilesData(resp);
      });
    };

}])

/**
* @name        fileUploader
*/
.directive('fileUploader', [function () {
return {
    restrict: 'A',
    controller: 'fileUploaderCtrl',
    link : function(scope,element,attrs){

      var onChange = scope.$eval(attrs.fileUploader);
      var desc = element.bind('change', onChange);

      scope.$on('$destroy', function () {
        desc();
      });

      scope.loadUploadFiles();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/usedLangs.js
angular.module('base')

    /**
     * @name        usedLangs
     * @description Directive for usedLangs
     */
    .directive('usedLangs', function usedLangs() {
var ctrl = ['$scope', '$translate', '$modal', 'appConfig', function ($scope, $translate, $modal, AppConfig) {

            $scope.getSize = function (obj) {
                var size = 0, key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) size++;
                }
                return size;
            };

            $scope.showLangs = function () {
                $scope.phrases = _allLangs;
                $scope.phrases.all = angular.extend({}, $scope.phrases.translated, $scope.phrases.untranslated);

                $scope.allTabs = {
                    all: {
                        heading: 'All',
                        amount: $scope.getSize($scope.phrases.all),
                        phrases: $scope.phrases.all
                    },
                    translated: {
                        heading: 'Translated',
                        amount: $scope.getSize($scope.phrases.translated),
                        phrases: $scope.phrases.translated
                    },
                    untranslated: {
                        heading: 'Untranslated',
                        amount: $scope.getSize($scope.phrases.untranslated),
                        phrases: $scope.phrases.untranslated
                    }
                };

                $modal.open({
                    animation: true,
                    windowClass: 'usedLangsModal',
                    templateUrl: 'tpl/show/jsShared/templates/base/directives/usedLangs/showLangs'
                });
            };
        }];

        return {
            restrict: 'E',
            templateUrl: 'tpl/show/jsShared/templates/base/directives/usedLangs/usedLangs',
            transclude: true,
            replace: true,
            controller: ctrl
        };
    });
;

// Source: ../shared/public_html/assets/js/base/directives/userBar.js
angular.module('base')

/**
 * @name        userBar
 * @description
 */
.directive('userBar', function () {
return {
    restrict: 'EA',
    templateUrl: '/tpl/show/jsShared/templates/user/directives/userBar',
    replace: true,
    controller: ['$scope', 'AuthService', '$rootScope', 'RoutingService', 'ModalHelper', 'AuthService2', 'AuthGuard', function ($scope, AuthService, $rootScope, RoutingService, ModalHelper, AuthService2, AuthGuard) {
      $scope.fareAlerts = function () {
        var tempRedirect = _js_app_config_.translateRoutes.fareAlerts;
        if ($rootScope.auth && $rootScope.auth.newsletterToken) {
          tempRedirect += '/' + $rootScope.auth.newsletterToken;
        }
        RoutingService.doRedirect(tempRedirect, 'en');

      };

      $scope.logout = function () {
        AuthService2.logout().then(function() {
          AuthService.logout().then(function() {
            AuthGuard.redirectToMainPage();
          });
        });
      };
    }]
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/userNotifications.js
angular.module('base')

/**
 * @name        userNotifications
 * @description directive for backing to old view bar - box on top
 */
.directive('userNotifications', function () {
return {
    restrict: 'EA',
    controller: ['$scope', '$rootScope', '$localStorage','$modal', 'appConfig', '$filter', function ($scope, $rootScope, $localStorage, $modal, appConfig, $filter) {
      var  device = appConfig.getDeviceType();

      if(!$localStorage.userNotificationsClosed){

        var lang = $filter('translate')('LANGM_JS_NAVBAR_NOTICE');
        lang == 'LANGM_JS_NAVBAR_NOTICE' || lang.length < 4 ? $rootScope.userNotifications = false : $rootScope.userNotifications = true;

        if((device.tablet || device.mobile) && $rootScope.userNotifications){
          $rootScope.userNotifications = false;
            var modalInstance = $modal.open({
              size: 'sm',
              templateUrl: 'noticeModal.html',
              controller: 'noticeModalCtrl'
            })
          }
        else{
          $scope.closeUserNotificationsInfo = function () {
            $rootScope.userNotifications = false;
            $localStorage.userNotificationsClosed = true;
            $localStorage.$apply();
          };
        }

      }
    }]
  };
})


.controller('noticeModalCtrl', ['$scope','$modalInstance','$localStorage', function($scope, $modalInstance, $localStorage){
  $scope.understood = function(){
    $localStorage.userNotificationsClosed = true;
    $localStorage.$apply();
    $modalInstance.dismiss('cancel');
  }
}]);
;

// Source: ../shared/public_html/assets/js/base/directives/voInputMask.js
angular.module('base')

/**
 * @name        voInputMask
 * @description allow type only valid characters
 */
.directive('voInputMask', function ()
{
var allowedKeysRegex = null;
  var keydownFunction = function(e){
    var s = String.fromCharCode(e.charCode);
    if (e.charCode != 0 && allowedKeysRegex !== null && !s.match(allowedKeysRegex))
    {
      e.preventDefault();
    }
  };

  return {
    restrict: 'A',
    replace: false,
    link: function (scope, element, attr)
    {
      switch(attr.type) {
        case 'numeric':
          allowedKeysRegex = new RegExp('[0-9]{1}');
          element.bind('keypress', keydownFunction); //keypress, because keydown and keyup doesn't set charCode
          break;
      }

      scope.$on('$destroy', function() {
        element.unbind('keypress', keydownFunction);
      });
    }
  };
});
;

// Source: ../shared/public_html/assets/js/base/directives/voModal.js
angular.module('base')

/**
 * @name        voModal
 * @description create modal by textbox id
 */
.directive('voModal', ['$compile', '$modal', 'TextBox', function ($compile, $modal, TextBox) {
return {
      restrict: 'A',
      replace: false,
      link: function (scope, element, attr) {
        var textboxId = attr.voModal;
        var modalInstance = null;

        var HTML = {
          START: '<div class="modal-body no-padding-imp">',
          END: '</div>',
          CONTENT: '<div class="close-button" ng-click="hide();">✕</div>'
        };

        var loadTextBox = function ($name, $callback)
        {
          TextBox.getByName($name).then(
            function (textBox) {
              var htmlTmp = HTML.START + HTML.CONTENT + textBox.text + HTML.END;
              $compile(htmlTmp)(scope);
              $callback(htmlTmp);
            },
            function (failure) {
              console.log('something went wrong', failure);
            }
          );
        };

        var clickEventFn = function ($event)
        {
          loadTextBox(textboxId, function (textBoxContent)
          {
            modalInstance = $modal.open({
              template: textBoxContent,
              controller: 'flightsFormErrorsModalCtrl',
              size: 'lg',
              resolve: {
                errors: function () {
                  return [];
                }
              }
            });
          });
        };

        element.bind('click', clickEventFn);

        scope.$on('$destroy', function () {
          element.unbind('click', clickEventFn);
        });
      }
    };
  }]
);
;

// Source: ../shared/public_html/assets/js/base/directives/voSelect.js
angular.module('base')

  .directive('voSelect', [function(){

    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        options: '=options'
      },
      templateUrl: function (element, attrs) {
        return attrs.template ? attrs.template : '/tpl/show/jsShared/templates/base/directives/forms/customSelect';
      },

      link: function(scope,el,attr,ngModel){

        var $id = 'vo-select-' + Math.random(),
          blockHiding = false;

        el.attr('vo-select', $id);

        _.defer(function(){
          scope.selected = ngModel.$viewValue ? scope.options[ngModel.$viewValue] : scope.options[0];
        });

        var openSelect = function ()
        {
          return el.addClass('selecting');
        };

        var closeSelect = function ()
        {
          el.removeClass('selecting')
        };

        var hasSelectOpen = function ()
        {
          return el.hasClass('selecting');
        };

        var toggleSelecting = function ()
        {
          hasSelectOpen() ? closeSelect() : openSelect();
        };

        el.bind('touchend click' ,function(){

          if(blockHiding){
            blockHiding = false;
            return;
          }

          toggleSelecting();
        });

        el.bind('touchmove' ,function(){
          blockHiding = true;
        });


        scope.$watch(function () {
          return ngModel.$viewValue;
        }, function(){

          scope.selected = ngModel.$viewValue ? scope.options[ngModel.$viewValue] : scope.options[0];
        });

        scope.select = function(key){
          scope.selected = scope.options[key];
          ngModel.$setViewValue(key);
        };

        var getBody = function ()
        {
          return angular.element(document.getElementsByTagName('body')[0]);
        };

        var isInsideSelect = function (element)
        {
          var isInside = false;

          while (element && element.tagName != 'BODY')
          {
            if (element.hasAttribute('vo-select') && element.getAttribute('vo-select') == $id)
            {
              isInside = true;
              break;
            }

            element = element.parentNode;
          }
          return isInside;
        };

        var bindUnClickFn = function ($event)
        {
          var target = $event.target;

          if (!isInsideSelect(target))
          {
            closeSelect();
          }
        };

        getBody().bind('touchend click', bindUnClickFn);

        scope.$on('$destroy', function() {
          getBody().unbind('touchend click', bindUnClickFn);
        });

      }
    }

  }]);;

// Source: ../shared/public_html/assets/js/base/directives/voStopEvent.js
angular.module('base')

  /**
   * @name        voStopEvent
   * @description stop event propagation
   */
  .directive('voStopEvent', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        element.on(attr.stopEvent, function (e) {
          e.stopPropagation();
        });
      }
    };
  });;

// Source: ../shared/public_html/assets/js/base/directives/voTooltip.js
angular.module('base')

.directive('voTooltip', [function(){

  return {
    restrict: 'A',
    link: function(scope, el, attr){

      var tooltipBody = el[0].querySelector('.tooltip-body');
      var $tooltipBody = angular.element(tooltipBody);

      function setPos(top, right, bottom, left){
        var sides = {
          "top": typeof top !== 'undefined' ?  top : false,
          "right": typeof right !== 'undefined' ?  right : false,
          "bottom": typeof bottom !== 'undefined' ?  bottom : false,
          "left": typeof left !== 'undefined' ?  left : false
        };

        _.each(sides, function(value, key){
          if(value){
            $tooltipBody.css(key, '-' + parseInt(value) + "px");
          }
        });
      }

      el.on('mouseenter', function(){

        if($tooltipBody.hasClass('tooltip-top')){
          setPos(tooltipBody.offsetHeight, false, false, tooltipBody.offsetWidth/2);
        }
        else if($tooltipBody.hasClass('tooltip-bottom')){
          setPos(false, false, tooltipBody.offsetHeight, tooltipBody.offsetWidth/2);
        }
        else if($tooltipBody.hasClass('tooltip-left')){
          setPos(tooltipBody.offsetHeight/2, false, false, tooltipBody.offsetWidth);
        }
        else if($tooltipBody.hasClass('tooltip-right')){
          setPos(tooltipBody.offsetHeight/2, tooltipBody.offsetWidth, false, false);
        }
      });

    }
  }

}]);;

// Source: ../shared/public_html/assets/js/base/directives/voTooltipTrigger.js
angular.module('base')



.directive('voTooltipTrigger', ['appConfig', function(appConfig){
return {
    restrict: 'A',
    link: function(scope,element,attr){
      var device = appConfig.getDeviceType();

      if(device.tablet || device.mobile){
        scope.trigger = 'touchstart';
        scope.placement = 'top'
      }
      else{
        scope.trigger = 'mouseenter';
        scope.placement = 'bottom'
      }
      scope.isOpen = false;

      var setOpen = function(){
        scope.isOpen = true;
      };

      var setClose = function(){
        scope.isOpen = false;
      };

      angular.element(element).bind('touchstart',setOpen);
      angular.element(element).bind('touchend',setClose);


      scope.$on('$destroy', function () {

        angular
          .element(element)
          .unbind('touchstart', setOpen);

        angular
          .element(element)
          .unbind('touchend', setClose);

      });
    }
  }
}]);;

// Source: ../shared/public_html/assets/js/base/directives/voTouch.js
angular.module('base')

/**
 * @name        voTouch
 * @description bind touch event
 */
.directive('voTouch', function () {
return {
      restrict: 'A',
      replace: false,
      link: function (scope, element, attr) {
        var eventType = attr.voTouchEvent || 'touchstart';
        var eventCondition = attr.voTouchCondition || 'true';


        var isDevice = function is_touch_device()
        {
          return _js_app_config_.device.tablet || _js_app_config_.device.mobile;
        };

        var handleStart = function ($event) {
          if (!scope.$eval(eventCondition)) return;
          scope.$eval(attr.voTouch, {$event: $event});
        };
        angular
          .element(element)
          .bind(eventType, handleStart);


        if(attr.disableEvent && isDevice()){

          _.defer(function()
          {
            angular
              .element(element)
              .unbind(attr.disableEvent);
          });
        }

        scope.$on('$destroy', function () {
          angular
            .element(element)
            .unbind(eventType, handleStart);
        });
      }
    };
  }
);
;

// Source: ../shared/public_html/assets/js/base/directives/wgslider.directive.js
(function(angular) {
/**
   * @name WgSliderDirective
   * @description Directive for jumbotron.
   * @constructor
   * @author Piotr Slosarz <piotr.slosarz@fru.pl>
   */
  var WgSliderDirective = function(WgSliderService) {

    /**
     * Slide changing time.
     * 
     * @type {number}
     */
    var SLIDE_CHANGING_TIME = 500;
    
    /**
     * Slide change time.
     *
     * @type {number}
     */
    var SLIDE_CHANGE_TIME = 5000;

    /**
     * Disable frozen height.
     *
     * @type {?number}
     */
    var DISABLE_FROZEN_HEIGHT = null;

    return {
      restrict: 'A',
      replace: false,
      priority: 1000,
      controller: 'WgSliderController',
      link: function (scope, element, attr, ctrl) {
        SLIDE_CHANGE_TIME = scope.wgSliderChangeTime || _js_app_config_.wgSliderRotatingTime  || SLIDE_CHANGE_TIME;
        DISABLE_FROZEN_HEIGHT = scope.wgSliderDisableFrozenHeight || DISABLE_FROZEN_HEIGHT;

        ctrl.init(element);

        /**
         * Parent node.
         *
         * @type {Object}
         */
        var parentNode = element[0];

        /**
         * State of slide change action.
         * Truthy when slide change is in progress.
         * 
         * @type {boolean}
         */
        scope.isMoveAction = false;

        /**
         * Action change to previous slide.
         */
        scope.moveLeft = function () {
          if (scope.isMoveAction) {
            return;
          }
          WgSliderService.changerActiveElement(element, scope, scope.currentActive - 1, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT);
        };

        /**
         * Action change to next slide.
         */
        scope.moveRight = function () {
          if (scope.isMoveAction) {
            return;
          }
          WgSliderService.changerActiveElement(element, scope, scope.currentActive + 1, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT);
        };

        /**
         * Mouse click event handler.
         *
         * @param {Object} $event
         */
        var clickEventFn = function ($event) {
          var target = $event.target;
          var newActive = +target.getAttribute('wg-slide-index');

          if (!newActive) return;

          WgSliderService.changeSlide(element, scope.currentActive, newActive, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT);
          WgSliderService.changeParams(scope.params, newActive);

          scope.currentActive = newActive;
        };

        WgSliderService.bindMouseOnControl(element, clickEventFn);

        /**
         * Slides autochanger destructor.
         *
         * @type {function}
         */
        var autoChangerDestructor = WgSliderService.autoChanger(scope, element, parentNode, SLIDE_CHANGING_TIME, SLIDE_CHANGE_TIME, DISABLE_FROZEN_HEIGHT);

        scope.$on('$destroy', function () {
          WgSliderService.unbindMouseOnControl(element, clickEventFn);
          autoChangerDestructor();
        });
      }
    };
  };

  WgSliderDirective.$inject = [
    'WgSliderService'
  ];

  angular.module('base').directive('wgSlider', WgSliderDirective);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/filters/camelCase.js
angular.module('base')

/**
 * @name        capitalizeWords
 * @description Filter that capitalizes first letter of each word
 *
 * @return {String}
 */
.filter('camelCase',
[function camelCase() {
  return function (str, scope) {
    return str
      .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/\s/g, '')
      .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/filters/capitalizeWords.js
angular.module('base')

/**
 * @name        capitalizeWords
 * @description Filter that capitalizes first letter of each word
 *
 * @return {String}
 */
.filter('capitalizeWords',
[function capitalizeWords()
{
  var displayError = function(error)
  {
    console.error('Bad value for capitalizeWords. This is not a string: ', error);
  };
  var isInvalidDate = function(date)
  {
    return angular.isDate(date) && isNaN(date.getTime());
  };

  return function(input, scope)
  {
    if (!input || isInvalidDate(input)) input = '';

    var isString = angular.isString(input);

    if (input && isString)
    {
      input = input.toLowerCase();

      // This regex will match words containing letters from the Latin, Greek, Cyrillic, and CJK blocks
      const regex = /[\u0041-\u007A\u00C0-\u00FF\u0100-\u017F\u0400-\u04FF\u4E00-\u9FFF]+\S*/gu;

      return input.replace(regex, function(str)
      {
        return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
      });
    }
    else if(!isString)
    {
      displayError(JSON.stringify(input));
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/currency.js
angular.module('base')

  /**
   * @name        currencySymbol
   * @description Filter for returning currency symbol
   */
  .filter('currencySymbol',
    ['appConfig',
      function (appConfig) {
return function (input, code) {
          var currencies = appConfig.getCurrencies();

          if (code == 'general') {
            code = appConfig.getGeneralCurrency();
          }

          return input + currencies.currency[code]['symbol'];
        };
      }]);
;

// Source: ../shared/public_html/assets/js/base/filters/currencySymbolStatic.js
(function (angular) {
/**
   * Static map: currency code to symbol
   * @type object
   */
  var currencyMap = {
    'EUR': '€',
    'PLN': 'zł'
  };

  /**
   * @name currencySymbolStatic
   * @description Change currency code into symbol using static map
   * @author Łukasz Podolski <lukasz.podolski@fru.pl>
   */
  var currencySymbolStatic = function () {
    return function (currencyCode, fallback) {
      return currencyMap[currencyCode] || fallback || currencyCode;
    };
  };

  angular.module('base').filter('currencySymbolStatic', currencySymbolStatic);

})(angular);
;

// Source: ../shared/public_html/assets/js/base/filters/dateFilters.js
(function (angular) {
/**
   * @name
   * @description .
   * @constructor
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var filterDays = function () {

    /**
     * filter posible day number  in select form (like birthday select ).
     *
     * @param {array <{dayId,dayName}>} datetime
     * @param {<birthDate>} format {year, month, day}
     * @returns {array<{dayId,dayName}>}
     */
    return function (dayArray, birthDate) {
      if (!dayArray || !birthDate) {
        return [];
      }
      var birthDateMonth = birthDate.month || 1;
      var birthDateYear = birthDate.year || 1980;
      var birthDateDay = birthDate.day || 1;

      var date = moment([birthDateYear, birthDateMonth - 1, birthDateDay]);
      var maxDays = date.daysInMonth();

      return dayArray.filter(function (day) {
        var condition = day.dayId <= maxDays;
        return condition;
      })
    };
  };

  angular.module('base').filter('filterDays', filterDays);
})(angular);;

// Source: ../shared/public_html/assets/js/base/filters/datetime.filter.js
(function(angular) {
/**
   * @name DateTimeFilter
   * @description Filter for date and time.
   * @constructor
   * @author Michal Czudowski <michal.czudowski@fru.pl>
   */
  var DateTimeFilter = function (DateTimeFactory) {
    
    /**
     * Format date and time.
     *
     * @param {string} datetime
     * @param {string} format
     * @returns {string}
     */
    return function (datetime, format) {
      var dt = new DateTimeFactory(datetime);
      return dt.format(format);
    };
  };
    
  DateTimeFilter.$inject = ['DateTimeFactory'];

  angular.module('base').filter('datetime', DateTimeFilter);
})(angular);;

// Source: ../shared/public_html/assets/js/base/filters/daysNumberFileter.js
(function (angular) {
/**
   * @name daysNumberName
   * @description add day/days sufix
   * @constructor
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var daysNumberName = function ($filter) {

    /**
     * filter posible day number  in select form (like birthday select ).
     *
     * @param {number} day number
     * @returns {string}
     */
    var translate =  $filter('translate');
    var dayString = translate('LANGM_JS_DAY_1');
    var daysString  = translate('LANGM_JS_DAY_2_4');
    return function (day) {
      var name = day === 1 ? dayString : daysString;
      return day + ' ' + name;
    };
  };

  daysNumberName.$inject = ['$filter'];

  angular.module('base').filter('daysNumberName', daysNumberName);
})(angular);;

// Source: ../shared/public_html/assets/js/base/filters/dimensions.js
angular.module('base')

/**
 * @name        dimensions
 * @description Display multiple dimensions in a human-readable form (W x H x D unit)
 */
.filter('dimensions',
[
  function () {
return function (dimensions, unit) {
      unit = ' ' + unit || '';
      var value = (_.isArray(dimensions)) ? dimensions.join(' x ') : dimensions;

      return value + unit;
    };
  }]);

;

// Source: ../shared/public_html/assets/js/base/filters/findOne.js
angular.module('base')

/**
 * @name        findOne
 * @description Filter to find first matching element from collection
 */
.filter('findOne',
['$filter',
  /**
   * Returns filter function
   *
   * @param $filter {Function}
   * @returns {Function}
   */
    function ($filter) {
/**
     * Returns first matching element
     *
     * @param {Array} array - The source array
     * @param {String|Object|Function} expression - The predicate to be used for selecting items from array
     * @param {Boolean|Function} [comparator] - Comparator which is used in determining if the expected value (from the filter expression) and actual value (from the object in the array) should be considered a match.
     *
     * @returns {*}
     */
    return function (array, expression, comparator) {
      var result = $filter('filter')(array, expression, comparator);

      if (result) {
        return result[0];
      }
    };
  }]);

;

// Source: ../shared/public_html/assets/js/base/filters/flDates.js
angular.module('base')

    /**
     * Default configuration for dates used in home search panel
     *
     * @type {Object}
     */
    .constant('DATES_CONFIG',
    {
        FORMAT: {
            DATE: 'YYYY-MM-DD',
            NICEDATE: "DD MMMM YYYY",
            ONLYDAY: "DD",
            ONLYMONTH: "MMMM",
            ONLYDAYNAME: "dddd",
            NAVBARSHORT: "DD MMM",
            DOTDATE: 'DD.MM.YYYY'
        }
    })

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('dateFormat',
    ['DATES_CONFIG',
        function dateFormat(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.DATE);
            };
        }])

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('niceDateFormat',
    ['DATES_CONFIG',
        function niceDateFormat(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.NICEDATE);
            };
        }])

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('onlyDay',
    ['DATES_CONFIG',
        function onlyDay(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.ONLYDAY);
            };
        }])

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('onlyMonth',
    ['DATES_CONFIG',
        function onlyMonth(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.ONLYMONTH);
            };
        }])

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('onlyDayName',
    ['DATES_CONFIG',
        function onlyDayName(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.ONLYDAYNAME);
            };
        }])

    /**
     * Format date in the default format
     *
     * @param  {Object} DATES_CONFIG The configuration constant
     * @return {String}
     */
    .filter('navbarShort',
    ['DATES_CONFIG',
        function navbarShort(DATES_CONFIG) {
return function (ts) {
                return moment(ts).format(DATES_CONFIG.FORMAT.NAVBARSHORT);
            };
        }])

   
    .filter('objDateFormat', ['DATES_CONFIG', function (DATES_CONFIG) {
/**
         * Format date object in desired format.
         *
         * @param {Object} dateObj
         * @param {String} format
         *
         * @returns {String}
         */
        return function (dateObj, format) {
            if (!dateObj || !(dateObj instanceof Object)) {
                return null;
            }

            // Make sure we have a default format
            var dateFormat = format || DATES_CONFIG.FORMAT.DOTDATE;

            // Set moment and format
            var formattedDate = moment()
                .year(+dateObj.year)
                .month(+dateObj.month)
                .date(+dateObj.day)
                .format(dateFormat);
            
            return formattedDate;
        };
    }]);;

// Source: ../shared/public_html/assets/js/base/filters/flKilometers.js
angular.module('base')

/**
 * @name        flKilometers
 * @description Filter for adding meters or transform meters into kilometers
 */
  .filter('flKilometers',
[
function () {
/**
   * Add meters or transform meters into kilometers
   *
   * @param {Number} input
   *
   * @return {Number}
   */
  return function (input, decimals) {
    if (!input) {
      input = 0;
    }

    function isInteger(x) {
      return Math.round(x) === x;
    }

    var raport = isInteger(Number(input / 1000)) ? (input / 1000) : (input / 1000).toFixed(decimals);

    return input < 1000 ? input + ' m' : raport + ' km';
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/filters/flPrice.js
angular.module('base')

  /**
   * @name flPrice
   * @description Filter for returning price with toFixed decimal points.
   * @param {appConfig} appConfig
   * @param {PriceFactory.Price} Price
   * @returns {String}
   */
  .filter('flPrice', ['appConfig', 'Price', function (appConfig, Price) {
/**
     * Round number to x decimal numbers
     *
     * @param {Number} input
     * @param {Number} [toFixed=0] The number greater or equal to zero
     * @param {String} [format=%price% %currency%]
     * @param {String} forcedCurrency
     * @param {Number} forcedExRate
     *
     * @return {String}
     */
    return function (input, toFixed, format, forcedCurrency, forcedExRate) {
      var price = new Price(input, toFixed, format, forcedCurrency, forcedExRate);
      return price.getValueStringFormatted();
    };
}])

  /**
   * @name        roundPrice
   * @description Filter for returning price with floating point number precision.
   */
  .filter('roundPrice',
    [function () {
/**
       * Increase number precision
       *
       * @param {Number} input
       *
       * @return {Number}
       */
      return function (number) {

        /**
         * @param number
         * @param precision
         *
         * @returns {number}
         */
        var multiple = function (number, precision) {
          var at = Math.pow(10, String(number).length - String(number).indexOf('.') - 1),
            bt = Math.pow(10, String(precision).length - String(precision).indexOf('.') - 1);
          return (number * at) * (precision * bt) / (at * bt);
        };

        return Math.round(multiple(number, 100)) / 100;
      };
    }]);
;

// Source: ../shared/public_html/assets/js/base/filters/flPriceDifference.js
angular.module('base')

/**
 * @name        flPriceDifference
 * @description Filter for returning a signed number with toFixed decimal points
 */
.filter('flPriceDifference',
['appConfig',
function (appConfig) {
/**
   * Round number to x decimal numbers
   *
   * @param  {Number} input
   * @param  {Number} toFixed
   *
   * @return {Number}
   */
  return function (input, toFixed) {
    toFixed = toFixed || 0;

    // Defensive codding
    if (!input) {
      input = 0;
    } else {
      input = (toFixed === 0) ? Math.round(input) : input.toFixed(toFixed);
    }

    var sign = (input >= 0) ? '+' : '';

    return sign + input + ' ' + appConfig.getCurrencySymbol(true);
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/flPriceVal.js
angular.module('base')

  /**
   * @name flPriceVal
   * @description Filter for returning price with toFixed decimal points without currency symbol.
   * @param {appConfig} appConfig
   * @param {PriceFactory.Price} Price
   * @returns {String}
   */
  .filter('flPriceVal', ['appConfig', 'Price', function (appConfig, Price) {
/**
     * Round number to x decimal numbers
     *
     * @param {Number} input
     * @param {Number} [toFixed=0] The number greater or equal to zero
     *
     * @return {String}
     */
    return function (input, toFixed) {
      var price = new Price(input, toFixed);
      return price.getValueString();
    };
}]);
;

// Source: ../shared/public_html/assets/js/base/filters/formatDuration.js
angular.module('base')

/**
 * @name        formatDuration
 * @description Format a duration (in minutes) as xh ym
 */
.filter('formatDuration',
[
/**
 * Returns filter function
 *
 * @returns {Function}
 */
  function () {
/**
   * Format duration (in minutes) as xh ym
   *
   * @param  {duration}
   * @param  {Boolean}  [hideNoHours=false]
   * @param  {String}   hourUnit
   * @return {String}   minuteUnit
   */
  return function (duration, hideNoHours, hourUnit, minuteUnit) {
    hideNoHours = hideNoHours || false;
    hourUnit = hourUnit || 'h';
    minuteUnit = minuteUnit || 'm';

    var _hours, _minutes, _strTime = '';

    _hours = Math.floor(duration / 60);
    if (!hideNoHours || _hours > 0) {
      _strTime += _hours + hourUnit + ' ';
    }

    _minutes = duration - _hours * 60;
    _strTime += _minutes + minuteUnit;

    return _strTime;
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/filters/formatSecondsSinceMidnight.js
angular.module('base')

/**
 * @name        formatSecondsSinceMidnight
 * @description Format seconds since midnight as hh:mm or hh:mm:ss
 */
.filter('formatSecondsSinceMidnight',
[
/**
 * Returns filter function
 *
 * @returns {Function}
 */
  function () {
/**
   * Format seconds since midnight as hh:mm or hh:mm:ss
   *
   * @param  {Number}  secondsSinceMidnight
   * @param  {Boolean} [withSeconds=false]
   * @return {String}
   */
  return function (secondsSinceMidnight, withSeconds) {
    withSeconds = withSeconds || false;

    var _hours, _minutes, _seconds = '', _strTime = '';

    _hours = Math.floor(secondsSinceMidnight / 3600);
    _strTime += _hours < 10 ? '0' + _hours + ':' : _hours + ':';
    _minutes = Math.floor((secondsSinceMidnight - _hours * 3600) / 60);
    _strTime += _minutes < 10 ? '0' + _minutes : _minutes;

    if (withSeconds) {
      _seconds = (secondsSinceMidnight - _hours * 3600 - _minutes * 60);
      _strTime += _seconds < 10 ? ':0' + _seconds : ':' + _seconds;
    }

    return _strTime;
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/int.js
angular.module('base')

/**
 * @name        int
 * @description Cast to integer
 */
.filter('int',
[
function () {
/**
   * Cast to integer
   *
   * @param  {Number} input
   *
   * @return {Number}
   */
  return function (input) {
    return parseInt(input);
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/filters/langPluralize.js
angular.module('base')

/**
 * @name        langPluralize
 * @description Filter for setting different langs depending on noun plurals
 */
  .filter('langPluralize', [function () {
return function (lang, count) {
      if (count === 1) {
        return lang + '_1';
      }

      if (count > 1 && count < 5) {
        return lang + '_2_4';
      }

      return lang + 'S';
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/filters/localDateNoYear.js
angular.module('base')

/**
 * Date formats
 *
 * @type {Object}
 */
.constant('LOCAL_DATES_CONFIG',
{
  ro: {
    fullDate: 'EEEE, d MMMM',
    longDate: 'd MMMM',
    mediumDate: "d MMM"
  },
  pl: {
    fullDate: 'EEEE, d MMMM',
    longDate: 'd MMMM',
    mediumDate: "d MMM"
  },
  en: {
    fullDate: 'EEEE, MMMM d',
    longDate: 'MMMM d',
    mediumDate: "MMM d"
  }
})

/**
 * @name        localDateNoYear
 * @description Same as date:'<formatName>' but without the year; formatName
 *              can be fullDate, longDate or mediumDate
 */
.filter('localDateNoYear',
['appConfig', 'LOCAL_DATES_CONFIG', 'dateFilter',
  function (appConfig, LOCAL_DATES_CONFIG, dateFilter) {
return function (input, formatName) {
      var language = appConfig.getLanguageCode().toLowerCase();

      return (formatName in LOCAL_DATES_CONFIG[language]) ?
        dateFilter(input, LOCAL_DATES_CONFIG[language][formatName]) :
        dateFilter(input, formatName);
    };
  }
]);

;

// Source: ../shared/public_html/assets/js/base/filters/moment.js
angular.module('base')

.filter('moment', [function () {
return function (dateString, format) {
    return moment(dateString).format(format);
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/nl2br.js
// nl2br linky-compatible Angular filter
//
// Author: Jordan Becker (https://gist.github.com/habovh)
// Source: https://gist.github.com/habovh/3dcb42d18975375d5247
//
// Sample usage in html template:
// "xxx | nl2br"
// <div ng-bind-html=" YourString | nl2br "></div>

angular.module('base')

.filter('nl2br', ['$sanitize', function ($sanitize) {
var tag = '<br />';
  return function (msg) {
    // ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
    msg = (msg + '').replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, tag + '$1');
    return $sanitize(msg);
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/range.js
angular.module('base')

/**
 * @name        range
 * @description Loop to print numbers for specified range
 *   Example:
 *   <div ng-repeat="x in [1,10] | range">
 {{x}}
 </div>
 */
.filter('range',
[
function () {
return function (range) {
    return _.range(range[0], range[1] + 1);
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/sanitize.js
angular.module('base')

/**
 * @name        trustHtml
 * @description Marks html as trusted
 */
  .filter('sanitize',
  ['$sanitize',
    /**
     * Returns filter function
     *
     * @returns {Function}
     */
      function ($sanitize) {
/**
       * Return seconds since midnight for any date
       *
       * @param  {String} dateStr The date string in format hh:mm:ss or just hh:mm
       * @return {Number}
       */
      return function (text) {
        return $sanitize(text);
      };

    }]);

;

// Source: ../shared/public_html/assets/js/base/filters/secondsSinceMidnight.js
angular.module('base')

/**
 * @name        secondsSinceMidnight
 * @description Return seconds since midnight for any date
 */
.filter('secondsSinceMidnight',
[
/**
 * Returns filter function
 *
 * @returns {Function}
 */
function () {
/**
   * Return seconds since midnight for any date
   *
   * @param  {String} dateStr The date string in format hh:mm:ss or just hh:mm
   * @return {Number}
   */
  return function (dateStr) {
    return _.reduce(dateStr.split(':'), function (memo, value, index) {
      // Cast to integer
      value = +value;

      // Hour
      if (index === 0) {
        return memo + value * 3600;
      }

      // Minute
      if (index === 1) {
        return memo + value * 60;
      }

      // Second
      return memo + value;

    }, 0);
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/filters/truncate-to-words.filter.js
(function (angular) {
/**
   * @name        Truncate to words
   * @description Truncates to certain amount of characters and returns only full words
   * @author Floares Bogdan <bogdan.floares@vola.ro>
   */

  var truncateToWordsFilter = function () {

    return function (text, length) {

      var newText = text.substr(0, length);

      if (text == newText) {
        return newText;
      }

      var words = newText.split(' ');
      words.splice(-1, 1);

      return words.join(' ').replace(/,\s*$/, "") + '...';
    };
  };

  angular.module('base')
    .filter('truncateToWords', truncateToWordsFilter);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/filters/trustHtml.js
angular.module('base')

/**
 * @name        trustHtml
 * @description Marks html as trusted
 */
.filter('trustHtml',
['$sce',
/**
 * Returns filter function
 *
 * @returns {Function}
 */
function ($sce) {
/**
   * Return seconds since midnight for any date
   *
   * @param  {String} dateStr The date string in format hh:mm:ss or just hh:mm
   * @return {Number}
   */
  return function (text) {
    return $sce.trustAsHtml(text);
  };

}]);

;

// Source: ../shared/public_html/assets/js/base/filters/trustSrc.js
angular.module('base')

/**
 * @name        trustSrc
 * @description Marks url as trusted
 */
  .filter('trustSrc',
  ['$sce',
    /**
     * Returns filter function
     *
     * @returns {Function}
     */
      function ($sce) {
/**
       * Return seconds since midnight for any date
       *
       * @param  {String} dateStr The date string in format hh:mm:ss or just hh:mm
       * @return {Number}
       */
      return function (text) {
        return $sce.trustAsResourceUrl(text);
      };

    }]);

;

// Source: ../shared/public_html/assets/js/base/free-rebooking/free-rebooking-basket-banner.component.js
(function (angular) {

    var template = '\
        <div class="orderSummary__table__item orderSummary__table__item--green" ng-if="$ctrl.isVisible()">\
            <strong class="orderSummary__table__product" style="display: flex; gap: 5px;">\
                <translate style="flex: 1; overflow: hidden; text-overflow: ellipsis;">LANGM_JS_FREE_REBOOKING_BASKET</translate>\
                <inline-tooltip placement="left" content="{{ $ctrl.tooltipContent }}" ng-if="$ctrl.tooltipContent !== null">\
                    <svg-icon id="info" class="size--14 color--muted"></svg-icon>\
                </inline-tooltip>\
            </strong>\
            <strong class="orderSummary__table__price" translate>LANGM_JS_FREE_REBOOKING_INCLUDED</strong>\
            <style>.free-rebook-hidden { display: none !important; }</style>\
        </div>\
    ';

    var controller = function (AppConfig, TextBox) {
        this.isVisible = function () {
            return AppConfig.isFreeRebookingFlow();
        };

        this.tooltipContent = null;

        this.$onInit = function () {
            var self = this;

            TextBox
                .getByName('free_rebooking_campaign_modal')
                .then(function (response) {
                    self.tooltipContent = response.text;
                });
        };
    };

    controller.$inject = ['appConfig', 'TextBox'];

    angular.module('base').component('freeRebookingBasketBanner', {
        template: template,
        controller: controller
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/free-rebooking/free-rebooking-fd-banner.component.js
(function (angular) {

    var template = '\
        <div class="basicBox basicBox--slim covid-pax-top-box" style="cursor: pointer;" ng-if="$ctrl.isVisible()" ng-click="$ctrl.openModal()">\
            <div\
                class="basicBox__container"\
                text-box-body="free_rebooking_campaign_fd_banner"\
                show-loader="true">\
            </div>\
            <free-rebooking-modal />\
        </div>\
    ';

    var controller = function (AppConfig, ResponsiveTooltipService) {
        this.isVisible = function () {
            return AppConfig.isFreeRebookingFlow();
        };

        this.openModal = function () {
            ResponsiveTooltipService.open('freeRebookingModal');
        };
    };

    controller.$inject = ['appConfig', 'ResponsiveTooltipService'];

    angular.module('base').component('freeRebookingFdBanner', {
        template: template,
        controller: controller
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/free-rebooking/free-rebooking-modal.component.js
(function (angular) {

    angular.module('base').component('freeRebookingModal', {
        template: '\
            <ith-responsive-tooltip title="{{ \'LANGM_JS_FREE_REBOOKING_MODAL_TITLE\' | translate }}" id="freeRebookingModal">\
                <content>\
                    <div text-box-body="free_rebooking_campaign_modal" show-loader="true"></div>\
                </content>\
            </ith-responsive-tooltip>\
        '
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/free-rebooking/free-rebooking-search-banner.component.js
(function (angular) {

    var template = '\
        <div\
            ng-if="$ctrl.isVisible()"\
            class="ith-alert-box ith-alert-box--success free-rebooking__search-banner"\
            text-box-body="free_rebooking_campaign_search_banner"\
            show-loader="true"\
            ng-click="$ctrl.openModal()">\
        </div>\
        <free-rebooking-modal />\
    ';

    var controller = function (AppConfig, ResponsiveTooltipService) {
        this.isVisible = function () {
            return AppConfig.isFreeRebookingFlow();
        };

        this.openModal = function () {
            ResponsiveTooltipService.open('freeRebookingModal');
        };
    };

    controller.$inject = ['appConfig', 'ResponsiveTooltipService'];

    angular.module('base').component('freeRebookingSearchBanner', {
        template: template,
        controller: controller
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/location-types.constant.js
(function(angular) {
angular
        .module('base')
        .constant('LOCATION_TYPES', {
            CITY: 'CITY',
            AIRPORT: 'AIRPORT',
            COUNTRY: 'COUNTRY'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/mixins/ErrorMixin.js
/*global _: false */

angular.module('base')

/**
 * @name        ErrorMixin
 * @description Mixes with a specified class to add handlers for errors
 */
.factory('ErrorMixin',
[function ErrorMixinFactory() {
return {
    /**
     * Reset errors
     *
     * @return {*}
     */
    resetErrors: function () {
      // We set errors properties to null manually so we
      // don't lose reference to it.
      if (typeof this.errors === 'string') {
        this.errors = null;
        return this;
      }

      _.each(this.errors, function (err, idx, obj) {
        if (_.isArray(err)) {
          _.each(obj[idx], function (err, idx, obj) {
            if (obj[idx] && typeof(obj[idx].resetErrors) == 'function') {
              obj[idx].resetErrors();
            }
          });
        }
        else if (_.isObject(err)) {
          if (obj[idx] && typeof(obj[idx].resetErrors) == 'function') {
            obj[idx].resetErrors();
          }
        }
        else {
          obj[idx] = null;
        }
      });

      return this;
    },

    /**
     * Returns true if object is in error state
     *
     * @return {bool}
     */
    hasErrors: function () {
      return _.reduce(this.errors, function (memo, err) {
        // We need to check for array first. Arrays are objects as well.
        if (_.isArray(err)) {
          // Here we assume that it is an array of objects !
          return memo || _.reduce(err, function (m, e) {
              return m || e.hasErrors();
            }, false);
        }
        else if (_.isObject(err)) {
          return memo || err.hasErrors();
        }
        else {
          return memo || !!err;
        }
      }, false);
    },

    /**
     * Get errors
     *
     * @return {Object}
     */
    getErrors: function () {
      return this.errors;
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/mixins/FormErrorMixin.js
/*global _: false */

angular.module('base')

/**
 * @name        FormErrorMixin
 * @description Mixes with a specified class to add handlers for form errors
 */
.factory('FormErrorMixin',
[function FormErrorMixinFactory() {
return {
    /**
     * Updates AngularJS validity property for fields marked from backend
     *
     * @param {FormController} form
     */
    setFormValidity: function (form) {
      _.each(this.errors, function (value, key) {
        if (_.isObject(value)) {
          if (typeof(value.setFormValidity) == 'function') {
            // Value is of type object and has validation method
            // Set form validity in cascade
            value.setFormValidity(form);
          }
        }
        else if (!_.isArray(value) && value && key in form) {
          form[key].$setValidity('backend', false);
        }
      }, this);
    },

    setServerErrors: function (form, errors) {
      var self = this;
      _.each(errors, function (value, key) {
        if (_.isObject(value)) {
          self.setServerErrors(form, value);
        }
        else if (!_.isArray(value) && value && key in form) {
          form[key].$setValidity('backend', false);
        }
      });
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/models/Amenities.js
angular.module('base')

/**
 * @name        base.Amenities
 * @namespace   base
 * @description Amenities list responsability
 */
.factory('base.Amenities',
['base.Amenity', '$filter',
function AmenitiesFactory(Amenity, $filter) {
/**
   * Amenities constructor
   *
   * @constructor
   * @class Amenities
   */
  var Amenities = function (apiAmenities) {
    /**
     * The object holding all amenities split by types
     * @type {Object}
     */
    this.list = {};

    if (!_.isArray(apiAmenities)) {
      apiAmenities = [];
    }

    _.each(apiAmenities, function (amenityObj) {
      var amenity = new Amenity(amenityObj);

      if (!_.isArray(this.list[amenity.type])) {
        this.list[amenity.type] = [];
      }

      this.list[amenity.type].push(amenity);
    }, this);
  };

  // Add instance methods
  Amenities.prototype = /** @lends Amenities.prototype */ {
    /**
     * Get the first distance amenity
     * @returns {?String}
     */
    getFirstDistance: function () {
      var ds = this.getDistances();
      return ds.length > 0 ? ds[0].name : null;
    },

    /**
     * Get the distance amenities joined
     * @returns {String}
     */
    getDistancesList: function (sorting) {
      var ds = this.getDistances();

      if (ds.length > 1) {
        if ((typeof sorting != 'undefined') && (typeof sorting.type != 'undefined') && (sorting.type == 'distance')) {
          if ((typeof sorting.key != 'undefined') && (typeof ds[0].id != 'undefined') && (parseInt(ds[0].id) != parseInt(sorting.key))) {
            ds.reverse();
          }
        } else {
          ds = $filter('orderBy')(ds, '+text');
        }
      }
      return _.pluck(ds, 'name').join(', ');
    },

    /**
     * Get the hotel amenities
     * @returns {Amenity[]}
     */
    getHotelAmenities: function () {
      return this.list.Facilitati || [];
    },

    /**
     * Get distances amenities
     * @returns {Amenity[]}
     */
    getDistances: function () {
      if(this.list.distancesListMeters){
        return this.list.distancesListMeters;
      }
      return this.list.distancesList || [];
    },

    /**
     * Get pricegroup themes amenities
     * @returns {Amenity[]}
     */
    getPricegroupThemes: function () {
      return this.list.pricegroupThemes || [];
    }
  };

  Amenities.prototype.constructor = Amenities;

  return Amenities;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/Amenity.js
angular.module('base')

/**
 * @name        base.Amenity
 * @namespace   base
 * @description
 */
.factory('base.Amenity',
[
function AmenityFactory() {
/**
   * Amenity constructor
   *
   * @constructor
   * @class Amenity
   */
  var Amenity = function (amenityObj) {

    amenityObj = amenityObj || {};

    /**
     * Id
     * @type {Number}
     */
    this.id = amenityObj.id || 0;

    /**
     * Name
     * @type {String}
     */
    this.name = amenityObj.name || '';

    /**
     * Icon
     * @type {String}
     */
    this.icon = amenityObj.icon || '';

    /**
     * Type
     * @type {String}
     */
    this.type = amenityObj.type || '';

    /**
     * Text
     * @type {String}
     */
    this.text = amenityObj.text || '';
  };

  // Add instance methods
  Amenity.prototype = /** @lends Amenity.prototype */ {};

  Amenity.prototype.constructor = Amenity;

  return Amenity;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/ApiError.js
angular.module('base')

/**
 * @name        ApiError
 * @description Class that holds API error information
 */
.factory('ApiError',
[function ApiErrorFactory() {
  /**
   * ApiError constructor
   *
   * @constructor
   * @class ApiError
   *
   * @param {Object} apiErrorResponse
   */
  var ApiError = function (apiErrorResponse) {
    var response = apiErrorResponse.response || '';

    /**
     * The error constant
     *
     * @type {String}
     */
    this.error = response.error || '';

    /**
     * The error code
     *
     * @type {int}
     */
    this.errorCode = response.error_code || '';

    /**
     * The error message in human readable form or lang constant
     *
     * @type {String}
     */
    this.msg = response.msg || '';

    /**
     * The name of the subsystem that error originated from
     *
     * @type {String}
     */
    this.origin = response.origin || '';

    /**
     * Additional data attached to error response
     *
     * @type {String}
     */
    this.data = response.data || '';
  };

  // Add instance methods
  ApiError.prototype = /** @lends ApiError.prototype */ {

    /**
     * Returns error constant
     *
     * @returns {String}
     */
    getError: function () {
      return this.error;
    },

    /**
     * Returns the error message in human readable form or lang constant
     *
     * @returns {String}
     */
    getMsg: function () {
      return this.msg;
    },

    /**
     * Returns the error code
     *
     * @returns {int}
     */
    getErrorCode: function () {
      return this.errorCode;
    },

    /**
     * Returns the name of the subsystem that error originated from
     *
     * Returns empty string if unknown subsystem
     *
     * @returns {String}
     */
    getOrigin: function () {
      return this.origin;
    },

    /**
     * Returns additional data attached to the error
     *
     * @param {String} key
     * @returns {*}
     */
    getDataByKey: function (key) {
      if (this.data && this.data[key]) {
        return this.data[key];
      }

      return null;
    }
  };

  ApiError.prototype.constructor = ApiError;

  return ApiError;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/ChangeLanguage.js
angular.module('base')

  /**
   * @name        ChangeLanguage
   * @description Modal for changing language and currency
   */
  .factory('ChangeLanguage',
    ['$modal', 'appConfig', function ChangeLanguageFactory($modal, appConfig) {
/**
         * ChangeLanguage constructor
         *
         * @constructor
         * @class ChangeLanguage
         */
        var ChangeLanguage = function()
        {
          this.data = {
            language: appConfig.getUserLanguage(),
            flag: appConfig.getUserLanguage(),
            currency: appConfig.getCurrencyCode(),
            currency_symbol: appConfig.getCurrencySymbol()
          }
        };

        ChangeLanguage.prototype = /** @lends ChangeLanguage.prototype */ {

          setLanguage: function(data){
            this.data.language = data;
          },

          setCurrency: function(data){
            this.data.currency = data;
          },

          getLanguage: function(){
            return this.data.language;
          },

          getCurrency: function(){
            return this.data.currency;
          },

          getData: function(){
            return this.data;
          },

          showChangeLangModal: function(){
            var data = {};
            var self = this;
            var instance = $modal.open({
              templateUrl: 'changeLangModal.html',
              controller: 'ChangeLangModalCtrl',
              size: 'change-lang',
              resolve: {
                selectedData: function(){
                  return self.data;
                }
              }
            });

            instance.result.then(function(selectedData){
              data = selectedData;

              self.setLanguage(data.language);
              self.setCurrency(data.currency);

            });

          }
        };

        ChangeLanguage.prototype.constructor = ChangeLanguage;

        return ChangeLanguage;
      }]);

;

// Source: ../shared/public_html/assets/js/base/models/FavoritesItem.js
angular.module('base')

/**
 * @name        CityHelperItem
 * @namespace   sch
 * @description Factory returning CityHelperItem constructor
 */
.factory('base.FavoritesItem',
[
/**
 * CityHelperItem factory
 *
 * @return {CityHelperItem}
 */
  function FavoritesItemFactory() {

/**
     * CityHelperItem constructor
     *
     * @class CityHelperItem
     * @constructor
     */
    var FavoritesItem = function (data) {

      /**
       * Flight id
       *
       * @type {String}
       */
      this.id = data.id || '';

      /**
       * Number of all paxes
       *
       * @type {Number}
       */
      this.paxes = data.paxes || '';

      /**
       * Title
       *
       * @type {String}
       */
      this.title = data.title || '';

      /**
       * Departure date ( unix timestamp - PHP! )
       *
       * @type {Number}
       */
      this.departure_date = data.departure_date || '';

      /**
       * Arrival date ( unix timestamp - PHP! )
       *
       * @type {Number}
       */
      this.arrival_date = arrival_date || '';

      /**
       * Price
       *
       * @type {Number}
       */
      this.price = data.price || '';

      /**
       * Link to 'See Details'
       *
       * @type {String}
       */
      this.details_link = data.details_link || '';
    };

    // Add instance methods
  FavoritesItem.prototype = /** @lends CityHelperItem.prototype */ {

    /**
     * @returns {String}
     */
    getCode: function () {
      if (this.type === 'a') {
        return this.getAirportCode();
      }
      else if (this.isCountry()) {
        return this.getCountryCode();
      }
      else {
        return this.getCityCode();
      }
    },

    /**
     * Returns airport code
     *
     * @returns {String}
     */
    getAirportCode: function () {
      return this.airport_code;
    },

    /**
     * Returns airport name
     *
     * @returns {String}
     */
    getAirportName: function () {
      return this.airport_name;
    },

    /**
     * Returns city id
     *
     * @returns {Number}
     */
    getCityId: function () {
      return this.city_id;
    },

    /**
     * Returns city code
     *
     * @returns {String}
     */
    getCityCode: function () {
      return this.city_code;
    },

    /**
     * Returns city name
     *
     * @returns {String}
     */
    getCityName: function () {
      return this.city_name;
    },

    /**
     * Returns country code
     *
     * @returns {String}
     */
    getCountryCode: function () {
      return this.country_code;
    },

    /**
     * Returns airport name
     *
     * @returns {String}
     */
    getCountryName: function () {
      return this.country_name;
    },

    /**
     * Returns type
     *
     * @returns {String} One of the a - airport, c - city
     */
    getType: function () {
      return this.type;
    },

    /**
     * Returns language code
     *
     * @returns {String}
     */
    getLanguageCode: function () {
      return this.languageCode;
    },

    /**
     * @returns {Boolean}
     */
    isCountry: function () {
      return this.type === 'c' && this.formatter === 'country_name';
    },

    /**
     * Returns object as string
     *
     * @returns {String}
     */
    toString: function () {
      var string = '';
      switch (this.type + this.formatter) {
        case 'a':
          string += this.city_name + ', ' + this.country_name;
          string += ' - ' + this.airport_name + ' (' + this.airport_code + ')';
          break;

        case 'city_country_name':
          string += this.city_name + ', ' + this.country_name;
          break;

        case 'ccountry_name':
          string += this.country_name;
          break;

        case 'ccity_code':
        case 'acity_code':
          string += this.city_code;
          break;

        case 'acity_name':
        case 'ccity_name':
        case 'city_name':
        case 'only_city':
        case 'aonly_city':
        case 'conly_city':
          string += this.city_name;
          break;

        case 'ccity_airport':
        case 'city_airport':
          string += this.city_name + ', ' + this.country_name + ' (' + this.airport_code + ')';
          break;

        case 'acity_airport':
          string += this.city_name + ', ' + this.airport_name + ' (' + this.airport_code + ')';
          break;

        default:
          string += this.city_name + ', ' + this.country_name;
          string += ' - ' + '(' + this.city_code + ')';
          break;
      }

      return string;
    }
  };

  FavoritesItem.prototype.constructor = FavoritesItem;

  return FavoritesItem;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/Market.js
angular.module('base')
  .factory('Market',
    ['appConfig', function MarketFactory(appConfig) {
var Market = function () {
        this.data = {
          affiliate: appConfig.getAffiliateName().toUpperCase(),
          code: appConfig.getMarket(),
          language: appConfig.getLanguageCode().toUpperCase(),
          currency: appConfig.getCurrencyCode().toUpperCase(),
        };
      };

      Market.prototype = /** @lends Market.prototype */ {
        getData: function () {
          return this.data;
        },
        getAffiliate: function () {
          return this.data.affiliate;
        },
        getLanguage: function () {
          return this.data.language;
        },
        getCurrency: function () {
          return this.data.currency;
        },
      };

      Market.prototype.constructor = Market;

      return Market;
    }]);
;

// Source: ../shared/public_html/assets/js/base/models/Picture.js
angular.module('base')

/**
 * @name        Picture
 * @namespace
 * @description
 */
.factory('Picture',
['appConfig',
function PictureFactory(appConfig) {
/**
   * Picture constructor
   *
   * @constructor
   * @class Picture
   */
  var Picture = function (pictureObj) {

    pictureObj = pictureObj || {};

    /**
     * Filename
     * @type {String}
     */
    this.filename = pictureObj.filename || '';

    /**
     * Description
     * @type {String}
     */
    this.description = pictureObj.description || '';

    /**
     * File path
     * @type {String}
     */
    this.path = pictureObj.path || '';

    /**
     * Is main picture
     * @type {Boolean}
     */
    this.isMain = pictureObj.isMain || false;
  };

  // Add instance methods
  Picture.prototype = /** @lends Picture.prototype */ {

    /**
     * Get filename
     * @return {String} {name}.{jpg|png}
     */
    getFilename: function () {
      return this.filename;
    },

    /**
     * Get the file path
     * @returns {String}
     */
    getPath: function () {
      return this.path;
    },

    /**
     * Get description
     * @returns {String}
     */
    getDescription: function () {
      return this.description;
    },

    /**
     * Get file path
     *
     * @param {Boolean} skipMock
     * @returns {String}
     */
    getFilePath: function (skipMock) {
        return appConfig.getMediaUrl() + '/media/img/' + this.getPath() + '/' + this.getFilename();
    },

    /**
     * Returns TRUE if this picture is main picture of the item
     * @returns {Boolean}
     */
    isMainPicture: function () {
      return this.isMain;
    }
  };

  Picture.prototype.constructor = Picture;

  return Picture;
}]);
;

// Source: ../shared/public_html/assets/js/base/models/Pictures.js
angular.module('base')

/**
 * @name        Pictures
 * @namespace   pkg
 * @description
 */
.factory('Pictures',
['Picture',
function PicturesFactory(Picture) {
/**
   * Pictures constructor
   *
   * @constructor
   * @class Pictures
   */
  var Pictures = function (apiPictures) {
    /**
     * The array of pictures
     * @type {Picture[]}
     */
    this.list = [];

    apiPictures = apiPictures || {};

    _.each(apiPictures.list, function (pictureObj) {
      var picture = new Picture(pictureObj);
      this.list.push(picture);
    }, this);

  };

  // Add instance methods
  Pictures.prototype = /** @lends Pictures.prototype */ {

    getMainPicture: function () {
      var main = _.findWhere(this.list, {isMain: true});

      if (main === undefined && this.list.length > 0)
        main = this.list[0];

      return main;
    },

    /**
     * Get pictures list
     *
     * @returns {Picture[]}
     */
    getPictures: function () {
      return this.list;
    }
  };

  Pictures.prototype.constructor = Pictures;

  return Pictures;
}]);
;

// Source: ../shared/public_html/assets/js/base/models/Price.js
angular.module('base')

  /**
   * @name Price
   * @description price model for handling price presentation
   * @param {appConfig} appConfig
   * @returns {PriceFactory.Price}
   */
  .factory('Price', ['appConfig', function PriceFactory(appConfig) {
var symbols = {
      EUR: '€',
      RON: 'RON',
      PLN: 'zł',
      GBP: '£',
      HUF: 'Ft',
      USD: '$',
      CZK: 'Kč',
      BGN: 'лв',
      ALL: 'Lek',
    };

    /**
     * Price constructor.
     *
     * @constructor
     * @class Price
     * @param {Number} input
     * @param {Number} toFixed
     * @param {String} format
     * @param {String} forcedCurrency
     * @param {Number} forcedExRate
     * @returns {PriceFactory.Price}
     */
    var Price = function(input, toFixed, format, forcedCurrency, forcedExRate) {

      /**
       * Default format.
       *
       * @type {String}
       */
      var defaultFormat = '%price% %currency%';

      /**
       * Price value.
       *
       * @type {Number}
       */
      this.value = input;

      /**
       * Decimal precision.
       *
       * @type {Number}
       */
      this.precision = toFixed || 0;

      /**
       * Currency symbol.
       *
       * @type {String}
       */
      this.currency = symbols[forcedCurrency || appConfig.getCurrencyCode()];

      /**
       * Exchange rate.
       *
       * @type {Number}
       */
      this.exchangeRate = forcedExRate || appConfig.getCurrencyExRate();

      /**
       * Display format.
       *
       * @type {String}
       */
      this.format = format || defaultFormat;

      if(this.format == defaultFormat && (this.currency == '$' || this.currency == '£') ) {
        this.format = '%currency%%price%';
      }
    };

    Price.prototype = {

      /**
       * Get price value.
       *
       * @returns {Number}
       */
      getValue: function() {
        var val = this.value;

        // Defensive codding
        if (!val) {
          val = 0;

          if (this.precision > 0) {
            val = val.toFixed(this.precision);
          }
        }
        else {
          val = val * this.exchangeRate;

          if (this.precision === 0) {
            val = Math.round(val);
          }
          else if (this.precision > 0) {
            var pow = Math.pow(10, this.precision);
            val = Math.round(val * pow) / pow;
            val = val.toFixed(this.precision);
          }
        }

        return val;
      },

      /**
       * Get price value as string.
       *
       * @returns {String}
       */
      getValueString: function() {
        return this.getValue().toString();
      },

      /**
       * Get price value as formatted string.
       *
       * @returns {String}
       */
      getValueStringFormatted: function() {
        var val = this.getValueString();
        return this.format.replace('%price%', val).replace('%currency%', this.currency);
      }

    };

    return Price;
  }]);
;

// Source: ../shared/public_html/assets/js/base/models/Room.js
angular.module('base')

/**
 * @name        base.Room
 * @namespace   base
 * @description Room model for Local Escapes
 */
  .factory('base.Room',
[
function RoomFactory() {
/**
   * Room constructor
   *
   * @constructor
   * @class Room
   */
  var Room = function (roomObj) {

    roomObj = roomObj || {};

    /**
     * Name
     * @type {String}
     */
    this.room_name = roomObj.room_name || '';

    /**
     * Description
     * @type {String}
     */
    this.room_desc = roomObj.room_desc || '';

    /**
     * Image Id
     * @type {Number}
     */
    this.image_id = roomObj.image_id || 0;

    /**
     * Pax bed count
     * @type {Number}
     */
    this.pax_bed_count = roomObj.pax_bed_count || 0;

    /**
     * Pax extra count
     * @type {Number}
     */
    this.pax_extra_count = roomObj.pax_extra_count || 0;

    /**
     * Pax count
     * @type {Number}
     */
    this.pax_count = roomObj.pax_count || 0;

    /**
     * Infants count
     * @type {Number}
     */
    this.infants_count = roomObj.infants_count || 0;
  };

  // Add instance methods
  Room.prototype = /** @lends Room.prototype */ {};

  Room.prototype.constructor = Room;

  return Room;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/SelectableObject.js
angular.module('base')

/**
 * @name        SelectableObject
 * @namespace   base
 * @description Factory returning SelectableObject constructor
 */
.factory('base.SelectableObject',
[
 /**
  * SelectableObject class
  *
  * @return {SelectableObject}
  */
  function SelectableObjectFactory() {

/**
   * SelectableObject constructor
   *
   * @class SelectableObject
   * @constructor
   */
  var SelectableObject = function () {
    /**
     * True if object is selected (on view)
     *
     * @type {Boolean}
     */
    this.selected = false;
  };

  // Add instance methods
  SelectableObject.prototype = /** @lends SelectableObject.prototype */ {

    /**
     * Returns true if object is selected
     *
     * @returns {Boolean}
     */
    isSelected: function () {
      return this.selected;
    },

    /**
     * Mark object as selected or not selected
     *
     * @param {Boolean} [isSelected] if isSelected is not passed, object will be marked as selected
     */
    select: function (isSelected) {
      this.selected = isSelected !== false;
    }

  };

  SelectableObject.prototype.constructor = SelectableObject;

  return SelectableObject;
}]);
;

// Source: ../shared/public_html/assets/js/base/models/SelectableObjects.js
angular.module('base')

/**
 * @name        SelectableObjects
 * @namespace   base
 * @description Factory returning constructor for collection of elements which can be selected (on view)
 */
.factory('base.SelectableObjects',
['$filter',

/**
 * SelectableObjects class
 *
 * @param {Function} $filter
 *
 * @return {SelectableObjects}
 */
  function SelectableObjectsFactory($filter) {
/**
   * SelectableObjects constructor
   *
   * @class SelectableObjects
   * @constructor
   */
  var SelectableObjects = function () {
    /**
     * Selectable objects
     *
     * @type {Object[]}
     */
    this.objects = [];
  };

  /**
   * Angular filter
   *
   * @type {Function}
   */
  var filter = $filter('filter');

  // Add instance methods
  SelectableObjects.prototype = /** @lends SelectableObjects.prototype */ {

    /**
     * Get all objects
     *
     * @return {Object[]}
     */
    get: function () {
      return this.objects;
    },

    /**
     * Get selected objects
     *
     * @returns {SelectableObject[]}
     */
    getSelected: function () {
      return filter(this.get(), function (object) {
        return object.isSelected();
      });
    },

    /**
     * Add object
     *
     * @param {SelectableObject} object
     */
    add: function (object) {
      this.get().push(object);
    },

    /**
     * Mark all objects as selected
     */
    selectAll: function () {
      angular.forEach(this.get(), function (object) {
        object.select();
      });
    },

    /**
     * Returns true if all objects are selected
     *
     * @returns {Boolean}
     */
    allSelected: function () {
      return filter(this.get(), function (object) {
          return !object.isSelected();
        }).length === 0;
    },

    /**
     * Returns true if collection is not empty and all objects are unselected
     *
     * @returns {Boolean}
     */
    allUnselected: function () {
      return !this.isEmpty() && filter(this.get(), function (object) {
          return object.isSelected();
        }).length === 0;
    },

    /**
     * Returns number of objects
     *
     * @return {Number}
     */
    count: function () {
      return this.get().length;
    },

    /**
     * Return true if collection is empty
     *
     * @returns {Boolean}
     */
    isEmpty: function () {
      return this.objects.length === 0;
    },

    /**
     * Clear collection
     */
    clear: function () {
      this.objects.length = 0;
    }

  };

  SelectableObjects.prototype.constructor = SelectableObjects;

  return SelectableObjects;
}]);
;

// Source: ../shared/public_html/assets/js/base/models/SessionExpiration.js
angular.module('base')

/**
 * @name        SessionExpiration
 * @description Class that handles session expiration by displaying a modal
 * @todo        Make it abstract
 */
.factory('SessionExpiration', ['$modal', '$timeout', 'appConfig',
function SessionExpirationFactory($modal, $timeout, appConfig) {
/**
   * SessionExpiration constructor
   *
   * @constructor
   * @class SessionExpiration
   */
  var SessionExpiration = function () {};

  // Private variables
  var
  // Session modal promise
    sessionExpModal,

  // Timeout promise
    sessionExpTimeout;

  // Add instance methods
  SessionExpiration.prototype = /** @lends SessionExpiration.prototype */ {
    /**
     * Displays a session expiration modal
     *
     * @param {Function} callbackMethod Method to be called on modal button click
     */
    trigger: function (callbackMethod) {
      // Create modal instance
      sessionExpModal = $modal.open({
        templateUrl: "/mtpl/modals/sessionExp.html",
        controller: 'SessionExpModalCtrl',
        windowClass: 'datePickModal no-animation-modal',
        backdrop: 'static'
      });

      // Handle communication from modal controller
      sessionExpModal.result.then(function (action) {
        // Callback
        try {
          callbackMethod();
        }
        catch (error) {
          throw "Callback method for session expiration modal is not set!";
        }
      });
    },

    /**
     * Starts a session expiration timeout
     * that triggers a session expiration modal
     *
     * @param {FlightBooking} flightBooking  Flight booking instance
     * @param {Function}      callbackMethod Method to be called on modal button click
     */
    startTimeout: function (flightBooking, callbackMethod) {
      // Check if session expiration is enabled
      if (!appConfig.isCacheActive()) {
        return;
      }

      var
      // Flight details valability
        valability = flightBooking.getFlightDetails().isLowCost() ? appConfig.getLccCacheTime() : appConfig.getGdsCacheTime(),

      // Calculate expiration delay
        expDelay = (valability - flightBooking.getFlightDetails().getRequestAge()) * 1000,

      // This instance reference
        self = this;

      if (expDelay < 0) expDelay = 0;

      // Trigger session expiration modal
      sessionExpTimeout = $timeout(function () {
        self.trigger(callbackMethod);
      }, expDelay);
    },

    /**
     * Cancels the session expiration timeout
     */
    cancelTimeout: function () {
      // Cancel timeout
      $timeout.cancel(sessionExpTimeout);

      // Dismiss modal (if visible)
      if (sessionExpModal) {
        sessionExpModal.dismiss('cancel');
      }
    }
  };

  SessionExpiration.prototype.constructor = SessionExpiration;

  return new SessionExpiration();
}]);

;

// Source: ../shared/public_html/assets/js/base/models/TabsHandler.js
angular.module('base')

/**
 * @name        SearchForm
 * @description SearchForm service to handle the tabs
 */
.factory('TabsHandler', [
function TabsHandlerFactory() {
// Constructor
  var TabsHandler = function () {

    /**
     * The list of tabs
     *
     * @type {Array}
     */
    this.tabs = [];

    /**
     * Selected tab instance
     *
     * @type {Object}
     */
    this.selectedTab = null;

    /**
     * Tabs destroyed flag
     *
     * @type {Boolean}
     */
    this.destroyed = false;

  };

  // Set instance methods
  TabsHandler.prototype = /** @lends TypeAhead.prototype */ {

    /**
     * Select a tab
     *
     * @param tab
     */
    select: function (tab) {

      if (this.selectedTab != null) {
        this.selectedTab.active = false;
        this.selectedTab.onDeselect();
      }

      tab.active = true;
      tab.onSelect();

      this.selectedTab = tab;
    },

    /**
     * Add a tab
     *
     * @param tab
     */
    addTab: function addTab(tab) {
      this.tabs.push(tab);
    },

    /**
     * Set destroyed flag
     *
     * @param flag
     */
    setDestroyed: function (flag) {
      this.destroyed = flag;

      if (flag) {
        this.reset();
      }
    },

    reset: function () {
      this.tabs.length = 0;
      this.selectedTab = null;

      return this;
    },

    /**
     * Select tab by his id
     *
     * @param id
     */
    selectById: function (id) {
      angular.forEach(this.tabs, function (tab) {
        if (tab.id == id) {
          this.select(tab);
        }
      }, this);
    },

    /**
     * Remove a tab
     *
     * @param tab
     */
    removeTab: function removeTab(tab) {
      var index = this.tabs.indexOf(tab);
      //Select a new tab if the tab to be removed is selected and not destroyed
      if (tab.active && this.tabs.length > 1 && !this.destroyed) {
        //If this is the last tab, select the previous tab. else, the next tab.
        var newActiveIndex = index == this.tabs.length - 1 ? index - 1 : index + 1;
        this.select(this.tabs[newActiveIndex]);
      }
      this.tabs.splice(index, 1);
    }
  };

  TabsHandler.prototype.constructor = TabsHandler;

  return TabsHandler;
}]);

;

// Source: ../shared/public_html/assets/js/base/models/datetime.factory.js
(function(angular) {
/**
   * @name DateTimeFactory
   * @description Create datetime model.
   * @constructor
   * @author Michal Czudowski <michal.czudowski@fru.pl>
   */
  var DateTimeFactory = function($filter) {
    
    /**
     * Datetime model.
     * 
     * @param {string} datetime - ISO 8601 datetime string.
     * @constructor
     */
    var DateTime = function(datetime) {
      
      /**
       * ISO 8601 datetime string.
       *
       * @type {string}
       */
      this.date = datetime;
    };
    
    /**
     * Formatting rules.
     *
     * @type {object}
     */
    DateTime.prototype.formatRules = {
        shortMd: 'MMM d',
        fullMd: 'MMMM d'
    };
    
    /**
     * Name of default formatting rule.
     *
     * @type {string}
     */
    DateTime.prototype.formatDefault = 'shortMd';
    
    /**
     * Returns formatted datetime.
     *
     * @param {string} formatName - name of formatting rule.
     * @returns {string}
     */
    DateTime.prototype.format = function(formatName) {
      var format = this.formatRules[formatName] || this.formatRules[this.formatDefault];
      return $filter('date')(this.date, format);
    };
    
    return DateTime;
  };
  
  DateTimeFactory.$inject = ['$filter'];

  angular.module('base').factory('DateTimeFactory', DateTimeFactory);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/models/hotels/Cancellations.js
(function (angular) {
/**
   * @name        htl.Cancellations
   * @description Handles cancellation information for hotels
   * @constructor hotelCancellationsFactory
   * @author Floares Bogdan <bogdan.floares@vola.ro>
   */

  var hotelCancellationsFactory = function ($translate) {
/**
     * Cancellations constructor
     *
     * @class
     * @param {Object} api
     */
    var Cancellations = function (api) {

      api = api || {};

      /**
       * This is true if the price for the room is refundable
       *
       * @type {boolean|*}
       */
      this.refundable = api.refundable || false;

      /**
       * Cancellation rules disclaimer
       *
       * @type {string|*}
       */
      this.disclaimer = api.disclaimer || '';

      /**
       * The cancelattions general description
       *
       * @type {string|*}
       */
      this.generalDescription = api.generalDescription || '';

      /**
       * The cancellations room id
       *
       * @type {*|string}
       */
      this.roomId = api.room_id || '';

      /**
       * Provider id for the cancellation rules
       *
       * @type {*|string}
       */
      this.provider = api.provider || '';

      /**
       * The cancellation rules
       *
       * @type {*|Array}
       */
      this.rules = api.rules || [];
    };

    // Add instance methods
    Cancellations.prototype = /** @lends Cancellations.prototype */ {

      /**
       * Get the policies general description
       *
       * @returns {string|*}
       */
      getGeneralDescription: function () {
        return this.generalDescription;
      },

      /**
       * Get the policies disclaimer
       *
       * @returns {string|*}
       */
      getDisclaimer: function () {
        return this.disclaimer;
      },

      /**
       * Return true if the room price is refoundable
       *
       * @returns {boolean|*}
       */
      isRefundable: function () {
        return this.refundable;
      },

      /**
       * Get rules room id
       *
       * @returns {string}
       */
      getRoomId: function () {
        return this.roomId;
      },

      /**
       * Get rules provider
       *
       * @returns {string}
       */
      getProvider: function () {
        return this.provider;
      },

      /**
       * Get cancellation rules tooltip
       *
       * @param roomName
       * @returns {string}
       */
      getTooltip: function (roomName) {
        var content = [];

        content.push('<strong style="text-size-small">' + roomName + '</strong>');
        _.each(this.rules, function (text, name) {
          text = Array.isArray(text) ? text.join('<br />') : text;
          content.push('<p>' + '<strong>' + $translate.instant('LANGM_JS_HOTELS_' + name + '_LABEL') + '</strong> ' + text + '</p>');
        });

        if (!_.isEmpty(this.getDisclaimer())) {
          content.push('<p class="text-size-xsmall">' + this.getDisclaimer() + '</p>');
        }

        return '<p>' + content.join('</p><p>') + '</p>';
      }
    };

    Cancellations.prototype.constructor = Cancellations;

    return Cancellations;
  };

  hotelCancellationsFactory.$inject = ['$translate'];

  angular.module('base')
    .factory('htl.Cancellations', hotelCancellationsFactory);


})(angular);

;

// Source: ../shared/public_html/assets/js/base/newsletter-box/ith-newsletter-form.api.js
(function(angular) {
/**
     * Service that handles data submit to newsletter API
     */
    var IthNewsletterFormApi = function ($http) {
        /**
         * Newsletter register endpoint URL
         *
         * @type {String}
         */
        var enpointUrl = '/newsletter/addToNewsLetter';

        /**
         * Register email with backend API
         *
         * @param {String} email
         * @returns {Promise}
         */
        this.register = function (email) {
            return $http.post(enpointUrl, { email: email });
        };
    };

    IthNewsletterFormApi.$inject = [
        '$http'
    ];

    angular
        .module('base')
        .service('IthNewsletterFormApi', IthNewsletterFormApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter-box/ith-newsletter-form.component.js
(function(angular) {
var IthNewsletterFormComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/newsletter-form/newsletter-form',
        controller: 'NewsletterFormController'
    };

    angular
        .module('base')
        .component('ithNewsletterForm', IthNewsletterFormComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter-box/ith-newsletter-form.controller.js
(function(angular) {
/**
     * Controller handling form management
     */
    var IthNewsletterFormController = function ($scope, $state, $stateParams, IthNewsletterFormApi, AppConfig, StaticPageHelper) {
        /**
         * Data passed to backend endpoint
         *
         * @type {Object}
         */
        this.formData = {
            /**
             * @type {String}
             */
            email: '',

            /**
             * @type {Boolean}
             */
            terms: false
        };

        /**
         * Form states
         *
         * @type {Object}
         */
        this.formState = {
            /**
             * Form is loading state
             *
             * @type {Boolean}
             */
            isLoading: false,

            /**
             * Form error state
             *
             * @type {Boolean}
             */
            isError: false,

            /**
             * Form success state
             *
             * @type {Boolean}
             */
            isSuccess: false
        };

        /**
         * Checks if form should display terms not accepted error
         *
         * @returns {Boolean}
         */
        this.shouldShowTermsError = function () {
            return $scope.nlForm.$submitted && !this.formData.terms;
        };

        /**
         * Submits the form
         */
        this.submit = function () {
            $scope.nlForm.$setSubmitted();

            if ($scope.nlForm.$valid && this.formData.terms && !this.formState.isLoading) {
                this.formState.isLoading = true;
                var self = this;

                IthNewsletterFormApi
                    .register(this.formData.email)
                    .then(function () {
                        self.formState.isSuccess = true;
                    })
                    .catch(function () {
                        self.formState.isError = true;
                    })
                    .finally(function () {
                        self.formState.isLoading = false;
                    });
            }
        };

        /**
         * Toggles this component on and off based on url
         *
         * @returns {Boolean}
         */
        this.isVisible = function () {
            return true;

            var prefixHomepage = AppConfig.getUriPrefix() + '_homepage';
            var enabledOn = [
                // Homepage
                'homepage',
                prefixHomepage,

                // Contact pages
                'contact',
                'kontakt',

                // About us pages
                'despre_noi_povestea_vola',
                'rolunk-a-vola-tortenete',
                'about_us_the_vola_story',
                'nasze-wartosci',

                // Our values pages
                'our-values'
            ];

            if (AppConfig.getUriPrefix()) {
                if (prefixHomepage === $state.current.name) {
                    return true;
                }

                enabledOn.push(AppConfig.getUriPrefix());
            }

            return (
              StaticPageHelper.isStaticPage($state.current.name) &&
              (!$stateParams.params || enabledOn.indexOf($stateParams.params) !== -1)
            );
        };

        this.isJanuaryCampaignEnabled = function () {
            return AppConfig.getIeftinuarieConfig() === true;
        };
    };

    IthNewsletterFormController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'IthNewsletterFormApi',
        'appConfig',
        'StaticPageHelper'
    ];

    angular
        .module('base')
        .controller('NewsletterFormController', IthNewsletterFormController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter-coupons/newsletter-coupons.api.js
(function(angular) {
var NewsletterCouponsApi = function ($http) {
        /**
         * API url
         */
        var apiUrl = '/api/coupons/';

        /**
         * Endpoint for campaign details
         *
         * @param {string} topic
         * @returns {Promise}
         */
        this.getCampaignDetails = function (topic) {
            return $http.post(apiUrl + 'getCampaignDetails', {
                topic: topic
            });
        };

        /**
         * Endpoint for generating coupon
         *
         * @param {string} topic
         * @param {string} email
         * @returns {Promise}
         */
        this.generateCoupon = function (topic, email) {
            return $http.post(apiUrl + 'generateCampaignCoupon', {
                topic: topic,
                email: email,
                terms_accepted: true
            });
        };
    };

    NewsletterCouponsApi.$inject = ['$http'];

    angular
        .module('base')
        .service('NewsletterCouponsApi', NewsletterCouponsApi);
}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter-coupons/newsletter-coupons.component.js
(function(angular) {
var NewsletterCouponsController = function ($scope, $translate, NewsletterCouponsApi) {
        /**
         * Self ref
         */
        var self = this;

        /**
         * Possible view states
         */
        this.viewStates = {
            LOADING: 'loading',
            LOAD_ERROR: 'load-error',
            LOAD_SUCCESS: 'load-success',
            SUBMITTING: 'submitting',
            SUBMIT_ERROR: 'submit-error',
            SUBMIT_SUCCESS: 'submit-success',
        };

        /**
         * Current view state
         */
        this.viewState = this.viewStates.LOADING;

        /**
         * Campagin data
         * @type {Object}
         */
        this.campaignData = null;

        /**
         * Error code
         */
        this.errorTopic = null;

        /**
         * Error email
         */
        this.errorEmail = null;

        /**
         * Data passed to backend endpoint
         *
         * @type {Object}
         */
        this.formData = {
            /**
             * @type {String}
             */
            email: '',

            /**
             * @type {Boolean}
             */
            terms: {}
        };

        /**
         * Checks if form should display terms not accepted error
         *
         * @returns {Boolean}
         */
        this.shouldShowTermsError = function (index) {
            if (!$scope.couponForm) {
                return false;
            }

            return $scope.couponForm.$submitted && this.formData.terms[index] === false;
        };

        /**
         * Submits the form
         */
        this.submit = function () {
            $scope.couponForm.$setSubmitted();
            var termsAccepted = true;

            angular.forEach(Object.values(this.formData.terms), function (checkboxValue) {
                if (!checkboxValue) {
                    termsAccepted = false;
                }
            });

            if ($scope.couponForm.$valid && termsAccepted && this.viewState !== this.viewStates.SUBMITTING) {
                this.viewState = this.viewStates.SUBMITTING;

                NewsletterCouponsApi
                    .generateCoupon(this.topic, this.formData.email)
                    .then(function () {
                        self.viewState = self.viewStates.SUBMIT_SUCCESS;
                    })
                    .catch(function (error) {
                        self.errorTopic = error.data.response.errors.topic || null;
                        self.errorEmail = error.data.response.errors.email
                            ? $translate.instant(self.getErrorLang(error.data.response.errors.email))
                            : null;

                        self.viewState = self.viewStates.SUBMIT_ERROR;
                    });
            }
        };

        /**
         * Loads campaign details
         */
        this.loadCampaign = function () {
            NewsletterCouponsApi
                .getCampaignDetails(this.topic)
                .then(function (success) {
                    self.campaignData = success.data.response;

                    for (var i = 0; i < self.campaignData.consents.length; i++) {
                        self.formData.terms[i] = false;
                    }

                    self.viewState = self.viewStates.LOAD_SUCCESS;
                })
                .catch(function (error) {
                    self.errorTopic = error.data.response.errors.topic;
                    self.viewState = self.viewStates.LOAD_ERROR;
                });
        };

        this.shouldShowForm = function () {
            return [
                this.viewStates.LOAD_SUCCESS,
                this.viewStates.SUBMITTING,
                this.viewStates.SUBMIT_ERROR
            ].indexOf(this.viewState) !== -1;
        };

        this.$onInit = function () {
            this.loadCampaign();
        };

        this.getErrorLang = function (suffix) {
            return 'LANGM_JS_NLC_' + suffix;
        };
    };

    NewsletterCouponsController.$inject = ['$scope', '$translate', 'NewsletterCouponsApi'];

    var template = '\
        <div class="text-center newsletter-box newsletter-box--coupons">\
            <div class="container">\
                <div class="row">\
                    <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\
                        <ith-preloader ng-show="$ctrl.viewState === $ctrl.viewStates.LOADING"></ith-preloader>\
                        <div class="alert alert-danger" ng-show="$ctrl.viewState === $ctrl.viewStates.LOAD_ERROR">\
                            {{ $ctrl.getErrorLang($ctrl.errorTopic) | translate }}\
                        </div>\
                        <form name="couponForm" ng-show="$ctrl.shouldShowForm()">\
                            <h2 class="newsletter-box__title">{{ :: $ctrl.title }}</h2>\
                            <div class="newsletter-box__fields">\
                                <ith-input-field\
                                    type="email"\
                                    name="email"\
                                    model="$ctrl.formData.email"\
                                    backend-error="$ctrl.errorEmail"\
                                    label="{{ :: $ctrl.inputLabelText }}"\
                                    form="couponForm"\
                                    placeholder="{{ :: $ctrl.inputPlaceholderText }}"\
                                    required="true"\
                                    disabled="$ctrl.viewState === $ctrl.viewStates.SUBMITTING"\
                                    class="newsletter-box__fields__email">\
                                </ith-input-field>\
                                \
                                <ith-ui-checkbox\
                                    ng-repeat="consent in $ctrl.campaignData.consents"\
                                    ng-model="$ctrl.formData.terms[$index]"\
                                    class="newsletter-box__fields__checkbox"\
                                    disabled="$ctrl.viewState === $ctrl.viewStates.SUBMITTING">\
                                    <span class="disclaimer-text" ng-bind-html="consent"></span>\
                                    <span class="has-error" ng-show="$ctrl.shouldShowTermsError($index)">\
                                        <span class="help-block" translate>LANGM_JS_NL_BOX_VALIDATION_ERROR</span>\
                                    </span>\
                                </ith-ui-checkbox>\
                                \
                                <div class="newsletter-box__fields__alert alert alert-danger" ng-show="$ctrl.viewState === $ctrl.viewStates.SUBMIT_ERROR && $ctrl.errorTopic !== null" translate>\
                                    {{ $ctrl.getErrorLang($ctrl.errorTopic) | translate }}\
                                </div>\
                                \
                                <div class="newsletter-box__fields__submit">\
                                    <button type="button" class="newsletter-box__fields__button btn btn-lg btn-primary btn-block ng-animate-disabled" ng-click="$ctrl.submit()" ng-disabled="$ctrl.viewState === $ctrl.viewStates.SUBMITTING">\
                                        <span class="ng-animate-disabled" ng-show="$ctrl.viewState !== $ctrl.viewStates.SUBMITTING">{{ :: $ctrl.buttonText }}</span>\
                                        <span class="loader ng-animate-disabled" ng-show="$ctrl.viewState === $ctrl.viewStates.SUBMITTING"></span>\
                                    </button>\
                                </div>\
                            </div>\
                        </form>\
                        <ith-status-notification status="success" ng-show="$ctrl.viewState === $ctrl.viewStates.SUBMIT_SUCCESS">\
                            <pane-title>{{ :: $ctrl.successTitle }}</pane-title>\
                            <pane-text></pane-text>\
                        </ith-status-notification>\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    var NewsletterCouponsComponent = {
        bindings: {
            topic: '@',
            title: '@',
            inputLabelText: '@',
            inputPlaceholderText: '@',
            buttonText: '@',
            successTitle: '@'
        },
        controller: NewsletterCouponsController,
        template: template
    };

    angular.module('base').component('ithNewsletterCoupons', NewsletterCouponsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter/newsletter-unsubscribe.controller.js
(function(angular) {
/**
     * Manages data on the newsletter unsubscribe page
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var NewsletterUnsubscribeCtrl = function (StateParams, PageLoading, NewsletterService) {
        /**
         * Self reference
         *
         * @type {NewsletterUnsubscribeCtrl}
         */
        var ctrl = this;

        /**
         * Success status
         *
         * @type {Boolean}
         */
        this.success = false;

        /**
         * Unsubscribe method
         *
         * @param {String} uuid
         * @private
         */
        var unsubscribe = function (uuid) {
            PageLoading.on();

            if (!uuid) {
                requestFailure();
                stopLoading();
                return;
            }

            NewsletterService
                .Unsubscribe(uuid)
                .then(requestSuccess, requestFailure)
                .finally(stopLoading);
        };

        /**
         * Sets success status
         *
         * @private
         */
        var requestSuccess = function () {
            ctrl.success = true;
        };

        /**
         * Sets failure status
         *
         * @private
         */
        var requestFailure = function () {
            ctrl.success = false;
        };

        /**
         * Sets loading state to false
         *
         * @private
         */
        var stopLoading = function () {
            PageLoading.off();
        };

        unsubscribe(StateParams.uuid);
    };

    NewsletterUnsubscribeCtrl.$inject = [
        '$stateParams',
        'PageLoading',
        'NewsletterService'
    ];

    angular
        .module('ITH.Base.Newsletter')
        .controller('NewsletterUnsubscribeCtrl', NewsletterUnsubscribeCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/newsletter/newsletter.service.js
(function(angular) {
/**
     * Newsletter API Service
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthNewsletterService = function (ApiTools) {
        /**
         * Object containing endpoint information
         *
         * @type {Object}
         */
        var endpoints = {
            unsubscribe: {
                url: '/api/emarsys/optOut?uuid=',
                method: 'GET',
                respParser: function (response) {
                    return response.response;
                }
            }
        };

        /**
         * Makes request to API to unsubscribe a user
         *
         * @param   {String}  uuid
         * @returns {Promise}
         */
        this.Unsubscribe = function (uuid) {
            var endpoint = angular.copy(endpoints.unsubscribe);
            endpoint.url += uuid;
            return ApiTools.fetch(this, endpoint);
        };

        return this;
    };

    IthNewsletterService.$inject = [
        'ApiTools'
    ];

    angular
        .module('ITH.Base.Newsletter')
        .service('NewsletterService', IthNewsletterService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/notification/notification-types/notification-alert/notification-alert.component.js

(function(angular) {
/**
     * @name        notificationAlert
     * @description component responsibility for show/hide alert
     */

    var notificationAlert = {
        templateUrl: "/tpl/show/templates/components/flights/notification/types/notification-alert",
        controller: 'NotificationAlertController',
        transclude: true,
        require: {
            notificationCtrl: '^^ithNotification'
        },
        bindings: {
            dismissAfterTimeout: '<?',
            hideOnClick: '<?',
            notificationClass:'@?'
        }
    };

    angular.module('ITH.Base.Notification')
        .component('ithNotificationAlert', notificationAlert);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification-types/notification-alert/notification-alert.controller.js
(function(angular) {
/**
     * @name        NotificationAlertController
     * @description controller
     */

    var NotificationAlertController = function($timeout) {
        /**
         *
         * @type {NotificationAlertController}
         */
        var ctrl = this;

        this.$onInit = function() {
            this.notificationCtrl.registerNotification({
              show: this.show,
              hide: this.hide
            });
        };

        /**
         * @description show component (alert),
         * in case when dismiss timeout has been set in timeout call hide function
         *
         */
        this.show = function() {
            ctrl.isVisible = true;
            if(angular.isDefined(ctrl.dismissAfterTimeout)){
                $timeout(ctrl.hide.bind(ctrl), ctrl.dismissAfterTimeout);
            }
        };

        /**
         * @description hide component (alert)
         */
        this.hide = function() {
            ctrl.isVisible =  false;
        };
    };

    NotificationAlertController.$inject = [
        '$timeout'
    ];

    angular.module('ITH.Base.Notification')
        .controller('NotificationAlertController', NotificationAlertController);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification-types/notification-popover/notification-popover.component.js
(function(angular) {
/**
     * @name        notificationPopover
     * @description component responsibility for show/hide popover
     */
    var notificationPopover = {
        templateUrl: '/tpl/show/templates/components/flights/notification/types/notification-popover',
        controller: 'NotificationPopoverController',
        transclude: true,
        require: {
            notificationCtrl: '^^ithNotification'
        },
        bindings: {
            dismissAfterTimeout: '<?',
            popoverClass: '@',
        }
    };

    angular.module('ITH.Base.Notification')
        .component('ithNotificationPopover', notificationPopover);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification-types/notification-popover/notification-popover.controller.js
(function(angular) {
/**
     * @name        NotificationPopoverController
     * @description controller
     */
    var NotificationPopoverController = function($timeout) {
        /**
         *
         * @type {NotificationPopoverController}
         */
        var ctrl = this;
        /**
         * tru in case when popover should be Visible
         * @type {boolean}
         */
        this.isVisible = false;

        /**
         * register notification interface
         * show & hide method will be called by notification component
         */
        this.$onInit = function() {
            this.notificationCtrl.registerNotification({
                show: this.show,
                hide: this.hide
            });
        };

        /**
         * @description show popover,
         * in case when dismiss timeout has been set in timeout call hide function
         *
         */
        this.show = function(template) {
            ctrl.template = "/tpl/show/templates/components/flights/notification/templates/" + template;
            ctrl.isVisible = true;

            if(angular.isDefined(ctrl.dismissAfterTimeout)) {
                $timeout(ctrl.hide, ctrl.dismissAfterTimeout);
            }
        };

        /**
         * @description hide popover,
         */
        this.hide = function() {
            ctrl.isVisible = false;
        };

    };

    NotificationPopoverController.$inject = [
        '$timeout'
    ];

    angular.module('ITH.Base.Notification')
        .controller('NotificationPopoverController', NotificationPopoverController);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification.component.js
(function(angular) {
/**
     * @name        NotificationSubscriber
     * @description component register and hailing notification
     */
    var NotificationSubscriber = {
        template: '<div ng-transclude></div>',
        controller: 'NotificationController',
        transclude: true,
        bindings: {
            name: '<'
        }
    };

    angular.module('ITH.Base.Notification')
        .component('ithNotification', NotificationSubscriber);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification.constant.js
(function(angular) {
/**
     * Defined notification names
     *
     * Notification name should follow pattern module-name:notification-name
     *
     * @constant
     * @type {object}
     */
    var NotificationConstant = {
        NAME: {
            LUGGAGE_WEIGHT_AND_SIZE_MAY_VARY: 'luggage:weight-and-size-may-vary',
            LUGGAGE_CHANGE_ALERT: 'luggage:change-alert',
            LUGGAGE_CONTACT_US_ALERT: 'luggage:contact-us-alert',
            MOBILE_SUFIX:'_MOBILE'
        }
    };

    angular.module('ITH.Base.Notification')
        .constant('NotificationConstant', NotificationConstant);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification.controller.js
(function(angular) {
/**
     * @name        NotificationController
     * @description controller of Notification component
     */

    var NotificationController = function(NotificationService) {
        /**
         * array of hide/show interface of child components
         * @type {Array}
         */
        var registeredNotifications = [];

        /**
         * subscribe name in notification watcher
         */
        this.$onInit = function() {
            this.isVisible = false;

            NotificationService.subscribe(this.name, this.showNotification.bind(this));
        };

        /**
         * unregistered name in notification watcher
         */
        this.$onDestroy = function() {
            NotificationService.unsubscribe(this.name);
        };

        /**
         * function called by notification services
         * should display all child component
         * @param params
         */
        this.showNotification = function(params) {
            registeredNotifications.forEach(function(notification) {
                notification.show(params);
            });
        };

        /**
         * hide all child component
         */
        this.hideNotification = function() {
            registeredNotifications.forEach(function(notification) {
                notification.hide();
            });
        };

        /**
         * register hide/show interface of child components
         * @param notification
         */
        this.registerNotification = function(notification) {
            var indexOf = registeredNotifications.indexOf(notification);

            if(indexOf === -1) {
                registeredNotifications.push(notification);
            }
        };
    };

    NotificationController.$inject = [
        'NotificationService'
    ];

    angular.module('ITH.Base.Notification')
        .controller('NotificationController', NotificationController);

})(angular);



;

// Source: ../shared/public_html/assets/js/base/notification/notification.service.js
(function(angular, underscore) {
/**
     * @name        NotificationSubscribeService
     * @description observer services for notification
     */

    var NotificationSubscribeService = function($timeout, $rootScope, config, notificationConstant) {
        /**
         * array od subscriber
         * @type {{}}
         */
        var subscribers = {};

        /**
         *
         * @param {string} name
         * @param {Function} callback
         */
        function subscribe(name, callback) {
            if(angular.isUndefined(name)) {
                throw {errorMessage: "'name' parameter has not been provided"};
            }

            subscribers[name] = callback;
        }

        /**
         *
         * @param {string} name
         */
        function unsubscribe(name) {
            if(angular.isUndefined(name)) {
                throw {errorMessage: "'name' parameter has not been provided"};
            }

            delete subscribers[name];
        }

        /**
         * subject use this method for trigger show notification action
         * @param {string} name
         * @param params
         */
        function show(name, params) {
            if(angular.isUndefined(name)) {
                throw {errorMessage: "'name' parameter has not been provided"};
            }

            $timeout(function () {
                var callback = subscribers[name];
                if (!callback || !angular.isFunction(callback)) {
                    return;
                }
                callback(params);
            });
        }

        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            show: underscore.debounce(show, 500, true),
            NAME: notificationConstant.NAME
        };
    };

    NotificationSubscribeService.$inject = [
        '$timeout',
        '$rootScope',
        'appConfig',
        'NotificationConstant'
    ];

    angular.module('ITH.Base.Notification')
        .service('NotificationService', NotificationSubscribeService);

})(angular, _);



;

// Source: ../shared/public_html/assets/js/base/outdatedAlert/controllers/OutdatedAlertCtrl.js
angular
  .module('base')
  .controller('OutdatedAlertCtrl', ['$scope', 'OutdatedAlertSrv', '$modalInstance', function ($scope, OutdatedAlertSrv, $modalInstance) {
/**
     * Close modal.
     */
    this.close = function () {
      $modalInstance.close();
    };

  }]);

// Source: ../shared/public_html/assets/js/base/outdatedAlert/directives/outdatedAlert.js
angular
  .module('base')

  /**
   * Directive for the outdated alert popup.
   */
  .directive('outdatedAlert', ['OutdatedAlertSrv', function (OutdatedAlertSrv) {
return {
      restrict: 'E',
      replace: true,
      templateUrl: '/tpl/show/jsShared/templates/base/directives/outdatedAlert/popup',
      link: function ($scope) {
        /**
         * Reference to service
         */
        $scope.service = OutdatedAlertSrv;
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/outdatedAlert/services/OutdatedAlertSrv.js
angular
  .module('base')

  /**
   * Service displaying outdated alert.
   */
  .service('OutdatedAlertSrv', ['$rootScope', '$modal', '$timeout', function ($rootScope, $modal, $timeout) {
/**
     * Instance of $modal.
     */
    var modalInstance;
  
    /**
     * Instance of $timeout.
     */
    var timeoutInstance;
  
    /**
     * Popup visible.
     */
    this.popupVisible = false;
    
    /**
     * Display modal.
     */
    this.displayModal = false;

    /**
     * Display alert after timeout.
     */
    this.show = function (delay) {
      if (delay === false) {
        return;
      }

      $timeout.cancel(timeoutInstance);

      timeoutInstance = $timeout((function () {
        if (this.displayModal) {
          this.openModal();
        } else {
          this.popupVisible = true;
          $rootScope.$digest();
        }
      }).bind(this), delay);
    };
    

    /**
     * Action on reload button.
     */
    this.clickReloadBtn = function () {
      location.reload();
    }

    /**
     * Close displayed alert.
     */
    this.close = function () {
      this.popupVisible = false;
    };

    /**
     * Cancel timeout on diplay alert.
     */
    this.destroy = function () {
      $timeout.cancel(timeoutInstance);
    };
    
    /**
     * Open modal.
     */
    this.openModal = function () {
      modalInstance = $modal.open({
        templateUrl: '/tpl/show/jsShared/templates/base/directives/outdatedAlert/modal',
        controller: 'OutdatedAlertCtrl as outdated_alert',
        windowClass: 'modal-outdated-alert',
        backdrop: 'static',
        animation: true,
        keyboard: false
      });
      
      modalInstance.result.then(function () {
        location.reload();
      });
    };

  }]);

// Source: ../shared/public_html/assets/js/base/phoneNumber.js
angular.module('base')

/**
 * @name        phoneNumber
 * @description
 */
.directive('phoneNumber', function () {
var ctrl = ['$rootScope', '$scope', '$state', 'appConfig', '$location', '$filter',
  function ($rootScope, $scope, $state, AppConfig, $location, $filter) {

    var path   = $location.url();
    var spKeys = ['vacations',
                  'city-break',
                  'wakacje',
                  'early-booking',
                  'obiective-turistice',
                  'sejur',
                  'vacante',
                  'packages',
                  'vacations',
                  'touristic-objectives',
                  'city-break',
                  'city-breaks',
                  'vacanta',
                  'strefa-biznes',
                  'business-zone',
                  'escapes'];

    var phoneNumbers = AppConfig.getPhoneNumbers();

    var customPhoneNumberStates = [
      {name: 'packages_html_sitemap', phoneNumber: phoneNumbers.packages},
      {name: 'package_offer_lps', phoneNumber: phoneNumbers.packages},
      {name: 'package_booking', phoneNumber: phoneNumbers.packages},
      {name: 'package_details', phoneNumber: phoneNumbers.packages},
      {name: 'package_offer_lps_cb', phoneNumber: phoneNumbers.packages},
      {name: 'package_old_lps_vacations', phoneNumber: phoneNumbers.packages},
      {name: 'package_old_lps_cb', phoneNumber: phoneNumbers.packages},
      {name: 'package_offer_lps_vacations', phoneNumber: phoneNumbers.packages},
      {name: 'package_search_results', phoneNumber: phoneNumbers.packages},
      {name: 'ngStaticPageShow', phoneNumber: phoneNumbers.packages},
      {name: 'escapes escapes_hp', phoneNumber: phoneNumbers.escapes},
      {name: 'escapes escapes_details', phoneNumber: phoneNumbers.escapes},
      {name: 'escapes confirmation escapes_checkout', phoneNumber: phoneNumbers.escapes}
    ];

    var customPhoneNumberStaticPages = [
      {urlPattern: '^/strefa-biznes', phoneNumber: phoneNumbers.business_zone},
      {urlPattern: '^/business-zone', phoneNumber: phoneNumbers.business_zone}
    ];

    /**
     * @param {String} stateName
     * @returns {String}
     */
    var getPhoneNumber = function (stateName) {
      var settings = _.find(customPhoneNumberStates, {name: stateName});

      if(settings == undefined)
      {
        return phoneNumbers.general;
      }

      var isGeneral = true;

      for (var i = 0; i < spKeys.length; i++)
      {
        if ( path.indexOf( spKeys[i] )  > -1)
        {
          isGeneral = false;
          break;
        }
      }

      if(stateName == 'ngStaticPageShow')
      {
        if (isGeneral) {
          return phoneNumbers.general;
        }
        else
        {
          var tempPhone = getPhoneCustomStaticPages();
          if (tempPhone)
          {
            return tempPhone;
          }
        }
      }

      return settings.phoneNumber;
    };

    var getPhoneCustomStaticPages = function()
    {
      for(var i = 0; i < customPhoneNumberStaticPages.length; i++)
      {
        var regex = new RegExp(customPhoneNumberStaticPages[i].urlPattern);
        if (regex.test($location.url()))
        {
          return customPhoneNumberStaticPages[i].phoneNumber;
        }
      }
      return null;
    };

    if (['escapes escapes_hp', 'escapes escapes_details', 'escapes confirmation escapes_checkout'].indexOf($state.current.name) != -1) {
      $scope.phoneNumberInfo = $filter('translate')('LANGM_NAVBAR_PHONE_NUMBER_INFO_ESCAPES');
    } else {
      $scope.phoneNumberInfo = $filter('translate')('LANGM_JS_NAVBAR_PHONE_NUMBER_INFO');
    }

    // $scope.phoneNumberInfo = ($scope.phoneNumberInfo == 'LANGM_JS_NAVBAR_PHONE_NUMBER_INFO')? false : $scope.phoneNumberInfo;

    var refreshPhoneNumber = function(currentState){
      $scope.phoneNumber = getPhoneNumber(currentState);
      $scope.phoneNumberLink = getPhoneNumber(currentState).replace(/ /g, '');
    };

    refreshPhoneNumber($state.current);

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      refreshPhoneNumber(toState.name);
    });
  }];

  return {
    restrict: 'E',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    controller: ctrl,
    transclude: true,
    replace: true
  };
});
;

// Source: ../shared/public_html/assets/js/base/price-calendar/api/ith-price-calendar.api.js
(function(angular) {
var CalendarApiService = function ($http, AppConfig, ApiTools, SearchQueryParams) {
    /**
     * Self reference
     */
    var self = this;

    /**
     * Departure place
     */
    self.departurePlace = null;

    /**
     * Destination place
     */
    self.destinationPlace = null;

    /**
     * Endoints object
     * @type {Object}
     */
    var endpoints = {
      /**
       * Gets fare calendar data
       * @type {Object}
       */
      apiGetCalendar: {
        url: '/api/search/getCalendar?abv=' + _js_app_config_.ab_version,
        method: 'GET',
        respParser: function (response) {
          return response.response;
        }
      }
    };

    /**
     * Creates payload for API
     * @return {Object}
     */
    var _createPayload = function () {
      var depDate = moment(SearchQueryParams.getDepDate(), 'YYYY-MM-DD');
      var retDate = moment(SearchQueryParams.getRetDate(), 'YYYY-MM-DD');

      return  {
        flight_from_code: self.departurePlace.city_code,
        flight_to_code: self.destinationPlace.city_code,
        departure_date: depDate,
        return_date: retDate,
        adults: SearchQueryParams.getAdults(),
        children: SearchQueryParams.getChildren(),
        infants: SearchQueryParams.getInfants(),
        blackListMode: 1
      };
    };

    /**
     * Makes post request to calendar API endpoint
     * @return {Promise}
     */
    var _getData = function (payload) {
      var endpoint = angular.copy(endpoints.apiGetCalendar);
      var encodedParam = btoa(JSON.stringify(payload));
      endpoint.url += '&p=' + encodedParam;

      return ApiTools.fetchCache(this, endpoint);
    };

    /**
     * Makes backend request to bring back departure flight prices for an array of months
     *
     * @param {Array}   monthsRange Array containing months in yyyy-mm format
     * @param {Boolean} oneWay      Prices are for one way flights
     *
     * @return {Promise}
     */
    self.getDepartureData = function (monthsRange, oneWay) {
      var _departurePayload = _createPayload();
      _departurePayload.months_range = monthsRange;
      _departurePayload.oneway = (oneWay) ? 1 : 0;
      _departurePayload.calendar_type = 'departure';
      return _getData(_departurePayload);
    };

    /**
     * Makes backend request to bring back return flight prices for an array of months by departure date
     *
     * @param {Array}  monthsRange  Array containing months in yyyy-mm format
     * @param {String} selectedDate Departure date in format dd-mm-yyyy
     *
     * @return {Promise}
     */
    self.getReturnData = function (monthsRange, selectedDate) {
      var _returnPayload = _createPayload();
      _returnPayload.months_range = monthsRange;
      _returnPayload.selected_date = selectedDate;
      _returnPayload.calendar_type = 'return';
      return _getData(_returnPayload);
    };

    return this;
  };

  CalendarApiService.$inject = [
    '$http',
    'appConfig',
    'ApiTools',
    'sch.SearchQueryParams'
  ];

  angular
    .module('ITH.Base.PriceCalendar')
    .service('CalendarApi', CalendarApiService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/price-calendar/components/ith-price-calendar-loader.component.js
(function(angular) {
/**
   * @name        IthPriceCalendarLoader
   * @description Stateless component that handles the loading screen inside the price calendar
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthPriceCalendarLoader = {
    templateUrl: '/tpl/show/jsShared/templates/base/price-calendar-component/price-calendar-loader'
  };

  angular
    .module('ITH.Base.PriceCalendar')
    .component('ithPriceCalendarLoader', IthPriceCalendarLoader);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/price-calendar/components/ith-price-calendar.component.js
(function (angular) {
var IthPriceCalendarTemplateUrl = function ($attrs) {
    if ($attrs.templateUrl) {
      return $attrs.templateUrl;
    }

    var _url = '';

    switch ($attrs.type) {
    case 'scroll': _url = '/tpl/show/jsShared/templates/base/price-calendar-component/price-scroll-calendar-wrapper'; break;
    case 'double': _url = '/tpl/show/jsShared/templates/base/price-calendar-component/price-double-calendar-wrapper'; break;
    case 'single': default: _url = '/tpl/show/jsShared/templates/base/price-calendar-component/price-single-calendar-wrapper'; break;
    }

    return _url;
  };

  IthPriceCalendarTemplateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        IthPriceCalendarComponent
   * @description Renders a price calendar
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthPriceCalendarComponent = {
    bindings: {
      startDate: '=',
      endDate: '=?',
      tripLength: '=?',
      departurePlace: '<?',
      destinationPlace: '<?',
      minDate: '<?',
      maxDate: '<?',
      multipleSelect: '<?',
      onCellClick: '&?',
      rangeStart: '<?',
      rangeEnd: '<?',
      rangeChange: '@',
      type: '@',
      oneWay: '<',
      totalPrice: '=',
      selecting: '<',
      newDatePicker: '<'
    },
    controller: 'IthPriceCalendarController',
    templateUrl: IthPriceCalendarTemplateUrl
  };

  angular
    .module('ITH.Base.PriceCalendar')
    .component('ithPriceCalendar', IthPriceCalendarComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/price-calendar/components/ith-scroll-calendar-tooltip.component.js
(function (angular) {

    var template = '\
        <div class="ith-calendar__cell__tooltip" ng-class="$ctrl.getClassMap()" ng-show="$ctrl.isVisible()" id="scroll-datepicker-tooltip-unique-id">\
            <div ng-if="$ctrl.endDate !== null">\
                <strong>\
                    <span>{{ $ctrl.startDate | date:\'d MMM\' }}</span> - <span>{{ $ctrl.endDate | date:\'d MMM\' }}</span>\
                </strong>\
                <span translate>LANGM_JS_DATEPICKER_HELP_TOOLTIP_CONTINUE</span>\
            </div>\
            <div ng-if="$ctrl.endDate === null">\
                <strong>{{ $ctrl.startDate | date:\'d MMM\' }}</strong>\
                <span ng-if="$ctrl.externalData.oneWay" translate>LANGM_JS_DATEPICKER_HELP_TOOLTIP_CONTINUE</span>\
                <span ng-if="!$ctrl.externalData.oneWay" translate>LANGM_JS_DATEPICKER_HELP_TOOLTIP_SELECT_RETURN</span>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, $rootScope) {
        var ctrl = this;

        this.index = 0;

        this.isVisible = function () {
            return (
                $rootScope.datepicker.showTooltip === true &&
                (
                    ($rootScope.datepicker.selection === 'start' && ctrl.startDate !== null) ||
                    ($rootScope.datepicker.selection === 'end' && ctrl.endDate !== null)
                )
            );
        };

        this.getClassMap = function () {
            return {
                'ith-calendar__cell__tooltip--left': this.index < 3,
                'ith-calendar__cell__tooltip--right': this.index > 5
            };
        };

        this.$onInit = function () {
            var tooltipHtmlElement = document.querySelector('#scroll-datepicker-tooltip-unique-id');

            $scope.$watch(
                function () {
                    return $rootScope.datepicker.showTooltip;
                },
                function (newValue) {
                    if (newValue === true) {
                        ctrl.index = $rootScope.datepicker.selection === 'start'
                            ? moment(ctrl.startDate).isoWeekday()
                            : moment(ctrl.endDate).isoWeekday()
                        ;

                        var targetElement = $rootScope.datepicker.selection === 'start'
                            ? '.ith-calendar__datacell--range-start'
                            : '.ith-calendar__datacell--range-end'
                        ;

                        document
                            .querySelector(targetElement)
                            .appendChild(tooltipHtmlElement);
                    }
                }
            );
        };
    };

    controller.$inject = ['$scope', '$rootScope'];

    angular
        .module('base')
        .component('ithScrollCalendarTooltip', {
            template: template,
            controller: controller,
            bindings: {
                externalData: '<',
                startDate: '<',
                endDate: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/price-calendar/controllers/ith-price-calendar.controller.js
(function(angular) {
/**
   * @name        IthPriceCalendarController
   * @description Handles data sharing between calendar API and calendar components.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthPriceCalendarController = function (PriceCalendarHelper, $timeout) {
    /**
     * View model
     * @type {Object}
     */
    var ctrl = this;

    /**
     * Calendar helper service reference
     * @type {PriceCalendarHelper}
     */
    ctrl.externalData = PriceCalendarHelper;

    /**
     * Route for which rates are loaded in calendar
     * @type {String}
     */
    var _route = 'departure';

    /**
     * Angular init hook
     */
    var _onInit = function () {
      if (ctrl.type === 'double') {
        ctrl.externalData.setSelectedDeparture(ctrl.rangeStart);
      }

      if (ctrl.type === 'scroll') {
        ctrl.externalData.setSelectedDeparture(ctrl.startDate);
        ctrl.externalData.setSelectedReturn(ctrl.endDate);
      }
    };

    /**
     * Angular on change hook
     * @param {Object} changes Object containing one way binding changes
     */
    var _onChanges = function (changes) {
      var shouldLoad = false;

      if (changes.hasOwnProperty('selecting')) {
        ctrl.selecting = changes.selecting.currentValue;
        ctrl.rangeChange = ctrl.selecting === 'dep' ? 'start' : 'end';
        _route = ctrl.rangeChange === 'start' ? 'departure' : 'return';
        shouldLoad = true;
      }

      if (changes.hasOwnProperty('oneWay')) {
        ctrl.externalData.oneWay = changes.oneWay.currentValue;
        if (
          (ctrl.selecting === 'dep' && ctrl.rangeChange === 'start') ||
          (ctrl.selecting === 'ret' && ctrl.rangeChange === 'end') ||
          !ctrl.rangeChange
        ) {
          shouldLoad = true;
        }
      }

      if (changes.hasOwnProperty('departurePlace')) {
        ctrl.externalData.departurePlace = changes.departurePlace.currentValue;
        shouldLoad = true;
      }

      if (changes.hasOwnProperty('destinationPlace')) {
        ctrl.externalData.destinationPlace = changes.destinationPlace.currentValue;
        shouldLoad = true;
      }

      if (shouldLoad) {
        $timeout(function () {
          _loadCalendarData();
        });
      }
    };

    /**
     * Method triggered when child calendar is initiated to load prices
     * @param  {Array} dates Array of dates representing the calendar month(s)
     * @return {Void}
     */
    var _onCalendarInit = function (dates) {
      ctrl.externalData.calendarMonths = dates;

      if (this.rangeChange === 'start') {
        _route = 'departure';
        // _loadCalendarData();
      }

      if (this.rangeChange === 'end' && this.rangeStart) {
        _route = 'return';
        // _loadCalendarData();
      }

      if (!this.rangeChange) {
        _route = 'departure';
        // _loadCalendarData();

        if (ctrl.externalData.selectedDeparture.date) {
          _route = 'return';
          // _loadCalendarData();
        }
      }
    };

    /**
     * Method triggered when user changes the visible month(s) in the calendar
     * @param  {Array} dates Array of dates representing the calendar month(s)
     * @return {Void}
     */
    var _onCalendarMoveMonths = function (dates) {
      ctrl.externalData.calendarMonths = dates;
      _loadCalendarData();
    };

    var _calculateTotalPrice = function () {
      ctrl.totalPrice = ctrl.externalData.getTotalPrice();
    };

    /**
     * Method triggered when clicking on a cell
     * @param  {String} whichDate String representing which date is selected (start, end)
     * @param  {Object} cell      Object containing data about selected cell
     * @return {Void}
     */
    var _onCalendarCellClick = function (whichDate, cell) {
      if (whichDate === 'start') {
        ctrl.externalData.setSelectedDeparture(cell.date);

        if (ctrl.externalData.oneWay) {
          _calculateTotalPrice();
        }

        if (!ctrl.externalData.oneWay && ctrl.type === 'scroll') {
          _route = 'return';
          // _loadCalendarData();
        }
      } else {
        // Both dates selected
        ctrl.externalData.setSelectedReturn(cell.date);
        _calculateTotalPrice();
      }

      if (ctrl.onCellClick !== undefined) {
        // Call cell click callback
        $timeout(function () {
          ctrl.onCellClick({ whichDate: whichDate, cell: cell });
        });
      }
    };

    /**
     * Loads prices to show in the calendar
     * @return {Void}
     */
    var _loadCalendarData = function () {
      // Check if cities are loaded
      if (ctrl.externalData.departurePlace === undefined || ctrl.externalData.destinationPlace === undefined) {
        // Don't load data until cities are loaded
        return;
      }

      if (ctrl.oneWay) {
        _route = 'departure';
      }

      ctrl.externalData.loadData(
        _route,
        ctrl.oneWay
      );
    };

    // Controller hooks
    ctrl.$onInit = _onInit;
    ctrl.$onChanges = _onChanges;

    // Public methods
    ctrl.onCalendarInit = _onCalendarInit;
    ctrl.onCalendarMoveMonths = _onCalendarMoveMonths;
    ctrl.onCalendarCellClick = _onCalendarCellClick;
  };

  IthPriceCalendarController.$inject = [
    'PriceCalendarHelper',
    '$timeout'
  ];

  angular
    .module('ITH.Base.PriceCalendar')
    .controller('IthPriceCalendarController', IthPriceCalendarController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/price-calendar/helpers/price-calendar.helper.js
(function(angular, moment, underscore) {
/**
   * @name        PriceCalendarHelperService
   * @description Service responsible for loading cell data from backend.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
    var PriceCalendarHelperService = function ($timeout, $filter, CalendarCheapestService, AppConfig, FlightRangeDatePicker) {
        /**
         * Self reference
         */
        var self = this;

        /**
         * Prices for departure calendar
         *
         * @type {Object}
         */
        this.departures = {};

        this.outboundDirects = {};

        /**
         * Minimum departure prices per month
         *
         * @type {Object}
         */
        this.minDepartures = {};

        /**
         * Prices for return calendar
         *
         * @type {Object}
         */
        this.returns = {};

        /**
         * Minimum return prices per month
         *
         * @type {Object}
         */
        this.minReturns = {};

        this.inboundDirects = {};

        /**
         * Calendar departure cell object
         *
         * @type {Object}
         */
        this.selectedDeparture = {
            moment: null,
            date: null,
            hash: '',
            dateObj: {
                year: 0,
                month: 0,
            },
            backendDate: ''
        };

        /**
         * Calendar return cell object
         *
         * @type {Object}
         */
        this.selectedReturn = {
            moment: null,
            date: null,
            hash: '',
            dateObj: {
                year: 0,
                month: 0,
            },
            backendDate: ''
        };

        /**
         * Flag for one-way / round-trip
         *
         * @type {Boolean}
         */
        this.oneWay = false;

        /**
         * Flag for visibility of loader
         *
         * @type {Boolean}
         */
        this.showLoading = false;

        /**
         * Array containing calendar months
         *
         * @type {Array}
         */
        this.calendarMonths = [];

        /**
         * IATA city code for departure place
         *
         * @type {String}
         */
        this.departurePlace = null;

        /**
         * IATA city code for destination place
         *
         * @type {String}
         */
        this.destinationPlace = null;

        /**
         * Application config reference (for currency)
         *
         * @type {AppConfig}
         */
        this.appConfig = AppConfig;

        /**
         * Price filter
         *
         * @type {Object}
         */
        this.priceFilter = $filter('flPrice');

        this.setSelectedDeparture = function (newDeparture) {
            var mom = moment(newDeparture);

            this.selectedDeparture = {
                moment: mom,
                date: newDeparture,
                hash: mom.format('YYYYMMDD'),
                dateObj: {
                    year: mom.format('YYYY'),
                    month: mom.format('MM'),
                },
                backendDate: mom.format('YYYY-MM-DD')
            };
        };

        this.setSelectedReturn = function (newReturn) {
            var mom = moment(newReturn);

            this.selectedReturn = {
                moment: mom,
                date: newReturn,
                hash: mom.format('YYYYMMDD'),
                dateObj: {
                    year: mom.format('YYYY'),
                    month: mom.format('MM'),
                },
                backendDate: mom.format('YYYY-MM-DD')
            };
        };

        /**
         * Calculates cheapest cells by month
         */
        this.calculateCheapestCells = function () {
            var _priceMap = function (sourceObject, way) {
                var year;
                var month;
                var _dayArray;
                var _dayPriceArray;
                var _cellPrice;
                var keyMonth;
                var _targetObject = {};

                for (year in sourceObject) {
                    if (!sourceObject.hasOwnProperty(year)) {
                        continue;
                    }

                    // Prepare data for this year
                    _targetObject[year] = {};

                    for (month in sourceObject[year]) {
                        if (!sourceObject[year].hasOwnProperty(month)) {
                            continue;
                        }

                        _dayArray = sourceObject[year][month];

                        // Map all days for this month
                        _dayPriceArray = Object.keys(_dayArray).map(function (key) {
                            keyMonth = moment(key).format('MM');

                            if (keyMonth !== month) {
                                _cellPrice = Infinity;
                            } else if (way === 'dep') {
                                _cellPrice = _dayArray[key].min_price;
                            } else {
                                _cellPrice = _dayArray[key].min_price - self.getDeparture(self.selectedDeparture);
                            }
                            return _cellPrice;
                        });

                        _targetObject[year][month] = Math.min.apply(0, _dayPriceArray);
                    }
                }

                return _targetObject;
            };

            // Reset minimum prices
            this.minDepartures = _priceMap(this.departures, 'dep');
            this.minReturns = _priceMap(this.returns, 'ret');
        };

        /**
         * Returns total flight price
         *
         * @returns {Number}
         */
        this.getTotalPrice = function () {
            var departurePrice = this.getDeparture(this.selectedDeparture);
            if (this.oneWay) {
                return (departurePrice === 0 || departurePrice === false) ? false : this.priceFilter(departurePrice);
            }
            var returnPrice = this.getReturn(this.selectedReturn);
            return (returnPrice !== false) ? this.priceFilter(returnPrice) : false;
        };

        /**
         * Returns departure price for a specific day
         *
         * @param   {CalendarCellModel} day
         * @returns {Number}
         */
        this.getDeparture = function (day) {
            if (day === null || day.date === null) {
                return false;
            }

            if (
                !this.departures.hasOwnProperty(day.dateObj.year) ||
                !this.departures[day.dateObj.year].hasOwnProperty(day.dateObj.month) ||
                !this.departures[day.dateObj.year][day.dateObj.month].hasOwnProperty(day.backendDate)
            ) {
                return false;
            }

            return this.departures[day.dateObj.year][day.dateObj.month][day.backendDate].min_price;
        };

        /**
         * Returns return price for a specific day
         *
         * @param   {CalendarCellModel} day
         * @returns {Number}
         */
        this.getReturn = function (day) {
            if (day === null || day.date === null) {
                return false;
            }

            if (
                !this.returns.hasOwnProperty(day.dateObj.year) ||
                !this.returns[day.dateObj.year].hasOwnProperty(day.dateObj.month) ||
                !this.returns[day.dateObj.year][day.dateObj.month].hasOwnProperty(day.backendDate)
            ) {
                return false;
            }

            return this.returns[day.dateObj.year][day.dateObj.month][day.backendDate].min_price;
        };

        var dateValue;
        var insertMoment;
        var insertKeyYear;
        var insertKeyMonth;
        var insertKeyDate;

        /**
         * Inserts prices in internal cache
         *
         * @param {Object} targetObject
         * @param {Object} data
         * @param {String} type Either 'dep' or 'ret'
         */
        var _insertDates = function (targetObject, data, type) {
            angular.forEach(data, function (value) {
                dateValue = (type === 'dep') ? value.outboundDepartureDateTime : value.inboundDepartureDateTime;
                insertMoment = moment(dateValue);
                insertKeyYear = insertMoment.format('YYYY');
                insertKeyMonth = insertMoment.format('MM');
                insertKeyDate = insertMoment.format('YYYY-MM-DD');

                if (!targetObject.hasOwnProperty(insertKeyYear)) {
                    // Create entry if it doesn't exist
                    targetObject[insertKeyYear] = {};
                }

                if (!targetObject[insertKeyYear].hasOwnProperty(insertKeyMonth)) {
                    targetObject[insertKeyYear][insertKeyMonth] = {};
                }

                // Insert data for current date
                targetObject[insertKeyYear][insertKeyMonth][insertKeyDate] = {
                    min_price: value.price.value.amount
                };
            });
        };

        var _insertDirects = function (targetObject, data, keyToTake) {
            data.forEach(function (route) {
                route[keyToTake].forEach(function (dateStr) {
                    targetObject[dateStr] = true;
                });
            });
        };

        /**
         * Inserts departure prices in internal cache
         *
         * @param {Object} data
         */
        this.insertDepartures = function (cellData, directData) {
            this.resetDepartures();
            _insertDates(this.departures, cellData, 'dep');
            _insertDirects(this.outboundDirects, directData, 'outboundDates');
        };

        this.resetDepartures = function () {
            Object.keys(this.departures).forEach(function (key) {
                delete self.departures[key];
            });

            Object.keys(this.outboundDirects).forEach(function (key) {
                delete self.outboundDirects[key];
            });
        };

        /**
         * Inserts return prices in internal cache
         *
         * @param {Object} data
         */
        this.insertReturns = function (cellData, directData) {
            this.resetReturns();
            _insertDates(this.returns, cellData, 'ret');
            _insertDirects(this.inboundDirects, directData, 'inboundDates');
        };

        this.resetReturns = function () {
            Object.keys(this.returns).forEach(function (key) {
                delete self.returns[key];
            });

            Object.keys(this.inboundDirects).forEach(function (key) {
                delete self.inboundDirects[key];
            });
        };

        var departureDateInReturnCalendar;

        /**
         * Returns price value for a cell
         *
         * @param {IthPriceCalendarController} ctrl Price calendar controller
         * @param {CalendarCellModel}          day  Calendar cell model
         * @returns {Number}
         */
        this.getCellPriceValue = function (ctrl, day) {
            if (!ctrl.multipleSelect) {
                // Single
                departureDateInReturnCalendar = (
                    ctrl.rangeChange === 'end' &&
                    this.selectedDeparture.date instanceof Date &&
                    this.selectedDeparture.hash === day.hash
                );

                if (ctrl.rangeChange === 'start' || this.oneWay || departureDateInReturnCalendar) {
                    return this.getDeparture(day);
                }

                if (!this.getDeparture(this.selectedDeparture) || !this.getReturn(day)) {
                    return false;
                }

                return this.getReturn(day) - this.getDeparture(this.selectedDeparture);
            }

            // Multiple
            if (this.oneWay || ctrl.rangeChange === 'start') {
                return this.getDeparture(day);
            }

            if (ctrl.startDate && day.date.getTime() <= ctrl.startDate.getTime()) {
                // Before departure date
                return this.getDeparture(day);
            }

            if (!this.getDeparture(this.selectedDeparture) || !this.getReturn(day)) {
                return false;
            }

            // Calculate difference
            return this.getReturn(day) - this.getDeparture(this.selectedDeparture);
        };

        var _price;

        /**
         * Returns price for a cell
         *
         * @param {IthPriceCalendarController} ctrl Price calendar controller
         * @param {CalendarCellModel}          day  Calendar cell model
         * @returns {String}
         */
        this.getCellPrice = function (ctrl, day) {
            _price = this.getCellPriceValue(ctrl, day);

            if (this.oneWay) {
                return this.priceFilter(_price);
            }

            if (!ctrl.multipleSelect) {
                // Single
                if (ctrl.rangeChange === 'end' && _price >= 0 && this.selectedDeparture.date instanceof Date && day.moment.isAfter(this.selectedDeparture.moment, 'day')) {
                    return '+' + this.priceFilter(_price);
                }

                return this.priceFilter(_price);
            }

            // Multiple
            if (_price >= 0 && ctrl.startDate !== null && day.date.getTime() > ctrl.startDate.getTime() && ctrl.rangeChange !== 'start') {
                return '+' + this.priceFilter(_price);
            }

            return this.priceFilter(_price);
        };

        var isStartSelection = function (ctrl) {
            return ctrl.rangeChange === 'start' || self.oneWay || (ctrl.rangeChange !== 'end' && ctrl.rangeChange !== undefined) || ctrl.multipleSelect === true && ctrl.startDate === null;
        };

        var cellPriceValue;
        var whichCollection;
        var dayYear;
        var dayMonth;
        var monthCheapest;

        /**
         * Checks if a cell is cheapest in that month
         *
         * @param   {IthPriceCalendarController} ctrl
         * @param   {CalendarCellModel}          day
         * @returns {Boolean}
         */
        this.isCheapestCell = function (ctrl, day) {
            cellPriceValue = this.getCellPriceValue(ctrl, day);
            whichCollection = isStartSelection(ctrl) ? this.minDepartures : this.minReturns;
            dayYear = day.dateObj.year;
            dayMonth = day.dateObj.month;

            monthCheapest = whichCollection.hasOwnProperty(dayYear) && whichCollection[dayYear].hasOwnProperty(dayMonth) && whichCollection[dayYear][dayMonth];
            return (monthCheapest === cellPriceValue);
        };

        var targetObject;

        this.isDirectCell = function (ctrl, day) {
            targetObject = isStartSelection(ctrl)
                ? this.outboundDirects
                : this.inboundDirects;

            return targetObject.hasOwnProperty(day.backendDate);
        };

        /**
         * Loads price calendar data from API
         *
         * @param {String} whichDate
         * @param {Boolean} oneWay
         */
        this.loadData = function (whichDate, oneWay) {
            if (whichDate === 'departure') {
                this.resetDepartures();
            }

            this.resetReturns();

            if (this.departurePlace.length === 0 || this.destinationPlace.length === 0) {
                return;
            }

            this.showLoading = true;

            if (whichDate === 'return' && this.getDeparture(this.selectedDeparture) === false) {
                this.calendarMonths = [];

                for (var i = 0; i < 12; i++) {
                    var currentMonth = moment(new Date()).startOf('month');
                    this.calendarMonths.push(currentMonth.add(i, 'month').toDate());
                }

                this
                    .makeCalendarRequest('departure', oneWay)
                    .then(function () {
                        if (FlightRangeDatePicker.isStandardMode()) {
                            return self.makeCalendarRequest('return', oneWay);
                        }
                    })
                    .finally(function () {
                        $timeout(function () {
                            self.showLoading = false;
                        }, 100);
                    });

                return;
            }

            this
                .makeCalendarRequest(whichDate, oneWay)
                .finally(function () {
                    $timeout(function () {
                        self.showLoading = false;
                    }, 100);
                });
        };

        this.prevRequestPayload = {};

        this.makeCalendarRequest = function (whichDate, oneWay) {
            return CalendarCheapestService
                .getCells({
                    departurePlace: this.departurePlace,
                    destinationPlace: this.destinationPlace,
                    months: this.calendarMonths,
                    departureDate: this.selectedDeparture.date,
                    maxVisibleDate: moment(underscore.last(this.calendarMonths)).endOf('month').toDate(),
                    oneWay: oneWay,
                    whichDate: whichDate
                })
                .then(function (success) {
                    if (whichDate === 'departure') {
                        self.insertDepartures(success.data.cells, success.data.directMatrices);
                    } else {
                        self.insertReturns(success.data.cells, success.data.directMatrices);
                    }

                    self.calculateCheapestCells();
                })
                .catch(function () {
                    if (whichDate === 'departure') {
                        self.resetDepartures();
                        self.resetReturns();
                    } else {
                        self.resetReturns();
                    }
                });
        };
    };

    PriceCalendarHelperService.$inject = [
        '$timeout',
        '$filter',
        'CalendarCheapestService',
        'appConfig',
        'FlightRangeDatePicker'
    ];

    angular
        .module('ITH.Base.PriceCalendar')
        .service('PriceCalendarHelper', PriceCalendarHelperService);

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/base/providers/AppConfig.js
/*global angular: false, document: false */

angular.module('base')

/**
* Application configuration provider
* The configuration is passed to the app from the backend application in form of JSON object.
*/
    .provider('appConfig',
        [
            function appConfigProvider() {
                //noinspection JSUnresolvedVariable
                var config = angular.extend(getDefaultConfig(), window._js_app_config_ || {}),

                    /**
     * Application configuration
     *
     * @constructor
     */
                    AppConfig = function () {
                        this.decodedCurrencySymbol = this.getCurrencySymbol(true, true);
                    },

                    /**
     * Get application language code
     *
     * @function
     * @return {String}
     */
                    getLanguageCode = function () {
                        return config.language_code;
                    };

                /**
   * Get default config parameters
   *
   * @return {Object}
   */
  function getDefaultConfig() {
    return {
      env_name: 'prod',
      auth_token: '',
      users_service_host: '',
      default_country_code: 'RO',
      language_code: 'en',
      language_flag: 'flag-en',
      departure_date: '',
      return_date: '',
      min_date: moment(),
      max_date: moment().add(1, 'y'),
      first_entry: true,
      flight_from: '',
      flight_from_code: '',
      flight_from_country_code: '',
      flight_from_country_name: '',
      flight_from_airport_name: '',
      flight_from_airport_code: '',
      flight_to: '',
      flight_to_code: '',
      flight_to_country_code: '',
      flight_to_country_name: '',
      flight_to_airport_name: '',
      flight_to_airport_code: '',
      adults: 1,
      children: 0,
      infants: 0,
      youths: 0,
      seniors: 0,
      oneway: false,
      currency_symbol: '&euro;',
      currency_code: 'EUR',
      currency_ex_rate: '1',
      currency_general: 'EUR',
      currency_credit_card_installments: 'RON',
      ignoreLS: false,
      appVer: 'xxx',
      jsMinified: true,
      jsCacheBuster: '',
      cssCacheBuster: '',
      imgCacheBuster: '',
      trip_length_from: 5,
      trip_length_to: 7,
      searchClient: {},
      ab_version: '',
      market: '',
      supportedLangCodes: {},
      domain: window.location.hostname,

                        // TODO: WTF!!!!! This should be passed form PHP !!!

                        // Google remarketing ID
                        googleRemarketingId: 0,

                        // TODO: WTF!!!!! This should be passed form PHP !!!

                        // Google conversions
                        googleConversions: {
                            accounts: [],

                            labels: {}
                        },
                        linkFavorite: '',
                        phones: {general:'',packages:'',hotels:'',escapes:''},
                        special_flag: false,
                        dropZone:true,
                        cbDisabled:true
                    };
                }

                AppConfig.prototype = /** @lends AppConfig.prototype */ {

                    /**
     * Get application language code
     *
     * @type   {Function}
     * @return {String}   The language code ex: pl, ro, en
     */
                    getLanguageCode: getLanguageCode,

                    /**
     * Set language code
     *
     * @param {String} languageCode The language code ex: pl, ro, en
     */
                    setLanguageCode: function (languageCode) {
                        config.language_code = languageCode;
                    },

                    getMarket: function () {
                        return config.market;
                    },

                    getActiveLanguageFlag: function () {
                        return config.language_flag;
                    },
                    /**
     * Has agent permission
     *
     * @returns {boolean}
     */
                    isAgent: function()
                    {
                        return config.user.agent;
                    },

                    /**
     * Get default departure date
     *
     * @return {String} Date in YYYY-MM-DD format
     */
                    getDepDate: function () {
                        return config.departure_date;
                    },

    getAuthToken: function() {
      return config.auth_token;
    },

    setAuthToken: function(token) {
      config.auth_token = token;
    },

    /**
     * Get default initial drop Zone data
     *
     * @return object
     */
                    getDropZone: function () {
                        return config.dropZone;
                    },
                    /**
     * Get default initial drop Zone data
     *
     * @return object
     */

                    setDropZone: function (drop) {
                        config.dropZone=drop;
                    },

                    /**
     * Returns the current domain
     *
     * @return {String}
     */
                    getDomain: function () {
                        return config.domain;
                    },

                    /**
     * Get default return date
     *
     * @return {String} Date in YYYY-MM-DD format
     */
                    getRetDate: function () {
                        return config.return_date;
                    },

                    /**
     * Get Ab app version
     *
     * @return {String} example: A, B or C
     */
                    getAppAbVersion: function () {
                        return config.ab_version;
                    },

                    /**
     * Get default minimum date for calendar
     *
     * @return {String}
     */
                    getMinDate: function () {
                        return config.min_date;
                    },

                    /**
     * Get default maximum date for calendar
     *
     * @return {String}
     */
                    getMaxDate: function () {
                        return config.max_date;
                    },

                    /**
     * Get default departure city name
     *
     * @return {String}
     */
                    getDepCityName: function () {
                        return config.flight_from;
                    },

                    /**
     * Get default departure city code
     *
     * @return {String} The three letter city code ex. KRK
     */
                    getDepCityCode: function () {
                        return config.flight_from_code;
                    },

                    /**
     * Get search client details
     *
     * @return {Object}
     */
                    getSearchClient: function () {
                        return config.searchClient;
                    },

                    /**
     * Get default departure country code
     *
     * @return {String} The two letter country code ex. PL
     */
                    getDepCountryCode: function () {
                        return config.flight_from_country_code;
                    },

                    /**
     * Get default departure country name
     *
     * @return {String}
     */
                    getDepCountryName: function () {
                        return config.flight_from_country_name;
                    },

                    /**
     * Get default departure airport name
     *
     * @return {String}
     */
                    getDepAirportName: function () {
                        return config.flight_from_airport_name;
                    },

                    /**
     * Get default departure airport code
     *
     * @return {String} The three letter airport code ex. KRK
     */
                    getDepAirportCode: function () {
                        return config.flight_from_airport_code;
                    },

                    /**
     * Returns true if CB module is disabled
     *
     * @return {String} The three letter airport code ex. KRK
     */
                    isCBModuleDisabled: function () {
                        return config.cbDisabled;
                    },

                    /**
     * Get default return city name
     *
     * @return {String}
     */
                    getDesCityName: function () {
                        return config.flight_to;
                    },

                    /**
     * Get default return city code
     *
     * @return {String} The three letter city code ex. KRK
     */
                    getDesCityCode: function () {
                        return config.flight_to_code;
                    },

                    /**
     * Get default return country code
     *
     * @return {String} The two letter country code ex. PL
     */
                    getDesCountryCode: function () {
                        return config.flight_to_country_code;
                    },

                    /**
     * Get default return country name
     *
     * @return {String}
     */
                    getDesCountryName: function () {
                        return config.flight_to_country_name;
                    },

                    /**
     * Get default return airport name
     *
     * @return {String}
     */
                    getDesAirportName: function () {
                        return config.flight_to_airport_name;
                    },

                    /**
     * Get default return airport code
     *
     * @return {String} The three letter airport code ex. KRK
     */
                    getDesAirportCode: function () {
                        return config.flight_to_airport_code;
                    },

                    /**
     * Get default number of adults
     *
     * @return {Number}
     */
                    getAdults: function () {
                        return config.adults;
                    },

                    /**
     * Get default number of children
     *
     * @return {Number}
     */
                    getChildren: function () {
                        return config.children;
                    },

                    /**
     * Get default number of infants
     *
     * @return {Number}
     */
                    getInfants: function () {
                        return config.infants;
                    },

                    /**
     * Get default number of youths
     *
     * @return {Number}
     */
                    getYouths: function () {
                        return config.youths;
                    },

                    /**
     * Returns true if default should be one way
     *
     * @return {bool}
     */
                    isOneWay: function () {
                        return config.oneway;
                    },

                    /**
     * Get default currency symbol
     *
     * @param {Boolean} [decoded=false]
     * @param {Boolean} [force=false]
     *
     * @return {String}
     */
                    getCurrencySymbol: function (decoded, force) {
                        force = force || false;

                        if (decoded) {
                            if (!force && this.decodedCurrencySymbol) return this.decodedCurrencySymbol;

                            var str, temp = document.createElement('p');
                            temp.innerHTML = config.currency_symbol;
                            str = temp.textContent || temp.innerText;
                            temp = null;
                            this.decodedCurrencySymbol = str;

                            return str;
                        }
                        else {
                            return config.currency_symbol;
                        }
                    },

                    /**
     * Get default currency code
     *
     * @return {String}
     */
                    getCurrencyCode: function () {
                        return config.currency_code;
                    },

                    /**
     * Get default currency exchange rate
     *
     * @return {String}
     */
                    getCurrencyExRate: function () {
                        return config.currency_ex_rate;
                    },

                    /**
     * Get general currency
     *
     * @return {String}
     */
                    getGeneralCurrency: function () {
                        return config.currency_general;
                    },

                    getCurrencyForCreditCardInstallments: function () {
                        return config.currency_credit_card_installments;
                    },

                    /**
     * Get default country code
     *
     * @return {String} Ex: PL, RO, GB
     */
                    getDefaultCountryCode: function () {
                        return config.default_country_code;
                    },

                    /**
     * Return true if we run on production
     *
     * @return {Boolean}
     */
                    isProd: function () {
                        return config.env_name == 'prod';
                    },

                    /**
     * Return true if we run on test
     *
     * @return {Boolean}
     */
                    isTest: function () {
                        return config.env_name == 'test' || config.env_name == 'testx';
                    },

                    /**
     * Return true if we run on local
     *
     * @return {Boolean}
     */
                    isLocal: function () {
                        return config.env_name == 'local';
                    },

                    /**
     * Return true if special flag is set
     *
     * @return {Boolean}
     */
                    isSpecial: function() {
                        return config.special_flag;
                    },

                    /**
     * Return environment name: prod, test, local
     *
     * @return {String}
     */
                    getEnvName: function () {
                        return config.env_name;
                    },

                    /**
     * Checks to see if environment is production
     * @return {Boolean}
     */
                    isEnvProd: function () {
                        return this.getEnvName() === 'prod';
                    },

                    isEnvLocal: function () {
                        return this.getEnvName() === 'local';
                    },

                    /**
     * Should local storage be ignored?
     *
     * @return {Boolean}
     */
                    getIgnoreLS: function () {
                        return config.ignoreLS;
                    },

                    /**
     * Log config
     *
     * Debugging helper
     */
                    logConfig: function () {
                        //console.log('AppConfig config', config);
                    },

                    /**
     * Returns desktop redirect link
     *
     * @param {String} path The redirect path
     *
     * @return {String}
     */
                    getDesktopRedirect: function (path) {
                        return config.desktopLink + path;
                    },

                    /**
     * Get application version
     *
     * @return {String}
     */
                    getAppVersion: function () {
                        return config.app_version;
                    },

                    /**
     * Get application media version
     *
     * @return {String}
     */
                    getAppVer: function () {
                        return config.appVer;
                    },

                    /**
     * Get JavaScript cache buster
     *
     * @return {String}
     */
                    getJsCacheBuster: function () {
                        return config.jsCacheBuster;
                    },

                    /**
     * Returns Google conversion Id for AdWords
     *
     * @return {Number}
     */
                    getGoogleRemarketingId: function () {
                        return config.googleRemarketingId;
                    },

                    /**
     * Returns Google conversion config object
     *
     * @return {Object}
     */
                    getGoogleConversions: function () {
                        return config.googleConversions;
                    },

                    /**
     * Returns caching setting
     *
     * @return {Boolean}
     */
                    isCacheActive: function () {
                        return !!config.useCache;
                    },

                    /**
     * Get phone numbers
     *
     * @return {Boolean}
     */
                    getPhoneNumbers: function () {
                        return config.phones;
                    },

                    /**
     * Returns LCC cache time setting (in miliseconds)
     *
     * @return {Number}
     */
                    getLccCacheTime: function () {
                        return +config.cacheTimeLcc;
                    },

                    /**
     * Returns GDS cache time setting (in miliseconds)
     *
     * @return {Number}
     */
                    getGdsCacheTime: function () {
                        return +config.cacheTimeGds;
                    },

                    /**
     * Min trip length as number of days
     *
     * @return {Number}
     */
                    getTripLengthFrom: function () {
                        return config.trip_length_from;
                    },

                    /**
     * Max trip length as number of days
     *
     * @return {Number}
     */
                    getTripLengthTo: function () {
                        return config.trip_length_to;
                    },

                    /**
     * Return true if js minified
     *
     * @return {Boolean}
     */
                    isJsMinified: function () {
                        return config.jsMinified;
                    },

                    /**
     * Returns URL for template
     *
     * @return {String}
     */
                    templateUrl: function (url) {
                        return (this.isLocal() && !this.isJsMinified() || this.getJsCacheBuster() === '__local__') ? 'http://shared.local' + url : url;
                    },

                    /**
     * Returns media URL
     *
     * @return {String}
     */
                    getMediaUrl: function () {
                        return config.media_url;
                    },

                    /**
     * Get Facebook App Id
     * @returns {*}
     */
                    getFacebookAppId: function () {
                        return config.facebook_appId;
                    },

                    getPaymentButton: function () {
                        return config.paymentButton;
                    },

                    /**
     * Get Cashback settings
     * @returns {Boolean}
     */
                    getCashbackSettings: function () {
                        return config.cashback;
                    },

                    /**
     * Get Newsletter settings
     * @returns {Boolean}
     */
                    getNewsletterSettings: function () {
                        return config.newsletter;
                    },

                    /**
     * Dynamic (from database) Angular routes
     *
     * @returns {Array}
     */
                    getRoutes: function () {
                        return config.ng_routes;
                    },

                    /**
     * Lazy-loaded module dependencies
     *
     * @param {String} module
     * @returns {Array}
     */
                    getLazyFiles: function (module) {
                        function addCacheBuster(file) {
                            return file + '?v=' + this.getJsCacheBuster()  +'&abv='+_js_app_config_.ab_version;
                        }

                        return _.map(config.lazyload[module], addCacheBuster, this);
                    },

                    /**
     * Get the ng static page default url
     * (for home page)
     *
     * @returns {Object}
     */
                    getHomePageUrl: function () {
                        return config.home_page_url;
                    },

                    /**
     * Get the hotel config
     *
     * @returns {Object}
     */
                    getHotelConfig: function () {
                        return config.hotel;
                    },

                    /**
     * Get the insurance type
     *
     * @returns {Object}
     */
                    getInsuranceConfig: function () {
                        return config.insurance.defaultType;
                    },

                    /**
     * Get the refunds config
     *
     * @returns {Object}
     */
                    getRefundsConfig: function () {
                        return config.refunds;
                    },

                    /**
     * Get device params
     *
     * @returns {Object}
     */
                    getDeviceType: function () {
                        return config.device;
                    },

                    /**
     * Get device tablet params
     *
     * @returns {Boolean}
     */
                    isTablet: function () {
                        return config.device && config.device.tablet;
                    },

                    /**
     * Return true if user device is mobile and not tablet
     *
     * @returns {boolean}
     */
                    isPhone: function(){
                        return this.isMobile() && (this.isTablet() === false);
                    },

                    /**
     * Get device tablet params
     *
     * @returns {Boolean}
     */
                    isMobile: function () {
                        return config.device && config.device.mobile;
                    },

                    /**
     * False if user make search before
     *
     * @returns {Boolean}
     */
                    isFirstEntry: function () {
                        return config.first_entry;
                    },

                    /**
     * mark, that is no first entry
     */
                    setFirstEntryToFalse: function () {
                        config.first_entry = false;
                    },

                    /**
     * Check is search result page
     *
     * @return {string}
     */
                    isSearchResultPage: function () {
                        var path = window.location.pathname;
                        var regex = /\/(flight_search)\//g;
                        return (regex.exec(path) !== null) ? true : false;
                    },

                    isRoundTrip: function(){
                        if(this.isSearchResultPage()){
                            var path = window.location.pathname,
                                regex = /\/(ow)\/1/,
                                matches;

                            matches = regex.exec(path);

                            if(matches){
                                return 'OW';
                            }

                            return 'RT';
                        }
                        return false;
                    },

                    /**
     * Check is device has iOS
     *
     * @returns {boolean}
     */
                    isIOS: function ()
                    {
                        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    },

                    /**
     * Check the a/b config
     *
     * @return {Object}
     */
                    getAbConfig: function () {
                        return Object.assign({ dfs_forms_position: 'end' }, config.flow);
                    },

                    /**
     * Check if a feature test is enabled by name
     *
     * @returns {Boolean}
     */
                    isFeatureTestEnabled: function (testName) {
                        return (
                            this.getAbConfig().hasOwnProperty(testName) &&
        this.getAbConfig()[testName].toLowerCase() === 'on'
                        );
                    },

                    /**
     * Get config user
     *
     * @return {Object}
     */
                    getUser: function () {

                        return config.user || {};
                    },

                    getLinkFavorite: function () {
                        var value = config.linkFavorite;
                        config.linkFavorite = '';

                        return value;
                    },

                    getCityHelperCache: function() {
                        return config.cityHelperCache;
                    },

                    getAnotherLanguages: function () {
                        return config.anotherLanguages;
                    },

                    getCurrencies: function () {
                        return config.currencies;
                    },

                    getUserLanguage: function(){
                        return config.userLanguage;
                    },

                    getUserFlag: function(){
                        return config.userLanguageFlag;
                    },

                    isStaticPage: function() {
                        return config.isStaticPage;
                    },

                    isLandingPage: function(){
                        return config.isLandingPage;
                    },

                    /**
     * Get fare alerts config.
     *
     * @returns {Array}
     */
                    getFareAlerts: function() {
                        return config.fareAlerts;
                    },

                    /**
     * Returns affiliate Id
     *
     * @returns {Number}
     */
                    getAffiliateId: function () {
                        return config.affiliateId;
                    },

                    /**
     * Returns affiliate name based on affiliate id
     *
     * @returns {String}
     */
                    getAffiliateName: function () {
                        return config.affiliateName;
                    },

                    /**
     * Checks if affiliate is Vola
     *
     * @returns {Boolean}
     */
                    isVola: function () {
                        return this.getAffiliateId() === 1;
                    },

                    isFru: function () {
                        return this.getAffiliateId() === 3;
                    },

                    isGovola: function () {
                        return this.getAffiliateName() === 'govola';
                    },

                    /**
     * Get search panel config.
     *
     * @returns {Array}
     */
                    getSearchPanel: function() {
                        return config.searchPanel || {};
                    },

                    /**
     * Returns RODO configuration.
     *
     * @returns {Object}
     */
                    getRodoConfig: function () {
                        return config.rodo || {};
                    },

                    /**
     * Returns Ieftinuarie enabled status.
     *
     * @returns {boolean}
     */
                    getIeftinuarieConfig: function () {
                        return config.flow.ieftinuarie || false;
                    },

                    getFareLockAbTest: function () {
                        return config.flow.fare_lock_enabled !== 'Off' || false;
                    },

                    getIeftinuarieStaticPagePath: function () {
                        return config.flow.ieftinuarieStaticPage || '';
                    },

                    isLangsCollectorEnabled: function () {
                        return config.isLangsCollectorEnabled || false;
                    },

                    getFreeRebookingConfig: function () {
                        return config.flow.freeRebooking || false;
                    },

                    isFreeRebookingFlow: function () {
                        return this.getFreeRebookingConfig() === 'On';
                    },

                    getSeatsSearchMode: function () {
                        return config.seats.searchMode;
                    },

                    /**
                     * Returns on/off switch for the price trends campaign
                     *
                     * @returns {Boolean}
                     */
                    getPriceTrendsConfig: function () {
                        return config.priceTrends || false;
                    },
                    /**
                     *
                     */
                    getWebsiteSettings: function () {
                        return config.websiteSettings || {};
                    },

                    getUriPrefix: function () {
                      return config.websiteSettings.domain.uriPrefix || '';
                    },

                    /**
                     * Returns vacations config
                     */
                    getVacationsConfig: function () {
                        return config.vacations || {};
                    },

                    /**
                     * Returns config for seats
                     *
                     * @returns {Object}
                     */
                    getSeatsConfig: function () {
                        return config.seats || {
                            host: ''
                        };
                    },

                    /**
                     * Returns config for payments
                     *
                     * @returns {Object}
                     */
                    getPaymentsConfig: function () {
                        return config.payments || {
                            host: ''
                        };
                    },

                    getUsersServiceHost: function () {
                        return config.users_service_host;
                    },

                    getPusherConfig: function () {
                        return config.pusher;
                    },

                    getSupportedLangCodes: function () {
                        return config.supportedLangCodes;
                    },

                    getCovidInsuranceConfig: function () {
                        return config.covidInsurance || {
                            paxPriceTrends: false
                        };
                    },

                    getShelfConfig: function () {
                        return config.shelfManagement;
                    },

                    getAnalyticsMicroserviceConfig: function () {
                        var defaultConfig = {
                            endpoints: {
                                message: 'https://sbox.ith.toys/analytics-service/v1/public/message/send'
                            }
                        };

                        return Object.keys(config.analyticsMicroservice).length > 0
                            ? config.analyticsMicroservice
                            : defaultConfig;
                    },

                    getGaSession: function () {
                        return config.gaSession;
                    },

                    getCheckinServiceConfig: function() {
                        return config.checkinService;
                    },

                    getIsBookingComSearchEnabled: function() {
                        return this.isFeatureTestEnabled('booking_search_extension')
                    },

                    getBookingComAid: function() {
                        return config.websiteSettings.booking.aid;
                    },

                    getNextGenSearchAbTest: function() {
                        return config.flow.new_gen_search_version !== 'Off' || false;
                    },

                    getIsChangedButtonFlowAbTest: function() {
                        return config.flow.changed_buttons_flow !== 'Off' || false;
                    }
                };

                AppConfig.prototype.constructor = AppConfig;

                /**
   * Get application language code
   *
   * @type   {Function}
   * @return {String} The language code ex. pl, ro, en
   */
                this.getLanguageCode = getLanguageCode;

                this.$get = [function () {
                    return new AppConfig();
                }];

            }]);
;

// Source: ../shared/public_html/assets/js/base/providers/StyleHelper.js
angular.module('base')

/**
 * @name base.StyleHelper
 *
 * @description Helper responsible for applying cross-browser styles to an element from js
 */
.factory('StyleHelper',
[function StyleHelperFactory() {
/**
   * Style helper
   *
   * @constructor
   */
  var StyleHelper = function () {};

  StyleHelper.prototype = /** @lends StyleHelper.prototype */ {
    /**
     * Applies cross browser style to a DOM element
     *
     * @param  {DOMElement} element The dom element we want to apply styles to
     * @param  {String} style       The style we want to apply to the DOM element
     */
    applyStyle: function (element, style) {
      element.style.transform = style;
      element.style.OTransform = style;
      element.style.msTransform = style;
      element.style.MozTransform = style;
      element.style.WebkitTransform = style;
    },

    /**
     * Applies cross browser css transition to a DOM element
     *
     * @param  {DOMElement} element The dom element we want to apply transition to
     * @param  {String} transition  The css transition we want to apply to the DOM element
     */
    applyTransition: function (element, transition) {
      element.style.transition = transition;
      element.style.OTransition = transition;
      element.style.msTransition = transition;
      element.style.MozTransition = transition;
      element.style.WebkitTransition = transition;
    }
  };

  StyleHelper.prototype.constructor = StyleHelper;

  return new StyleHelper();
}]);

;

// Source: ../shared/public_html/assets/js/base/rodo/rodo-clause.component.js
(function (angular) {
var template = ''
        + '<div class="rodo-clause">'
        + '  <div class="rodo-clause__short-text rodo-slide-animation" ng-show="!$ctrl.isOpen()">'
        + '    <span>{{ $ctrl.getClauseData().short | translate }}</span>'
        + '    <a href="javascript:void(0)" ng-click="$ctrl.openClause()" translate>LANGM_JS_RODO_SHOW_MORE</a>'
        + '  </div>'
        + '  <div class="rodo-clause__scroll-box rodo-slide-animation" ng-show="$ctrl.isOpen()" text-box-body="{{ $ctrl.getClauseData().long }}"></div>'
        + '</div>';

    /**
     * @name        IthRodoClauseComponent
     * @description Displays a RODO clause
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRodoClauseComponent = {
        template: template,
        controller: 'RodoClauseController',
        bindings: {
            index: '<',
            zone: '<'
        }
    };

    angular
        .module('ITH.Base.Rodo')
        .component('ithRodoClause', IthRodoClauseComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo-clause.controller.js
(function(angular) {
/**
     * @name        IthRodoClauseController
     * @description Binds data for the RODO template
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRodoClauseController = function (RODO_CLAUSES, RodoService) {
        /**
         * Array with clause langs and text boxes
         * @type {Object[]}
         */
        this.clauses = RODO_CLAUSES;

        /**
         * Sets the current open clause index
         */
        this.openClause = function () {
            RodoService.setActiveIndex(this.index, this.zone);
        };

        /**
         * Checks if current clause is open
         * @returns {bool}
         */
        this.isOpen = function () {
            return parseInt(this.index) === RodoService.activeIndex;
        };

        /**
         * Returns current clause data
         * @returns {object}
         */
        this.getClauseData = function () {
            return this.clauses[parseInt(this.index)];
        };
    };

    IthRodoClauseController.$inject = [
        'RODO_CLAUSES',
        'RodoService'
    ];

    angular
        .module('ITH.Base.Rodo')
        .controller('RodoClauseController', IthRodoClauseController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo-sliding-checkbox.component.js
(function(angular) {
/**
     * @name        IthRodoSlidingCheckboxComponent
     * @description Component that shows a checkbox when clicking a link (used in GDPR for vola)
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRodoSlidingCheckboxComponent = {
        templateUrl: 'tpl/show/jsShared/templates/base/components/rodo/sliding-checkbox',
        controller: 'SlidingCheckboxController',
        bindings: {
            nlSubscribeProp: '=',
            product: '@'
        }
    };

    angular
        .module('ITH.Base.Rodo')
        .component('ithRodoSlidingCheckbox', IthRodoSlidingCheckboxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo-sliding-checkbox.controller.js
(function(angular) {
/**
     * @name        RodoSlidingCheckboxController
     * @description Binds data for the sliding checkbox component
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var RodoSlidingCheckboxController = function () {
        /**
         * Controller on init hook
         */
        this.$onInit = function () {
            // Set newsletter subscription to opt-out
            this.nlSubscribeProp = true;

            // Hide checkbox initially
            this.showCheckbox = false;
        };

        /**
         * Returns proper lang by using the product component property.
         *
         * @returns {string}
         */
        this.getLangByProduct = function () {
            return 'LANGM_JS_RODO_PAX_NEWSLETTER_CLAUSE_' + this.product.toUpperCase();
        };

        /**
         * Show checkbox
         */
        this.show = function () {
            this.showCheckbox = true;
            this.nlSubscribeProp = false;
        };
    };

    angular
        .module('ITH.Base.Rodo')
        .controller('SlidingCheckboxController', RodoSlidingCheckboxController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        var templateName = '';

        switch ($attrs.zone) {
        case 'aboveButtons': templateName = 'above-buttons'; break;
        case 'belowButtons': templateName = 'below-buttons'; break;
        case 'nlComponent': templateName = 'nl-component'; break;
        case 'fareAlertsBox': templateName = 'fa-box'; break;
        case 'fareAlertsPage': templateName = 'fa-page'; break;
        case 'packagesPax': templateName = 'packages-pax'; break;
        case 'hotelsPax': templateName = 'hotels-pax'; break;
        case 'contactForms': templateName = 'contact-forms'; break;
        default: templateName = 'register'; break;
        }

        return '/tpl/show/jsShared/templates/base/components/rodo/' + templateName;
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    /**
     * @name        IthRodoComponent
     * @description Displays a RODO zone
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRodoComponent = {
        templateUrl: templateUrl,
        controller: 'RodoController',
        bindings: {
            zone: '@',
            nlSubscribeProp: '=',
            nlSubscribeHasError: '<'
        }
    };

    angular
        .module('ITH.Base.Rodo')
        .component('ithRodo', IthRodoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo.constant.js
(function(angular) {
/**
     * Collection of all the RODO clauses
     * @type {Object[]}
     */
    var rodoClauses = [
        {
            short: 'LANGM_JS_RODO1_TEXT_SHORT',
            long: 'rodo_long_clause_text_1'
        },
        {
            short: 'LANGM_JS_RODO2_TEXT_SHORT',
            long: 'rodo_long_clause_text_2'
        },
        {
            short: 'LANGM_JS_RODO3_TEXT_SHORT',
            long: 'rodo_long_clause_text_3'
        }
    ];

    angular
        .module('ITH.Base.Rodo')
        .constant('RODO_CLAUSES', rodoClauses);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo.controller.js
(function(angular) {
/**
     * @name        IthRodoController
     * @description Keeps track of which RODO clause is open
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRodoController = function (RodoService) {
        /**
         * Controller on init hook
         */
        this.$onInit = function () {
            // Default to hidden boxes
            RodoService.resetActiveIndex();

            if (this.nlSubscribeProp && this.isEnabled()) {
                // Set newsletter to opt in
                this.nlSubscribeProp = false;
            }
        };

        /**
         * Checks if this rodo zone is enabled
         * @returns {boolean}
         */
        this.isEnabled = function () {
            return RodoService.isEnabled(this.zone);
        };
    };

    IthRodoController.$inject = [
        'RodoService'
    ];

    angular
        .module('ITH.Base.Rodo')
        .controller('RodoController', IthRodoController);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/rodo/rodo.service.js
(function(angular) {
/**
     * Module responsible for showing EU regulations clauses on pax details
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var RodoService = function (AppConfig) {
        /**
         * Index of current open clause (defaults to -1 to have nothing open by default).
         *
         * @type {int}
         */
        this.activeIndex = -1;

        /**
         * Set new clause active index.
         *
         * @param {integer} newIndex Index for the open clause
         * @param {string}  zone     Zone where the clause is open
         */
        this.setActiveIndex = function (newIndex, zone) {
            this.activeIndex = newIndex;

            if (typeof (ga) !== 'undefined') {
                // Track this event in analytics
                ga('send', 'event', 'Website Clicks', 'Rodo clause click', 'Rodo clause ' + zone + ' ' + newIndex, { nonInteraction: true });
            }
        };

        /**
         * Resets active index to detault.
         */
        this.resetActiveIndex = function () {
            this.activeIndex = -1;
        };

        /**
         * Checks if RODO is enabled.
         *
         * @param {string} zone Zone on which rodo is displayed.
         * @returns {boolean}
         */
        this.isEnabled = function (zone) {
            // Check if RODO is active in current language
            if (AppConfig.getRodoConfig().languages.indexOf('*') === -1 && AppConfig.getRodoConfig().languages.indexOf(AppConfig.getLanguageCode()) === -1) {
                // RODO is not active for current language
                return false;
            }

            return AppConfig.getRodoConfig().zones[zone] || false;
        };

        this.getSettings = function () {
            return AppConfig.getRodoConfig().settings || {};
        };
    };

    RodoService.$inject = [
        'appConfig'
    ];

    angular
        .module('ITH.Base.Rodo')
        .service('RodoService', RodoService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/script-inject.service.js
(function(angular, document) {
var ScriptInjectService = function ($q) {
        /**
         * Injects a script and returns load promise
         *
         * @param {String} id
         * @param {String} src
         *
         * @returns {Promise}
         */
        this.inject = function (id, src) {
            var injectedScript = document.getElementById(id);

            return $q(function (resolve, reject) {
                if (injectedScript !== null) {
                    injectedScript.remove();
                }

                if (src === '' || src === null) {
                    return;
                }

                var script = document.createElement('script');
                script.async = true;
                script.src = src + '?v=' + new Date().getTime();
                script.id = id;
                script.addEventListener('load', resolve);
                script.addEventListener('error', reject);
                script.addEventListener('abort', reject);
                document.head.appendChild(script);
            });
        };

        /**
         * Checks whether a script with given id has been already injected
         *
         * @param {String} id
         * @returns {boolean}
         */
        this.isInjected = function (id) {
            return document.getElementById(id) !== null;
        };
    };

    ScriptInjectService.$inject = ['$q'];

    angular
        .module('base')
        .service('ScriptInject', ScriptInjectService);

}(angular, document));
;

// Source: ../shared/public_html/assets/js/base/services/AnchorSmoothScroll.js
/*global angular: false */

angular.module('base')

/**
 * @name        AnchorSmoothScroll
 * @description Handles smooth scroll on anchor interaction
 */
.factory('AnchorSmoothScroll',
[
'$timeout', function AnchorSmoothScrollFactory($timeout) {
/**
   * AnchorSmoothScroll
   *
   * @constructor
   */
  var AnchorSmoothScroll = function () {
  };

  AnchorSmoothScroll.prototype = /** @lends AnchorSmoothScroll.prototype */ {
    scrollTo: function (eID) {
      var startY = this.currentYPosition(),
        stopY = this.elmYPosition(eID),
        distance = stopY > startY ? stopY - startY : startY - stopY,
        speed = Math.round(distance / 100);

      if (distance < 100) {
        scrollTo(0, stopY);
        return;
      }

      if (speed >= 20) speed = 20;

      var step = Math.round(distance / 25),
        leapY = stopY > startY ? startY + step : startY - step,
        i = 0,
        timer = 0;

      if (stopY > startY) {
        for (i = startY; i < stopY; i += step) {
          this.timeoutScroll(leapY, timer, speed);
          leapY += step;
          timer++;

          if (leapY > stopY) {
            leapY = stopY;
          }
        }
        return;
      }

      for (i = startY; i > stopY; i -= step) {
        this.timeoutScroll(leapY, timer, speed);
        leapY -= step;
        timer++;

        if (leapY < stopY) {
          leapY = stopY;
        }
      }
    },

    currentYPosition: function () {
      // Firefox, Chrome, Opera, Safari
      if (self.pageYOffset) {
        return self.pageYOffset;
      }

      // Internet Explorer 6 - standards mode
      if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
      }

      // Internet Explorer 6, 7 and 8
      if (document.body.scrollTop) {
        return document.body.scrollTop;
      }

      return 0;
    },

    elmYPosition: function (eID) {
      var elm = document.getElementById(eID);
      var y = elm.offsetTop;
      var node = elm;

      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }

      return y;
    },

    timeoutScroll: function (leapY, timer, speed) {
      $timeout(function () {
        window.scrollTo(0, leapY);
      }, timer * speed);
    }
  };

  AnchorSmoothScroll.prototype.constructor = AnchorSmoothScroll;

  return new AnchorSmoothScroll();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/ApiTools.js
/* global angular: false */
(function (angular, _) {
/**
     * @name        ApiTools
     * @description A service that provides methods for communicating with the server through JSON APIs
     */
    angular.module('base').factory('ApiTools', factory);

    factory.$inject = ['$http', '$q', '$cacheFactory'];
    function factory($http, $q, $cacheFactory) {

        var forEach = angular.forEach;
        var bind = angular.bind;

        var baseConfig = {
            cache: false,
            ignoreLoadingBar: true,
            headers: {
                'Content-Type': 'application/json',
            },
        };

        /**
         * ApiTools constructor
         *
         * @constructor
         */
        var ApiTools = function () {};

        ApiTools.prototype = {

            /**
             * Check if API response is a success
             *
             * @param  {apiResponse} response
             *
             * @return {Boolean}
             */
            isSuccess: function (response) {
                return response &&
                    response.success === true &&
                    response.http_code &&
                    response.http_code >= 200 &&
                    response.http_code < 300;
            },

            /**
             * Build API request URL
             *
             * @param  {String} url    The endpoint path with parameters indicated with colon ex. /api/getResult/:requestId
             * @param  {String} verb   The HTTP verb (GET, POST,...)
             * @param  {Object} params The URL parameters
             *
             * @return {String}
             */
            buildRequestUrl: function (url, verb, params) {
                var requestUrl = url;
                forEach(params, function (value, key) {
                    var tmpUrl = requestUrl;

                    requestUrl = requestUrl.replace(':' + key, value);

                    // Detecting if key was replaced
                    if (requestUrl !== tmpUrl) {
                        // Key was replaced
                        delete params[key];
                    }
                });

                return requestUrl.replace(new RegExp('\/+$', 'g'), '/');
            },

            /**
             * Fetch results from the REST API
             *
             * @param  {Object} requesterObj    The the instance on behalf whom we do the request for
             * @param  {Object} apiEndpoint     The request configuration
             * @param  {Object} [reqData=null]  The data to send with the request
             * @param  {Object} [reqUrlData={}] The URL parameters
             * @param  {Object} [timeout]       Timeout in milliseconds, or promise that should abort the request when resolved
             *
             * @return {Promise}
             */
            fetch: _.compose(withoutCache, createReqConfig),

            /**
             * Fetch results from the REST API and cache them
             *
             * @param  {Object} requesterObj    The the instance on behalf whom we do the request for
             * @param  {Object} apiEndpoint     The request configuration
             * @param  {Object} [reqData=null]  The data to send with the request
             * @param  {Object} [reqUrlData={}] The URL parameters
             * @param  {Object} [timeout]       Timeout in milliseconds, or promise that should abort the request when resolved
             *
             * @return {Promise}
             * */
            fetchCache: _.compose(withCache, createReqConfig),

            /**
             * Base config for `http` method
             */
            baseConfig: baseConfig,

            /**
             * Tiny wrapper around Angular's `$http`
             *
             * @param config
             * @returns {*}
             */
            http: function (config) {
                return $http(angular.merge({}, baseConfig, config));
            },

            /**
             * Adds serialized GET parameters to an url
             *
             * @param  {String} url    The base API url
             * @param  {Object} params The parameters that need appending to url
             *
             * @return {String}
             */
            serializeParams: function (url, params) {
                var str = [];
                for (var p in params) {
                    if (params.hasOwnProperty(p)) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
                    }
                }
                return url + '?' + str.join('&');
            }
        };

        ApiTools.prototype.constructor = ApiTools;

        function createReqConfig(requesterObj, apiEndpoint, reqData, reqUrlData, timeout, headers) {
            // Set default function parameters values if not provided
            reqData = reqData || null;
            reqUrlData = reqUrlData || {};
            headers = angular.extend({}, headers, {'Content-Type': 'application/json'});

            if (apiEndpoint.method && apiEndpoint.method === 'POST') {
                reqData.debugMode = 1;
            }
            if (apiEndpoint.method && apiEndpoint.method === 'GET') {
                reqUrlData.debugMode = 1;
            }
            // Assign SearchAPI instance to self
            var
                // Build URL to send request to
                url = ApiTools.prototype.buildRequestUrl(apiEndpoint.url, apiEndpoint.method, reqUrlData),

                // Configure the request
                reqConfig = {
                    url: url,
                    method: apiEndpoint.method,
                    params: reqUrlData,
                    headers: headers,
                    cache: false,
                    ignoreLoadingBar: true,
                    // Set the parser to parse the results with
                    respParser: bind(requesterObj, apiEndpoint.respParser),
                    isSuccess: bind(requesterObj, apiEndpoint.isSuccess)
                };

            if (reqData !== null) {
                reqConfig.data = JSON.stringify(reqData);
            }
            if (timeout) {
                reqConfig.timeout = timeout;
            }
            return reqConfig;
        }

        function withCache(reqConfig) {
            var cache = $cacheFactory.get(reqConfig.url);

            if (!cache) {
                cache = $cacheFactory(reqConfig.url);
            }
            return cache.get(reqConfig.url) || cache.put(
                reqConfig.url,
                $http(reqConfig).then(successCallback, errorCallback)
            );
        }

        function withoutCache(reqConfig) {

            // Perform API request
            return $http(reqConfig).then(successCallback, errorCallback);
        }

        function successCallback(response) {
            // use custom success check or fallback to ApiTools.prototype.isSuccess
            if (response.config.isSuccess && response.config.isSuccess(response)) {
                return response.config.respParser(response.data);
            } else if (ApiTools.prototype.isSuccess(response.data)) {
                // Parse response
                return response.config.respParser(response.data);
            } else {
                return $q.reject(response.data);
            }
        }

        function errorCallback(response) {
            return $q.reject(response.data);
        }

        return new ApiTools();
    }

})(angular, _);
;

// Source: ../shared/public_html/assets/js/base/services/BackToBasket.js
/*global angular: false */

angular.module('base')

/**
 * @name        BackToBasket
 * @description Class that handles back to basket from profile
 */
.factory('BackToBasket',
[
function BackToBasketFactory() {
/**
   * BackToBasket
   *
   * @constructor
   */
  var BackToBasket = function () {};
  /**
   * Webstorage key
   * @type {String}
   */
  var storageKey = 'backToBasket';

  BackToBasket.prototype = /** @lends BackToBasket.prototype */ {

    /**
     * Check if local storage is available
     *
     * @return {Boolean}
     */
    checkStorage:function()
    {
      var testKey = 'test';
      try {
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
      } catch (error) {
        return false;
      }

      return true;
    },
    /**
     * Save back to basket for flight
     * @param result
     */
    saveFlight: function (result) {
      var retFlight = '';
      var retDate = '';
      var oneWay = false;

      if (typeof result.legs[1] == 'object') {
        retDate = result.legs[1].arrT;
      }
      else {
        oneWay = true;
        retDate = result.legs[0].arrT;
      }

      var toSave = {};
      toSave.oneway = oneWay;
      toSave.link = window.location.href;
      toSave.from = result.getCityName(result.legs[0].dep, '');
      toSave.to = result.getCityName(result.legs[0].arr, '');
      toSave.fromDate = result.legs[0].depT;
      toSave.toDate = retDate;
      toSave.type = 'flight';
      toSave = JSON.stringify(toSave);
      if(this.checkStorage())
      {
        localStorage.setItem(storageKey, toSave);
      }

    },

    /**
     * Save back to basket for package
     * @param result
     */
    savePackage: function (result) {
      var toSave = {};
      //console.log(result);
      toSave.from = result.departureCity;
      toSave.to = result.returnCity;
      toSave.date = result.beginDate;
      toSave.type = 'package';
      toSave.link = window.location.href;
      toSave = JSON.stringify(toSave);
      if(this.checkStorage())
      {
        localStorage.setItem(storageKey, toSave);
      }
    },

    /**
     * Get Data
     * @returns {*}
     */
    getData: function () {
      var myData = localStorage.getItem(storageKey);
      if (myData) {
        return JSON.parse(myData);
      }

      return false;
    }

  };

  BackToBasket.prototype.constructor = BackToBasket;

  return new BackToBasket();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/Base64.js
angular.module('base')

/**
 * @name        Base64
 * @description Provides methods to encode and decode strings to / from base 64
 */
.factory('Base64',
[
function Base64Factory() {
/*
   * Copyright (c) 2010 Nick Galbreath
   * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
   *
   * Permission is hereby granted, free of charge, to any person
   * obtaining a copy of this software and associated documentation
   * files (the "Software"), to deal in the Software without
   * restriction, including without limitation the rights to use,
   * copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the
   * Software is furnished to do so, subject to the following
   * conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
   * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
   * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
   * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
   * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
   * OTHER DEALINGS IN THE SOFTWARE.
   */

  /* base64 encode/decode compatible with window.btoa/atob
   *
   * window.atob/btoa is a Firefox extension to convert binary data (the "b")
   * to base64 (ascii, the "a").
   *
   * It is also found in Safari and Chrome.  It is not available in IE.
   *
   * if (!window.btoa) window.btoa = base64.encode
   * if (!window.atob) window.atob = base64.decode
   *
   * The original spec's for atob/btoa are a bit lacking
   * https://developer.mozilla.org/en/DOM/window.atob
   * https://developer.mozilla.org/en/DOM/window.btoa
   *
   * window.btoa and base64.encode takes a string where charCodeAt is [0,255]
   * If any character is not [0,255], then an DOMException(5) is thrown.
   *
   * window.atob and base64.decode take a base64-encoded string
   * If the input length is not a multiple of 4, or contains invalid characters
   *   then an DOMException(5) is thrown.
   */
  var base64 = {};
  base64.PADCHAR = '=';
  base64.ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  base64.makeDOMException = function () {
    // sadly in FF,Safari,Chrome you can't make a DOMException

    try {
      return new DOMException(DOMException.INVALID_CHARACTER_ERR);
    }
    catch (tmp) {
      // not available, just passback a duck-typed equiv
      // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
      // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
      var ex = new Error('DOM Exception 5');

      // ex.number and ex.description is IE-specific.
      ex.code = ex.number = 5;
      ex.name = ex.description = 'INVALID_CHARACTER_ERR';

      // Safari/Chrome output format
      ex.toString = function () {
        return 'Error: ' + ex.name + ': ' + ex.message;
      };
      return ex;
    }
  };

  base64.getbyte64 = function (s, i) {
    // This is oddly fast, except on Chrome/V8.
    //  Minimal or no improvement in performance by using a
    //   object with properties mapping chars to value (eg. 'A': 0)
    var idx = base64.ALPHA.indexOf(s.charAt(i));
    if (idx === -1) {
      throw base64.makeDOMException();
    }
    return idx;
  };

  base64.decode = function (input) {
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
      throw "There were invalid base64 characters in the input text.\n" +
      "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
      "Expect errors in decoding.";
    }
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    do {
      enc1 = base64.ALPHA.indexOf(input.charAt(i++));
      enc2 = base64.ALPHA.indexOf(input.charAt(i++));
      enc3 = base64.ALPHA.indexOf(input.charAt(i++));
      enc4 = base64.ALPHA.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";

    } while (i < input.length);

    return decodeURIComponent(output);

  };

  base64.getbyte = function (s, i) {
    var x = s.charCodeAt(i);
    if (x > 255) {
      throw base64.makeDOMException();
    }
    return x;
  };

  base64.encode = function (s) {
    //console.log('encode', s, arguments);
    if (arguments.length !== 1) {
      throw new SyntaxError("Not enough arguments");
    }
    var padchar = base64.PADCHAR;
    var alpha = base64.ALPHA;
    var getbyte = base64.getbyte;

    var i, b10;
    var x = [];

    // convert to string
    s = '' + s;

    var imax = s.length - s.length % 3;

    if (s.length === 0) {
      return s;
    }
    for (i = 0; i < imax; i += 3) {
      b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8) | getbyte(s, i + 2);
      x.push(alpha.charAt(b10 >> 18));
      x.push(alpha.charAt((b10 >> 12) & 0x3F));
      x.push(alpha.charAt((b10 >> 6) & 0x3f));
      x.push(alpha.charAt(b10 & 0x3f));
    }
    switch (s.length - imax) {
      case 1:
        b10 = getbyte(s, i) << 16;
        x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
          padchar + padchar);
        break;
      case 2:
        b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8);
        x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
          alpha.charAt((b10 >> 6) & 0x3f) + padchar);
        break;
    }
    return x.join('');
  };

  return base64;
}]);
;

// Source: ../shared/public_html/assets/js/base/services/BookingComLinkGenerator.service.js
(function (angular) {
var Service = function (appConfig) {
        this.getUrl = function (data) {
            var baseUrl = 'https://www.booking.com/searchresults.html?';
            var searchParams = new URLSearchParams();

            searchParams.set('aid', appConfig.getBookingComAid());
            searchParams.set('checkin', data.departureDate);
            searchParams.set('checkout', data.returnDate);
            searchParams.set('group_adults', data.adultsCount);
            searchParams.set('group_children', data.childrenCount);

            if (data.destinationAirportCode) {
                searchParams.set('iata', data.destinationAirportCode);
            } else {
                searchParams.set('ss', data.destinationCityName + ' (' + data.destinationCountryName + ')');
            }

            if (!data.returnDate) { //checkout date should be added anyway for booking.com to work.
                searchParams.set('checkout', moment(data.departureDate, 'YYYY-MM-DD')
                    .add(3, 'd')
                    .format('YYYY-MM-DD')
                );
            }

            return baseUrl + searchParams.toString();
        };
    };

    Service.$inject = [
        'appConfig'
    ];

    angular
        .module('base')
        .service('BookingComLinkGenerator', Service);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/CashBackService.js
angular.module('base')

/**
 * @name base.TextBox
 *
 * @description Example service responsibility description
 */
.factory('CashBackService',
['ApiTools', 'SalesManagoSrv',
function cashBackFactory(ApiTools,SalesManagoSrv) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Example endpoint
      newsletter: {url: 'newsletter/newsletterVoucher', method: 'POST', respParser: textParser},
      newsletterModal: {url: 'newsletter/newsletterVoucher', method: 'GET', respParser: textParser}
    },

    /**
     * @class TextBoxFactory
     * @constructor
     */
    cashBackFactory = function () {
    };

  cashBackFactory.prototype = /** @lends cashBackFactory.prototype */  {

    /**
     * Example method on the service
     *
     * @param {int} data Text Box id
     * @return {Promise}
     */
    getCoupon: function (data) {
      var copyRes =  ApiTools.fetch(this, endpoints.newsletter, data);
      copyRes.then(
          function success(resp) {
            if(resp.code != ''){
              if (typeof ga != 'undefined') {
                ga('send', 'event', 'Coupon Sent', resp.code, '1', {
                  nonInteraction: true
                });
              }
            }
          }
      );
      return copyRes;
    },

    addToNewsletter: function (data,url) {
      if (url) {
        endpoints.newsletterModal.url = url;
      }

      var getPrams = "?";
      angular.forEach(data,function(v,k){
        getPrams += k + "=" + v + "&"
      });

      endpoints.newsletterModal.url += getPrams;

      return ApiTools.fetch(this, endpoints.newsletterModal, data);
    }
  };

  cashBackFactory.prototype.constructor = cashBackFactory;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {myModule.Example}
   */
  function textParser(response) {
    var resp = response.response;
    if(resp.contactId)
    {
      SalesManagoSrv.load(resp.contactId);
    }

    return resp;
  }

  return new cashBackFactory();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/CollectionGrouper.js
angular.module('base')

/**
 * @name base.CollectionGrouper
 *
 * @description
 */
.factory('CollectionGrouper', [
function CollectionGrouperFactory() {
var

    /**
     * @class CollectionGrouper
     * @constructor
     */
    CollectionGrouper = function (type) {
      this.config =
      {
        elements: [],
        selectedElements: [],
        label: ''
      };

      _.mixin({
        capitalize: function (string) {
          return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
        }
      });

      switch (type) {
        case 'months':
          var m = moment();
          for (var i = 0; i < 12; i++) {
            this.config.elements.push({
              name: _(m.month(i).format('MMMM')).capitalize(),
              short: _(m.month(i).format('MMM')).capitalize(),
              value: i + 1
            });
          }
          break;
        default:
          break;
      }
    };

  CollectionGrouper.prototype = /** @lends CollectionGrouper.prototype */  {

    setSelectedElements: function (elements) {
      if (angular.isString(elements)) {
        elements = elements.split(',');
      }

      for (var i in elements) {
        elements[i] = parseInt(elements[i]);
      }

      this.config.selectedElements = elements;
      this.updateInfo();

    },

    toggleItem: function (item) {
      var index;
      if ((index = this.config.selectedElements.indexOf(item.value)) >= 0) {
        this.config.selectedElements.splice(index, 1);
      }
      else {
        this.config.selectedElements.push(item.value);
      }
      this.updateInfo();
    },

    sortItems: function () {
      this.config.selectedElements = _.sortBy(this.config.selectedElements, function (num) {
        return parseInt(num);
      });
    },

    getValue: function (index) {
      if (this.config.selectedElements[index] !== 'undefined') {
        return this.config.selectedElements[index];
      }
      return Number.NaN;
    },

    isActive: function (item) {
      return this.config.selectedElements.indexOf(item.value) >= 0;
    },

    getName: function (i) {
      var self = this;
      var name = _.find(self.config.elements, function (p) {
        return p.value === self.getValue(i);
      });

      if (!name) {
        return null;
      }

      if (this.config.selectedElements.length > 3) {
        return name.short;
      }
      else {
        return name.name;
      }
    },

    updateInfo: function () {
      var self = this;
      this.sortItems();
      this.config.label = '';

      var tabLength = this.config.selectedElements.length,
        _range = {
          start: 0,
          end: 0,
          size: 0,

          hasSequence: function (i) {

            if (self.getValue(i) === (self.getValue(i - 1) + 1)) {
              return true;
            }

            return false;
          },

          resetSequence: function (i) {
            if (i === 'undefined') {
              i = 0;
            }
            _range.setStart(i);
            _range.size = 0;
          },

          renderPrevSequence: function () {
            if (self.config.label.length > 0) {
              self.config.label += ', ';
            }
            switch (_range.size) {
              case 0:
                self.config.label += self.getName(_range.start);
                break;
              case 1:
                self.config.label += self.getName(_range.start);
                self.config.label += ', ';
                self.config.label += self.getName(_range.start + 1);
                break;
              default:
                self.config.label += self.getName(_range.start);
                self.config.label += '-';
                self.config.label += self.getName(_range.end);
                break;
            }
          },

          setStart: function (i) {
            _range.start = i;
          },

          setEnd: function (i) {
            _range.end = i;
          }
        };

      for (var i = 0; i < tabLength; i++) {

        var answer = _range.hasSequence(i);
        if (!answer && i > 0) {
          _range.renderPrevSequence();
          _range.resetSequence(i);
        }
        else if (i > 0) {
          _range.size++;
        }
        _range.setEnd(i);

        //render prevSequence if this is last element
        if (i === tabLength - 1) {
          _range.renderPrevSequence();
        }
      }
    },

    getLabel: function () {
      return this.config.label;
    },

    isLabelEmpty: function () {
      return this.config.label.length === 0;
    },

    clearSelectedElements: function () {
      this.config.selectedElements = [];
      this.updateInfo();
    },

    getSelectedElementsValues: function () {
      this.sortItems();
      return this.config.selectedElements;
    },


    selectAll: function(){
      this.setSelectedElements('1,2,3,4,5,6,7,8,9,10,11,12');
      this.updateInfo();
    },


    getItems: function () {
      return this.config.elements;
    },

    getSortItems: function ()
    {
      var end = [];
      for(var i=0;i<6; i++)
      {
        end.push(this.config.elements[i]);
        end.push(this.config.elements[i+6]);
      }
      return end;
    }
  };

  CollectionGrouper.prototype.constructor = CollectionGrouper;

  return CollectionGrouper;
}]);
;

// Source: ../shared/public_html/assets/js/base/services/ContactFormSrv.js
angular.module('base')

/**
 * @name base.ContactFormSrv
 *
 * @description Example service responsibility description
 */
.factory('ContactFormSrv', ['ApiTools','SalesManagoSrv',
function ContactFormSrvFactory(ApiTools,SalesManagoSrv) {
var
    /**
     * The API endpoints configuration
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Send Contact Form
      sendFormMessage: {url: '/api/contact/send', method: 'POST', respParser: responseParser},

      sendCareerForm: {url: '/api/contact/sendCareer', method: 'POST', respParser: responseParser},

      // Send Contact Form
      sendCompanyForm: {url: '/api/contact/sendCompany', method: 'POST', respParser: responseParser},

      // get topic message
      getTopics: {url: '/api/contact/getTopics', method: 'POST', respParser: responseTopics}
    },

    /**
     * @class ContactFormSrv
     * @constructor
     */
    ContactFormSrv = function () {};

  ContactFormSrv.prototype = /** @lends ContactFormSrv.prototype */  {

    /**
     * send contact form data
     *
     * @param {Object} formData
     * @return {Promise}
     */
    sendFormMessage: function (formData) {
      return ApiTools.fetch(this, endpoints.sendFormMessage, formData);
    },

    sendCareerForm: function(formData){
      return ApiTools.fetch(this, endpoints.sendCareerForm, formData);
    },

    sendCompanyForm: function (formData) {
      return ApiTools.fetch(this, endpoints.sendCompanyForm, formData);
    },

    getTopics: function () {
      return ApiTools.fetch(this, endpoints.getTopics, {});
    }
  };

  ContactFormSrv.prototype.constructor = ContactFormSrv;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {Object}
   */
  function responseTopics(response) {
    return response.response;
  }

  function responseParser(response) {
    var resp = response.response;
    if(resp.nl_response && resp.nl_response.contactId)
    {
      SalesManagoSrv.load(resp.nl_response.contactId);
    }

    return this;
  }

  return new ContactFormSrv();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/Cookies.js
/*global angular: false */

angular.module('base')

/**
 * @name        Cookies
 * @description Class that handles cookies the AngularJS way
 */
.factory('Cookies',
[
function CookiesFactory() {
/**
   * Cookies
   *
   * @constructor
   */
  var Cookies = function () {};

  Cookies.prototype = /** @lends Cookies.prototype */ {
    // Allows for setter injection in unit tests
    _document: document,
    _navigator: navigator,

    // Default settings
    defaults: {
      path: '/'
    },

    /**
     * Retrieves the cookie value of the most locally scoped cookie with the specified key
     *
     * @param  {String} key    The cookie key
     *
     * @return {String|Object} The cookie value or object containing all cookies
     */
    get: function (key) {
      if (this._cachedDocumentCookie !== this._document.cookie) {
        this._renewCache();
      }

      return key ? this._cache[key] : this._cache;
    },

    /**
     * Sets a cookie in the document. If the cookie does not already exist, it will be created.
     *
     * @param {String} key     The cookie key
     * @param {mixed}  value   The cookie value
     * @param {Object} options The cookie options
     *
     * @return {Cookies}
     */
    set: function (key, value, options) {
      options = this._getExtendedOptions(options);
      options.expires = this._getExpiresDate(value === undefined ? -1 : options.expires);

      this._document.cookie = this._generateCookieString(key, value, options);

      return this;
    },

    /**
     * Expires a cookie, removing it from the document
     *
     * @param  {String} key     The cookie key
     * @param  {Object} options The cookie options
     *
     * @return {Cookies}
     */
    expire: function (key, options) {
      return this.set(key, undefined, options);
    },

    /**
     * Returns default settings and completes the cookie options object
     *
     * @param  {Object} options The cookie options
     *
     * @return {Object}
     */
    _getExtendedOptions: function (options) {
      return {
        path: options && options.path || this.defaults.path,
        domain: options && options.domain || this.defaults.domain,
        expires: options && options.expires || this.defaults.expires,
        secure: options && options.secure !== undefined ? options.secure : this.defaults.secure
      };
    },

    /**
     * Checks if a date is valid
     *
     * @param  {Date}  date
     *
     * @return {Boolean}
     */
    _isValidDate: function (date) {
      return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
    },

    /**
     * Converts string dates to dates and returns expires date
     *
     * @param  {Number|String|Date} expires
     * @param  {Date}               now
     *
     * @return {Date}
     */
    _getExpiresDate: function (expires, now) {
      now = now || new Date();
      switch (typeof expires) {
        case 'number':
          expires = new Date(now.getTime() + expires * 1000);
          break;
        case 'string':
          expires = new Date(expires);
          break;
      }

      if (expires && !this._isValidDate(expires)) {
        throw new Error('`expires` parameter cannot be converted to a valid Date instance');
      }

      return expires;
    },

    _generateCookieString: function (key, value, options) {
      key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
      key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
      value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
      options = options || {};

      var cookieString = key + '=' + value;
      cookieString += options.path ? ';path=' + options.path : '';
      cookieString += options.domain ? ';domain=' + options.domain : '';
      cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
      cookieString += options.secure ? ';secure' : '';

      return cookieString;
    },

    _getCookieObjectFromString: function (documentCookie) {
      var cookieObject = {};
      var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

      for (var i = 0; i < cookiesArray.length; i++) {
        var cookieKvp = this._getKeyValuePairFromCookieString(cookiesArray[i]);

        if (cookieObject[cookieKvp.key] === undefined) {
          cookieObject[cookieKvp.key] = cookieKvp.value;
        }
      }

      return cookieObject;
    },

    _getKeyValuePairFromCookieString: function (cookieString) {
      // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
      var separatorIndex = cookieString.indexOf('=');

      // IE omits the "=" when the cookie value is an empty string
      separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

      return {
        key: decodeURIComponent(cookieString.substr(0, separatorIndex)),
        value: decodeURIComponent(cookieString.substr(separatorIndex + 1))
      };
    },

    _renewCache: function () {
      this._cache = this._getCookieObjectFromString(this._document.cookie);
      this._cachedDocumentCookie = this._document.cookie;
    },

    _areEnabled: function () {
      var testKey = 'cookies.js';
      var areEnabled = this.set(testKey, 1).get(testKey) === '1';
      this.expire(testKey);
      return areEnabled;
    }
  };

  Cookies.prototype.constructor = Cookies;

  return new Cookies();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/CssService.js
(function(angular, globalAppConfig, tplCacheBuster) {
//TODO: add mobile files when CO-11
    var CssService = function($ocLazyLoad) {

        var path = '/assets/v-' + tplCacheBuster + '/css/';

        /**
         *
         * @param asset
         * @returns {boolean}
         */
        function notLoaded(asset) {
            return !globalAppConfig.loadedCSS || typeof globalAppConfig.loadedCSS[asset] === 'undefined';
        }

        /**
         * Synchronizes current resolution, device and state and checks if additional files needed.
         *
         * @param {string} currentState
         */
        var load = function(currentState) {
            var isHomePage = (currentState === 'homepage');
            var files = {
                homepage: 'home.min.css',
                app: 'app.min.css'
            };
            var filesToLoad = [];

            if(isHomePage) {
                if(notLoaded(files.homepage)) {
                    filesToLoad.push(files.homepage);
                }
            } else if(notLoaded(files.app)) {
                filesToLoad.push(files.app);
            }

            $ocLazyLoad.load(filesToLoad.map(function (file){
                return path + file
            }));

        };

        return {
            load: load
        };
    };

    CssService.$inject = [
        '$ocLazyLoad',
        'appConfig'
    ];

    angular.module('base')
        .service('CssService', CssService);

})(angular, _js_app_config_, _template_cache_buster);
;

// Source: ../shared/public_html/assets/js/base/services/DateUtils.js
(function(angular) {
/**
     * @name        DateUtils
     * @description A service that provides methods for date selectors
     */
    var DateUtilsFactory = function (appConfig) {
        var
            /**
             * DateUtils constructor
             *
             * @constructor
             */
            DateUtils = function() {
            };

        var m = moment(), currYear = m.year();

        /**
         * Set birth date year range
         */
        function setRange(min, max) {
            var i, result = [];
            for(i = max; i > min; i--) {
                result.push({
                    yearId: i,
                    yearName: i
                });
            }
            return result;
        }

        function getNiceMonthName(index) {
            var momentMonth = m.month(index).format('MMMM');
            return momentMonth.charAt(0).toUpperCase() + momentMonth.slice(1);
        }

        function getDayAndMonth() {
            // The default config object for birthdate selector
            var obj = {
                days: [],
                months: [],
                years: []
            };

            // Days
            for(var i = 1; i <= 31; i++) {
                obj.days.push({
                    dayId: i,
                    dayName: i
                });
            }

            // Months
            for(var j = 1; j <= 12; j++) {
                obj.months.push({
                    monthId: j,
                    monthNumber: j - 1,
                    monthName: getNiceMonthName(j - 1)
                });
            }

            return obj;
        }

        function setRegularYear(maxYears) {
            var years = [];
            for(var k = currYear; k >= currYear - maxYears; k--) {
                years.push({yearId: k, yearName: k});
            }
            return years;
        }

        function setPassportYear() {
            var years = [];
            for(var k = currYear; k <= currYear + 100; k++) {
                years.push({yearId: k, yearName: k});
            }
            return years;
        }

        function setFutureYear(nextYears) {
            var years = [];
            for(var k = currYear; k <= currYear + nextYears; k++) {
                years.push({yearId: k, yearName: k});
            }
            return years;
        }

        /**
         * Year range for passport issue dates
         *
         * @returns {Number[]}
         */
        function setPassportIssueYear() {
            var years = [];
            for (var k = currYear - 50; k <= currYear; k++) {
                years.push({ yearId: k, yearName: k });
            }
            return years.reverse();
        }

        /**
         * Returns correct values for pax year selectors
         *
         * @param {Number} minAge
         * @param {Number} maxAge
         *
         * @returns {Object[]}
         */
        function getOptimisedYearRange(minAge, maxAge) {
            var minYear = currYear - maxAge - 1;
            var maxYear = currYear - minAge;

            var result = [], i;
            for (i = maxYear; i > minYear; i--) {
                result.push({
                    yearId: i,
                    yearName: i
                });
            }
            return result;
        }

        DateUtils.prototype = /** @lends DateUtils.prototype */ {

            /**
             * Return regular date object for select
             *
             * @param maxYears
             * @returns {*}
             */
            getRegularDate: function(maxYears) {
                // Minimum and maximum years shown in selector and moment instance
                maxYears = typeof maxYears !== 'undefined' ? maxYears : 120;

                var date = getDayAndMonth();

                date.years = setRegularYear(maxYears);

                return date;
            },

            /**
             * Return passport date object for select
             *
             * @returns {*}
             */
            getPassportDate: function() {
                var date = getDayAndMonth();
                date.years = setPassportYear();

                return date;
            },

            getPassportIssueDate: function () {
                var date = getDayAndMonth();
                date.years = setPassportIssueYear();
                return date;
            },

            getFutureDate: function (years) {
                var date = getDayAndMonth();
                date.years = setFutureYear(years);
                return date;
            },

            /**
             * Get infant year range
             *
             * @returns {*}
             */
            getInfYearRange: function () {
                var infMinAge = 0;
                var infMaxAge = 2;
                return getOptimisedYearRange(infMinAge, infMaxAge);
            },

            /**
             * Get child year range
             *
             * @returns {*}
             */
            getChdYearRange: function () {
                var chdMinAge = 2;
                var chdMaxAge = 12;
                return getOptimisedYearRange(chdMinAge, chdMaxAge);
            },

            /**
             * Get youth year range
             *
             * @returns {*}
             */
            getYthYearRange: function () {
                // Fru youth: 12-16
                // Vola youth: 12-18
                var youthMinAge = 12;
                var youthMaxAge = appConfig.isFru() ? 16 : 18;
                return getOptimisedYearRange(youthMinAge, youthMaxAge);
            },

            /**
             * Get adult year range
             *
             * @returns {*}
             */
            getAdtYearRange: function () {
                var adultMinAge = appConfig.isFru() ? 16 : 18;
                var adultMaxAge = 120;
                return getOptimisedYearRange(adultMinAge, adultMaxAge);
            },

            /**
             * @param minAge
             * @param maxAge
            */
            getYearRange: function (minAge, maxAge) {
                return setRange(currYear - maxAge, currYear - minAge);
            },

            /**
             *
             * @param {string | Date} date
             * @returns {string}
             */
            dateToString: function (date) {
                var m = moment(date);
                return m.format('YYYY-MM-DD');
            }
        };

        DateUtils.prototype.constructor = DateUtils;

        return new DateUtils();
    };

    DateUtilsFactory.$inject = [
        'appConfig'
    ];

    angular.module('base').factory('DateUtils', DateUtilsFactory);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/services/Dictionaries.js
/*global angular: false, _: false */

angular.module('base')

/**
 * @name        Dictionaries
 * @description Provides methods to manage dictionaries for the application
 */
.factory('Dictionaries',
['appConfig',
function DictionariesFactory(appConfig) {
/**
   * Dictionaries
   *
   * @constructor
   */
  var Dictionaries = function () {
    /**
     * Carriers dictionary
     *
     * The object properties are the language codes (en, pl, ro, ...).
     * Each language code points to an object where keys are carrier codes and
     * values are object describing them.
     *
     * @type {Object}
     */
    this.carriers = {};

    /**
     * Airports dictionary
     *
     * The object properties are the language codes (en, pl, ro, ...).
     * Each language code points to an object where keys are airport codes and
     * values are object describing them.
     *
     * @type {Object}
     */
    this.airports = {};

    /**
     * Cities dictionary
     *
     * The object properties are the language codes (en, pl, ro, ...).
     * Each language code points to an object where keys are city codes and
     * values are object describing them.
     *
     * @type {Object}
     */
    this.cities = {};

    /**
     * The language codes that have been added
     *
     * @type {Object}
     */
    this.addedLanguageCodes = {};
  };

  // Add instance methods
  Dictionaries.prototype = /** @lends Dictionaries.prototype */ {

    /**
     * Adds language code to the dictionaries if its not already there
     *
     * @param {String} languageCode The language code ex: pl, ro, en
     */
    addLanguageCodes: function (languageCode) {
      if (this.addedLanguageCodes[languageCode] === true) return;

      if (!this.carriers[languageCode]) this.carriers[languageCode] = {};
      if (!this.airports[languageCode]) this.airports[languageCode] = {};
      if (!this.cities[languageCode]) this.cities[languageCode] = {};

      this.addedLanguageCodes[languageCode] = true;
    },
    /**
     * Add dictionary to existing ones
     *
     * @param {Object} dictionary
     * @param {String} languageCode The language code ex: pl, ro, en
     */
    addDictionary: function (dictionary, languageCode) {
      this.addLanguageCodes(languageCode);
      if (dictionary.carriers) {
        this.carriers[languageCode] = angular.extend(this.carriers[languageCode], dictionary.carriers);
      }

      if (dictionary.airports) {
        this.airports[languageCode] = angular.extend(this.airports[languageCode], dictionary.airports);

        // Set city dictionary based on airport data
        _.each(dictionary.airports, function (value, code) {
          this.cities[languageCode][value.city_code] = {
            city_code: value.city_code,
            city_name: value.city_name,
            country_code: value.country_code,
            country_name: value.country_name
          };
        }, this);
      }

      if (dictionary.cities) {
        this.cities[languageCode] = angular.extend(this.cities[languageCode], dictionary.cities);
      }
    },

    addCity: function (cityObj, languageCode) {
      this.addLanguageCodes(languageCode);

      if (!(cityObj && cityObj.city_code)) return;

      this.cities[languageCode][cityObj.city_code] = cityObj;
    },

    addAirport: function (airportObj, languageCode) {
      this.addLanguageCodes(languageCode);

      if (!(airportObj && airportObj.airport_code)) return;

      this.airports[languageCode][airportObj.airport_code] = airportObj;
    },

    addCarrier: function (carrierObj, languageCode) {
      this.addLanguageCodes(languageCode);
      this.carriers[languageCode][carrierObj.code] = carrierObj.name;
    },

    /**
     * Get formatted city name
     *
     * @param {String} code                The city code ex: LON
     * @param {bool}   [withCountry=true]  Set to true if you want to get country name as well
     * @param {String} [languageCode]      The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String}
     */
    getCityNameByCode: function (code, withCountry, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      withCountry = withCountry === undefined ? true : withCountry;
      this.addLanguageCodes(languageCode);

      var place = this.airports[languageCode][code],
        strName = code;

      if (!place && this.cities[languageCode][code]) {
        place = this.cities[languageCode][code];
      }

      if (place && angular.isObject(place)) {
        strName = place.city_name;

        if (withCountry) {
          strName += ', ' + place.country_name;
        }
      }

      return strName;
    },

    /**
     * Get formatted airport name
     *
     * @param {String}  code                The airport code ex: LAX
     * @param {Boolean} [withCountry=true]  Set to true if you want to get country name as well
     * @param {String}  [languageCode]      The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String}
     */
    getAirportNameByCode: function (code, withCountry, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      withCountry = withCountry === undefined ? true : withCountry;
      this.addLanguageCodes(languageCode);

      var place = this.airports[languageCode][code],
        strName = code;

      if (place && angular.isObject(place)) {
        strName = place.airport_name;

        if (withCountry) {
          strName += ', ' + place.country_name;
        }
      }

      return strName;
    },

    /**
     * Get formatted city name (with country) by airport code
     *
     * @param {String}  code                The airport code ex: LAX
     * @param {Boolean} [withCountry=true]  Set to true if you want to get country name as well
     *
     * @return {String}
     */
    getCityNameByAirportCode: function (code, withCountry, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      withCountry = withCountry === undefined ? true : withCountry;
      this.addLanguageCodes(languageCode);

      var
        place = this.airports[languageCode][code],
        strName = code;

      if (place && angular.isObject(place)) {
        strName = place.city_name;

        if (withCountry) {
          strName += ', ' + place.country_name;
        }
      }

      return strName;
    },

    /**
     * Get city code by airport code
     *
     * @param {String} code
     * @param {String} [languageCode=appConfig.getLanguageCode()]
     *
     * @returns {String}
     */
    getCityCodeByAirportCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      this.addLanguageCodes(languageCode);

      var place = this.airports[languageCode][code];

      if (place && angular.isObject(place)) {
        return place.city_code;
      }
    },

    /**
     * Get country name by airport code
     *
     * @param {String} code
     * @param {String} [languageCode=appConfig.getLanguageCode()]
     *
     * @returns {String}
     */
    getCountryNameByAirportCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      this.addLanguageCodes(languageCode);

      var place = this.airports[languageCode][code];

      if (place && angular.isObject(place)) {
        return place.country_name;
      }
    },

    /**
     * Get country code passing airport code
     *
     * @param {String} code         Airport code
     * @param {String} languageCode The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String} The ISO country code ex: PL, RO,...
     */
    getCountryCodeByAirportCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      this.addLanguageCodes(languageCode);

      var
        place = this.airports[languageCode][code],
        strName = code;

      if (place && angular.isObject(place)) {
        strName = place.country_code;
      }

      return strName;
    },

    /**
     * Get country code passing city code
     *
     * @param {String} code         City code
     * @param {String} languageCode The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String} The ISO country code ex: PL, RO,...
     */
    getCountryCodeByCityCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      this.addLanguageCodes(languageCode);

      var
        place = this.cities[languageCode][code],
        strName = code;

      if (place && angular.isObject(place)) {
        strName = place.country_code;
      }

      return strName;
    },

    /**
     * Get country name passing city code
     *
     * @param {String} code         City code
     * @param {String} languageCode The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String} The ISO country code ex: PL, RO,...
     */
    getCountryNameByCityCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();
      this.addLanguageCodes(languageCode);

      var
        place = this.cities[languageCode][code],
        strName = code;

      if (place && angular.isObject(place)) {
        strName = place.country_name;
      }

      return strName;
    },

    /**
     * Get formatted carrier name
     *
     * @param {String} code           Carrier code
     * @param {String} [languageCode] The language code to return the name in (ex. pl, ro, en, ...)
     *
     * @return {String}
     */
    getCarrierNameByCode: function (code, languageCode) {
      languageCode = languageCode || appConfig.getLanguageCode();

      this.addLanguageCodes(languageCode);

      return this.carriers[languageCode][code] || code;
    },

    /**
     * Returns all used codes for all languages
     *
     * @return {{carriers: Array, airports: Array, cities: Array}}
     */
    getUsedCodes: function () {
      var usedCodes = {
        carriers: [],
        airports: [],
        cities: []
      };

      _.each(this.carriers, function (el) {
        usedCodes.carriers = usedCodes.carriers.concat(_.keys(el));
      });

      _.each(this.airports, function (el) {
        usedCodes.airports = usedCodes.airports.concat(_.keys(el));
      });

      _.each(this.cities, function (el) {
        usedCodes.cities = usedCodes.cities.concat(_.keys(el));
      });

      usedCodes.carriers = _.uniq(usedCodes.carriers);
      usedCodes.airports = _.uniq(usedCodes.airports);
      usedCodes.cities = _.uniq(usedCodes.cities);

      return usedCodes;
    }
  };

  Dictionaries.prototype.constructor = Dictionaries;

  return new Dictionaries();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/EmailServ.js
angular.module('base')

/**
 * @name        EmailServ
 * @description Class that sends email data to the API
 */
.factory('EmailServ',
['ApiTools',
function EmailServFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Send flight details
      sendFlight: {
        url: '/api/flightDetails/email/:requestId/:priceGroupId/:depLegId/:retLegId',
        method: 'POST',
        respParser: emailParser
      },

      // Send message from contact page
      sendContactEmail: {url: '/api/contact/send/', method: 'POST', respParser: emailParser}
    },

    /**
     * @class EmailServ
     * @constructor
     */
    EmailServ = function () {};

  EmailServ.prototype = /** @lends EmailServ.prototype */  {

    /**
     * Send email and route to backend to be sent by email
     *
     * @param {String} email       The coupon/voucher code
     * @param {Object} routeParams The route parameters
     */
    sendLink: function (email, routeParams) {
      if (!routeParams.retLegId) {
        routeParams.retLegId = '';
      }

      return ApiTools.fetch(this, endpoints.sendFlight, {email: email}, routeParams);
    },

    /**
     * Send contact email
     *
     * @param  {Object} contactData
     *
     * @return {Promise}
     */
    sendContactEmail: function (contactData) {
      return ApiTools.fetch(this, endpoints.sendContactEmail, contactData);
    }
  };

  EmailServ.prototype.constructor = EmailServ;

  /**
   * Parse example response
   *
   * @param {Object} response
   *
   * @return {Object}
   */
  function emailParser(response) {
    return response.response;
  }

  return new EmailServ();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/ErrorLogService.js
angular.module('base')

/**
 * @name        ErrorLogService
 * @description Provides JavaScript error logging to the server
 */
.factory('ErrorLogService',
['ApiTools', '$injector', 'StackTrace', 'appConfig',
function (ApiTools, $injector, StackTrace, appConfig) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Get countries
      apiErrorLog: {url: '/api/error/log', method: 'POST', respParser: respParser}
    },

    /**
     * @class ErrorLogService
     * @constructor
     */
    ErrorLogService = function () {};

  ErrorLogService.prototype = /** @lends ErrorLogService.prototype */  {

    /**
     * Send JavaScript error log back to server
     *
     * @param {Object} exception The exception to log on the server
     * @param {Object} cause     The cause of the exception
     *
     * @return {Promise}
     */
    sendErrorLog: function (exception, cause) {


      var
        msg = exception.toString(),
        location = $injector.get("$location"),
        log = {
          message: msg,
          stackTrace: printStackTrace({ e: exception }),
          abTests: angular.toJson(appConfig.getAbConfig()),
          appVer: appConfig.getJsCacheBuster(),
          url: location.absUrl(),
          ua: navigator.userAgent || '',
          phpVer: appConfig.getAppVersion()
        };


      // Ignore digest warning
      if (msg.indexOf('10 $digest() iterations reached. Aborting') > -1) {
        // TODO: we should return promise
        return;
      }

      // Ignore stringify error. We have to get back to it !!! for now it generates too much logs
      if (msg.indexOf('JSON.stringify cannot serialize cyclic structures') > -1) {
        // TODO: we should return promise
        return;
      }

      return ApiTools.fetch(this, endpoints.apiErrorLog, log, {});
    }
  };

  ErrorLogService.prototype.constructor = ErrorLogService;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {FlApp.ErrorLogService}
   */
  function respParser(response) {
    var resp = response.response;

    return this;
  }

  return new ErrorLogService();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/ExploreModeIdService.js
(function (angular) {
var Service = function () {
        this.id = null;
        this.includeInPayload = false;

        this.getId = function () {
            return this.id;
        };

        this.setId = function (id) {
            this.id = id;
        };

        this.getIncludeInPayload = function () {
            return this.includeInPayload;
        };

        this.setIncludeInPayload = function (val) {
            this.includeInPayload = val;
        };


    };

    Service.$inject = [];

    angular
        .module('base')
        .service('ExploreModeIdService', Service);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/FareAlertsLib.js
/*global angular: false */

angular.module('base')

/**
 * @name        FareAlertsLib
 * @description Class Fare Alerts Library
 */
.factory('FareAlertsLib',
['FareAlertsSrv', '$localStorage', 'appConfig',
function FareAlertsLibFactory(FareAlertsSrv, $localStorage, appConfig) {
/**
   * FareAlertsLib
   * @constructor
   */
  var FareAlertsLib = function () {};

  var showResetButton = false,
    showEmailInput = false,
    showUnlockBox = false,
    forceSetArgs = false,
    showFaProfile = true,
    autoResetForm = true;

  $localStorage.faLocalData = $localStorage.faLocalData || {};

  /**
   * @lends FareAlertsLib.prototype
   **/
  FareAlertsLib.prototype =
  {
    showResetButton: function (value) {showResetButton = value; },
    isShowResetButton: function () {return showResetButton; },

    showEmailInput: function (value) { showEmailInput = value; },
    isShowEmailInput: function () { return showEmailInput; },

    autoResetForm: function (value) { autoResetForm = value; },
    isAutoResetForm: function () { return autoResetForm; },

    showFaProfile: function (value) { showFaProfile = value; },
    isShowFaProfile: function () { return showFaProfile; },

    showUnlockBox: function (value) { showUnlockBox = value; },
    isShowUnlockBox: function () { return showUnlockBox; },

    forceSetArgs: function (value) { forceSetArgs = value; },
    isForceSetArgs: function () { return forceSetArgs; },

    getProfileData: function () {
      return FareAlertsSrv.GetProfile().then
      (
        function success(resp) {return resp;}
      );

    },

    validCode: function (code) {
      if (angular.isString(code) && code.length != 3 && code.length != 2) {
        return false;
      }

      return true;
    },

    isAlertExists: function (alert_msg, alerts) {
      return !!( _.find(alerts, function(data){return (data.msg == alert_msg)}) )
    },

    setAsCreatedFor: function (args) {
      var sKey = 'fadFsQp_' + args.flight_from_code + args.flight_to_code + args.trip_length_min + args.trip_length_max;

      $localStorage.faLocalData[sKey] = true;
      $localStorage.$apply();

      return this;
    },

    isAlreadyCreated: function (args) {
      var sKey = 'fadFsQp_' + args.flight_from_code + args.flight_to_code + args.trip_length_min + args.trip_length_max;

      if ($localStorage.faLocalData && $localStorage.faLocalData[sKey]) {
        return $localStorage.faLocalData[sKey];
      }

      return false;
    },
    
    /**
     * Get price maximum length.
     *
     * @returns {Number}
     */
    getPriceLengthMax: function() {
      return appConfig.getFareAlerts().priceLengthMax || 5;
    },

    setDefaultValues: function (scope, args) {
      if (args && (this.isForceSetArgs() || !this.isAlreadyCreated(args))) {
        scope.formData.max_price = args.round_trip ? args.matrix_min_price : args.matrix_min_price * 2;
        scope.formData.travel_period = '1,2,3,4,5,6,7,8,9,10,11,12'; //args.travel_period;
        scope.formData.flight_from_code = args.flight_from_code;
        scope.formData.flight_to_code = args.flight_to_code;
        scope.formData.trip_length_min = args.trip_length_min;
        scope.formData.trip_length_max = args.trip_length_max;
        scope.$on('matrixUpdated', function (event, obj) {
          scope.formData.max_price = args.round_trip ? obj.min_price : obj.min_price * 2;
        });
      }
      else {
        scope.formData.id = '';
        scope.formData.max_price = '';
        scope.formData.travel_period = '1,2,3,4,5,6,7,8,9,10,11,12';
        scope.formData.flight_from_code = appConfig.getDepCityCode();
        scope.formData.flight_to_code = appConfig.getDesCityCode();
        scope.formData.trip_length_min = "1";
        scope.formData.trip_length_max = "40";
      }
    }
  };

  FareAlertsLib.prototype.constructor = FareAlertsLib;

  return new FareAlertsLib();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/FareAlertsSrv.js
angular.module('base')

/**
 * @name Fare Alerts Service
 *
 * @description Example service responsibility description
 */
.factory('FareAlertsSrv',
['ApiTools', '$stateParams','SalesManagoSrv',
function FareAlertsSrvFactory(ApiTools, $stateParams,SalesManagoSrv) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints =
    {
      save_user: {url: '/new_fare_alerts/save_user' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse},
      save_alert: function (args) {
        if (args.uId === undefined) {
          return {url: '/new_fare_alerts/index' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse};
        }

        return {url: '/new_fare_alerts/uid/' + args.uId +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse};
      },
      delete_alert: function (args) {
        return {url: '/new_fare_alerts/delete/' + args.uId  +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse};
      },
      get_profile: {url: '/new_fare_alerts/getNgProfile' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse},
      get_data: {url: '/new_fare_alerts/getNgData' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: getResponse}
    },

    /**
     * @class FareAlertsSrv
     * @constructor
     */
    FareAlertsSrv = function () {};

  /**
   * @lends ExampleService.prototype
   */
  FareAlertsSrv.prototype =
  {
    /**
     * Save user
     *
     * @param {String} email address
     * @return {Promise}
     */
    saveUser: function (email) {
      return ApiTools.fetch(this, endpoints.save_user, {email: email, force: 1});
    },

    /**
     * Get Profile
     *
     * @return {Promise}
     */
    getProfile: function (hash) {
      var args = hash ? {hash: hash} : {token: $stateParams.uId};

      return ApiTools.fetch(this, endpoints.get_profile, args);
    },

    /**
     * Get Data
     *
     * @return {Promise}
     */
    getData: function (type, value) {
      return ApiTools.fetch(this, endpoints.get_data, {type: type, value: value});
    },

    /**
     * Save Alert
     *
     * @return {Promise}
     */
    saveAlert: function (args) {
      if (args.id) {
        args.action = 'edit';
      }

      return ApiTools.fetch(this, endpoints.save_alert(args), args);
    },

    /**
     * Delete Alert
     *
     * @param {int} id
     * @return {Promise}
     */
    deleteAlert: function (args) {
      return ApiTools.fetch(this, endpoints.delete_alert(args), {id: args.id});
    }

  };

  FareAlertsSrv.prototype.constructor = FareAlertsSrv;

  /**
   * Get Response
   *
   * @param {Object} response
   * @return Object
   */
  function getResponse(response) {
    var resp = response.response;
    if(resp && resp.nl_response && resp.nl_response.contactId)
    {
      SalesManagoSrv.load(resp.nl_response.contactId);
    }
    return response.response;
  }

  return new FareAlertsSrv();
}]);




;

// Source: ../shared/public_html/assets/js/base/services/FeedbackService.js
angular.module('base')

  /**
   * @name base.FeedbackService
   *
   * @description Service for send user opinion about page
   */
  .factory('FeedbackService', ['ApiTools',
    function FeedbackFactory(ApiTools) {
var endpoints = {
          default: {url: '/api/contact/sendUserFeedback', method: 'POST', respParser: textParser}
        },

        /**
         * @class FeedbackFactory
         * @constructor
         */
        FeedbackFactory = function () {
        };

      FeedbackFactory.prototype = /** @lends FeedbackFactory.prototype */  {
        /**
         *
         * @param data
         * @returns {Promise}
         */
        sendFeedback: function(data){
          return ApiTools.fetch(this,endpoints.default,data);
        }
      };

      FeedbackFactory.prototype.constructor = FeedbackFactory;

      /**
       * Def passer
       * @param {Object} response
       * @return {Object}
       */
      function textParser(response) {
        return response.response;
      }

      return new FeedbackFactory();
    }]);;

// Source: ../shared/public_html/assets/js/base/services/FormControlGenerator.js
/*global angular: false, _: false */

angular.module('base')

/**
 * @name        formControl
 * @description A service that provides methods for communicating with the server through JSON APIs
 */
.factory('formControl',
['ValidationUtils',
function formControlFactory(ValidationUtils)
{
var BOB = (function () {
      BOB._data = null;

      BOB.find = function (selector) {
      };

      BOB.data = function () {
        return BOB._data;
      };

      BOB.d = function () {
        return BOB._data;
      };

      BOB.get_or_create_bob = function (data, options, parent) {
        var child_bob;
        child_bob = null;
        if (data instanceof BOB) {
          child_bob = data;
        } else {
          child_bob = new BOB(data, options, parent);
        }
        return child_bob;
      };

      BOB.toVariable = function (data) {
        if (typeof data === 'function') {
          return data();
        } else {
          return data;
        }
      };

      function BOB(selector, options, parent, preBob, contentBob, postBob) {
        var key, value, _ref, _ref1;
        if (parent == null) {
          parent = null;
        }
        if (preBob == null) {
          preBob = null;
        }
        if (contentBob == null) {
          contentBob = null;
        }
        if (postBob == null) {
          postBob = null;
        }
        if (selector.indexOf(" ") > -1) {
          console.error("Invalid BOB selector. \"" + selector + "\" contains \" \"(space). Only allowed is \"tag\", \"tag.class\", or \"tag#id\".");
          return "Invalid selector. See console log for more details.";
        }
        this.parent = parent;
        this.options = {};
        if (options) {
          for (key in options) {
            value = options[key];
            this.options[key] = BOB.toVariable(value);
          }
        }
        this.preBob = preBob;
        this.innerBob = contentBob;
        this.postBob = postBob;
        this.type = selector;
        this.object_class = null;
        this.object_id = null;
        this.object_content = "";
        this.object_style = null;
        if (selector.indexOf(".") > -1) {
          _ref = selector.split("."), this.type = _ref[0], this.object_class = _ref[1];
        } else if (selector.indexOf("#") > -1) {
          _ref1 = selector.split("#"), this.type = _ref1[0], this.object_id = _ref1[1];
        }
      }

      BOB.prototype.content = function (content) {
        return this.co(content);
      };

      BOB.prototype.co = function (content) {
        var child;
        child = this.i("");
        child.object_content = BOB.toVariable(content);
        return this;
      };

      BOB.prototype.style = function (style) {
        return this.st(style);
      };

      BOB.prototype.st = function (style) {
        this.object_style = BOB.toVariable(style);
        return this;
      };

      BOB.prototype["class"] = function (object_class) {
        return this.cl(object_class);
      };

      BOB.prototype.cl = function (object_class) {
        this.object_class = BOB.toVariable(object_class);
        return this;
      };

      BOB.prototype.id = function (object_id) {
        this.object_id = BOB.toVariable(object_id);
        return this;
      };

      BOB.prototype.insert = function (data, options) {
        return this.i(data, options);
      };

      BOB.prototype.i = function (data, options) {
        var child_bob;
        child_bob = BOB.get_or_create_bob(data, options, this);
        if (this.innerBob) {
          this.innerBob.a(child_bob);
        } else {
          this.innerBob = child_bob;
        }
        return child_bob;
      };

      BOB.prototype.append = function (data, options) {
        return this.a(data, options);
      };

      BOB.prototype.a = function (data, options) {
        var new_bob, par;
        par = this;
        if (this.parent) {
          par = this.parent;
        }
        new_bob = BOB.get_or_create_bob(data, options, par);
        if (this.postBob) {
          return this.postBob.a(new_bob);
        } else {
          return this.postBob = new_bob;
        }
      };

      BOB.prototype.prepend = function (data, options) {
        return this.p(data, options);
      };

      BOB.prototype.p = function (data, options) {
        var new_bob, par;
        par = this;
        if (this.parent) {
          par = this.parent;
        }
        new_bob = BOB.get_or_create_bob(data, options, par);
        if (this.preBob) {
          return this.preBob.p(new_bob);
        } else {
          return this.preBob = new_bob;
        }
      };

      BOB.prototype["do"] = function (dataset) {
        return this.d(dataset);
      };

      BOB.prototype.d = function (dataset) {
        var child_array;
        child_array = new BOBChildArray(dataset, this);
        return child_array;
      };

      BOB.prototype.up = function () {
        return this.parent;
      };

      BOB.prototype.u = function () {
        return this.parent;
      };

      BOB.prototype.prettyPrint = function () {
        return this.pp();
      };

      BOB.prototype.pp = function () {
        return this.s(true);
      };

      BOB.prototype.toString = function () {
        return this.s();
      };

      BOB.prototype.s = function (pretty) {
        var append, closable, content_b, key, prepend, printself, value, _ref;
        if (pretty == null) {
          pretty = false;
        }
        if (this.parent) {
          return this.parent.s(pretty);
        }
        if (this.innerBob) {
          this.innerBob.parent = null;
        }
        if (this.preBob) {
          this.preBob.parent = null;
        }
        if (this.postBob) {
          this.postBob.parent = null;
        }
        prepend = '';
        append = '';
        printself = '';
        content_b = '';
        if (this.innerBob) {
          content_b = this.innerBob.s(pretty);
        }
        if (this.preBob) {
          prepend = this.preBob.s(pretty);
        }
        if (this.postBob) {
          append = this.postBob.s(pretty);
        }
        if (this.type !== "") {
          printself += '<' + this.type + ' ';
          _ref = this.options;
          for (key in _ref) {
            value = _ref[key];
            if (!(key === 'style' && this.object_style || key === 'id' && this.object_id || key === 'class' && this.object_class)) {
              printself += key + '="' + value + '" ';
            }
          }
          if (this.object_class) {
            printself += 'class="' + this.object_class + '" ';
          }
          if (this.object_id) {
            printself += 'id="' + this.object_id + '" ';
          }
          if (this.object_style) {
            printself += 'style="' + this.object_style + '" ';
          }
          printself = printself.slice(0, -1);
          closable = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr", "basefont", "bgsound", "frame", "isindex"].indexOf(this.type) !== -1;
          if (closable && content_b === '') {
            printself += ' />';
          } else {
            if (pretty) {
              if (content_b) {
                content_b = "\n\t" + content_b.split("\n").join("\n\t") + "\n";
              } else {
                content_b = "\n";
              }
            }
            printself += '>' + content_b + '</' + this.type + '>';
          }
        } else {
          printself = this.object_content;
        }
        if (pretty) {
          if (prepend) {
            prepend = prepend + "\n\t";
            printself = printself.split("\n").join("\n\t");
          }
          if (append) {
            append = "\n" + append;
          }
        }
        return prepend + printself + append;
      };

      return BOB;

    })();


  var
    /**
     * formControl constructor
     *
     * @constructor
     */
    formControl = function()
    {
      this.controlConfig = {
        form: {
          name: ""
        },
        formControl: {
          name: "",
          id: "",
          input: {
            type: "text",
            name: "",
            size: "",
            placeholder: ""
          },
          select: {
            name: "",
            type: "",
            translate: false,
            optionsObj: [],
            options: "",
            emptyOption: "",
            emptyValue: ""
          },
          textarea: {
            name: "",
            type: "",
            placeholder: "",
            rows: "",
            cols: ""
          }
        },
        label: {
          text: ""
        },
        validators: {
          required: false,
          minLength: "",
          maxLength: "",
          pattern: "",
          equals: ""
        },
        messages: {
          ngMessages: "",
          disable: false,
          ngShow: "",
          ngMessagesInclude: '/tpl/show/jsShared/templates/base/directives/errors/validationMessages',
          backendSource: "",
          frontendSource: ""
        },
        events: {
          click: "",
          change: "",
          keyUp: "",
          keyDown: ""
        },
        state: {
          if: "",
          show: "",
          hide: "",
          disabled: ""
        },
        extra: {
          formControlStatus: false,
          formState: false,
          disableFormElements: false,
          directives: [],
          requiredDesign: true,
          autocomplete: "",
          formGroupClass: ""
        },
        attrs: null,
        model: "",
        modelOptions: "",
        class: "form-control"

      };

      var self = this;

      function convertCommas(string)
      {
        return string.replace(/"/g, "'");
      }

      /**
       * Assign common functions for every control
       *
       */
      function assignCommon()
      {
        var formControlConfig = {};

/*        if(self.controlConfig.extra.formControlStatus)
        {
          formControlConfig["form-control-status"] = "";
        }*/

        if(self.controlConfig.formControl.id){
          formControlConfig.id = self.controlConfig.formControl.id;
        }
        if(self.controlConfig.extra.formState)
        {
          formControlConfig["form-state"] = "";
        }
        if(self.controlConfig.extra.disableFormElements)
        {
          formControlConfig["disable-form-elements"] = self.controlConfig.extra.disableFormElements;
        }
        if(self.controlConfig.extra.autocomplete)
        {
          formControlConfig.autocomplete = self.controlConfig.extra.autocomplete;
        }
        if(self.controlConfig.validators)
        {
          if(self.controlConfig.validators.required)
          {
            formControlConfig.required = self.controlConfig.validators.required;
          }
          if(self.controlConfig.validators.minLength)
          {
            formControlConfig["ng-minlength"] = self.controlConfig.validators.minLength;
          }
          if(self.controlConfig.validators.maxLength)
          {
            formControlConfig["ng-maxlength"] = self.controlConfig.validators.maxLength;
          }
          if(self.controlConfig.validators.pattern)
          {
            formControlConfig["ng-pattern"] = "'" + self.controlConfig.validators.pattern + "'";
          }
          if(self.controlConfig.validators.equals)
          {
            formControlConfig.equals = "{{" + self.controlConfig.validators.equals + "}}";
          }

          if(self.controlConfig.validators.attrs){
            _.extend(formControlConfig, self.controlConfig.validators.attrs)
          }
        }

        if(self.controlConfig.events)
        {
          if(self.controlConfig.events.change)
          {
            formControlConfig["ng-change"] = self.controlConfig.events.change;
          }
          if(self.controlConfig.events.click)
          {
            formControlConfig["ng-click"] = self.controlConfig.events.click;
          }
          if(self.controlConfig.events.keyUp)
          {
            formControlConfig["ng-keyup"] = self.controlConfig.events.keyUp;
          }
          if(self.controlConfig.events.keyDown)
          {
            formControlConfig["ng-keydown"] = self.controlConfig.events.keyDown;
          }
        }

        if(self.controlConfig.state)
        {
          if(self.controlConfig.state.disabled)
          {
            formControlConfig["ng-disabled"] = self.controlConfig.state.disabled;
          }
        }
/*
        if(self.controlConfig.extra.directives)
        {
          formControlConfig["form-control-status"] = "";
        }*/

        _.forEach(self.controlConfig.extra.directives, function(directive){
          formControlConfig[ directive ] = "";
        });

        var optionsObject = "{ updateOn: 'change blur' }";
        if(self.controlConfig.modelOptions)
        {
          optionsObject = convertCommas(JSON.stringify(self.controlConfig.modelOptions));
        }
        formControlConfig["ng-model-options"] = optionsObject;
        formControlConfig["ng-model"] = self.controlConfig.model;
        formControlConfig["class"] = self.controlConfig.class;
        formControlConfig["base-backend-valid"] = self.controlConfig.messages.backendSource ? self.controlConfig.messages.backendSource : "";
        formControlConfig["frontend-valid"] = self.controlConfig.messages.frontendSource ? self.controlConfig.form.name + "." + self.controlConfig.messages.frontendSource : "";

        if(_.isObject(self.controlConfig.attrs)){
          _.extend(formControlConfig, self.controlConfig.attrs)
        }

        return formControlConfig;
      }

      /**
       * Builds input form control
       *
       * @returns {BOB}
       */
      function buildInput()
      {
        var inputConfig = assignCommon();
        inputConfig.name = self.controlConfig.formControl.input.name;
        inputConfig.type = self.controlConfig.formControl.input.type;
        if(inputConfig.type == "email")
        {
          inputConfig['customemail'] = "";
          inputConfig["ng-minlength"] = 6;
          inputConfig["ng-maxlength"] = 50;
        }
        if(inputConfig.type == "tel")
        {
          inputConfig["phone"] = "";
          inputConfig["ng-minlength"] = 9;
          inputConfig["ng-maxlength"] = 20;
        }
        if(inputConfig.type == "password")
        {
          inputConfig["password"] = "";
          inputConfig["ng-minlength"] = 5;
          inputConfig["ng-maxlength"] = 255;
        }
        if(self.controlConfig.formControl.input.placeholder){
          inputConfig.placeholder = "{{ ::('" + self.controlConfig.formControl.input.placeholder + "' | translate) }}";
        }

        if(self.controlConfig.formControl.input.size){
          inputConfig["class"] += " input-" + self.controlConfig.formControl.input.size;
        }

        if(self.controlConfig.formControl.input.type == "checkbox"){
          inputConfig["class"] += " custom-checkbox";
        }

        return new BOB("input", inputConfig);
      }

      /**
       * Builds select form control
       *
       * @returns {BOB}
       */
      function buildSelect()
      {
        var selectConfig = assignCommon();
        selectConfig.name = self.controlConfig.formControl.select.name;

        var builtOptions = "", optionConfig = {};
        if(angular.isArray(self.controlConfig.formControl.select.optionsObj) && self.controlConfig.formControl.select.optionsObj.length > 0)
        {
          _.forEach(self.controlConfig.formControl.select.optionsObj, function(option){
            if(self.controlConfig.formControl.select.translate){
              optionConfig.translate = "";
            }
            optionConfig.value = option.value;
            builtOptions += new BOB('option', optionConfig).content(option.label);
          });
        }

        if(self.controlConfig.formControl.select.options)
        {
          selectConfig["ng-options"] = self.controlConfig.formControl.select.options;
          if(self.controlConfig.formControl.select.emptyOption)
          {
            if(self.controlConfig.formControl.select.translate){
              optionConfig = {
                translate: "",
                value: self.controlConfig.formControl.select.emptyValue
              };
            }
            builtOptions += new BOB('option', optionConfig).content(self.controlConfig.formControl.select.emptyOption);
          }
        }

        var wrappedSelect = new BOB("label",
          {
            "class": "selectControlWrapper"
          }
        )
          .content(new BOB("select", selectConfig).content(builtOptions).s());
        return wrappedSelect;
      }

      /**
       * Builds textarea form control
       *
       * @returns {BOB}
       */
      function buildTextarea()
      {
        var textareaConfig = assignCommon();
        textareaConfig.name = self.controlConfig.formControl.textarea.name;
        textareaConfig['ng-attr-placeholder'] = "{{ ::('" + self.controlConfig.formControl.textarea.placeholder + "' | translate) }}";

        if(self.controlConfig.formControl.textarea.rows)
        {
          textareaConfig.rows = self.controlConfig.formControl.textarea.rows;
        }

        if(self.controlConfig.formControl.textarea.cols)
        {
          textareaConfig.cols = self.controlConfig.formControl.textarea.cols;
        }

        return new BOB("textarea", textareaConfig);
      }

      /**
       * Build form control (input, select, textarea)
       *
       * @returns {BOB}
       */
      function buildFormControl()
      {
        var formControl = "";

        if(self.controlConfig.formControl.input && self.controlConfig.formControl.input.name)
        {
          formControl = buildInput();
        }
        else if(self.controlConfig.formControl.select && self.controlConfig.formControl.select.name){
          formControl = buildSelect();
        }
        else if(self.controlConfig.formControl.textarea && self.controlConfig.formControl.textarea.name){
          formControl = buildTextarea();
        }

        return formControl;
      }

      /**
       * Build ng-messages
       *
       * @returns {BOB}
       */
      function buildNgMessages() {
        // var ngMessages = "", message = "";

        // message = new BOB("small", {
        //   "ng-message": "backend"
        // }).class("help-block");

        // if(self.controlConfig.messages.backendSource)
        // {
        //   message.content("{{ " + self.controlConfig.messages.backendSource + " }}");
        // }

        // var showIfBackend = self.controlConfig.messages.backendSource ? self.controlConfig.form.name + "." + self.controlConfig.formControl.name + ".$error.backend" : false;

        // ngMessages = new BOB("div",
        //   {
        //     "ng-messages": self.controlConfig.form.name + "." + self.controlConfig.formControl.name + ".$error",
        //     "ng-if": "(" + self.controlConfig.form.name + "." + self.controlConfig.formControl.name + ".$invalid && (" + self.controlConfig.form.name + "." + self.controlConfig.formControl.name + ".$dirty || " + self.controlConfig.form.name + ".$submitted) ) || " + showIfBackend
        //   });

        // var ngMessagesInclude = new BOB("div",
        //   {
        //     "ng-messages-include": self.controlConfig.messages.ngMessagesInclude
        //   });

        // ngMessages.content(message.s() + ngMessagesInclude.s());

        return new BOB('field-validation', {
          'form': self.controlConfig.form.name,
          'name': self.controlConfig.formControl.name,
          'backend-error': self.controlConfig.messages.backendSource
        });
      }

      /**
       * Build form control label
       *
       * @returns {BOB}
       */
      function buildLabel(translate)
      {
        translate = typeof translate !== 'undefined' ?  translate : true;

        var labelConfig = {
          "class": "control-label"
        };

        if(translate){
          labelConfig["translate"] = ""
        }

        if(self.controlConfig.formControl.id){
          labelConfig["for"] = self.controlConfig.formControl.id;
        }

        var label = new BOB("label", labelConfig);

        if(self.controlConfig.formControl.input.type == "checkbox")
        {
          var span = new BOB("span", { class: "pull-left", translate: "" });
          span.content(self.controlConfig.label.text);
          label.content(span.s());
        }
        else if(self.controlConfig.label)
        {
          label.content(self.controlConfig.label.text);
        }
        return label;
      }

      /**
       * Sets formControl name from input, select or textarea
       */
      function setControlName(){
        try
        {
          self.controlConfig.formControl.name = self.controlConfig.formControl.input.name || self.controlConfig.formControl.select.name || self.controlConfig.formControl.textarea.name;

          if( _.isUndefined(self.controlConfig.formControl.name) )
          {
            throw "form control name not found";
          }

        }
        catch(e)
        {
          console.error(e);
        }
      }

      function hiddenControl(){
        return self.controlConfig.formControl.input.type == 'hidden' || self.controlConfig.formControl.select.type == 'hidden' || self.controlConfig.formControl.textarea.type == 'hidden';
      }

      /**
       * Build form control group
       * @returns {string} (HTML)
       */
      var buildFormGroup = function()
      {
        setControlName();

        var error = ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name) ? ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name)["has-error"] : "";
        var success = ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name) ? ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name)["has-success"] : "";

        var className = "form-group " + self.controlConfig.extra.formGroupClass,
          wrapperConfig = { // has-feedback removed
            "ng-class": "{ 'has-error': " + error +
            ", 'has-success': " + success + " }"
          };

        if(self.controlConfig.state)
        {
          if(self.controlConfig.state.if)
          {
            wrapperConfig["ng-if"] = self.controlConfig.state.if;
          }
          if(self.controlConfig.state.show)
          {
            wrapperConfig["ng-show"] = self.controlConfig.state.show;
          }
          if(self.controlConfig.state.hide)
          {
            wrapperConfig["ng-hide"] = self.controlConfig.state.hide;
          }
        }

        if(self.controlConfig.validators.required && self.controlConfig.extra.requiredDesign)
        {
          className += " required";
        }
        var wrapper = new BOB("div", wrapperConfig).class(className);

        var ngMessages = !self.controlConfig.messages.disable && !hiddenControl() ? buildNgMessages().s() : "";

        var label = _.isObject(self.controlConfig.label) && self.controlConfig.label.text && !hiddenControl() ? buildLabel().s() : "";

          wrapper.content(label + buildFormControl().s() + ngMessages);

        //console.info(wrapper.s());
        return wrapper.s();
      };

      /**
       * Build checkbox
       * @returns {string} (HTML)
       */
      var buildCheckbox = function() //todo refactor
      {
        setControlName();

        var error = ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name) ? ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name)["has-error"] : "";
        var success = ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name) ? ValidationUtils.getValidationClass(self.controlConfig.form.name, self.controlConfig.formControl.name)["has-success"] : "";

        var className = "form-group " + self.controlConfig.extra.formGroupClass,
          wrapperConfig = { // has-feedback removed
            "ng-class": "{ 'has-error': " + error +
            ", 'has-success': " + success + " }"
          };

        if(self.controlConfig.state)
        {
          if(self.controlConfig.state.if)
          {
            wrapperConfig["ng-if"] = self.controlConfig.state.if;
          }
          if(self.controlConfig.state.show)
          {
            wrapperConfig["ng-show"] = self.controlConfig.state.show;
          }
          if(self.controlConfig.state.hide)
          {
            wrapperConfig["ng-hide"] = self.controlConfig.state.hide;
          }
        }

        if(self.controlConfig.validators.required && self.controlConfig.extra.requiredDesign)
        {
          className += " required";
        }
        var wrapper = new BOB("div", wrapperConfig).class(className);

        var ngMessages = !self.controlConfig.messages.disable && !hiddenControl() ? buildNgMessages().s() : "";

        var label = _.isObject(self.controlConfig.label) && self.controlConfig.label.text && !hiddenControl() ? buildLabel(false).s() : "";

        if(self.controlConfig.formControl.input.type == "checkbox"){
          wrapper.content(buildFormControl().s() + label + ngMessages);
        }
        else{
          wrapper.content(buildInput().s() + label + ngMessages);
        }

        //console.info(wrapper.s())
        return wrapper.s();
      };

      /**
       * Sets controlConfig from directive attribute "config"
       *
       * @param config
       */
      this.setFormControlConfig = function(config)
      {
        this.controlConfig = angular.merge({}, this.controlConfig, config);
      };

      /**
       * Returns built form group
       *
       * @returns {string}
       */
      this.getBuiltFormGroup = function()
      {
        if(self.controlConfig.formControl.input.type == "checkbox"){
          return buildCheckbox();
         }
         else{
          return buildFormGroup();
        }
      };

    };

  formControl.prototype.constructor = formControl;

  return formControl;
}]);
;

// Source: ../shared/public_html/assets/js/base/services/GalleryService.js
angular.module('base')

/**
 * @name GalleryService
 * @description
 */
.service('GalleryService',
['ApiTools', 'Picture',
function GalleryService(ApiTools, Picture) {
/**
   * @param {Number} galleryId Gallery ID
   * @return {Promise}
   */
  this.getImages = function (galleryId) {
    var endpoint = {url: 'api/gallery/getImages/:id', method: 'GET', respParser: imagesParser};
    return ApiTools.fetch(this, endpoint, {}, {id: galleryId});
  };

  /**
   * @param {Object} response
   * @return {Array<Object>}
   */
  function imagesParser(response) {
    var list = [];

    _.each(response.response, function (v) {
      var picture = new Picture(v);
      list.push(picture);
    });

    return list;
  }
}]);
;

// Source: ../shared/public_html/assets/js/base/services/LangSelectionSrv.js
/*global _js_app_config_: false */

  angular.module('base')

  /**
   * @name        LangSelection
   * @description Class that handles API language change
   * @todo        Improve description
   */
.factory('LangSelection',
['ApiTools', 'appConfig', 'Dictionaries', '$q',
function LangSelectionFactory(ApiTools, appConfig, Dictionaries, $q)
{
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Get countries
      apiSetLang: {url: '/config/setLanguageCode/:languageCode', method: 'POST', respParser: langSelectionParser}
    },

    /**
     * Language selection
     *
     * @class LangSelection
     * @constructor
     */
    LangSelection = function()
    {
      this.code = appConfig.getLanguageCode();
    },

    langChangePromise = null;

  LangSelection.prototype = /** @lends LangSelection.prototype */ {

    /**
     * Set site language
     *
     * @param  {String} code The language code ex: pl, en, ro, ...
     * @return {Promise}
     */
    setLanguageCode: function(code)
    {
      this.code = code;
      langChangePromise = ApiTools.fetch(this, endpoints.apiSetLang, Dictionaries.getUsedCodes(), {languageCode: code});
      return langChangePromise;
    },

    /**
     * Returns language code
     *
     * @return {String} The language code ex: pl, en, ro, ...
     */
    getLanguageCode: function()
    {
      return this.code;
    },

    /**
     * Returns language code
     *
     * @return {Promise}
     */
    getLanguageCodePromise: function()
    {
      if(langChangePromise === null)
      {
        var deferred = $q.defer();
        deferred.resolve(this.code);
        return deferred.promise;
      }

      return langChangePromise;
    }
  };

  LangSelection.prototype.constructor = LangSelection;

  /**
   * Parse language selection response
   *
   * @param  {Object} response
   *
   * @return {LangSelection}
   */
  function langSelectionParser(response)
  {
    var resp = response.response;

    // We set it on global object. Not beautiful but it works for now.
    _js_app_config_.language_code = resp.languageCode;
    appConfig.setLanguageCode(resp.languageCode);
    Dictionaries.addDictionary(resp.dictionary, resp.languageCode);
    langChangePromise = null;

    return this;
  }

  return new LangSelection();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/LangSrv.js
angular.module('base')

/**
 * @name myModule.ExampleService
 *
 * @description Example service responsibility description
 */
.factory('LangSrv',
['ApiTools',
function LangSrvFactory(ApiTools) {
var endpoints =
    {
      get_translated_url: {url: '/home/getLangTranslate', method: 'POST', respParser: getResponse}
    },

    /**
     * @constructor
     */
    LangSrv = function () {};

  LangSrv.prototype = /** @lends ExampleService.prototype */ {
    getTranslatedUrl: function (args) {
      return ApiTools.fetch(this, endpoints.get_translated_url, args);
    }
  };

  function getResponse(response) {
    return response.response;
  }

  LangSrv.prototype.constructor = LangSrv;

  return new LangSrv();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/LeadOfferSrv.js
angular.module('base')

/**
 * @name base.LeadOffers
 *
 * @description Example service responsibility description
 */
.factory('LeadOffers',
['ApiTools','$location',
function LeadOffersFactory(ApiTools,$location) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Example endpoint
      leadOffers: {url: 'api/leadOffers/getLeadOffers', method: 'POST', respParser: leadParser}
    },

    /**
     * @class LeadOffersFactory
     * @constructor
     */
    LeadOffersFactory = function () {};

  LeadOffersFactory.prototype = /** @lends LeadOffersFactory.prototype */  {

    /**
     * getLeadOffers return lead offer for new filters
     *
     * @param {String} name Lead Offers page name
     * @param {Object} params - filters
     * @return {Promise}
     */
    getLeadOffers: function (name, params) {
      var endpoint = angular.copy(endpoints.leadOffers);
      endpoint.url += '/' + name;
      if ($location.search().disablecache) {
        endpoint.url += '?disablecache=1';
      }
      return ApiTools.fetch(this, endpoint, params);
    }
  };

  LeadOffersFactory.prototype.constructor = LeadOffersFactory;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {myModule.Example}
   */
  function leadParser(response) {
    return response.response;
  }

  return new LeadOffersFactory();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/Links.js
angular.module('base')

/**
 * @name base.Links
 *
 * @description Example service responsibility description
 */
.factory('Links',
['ApiTools',
function LinksFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Example endpoint
      countries: {url: 'fakeApi/countries', method: 'GET', respParser: leadParser},
      airlines: {url: 'fakeApi/airlines', method: 'GET', respParser: leadParser}
    },

    /**
     * @class LinksFactory
     * @constructor
     */
    LinksFactory = function () {};

  LinksFactory.prototype = /** @lends LinksFactory.prototype */  {

    /**
     * Example method on the service
     *
     * @param {String} code The parameter
     * @return {Promise}
     */
    getCountries: function () {
      return ApiTools.fetch(this, endpoints.countries);
    },
    getAirlines: function () {
      return ApiTools.fetch(this, endpoints.airlines);
    }
  };

  LinksFactory.prototype.constructor = LinksFactory;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {myModule.Example}
   */
  function leadParser(response) {

    return response.response;
  }

  return new LinksFactory();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/Locations.js
/*global _: false */

angular.module('base')

/**
 * @name        Locations
 * @description
 */
.factory('Locations',
['ApiTools', '$q', 'appConfig', 'bil.Country', 'bil.Province', 'LangSelection', '$filter',
function LocationsFactory(ApiTools, $q, appConfig, Country, Province, LangSelection, $filter)
{
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Get countries
      apiGetCountries:
      {
        url: '/api/location/getCountries' +'?abv='+_js_app_config_.ab_version ,
        method: 'GET',
        respParser: countriesParser
      },
      // Get provinces for a country
      apiGetCountryProvinces:
      {
        url: '/api/location/getProvinces/:countryCode' +'?abv='+_js_app_config_.ab_version ,
        method: 'GET',
        respParser: provincesParser
      }
    },

    /**
     * Array of retrieved countries
     *
     * The key is the language code and value is an array of Country objects
     *
     * {'en' = [Country, Country]}
     *
     * @type {Object}
     */
    countries = {},

    /**
     * Provinces
     *
     * {'en': { 'ro' : [Province, Province]}
     *
     * @type {Object}
     */
    provinces = {},

    /**
     *
     * @class Locations
     * @constructor
     */
    Locations = function() {};

  // Add instance methods
  Locations.prototype = /** @lends Locations.prototype */ {

    /**
     * Get all countries
     *
     * @return {Promise}
     */
    getCountries: function(addPlaceholder)
    {
      return LangSelection.getLanguageCodePromise().then(function(languageCode)
      {
        if (countries[languageCode])
        {
          var deferred = $q.defer();
          deferred.resolve(countries[languageCode]);
          return deferred.promise;
        }

        return ApiTools.fetch(this, endpoints.apiGetCountries).then(function(countries) {
          if (addPlaceholder) {
            var country = new Country({
                code: '',
                name: $filter('translate')('LANGM_JS_SELECT_COUNTRY')
            });
            country.disabled = true;
            countries.unshift(country);
          }

          return countries;
        });
      });
    },

    /**
     * Get provinces by country code
     *
     * @param  {String} countryCode
     *
     * @return {Object}
     */
    getProvinces: function(countryCode)
    {
      var languageCode = appConfig.getLanguageCode().toLowerCase();
      countryCode = countryCode.toLowerCase();

      if (provinces[languageCode] && provinces[languageCode][countryCode])
      {
        var deferred = $q.defer();
        deferred.resolve(provinces[languageCode][countryCode]);
        return deferred.promise;
      }

      return ApiTools.fetch(this, endpoints.apiGetCountryProvinces,
      {},
      {
        countryCode: countryCode
      });
    }
  };

  /**
   * Parse API response for countries
   *
   * @param  response
   *
   * @return {Country[]}
   */
  function countriesParser(response)
  {
    var resp = response.response,
      languageCode = appConfig.getLanguageCode();

    countries[languageCode] = [];

    _.map(resp, function(country)
    {
      countries[languageCode].push(new Country(country));
    });

    return countries[languageCode];
  }

  /**
   * Parse API response for provinces
   *
   * @param  response
   *
   * @return {Country[]}
   */
  function provincesParser(response)
  {
    var resp = response.response,
      languageCode = appConfig.getLanguageCode().toLowerCase(),
      countryCode = resp[0].country_code.toLowerCase();

    if (!provinces[languageCode])
    {
      provinces[languageCode] = {};
    }

    provinces[languageCode][countryCode] = [];

    _.map(resp, function(country)
    {
      provinces[languageCode][countryCode].push(new Province(country));
    });

    return provinces[languageCode][countryCode];
  }

  Locations.prototype.constructor = Locations;

  return new Locations();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/MediaMatch.js
(function () {
angular.module('base').service('MediaMatch', MediaMatch);

    MediaMatch.$inject = ['$window'];

    /**
     * MediaMatch service.
     *
     * Wrapper around `window.matchMedia` API for checking media queries and detecting its changes.
     * Can be used with or without angular's scope. When used without a scope, care need to be taken about
     * propagating changes and removing the listener.
     *
     * @param $window
     *
     * @constructor
     */
    function MediaMatch($window) {

        return {
            listen: listen,
            listenWithScope: listenWithScope,
        };

        /**
         * Check matchMedia and listen for its change events.
         *
         * @typedef {Object} MediaMatchDescriptor
         * @property {boolean} matches - the current status
         * @property {function} end - remover for changes listener
         *
         * @param {string} query
         * @param {Function} callback
         *
         * @return {MediaMatchDescriptor}
         */
        function listen(query, callback) {

            var mediaQueryList = $window.matchMedia(query);

            mediaQueryList.addListener(callback); // for IE10 compatibility

            return {
                matches: mediaQueryList.matches,
                end: function () {
                    mediaQueryList.removeListener(callback);
                },
            };
        }

        /**
         * Check matchMedia and listen for its change events, in a scope context.
         *
         * @param {$rootScope.Scope} scope
         * @param {string} query
         * @param {Function} callback
         *
         * @return {boolean}
         */
        function listenWithScope(scope, query, callback) {

            var proxy = function (event) {
                scope.$apply(function ($scope) {
                    callback.call($scope, event);
                });
            };

            var descriptor = listen(query, proxy);

            scope.$on('$destroy', descriptor.end);

            return descriptor.matches;
        }
    }

})(angular);
;

// Source: ../shared/public_html/assets/js/base/services/MetaTranslator.js
/*global angular: false */

angular.module('base')

/**
 * @name        MetaTranslator
 * @description
 */
.factory('MetaTranslator',
['$translate',
function MetaTranslatorFactory($translate) {
/**
   * MetaTranslator
   *
   * @constructor
   */
  var MetaTranslator = function () {

    // Meta title
    this.metaTitleLang = '';
    this.metaTitle = '';

    // Meta description
    this.metaDescriptionLang = '';
    this.metaDescription = '';

    // Navigation bar title
    this.navbarTitleLang = '';
    this.navbarTitle = '';

    // Translation parameters
    this.translateParams = {};
  };

  MetaTranslator.prototype = /** @lends MetaTranslator.prototype */ {

    /**
     * Sets the html meta title
     *
     * @param {String} lang
     */
    setMetaTitle: function (lang) {
      this.metaTitleLang = lang;
      return this;
    },

    /**
     * Returns the html meta title
     *
     * @return {String}
     */
    getMetaTitle: function () {
      return this.metaTitle;
    },

    /**
     * Sets the html meta description
     *
     * @param {String} lang
     */
    setMetaDescription: function (lang) {
      this.metaDescriptionLang = lang;
      return this;
    },

    /**
     * Returns the html meta description
     *
     * @return {String}
     */
    getMetaDescription: function () {
      return this.metaDescription;
    },

    /**
     * Sets the navigation bar title
     *
     * @param {String} lang
     */
    setNavbarTitle: function (lang) {
      this.navbarTitleLang = lang;
      return this;
    },

    /**
     * Returns the navigation bar title
     *
     * @return {String}
     */
    getNavbarTitle: function () {
      return this.navbarTitle;
    },

    /**
     * Sets the optional translation parameters
     *
     * @param {Object} params
     */
    setParams: function (params) {
      this.translateParams = params;
      return this;
    },

    /**
     * Checks if a string is a translation or lang snippet
     *
     * @param  {String}  str
     *
     * @return {Boolean}
     */
    isTranslated: function (str) {
      return str.indexOf('LANGM_JS_') !== 0;
    },

    /**
     * Translates the snippets
     */
    translate: function (callback) {
      var self = this;

      // Call translation service
      this.promise = $translate([this.metaTitleLang, this.metaDescriptionLang, this.navbarTitleLang], this.translateParams).then(function (translations) {
        // Set meta data with translated lang data
        self.metaTitle = translations[self.metaTitleLang];
        self.metaDescription = translations[self.metaDescriptionLang];

        // Set navbar title
        self.navbarTitle = translations[self.navbarTitleLang];

        if(callback) {
          callback();
        }
      });

      return self;
    },

    /**
     * Add the meta information to the page
     */
    addInfoToPage: function () {
      document.querySelector('title').innerHTML = this.metaTitle;
      document.querySelector("meta[name='description']").setAttribute('content', this.metaDescription);
    }

  };

  MetaTranslator.prototype.constructor = MetaTranslator;

  return new MetaTranslator();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/ModalService.js
angular.module('base')

/**
 * @name        ModalService
 * @namespace   pkg
 * @description Handles modals
 */
.service('pkg.ModalService',
['$modal',
function ModalService($modal) {
/**
   * Modal instance
   *
   * @type {$modal}
   */
  var modalInstance;

  /**
   * @param data
   * @param tpl
   * @param {Object} options
   * @returns {Object}
   */
  this.open = function (data, tpl, options) {
    modalInstance = $modal.open(_.extend({
      animation: false,
      size: 'lg',
      backdrop: true,
      templateUrl: tpl,
      controller: function () {
        _.extend(this, data);

        this.dismiss = function () {
          modalInstance.close();
        };
      },
      controllerAs: 'vm'
    }, options));

    return modalInstance;
  };

  /**
   * Close modal instance
   */
  this.close = function() {
    if(modalInstance) {
      modalInstance.close();
    }
  }

}]);
;

// Source: ../shared/public_html/assets/js/base/services/NewsletterSrv.js
angular.module('base')

/**
 * @name Newsletter Service
 *
 * @description Newsletter service responsibility description
 */
.factory('NewsletterSrv', ['ApiTools','SalesManagoSrv',
function NewsletterSrvFactory(ApiTools,SalesManagoSrv) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints =
    {
      get_data: {url: '/newsletter/getJsonData', method: 'POST', respParser: getResponse},
      add_to_newsletter: {url: '/newsletter/addToNewsLetter', method: 'POST', respParser: getResponse}
    },

    /**
     * @class NewsletterSrv
     * @constructor
     */
    NewsletterSrv = function () {};

  /**
   * @lends NewsletterSrv.prototype
   */
  NewsletterSrv.prototype =
  {

    /**
     * Get Data
     *
     * @return {Promise}
     */
    getData: function (type, value) {
      return ApiTools.fetch(this, endpoints.get_data, {type: type, value: value});
    },

    /**
     * Add To Newsletter
     *
     * @return {Promise}
     */
    addToNewsletter: function (args) {
      return ApiTools.fetch(this, endpoints.add_to_newsletter, args);
    }

  };

  NewsletterSrv.prototype.constructor = NewsletterSrv;

  /**
   * Get Response
   *
   * @param {Object} response
   * @return Object
   */
  function getResponse(response) {
    var resp = response.response;
    if(resp.contactId)
    {
      SalesManagoSrv.load(resp.contactId);
    }

    return resp;
  }

  return new NewsletterSrv();
}]);




;

// Source: ../shared/public_html/assets/js/base/services/NgStaticPage.js
angular.module('base')

/**
 * @name base.NgStaticPage
 *
 * @description Example service responsibility description
 */
.factory('NgStaticPage',
['ApiTools', 'appConfig', '$location',
function (ApiTools, appConfig, $location) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      ngStaticPage: {url: 'api/ngStaticPage/getNgStaticPage', method: 'GET', respParser: parser}
    },

    /**
     * @class NgStaticPageFactory
     * @constructor
     */
    NgStaticPageFactory = function () {};

  NgStaticPageFactory.prototype = /** @lends NgStaticPageFactory.prototype */  {

    /**
     * Example method on the service
     *
     * @param {int} Text Box name
     * @return {Promise}
     */
    getNgStaticPage: function (name) {
      if (name == '/' || !name) name = appConfig.getHomePageUrl();

      var endpoint = angular.copy(endpoints.ngStaticPage);
      endpoint.url += '/' + name;

      if ($location.search().disable_search) {
        endpoint.url += '?disable_search=1';
      }

      return ApiTools.fetch(this, endpoint);
    }
  };

  NgStaticPageFactory.prototype.constructor = NgStaticPageFactory;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {myModule.Example}
   */
  function parser(response) {
    return response.response;
  }

  return new NgStaticPageFactory();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/OrderValidation.js
/*global angular: false, _: false */

angular.module('base')

/**
 * @name        OrderValidation
 * @description A service that provides methods for communicating with the server through JSON APIs
 */
.factory('OrderValidation',
[ '$location',
function ($location) {
var
    /**
     * OrderValidation constructor
     *
     * @constructor
     */
    OrderValidation = function () {
    };

  OrderValidation.prototype = /** @lends OrderValidation.prototype */ {
    /**
     * Validate order forms
     *
     * @param form
     * @param order
     */
    validateForms: function(form, order)
    {
      var i, tempPassengerDetails = "";

      //console.warn(this, form, self.bookingForm, bookingForm);
      if (typeof form.contactInfo != 'undefined')
      {
       form.contactInfo.$setSubmitted();
      }

      for (i = 0; i < order.getPaxCount(); i++)
      {
       tempPassengerDetails = "passengerDetails" + i;
       if (form && form[tempPassengerDetails])
       {
         form[tempPassengerDetails].$setSubmitted();
       }
      }

      if (order.getBilling().isPerson() && form.billingPerson)
      {
       form.billingPerson.$setSubmitted();
      }
      else if (order.getBilling().isCompany())
      {
        if(form && form.billingCompany)
        {
          form.billingCompany.$setSubmitted();
        }
      }

      if (order.getPayment().getType() === 'CC' && _js_app_config_.affiliateId != 11)
      {
        form.paymentInfo.creditCardForm.$setSubmitted();
      }

      if (order.getPayment().getType() === 'BA' && _js_app_config_.affiliateId != 11)
      {
        form.paymentInfo.blikCodeForm.$setSubmitted();
      }

      if (order.getPayment().getType() === 'PBL' && _js_app_config_.affiliateId != 11)
      {
        form.paymentInfo.pblForm.$setSubmitted();
      }

      //reset continue to desktop form, it was blocking booking
      if(form.desktopLink){
        form.desktopLink.contactMail.$setValidity('required', true);
        form.desktopLink.contactMail.$setValidity('email', true);
        form.desktopLink.contactMail.$setValidity('minlength', true);
        form.desktopLink.contactMail.$setValidity('maxlength', true);
      }
    },

    /**
     * Set errors from server
     *
     * @param form
     * @param order
     * @param response
     */
    setServerErrors: function(form, order, response)
    {
      order.hasBackendErrors = true;

      // Set server errors in booking
      order.srvErrors2(response, form);

      // Set billing validity
      switch (order.getBilling().getType())
      {
       case 'person':
         form.billingPerson ? order.getBilling().getPerson().setFormValidity(form.billingPerson) : _.noop;
         order.getBilling().getPerson().setFormValidity(form.contactInfo);
         break;
       case 'company':
         order.getBilling().getCompany().setFormValidity(form.billingCompany);
         order.getBilling().getCompany().setFormValidity(form.contactInfo);
         break;
      }

      // Set credit card validity
      if (order.getPayment().getType() == 'CC' && _js_app_config_.affiliateId != 11)
      {
       order.payment.creditCard.setFormValidity(form.paymentInfo.creditCardForm);
        //form.paymentInfo.creditCardForm.$setPristine();
      }

      // Set Blik Code validity
      if (order.getPayment().getType() == 'BA' && _js_app_config_.affiliateId != 11)
      {
        order.payment.blikCode.setFormValidity(form.paymentInfo.blikCodeForm);
      }

      // Set PBL Vendor validity
      if (order.getPayment().getType() == 'PBL' && _js_app_config_.affiliateId != 11)
      {
        order.payment.pbl.setFormValidity(form.paymentInfo.pblForm);
      }

      if (response.paxes) {
        angular.forEach(response.paxes, function (errorsObject, key) {
          var possiblePaxForms = [
            'passengerDetails' + key,
            'editPassengerDetails' + key
          ];

          angular.forEach(possiblePaxForms, function (paxFormName) {
            if (form.hasOwnProperty(paxFormName)) {
              order.paxes[key].person.setFormValidity(form[paxFormName]);
            }
          });
        });
      }
    },

    /**
     * Get form name to scroll to in case of server errors
     *
     * @param response
     * @returns {string}
     */
    getFormToScrollIfServer: function(response) {
      var keys = _.keys(_.omit(response, function (value, key) {
       return value == null || (_.isArray(value) && !value.length) || key.charAt(0) == '_';
      }));

      if (keys.includes('paxes') || keys.includes('contact')) {
        return 'passengerDetails';
      }

      if (keys.includes('billing')) {
        return 'billingInfo';
      }

      if (keys.includes('payment')) {
       return 'paymentInfo';
      }

      return 'bookingForm';
    },

    /**
     * Get form name to scroll to in case of client side errors
     *
     * @param form
     * @returns {string}
     */
    scrollIfClient: function(form) { //todo unify with server validation
      var goTo = "bookingForm";

      var orderWeight = ['passengerDetails', 'contactInfo', 'billingCompany', 'billingPerson', 'paymentInfo'];
      var i = 0;
      var j = 0;

      try
      {
        var keys = _.keys(_.omit(form, function (value, key)
        {
          return value == null || key.charAt(0) == '$' || value.$valid;
        }));

        keys = keys.sort();

        if (keys.length > 0 && keys[0])
        {
          orderLoop:
            for (i; i < orderWeight.length; i++) {
              j = 0;

              for (j; j < keys.length; j++) {
                if ( keys[j].indexOf(orderWeight[i]) == 0 ) {
                  goTo = keys[j];
                  break orderLoop;
                }
              }
            }
        }
      }
      catch (e)
      {
        goTo = "bookingForm";
      }

      return goTo;
    }

  };

  OrderValidation.prototype.constructor = OrderValidation;

  return new OrderValidation();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/PageLoading.js
angular.module('base')

/**
 * @name        PageLoading
 * @description Keeps the state for full page loading
 */
.service('PageLoading', ['$timeout', '$q', function PageLoading($timeout, $q) {
var
    /**
     * $q defer object
     * @type {Object}
     */
    _deferred = $q.defer(),

    /**
     * Promise object for loader
     * @type {[type]}
     */
    _promise = _deferred.promise,

    /**
     * Flag if loading is on
     * @type {Boolean}
     */
    _loading = false,

    /**
     * Index of the randomised lang
     * @type {Number}
     */
    _langIndex = 1,

    /**
     * Maximum number of langs to be shufled
     * @type {Number}
     * @default: 10
     */
    _maxLangs = 10,

    /**
     * Generates a new lang index if a new loader is shown
     * @return {Void}
     */
    _generateNewIndex = function () {
      if (!_loading) {
        // Generate a new random lang index
        _langIndex = Math.floor((Math.random() * _maxLangs) + 1);
      }
    };

  /**
   * Display page loading
   * @return {Void}
   */
  this.on = function () {
    _generateNewIndex();
    _loading = true;
  };

  /**
   * Hide page loading
   * @return {Void}
   */
  this.off = function () {
    $timeout(function() {
      _loading = false;
      _deferred.resolve(_loading);
    }, 50);
  };

  /**
   * Returns true if page is loading
   * @return {Boolean}
   */
  this.isLoading = function () {
    return _loading;
  };

  /**
   * Returns the current lang index for loading text
   * @return {Number}
   */
  this.getLangIndex = function() {
    return _langIndex;
  };

  /**
   * Get loading promise
   * @return {Promise}
   */
  this.getLoadingPromise = function() {
    return _promise;
  }
}]);
;

// Source: ../shared/public_html/assets/js/base/services/PaxAgeChecker.service.js
(function (angular) {
var Service = function (SearchQueryParams) {
        this.isAnyPaxReached75Years = function (paxes) {
            var depDate = SearchQueryParams.getDepDate()

            return paxes.some(function (pax) {
                var birthDate = pax.person.birthDate;

                if (!birthDate) {
                    return false;
                }

                var ageOnDepDate = moment(depDate).diff(birthDate, 'years');

                return ageOnDepDate >= 75;
            });
        };
    };

    Service.$inject = [
        'sch.SearchQueryParams'
    ];

    angular
        .module('base')
        .service('PaxAgeCheckerService', Service);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/PaymentPageSrv.js
angular.module('base')

/**
 * @name UserService
 *
 * @description UserService
 */
.factory('PaymentPage', ['ApiTools',
function PaymentPageFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     *                         https://en.vola.ro/profile/save_traveler
     */
    endpoints =
    {
      index: {url: '/payment_red/request/', method: 'POST', respParser: defaultParser},
      installments: {url: '/payment_red/installments/', method: 'POST', respParser: defaultParser},
      getPaymentLink: {url: '/payment_red/getPaymentLink/', method: 'POST', respParser: defaultParser},
      transaction: {url: '/payment_red/transaction/', method: 'POST', respParser: defaultParser}
    },

    /**
     * @class UserService
     * @constructor
     */
    PaymentPage = function () {

    };

  PaymentPage.prototype = /** @lends UserService.prototype */
  {

    /**
     * Create Function
     *
     * @param {{}} data
     * @return {Promise}
     */
    index: function (data, getParams) {
      getParams = getParams == undefined ? {} : getParams;

      var tempChange = (JSON.parse(JSON.stringify(endpoints.index)));
      tempChange.url = endpoints.index.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data, getParams);
    },
    /**
     * Transaction
     *
     * @param {{}} data
     * @return {Promise}
     */
    installments: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.installments)));
      tempChange.url = endpoints.installments.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    /**
     * Transaction
     *
     * @param {{}} data
     * @return {Promise}
     */
    transaction: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.transaction)));
      tempChange.url = endpoints.transaction.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    getPaymentLink: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.getPaymentLink)));
      tempChange.url = endpoints.getPaymentLink.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    }
  };

  PaymentPage.prototype.constructor = PaymentPage;

  /**
   * Parse response fro login
   *
   * @param {Object} response
   * @return {Object}
   */
  function defaultParser(response) {
    return response.response;
  }

  return new PaymentPage();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/PopularCitiesSrv.js
angular.module('base')

/**
 * @name        PopularCities
 * @description Class that retrieves results for a popular cities box
 */
.factory('PopularCities',
['$http', '$q','WarmUpSrv',
function PopularCitiesFactory($http, $q,WarmUpSrv) {
// Constructor
  var PopularCities = function () {
    this.httpConfig = {
      url: '/suggestion_area',
      method: 'GET'
    };

    this.cities = {};
    this.citiesC = {};
  };

  // Set instance methods
  PopularCities.prototype = /** @lends TypeAhead.prototype */ {
    /**
     * Set places (city helper)
     *
     * @param  {String}  code   City code
     * @param  {String}  source
     * @param  {String}  ngData
     * @param  {String}  isCountry
     */
    setPopularCities: function (code, source, ngData,isCountry) {

      if (source === 'to') {
        this.httpConfig.params = {source: 'to', code: code, ngData: ngData};
        if(isCountry) {
          this.httpConfig.params.FROM_COUNTRY = code;
        } else {
          this.httpConfig.params.FROM_CITY = code;
        }
      }
      else {
        this.httpConfig.params = {ngData: ngData};
      }

      if(!isCountry){
        isCountry="";
      }
      var cacheKey = ""+code+source+ngData+isCountry;
      var staticCacheData=WarmUpSrv.getByKey('suggestModule'+cacheKey,true);

      if(staticCacheData&&staticCacheData.popular&&staticCacheData.popular.cities){
        var deferred = $q.defer();
        deferred.resolve(_.rest(staticCacheData.popular.cities));
        this.cities[source]= staticCacheData.popular.cities;
        this.citiesC[cacheKey] = this.cities[source] = deferred.promise;
      }

        if(this.citiesC[cacheKey])
        {
          this.cities[source] = this.citiesC[cacheKey];
          return this.cities[source];
        }



      var promise = $http(this.httpConfig).then(function (response) {
        return _.rest(response.data.popular.cities);
      });



      this.citiesC[cacheKey] = this.cities[source] = promise;

      return this.cities[source];
    },

    /**
     * Get places (city helper)
     *
     * @param  {String}  source
     */
    getPopularCities: function (source) {
      return this.cities[source];
    }
  };

  PopularCities.prototype.constructor = PopularCities;

  return new PopularCities();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/Preloader.js
/*global angular: false, _: false */

angular.module('base')

/**
 * @name        Preloader
 * @description Class that preloads templates
 */
.factory('Preloader', ['$http', '$templateCache', '$compile',
function PreloaderFactory($http, $templateCache, $compile) {
/**
   * Preloader constructor
   *
   * @constructor
   */
  var Preloader = function () {};

  Preloader.prototype = /** @lends Preloader.prototype */ {

    /**
     * Loads a list of templates and stores them into the
     * template cache for further referencing
     *
     * @param {Array} templates The array of template URLs
     */
    getTemplates: function (templates) {
      _.each(templates, function (url) {
        $http.get('/mtpl/' + url, {cache: $templateCache, ignoreLoadingBar: true});
      });
    },

    /**
     * Loads a template and stores it into the
     * template cache for further referencing
     *
     * @param  {String}   templateUrl Url of the template
     *
     * @return {HttpPromise} $http promise
     */
    getTemplate: function (templateUrl) {
      if (!angular.isDefined(templateUrl) || templateUrl == '') {
        throw 'Template URL was not specified';
      }

      return $http.get('/mtpl/' + templateUrl, {cache: $templateCache, ignoreLoadingBar: true});
    },

    /**
     * Compiles a template with a scope
     *
     * @param  {String} tplContent The template content to be compiled
     * @param  {Object} compScope  Scope to be compiled in the template
     *
     * @return {String}            The compiled template
     */
    compileTemplate: function (tplContent, compScope) {
      return $compile(tplContent.trim())(compScope);
    }
  };

  Preloader.prototype.constructor = Preloader;

  return new Preloader();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/ProcessedImageService.js
angular.module('base')

/**
 * @name        ProcessedImageService
 * @description
 */
.service('ProcessedImageService',
['appConfig',
function ProcessedImageService(appConfig) {
/**
   * Get image source
   *
   * @param {Picture|String} picture
   * @param {String} filename
   * @param {String} method
   * @param {Number} width
   * @param {Number} height
   *
   * @return {String}
   */
  this.getSrc = function (picture, method, width, height) {
    if (appConfig.isLocal()) {
      return this.getDummySrc(method, width, height);
    }
    else {
      return this.getProcessedSrc(picture, method, width, height);
    }
  };

  /**
   * @param {Picture|String} picture
   * @param {String} method
   * @param {String} width
   * @param {String} height
   *
   * @return {String}
   */
  this.getProcessedSrc = function (picture, method, width, height) {
    if (typeof picture === 'string') {
      return picture;
    }

    var srcParts = [
      null,
      'image_resize',
      method,
      picture.filename,
      width,
      height,
      picture.path.trim().replace(/^\//, '').split('/').join('.')
    ];

    return srcParts.join('/');
  };

  /**
   * Get dummy src picture
   *
   * @param {String} method
   * @param {Number} width
   * @param {Number} height
   *
   * @return {String}
   */
  this.getDummySrc = function (method, width, height) {
    var dummy = {path: 'redesign', filename: 'dummy.png'};
    return this.getProcessedSrc(dummy, method, width, height);
  };
}]);
;

// Source: ../shared/public_html/assets/js/base/services/ReCaptchaSrv.js
angular.module('base')

/**
 * @name base.ReCaptchaSrv
 *
 * @description Example service responsibility description
 */
.factory('ReCaptchaSrv', ['ApiTools','$window',
function ReCaptchaSrvFactory(ApiTools,$window) {
/**
     * @class ReCaptchaSrv
     * @constructor
     */
  var ReCaptchaSrv = function () {};

  ReCaptchaSrv.prototype = /** @lends ReCaptchaSrv.prototype */  {

    load: function () {
      var src           = '//www.google.com/recaptcha/api.js',
          script        = document.createElement('script');
          script.async  = true;

        // Prefix protocol
        if (['file', 'file:'].indexOf($window.location.protocol) !== -1) {
        src = 'https:' + src;
      }

      script.src = src;

      document.getElementsByTagName('head')[0].appendChild(script); // // Fix for IE < 9, and yet supported by lattest browsers
    }

  };

  ReCaptchaSrv.prototype.constructor = ReCaptchaSrv;

  return new ReCaptchaSrv();
}]);



;

// Source: ../shared/public_html/assets/js/base/services/RefundClaim.api.js
(function(angular) {
/**
     * @name        RefundClaimApi
     * @description Service responsible for making API calls to the COVID voucher claim api
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var RefundClaimApi = function ($http) {
        var endpoints = {
            details: '/api/flightCancelHelp/getDetails/',
            save: '/api/flightCancelHelp/save/'
        };

        /**
         * Loads initial voucher data
         * @param   {String}  hash
         * @returns {Promise}
         */
        this.loadInitialData = function (hash) {
            return $http({
                method: 'GET',
                url: endpoints.details + hash
            });
        };

        /**
         * Sends the T&C acceptance to the API
         * @param   {String}  hash
         * @param   {Object}  payload
         * @returns {Promise}
         */
        this.saveData = function (hash, payload) {
            return $http({
                method: 'POST',
                url: endpoints.save + hash,
                data: payload
            });
        };
    };

    RefundClaimApi.$inject = [
        '$http'
    ];

    angular
        .module('base')
        .service('RefundClaimApi', RefundClaimApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/RetryInterceptor.js
/* global angular: false */
(function (angular) {
angular.module('base').provider('RetryInterceptor', provider);

    provider.$inject = ['$httpProvider'];
    function provider($httpProvider) {

        $httpProvider.interceptors.push('RetryInterceptor');

        var defaults = {
            attempts: 3,
            attemptsMade: 0,
            delay: 500,
            until: function (response) {
                return response.status > 0;
            },
            getDelay: function () {
                return this.delay;
            },
        };

        factory.$inject = ['$injector', '$q', '$timeout'];
        function factory($injector, $q, $timeout) {
            return {
                responseError: function (response) {
                    // ignore Errors and non-retryable
                    if (!response || !angular.isObject(response.config) || !response.config.retry) {
                        return $q.reject(response);
                    }
                    var config = response.config;
                    var options = config.retry;
                    if (angular.isNumber(options)) {
                        options = { attempts: options };
                    } else if (!angular.isObject(options)) {
                        options = {};
                    }
                    config.retry = options = angular.merge({}, defaults, options);
                    var attemptsMade = config.retry.attemptsMade = (options.attemptsMade || 0) + 1;
                    if (attemptsMade >= options.attempts || options.until(response)) {
                        return $q.reject(response);
                    }
                    return $timeout(function () {
                        return $injector.get('$http')(config);
                    }, options.getDelay());
                },
            };
        }

        return {
            defaults: defaults,
            $get: factory,
        };
    }

})(angular);
;

// Source: ../shared/public_html/assets/js/base/services/RoutingService.js
angular.module('base')

/**
 * @name RoutingService
 *
 * @description Authorization Service
 */
.factory('RoutingService',
['$location', 'ApiTools', 'appConfig',
function ($location, ApiTools, AppConfig)
{
var

    endpoints = {
          getToken: {url: '/api/changeLanguage/getSessionToken', method: 'POST', respParser: defaultParser}
    },

    allowed_hosts_pattern = '^[a-z]+\.flyhacks\..*',

    lang_domain_map = {
      en: 'com'
    },

    /**
     * Auth service
     *
     * @constructor
     */
    RoutingService = function () {};

  RoutingService.prototype = /** @lends AuthService.prototype */
  {
    /**
     * getToken
     * @returns {Promise}
     */
    getToken: function ()
    {
      return ApiTools.fetch(this, endpoints.getToken, {});
    },

    /**
     * @returns {string}
     */
    getHostname: function ()
    {
      return window.location.hostname;
    },

    /**
     * @returns {string}
     */
    getProtocol: function ()
    {
      return window.location.protocol;
    },

    /**
     * @returns {boolean}
     */
    isDomainRedirectAllowed: function ()
    {
      var regex = new RegExp(allowed_hosts_pattern);

      return !!this.getHostname().match(regex);
    },

    /**
     *
     * @param defaultLang
     * @returns {boolean}
     */
    isDomainRedirectNecessary: function (defaultLang)
    {
      if (!this.isDomainRedirectAllowed()) return false;

      return defaultLang !== AppConfig.getUserLanguage();
    },


    /**
     * Return true if url has https:// or http://
     * @param url
     * @returns {boolean}
     */
    isHttpUrl: function (url)
    {
      return !!url.match(/^(http|https):\/\//);
    },

    /**
     * Remove http & domain from URL
     * @param url
     * @returns {string}
     */
    removeDomain: function (url)
    {
      return ('/' + url.replace(/^https?:\/\/[a-z\.]+\//, '')).replace(/\/\//, '/');
    },

    /**
     *
     * @param domain
     * @returns {string}
     */
    removeTLD: function (domain)
    {
      var tld1 = ['.com', '.co', '.org'];
      var regex = new RegExp('([a-z0-9\\-_]*\\.?)([a-z0-9\\-_]{5,30})(\\' + tld1.join('|\\') +')?\\.([a-z]+)');

      return domain.replace(regex, '$1$2');
    },

    /**
     *
     * @param url
     * @param token
     * @returns {string}
     */
    createTokenUrl: function (url, lang, token)
    {
      var domain,
        _url;

      _url = this.removeDomain(url);
      _url += ( _url.indexOf('?') === -1 )? '?token=' : '&token=';

      domain = this.getProtocol() + '//' + this.removeTLD(this.getHostname());
      domain += '.' + lang_domain_map[lang];

      return domain + _url + token;
    },

    /**
     *
     * @param url
     * @param lang
     * @param isHardRedirect
     */
    doRedirect: function (url, lang, isHardRedirect)
    {
      var self = this;
      if (this.isDomainRedirectNecessary(lang))
      {
        this.getToken().then(function (response)
        {
          window.location = self.createTokenUrl(url, lang, response.token);
        });
      } else if (isHardRedirect || this.isHttpUrl(url))
      {
        window.location = url;
      }
      else
      {
        $location.url(url);
      }
    },

    /**
     * Remove UTM params form the current URL
     *
     * Params are identified by prefix 'utm_'.
     * This operation does not reload the state.
     */
    removeUtmParams: function () {
      var searchParams = $location.search();
      var filteredSearchParams = _.omit(searchParams, function (value, key) {
        return key.substr(0, 4) === 'utm_';
      });
      $location.search(filteredSearchParams);
    }

  };

  RoutingService.prototype.constructor = RoutingService;

  /**
   * Parse response
   *
   * @param {Object} response
   * @return {Object}
   */
  function defaultParser(response)
  {
    return response.response;
  }

  return new RoutingService();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/SalesManagoSrv.js
angular.module('base')

/**
 * @name SalesManagoSrv Service
 *
 * @description SalesManagoSrv service responsibility description
 */
.factory('SalesManagoSrv', ['ApiTools',
function SalesManagoSrvFactory(ApiTools) {
var
    /**
     * @class SalesManagoSrv
     * @constructor
     */
    SalesManagoSrv = function () {};

  /**
   * @lends SalesManagoSrv.prototype
   */
  SalesManagoSrv.prototype =
  {
    load: function (clientid) {
      window._smid = "vzdjlylp29nid5og";
      window._smclientid = clientid;
    }
  };

  SalesManagoSrv.prototype.constructor = SalesManagoSrv;

  return new SalesManagoSrv();
}]);




;

// Source: ../shared/public_html/assets/js/base/services/ScrollToElement.js
angular.module('base')

  /**
   * @name        ScrollToElement
   * @description
   */
  .factory('ScrollToElement', ['$document', function ScrollToElementFactory($document) {
this.scrollTo = function (id, offset) {
      var element = $document[0].getElementById(id);
      
      if (element !== null) {
        $document.scrollToElementAnimated(angular.element(element), offset);
      }
    };

    return this;
  }])

  .directive('scrollToEl', ['ScrollToElement', '$document', function (ScrollToElement, $document) {
return {
      restrict: "A",
      link: function (scope, el, attrs) {
        el.bind('click', function () {
          if ($document[0].querySelectorAll('#' + attrs.scrollTarget).length != 0) {
            ScrollToElement.scrollTo(attrs.scrollTarget, attrs.scrollOffset);
          }
        });
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/base/services/StackTrace.js
/*global angular: false, printStackTrace: false */

angular.module('base')

/**
 * @name        StackTrace
 * @description
 */
.factory('StackTrace',
[
function StackTraceFactory() {
// "printStackTrace" is a global object.
  return {
    print: printStackTrace
  };
}]);

;

// Source: ../shared/public_html/assets/js/base/services/StaticPageHelper.js
(function (angular) {

    angular.module('base').service('StaticPageHelper', function () {
        this.staticStates = [
            'homepage',
            'ngStaticPageShow',
            'landingPages',
            'lpNoParams'
        ];

        this.isStaticPage = function (stateName) {
            if (stateName === '') {
                return false;
            }

            var found = false;

            angular.forEach(this.staticStates, function (entry) {
                if (entry === stateName || stateName.includes(entry)) {
                    found = true;
                }
            });

            return found;
        };

        this.isHomepage = function (stateName) {
            if (stateName === '') {
                return false;
            }

            return stateName.includes('homepage');
        };
    });

})(angular);
;

// Source: ../shared/public_html/assets/js/base/services/TemplateHelperSrv.js
angular.module('base')

/**
 * @name base.TextBox
 *
 * @description Example service responsibility description
 */
.factory('TemplateHelperSrv', ['ApiTools', '$templateRequest', '$compile', '$q',
function TemplateHelperFactor(ApiTools, $templateRequest, $compile, $q) {
var
    /**
     * @class TemplateHelperFactor
     * @constructor
     */
    TemplateHelperFactor = function () {
      return this;
    };

  TemplateHelperFactor.prototype = /** @lends TextBoxFactory.prototype */
  {
    getTemplatePromise: function (templateUrl) {
      return $templateRequest(angular.isFunction(templateUrl) ? (templateUrl)() : templateUrl);
    },
    renderWithTemplate: function (options) {

      if (!options.templateUrl || !options.scope || options.phpInit == true) {
        return false;
      }

      var promise = $q.all([this.getTemplatePromise(options.templateUrl)]);

      promise.then(function (tpl) {
        //append to element, and set scope
        tpl = $compile(tpl[0])(options.scope);

        var el = angular.element(options.element);
        el.ready(function () {
          el.empty();
          el.append(tpl);

          if (angular.isFunction(options.callback))
          {
            options.callback();
          }
        });
      });

      return true;
    },

    run: function (options) {
      var defaultOptions = {
        phpInit: false,
        templateUrl: false,
        waitForParent: true,
        callback: null
      };

      options = angular.extend(defaultOptions, options);

      if (!this.renderWithTemplate(options)) {
        var el = angular.element(options.element);
        options.transcludeFn(options.scope, function (clone) {
          el.append(clone);

          if (angular.isFunction(options.callback))
          {
            options.callback();
          }
        });
      }
    }
  };

  TemplateHelperFactor.prototype.constructor = TemplateHelperFactor;

  return new TemplateHelperFactor();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/TermsAndConditions.service.js
(function (angular) {
var TermsAndConditionsService = function ($modal) {

        this.proposeToAccept = function () {
            return $modal.open({
                templateUrl: 'termsAndConditionsModal.html',
                controller: 'AcceptTermsAndConditions',
                controllerAs: '$ctrl',
                size: 'md',
                backdrop: 'static'
            });
        };

        this.shouldHideModal = function () {
            var pathsWhereModalIsHidden = [
                '/terms',
                '/regulamin',
                '/regulaminy',
                '/uslovia',
                '/terms-of-use',
                '/termeni-si-conditii-generale',
                '/terms-and-conditions'
            ];
            var currentPath = window.location.pathname;

            return pathsWhereModalIsHidden.some(function (path) {
                return currentPath === path;
            });
        };
    };

    TermsAndConditionsService.$inject = [
        '$modal'
    ];

    angular
        .module('base')
        .service('TermsAndConditionsService', TermsAndConditionsService);
}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/TextBoxSrv.js
angular.module('base')

/**
 * @name base.TextBox
 *
 * @description Example service responsibility description
 */
.factory('TextBox', ['appConfig', 'ApiTools',
function TextBoxFactory(appConfig, ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Example endpoint
      textBox: {url: appConfig.getUriPrefix() + '/api/textBox/getTextBox', method: 'GET', respParser: textParser},
      textBoxByName: {url: appConfig.getUriPrefix() + '/api/textBox/getByName', method: 'GET', respParser: textParser}
    },

    /**
     * @class TextBoxFactory
     * @constructor
     */
    TextBoxFactory = function () {
    };

  TextBoxFactory.prototype = /** @lends TextBoxFactory.prototype */  {

    /**
     * Example method on the service
     *
     * @param {int} id Text Box id
     * @return {Promise}
     */
    getTextBox: function (id) {
      var endpoint = angular.copy(endpoints.textBox);
      endpoint.url += '/' + id;

      return ApiTools.fetch(this, endpoint);
    },

    /**
     * Get the text box by name
     *
     * @param {string} name Text Box name
     * @return {Promise}
     */
    getByName: function (name) {
      var endpoint = angular.copy(endpoints.textBoxByName);
      endpoint.url += '/' + name;

      return ApiTools.fetch(this, endpoint);
    }
  };

  TextBoxFactory.prototype.constructor = TextBoxFactory;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {myModule.Example}
   */
  function textParser(response) {
    return response.response;
  }

  return new TextBoxFactory();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/Tools.js
(function (angular, underscore) {
/**
   * @name        BaseToolsFactory
   * @description A service that provides methods for communicating with the server through JSON APIs
   * @constructor
   * @author Floares Bogdan <bogdan.floares@vola.ro>
   */
  var BaseToolsFactory = function () {
    var
      /**
       * Tools constructor
       *
       * @constructor
       */
      Tools = function () {
        this.today = moment();
      };

    Tools.prototype = /** @lends Tools.prototype */ {

      validateFlightDetailsParams: function(urlParams) {
        if(!urlParams[0] || !urlParams[1])
        {
          throw 'urlParams invalid: ' + JSON.stringify(urlParams);
        }
      },

      /**
       * Returns URL to connection selection page
       *
       * @param  {String} requestId
       * @param  {String} base64PgId
       *
       * @return {String}
       */
      selectConnectionUrl: function (requestId, base64PgId) {
        return '/selectConnection/get/' + requestId + '/' + base64PgId;
      },

      /**
       * Returns true if regular flight
       *
       * @param  {String} flightType
       *
       * @return {Boolean}
       */
      isRegularFlight: function (flightType) {
        return flightType == 'REGULAR';
      },

      /**
       * Returns true if sum of one ways
       *
       * @param  {String} flightType
       *
       * @return {Boolean}
       */
      isSoowFlight: function (flightType) {
        return flightType == 'MIXED';
      },

      /**
       * Returns true if hub
       *
       * @param  {String} flightType
       *
       * @return {Boolean}
       */
      isHubFlight: function (flightType) {
        return flightType == 'HUB';
      },

      /**
       * Returns true if Chareter flight
       *
       * @param  {String} flightType
       *
       * @return {Boolean}
       */
      isCharter: function (flightType) {
        return flightType == 'CHARTER';
      },

      /**
       * Returns true if flight is low cost
       *
       * @param  {String} flightType
       *
       * @return {Boolean}
       */
      isLowCost: function (flightType) {
        return flightType == 'LOWCOST' || this.isSoowFlight(flightType);
      },

      getObfuscatedValue : function (value) {
        if (!value) {
          return value;
        }

        var character = '*';
        var length = value.length;

        if (length <= 3) {
          return character.repeat(3);
        }

        return value.substring(0, 1) + character.repeat(length - 3) + value.slice(-2);
      },

      /**
       * Divides array in chunks for bootstrap columns
       *
       * @param {Array}  arr  Array of objects
       * @param {Number} size Number of columns
       * @returns {Array} Array of chunks
       */
      chunk: function (arr, size) {
        var n = Math.ceil(arr.length / size);

        return underscore.chain(arr).groupBy(function (element, index) {
          return Math.floor(index / n);
        }).toArray().value();
      },

      /**
       * Translates the customer type number coming from backend to pax type string.
       * TODO: this needs backend refactoring (backend should return string ADT, CHD, etc) instead of 1,2,3.
       *
       * @param   {Number} paxTypeNumber
       * @returns {String} Pax type in string format
       */
      customerPaxTypeTranslation: function (paxTypeNumber) {
        switch (paxTypeNumber) {
          case 1: return 'ADT';
          case 2: return 'CHD';
          case 3: return 'ADT'; // Was senior (SRC)
          case 4: return 'YTH';
          default: return 'ADT';
        }
      }
    };

    Tools.prototype.constructor = Tools;

    return new Tools();
  };

  angular.module('base')
    .factory('Tools', BaseToolsFactory);
})(angular, _);
;

// Source: ../shared/public_html/assets/js/base/services/Tracker.js
/* global _: false */

angular.module('base')

/**
 * @name        Tracker
 * @description
 */
.factory('Tracker',
['$cookies',
function TrackerFactory($cookies) {
/**
   * The Phoenix tracker
   *
   * @class Tracker
   * @constructor
   */
  var Tracker = function () {};

  function setCookie(name, value, expires, path, domain, secure) {
    document.cookie = name + "=" + _.escape(value) +
      ((expires) ? "; expires=" + expires.toGMTString() : "") +
      ("; path=/") +
      ((domain) ? "; domain=" + domain : "") +
      ((secure) ? "; secure" : "");
  }

  Tracker.prototype = /** @lends Tracker.prototype */  {

    /**
     * Example method on the service
     *
     * @param {bool} flag The true / false flag
     */
    setSetUserAsPhoenixTester: function (flag) {
      var future = new Date();
      // Add two weeks
      future.setDate(future.getDate() + 14);

      flag = flag ? 'true' : 'false';
      setCookie('_PhoenixTracker', flag, future, '/');
    },

    /**
     * Returns true if user is set as Phoenix tracker
     *
     * @return {Boolean}
     */
    isPhoenixTester: function () {
      var flag = $cookies._PhoenixTracker === undefined ? 'false' : $cookies._PhoenixTracker;
      return flag === 'true';
    }
  };

  Tracker.prototype.constructor = Tracker;

  return new Tracker();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/TranslationCollectionService.js
(function (angular, _) {
var TranslationCollectionService = function (AppConfig, $translate, AnalyticsServiceApi) {
        var DEBOUNCE_DELAY_MS = 3000;
        var sent = [];

        var getIdsToSend = function () {
            var translated = $translate.getTranslationIdsList();

            return translated.filter(function (id) {
                return id !== (
                    sent.find(function (sentId) {
                        return sentId === id;
                    })
                );
            });
        };

        /**
         * @param {string[]} toSend
         */
        var updateSent = function (toSend) {
            sent = sent.concat(toSend);
        };

        var sendIds = _.debounce(function () {
            var toSend = getIdsToSend();

            if (toSend.length) {
                AnalyticsServiceApi.sendTranslationIdsList(toSend);
                updateSent(toSend);
            }
        }, DEBOUNCE_DELAY_MS);

        this.sendCollectedTranslationIds = function () {
            sendIds();
        };

        this.resetSentTranslationIdsList = function () {
            sent = [];
        };
    };

    TranslationCollectionService.$inject = [
        'appConfig',
        '$translate',
        'AnalyticsServiceApi'
    ];

    angular
        .module('base')
        .service('TranslationCollectionService', TranslationCollectionService);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/base/services/UploaderSrv.js
angular.module('base')

/**
 * @name base.UploaderSrv
 *
 * @description Example service responsibility description
 */
.factory('UploaderSrv', ['ApiTools','$http','$q',
function UploaderSrvFactory(ApiTools,$http,$q) {
var
    endpoints = {
      // Send Contact Form
      removeFile: {url: '/api/uploads/remove', method: 'POST', respParser: responseParser},
      showBasket: {url: '/api/uploads/showBasket', method: 'POST', respParser: responseParser}
    },
    /**
     * @class UploaderSrv
     * @constructor
     */
    UploaderSrv = function () {};

  UploaderSrv.prototype = /** @lends UploaderSrv.prototype */  {

    /**
     * send contact form data
     *
     * @param {Object} formData
     * @return {Promise}
     */
    uploadFile: function (file, uploadUrl)
    {
      var fd = new FormData();
      fd.append('file', file);

      return $http.post(uploadUrl, fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      }).then(function(response) {
        return $q.resolve(response.data.response);
      },function (response){
        return $q.reject(response.data.response);
      });
    },

    showBasket: function()
    {
      return ApiTools.fetch(this, endpoints.showBasket, {});
    },

    removeFile: function(formData){
      return ApiTools.fetch(this, endpoints.removeFile, formData);
    }

  };

  UploaderSrv.prototype.constructor = UploaderSrv;

  function responseParser(response) {
    return response.response;

  }

  return new UploaderSrv();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/Uri.js
angular.module('base')

/**
 * @name base.Uri
 *
 * @description Uri service
 */
.factory('Uri',
['ApiTools','$location',
function UriFactory(ApiTools, $location) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {},

    /**
     * @class UriFactory
     * @constructor
     */
    UriFactory = function () {};

  UriFactory.prototype = /** @lends UriFactory.prototype */  {

    /**
     * Get translated uri
     *
     * @param {String} uri
     *
     * @return {String}
     */
    translate: function (uri) {
      return uri;
    },

    /**
     * Get URI segment by index
     *
     * @param {Integer} index
     *
     * @return {String} | bool
     */
    getSegment: function(index)
    {
      // Protocol
      var protocol = $location.protocol();

      // Host name
      var host = $location.host();

      // Get URI and remove the domain base url
      var query = $location.absUrl().replace(protocol + '://' + host+'/',"");

      // Convert To obj
      var data = query.split("/");

      // Return segment
      if(data[index]) {
        return data[index];
      }
      return false;
    }
  };

  UriFactory.prototype.constructor = UriFactory;

  return new UriFactory();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/ValidationUtils.js
/*global angular: false */

angular.module('base')

/**
 * @name        ValidationUtils
 * @description A service that provides methods for communicating with the server through JSON APIs
 */
.factory('ValidationUtils',
[
function () {
var
    /**
     * ValidationUtils constructor
     *
     * @constructor
     */
    ValidationUtils = function () {
    };

  var currentYear = "" + new Date().getFullYear();
  var yearDecimal = currentYear.substring(2, 4);
  var yd1 = parseInt(yearDecimal[0]), yd2 = parseInt(yearDecimal[1]);
  var nextDecade = yd1 + 1 < 4 ? yd1 + 1 : 4;

  ValidationUtils.prototype = /** @lends ValidationUtils.prototype */ {
    /**
     * Default validation class
     *
     * @param formName {string}
     * @param fieldName {string}
     * @returns {*}
     */
    getValidationClass: function (formName, fieldName) {
      try {
        return {
          "has-error": "(" + formName + "." + fieldName + ".$invalid && " + formName + "." + fieldName + ".$dirty) || (" + formName + "." + fieldName + ".$invalid && " + formName + ".$submitted) || " + formName + "." + fieldName + ".$error.backend",
          //"has-success": formName + "." + fieldName + ".wasInvalid && (" + formName + "." + fieldName + ".$dirty && " + formName + "." + fieldName + ".$valid)"
          "has-success": formName + "." + fieldName + " && (!!" + formName + "." + fieldName + ".$viewValue != '' && " + formName + "." + fieldName + ".$valid)"
        };
      }
      catch (e) {
        return "";
      }
    },

    /**
     * date validation class
     *
     * @param form
     * @param identifier {string} i.e. 'birth'
     * @returns {*}
     */
    getDateValidationClass: function (form, identifier) {
      try {
        //console.log(form[identifier + "Date"].$invalid, form[identifier + "Month"].$invalid, form[identifier + "Year"].$invalid , form[identifier + "Date"].$dirty, form[identifier + "Month"].$dirty, form[identifier + "Year"].$dirty, form.$submitted, form[identifier + "Date"].$error);
        var obj =  {
          'has-error': ((form[identifier + "Date"].$invalid || form[identifier + "Month"].$invalid || form[identifier + "Year"].$invalid) && (form[identifier + "Date"].$dirty && form[identifier + "Month"].$dirty && form[identifier + "Year"].$dirty)) || ( form[identifier + "Date"].$invalid && form.$submitted) || (form[identifier + "Month"].$invalid && form.$submitted) || (form[identifier + "Year"].$invalid && form.$submitted) || form[identifier + "Date"].$error.backend,
          //'has-error': (form.$submitted && (!form[identifier + "Date"].$viewValue || !form[identifier + "Month"].$viewValue || !form[identifier + "Year"].$viewValue)) || ((form[identifier + "Date"].$invalid || form[identifier + "Month"].$invalid || form[identifier + "Year"].$invalid) && (form[identifier + "Date"].$dirty && form[identifier + "Month"].$dirty && form[identifier + "Year"].$dirty)) || ( form[identifier + "Date"].$invalid && form.$submitted) || (form[identifier + "Month"].$invalid && form.$submitted) || (form[identifier + "Year"].$invalid && form.$submitted) || form[identifier + "Date"].$error.backend,
          'has-success': (form[identifier + "Date"] || form[identifier + "Month"] || form[identifier + "Year"]) && ( form[identifier + "Date"].$valid && form[identifier + "Month"].$valid && form[identifier + "Year"].$valid)
          //'has-success': (form[identifier + "Date"].wasInvalid || form[identifier + "Month"].wasInvalid || form[identifier + "Year"].wasInvalid) && ( form[identifier + "Date"].$valid && form[identifier + "Month"].$valid && form[identifier + "Year"].$valid)
        };
        //console.log(obj);
        return obj;
      }
      catch (e) {
        return "";
      }
    },
    /**
     * date validation class
     *
     * @param form
     * @param identifier {string} i.e. 'birth'
     * @returns {*}
     */
    getSimpleDateValidationClass: function (form, identifier) {
      try {
        var obj =  {
          'has-error': ((form[identifier].$invalid || form[identifier + "Month"].$invalid || form[identifier + "Year"].$invalid) && (form[identifier].$dirty && form[identifier + "Month"].$dirty && form[identifier + "Year"].$dirty)) || ( form[identifier].$invalid && form.$submitted) || (form[identifier + "Month"].$invalid && form.$submitted) || (form[identifier + "Year"].$invalid && form.$submitted) || form[identifier].$error.backend,
          'has-success': (form[identifier] || form[identifier + "Month"] || form[identifier + "Year"]) && ( form[identifier].$valid && form[identifier + "Month"].$valid && form[identifier + "Year"].$valid)
        };
        //console.log(obj);
        return obj;
      }
      catch (e) {
        return "";
      }
    },
    /**
     * Strict expiration regex
     * @returns {RegExp}
     */
    getStrictExpirationRegex: function(){
      return new RegExp("^(0[1-9]|1[0-2])\/?(" + yd1 + "[" + yd2 + "-9]|[" + nextDecade + "-4][0-9]|50)$");
    },

    /**
     * Flexible expiration regex
     * @returns {RegExp}
     */
    getExpirationRegex: function(){
      return new RegExp("^(?:0[1-9]|1[0-2])\\/?([0-5]?|" + yd1 + "[" + yd2 + "-9]?|[" + nextDecade + "-4][0-9]?|50?)?$");
    }

  };

  ValidationUtils.prototype.constructor = ValidationUtils;

  return new ValidationUtils();
}]);
;

// Source: ../shared/public_html/assets/js/base/services/WarmUpSrv.js
/* global: _warm_up_data_: true */

angular.module('base')

/**
 * @name base.WarmUpSrv
 *
 * @description Example service responsibility description
 */
.factory('WarmUpSrv',
[
function WarmUpSrvFactory() {
/**
   * Warm up JSON data
   *
   * @type {*}
   */
  var data = window._warm_up_data_ || {};

  // We do not need it there
  window._warm_up_data_ = {};

  /**
   * WarmUpSrv
   *
   * @constructor
   */
  var WarmUpSrv = function () {

  };

  WarmUpSrv.prototype = /** @lends WarmUpSrv.prototype */ {

    /**
     * Clear JSON cache key
     *
     * @param {String} keyName
     */
    clearKey: function (keyName) {
      data[keyName] = null;

      return this;
    },

    /**
     * Get warm up data by key
     *
     * @param {String} keyName           The cache key to get
     * @param {bool}   [clearKey=false]  If st to true it will remove found JSON data
     *
     * @return mixed
     */
    getByKey: function (keyName, clearKey) {
      clearKey = clearKey || false;

      var ret = data[keyName];

      if (ret === undefined) return undefined;
      if (clearKey) this.clearKey(keyName);

      return ret;
    }

  };

  WarmUpSrv.prototype.constructor = WarmUpSrv;

  return new WarmUpSrv();
}]);

;

// Source: ../shared/public_html/assets/js/base/services/liveChatServ.js
angular.module('base')

    .service('liveChatServ', ['$localStorage', function ($localStorage) {
        this.status = false;
        this.showChatCount = 5;
        /**
         * Enable Live chat module
         * @returns void
         */
        this.enable = function () {
            this.status = true;
        }

        /**
         * Disable Live chat module
         * @returns void
         */
        this.disable = function () {
            this.status = false;
        }

        /**
         * Disable Live chat module
         * @returns void
         */
        this.update = function (status) {
            this.status = status;
        }

        /**
         * Get Status of the Live Chat module
         * @returns {*}
         */
        this.getStatus = function () {
            return this.status;
        }

        /**
         * Check if Live Chat
         * @param page
         */
        this.checkPage = function (page) {
            if (page == 'ngStaticPageShow') {
                return;
            }

            var config = false;
            if (_js_app_config_.liveChat) {
                config = _js_app_config_.liveChat
            }

            var set = false;
            try{
                if (config.live && config.live.all === "1") {
                    // Enable Live chat on Every page
                    set = true;
                } else if ($localStorage.userSearchCount && $localStorage.userSearchCountExpire && $localStorage.userSearchCount  >= this.showChatCount) {

                    var currentTime = moment().unix();
                    if(currentTime > $localStorage.userSearchCountExpire){
                        $localStorage.userSearchCountExpire = 0;
                        $localStorage.userSearchCount = 0;
                    }

                    if($localStorage.userSearchCount >= this.showChatCount){
                        set = true;
                    }

                }
                else {

                    if (config.live) {
                        // Merge all object into one
                        var merge = {};

                        if (config.live.flights) {
                            merge = _.extend(merge, config.live.flights);
                        }

                        if (config.live.hotels) {
                            merge = _.extend(merge, config.live.hotels);
                        }

                        if (config.live.insurances) {
                            merge = _.extend(merge, config.live.insurances);
                        }

                        if (config.live.packages) {
                            merge = _.extend(merge, config.live.packages);

                        }

                        // Check if we can show livechat
                        if (!_.isEmpty(merge) && _.has(merge, page)) {
                            set = true;
                        }
                    }
                }
            }catch (e){
            }
            // Set value
            this.update(set);
        }

        return this;

    }]);;

// Source: ../shared/public_html/assets/js/base/services/location-translator.service.js
(function (angular) {

    var service = function (SouthParkFlightCache, SouthParkApi, IataDictionary, AppConfig, $q) {
        this.iataDictionary = new IataDictionary();
        this.isPopulated = false;
        this.deferred = $q.defer();

        this.load = function () {
            var self = this;

            SouthParkFlightCache
                .getDictionary()
                .then(function (dictionaryCache) {
                    if (dictionaryCache !== null) {
                        self.iataDictionary.populate(dictionaryCache.data);
                        self.isPopulated = true;
                        self.deferred.resolve();
                        return;
                    }

                    SouthParkApi
                        .getIataDictionary(AppConfig.getAffiliateName(), AppConfig.getLanguageCode())
                        .then(function (success) {
                            SouthParkFlightCache.addDictionary(success.data);
                            self.iataDictionary.populate(success.data);
                            self.isPopulated = true;
                            self.deferred.resolve();
                        })
                        .catch(function (error) {
                            self.deferred.reject(error);
                        });
                })
                .catch(function (error) {
                    self.deferred.reject(error);
                });
        };
    };

    service.$inject = ['SouthParkFlightCache', 'SouthParkApi', 'IataDictionary', 'appConfig', '$q'];

    angular.module('base').service('LocationTranslator', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/modal-helper.service.js
(function(angular) {
/**
     * Service that handles common functionalities related to modals
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var ModalHelperService = function ($document, $window) {
        /**
         * Amount of scroll top
         *
         * @type {Number}
         */
        this.scrollTop = 0;

        /**
         * Class added to body when modal is open
         *
         * @type {String}
         */
        this.modalOpenClass = 'modal-visible';

        /**
         * Locks body scroll when a modal is opened
         */
        this.lockBodyScroll = function () {
            this.scrollTop = $window.pageYOffset;
            getBody().style.top = -this.scrollTop + 'px';
            getBody().classList.add(this.modalOpenClass);
        };

        /**
         * Unlocks body scroll when a modal is closed
         */
        this.unlockBodyScroll = function () {
            getBody().style.top = '';
            getBody().classList.remove(this.modalOpenClass);
            $window.scrollTo(0, this.scrollTop);
        };

        /**
         * Returns the body dom element
         *
         * @returns {Object}
         */
        var getBody = function () {
            return $document[0].querySelector('body');
        };
    };

    ModalHelperService.$inject = [
        '$document',
        '$window'
    ];

    angular
        .module('base')
        .service('ModalHelper', ModalHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/overflow-smooth-scroll.directive.js
(function(angular) {
/**
     * Smooth scroll directive that scrolls inside of overflow <auto|scroll> elements.
     * 
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var OverflowSmoothScrollDirective = function (OverflowSmoothScroll) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                element.on('click', function () {
                    OverflowSmoothScroll.scroll(attributes.target, attributes.container, attributes.offset);
                });
            }
        };
    };

    OverflowSmoothScrollDirective.$inject = [
        'OverflowSmoothScroll'
    ];

    angular
        .module('base')
        .directive('overflowSmoothScroll', OverflowSmoothScrollDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/overflow-smooth-scroll.service.js
(function(angular) {
/**
     * Smooth scroll service that scrolls inside of overflow <auto|scroll> elements.
     * 
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var OverflowSmoothScrollService = function ($document, $window) {
        /**
         * Smoothly scrolls an overflow scroll|auto element vertically.
         * 
         * @param {DOMElement} el               Scrolling element
         * @param {Number}     from             From position
         * @param {Number}     to               To position
         * @param {Number}     duration         Duration of smooth scroll animation
         * @param {Number}     [currentTime=0]  Currently elapsed time
         */
        function scrollTo(el, from, to, duration, currentTime) {
            if (from <= 0) from = 0;
            if (to <= 0) to = 0;
            if (currentTime >= duration) return;

            var delta = to - from;
            var progress = currentTime / duration * Math.PI / 2;
            var position = delta * (Math.sin(progress));

            $window.requestAnimationFrame(function () {
                el.scrollTop = from + position;
                scrollTo(el, from, to, duration, currentTime + 10);
            });
        }

        /**
         * Smooth scolls to target element.
         * 
         * @param {String} targetElement    CSS selector for element where we want to scroll
         * @param {String} scrollContainer  CSS selector for the scrolling container (must have overflow scroll or auto)
         * @param {Number} [scrollOffset=0] Offset scroll position by this amount of pixels (to compensate for sticky elements as navbar)
         */
        function initScroll(targetElement, scrollContainer, scrollOffset) {
            scrollOffset = (scrollOffset == null || isNaN(scrollOffset)) ? 0 : parseInt(scrollOffset);

            var domTargetElement = $document[0].querySelector(targetElement);
            var scroller = $document[0].querySelector(scrollContainer);

            if (domTargetElement === null || scroller === null) {
                return;
            }

            var targetTopPosition = $document[0].querySelector(targetElement).getBoundingClientRect().top;
            scrollTo(scroller, scroller.scrollTop, targetTopPosition + scroller.scrollTop - scrollOffset, 500, 0);
        }

        return {
            scroll: initScroll
        };
    };

    OverflowSmoothScrollService.$inject = [
        '$document',
        '$window'
    ];

    angular
        .module('base')
        .service('OverflowSmoothScroll', OverflowSmoothScrollService);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/searchform-location.service.js
(function(angular) {
/**
   * @name SearchFormLocationService
   * @description Location service for search form.
   * @constructor
   * @author Michal Czudowski <michal.czudowski@fru.pl>
   */
  var SearchFormLocationService = function($location) {

    /**
     * Checks if part of an url is matching the current path.
     *
     * @param  {string}  $url The string to test for
     * @return {Boolean}
     */
    this.isUrlMatch = function($url) {
      var path = $location.path();
      if (!angular.isString($url)) return false;
      if ($url.length == 0 || $url[0] != '/') $url = '/' + $url;
      var regex = new RegExp('^' + $url + '.*');
      return !!path.match(regex);
    };

    /**
     * Checks if current path is homepage.
     *
     * @return {Boolean}
     */
    this.isHomePage = function() {
      return $location.path() == '/';
    };
    
    /**
     * Redirect location to a given url.
     * 
     * @param {string} $url
     * @returns {Boolean}
     */
    this.redirect = function($url) {
      if (!this.isUrlMatch($url) && this.isHomePage()) {
        $location.url('/' + $url);
        return true;
      }
      return false;
    }
  };

  SearchFormLocationService.$inject = [
    '$location'
  ];

  angular.module('base').service('SearchFormLocationService', SearchFormLocationService);
})(angular);
;

// Source: ../shared/public_html/assets/js/base/services/transliterate.service.js
(function (angular) {

    var transliterationConfig = {
        // Bulgarian lowercase
        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'e',
        'ж': 'j',
        'з': 'z',
        'и': 'i',
        'й': 'i',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'h',
        'ц': 'ts',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sht',
        'ъ': 'ie',
        'ы': 'y',
        'ь': '',
        'э': 'e',
        'ю': 'iu',
        'я': 'ia',

        // Bulgarian uppercase
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'E',
        'Ж': 'J',
        'З': 'Z',
        'И': 'I',
        'Й': 'I',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'H',
        'Ц': 'TS',
        'Ч': 'CH',
        'Ш': 'SH',
        'Щ': 'SHT',
        'Ъ': 'IE',
        'Ы': 'Y',
        'Ь': '',
        'Э': 'E',
        'Ю': 'IU',
        'Я': 'IA',
    };

    angular.module('base').service('LatinText', function () {
        this.keys = Object.keys(transliterationConfig);
        this.values = Object.values(transliterationConfig);

        this.transliterate = function (text) {
            for (var i = 0; i < this.keys.length; i++) {
                text = text.split(this.keys[i]).join(this.values[i]);
            }

            return text;
        };
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/uuid.service.js
(function(angular) {
angular.module('base').service('UUID', function () {
        this.v4 = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/services/wgslider.service.js
(function(angular) {
/**
   * @name WgSliderService
   * @description Service for jumbotron.
   * @constructor
   * @author Piotr Slosarz <piotr.slosarz@fru.pl>
   */
  var WgSliderService = function($timeout) {
    
    /**
     * Lexical scope handler.
     *
     * @type {WgSliderService}
     */
    var wgSliderService = this;

    /**
     * Collect slides elements from DOM tree.
     *
     * @param {Object} element
     * @returns {Array}
     */
    this.collectSlidesFromDOM = function (element)
    {
      var elements = element[0].querySelectorAll('[wg-slide]');
      var slides = [];

      for (var i = 0, length = elements.length; i < length; i++)
      {
        var nr = elements[i].getAttribute('wg-slide') - 1;

        if (angular.isArray(slides[nr])) {
          slides[nr].push(elements[i]);
        } else {
          slides[nr] = [elements[i]];
        }
      }
      return slides;
    };

    /**
     * Collect params elements from DOM tree.
     *
     * @param {Object} element
     * @returns {Array}
     */
    this.collectParamsFromDOM = function (element) {
      var elements = element[0].querySelectorAll('[wg-slide-params]');
      var params = [];

      for (var i = 0, length = elements.length; i < length; i++) {
        var nr = elements[i].getAttribute('wg-slide-params').replace(/'/g, '"');
        var object = JSON.parse(nr);
        object.element = elements[i];
        params.push(object);
      }

      return params;
    };

    /**
     * Collect preloader.
     *
     * @param {Object} element
     */
    this.collectPreLoader = function (element) {
      var _th = this;
      _th.loadImages = [];

      _th.loadImage = function (path,timeout) {
        $timeout(function () {
          var img = new Image();
          img.src = path;
          _th.loadImages.push(img)
        },timeout);
      };

      var elements = element[0].querySelectorAll('[wg-slide-preloader]');
      for (var i = 0, length = elements.length; i < length; i++) {
        var nr = elements[i].getAttribute('wg-slide-preloader');
        if (angular.isString(nr)) {
          var imageArray = nr.split(',');
          for (var j = 0; j < imageArray.length; j++){
            _th.loadImage(imageArray[j],2000);
          }
        }
      }
    };


    /**
     * Get slide parent by element.
     *
     * @param {Object} slideElement
     * @param {Object} parentNode
     * @returns {HTMLElement}
     */
    this.getSlideParentByElement = function (slideElement, parentNode)
    {
      return parentNode || slideElement.parentNode;
    };

    /**
     * Slide elements iterator.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {function} $callback
     */
    this.slideElementsIterator = function (element, slideIndex, $callback)
    {
      var slides = this.getSlideElementsByIndex(element, slideIndex);

      for (var i = 0, length = slides.length; i < length; i++)
      {
        $callback(slides[i], i);
      }
    };

    /**
     * Froze slide.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {Object} parentNode
     */
    this.frozeSlideParentHeight = function (element, slideIndex, parentNode)
    {
      this.slideElementsIterator(element, slideIndex, function (slide)
      {
        var parent = wgSliderService.getSlideParentByElement(slide, parentNode);
        parent.style.height = parent.offsetHeight + 'px';
      });
    };

    /**
     * Set parent height by slide.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {Object} parentNode
     */
    this.setParentHeightBySlide = function (element, slideIndex, parentNode)
    {
      var slideMax = 0;
      this.slideElementsIterator(element, slideIndex, function (slide)
      {
        var parent = wgSliderService.getSlideParentByElement(slide, parentNode);

        var slideWithPadding = slide.parentNode.offsetHeight;

        if (slideMax < slideWithPadding)
        {
          slideMax = slideWithPadding;
          parent.style.height = slideMax + 'px';
        }
      });
    };

    /**
     * Unfroze slide parent height.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {Object} parentNode
     */
    this.unfrozeSlideParentHeight = function (element, slideIndex, parentNode)
    {
      this.slideElementsIterator(element, slideIndex, function (slide)
      {
        var parent = wgSliderService.getSlideParentByElement(slide, parentNode);
        parent.style.height = '';
      });
    };

    /**
     * Get slide elements by index.
     *
     * @param {Object} element
     * @param {number} index
     * @returns {HTMLElement}
     */
    this.getSlideElementsByIndex = function (element, index)
    {
      return element[0].querySelectorAll('[wg-slide="'+ index +'"]');
    };

    /**
     * Get control element by index.
     *
     * @param {Object} element
     * @param {number} index
     * @returns {HTMLElement}
     */
    this.getControlElementByIndex = function (element, index)
    {
      return element[0].querySelector('[wg-slide-index="'+ index +'"]');
    };

    /**
     * Set indexes to control elements.
     *
     * @param {Object} elementsWrapper
     * @returns {WgSliderService}
     */
    this.setIndexesToControlElements = function (elementsWrapper)
    {
      var elements = elementsWrapper.children();

      for (var i = 0, length = elements.length; i < length; i ++)
      {
        elements[i].setAttribute('wg-slide-index', i + 1);
      }

      return this;
    };

    /**
     * Get control element.
     *
     * @param {Object} element
     * @returns {Angular.element}
     */
    this.getControlElement = function (element)
    {
      return angular.element( element[0].querySelector('[wg-slider-control]') );
    };

    /**
     * Hide slide by index.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {number} delay
     * @param {function} $callback
     */
    this.hideSlideByIndex = function (element, slideIndex, delay, $callback)
    {
      var slides = this.getSlideElementsByIndex(element, slideIndex);

      var hideFn = function ($index)
      {
        $timeout(function ()
        {
          slides[$index].classList.remove('active');

          if(angular.isFunction($callback)) {
            $callback();
          }
        }, delay/2);
      };

      for (var i = 0, length = slides.length; i < length; i++)
      {
        slides[i].style.opacity = 0;
        hideFn(i);
      }
    };

    /**
     * Show slide by index.
     *
     * @param {Object} element
     * @param {number} slideIndex
     * @param {number} delay
     * @param {function} $callback
     */
    this.showSlideByIndex = function (element, slideIndex, delay, $callback)
    {
      var slides = this.getSlideElementsByIndex(element, slideIndex);

      var showFn = function ($index)
      {
        $timeout(function ()
        {
          slides[$index].classList.add('active');

          if(angular.isFunction($callback)) {
            $callback();
          }
        }, delay/2);
      };

      for (var i = 0, length = slides.length; i < length; i++)
      {
        slides[i].style.opacity = 1;
        showFn(i);
      }
    };

    /**
     * Bind mouse on control.
     *
     * @param {Object} element
     * @param {function} fn
     */
    this.bindMouseOnControl = function (element, fn)
    {
      var controlElement = this.getControlElement(element);

      this.setIndexesToControlElements(controlElement);

      controlElement.bind('click', fn);
    };

    /**
     * Unbind mouse on control.
     *
     * @param {Object} element
     * @param {function} fn
     */
    this.unbindMouseOnControl = function (element, fn)
    {
      this
        .getControlElement(element)
        .unbind('click', fn);
    };

    /**
     * Change slide.
     *
     * @param {Object} element
     * @param {number} currentActive
     * @param {number} newActive
     * @param {Object} parentNode
     * @param {number} SLIDE_CHANGING_TIME
     * @param {?number} DISABLE_FROZEN_HEIGHT
     */
    this.changeSlide = function (element, currentActive, newActive, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT) {
      SLIDE_CHANGING_TIME = SLIDE_CHANGING_TIME || 500;

      this.getControlElementByIndex(element, currentActive).classList.remove('active');
      wgSliderService.getControlElementByIndex(element, newActive).classList.add('active');

      DISABLE_FROZEN_HEIGHT || wgSliderService.frozeSlideParentHeight(element, currentActive, parentNode);

      wgSliderService.hideSlideByIndex(element, currentActive, SLIDE_CHANGING_TIME);
      wgSliderService.showSlideByIndex(element, newActive, SLIDE_CHANGING_TIME, function () {
        DISABLE_FROZEN_HEIGHT || wgSliderService.setParentHeightBySlide(element, newActive, parentNode);
      });
    };

    /**
     * Change parameters.
     *
     * @param {Array} params
     * @param {number} nextSlide
     */
    this.changeParams = function (params, nextSlide) {
      for (var k in params) {
        angular.forEach(params[k], function (param, attr) {
          if (attr == 'element') return true;
          var value = param.template.replace(/\{element\}/g, param.values[nextSlide - 1]);
          params[k].element.setAttribute(attr, value);
        });
      }
    };

    /**
     * Slides autochanger.
     *
     * @param {Object} scope
     * @param {Object} element
     * @param {Object} parentNode
     * @param {number} SLIDE_CHANGING_TIME
     * @param {number} SLIDE_CHANGE_TIME
     * @param {?number} DISABLE_FROZEN_HEIGHT
     * @returns {function} changer destructor
     */
    this.autoChanger = function(scope, element, parentNode, SLIDE_CHANGING_TIME, SLIDE_CHANGE_TIME, DISABLE_FROZEN_HEIGHT)
    {
      SLIDE_CHANGE_TIME = SLIDE_CHANGE_TIME || 5000;
      var $interval = setInterval(function ()
      {
        var slidesCount = scope.slides.length;
        if (slidesCount > 0) {
          var newActive = (scope.currentActive < slidesCount)? scope.currentActive + 1 : 1;

          wgSliderService.changeSlide(element, scope.currentActive, newActive, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT);
          wgSliderService.changeParams(scope.params, newActive);

          scope.currentActive = newActive;
        }
      }, SLIDE_CHANGE_TIME);

      return function ()
      {
        clearInterval($interval);
      };
    };

    /**
     * Changer active element.
     *
     * @param {Object} element
     * @param {Object} scope
     * @param {number} newActive
     * @param {Object} parentNode
     * @param {number} SLIDE_CHANGING_TIME
     * @param {number} DISABLE_FROZEN_HEIGHT
     */
    this.changerActiveElement = function(element, scope, newActive, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT){
      scope.isMoveAction = true;

      var length = scope.slides.length;
      if (length > 0) {
        if (newActive < 1) {
          newActive = length;
        }

        if (newActive > length) {
          newActive = 1;
        }

        this.changeSlide(element, scope.currentActive, newActive, parentNode, SLIDE_CHANGING_TIME, DISABLE_FROZEN_HEIGHT);
        this.changeParams(scope.params, newActive);

        scope.currentActive = newActive;
      }

      $timeout(function () {
        scope.isMoveAction = false;
      }, 1000);
    };
  };

  WgSliderService.$inject = [
    '$timeout'
  ];

  angular.module('base').service('WgSliderService', WgSliderService);
})(angular);
  ;

// Source: ../shared/public_html/assets/js/base/socket.service.js
(function(angular, window) {
var SocketService = function ($q, $rootScope, ScriptInject, AppConfig) {
        this.pusher = null;
        this.currentChannelId = null;

        /**
         * Injects pusher script and creates the global object
         *
         * @returns {Promise}
         */
        this.init = function () {
            var self = this;

            return $q(function (resolve, reject) {
                ScriptInject
                    .inject('pusher-script', 'https://js.pusher.com/7.0.3/pusher.min.js')
                    .then(function () {
                        self.pusher = new window.Pusher(AppConfig.getPusherConfig().appKey, {
                            cluster: AppConfig.getPusherConfig().appCluster
                        });
                        resolve();
                    })
                    .catch(function () {
                        reject();
                    });
            });
        };

        /**
         * Creates and subscribes to a channel
         *
         * @param {String} channelId
         * @param {String} eventName
         * @param {Function} callback
         */
        this.subscribe = function (channelId, eventName, callback) {
            this.currentChannelId = channelId;

            this.pusher.subscribe(channelId).bind(eventName, function (message) {
                callback(message);
                $rootScope.$apply();
            });
        };

        /**
         * Unsubscribes from pusher events for the current channelId
         */
        this.unsubscribe = function () {
            this.pusher.unsubscribe(this.currentChannelId);
        };
    };

    SocketService.$inject = ['$q', '$rootScope', 'ScriptInject', 'appConfig'];

    angular
        .module('base')
        .service('Socket', SocketService);

}(angular, window));
;

// Source: ../shared/public_html/assets/js/base/ui/components/inline-tooltip.component.js
(function(angular) {
var template = '\
        <span class="inline-tooltip">\
            <span class="visible-xs-inline visible-sm-inline" ng-click="$ctrl.toggle()"><ng-transclude class="transcluded"></ng-transclude></span>\
            <span class="hidden-xs hidden-sm" tooltip-html="$ctrl.tooltipContent" tooltip-placement="{{ $ctrl.placement || \'right\' }}" tooltip-append-to-body="true" tooltip-class="tooltip--contrast"><ng-transclude class="transcluded"></ng-transclude></span>\
            <ith-responsive-tooltip id="{{ $ctrl.modalId }}">\
                <content>\
                    <div class="tooltip--contrast" ng-bind-html="$ctrl.modalContent"></div>\
                </content>\
            </ith-responsive-tooltip>\
        </span>\
    ';

    var controller = function (UUID, ResponsiveTooltipService, $sce) {
        this.modalId = '';
        this.modalContent = '';
        this.tooltipContent = '';

        this.toggle = function () {
            ResponsiveTooltipService.open(this.modalId);
        };

        this.getTooltipContent = function () {
            return $sce.trustAsHtml(this.content);
        };

        this.$onInit = function () {
            this.modalId = UUID.v4();
        };

        this.$onChanges = function (changes) {
            this.modalContent = changes.content.currentValue;
            this.tooltipContent = $sce.trustAsHtml(changes.content.currentValue);
        };
    };

    controller.$inject = ['UUID', 'ResponsiveTooltipService', '$sce'];

    var IthInlineTooltip = {
        transclude: true,
        template: template,
        controller: controller,
        bindings: {
            content: '@',
            placement: '@'
        }
    };

    angular
        .module('base')
        .component('inlineTooltip', IthInlineTooltip);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-alert-box.component.js
(function (angular) {
var template =
        '<div class="ith-alert-box" ng-class="\'ith-alert-box--\' + $ctrl.type">' +
        '   <ng-transclude></ng-transclude>' +
        '</div>';

    var IthAlertBoxComponent = {
        template: template,
        bindings: {
            type: '@'
        },
        transclude: true
    };

    angular
        .module('ITH.Base.Ui')
        .component('ithAlertBox', IthAlertBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-modal-layout.component.js
(function(angular) {
var template = '\
        <div class="ith-modal">\
            <div class="ith-modal__header">\
                <h4 class="ith-modal__title">{{ $ctrl.title }}</h4>\
                <button class="ith-modal__close" ng-if="$ctrl.instance" ng-click="$ctrl.instance.dismiss()">\
                    <svg-icon id="modal-close"></svg-icon>\
                </button>\
            </div>\
            <div class="ith-modal__body">\
                <ng-transclude></ng-transclude>\
            </div>\
        </div>\
    ';

    var controller = function ($scope) {
        var ctrl = this;

        $scope.$on('contact-form-email-ticket-created', function () {
            ctrl.title = '';
        });
    }

    controller.$inject = [
        '$scope'
    ];

    angular
        .module('base')
        .component('ithModalLayout', {
            template: template,
            transclude: true,
            controller: controller,
            bindings: {
                instance: '<',
                title: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-status-indicator.component.js
(function(angular) {
var template = '<span>\
        <ist-status-indicator ng-if="$ctrl.isLoader()" size="{{$ctrl.size}}"></ist-status-indicator>\
        <svg-icon ng-if="!$ctrl.isLoader()" id="{{ $ctrl.getIconId() }}"></svg-icon>\
    </span>';

    /**
     * Status indicator controller
     */
    var ctrl = function () {
        /**
         * On init hook
         */
        this.$onInit = function() {
            this.size = this.size || 48;
        };

        /**
         * Indicator of type loader?
         *
         * @returns {Boolean}
         */
        this.isLoader = function () {
            return this.status === '' || this.status === 'loading';
        };

        /**
         * Returns icon id
         *
         * @returns {String}
         */
        this.getIconId = function () {
            return 'status/' + this.status;
        };
    };

    angular
        .module('ITH.Base.Ui')
        .component('ithStatusIndicator', {
            template: template,
            controller: ctrl,
            bindings: {
                status: '@',
                size: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-status-notification.component.js
(function(angular) {
var template =
        '<div class="ith-status-notification" ng-class="\'ith-status-notification--\' + $ctrl.status">' +
        '    <ith-status-indicator status="{{ $ctrl.status }}"></ith-status-indicator>' +
        '    <h3 ng-transclude="title"></h3>' +
        '    <p ng-transclude="text"></p>' +
        '</div>';

    var IthStatusNotificationComponent = {
        template: template,
        bindings: {
            status: '@'
        },
        transclude: {
            title: 'paneTitle',
            text: 'paneText'
        }
    };

    angular
        .module('ITH.Base.Ui')
        .component('ithStatusNotification', IthStatusNotificationComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-ui-checkbox.component.js
(function(angular) {
/**
   * @name        IthUiCheckboxComponent
   * @description Renders a UI checkbox element
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
    var IthUiCheckboxComponent = {
        bindings: {
            ngModel: '=',
            value: '<?',
            disabled: '<?',
            inverted: '<?',
            switcher: '<?',
            callback: '&?'
        },
        controller: function () {
            this.onClick = function () {
                if (this.disabled) {
                    return;
                }

                this.ngModel = !this.ngModel;

                if (this.callback) {
                    this.callback();
                }
            };

            this.getClassMap = function () {
                return {
                    on: this.inverted ? !this.ngModel : this.ngModel,
                    disabled: this.disabled,
                    'ui-switch': this.switcher === true
                };
            };
        },
        transclude: true,
        template: '\
            <span class="boolean" ng-click="$ctrl.onClick()" ng-class="$ctrl.getClassMap()">\
                <span class="toggler"></span>\
                <ng-transclude></ng-transclude>\
            </span>\
        '
    };

    angular
        .module('ITH.Base.Ui')
        .component('ithUiCheckbox', IthUiCheckboxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/ui/components/ith-ui-radio.component.js
(function(angular) {
/**
   * @name        IthUiRadioComponent
   * @description Renders a UI radio element
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthUiRadioComponent = {
    bindings: {
      ngModel: '=',
      value: '<?',
      disabled: '<?',
      changeEvent: '&?'
    },
    transclude: true,
    template: '<label class="ui-radio secondary cursorPointer" ng-click="$ctrl.onClick()" ng-class="{ on: $ctrl.ngModel === $ctrl.value, disabled: $ctrl.disabled }"><span class="toggler"></span> <span class="ui-radio-label"><ng-transclude></ng-transclude></span></label>',
    controller: function () {
      this.onClick = function () {
        this.ngModel = this.value;

        if (this.changeEvent !== undefined) {
          this.changeEvent();
        }
      };
    }
  };

  angular
    .module('ITH.Base.Ui')
    .component('ithUiRadio', IthUiRadioComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/base/validator/cityValid.js
angular.module('base')

/**
 * @name        compile
 * @description appends compiled source
 */
.directive('cityValid',
[
function () {
return {
    restrict: 'AE',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators.cityValid = function (modelValue, viewValue) {
        if (!ctrl.$isEmpty(modelValue) && (viewValue.city_code || viewValue.country_code)) {

          return true;
        }

        // it is invalid
        return false;
      };
    }
  };
}]);;

// Source: ../shared/public_html/assets/js/basket/models/Basket.js
/* eslint-disable indent */
angular.module('basket')

  /**
   * @name        Basket
   * @namespace   bas
   * @description Helper class providing methods dealing with all kinds of payment / price stuff
   */
  .factory('bas.Basket',
    ['$filter', 'bas.PricesCalculator', 'IbeLuggageSummaryHelper', function BasketFactory ($filter, PricesCalculator, IbeLuggageSummaryHelper) {
/**
       * Rounds a float number to 2 decimals
       *
       * @param {Number} float
       * @returns {Number}
       */
      var roundFloat = function (float) {
        return Math.round(float * 100) / 100;
      };

      /**
       * Basket constructor
       *
       * @constructor
       * @class Basket
       */
      var Basket = function (dataProvider) {
        // data provider must be an object with getFlightDetails method
        if (!_.isObject(dataProvider) || typeof(dataProvider.getFlightDetails) !== 'function') {
          throw 'Basket requires dataProvider to have getFlightDetails method';
        }

        /**
         * Basket data provider
         *
         * @type {*}
         */
        this.dataProvider = dataProvider;

        /**
         * Flight details
         *
         * @type {FlightDetails|null}
         */
        this.flightDetails = dataProvider.getFlightDetails();

        // Make sure we really have FlightDetails instance
        if (this.flightDetails == null) {
          throw 'Basket requires FlightDetails instance';
        }

        /**
         * Types to price mapping: [key:string]: number
         *
         * @type {Object}
         */
        this.feeCount = {};

        this.totalPriceReference = 0;
        this.itemCountReference = 0;
      };

      // Add instance methods
      Basket.prototype = /** @lends Basket.prototype */ {

        /**
         * Return total number of paxes
         *
         * @return {Number}
         */
        getPaxCount: function () {
          return this.getPaxesPricing().getPaxCount();
        },

        /**
         * Get paxes pricing information
         *
         * @return {Pricings}
         */
        getPaxesPricing: function () {
          return this.flightDetails.getPaxesPricing();
        },

        /**
         * Returns the discount object
         *
         * @return {Discount}
         */
        getDiscount: function () {
          return this.flightDetails.getDiscount();
        },

        /**
         * TF
         *
         * @returns {number}
         */
        getTFee: function () {
          return this.flightDetails.getTFee();
        },

        /**
         * Get total netto price
         *
         * @return {Number}
         */
        getTotalNettoPrice: function () {
          return this.getPaxesPricing().getTotalNettoPrice();
        },

        /**
         * Get total transaction fee
         *
         * @return {Number}
         */
        getTotalTransFee: function () {
          return this.getPaxesPricing().getTotalTf() - this.getDiscount().getTotalDefaultDiscount();
        },

        getMassCampaignTransFee: function () {
          return this.getPaxesPricing().getTotalTf() - this.getDiscount().getTotalMassCampaign();
        },

        /**
         * Returns all mandatory fees
         *
         * @return {MandatoryFee[]}
         */
        getMandatoryFees: function () {
          return this.flightDetails.getMandatoryFees();
        },

        /**
         * Returns all mandatory fees
         *
         * @return {FareLock}
         */
        getFareLock: function () {
          return this.dataProvider.fareLock;
        },

        /**
         * Returns the total of mandatory fees
         *
         * @return {Number}
         */
        getTotalMandaFees: function () {
          return this.flightDetails.getTotalMandatoryFees();
        },

        /**
         * Returns cheapest payment option
         *
         * @return {Number}
         */
        getCheapestPaymentOption: function () {
          return this.flightDetails.getPaymentOptions().getCheapest();
        },

        /**
         * Returns expensive payment option
         *
         * @return {Number}
         */
        getExpensivePaymentOptions: function () {
          return this.flightDetails.getPaymentOptions().getExpensive();
        },

        /**
         * Returns insurance type in uppercase
         *
         * @return {String}
         */
        getInsuranceType: function () {
          var insurance = this.dataProvider.getNewInsurance();
          insurance = insurance.selectedInsurance ? insurance.selectedInsurance : false;
          return insurance ? insurance.provider + '_' + insurance.type : '';
        },

        /**
         * Returns true if selected insurance is COVID insurance
         *
         * @returns {Boolean}
         */
        isCovidInsurance: function () {
          var selectedInsurance = this.dataProvider.getNewInsurance().selectedInsurance;
          return selectedInsurance ? selectedInsurance.isCovid : false;
        },

        /**
         * Get insurance price
         *
         * @return {Number}
         */
        getTotalInsurancePrice: function () {
          var insurance = this.dataProvider.getNewInsurance();
          return insurance.selectedInsurance && insurance.selectedInsurance.totalPrice || 0.0;
        },

        /**
         * Check if payment fees are set
         *
         * @param  {String|null} type Type of payment. Ex: CC, BT, CA, etc
         *
         * @return {Boolean}
         */
        hasPaymentFees: function (type) {
          return this.getFee(type) !== null;
        },

        /**
         * Get payment fee
         *
         * @param  {String|null} type Type of payment. Ex: CC, BT, CA, etc
         *
         * @return {PaymentFee|null}
         */
        getFee: function (type) {
          return this.dataProvider.getPayment().getFeeProperties(type);
        },

        /**
         * Returns total discount
         *
         * @return {Number}
         */
        getTotalDiscount: function () {
          return this.getDiscount().getTotalDiscount();
        },

        /**
         * Returns total insurance discount
         *
         * @return {Number}
         */
        getTotalInsuranceDiscount: function () {
          return 0;
        },

        /**
         * Get BNR exchange rate
         *
         * @param {String} fromCurr The from currency code ex: EUR
         * @param {String} toCurr   The to currency code ex: RON
         *
         * @return {float}
         */
        getExchangeRate: function (fromCurr, toCurr) {
          if (fromCurr === toCurr) {
            return 1.0;
          }
          return this.flightDetails.getPaymentInfo().getExchangeRate(fromCurr, toCurr).getRate();
        },

        /**
         * Get total in RON (for Card Avantaj payment)
         * This is strictly informative
         *
         * @return {Number}
         */
        getTotalRonPrice: function () {
          return +(this.getExchangeRate('EUR', 'RON') * this.getTotalPrice().toFixed(2)).toFixed(2);
        },

        /**
         * Get total exchanged price (for Card Avantaj payment)
         * This is strictly informative
         *
         * @return {Number}
         */
        getTotalPriceCurrency: function (currency) {
          return +(this.getExchangeRate(this.getPaxesPricing().getCurrencyCode(), currency) * this.getTotalPrice().toFixed(2)).toFixed(2);
        },

        /**
         * Returns true if pricing has coupons
         *
         * @return {Boolean}
         */
        hasCoupons: function () {
          return this.getDiscount().hasCoupons();
        },

        /**
         * Returns true if pricing has coupons
         *
         * @return {Boolean}
         */
        hasRemovableCoupons: function () {
          return this.getDiscount().hasCouponsByType(1);
        },

        /**
         * Returns true if pricing has coupons
         *
         * @return {Boolean}
         */
        canAddCoupon: function () {
          return this.getDiscount().canAddCoupon();
        },

        /**
         * Adds a new coupon in the coupons array
         *
         * @param {Object}  couponData Data containing coupon information
         * @param {int}     type       Type of coupon (0 - discount on a specific route, 1 - voucher added by user, 2 - voucher added by a promotion)
         *
         * @return {Object}
         */
        addCoupon: function (couponData, type) {
          return this.getDiscount().addCoupon(couponData, type);
        },

        /**
         * Removes a coupon by type
         *
         * @param {int} type The coupon type (0: discount | 1: voucher | 2: promotion)
         *
         * @return {Basket}
         */
        removeCoupon: function (type) {
          this.getDiscount().removeCoupon(type);
          return this;
        },

        /**
         * Removes a coupon by code
         *
         * @param code
         * @returns {*|Number}
         */
        removeCouponOnDiscountCode: function (code) {
          this.getDiscount().removeCouponOnDiscountCode(code);
          return this;
        },

        /**
         * Returns the coupons associated with current flight
         *
         * @return {Coupon[]}
         */
        getCoupons: function () {
          return this.getDiscount().getCoupons();
        },

        getCalculatedCoupons: function () {
          var elements = this.getPriceElements();
          return this.getDiscount().getCalculatedCoupons(elements.totalDiscount);
        },

        /**
         * Get total payment fees amount
         *
         * @param {String|null} [type] Type of payment. Ex: CC, CA, BT, etc.
         * @param {Number|null} [price]
         *
         * @return {Number}
         */
        getTotalPaymentFee: function (type, price) {
          if (!this.hasPaymentFees(type)) {
            return 0;
          }

          price = price || 0;

          var
            setFee = true,
            fee = this.getFee(type),
            amount = fee.getAmount(); // Get initial amount

          // Check if amount is per pax
          if (fee.isPerPax()) {
            amount *= this.getPaxCount();
          }
          // Is fee set to type percent?
          if (fee.isPercentType()) {
            // Percent from what price?
            if (price) {
              // Add percent from sended price
              amount = this.getPercent(price, amount);
              setFee = false;
            }
            else  {
              amount = fee.isFromTotalPrice()
                  // Add percent from total price
                  ? this.getPercent(this.getInitialPriceWithoutInsurance(), amount)
                  // Add percent from total netto price
                  : this.getPercent(this.getTotalNettoPrice(), amount);
            }
          }

          if (setFee && type) {
            this.setFeeCount(setFee && amount > 0, type);
          }

          return amount;
        },

        /**
         * Get fee amount for sended price
         *
         * @param price
         *
         * @returns {Number}
         */
        getTotalPaymentFeeForPrice: function (price) {
          return this.getTotalPaymentFee(null, price);
        },

        /**
         * Set fee for ng-show/if in views
         * @see pax/paymentOption.php
         *
         * @param setFee {Boolean};
         * @param {String|null} [type] Type of payment. Ex: CC, CA, BT, etc.
         * @returns {void};
         */
        setFeeCount: function (setFee, type) {
          if(type && setFee){
            this.feeCount[type] = setFee ? 1 : 0;
          }
        },

        /**
         * Get fee for ng-show/if in views
         * @see paymentOption.php view
         *
         * @param {String|null} [type] Type of payment. Ex: CC, CA, BT, etc.
         * @returns {Number}
         */
        getFeeCount: function (type) {
          return type ? this.feeCount[type] : 0;
        },

        /**
         * Get percent from amount
         *
         * @param  {Number} amount  The total amount
         * @param  {Number} percent The percent
         *
         * @return {Number}         Percent from amount
         */
        getPercent: function (amount, percent) {
          return $filter('roundPrice')((percent * amount) / 100);
        },

        getTotalLuggagePrice: function () {
          return IbeLuggageSummaryHelper.getTotalPrice(this.dataProvider);
        },

        getInitialPriceWithoutInsurance: function (ignoreDiscounts) {
          var initialPrice =
            this.getTotalNettoPrice() +
            this.getTotalTransFee() +
            this.getTotalMandaFees() +
            this.getTotalLuggagePrice();

          if (!ignoreDiscounts) {
            initialPrice -= this.getDiscount().getTotalNoTfDiscount();
          } else {
            initialPrice += this.getDiscount().getTotalDefaultDiscount();
          }

          return initialPrice;
        },

        getTotalTicketTypePrice: function () {
          return this.dataProvider.ticketType.getTotalPrice();
        },

        getTotalFrolaAssistancePrice: function () {
          return this.dataProvider.frolaAssistance.getTotalPrice();
        },

        /**
         * Returns total price (initial price + payment fee)
         *
         * @param {Boolean} withPriceDiff
         * @return {Number}
         */
        getTotalPrice: function (withPriceDiff) {
          withPriceDiff = (typeof withPriceDiff !== 'undefined') ? withPriceDiff : false;

          var elements = this.getPriceElements();
          var totalPriceCalculation = this.getInitialPriceWithoutInsurance() + elements.totalToPay - elements.elements.baggage.price;

          if (withPriceDiff) {
            totalPriceCalculation += this.dataProvider.getTestSell().getPriceDiff();
            totalPriceCalculation += this.dataProvider.getTestSell().getPriceDiffAdjustment();
          }

          return totalPriceCalculation;
        },

        getTotalPaidCheckin: function () {
          if (!this.dataProvider.paidCheckin.isSelected()) {
            return 0;
          }

          return this.dataProvider.paidCheckin.getTotalPrice();
        },

        getTotalSeatsPrice: function () {
          return this.dataProvider.seatSelect.getTotalPrice();
        },

        getPaymentFee: function () {
          return this.getTotalPaymentFee(null, null) + this.getCheapestPaymentOption();
        },

        getRefundBasePrice: function () {
          return (
            this.getTotalNettoPrice() + this.getTotalTransFee()
          );
        },

        getTotalFastRefundPrice: function () {
          return this.dataProvider.fastRefund.isSelected()
            ? this.dataProvider.fastRefund.getTotalPrice()
            : 0;
        },

        getTotalTripGuaranteePrice: function () {
          if (!this.dataProvider.tripGuarantee.isChosen()) {
            return 0;
          }

          if (this.dataProvider.tripGuarantee.isOrdered) {
            return this.dataProvider.tripGuarantee.orderedPrice;
          }

          return this.dataProvider.tripGuarantee.getPrice();
        },

        getTotalSmsNotification: function () {
          if (!this.dataProvider.smsNotification.isChosen()) {
            return 0;
          }

          return roundFloat(this.dataProvider.smsNotification.price);
        },

        getTotalCfarPrice: function () {
          return this.dataProvider.cfar.isSelected() ? this.dataProvider.cfar.getTotalPrice() : 0;
        },

        getBasketItems: function () {
          var items = [];

          var addItem = function (id, price, quantity, variant) {
            items.push({ id: id, price: roundFloat(price), quantity: parseInt(quantity), variant: variant });
          };

          addItem(
            'flight',
            this.getPaxesPricing().getTotalTf() + this.getTFee(),
            this.getPaxCount()
          );

          if (this.dataProvider.smsNotification.isChosen()) {
            addItem(
              'smsNotification',
              this.getTotalSmsNotification(),
              1
            );
          }

          var luggageItems = IbeLuggageSummaryHelper.getItems(this.dataProvider);

          if (luggageItems[0].count > 0) {
            addItem(
              'cabinLuggage',
              luggageItems[0].totalPrice,
              luggageItems[0].count
            );
          }

          if (luggageItems[1].count > 0) {
            addItem(
              'checkedLuggage',
              luggageItems[1].totalPrice,
              luggageItems[1].count
            );
          }

          if (this.dataProvider.ticketType.isSelected()) {
            addItem(
              'ticketType',
              this.dataProvider.ticketType.getTotalPrice(),
              this.getPaxCount(),
              this.dataProvider.ticketType.getSelectedPackage().type
            );
          }

          if (this.dataProvider.frolaAssistance.isSelected()) {
            addItem(
              'frolaAssistance',
              this.dataProvider.frolaAssistance.getTotalPrice(),
              this.getPaxCount(),
              this.dataProvider.frolaAssistance.getSelectedPackage().type
            );
          }

          if (this.dataProvider.paidCheckin.isSelected()) {
            addItem(
              'paidCheckin',
              this.dataProvider.paidCheckin.getTotalPrice(),
              this.getPaxCount()
            );
          }

          if (this.dataProvider.seatSelect.getTotalPrice() > 0) {
            addItem(
              'seatSelect',
              this.dataProvider.seatSelect.getTotalPrice(),
              this.getPaxCount()
            );
          }

          if (this.getTotalInsurancePrice()) {
            addItem(
              'insurance',
              this.getTotalInsurancePrice(),
              this.getPaxCount()
            );
          }

          if (this.dataProvider.tripGuarantee.isChosen()) {
            addItem(
              'tripGuarantee',
              this.getTotalTripGuaranteePrice(),
              this.getPaxCount()
            );
          }

          if (this.dataProvider.refund.added) {
            addItem(
              'refund',
              this.dataProvider.refund.price,
              this.getPaxCount()
            );
          }

          if (this.dataProvider.fastRefund.isSelected()) {
            addItem(
              'fastRefund',
              this.dataProvider.fastRefund.getTotalPrice(),
              this.getPaxCount()
            );
          }

          if (this.dataProvider.cfar.isSelected()) {
            addItem(
              'cfar',
              this.dataProvider.cfar.getTotalPrice(),
              this.getPaxCount()
            );
          }

          return items;
        },

        /**
         * @return {Object}
         */
        getPriceElements: function () {
          var prices = {
            insurance: this.getTotalInsurancePrice(),
            payment: this.getPaymentFee(),
            baggage: roundFloat(this.getTotalLuggagePrice()),
            fastRefund: this.getTotalFastRefundPrice(),
            cfar: this.getTotalCfarPrice(),
            seats: this.getTotalSeatsPrice(),
            tripGuarantee: this.getTotalTripGuaranteePrice(),
            paidCheckin: this.getTotalPaidCheckin(),
            ticketType: this.getTotalTicketTypePrice(),
            frolaAssistance: this.getTotalFrolaAssistancePrice(),
            smsNotification: this.getTotalSmsNotification(),
          };

          return PricesCalculator(this.getDiscount().getTotalAvailableFunds(), prices);
        },
      };

      Basket.prototype.constructor = Basket;

      return Basket;
    }]);

;

// Source: ../shared/public_html/assets/js/basket/models/PricesCalculator.js
(function (angular) {
angular.module('basket').factory('bas.PricesCalculator', factory);

    var availableElements = [
        { id: 'insurance', discountable: true },
        { id: 'payment', discountable: true },
        { id: 'baggage', discountable: true },
        { id: 'refund', discountable: true },
        { id: 'fastRefund', discountable: true },
        { id: 'cfar', discountable: true },
        { id: 'seats', discountable: true },
        { id: 'paidCheckin', discountable: true },
        { id: 'tripGuarantee', discountable: true },
        { id: 'smsNotification', discountable: true },
        { id: 'ticketType', discountable: true },
        { id: 'frolaAssistance', discountable: true },
    ];

    function factory() {
    /**
     * @param {Number} availableDiscountFunds - The amount of the excess coupon after deducting the flight price
     * @param {Object} prices - e.g. { flight: 123.4, insurance: 42.0 }
     */
        return function (availableDiscountFunds, prices) {
            var elements = {};
            var totalPrice = 0.0;
            var totalDiscount = 0.0;
            var totalToPay = 0.0;

            availableElements.forEach(function (element) {
                var id = element.id;
                var price = prices[id] || 0.0;
                var discount = 0.0;

                if (element.discountable) {
                    discount = Math.min(price, availableDiscountFunds);
                    availableDiscountFunds -= discount;
                }

                var toPay = price - discount;

                totalPrice += price;
                totalDiscount += discount;
                totalToPay += toPay;

                elements[id] = {
                    price: price,
                    discount: discount,
                    toPay: toPay,
                };
            });

            return {
                elements: elements,
                totalPrice: totalPrice,
                totalDiscount: totalDiscount,
                totalToPay: totalToPay,
            };
        };

    }

})(angular);
;

// Source: ../shared/public_html/assets/js/basket/services/PriceLockServ.js
/* global FlApp: false, _: false, moment: false */

angular.module('basket')

/**
 * @name        PriceLockServ
 * @namespace   dsc
 * @description Class that handles coupon communication with the API
 */
.factory('dsc.PriceLockServ', ['ApiTools',
function PriceLockServFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Add coupon
      checkEmail: {
        url: '/api/api/lockPriceCheckEmail',
        method: 'POST',
        respParser: priceLockParser
      }
    },

    /**
     * @class InsuranceServ
     * @constructor
     */
    PriceLockServ = function () {};

  PriceLockServ.prototype = /** @lends InsuranceServ.prototype */ {

    /**
     * Send coupon code to backend for validation
     *
     * @param {Object} params  Params
     * @param {Object} routeParams The route parameters
     */
    checkEmail: function (params, routeParams) {
      return ApiTools.fetch(this, endpoints.checkEmail, params, routeParams);
    }
  };

  PriceLockServ.prototype.constructor = PriceLockServ;

  /**
   * Parse example response
   *
   * @param {Object} response
   *
   * @return {Object}
   */
  function priceLockParser(response) {
    return response.response;
  }

  return new PriceLockServ();
}]);
;

// Source: ../shared/public_html/assets/js/billing/models/Address.js
/* global FlApp: false, _: false, moment: false */

angular.module('billing')

/**
 * @name        Address
 * @namespace   bil
 * @description Address abstract class
 */
.factory('bil.Address',
['ErrorMixin', 'FormErrorMixin', 'appConfig',
function AddressFactory(ErrorMixin, FormErrorMixin, appConfig) {
/**
   * Address constructor
   *
   * @constructor
   * @class Address
   */
  var Address = function () {
    /**
     * Street address
     *
     * @type {String}
     */
    this.street = '';

    /**
     * City name
     *
     * @type {String}
     */
    this.city = '';
    /**
     * City code
     *
     * @type {String}
     */
    this.zipCode = '';

    /**
     * Country ID
     *
     * @type {String}
     */
    this.country = appConfig.getDefaultCountryCode();

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Add instance methods
  Address.prototype = /** @lends Address.prototype */ {

    /**
     * Returns street
     *
     * @return {String}
     */
    getStreet: function () {
      return this.street;
    },

    /**
     * Sets street
     *
     * @param street {String}
     */
    setStreet: function (street) {
      this.street = street;
    },

    /**
     * Returns city name
     *
     * @return {String}
     */
    getCity: function () {
      return this.city;
    },

    /**
     * Sets city
     *
     * @param city {String}
     */
    setCity: function (city) {
      this.city = city;
    },

    /**
     * Returns zip code
     *
     * @return {String}
     */
    getZipCode: function () {
      return this.zipCode;
    },

    /**
     * Sets zipCode
     *
     * @param {String}
     */
    setZipCode: function (zipCode) {
      this.zipCode = zipCode;
    },

    /**
     * Return country ID
     *
     * @return {String}
     */
    getCountry: function () {
      return this.country;
    },

    /**
     * Set country
     *
     * @param {String} country
     */
    setCountry: function (country) {
      this.country = country;
    },

    /**
     * Returns this instance as simple object for communicating API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        street: this.street,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Address}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.street = errors.street;
      this.errors.city = errors.city;
      this.errors.zipCode = errors.zipCode;
      this.errors.country = errors.country;

      return this;
    },

    /**
     * Sets address from API object
     *
     * @param {Object} srvData
     *
     * @return {Address}
     */
    srvSet: function (srvData) {
      this.street = srvData.street;
      this.city = srvData.city;
      this.zipCode = srvData.zipCode;
      this.country = srvData.country;

      return this;
    }
  };

  Address.prototype.constructor = Address;

  // Add mixins
  _.extend(Address.prototype, ErrorMixin);
  _.extend(Address.prototype, FormErrorMixin);

  return Address;
}]);

;

// Source: ../shared/public_html/assets/js/billing/models/Billing.js
(function(angular, underscore) {
/**
     * @name        Billing
     * @namespace   bil
     * @description Class holding all billing information.
     */
    var BillingFactory = function (BillingPerson, Company, ErrorMixin) {

        /**
         * Billing.
         *
         * @class Billing
         * @constructor
         */
        var Billing = function() {
            /**
             * Type of billing form shown to the user.
             *
             * @type {String} One of the 'person' or 'company'.
             */
            this.type = 'person';

            /**
             * Indicate fake billing data
             *
             * @type {Boolean}
             */
            this.fake = true;

            /**
             * Funnel save billing to profile flag.
             *
             * @type {Boolean}
             */
            this.saveInFunnel = false;

            /**
             * Billing information for individuals.
             *
             * @type {Person}
             */
            this.person = new BillingPerson();

            /**
             * Billing information for companies.
             *
             * @type {Company}
             */
            this.company = new Company();

            /**
             * Invoice Address.
             * @type {{}}
             */
            this.invoice_adress = {};

            /**
             * Errors object.
             *
             * Used in templates to mark error fields and show error messages.
             * The keys are filed names and values are error messages or instances.
             *
             * Example:
             *
             * {
             *  property_name: "error message",
             *  property_with_some_instance: that instance
             * }
             *
             * @type {Object}
             */
            this.errors = {};

            /**
             * States for ex. tabs.
             *
             * @type {{person: boolean, company: boolean}}
             */
            this.activeType = {
                person: true,
                company: false
            };
        };

        // Add instance methods
        Billing.prototype = /** @lends Billing.prototype */ {

            /**
             * Reset billing data.
             */
            reset: function() {
                this.type = 'person';
                this.person = new BillingPerson();
                this.company = new Company();
                this.saveInFunnel = false;
                this.resetErrors();
            },

            /**
             * Returns type of billing that has been set.
             *
             * @return {String}
             */
            getType: function() {
                return this.type;
            },

            /**
             * Set type.
             *
             * @param type
             */
            setType: function(type) {
                var self = this;

                angular.forEach(this.activeType, function(e, i) {
                    self.activeType[i] = false;
                });
                this.activeType[type] = true;

                this.type = type;
            },

            /**
             * Is billing data fake.
             *
             * @return {Boolean}
             */
            isFake: function() {
                return this.fake;
            },

            /**
             * Is billing data fake.
             *
             * @return {Boolean}
             */
            setFake: function (val) {
                this.fake = val;
            },

            /**
             * Returns person.
             *
             * @return {Person}
             */
            getPerson: function() {
                return this.person;
            },

            /**
             * Sets person.
             *
             * @param person {Person}
             */
            setPerson: function (person) {
                this.person = angular.extend(new BillingPerson(), person);
            },

            /**
             * Returns company.
             *
             * @return {Company}
             */
            getCompany: function() {
                return this.company;
            },


            /**
             * Sets company.
             *
             * @param company {Company}
             */
            setCompany: function(company) {
                this.company = company;
            },
            /**
             * Returns true if type is set to person.
             *
             * @return {Boolean}
             */
            isPerson: function() {
                return this.type === 'person';
            },

            /**
             * Returns true if type is set to company.
             *
             * @return {Boolean}
             */
            isCompany: function() {
                return this.type === 'company';
            },

            /**
             * Get selected country for this billing.
             *
             * @return {Country}
             */
            getCountry: function() {
                var ret = this.isCompany() ? this.getCompany() : this.getPerson();
                return ret.getAddress().getCountry();
            },

            /**
             * Returns this instance as simple object for communicating with API.
             *
             * @return {Object}
             */
            srvObj: function() {
                var data = this.isCompany() ? this.getCompany() : this.getPerson();
                var srvTargetData = this.isFake() ? null : data.srvObj();

                return {
                    'type': this.type,
                    'fake': this.fake,
                    'saveInFunnel': this.saveInFunnel,
                    'data': srvTargetData
                };
            },

            /**
             * Set errors form server.
             *
             * @param {Object} errors
             * @return {Billing}
             */
            srvErrors: function(errors) {
                // Reset errors
                this.resetErrors();

                // If errors is not an object we bail out
                if(!underscore.isObject(errors)) {
                    errors = {};
                }

                switch(errors.type) {
                    case null:
                        break;

                    case 'person':
                        this.errors.type = errors.type;
                        this.errors.person = this.person.srvErrors(errors.data);
                        break;

                    case 'company':
                        this.errors.type = errors.type;
                        this.errors.company = this.company.srvErrors(errors.data);
                        break;
                }

                return this;
            },

            /**
             * Set billing from API object.
             *
             * @param {Object} srvData
             * @return {Billing}
             */
            srvSet: function (srvData) {
                // Set type
                this.type = srvData.type || this.type;
                this.setFake(srvData.fake || true);

                // Set data
                var data = this.isCompany() ? this.company : this.person;

                if (srvData.data !== null) {
                    data.srvSet(srvData.data);
                }

                return this;
            }
        };

        Billing.prototype.constructor = Billing;

        // Add mixins
        underscore.extend(Billing.prototype, ErrorMixin);

        return Billing;
    };

    BillingFactory.$inject = [
        'bil.BillingPerson',
        'bil.Company',
        'ErrorMixin'
    ];

    angular.module('billing').factory('bil.Billing', BillingFactory);

})(angular, _);

;

// Source: ../shared/public_html/assets/js/billing/models/BillingPerson.js
(function (angular) {
var BillingPersonFactory = function (Address, ErrorMixin, FormErrorMixin, AppConfig) {

        /**
         * Person constructor
         *
         * @constructor
         * @class Person
         */
        var Person = function () {
            /**
             * ID
             *
             * @type {string}
             */
            this.id = '';

            /**
             * First name
             *
             * @type {String}
             */
            this.firstName = '';

            /**
             * Last name
             *
             * @type {String}
             */
            this.lastName = '';

            /**
             * Address
             *
             * @type {Address}
             */
            this.address = new Address();

            /**
             * Passport or gov id number needed for invoicing in RO
             *
             * @type {String}
             */
            this.cnp = '';

            this.type = 'person';

            /**
             * Errors object
             *
             * Used in templates to mark error fields and show error messages
             * The keys are filed names and values are error messages or instances.
             *
             * Example:
             *
             * {
             *  property_name: "error message",
             *  property_with_some_instance: that instance
             * }
             *
             * @type {Object}
             */
            this.errors = {};
        };

        // Add instance methods
        Person.prototype = /** @lends Person.prototype */ {

            /**
             * Reset person data
             */
            reset: function () {
                this.id = '';
                this.firstName = '';
                this.lastName = '';
                this.address = new Address();
                this.cnp = '';
                this.resetErrors();
            },

            getId: function () {
                return this.id;
            },

            /**
             * Returns person's address
             *
             * @returns {Address}
             */
            getAddress: function () {
                return this.address;
            },

            /**
             * Returns first name
             *
             * @returns {String}
             */
            getFirstName: function () {
                return this.firstName;
            },

            /**
             * Set first name
             *
             * @param {String} firstName
             */
            setFirstName: function (firstName) {
                this.firstName = firstName;

                return this;
            },

            /**
             * Returns last name
             *
             * @returns {String}
             */
            getLastName: function () {
                return this.lastName;
            },

            /**
             * Set last name
             *
             * @param {String} lastName
             */
            setLastName: function (lastName) {
                this.lastName = lastName;

                return this;
            },

            /**
             * Returns this instance as simple object for communicating with API
             *
             * @return {Object}
             */
            srvObj: function () {
                return {
                    id: this.id,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    address: this.address.srvObj(),
                    cnp: this.cnp
                };
            },

            /**
             * Set errors form server
             *
             * @param {Object} errors
             *
             * @return {Person}
             */
            srvErrors: function (errors) {
                // Reset errors
                this.resetErrors();

                // If errors is not an object we bail out
                if (!_.isObject(errors)) {
                    errors = {};
                }

                this.errors.firstName = errors.firstName;
                this.errors.lastName = errors.lastName;
                this.errors.address = this.address.srvErrors(errors.address);
                this.errors.cnp = errors.cnp;

                return this;
            },

            /**
             * Set person from API object
             *
             * @param {Object} srvData
             *
             * @return {Person}
             */
            srvSet: function (srvData) {
                // Set basic information
                this.id = srvData.id || '';
                this.firstName = srvData.first_name;
                this.lastName = srvData.last_name;
                this.address.srvSet(srvData.address);

                if (!AppConfig.isVola()) {
                    this.cnp = srvData.cnp;
                }

                return this;
            }
        };

        Person.prototype.constructor = Person;

        // Add mixins
        _.extend(Person.prototype, ErrorMixin);
        _.extend(Person.prototype, FormErrorMixin);

        return Person;
    };

    BillingPersonFactory.$inject = [
        'bil.Address',
        'ErrorMixin',
        'FormErrorMixin',
        'appConfig'
    ];

    angular.module('billing')
        .factory('bil.BillingPerson', BillingPersonFactory);
})(angular);
;

// Source: ../shared/public_html/assets/js/billing/models/Company.js
/* global FlApp: false, _: false, moment: false */

angular.module('billing')

/**
 * @name        Company
 * @namespace   bil
 * @description Class that holds company information
 */
.factory('bil.Company',
['bil.Address', 'ErrorMixin', 'FormErrorMixin', 'appConfig',
function CompanyFactory(Address, ErrorMixin, FormErrorMixin, AppConfig) {
/**
   * Company constructor
   *
   * @constructor
   * @class Company
   */
  var Company = function () {
    /**
     * ID
     *
     * @type {string}
     */
    this.id = '';

    /**
     * Company name
     *
     * @type {String}
     */
    this.name = '';

    /**
     * Tax number
     *
     * @type {String}
     */
    this.taxNumber = '';

    /**
     * VAT number
     *
     * @type {String}
     */
    this.vatNumber = '';

    /**
     * Address
     *
     * @type {Address}
     */
    this.address = new Address();

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *   property_name: "error message",
   *   property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};

    this.type = 'company';
  };

  // Add instance methods
  Company.prototype = /** @lends Company.prototype */ {

    getId: function () {
      return this.id;
    },

    /**
     * Returns person's address
     *
     * @returns {Address}
     */
    getAddress: function () {
      return this.address;
    },

    /**
     * Set company address
     *
     * @param address {Address}
     */
    setAddress: function (address) {
      this.address = address;
    },

    /**
     * Returns company name
     *
     * @returns {String}
     */
    getName: function () {
      return this.name;
    },

    /**
     * Set company name
     *
     * @param name {String}
     */
    setName: function (name) {
      this.name = name;
    },

    /**
     * Returns tax number
     *
     * @returns {String}
     */
    getTaxNumber: function () {
      return this.taxNumber;
    },

    /**
     * Set tax number
     *
     * @param taxNumber {String}
     */
    setTaxNumber: function (taxNumber) {
      this.taxNumber = taxNumber;
    },

    /**
     * Returns VAT number
     *
     * @returns {String}
     */
    getVatNumber: function () {
      return this.vatNumber;
    },

    /**
     * Sets vat number
     *
     * @param vatNumber {String}
     */
    setVatNumber: function (vatNumber) {
      this.vatNumber = vatNumber;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        id: this.id,
        name: this.name,
        tax_number: this.taxNumber,
        vat_number: this.vatNumber,
        address: this.address.srvObj()
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Company}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.name = errors.name;
      this.errors.taxNumber = errors.taxNumber;
      this.errors.vatNumber = errors.vatNumber;
      this.errors.address = this.address.srvErrors(errors.address);

      return this;
    },

    /**
     * Set company from API object
     *
     * @param {Object} srvData
     *
     * @return {Company}
     */
    srvSet: function (srvData) {
      // Set main details
      this.id = srvData.id || '';
      this.name = srvData.name;
      this.vatNumber = srvData.vat_number;
      this.address.srvSet(srvData.address);

      if (!AppConfig.isVola()) {
        this.taxNumber = srvData.tax_number;
      }


      return this;
    }
  };

  Company.prototype.constructor = Company;

  // Add mixins
  _.extend(Company.prototype, ErrorMixin);
  _.extend(Company.prototype, FormErrorMixin);

  return Company;
}]);

;

// Source: ../shared/public_html/assets/js/billing/models/ContactDetails.js
/* global FlApp: false, _: false, moment: false */

angular.module('billing')

/**
 * @name        ContactDetails
 * @namespace   bil
 * @description Class that holds contact information
 */
.factory('bil.ContactDetails',
['ErrorMixin', 'FormErrorMixin', 'ContactPhone',
function ContactDetailsFactory(ErrorMixin, FormErrorMixin, ContactPhone) {
/**
   * ContactDetails constructor
   *
   * @constructor
   * @class ContactDetails
   */
  var ContactDetails = function () {
    /**
     * Contact mail address
     *
     * @type {String}
     */
    this.email = '';

    /**
     * Contact phone number
     *
     * @type {ContactPhone}
     */
    this.phone = new ContactPhone();

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Add instance methods
  ContactDetails.prototype = /** @lends ContactDetails.prototype */ {
    /**
     * Returns email
     *
     * @return {String}
     */
    getEmail: function () {
      return this.email;
    },

    /**
     * Sets email
     *
     * @param  {String} email
     *
     * @return {ContactDetails}
     */
    setEmail: function (email) {
      this.email = email;
      return this;
    },

    /**
     * Returns phone number class
     *
     * @return {ContactPhone}
     */
    getPhone: function () {
      return this.phone;
    },

    /**
     * Sets phone number class
     *
     * @param  {Object} phone
     *
     * @return {ContactDetails}
     */
    setPhone: function (phone) {
      if (phone.hasOwnProperty('prefix')) {
        this.phone.setPrefix(phone.prefix);
      }

      if (phone.hasOwnProperty('number')) {
        this.phone.setNumber(phone.number);
      }

      return this;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        email: this.email,
        phone: this.phone.srvObj()
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {ContactDetails}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.email = errors.email;
      this.phone.srvErrors(errors.phone);

      return this;
    },

    /**
     * Set contact details from API object
     *
     * @param {Object} srvData
     *
     * @return {ContactDetails}
     */
    srvSet: function (srvData) {
      this.email = srvData.email;
      this.phone.srvSet(srvData.phone);

      return this;
    }

  };

  ContactDetails.prototype.constructor = ContactDetails;

  // Add mixins
  _.extend(ContactDetails.prototype, ErrorMixin);
  _.extend(ContactDetails.prototype, FormErrorMixin);

  return ContactDetails;
}]);
;

// Source: ../shared/public_html/assets/js/billing/models/ContactPhone.js
(function(angular, underscore) {
var ContactPhoneFactory = function (ErrorMixin, FormErrorMixin, AppConfig) {
        var ContactPhone = function () {
            /**
             * Phone country code prefix
             *
             * @type {String}
             */
            this.prefix = this.getInitPrefix();

            /**
             * Phone number
             *
             * @type {String}
             */
            this.number = '';
        };

        ContactPhone.prototype.getInitPrefix = function () {
            if (AppConfig.isVola()) {
                return '+40';
            }

            if (AppConfig.isFru()) {
                return '+48';
            }

            // Govola
            try {
                var phoneCodes = AppConfig.getWebsiteSettings().marketToPhoneCode;
                return phoneCodes[AppConfig.getMarket()];
            } catch (e) {
                return '+44';
            }
        };

        /**
         *
         * @returns {String}
         */
        ContactPhone.prototype.getPrefix = function () {
            return this.prefix;
        };

        /**
         *
         * @param {String} prefix
         * @returns {ContactPhone}
         */
        ContactPhone.prototype.setPrefix = function (prefix) {
            this.prefix = prefix;
            return this;
        };

        /**
         *
         * @returns {String}
         */
        ContactPhone.prototype.getNumber = function () {
            return this.number;
        };

        /**
         *
         * @param {String} number
         * @returns {ContactPhone}
         */
        ContactPhone.prototype.setNumber = function (number) {
            this.number = number;
            return this;
        };

        /**
         *
         * @returns {Object}
         */
        ContactPhone.prototype.srvObj = function () {
            return {
                prefix: this.prefix,
                number: this.number
            };
        };

        /**
         *
         * @param {Object} errors
         */
        ContactPhone.prototype.srvErrors = function (errors) {
            if (errors && errors.number) {
                this.errors = errors.number;
            } else if (errors && errors.prefix) {
                this.errors = errors.prefix;
            } else {
                this.errors = errors;
            }

            return this;
        };

        /**
         *
         * @param {Object} data
         */
        ContactPhone.prototype.srvSet = function (data) {
            if (!data) {
                return;
            }

            this.prefix = data.prefix || this.prefix;
            this.number = data.number || '';

            return this;
        };

        ContactPhone.prototype.constructor = ContactPhone;

        underscore.extend(ContactPhone.prototype, ErrorMixin);
        underscore.extend(ContactPhone.prototype, FormErrorMixin);

        return ContactPhone;
    };

    ContactPhoneFactory.$inject = ['ErrorMixin', 'FormErrorMixin', 'appConfig'];

    angular
        .module('billing')
        .factory('ContactPhone', ContactPhoneFactory);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/billing/models/Country.js
/* global _: false */

angular.module('billing')

/**
 * @name        Country
 * @namespace   bil
 * @description Class describing a country
 */
.factory('bil.Country',
['ErrorMixin',
function CountryFactory(ErrorMixin) {
/**
   * Country constructor
   *
   * @param {Object} apiCountry
   * @constructor
   */
  var Country = function (apiCountry) {
    /**
     * Country code ex: pl, ro, en
     *
     * @type {String}
     */
    this.code = apiCountry ? apiCountry.code : '';

    /**
     * Country name
     *
     * The name is in the currently used language
     *
     * @type {String}
     */
    this.name = apiCountry ? apiCountry.name : '';

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Add instance methods
  Country.prototype = /** @lends Country.prototype */ {

    /**
     * Set country code
     *
     * @param {String} code
     */
    setCode: function (code) {
      this.code = code;
    },

    /**
     * Get country code
     *
     * @return {String}
     */
    getCode: function () {
      return this.code;
    },

    /**
     * Get country name
     *
     * @return {String}
     */
    getName: function () {
      return this.name;
    },

    setName: function(name) {
      this.name = name;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        'code': this.code,
        'name': this.name
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Country}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.code = errors.code;
      this.errors.name = errors.name;

      return this;
    },

    /**
     * Set country form API object
     *
     * @param {Object} srvData
     *
     * @return {Country}
     */
    srvSet: function (srvData) {
      this.code = (srvData && srvData.code) ? srvData.code : this.code;
      this.name = (srvData && srvData.name) ? srvData.name : this.name;

      return this;
    }

  };

  Country.prototype.constructor = Country;

  // Add mixins
  _.extend(Country.prototype, ErrorMixin);

  return Country;
}]);

;

// Source: ../shared/public_html/assets/js/billing/models/IdCard.js
(function (angular, underscore) {
/**
   * @name        BillingIdCardFactory
   * @description Class that holds a person ID card information
   * @constructor
   * @author Floares Bogdan <bogdan.floares@vola.ro>
   */
  var BillingIdCardFactory = function (ErrorMixin, FormErrorMixin, AppConfig) {
    /**
     * IdCard constructor
     *
     * @constructor
     * @class IdCard
     */
    var IdCard = function () {
      /**
       * Id card number
       *
       * @type {String}
       */
      this.number = '';

      /**
       * Expiration date
       *
       * @type {NgDate}
       */
      this.expiration = null;

      /**
       * Issue date.
       *
       * @type {NgDate}
       */
      this.issueDate = null;

      /**
       * Should issue date be serialized?
       *
       * @type {bool}
       */
      this.serializeIssueDate = true;

      /**
       * The issuing country code ex: RO, PL, US
       *
       * @type {String}
       */
      this.issueCountry = AppConfig.getDefaultCountryCode();

      /**
       * Document type
       *
       * @type {'PASSPORT' | 'GOV_ID' | null}
       */
      this.docType = null;

      /**
       * Errors object
       *
       * @type {Object}
       */
      this.errors = {};
      this.id = null;
    };

    // Add instance methods
    IdCard.prototype = /** @lends IdCard.prototype */ {

      /**
       * set id card number
       *
       * @param {String} number
       */
      setNumber: function (number) {
        this.number = number;
      },

      /**
       * Returns id card number
       *
       * @returns {String}
       */
      getNumber: function () {
        return this.number;
      },

      /**
       * Get expiration date
       *
       * @return {NgDate}
       */
      getExpDate: function () {
        return this.expiration;
      },

      /**
       * Set expiration date
       *
       * @param {NgDate|String} expDate If you pass date as a string it must be in YYYY-MM-DD or YYYY-MM-DD HH:MM:SS format
       *
       * @return {IdCard}
       */
      setExpDate: function (expDate) {
        var dateMoment = moment(expDate);
        this.expiration = dateMoment.isValid() ? dateMoment.format('YYYY-MM-DD') : null;
        return this;
      },

      /**
       * Returns issue date.
       *
       * @returns {NgDate}
       */
      getIssueDate: function () {
        return this.issueDate;
      },

      /**
       * Sets a new issue date.
       *
       * @param {NgDate} date
       *
       * @returns {Passport}
       */
      setIssueDate: function (date) {
        var dateMoment = moment(date);
        this.issueDate = dateMoment.isValid() ? dateMoment.format('YYYY-MM-DD') : null;
        return this;
      },

      /**
       * Returns issuing country code
       *
       * @returns {String} The country code ex: PL, RO, US, ...
       */
      getIssuingCountry: function () {
        return this.issueCountry;
      },

      /**
       * Set issuing country code
       *
       * @param {String} issueCountry The issuing country code ex. PL, RO, US
       *
       * @returns {IdCard}
       */
      setIssuingCountry: function (country) {
        this.issueCountry = country;
        return this;
      },

      getDocumentType: function () {
        return this.docType;
      },

      setDocumentType: function (type) {
        this.docType = type;
        return this;
      },

      setDocumentId: function (id) {
        this.id = id;
        return this;
      },

      getDocumentId: function () {
        return this.id;
      },

      /**
       * Returns true if object is in error state
       *
       * @return {bool}
       */
      hasErrors: function () {
        return underscore.reduce(this.errors, function (memo, err) {
          if (underscore.isObject(err)) {
            return memo || err.hasErrors();
          }
          else {
            return memo || !!err;
          }
        }, false);
      },

      /**
       * Returns this instance as simple object for communicating with API
       *
       * @return {Object}
       */
      srvObj: function () {
        return {
          number: this.number,
          expiration: this.expiration,
          issued: this.serializeIssueDate ? this.issueDate : null,
          issue_country: this.issueCountry,
          doc_type: this.docType,
          id: this.id,
        };
      },

      /**
       * Set errors form server
       *
       * @param {Object} errors
       *
       * @return {IdCard}
       */
      srvErrors: function (errors) {
        // Reset errors
        this.resetErrors();

        // If errors is not an object we bail out
        if (!underscore.isObject(errors)) errors = {};

        this.errors.number = errors.number;
        this.errors.issueCountry = errors.issue_country;
        this.errors.issueDate = errors.issued;
        this.errors.expiration = errors.expiration;

        return this;
      },

      /**
       * Set ID card from API object
       *
       * @param {Object} srvData
       *
       * @return {IdCard}
       */
      srvSet: function (srvData) {
        this.setNumber(srvData.number);
        this.setIssuingCountry(srvData.issue_country);
        this.setIssueDate(srvData.issued);
        this.setExpDate(srvData.expiration);
        this.setDocumentType(srvData.doc_type || null);
        this.setDocumentId(srvData.id || null);
        return this;
      }
    };

    IdCard.prototype.constructor = IdCard;

    // Add mixins
    underscore.extend(IdCard.prototype, ErrorMixin);
    underscore.extend(IdCard.prototype, FormErrorMixin);

    return IdCard;
  };

  BillingIdCardFactory.$inject = [
    'ErrorMixin',
    'FormErrorMixin',
    'appConfig'
  ];

  angular.module('billing')
    .factory('bil.IdCard', BillingIdCardFactory);
})(angular, _);
;

// Source: ../shared/public_html/assets/js/billing/models/Person.js
(function (angular, moment) {
/**
     * @name PersonFactory
     * @description Person factory
     * @param IdCard
     * @param ContactDetails
     * @param ErrorMixin
     * @param FormErrorMixin
     * @returns {Person}
     * @constructor
     */
    var PersonFactory = function (IdCard, ErrorMixin, FormErrorMixin, ContactPhone, Country, appConfig) {

        /**
         * Person constructor
         *
         * @constructor
         * @class Person
         */
        var Person = function () {

            /**
             * ID
             *
             * @type {string}
             */
            this.id = '';

            this.phone = new ContactPhone();

            /**
             * Pax type: ADT, CHD, INF
             *
             * @type {String}
             */
            this.paxType = 'ADT';

            /**
             * First name
             *
             * @type {String}
             */
            this.firstName = '';

            /**
             * Gender
             *
             * @type {String}
             */
            this.gender = '';

            /**
             * Last name
             *
             * @type {String}
             */
            this.lastName = '';

            /**
             * Birth date
             *
             * @type {NgDate}
             */
            this.birthDate = null;

            /**
             * Person nationality
             *
             * @type {Country}
             */
            this.nationality = appConfig.getDefaultCountryCode();

            /**
             * Identification card number
             *
             * @type {IdCard}
             */
            this.idCard = new IdCard();

            /**
             * Helper with date range for default dates of paxes
             * @type {boolean}
             */
            this.birthDateRage = {ADT: 20, CHD: 8, INF: 1, YTH: 15, SRC: 70};

            /**
             * Add new pax to profile
             * @type {boolean}
             */
            this.addToProfile = false;

            /**
             * Decides if id card data is serialized or not
             *
             * @type {Boolean}
             */
            this.serializeIdCard = true;

            /**
             * Errors object
             *
             * Used in templates to mark error fields and show error messages
             * The keys are filed names and values are error messages or instances.
             *
             * Example:
             *
             * {
             *  property_name: "error message",
             *  property_with_some_instance: that instance
             * }
             *
             * @type {Object}
             */
            this.errors = {};
        };

        // Add instance methods
        Person.prototype = /** @lends Person.prototype */ {

            /**
             * Reset person data
             */
            reset: function () {
                this.id = '';
                this.firstName = '';
                this.lastName = '';
                this.nationality = appConfig.getDefaultCountryCode();
                this.birthDate = null;
                this.idCard = new IdCard();
                this.addToProfile = true;
                this.resetErrors();
            },

            getId: function () {
                return this.id;
            },

            /**
             * Returns person type
             *
             * @return {String}
             */
            getType: function () {
                return this.paxType;
            },

            /**
             * Sets person type
             *
             * @param {String} paxType One of the ADT, CHD, INF, ...
             *
             * @return {Person}
             */
            setType: function (paxType) {
                this.paxType = paxType;
                return this;
            },

            getGender: function () {
                return this.gender;
            },

            setGender: function(gender) {
                this.gender = gender;
                return this;
            },

            getFullName: function () {
                return this.firstName + ' ' + this.lastName;
            },

            /**
             * Returns first name
             *
             * @returns {String}
             */
            getFirstName: function () {
                return this.firstName;
            },

            /**
             * Set first name
             *
             * @param {String} firstName
             */
            setFirstName: function (firstName) {
                this.firstName = firstName;

                return this;
            },

            /**
             * Returns last name
             *
             * @returns {String}
             */
            getLastName: function () {
                return this.lastName;
            },

            /**
             * Set last name
             *
             * @param {String} lastName
             */
            setLastName: function (lastName) {
                this.lastName = lastName;

                return this;
            },

            getNationality: function () {
                return this.nationality;
            },

            /**
             * Add to profile
             * @param value
             */
            setAddToProfile: function (value) {
                this.addToProfile = value;
            },

            /**
             * Get pax birth date
             *
             * @return {NgDate}
             */
            getBirthDate: function () {
                return this.birthDate;
            },

            validateBirthDate: function (depDate) {
                var depDateMy = moment(depDate);
                var dateDiff = depDateMy.diff(moment(this.birthDate), 'years');

                if (dateDiff > 200 || dateDiff < 18) {
                    return false;
                }
                return true;
            },

            /**
             * Set pax birth date
             *
             * @param {NgDate|String} birthDate If you pass date as a string it must be in YYYY-MM-DD or YYYY-MM-DD HH:MM:SS format
             *
             * @return {Person}
             */
            setBirthDate: function (birthDate) {
                var dateMoment = moment(birthDate);
                this.birthDate = dateMoment.isValid() ? dateMoment.format('YYYY-MM-DD') : null;
                return this;
            },

            /**
             * Returns id card
             *
             * @returns {IdCard}
             */
            getIdCard: function () {
                return this.idCard;
            },

            /**
             * Sets nationality
             *
             * @param  {Country|Object} country
             *
             * @return {Person}
             */
            setNationality: function (country) {
                this.nationality = country;
                return this;
            },

            getPhone: function () {
                return this.phone;
            },

            getPhoneFormatted: function () {
                return this.phone.prefix + ' ' + this.phone.number;
            },

            /**
             * Returns this instance as simple object for communicating with API
             *
             * @return {Object}
             */
            srvObj: function () {
                return {
                    id: this.id,
                    type: this.paxType,
                    gender: this.gender,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    birth_date: this.birthDate,
                    phone: this.phone.srvObj(),
                    email: this.email,
                    id_card: this.serializeIdCard ? this.idCard.srvObj() : null,
                    addToProfile: this.id === '' ? this.addToProfile : false,
                    nationality: this.nationality
                };
            },

            /**
             * Set errors form server
             *
             * @param {Object} errors
             *
             * @return {Person}
             */
            srvErrors: function (errors) {
                // Reset errors
                this.resetErrors();

                // If errors is not an object we bail out
                if (!_.isObject(errors)) {
                    errors = {};
                }

                this.errors.birthDate = errors.birth_date;
                this.errors.firstName = errors.first_name;
                this.errors.lastName = errors.last_name;

                if (this.idCard !== null) {
                    this.idCard.srvErrors(errors.id_card);
                }

                return this;
            },

            /**
             * Set person from API object
             *
             * @param {Object} srvData
             *
             * @return {Person}
             */
            srvSet: function (srvData) {
                this.id = srvData.id || '';
                var wasIdCardDeserialised = false;

                // Set basic information
                this.setType(srvData.pax_type || srvData.type);

                if (srvData.first_name) {
                    this.firstName = srvData.first_name;
                }

                if (srvData.last_name) {
                    this.lastName = srvData.last_name;
                }

                if (srvData.nationality) {
                    this.setNationality(srvData.nationality);
                }

                if (srvData.birth_date) {
                    // Set birth date
                    this.setBirthDate(srvData.birth_date);
                }

                if (srvData.gender) {
                    this.setGender(srvData.gender);
                }

                if (srvData.idCard) {
                    // Set ID card
                    this.idCard.srvSet(srvData.idCard);
                    wasIdCardDeserialised = true;
                }

                if (srvData.phone) {
                    this.phone.srvSet(srvData.phone);
                }

                if (srvData.email) {
                    this.email = srvData.email;
                }

                if (srvData.id_card) { // Set ID card
                    this.idCard.srvSet(srvData.id_card);
                    wasIdCardDeserialised = true;
                }

                this.serializeIdCard = wasIdCardDeserialised;

                return this;
            },

            /**
             * Chech if Pax is INF.
             * Utility method for `Pax.canHaveBaggage`.
             * @returns {boolean}
             */
            isInf: function () {
                return this.paxType === 'INF';
            }
        };

        Person.prototype.constructor = Person;

        // Add mixins
        _.extend(Person.prototype, ErrorMixin);
        _.extend(Person.prototype, FormErrorMixin);

        return Person;
    };

    PersonFactory.$inject = [
        'bil.IdCard',
        'ErrorMixin',
        'FormErrorMixin',
        'ContactPhone',
        'bil.Country',
        'appConfig'
    ];

    angular.module('billing')
        .factory('bil.Person', PersonFactory);
})(angular, moment);
;

// Source: ../shared/public_html/assets/js/billing/models/Province.js
/* global _: false */

angular.module('billing')

/**
 * @name        Province
 * @namespace   bil
 * @description Class describing province
 */
.factory('bil.Province',
['ErrorMixin',
function ProvinceFactory(ErrorMixin) {
/**
   * Country constructor
   *
   * @param {Object} apiProvince
   *
   * @constructor
   */
  var Province = function (apiProvince) {
    /**
     * Province id
     *
     * @type {Number}
     */
    this.id = apiProvince ? apiProvince.id : 0;

    /**
     * Province name
     *
     * @type {String}
     */
    this.name = apiProvince ? apiProvince.name : '';

    /**
     * Country code for the province
     *
     * @type {String}
     */
    this.countryCode = apiProvince ? apiProvince.country_code : '';

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Add instance methods
  Province.prototype = /** @lends Province.prototype */ {

    /**
     * Get province id
     *
     * @return {Number}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Get country code
     *
     * @return {String}
     */
    getCountryCode: function () {
      return this.countryCode;
    },

    /**
     * Get country name
     *
     * @return {String}
     */
    getName: function () {
      return this.name;
    },
    /**
     * set country name
     *
     * @return {String}
     */
    setName: function (name) {
      return this.name = name;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        'id': this.id,
        'name': this.name,
        'country_code': this.countryCode
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Province}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.id = errors.id;
      this.errors.name = errors.name;
      this.errors.countryCode = errors.country_code;

      return this;
    },

    /**
     * Set province from API object
     *
     * @param {Object} srvData
     *
     * @return {Province}
     */
    srvSet: function (srvData) {
      this.id = srvData.id;
      this.name = srvData.name;
      this.countryCode = srvData.country_code;

      return this;
    }
  };

  Province.prototype.constructor = Province;

  // Add mixins
  _.extend(Province.prototype, ErrorMixin);

  return Province;
}]);
;

// Source: ../shared/public_html/assets/js/book/booking-bt-info/bt-bank.model.js
(function(angular) {
/**
     * Bt Bank Model
     */
    var BtBankModel = function () {
        /**
         * Bt Bank
         *
         * @param {String} id
         * @param {String} name
         * @param {String} address
         *
         * @constructor
         */
        var BtBank = function (id, name, address) {
            this.id = id;
            this.name = name;
            this.address = address;
            this.ibans = {};
        };

        /**
         * Adds an IBAN
         *
         * @param {String} currency
         * @param {String} iban
         */
        BtBank.prototype.addIban = function (currency, iban) {
            this.ibans[currency] = iban;
        };

        /**
         * Returns bank IBAN by currency
         *
         * @param {String} currency
         * @returns {String}
         */
        BtBank.prototype.getIban = function (currency) {
            return this.ibans[currency];
        };

        BtBank.prototype.constructor = BtBank;

        return BtBank;
    };

    angular
        .module('book')
        .factory('BtBank', BtBankModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-bt-info/bt-config.service.js
(function(angular) {
/**
     * Config for bank payment information on thank you page
     */
    var BtConfigService = function (BtBank, CURRENCY_CODES, AppConfig) {
        /**
         * Bank list
         *
         * @type {BtBank[]}
         */
        this.banks = [];

        /**
         * Default currency for bank transfer
         *
         * @type {String}
         */
        this.defaultCurrency = '';

        /**
         * Bank transfer beneficiary
         *
         * @type {String}
         */
        this.beneficiary = '';

        /**
         * Bank transfer beneficiary id
         *
         * @type {String}
         */
        this.beneficiaryId = '';

        /**
         * Flag for showing/hiding currency select
         *
         * @type {Boolean}
         */
        this.showCurrencySelect = true;

        /**
         * Flag for showing/hiding fast payment CTA
         *
         * @type {Boolean}
         */
        this.showFastPaymentCta = false;

        if (AppConfig.isVola()) {
            var transilvania = new BtBank('bt', 'Banca Transilvania', 'Sucursala Magheru, Agentia Lipscani');
            transilvania.addIban(CURRENCY_CODES.RON, 'RO96 BTRL 0410 1202 S670 8200');
            transilvania.addIban(CURRENCY_CODES.EUR, 'RO23 BTRL 0410 4202 S670 8200');
            this.banks.push(transilvania);

            var garanti = new BtBank('garanti', 'Garanti', 'Sucursala Magheru');
            garanti.addIban(CURRENCY_CODES.RON, 'RO27 UGBI 0000 1320 1960 5RON');
            garanti.addIban(CURRENCY_CODES.EUR, 'RO20 UGBI 0000 1320 1960 6EUR');
            this.banks.push(garanti);

            var brd = new BtBank('brd', 'BRD', 'Sucursala Unirea');
            brd.addIban(CURRENCY_CODES.RON, 'RO71 BRDE 441S V399 7580 4410');
            brd.addIban(CURRENCY_CODES.EUR, 'RO16 BRDE 441S V634 1501 4410');
            this.banks.push(brd);

            this.defaultCurrency = CURRENCY_CODES.RON;
            this.beneficiary = 'S.C. Vola.ro SRL';
            this.beneficiaryId = 'RO 17043146';
        } else if(AppConfig.isGovola() && AppConfig.getMarket() === 'bg') {
            var bank = new BtBank('dsk', 'DSK Bank', '');
            bank.addIban(CURRENCY_CODES.EUR, 'BG 22 STSA 9300 0029 8410 65');
            bank.addIban(CURRENCY_CODES.BGN, 'BG 28 STSA 9300 0029 8410 54');
            this.banks.push(bank);

            this.defaultCurrency = CURRENCY_CODES.BGN;
            this.beneficiary = 'SC Vola.ro SRL';
            this.beneficiaryId = 'STSABGSF';
            this.showFastPaymentCta = false;
        } else if (!AppConfig.isVola()) {
            var alior = new BtBank('alior', 'Alior', '');
            alior.addIban(CURRENCY_CODES.PLN, '30 2490 0005 0000 4530 4173 3210');
            this.banks.push(alior);

            this.defaultCurrency = CURRENCY_CODES.PLN;
            this.beneficiary = 'FRU.PL S.A.';
            this.beneficiaryId = '';
            this.showCurrencySelect = false;
            this.showFastPaymentCta = true;
        }
    };

    BtConfigService.$inject = ['BtBank', 'CURRENCY_CODES', 'appConfig'];

    angular
        .module('book')
        .service('BtConfig', BtConfigService);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-bt-info/bt-currency-codes.constant.js
(function(angular) {
angular
        .module('book')
        .constant('CURRENCY_CODES', {
            RON: 'RON',
            EUR: 'EUR',
            PLN: 'PLN',
            BGN: 'BGN',
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-bt-info/copy-paste.component.js
(function(angular, navigator) {
var template = '<div class="ith-copy-paste" ng-click="$ctrl.copy()">\
        <strong class="ith-copy-paste__label">{{ $ctrl.label }}</strong>\
        <div class="ith-copy-paste__box" ng-class="{ \'ith-copy-paste--feedback\': $ctrl.showFeedback }">\
            <div class="ith-copy-paste__box__info">\
                <span>{{ $ctrl.value }}</span>\
                <svg-icon id="clipboard"></svg-icon>\
            </div>\
            <div class="ith-copy-paste__box__feedback">\
                <svg-icon id="check"></svg-icon>\
                <span translate>LANGM_JS_COPIED_TO_CLIPBOARD</span>\
            </div>\
        </div >\
    </div>';

    /**
     * Component controller
     */
    var ctrl = function ($timeout) {
        /**
         * Context
         *
         * @type {Object}
         */
        var context = this;

        /**
         * Feedback display flag
         *
         * @type {Boolean}
         */
        this.showFeedback = false;

        /**
         * Copies a value to clipboard
         *
         * @param {String} value
         * @private
         */
        var copyToClipboard = function (value) {
            if (navigator.clipboard !== undefined) {
                navigator.clipboard.writeText(value);
            }

            if (window.clipboardData) {
                // Internet Explorer
                window.clipboardData.setData('Text', value);
            }
        };

        /**
         * Copies the component value into the clipboard
         */
        this.copy = function () {
            if (this.showFeedback) {
                return;
            }

            var copyValue = !!this.removeSpaces ? this.value.split(' ').join('') : this.value;
            copyToClipboard(copyValue);
            this.showFeedback = true;

            $timeout(function () {
                context.showFeedback = false;
            }, 2000);
        };
    };

    ctrl.$inject = ['$timeout'];

    angular
        .module('book')
        .component('ithCopyPaste', {
            controller: ctrl,
            template: template,
            bindings: {
                label: '@',
                value: '@',
                removeSpaces: '@'
            }
        });

}(angular, navigator));
;

// Source: ../shared/public_html/assets/js/book/booking-bt-info/ith-booking-bt-info.component.js
(function(angular) {
/**
     * Bt Info controller
     */
    var controller = function (BtConfig, CURRENCY_CODES, AppConfig) {
        /**
         * BT info config
         *
         * @type {BtConfig}
         */
        this.conf = BtConfig;

        /**
         * Selected bank index
         *
         * @type {Number}
         */
        this.selectedBankIndex = 0;

        /**
         * Selected currency
         *
         * @type {String}
         */
        this.selectedCurrency = BtConfig.defaultCurrency;

        /**
         * Selected IBAN
         *
         * @type {String}
         */
        this.selectedIban = '';

        /**
         * Currency codes enum
         *
         * @type {CURRENCY_CODES}
         */
        this.currencyCodes = CURRENCY_CODES;

        /**
         * Change hook
         */
        this.$doCheck = function () {
            this.selectedIban = this.conf.banks[this.selectedBankIndex].getIban(this.selectedCurrency);

            if (AppConfig.isFru() && this.booking) {
                // For FRU beneficiary id is reservation number
                this.conf.beneficiaryId = this.booking.getReservationNumber();
            }
        };

        /**
         * Selects a bank by index
         *
         * @param {Number} index
         */
        this.selectBank = function (index) {
            this.selectedBankIndex = index;
        };

        /**
         * Get aff name
         */
        this.getAffiliateName = function () {
            return AppConfig.getAffiliateName();
        };
    };

    controller.$inject = ['BtConfig', 'CURRENCY_CODES', 'appConfig'];

    angular
        .module('book')
        .component('ithBookingBtInfo', {
            templateUrl: '/tpl/show/jsShared/templates/flights/booking/bt-info',
            controller: controller,
            bindings: {
                booking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-header-info/ith-booking-header-info.component.js
(function(angular) {
var template = '<div class="typ-summary__details__header-info">\
        <div ng-if="$ctrl.hasFlightDetails()">\
            <div translate="LANGM_JS_TY_BOOKING_HEADER_INFO" translate-values="{ number: $ctrl.getReservationNumber() }"></strong></div>\
            <div><strong>{{ $ctrl.getDepCity() }}</strong> - <strong>{{ $ctrl.getDesCity() }}</strong>, <span class="dates">{{ $ctrl.getDepDate() }} <span ng-if="!$ctrl.isOneWay()"> - {{ $ctrl.getRetDate() }}</span></span></div>\
        </div>\
    </div>';

    /**
     * Format for displaying dates
     *
     * @type {String}
     */
    var dateFormat = 'dd MMM yyyy';

    /**
     * Header infor controller
     */
    var controller = function (Dictionaries, $filter) {
        /**
         * Checks if flight details are loaded
         *
         * @returns {Boolean}
         */
        this.hasFlightDetails = function () {
            return this.flightBooking.getFlightDetails() !== null;
        };

        /**
         * Returns translated departure city
         *
         * @returns {String}
         */
        this.getDepCity = function () {
            return Dictionaries.getCityNameByCode(this.flightBooking.getFlightDetails().getDepLeg().getDepCityCode(), false);
        };

        /**
         * Returns translated destination city
         *
         * @type {String}
         */
        this.getDesCity = function () {
            return Dictionaries.getCityNameByCode(this.flightBooking.getFlightDetails().getDepLeg().getArrCityCode(), false);
        };

        /**
         * Returns reservation number
         *
         * @returns {String}
         */
        this.getReservationNumber = function () {
            return this.flightBooking.getReservationNumber();
        };

        /**
         * Returns departure date formatted
         *
         * @returns {String}
         */
        this.getDepDate = function () {
            return $filter('date')(
                this.flightBooking.getFlightDetails().getDepLeg().getDepDate(),
                dateFormat
            );
        };

        /**
         * Returns return date formatted
         *
         * @returns {String}
         */
        this.getRetDate = function () {
            return $filter('date')(
                this.flightBooking.getFlightDetails().getRetLeg().getDepDate(),
                dateFormat
            );
        };

        /**
         * Returns flag if flight is one-way
         *
         * @type {Boolean}
         */
        this.isOneWay = function () {
            return this.flightBooking.getFlightDetails().isOneWay();
        };
    };

    controller.$inject = ['Dictionaries', '$filter'];

    angular
        .module('book')
        .component('ithBookingHeaderInfo', {
            template: template,
            bindings: {
                flightBooking: '<'
            },
            controller: controller
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-paxes-info/booking-paxes-details.component.js
(function(angular) {
var template = '\
        <div class="booking-pax-luggage">\
            <div ng-repeat="pax in $ctrl.booking.paxes" class="pax-luggage">\
                <h4>{{ pax.person.getFirstName() }} {{ pax.person.getLastName() }}</h4>\
                <div>\
                    <ul class="list-unstyled">\
                        <li><span ng-show="pax.person.getBirthDate() !== null">{{ pax.person.getBirthDate() | date:\'d MMMM yyyy\' }}, </span>{{ $ctrl.getPaxTypeTranslated(pax.person.paxType) }}</li>\
                        <li>{{ $ctrl.getCountryNameByCode(pax.person.nationality) }}</li>\
                    </ul>\
                    <ith-ibe-pax-luggage\
                        booking="$ctrl.booking"\
                        pax="pax">\
                    </ith-ibe-pax-luggage>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function ($translate, Locations) {
        this.$onInit = function () {
            var self = this;

            Locations.getCountries().then(function (resp) {
                self.countries = resp;
            });
        };

        this.getPaxTypeTranslated = function (paxType) {
            return $translate.instant('LANGM_JS_' + paxType + '_PAX_TYPE');
        };

        this.getCountryNameByCode = function (code) {
            var found = '';

            angular.forEach(this.countries, function (country) {
                if (country.code === code) {
                    found = country.name;
                }
            });

            return found;
        };
    };

    controller.$inject = ['$translate', 'Locations'];

    var IthBookingPaxesDetailsComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('book')
        .component('ithBookingPaxesDetails', IthBookingPaxesDetailsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/booking-summary/ith-booking-summary.component.js
(function(angular) {
var template = '\
        <div class="typ-summary">\
            <div class="typ-summary__status" ng-transclude></div>\
            <div class="typ-summary__details">\
                <ith-booking-header-info flight-booking="$ctrl.flightBooking"></ith-booking-header-info>\
                <div class="typ-summary__details__items">\
                    <strong class="typ-summary__details__items__title" translate>LANGM_JS_TY_BOOKING_SUMMARY_TITLE</strong>\
                    <div\
                        ng-if="$ctrl.flightBooking !== null && $ctrl.flightBooking.getFlightDetails() !== null"\
                        order-summary\
                        flight-booking="$ctrl.flightBooking">\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    angular
        .module('book')
        .component('ithBookingSummary', {
            template: template,
            transclude: true,
            bindings: {
                flightBooking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/directives/blikForm.js
angular.module('book')

    /**
     * @name        bookBlikForm
     * @description Blik form directive
     */
    .directive('bookBlikForm', function bookBlikForm() {
return {
            restrict: 'E',
            replace: true,
            controller: 'blikFormCtrl',
            templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/payment/blikCodeTemplate',
            scope: {
                /**
                 * Model passed is in the form of Blik Code object
                 *
                 * @type {BlikCode}
                 */
                model: '=?ngModel',

                /**
                 * Form controller passed to this directive
                 *
                 * @type {FormController}
                 */
                formCtrl: '=',

                /**
                 * Enables and disables the credit card form
                 *
                 * @type {Boolean}
                 */
                isdisabled: '=',

                /**
                 * payment type
                 */
                paymentType: '=?',

                basket: '=?'
            }
        };
    });

;

// Source: ../shared/public_html/assets/js/book/directives/ccForm.js
angular.module('book')

/**
 * @name        bookCcForm
 * @description Credit card form directive
 */
    .directive('bookCcForm',
        ['bok.CreditCard', '$rootScope', 'appConfig', 'PaymentTokenize', 'Locations',
            function bookCcForm(CreditCard, $rootScope, appConfig, PaymentTokenize, Locations) {
return {
                    restrict: 'E',
                    replace: true,
                    controller: "ccFormCtrl",
                    templateUrl: function (element, attrs) {
                        return attrs.templateUrl || '/tpl/show/jsShared/templates/flights/flightDetails/pax/payment/creditCardTemplate';
                    },
                    //templateUrl: '/mtpl/ccForm.html',
                    scope: {
                        /**
                         * Model passed is in the form of credit card object
                         *
                         * @type {CreditCard}
                         */
                        model: '=?ngModel',

                        /**
                         * Form controller passed to this directive
                         *
                         * @type {FormController}
                         */
                        formCtrl: '=',

                        /**
                         * Enables and disables the credit card form
                         *
                         * @type {Boolean}
                         */
                        isdisabled: '=',

                        /**
                         * payment type
                         */
                        paymentType: '=?',

                        basket: '=?'
                    },
                    link: function (scope, element, attrs) {

                        // Instantiate credit card class
                        var creditCard = new CreditCard();

                        scope.defaultCountry = appConfig.getDefaultCountryCode();

                        scope.countries = [];

                        // Update credit card type in billing payment
                        scope.updateCC = function () {
                            // Get credit card information from number
                            var card = creditCard.cardFromNumber(scope.model.getNumber());

                            // Set credit card data
                            scope.model.setType(card.type).setId(card.id);
                        };

                        /**
                         * Credit card expiry data
                         *
                         * @type {Object}
                         */
                        scope.ccExpData = {months: [], years: []};

                        /**
                         * Generate credit card expiry data
                         */
                        scope.generateCcExpData = function () {
                            // Generate months
                            for (var m = 0; m <= 11; m++) {
                                scope.ccExpData.months.push({
                                    label: moment().month(m).format('MMMM'),
                                    value: m
                                });
                            }

                            // Generate years
                            var currYear = moment().year();

                            for (var y = currYear; y < currYear + 12; y++) {
                                scope.ccExpData.years.push({
                                    label: y,
                                    value: y
                                });
                            }
                        };

                        /**
                         * @returns {string[]}
                         */
                        scope.getRequiredBillingFields = function () {
                            var credential = PaymentTokenize.findCredential({
                                currency: scope.model.currency || appConfig.getCurrencyCode(),
                                paymentType: 'CC'
                            });

                            return credential.hasOwnProperty('requiredBillingFields')
                                ? credential.requiredBillingFields
                                : [];
                        };

                        /**
                         * @returns {boolean}
                         */
                        scope.isCountryCodeRequired = function () {
                            return scope.getRequiredBillingFields().indexOf('country_code') !== -1;
                        };

                        /**
                         * @returns {boolean}
                         */
                        scope.isZipCodeRequired = function () {
                            return scope.getRequiredBillingFields().indexOf('zip_code') !== -1;
                        };

                        /**
                         * Initiate credit card expiry data
                         */
                        scope.generateCcExpData();

                        Locations.getCountries(true).then(function(resp) {
                            scope.countries = resp;
                        });
                    }
                };
            }]);

;

// Source: ../shared/public_html/assets/js/book/directives/ccValid.js
angular.module('book')

/**
 * @name        bookCcValid
 * @description Validates credit card number
 */
.directive('bookCcValid',
['bok.CreditCard',
  function bookCcValid(CreditCard) {
return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attrs, ctrl) {
        var cc = new CreditCard();

        // Set parsers
        ctrl.$parsers.unshift(ccValidator);

        // Set formatters
        ctrl.$formatters.unshift(ccValidator);

        // Bind validator to blur
        // element.bind('blur', function()
        // {
        //   ccValidator(ctrl.$viewValue);
        // });

        //var $timer = null;

        /**
         * Checks if current credit card number is valid
         *
         * @param  {String} value
         *
         * @return {String}
         */
        function ccValidator(value) {
          ctrl.$setValidity('ccnumber', true);

          // Make sure we kick in only when user writes something in the field
          if (!value || value.length == 0) {
            return value;
          }

          //if ($timer) clearTimeout($timer);

          // Set validity of the form element
          //$timer = setTimeout(function()
          //{
            ctrl.$setValidity('ccnumber', cc.validateCardNumber(value));
            //scope.$digest();
          //}, 0);

          // Return value
          return value;
        }
      }
    };
  }]);

;

// Source: ../shared/public_html/assets/js/book/directives/cnSplit.js
angular.module('book')

/**
 * @name        bookCnSplit
 * @description Splits the credit card number in series of 4
 */
.directive('bookCnSplit',
[function bookCnSplit() {
return {
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      /**
       * Split string in groups of 4
       *
       * @param  {String} inputValue
       *
       * @return {String}
       */
      var split = function (inputValue) {
        if (angular.isUndefined(inputValue)) {
          return '';
        }

        var newValue = '', joinedValue = inputValue.split(' ').join('');

        for (var i = 0; i < joinedValue.length; i++) {
          newValue += joinedValue.charAt(i);
          if ((i + 1) % 4 == 0 && i > 0) {
            newValue += ' ';
          }
        }

        newValue = newValue.trim();

        if (newValue != inputValue) {
          // Render the new value
          ctrl.$setViewValue(newValue);
          ctrl.$render();
        }

        // Set caret position to the end of the input
        //setCaretPosition(element[0], newValue.length);
        moveCursorToEnd(element[0]);

        return newValue;
      };

      /**
       * Set caret position function
       *
       * @param {domObject} elm
       * @param {Number}    pos
       */
      var setCaretPosition = function (elm, pos) {
        pos = 1;
        if (elm != null) {
          if (elm.createTextRange) {
            var range = elm.createTextRange();
            range.move('character', pos);
            range.select();
            return true;
          }
          else {
            if (elm.selectionStart || elm.selectionStart === 0) {
              elm.focus();
              elm.setSelectionRange(pos, pos);
              return true;
            }
            else {
              elm.focus();
              return false;
            }
          }
        }
      };

      /**
       * Moves caret position to end of element
       *
       * @param {DOMElement} el
       */
      var moveCursorToEnd = function (el) {
        if (typeof el.selectionStart == "number") {
          el.selectionStart = el.selectionEnd = el.value.length;
        } else if (typeof el.createTextRange != "undefined") {
          el.focus();
          var range = el.createTextRange();
          range.collapse(false);
          range.select();
        }
      };

      // Update input
      ctrl.$parsers.unshift(split);
      //ctrl.$formatters.unshift(split);
      //split(scope[attrs.ngModel]);
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/book/directives/minMaxValid.js
(function (angular) {

    /**
     * @name        bookCcValid
     * @description Validates credit card number
     */
    var RangeValidatorDirective = function() {
return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attributes, ctrl) {

                var range = scope.$eval(attributes.rangeValidator);

                element.on('blur', function () {
                    var valueLength = ctrl.$viewValue.replace(/[ _]+/g, '').length;
                    var hasMinLength = !(valueLength < range.min);
                    var hasMaxLength = !(valueLength > range.max);

                    ctrl.$setValidity('minlength', hasMinLength);
                    ctrl.$setValidity('maxlength', hasMaxLength);
                });


            }
        };
    };

    RangeValidatorDirective.$inject = [];

    angular.module('book').directive('rangeValidator', RangeValidatorDirective);
})(angular);



;

// Source: ../shared/public_html/assets/js/book/directives/pblForm.js
(function (angular) {
var controller = function () {
        this.isSelected = function (vendor) {
            return vendor.code === this.model.bankCode;
        };

        this.select = function (vendor) {
            this.model.bankCode = vendor.code;
        };

        this.$onInit = function () {
            // Preselect first vendor
            this.select(this.model.getAvailableVendors()[0]);
        };
    };

    angular.module('book').component('bookPblForm', {
        controller: controller,
        templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/payment/pblTemplate',
        bindings: {
            /**
             * Model passed is in the form of PBL object
             *
             * @type {BlikCode}
             */
            model: '=?ngModel',

            /**
             * Form controller passed to this directive
             *
             * @type {FormController}
             */
            formCtrl: '=',

            /**
             * Enables and disables the credit card form
             *
             * @type {Boolean}
             */
            isdisabled: '=',

            /**
             * payment type
             */
            paymentType: '=?',

            basket: '=?'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-lower-price.component.js
(function (angular) {

    var template = '\
        <div>\
            <div class="basicBox" ng-if="$ctrl.isVisible()">\
                <div class="basicBox__container fare-lock__lower-price-box">\
                    <img src="/assets/img/ui/icons/svg/thumbs-up.svg" />\
                    <div class="fare-lock__lower-price-box__content">\
                        <h3 translate>LANGM_JS_FL_LOWER_PD_TITLE</h3>\
                        <p translate translate-values="{ oldPrice: $ctrl.display.old, newPrice: $ctrl.display.new }">LANGM_JS_FL_LOWER_PD_DESC</p>\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function (PriceDiffHelper, $filter, $scope) {
        this.display = {
            old: 0,
            new: 0
        };

        var hasLowerPriceDiff = function (booking) {
            return booking.getTestSell().isLower();
        };

        var hasBiggerHistoricPrice = function (booking) {
            return (
                booking.getFlightDetails().initialTotalValue !== null &&
                booking.getFlightDetails().initialTotalValue - getTotalBruttoPrice(booking) > 0.01
            );
        };

        var getTotalBruttoPrice = function (booking) {
            return booking.getFlightDetails().getPaxesPricing().getTotalNettoPrice() + booking.getFlightDetails().getPaxesPricing().getTotalTf();
        };

        this.updateTemplateVars = function () {
            if (hasLowerPriceDiff(this.booking)) {
                this.display.old = $filter('flPrice')(PriceDiffHelper.getOldPrice(this.booking), 2);
                this.display.new = $filter('flPrice')(PriceDiffHelper.getNewPrice(this.booking), 2);
            }

            if (hasBiggerHistoricPrice(this.booking)) {
                this.display.old = $filter('flPrice')(this.booking.getFlightDetails().initialTotalValue, 2);
                this.display.new = $filter('flPrice')(getTotalBruttoPrice(this.booking), 2);
            }
        };

        this.isVisible = function () {
            return !this.booking.getTestSell().isInProgress() && hasLowerPriceDiff(this.booking) || hasBiggerHistoricPrice(this.booking);
        };

        this.$onInit = function () {
            var ctrl = this;

            this.updateTemplateVars();

            $scope.$watch(function () {
                return hasLowerPriceDiff(ctrl.booking);
            }, function () {
                ctrl.updateTemplateVars();
            });

            $scope.$watch(function () {
                return hasBiggerHistoricPrice(ctrl.booking);
            }, function () {
                ctrl.updateTemplateVars();
            });
        };
    };

    controller.$inject = [
        'PriceDiffHelper',
        '$filter',
        '$scope'
    ];

    angular
        .module('base')
        .component('fareLockLowerPrice', {
            template: template,
            controller: controller,
            bindings: {
                booking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-no-seats.component.js
(function (angular) {

    var template = '\
        <div>\
            <ith-preloader ng-show="$ctrl.currentViewState === $ctrl.viewStates.SUBMITTING"></ith-preloader>\
            \
            <div\
                ng-show="$ctrl.currentViewState === $ctrl.viewStates.SUCCESS"\
                text-box-body="fare_lock_no_seats_desc"\
                show-loader="true"\
                text-box-variables="{{ $ctrl.textBoxVars }}">\
            </div>\
            \
            <ith-status-notification status="error" ng-if="$ctrl.currentViewState === $ctrl.viewStates.ALREADY">\
                <pane-title translate>LANGM_JS_FL_REFUND_REQUEST_ALREADY_ERROR_TITLE</pane-title>\
                <pane-text translate>LANGM_JS_FL_REFUND_REQUEST_ALREADY_ERROR_DESC</pane-text>\
            </ith-status-notification>\
            \
            <ith-status-notification status="error" ng-if="$ctrl.currentViewState === $ctrl.viewStates.FAIL">\
                <pane-title translate>LANGM_JS_FL_REFUND_REQUEST_BACKEND_ERROR_TITLE</pane-title>\
                <pane-text translate>LANGM_JS_FL_REFUND_REQUEST_BACKEND_ERROR_DESC</pane-text>\
            </ith-status-notification>\
            \
            <div ng-show="$ctrl.currentViewState !== $ctrl.viewStates.SUBMITTING">\
                <div\
                    text-box-body="fare_lock_explore_other_flights"\
                    show-loader="true">\
                </div>\
                \
                <p>&nbsp;</p>\
                \
                <a\
                    class="btn btn-lg btn-outline btn-block"\
                    ng-click="$ctrl.explore()"\
                    translate="LANGM_JS_FL_EXPLORE_OTHER_FLIGHTS">\
                </a>\
            </div>\
        </div>\
    ';

    var controller = function ($filter, FareLockApi) {
        this.fareLockRefundLoading = false;
        this.fareLockRefundSubmitted = false;
        this.fareLockSubmitError = null;
        this.refundType = '';
        this.textBoxVars = {
            fee: $filter('flPrice')(this.flightBooking.fareLock.price, 2)
        };

        this.viewStates = {
            SUBMITTING: 'submitting',
            SUCCESS: 'success',
            ALREADY: 'already',
            FAIL: 'fail'
        };

        this.refundTypes = {
            CASH: 'cash',
            VOUCHER: 'voucher'
        };

        this.currentViewState = this.viewStates.SUBMITTING;

        this.requestFareLockRefund = function () {
            this.fareLockSubmitError = null;

            var self = this;

            FareLockApi
                .initiateRefund(this.refundTypes.CASH, this.flightBooking.fareLock.requestUuid)
                .then(function () {
                    self.currentViewState = self.viewStates.SUCCESS;
                })
                .catch(function (error) {
                    if (error.data.response.error_code === 666) {
                        self.currentViewState = self.viewStates.ALREADY;
                        return;
                    }

                    self.currentViewState = self.viewStates.FAIL;
                });
        };

        this.requestFareLockRefund();

        this.explore = function () {
            this.modalInstance.dismiss('cancel');
        };
    };

    controller.$inject = ['$filter', 'FareLockApi'];

    angular.module('base').component('fareLockNoSeats', {
        template: template,
        controller: controller,
        bindings: {
            flightBooking: '<',
            modalInstance: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-price-diff.component.js
(function (angular) {

    var template = '\
        <div\
            text-box-body="fare_lock_price_diff_desc"\
            show-loader="true"\
            text-box-variables="{{ $ctrl.fareLockParams }}">\
        </div>\
    ';

    var controller = function (FareLockHelper) {
        this.fareLockParams = {};

        this.$onInit = function () {
            this.fareLockParams = FareLockHelper.getPriceDiffModalTemplateVars(
                this.flightBooking
            );
        };
    };

    controller.$inject = ['FareLockHelper'];

    angular
        .module('base')
        .component('fareLockPriceDiff', {
            template: template,
            controller: controller,
            bindings: {
                flightBooking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-product-countdown.component.js
(function (angular) {

    var template = '\
        <ith-alert-box type="info">\
            <div class="fare-lock-countdown">\
                <span class="fare-lock-countdown__title" translate>LANGM_JS_FL_HURRY_UP_TITLE</span>\
                <span><translate>LANGM_JS_FL_HURRY_UP_DESC</translate> <countdown limit-date-time="$ctrl.flightDetails.expires" hide-days="true" hide-hours="true"></countdown></span>\
            </div>\
        </ith-alert-box>\
    ';

    angular.module('base').component('fareLockProductCountdown', {
        template: template,
        bindings: {
            flightDetails: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-product-display.component.js
(function (angular) {

    var template = '\
        <div class="fare-lock-content__top__logo-box">\
            <img src="/assets/img/product-logos/price-lock.svg" />\
            <div>\
                <strong ng-bind="$ctrl.text"></strong>\
                <div ng-if="$ctrl.desc" ng-bind-html="$ctrl.desc"></div>\
            </div>\
        </div>\
    ';

    angular
        .module('base')
        .component('fareLockProductDisplay', {
            template: template,
            bindings: {
                text: '@',
                desc: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-states.constant.js
angular.module('base').constant(
    'FARE_LOCK_STATES',
    {
        LOADING: 'loading',
        PENDING: 'pending',
        CONFIRMED: 'confirmed',
        EXPIRED: 'expired',
        ALREADY_USED: 'alreadyUsed',
        FAILED: 'failed',
        NOT_FOUND: 'notFound',
        REFUND_REQUESTED: 'refund_requested',
        VOUCHER_REQUESTED: 'voucher_requested'
    });
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock-upsell.component.js
(function (angular) {

    var template = '\
        <div class="basicBox">\
            <div class="fare-lock-content__top">\
                <div class="basicBox__container fare-lock-content__fd">\
                    <div class="fare-lock-content__fd__left">\
                        <fare-lock-product-display\
                            text="{{ \'LANGM_JS_FARE_LOCK_INSTEAD_TITLE\' | translate }}">\
                        </fare-lock-product-display>\
                        \
                        <h2 translate>LANGM_JS_FARE_LOCK_INSTEAD_SUBTITLE</h2>\
                        <p translate>LANGM_JS_FARE_LOCK_INSTEAD_DESC</p>\
                    </div>\
                    <div class="fare-lock-content__fd__right">\
                        <a class="btn btn-lg btn-primary btn-block" ng-disabled="$ctrl.isLoading" ng-switch="$ctrl.isLoading" ng-click="$ctrl.goToFareLock()">\
                            <span class="spin-loader ng-animate-disabled" ng-switch-when="true"></span>\
                            <div class="ng-animate-disabled price-btn" ng-switch-when="false">\
                                <span translate>LANGM_JS_CONTINUE_FARE_LOCK</span>\
                                <strong>{{ $ctrl.getPrice() | flPrice:0 }}</strong>\
                            </div>\
                        </a>\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function (FareLockHelper, $location) {
        this.isLoading = false;

        this.getSearchUrl = function () {
            var backToSearchUrl = this.backToSearchUrl;
            var locationSearch = $location.search();

            if (locationSearch.hasOwnProperty('backToSearchUrl')) {
                backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
            }

            return backToSearchUrl;
        };

        this.goToFareLock = function () {
            var self = this;

            this.isLoading = true;

            FareLockHelper
                .goToFareLock(
                    decodeURIComponent(this.fulfillmentToken),
                    decodeURIComponent(this.getSearchUrl()),
                    'flight_details'

                )
                .finally(function () {
                    self.isLoading = false;
                });
        };

        this.getPrice = function () {
            if (this.flightDetails.fareLock === null) {
                return 0;
            }

            return this.flightDetails.fareLock.pricing[0].price.amount;
        };
    };

    controller.$inject = ['FareLockHelper', '$location'];

    angular
        .module('base')
        .component('fareLockUpsell', {
            template: template,
            controller: controller,
            bindings: {
                fulfillmentToken: '<',
                backToSearchUrl: '<',
                flightDetails: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock.helper.js
(function (angular) {

    var FareLockHelperService = function ($translate, $location, SouthParkApi, FeedbackPopup, $filter, PriceDiffHelper, Pricings, AppConfig) {
        this.goToFareLock = function (fulfillmentToken, backToSearchUrl, orderingSource) {
            var promise = SouthParkApi.getFulfilmentOfferUuid(fulfillmentToken, orderingSource);

            promise
                .then(function (success) {
                    if (typeof success.data.response.uuid === 'undefined') {
                        throw new Error('Missing fare lock uuid');
                    }

                    $location.path(AppConfig.getUriPrefix() + '/fareLock/get/' + success.data.response.uuid).search('backToSearchUrl', backToSearchUrl);
                })
                .catch(function () {
                    var titleLang = 'LANGM_JS_FS_CONTINUE_ERROR_TITLE';
                    var textLang = 'LANGM_JS_FS_CONTINUE_ERROR_TEXT';
                    var buttonLang = 'LANGM_JS_CLOSE';

                    $translate([titleLang, textLang, buttonLang])
                        .then(function (translations) {
                            FeedbackPopup.openErrorPopup(
                                translations[titleLang],
                                translations[textLang],
                                translations[buttonLang]
                            );
                        });
                });

            return promise;
        };

        var getDefaultVars = function () {
            return {
                originalTotalPrice: 0,
                originalPrice: 0,
                fareLockPrice: 0,
                maxDiff: 0,
                maxCoverAmount: 0,
                currentPrice: 0,
                fareLockAmountToPay: 0,
                flightAmountToPay: 0,
                totalAmountToPay: 0,
                diffToPay: 0,
                totalAfterPriceDiff: 0,
                newPriceafterPD: 0
            };
        };

        this.getDetailsTemplateVars = function (fareLockOrder, diffFlightDetails) {
            var vars = getDefaultVars();

            var originalTotalPrice = fareLockOrder.getFlightDetails().getPaxesPricing().getTotalNettoPrice() + fareLockOrder.getFlightDetails().getPaxesPricing().getTotalTf();
            var originalPrice = fareLockOrder.getFlightDetails().getPaxesPricing().getTotalNettoPrice();
            var fareLockPrice = fareLockOrder.getSelectedOption().price.amount;
            var maxDiff = parseFloat(fareLockOrder.fareLock.coveringAmount.amount) - originalTotalPrice;
            var maxCoverAmount = originalPrice + maxDiff;

            vars.originalTotalPrice = $filter('flPrice')(originalTotalPrice, 2);
            vars.originalPrice = $filter('flPrice')(originalPrice, 2);
            vars.fareLockPrice = $filter('flPrice')(fareLockPrice, 2);
            vars.maxDiff = $filter('flPrice')(maxDiff, 2);
            vars.maxCoverAmount = $filter('flPrice')(maxCoverAmount, 2);

            if (diffFlightDetails) {
                var equivalentDiffOption = diffFlightDetails.fareLock.pricing.find(function (option) {
                    return option.id === fareLockOrder.selectedFareLockRuleId;
                });

                var diffPricings = new Pricings(diffFlightDetails.pricing.paxes);

                var currentPrice = diffPricings.getTotalNettoPrice() + diffPricings.getTotalTf();
                var fareLockAmountToPay = parseFloat(equivalentDiffOption.price.amount);
                var flightAmountToPay = currentPrice - fareLockAmountToPay;
                var totalAmountToPay = currentPrice - maxCoverAmount;
                var diffToPay = currentPrice - originalTotalPrice;
                var totalAfterPriceDiff = currentPrice - maxDiff;

                vars.currentPrice = $filter('flPrice')(currentPrice, 2);
                vars.fareLockAmountToPay = $filter('flPrice')(fareLockAmountToPay, 2);
                vars.flightAmountToPay = $filter('flPrice')(flightAmountToPay, 2);
                vars.totalAmountToPay = $filter('flPrice')(totalAmountToPay, 2);
                vars.diffToPay = $filter('flPrice')(diffToPay, 2);
                vars.totalAfterPriceDiff = $filter('flPrice')(totalAfterPriceDiff, 2);
            }

            return vars;
        };

        this.getPriceDiffModalTemplateVars = function (flightBooking) {
            var vars = getDefaultVars();

            var originalTotalPrice = flightBooking.getFlightDetails().getPaxesPricing().getTotalNettoPrice() + flightBooking.getFlightDetails().getPaxesPricing().getTotalTf();
            var originalPrice = flightBooking.fareLock.flightPrice;
            var fareLockPrice = flightBooking.fareLock.price;
            var maxDiff = flightBooking.fareLock.coveredAmount - originalTotalPrice;
            var newPriceafterPD = parseFloat(originalTotalPrice) + parseFloat(flightBooking.getTestSell().getPriceDiffAdjustment()) + maxDiff;
            var maxCoverAmount = originalTotalPrice + maxDiff;
            var currentPrice = PriceDiffHelper.getNewPrice(flightBooking);
            var fareLockAmountToPay = originalTotalPrice - fareLockPrice;
            var flightAmountToPay = currentPrice - fareLockAmountToPay;
            var totalAmountToPay = fareLockAmountToPay + flightAmountToPay;
            var diffToPay = currentPrice - originalTotalPrice;
            var totalAfterPriceDiff = currentPrice - maxDiff;

            vars.originalTotalPrice = $filter('flPrice')(originalTotalPrice, 2);
            vars.originalPrice = $filter('flPrice')(originalPrice, 2);
            vars.fareLockPrice = $filter('flPrice')(fareLockPrice, 2);
            vars.maxDiff = $filter('flPrice')(maxDiff, 2);
            vars.maxCoverAmount = $filter('flPrice')(maxCoverAmount, 2);
            vars.currentPrice = $filter('flPrice')(currentPrice, 2);
            vars.fareLockAmountToPay = $filter('flPrice')(fareLockAmountToPay, 2);
            vars.flightAmountToPay = $filter('flPrice')(flightAmountToPay, 2);
            vars.totalAmountToPay = $filter('flPrice')(totalAmountToPay, 2);
            vars.diffToPay = $filter('flPrice')(diffToPay, 2);
            vars.totalAfterPriceDiff = $filter('flPrice')(totalAfterPriceDiff, 2);
            vars.newPriceafterPD = $filter('flPrice')(newPriceafterPD, 2);

            return vars;
        };

        this.getBackToSearch = function (flightDetails) {
            var locationSearch = $location.search();

            if (locationSearch.hasOwnProperty('backToSearchUrl')) {
                var backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
                $location.hash('');
                $location.search('');
                $location.path(backToSearchUrl).search('');
                return;
            }

            $location.path(flightDetails.getSearchUrl());
        };
    };

    FareLockHelperService.$inject = ['$translate', '$location', 'SouthParkApi', 'FeedbackPopup', '$filter', 'PriceDiffHelper', 'fdt.Pricings', 'appConfig'];

    angular
        .module('base')
        .service('FareLockHelper', FareLockHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/fare-lock/fare-lock.model.js
(function (angular) {
var FareLockModel = function (FARE_LOCK_STATES) {
        var FareLock = function () {
            this.populated = false;
            this.fareNumber = false;
            this.requestUuid = null;
            this.price = 0;
            this.coveredAmount = 0;
            this.expiryDate = 0;
            this.status = 0;
            this.onExpiredStatusCallback = null;
        };

        FareLock.prototype.populateFromWebSocket = function (responseObject, code) {
            if (code >= 400) {
                this.populated = true;
                return;
            }

            this.populated = true;
            this.fareNumber = responseObject.fareNumber;
            this.requestUuid = responseObject.requestUuid;
            this.price = responseObject.price.amount;
            this.flightPrice = responseObject.flightPrice.amount;
            this.coveredAmount = responseObject.coveredAmount.amount;
            this.expiryDate = responseObject.expiryDate;
            this.status = responseObject.status;
            this.selectedDuration = responseObject.selectedDuration || null;

            if (this.status === FARE_LOCK_STATES.EXPIRED && this.onExpiredStatusCallback !== null) {
                this.onExpiredStatusCallback();
            }
        };

        FareLock.prototype.initWithBookingData = function (fareLockData) {
            this.price = fareLockData.amount;
            this.populated = true;
        };

        FareLock.prototype.isPopulated = function () {
            return this.populated;
        };

        FareLock.prototype.getPrice = function () {
            return this.price;
        };

        FareLock.prototype.getStatus = function () {
            return this.status;
        };

        FareLock.prototype.isConfirmed = function () {
            return this.getStatus() === FARE_LOCK_STATES.CONFIRMED;
        };

        FareLock.prototype.getRequestUuid = function () {
            return this.requestUuid;
        };

        FareLock.prototype.onExpiredStatus = function (callback) {
            this.onExpiredStatusCallback = callback;
        };

        FareLock.prototype.constructor = FareLock;

        return FareLock;
    };

    FareLockModel.$inject = ['FARE_LOCK_STATES'];

    angular
        .module('book')
        .factory('FareLock', FareLockModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/ApplePay.js
/* eslint-disable no-undef */
(function (angular) {

    angular.module('book')

        /**
         * @name ApplePay
         * @namespace bok
         * @description Class for communication with Apple Pay
         */
        .factory('bok.ApplePay', ['$rootScope', '$timeout', 'appConfig', 'fdt.FlightDetailsServ', 'FastPaymentLineItem', function ApplePayFactory($rootScope, $timeout, AppConfig, FlightDetailsServ, FastPaymentLineItem) {
            /**
             * ApplePay constructor
             *
             * @class ApplePay
             * @constructor
             */
            var ApplePay = function () {
                this.flightBooking = null;
                this.isReadyToPay = false;
                this.session = null;
                this.merchantCapabilities = [];
                this.supportedNetworks = [];
                this.countryCode = '';
                this.currencyCode = '';
                this.merchantName = AppConfig.getAffiliateName();
                this.paymentData = null;
                this.apiVersion = 3;
            };

            ApplePay.prototype.setFlightBooking = function (flightBooking) {
                this.flightBooking = flightBooking;
            };

            /**
             * Initialize ApplePay
             *
             * @param {Object} clientData
             */
            ApplePay.prototype.init = function (clientData) {
                if (typeof ApplePaySession === 'undefined') {
                    return;
                }

                if (!ApplePaySession.supportsVersion(this.apiVersion)) {
                    return;
                }

                // currencyCode should be loaded from proper credential once we support multiple currencies
                // this.currencyCode = clientData.currencyCode;
                this.currencyCode = AppConfig.getCurrencyCode();
                this.merchantCapabilities = clientData.merchantCapabilities;
                this.supportedNetworks = clientData.supportedNetworks;
                this.countryCode = clientData.countryCode || AppConfig.getDefaultCountryCode();

                this.waitForApplePayButton(200, 10, (function (btn) {
                    if (btn) {
                        btn.onclick = this.onButtonClicked.bind(this);
                        this.isReadyToPay = ApplePaySession.canMakePayments();
                    }
                }).bind(this));
            };

            ApplePay.prototype.createBasePaymentRequest = function () {
                return {
                    countryCode: this.countryCode,
                    currencyCode: this.currencyCode,
                    merchantCapabilities: this.merchantCapabilities,
                    supportedNetworks: this.supportedNetworks,
                };
            };

            ApplePay.prototype.prepareLineItems = function () {
                return [
                    {
                        label: FastPaymentLineItem.getLineItem(this.flightBooking.getFlightDetails()),
                        type: 'final',
                        amount: this.flightBooking.basket.getTotalPrice().toFixed(2)
                    }
                ];
            };

            ApplePay.prototype.prepareTotal = function () {
                return {
                    type: 'final',
                    label: this.merchantName,
                    amount: this.flightBooking.basket.getTotalPrice().toFixed(2),
                };
            };

            ApplePay.prototype.onButtonClicked = function () {
                var paymentDataRequest = this.createBasePaymentRequest();
                paymentDataRequest.total = this.prepareTotal();
                paymentDataRequest.lineItems = this.prepareLineItems();

                this.session = new ApplePaySession(this.apiVersion, paymentDataRequest);

                this.session.onvalidatemerchant = this.onValidateMerchant.bind(this);
                this.session.onpaymentauthorized = this.onPaymentAuthorized.bind(this);
                this.session.onpaymentmethodselected = this.onPaymentMethodSelected.bind(this);
                this.session.oncancel = this.onCancel.bind(this);

                this.session.begin();
            };

            ApplePay.prototype.onCancel = function (/* ApplePayCancelEvent */) {
                //
            };

            ApplePay.prototype.onValidateMerchant = function (ApplePayValidateMerchantEvent) {
                this.validateMerchant(ApplePayValidateMerchantEvent).then(function (response) {
                    if (response && response.status === 'success') {
                        return this.session.completeMerchantValidation(response.session);
                    }
                    console.error('merchant validation failed', response);
                    return this.session.abort();
                }.bind(this));
            };

            ApplePay.prototype.onPaymentMethodSelected = function (/* ApplePayPaymentMethodSelected */) {
                this.session.completePaymentMethodSelection({
                    newTotal: this.prepareTotal(),
                    newLineItems: this.prepareLineItems()
                });
            };

            ApplePay.prototype.onPaymentAuthorized = function (ApplePayPaymentAuthorizedEvent) {
                this.paymentData = ApplePayPaymentAuthorizedEvent.payment;
                $rootScope.$broadcast('ApplePayTokenGenerated');

                // call this at appropriate time (should close modal etc)
                this.session.completePayment({
                    status: ApplePaySession.STATUS_SUCCESS
                });
            };

            ApplePay.prototype.validateMerchant = function (ApplePayValidateMerchantEvent) {
                return FlightDetailsServ
                    .requestMerchantSession({
                        url: ApplePayValidateMerchantEvent.validationURL,
                        type: 'ApplePay',
                        domain: AppConfig.getDomain()
                    })
                    .then(function (response) {
                        return response;
                    })
                    .catch(function (e) {
                        return e;
                    });
            };

            /**
             * @return {String}
             */
            ApplePay.prototype.getValidationType = function () {
                return this.type;
            };

            /**
             * @return {String}
             */
            ApplePay.prototype.getPaymentTokenString = function () {
                if (!this.paymentData) {
                    return '{}';
                }

                return JSON.stringify(this.paymentData.token.paymentData);
            };

            /**
             * @return {Object}
             */
            ApplePay.prototype.waitForApplePayButton = function (interval, maxAttempts, callback) {
                function checkButton() {
                    var btnDiv = document.getElementById('apple-pay-btn-div');

                    if (btnDiv) {
                        var btn = document.createElement('apple-pay-button');
                        btn.setAttribute('id', 'apple-pay-button');
                        btn.setAttribute('buttonstyle', 'black');
                        btn.setAttribute('type', 'plain');
                        btn.setAttribute('locale', 'en-US');
                        btn.setAttribute('lang', 'en-US');
                        btn.setAttribute('lang', 'en-US');
                        btn.style.setProperty('--apple-pay-button-width', '270px');
                        btn.style.setProperty('--apple-pay-button-height', '48px');
                        btnDiv.replaceChildren(btn);
                        callback(btn);
                        return;
                    }

                    if (maxAttempts <= 0) {
                        callback(null);
                        return;
                    }

                    $timeout(checkButton, interval);
                    maxAttempts--;
                }

                checkButton();
            };

            ApplePay.prototype.constructor = ApplePay;

            return ApplePay;
        }]);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/Baggage.js
angular.module('book')

/**
 * @name        Baggage
 * @namespace   bok
 * @description Class that describes baggage information
 */
.factory('bok.Baggage',
[function BaggageFactory() {
/**
   * Baggage
   *
   * @class Baggage
   * @constructor
   *
   * @param {Object} baggageObj
   * @param {String} kind        The kind of the baggage: BAGGAGE, CABIN
   * @param {String} direction   The type of the baggage: COMMON, DEPARTURE, RETURN
   */
  var Baggage = function (baggageObj, kind, direction) {
    /**
     * Baggage ID
     *
     * @type {String}
     */
    this.id = baggageObj.id;

    /**
     * The baggage type
     *
     * @type {String}
     */
    this.type = baggageObj.type;

    /**
     * Baggage name
     *
     * @type {String}
     */
    this.name = baggageObj.descr;

    /**
     * The baggage kind
     *
     * @type {String}
     */
    this.kind = kind;

    /**
     * The direction the baggage is for
     *
     * One of the: Baggage.DIR_COMMON, Baggage.DIR_DEPARTURE, Baggage.DIR_RETURN
     *
     * @type {String}
     */
    this.direction = direction;

    /**
     * The baggage weight
     *
     * @type {float}
     */
    this.weight = +baggageObj.weight;

    /**
     * The maximum weight for baggage for PAX
     *
     * @type {int}
     */
    this.maxWeightPerPax = baggageObj.maxWeightPerPax;

    /**
     * The baggage price
     *
     * @type {float}
     */
    this.price = +baggageObj.price;

    /**
     * Number of baggage for the current selection
     *
     * @type {int}
     */
    this.count = baggageObj.count || 1;

    /**
     * select desc
     *
     * @type {String}
     */
    this.descSelect = baggageObj.descSelect;

    /**
     * Price currency
     *
     * @type {String}
     */
    this.currency = baggageObj.currency;

    /**
     * Size param
     *
     * @type {String}
     */
    this.size = baggageObj.size || '';

    /**
     *  @type {Array}
     */
    this.luggageDetails = baggageObj.luggageDetails;
  };

  /**
   * Baggage
   *
   * @constant
   * @type {String}
   */
  Baggage.KIND_BAGGAGE = 'BAGGAGE';

  /**
   * Cabin baggage
   *
   * @constant
   * @type {String}
   */
  Baggage.KIND_CABIN = 'CABIN';

  /**
   * Cabin baggage
   *
   * @constant
   * @type {String}
   */
  Baggage.KIND_ONE_BAG = 'ONEBAG';

  /**
   * Baggage direction common
   *
   * For both departure and return flights
   *
   * @constant
   * @type {String}
   */
  Baggage.DIR_COMMON = 'COMMON';

  /**
   * Baggage direction departure
   *
   * For departure flight
   *
   * @constant
   * @type {String}
   */
  Baggage.DIR_DEPARTURE = 'DEPARTURE';

  /**
   * Baggage direction return
   *
   * For return flight
   *
   * @constant
   * @type {String}
   */
  Baggage.DIR_RETURN = 'RETURN';

  // Add instance methods
  Baggage.prototype = /** @lends Baggage.prototype */ {

    /**
     * Get select desc
     *
     * @returns {String}
     */
    getDescSelect: function () {
      return this.descSelect;
    },

    /**
     * Get baggage currency
     *
     * @returns {String}
     */
    getCurrency: function () {
      return this.currency == '&euro;' ? '€' : this.currency;
    },

    /**
     * Set select desc
     *
     * @param desc
     */
    setDescSelect: function (desc) {
      this.descSelect = desc;
    },

    /**
     * Returns baggage id
     *
     * @return {String}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Returns baggage name
     *
     * @return {String}
     */
    getName: function () {
      return this.name;
    },

    /**
     * Returns size param
     *
     * @return {String}
     */
    getSize: function () {
      return this.size;
    },

    /**
     * Returns count
     *
     * @return {int}
     */
    getCount: function () {
      return this.count;
    },

    /**
     * Returns weight
     *
     * @return {float}
     */
    getWeight: function () {
      return this.weight;
    },

    /**
     * Returns total weight
     *
     * @return {float}
     */
    getTotalWeight: function () {
      return this.getWeight();
    },

    /**
     * Returns baggage price
     *
     * @return {float}
     */
    getPrice: function () {
      return this.price;
    },

    /**
     * Get the direction the baggage is for
     *
     * One of the: Baggage.DIR_COMMON, Baggage.DIR_DEPARTURE, Baggage.DIR_RETURN
     *
     * @return {String}
     */
    getDir: function () {
      return this.direction;
    }
  };

  Baggage.prototype.constructor = Baggage;

  return Baggage;
}]);
;

// Source: ../shared/public_html/assets/js/book/models/BlikCode.js
/* global _: false */

angular.module('book')

/**
 * @name        BlikCode
 * @namespace   bok
 * @description Class that holds and validates Blik Code information
 */
.factory('bok.BlikCode',
['ErrorMixin', 'FormErrorMixin',
function BlikCodeFactory(ErrorMixin, FormErrorMixin) {
/**
   * BlikCode constructor
   *
   * @class BlikCode
   * @constructor
   */
  var BlikCode = function () {
    /**
     * Blik Code
     *
     * @type {String}
     */
    this.authorizationCode = '';
    this.tokenized = false;
    this.tokenizedData = {};

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  /**
   * Validation type token
   *
   * @constant
   * @type {String}
   */
  BlikCode.VALIDATION_TOKEN = 'token';

  /**
   * Validation type Blik Code
   *
   * @constant
   * @type {String}
   */
  BlikCode.VALIDATION_NUMBER = 'authorizationCode';

  // Add instance methods
  BlikCode.prototype = /** @lends BlikCode.prototype */ {
    /**
     * Tokenize blik code
     */
    tokenize: function(tokenized) {
      this.tokenized = true;
      this.tokenizedData = tokenized;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function() {
      return {authorizationCode: this.authorizationCode};
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {BlikCode}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) {
        errors = {};
      }

      this.errors.authorizationCode = errors.authorizationCode;
      this.errors.type = errors.type;

      this.tokenized = false;

      return this;
    }
  };

  BlikCode.prototype.constructor = BlikCode;

  // Add mixins
  _.extend(BlikCode.prototype, ErrorMixin);
  _.extend(BlikCode.prototype, FormErrorMixin);

  return BlikCode;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/Booking.js
/*global _: false */
(function (angular, underscore) {
/**
   * @name        Booking
   * @namespace   bok
   * @description Class holding all the information about flight booking
   */
  var BookingFactory = function BookingFactory(Insurance, NewInsurance, ContactDetails, Basket, TestSell, $q, UnitOpts, Order, AuthService, Refund, PaidCheckin, FastRefund, Cfar, SouthParkFlightCache, PaidCheckinRules, GiveawayParticipate, IbeLuggageHandler, TripGuarantee, SeatsInitialData, SeatSelect, TicketType, FrolaAssistance, SmsNotification, FareLock) {

    /**
     * Booking
     *
     * @class Booking
     * @constructor
     */
    var Booking = function () {
      /**
       * The insurance chosen for this booking
       *
       * @type {Insurance}
       */
      this.insuranceNew = NewInsurance;

      /**
       * Refund object
       *
       * @type {Refund}
       */
      this.refund = new Refund();

      /**
       * Fast refund model instance
       *
       * @type {FastRefund}
       */
      this.fastRefund = new FastRefund();

      /**
       * Cfar model instance
       *
       * @type {Cfar}
       */
      this.cfar = new Cfar();

      /**
       * Paid checkin object
       *
       * @type {PaidCheckin}
       */
      this.paidCheckin = new PaidCheckin();
      this.tripGuarantee = new TripGuarantee();
      this.fareLock = new FareLock();
      this.seatsInitialData = new SeatsInitialData();
      this.seatSelect = new SeatSelect(this);
      this.ticketType = new TicketType();
      this.frolaAssistance = new FrolaAssistance();

      /**
       * The flight details we are doing booking for
       *
       * @type {FlightDetails}
       */
      this.flightDetails = null;

      /**
       * The flight details promise
       *
       * @type {promise}
       */
      this.flightDetailsPromise = $q.defer();

      /**
       * The test sell for the chosen flight
       *
       * @type {TestSell}
       */
      this.testSell = new TestSell(this);

      /**
       * The test sell promise
       *
       * @type {promise}
       */
      this.testSellPromise = $q.defer();

      /**
       * The test sell status
       *
       * @type {Boolean}
       */
      this.testSellInProgress = false;

      /**
       * Subscribe to newsletter (opt-in)
       *
       * @type {Boolean}
       */
      this.subscribe = false;

      /**
       * Cash back
       *
       * @type {Boolean}
       */
      this.cashback = true;
      /**
       * Cash back
       *
       * @type {Boolean}
       */
      this.terms_condition = false;
      /**
       * Cash back
       *
       * @type {Boolean}
       */
      this.terms_charter_time = false;

      /**
       *
       */
      this.terms_charter_agreement = false;

      /**
       * Invoice adress
       * @type {{}}
       */
      this.invoice_adress = {};
      /**
       * In case of LTD orders this indicates the timeframe
       * in which the orde;r can be payed
       *
       * @type {datetime}
       */
      this.payableUntil = null;

      /**
       * The order reservation number
       *
       * @type {String}
       */
      this.reservationNumber = '';

      /**
       * Is this reservation an order?
       *
       * @type {Boolean}
       */
      this.order = false;

      /**
       * Errors object
       *
       * Used in templates to mark error fields and show error messages
       * The keys are filed names and values are error messages or instances.
       *
       * Example:
       *
       * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
       *
       * @type {Object}
       */
      this.errors = {};

      /**
       * Should we send confirmations (e-mail and SMS) to the client.
       * This is a setting meant for agents to avoid sending extra confirmations to clients.
       *
       * @type {boolean}
       */
      this.sendConfirmation = true;

      /**
       * Should we disable AT.
       *
       * @type {boolean}
       */
      this.disableAT = false;

      /**
       * Should we disable auto invoicing.
       *
       * @type {boolean}
       */
      this.disableInvoice = false;

      /**
       * @type {GiveawayParticipate}
       */
      this.giveawayParticipate = new GiveawayParticipate();

      /**
       * Check-in airline rules
       *
       * @type {Object[]}
       */
      this.checkinAirlineRules = [];

      /**
       * Booking includes free auto checkin
       *
       * @type {Boolean}
       */
      this.hasFreeAutomatedCheckin = false;

      /**
       * Paid checkin rules model
       *
       * @type {PaidCheckinRules}
       */
      this.paidCheckinRules = new PaidCheckinRules();
      this.luggageHandler = new IbeLuggageHandler(this);
      this.smsNotification = new SmsNotification();
    };

    function insuranceValidation(hasErrors) {
      var result = false;
      return hasErrors && result;
    }

    var methods = {

      /**
       * Reset booking data
       */
      reset: function () {
        Order.prototype.reset.call(this);

        this.insuranceNew = this.insuranceNew.reset();
        this.refund = new Refund();
        this.fastRefund = new FastRefund();
        this.cfar = new Cfar();
        this.paidCheckin = new PaidCheckin();
        this.tripGuarantee = new TripGuarantee();
        this.fareLock = new FareLock();
        this.ticketType = new TicketType();
        this.frolaAssistance = new FrolaAssistance();
        this.seatsInitialData = new SeatsInitialData();
        this.seatSelect = new SeatSelect(this);
        this.contactDetails = new ContactDetails();
        this.flightDetails = null;
        this.testSell = new TestSell(this);
        this.testSellPromise = $q.defer();
        this.testSellInProgress = false;
        this.subscribe = false;
        this.cashback = true;
        this.payableUntil = null;
        this.reservationNumber = '';
        this.order = false;
        this.flightDetailsPromise = $q.defer(); // CO-873
        this.sendConfirmation = true;
        this.disableAT = false;
        this.disableInvoice = false;
        this.giveawayParticipate = new GiveawayParticipate();
        this.paidCheckinRules = new PaidCheckinRules();
        this.luggageHandler = new IbeLuggageHandler(this);

        this.resetErrors();
      },

      /**
       * Reset flight details
       */
      resetFlightDetails: function () {
        if (this.flightDetails) {
          this.flightDetails = null;
        }
      },

      getNewInsurance: function () {
        return this.insuranceNew;
      },

      /**
       * Get insurance total
       *
       * @return {Number}
       */
      getTotalInsurance: function () {
        // Get selected insurance
        throw error("method does not implement")
      },

      /**
       * Returns contact details
       *
       * @return {ContactDetails}
       */
      getContactDetails: function () {
        return this.contactDetails;
      },

      /**
       * Returns if user subscribed to a newsletter
       *
       * @return {Boolean}
       */
      doSubscribeToNewsLetter: function () {
        return this.subscribe;
      },

      /**
       * Get flight details promise
       *
       * @return {FlightDetails|null}
       */
      getFlightDetails: function () {
        return this.flightDetails;
      },

      /**
       * Get flight details promise
       *
       * @return {promise}
       */
      getFlightDetailsPromise: function () {
        return this.flightDetailsPromise.promise;
      },

      /**
       * Set flight details
       *
       * @param {FlightDetails} flightDetails
       */
      setFlightDetails: function (flightDetails) {
        this.flightDetails = flightDetails;
        this.flightDetailsPromise.resolve(this.flightDetails);

        this.basket = new Basket(this);

        this.refund.initWithFlightDetails(this.getFlightDetails());
        this.fastRefund.initWithFlightDetails(this.getFlightDetails(), this.basket.getRefundBasePrice());
        this.cfar.initWithFlightDetails(this.getFlightDetails());
        this.frolaAssistance.initWithFlightDetails(this.getFlightDetails());

        this._setCarriers(this.getFlightDetails());

        // Add paxes
        this.addPaxesByTypeBulk(this.getFlightDetails().getPaxesPricing().getPricings());

        // Set payment fees
        this.payment.setFees(this.getFlightDetails().getPaymentFees());
        this.payment.setPaymentOptions(this.getFlightDetails().getPaymentOptions());

        if (this.paidCheckin.getTotalPrice() === null && this.getFlightDetails().additionalServices.paidCheckin !== null) {
          this.paidCheckin.setTotalPrice(this.getFlightDetails().additionalServices.paidCheckin.totalPrice);
        }

        // Do test sell
        this.doTestSell();

        // Reset errors
        this.resetErrors();
        this.luggageHandler.populate();
        return this;
      },

      postBasketUpdate: function () {

      },

      /**
       * Set test sell for the chosen flight
       *
       * @param  {TestSell} testSell
       *
       * @return {Booking}
       */
      setTestSell: function (testSell) {
        this.testSell = testSell;
        return this;
      },

      /**
       * Returns test sell
       *
       * @return {TestSell}
       */
      getTestSell: function () {
        return this.testSell;
      },
      /**
       * Returns test sell status
       *
       * @return {Boolean}
       */
      getTestSellStatus: function () {
        return this.testSellInProgress;
      },

      /**
       * Get flight details promise
       *
       * @return {promise}
       */
      getTestSellPromise: function () {
        return this.testSellPromise.promise;
      },

      /**
       * Do test sell
       *
       * @return {Boolean}
       */
      doTestSell: function () {
        // Can't do test sell without flight details
        if (!this.getFlightDetails()) return false;

        // resolve case with doubling request
        if (this.testSellInProgress) {
          return false;
        }

        this.testSellInProgress = true;

        // Initiate a new test sell
        var testSell, hash = this.getFlightDetails().hash();

        testSell = this.testSell ? this.testSell : new TestSell(this);

        // Reset previous test sell
        testSell.reset();

        // Set initial test sell data from flight details
        testSell.setInitialTestSell(
          this.getFlightDetails().getTestSell(),
          this.getFlightDetails().verification.getVerificationId()
        );

        var self = this;

        // Only do test sell request when test sell version is not 0
        if (testSell.getVersion() != 0) {
          testSell.doTestSellFD(this.getFlightDetails()).then(function (response) {
            // resolve case: to do flightDetails page -> back to search before TS ends and go to 2nd pGr
            if (self.flightDetails && hash != self.flightDetails.hash()) {
              return false;
            }

            if (response.version === 2) {
              // Price diff - higher price
              SouthParkFlightCache.clear();
            }

            if (response.version === 3 || response.version === 4) {
              // No seats available
              SouthParkFlightCache.clear();
            }

            self.setTestSell(response);
            // Restrict methods of payment according to test sell?
            self._paymentRestrict();

            var array = [];

            underscore.forEach(self.getTestSell().getSellingUnits(), function (el) {
              //console.info("el", el);
              array.push(new UnitOpts(el));
            });
            self.flightDetails.setUnitOpts(array);
            //console.warn("self.flightDetails", self.flightDetails);

            self.testSellPromise.resolve(self.flightDetails);
            self.testSellInProgress = false;
          }, function () {
            // resolve case: to do flightDetails page -> back to search before TS ends and go to 2nd pGr
            if (hash != self.flightDetails.hash()) {
              return false;
            }

            testSell.setInProgress(false);

            self.setTestSell(testSell);

            // Restrict methods of payment according to test sell?
            self._paymentRestrict();

            self.testSellPromise.resolve(self.flightDetails);
            self.testSellInProgress = false;
          });
        }
        else {
          this.setTestSell(testSell);

          // Restrict methods of payment according to test sell?
          this._paymentRestrict();

          self.testSellPromise.resolve(self.flightDetails);
          self.testSellInProgress = false;
        }

        return true;
      },

      /**
       * Returns the order reservation number
       *
       * @return {String}
       */
      getReservationNumber: function () {
        return this.reservationNumber;
      },

      /**
       * Restricts some methods of payment after test sell response
       */
      _paymentRestrict: function () {
        // TODO: investigate why this is happening
        //if(this.getFlightDetails() === null) return;

        // Check for disabled CC form
        if (!this.getFlightDetails().getPaymentOptions().isAvailable('CC')) {
          // Check for disabled bank transfer
          if (this.getFlightDetails().getBookingReq().isLTD() || !this.getFlightDetails().getPaymentOptions().isAvailable('BT')) {
            // Set default billing to cash
            this.getPayment().setTypeCash();
          }
          else {
            // Set default billing to bank transfer
            this.getPayment().setTypeBankTransfer();
          }
        }
      },

      /**
       * Sets list of carrier by server's response object.
       *
       * @param response
       * @returns {methods}
       * @private
       */
      _setCarriers: function (response) {

        var self = this;

        //clean the list of carriers, from previous set
        self.carriers = [];

        angular.forEach(response.unitOpts, function (opt) {
          if (self.carriers.indexOf(opt.carrier) === -1) {
            self.carriers.push(opt.carrier);
          }
        });

        return this;
      },

      /**
       * Returns unique array of carrier codes on current unit.
       *
       * @returns {string[]}
       */
      getCarriers: function () {
        return this.carriers;
      },

      /**
       * Returns reservation type.
       * For GDSs it returns false (it's a booking)
       * For LCCs, SOOWs or GDS with failed test sell returns true (it's an order)
       *
       * @return {Boolean}
       */
      isOrder: function () {
        // Detect if this is requested from thank you page or booking details
        if (this.getReservationNumber() != '') {
          return this.order;
        }

        if (!this.getFlightDetails()) {
          // Flight details are not loaded yet, assume it's a booking
          return false;
        }
        else if (this.getFlightDetails().isLowCost() || this.getFlightDetails().isSoowFlight()) {
          // LCCs or SOOWs
          return true;
        }
        else {
          // GDSs
          if (this.getTestSell() && this.getTestSell().isInProgress() && this.getTestSell().getTestSellNote() == "strong") {
            // GDS with failed test sell (strong price diff)
            return true;
          }

          return false;
        }
      },

      /**
       * Get URL to any booking step
       *
       * @param  {String} subPage
       * @param  {Object} routeParams
       *
       * @return {String}
       */
      getStepURL: function (subPage, routeParams) {
        // Build first part of URL
        var url = '/' + subPage + '/get/';

        // Build page for passenger details
        if (subPage == 'passengerDetails') url += routeParams.passengerIndex + '/';

        // Build rest of the URL
        url += routeParams.requestId + '/' + routeParams.priceGroupId + '/' + routeParams.fsId + '/' + routeParams.depLegId;

        // Only for one-way flights
        if (routeParams.retLegId) url += '/' + routeParams.retLegId;

        // Return full URL
        return url;
      },

      /**
       * Validate Booking
       *
       * @return {Boolean}
       */
      validate: function () {
        var inheritedWrapper = function () {
          return Order.prototype.validate.call(this);
        };

        return underscore.compose(insuranceValidation, inheritedWrapper);
      },

      /**
       * Returns this instance as simple object for communicating with API
       *
       * @return {Object}
       */
      srvObj: function () {
        var self = this;
        // At this point we must have this.flightDetails
        if (!this.getFlightDetails()) {
          throw new Error('Flight details not available');
        }
        var bookingSrvObj = function (obj) {
          return underscore.extend(obj, {
            'fulfillmentToken': self.getFlightDetails().getFulfillmentToken(),
            'insurance': self.insuranceNew.getDataToBook(),
            'refund': self.refund.serializeForBookingRequest(),
            'discounts': self.getFlightDetails().getDiscount().getVoucherCodes(),
            'test_sell': self.testSell ? self.testSell.srvObj() : self.testSell,
            'unitOpts': underscore.map(self.getFlightDetails().getUnitOpts(), function (unit) {
              return unit.srvObj();
            }),
            'newsletter_subscribe': self.subscribe,
            'cashback': self.cashback,
            'terms_condition': true,
            'terms_charter_time': true,
            'terms_charter_agreement': true,
            'invoice_adress': self.invoice_adress,
            'hub_guarantee': self.getFlightDetails().isHubFlight() && AuthService.checkIsLoggedIn(),
            'sendConfirmation': self.sendConfirmation,
            'disableAT': self.disableAT,
            'disableInvoice': self.disableInvoice,
            'giveawayParticipate': self.giveawayParticipate.selected,
            'basketId': self.getFlightDetails().getBasketId(),
            'isUnifiedLuggageLogic': true,
            'fareLock': {
              'requestUuid': self.fareLock.getRequestUuid(),
            },
            'additionalServices': {
              'splitFunnelPackage': self.ticketType.srvObj(),
              'paidCheckin': {
                'chosen': self.paidCheckin.isSelected()
              },
              'fastRefund': {
                'chosen': self.fastRefund.isSelected()
              },
              'cfar': {
                'chosen': self.cfar.isSelected(),
                'requestId': self.cfar.ancillariesRequestId,
                'price': self.cfar.getTotalPrice()
              },
              smsNotification: self.smsNotification.srvObj(),
              tripGuarantee: self.tripGuarantee.srvObj(),
              seats: {
                chosen: self.seatSelect.getTotalSelections() > 0,
                basketUuid: self.seatsInitialData.basketUuid
              },
              'paidContact': {
                'chosen': self.frolaAssistance.srvObj()
              }
            }
          });
        };

        // Unset gov id and passport where not necessary
        this.paxes = this.getFlightDetails().verificationHandler.preparePaxes(this.paxes);

        var inheritedWrapper = function (context) {
          return Order.prototype.srvObj.call(context);
        };

        var helper = underscore.compose(bookingSrvObj, inheritedWrapper);
        var srvData = helper(this);

        return srvData;
      },

      /**
       * Set errors form server
       *
       * @param {Object} errors
       * @param {FormController} bookingForm AngularJS form controller object that keeps information about form validation status
       *
       * @return {Booking}
       */
      srvErrors: function (errors, bookingForm) {
        // Reset errors
        this.resetErrors();

        // If errors is not an object we bail out
        if (!underscore.isObject(errors)) errors = {};

        // Set simple fields
        this.errors.subscribe = errors.newsletter_subscribe;


        // TODO: errors.discount_code

        this.errors.paxes = [];
        underscore.each(errors.paxes, function (paxErrors, index) {
          this.errors.paxes[index] = this.getPax(index).srvErrors(paxErrors);
        }, this);

        this.errors.billing = this.billing.srvErrors(errors.billing);
        this.errors.payment = this.payment.srvErrors(errors.payment);
        this.errors.testSell = this.testSell.srvErrors(errors.test_sell);

        // Update validation for angular
        this.setFormValidity(bookingForm);

        return this;
      },
      /**
       * Set errors form server
       *
       * @param {Object} errors
       * @param {FormController} bookingForm AngularJS form controller object that keeps information about form validation status
       *
       * @return {Booking}
       */
      srvErrors2: function (errors, bookingForm) {
        // Reset errors
        this.resetErrors();

        // If errors is not an object we bail out
        if (!underscore.isObject(errors)) errors = {};

        // Set simple fields
        this.errors.subscribe = errors.newsletter_subscribe;


        // TODO: errors.discount_code

        this.errors.testSell = this.testSell.srvErrors(errors.test_sell);

        Order.prototype.srvErrors2.call(this, errors, bookingForm);
        return this;
      },

      /**
       * Set booking from API object
       *
       * @param {Object} srvData
       *
       * @return {Booking}
       */
      srvSet: function (srvData) {
        // Reset before setting server data
        this.reset();
        Order.prototype.srvSet.call(this, srvData);
        // Set insurance
        var insurance = srvData.insurance;
        insurance.type = insurance.type ? insurance.type : null;
        insurance.provider = insurance.provider ? insurance.provider : null;
        insurance.days = insurance.days ? insurance.days : 2;
        insurance.zone = insurance.zone ? insurance.zone : null;
        insurance.isCovid = insurance.isCovid ? insurance.isCovid : false;

        this.insuranceNew
          .setInsuraceAllow(true)
          .fetchProviders([insurance.provider])
          .fetchInsurances(insurance)
          .selectInsurance(insurance.provider, insurance.type);

        this.refund.initWithBookingData(srvData);
        this.fastRefund.initWithBookingData(srvData);
        this.cfar.initWithBookingData(srvData);

        if (srvData.additionalServices && srvData.additionalServices.tripGuarantee) {
          this.tripGuarantee.srvSet(srvData.additionalServices.tripGuarantee);
        }

        if (srvData.additionalServices && srvData.additionalServices.smsNotification) {
          this.smsNotification.srvSet(srvData.additionalServices.smsNotification);
        }

        if (srvData.additionalServices && srvData.additionalServices.paidCheckin) {
          this.paidCheckin.toggle(srvData.additionalServices.paidCheckin.chosen);
          this.paidCheckin.setTotalPrice(srvData.additionalServices.paidCheckin.totalPrice);
        }

        if (srvData.additionalServices && srvData.additionalServices.seats) {
          this.seatSelect.tyPageData = srvData.additionalServices.seats;
        }

        if (srvData.additionalServices && srvData.additionalServices.paidContact) {
          this.frolaAssistance.initWithBookingData(srvData.additionalServices.paidContact);
        }

        if (srvData.additionalServices && srvData.additionalServices.splitFunnel) {
          this.ticketType.initWithBookingData(srvData.additionalServices.splitFunnel);
        }

        if (srvData.payments && srvData.payments.FARE_LOCK) {
          this.fareLock.initWithBookingData(srvData.payments.FARE_LOCK);
        }

        this.payableUntil = srvData.payableUntil || null;
        this.reservationNumber = srvData.reservationNumber || '';
        this.order = srvData.isOrder || false;
        // TODO: set discount and/or coupon

        return this;
      }
    };

    // inherit from Order
    Booking.prototype = new Order();

    // Add methods
    underscore.extend(Booking.prototype, methods);

    Booking.prototype.constructor = Booking;

    return Booking;
  };

  BookingFactory.$inject = [
    'bok.Insurance',
    'InsuranceServices',
    'bil.ContactDetails',
    'bas.Basket',
    'flt.TestSell',
    '$q',
    'fdt.UnitOpts',
    'bok.Order',
    'AuthService',
    'Refund',
    'PaidCheckin',
    'FastRefund',
    'Cfar',
    'SouthParkFlightCache',
    'PaidCheckinRules',
    'GiveawayParticipate',
    'IbeLuggageHandler',
    'TripGuarantee',
    'SeatsInitialData',
    'SeatSelect',
    'TicketType',
    'FrolaAssistance',
    'SmsNotification',
    'FareLock',
  ];

  angular.module('book')
    .factory('bok.Booking', BookingFactory);

})(angular, _);
;

// Source: ../shared/public_html/assets/js/book/models/Cfar.js
(function (angular) {
var CfarModel = function () {
        /**
         * @constructor
         */
        var Cfar = function () {
            /**
             * Is cfar selected?
             *
             * @type {Boolean}
             */
            this.selected = false;

            /**
             * Initialization status
             *
             * @type {Boolean}
             */
            this.initialized = false;

            /**
             * Basket limit amount
             *
             * @type {Number}
             */
            this.basketLimitAmount = 0;

            /**
             * Max refund amount
             *
             * @type {Number}
             */
            this.customerRefundAmount = 0;

            /**
             * Deadline date
             *
             * @type {String}
             */
            this.deadlineDate = '';

            /**
             * Is CFAR available for the current flight(s)?
             *
             * @type {Boolean}
             */
            this.isAllowed = false;

            /**
             * Id from ancillaries service
             *
             * @type {String}
             */
            this.ancillariesRequestId = '';
        };

        /**
         * Toggles selection on or off
         *
         * @param {Boolean} newValue
         */
        Cfar.prototype.toggle = function (newValue) {
            this.selected = newValue;
        };

        /**
         * Initiates model data with booking data
         *
         * @param {Object} data
         */
        Cfar.prototype.initWithBookingData = function (data) {
            if (!this.initialized && data.additionalServices.cfar) {
                this.selected = data.additionalServices.cfar.chosen;
                this.totalPrice = data.additionalServices.cfar.price;
                this.initialized = true;
                this.customerRefundAmount = data.additionalServices.cfar.refundAmount || 0;
                this.deadlineDate = data.additionalServices.cfar.deadlineDate || '';
            }
        };

        /**
         * Initiates model data with flight details data
         *
         * @param {Object} data
         */
        Cfar.prototype.initWithFlightDetails = function (data) {
            if (!this.initialized && data.additionalServices.cfar) {
                this.isAllowed = data.additionalServices.cfar.isAllowed;
                this.basketLimitAmount = data.additionalServices.cfar.basketLimitAmount;
                this.initialized = true;
            }
        };

        /**
         * Initializes cfar from ticket type data
         *
         * @param {object} response
         * @returns
         */
        Cfar.prototype.initWithTicketTypes = function (response) {
            var self = this;

            if (!response.packages.hasOwnProperty('flex')) {
                return;
            }

            response.packages.flex.includes.forEach(function (include) {
                if (include.name === 'CFAR') {
                    self.totalPrice = include.responseQuote.price;
                    self.customerRefundAmount = include.responseQuote.customerRefundAmount;
                    self.ancillariesRequestId = include.responseQuote.requestId;
                }
            });
        };

        /**
         * Checks if it's selected
         *
         * @returns {Boolean}
         */
        Cfar.prototype.isSelected = function () {
            return this.selected;
        };

        /**
         * Returns total price
         *
         * @returns {Number}
         */
        Cfar.prototype.getTotalPrice = function () {
            return this.totalPrice;
        };

        /**
         * Checks if it was initialized
         *
         * @returns {Boolean}
         */
        Cfar.prototype.isInitialized = function () {
            return this.initialized;
        };

        Cfar.prototype.constructor = Cfar;

        return Cfar;
    };

    angular
        .module('book')
        .factory('Cfar', CfarModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/CreditCard.js
/* global _: false */

angular.module('book')

/**
 * @name        CreditCard
 * @namespace   bok
 * @description Class that holds and validates credit card information
 */
.factory('bok.CreditCard',
['Tools', 'ErrorMixin', 'FormErrorMixin', 'appConfig',
function CreditCardFactory(Tools, ErrorMixin, FormErrorMixin, appConfig) {
/**
   * CreditCard constructor
   *
   * @class CreditCard
   * @constructor
   */
  var CreditCard = function () {
    /**
     * Disabled currency switch
     *
     * @type {boolean}
     */
    this.disableCurrencySwitch = false;

    /**
     * Credit card type
     *
     * @type {String}
     */
    this.type = '';

    /**
     * Credit card id
     *
     * @type {String}
     */
    this.id = '';

    /**
     * Credit card holder full name
     *
     * @type {String}
     */
    this.fullName = '';

    /**
     * The credit card number
     *
     * @type {String}
     */
    this.number = '';

    /**
     * Card expiration date
     *
     * @type {NgDate}
     */
    this.expiration = null;

    /**
     * Card expiration date - new format for booking form
     *
     * @type {string}
     */
    this.newExp = '';

    /**
     * CVC code
     *
     * @type {String}
     */
    this.cvc = '';

    /**
     * @type {string}
     */
    this.country_code = appConfig.getDefaultCountryCode();

    /**
     * @type {string}
     */
    this.zip_code = '';

    this.currencies = [];

      /**
       * currency
       *
       * @type {string}
       */
    this.currency = '';

    /**
     * Default credit card number format
     *
     * @type {RegExp}
     */
    this.defaultFormat = /(\d{1,4})/g;

    /**
     * Unknown card placeholder
     *
     * @type {Object}
     */
    this.unknownCard = {
      type: '',
      id: '',
      pattern: /.*/,
      format: this.defaultFormat,
      length: [16],
      cvcLength: [3],
      luhn: true
    };

    /**
     * Default credit cards and properties
     *
     * @type {Array}
     */
    this.cards = [
      {
        type: 'maestro',
        id: 'ME',
        pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
        format: this.defaultFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'dinersclub',
        id: 'DC',
        pattern: /^(36|38|30[0-5])/,
        format: this.defaultFormat,
        length: [14],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'laser',
        id: 'LA',
        pattern: /^(6706|6771|6709)/,
        format: this.defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'jcb',
        id: 'JC',
        pattern: /^35/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'unionpay',
        id: 'UP',
        pattern: /^62/,
        format: this.defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: false
      }, {
        type: 'discover',
        id: 'DI',
        pattern: /^(6011|65|64[4-9]|622)/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'mastercard',
        id: 'MA',
        pattern: /^5[1-5]\d{2}-?\d{4}-?\d{4}-?\d{4}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))-?\d{4}-?\d{4}-?\d{4}$/,
        format: this.defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'amex',
        id: 'AX',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [3, 4],
        luhn: true
      }, {
        type: 'visa',
        id: 'VI',
        pattern: /^4/,
        format: this.defaultFormat,
        length: [13, 16],
        cvcLength: [3],
        luhn: true
      }, {
        type: 'testCard',
        id: 'ME',
        pattern: /^(5000105018126595|5099802211165618)/,
        format: this.defaultFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
      }
    ];

    this.tokenized = false;
    this.tokenizedData = {};

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  /**
   * Validation type token
   *
   * @constant
   * @type {String}
   */
  CreditCard.VALIDATION_TOKEN = 'token';

  /**
   * Validation type CC number
   *
   * @constant
   * @type {String}
   */
  CreditCard.VALIDATION_NUMBER = 'ccNumber';

  // Add instance methods
  CreditCard.prototype = /** @lends CreditCard.prototype */ {

    /**
     * Set credit card type
     *
     * @param {String} type Credit card type/name
     *
     * @return {CreditCard}
     */
    setType: function (type) {
      this.type = type;

      return this;
    },

    /**
     * Get credit card type
     *
     * @return {String|null} Credit card type/name
     */
    getType: function () {
      return this.type;
    },

    /**
     * Set card id
     *
     * @param {String} id
     *
     * @return {CreditCard}
     */
    setId: function (id) {
      this.id = id;

      return this;
    },

    /**
     * Get credit card id
     *
     * @return {String}
     */
    getId: function () {
      return this.id;
    },

    getExpiration: function () {
      if (this.newExp === '' || this.newExp === undefined) {
        return '';
      }

      var expDate = this.newExp.split('/');
      return '20' + expDate[1] + '-' + expDate[0] + '-01 ';
    },

    /**
     * Get credit card expiration year
     *
     * @return {String}
     */
    getExpirationYear: function () {
      return '20' + this.newExp.split('/')[1];
    },

    /**
     * Get credit card expiration month
     *
     * @return {String}
     */
    getExpirationMonth: function () {
      return this.newExp.split('/')[0];
    },

    /**
     * Credit card holder (full name)
     *
     * @return {String}
     */
    getFullName: function () {
      return this.fullName;
    },

    /**
     * Get credit card security code
     *
     * @return {String}
     */
    getCvc: function () {
      return this.cvc;
    },


    /**
     * Get currency
     *
     * @return {String}
     */
    getCurrency: function () {
      return this.currency;
    },

    getCountryCode: function () {
      return this.country_code;
    },

    getZipCode: function () {
      return this.zip_code;
    },

    /**
     * Get currency code
     *
     * @return {String}
     */
    getCurrencyCode: function () {
      return this.currency === 'EURO' ? 'EUR' : this.currency;
    },

    /**
     * Returns credit card object from credit card number
     *
     * @param  {String} num The credit card number
     *
     * @return {Object}     The credit card object
     */
    cardFromNumber: function (num) {
      var card, _i, _len;
      num = (num + '').replace(/\D/g, '');

      for (_i = 0, _len = this.cards.length; _i < _len; _i++) {
        card = this.cards[_i];
        if (card.pattern.test(num)) {
          return card;
        }
      }

      return this.unknownCard;
    },

    /**
     * Returns credit card type from credit card number
     *
     * @param  {String} num The credit card number
     *
     * @return {String}     The credit card name
     */
    typeFromNumber: function (num) {
      return this.cardFromNumber(num).type;
    },

    /**
     * Get credit card number
     *
     * @return {String}
     */
    getNumber: function () {
      return this.number ? this.number.split(" ").join("") : this.number;
    },

    /**
     *
     * @returns {boolean}
     */
    getDisableCurrencySwitch: function(){
      return this.disableCurrencySwitch
    },

    /**
     *
     * @param disable
     * @returns {CreditCard}
     */
    setDisableCurrencySwitch: function(disable){
      this.disableCurrencySwitch = disable;

      return this;
    },

    /**
     * Validates a credit card number
     *
     * @param  {String} num The credit card number
     *
     * @return {Boolean}
     */
    validateCardNumber: function (num) {
      var card, _ref, __indexOf = [].indexOf || function (item) {
          for (var i = 0, l = this.length; i < l; i++) {
            if (i in this && this[i] === item) return i;
          }
          return -1;
        };

      num = (num + '').replace(/\s+|-/g, '');
      if (!/^\d+$/.test(num)) {
        return false;
      }

      card = this.cardFromNumber(num);
      if (!card) {
        return false;
      }

      return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || this.checkLUHN(num));
    },

    /**
     * Performs a LUHN check on credit card number
     *
     * @see http://en.wikipedia.org/wiki/Luhn_algorithm
     *
     * @param  {Number} num The credit card number
     *
     * @return {Boolean}
     */
    checkLUHN: function (num) {
      var digits = (num + '').split('').reverse(),
        odd = true,
        sum = 0,
        digit, _i, _len;

      for (_i = 0, _len = digits.length; _i < _len; _i++) {
        digit = digits[_i];
        digit = parseInt(digit, 10);

        if ((odd = !odd)) {
          digit *= 2;
        }

        if (digit > 9) {
          digit -= 9;
        }

        sum += digit;
      }

      return sum % 10 === 0;
    },

    /**
     * Tokenize card data
     *
     * @param {Object} tokenized
     * @param {string} tokenized.bin - Card BIN
     * @param {string} tokenized.card - Card data token
     * @param {string} tokenized.cvv - encrypted cvv number
     */
    tokenize: function(tokenized) {
      this.tokenized = true;
      this.tokenizedData = tokenized;
    },

    /**
     * @return {String}
     */
    getToken: function () {
      return this.tokenizedData.card_token;
    },

    /**
     * @return {String}
     */
    getBin: function () {
      return this.tokenizedData.bin;
    },

    /**
     * @return {String}
     */
    getCvv: function () {
      return this.tokenizedData.cvc;
    },

    /**
     * @return {String}
     */
    getCredentialsType: function () {
      return this.tokenizedData.validationType;
    },

    setCurrencies: function (currencies) {
      this.currencies = currencies;
      this.currency = currencies[0] || '';

      if (appConfig.isGovola()) {
        var isEuroCurrencyExists = this.currencies.find(function (currency) {
          return currency === 'EUR';
        });

        if (isEuroCurrencyExists) {
          this.currency = 'EUR';
        }
      }
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function() {
      if (this.tokenized) {
        this.tokenized = false;

        return angular.merge(
          {},
          {
            'type': this.getType(),
            'id': this.getId(),
            'currency': this.getCurrency(),
          },
          this.tokenizedData
        );
      }

      return {
        type: this.getType(),
        id: this.getId(),
        full_name: this.getFullName(),
        number: this.getNumber(),
        expiration: this.getExpiration(),
        cvc: this.getCvc(),
        currency: this.getCurrency(),
        country_code: this.getCountryCode(),
        zip_code: this.getZipCode(),
        validationType: CreditCard.VALIDATION_NUMBER,
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {CreditCard}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) {
        errors = {};
      }

      this.errors.cvc = errors.cvc;
      this.errors.expiration = errors.expiration;
      this.errors.fullName = errors.fullName;
      this.errors.ccNumber = errors.number;
      this.errors.type = errors.type;

      this.tokenized = false;

      return this;
    }
  };

  CreditCard.prototype.constructor = CreditCard;

  // Add mixins
  _.extend(CreditCard.prototype, ErrorMixin);
  _.extend(CreditCard.prototype, FormErrorMixin);

  return CreditCard;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/ExchangeRate.js
/* global FlApp: false, _: false, moment: false */

angular.module('book')

/**
 * @name        ExchangeRate
 * @namespace   bok
 * @description Class that handles exchange rates
 */
.factory('bok.ExchangeRate',
[function ExchangeRateFactory() {
/**
   * ExchangeRate constructor
   *
   * @param {Object} apiER The exchange rate from API
   *
   * @constructor
   * @class ExchangeRate
   */
  var ExchangeRate = function (apiER) {
    /**
     * The exchange ID
     *
     * @type {int}
     */
    this.id = apiER.id;

    /**
     * Multiplier
     *
     * @type {Number}
     */
    this.multiplier = apiER.multiplier;

    /**
     * The rate
     *
     * @type {float}
     */
    this.rate1 = apiER.rate1;

    /**
     * The risk
     *
     * @type {Number}
     */
    this.risk = apiER.risk;

    /**
     * The date in
     *
     * @type {Moment}
     */
    this.dateIn = moment(apiER.date_in);

    /**
     * The designation
     *
     * @type {String}
     */
    this.designation = apiER.designation;

    /**
     * The edition date
     *
     * @type {Moment}
     */
    this.editionDay = moment(apiER.edition_day);

    /**
     * The edition name
     *
     * @type {String}
     */
    this.editionName = apiER.edition_name;

    /**
     * The exchange from currency code
     *
     * @type {String} Ex. EUR, PLN, ...
     */
    this.fromCurrencyCode = apiER.from_code || '';

    /**
     * The currency name
     *
     * @type {String}
     */
    this.fromCurrencyName = apiER.from_name;

    /**
     * The exchange to currency code
     *
     * @type {String} Ex: EUR, PLN, ...
     */
    this.toCurrencyCode = apiER.to_code || '';

    /**
     * The exchange to currency code
     *
     * @type {String}
     */
    this.toCurrencyName = apiER.to_name;

    /**
     * The exchange source
     *
     * @type {String} The URL
     */
    this.source = apiER.source;
  };

  /**
   * Calculate hash
   *
   * @param {String} fromCurr The from currency code ex: EUR
   * @param {String} toCurr   The to currency code ex: RON
   *
   * @return {String}
   */
  ExchangeRate.calcHash = function (fromCurr, toCurr) {
    return fromCurr + toCurr;
  };

  // Add instance methods
  ExchangeRate.prototype = /** @lends ExchangeRate.prototype */ {

    /**
     * Get this exchange hash
     *
     * @return {String}
     */
    getHash: function () {
      return ExchangeRate.calcHash(this.fromCurrencyCode, this.toCurrencyCode);
    },

    /**
     * Get the rate for this exchange hash
     *
     * @return {float}
     */
    getRate: function () {
      return this.rate1;
    }
  };

  ExchangeRate.prototype.constructor = ExchangeRate;

  return ExchangeRate;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/GooglePayClient.js
/* eslint-disable no-undef */
(function(angular) {
angular.module('book')

    /**
     * @name        GooglePayClient
     * @namespace   bok
     * @description Class for communication with Google Pay
     */
        .factory('bok.GooglePayClient', ['$rootScope', '$timeout', 'appConfig', '$q', 'FastPaymentLineItem', function GooglePayClientFactory($rootScope, $timeout, AppConfig, $q, FastPaymentLineItem) {
/**
             * GooglePayClient constructor
             *
             * @class GooglePayClient
             * @constructor
             */
            var GooglePayClient = function (scope) {
                this.flightBooking = null;
                this.isReadyToPay = false;
                this.environment = '';
                this.merchantId = '';
                this.client = null;
                this.paymentData = null;
                this.allowedCardAuthMethods = [];
                this.allowedCardNetworks = [];
                // payu = PayU Poland, payuro = PayU Romania
                this.gateway = '';
                this.pos = '';
                this.merchantId = '';
                this.merchantName = '';
                this.countryCode = '';
                this.currencyCode = '';
                this.apiVersion = 2;
                this.apiVersionMinor = 0;
            };

            GooglePayClient.prototype.setFlightBooking = function (flightBooking) {
                this.flightBooking = flightBooking;
            };

            /**
             * Initialize GooglePayClient
             *
             * @param {Object} clientData
             */
            GooglePayClient.prototype.init = function(clientData) {
                if (typeof google === 'undefined') {
                    return;
                }

                // currencyCode should be loaded from proper credential once we support multiple currencies
                // this.currencyCode = clientData.currencyCode;
                this.currencyCode = AppConfig.getCurrencyCode();

                this.allowedCardAuthMethods = clientData.allowedCardAuthMethods;
                this.allowedCardNetworks = clientData.allowedCardNetworks;
                this.environment = clientData.environment;
                this.gateway = clientData.gateway;
                this.pos = clientData.pos;
                this.merchantId = clientData.merchantId;
                this.merchantName = clientData.merchantName;
                this.countryCode = clientData.countryCode || AppConfig.getDefaultCountryCode();

                this.client = new google.payments.api.PaymentsClient({
                    environment: this.environment,
                    merchantInfo: {
                        merchantName: this.merchantName,
                        merchantId: this.merchantId,
                    },
                    paymentDataCallbacks: {
                        onPaymentAuthorized: this.onPaymentAuthorized.bind(this)
                    }
                });

                this.client
                    .isReadyToPay(this.createPaymentRequest())
                    .then(function (response) {
                        if (response.result === true) {
                            try {
                                this.waitForGooglePayBtnDiv(200, 10, (function (div) {
                                    if (div) {
                                        div.replaceChildren(
                                            this.client.createButton({
                                                onClick: this.onGooglePayButtonClicked.bind(this),
                                                buttonType: 'pay',
                                                buttonLocale: AppConfig.getLanguageCode(),
                                                buttonSizeMode: 'fill'
                                            })
                                        );
                                        this.isReadyToPay = true;
                                    } else {
                                        this.isReadyToPay = false;
                                    }
                                }).bind(this));
                            } catch (e) {
                                console.error('Failed to add the Google Pay button', e);
                                this.isReadyToPay = false;
                            }
                        }
                    }.bind(this))
                    .catch(function (err) {
                        this.isReadyToPay = false;
                        console.error('Google Pay initialization failed', err);
                    }.bind(this));
            };

            GooglePayClient.prototype.onPaymentAuthorized = function(paymentData) {
                return $q(function(resolve) {
                    this.paymentData = paymentData;
                    $rootScope.$broadcast('GooglePayTokenGenerated');
                    resolve({
                        transactionState: 'SUCCESS'
                    });
                }.bind(this));
            };

            GooglePayClient.prototype.onGooglePayButtonClicked = function() {
                var paymentDataRequest = this.createPaymentRequest();
                paymentDataRequest.transactionInfo = {
                    countryCode: this.countryCode,
                    currencyCode: this.currencyCode,
                    totalPriceStatus: 'FINAL',
                    totalPrice: this.flightBooking.basket.getTotalPrice().toFixed(2),
                    totalPriceLabel: FastPaymentLineItem.getTotalLabel(),
                    displayItems: [
                        {
                            label: FastPaymentLineItem.getLineItem(this.flightBooking.getFlightDetails()),
                            type: 'LINE_ITEM',
                            price: this.flightBooking.basket.getTotalPrice().toFixed(2),
                        }
                    ]
                };
                paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];
                this.client.loadPaymentData(paymentDataRequest);
            };

            GooglePayClient.prototype.createPaymentRequest = function() {
                return {
                    apiVersion: this.apiVersion,
                    apiVersionMinor: this.apiVersionMinor,
                    merchantInfo: {
                        merchantName: this.merchantName,
                        merchantId: this.merchantId,
                    },
                    allowedPaymentMethods: [
                        {
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: this.allowedCardAuthMethods,
                                allowedCardNetworks: this.allowedCardNetworks,
                            },
                            tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY',
                                parameters: {
                                    gateway: this.gateway,
                                    gatewayMerchantId: this.pos,
                                }
                            },
                        }
                    ]
                };
            };

            /**
             * @return {String}
             */
            GooglePayClient.prototype.getValidationType = function () {
                return this.type;
            };

            /**
             * @return {String}
             */
            GooglePayClient.prototype.getPaymentTokenString = function () {
                if (!this.paymentData) {
                    return '{}';
                }
                return this.paymentData.paymentMethodData.tokenizationData.token;
            };

            /**
             * @return {Object}
             */
            GooglePayClient.prototype.waitForGooglePayBtnDiv = function (interval, maxAttempts, callback) {
                function checkDiv() {
                    var div = document.getElementById('google-pay-btn-div');

                    if (div) {
                        callback(div);
                        return;
                    }

                    if (maxAttempts <= 0) {
                        callback(null);
                        return;
                    }

                    $timeout(checkDiv, interval);
                    maxAttempts--;
                }

                checkDiv();
            };

            GooglePayClient.prototype.constructor = GooglePayClient;

            return GooglePayClient;
        }]);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/Insurance.js
/* global FlApp: false, _: false, moment: false */

angular.module('book')

/**
 * @name        Insurance
 * @namespace   bok
 * @description Class holding information about booking insurance
 */
.factory('bok.Insurance',
['$localStorage', 'ErrorMixin', 'appConfig', '$rootScope',
function InsuranceFactory($localStorage, ErrorMixin, appConfig, $rootScope) {
/**
   * Insurance
   *
   * @class Insurance
   * @constructor
   *
   * @param {int} type Insurance type
   */
  var Insurance = function (type) {
    /**
     * Default type of insurance
     *
     * @type {String}
     */
    this.defaultType = appConfig.getInsuranceConfig();

    /**
     * Selected insurance type
     *
     * Possible values:
     * ''         - no insurance
     * msimple    - simple
     * optim      - optim
     * complex    - complex
     *
     * @type {String}
     */
    this.type = type || ''/* || this.defaultType*/;

    this.provider = null;

    this.package = null;
    /**
     * Default editing state (untouched)
     *
     * If user refreshes page on pax details and insurance is pristine it means that
     * we need to redirect user to insurance step again
     *
     * @type {Boolean}
     */
    this.pristine = true;

    /**
     * For how many days we want to have insurance in OW flight
     *
     * @type {Number}
     */
    this.owNoOfDays = 0;

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Define instance methods
  Insurance.prototype = /** @lends  Insurance.prototype */ {

    /**
     * Set insurance object status as modified by the user
     *
     * @return {Insurance}
     */
    setDirty: function () {
      this.pristine = false;
      return this;
    },

    /**
     * Is insurance object set by the user or pristine (untouched)
     *
     * @return {Boolean}
     */
    isPristine: function () {
      return this.pristine;
    },

    /**
     * Set insurance type
     *
     * @param {String} type Insurance type
     *
     * @return {Insurance}
     */
    setType: function (type) {
      this.type = type;

      // Mark insurance dirty (modified by the user)
      this.setDirty();

      return this;
    },

    setProvider: function (providerName) {
      this.provider = providerName;
      return this;
    },

    setPackage: function (packageName) {
      this.package = packageName;

      return this;
    },

    setOwNoOfDays: function (owNoOfDays) {
      this.owNoOfDays = owNoOfDays;

      return this;
    },

    /**
     * Set insurance type to none
     *
     * @return {Insurance}
     */
    setNone: function () {

      if (typeof ga != 'undefined') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Flight Funnel',
          eventAction: 'Remove insurance',
          eventLabel: '1',
          nonInteraction: true
        });
      }

      this.type = '';
      this.owNoOfDays = 0;
      this.setDirty();
      $rootScope.insuranceAdded = false;
      $rootScope.insuranceAdActionTimeout = false;

      return this;
    },

    /**
     * Is insurance selected
     *
     * @returns {Boolean}
     */
    isSet: function () {
      return this.type !== '';
    },

    /**
     * Reset insurance
     *
     * @return {Insurance}
     */
    reset: function () {
      this.type = "";
      this.pristine = true;
      this.owNoOfDays = 0;

      return this;
    },

    /**
     * Returns the insurance type
     *
     * @return {String}
     */
    getType: function () {
      return this.type;
    },

    /**
     * Returns the number of days for one way
     *
     * @return {Number}
     */
    getOwNoOfDays: function () {
      return this.owNoOfDays;
    },

    /**
     * Validate Insurance
     *
     * @return {Boolean}
     */
    validate: function () {
      // TODO: write validation, populate this.errors
      return true;
    },

    /**
     * Returns this instance as simple object for communicating with backend
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        type: this.type,
        owNoOfDays: this.owNoOfDays,
        package : this.package,
        provider : this.provider
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Insurance}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.type = errors.type;

      return this;
    },

    /**
     * Set insurance from API
     *
     * @param {String} type
     *
     * @return {Insurance}
     */
    srvSet: function (type) {
      this.setType(type);
      return this;
    }
  };

  Insurance.prototype.constructor = Insurance;

  // Add mixins
  _.extend(Insurance.prototype, ErrorMixin);

  return Insurance;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/Order.js
/*global FlApp: false, _: false, moment: false */

angular.module('book')

/**
 * @name        Order
 * @namespace   bok
 * @description Class holding all the information about flight booking
 */
.factory('bok.Order',
  ['bok.Pax', 'bil.ContactDetails', 'bil.Billing', 'bok.Payment', 'ErrorMixin',
  function OrderFactory(Pax, ContactDetails, Billing, Payment, ErrorMixin) {
/**
   * Order
   *
   * @class Order
   * @constructor
   */
  var Order = function () {

    /**
     * The array of paxes
     *
     * @type {Pax[]}
     */
    this.paxes = [];

    /**
     * Contact details
     *
     * @type {ContactDetails}
     */
    this.contactDetails = new ContactDetails();

    /**
     * The billing information
     *
     * @type {Billing}
     */
    this.billing = new Billing();

    /**
     * Order payment information
     *
     * @type {Payment}
     */
    this.payment = new Payment();

    /**
     * used for hotel booking
     *
     * @type {string}
     */
    this.remarks = "";

    /**
     * Used for hotel booking
     *
     * @type {boolean}
     */
    this.newsletter_subscribe = true;

    this.errors = {};

    this.hasBackendErrors = false;

    /**
     * Payment options.
     * Used to display paymentInfo block.
     *
     * @type {Array}
     */
    this.paymentOptions = [];
  };

  // Add instance methods
  Order.prototype = /** @lends Order.prototype */ {

    /**
     * Reset booking data
     */
    reset: function () {
      this.paxes = [];
      this.contactDetails = new ContactDetails();
      this.billing = new Billing();
      this.payment = new Payment();
      this.newsletter_subscribe = false;

      this.resetErrors();
    },

    /**
     * Reset paxes
     */
    resetPaxes: function () {
      if (this.paxes) {
        this.paxes = [];
      }
    },

    /**
     * Get pax
     *
     * @param {int} index
     *
     * @return {Pax}
     */
    getPax: function (index) {
      return this.paxes[index];
    },

    /**
     * Set pax by index with data
     *
     * @param {int} index
     * @param {Pax} pax
     */
    setPax: function (index, pax) {
      this.paxes[index] = pax;
    },

    /**
     * Get all paxes in the booking
     *
     * @return {Pax[]}
     */
    getPaxes: function () {
      return this.paxes;
    },

    /**
     * Get all paxes in the booking
     *
     * @return bool
     */
    paxesHasOption: function (type, segment) {
      for (var i = 0; i < this.paxes.length; i++) {
        if (this.paxes[i].hasOption(type, segment)) {
          return true;
        }
      }

      return false;
    },

    /**
     * Return number of paxes
     *
     * @return {int}
     */
    getPaxCount: function () {
      return this.paxes.length;
    },

    /**
     *
     * @returns {ContactDetails}
     */
    getContact: function () {
      return this.contactDetails;
    },

    /**
     * Get billing
     *
     * @return {Billing}
     */
    getBilling: function () {
      return this.billing;
    },

    /**
     * Returns payment
     *
     * @return {Payment}
     */
    getPayment: function () {
      return this.payment;
    },

    /**
     * Add pax placeholder
     *
     * @param {String} paxType The pax type: ADT, CHD, INF, ...
     */
    addPaxByType: function (paxType) {
      var pax = new Pax(paxType);
      this.paxes.push(pax);

      return pax;
    },

    /**
     * Adds multiple pax placeholders types to Order
     *
     * @param {Object[]} paxArray The array of pax types to add placeholders for
     */
    addPaxesByTypeBulk: function (paxArray) {
      // Preventing a bug (paxes were added each time we got back to previous screen and clicked next)
      if (this.paxes.length) return;

      _.each(paxArray, function (pax) {
        for (var i = 0, paxCount = pax.count; i < paxCount; i++) {
          this.paxes.push(new Pax(pax.paxType));
        }
      }, this);
    },

    /**
     * Returns the time frame in witch the order can be payed
     *
     * @return {datetime}
     */
    getPayableUntil: function () {
      return this.payableUntil;
    },

    /**
     * Validate Order
     *
     * @return {Boolean}
     */
    validate: function () {
      var hasErrors = false;

      this.resetErrors();

      if (this.contactDetails.hasErrors()) {
        this.errors.contactDetails = this.contactDetails.getErrors();
        hasErrors = true;
      }

      if (!this.billing.validate()) {
        this.errors.billing = this.billing.getErrors();
        hasErrors = true;
      }

      this.errors.paxes = [];

      _.each(this.paxes, function (pax, index) {
        if (pax.validate()) {
          this.errors.paxes[index] = null;
        }
        else {
          this.errors.paxes[index] = pax.getErrors();
          hasErrors = true;
        }
      }, this);

      return hasErrors;
    },

    /**
     * Updates validity for all booking details page fields
     *
     * @param {FormController} bookingForm
     */
    setFormValidity: function (bookingForm) {
      // Set billing validity
      switch (this.getBilling().getType()) {
        case 'person':
          this.billing.person.setFormValidity(bookingForm);
          break;
        case 'company':
          this.billing.company.setFormValidity(bookingForm);
          break;
      }

      // Set payment validity
      this.payment.setFormValidity(bookingForm);
    },

    /**
     * Updates validity for passenger details page fields
     *
     * @param {FormController} passengerForm
     * @param {Number} passengerIndex
     */
    setPaxFormValidity: function (passengerForm, passengerIndex) {
      // Set pax validity
      if (typeof this.getPax(passengerIndex) != 'undefined') {
        this.getPax(passengerIndex).setFormValidity(passengerForm);
      }
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        'paxes': _.map(this.paxes, function (pax) { return pax.srvObj(); }),
        'contact': this.contactDetails.srvObj(),
        'billing': this.billing.srvObj(),
        'payment': this.payment.srvObj(),
        'newsletter_subscribe': this.newsletter_subscribe,
        'remarks': this.remarks
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     * @param {FormController} bookingForm AngularJS form controller object that keeps information about form validation status
     *
     * @return {Order}
     */
    srvErrors: function (errors, bookingForm) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      // Set simple fields
      this.errors.subscribe = errors.newsletter_subscribe;

      // Pass errors to other classes
      this.errors.insurance = this.insurance.srvErrors(errors.insurance);

      // TODO: errors.discount_code

      this.errors.paxes = [];
      _.each(errors.paxes, function (paxErrors, index) {
        this.errors.paxes[index] = this.getPax(index).srvErrors(paxErrors);
      }, this);

      this.errors.contactDetails = this.contactDetails.srvErrors(errors.contactDetails);
      this.errors.billing = this.billing.srvErrors(errors.billing);
      this.errors.payment = this.payment.srvErrors(errors.payment);
      this.errors.testSell = this.testSell.srvErrors(errors.test_sell);

      // Update validation for angular
      this.setFormValidity(bookingForm);

      return this;
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     * @param {FormController} bookingForm AngularJS form controller object that keeps information about form validation status
     *
     * @return {Order}
     */
    srvErrors2: function (errors, bookingForm) {
      // Reset errors
      this.resetErrors();

      this.errors.paxes = [];
      _.each(errors.paxes, function (paxErrors, index) {
        this.errors.paxes[index] = this.getPax(index).srvErrors(paxErrors);
      }, this);

      this.errors.contactDetails = this.contactDetails.srvErrors(errors.contact);
      this.errors.billing = this.billing.srvErrors(errors.billing);
      this.errors.payment = this.payment.srvErrors(errors.payment);

      if(errors.antiFraud) {
        this.errors.antiFraud = 1;
      }

      this.setTermsErrors(errors);

      return this;
    },

    /**
     * Set Terms Errors
     * @param errors
     */
    setTermsErrors:function(errors) {
      if(errors.terms_conditions) {
        if(errors.terms_charter_time) {
          this.errors.terms_charter_time = 1;
        }

        if(errors.terms_conditions) {
          this.errors.terms_conditions = 1;
        }

        if(errors.terms_charter_agreement) {
          this.errors.terms_charter_agreement = 1;
        }
      }
    },

    /**
     * Set booking from API object
     *
     * @param {Object} srvData
     *
     * @return {Order}
     */
    srvSet: function (srvData) {
      // Reset before setting server data
      this.reset();

      // Set paxes
      _.each(srvData.paxes, function (paxData, index) {
        this.setPax(index, new Pax(paxData.person.type).srvSet(paxData));
      }, this);

      this.contactDetails.srvSet(srvData.contact);
      this.billing.srvSet(srvData.billing);
      this.payment.srvSet(srvData.payment);

      return this;
    },

    /**
     * Set payment options.
     *
     * @param {Array} options
     */
    setPaymentOptions: function(options) {
      this.paymentOptions = _.map(options, function(elem){
        return {
          type: elem,
          descr: 'LANGM_JS_' + elem + '_PAYMENT_DESC_RD'
        }
      });
    }
  };

  Order.prototype.constructor = Order;

  // Add mixins
  _.extend(Order.prototype, ErrorMixin);

  return Order;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/PBL.js
/* global _: false */

angular.module('book')

/**
 * @name        PBL
 * @namespace   bok
 * @description Class that holds and validates PBL Vendor information
 */
.factory('bok.PBL',
['ErrorMixin', 'FormErrorMixin', 'appConfig',
function PBLFactory(ErrorMixin, FormErrorMixin, appConfig) {
/**
   * PBL constructor
   *
   * @class PBL
   * @constructor
   */
  var PBL = function () {
    /**
     * Bank Code
     *
     * @type {String}
     */
    this.bankCode = '';
    this.vendorData = [];
    this.tokenized = false;
    this.tokenizedData = {};

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  /**
   * Validation type PBL
   *
   * @constant
   * @type {String}
   */
  PBL.VALIDATION_NUMBER = 'bankCode';

  // Add instance methods
  PBL.prototype = /** @lends PBL.prototype */ {
    /**
     * Set available vendors
     */
    setVendorData: function (vendorData) {
      this.vendorData = vendorData;
    },

    /**
     * Get available vendors
     *
     * @return {array}
     */
    getAvailableVendors: function () {
      var currencyVendors = _.find(this.vendorData, function(currencyVendors) {
        return currencyVendors.currency === appConfig.getCurrencyCode();
      }, this);

      return currencyVendors ? currencyVendors.vendors : [];
    },

    /**
     * Tokenize PBL Vendor
     */
    tokenize: function(tokenized) {
      this.tokenized = true;
      this.tokenizedData = tokenized;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function() {
      return {
        bankCode: this.bankCode,
        languageCode: appConfig.getLanguageCode()
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {PBL}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) {
        errors = {};
      }

      this.errors.bankCode = errors.bankCode;
      this.errors.gatewayParams = errors.gatewayParams;

      this.tokenized = false;

      return this;
    }
  };

  PBL.prototype.constructor = PBL;

  // Add mixins
  _.extend(PBL.prototype, ErrorMixin);
  _.extend(PBL.prototype, FormErrorMixin);

  return PBL;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/Pax.js
/* global _: false */
angular.module('book')

/**
 * @name        Pax
 * @namespace   bok
 * @description Class holding passenger information
 */
.factory('bok.Pax',
['bok.Preferences', 'bil.Person', 'bok.Baggage', 'ErrorMixin', 'FormErrorMixin',
function PaxFactory(Preferences, Person, Baggage, ErrorMixin, FormErrorMixin) {
/**
   * Constructor for pax
   *
   * @class Pax
   * @constructor
   *
   * @param {String} paxType
   */
  var Pax = function (paxType) {
    /**
     * The pax personal info
     *
     * @type {Person}
     */
    this.person = new Person();
    this.person.setType(paxType);


    /**
     * Pax luggage information
     *
     * @type {string[]}
     */
    this.luggage = [];


    this.oldLuggage = {
      cabin: null,
      checked: null
    };

    /**
     * Pax optional preferences (frequent flayer card / favorite seat)
     *
     * @type {Preferences}
     */
    this.preferences = new Preferences();

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};

    /**
     * List of available years for this pax
     * NOTE: this is used to populate year dropdown for birthday selector
     *
     * @type {Array}
     */
    this.yearRange = [];

    /**
     * Seat selection data
     */
    this.seats = {
      uuid: null
    };
  };

  /**
   * Adult pax
   *
   * @constant
   * @type {String}
   */
  Pax.ADT = 'ADT';

  /**
   * Child pax
   *
   * @constant
   * @type {String}
   */
  Pax.CHD = 'CHD';

  /**
   * Infant pax
   *
   * @constant
   * @type {String}
   */
  Pax.INF = 'INF';

  /**
   * Unknown pax type
   *
   * @constant
   * @type {String}
   */
  Pax.UNKNOWN = '';

  // Define instance methods
  Pax.prototype = /** @lends Pax.prototype */ {
    /**
     * Set pax birthday year range
     *
     * @param range
     * @returns {Pax}
     */
    setYearRange: function (range) {
      this.yearRange = range;

      return this;
    },

    /**
     * Get year range
     *
     * @param defaultRange
     * @returns {*|Array}
     */
    getYearRange: function (defaultRange) {
      return this.yearRange.length > 0 || defaultRange == undefined ? this.yearRange : defaultRange;
    },

    /**
     * Returns person
     *
     * @return {Person}
     */
    getPerson: function () {
      return this.person;
    },

    /**
     * Returns preferences
     *
     * @return {Preferences}
     */
    getPreferences: function () {
      return this.preferences;
    },

    /**
     * Validate Pax
     *
     * @return {Boolean}
     */
    validate: function () {
      return true;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        person: this.person.srvObj(),
        luggage: this.luggage,
        preferences: this.preferences.srvObj(),
        seats: {
          paxUuid: this.seats.uuid
        }
      };
    },

    /**
     * Set errors form server
     *
     * @param errors
     *
     * @return {Pax}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.person = this.person.srvErrors(errors.person);
      this.errors.preferences = this.preferences.srvErrors(errors.preferences);

      return this;
    },

    /**
     * Set pax from API object
     *
     * todo: IMPLEMENT NEW LOGIC FOR SELLING UNITS
     *
     * @param {Object} srvData
     *
     * @return {Pax}
     */
    srvSet: function (srvData) {
      this.person.srvSet(srvData.person);
      this.preferences.srvSet(srvData.preferences);

      if (Array.isArray(srvData.luggage)) {
        this.luggage = _.map(srvData.luggage, function (entry) {
          if (entry && entry.hasOwnProperty('token')) {
            return entry.token;
          }

          return entry;
        });
      }

      this.oldLuggage.cabin = srvData.cabin_baggage || null;
      this.oldLuggage.checked = srvData.baggage || null;

      if (srvData.seats && srvData.seats.paxUuid) {
        this.seats.uuid = srvData.seats.paxUuid;
      }

      return this;
    },

    /**
     * Chech if Pax can have baggage.
     * Utility method for luggage-related code.
     * At the time of writing this means checking if pax is infant (INF).
     * With this method we can avoid requiring Pax service wherever we need to check this condition
     * (like `pax.getPerson().getType() == Pax.INF`).
     * @returns {boolean}
     */
    canHaveBaggage: function () {
      return ! this.person.isInf();
    }
  };

  Pax.prototype.constructor = Pax;

  // Add mixins
  _.extend(Pax.prototype, ErrorMixin);
  _.extend(Pax.prototype, FormErrorMixin);

  return Pax;
}]);
;

// Source: ../shared/public_html/assets/js/book/models/Payment.js
/*global _: false */

angular.module('book')

/**
 * @name        Payment
 * @namespace   bok
 * @description Class holding payment information
 */
.factory('bok.Payment',
['bok.CreditCard', 'bok.PaymentToken', 'bok.PBL', 'bok.BlikCode', 'bok.PaymentFee', 'ErrorMixin', 'FormErrorMixin', 'bok.GooglePayClient', 'bok.ApplePay', 'bok.RevolutCheckoutClient',
  function PaymentFactory(CreditCard, PaymentToken, PBL, BlikCode, PaymentFee, ErrorMixin, FormErrorMixin, GooglePayClient, ApplePay, RevolutCheckoutClient) {
/**
   * Constructor for payment
   *
   * @class Payment
   * @constructor
   *
   * @param {String} type
   */
  var Payment = function (type) {

    /**
     * Revolut Order Token value indicating token creation failure
     *
     * @constant
     * @type {String}
     */
    Payment.REVOLUT_ORDER_TOKEN_ERROR = 'ERROR';

    /**
     * One of the payment types (default = CC)
     *
     * Possible values:
     * - CC for credit card
     * - BT for bank transfer
     * - CA for cache
     * - CC4 for card avantaj
     *
     * @type {String}
     */
    this.type = type || 'CC';

    /**
     * Card Avantaj installments (default: 2)
     *
     * @type {Number}
     */
    this.installments = 2;

    /**
     * Empty credit card data
     *
     * @todo clean it up
     * @type {CreditCard}
     */
    this.creditCard = new CreditCard();

    /**
     * Google Pay Client.
     *
     * @type {GooglePayClient}
     */
    this.googlePayClient = new GooglePayClient();

    /**
     * Apple Pay.
     *
     * @type {ApplePay}
     */
    this.applePayClient = new ApplePay();

    /**
     * Revolut Checkout Client for Google Pay
     *
     * @type {RevolutCheckoutClient}
     */
    this.revolutCheckoutClientForGooglePay = new RevolutCheckoutClient();

    /**
     * Revolut Checkout Client for Apple Pay
     *
     * @type {RevolutCheckoutClient}
     */
    this.revolutCheckoutClientForApplePay = new RevolutCheckoutClient();

    /**
     * Revolut Checkout Client for Revolut Pay
     *
     * @type {RevolutCheckoutClient}
     */
    this.revolutCheckoutClientForRevolutPay = new RevolutCheckoutClient();

    /**
     * Revolut order token required for Revolut Checkout Widget.
     *
     * If token could not be created it contains:
     * @see Payment.REVOLUT_ORDER_TOKEN_ERROR
     *
     * @type {?String}
     */
    this.revolutOrderToken = null;

    /**
     * Url to redirect to after completed payment in Revolut Checkout Widget
     *
     * @type {?String}
     */
    this.revolutRedirectUrl = null;

    /**
     * Empty blik code data
     *
     * @type {BlikCode}
     */
    this.blikCode = new BlikCode();

    /**
     * Empty PBL data
     *
     * @type {BlikCode}
     */
    this.pbl = new PBL();

    /**
     * Empty payment token data
     *
     * @type {PaymentToken}
     */
    this.paymentToken = new PaymentToken();

    /**
     * Payment method fees
     *
     * This is an object with keys as payment fee type (ex: CA, BT, CC, ...) and values as PaymentFee
     *
     * @type {Object}
     */
    this.fees = {};

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Define instance methods
  Payment.prototype = /** @lends Payment.prototype */ {

    /**
     * Return type of payment
     *
     * @return {String} One of these: CC, BT, CA, CC4
     */
    getType: function () {
      return this.type;
    },

    /**
     * Returns the credit card
     *
     * @return {CreditCard}
     */
    getCreditCard: function () {
      return this.creditCard;
    },

    /**
     * Returns the payment token
     *
     * @return {PaymentToken}
     */
    getPaymentToken: function () {
      return this.paymentToken;
    },

    /**
     * Set payment method fees
     */
    setFees: function (fees) {
      if (fees && fees.list) {
        _.each(fees.list, function (fee, feeId) {
          this.fees[feeId] = new PaymentFee(fee);
        }, this);
      }
    },

    setPaymentOptions: function (paymentOptions) {
      var creditCardCurrencies = _.filter(paymentOptions.getCredentials(), function (credential) {
        return credential.conditions.paymentType === 'CC';
      })
      .map(function (credential) {
        return credential.conditions.currency;
      });


      this.creditCard.setCurrencies(creditCardCurrencies);
    },

    /**
     * Get payment fee for currently selected payment type
     *
     * @param {String|null} [type] Type of payment. Ex: CC, CA, BT, etc.
     *
     * @return {PaymentFee|null}
     */
    getFeeProperties: function (type) {
      var
        payType = type || this.getType(),
      // Get the payment fee type for
        fee = this.fees[payType],
        paymentFee = null,
        feeType, feeOption;

      if (fee == undefined) {
        return null;
      }

      if (payType == 'CC') {
        feeType = fee.getType();

        switch (feeType) {
          case 2: // payment fee per each card (option percent or amount)

            feeOption = fee.getOption(this.creditCard.getId());

            if (feeOption) {
              paymentFee = new PaymentFee();
              paymentFee.amount = +feeOption.amount;
              paymentFee.fromTotalPrice = fee.isFromTotalPrice();
              paymentFee.perPax = fee.isPerPax();
              paymentFee.type = +feeOption.type;
            }
            break;

          default:
            paymentFee = new PaymentFee();
            paymentFee.amount = fee.getAmount();
            paymentFee.fromTotalPrice = fee.isFromTotalPrice();
            paymentFee.perPax = fee.isPerPax();
            paymentFee.type = fee.getType();
        }
      }
      else {
        paymentFee = new PaymentFee();
        paymentFee.amount = fee.getAmount();
        paymentFee.fromTotalPrice = fee.isFromTotalPrice();
        paymentFee.perPax = fee.isPerPax();
        paymentFee.type = fee.getType();
      }

      return paymentFee;
    },

    /**
     * Returns true if paymentFee exists for currently selected payment type
     *
     * @return {Boolean}
     */
    hasPaymentFee: function () {
      return this.getFeeProperties() !== null;
    },

    /**
     * Set payment type
     *
     * @return {Payment} Payment object
     */
    setType: function (type) {
      this.type = type;

      return this;
    },

    /**
     * Set payment type to bank transfer
     *
     * @return {Payment} Payment object
     */
    setTypeBankTransfer: function () {
      this.type = 'BT';

      return this;
    },

    /**
     * Set payment type to cash
     *
     * @return {Payment} Payment object
     */
    setTypeCash: function () {
      this.type = 'CA';

      return this;
    },

    /**
     * Set payment type to Card Avantaj
     *
     * @return {Payment} Payment object
     */
    setTypeAvantaj: function () {
      this.type = 'CC4';

      return this;
    },

    /**
     * Set payment type to ePayment
     *
     * @return {Payment} Payment object
     */
    setTypeEPayment: function () {
      this.type = 'EP';

      return this;
    },

    /**
     * Set installments
     *
     * @param val
     * @returns {Payment}
     */
    setInstallments: function(val){
      this.installments = val;

      return this;
    },

    /**
     * Set revolut order token
     *
     * @return {Payment} Payment object
     */
    setRevolutOrderToken: function (orderToken) {
      this.revolutOrderToken = orderToken;

      return this;
    },

    /**
     * Set revolut order token to error value
     *
     * @return {Payment} Payment object
     */
    setRevolutOrderTokenError: function () {
      this.revolutOrderToken = Payment.REVOLUT_ORDER_TOKEN_ERROR;

      return this;
    },

    /**
     * Check if revolut order creation terminated with error
     *
     * @return {Boolean}
     */
    isRevolutOrderTokenError: function () {
      return this.revolutOrderToken === Payment.REVOLUT_ORDER_TOKEN_ERROR;
    },

    /**
     * Set revolut redirect url
     *
     * @return {Payment} Payment object
     */
    setRevolutRedirectUrl: function (redirectUrl) {
      this.revolutRedirectUrl = redirectUrl;

      return this;
    },

    /**
     * Validate payment type object
     *
     * @return {Boolean}
     */
    validate: function () {
      // TODO: write validation, populate this.errors
      return true;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        'type': this.type,
        'credit_card': this.type === 'CC' ? this.creditCard.srvObj() : undefined,
        'payment_token': this.paymentToken.srvObj(),
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Payment}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) {
        errors = {};
      }

      this.errors.type = errors.type;
      this.errors.installments = errors.installments;
      this.errors.creditCard = this.creditCard.srvErrors(errors.credit_card);
      if (this.type === 'BA') {
        this.errors.blikCode = this.blikCode.srvErrors(errors.payment_token);
      }
      if (this.type === 'PBL') {
        this.errors.pbl = this.pbl.srvErrors(errors.payment_token);
      }

      return this;
    },

    /**
     * Set payment from API object
     *
     * @param {Object} srvData
     *
     * @return {Payment}
     */
    srvSet: function (srvData) {
      this.type = srvData.type;
      this.installments = srvData.installments ? srvData.installments : this.installments;

      return this;
    }
  };

  Payment.prototype.constructor = Payment;

  // Add mixins
  _.extend(Payment.prototype, ErrorMixin);
  _.extend(Payment.prototype, FormErrorMixin);

  return Payment;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/PaymentFee.js
angular.module('book')

/**
 * @name        PaymentFee
 * @namespace   bok
 * @description Class holding a payment fee information
 */
.factory('bok.PaymentFee',
[
function PaymentFeeFactory() {
/**
   * PaymentFee constructor
   *
   * @constructor
   * @class PaymentFee
   */
  var PaymentFee = function (fee) {
    // Fee has not been passed
    if (!fee) return;

    /**
     * Payment fee amount
     *
     * @type {float}
     */
    this.amount = fee.amount || 0;

    /**
     * Fee calculated from total price?
     *
     * @type {Boolean}
     */
    this.fromTotalPrice = fee.fromTotalPrice || false;

    /**
     * Payment fee options
     *
     * @type {Array}
     */
    this.options = fee.options || [];

    /**
     * Payment fee id
     *
     * @type {String} The method ex: CA
     */
    this.id = fee.paymentMethod || '';

    /**
     * Payment fee calculated per pax?
     *
     * @type {Boolean}
     */
    this.perPax = fee.perPax || false;

    /**
     * Payment fee type
     *
     * Supported values:
     *
     * 0 - fix value,
     * 1 - percent,
     * 2 - payment fee per each card (option percent or amount),
     * 3 - fix amount on all cards,
     * 4 - percent on all cards
     *
     * @type {int}
     */
    this.type = fee.type || 0;
  };

  // Add instance methods
  PaymentFee.prototype = /** @lends PaymentFee.prototype */ {

    /**
     * Get payment fee amount
     *
     * @return {Number}
     */
    getAmount: function () {
      return +this.amount;
    },

    /**
     * Get bool if fee is calculate from total price
     *
     * @return {Boolean}
     */
    isFromTotalPrice: function () {
      return this.fromTotalPrice;
    },

    /**
     * Get payment fee options
     *
     * @return {Array}
     */
    getOptions: function () {
      return this.options;
    },

    /**
     * @todo
     * @param id
     * @return {Object}
     */
    getOption: function (id) {
      return this.options[id];
    },

    /**
     * Get bool if payment fee is calculated per price
     *
     * @return {Boolean}
     */
    isPerPax: function () {
      return this.perPax;
    },

    /**
     * Get payment fee type
     *
     * @return {int}
     */
    getType: function () {
      return this.type;
    },

    /**
     * Get payment fee type
     *
     * @return {int}
     */
    isPercentType: function () {
      return this.type === 1 || this.type === 4;
    }
  };

  PaymentFee.prototype.constructor = PaymentFee;

  return PaymentFee;
}]);
;

// Source: ../shared/public_html/assets/js/book/models/PaymentInfo.js
angular.module('book')

/**
 * @name        PaymentInfo
 * @namespace   bok
 * @description
 */
.factory('bok.PaymentInfo',
[
'bok.ExchangeRate',
function PaymentInfoFactory(ExchangeRate) {
/**
   * PaymentInfo constructor
   *
   * @param {Object} apiPI The payment info from API
   *
   * @constructor
   * @class PaymentInfo
   */
  var PaymentInfo = function (apiPI) {
    var exchangeRate, exHash;
    var self = this;

    /**
     * The exchange rate info
     *
     * @type {ExchangeRate}
     */
    this.exchangeRates = {};

    var rates = apiPI.additionalInfo.exchangeRates||[];
    _.each(rates, function (rate) {
      exchangeRate = new ExchangeRate(rate);
      exHash = exchangeRate.getHash();
      if (exHash !== '') {
        self.exchangeRates[exHash] = exchangeRate;
      }
    });

    /**
     * The payment fees
     *
     * @type {Array}
     */
    this.paymentFees = apiPI.paymentFees;
  };

  // Add instance methods
  PaymentInfo.prototype = /** @lends PaymentInfo.prototype */ {

    /**
     * Returns exchange rate
     *
     * @return {ExchangeRate}
     */
    getExchangeRate: function (fromCurr, toCurr) {
      var exHash = ExchangeRate.calcHash(fromCurr, toCurr);

      return this.exchangeRates[exHash];
    },

    /**
     * Add exchange rate
     *
     * @param {ExchangeRate} exchangeRate
     */
    addExchangeRate: function (exchangeRate) {
      this.exchangeRates[exchangeRate.getHash()] = exchangeRate;
    },

    /**
     * Returns payment fees
     *
     * @return {Array}
     */
    getPaymentFees: function () {
      return this.paymentFees;
    }
  };

  PaymentInfo.prototype.constructor = PaymentInfo;

  return PaymentInfo;
}]);
;

// Source: ../shared/public_html/assets/js/book/models/PaymentToken.js
/* global _: false */

angular.module('book')

/**
 * @name        PaymentToken
 * @namespace   bok
 * @description Class that holds and validates payment token information
 */
.factory('bok.PaymentToken',
['Tools', 'ErrorMixin', 'FormErrorMixin',
function PaymentTokenFactory(Tools, ErrorMixin, FormErrorMixin) {
/**
   * PaymentToken constructor
   *
   * @class PaymentToken
   * @constructor
   */
  var PaymentToken = function () {
    this.type = '';
    this.tokenized = false;
    this.tokenizedData = {};

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
   *  property_name: "error message",
   *  property_with_some_instance: that instance
   * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.GOOGLE_PAY_TOKEN = 'GooglePayToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN = 'GooglePayRevolutWidgetToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.APPLE_PAY_TOKEN = 'ApplePayToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN = 'ApplePayRevolutWidgetToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.REVOLUT_PAY_TOKEN = 'RevolutPayToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.BLIK_AUTH_CODE = 'BlikAuthCode';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.PBL_TOKEN = 'PayByLinkToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN = 'CreditCardInstallmentsToken';

  /**
   * @constant
   * @type {String}
   */
  PaymentToken.PAYMENT_INIT_FLOW = 'PaymentInitFlow';


  // Add instance methods
  PaymentToken.prototype = /** @lends PaymentToken.prototype */ {

    /**
     * Set payment token type
     *
     * @param {String} type Payment Token type/name
     *
     * @return {PaymentToken}
     */
    setType: function (type) {
      this.type = type;

      return this;
    },

    /**
     * Get cpayment token type
     *
     * @return {String|null} payment token type/name
     */
    getType: function () {
      return this.type;
    },

    resolveType: function(tokenized) {
      if (tokenized.validationType === PaymentToken.GOOGLE_PAY_TOKEN) {
        return PaymentToken.GOOGLE_PAY_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.APPLE_PAY_TOKEN) {
        return PaymentToken.APPLE_PAY_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN) {
        return PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN) {
        return PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.REVOLUT_PAY_TOKEN) {
        return PaymentToken.REVOLUT_PAY_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.BLIK_AUTH_CODE) {
        return PaymentToken.BLIK_AUTH_CODE;
      }
      if (tokenized.validationType === PaymentToken.PBL_TOKEN) {
        return PaymentToken.PBL_TOKEN;
      }
      if (tokenized.validationType === PaymentToken.PAYMENT_INIT_FLOW) {
        return PaymentToken.PAYMENT_INIT_FLOW;
      }
      if (tokenized.validationType === PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN) {
        return PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN;
      }

      return '';
    },

    /**
     * Tokenize payment token data
     *
     * @param {Object} tokenized
     */
    tokenize: function(tokenized) {
      this.type = this.resolveType(tokenized);
      this.tokenized = true;
      this.tokenizedData = tokenized;
    },

    /**
     * @return {String}
     */
    getGatewayParams: function () {
      return this.tokenizedData.gatewayParams;
    },

    /**
     * @return {String}
     */
    getData: function () {
      return this.tokenizedData.data;
    },

    /**
     * @return {String}
     */
    getSignedMessage: function () {
      return this.tokenizedData.signedMessage;
    },

    /**
     * @return {String}
     */
    getSignature: function () {
      return this.tokenizedData.signature;
    },

    /**
     * @return {String}
     */
    getProtocolVersion: function () {
      return this.tokenizedData.protocolVersion;
    },

    /**
     * @return {String}
     */
    getTransactionId: function () {
      return this.tokenizedData.transactionId;
    },

    /**
     * @return {String}
     */
    getVersion: function () {
      return this.tokenizedData.version;
    },

    /**
     * @return {String}
     */
    getEphemeralPublicKey: function () {
      return this.tokenizedData.ephemeralPublicKey;
    },

    /**
     * @return {String}
     */
    getPublicKeyHash: function () {
      return this.tokenizedData.publicKeyHash;
    },

    /**
     * @return {String}
     */
    getAuthCode: function () {
      return this.tokenizedData.authorizationCode;
    },

    /**
     * @return {String}
     */
    getBankCode: function () {
      return this.tokenizedData.bankCode;
    },

    /**
     * @return {String}
     */
    getLanguageCode: function () {
      return this.tokenizedData.languageCode;
    },

    /**
     * @return {String}
     */
    getPaymentInitFlowType: function () {
      return this.tokenizedData.type;
    },

    /**
     * @return {String}
     */
    getInstallments: function () {
      return this.tokenizedData.installments;
    },

    /**
     * @return {String}
     */
    getCredentialsType: function () {
      return this.tokenizedData.validationType;
    },

    /**
     * @return {String}
     */
    getValidationType: function () {
      return this.type;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function() {
      if (!this.tokenized) {
        return {};
      }
      if (this.type === PaymentToken.GOOGLE_PAY_TOKEN) {
        this.tokenized = false;
        return {
          signedMessage: this.getSignedMessage(),
          protocolVersion: this.getProtocolVersion(),
          signature: this.getSignature(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.GOOGLE_PAY_TOKEN,
        };
      }
      if (this.type === PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN) {
        this.tokenized = false;
        return {
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN,
        };
      }
      if (this.type === PaymentToken.APPLE_PAY_TOKEN) {
        this.tokenized = false;
        return {
          data: this.getData(),
          transactionId: this.getTransactionId(),
          version: this.getVersion(),
          ephemeralPublicKey: this.getEphemeralPublicKey(),
          publicKeyHash: this.getPublicKeyHash(),
          signature: this.getSignature(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.APPLE_PAY_TOKEN,
        };
      }
      if (this.type === PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN) {
        this.tokenized = false;
        return {
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN,
        };
      }
      if (this.type === PaymentToken.REVOLUT_PAY_TOKEN) {
        this.tokenized = false;
        return {
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.REVOLUT_PAY_TOKEN,
        };
      }
      if (this.type === PaymentToken.BLIK_AUTH_CODE) {
        this.tokenized = false;
        return {
          authorizationCode: this.getAuthCode(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.BLIK_AUTH_CODE,
        };
      }
      if (this.type === PaymentToken.PBL_TOKEN) {
        this.tokenized = false;
        return {
          bankCode: this.getBankCode(),
          languageCode: this.getLanguageCode(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.PBL_TOKEN,
        };
      }
      if (this.type === PaymentToken.PAYMENT_INIT_FLOW) {
        this.tokenized = false;
        return {
          type: this.getPaymentInitFlowType(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.PAYMENT_INIT_FLOW,
        };
      }
      if (this.type === PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN) {
        this.tokenized = false;
        return {
          installments: this.getInstallments(),
          gatewayParams: this.getGatewayParams(),
          validationType: PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN,
        };
      }
      return {};
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {PaymentToken}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) {
        errors = {};
      }

      this.errors.type = errors.type;

      this.tokenized = false;

      return this;
    }
  };

  PaymentToken.prototype.constructor = PaymentToken;

  // Add mixins
  _.extend(PaymentToken.prototype, ErrorMixin);
  _.extend(PaymentToken.prototype, FormErrorMixin);

  return PaymentToken;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/Preferences.js
/* global _: false */

angular.module('book')

/**
 * @name        Preferences
 * @namespace   bok
 * @description Class holding flight optional preferences
 */
.factory('bok.Preferences',
['ErrorMixin', 'FormErrorMixin',
function PreferencesFactory(ErrorMixin, FormErrorMixin) {
/**
   * Preferences constructor
   *
   * @constructor
   */
  var Preferences = function () {
    /**
     * Default frequent flier card
     *
     * @type {String}
     */
    this.card = '';

    /**
     * Frequent flier card
     *
     * @type {String}
     */
    this.frequentFlyerCards = [];

    /**
     * Default selected seat
     *
     * Possible values:
     * - WIN for window seat
     * - WAY for isle seat
     *
     * @type {String}
     */
    this.seat = '';

    this.seatPreference = null;

    this.sectionPreference = null;

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
     *
     * @type {Object}
     */
    this.errors = {};
  };

  // Add instance methods
  Preferences.prototype = /** @lends Preferences.prototype */ {

    /**
     * Get fidelity card number
     *
     * @return {String}
     */
    getCard: function () {
      return this.card;
    },

    /**
     * Set fidelity card number
     *
     * @param {String} card number
     *
     * @return {Preferences}
     */
    setCard: function (card) {
      this.card = card;
      return this;
    },

    /**
     * Set ff cards array
     *
     * @return {Preferences}
     */
    getFrequentFlyerCards: function () {
      return this.frequentFlyerCards;
    },

    /**
     * Set ff cards array
     *
     * @param {Array} cards array
     *
     * @return {Preferences}
     */
    setFrequentFlyerCards: function (cards) {
      this.frequentFlyerCards = cards;
      return this;
    },

    /**
     * Get preferred seat
     *
     * @return {String} One of WIN or WAY
     */
    getSeat: function () {
      return this.seat;
    },

    /**
     * Set preferred seat
     *
     * @param {String} seat One of WIN or WAY
     *
     * @return {Preferences}
     */
    setSeat: function (seat) {
      this.seat = seat;

      return this;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        card: this.card,
        seat: this.seat,
        seat_passage: this.seatPreference,
        seat_section: this.sectionPreference
      };
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {Preferences}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.card = errors.card;
      this.errors.seat = errors.seat;

      return this;
    },

    /**
     * Set preferences from API object
     *
     * @param {Object} srvData
     *
     * @return {Preferences}
     */
    srvSet: function (srvData) {
      this.card = srvData.card;
      this.seatPreference = srvData.seat_passage;
      this.sectionPreference = srvData.seat_section;

      return this;
    }
  };

  Preferences.prototype.constructor = Preferences;

  // Add mixins
  _.extend(Preferences.prototype, ErrorMixin);
  _.extend(Preferences.prototype, FormErrorMixin);

  return Preferences;
}]);
;

// Source: ../shared/public_html/assets/js/book/models/RevolutCheckoutClient.js
/* eslint-disable no-undef */
(function(angular, window) {
function RevolutCheckoutClientFactory($rootScope, AppConfig, $log, $modal, $timeout) {
var revolutErrorLogger = function () {
            $log.error('[Revolut payment error]', arguments);
        };

        /**
         * RevolutCheckoutClient constructor
         *
         * @class RevolutCheckoutClient
         * @constructor
         */
        var RevolutCheckoutClient = function (scope) {
            this.publicKey = null;
            this.flightBooking = null;
            this.isReadyToPay = false;
            this.paymentMethod = null;
            this.paymentRequest = null;
            this.paymentRequestInstance = null;
            this.revolutPay = null;
            this.target = null;
            this.paymentErrorModal = false;
            this.creatingOrderInProgress = false;
            this.widgetFlowCancelledDuringApiCall = false;
        };

        RevolutCheckoutClient.prototype.setFlightBooking = function (flightBooking) {
            this.flightBooking = flightBooking;
        };

        RevolutCheckoutClient.prototype.getRevolutOrderToken = function () {
            const ctx = this;

            return new Promise(function (resolve, reject) {
                const pollInterval = 100; // We can check faster since there is no request being made
                const maxAttempts = 1200;
                var attempts = 0;

                const pollOrderToken = function () {
                    attempts++;

                    if (ctx.flightBooking.payment.isRevolutOrderTokenError()) {
                        reject(new Error('Creating order token failed'));
                    } else if (ctx.flightBooking.payment.revolutOrderToken) {
                        clearInterval(polling);
                        resolve(ctx.flightBooking.payment.revolutOrderToken);
                    } else if (attempts >= maxAttempts) {
                        clearInterval(polling);
                        reject(new Error('Polling order token timed out'));
                    }
                };

                const polling = setInterval(pollOrderToken, pollInterval);
            });
        };

        /**
         * Initialize RevolutCheckoutClient
         *
         * @param {String} publicKey
         * @param {String} paymentMethod either "applePay" or "googlePay"
         */
        RevolutCheckoutClient.prototype.init = function (publicKey, paymentMethod) {
            if (typeof RevolutCheckout === 'undefined') {
                return;
            }

            const ctx = this;
            ctx.publicKey = publicKey;
            ctx.paymentMethod = paymentMethod;

            switch (paymentMethod) {
                case 'revolutPay':
                    RevolutCheckout
                        .payments({
                            locale: AppConfig.getLanguageCode(), // Optional, defaults to "auto"
                            publicToken: publicKey, // Merchant public API key
                            mode: AppConfig.isTest() || AppConfig.isLocal() ? 'sandbox' : 'prod'
                        })
                        .then(function (paymentsInstance) {
                            ctx.revolutPay = paymentsInstance.revolutPay;
                            ctx.target = document.getElementById('revolut-pay-btn-div');

                            ctx.mountRevolutPayPromotionalBanner();
                            ctx.mountRevolutPay();

                            $rootScope.$watch(function () {
                                return ctx.flightBooking.basket.getTotalPrice();
                            }, function () {
                                ctx.mountRevolutPay();
                            });
                        });
                    break;

                case 'applePay':
                case 'googlePay':
                    RevolutCheckout
                        .payments({
                            locale: AppConfig.getLanguageCode(), // Optional, defaults to "auto"
                            publicToken: publicKey, // Merchant public API key
                        })
                        .then(function (paymentsInstance) {
                            ctx.paymentRequest = paymentsInstance.paymentRequest;

                            if (ctx.paymentMethod === 'googlePay') {
                                ctx.target = document.getElementById('google-pay-btn-div');
                            }

                            if (ctx.paymentMethod === 'applePay') {
                                ctx.target = document.getElementById('apple-pay-btn-div');
                            }

                            ctx.initPaymentRequest();

                            $rootScope.$watch(function () {
                                return ctx.flightBooking.basket.getTotalPrice();
                            }, function () {
                                ctx.initPaymentRequest();
                            });
                        });
                    break;
            }
        };

        RevolutCheckoutClient.prototype.initPaymentRequest = function () {
            const ctx = this;

            if (ctx.paymentRequestInstance !== null) {
                ctx.paymentRequestInstance.destroy();
            }

            ctx.paymentRequestInstance = ctx.paymentRequest(ctx.target, {
                // 3-letter currency code
                currency: AppConfig.getCurrencyCode(),
                // In lowest denomination e.g., cents
                amount: parseInt(ctx.flightBooking.basket.getTotalPrice().toFixed(2) * 100),
                // applePay/googlePay
                preferredPaymentMethod: ctx.paymentMethod,
                buttonStyle: {
                    height: '46px',
                    size: 'large',
                    radius: 'small',
                    variant: 'dark'
                },
                createOrder: function () {
                    ctx.creatingOrderInProgress = true;
                    $rootScope.$broadcast('RevolutPayTriggered');

                    return ctx
                        .getRevolutOrderToken()
                        .then(function (orderToken) {
                            ctx.creatingOrderInProgress = false;
                            return {
                                publicId: orderToken,
                            };
                        })
                        .catch(function (error) {
                            ctx.creatingOrderInProgress = false;
                            revolutErrorLogger(error);
                        });
                },
                onSuccess: function () {
                    // Redirects to TYP
                    window.location.href = ctx.flightBooking.payment.revolutRedirectUrl;
                },
                onError: function (error) {
                    // Todo: to consider notifying backend about error occured on frontend side to prevent user stuck in pending state
                    revolutErrorLogger(error);

                    if (ctx.flightBooking.payment.revolutRedirectUrl) {
                        window.location.href = ctx.flightBooking.payment.revolutRedirectUrl;
                    } else {
                        ctx.showPaymentErrorModal();
                    }
                }
            });

            ctx.paymentRequestInstance
                .canMakePayment()
                .then(function (method) {
                    if (method) {
                        $timeout(function () {
                            ctx.paymentRequestInstance.render();
                            ctx.isReadyToPay = true;
                        }, 50);

                        return;
                    }

                    ctx.paymentRequestInstance.destroy();
                    ctx.isReadyToPay = false;
                });
        };

        RevolutCheckoutClient.prototype.mountRevolutPayPromotionalBanner = function () {
            const ctx = this;

            RevolutCheckout.upsell({
                locale: AppConfig.getLanguageCode(),
                mode: AppConfig.isTest() || AppConfig.isLocal() ? 'sandbox' : 'prod',
                publicToken: ctx.publicKey
            }).then(function (upsellInstance) {
                const promotionalBanner = upsellInstance.promotionalBanner;

                ctx.getTargetById('revolut-pay-promotional-banner-wide').then(function (target) {
                    target.innerHTML = '';
                    promotionalBanner.mount(
                        target,
                        {
                            variant: 'banner',
                            currency: AppConfig.getCurrencyCode(),
                        }
                    );
                });
            });
        };

        RevolutCheckoutClient.prototype.mountRevolutPay = function () {
            const ctx = this;

            if (ctx.revolutPay !== null) {
                ctx.revolutPay.destroy();
            }

            const redirectUrls = {
                success: AppConfig.getPaymentsConfig().host + '/public/revolut-checkout/success',
                failure: AppConfig.getPaymentsConfig().host + '/public/revolut-checkout/failure',
                cancel: AppConfig.getPaymentsConfig().host + '/public/revolut-checkout/cancel'
            };

            ctx.revolutPay.mount(ctx.target, {
                // 3-letter currency code
                currency: AppConfig.getCurrencyCode(),
                // In lowest denomination e.g., cents
                totalAmount: parseInt(ctx.flightBooking.basket.getTotalPrice().toFixed(2) * 100),
                buttonStyle: {
                    height: '46px',
                    size: 'large',
                    radius: 'small',
                    variant: 'dark',
                    cashback: false,
                    cashbackCurrency: AppConfig.getCurrencyCode()
                },
                createOrder: function () {
                    ctx.creatingOrderInProgress = true;
                    $rootScope.$broadcast('RevolutPayTriggered');

                    return ctx
                        .getRevolutOrderToken()
                        .then(function (orderToken) {
                            ctx.creatingOrderInProgress = false;

                            if (ctx.widgetFlowCancelledDuringApiCall) {
                                window.location.href = redirectUrls.cancel + '?_rp_oid=' + orderToken;
                            }

                            return {
                                publicId: orderToken,
                            };
                        })
                        .catch(function (error) {
                            ctx.creatingOrderInProgress = false;
                            revolutErrorLogger(error);
                        });
                },
                mobileRedirectUrls: redirectUrls
            });

            ctx.revolutPay.on('payment', function (event) {
                switch (event.type) {
                    case 'cancel': {
                        if (event.orderId) {
                            window.location.href = redirectUrls.cancel + '?_rp_oid=' + event.orderId + '&_rp_dos=' + event.dropOffState;
                        } else if (ctx.creatingOrderInProgress) {
                            ctx.widgetFlowCancelledDuringApiCall = true;
                        }

                        break;
                    }
                    case 'success':
                        window.location.href = ctx.flightBooking.payment.revolutRedirectUrl;

                        break;
                    case 'error':
                        revolutErrorLogger(event);

                        if (event.orderId) {
                            window.location.href = redirectUrls.failure + '?_rp_oid=' + event.orderId;
                        }

                        break;
                }
            });

            ctx.isReadyToPay = true;
        };

        RevolutCheckoutClient.prototype.showPaymentErrorModal = function () {
            const ctx = this;

            if (!ctx.paymentErrorModal) {
                ctx.paymentErrorModal = true;
                var modal = $modal.open({
                    templateUrl: '/tpl/show/templates/components/modals/funnel/paymentError',
                    controller: 'PaymentErrorModalCtrl',
                    controllerAs: '$ctrl',
                    backdrop: 'static',
                });

                modal.result.then(function () {
                    ctx.paymentErrorModal = false;
                });
            }
        };

        /**
         * @return {Promise}
         */
        RevolutCheckoutClient.prototype.getTargetById = function (id) {
            return new Promise(function (resolve, reject) {
                const interval= 200;
                var maxAttempts= 10;

                const checkTarget = function() {
                    var target = document.getElementById(id);

                    if (target) {
                        resolve(target);
                    }

                    if (maxAttempts <= 0) {
                        reject();
                    }

                    $timeout(checkTarget, interval);
                    maxAttempts--;
                };

                checkTarget();
            });
        };

        RevolutCheckoutClient.prototype.constructor = RevolutCheckoutClient;

        return RevolutCheckoutClient;
    }

    RevolutCheckoutClientFactory.$inject = [
        '$rootScope',
        'appConfig',
        '$log',
        '$modal',
        '$timeout'
    ];

    angular
        .module('book')
        /**
         * @name        RevolutCheckoutClient
         * @namespace   bok
         * @description Class for communication with Revolut
         */
        .factory('bok.RevolutCheckoutClient', RevolutCheckoutClientFactory);

}(angular, window));
;

// Source: ../shared/public_html/assets/js/book/models/SmsNotification.js
(function(angular) {
var SmsNotificationModel = function () {
        var SmsNotification = function () {
            this.isPopulated = false;
            this.enabled = false;
            this.requestId = null;
            this.chosen = false;
            this.price = 0;
        };

        SmsNotification.prototype.isChosen = function () {
            return this.chosen;
        };

        SmsNotification.prototype.populateFromWebSocket = function (responseObject, code) {
            if (code >= 400) {
                this.isPopulated = true;
                return;
            }

            this.enabled = responseObject.enabled;
            this.requestId = responseObject.requestId;
            this.price = responseObject.price;
            this.isPopulated = true;
        };

        SmsNotification.prototype.getPrice = function () {
            return this.price;
        };

        SmsNotification.prototype.srvSet = function (smsNotificationData) {
            this.chosen = smsNotificationData.chosen;
            this.price = smsNotificationData.price;
        };

        SmsNotification.prototype.srvObj = function () {
            return {
                chosen: this.chosen,
                requestId: this.requestId,
                price: this.price
            };
        };

        SmsNotification.prototype.constructor = SmsNotification;

        return SmsNotification;
    };

    angular
        .module('book')
        .factory('SmsNotification', SmsNotificationModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/ZoozArgs.js
/*global _: false */

angular.module('book')

/**
 * @name        ZoozArgs
 * @namespace   bok
 * @description Class using for communication with ZoozArgs
 */
.factory('bok.ZoozArgs',
['bok.CreditCard',
function ZoozArgsFactory(CreditCard) {
/**
   * UNUSED NOW!!!
   */


  /**
   * Constructor for payment
   *
   * @see modules/payment_module/libraries/Zooz.php::targetSerialize
   *
   * @class ZoozArgs
   * @constructor
   *
   * @param {Object} obj
   */
  var ZoozArgs = function (obj) {

    /** @type {String} */
    this.paymentToken = obj.paymentToken || '';

    /** @type {String} */
    this.uniqueId = obj.uniqueId || '';

    /** @type {String} */
    this.paymentMethodType = obj.paymentMethodType || '';

    /** @type {String} */
    this.hashParam = obj.param || '';

    /** @type {Boolean} */
    this.sandbox = obj.sandbox || false;

    /** @type {String} */
    this.email = obj.email || '';

    /** @type {String} */
    this.errUrl = obj.errUrl || '';

    /**
     * Empty credit card data
     *
     * @type {CreditCard}
     */
    this.creditCard = new CreditCard();

    /**
     * Errors object
     *
     * Used in templates to mark error fields and show error messages
     * The keys are filed names and values are error messages or instances.
     *
     * Example:
     *
     * {
     *  property_name: "error message",
     *  property_with_some_instance: that instance
     * }
     *
     * @type {Object}
     */
    this.errors = {};

    /** @type {Boolean} */
    this.success = false;

    /** @type {String} */
    this.paymentMethodStatus = '';

    /** @type {String} */
    this.paymentMethodToken = '';
  };

  /**
   * Baggage
   *
   * @constant
   * @type {String}
   */
  ZoozArgs.LIVE_UPDATE_NAME = 'zooz';

  // serialize
  ZoozArgs.SRV_OBJ_ZOOZ_INIT_PARAMS = 'SRV_OBJ_ZOOZ_INIT_PARAMS';
  ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_REQ = 'SRV_OBJ_ZOOZ_PAYMENT_REQ';
  ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_AUTH = 'SRV_OBJ_ZOOZ_PAYMENT_AUTH';

  // flow
  ZoozArgs.FLOW_3DS = 'FLOW_3DS';
  ZoozArgs.FLOW_DEFAULT = 'FLOW_DEFAULT';

  // define instance methods
  ZoozArgs.prototype = /** @lends ZoozArgs.prototype */ {

    /**
     * Parse success response
     *
     * @param {Object} response
     */
    parseSuccess: function (response) {
      this.success = true;

      this.paymentMethodStatus = response.paymentMethodStatus.toString();
      this.paymentMethodToken = response.paymentMethodToken;
    },

    /**
     * Parse failed response
     *
     * @param {Object} response
     */
    parseFailed: function (response) {
      this.success = false;

      var processorError = '';
      if (response.processorError != null) {
        processorError = "DeclineCode: " + response.processorError.declineCode.toString() + "; DeclineReason: " + response.processorError.declineReason.toString();
      }

      this.errors.processorError = processorError;
      this.errors.responseError = response.responseErrorCode.toString() + ": " + response.errorDescription.toString();
      this.paymentMethodStatus = '';
      this.paymentMethodToken = '';
    },

    /**
     * Set the credit card
     *
     * @param {CreditCard} creditCard
     *
     * @return {ZoozArgs}
     */
    setCreditCard: function (creditCard) {
      this.creditCard = creditCard;

      return this;
    },

    /**
     * Set email
     *
     * @param {String} email
     *
     * @return {ZoozArgs}
     */
    setEmail: function (email) {
      this.email = email;

      return this;
    },

    /**
     * Returns the credit card
     *
     * @return {CreditCard}
     */
    getCreditCard: function () {
      return this.creditCard;
    },

    /**
     * Returns error basket url
     *
     * @return {String}
     */
    getErrUrl: function () {
      return this.errUrl;
    },

    /**
     * Validate payment type object
     *
     * @return {Boolean}
     */
    validate: function () {
      // TODO: write validation, populate this.errors
      return true;
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @param {String} sType
     *
     * @return {Object}
     */
    srvObj: function (sType) {
      switch(sType) {
        case ZoozArgs.SRV_OBJ_ZOOZ_INIT_PARAMS:
          return {
            isSandbox: this.sandbox,
            uniqueId: this.uniqueId
          };

        case ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_REQ:
          var
            cc = this.creditCard.srvObj(),
            expDate = moment(cc.expiration);

          return {
            "paymentToken": this.paymentToken,
            "email": this.email,
            "paymentMethod": {
              "paymentMethodType": this.paymentMethodType,
              "paymentMethodDetails": {
                "cardNumber": cc.number,
                "month": expDate.format('MM'),
                "year": expDate.format('YYYY'),
                "cvvNumber": cc.cvc
              }
            }
          };

        case ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_AUTH:
          return {
            "success": this.success,
            "paymentMethodStatus": this.paymentMethodStatus,
            "paymentMethodToken": this.paymentMethodToken,
            "param": this.hashParam,
            "sandbox": this.sandbox,
            "paymentMethodType": this.paymentMethodType
          };

        default:
      }

      return {};
    },

    /**
     * Set errors form server
     *
     * @param {Object} errors
     *
     * @return {ZoozArgs}
     */
    srvErrors: function (errors) {
      // Reset errors
      this.resetErrors();

      // If errors is not an object we bail out
      if (!_.isObject(errors)) errors = {};

      this.errors.type = errors.type;
      this.errors.installments = errors.installments;
      this.errors.creditCard = this.creditCard.srvErrors(errors.credit_card);

      return this;
    }
  };

  ZoozArgs.prototype.constructor = ZoozArgs;

  // Add mixins
  //_.extend(Payment.prototype, ErrorMixin);

  return ZoozArgs;
}]);

;

// Source: ../shared/public_html/assets/js/book/models/fast-refund.model.js
(function(angular) {
var caclulatePrice = function (base, ctx) {
        var price = Math.round(base * ctx.factor * 100) / 100;
        return price < ctx.minimalPrice ? ctx.minimalPrice : price;
    };

    var FastRefundModel = function () {
        /**
         * @constructor
         */
        var FastRefund = function () {
            /**
             * Is fast refund selected?
             *
             * @type {Boolean}
             */
            this.selected = false;

            /**
             * Initialization status
             *
             * @type {Boolean}
             */
            this.initialized = false;

            /**
             * Percent from total
             *
             * @type {Number}
             */
            this.factor = 0;

            /**
             * Minimum price
             *
             * @type {Number}
             */
            this.minimalPrice = 0;

            /**
             * Calculated total price
             *
             * @type {Number}
             */
            this.totalPrice = 0;

            /**
             * Determines the visibility of the fast refund box
             *
             * @type {Boolean}
             */
            this.isAllowed = false;
        };

        /**
         * Toggles selection on or off
         *
         * @param {Boolean} newValue
         */
        FastRefund.prototype.toggle = function (newValue) {
            this.selected = newValue;
        };

        /**
         * Initiates model data with booking data
         *
         * @param {Object} data
         */
        FastRefund.prototype.initWithBookingData = function (data) {
            if (!this.initialized && data.additionalServices.fastRefund) {
                this.selected = data.additionalServices.fastRefund.chosen;
                this.totalPrice = data.additionalServices.fastRefund.totalPrice;
                this.initialized = true;
                this.isAllowed = true;
            }
        };

        /**
         * Initiates model data with flight details data
         *
         * @param {Object} data
         * @param {Number} refundBasePrice
         */
        FastRefund.prototype.initWithFlightDetails = function (data, refundBasePrice) {
            if (!this.initialized && data.additionalServices.fastRefund) {
                this.factor = data.additionalServices.fastRefund.factor;
                this.minimalPrice = data.additionalServices.fastRefund.minimalPrice;
                this.totalPrice = caclulatePrice(refundBasePrice, this);
                this.isAllowed = data.additionalServices.fastRefund.isAllowed;
                this.initialized = true;
            }
        };

        /**
         * Checks if it's selected
         *
         * @returns {Boolean}
         */
        FastRefund.prototype.isSelected = function () {
            return this.selected;
        };

        /**
         * Returns total price
         *
         * @returns {Number}
         */
        FastRefund.prototype.getTotalPrice = function () {
            return this.totalPrice;
        };

        /**
         * Checks if it was initialized
         *
         * @returns {Boolean}
         */
        FastRefund.prototype.isInitialized = function () {
            return this.initialized;
        };

        /**
         * @param {number} price
        */
        FastRefund.prototype.surchargeIfAdded = function (price) {
            if (!this.selected) {
                return price;
            }

            return price + Math.round(price * this.factor * 100) / 100;
        };

        FastRefund.prototype.constructor = FastRefund;

        return FastRefund;
    };

    angular
        .module('book')
        .factory('FastRefund', FastRefundModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/giveaway-participate.model.js
(function (angular) {
var GiveawayParticipateModel = function (appConfig) {
    var getDefaultSelected = function () {
      if (!appConfig.getAbConfig().assign_into_giveaway || appConfig.getAbConfig().assign_into_giveaway === 'Off') {
        return null;
      }

      return true;
    };

    var GiveawayParticipate = function () {
      /**
       * @type {?Boolean}
       */
      this.selected = getDefaultSelected();
    };

    GiveawayParticipate.prototype.constructor = GiveawayParticipate;

    return GiveawayParticipate;
  };

  GiveawayParticipateModel.$inject = ['appConfig'];

  angular
    .module('book')
    .factory('GiveawayParticipate', GiveawayParticipateModel);
}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/paid-checkin-rules.model.js
(function(angular) {
var PaidCheckinRulesModel = function (AutomatedCheckinHelper) {
        /**
         * @constructor
         */
        var PaidCheckinRules = function () {
            /**
             * @type {CheckinAirlineRuleModel[]}
             */
            this.checkinAirlineRules = [];

            /**
             * @type {Boolean}
             */
            this.hasFreeCheckin = false;

            /**
             * @type {Boolean}
             */
            this.hasPaidCheckin = false;

            /**
             * @type {CheckinAirlineRuleModel[]}
             */
            this.onlineFreeRules = [];

            /**
             * @type {CheckinAirlineRuleModel[]}
             */
            this.airportPaidRules = [];

            /**
             * @type {CheckinAirlineRuleModel[]}
             */
            this.onlyAirportMandatoryRules = [];
        };

        /**
         * Parses rules and prepares all needed data for templates
         *
         * @param {Object[]} rules
         */
        PaidCheckinRules.prototype.setRules = function (rules) {
            this.checkinAirlineRules = AutomatedCheckinHelper.parseAirlineRules(rules);
            this.hasFreeCheckin = AutomatedCheckinHelper.hasFreeCheckin(this.checkinAirlineRules);
            this.hasPaidCheckin = AutomatedCheckinHelper.hasPaidCheckin(this.checkinAirlineRules);
            this.onlineFreeRules = AutomatedCheckinHelper.getOnlineFreeRules(this.checkinAirlineRules);
            this.airportPaidRules = AutomatedCheckinHelper.getAirportPaidRules(this.checkinAirlineRules);
            this.onlyAirportMandatoryRules = AutomatedCheckinHelper.getAirportMandatoryRules(this.checkinAirlineRules);
        };

        return PaidCheckinRules;
    };

    PaidCheckinRulesModel.$inject = [
        'AutomatedCheckinHelper'
    ];

    angular
        .module('book')
        .factory('PaidCheckinRules', PaidCheckinRulesModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/models/paid-checkin.model.js
(function(angular) {
var PaidCheckinModel = function () {
        /**
         * @constructor
         */
        var PaidCheckin = function () {
            /**
             * Paid checkin selected state
             *
             * @type {Boolean}
             */
            this.selected = false;

            /**
             * Paid checkin total price
             *
             * @type {Float}
             */
            this.totalPrice = null;
        };

        /**
         * Toggles selection on or off
         *
         * @param {Boolean} newValue
         */
        PaidCheckin.prototype.toggle = function (newValue) {
            this.selected = newValue;
        };

        /**
         * @param {Float} value
         */
        PaidCheckin.prototype.setTotalPrice = function (value) {
            this.totalPrice = value;
        };

        /**
         * Checks if it's selected
         *
         * @returns {Boolean}
         */
        PaidCheckin.prototype.isSelected = function () {
            return this.selected;
        };

        /**
         * @returns {Float}
         */
        PaidCheckin.prototype.getTotalPrice = function () {
            return this.totalPrice;
        };

        PaidCheckin.prototype.constructor = PaidCheckin;

        return PaidCheckin;
    };

    angular
        .module('book')
        .factory('PaidCheckin', PaidCheckinModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/payment-retry/ith-payment-retry-submit.component.js
(function(angular) {
var template = '\
        <div class="fd-form margin-top-medium">\
            <div class="fd-form__wrapper text-center">\
                <button class="btn btn-lg btn-primary btn-block ng-animate-disabled" ng-disabled="$ctrl.isDisabled()" ng-click="$ctrl.submit()" ng-if="$ctrl.isSubmitPaymentButtonVisible()">\
                    <span ng-if="$ctrl.isLoading()" class="spin-loader ng-animate-disabled"></span>\
                    <span ng-if="!$ctrl.isLoading()" translate>LANGM_JS_PAY</span>\
                </button>\
                <div id="google-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isGooglePayPayment() || $ctrl.isLoading()">\
                </div>\
                <div id="apple-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isApplePayPayment() || $ctrl.isLoading()">\
                </div>\
                <div id="revolut-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isRevolutPayPayment() || $ctrl.isLoading()">\
                </div>\
                <ith-preloader class="ng-animate-disabled" size="38" ng-if="($ctrl.isGooglePayPayment() || $ctrl.isApplePayPayment() || $ctrl.isRevolutPayPayment()) && $ctrl.isLoading()"></ith-preloader>\
            </div>\
        </div>\
    ';

    var controller = function ($rootScope, $timeout, $q, BookingFormHelper, MediaMatch) {
        /**
         * @type {controller}
         */
        var self = this;

        /**
         * Is mobile?
         *
         * @type {Boolean}
         */
        this.isMobileResolution = true;

        this.rootEvents = {
            GooglePayTokenGenerated: null,
            ApplePayTokenGenerated: null,
            RevolutPayTriggered: null
        };

        /**
         * Determines if buttons are disabled
         *
         * @returns {Boolean}
         */
        this.isDisabled = function () {
            return $rootScope.paymentInProgress;
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isGooglePayPayment = function() {
            return this.booking.payment.type === 'GP' || this.booking.payment.type === 'GP2';
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isApplePayPayment = function() {
            return this.booking.payment.type === 'AP' || this.booking.payment.type === 'AP2';
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isRevolutPayPayment = function() {
            return this.booking.payment.type === 'RP';
        };

        /**
         * Determines if loading should be displayed on the submit payment button
         *
         * @returns {Boolean}
         */
        this.isLoading = function () {
            return $rootScope.paymentInProgress;
        };

        /**
         * Determines if submit button should be visible
         *
         * @returns {Boolean}
         */
        this.isSubmitPaymentButtonVisible = function () {
            if (this.isGooglePayPayment() || this.isApplePayPayment() || this.isRevolutPayPayment()) {
                return false;
            }

            return true;
        };

        /**
         * Validate forms and submit payment
         */
        this.submit = function () {
            var lastStepForms = BookingFormHelper.getLastStepForms(
                this.form,
                this.booking.paxes.length
            );

            angular.forEach(lastStepForms, function (subForm) {
                subForm.$setSubmitted(true);
            });

            if (!BookingFormHelper.areAllFormsValid(lastStepForms)) {
                return;
            }

            $timeout(function () {
                // Send data to backend
                self.bookingFormSync();
            }, 50);
        };

        this.$onInit = function () {
            this.rootEvents.GooglePayTokenGenerated = $rootScope.$on('GooglePayTokenGenerated', function () {
                self.submit();
            });
            this.rootEvents.ApplePayTokenGenerated = $rootScope.$on('ApplePayTokenGenerated', function () {
                self.submit();
            });
            this.rootEvents.RevolutPayTriggered = $rootScope.$on('RevolutPayTriggered', function () {
                self.submit();
            });

            var matchMediaQuery = MediaMatch.listen('(min-width: 768px)', function (event) {
                self.isMobileResolution = !event.matches;
            });

            self.isMobileResolution = !matchMediaQuery.matches;
        };

        this.$onDestroy = function () {
            this.rootEvents.GooglePayTokenGenerated();
            this.rootEvents.ApplePayTokenGenerated();
            this.rootEvents.RevolutPayTriggered();
        };
    };

    controller.$inject = [
        '$rootScope',
        '$timeout',
        '$q',
        'BookingFormHelper',
        'MediaMatch'
    ];

    var IthPaymentRetrySubmitController = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<',
            form: '<',
            bookingFormSync: '&'
        }
    };

    angular
        .module('book')
        .component('ithPaymentRetrySubmit', IthPaymentRetrySubmitController);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/payment-retry/ith-payment-retry.component.js
(function(angular) {
angular
        .module('book')
        .component('ithPaymentRetry', {
            templateUrl: '/tpl/show/jsShared/templates/flights/booking/payment-retry',
            controller: 'PaymentRetryController',
            bindings: {
                paymentToken: '<',
                flightBooking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/payment-retry/ith-payment-retry.controller.js
(function(angular) {
var IthPaymentRetryController = function ($window, $location, $rootScope, $scope, $sce, $stateParams, $timeout, PaymentPage, CreditCard, $modal, $exceptionHandler, PageLoadingService, ZoozArgs, ZoozServ, PaymentTokenize, appConfig, ErrorLogService, PaymentApi, Booking, PaymentToken, PaymentInject, PaymentOptions, PaymentInfo) {
        var ctrl = this;

        $rootScope.paymentInProgress = false;

        /**
         * Payment error message
         *
         * @type {string}
         */
        ctrl.message = '';

        /**
         * Payment amount details
         *
         * @type Object
         */
        ctrl.details = {};

        ctrl.initialLoading = false;
        ctrl.inProcess = false;
        ctrl.model = new CreditCard();
        ctrl.paymentError = false;
        ctrl.paymentRetryForm = undefined;

        /**
         * Prepare flight booking for a retry payment
         */
        ctrl.flightBooking.getFlightDetails().paymentOptions = new PaymentOptions();

        /**
         * Load payment retry view
         */
        ctrl.loadPayment = function () {
            var data = {};
            data.id = ctrl.paymentToken;
            data.ngData = 1;
            ctrl.initialLoading = true;

            PaymentPage.index(data, $location.search())
                .then(function success(response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                    }

                    ctrl.message = response.message;
                    ctrl.details = response.details;

                    ctrl.flightBooking.getFlightDetails().getPaymentOptions().srvSet(response.po);

                    PaymentTokenize.setCredentials(
                        response.po.credentials ? response.po.credentials : []
                    );

                    ctrl.flightBooking.payment.pbl.setVendorData(
                        ctrl.flightBooking.getFlightDetails().getPaymentOptions().getVendorData()
                    );

                    ctrl.flightBooking.getPayment().googlePayClient.setFlightBooking(ctrl.flightBooking);
                    ctrl.flightBooking.getPayment().applePayClient.setFlightBooking(ctrl.flightBooking);
                    ctrl.flightBooking.getPayment().revolutCheckoutClientForGooglePay.setFlightBooking(ctrl.flightBooking);
                    ctrl.flightBooking.getPayment().revolutCheckoutClientForApplePay.setFlightBooking(ctrl.flightBooking);
                    ctrl.flightBooking.getPayment().revolutCheckoutClientForRevolutPay.setFlightBooking(ctrl.flightBooking);

                    ctrl.paymentInject = new PaymentInject(
                        ctrl.flightBooking.getPayment().googlePayClient,
                        ctrl.flightBooking.getPayment().applePayClient,
                        ctrl.flightBooking.getPayment().revolutCheckoutClientForGooglePay,
                        ctrl.flightBooking.getPayment().revolutCheckoutClientForApplePay,
                        ctrl.flightBooking.getPayment().revolutCheckoutClientForRevolutPay
                    );

                    ctrl.paymentInject.check(
                        ctrl.flightBooking.getFlightDetails().getPaymentOptions()
                    );

                    if (!response.paymentInfo.additionalInfo.exchangeRate) {
                        ctrl.flightBooking.getPayment().getCreditCard().setDisableCurrencySwitch(true);
                    } else {
                        ctrl.flightBooking.getPayment().getCreditCard().setDisableCurrencySwitch(response.standaloneIns);
                    }

                    // Update exchange rates
                    ctrl.flightBooking.getFlightDetails().paymentInfo = new PaymentInfo(response.paymentInfo);

                }, function () {
                    ctrl.paymentError = true;
                }).catch(function () {
                    ctrl.paymentError = true;
                }).finally(function () {
                    ctrl.initialLoading = false;
                });
        };

        function getCreditCardCurrency() {
            return ctrl.flightBooking.getPayment().getCreditCard().getCurrencyCode() || appConfig.getCurrencyCode();
        }

        function handleInitPurchaseResponse(initPurchaseResponse, redirectLink) {
            if (initPurchaseResponse.redirect_type === 'form') {
                submitForm(initPurchaseResponse.redirect_attributes, initPurchaseResponse.redirect_url);
            } else if (initPurchaseResponse.redirect_type === 'revolut_widget') {
                ctrl.flightBooking.payment.setRevolutOrderToken(initPurchaseResponse.redirect_attributes[0].value);
                ctrl.flightBooking.payment.setRevolutRedirectUrl(redirectLink);
            } else if (initPurchaseResponse.redirect_url) {
                window.location.href = initPurchaseResponse.redirect_url;  // 3DS
            } else {
                window.location.href = redirectLink;
            }
        }

        function submitForm(redirectAttributes, redirectUrl) {
            var formAttributes = redirectAttributes.reduce(function (attributes, current) {
                attributes[current.name] = current.value;
                return attributes;
            }, {});

            $timeout(function () {
                $rootScope.$broadcast('paymentGatewayMicroservice',
                    {
                        url: $sce.trustAsResourceUrl(redirectUrl),
                        method: "post",
                        data: formAttributes,
                        id: "cardPaymentGatewayMicroservice"
                    });
            }, 2000);
        }

        function paymentError(response) {
            $rootScope.paymentInProgress = false;

            if (response.response.expiredLink === true) {
                ctrl.paymentError = true;
            } else {
                if (response.payment.errors.payment.details) {
                    ctrl.model.errors = response.payment.errors.payment.details;
                }

                $exceptionHandler(new Error('Payment problem ', response.payment.errors));
            }
        }

        ctrl.openPaymentProcessingModal = function () {
            ctrl.paymentProcessingModal = $modal.open({
              templateUrl: '/tpl/show/templates/components/modals/funnel/paymentProcessing',
              backdrop: 'static',
            });
        };

        ctrl.tokenizeDefault = function (credentials) {
            return PaymentTokenize.init(credentials)
                .then(function() {
                    // here we should already have a google/apple/blik code/pbl from frontend logic
                    var tokenString = '{}';

                    if (credentials.type === PaymentToken.GOOGLE_PAY_TOKEN) {
                        tokenString = ctrl.flightBooking.payment.googlePayClient.getPaymentTokenString();
                    }

                    if (credentials.type === PaymentToken.APPLE_PAY_TOKEN) {
                        tokenString = ctrl.flightBooking.payment.applePayClient.getPaymentTokenString();
                    }

                    if (credentials.type === PaymentToken.BLIK_AUTH_CODE) {
                        tokenString = JSON.stringify(ctrl.flightBooking.payment.blikCode.srvObj());
                    }

                    if (credentials.type === PaymentToken.PBL_TOKEN) {
                        tokenString = JSON.stringify(ctrl.flightBooking.payment.pbl.srvObj());
                    }

                    if (credentials.type === PaymentToken.PAYMENT_INIT_FLOW && credentials.conditions.paymentType === 'BT') {
                        tokenString = JSON.stringify({type: 'transfer'});
                    }

                    if (credentials.type === PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN && credentials.conditions.paymentType === 'CC4') {
                        tokenString = JSON.stringify({installments: ctrl.flightBooking.payment.installments});
                    }

                    if (credentials.type === PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN && credentials.conditions.paymentType === 'GP2') {
                        tokenString = JSON.stringify({type: 'google_pay_revolut_widget'});
                    }

                    if (credentials.type === PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN && credentials.conditions.paymentType === 'AP2') {
                        tokenString = JSON.stringify({type: 'apple_pay_revolut_widget'});
                    }

                    return PaymentTokenize.parseToken(tokenString);
                })
                .then(function(tokenData) {
                    ctrl.flightBooking.payment.paymentToken.tokenize(tokenData);
                })
                .catch(function(error) {
                    if (!appConfig.isEnvProd()) {
                        console.warn('PaymentTokenize', error);
                    }
                    if (!(error instanceof TypeError) && error instanceof Error) {
                        // dont log 'Wrong driver' tokenization problem
                        // @see PaymentTokenize.init
                        ErrorLogService.sendErrorLog(error);
                    }
                    throw error;
                });
        };

        ctrl.prepareToken = function () {
            var currency = getSelectedPaymentType() === 'CC' ? getCreditCardCurrency() : appConfig.getCurrencyCode();

            if (getSelectedPaymentType() === 'CC4') {
                currency = appConfig.getCurrencyForCreditCardInstallments();
            }

            // need to resolve currencies here, should not take currency from credit card setting for gp/ap etc
            var credentials = PaymentTokenize.findCredential({
                currency: currency,
                paymentType: getSelectedPaymentType(),
            });

            if (getSelectedPaymentType() === 'CC') {
                return ctrl.tokenizeCreditCard(credentials);
            }

            return ctrl.tokenizeDefault(credentials);
        };

        ctrl.tokenizeCreditCard = function (credentials) {
            return PaymentTokenize.init(credentials)
                .then(function() {
                    var cardObj = ctrl.flightBooking.payment.creditCard.srvObj();

                    return PaymentTokenize.tokenize(cardObj);
                })
                .then(function (tokenized) {
                  if (!ctrl.model.getDisableCurrencySwitch()) {
                    tokenized.currency = ctrl.flightBooking.payment.creditCard.getCurrency();
                  }

                  ctrl.flightBooking.payment.creditCard.tokenize(tokenized);
                })
                .catch(function(error) {
                    if (!appConfig.isEnvProd()) {
                        console.warn('PaymentTokenize', error);
                    }
                    if (!(error instanceof TypeError) && error instanceof Error) {
                        // dont log 'Wrong driver' tokenization problem
                        // @see PaymentTokenize.init
                        ErrorLogService.sendErrorLog(error);
                    }
                    throw error;
                });
        };

        ctrl.paymentMicroserviceFlow = function () {
            var redirectLink, paymentData;
            if (ctrl.flightBooking.payment.paymentToken.tokenized) {
                paymentData = ctrl.flightBooking.payment.paymentToken;
            } else {
                paymentData = ctrl.flightBooking.payment.creditCard;
            }
            var credentialsType = paymentData.getCredentialsType();

            var data = {
                id: ctrl.paymentToken,
                ngData: 1
            };

            data.payment = {};
            data.payment.details = paymentData.tokenizedData;
            data.payment.type = getSelectedPaymentType();

            PaymentPage.index(data)
                .then(function success(response) {
                        if (response.version !== data.payment.details.validationType) {
                            handleError(
                                new Error('Payment error: validation type does not match response version')
                            );
                            return;
                        }

                        redirectLink = response.redirectLink;
                        ctrl.openPaymentProcessingModal();

                        return PaymentApi
                            .initPurchase(response.bookingResponse.paymentServiceParams, paymentData, credentialsType)
                            .then(function (response) {
                                $timeout(function () {
                                    handleInitPurchaseResponse(response, redirectLink);
                                }, 1500);
                            }).catch(function (error) {
                                ctrl.paymentProcessingModal.close();
                                handleError(
                                    error instanceof Error ? error : new Error('Payment error')
                                );
                            });
                    },
                    function (response) {
                        paymentError(response);
                    }
                ).catch(
                    function (error) {
                        handleError(error);
                    }
                );
        };

        ctrl.submitPayment = function () {
            $rootScope.paymentInProgress = true;

            ctrl.prepareToken().then(
                function () {
                    ctrl.paymentMicroserviceFlow();
                }
            ).catch(
                function (error) {
                  handleError(error);
                }
            );
        };

        function handleError(error) {
            $rootScope.paymentInProgress = false;
            ctrl.showPaymentErrorModal();
            $exceptionHandler(error);
        }

        function getSelectedPaymentType() {
            return ctrl.flightBooking.getPayment().getType();
        }

        ctrl.setPaymentRetryForm = function (paymentRetryForm ) {
            ctrl.paymentRetryForm = paymentRetryForm;
        };

        /**
         * Returns payment options.
         *
         * @return {PaymentOptions}
         */
        ctrl.getPaymentOptions = function () {
            return ctrl.flightBooking.paymentOptions;
        };

      ctrl.showPaymentErrorModal = function () {
        var paymentErrorModal = $modal.open({
          templateUrl: '/tpl/show/templates/components/modals/funnel/paymentError',
          controller: 'PaymentErrorModalCtrl',
          controllerAs: '$ctrl',
          backdrop: 'static',
        });

        paymentErrorModal.result.then(function () {
          $window.location.reload();
        });
      };

        ctrl.loadPayment();
    };

    IthPaymentRetryController.$inject = ['$window', '$location', '$rootScope', '$scope', '$sce', '$stateParams', '$timeout', 'PaymentPage', 'bok.CreditCard', '$modal', '$exceptionHandler', 'PageLoading', 'bok.ZoozArgs', 'bok.ZoozServ', 'PaymentTokenize', 'appConfig', 'ErrorLogService', 'PaymentApi', 'bok.Booking', 'bok.PaymentToken', 'PaymentInject', 'fdt.PaymentOptions', 'bok.PaymentInfo'];

    angular
        .module('book')
        .controller('PaymentRetryController', IthPaymentRetryController);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/payment-status/ith-booking-status.component.js
(function(angular) {
angular
        .module('book')
        .component('ithBookingStatus', {
            templateUrl: '/tpl/show/jsShared/templates/flights/booking/booking-status',
            controller: function () {
                /**
                 *
                 * @returns {String}
                 */
                this.getLang = function () {
                    if (this.status === 'success') {
                        return 'LANGM_JS_TY_PAGE_PAID';
                    }

                    if (this.status === 'cancelled') {
                        return 'LANGM_JS_TY_PAGE_CANCELLED';
                    }

                    return 'LANGM_JS_TY_PAGE_' + this.paymentType.toUpperCase() + '_' + this.status.toUpperCase();
                };

                /**
                 *
                 * @returns {Boolean}
                 */
                this.isVisible = function () {
                    return this.paymentType !== '';
                };

                /**
                 *
                 * @returns {String}
                 */
                this.getTitle = function () {
                    return this.getLang() + '_TITLE';
                };

                /**
                 *
                 * @returns {String}
                 */
                this.getContent = function () {
                    return this.getLang() + '_CONTENT';
                };

                /**
                 *
                 * @returns {String}
                 */
                this.getButtonLang = function () {
                    return 'LANGM_JS_TY_PAGE_PAY_' + this.paymentType.toUpperCase();
                };

                /**
                 *
                 * @returns {Boolean}
                 */
                this.showPayButton = function () {
                    // Payment types that need the pay button
                    var buttonPaymentTypes = ['cc3', 'ep', 'pp'];

                    return (
                        buttonPaymentTypes.includes(this.paymentType.toLowerCase()) &&
                        this.status.toLowerCase() === 'waiting'
                    );
                };

                this.isPayButtonLoading = function () {
                    return this.paymentButtonIsLoading;
                };

                this.getOnlySuccessAndFailStatus = function () {
                    if (this.status === 'waiting') {
                        return 'success';
                    }

                    return this.status;
                };
            },
            bindings: {
                status: '@', // Success, Waiting
                paymentType: '@', // BT, CC, Etc
                paymentButtonIsLoading: '<',
                booking: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/payment-status/ith-payment-status.component.js
(function(angular) {
var ctrl = function () {
        /**
         * Content for display by status
         *
         * @type {Object}
         */
        var contentByStatus = {
            loading: {
                headline: 'LANGM_JS_PAYMENT_STATUS_PROCESSING',
                desc: 'LANGM_JS_PAYMENT_STATUS_PROCESSING_DESC'
            },
            success: {
                headline: 'LANGM_JS_PAYMENT_STATUS_CONFIRMED',
                desc: 'LANGM_JS_PAYMENT_STATUS_CONFIRMED_DESC'
            },
            error: {
                headline: 'LANGM_JS_PAYMENT_STATUS_FAILED',
                desc: 'LANGM_JS_PAYMENT_STATUS_FAILED_REDIRECT'
            },
            expired: {
                headline: 'LANGM_JS_PAYMENT_STATUS_EXPIRED',
                desc: 'LANGM_JS_PAYMENT_STATUS_EXPIRED_DESC'
            },
            slow: {
                headline: 'LANGM_JS_PAYMENT_STATUS_PROCESSING',
                desc: 'LANGM_JS_PAYMENT_STATUS_PROCESSING_SLOW_DESC'
            }
        };

        /**
         * Status for the notification component
         *
         * @type {String}
         */
        this.notificationStatus = 'loading';

        /**
         * Status for the displayed messages
         *
         * @type {String}
         */
        this.messageStatus = 'loading';

        /**
         * Status for notification component
         *
         * @returns {String} error | loading
         */
        var getNotificationStatus = function (status, statuses) {
            switch (status) {
                case statuses.ERROR: return 'error';
                case statuses.EXPIRED: return 'error';
                default: return 'loading';
            }
        };

        /**
         * Status for message display
         *
         * @returns {String}
         */
        var getMessageStatus = function (status, statuses, pendingAttempts, maxPendingAttempts) {
            if (status === statuses.PENDING) {
                // Loading state
                if (pendingAttempts > maxPendingAttempts) {
                    return 'slow';
                }

                return 'loading';
            }

            if (status === statuses.EXPIRED) {
                return 'expired';
            }

            return 'error';
        };

        /**
         * Returns headline by status
         *
         * @returns {String}
         */
        this.getHeadline = function () {
            return contentByStatus[this.messageStatus].headline;
        };

        /**
         * Returns description by status
         *
         * @returns {String}
         */
        this.getDesc = function () {
            if (this.service.isError() && this.service.getErrorMessage()) {
                return this.service.getErrorMessage();
            } else {
                return contentByStatus[this.messageStatus].desc;
            }
        };

        /**
         * On changes hook
         */
        this.$onChanges = function () {
            var intStatus = parseInt(this.status);
            this.notificationStatus = getNotificationStatus(
                intStatus,
                this.service.statuses
            );

            this.messageStatus = getMessageStatus(
                intStatus,
                this.service.statuses,
                this.service.pendingAttempts,
                this.service.maxPendingAttempts
            );
        };
    };

    angular
        .module('book')
        .component('ithPaymentStatus', {
            templateUrl: '/tpl/show/jsShared/templates/flights/booking/payment-status',
            controller: ctrl,
            bindings: {
                retryCallback: '&',
                service: '<',
                status: '@',
                pendingAttempts: '@',
                reservationNumber: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/services/BookingServ.js
angular.module('book')

/**
 * @name        BookingServ
 * @namespace   bok
 * @description
 */
.factory('bok.BookingServ',
['appConfig', 'ApiTools', 'bok.FlightBooking', 'fdt.FlightDetails','SalesManagoSrv',
function BookingServFactory(AppConfig, ApiTools, FlightBooking, FlightDetails, SalesManagoSrv) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Booking
      desktopBooking: {
        url: AppConfig.getUriPrefix() + '/api/book/flight/:requestId/:priceGroupId/:depLegId/:retLegId' +'?abv='+_js_app_config_.ab_version ,
        method: 'POST',
        respParser: respRaw
      },

      validateSplitFunnel: {
        url: AppConfig.getUriPrefix() + '/api/book/validate/',
        method: 'POST',
        respParser: respRaw
      },

      lockPriceBooking: {
        url: AppConfig.getUriPrefix() + '/api/book/lockPrice/:requestId/:priceGroupId/:depLegId/:retLegId' +'?abv='+_js_app_config_.ab_version ,
        method: 'POST',
        respParser: respRaw
      },

      // Payment request
      paymentRequest: {url: AppConfig.getUriPrefix() + '/api/payment/request/:requestId' +'?abv='+_js_app_config_.ab_version , method: 'GET', respParser: respRaw},

      // Make payment
      makePayment: {url: AppConfig.getUriPrefix() + '/api/payment/make/:requestId' +'?abv='+_js_app_config_.ab_version , method: 'POST', respParser: respRaw},

      // Add coupon
      addCoupon: {
        url: AppConfig.getUriPrefix() + '/api/coupons/checkFlightCoupon/:requestId/:priceGroupId/:depLegId/:retLegId' +'?abv='+_js_app_config_.ab_version ,
        method: 'POST',
        respParser: respRaw
      },

      // View order
      viewOrder: {url: AppConfig.getUriPrefix() + '/api/book/details/:hash' +'?abv='+_js_app_config_.ab_version , method: 'GET', respParser: bookingParser},

      // Change price
      replacePricing: {
        url: AppConfig.getUriPrefix() + '/api/testSell/replacePricing/:requestId/:priceGroupId/:depLegId/:retLegId' +'?abv='+_js_app_config_.ab_version ,
        method: 'GET',
        respParser: respRaw
      }
    },

    /**
     * @class BookingServ
     * @constructor
     */
    BookingServ = function () {};

  BookingServ.prototype = /** @lends BookingServ.prototype */ {
    /**
     * Send booking data
     *
     * @param  {Object} booking      The Booking.srvObj() result
     * @param  {Object} routeParams
     *
     * @return {Promise}
     */
    sendBookingData: function (booking, routeParams) {
        if (!routeParams.retLegId) {
          routeParams.retLegId = '';
        }

        if( !routeParams.requestId || !routeParams.priceGroupId || !routeParams.depLegId){
          throw 'route params missing: ' + JSON.stringify(routeParams);
        }

        return ApiTools.fetch(this, endpoints.desktopBooking, booking, routeParams);
    },

    validateSplitFunnelFirstStep: function (booking) {
      return ApiTools.fetch(this, endpoints.validateSplitFunnel, booking);
    },

    /**
     * Create lock price booking
     *
     * @param  {Object} booking      The Booking.srvObj() result
     * @param  {Object} routeParams
     *
     * @return {Promise}
     */
    createLockPrice: function (booking, routeParams) {
      if (!routeParams.retLegId) {
        routeParams.retLegId = '';
      }

      return ApiTools.fetch(this, endpoints.lockPriceBooking, booking, routeParams);
    },

    /**
     * Get payment details
     *
     * @param  {Object} routeParams
     *
     * @return {Promise}
     */
    getPaymentDetails: function (routeParams) {
      return ApiTools.fetch(this, endpoints.paymentRequest, null, routeParams);
    },

    /**
     * Send credit card payment details
     *
     * @param  {creditCard|Object} ccData      The credit card information
     * @param  {Object}            routeParams The route parameters
     *
     * @return {Promise}
     */
    makePayment: function (ccData, routeParams) {
      return ApiTools.fetch(this, endpoints.makePayment, ccData, routeParams);
    },

    /**
     * Send coupon code to backend for validation
     *
     * @param {String} couponCode  The coupon/voucher code
     * @param {Object} routeParams The route parameters
     */
    addCoupon: function (couponCode, routeParams) {
      if (!routeParams.retLegId) {
        routeParams.retLegId = '';
      }

      //TODO: check if this was not move to CouponServ::addCoupon ????
      return ApiTools.fetch(this, endpoints.addCoupon, {code: couponCode}, routeParams);
    },

    /**
     * Get thank you page data
     *
     * @param  {String} hash
     *
     * @return {Promise}
     */
    getFromHash: function (hash) {
      return ApiTools.fetch(this, endpoints.viewOrder, null, {hash: hash});
    },

    /**
     * Replace pricing in case of price diff
     *
     * @param  {Object} routeParams The route parameters
     *
     * @return {Promise}
     */
    replacePricing: function (routeParams) {
      return ApiTools.fetch(this, endpoints.replacePricing, null, routeParams);
    }
  };

  BookingServ.prototype.constructor = BookingServ;

  /**
   * Parse example response
   *
   * @param  {Object} response
   *
   * @return {FlightBooking}
   */
  function bookingParser(response) {
    var resp = response.response, ret = {};

    // Set booking data
    FlightBooking.srvSet(resp.bookingDetails);

    // Got flight details
    ret = FlightBooking.setFlightDetails(FlightDetails.srvSet(resp.flightDetails));
    ret.waitForPaymentStatus = resp.waitForPaymentStatus;
    ret.flow = resp.flow;

    //Sales Manago
    if(resp.nl_response && resp.nl_response.contactId)
    {
      SalesManagoSrv.load(resp.nl_response.contactId);
    }

    return ret;
  }

  /**
   * Returns raw API response
   *
   * @param {Object} response The API response
   *
   * @return {Object}
   */
  function respRaw(response) {
    return response.response;
  }

  return new BookingServ();
}]);
;

// Source: ../shared/public_html/assets/js/book/services/FlightBooking.js
angular.module('book')

/**
 * @name        FlightBooking
 * @namespace   bok
 * @description Flight booking singleton
 */
.factory('bok.FlightBooking', ['bok.Booking',
function FlightBookingFactory(Booking) {
return new Booking();
}]);

;

// Source: ../shared/public_html/assets/js/book/services/InsuranceServ.js
angular.module('book')

/**
 * @name        InsuranceServ
 * @namespace   dsc
 * @description Class that handles coupon communication with the API
 */
  .factory('dsc.InsuranceServ', ['ApiTools',
    function InsuranceServFactory(ApiTools) {
var
        /**
         * The API endpoints configuration
         * The API endpoints configuration
         *
         * Each endpoint is a configuration object which must have following properties:
         *
         * - {String}   url        The URL to the API with optional parameters as :parameterName
         * - {String}   method     The one of HTTP verbs (POST, GET...)
         * - {Function} respParser The function called by SearchAPI before returning results to caller.
         *                         It always receives two arguments the SearchAPI instance and the server JSON response
         *                         object. It must return whatever should be returned to the SearchAPI caller.
         *                         Returning $q.reject from this function will trigger error handler on calling code.
         */
        endpoints = {
          // Add coupon
          resetInsurance: {
            url: '/ngInsurance/getForFlight/:requestId/:priceGroupId/:depLegId/:retLegId' + '?abv=' + _js_app_config_.ab_version,
            method: 'POST',
            respParser: insuranceParser
          },
          getForReservation: {
            url: '/ngInsurance/getForReservation?abv=' + _js_app_config_.ab_version,
            method: 'POST',
            respParser: insuranceParser
          },
          addToOrder: {
            url: '/ngInsurance/add?abv=' + _js_app_config_.ab_version,
            method: 'POST',
            respParser: insuranceParser
          }
        },

        /**
         * @class InsuranceServ
         * @constructor
         */
        InsuranceServ = function () {
        };

      InsuranceServ.prototype = /** @lends InsuranceServ.prototype */ {

        /**
         * Send coupon code to backend for validation
         *
         * @param {String} params  Params
         * @param {Object} routeParams The route parameters
         */
        resetInsurance: function (params, routeParams) {

          if (!routeParams.retLegId) {
            routeParams.retLegId = '';
          }
          if (!routeParams.priceGroupId) {
            routeParams.priceGroupId = '';
          }
          if (!routeParams.fsId) {
            routeParams.fsId = '';
          }
          if (!routeParams.depLegId) {
            routeParams.depLegId = '';
          }
          return ApiTools.fetch(this, endpoints.resetInsurance, params, routeParams);
        },
        /**
         * @param {String} params  Params
         * @param {Object} routeParams The route parameters
         */
        getForReservation: function (params, routeParams) {

          return ApiTools.fetch(this, endpoints.getForReservation, params, routeParams);
        },
        /**
         * @param {String} params  Params
         * @param {Object} routeParams The route parameters
         */
        addToOrder: function (params, routeParams) {
          return ApiTools.fetch(this, endpoints.addToOrder, params, routeParams);
        }
      };

      InsuranceServ.prototype.constructor = InsuranceServ;

      /**
       * Parse example response
       *
       * @param {Object} response
       *
       * @return {Object}
       */
      function insuranceParser(response) {
        return response.response;
      }

      return new InsuranceServ();
    }]);

;

// Source: ../shared/public_html/assets/js/book/services/ZoozServ.js
angular.module('book')

/**
 * @name        ZoozServ
 * @namespace   bok
 * @description
 */
.factory('bok.ZoozServ',
['$rootScope', '$location', '$sce', 'ApiTools', 'bok.ZoozArgs',
function ZoozServFactory($rootScope, $location, $sce, ApiTools, ZoozArgs) {
/**
   * UNUSED NOW!!!
   */

  var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Zooz payment finishing
      zoozPaymentFinish: {
        url: '/zooz/zoozPaymentFinishing',
        method: 'POST',
        respParser: respRaw
      }
    },

    /**
     * @class ZoozServ
     * @constructor
     */
    ZoozServ = function () {};

  ZoozServ.prototype = /** @lends ZoozServ.prototype */ {
    /**
     * Send booking data
     *
     * @param  {Object} obj
     *
     * @return {Promise}
     */
    sendZoozPayment: function (obj) {
        return ApiTools.fetch(this, endpoints.zoozPaymentFinish, obj);
    },

    /**
     * Add payment method
     *
     * @param  {ZoozArgs} args
     * @param  {String} broadcast
     *
     * @return {Promise}
     */
    addPaymentMethod: function(args, broadcast) {
      var _this = this;
      var errUrl = args.getErrUrl();
      var zoozPaymentFinishing = function (zooz) {
        _this.sendZoozPayment(zooz.srvObj(ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_AUTH)).then(
          /**
           * @param {apiBookingResponse} response
           */
          function (response) {
            if(!response.success) {
              $location.path(errUrl);
            } else if (response.paymentForm) {
              // Submit form
              $rootScope.$broadcast(broadcast, {
                url: $sce.trustAsResourceUrl(response.paymentForm.url),
                method: "post",
                data: response.paymentForm.fields,
                id: "PAEnrollForm"
              });
            } else if (response.redirectLink) {
              $location.path(response.redirectLink);
            }
          },
          function (response) {
            $location.path(errUrl);
          }
        );
      };

      var succFunc = function (response) {
        args.parseSuccess(response);
        zoozPaymentFinishing(args);
      };

      var failFunc = function (response) {
        args.parseFailed(response);
        zoozPaymentFinishing(args);
      };

      var zoozApi = new Zooz.Ext.External(args.srvObj(ZoozArgs.SRV_OBJ_ZOOZ_INIT_PARAMS));
      var status = zoozApi.addPaymentMethod(args.srvObj(ZoozArgs.SRV_OBJ_ZOOZ_PAYMENT_REQ), succFunc, failFunc);

      if (status.code > 0) {
        $location.path(errUrl);
      }
    }
  };

  ZoozServ.prototype.constructor = ZoozServ;

  /**
   * Returns raw API response
   *
   * @param {Object} response The API response
   *
   * @return {Object}
   */
  function respRaw(response) {
    return response.response;
  }

  return new ZoozServ();
}]);
;

// Source: ../shared/public_html/assets/js/book/services/fast-payment-line-item.service.js
(function (angular) {

    var FastPaymentLineItem = function ($translate, Dictionaries) {
        /**
         *
         * @param {FlightDetails} flightDetails
         * @returns {string}
         */
        this.getLineItem = function (flightDetails) {
            return $translate.instant('LANGM_JS_FAST_PAYMENT_FLIGHT_ITEM', {
                depCity: Dictionaries.getCityNameByCode(flightDetails.legs[0].dep, false),
                arrCity: Dictionaries.getCityNameByCode(flightDetails.legs[0].arr, false),
                depCode: flightDetails.legs[0].dep,
                arrCode: flightDetails.legs[0].arr
            });
        };

        /**
         *
         * @returns {string}
         */
        this.getTotalLabel = function () {
            return $translate.instant('LANGM_JS_OS_TOTAL_PRICE');
        };
    };

    FastPaymentLineItem.$inject = ['$translate', 'Dictionaries'];

    angular.module('book').service('FastPaymentLineItem', FastPaymentLineItem);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/sms-notification-box.component.js
(function(angular) {
var template = '\
        <div>\
            <article class="sms-notification" ng-if="$ctrl.booking.smsNotification.isPopulated">\
                <ith-ui-checkbox ng-model="$ctrl.booking.smsNotification.chosen"></ith-ui-checkbox>\
                <span>\
                    <span ng-click="$ctrl.toggle()" translate translate-values="{ price: ($ctrl.booking.smsNotification.price | flPrice:2) }">LANGM_JS_SMS_NOTIFICATIONS_PRODUCT_TEXT</span>\
                    <inline-tooltip content="{{ :: \'LANGM_JS_SMS_NOTIFICATIONS_PRODUCT_DETAILS\' | translate }}" placement="top">\
                        <svg-icon class="size--16 color--text margin--5" id="info" style="vertical-align: middle"></svg-icon>\
                        <span class="hidden-lg hidden-md" translate>LANGM_JS_SMS_NOTIFICATIONS_OPEN_DETAILS</span>\
                    </inline-tooltip>\
                </span>\
            </article>\
        </div>\
    ';

    var IthSmsNotificationBoxComponent = {
        template: template,
        controller: function () {
            this.toggle = function () {
                this.booking.smsNotification.chosen = !this.booking.smsNotification.chosen;
            };
        },
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('book')
        .component('ithSmsNotificationBox', IthSmsNotificationBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/book/trip-guarantee/trip-guarantee-logo.component.js
(function (angular) {
angular
        .module('book')
        .component('ithFrolaTripGuaranteeLogo', {
            template: '<ith-product-logo image-name="trip-guarantee" show-affiliate-name="false" name="{{ \'LANGM_JS_TRIP_GUARANTEE_NAME\' | translate }}"></ith-product-logo>'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/trip-guarantee/trip-guarantee.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        var templateName = 'fd-box';

        if ($attrs.zone === 'ty') {
            templateName = 'ty-box';
        }

        return '/tpl/show/jsShared/templates/flights/trip-guarantee/' + templateName;
    };

    templateUrl.$inject = ['$attrs'];

    var controller = function (TextBox) {
        var self = this;

        this.description = '';

        this.getProductPricePerPax = function () {
            return this.booking.tripGuarantee.getPrice() / this.booking.paxes.length;
        };

        this.showActionPane = function () {
            return this.zone !== 'ty';
        };

        this.$onInit = function () {
            var textBoxId = 'trip_guarantee_fd_info_' + this.booking.getFlightDetails().getFlightType().toLowerCase();

            TextBox
                .getByName(textBoxId)
                .then(function (textBoxContent) {
                    self.description = textBoxContent.text;
                });
        };
    };

    controller.$inject = ['TextBox'];

    angular
        .module('book')
        .component('ithTripGuaranteeBox', {
            templateUrl: templateUrl,
            controller: controller,
            bindings: {
                booking: '<',
                zone: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/book/trip-guarantee/trip-guarantee.model.js
(function(angular) {
var calculatePrice = function (base, ctx) {
        if (ctx.isOrdered) {
            return ctx.orderedPrice;
        }

        var total = Math.round(base * parseFloat(ctx.multiplier) * 100) / 100;
        return total < ctx.minPrice ? ctx.minPrice : total;
    };

    var TripGuaranteeModel = function () {
        var TripGuarantee = function () {
            this.isPopulated = false;
            this.enabled = false;
            this.requestId = null;
            this.multiplier = 0;
            this.chosen = false;
            this.calculatedPrice = 0;
            this.isOrdered = false;
            this.orderedPrice = 0;
            this.minPrice = 0;
        };

        TripGuarantee.prototype.isChosen = function () {
            return this.chosen;
        };

        TripGuarantee.prototype.toggle = function (newValue) {
            this.chosen = newValue;
        };

        TripGuarantee.prototype.populateFromWebSocket = function (responseObject, code, basePrice) {
            if (code >= 400) {
                this.isPopulated = true;
                return;
            }

            this.enabled = responseObject.enabled;
            this.requestId = responseObject.requestId;
            this.multiplier = responseObject.multiplier;
            this.minPrice = responseObject.minPrice;
            this.calculatedPrice = calculatePrice(basePrice, this);
            this.isPopulated = true;
        };

        TripGuarantee.prototype.getPrice = function () {
            return this.calculatedPrice;
        };

        TripGuarantee.prototype.srvSet = function (tripGuaranteeData) {
            this.chosen = tripGuaranteeData.chosen;
            this.isOrdered = true;
            this.orderedPrice = tripGuaranteeData.price;
        };

        TripGuarantee.prototype.srvObj = function () {
            return {
                chosen: this.chosen,
                requestId: this.requestId,
                price: this.calculatedPrice
            };
        };

        TripGuarantee.prototype.constructor = TripGuarantee;

        return TripGuarantee;
    };

    angular
        .module('book')
        .factory('TripGuarantee', TripGuaranteeModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/calendar/directives/desktop/animateElement.js
angular.module('calendar')
/**
 * @name        calAnimateElement
 * @description HTMLElement having attr cal-animate-element will be animated when calendar is reloading
 */
.directive('calAnimateElement', [
  function () {
return {
      require: '^calBigFlexCalendar',
      link: function (scope, element, attrs, calBigFlexCalendarCtrl) {
        calBigFlexCalendarCtrl.setAnimateElement(element);
      }
    };
  }
]);;

// Source: ../shared/public_html/assets/js/calendar/directives/desktop/bigFlexCalendar.js
angular.module('calendar')
/**
 * @name        flightBigFlexCalendar
 * @description UI FlightBigFlexCalendar directive
 */
.directive('calBigFlexCalendar',
['cal.CalendarLoading', 'cal.Calendar', 'cal.CalendarSrv', 'sch.SearchQueryParams',
/**
 * @param {CalendarLoading} CalendarLoading
 * @param {Calendar} Calendar
 * @param {CalendarSrv} CalendarSrv
 * @param {SearchQueryParams} SearchQueryParams
 */
function (CalendarLoading, Calendar, CalendarSrv, SearchQueryParams) {
return {
    scope: {
      /**
       * This function will be called after choose return date
       * "retSelected" function should returns Promise
       *
       * @type {Function}
       */
      retSelected: '=',
      /**
       * This function will be called after choose departure date
       *
       * @type {Function}
       */
      depSelected: '=?',

      /**
       * This function will be called removing return date
       *
       * @type {Function}
       */
      retReset: '=?',
      /**
       * @type {Calendar}
       */
      calendar: '=?',
      /**
       * @type {SearchQueryParams}
       */
      searchQueryParams: '=?',

      /**
       * @type {bool}
       */
      instantModal: '<?',
    },

    controller: ['$scope', function ($scope) {
      /**
       * @param {HTMLElement} element
       */
      this.setAnimateElement = function (element) {
        $scope.calendar.setAnimateElement(element);
      };
    }],

    templateUrl: '/tpl/show/jsShared/templates/calendar/directives/bigFlexCalendar',
    link: function (scope) {
      if (!scope.searchQueryParams) {
        scope.searchQueryParams = SearchQueryParams;
      }

      scope.date = new Date(scope.searchQueryParams.getDepDate());

      if (isNaN(scope.date.getTime())) {
        scope.date = new Date();
      }

      if (!scope.calendar) {
        scope.calendar = new Calendar();
      }

      scope.selections = scope.calendar.selections;

      if (!scope.depSelected) {

        scope.depSelected = function () {
        };
      }
      if (!scope.retReset) {

        scope.retReset = function () {
        };
      }
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/calendar/directives/desktop/bigFlexDatepicker.js
angular.module('calendar')
/**
 * @name        flightBigFlexDatepicker
 * @description UI FlightBigFlexDatepicker directive
 */
.directive('calBigFlexDatepicker', ['datepickerDirective', function (datepickerDirective) {
var definition = angular.copy(datepickerDirective[0]);

  definition.templateUrl = '/tpl/show/jsShared/templates/calendar/directives/bigFlexDatepicker';

  angular.extend(definition.scope, {
    retSelected: '=',
    calendar: '=',
    loading: '=',
    depSelected: '=',
    retReset: '=',
    selections: '=?',
    searchQueryParams: '=',
    instantModal: '<?',
  });

  return definition;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/directives/desktop/bigFlexDaypicker.js
angular.module('calendar')
/**
 * @name        flightBigFlexDaypicker
 * @description UI FlightBigFlexDaypicker directive
 */
  .directive('calBigFlexDaypicker', ['$stateParams', '$rootScope', '$filter', '$timeout', 'daypickerDirective', 'appConfig', 'flt.PriceGroupPaxModal', '$location', 'sch.SearchQueryParams', 'goo.Remarketing',
function ($stateParams,$rootScope, $filter, $timeout, daypickerDirective, appConfig, PriceGroupPaxModal, $location, SearchQueryParams, Remarketing) {
var definition = angular.copy(daypickerDirective[0]);

  angular.extend(definition, {
    compile: function ($element, $attrs, linker) {

      return function ($scope, $element, $attrs, ctrl) {

        $scope.device = appConfig.getDeviceType();
        /**
         * Date filter
         *
         * @type {Function}
         */
        var dateFilter = $filter('date');

        var selections = $scope.selections;

        var calendar = $scope.calendar;

        var searchQueryParams = angular.copy(SearchQueryParams);

        $scope.cellSummary = calendar.getSummary();

        if ($scope.instantModal) {
          $scope.customPriceGroupPaxModal = new PriceGroupPaxModal();
        }

        $scope.selectedReset = false;

        var updateModel = function () {
          calendar.updateModel();
        };

        definition.link($scope, $element, $attrs, ctrl);

        calendar.setScope($scope);
        calendar.setCtrl(ctrl);
        if (!calendar.searchQueryParams) {
          calendar.setSearchQueryParams(searchQueryParams);
        }
        calendar.onUpdate(updateModel);
        if (calendar.activeMonthForView) {
          calendar.ctrl.activeDate = new Date(calendar.activeMonthForView);
          calendar.ctrl.refreshView();
        }
        calendar.updateModel();

        /**
         * Checks if departure date is selected
         *
         * @return {Boolean}
         */
        $scope.isDepSelected = function () {
          return selections.getDepCell() != null;
        };

        /**
         * Checks if return date is selected
         *
         * @return {Boolean}
         */
        $scope.isRetSelected = function () {
          return selections.getRetCell() != null;
        };

        /**
         *
         * @returns {Date}
         */
        $scope.getPrevMonthDate = function () {
          var prevMonth = moment(calendar.getActiveMonthForView());

            prevMonth.subtract(1, 'months');

            return prevMonth.toDate();
        };

        /**
         *
         * @returns {Date}
         */
        $scope.getNextMonthDate = function () {
          var nextMonth = moment(calendar.getActiveMonthForView());

            nextMonth.add(1, 'months');

            return nextMonth.toDate();
        };

        /**
         *
         * @returns {Boolean}
         */
        $scope.canGoToPrevMonth = function () {
          return calendar.canGoToPrevMonth();
        };

        /**
         *
         * @returns {Boolean}
         */
        $scope.canGoToNextMonth = function () {
          return calendar.canGoToNextMonth();
        };

        /**
         * Go to prev month
         */
        $scope.goToPrevMonth = function () {
          if (!calendar.isLoading()) {
            if (typeof ga != 'undefined') {
              ga('send', {
                hitType: 'event',
                eventCategory: 'Flight_Calendar_Page',
                eventAction: 'Month_Arrow_Click',
                eventLabel: 'Left_Arrow_Click',
                nonInteraction: true
              });
            }

            Remarketing.trackCalendarClick('Month_Arrow_Click', 'Left_Arrow_Click');

            calendar.goToPrevMonth();
          }
        };

        /**
         * Go to next month
         */
        $scope.goToNextMonth = function () {
          if (!calendar.isLoading()) {

             if (typeof ga != 'undefined') {
             ga('send', {
             hitType: 'event',
             eventCategory: 'Flight_Calendar_Page',
             eventAction: 'Month_Arrow_Click',
             eventLabel: 'Right_Arrow_Click',
             nonInteraction: true
             });
             }

            Remarketing.trackCalendarClick('Month_Arrow_Click', 'Right_Arrow_Click');
            calendar.goToNextMonth();
          }
        };

        /**
         * Click cell
         *
         * @param {Object} dt
         */
        $scope.clickCell = function (dt) {

          var date = dt.date,
            isLandingPage = $rootScope.$state.current.name == "landingPages";
          $scope.selectedReset = true;

          var cell = dt.calendarCell;

          if (dt.secondary || !cell || !cell.getPrice() || calendar.isLoading()) {
            return;
          }

          if (calendar.getDepCell() && cell.getId() === calendar.getDepCell().getId()) {
            return;
          }

          if (calendar.getRetCell() && cell.getId() === calendar.getRetCell().getId()) {
            return;
          }

          $scope.select(date);


          if (calendar.getRetCell() && dateDiff(calendar.getRetCell().getDate(), date) !== 0) {

            if (dateDiff(calendar.getDepCell().getDate(), date) < 0) {
              calendar.setRetCell(cell);
              updateModel();
              $scope.retSelected();
              $scope.cellSummary.setData(cell);
            }

            if (dateDiff(calendar.getDepCell().getDate(), date) > 0) {
              calendar.setDepCell(cell);
              calendar.setRetCell(null);
              updateModel();
              searchQueryParams.setSelectedDate(dateFilter(date, 'yyyy-MM-dd'));

              calendar.reload().then(function () {
                calendar.loading.setInProgress(false);
              });
              $scope.cellSummary.clear();
              $scope.cellSummary.setData(cell);
              $scope.$emit('flight.bigFlexDaypicker.selectedDatesRemoved');
            }
          }
          else if (!calendar.getDepCell() || dateDiff(calendar.getDepCell().getDate(), date) > 0 || ( searchQueryParams .isOneWay() && !isLandingPage)) {
            calendar.setDepCell(cell);
            updateModel();
            searchQueryParams.setSelectedDate(dateFilter(date, 'yyyy-MM-dd'));

            if (typeof ga != 'undefined') {
              ga('send', {
                hitType: 'event',
                eventCategory: 'Flight_Calendar_Page',
                eventAction: 'Calendar_Click',
                eventLabel: 'Start_Date_Click',
                nonInteraction: true
              });
            }

            Remarketing.trackCalendarClick('Calendar_Click', 'Start_Date_Click');

            $scope.depSelected();

            if (calendar.isOneWay() && !isLandingPage) {
              $scope.retSelected();

              $scope.cellSummary.setData(cell);
            }
            else {
              calendar.loading.setInProgress(true);
              calendar.refreshAndUpdate().then(function () {
                calendar.loading.setInProgress(false);
              });
              $scope.cellSummary.setData(cell);
            }
          }
          else if (!calendar.getRetCell()) {

            if ($scope.instantModal && PriceGroupPaxModal.isFeatureTestEnabled()) {
              showPriceGroupPaxModal($scope.customPriceGroupPaxModal, $scope.cellSummary);
            }

            if (typeof ga != 'undefined') {
              ga('send', {
                hitType: 'event',
                eventCategory: 'Flight_Calendar_Page',
                eventAction: 'Calendar_Click',
                eventLabel: 'End_Day_Click',
                nonInteraction: true
              });

            }

            Remarketing.trackCalendarClick('Calendar_Click', 'End_Day_Click');

            calendar.setRetCell(cell);
            updateModel();
            $scope.retSelected();
            $scope.cellSummary.setData(cell);
          }
        };

        /**
         * Redirect to search request.
         */
        $scope.callFlightSearchRequest = function () {

          var cellSummary = $scope.customPriceGroupPaxModal.cellSummary;

          searchQueryParams
            .setAdults($scope.customPriceGroupPaxModal.adults)
            .setChildren($scope.customPriceGroupPaxModal.children)
            .setInfants($scope.customPriceGroupPaxModal.infants)
            .setYouths($scope.customPriceGroupPaxModal.youth)
            .setDepDate(dateFilter(cellSummary.getDepDate(), 'yyyy-MM-dd'))
            .setRetDate(dateFilter(cellSummary.getRetDate(), 'yyyy-MM-dd'))
            .setOneWay(false);

          searchQueryParams.flight_from_code = cellSummary.depCityCode;
          searchQueryParams.flight_to_code = cellSummary.retCityCode;
          searchQueryParams.flight_from = cellSummary.getDepCityName();
          searchQueryParams.flight_to = cellSummary.getRetCityName();

          $location.url(searchQueryParams.generateUrl());
        };

        /**
         * Clean selected dates and reload flight results.
         */
        $scope.paxModalClose = function () {

          $scope.resetDates();
          $scope.retReset();
        };

        /**
         * Returns true if specified date is in range(depDate, retDate)
         *
         * @param {Date} date
         * @returns {Boolean}
         */
        $scope.inRange = function (date) {
          var depCell,
            start,
            retCell,
            end;

          if (calendar.isOneWay()) {
            return false;
          }

          depCell = calendar.getDepCell();
          start = depCell ? depCell.getDate() : null;
          retCell = calendar.getRetCell();
          end = selections.hovered ? selections.hovered : (retCell ? retCell.getDate() : null);

          if (start && end) {
            return start < date && date < end;
          }
        };

        if (!appConfig.isTablet() && !appConfig.isMobile()) {
          /**
           * Mouse enter cell
           *
           * @param {Object} dt
           */
          $scope.mouseEnterCell = function (dt) {
            var cell = dt.calendarCell;

            if (dt.secondary || !cell || (calendar.getRetCell() && cell.getId() === calendar.getRetCell().getId())) {
              return false;
            }

            if (dt.secondary || !calendar.getDepCell() || !cell || !cell.getPrice()) {
            }
            else {
              selections.hovered = dt.date;
            }

            if (cell && !dt.secondary) {
              dt.showReset = true;
              $scope.selectedReset = false;

              $scope.cellSummary.setDep(cell);
              $scope.cellSummary.setRet(cell);
              $scope.cellSummary.setPrice(cell.getPrice());
            }
            else {
              $scope.cellSummary.clear();
            }

          };

          /**
           * Mouse leave cell
           */
          $scope.mouseLeaveCell = function (dt) {
            dt.showReset = false;
            $scope.selectedReset = true;

            selections.hovered = null;
            $scope.cellSummary.clear();
            if (selections.retCell) {
             $scope.cellSummary.setData(selections.retCell);
            }
            else if (selections.depCell) {
             $scope.cellSummary.setData(selections.depCell);
            }
          };
        }

        /**
         * Reset dates
         */
        $scope.resetDates = function () {
          calendar.loading.setInProgress(true);
          calendar.setRetCell(null);
          calendar.setDepCell(null);
          calendar.reload().then(function () {
            calendar.loading.setInProgress(false);
          });
          $scope.$emit('flight.bigFlexDaypicker.selectedDatesRemoved');
        };

        /**
         * Reset return date
         */
        $scope.resetRetDate = function ($event) {
          $event.stopPropagation();
          calendar.setRetCell(null);
          $scope.retReset();
          $scope.$emit('flight.bigFlexDaypicker.selectedDatesRemoved');
        };

        /**
         * Check if specified date is departure date
         *
         * @param {Object} dt
         *
         * @returns {Boolean}
         */
        $scope.isDepDate = function (dt) {
          if (calendar.getDepCell()) {
            return dateFilter(dt.date, 'yyyy-MM-dd') === calendar.getDepCell().getId();
          }
        };

        /**
         * Check if specified date is return date
         *
         * @param {Object} dt
         *
         * @returns {Boolean}
         */
        $scope.isRetDate = function (dt) {
          if (calendar.getRetCell()) {
            return dateFilter(dt.date, 'yyyy-MM-dd') === calendar.getRetCell().getId();
          }
        };
      };
    },
    templateUrl: '/tpl/show/jsShared/templates/calendar/directives/bigFlexDaypicker'
  });

  /**
   * Showing the price group pax modal
   * for$scope.cellSummary from selected dates.
   *
   * @param {PriceGroupPaxModal} priceGroupPaxModal
   * @param {CalendarCellSummary} calendarCellSummary
   */
  function showPriceGroupPaxModal(priceGroupPaxModal, calendarCellSummary) {
    priceGroupPaxModal.cellSummary = calendarCellSummary;
    priceGroupPaxModal.openEmptyPriceGroupPax();
  }

  /**
   * Returns difference between date1 and date2 as the number of milliseconds
   *
   * @param {Date} date1
   * @param {Date} date2
   * @returns {Number}
   */
  function dateDiff(date1, date2) {
    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())).getTime() - (new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())).getTime();
  }

  return definition;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/models/Calendar.js
/*global _: false */

angular.module('calendar')

/**
 * @name        Calendar
 * @namespace   cal
 * @description Factory returning Calendar constructor
 */
.factory('cal.Calendar',
['cal.CalendarCell', 'cal.CalendarCellSummary', 'cal.CalendarSrv', 'cal.CalendarLoading', '$filter', '$q', '$animate',
/**
 * Calendar class
 *
 * @param {CalendarCell} CalendarCell
 * @param {CalendarCellSummary} CellSummary
 * @param {CalendarSrv} CalendarSrv
 * @param {CalendarLoading} CalendarLoading
 * @param {Function} $filter
 * @param {Function} $q
 * @param {Object} $animate
 *
 * @return {Calendar}
 */
function CalendarFactory(CalendarCell, CellSummary, CalendarSrv, CalendarLoading, $filter, $q, $animate) {
/**
   * Calendar constructor
   *
   * @class Calendar
   * @constructor
   * @param {Object} params
   * @param {CalendarLoading} loading
   */
  var Calendar = function (params) {
    // Defaults
    params = _.extend({
      loading: new CalendarLoading()
    }, params);

    /**
     * Cells
     *
     * @type {CalendarCell[]}
     */
    this.cells = [];

    /**
     * Cells having min price
     *
     * @type {CalendarCell[]}
     */
    this.best = [];

    /**
     * Selected range
     *
     * @type {{depCell: CalendarCell|null, retCell: CalendarCell|null}}
     */
    this.selections = {
      /**
       * Selected departure cell
       *
       * @type {CalendarCell|null}
       */
      depCell: null,
      /**
       * Selected return cell
       *
       * @type {CalendarCell|null}
       */
      retCell: null
    };

    /**
     * Cell summary
     *
     * @type {CalendarCellSummary}
     */
    this.summary = new CellSummary();

    /**
     * @type {CalendarLoading}
     */
    this.loading = params.loading;

    /**
     * angular.ui.bootstrap scope for this calendar
     *
     * @type {Object|null}
     */
    this.scope = null;

    /**
     * angular.ui.bootstrap controller for this calendar
     *
     * @type {Object|null}
     */
    this.ctrl = null;

    /**
     * ctrlLoad.promise will be resolved, when ctrl loaded
     */
    this.ctrlLoad = $q.defer();

    /**
     * @type {SearchQueryParams|null}
     */
    this.searchQueryParams = null;

    /**
     * @type {onMonthChangeFn|null}
     */
    this.onMonthChangeFn = null;

    this.canceller = $q.defer();

    /**
     * Params to send to API when we fetch cells
     *
     * @type {Object}
     */
    this.calendarSrvParams = {};

    /**
     * It specifies last available month in calendar (for UI)
     *
     * @type {Date}
     */
    this.maxDate = this.calcMaxDate();

    /**
     * It specifies first available month in calendar (for UI)
     *
     * @type {Date}
     */
    this.minDate = new Date(today);

    /**
     * @type {Date|null}
     */
    this.activeMonthForView = null;

    /**
     * Element to animate
     *
     * @type {HTMLElement|null}
     */
    this.animateElement = null;

    /**
     * @type {Boolean}
     */
    this.oneWay = false;
  };

  /**
   * AngularJS filter
   *
   * @type {Function}
   */
  var findOne = $filter('findOne');

  /**
   * AngularJS date filter
   *
   * @type {Function}
   */
  var dateFilter = $filter('date');

  /**
   * AngularJS filter
   *
   * @type {Function}
   */
  var filter = $filter('filter');

  /**
   * @type {Date}
   */
  var today = new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());

  // Add instance methods
  Calendar.prototype = /** @lends Calendar.prototype */ {

    /**
     * Price filter.
     *
     * @type {Function}
     */
    filterPrice: $filter('flPrice'),

    /**
     * Add cell
     *
     * @param {apiCalendarCell} apiCalendarCell
     * @param {String} id - date in format "YYYY-MM-DD"
     */
    add: function (apiCalendarCell, id) {
      var cell = this.getCellById(id);

      if (cell) {
        cell.update(apiCalendarCell);
      }
      else {
        this.cells.push(new CalendarCell(apiCalendarCell, id));
      }
    },

    /**
     * Returns cell by date
     *
     * @param {Date} date
     *
     * @returns {CalendarCell|undefined}
     */
    getCell: function (date) {
      return this.getCellById(dateFilter(date, 'yyyy-MM-dd'));
    },

    /**
     * Returns cell by id
     *
     * @param {String} id - date in format "YYYY-MM-DD"
     * @returns {CalendarCell|undefined}
     */
    getCellById: function (id) {
      return findOne(this.cells, function (cell) {
        return cell.getId() === id;
      });
    },

    /**
     * Returns cell by departure date
     *
     * @param {Date} dd Departure date
     *
     * @returns {CalendarCell|undefined}
     */
    getCellByDepDate: function (dd) {
      return findOne(this.cells, {dd: dateFilter(dd, 'yyyy-MM-dd')});
    },

    /**
     * Returns cell by return date
     *
     * @param {Date} rd Return date
     *
     * @returns {CalendarCell|undefined}
     */
    getCellByRetDate: function (rd) {
      return findOne(this.cells, {rd: dateFilter(rd, 'yyyy-MM-dd')});
    },

    /**
     * Returns true if there is any cell having price(for specified range(minDate, maxDate))
     *
     * @param {Date} [minDate]
     * @param {Date} [maxDate]
     * @returns {Boolean}
     */
    hasCellHavingPrice: function (minDate, maxDate) {
      return filter(this.getCellsInRange(minDate, maxDate), function (cell) {
          return !!cell.getPrice();
        }).length > 0;
    },

    /**
     * Returns best cell - having min price(for specified range(minDate, maxDate))
     *
     * @param {Date} [minDate]
     * @param {Date} [maxDate]
     * @returns {CalendarCell|undefined}
     */
    getBest: function (minDate, maxDate) {
      if (this.hasCellHavingPrice()) {
        return _.min(this.getCellsInRange(minDate, maxDate), function (cell) {
          return cell.getPrice();
        });
      }
    },

    /**
     * Returns cells in specified range(minDate, maxDate)
     *
     * @param {Date} [minDate]
     * @param {Date} [maxDate]
     * @returns {CalendarCell[]}
     */
    getCellsInRange: function (minDate, maxDate) {
      // Defaults
      minDate = minDate ? new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate()) : -Infinity;
      maxDate = maxDate ? new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate(), 23, 59, 59, 999) : Infinity;

      return filter(this.cells, function (cell) {
        var date = new Date(cell.getId());

        return minDate <= date && date <= maxDate;
      });
    },

    /**
     * @param {Date} date
     * @returns {CalendarCell[]}
     */
    getCellsForMonth: function (date) {
      var
        min = date,
        max = angular.copy(date);

      min.setDate(1);
      max.setDate(daysInMonth(date));

      return this.getCellsInRange(min, max);
    },

    /**
     * @returns {CalendarCell[]}
     */
    getCellsForActiveMonth: function () {
      return this.getCellsForMonth(this.getActiveDate());
    },

    /**
     * @returns {Date}
     */
    getActiveDate: function () {
      return angular.isObject(this.ctrl)? this.ctrl.activeDate : null;
    },

    /**
     * Returns minimum price(for specified range(minDate, maxDate))
     *
     * @param {Date} [minDate]
     * @param {Date} [maxDate]
     * @returns {Number|undefined}
     */
    getMinPrice: function (minDate, maxDate) {
      if (this.hasCellHavingPrice(minDate, maxDate)) {
        return this.getBest(minDate, maxDate).getPrice();
      }
    },

    /**
     * Set departure cell
     *
     * @param {CalendarCell|null} cell
     */
    setDepCell: function (cell) {
      if(typeof dataLayer != 'undefined' && cell !== null) {
        dataLayer.push(
            {
              'event': 'LP CalendarCell ClickFirst'
            }
        );

      }
      this.selections.depCell = cell;
    },

    /**
     * Returns departure cell
     *
     * @returns {CalendarCell|null}
     */
    getDepCell: function () {
      return this.selections.depCell;
    },

    /**
     * Set return cell
     *
     * @param {CalendarCell|null} cell
     */
    setRetCell: function (cell) {
      if(typeof dataLayer != 'undefined' && cell !== null) {
        dataLayer.push(
            {
              'event': 'LP CalendarCell ClickSecond'
            }
        );

      }
      this.selections.retCell = cell;
    },

    /**
     * Returns return cell
     *
     * @returns {CalendarCell|null}
     */
    getRetCell: function () {
      return this.selections.retCell;
    },

    /**
     * Returns cell summary object
     *
     * @returns {CellSummary}
     */
    getSummary: function () {
      return this.summary;
    },

    /**
     * True if loading in progress
     *
     * @returns {Boolean}
     */
    isLoading: function () {
      return this.loading.inProgress();
    },

    /**
     * Returns true if calendar is empty
     *
     * @returns {Boolean}
     */
    isEmpty: function () {
      return this.cells.length === 0;
    },

    /**
     * @returns {Boolean}
     */
    activeMonthIsEmpty: function () {
      return this.getCellsForActiveMonth().length === 0;
    },

    /**
     * @returns {Boolean}
     */
    canGoToPrevMonth: function () {
      var
        current = angular.copy(this.getActiveMonthForView()),
        min = angular.copy(this.minDate);

      current.setDate(1);
      current.setHours(0);
      min.setDate(1);
      min.setHours(0);

      return current > min;
    },

    /**
     * @returns {Boolean}
     */
    canGoToNextMonth: function () {
      var
        current = angular.copy(this.getActiveMonthForView()),
        max = angular.copy(this.maxDate);

      current.setDate(1);
      current.setHours(0);
      max.setDate(1);
      max.setHours(0);

      return current < max;
    },

    /**
     * Find cells having min price
     */
    calcBestCells: function () {
      var
        minPrice,
        maxDate = new Date(this.getActiveDate());

      maxDate.setMonth(maxDate.getMonth() + 1, 0);
      minPrice = this.getMinPrice(this.getDepDate(), maxDate);

      angular.forEach(this.getDepDate() ? this.getCellsInRange(this.getDepDate(), maxDate) : this.cells, function (cell) {
        cell.markAsBestPrice(cell.getPrice() === minPrice);
      });
    },

    /**
     * Calculate values to show on view
     */
    calcViewValues: function () {
      var self = this;

      angular.forEach(this.cells, function (cell) {
        var value;

        if (self.hasSelectedDepDate() && !self.isOneWay() && dateDiff(cell.getDate(), self.getDepDate()) > 0) {
          value = cell.getPrice() - self.selections.depCell.getPrice();
          value = (value < 0 ? '' : '+') + self.filterPrice(value);
        }
        else {
          value = self.filterPrice(cell.getPrice());
        }
        cell.setViewValue(value);
      });
    },

    /**
     * @returns {Boolean}
     */
    isOneWay: function () {
      return this.oneWay;
    },

    /**
     * @param {Boolean} oneWay
     */
    setOneWay: function(oneWay) {
      this.oneWay = oneWay;
    },

    /**
     * @param {Number} month
     * @param {Number} [year=undefined]
     * @param {Object} [params={}]
     * @param {Boolean} [params.animation]
     *
     * @returns {Promise}
     */
    goToMonth: function (month, year, params) {
      // Defaults
      params = _.extend({
        animation: false
      }, params);

      var self = this;

      return this.setActiveMonth(month, year).then(function () {
        self.loading.setInProgress(true);

        return self.refreshAndUpdate(params);
      });
    },

    /**
     * @returns {Promise}
     */
    goToNextMonth: function () {
      var date = moment(this.getActiveDate()).add(1, 'months').toDate();

      if (angular.isFunction(this.onMonthChangeFn)) {
        this.onMonthChangeFn(date.getMonth() + 1)
      }

      return this.goToMonth(date.getMonth() + 1, date.getFullYear(), {
        animation: false
      });
    },

    /**
     * @returns {Promise}
     */
    goToPrevMonth: function () {
      var date = angular.copy(this.getActiveDate());

      if (angular.isFunction(this.onMonthChangeFn)) {
        this.onMonthChangeFn(date.getMonth())
      }

      return this.goToMonth(date.getMonth(), date.getFullYear(), {
        animation: false
      });
    },

    goToNextNoEmptyMonth: function () {
      var self = this;

      if (this.canGoToNextMonth()) {
        this.goToNextMonth().then(function () {
          if (self.activeMonthIsEmpty()) {
            self.goToNextNoEmptyMonth();
          }
        });
      }
    },

    goToPrevNoEmptyMonth: function () {
      var self = this;

      if (this.canGoToPrevMonth()) {
        this.goToPrevMonth().then(function () {
          if (self.activeMonthIsEmpty()) {
            self.goToPrevNoEmptyMonth();
          }
        });
      }
    },

    /**
     * @param {Number} month
     * @param {Number} [year=undefined]
     *
     * @returns {Promise}
     */
    setActiveMonth: function (month, year) {
      var self = this;

      return this.waitForCtrl().then(function () {
        self.ctrl.activeDate.setFullYear(year ? year : self.ctrl.activeDate.getFullYear(), month - 1, 1);
        self.ctrl.refreshView();
      });
    },

    updateActiveMonthForView: function () {
      this.activeMonthForView = angular.copy(this.getActiveDate());
    },

    /**
     * @returns {Date}
     */
    getActiveMonthForView: function () {
      return this.activeMonthForView || this.getActiveDate();
    },

    /**
     * @param {String} cityCode
     * @returns {Calendar}
     */
    setDepCity: function (cityCode) {
      this.searchQueryParams.flight_from_code = cityCode;

      return this;
    },

    /**
     * @param {String} countryCode
     * @returns {Calendar}
     */
    setDepCountry: function (countryCode) {
      this.searchQueryParams.flight_from_country_code = countryCode;

      return this;
    },

    /**
     * @param {String} countryCode
     * @returns {Calendar}
     */
    setDesCountry: function (countryCode) {
      this.searchQueryParams.flight_to_country_code = countryCode;

      return this;
    },

    /**
     * @param {String} airportCode
     * @returns {Calendar}
     */
    setDepAirport: function (airportCode) {
      this.searchQueryParams.flight_from_airport_code = airportCode;

      return this;
    },

    /**
     * @param {String} airportCode
     * @returns {Calendar}
     */
    setDesAirport: function (airportCode) {
      this.searchQueryParams.flight_to_airport_code = airportCode;
      return this;
    },

    /**
     * @param {Object} params
     * @param {String} [params.cityCode]
     * @param {String} [params.airportCode]
     * @param {String} [params.countryCode]
     */
    setDesLocation: function(params) {
      this.setDesCountry(params.countryCode);
      this.setDesAirport(params.airportCode);
      this.setArrCity(params.cityCode);
      return this;
    },

    /**
     * @param {Object} params
     * @param {String} [params.cityCode]
     * @param {String} [params.airportCode]
     * @param {String} [params.countryCode]
     */
    setDepLocation: function(params) {
      this.setDepCountry(params.countryCode);
      this.setDepAirport(params.airportCode);
      this.setDepCity(params.cityCode);
      return this;
    },

    /**
     * @param {String} cityCode
     * @returns {Calendar}
     */
    setArrCity: function (cityCode) {
      this.searchQueryParams.flight_to_code = cityCode;

      return this;
    },

    /**
     * @param {Object} params
     */
    setCalendarSrvParams: function (params) {
      this.calendarSrvParams = params;
    },

    /**
     * @param {Object} [params={}]
     * @param {Boolean} [params.animation]
     *
     * @returns {Promise}
     */
    reload: function (params) {
      // Defaults
      params = _.extend({
        animation: false
      }, params);

      var
        self = this,
        selectedDepDate = this.getDepDate(),
        selectedRetDate = this.getRetDate();

      this.setDepCell(null);
      this.setRetCell(null);

      return this.refreshAndUpdate(params).then(function () {
        var depCell = self.getCell(selectedDepDate);

        if (depCell) {
          self.setDepCell(depCell);

          if (self.isOneWay()) {
            return self.scope.retSelected();
          }

          return self.refreshAndUpdate(params).then(function () {
            var retCell = self.getCell(selectedRetDate);

            self.loading.setInProgress(false);

            if (retCell) {
              self.setRetCell(retCell);

              return self.scope.retSelected();
            }
          });
        }
      });
    },

    /**
     * Refresh data for active month
     *
     * @returns {Promise}
     */
    refresh: function () {
      var
        self = this,
        request;

      this.cancelRequest();
      this.loading.setInProgress(true);

      var calParams = _.extend({
        month: dateFilter(this.getActiveDate(), 'MM'),
        year: dateFilter(this.getActiveDate(), 'yyyy'),
        searchQueryParams: this.searchQueryParams,
        calendar: this,
        timeout: this.canceller.promise
      }, this.calendarSrvParams);

      request = CalendarSrv.getCalendar(calParams);

      request.then(function () {
        self.loading.setInProgress(false);
      });

      return request;
    },

    /**
     * Cancel current request (if in progress)
     */
    cancelRequest: function() {
      this.canceller.resolve();
      this.canceller = $q.defer();
      this.loading.setInProgress(false);
    },

    /**
     * @param {Object} [params={}]
     * @param {Boolean} [params.animation]
     * @returns {Promise}
     */
    refreshAndUpdate: function (params) {
      // Defaults
      params = _.extend({
        animation: false
      }, params);

      var self = this;

      return this.refresh().then(function (cells) {
        return self.update(cells, params);
      });
    },

    /**
     * @param {apiCalendarCell[]} cells
     * @returns {Promise}
     */
    updateWithAnimation: function (cells) {
      var
        self = this,
        outCssClass,
        inCssClass;

      if (!this.animateElement) {
        return this.update(cells);
      }

      if (this.getActiveDate() > this.getActiveMonthForView()) {
        outCssClass = 'slideToLeft';
        inCssClass = 'slideFromRight';
      }
      else {
        outCssClass = 'slideToRight';
        inCssClass = 'slideFromLeft';
      }

      return $animate.addClass(this.animateElement, outCssClass).then(function () {
        var promise = $animate.addClass(self.animateElement, inCssClass);

        $animate.removeClass(self.animateElement, outCssClass);
        self.update(cells);

        return promise;
      }).then(function () {
        $animate.removeClass(self.animateElement, inCssClass);
      });
    },

    /**
     * @param {apiCalendarCell[]} cells
     * @param {Object} [params={}]
     * @param {Boolean} [params.animation]
     * @returns {Promise}
     */
    update: function (cells, params) {
      // Defaults
      params = _.extend({
        animation: false
      }, params);

      var self = this;

      if (params.animation) {
        return this.updateWithAnimation(cells);
      }
      if (this.getDepDate() && !this.isOneWay()) {
        // Clear cells after depDate
        this.clearLaterThanSelDepDate();
      }
      else {
        // Clear all cells
        this.clear();
      }

      angular.forEach(cells, function (cell, id) {
        if (new Date(id) >= today) {
          self.add(cell, id);
        }
      });
      this.calcBestCells();
      this.calcViewValues();
      this.updateCallback();
      this.updateActiveMonthForView();

      return $q.when();
    },

    /**
     * @param {HTMLElement} element
     */
    setAnimateElement: function (element) {
      this.animateElement = element;
    },

    /**
     * Set selected dates
     *
     * @param {{ depDate: Date|null, retDate: Date|null }} selections
     */
    setSelections: function (selections) {
      this.selections = selections;
    },

    /**
     * @param {Object} scope
     */
    setScope: function (scope) {
      this.scope = scope;
    },

    /**
     * @param {Object} ctrl
     */
    setCtrl: function (ctrl) {
      this.ctrl = ctrl;
      this.ctrlLoad.resolve();
    },

    /**
     * It's resolved if ctrl is loaded
     *
     * @returns {Promise}
     */
    waitForCtrl: function () {
      return this.ctrlLoad.promise;
    },

    /**
     * @param {SearchQueryParams} searchQueryParams
     */
    setSearchQueryParams: function (searchQueryParams) {
      this.searchQueryParams = searchQueryParams;
    },

    /**
     * @param {function} ChangeFn
     */
    setOnMonthChangeFn: function (ChangeFn) {
      this.onMonthChangeFn = ChangeFn;
    },

    /**
     * @returns {Date}
     */
    calcMaxDate: function () {
      var maxDate = new Date(today);

      maxDate.setMonth(maxDate.getMonth() + 14, 0);

      return maxDate;
    },

    /**
     * @param {Date} date
     */
    setMaxDate: function (date) {
      this.maxDate = date;
    },

    /**
     * @returns {Date|null}
     */
    getMaxDate: function () {
      return this.maxDate;
    },

    /**
     * @param {Date} date
     */
    setMinDate: function (date) {
      this.minDate = date;
    },

    /**
     * Returns true if calendar has selected departure date
     *
     * @returns {Boolean}
     */
    hasSelectedDepDate: function () {
      return !!this.selections.depCell;
    },

    /**
     * Returns true if calendar has selected return date
     *
     * @returns {Boolean}
     */
    hasSelectedRetDate: function () {
      return !!this.selections.retCell;
    },

    updateCallback: function () {
    },

    onUpdate: function (fn) {
      var old = angular.copy(this.updateCallback);

      this.updateCallback = function () {
        old.apply(null, arguments);
        fn.apply(null, arguments);
      };
    },

    updateModel: function () {
      var self = this;

      if (this.scope) {
        angular.forEach(this.scope.rows, function (row)
        {
          angular.forEach(row, function (cell)
          {
            cell.calendarCell = self.getCell(cell.date);
          });
        });
      }
    },

    /**
     * Clear calendar
     *
     * @param {Function|undefined} [fn=undefined] specifies which cells should be removed
     *
     * @returns {Calendar}
     */
    clear: function (fn) {
      if (!fn) {
        this.setDepCell(null);
        this.setRetCell(null);
        this.getSummary().clear();
      }

      this.cells = fn ? filter(this.cells, function (cell) {
        return !fn(cell);
      }) : [];

      this.updateModel();

      return this;
    },

    /**
     * Returns selected departure date
     *
     * @returns {Date|null}
     */
    getDepDate: function () {
      if (this.getDepCell()) {
        return this.getDepCell().getDate();
      }
    },

    /**
     * Returns selected return date
     *
     * @returns {Date|null}
     */
    getRetDate: function () {
      if (this.getRetCell()) {
        return this.getRetCell().getDate();
      }
    },

    /**
     * Clear cells later than departure date
     */
    clearLaterThanSelDepDate: function () {
      var self = this;

      this.clear(function (cell) {
        return new Date(cell.getId()) > self.getDepDate();
      });
    }

  };

  Calendar.prototype.constructor = Calendar;

  /**
   * Returns difference between date1 and date2 as the number of milliseconds
   *
   * @param {Date} date1
   * @param {Date} date2
   * @returns {Number}
   */
  function dateDiff(date1, date2) {
    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())).getTime() - (new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())).getTime();
  }

  /**
   * @param {Date} date
   * @returns {Number}
   */
  function daysInMonth(date) {
    return (new Date(date.getFullYear(), date.getMonth() + 1, 0)).getDate();
  }

  return Calendar;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/models/CalendarCell.js
angular.module('calendar')

/**
 * @name        CalendarCell
 * @namespace   cal
 * @description Factory returning CalendarCell constructor
 */
.factory('cal.CalendarCell',
['Dictionaries',

/**
 * CalendarCell class
 *
 * @param {Dictionaries} Dictionaries
 *
 * @return {CalendarCell}
 */
function CalendarCellFactory(Dictionaries) {
/**
   * CalendarCell constructor
   *
   * @class CalendarCell
   * @constructor
   *
   * @param {apiCalendarCell} calendarCell The JSON object representing calendarCell
   * @param {String} id - date in format "YYYY-MM-DD"
   */
  var CalendarCell = function (calendarCell, id) {
    /**
     * Id - date in format "YYYY-MM-DD"
     *
     * @type {String}
     */
    this.id = id;

    /**
     * Departure date as "yyyy-MM-dd"
     *
     * @type {String}
     */
    this.dd = calendarCell.date_dep;

    /**
     * Return date as "yyyy-MM-dd"
     *
     * @type {String}
     */
    this.rd = calendarCell.date_ret;

    /**
     * @type {String}
     */
    this.depCityCode = calendarCell.city_from;

    /**
     * @type {String}
     */
    this.arrCityCode = calendarCell.city_to;

    /**
     * @type {String}
     */
    this.depCityName = Dictionaries.getCityNameByCode(calendarCell.city_from, false);

    /**
     * @type {String}
     */
    this.arrCityName = Dictionaries.getCityNameByCode(calendarCell.city_to, false);

    /**
     * Price
     *
     * @type {Number}
     */
    this.price = +(+calendarCell.min_price).toFixed(2);

    /**
     * Url
     *
     * @type {String}
     */
    this.url = calendarCell.url;

    /**
     * Value to show on view
     *
     * @type {String}
     */
    this.viewValue = '';

    /**
     * True if cell is marked as best
     *
     * @type {Boolean}
     */
    this.bestPrice = false;

    if (calendarCell.outBoundDetails) {
      /**
       * Departure carrier code
       *
       * @type {string[]}
       */
      this.depCarrierCodes = calendarCell.outBoundDetails.airline;

      /**
       * Returns number of stopovers for departure route
       *
       * @type {Number}
       */
      this.depStops = calendarCell.outBoundDetails.stops;
    }

    if (calendarCell.inBoundDetails) {
      /**
       * Return carrier code
       *
       * @type {string[]}
       */
      this.retCarrierCodes = calendarCell.inBoundDetails.airline;

      /**
       * Returns number of stopovers for return route
       *
       * @type {Number}
       */
      this.retStops = calendarCell.inBoundDetails.stops;
    }
  };

  // Add instance methods
  CalendarCell.prototype = /** @lends CalendarCell.prototype */ {

    /**
     * Returns id in format "YYYY-MM-DD"
     *
     * @returns {String}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Returns date
     *
     * @returns {Date}
     */
    getDate: function () {
      return new Date(this.id);
    },

    /**
     * Returns price
     *
     * @returns {Number}
     */
    getPrice: function () {
      return this.price;
    },

    /**
     * Returns departure date
     *
     * @returns {String}
     */
    getDepDate: function () {
      return this.dd;
    },

    /**
     * Returns departure date
     *
     * @returns {String}
     */
    getRetDate: function () {
      return this.rd;
    },

    /**
     * @returns {String}
     */
    getDepCityName: function () {
      return this.depCityName;
    },

    /**
     * @returns {String}
     */
    getArrCityName: function () {
      return this.arrCityName;
    },

    /**
     * Returns url
     *
     * @returns {String}
     */
    getUrl: function () {
      return this.url;
    },

    /**
     * Returns departure carrier code
     *
     * @returns {string[]}
     */
    getDepCarrierCodes: function () {
      return this.depCarrierCodes;
    },

    /**
     * Returns number of stopovers for departure route
     *
     * @returns {Number}
     */
    getDepStops: function () {
      return this.depStops;
    },

    /**
     * Returns return carrier code
     *
     * @returns {string[]}
     */
    getRetCarrierCodes: function () {
      return this.retCarrierCodes;
    },

    /**
     * Returns number of stopovers for return route
     *
     * @returns {Number}
     */
    getRetStops: function () {
      return this.retStops;
    },

    /**
     * Returns value to show on view
     *
     * @returns {String}
     */
    getViewValue: function () {
      return this.viewValue;
    },

    /**
     * Set value to show on view
     *
     * @param {String} value
     */
    setViewValue: function (value) {
      this.viewValue = value;
    },

    /**
     * Mark cell as best
     *
     * @param {Boolean} [best=false]
     */
    markAsBestPrice: function (best) {
      this.bestPrice = best !== false;
    },

    /**
     * Returns true if cell is marked as best
     *
     * @returns {Boolean}
     */
    hasBestPrice: function () {
      return this.bestPrice;
    },

    /**
     * Update cell
     *
     * @param {apiCalendarCell} calendarCell The JSON object representing calendarCell
     */
    update: function (calendarCell) {
      this.dd = calendarCell.date_dep;
      this.rd = calendarCell.date_ret;
      this.price = +(+calendarCell.min_price).toFixed(2);
      this.url = calendarCell.url;

      if (calendarCell.outBoundDetails) {
        this.depCarrierCodes = calendarCell.outBoundDetails.airline;
        this.depStops = calendarCell.outBoundDetails.stops;
      }
      else {
        this.depCarrierCodes = undefined;
        this.depStops = undefined;
      }
      if (calendarCell.inBoundDetails) {
        this.retCarrierCodes = calendarCell.inBoundDetails.airline;
        this.retStops = calendarCell.inBoundDetails.stops;
      }
      else {
        this.retCarrierCodes = undefined;
        this.retStops = undefined;
      }
    }

  };

  CalendarCell.prototype.constructor = CalendarCell;

  return CalendarCell;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/models/CalendarCellSummary.js
angular.module('calendar')

/**
 * @name        CalendarCellSummary
 * @namespace   cal
 * @description Factory returning CalendarCellSummary constructor
 */
.factory('cal.CalendarCellSummary',
['$filter',

/**
 * CalendarCellSummary class
 *
 * @param {Function} $filter
 * @return {CalendarCellSummary}
 */
function CalendarCellSummaryFactory($filter) {
/**
   * Price filter.
   *
   * @type {Function}
   */
  var filterPrice = $filter('flPrice');

  /**
   * Date format filter.
   *
   * @type {Function}
   */
  var filterDate = $filter('date');

  /**
   * Formatted departure date.
   *
   * @param {String} format
   *
   * @returns {String}
   */
  function formatDate(date, format) {
    var format = format || 'd MMM yyyy';

    return filterDate(date, format);
  }

  /**
   * CalendarCellSummary constructor
   *
   * @class CalendarCellSummary
   * @constructor
   */
  var CalendarCellSummary = function () {
    /**
     * Departure date
     *
     * @type {Date|null}
     */
    this.depDate = null;

    /**
     * Departure carrier code
     *
     * @type {String|null}
     */
    this.depCarrierCode = null;

    /**
     * @type {String}
     */
    this.depCityCode = '';

    /**
     * @type {String}
     */
    this.depCityName = '';

    /**
     * Departure stops
     *
     * @type {Number|null}
     */
    this.depStops = null;

    /**
     * Return date
     *
     * @type {Date|null}
     */
    this.retDate = null;

    /**
     * Return carrier code
     *
     * @type {String|null}
     */
    this.retCarrierCode = null;

    /**
     * @type {String}
     */
    this.retCityCode = '';

    /**
     * @type {String}
     */
    this.retCityName = '';

    /**
     * Return stops
     *
     * @type {Number|null}
     */
    this.retStops = null;

    /**
     * Price per person
     *
     * @type {Number|null}
     */
    this.price = null;
  };

  // Add instance methods
  CalendarCellSummary.prototype = /** @lends CalendarCellSummary.prototype */ {
    /**
     * Departure date
     *
     * @returns {Date|null}
     */
    getDepDate: function () {
      return this.depDate;
    },

    /**
     * Formatted departure date.
     *
     * @param {String} format
     *
     * @returns {String}
     */
    getDepDateFormat: function (format) {
      return formatDate(this.depDate, format);
    },

    /**
     * Departure carrier code
     *
     * @returns {String|null}
     */
    getDepCarrierCode: function () {
      return this.depCarrierCode;
    },

    /**
     * @returns {String}
     */
    getDepCityName: function () {
      return this.depCityName;
    },

    /**
     * Departure stops
     *
     * @returns {Number|null}
     */
    getDepStops: function () {
      return this.depStops;
    },

    /**
     * Return date
     *
     * @returns {Date|null}
     */
    getRetDate: function () {
      return this.retDate;
    },

    /**
     * Formatted return date.
     *
     * @param {String} format
     *
     * @returns {String}
     */
    getRetDateFormat: function (format) {
      return formatDate(this.retDate, format);
    },

    /**
     * Return carrier code
     *
     * @returns {String|null}
     */
    getRetCarrierCode: function () {
      return this.retCarrierCode;
    },

    /**
     * @returns {String}
     */
    getRetCityName: function () {
      return this.retCityName;
    },

    /**
     * Return stops
     *
     * @returns {Number|null}
     */
    getRetStops: function () {
      return this.retStops;
    },

    /**
     * Returns price per person
     *
     * @returns {Number|null}
     */
    getPrice: function () {
      return this.price;
    },

    /**
     * Get price per person as string.
     *
     * @returns {String}
     */
    getPriceAsString: function() {
      return filterPrice(this.getPrice());
    },

    /**
     * Set departure data
     *
     * @param {CalendarCell} cell
     */
    setDep: function (cell) {
      this.depDate = new Date(cell.getDepDate());
      this.depCarrierCode = cell.getDepCarrierCodes()[0];
      this.depStops = cell.getDepStops();
      this.setDepCityName(cell.getDepCityName());
      this.depCityCode = cell.depCityCode;
    },

    /**
     * @param {String} cityName
     */
    setDepCityName: function (cityName) {
      this.depCityName = cityName;
    },

    /**
     * Set return data
     *
     * @param {CalendarCell} cell
     */
    setRet: function (cell) {
      this.retDate = new Date(cell.getRetDate());
      this.retCarrierCode = cell.getRetCarrierCodes() ? cell.getRetCarrierCodes()[0] : null;
      this.retStops = cell.getRetStops();
      this.setRetCityName(cell.getArrCityName());
      this.retCityCode = cell.arrCityCode;
    },

    /**
     * @param {String} cityName
     */
    setRetCityName: function (cityName) {
      this.retCityName = cityName;
    },

    /**
     * Set price
     *
     * @param {Number|null} price
     */
    setPrice: function (price) {
      this.price = price;
    },

    /**
     * Set data
     *
     * @param {CalendarCell} cell
     */
    setData: function (cell) {
      this.setDep(cell);
      this.setRet(cell);
      this.setPrice(cell.getPrice());
    },

    /**
     * Clear summary
     */
    clear: function () {
      this.depDate = null;
      this.depCarrierCode = null;
      this.depStops = null;
      this.retDate = null;
      this.retCarrierCode = null;
      this.retStops = null;
      this.price = null;
    }
  };

  CalendarCellSummary.prototype.constructor = CalendarCellSummary;

  return CalendarCellSummary;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/models/CalendarLoading.js
angular.module('calendar')

/**
 * @name        CalendarLoading
 * @namespace   cal
 * @description Factory returning CalendarLoading constructor
 */
.factory('cal.CalendarLoading',
['$filter',
/**
 * CalendarLoading class
 *
 * @param {Function} $filter
 *
 * @return {CalendarLoading}
 */
function CalendarLoadingFactory($filter) {
/**
   * CalendarLoading constructor
   *
   * @class CalendarLoading
   * @constructor
   *
   * @param {Object} [params]
   * @param {String} [params.text]
   * @param {String} [params.info]
   */
  var
    CalendarLoading = function (params) {
      params = params || {};

      /**
       * True if loading in progress
       *
       * @type {Boolean}
       */
      this.inprogress = false;

      /**
       * Loading text
       *
       * @type {String}
       */
      this.text = params.text || translate('LANGM_JS_LOADING');

      /**
       * Loading text
       *
       * @type {String}
       */
      this.info = params.info || translate('LANGM_JS_CALENDAR_LOADING_TEXT');
    },

    translate = $filter('translate');

  // Add instance methods
  CalendarLoading.prototype = /** @lends CalendarLoading.prototype */ {

    /**
     * Returns true if loading in progress
     *
     * @returns {Boolean}
     */
    inProgress: function () {
      return this.inprogress;
    },

    /**
     * @param {Boolean} value
     */
    setInProgress: function (value) {
      this.inprogress = value;
    },

    /**
     * Get text
     *
     * @returns {String}
     */
    getText: function () {
      return this.text;
    },

    /**
     * Get info
     *
     * @returns {String}
     */
    getInfo: function () {
      return this.info;
    }
  };

  CalendarLoading.prototype.constructor = CalendarLoading;

  return CalendarLoading;
}]);
;

// Source: ../shared/public_html/assets/js/calendar/services/CalendarCheapest.service.js
(function (angular, moment, underscore) {
/**
     * Service responsible for calling api endpoints that load cheapest prices in the fare calendar
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CalendarCheapestService = function (CheapestFlightsApi, CheapestFlightsRequestParams, LOCATION_TYPES, appConfig) {
        var bestPricesAbTestKey = 'best_prices_cal';

        /**
         * Returns data for the calendar cells
         *
         * @param {Object} params
         * @returns {Promise}
         */
        this.getCells = function (params) {
            if (params.whichDate === 'departure' || params.oneWay) {
                // Departures
                return CheapestFlightsApi.getNewCalendarData(getCalendarParams(params));
            }

            // Returns
            return CheapestFlightsApi.getNewMatrixData(getMatrixParams(params));
        };

        /**
         * Returns data for the LP calendar cells
         *
         * @param {Object} calendar
         * @param {SearchQueryParams} searchQueryParams
         * @param {String} month
         * @param {String} year
         * @param {String} selectedDate
         * @returns {Promise}
         */
        this.getLpCells = function (calendar, searchQueryParams, month, year, selectedDate) {
            if (!calendar.getDepDate() || calendar.isOneWay()) {
                // Departures
                return CheapestFlightsApi.getNewCalendarData(getLpCalendarParams(calendar, searchQueryParams, month, year));
            }

            // Returns
            return CheapestFlightsApi.getNewMatrixData(getLpMatrixParams(searchQueryParams, selectedDate));
        };

        this.getCarrierNewData = function (carrierCode) {
            var newParams = new CheapestFlightsRequestParams();
            newParams.add('carrierCode', carrierCode);

            return CheapestFlightsApi.getCarrierNewData(newParams);
        };

        /**
         * Returns month bar data
         *
         * @param {Object} payload
         * @returns {Promise}
         */
        this.getMonthBars = function (payload) {
            return CheapestFlightsApi.getNewCalendarData(getMonthBarsParams(payload));
        };

        /**
         * Returns flight for LPs
         *
         * @param {Object} payload
         * @returns {Promise}
         */
        this.getFlights = function (payload) {
            if (payload.depDate !== '' || payload.retDate !== '') {
                return CheapestFlightsApi.getNewMatrixData(getMatrixFlightsParams(payload));
            }

            return CheapestFlightsApi.getNewCalendarData(getCalendarFlightsParams(payload));
        };

        /**
         * Converts old API params into the new IBE calendar API params
         *
         * @param {Object} params
         * @returns {Object}
         */
        var getCalendarParams = function (params) {
            var newParams = new CheapestFlightsRequestParams();

            // From
            newParams.add('origins', underscore.map(params.departurePlace, function (place) {
                return getPlaceType(place).toLowerCase() + ':' + getPlaceCode(place);
            }).join(','));

            // To
            newParams.add('destinations', underscore.map(params.destinationPlace, function (place) {
                return getPlaceType(place).toLowerCase() + ':' + getPlaceCode(place);
            }).join(','));

            // Period
            if (params.months) {
                newParams.add('fromMonth', moment(params.months[0]).format('YYYY-MM'));
                newParams.add('toMonth', moment(params.months[params.months.length - 1]).format('YYYY-MM'));
            }

            newParams.add('filters.wholeYearStayTime', !params.oneWay);
            newParams.add('filters.limitPerCell', 1);
            newParams.add('requester', 'dep-datepicker');
            newParams.add('entryType', appConfig.isFeatureTestEnabled(bestPricesAbTestKey) ? 'BEST' : 'CHEAPEST');
            newParams.add('grouping', 'ROUTE');

            return newParams;
        };

        /**
         * Converts old API params into the new IBE matrix API params
         *
         * @param {Object} params
         * @returns {Object}
         */
        var getMatrixParams = function (params) {
            var newParams = new CheapestFlightsRequestParams();

            // From
            // From
            newParams.add('origins', underscore.map(params.departurePlace, function (place) {
                return getPlaceType(place).toLowerCase() + ':' + getPlaceCode(place);
            }).join(','));

            // To
            newParams.add('destinations', underscore.map(params.destinationPlace, function (place) {
                return getPlaceType(place).toLowerCase() + ':' + getPlaceCode(place);
            }).join(','));

            // Departure date
            if (params.departureDate && !params.oneWay) {
                newParams.add('outboundDepartureDate.exact', moment(params.departureDate).format('YYYY-MM-DD'));
                newParams.add('filters.minStayTime', 0);
                newParams.add('filters.maxStayTime', params.maxVisibleDate
                    ? moment(params.maxVisibleDate).diff(moment(params.departureDate), 'days')
                    : 31
                );
            }

            newParams.add('filters.limitPerCell', 1);
            newParams.add('requester', 'ret-datepicker');
            newParams.add('entryType', appConfig.isFeatureTestEnabled(bestPricesAbTestKey) ? 'BEST' : 'CHEAPEST');
            newParams.add('grouping', 'ROUTE');

            return newParams;
        };

        /**
         * Converts old calendar LP params to IBE calendar params
         *
         * @param {Object} calendar
         * @param {SearchQueryParams} searchQueryParams
         * @param {Number} month
         * @param {Number} year
         * @returns {Object}
         */
        var getLpCalendarParams = function (calendar, searchQueryParams, month, year) {
            var newParams = new CheapestFlightsRequestParams();

            // Origin / destination
            newParams.add('origins', getLpPlaceType(searchQueryParams, 'from').toLowerCase() + ':' + getLpPlaceCode(searchQueryParams, 'from'));
            newParams.add('destinations', getLpPlaceType(searchQueryParams, 'to').toLowerCase() + ':' + getLpPlaceCode(searchQueryParams, 'to'));
            newParams.add('filters.carriers', searchQueryParams.forceCarrier);

            // Min / max stay time
            if (!calendar.getDepDate() && !calendar.isOneWay()) {
                newParams.add('filters.minStayTime', searchQueryParams.getTripLengthFrom());
                newParams.add('filters.maxStayTime', searchQueryParams.getTripLengthTo());
            }

            // Period
            newParams.add('fromMonth', year + '-' + month);
            // newParams.add('filters.wholeYearStayTime', !calendar.isOneWay());
            newParams.add('filters.limitPerCell', 1);
            newParams.add('requester', 'lp-dep-calendar');
            newParams.add('entryType', appConfig.isFeatureTestEnabled(bestPricesAbTestKey) ? 'BEST' : 'CHEAPEST');
            newParams.add('grouping', 'ROUTE');

            return newParams;
        };

        /**
         * Returns LP calendar return prices
         *
         * @param {SearchQueryParams} searchQueryParams
         * @param {String} selectedDate
         * @returns {Object}
         */
        var getLpMatrixParams = function (searchQueryParams, selectedDate) {
            var newParams = new CheapestFlightsRequestParams();

            // Origin / destination
            newParams.add('origins', getLpPlaceType(searchQueryParams, 'from').toLowerCase() + ':' + getLpPlaceCode(searchQueryParams, 'from'));
            newParams.add('destinations', getLpPlaceType(searchQueryParams, 'to').toLowerCase() + ':' + getLpPlaceCode(searchQueryParams, 'to'));
            newParams.add('filters.carriers', searchQueryParams.forceCarrier);

            // Period
            newParams.add('outboundDepartureDate.exact', moment(selectedDate).format('YYYY-MM-DD'));
            newParams.add('filters.minStayTime', searchQueryParams.getTripLengthFrom());
            newParams.add('filters.maxStayTime', searchQueryParams.getTripLengthTo());
            newParams.add('filters.limitPerCell', 1);
            newParams.add('requester', 'lp-ret-calendar');
            newParams.add('entryType', appConfig.isFeatureTestEnabled(bestPricesAbTestKey) ? 'BEST' : 'CHEAPEST');
            newParams.add('grouping', 'ROUTE');

            return newParams;
        };

        /**
         * Returns LP month bar parameters
         *
         * @param {Object} payload
         * @returns {Object}
         */
        var getMonthBarsParams = function (payload) {
            var newParams = new CheapestFlightsRequestParams();

            // Origin / destination
            newParams.add('origins', mgetMonthBarPlaceType(payload, 'From').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'From'));
            newParams.add('destinations', mgetMonthBarPlaceType(payload, 'To').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'To'));
            newParams.add('filters.carriers', payload.forceCarrier);

            // Min / max stay time
            newParams.add('filters.minStayTime', payload.tripLengthFrom);
            newParams.add('filters.maxStayTime', payload.tripLengthTo);

            // Period
            var today = moment();
            newParams.add('fromMonth', today.format('YYYY-MM'));
            newParams.add('toMonth', today.add(11, 'month').format('YYYY-MM'));
            // newParams.add('filters.wholeYearStayTime', true);
            newParams.add('filters.limitPerCell', 1);
            newParams.add('requester', 'lp-bar-chart');

            return newParams;
        };

        /**
         * Returns LP flights departure flights
         *
         * @param {Object} payload
         * @returns {Object}
         */
        var getCalendarFlightsParams = function (payload) {
            var newParams = new CheapestFlightsRequestParams();

            // Origin / destination
            newParams.add('origins', mgetMonthBarPlaceType(payload, 'From').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'From'));
            newParams.add('destinations', mgetMonthBarPlaceType(payload, 'To').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'To'));
            newParams.add('filters.carriers', payload.forceCarrier);

            // // Min / max stay time
            newParams.add('filters.minStayTime', payload.minStayTime);
            newParams.add('filters.maxStayTime', payload.maxStayTime);

            // Period
            if (payload.fromMonth !== '') {
                newParams.add('fromMonth', payload.fromMonth);
            }

            if (payload.fromMonth === '') {
                var today = moment();
                newParams.add('fromMonth', today.format('YYYY-MM'));
                newParams.add('toMonth', today.add(11, 'month').format('YYYY-MM'));
            }

            // newParams.add('filters.wholeYearStayTime', true);
            newParams.add('filters.limitPerCell', 1);
            newParams.add('filters.limit', 100);
            newParams.add('requester', 'lp-dep-flights');

            return newParams;
        };

        /**
         * Returns LP flights return flights
         *
         * @param {Object} payload
         * @returns {Object}
         */
        var getMatrixFlightsParams = function (payload) {
            var newParams = new CheapestFlightsRequestParams();

            newParams.add('origins', mgetMonthBarPlaceType(payload, 'From').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'From'));
            newParams.add('destinations', mgetMonthBarPlaceType(payload, 'To').toLowerCase() + ':' + getMonthBarPlaceCode(payload, 'To'));
            newParams.add('filters.carriers', payload.forceCarrier);

            // Departure date
            if (payload.depDate !== '') {
                newParams.add('outboundDepartureDate.exact', moment(payload.depDate).format('YYYY-MM-DD'));
                newParams.add('filters.minStayTime', payload.minStayTime);
                newParams.add('filters.maxStayTime', payload.maxStayTime);
            }

            if (payload.retDate !== '') {
                newParams.add('inboundDepartureDate.exact', moment(payload.retDate).format('YYYY-MM-DD'));
            }

            newParams.add('filters.limitPerCell', 1);
            newParams.add('filters.limit', 100);
            newParams.add('requester', 'lp-ret-flights');

            return newParams;
        };

        /**
         * Get LP place code
         *
         * @param {SearchQueryParams} searchQueryParams
         * @param {String} whichPlace Either 'from' or 'to'
         * @returns {String}
         */
        var getLpPlaceCode = function (searchQueryParams, whichPlace) {
            var countryCode = 'flight_' + whichPlace + '_country_code';
            var cityCode = 'flight_' + whichPlace + '_code';
            var airportCode = 'flight_' + whichPlace + '_airport_code';

            if (searchQueryParams[airportCode] !== undefined && searchQueryParams[airportCode] !== '') {
                return searchQueryParams[airportCode];
            }

            if (searchQueryParams[cityCode] !== undefined && searchQueryParams[cityCode] !== '') {
                return searchQueryParams[cityCode];
            }

            if (searchQueryParams[countryCode] !== undefined && searchQueryParams[countryCode] !== '') {
                return searchQueryParams[countryCode];
            }

            return '*';
        };

        /**
         * Returns LP place type
         *
         * @param {SearchQueryParams} searchQueryParams
         * @param {String} whichPlace Either 'from' or 'to'
         * @returns {String}
         */
        var getLpPlaceType = function (searchQueryParams, whichPlace) {
            var countryCode = 'flight_' + whichPlace + '_country_code';
            var cityCode = 'flight_' + whichPlace + '_code';
            var airportCode = 'flight_' + whichPlace + '_airport_code';

            if (searchQueryParams[airportCode] !== undefined && searchQueryParams[airportCode] !== '') {
                return LOCATION_TYPES.AIRPORT;
            }

            if (searchQueryParams[cityCode] !== undefined && searchQueryParams[cityCode] !== '') {
                if (searchQueryParams[cityCode].length === 2) {
                    return LOCATION_TYPES.COUNTRY;
                }
                return LOCATION_TYPES.CITY;
            }

            if (searchQueryParams[countryCode] !== undefined && searchQueryParams[countryCode] !== '') {
                return LOCATION_TYPES.COUNTRY;
            }

            return LOCATION_TYPES.CITY;
        };

        /**
         * Returns place code
         *
         * @param {Object} place
         * @returns {String}
         */
        var getPlaceCode = function (place) {
            if (place.isCity()) {
                return place.cityCode;
            }

            if (place.isAirport()) {
                return place.airportCode;
            }

            if (place.isCountry()) {
                return place.countryCode;
            }
        };

        /**
         * Returns place type
         *
         * @param {Object} place
         * @returns {String}
         */
        var getPlaceType = function (place) {
            if (place.isCity()) {
                return LOCATION_TYPES.CITY;
            }

            if (place.isAirport()) {
                return LOCATION_TYPES.AIRPORT;
            }

            if (place.isCountry()) {
                return LOCATION_TYPES.COUNTRY;
            }
        };

        /**
         * Returns month bar place code
         *
         * @param {Object} payload
         * @param {String} type Either 'From' or 'To'
         * @returns {String}
         */
        var getMonthBarPlaceCode = function (payload, type) {
            var countryCode = 'country' + type;
            var cityCode = 'city' + type;
            var airportCode = 'airport' + type;

            if (payload[airportCode] !== '') {
                return payload[airportCode];
            }

            if (payload[cityCode] !== '') {
                return payload[cityCode];
            }

            if (payload[countryCode] !== '') {
                return payload[countryCode];
            }

            return '*';
        };

        /**
         * Returns month bar place type
         *
         * @param {Object} payload
         * @param {String} type Either 'From' or 'To'
         * @returns {String}
         */
        var mgetMonthBarPlaceType = function (payload, type) {
            var cityCode = 'city' + type;
            var airportCode = 'airport' + type;

            if (payload[airportCode] !== '') {
                return LOCATION_TYPES.AIRPORT;
            }

            if (payload[cityCode] !== '') {
                return LOCATION_TYPES.CITY;
            }

            return LOCATION_TYPES.COUNTRY;
        };
    };

    CalendarCheapestService.$inject = [
        'CheapestFlightsApi',
        'CheapestFlightsRequestParams',
        'LOCATION_TYPES',
        'appConfig'
    ];

    angular
        .module('calendar')
        .service('CalendarCheapestService', CalendarCheapestService);

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/calendar/services/CalendarSrv.js
angular.module('calendar')

/**
 * @name Calendar Service
 * @description Calendar service
 */
.factory('cal.CalendarSrv', ['$q', 'appConfig', 'Dictionaries', 'CalendarCheapestService',
function CalendarSrvFactory($q, appConfig, Dictionaries, CalendarCheapestService) {
/**
   * @class CalendarSrv
   * @constructor
   */
  var CalendarSrv = function () {};

  /**
   * @lends CalendarSrv.prototype
   */
  CalendarSrv.prototype = {
    /**
     * Get calendar for specified month
     *
     * @param {{month: string, year: string, type: string, timeout: number|Promise, searchQueryParams: SearchQueryParams, lpUrl: string|undefined, calendar: Calendar}} params
     *  month - 2 chars eq '02', '11' etc
     *  year - 4 chars eq 2015
     *  [timeout] timeout in milliseconds, or promise that should abort the request when resolved
     *  [lpUrl]
     *  searchQueryParams
     *  calendar
     *
     * @returns {Promise}
     */
    getCalendar: function (params) {
      var deferred = $q.defer();
      var selectedDate = (params.calendar.getDepDate() && !params.calendar.isOneWay()) ? moment(params.calendar.getDepDate()).format('YYYY-MM-DD') : undefined;

      CalendarCheapestService
        .getLpCells(params.calendar, params.searchQueryParams, params.month, params.year, selectedDate)
        .then(function (success) {
          if (success.data.hasOwnProperty('translations')) {
            // Add cities to dictionaries
            Object.keys(success.data.translations.cities).forEach(function (cityCode) {
              var cityName = success.data.translations.cities[cityCode];

              Dictionaries.addAirport(
                { city_name: cityName, city_code: cityCode },
                appConfig.getLanguageCode()
              );
            });
          }

          var cells = {};

          if (!success.data.hasOwnProperty('cells')) {
            deferred.resolve(cells);
            return;
          }

          angular.forEach(success.data.cells, function (cell) {
            var depDate = moment(cell.outboundDepartureDateTime).format('YYYY-MM-DD');
            var retDate = moment(cell.inboundDepartureDateTime).format('YYYY-MM-DD');
            var cellDate = selectedDate ? retDate : depDate;
            var price = cell.price.value.amount;

            cells[cellDate] = {
              city_from: cell.originCity,
              city_to: cell.destinationCity,
              date_dep: depDate,
              date_ret: retDate,
              outBoundDetails: {
                airline: cell.outboundOperatingCarriers,
                stops: cell.outboundStopovers
              },
              inBoundDetails: {
                airline: cell.inboundOperatingCarriers,
                stops: cell.inboundStopovers
              },
              min_price: price,
              min_price_not_rounded: price,
              url: ''
            };
          });

          deferred.resolve(cells);
        })
        .finally(function () {
          params.calendar.loading.setInProgress(false);
        });

      return deferred.promise;
    }
  };

  CalendarSrv.prototype.constructor = CalendarSrv;

  return new CalendarSrv();
}]);
;

// Source: ../shared/public_html/assets/js/checkin/checkin-document-types.constant.js
(function (angular) {
var IthCheckinDocumentTypesConstant = {
        PASSPORT: {
            id: 'PASSPORT',
            lang: 'LANGM_JS_CHECKIN_DOC_PASSPORT'
        },
        GOV_ID: {
            id: 'GOV_ID',
            lang: 'LANGM_JS_CHECKIN_DOC_ID'
        }
    };

    angular
        .module('ITH.Checkin')
        .constant('CHECKIN_DOCUMENT_TYPES', IthCheckinDocumentTypesConstant);

}(angular));;

// Source: ../shared/public_html/assets/js/checkin/checkin-form-logic.service.js
(function(angular, underscore) {
var IthCheckinFormLogicService = function ($q, AppConfig, Notifications, CHECKIN_NOTIFICATIONS, Country, CheckInService, $modal) {
        /**
         * Mock country data for htmls.
         *
         * @type {Array}
         */
        this.countries = [];

        /**
         * Returns the next checkin pax that has invalid check-in data.
         *
         * @returns {CheckinPax}
         */
        this.getNextInvalidPax = function (allPaxes, currentPax, ltd) {
            return underscore.find(allPaxes, function (checkinPax) {
                return checkinPax.isValid(ltd) !== true && checkinPax !== currentPax;
            }, this);
        };

        /**
         * Opens the edit ckeck-in pax modal on mobile.
         *
         * @param {CheckinPax}  paxData
         * @param {Countries[]} countries
         * @param {String}      hash
         */
        this.openCheckinModal = function (paxData, allPaxes, hash) {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/user/profile/modals/mobile-checkin-pax-modal',
                controller: 'CheckinPaxMobileModalCtrl',
                windowClass: 'mobile-modal-with-navbar checkin-mobile-modal',
                resolve: {
                    paxData: function () {
                        return paxData;
                    },
                    allPaxes: function () {
                        return allPaxes;
                    },
                    hash: function () {
                        return hash;
                    }
                }
            });
        };

        this.getCountries = function () {
            var deferred = $q.defer();

            if (this.countries.length) {
                // Send countries right away
                deferred.resolve(this.countries);
            } else {
                // Make request to get countries
                var self = this;
                CheckInService.getCountries().then(function (success) {
                    angular.forEach(success, function (countryData) {
                        self.countries.push(new Country(countryData));
                    });
                    deferred.resolve(self.countries);
                });
            }

            return deferred.promise;
        };

        /**
         *
         * @param ngForm
         * @param allPaxes
         * @param paxData
         * @param hash
         * @param ltd
         * @returns {*}
         * @deprecated
         */
        this.savePaxData = function (ngForm, allPaxes, paxData, hash, ltd) {
            var deferred = $q.defer();

            if (ngForm.$invalid) {
                deferred.reject();
                return deferred.promise;
            }

            var nextInvalidPax = this.getNextInvalidPax(allPaxes, paxData, ltd);

            if (nextInvalidPax !== undefined) {
                // Show success notification
                if (AppConfig.isPhone()) {
                    // Open next invalid pax modal
                    this.openCheckinModal(nextInvalidPax, allPaxes, hash);
                } else {
                    // Close this valid pax
                    paxData.editMode = false;
                    paxData.showInfo = false;

                    // Open next invalid pax
                    nextInvalidPax.editMode = true;
                    nextInvalidPax.showInfo = true;
                }
            } else {
                // Prepare paxes
                var dataForBackend = {
                    paxes: {}
                };

                angular.forEach(allPaxes, function (checkinPax) {
                    dataForBackend.paxes[checkinPax.travellerId] = checkinPax.srvObj();
                });

                // Save paxes to backend
                paxData.savingData = true;

                CheckInService
                    .saveInformation(hash, dataForBackend)
                    .then(function (success) {
                        paxData.editMode = false;
                        paxData.showInfo = true;

                        // Show success notification
                        Notifications.show(CHECKIN_NOTIFICATIONS.UPDATED);
                        angular.forEach(allPaxes, function (checkinPax) {
                            checkinPax.editMode = false;
                            checkinPax.showInfo = false;
                        });

                        deferred.resolve(success);
                    }, function (failure) {
                        // Set backend errors
                        deferred.reject(failure);
                    }).finally(function () {
                        // Set form saving state to false
                        paxData.savingData = false;
                    });
            }

            return deferred.promise;
        };

        this.saveData = function(ngForm, paxes, token) {
            var deferred = $q.defer();
            var payload = {
                paxes: {}
            };

            if (ngForm.$invalid) {
                deferred.reject();
                return deferred.promise;
            }

            angular.forEach(paxes, function (pax) {
                payload.paxes[pax.travellerId] = pax.srvObj();
            });

            paxes.savingData = true;

            console.log( payload, payload );

            deferred.resolve();

            //CheckInService
            //    .saveInformation(token, payload)
            //    .then(function (success) {
            //        // Show success notification
            //        Notifications.show(CHECKIN_NOTIFICATIONS.UPDATED);
            //
            //        deferred.resolve(success);
            //    }, function (failure) {
            //        // Set backend errors
            //        deferred.reject(failure);
            //    }).finally(function () {
            //        // Set form saving state to false
            //        paxes.savingData = false;
            //    });

            return deferred.promise;
        };

        /**
         * Returns names of invalid checkin paxes separated by a comma.
         *
         * @param   {CheckinPax[]} allPaxes
         * @returns {String}
         */
        this.getInvalidPaxNames = function (allPaxes) {
            var arr = underscore.filter(allPaxes, function (checkinPax) {
                return !checkinPax.isValid();
            });

            var invalidPaxes = underscore.map(arr, function (checkinPax) {
                return checkinPax.getPax().getPerson().getFirstName() + ' ' + checkinPax.getPax().getPerson().getLastName();
            });

            return invalidPaxes.join(', ');
        };

        this.setBackendErrors = function (allPaxes, errors) {
            if (errors === undefined || !errors.hasOwnProperty('response') || !errors.response.hasOwnProperty('paxes')) {
                return;
            }

            angular.forEach(allPaxes, function (checkinPax) {
                if (errors.response.paxes.hasOwnProperty(checkinPax.travellerId)) {
                    checkinPax.getPax().srvErrors(errors.response.paxes[checkinPax.travellerId]);
                }
            });
        };

        this.setPaxCountryCodes = function (person, countries) {
            angular.forEach(countries, function (country) {
                if (country.getCode() === person.getIdCard().getIssuingCountry()) {
                    person.getIdCard().setIssuingCountry(country.getCode());
                }
            });
        };
    };

    IthCheckinFormLogicService.$inject = [
        '$q',
        'appConfig',
        'NotificationService',
        'CHECKIN_NOTIFICATIONS',
        'bil.Country',
        'CheckInService',
        '$modal'
    ];

    angular
        .module('ITH.Checkin')
        .service('CheckinFormLogic', IthCheckinFormLogicService);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/checkin/checkin-notifications.constant.js
(function() {
var IthCheckinNotificationsConstant = {
        PHONE: 'MOBILE_CHECKIN_NOTIFICATION',
        OTHER: 'OTHER_CHECKIN_NOTIFICATION',
        UPDATED: 'UPDATED_CHECKIN_NOTIFICATION',
        INVALID: 'INVALID_CHECKIN_FORM_NOTIFICATION'
    };

    angular
        .module('ITH.Checkin')
        .constant('CHECKIN_NOTIFICATIONS', IthCheckinNotificationsConstant);

}());
;

// Source: ../shared/public_html/assets/js/checkin/checkin-statuses.constant.js
(function() {
var IthCheckinStatusesConstant = {
        HAS_CHECKIN_NUMBER: 'HAS_CHECKIN_NUMBER',
        HAS_AUTOMATIC_CHECKIN: 'HAS_AUTOMATIC_CHECKIN',
        HAS_FREE_AIRPORT_CHECKIN: 'HAS_FREE_AIRPORT_CHECKIN',
        IS_CHECKIN_COMPLETED: 'IS_CHECKIN_COMPLETED'
    };

    angular
        .module('ITH.Checkin')
        .constant('CHECKIN_STATUSES', IthCheckinStatusesConstant);
	
}());;

// Source: ../shared/public_html/assets/js/checkin/checkin-travel-document.factory.js
(function(angular) {
/**
     * @name        IthCheckinTravelDocumentFactory
     * @description Represents the model for the check-in travel document.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinTravelDocumentFactory = function (DateObject, Country, DOCUMENT_TYPES) {
        /**
         * Check-in travel document model.
         *
         * @param {String} type   Type of check-in document
         * @param {String} number Number of the check-in document
         *
         * @constructor
         */
        var CheckinTravelDocument = function (type, number) {
            /**
             * Check-in travel document type ('PASSPORT'|'GOV_ID').
             *
             * @type {String}
             */
            this.type = type || DOCUMENT_TYPES.passport;

            /**
             * Travel document number.
             *
             * @type {String}
             */
            this.number = number || null;

            /**
             * Travel document issue date.
             *
             * @type {DateObject}
             */
            this.issued = new DateObject();

            /**
             * Travel document expiration date.
             *
             * @type {DateObject}
             */
            this.expiration = new DateObject();

            /**
             * Travel document country.
             *
             * @type {Country}
             */
            this.country = new Country();
        };

        return CheckinTravelDocument;
    };

    IthCheckinTravelDocumentFactory.$inject = [
        'DateObject',
        'bil.Country',
        'DOCUMENT_TYPES'
    ];

    angular
        .module('ITH.Checkin')
        .factory('CheckinTravelDocument', IthCheckinTravelDocumentFactory)
        .constant('DOCUMENT_TYPES', {
            passport: 'PASSPORT',
            id: 'GOV_ID'
        });
	
}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/checkinDate.filter.js
(function (angular) {
/**
     * Filter for dates in check-in zone
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CheckinDateFilter = function ($filter) {
        return function (date) {
            return $filter('date')(date, 'dd.MM.yy');
        };
    };

    CheckinDateFilter.$inject = [
        '$filter'
    ];

    angular
        .module('ITH.Checkin')
        .filter('checkinDate', CheckinDateFilter);

}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/date-object.factory.js
(function(angular, moment) {
/**
     * @name        DateObjectFactory
     * @description A date model with simple properties.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var DateObjectFactory = function () {
        /**
         * Date object constructor.
         * @constructor
         *
         * @param {Number} day 
         * @param {Number} month 
         * @param {Number} year 
         */
        var DateObject = function (day, month, year) {
            /**
             * Day of month.
             *
             * @type {Number}
             */
            this.day = day || new Date().getDate();

            /**
             * Month number.
             *
             * @type {Number}
             */      
            this.month = month || new Date().getMonth();

            /**
             * Year.
             *
             * @type {Number}
             */      
            this.year = year || new Date().getFullYear();
        };

        DateObject.prototype = {
            /**
             * Transforms the date into a ISO string.
             *
             * @returns {String}
             */
            toISOString: function () {
                return new moment(this.month + '/' + this.day + '/' + this.year).toISOString();
            }
        };

        return DateObject;
    };

    angular
        .module('ITH.Checkin')
        .factory('DateObject', DateObjectFactory);
	
}(angular, moment));
;

// Source: ../shared/public_html/assets/js/checkin/flight/checkin-flight-information.factory.js
(function (angular, underscore, moment) {
/**
   * @name        CheckinFlightInformationFactory
   * @description Represents model for checkin information.
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var CheckinFlightInformationFactory = function (FlightDetails, CheckinFlight, CheckinPax) {
    /**
     * Checkin pax model.
     * @constructor
     *
     * @param   {Object} checkinInfo Check-in information from backend.
     * @returns {CheckinFlightInformation}
     */
    var CheckinFlightInformation = function (checkinInfo) {
      /**
       * Is checkin Form disabled
       *
       * @type {Boolean}
       */
      this.isFormDisabled = checkinInfo.isFormDisabled;
      /**
       * Is data collected (in check-in service)
       *
       * @type {Boolean}
       */
      this.isDataAlreadyCollected = checkinInfo.isDataAlreadyCollected;
      /**
       * Check-in status.
       *
       * @type {Number}
       */
      this.checkinStatus = checkinInfo.checkinStatus;

      /**
       * Flight details model.
       *
       * @type {FlightDetails}
       */
      this.flightDetails = FlightDetails;

      /**
       * Flight reservation number
       *
       * @type {String}
       */
      this.reservationNumber = checkinInfo.reservationNumber;

      /**
       * Departure check-in flights.
       *
       * @type {CheckinFlight[]}
       */
      this.depOpts = [];

      /**
       * Return check-in flights.
       *
       * @type {CheckinFlight[]}
       */
      this.retOpts = [];

      /**
       * Array of check-in paxes.
       *
       * @type {CheckinPax[]}
       */
      this.paxes = [];

      /**
       * Array of airlines that support both online and auto check-in
       *
       * @type {String[]}
       */
      this.autoOnlineCarriers = checkinInfo.autoOnlineCarriers || [];

      /**
       * Collection of online check-in links by airline
       *
       * @type {Object}
       */
      this.onlineCheckinLinks = checkinInfo.onlineCheckinLinks || {};

      // /**
      //  * Seats object instance
      //  *
      //  * @type {Seats}
      //  */
      // this.seats = new Seats();

      // this.seats.srvSet(checkinInfo.seats);

      // Set flight information
      this.flightDetails.srvSet(checkinInfo.flight);

      // Set check-in flights
      this.flightDetails.getUnitOpts().forEach(function (unit) {
        var checkinFlight = new CheckinFlight(unit, checkinInfo.checkInInfo[unit.unitId].attributes, this.checkinStatus);

        if (unit.getFlightRoute() == 0) {
          // Add to departure
          this.depOpts.push(checkinFlight);
        } else {
          // Add to return
          this.retOpts.push(checkinFlight);
        }
      }, this);

      // Set paxes
      angular.forEach(checkinInfo.buddies, function (pax) {
        var newPax = new CheckinPax(pax, pax.id);
        this.paxes.push(newPax);
      }, this);
    };

    CheckinFlightInformation.prototype = {
      /**
       * Returns flight details.
       *
       * @returns {FlightDetails}
       */
      getFlightDetails: function () {
        return this.flightDetails;
      },

      /**
       * Returns flight reservation number
       *
       * @returns {String}
       */
      getReservationNumber: function () {
        return this.reservationNumber;
      },

      /**
       * Returns paxes in the check-in information.
       *
       * @returns {CheckinPax[]}
       */
      getPaxes: function () {
        return this.paxes;
      },

      /**
       * Returns departure check-in flights.
       *
       * @returns {CheckinFlight[]}
       */
      getDepOpts: function () {
        return this.depOpts;
      },

      /**
       * Returns return check-in flights.
       *
       * @type {CheckinFlight[]}
       */
      getRetOpts: function () {
        return this.retOpts;
      },

      /**
       * Get all checkin flights
       *
       * @returns {CheckinFlight[]}
       */
      getAllOpts: function () {
        return underscore.union(this.depOpts, this.retOpts);
      },

      /**
       * Returns return date for round-trip flights and departure date for one-way.
       *
       * @returns {Date}
       */
      getLastTravelDate: function () {
        var leg = (this.flightDetails.isRoundTrip())
          ? this.flightDetails.getRetLeg()
          : this.flightDetails.getDepLeg();

        var ltd = this.flightDetails.isRoundTrip()
          ? leg.getLastSegment().getArrDateMoment()
          : leg.getFirstSegment().getDepDateMoment();

        return ltd.add(1, 'day').format('YYYY-MM-DD');
      },

      /**
       * Checks to see if any pax is invalid.
       *
       * @returns {Boolean}
       */
      isAnyPaxInvalid: function () {
        var invalid = false;
        this.paxes.forEach(function (pax) {
          if (!pax.isValid()) {
            invalid = true;
          }
        });
        return invalid;
      },

      /**
       * Checks if any flight has automatic check-in.
       *
       * @returns {Boolean}
       */
      isAnyCheckinAuto: function () {
        return this.getFirstAutoCheckin() !== undefined;
      },

      /**
       * Checks if check-in data was collected or not
       *
       * @returns {Boolean}
       */
      isDataCollected: function () {
        return this.isDataAlreadyCollected;
      },

      /**
       * Checks if current datetime is too close to flight departure (3h before flight)
       *
       * @returns {Boolean}
       */
      isFormDisabled: function () {
        return this.isFormDisabled;
      },

      /**
       * Checks if user can edit pax information.
       *
       * @returns {Boolean}
       */
      canEditPaxInfo: function () {
        return !this.isFormDisabled && !this.isDataCollected;
      },

      /**
       * Returns the first auto check-in flight.
       *
       *  @returns {CheckinFlight}
       */
      getFirstAutoCheckin: function () {
        return underscore.find(this.getAllOpts(), function (opt) {
          return opt.getCheckinInfo().hasAutomaticCheckin();
        });
      }
    };

    return CheckinFlightInformation;
  };

  CheckinFlightInformationFactory.$inject = [
    'fdt.FlightDetails',
    'CheckinFlight',
    'CheckinPax'
  ];

  angular
    .module('ITH.Checkin')
    .factory('CheckinFlightInfo', CheckinFlightInformationFactory);

}(angular, _, moment));
;

// Source: ../shared/public_html/assets/js/checkin/flight/checkin-flight.factory.js
(function(angular, moment) {
/**
     * @name        CheckinFlightFactory
     * @description Represents model for checkin paxes.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CheckinFlightFactory = function (CheckinInformation) {
        /**
         * Checkin pax model.
         *
         * @constructor
         *
         * @param {UnitOpts} unit
         * @param {Object}   checkInInfo
         */
        var CheckinFlight = function (unit, checkInInfo, checkinStatus) {
            this.unit = unit;
            this.checkInInfo = new CheckinInformation(checkInInfo, checkinStatus);
        };
        
        CheckinFlight.prototype = {
            /**
             * Returns the unit option.
             *
             * @type {UnitOpts}
             */
            getUnit: function () {
                return this.unit;
            },

            /**
             * Returns checkin information.
             *
             * @returns {CheckinInformation}
             */
            getCheckinInfo: function () {
                return this.checkInInfo;
            },

            /**
             * Checks if this flight is departure flight.
             * 
             * @returns {Boolean}
             */
            isDeparture: function () {
                return this.getUnit().flightRoute === 0;
            },

            /**
             * Returns the check-in date by route.
             *
             * @returns {String}
             */
            getCheckInDate: function () {
                var checkinDate = this.getCheckinInfo().getDepCheckinDate();
                // Check for return date if return flight
                if (!this.isDeparture() && this.getCheckinInfo().getRetCheckinDate() !== null) {
                    checkinDate = this.getCheckinInfo().getRetCheckinDate();
                }
                return checkinDate;
            },

            /**
             * Returns the day before check-in date by route.
             * 
             * @returns {Date}
             */
            getBeforeCheckinDate: function () {
                return moment(this.getCheckInDate()).subtract(1, 'days').toDate();
            },

            /**
             * Returns the online check-in window start.
             *
             * @returns {String}
             */
            getOnlineWindowStart: function () {
                var onlineWindowStart = this.getCheckinInfo().getDepartureWindowStart();
                // Check for return date if return flight
                if (!this.isDeparture() && this.getCheckinInfo().getReturnWindowStart() !== null) {
                    onlineWindowStart = this.getCheckinInfo().getReturnWindowStart();
                }
                return onlineWindowStart;
            },

            /**
             * Returns the online check-in window end.
             *
             * @returns {String}
             */
            getOnlineWindowEnd: function () {
                var onlineWindowEnd = this.getCheckinInfo().getDepartureWindowEnd();
                // Check for return date if return flight
                if (!this.isDeparture() && this.getCheckinInfo().getReturnWindowEnd() !== null) {
                    onlineWindowEnd = this.getCheckinInfo().getReturnWindowEnd();
                }
                return onlineWindowEnd;
            }
        };

        return CheckinFlight;
    };

    CheckinFlightFactory.$inject = [
        'CheckinInformation'
    ];

    angular
        .module('ITH.Checkin')
        .factory('CheckinFlight', CheckinFlightFactory);
	
}(angular, moment));
;

// Source: ../shared/public_html/assets/js/checkin/flight/ith-checkin-flight.component.js
(function(angular) {
/**
     * @name        IthCheckinFlightComponent
     * @description Displays a flight along with check-in information for that route.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinFlightComponent = {
        templateUrl: '/tpl/show/jsShared/templates/user/components/ith-checkin-flight',
        controller: 'IthCheckinFlight',
        bindings: {
            checkinUnit: '<',
            checkinInfo: '<'
        }
    };

    angular
        .module('ITH.Checkin')
        .component('ithCheckinFlight', IthCheckinFlightComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/flight/ith-checkin-flight.controller.js
(function(angular) {
/**
     * @name        IthCheckinFlightController
     * @description Handles flight data to be displayed in the component.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinFlightController = function (Dictionaries) {
        /**
         * Dictionaries reference.
         *
         * @type {Dictionaries}
         */
        this.dictionaries = Dictionaries;

        /**
         * Checks if checkin number should be visible
         * 
         * @returns {Boolean}
         */
        this.showCheckinNumber = function () {
            return this.checkinUnit.getUnit().getAirlineLocator() && (this.checkinUnit.getCheckinInfo().hasOnlineCheckin() || this.isAutomaticManual());
        };

        /**
         * Returns correct link for online check-in
         * 
         * @returns {String}
         */
        this.getCheckinLink = function () {
            return (this.isAutomaticManual()) ? this.checkinInfo.onlineCheckinLinks[this.checkinUnit.getUnit().getCarrier()] : this.checkinUnit.getCheckinInfo().link;
        };

        /**
         * Checks if flight check-in is automatic but can also be done manually
         * 
         * @returns {Boolean}
         */
        this.isAutomaticManual = function () {
            return this.checkinUnit.getCheckinInfo().hasAutomaticCheckin() && this.checkinInfo.autoOnlineCarriers.indexOf(this.checkinUnit.getUnit().getCarrier()) != -1;
        };
    };

    IthCheckinFlightController.$inject = [
        'Dictionaries'
    ];
    
    angular
        .module('ITH.Checkin')
        .controller('IthCheckinFlight', IthCheckinFlightController);

}(angular));

;

// Source: ../shared/public_html/assets/js/checkin/info/checkin-information.factory.js
(function (angular, moment) {
/**
     * @name        CheckinInformationFactory
     * @description Represents model for checkin information.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CheckinInformationFactory = function () {
        /**
         * Formatter for backend dates.
         *
         * @param   {String} backendDate
         * @returns {String}
         */
        var momentDateFormatter = function (backendDate) {
            return moment(backendDate).isValid() ? moment(backendDate).toISOString() : null;
        };

        /**
         * Checkin pax model.
         * @constructor
         *
         * @param {Object} checkinInfo
         * @param {Number} checkinStatus
         */
        var CheckinInformation = function (checkinInfo, checkinStatus) {
            /**
             * Type of check-in (airport / auto / online).
             *
             * @type {String}
             */
            this.type = checkinInfo.type;

            /**
             * Last check-in date for departure flights that are automatic or done.
             *
             * @type {String} Date ISO string
             */
            this.date = momentDateFormatter(checkinInfo.date);

            /**
             * Last check-in date for return flights that are automatic or done.
             *
             * @type {String} Date ISO string
             */
            this.returnCheckinDate = momentDateFormatter(checkinInfo.returnCheckinDate);

            /**
             * Check-in departure checkin start date.
             *
             * @type {String} Date ISO string
             */
            this.departureWindowStart = momentDateFormatter(checkinInfo.departureWindowStart);

            /**
             * Check-in departure checkin end date.
             *
             * @type {String} Date ISO string
             */
            this.departureWindowEnd = momentDateFormatter(checkinInfo.departureWindowEnd);

            /**
             * Check-in return checkin start date.
             *
             * @type {String} Date ISO string
             */
            this.returnWindowStart = momentDateFormatter(checkinInfo.returnWindowStart);

            /**
             * Check-in return checkin end date.
             *
             * @type {String} Date ISO string
             */
            this.returnWindowEnd = momentDateFormatter(checkinInfo.returnWindowEnd);

            /**
             * Status of check-in.
             *
             * @type {Number}
             */
            this.status = checkinStatus || 0;

            /**
             * Link for online check-in (only available for type online).
             *
             * @type {String}
             */
            this.link = checkinInfo.link || null;
            
            /**
             * Check-in number.
             *
             * @type {String}
             */
            this.number = checkinInfo.checkInNumber || null; 

            /**
             * Collection of check-in boarding passes download links.
             *
             * @type {String[]}
             */
            this.boardingPasses = checkinInfo.boardingPasses || [];
        };

        CheckinInformation.prototype = {
            /**
             * Checks if current flight has a check-in number.
             *
             * @returns {Boolean}
             */
            hasOnlineCheckin: function () {
                return this.type === 'online';
            },

            /**
             * Checks if current flight has free airport check-in.
             *
             * @returns {Boolean}
             */
            hasFreeAirportCheckin: function () {
                return this.type === 'airport';
            },

            /**
             * Checks if current flight has check-in completed.
             *
             * @returns {Boolean}
             */
            isCheckinCompleted: function () {
                return this.type === 'auto' && this.status >= 20;
            },

            /**
             * Checks if current flight has automatic check-in.
             *
             * @returns {Boolean}
             */
            hasAutomaticCheckin: function () {
                return this.type === 'auto' && this.status < 20;
            },

            /**
             * Returns a boarding pass download link by pax index.
             *
             * @returns {String}
             */
            getBoardingPassByIndex: function (index) {
                if (this.boardingPasses.length === 0 || this.boardingPasses.length < index + 1) {
                    // No boarding passes or index out of range
                    return false;
                }
                return this.boardingPasses[index];
            },

            /**
             * Returns departure check-in date.
             * 
             *  @type {String}
             */
            getDepCheckinDate: function () {
                return this.date;
            },

            /**
             * Returns return check-in date.
             * 
             * @type {String}
             */
            getRetCheckinDate: function () {
                return this.returnCheckinDate;
            },

            /**
             * Returns the departure online check-in start date formatted.
             *
             * @returns {String}
             */
            getDepartureWindowStart: function () {
                return this.departureWindowStart;
            },

            /**
             * Returns the departure online check-in end date formatted.
             *
             * @returns {String}
             */
            getDepartureWindowEnd: function () {
                return this.departureWindowEnd;
            },

            /**
             * Returns the return online check-in start date formatted.
             *
             * @returns {String}
             */
            getReturnWindowStart: function () {
                return this.returnWindowStart;
            },

            /**
             * Returns the return online check-in end date formatted.
             *
             * @returns {String}
             */
            getReturnWindowEnd: function () {
                return this.returnWindowEnd;
            }
        };

        CheckinInformation.prototype.constructor = CheckinInformation;

        return CheckinInformation;
    };

    angular
        .module('ITH.Checkin')
        .factory('CheckinInformation', CheckinInformationFactory);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/checkin/info/ith-checkin-info.component.js
(function(angular) {
/**
     * Template function for default template path
     *
     * @returns {String}
     */
    var IthCheckinInfoComponentTemplateUrl = function ($attrs) {
        return $attrs.templateUrl || '/tpl/show/jsShared/templates/user/components/checkin-info';
    };

    IthCheckinInfoComponentTemplateUrl.$inject = [
        '$attrs'
    ];

    /**
     * @name        IthCheckinInfoComponent
     * @description Displays check-in information in profile for a booked flight.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinInfoComponent = {
        templateUrl: IthCheckinInfoComponentTemplateUrl,
        controller: 'CheckinInfoController',
        bindings: {
            hash: '<'
        }
    };

    angular
        .module('ITH.Checkin')
        .component('ithCheckinInfo', IthCheckinInfoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/info/ith-checkin-info.controller.js
(function(angular, underscore) {
/**
     * @name        IthCheckinInfoController
     * @description Handles data inside the check-in info component.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinInfoController = function(CHECKIN_NOTIFICATIONS, CheckInService, OverflowSmoothScroll,
        CheckinFlightInfo, Dictionaries, UserServiceV2, $rootScope, Tools, CheckinFormLogic, AuthValuesConverter) {
        /**
         * Self reference.
         *
         * @type {IthCheckinInfoController}
         */
        var ctrl = this;

        /**
         * Reference to tools service.
         *
         * @type {Tools}
         */
        this.tools = Tools;

        /**
         * Notification names constant.
         *
         * @type {Object}
         */
        this.notifications = CHECKIN_NOTIFICATIONS;

        /**
         * Flag for error message.
         *
         * @type {Boolean}
         */
        this.isError = false;

        /**
         * Flag for loading sequence.
         *
         * @type {Boolean}
         */
        this.isLoading = false;

        /**
         * Form save success response data
         *
         * @type {Object}
         */
        this.isSaved = { success: false, response: undefined };

        /**
         * Flight details reference.
         *
         * @type {CheckinFlightInfo}
         */
        this.checkinInfo = null;

        /**
         * Last day of open online self-checkin.
         *
         * @type {String}
         */
        this.lastCheckinDate = null;

        /**
         * Departure online checkin airline names separated by commas.
         *
         * @type {String}
         */
        this.departureOnlineCheckinAirlines = '';

        /**
         * Departure airport checkin airline names separated by commas.
         *
         * @type {String}
         */
        this.airportCheckinAirlines = '';

        /**
         * Return online checkin airline names separated by commas.
         *
         * @type {String}
         */
        this.returnOnlineCheckinAirlines = '';

        /**
         * Return airport checkin airline names separated by commas.
         *
         * @type {String}
         */
        this.returnAirportCheckinAirlines = '';

        /**
         * Departure flight data
         *
         * @type {Object}
         */
        this.departureFlightData = null;

        /**
         * Return flight data
         *
         * @type {Object}
         */
        this.returnFlightData = null;

        /**
         * Switch for showing / hiding flight information above form
         *
         * @type {Boolean}
         */
        this.showFlightInformation = false;


        this.savingData = false;

        this.loadPresets = function () {
            UserServiceV2.getPassengersData(true).then(function (response) {
                const resp = UserServiceV2.adaptResponse(response);

                ctrl.buddies = AuthValuesConverter.getTravelBuddiesArray(
                    resp.buddies,
                    resp.customer.person
                );
            });
        };

        /**
         * Controller on init hook.
         */
        this.$onInit = function() {
            this.isLoading = true;

            CheckInService
                .getInformation(this.hash)
                .then(function(success) {
                    // Set check-in info
                    ctrl.checkinInfo = new CheckinFlightInfo(success);

                    // Set airlines by checkin type
                    ctrl.onlineCheckinAirlines = ctrl.filterFlightsByCheckin(ctrl.checkinInfo.getAllOpts(), 'online');
                    ctrl.airportCheckinAirlines = ctrl.filterFlightsByCheckin(ctrl.checkinInfo.getAllOpts(), 'airport');

                    ctrl.departureFlightData = {
                        leg: ctrl.checkinInfo.getFlightDetails().getDepLeg()
                    };
                    ctrl.returnFlightData = {
                        leg: ctrl.checkinInfo.getFlightDetails().isRoundTrip()
                          ? ctrl.checkinInfo.getFlightDetails().getRetLeg()
                          : null
                    };

                    var carriers = _.map(ctrl.departureFlightData.leg.carriers, function(carrier){return carrier;});

                    if(ctrl.returnFlightData.leg){
                        _.forEach(ctrl.returnFlightData.leg.carriers, function(carrier){carriers.push(carrier);});
                    }

                    ctrl.cities = [
                        Dictionaries.getCityNameByCode(ctrl.departureFlightData.leg.dep, false),
                        Dictionaries.getCityNameByCode(ctrl.departureFlightData.leg.arr, false)
                    ].join(' - ');

                })
                .catch(function(e) {
                    ctrl.isError = true;
                })
                .finally(function() {
                    ctrl.isLoading = false;
                });

            var loggedIn = $rootScope.auth ? $rootScope.auth.loggedIn : false;

            if (loggedIn) {
               ctrl.loadPresets();
            }

            CheckinFormLogic.getCountries().then(function(result){
                ctrl.countries = result;
            });
        };

        /**
         * Scrolls to passenger zone.
         */
        this.scrollToPaxes = function() {
            OverflowSmoothScroll.scroll('.ith-checkin-pax', '.scroll-container', 50);
        };

        /**
         * Enables the flight information zone (makes it visible)
         */
        this.showFlightInfo = function() {
            this.showFlightInformation = true;
        };

        /**
         * Filters flights by check-in type and returns airlines in pretty print.
         *
         * @param   {CheckinFlight[]}   checkinFlightArray  Array containing check-in flights
         * @param   {String}            checkinType         Type of check-in
         * @returns {String}            Airline names separated by commas
         */
        this.filterFlightsByCheckin = function(checkinFlightArray, checkinType) {
            var arr = _.filter(checkinFlightArray, function(checkInFlight) {
                return checkInFlight.getCheckinInfo().type === checkinType;
            });

            var carriers = _.map(arr, function(checkInFlight) {
                return Dictionaries.getCarrierNameByCode(checkInFlight.getUnit().getCarrier());
            });

            return _.uniq(carriers).join(', ');
        };

        this.saveForm = function(form, paxes) {
            var payload = {
                paxes: {}
            };

            if(form.$invalid) {
                return false;
            }

            ctrl.savingData = true;

            angular.forEach(paxes, function(pax) {
                payload.paxes[pax.travellerId] = pax.srvObj();
                pax.savingData = true;
            });

            CheckInService
                .saveInformation(this.hash, payload)
                .then(function(response) {
                    ctrl.isSaved.success = true;
                    ctrl.isSaved.response = response;
                }, function(failure) {
                    // Set backend errors
                    console.log('error');
                })
                .finally(function() {
                    // Set form saving state to false
                    ctrl.savingData = false;
                    angular.forEach(paxes, function(pax) {
                        pax.savingData = false;
                    });
                });
        };

        /**
         * Checks to see if check-in is for special airlines (W6 and FR).
         *
         * @returns {Boolean}
         */
        this.hasSpecialCarriers = function() {
            var specialCarrierFind = _.find(ctrl.checkinInfo.getAllOpts(), function(checkinFlight) {
                return ['W6', 'FR'].indexOf(checkinFlight.getUnit().carrier) !== -1;
            });

            return specialCarrierFind !== undefined;
        };

        /**
         * Check if checkin form could be displayed
         *
         * @returns {boolean}
         */
        this.isFormEnabled = function () {
            return !ctrl.isLoading && !ctrl.isSaved.success && !ctrl.checkinInfo.isFormDisabled && !ctrl.checkinInfo.isDataAlreadyCollected && !ctrl.isError;
        };

        $rootScope.$on('userLogged', function () {
            ctrl.loadPresets();
        });
    };

    IthCheckinInfoController.$inject = [
        'CHECKIN_NOTIFICATIONS',
        'CheckInService',
        'OverflowSmoothScroll',
        'CheckinFlightInfo',
        'Dictionaries',
        'UserServiceV2',
        '$rootScope',
        'Tools',
        'CheckinFormLogic',
        'AuthValuesConverter'
    ];

    angular
        .module('ITH.Checkin')
        .controller('CheckinInfoController', IthCheckinInfoController);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/checkin/modals/ith-checkin-mobile-modal.controller.js
(function(angular) {
/**
     * @name        IthCheckinMobileModalController
     * @description Handles data inside the check-in modal on mobile.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinMobileModalController = function ($scope, hash) {
        /**
         * Flight hash.
         *
         * @type {String}
         */
        $scope.hash = hash;
    };

    IthCheckinMobileModalController.$inject = [
        '$scope',
        'hash'
    ];

    angular
        .module('ITH.Checkin')
        .controller('CheckinMobileModalCtrl', IthCheckinMobileModalController);
	
}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/modals/ith-checkin-mobile-pax-modal.controller.js
(function(angular) {
/**
     * @name        IthCheckinMobilePaxModalController
     * @description Handles data inside the check-in pax modal on mobile.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinMobilePaxModalController = function ($scope, paxData, allPaxes, hash, CheckinFormLogic) {
        /**
         * Pax data.
         *
         * @type {CheckinPax}
         */
        $scope.paxData = paxData;

        /**
         * All check-in paxes in this flight.
         *
         * @type {CheckinPax[]}
         */
        $scope.allPaxes = allPaxes;

        $scope.hash = hash;

        /**
         * Reference to check-in form logic.
         *
         * @type {CheckinFormLogic}
         */
        $scope.checkinFormLogic = CheckinFormLogic;

        /**
         * Saves form data and shows text information.
         *
         * @param {ngForm} ngForm
         */
        $scope.save = function (ngForm) {
            CheckinFormLogic
                .savePaxData(ngForm, $scope.allPaxes, $scope.paxData, $scope.hash)
                .then(function () {
                    // Success
                    $scope.$close();
                }, function (failure) {
                    CheckinFormLogic.setBackendErrors(allPaxes, failure);
                });
        };
    };

    IthCheckinMobilePaxModalController.$inject = [
        '$scope',
        'paxData',
        'allPaxes',
        'hash',
        'CheckinFormLogic'
    ];

    angular
        .module('ITH.Checkin')
        .controller('CheckinPaxMobileModalCtrl', IthCheckinMobilePaxModalController);
	
}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/pax/checkin-pax.factory.js
(function (angular, moment, underscore) {
/**
     * @name        CheckinPaxFactory
     * @description Represents model for checkin paxes.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CheckinPaxFactory = function (Pax, CHECKIN_DOCUMENT_TYPES) {
        /**
         * Checkin pax model.
         *
         * @constructor
         *
         * @param {Object}  paxData
         * @param {Number}  travellerId
         */
        var CheckinPax = function (paxData, travellerId) {
            /**
             * Pax object reference.
             *
             * @type {Pax}
             */
            this.pax = new Pax();
            this.pax.srvSet(paxData);

            /**
             * Pax traveller ID
             *
             * @type {Number}
             */
            this.travellerId = travellerId;

            /**
             * State variable for showing pax information.
             *
             * @type {Boolean}
             */
            this.showInfo = false;

            /**
             * State variable for showing form instead of information.
             *
             * @type {Boolean}
             */
            this.editMode = false;

            /**
             * State variable for for showing loading information while saving.
             *
             * @type {Boolean}
             */
            this.savingData = false;
        };

        CheckinPax.prototype = {
            /**
             * Returns the pax object.
             *
             * @returns {Pax}
             */
            getPax: function () {
                return this.pax;
            },

            /**
             * Prepares data to be sent to backend.
             *
             * @returns {Object}
             */
            srvObj: function () {
                return this.getPax().srvObj();
            }
        };

        return CheckinPax;
    };

    CheckinPaxFactory.$inject = [
        'bok.Pax',
        'CHECKIN_DOCUMENT_TYPES',
    ];

    angular
        .module('ITH.Checkin')
        .factory('CheckinPax', CheckinPaxFactory);

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/checkin/pax/ith-checkin-pax.component.js
(function(angular) {
/**
     * @name        IthCheckinPaxComponent
     * @description Displays a passenger in a check-in flight.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinPaxComponent = {
        templateUrl: '/tpl/show/jsShared/templates/user/components/ith-checkin-pax',
        controller: 'IthCheckinPax',
        bindings: {
            /**
             * Person object.
             *
             * @type {CheckinPax}
             */
            paxData: '=',

            /**
             * All paxes in this check-in flight.
             *
             * @type {CheckinPax[]}
             */
            allPaxes: '=',

            /**
             * Last travelling date.
             *
             * @type {String}
             */
            ltd: '<',

            /**
             * Flight id / hash.
             *
             * @type {String}
             */
            hash: '<',

            /**
             * Ability for user to modify pax information.
             *
             *  @type {Boolean}
             */
            isEditable: '<',
            form: '=',
            buddies: '=',
            countries: '=',
        }
    };

    angular
        .module('ITH.Checkin')
        .component('ithCheckinPax', IthCheckinPaxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/pax/ith-checkin-pax.controller.js
(function(angular) {
/**
     * @name        IthCheckinPaxController
     * @description Handles data inside the check-in pax component.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinPaxController = function (AppConfig, Tools, CheckinFormLogic) {
        /**
         * Reference to tools service.
         *
         * @type {Tools}
         */
        this.tools = Tools;

        /**
         * Mock backend errors data for htmls.
         *
         * @type {Object}
         */
        this.backendErrors = {

        };

        /**
         * Checkin form logic service
         *
         * @type {CheckinFormLogic}
         */
        this.checkinFormLogic = CheckinFormLogic;

        /**
         * OnInit hook
         */
        this.$onInit = function () {
            // Assign correct countries to person's document(s)
            var person = this.paxData.getPax().getPerson();
            var countries = this.countries;

            this.paxData.editMode = true;
            this.paxData.showInfo = true;

            // this.form.$setSubmitted();

            CheckinFormLogic.setPaxCountryCodes(person, countries);
        };

        /**
         * Toggles on and off the pax information box.
         */
        this.toggleInfoBox = function () {
            this.paxData.showInfo = !this.paxData.showInfo;
        };

        /**
         * Shows edit form instead of text information.
         */
        this.edit = function () {
            if (AppConfig.isPhone()) {
                CheckinFormLogic.openCheckinModal(this.paxData, this.allPaxes, this.hash);
            } else {
                // Enter edit mode
                this.paxData.editMode = true;
            }
        };

        /**
         * Saves form data and shows text information.
         *
         * @param {ngForm} ngForm
         */
        this.save = function (ngForm, ltd) {
            if (ngForm.$invalid) {
                return;
            }

            var ctrl = this;

            CheckinFormLogic
                .savePaxData(ngForm, this.allPaxes, this.paxData, this.hash, ltd)
                .then(null, function (failure) {
                    CheckinFormLogic.setBackendErrors(ctrl.allPaxes, failure);
                });
        };

        this.isPaxValid = function () {
            var self = this;
            var isValid = true;

            Object.keys(this.form).forEach(function (key) {
                if (key.includes(self.paxData.travellerId) && self.form[key].$invalid) {
                    isValid = false;
                }
            });

            return isValid;
        };
    };

    IthCheckinPaxController.$inject = [
        'appConfig',
        'Tools',
        'CheckinFormLogic'
    ];

    angular
        .module('ITH.Checkin')
        .controller('IthCheckinPax', IthCheckinPaxController);

}(angular));

;

// Source: ../shared/public_html/assets/js/checkin/person/ith-checkin-person-edit.component.js
(function (angular) {
/**
     * @name        IthCheckinPersonEditComponent
     * @description Displays check-in edit personal information form for a passenger
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinPersonEditComponent = {
        templateUrl: '/tpl/show/jsShared/templates/user/directives/editCheckinPersonForm',
        controller: 'CheckinPersonEditController',
        bindings: {
            form: '=',
            countries: '=',
            errors: '<',
            checkinPerson: '=',
            ltd: '<?',
            buddies: '='
        }
    };

    angular
        .module('ITH.Checkin')
        .component('ithCheckinPersonEdit', IthCheckinPersonEditComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/checkin/person/ith-checkin-person-edit.controller.js
(function (angular, moment) {
/**
     * @name        IthCheckinPersonEditController
     * @description Handles checkin personal data to be saved to reservation.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheckinPersonEditController = function (CHECKIN_DOCUMENT_TYPES, $translate, Tools) {
        /**
         * Self reference.
         *
         * @type {IthCheckinPersonEditController}
         */
        var self = this;

        /**
         * Reference to tools service.
         *
         * @type {Tools}
         */
        this.tools = Tools;

        /**
         *
         *
         * @type
         */
        this.seatPreference = false;

        /**
         *
         *
         * @type
         */
        this.sectionPreference = false;

        /**
         * Reference to check-in document types constant.
         *
         * @type {Object}
         */
        this.CHECKIN_DOCUMENT_TYPES = CHECKIN_DOCUMENT_TYPES;

        /**
         * Returns document number placeholder according to document type and
         * document issue country.
         *
         * @returns {String}
         */
        this.getDocumentPlaceholder = function () {
            var fallbackPlaceholderLang = isGovId() ? 'LANGM_JS_GOV_ID_NUMBER_PLACEHOLDER' : 'LANGM_JS_PASSPORT_NUMBER_HELP';
            var docTypePart = isGovId() ? 'GOV_ID' : 'PASSPORT';
            var countryPart = self.checkinPerson.getPax().getPerson().getIdCard().getIssuingCountry();
            var issueCountryPlaceholderLang = 'LANGM_JS_' + docTypePart + '_' + countryPart + '_PLACEHOLDER';
            var translation = $translate.instant(issueCountryPlaceholderLang);

            // Return translated nationality placeholder or fallback
            return(translation != issueCountryPlaceholderLang) ? translation : $translate.instant(fallbackPlaceholderLang);
        };

        this.seatPreferenceHandler = function(event) {
            self.checkinPerson.getPax().getPreferences().seatPreference = event.detail;
        };

        this.resetSeatPreference = function() {
            self.checkinPerson.getPax().getPreferences().seatPreference = null;
        };

        this.setDefaultSeatPreference = function() {
            self.checkinPerson.getPax().getPreferences().seatPreference = 'window';
        };

        this.sectionPreferenceHandler = function(event) {
            self.checkinPerson.getPax().getPreferences().sectionPreference = event.detail;
        };

        this.resetSectionPreference = function() {
            self.checkinPerson.getPax().getPreferences().sectionPreference = null;
        };

        this.setDefaultSectionPreference = function() {
            self.checkinPerson.getPax().getPreferences().sectionPreference = 'front';
        };

        this.$onInit = function() {
            if(self.checkinPerson.pax.preferences.sectionPreference){
                this.sectionPreference = true;
            }

            if(self.checkinPerson.pax.preferences.seatPreference){
                this.seatPreference = true;
            }
        };

        /**
         * Checks if the checkin person's document type is government id
         *
         * @returns {boolean}
         */
        function isGovId() {
            return self.checkinPerson.getPax().getPerson().getIdCard().docType === CHECKIN_DOCUMENT_TYPES.GOV_ID.id;
        }

        this.getTodayDate = function () {
            return moment().format('YYYY-MM-DD');
        };

        this.getLangBasedDocumentType = function (govIdLang, passportLang) {
            return isGovId() ? govIdLang : passportLang;
        };

        this.updatePax = function(buddyId) {
            var buddy = this.buddies.find(function(buddy) {
                if(buddy.id === buddyId)
                    return true;
            });

            if (!buddy) {
                return;
            }

            this.checkinPerson.docType = CHECKIN_DOCUMENT_TYPES.GOV_ID.id;

            var buddyData = buddy.srvObj();

            // Check-in form should not change name
            delete buddyData.first_name;
            delete buddyData.last_name;

            this.checkinPerson.pax.getPerson().srvSet(buddyData);
        };
    };

    IthCheckinPersonEditController.$inject = [
        'CHECKIN_DOCUMENT_TYPES',
        '$translate',
        'Tools'
    ];

    angular
        .module('ITH.Checkin')
        .controller('CheckinPersonEditController', IthCheckinPersonEditController);

}(angular, moment));

;

// Source: ../shared/public_html/assets/js/checkin/standalone-page/checkin-standalone.controller.js
(function(angular) {
/**
     * @name        CheckinStandaloneCtrl
     * @description Handles data inside the check-in standalone page.
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var CheckinStandaloneCtrl = function (StateParams) {
        this.hash = StateParams.checkId;
    };

    CheckinStandaloneCtrl.$inject = [
        '$stateParams'
    ];

    angular
        .module('ITH.Checkin')
        .controller('CheckinStandaloneCtrl', CheckinStandaloneCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/components/city-helper-location-display.component.js
(function (angular) {

    var template = '\
        <div class="ch-location">\
            <strong class="ch-location__title" ng-if="$ctrl.isTitle()" translate>{{ $ctrl.result.lang }}</strong>\
            <strong class="ch-location__title" ng-if="$ctrl.isNothing()" translate>LANGM_JS_CT_NOT_FOUND</strong>\
            <div \
                class="ch-location__item" \
                id="{{ $ctrl.locId }}" \
                ng-if="$ctrl.isResult()" \
                ng-class="$ctrl.getClassMap()"\
                ng-click="$ctrl.click()">\
                <div class="ch-location__left-side">\
                    <svg-icon \
                        ng-if="!$ctrl.result.isCountry()" \
                        id="{{ $ctrl.getSvgIcon() }}" \
                        class="ch-location__left-icon size--20"\
                    ></svg-icon>\
                    <img\
                        ng-if="$ctrl.result.isCountry()" \
                        ng-src="/assets/img/ui/icons/svg/countries/{{ $ctrl.result.getCountryCode().toLowerCase() }}.svg"\
                        alt=""\
                        class="ch-location__flag-img"\
                      >\
                    <span class="ch-location__text">\
                        <span>\
                            <span ng-if="$ctrl.result.isCity() || $ctrl.result.isAnyCity()"><strong ng-bind-html="$ctrl.result.cityName"></strong><span ng-if="!$ctrl.result.isAnyCity()">,</span> <span ng-bind-html="$ctrl.result.countryName | typeaheadHighlight:$ctrl.search"></span></span>\
                            <span ng-if="$ctrl.result.isAirport()"><strong ng-bind-html="$ctrl.result.airportName"></strong>, <span ng-bind-html="$ctrl.result.cityName | typeaheadHighlight:$ctrl.search"></span></span>\
                            <span ng-if="$ctrl.result.isCountry()"><strong ng-bind-html="$ctrl.result.countryName | typeaheadHighlight:$ctrl.search"></strong></span>\
                        </span>\
                        <span class="text-muted" ng-if="!$ctrl.result.isCountry() && !$ctrl.result.isAnyCity()">({{ $ctrl.result.isCity() ? $ctrl.result.cityCode : $ctrl.result.airportCode }})</span>\
                        <p \
                            ng-if="$ctrl.result.getDistanceFromCenter()"\
                            class="ch-location__text-distance"\
                        >\
                            <span>{{ $ctrl.result.getDistanceFromCenter() }}</span>\
                            <span> </span>\
                            <span translate>LANGM_JS_DISTANCE_FROM_CITY_CENTER</span>\
                        </p>\
                    </span>\
                </div>\
                <city-helper-location-presence-icon \
                    class="ch-location__presence-icon__wrapper"\
                    ng-if="$ctrl.showIcons" \
                    is-location-present="$ctrl.isLocationPresent()">\
                </city-helper-location-presence-icon>\
            </div>\
        </div>\
    ';

    angular.module('cityHelper').component('cityHelperLocationDisplay', {
        template: template,
        bindings: {
            result: '<',
            search: '<?',
            cth: '<',
            onLocationClick: '&',
            showIcons: '<?',
            direction: '@',
            yourSelection: '<?',
            locId: '<?',
            disableHover: '<?',
            onHover: '&'
        },
        controller: function () {
            this.isTitle = function () {
                return this.result.type === 'title';
            };

            this.isNothing = function () {
                return this.result.type === 'nothing';
            };

            this.isResult = function () {
                return !this.isTitle() && !this.isNothing();
            };

            this.getClassMap = function () {
                return {
                    'ch-location__item--airport': this.isResult() && this.result.isAirport() && !this.yourSelection && !this.result.isRecent,
                    'ch-location__item--disable-hover': this.disableHover
                };
            };

            this.click = function () {
                this.onLocationClick({
                    loc: this.result
                });
            };

            /**
             * @returns {'takeoff' | 'landing' | 'ith-recent-location' | 'location-regular'}
             */
            this.getSvgIcon = function () {
                if (this.yourSelection) {
                    return 'location-regular';
                }

                if (this.isResult() && this.result.isAirport() && !this.result.isRecent) {
                    return this.direction === 'dep' ? 'takeoff' : 'landing';
                }

                return this.result.isRecent ? 'ith-recent-location' : 'location-regular';
            };

            this.isLocationPresent = function () {
                return this.cth.isLocationPresent(this.result);
            };
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/components/city-helper-location-presence-icon.component.js
(function (angular) {

    var template = '\
        <span \
            class="ch-location__presence-icon">\
            <svg-icon ng-if="$ctrl.isLocationPresent" class="remove size--16" id="minus"></svg-icon>\
            <svg-icon ng-if="!$ctrl.isLocationPresent" class="add size--16" id="plus"></svg-icon>\
        </span>\
    ';

    angular.module('cityHelper').component('cityHelperLocationPresenceIcon', {
        template: template,
        bindings: {
            isLocationPresent: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/components/city-helper-no-results.component.js
(function (angular) {

    var template = '\
        <div class="ch-no-results">\
            <img src="/assets/img/ui/icons/svg/no-location.svg">\
            <span translate>LANGM_JS_CT_NOT_FOUND</span>\
        </div>\
    ';

    angular.module('cityHelper').component('cityHelperNoResults', {
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/components/city-helper-your-selection-title.component.js
(function (angular) {

    var template = '\
        <div class="ch-location">\
            <strong class="ch-location__title">\
                <translate>{{ \'LANGM_JS_YOUR_SELECTION\' | translate }}</translate>\
            </strong>\
        </div>\
    ';

    angular.module('cityHelper').component('cityHelperYourSelectionTitle', {
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/components/mobile-city-helper.component.js
(function (angular) {
/**
     * @name        IthMobileCityHelperComponent
     * @description Displays a modal city helper on mobile devices
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthMobileCityHelperComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsFormCityHelperModal',
        controller: [function () {
            this.onFocus = function () {
                this.cth.inputValue = '';
                this.cth.search();
                this.cth.locationHighlight.reset();
            };

            /**
             *
             * @param {*} item
             * @param {*} zone
             */
            this.select = function (item, zone) {
                this.onItemSelect({
                    item: item,
                    flightType: this.cth.getFlightType()
                });
                this.cth.locationHighlight.reset();

                if (zone !== 'icon') {
                    this.onClose(null);
                }
            };

            this.getInputId = function () {
                return 'cityHelperInput-' + this.focusId;
            };

            this.focus = function () {
                document.getElementById(this.getInputId()).focus();
                this.cth.locationHighlight.reset();
            };

            this.keydown = function ($event) {
                if ($event.key === 'Backspace' && $event.target.selectionStart === 0) {
                    if (this.cth.locationHighlight.getHighlightIndex() < this.cth.locations.length) {
                        this.cth.removeLocationByIndex(
                            this.cth.locationHighlight.getHighlightIndex()
                        );
                        this.cth.locationHighlight.reset();
                        return;
                    }

                    this.cth.locationHighlight.move($event, -1);
                }
            };

            // click on already picked location in the "input"
            this.locationClicked = function (location) {
                this.onAddedLocationClick({
                    location: location,
                    flightType: this.cth.flightType
                });
            };
        }],
        bindings: {
            cth: '<',
            isVisible: '<',
            onItemSelect: '&',
            onClose: '&',
            focusId: '@',
            onAddedLocationClick: '&'
        }
    };

    angular
        .module('cityHelper')
        .component('ithMobileCityHelper', IthMobileCityHelperComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/constants/city-helper.constant.js
(function (angular) {

    angular.module('cityHelper').constant('CITY_HELPER', {
        FORMAT_FULL_INFO: 'FULL_INFO',

        TYPE_CITY: 'c',
        TYPE_ANY: '*',
        TYPE_AIRPORT: 'a',
        TYPE_COUNTRY: 'country',

        FLIGHT_TYPE_FROM: 'ORIGIN',
        FLIGHT_TYPE_TO: 'DESTINATION',

        LOCATIONS_ALLOWED_AMOUNT: 3,

        // # css selectors
        DIRECTION_HOLDER_ID_FROM: 'direction-holder-from',
        DIRECTION_INNER_ID_FROM: 'direction-inner-from',
        DIRECTION_INPUT_ID_FROM: 'cityHelperORIGINdepartureField',
        DIRECTION_HOLDER_ID_TO: 'direction-holder-to',
        DIRECTION_INNER_ID_TO: 'direction-inner-to',
        DIRECTION_INPUT_ID_TO: 'cityHelperDESTINATIONreturnField',
        DROPDOWN_RESULT_CLASS: 'ch-location__item'
    });
})(angular);

;

// Source: ../shared/public_html/assets/js/cityHelper/directives/city-helper.directive.js
(function (angular) {
/**
     * @name        cityHelper
     * @description Directive for cityHelperCity and cityHelperHotel.
     */
    function cityHelperDirective($document, $translate) {
        return {
            restrict: 'A',
            require: 'ngModel',
            templateUrl: '/tpl/show/jsShared/templates/base/directives/cityHelper/cityHelper',

            scope: {
                cityHelper: '=',
                onSelect: '&?',
                autoSize: '<',
                id: '@',
                isNotLandingPage: '<?',
                onItemSelect: '&?'
            },

            controller: ['$scope', '$rootScope', '$timeout', '$state', 'CITY_HELPER', 'appConfig', 'CthUtils', function ($scope, $rootScope, $timeout, $state, CITY_HELPER, appConfig, CthUtils) {
                var isLandingPage = !$scope.isNotLandingPage;
                var isFrom = $scope.cityHelper.isOrigin();
                var removeFocusEventListener = null;

                var setDefaultCursorIndex = function () {
                    $scope.status.cursor = isLandingPage ? 0 : -1;
                };

                /**
                 * @returns {number}
                 */
                var getCursorIndex = function () {
                    return $scope.status.cursor;
                };

                var increaseCursorIndex = function () {
                    $scope.status.cursor++;
                };

                var decreaseCursorIndex = function () {
                    $scope.status.cursor--;
                };

                /**
                 * @param {Number} index
                 */
                var setCursorIndex = function (index) {
                    $scope.status.cursor = index;
                };

                var lockEnterKey = function () {
                    $scope.status.isEnterKeyLocked = true;
                };

                /**
                 * @returns {Boolean}
                 */
                var isEnterKeyLocked = function () {
                    return $scope.status.isEnterKeyLocked === true;
                };

                /**
                 *
                 * @param {KeyboardEvent} $event
                 * @param {-1|1} direction
                 */
                var onLeftRightKeys = function ($event, direction) {
                    $scope.cityHelper.locationHighlight.move($event, direction);

                    if ($scope.cityHelper.locationHighlight.isOnInput()) {
                        CthUtils.scrollToInput(isFrom);
                    } else {
                        CthUtils.scrollToHighlight(isFrom, $scope.cityHelper.locationHighlight.highlightIndex);
                    }
                };

                $scope.status = {
                    isOpen: false,
                    isEnterKeyLocked: false,
                    cursor: isLandingPage ? 0 : -1,
                    autosizeModelElement: null,
                    inputPlaceholder: ''
                };

                /**
                 *
                 */
                $scope.getInputId = function () {
                    return 'cityHelper' + $scope.cityHelper.getFlightType() + $scope.id;
                };

                /**
                 *
                 */
                $scope.hideDropdown = function () {
                    $scope.status.isOpen = false;
                };

                /**
                 *
                 */
                $scope.showDropdown = function () {
                    $scope.status.isOpen = true;
                };

                /**
                 *
                 */
                $scope.isDropdownVisible = function () {
                    return $scope.status.isOpen && ($scope.cityHelper.results.length > 0 || $scope.cityHelper.inputValue.length >= 2);
                };

                /**
                 *
                 */
                $scope.setCityHelperLocation = function (item) {
                    if (item === $scope.cityHelper.locations[0]) {
                        return;
                    }

                    $scope.cityHelper.setData(item);
                    $scope.onBlur();

                    if ($scope.onSelect) {
                        $scope.onSelect();
                    }
                };

                /**
                 *
                 */
                $scope.onFocus = function () {
                    $rootScope.$broadcast('chFocus', $scope.cityHelper.isOrigin());
                    $scope.cityHelper.locationHighlight.reset();

                    if (isLandingPage) {
                        setDefaultCursorIndex();
                        $scope.showDropdown();
                        $scope.cityHelper.emptyInputValue();
                        $scope.cityHelper.search();
                        return;
                    }

                    setDefaultCursorIndex();
                    $scope.cityHelper.show();
                    $scope.cityHelper.emptyInputValue();
                    $scope.cityHelper.search();

                    if ($state.current.name === 'homepage') {
                        window.scrollTo({
                            top: 100,
                            behavior: 'smooth'
                        });
                    }
                };

                /**
                 *
                 */
                $scope.onBlur = function () {
                    $timeout(function () {
                        $scope.updateInputValue();
                        $scope.hideDropdown();
                        $scope.cityHelper.locationHighlight.reset();
                    }, 10);
                };

                /**
                 *
                 */
                $scope.onClick = function () {
                    $scope.cityHelper.emptyInputValue();
                    $scope.cityHelper.locationHighlight.reset();

                    if (!isLandingPage) {
                        $scope.cityHelper.search();
                        setDefaultCursorIndex();
                    }
                };

                /**
                 *
                 */
                $scope.updateInputValue = function () {
                    $scope.cityHelper.updateInputValue();
                };

                /**
                 *
                 */
                $scope.getStyleMap = function () {
                    if ($scope.autoSize) {
                        if ($scope.status.autosizeModelElement === null) {
                            $scope.status.autosizeModelElement = $document[0].querySelector('#' + $scope.getInputId() + '-autosize-model');
                        }

                        if ($scope.status.autosizeModelElement === null) {
                            return {};
                        }

                        return {
                            width: $scope.status.autosizeModelElement.clientWidth + 'px'
                        };
                    }

                    return {};
                };

                /**
                 *
                 */
                $scope.onChange = function () {
                    setDefaultCursorIndex();
                    $scope.cityHelper.search();
                    $scope.cityHelper.locationHighlight.reset();
                };

                /**
                 *
                 */
                $scope.onKeyDown = function ($event) {
                    if (!$scope.cityHelper.results.length) {
                        return;
                    }

                    var min = $scope.cityHelper.results[0].type === 'title' ? 1 : 0;

                    var max = $scope.cityHelper.results.length - 1;

                    if ($event.key && $event.key === 'ArrowDown') {
                        $event.preventDefault();

                        if ($scope.status.cursor >= max) {
                            setCursorIndex(max);
                        } else {
                            increaseCursorIndex();
                        }

                        if ($scope.getSelectedEntry().type === 'title') {
                            increaseCursorIndex();
                        }
                    }

                    if ($event.key && $event.key === 'ArrowUp') {
                        $event.preventDefault();

                        if ($scope.status.cursor <= min) {
                            setCursorIndex(min);
                        } else {
                            decreaseCursorIndex();
                        }

                        if ($scope.getSelectedEntry().type === 'title') {
                            decreaseCursorIndex();
                        }
                    }

                    if ($event.key && $event.key === 'Enter') {
                        $event.preventDefault();

                        $scope.setCityHelperLocation($scope.cityHelper.results[$scope.status.cursor]);

                        $document[0].querySelector('#' + $scope.getInputId()).blur();
                    }

                    if ($event.key && $event.key === 'Escape') {
                        $event.preventDefault();
                        $document[0].querySelector('#' + $scope.getInputId()).blur();
                    }
                };

                /**
                 *
                 */
                $scope.getSelectedEntry = function () {
                    return $scope.cityHelper.results[$scope.status.cursor];
                };

                /**
                 *
                 */
                $scope.isActive = function (index) {
                    return $scope.status.cursor === index;
                };

                /**
                 * @param {KeyboardEvent} $event
                 */
                $scope.onKeyDownMultiCity = function ($event) {
                    var cth = $scope.cityHelper;
                    var dataElements = CthUtils.getDataElements(cth);
                    var maxIndex = CthUtils.getMaxIndex(dataElements);

                    if ($event.key === 'Backspace' && $event.target.selectionStart === 0) {
                        if ($scope.cityHelper.locationHighlight.getHighlightIndex() < $scope.cityHelper.locations.length) {
                            cth.removeLocationByIndex(
                                $scope.cityHelper.locationHighlight.getHighlightIndex()
                            );
                            $scope.cityHelper.locationHighlight.reset();
                            return;
                        }

                        $scope.cityHelper.locationHighlight.move($event, -1);
                    }

                    if ($event.code === 'Escape') {
                        $event.preventDefault();
                        $document[0].querySelector('#' + $scope.getInputId()).blur();
                        $scope.collapseDropdown();
                    }

                    if ($event.code === 'ArrowLeft') {
                        onLeftRightKeys($event, -1);
                    }

                    if ($event.code === 'ArrowRight') {
                        onLeftRightKeys($event, 1);
                    }

                    if (CthUtils.isNoResults(cth)) {
                        return;
                    }

                    if ($event.code === 'ArrowDown') {
                        $event.preventDefault();

                        if (getCursorIndex() >= maxIndex) {
                            setCursorIndex(0);
                        } else {
                            increaseCursorIndex();
                        }
                        tt();
                    }

                    if ($event.code === 'ArrowUp') {
                        $event.preventDefault();

                        if (getCursorIndex() <= 0) {
                            setCursorIndex(maxIndex);
                        } else {
                            decreaseCursorIndex();
                        }
                        tt();
                    }

                    if ($event.code === 'Enter' && !isEnterKeyLocked() && getCursorIndex() !== -1) {
                        var isItemRemoved = cth.isLocationPresent(dataElements[getCursorIndex()]);
                        var currentIndex = getCursorIndex();


                        $event.preventDefault();
                        lockEnterKey();

                        if (!CthUtils.isSearched(cth) && CthUtils.isLocDefaultResult(currentIndex, cth)) {
                            isItemRemoved
                                ? decreaseCursorIndex()
                                : increaseCursorIndex();
                        }

                        $scope.locationClickHandler(dataElements[currentIndex]);

                        CthUtils.removeActiveClasses(isFrom);
                        CthUtils.addActiveClass(isFrom, getCursorIndex(), $scope);
                    }
                };

                /**
                 * @param {CityHelperLocation} item
                 */
                $scope.locationClickHandler = function (item) {
                    $scope.onItemSelect({
                        item: item,
                        flightType: $scope.cityHelper.getFlightType()
                    });
                    CthUtils.scrollToInput(isFrom);
                    CthUtils.focusInput(isFrom);

                    var cth = $scope.cityHelper;
                    var dataElements = CthUtils.getDataElements(cth);
                    var currentIndex = getCursorIndex();

                    var preventCursorReset = !CthUtils.isSearched(cth)
                        || (dataElements[currentIndex].isAirport() && !cth.isAirportTheOnlyOne());

                    if (!preventCursorReset) {
                        setDefaultCursorIndex();
                    }

                    $scope.cityHelper.locationHighlight.reset();
                };

                /**
                 * @param {MouseEvent} $event
                 * @param {String} id
                 */
                $scope.mouseEnterHandler = function ($event, id) {
                    var domElements = Array.from(CthUtils.getDomElements(isFrom));

                    if (!CthUtils.isLocationItem($event) || isEnterKeyLocked()) {
                        return;
                    }

                    setCursorIndex(
                        domElements.findIndex(function (el) {
                            return el.id === id;
                        })
                    );

                    tt();
                };

                /**
                 * @param {String} prefix
                 * @param {Number} index
                 * @return {String}
                 */
                $scope.generateLocationId = function (prefix, index) {
                    return prefix + index;
                };

                /**
                 * @param {MouseEvent} [$event]
                 */
                $scope.collapseDropdown = function ($event) {
                    if (appConfig.isMobile() || isLandingPage) {
                        return;
                    }

                    $event && $event.stopPropagation();
                    $scope.cityHelper.hide();
                    $scope.cityHelper.emptyInputValue();
                    setDefaultCursorIndex();
                    CthUtils.removeActiveClasses(isFrom);
                };

                /**
                 * @param {MouseEvent} $event
                 */
                $scope.dropdownHandler = function ($event) {
                    var parentSelector = isFrom ? ('#' + CITY_HELPER.DIRECTION_HOLDER_ID_FROM) : ('#' + CITY_HELPER.DIRECTION_HOLDER_ID_TO);

                    $scope.$evalAsync(function () {
                        // if the clicked element is NOT inside flight direction section of search form
                        if (!$event.target.closest(parentSelector)) {
                            $scope.collapseDropdown();
                        }
                    });
                };

                var tt = function () {
                    CthUtils.removeActiveClasses(isFrom);
                    CthUtils.addActiveClass(isFrom, getCursorIndex());
                };

                /**
                 *
                 */
                this.$onInit = function () {
                    if (!$scope.autoSize) {
                        $scope.autoSize = false;
                    }

                    $scope.status.inputPlaceholder = $translate.instant(isFrom ? 'LANGM_JS_FLIGHT_SEARCH_FROM_PLACEHOLDER' : 'LANGM_JS_FLIGHT_SEARCH_TO_PLACEHOLDER');
                    $scope.cityHelper.onPopularChangeCallbacks.push(tt);
                    document.addEventListener('mousedown', $scope.dropdownHandler);

                    removeFocusEventListener = $rootScope.$on('chFocus', function (event, isOrigin) {
                        if ($scope.cityHelper.isOrigin() !== isOrigin) {
                            $scope.cityHelper.hide();
                        }
                    });
                };

                this.$onDestroy = function () {
                    document.removeEventListener('mousedown', $scope.dropdownHandler);
                    removeFocusEventListener();
                };
            }]
        };
    }

    cityHelperDirective.$inject = ['$document', '$translate'];

    angular.module('cityHelper').directive('cityHelper', cityHelperDirective);

})(angular);
;

// Source: ../shared/public_html/assets/js/cityHelper/models/city-helper-handler.model.js
angular.module('cityHelper')

    /**
     * @name cityHelper.Flight
     *
     * @description city
     */
    .factory('CityHelperHandler', [
        '$translate',
        'CITY_HELPER',
        'LocationAutocompleteApi',
        'LocationAutocompleteService',
        'LocationHistory',
        'LocationTranslator',
        'CityHelperLocation',
        '$timeout',
        'LocationHighlight',
        'appConfig',
        function FlightFactory(
            $translate,
            CITY_HELPER,
            LocationAutocompleteApi,
            LocationAutocompleteService,
            LocationHistory,
            LocationTranslator,
            CityHelperLocation,
            $timeout,
            LocationHighlight,
            AppConfig
        ) {
            var Flight = function (locations, flightType, inputValueFormatter) {
                this.locations = locations;
                this.inputValue = '';
                this.flightType = flightType;
                this.inputValueFormatter = inputValueFormatter;
                this.allowCountries = false;
                this.isSearching = false;
                this.isShown = false;
                this.locationHighlight = new LocationHighlight(this);
                this.preloadedPopular = false;

                /**
                 * @type {Flight}
                 */
                this.opposing = null;

                this.predefined = [];
                this.popular = [];
                this.results = [];

                this.onPopularChangeCallbacks = [];
            };

            Flight.prototype.setOpposing = function (opposing) {
                this.opposing = opposing;
                var self = this;

                $timeout(function () {
                    if (LocationTranslator.isPopulated) {
                        self.init();
                    } else {
                        LocationTranslator.deferred.promise.then(function () {
                            self.init();
                        });
                    }
                }, 20);
            };

            Flight.prototype.setAllowCountries = function () {
                this.allowCountries = true;
                return this;
            };

            Flight.prototype.setPredefined = function (predefinedArray) {
                this.predefined = predefinedArray;
                return this;
            };

            Flight.prototype.init = function () {
                if (this.isOrigin()) {
                    this.updatePopular();
                }

                this.translateLocations();
            };

            Flight.prototype.translateLocations = function () {
                this.locations = this.locations.map(function (location) {
                    return LocationAutocompleteService.translateLocation(location);
                });

                var self = this;

                var codes = this.locations
                    .filter(function (location) {
                        return !location.isTranslated();
                    })
                    .map(function (location) {
                        return location.getCodeByType();
                    });

                if (!codes.length) {
                    if (self.inputValueFormatter) {
                        self.updateInputValue();
                    }
                    return;
                }

                LocationAutocompleteApi
                    .codesToLocation(codes.join(','))
                    .then(function (response) {
                        if (response.data.response) {
                            self.locations.forEach(function (location) {
                                response.data.response.forEach(function (detailedLocation) {
                                    if (location.isCity() && location.cityCode === detailedLocation.cityCode) {
                                        location.countryCode = detailedLocation.countryCode;
                                    }

                                    if (location.isAirport() && location.airportCode === detailedLocation.airportCode) {
                                        location.cityCode = detailedLocation.cityCode;
                                        location.countryCode = detailedLocation.countryCode;
                                    }
                                });
                            });
                        }

                        self.locations.map(function (loc) {
                            return LocationAutocompleteService.translateLocation(loc);
                        });

                        if (self.inputValueFormatter) {
                            self.updateInputValue();
                        }
                    });
            };

            Flight.prototype.populateDefaults = function () {
                this.results = [];

                if (this.predefined.length) {
                    this.results = _.union(this.results, this.predefined);
                }

                if (this.getLastSearched() && this.getLastSearched().length) {
                    this.results = _.union(this.results, [{
                        type: 'title',
                        lang: this.isOrigin() ? 'LANGM_JS_CT_LAST_SEARCH_FROM' : 'LANGM_JS_CT_LAST_SEARCH_TO'
                    }], this.getLastSearched());
                }

                if (this.popular && this.popular.length) {
                    this.results = _.union(this.results, [{
                        type: 'title',
                        lang: this.isOrigin() ? 'LANGM_JS_CT_POPULAR_ORIGIN' : 'LANGM_JS_CT_POPULAR_DESTINATION'
                    }], this.popular);
                }
            };

            Flight.prototype.updateInputValue = function () {
                this.inputValue = this.inputValueFormatter(this.locations);
            };

            Flight.prototype.emptyInputValue = function () {
                this.inputValue = '';
            };

            Flight.prototype.getFlightType = function () {
                return this.flightType;
            };

            Flight.prototype.isOrigin = function () {
                return this.getFlightType() === CITY_HELPER.FLIGHT_TYPE_FROM;
            };

            Flight.prototype.populateWholeData = function (query, locationIndex) {
                var self = this;

                this
                    .search(query)
                    .then(function (success) {
                        self.locations[locationIndex] = _.find(success, function (loc) {
                            return (loc.getCodeByType() === self.locations[locationIndex].getCodeByType() && loc.type === self.locations[locationIndex].type);
                        });
                    });
            };

            /**
             * Returns last searched departure / return cities
             *
             * @returns {CityHelperLocation[]}
             */
            Flight.prototype.getLastSearched = function () {
                var locations = LocationHistory.get(this.getFlightType()) || [];
                var output = [];

                locations.forEach(function (location) {
                    var loc = new CityHelperLocation(location);
                    loc.isRecent = true;

                    if (loc.isCountry() && !AppConfig.getNextGenSearchAbTest()) {
                        return;
                    }

                    output.push(loc);
                });

                return output;
            };

            Flight.prototype.getSelectedOrigins = function () {
                var self = this;

                return LocationAutocompleteService.convertLocationsToStringParam(
                    self.isOrigin() ? this.locations : this.opposing.locations
                );
            };

            Flight.prototype.getSelectedDestinations = function () {
                var self = this;

                return LocationAutocompleteService.convertLocationsToStringParam(
                    self.isOrigin() ? this.opposing.locations : this.locations
                );
            };

            Flight.prototype.updatePopular = function () {
                var self = this;

                var request = this.isOrigin()
                    ? LocationAutocompleteApi.getPopularOrigins(this.getSelectedOrigins(), this.getSelectedDestinations())
                    : LocationAutocompleteApi.getPopularDestinations(this.getSelectedOrigins(), this.getSelectedDestinations());

                request.then(function (success) {
                    self.popular = success.filter(function (location) {
                        return location.isCity() || self.allowCountries && location.isCountry();
                    });

                    if (self.isOrigin() && self.locations.length === 0 && !self.preloadedPopular) {
                        self.locations.push(new CityHelperLocation(self.popular[0]));
                        self.locationHighlight.reset();
                    }

                    if (self.isOrigin() && !self.opposing.preloadedPopular) {
                        self.opposing.updatePopular();
                    }

                    self.populateDefaults();
                    $timeout(function () {
                        self.onPopularChangeCallbacks.forEach(function (callback) {
                            callback();
                        });
                    }, 10);

                    self.preloadedPopular = true;
                });
            };

            Flight.prototype.search = function (query) {
                if (!query) {
                    query = this.inputValue;
                }

                if (query.length < 2) {
                    this.populateDefaults();
                    return;
                }

                var self = this;
                this.isSearching = true;

                return LocationAutocompleteApi
                    .search(query, this.getFlightType(), this.getSelectedOrigins(), this.getSelectedDestinations())
                    .then(function (success) {
                        self.results = _.filter(success, function (item) {
                            if (self.allowCountries) {
                                return item;
                            }

                            return !item.isCountry();
                        });

                        return success;
                    })
                    .finally(function () {
                        self.isSearching = false;
                    });
            };

            Flight.prototype.searchPreferredAirport = function () {
                var query = this.inputValue;
                var self = this;

                if (query.length < 2) {
                    self.results = [];

                    return;
                }

                this.isSearching = true;

                return LocationAutocompleteApi
                    .search(query, this.getFlightType())
                    .then(function (response) {
                        self.results = _.filter(response, function (item) {
                            return item.isAirport();
                        });

                        return response;
                    })
                    .finally(function () {
                        self.isSearching = false;
                    });
            };

            Flight.prototype.isLocationPresent = function (location) {
                return this.locations.some(function (existingLocation) {
                    if (location.isAirport()) {
                        return location.airportCode === existingLocation.airportCode;
                    }

                    if (location.isCity()) {
                        return location.cityCode === existingLocation.cityCode && !existingLocation.airportCode;
                    }

                    if (location.isCountry()) {
                        return location.countryCode === existingLocation.countryCode && !existingLocation.airportCode && !existingLocation.cityCode;
                    }

                    return false;

                });
            };

            Flight.prototype.removeLocation = function (location) {
                this.locations = this.locations.filter(function (existingLocation) {
                    if (location.isAirport()) {
                        return location.airportCode !== existingLocation.airportCode;
                    }

                    if (location.isCity()) {
                        return existingLocation.airportCode || (location.cityCode !== existingLocation.cityCode);
                    }

                    if (location.isCountry()) {
                        return existingLocation.cityCode || existingLocation.airportCode || (location.countryCode !== existingLocation.countryCode);
                    }

                    return true;
                });

                this.onChange();
            };

            Flight.prototype.removeLastLocation = function () {
                this.locations.pop();
                this.onChange();
            };

            Flight.prototype.removeLocationByIndex = function (index) {
                this.locations.splice(index, 1);
                this.onChange();
            };

            Flight.prototype.addLocation = function (location) {
                this.locations.push(location);
                this.onChange();
            };

            Flight.prototype.buildCitiesQueryString = function () {
                return this.locations
                    .filter(function (location) {
                        return location.isCity();
                    })
                    .map(function (city) {
                        return city.getCityCode();
                    })
                    .join(',');
            };

            Flight.prototype.buildAirportsQueryString = function () {
                return this.locations
                    .filter(function (location) {
                        return location.isAirport();
                    })
                    .map(function (airport) {
                        return airport.getAirportCode();
                    })
                    .join(',');
            };

            Flight.prototype.buildCountriesQueryString = function () {
                return this.locations
                    .filter(function (location) {
                        return location.isCountry();
                    })
                    .map(function (country) {
                        return country.getCountryCode();
                    })
                    .join(',');
            };

            Flight.prototype.onChange = function () {
                this.updatePopular();
                this.opposing.updatePopular();
            };

            Flight.prototype.setData = function (location) {
                this.locations[0] = location;
                this.translateLocations();
                this.onChange();
            };

            Flight.prototype.show = function () {
                this.isShown = true;
                this.locationHighlight.reset();
            };

            Flight.prototype.hide = function () {
                this.isShown = false;
                this.locationHighlight.reset();
            };

            Flight.prototype.isVisible = function () {
                return this.isShown === true;
            };

            Flight.prototype.getPlaceholder = function () {
                var isExploreMode = AppConfig.getNextGenSearchAbTest();
                var text = isExploreMode
                    ? 'LANGM_JS_FLIGHT_SEARCH_FROM_PLACEHOLDER_EXPLORE_MODE'
                    : 'LANGM_JS_FLIGHT_SEARCH_FROM_PLACEHOLDER';

                if (!this.isOrigin()) {
                    text = isExploreMode
                        ? 'LANGM_JS_FLIGHT_SEARCH_TO_PLACEHOLDER_EXPLORE_MODE'
                        : 'LANGM_JS_FLIGHT_SEARCH_TO_PLACEHOLDER';
                }

                if (this.locations.length > 0) {
                    text = this.isOrigin()
                        ? isExploreMode ? 'LANGM_JS_FLIGHT_SEARCH_FROM_PLACEHOLDER_MULTIPLE_EXPLORE_MODE' : 'LANGM_JS_FLIGHT_SEARCH_FROM_PLACEHOLDER_MULTIPLE'
                        : isExploreMode ? 'LANGM_JS_FLIGHT_SEARCH_TO_PLACEHOLDER_MULTIPLE_EXPLORE_MODE' : 'LANGM_JS_FLIGHT_SEARCH_TO_PLACEHOLDER_MULTIPLE';
                }

                return $translate.instant(text);
            };

            Flight.prototype.countAirportsInResults = function () {
                return (this.results.filter(function (loc) {
                    return loc.type !== 'title' && loc.isAirport();
                })).length;
            };

            Flight.prototype.isAirportTheOnlyOne = function () {
                return this.countAirportsInResults() === 1;
            };

            Flight.prototype.getLocationCodes = function () {
                return this.locations.map(function (location) {
                    return location.getCodeByType();
                });
            };

            Flight.prototype.constructor = Flight;

            return Flight;
        }]);
;

// Source: ../shared/public_html/assets/js/cityHelper/models/city-helper-location.model.js
(function (angular) {

    var CityHelperLocationFactory = function (CITY_HELPER) {
        var CityHelperLocation = function (data) {
            this.cityCode = data.cityCode || '';
            this.cityName = data.cityName || '';
            this.airportCode = data.airportCode || '';
            this.airportName = data.airportName || '';
            this.countryCode = data.countryCode || '';
            this.countryName = data.countryName || '';
            this.type = data.type || this.getInferredType();
            this.distanceFromCityCenterKm = data.distanceFromCityCenterKm || null;

            return this;
        };

        CityHelperLocation.prototype.getInferredType = function () {
            if (this.airportCode !== '') {
                return CITY_HELPER.TYPE_AIRPORT;
            }

            if (this.cityCode !== '') {
                return CITY_HELPER.TYPE_CITY;
            }

            if (this.countryCode !== '') {
                return CITY_HELPER.TYPE_COUNTRY;
            }

            return CITY_HELPER.TYPE_ANY;
        };

        CityHelperLocation.prototype.getCityCode = function () {
            return this.cityCode;
        };

        CityHelperLocation.prototype.getAirportCode = function () {
            return this.airportCode;
        };

        CityHelperLocation.prototype.getCountryCode = function () {
            return this.countryCode;
        };

        CityHelperLocation.prototype.isCity = function () {
            return this.type === CITY_HELPER.TYPE_CITY;
        };

        CityHelperLocation.prototype.isAirport = function () {
            return this.type === CITY_HELPER.TYPE_AIRPORT;
        };

        CityHelperLocation.prototype.isCountry = function () {
            return this.type === CITY_HELPER.TYPE_COUNTRY;
        };

        CityHelperLocation.prototype.isAnyCity = function () {
            return this.type === CITY_HELPER.TYPE_ANY;
        };

        CityHelperLocation.prototype.isTranslated = function () {
            return (
                (this.isCountry() && this.countryName !== '') ||
                (this.isCity() && this.cityName !== '' && this.countryName !== '') ||
                (this.isAirport() && this.cityName !== '' && this.countryName !== '' && this.airportName !== '') ||
                (this.isAnyCity() && this.cityName !== '')
            );
        };

        CityHelperLocation.prototype.getCodeByType = function () {
            if (this.isAirport()) {
                return this.airportCode;
            }

            if (this.isCity()) {
                return this.cityCode;
            }

            if (this.isCountry()) {
                return this.countryCode;
            }

            return '';
        };

        CityHelperLocation.prototype.setCodeByType = function (code) {
            if (this.isAirport()) {
                this.airportCode = code;
            }

            if (this.isCity()) {
                this.cityCode = code;
            }

            if (this.isCountry()) {
                this.countryCode = code;
            }
        };

        CityHelperLocation.prototype.getDistanceFromCenter = function () {
            return this.distanceFromCityCenterKm;
        };

        CityHelperLocation.prototype.contstructor = CityHelperLocation;

        return CityHelperLocation;
    };

    CityHelperLocationFactory.$inject = ['CITY_HELPER'];

    angular
        .module('cityHelper')
        .factory('CityHelperLocation', CityHelperLocationFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/models/location-highlight.model.js
(function (angular) {

    angular.module('cityHelper').factory('LocationHighlight', function () {
        /**
         * @constructor
         * @param {CityHelper} cityHelperRef
         */
        var LocationHighlight = function (cityHelperRef) {
            /**
             * @type {CityHelper}
             */
            this.cityHelper = cityHelperRef;

            /**
             * @type {number}
             */
            this.highlightIndex = 0;
            this.reset();
        };

        /**
         * Resets index to max length
         */
        LocationHighlight.prototype.reset = function () {
            this.highlightIndex = this.cityHelper.locations.length;
        };

        /**
         * Increases / decreases index
         *
         * @param {KeyboardEvent} event
         * @param {-1 | 1} direction
         */
        LocationHighlight.prototype.move = function (event, direction) {
            if (event.target.selectionStart > 0) {
                return;
            }

            if (this.highlightIndex < this.cityHelper.locations.length) {
                event.preventDefault();
            }

            this.highlightIndex += direction;
            this.highlightIndex = Math.min(Math.max(parseInt(this.highlightIndex), 0), this.cityHelper.locations.length);
        };

        /**
         *
         * @returns {number}
         */
        LocationHighlight.prototype.getHighlightIndex = function () {
            return this.highlightIndex;
        };

        /**
         *
         * @returns {boolean}
         */
        LocationHighlight.prototype.isOnInput = function () {
            return this.highlightIndex === this.cityHelper.locations.length;
        };

        LocationHighlight.prototype.constructor = LocationHighlight;

        return LocationHighlight;
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/services/city-helper.utils.js
(function (angular) {

    var CthUtils = function ($timeout, CITY_HELPER) {
        /**
         * @param {Boolean} isFrom
         */
        this.focusInput = function (isFrom) {
            document
                .getElementById(isFrom ? CITY_HELPER.DIRECTION_INPUT_ID_FROM : CITY_HELPER.DIRECTION_INPUT_ID_TO)
                .focus();
        };

        /**
         * @param {Boolean} isFrom
         */
        this.scrollInputArea = function (isFrom, xOffset) {
            $timeout(function () {
                document
                    .getElementById(isFrom ? CITY_HELPER.DIRECTION_INNER_ID_FROM : CITY_HELPER.DIRECTION_INNER_ID_TO)
                    .scrollTo({
                        top: 0,
                        left: xOffset,
                        behavior: 'smooth'
                    });
            }, 50);
        };

        this.scrollToInput = function (isFrom) {
            this.scrollInputArea(isFrom, 10000);
        };

        this.scrollToHighlight = function (isFrom, index) {
            var inner = document.getElementById(isFrom ? CITY_HELPER.DIRECTION_INNER_ID_FROM : CITY_HELPER.DIRECTION_INNER_ID_TO);
            var labelChild = inner.parentElement.querySelector('.flights-form-focusable__label');
            var innerPaddingLeft = parseInt(window.getComputedStyle(inner.parentElement).getPropertyValue('padding-left'));
            var firstChildNodeWidth = parseInt(window.getComputedStyle(labelChild).getPropertyValue('width'));
            var innerGap = parseInt(window.getComputedStyle(inner.parentElement).getPropertyValue('gap'));
            var innerWidth = parseInt(window.getComputedStyle(inner.parentElement).getPropertyValue('width')) - innerPaddingLeft * 2 - firstChildNodeWidth - innerGap;
            var pillArray = Array.from(inner.querySelectorAll('selected-location'));
            var selectedPill = pillArray[index];
            var selectedPillLeftOffset = selectedPill.offsetLeft - innerPaddingLeft - firstChildNodeWidth - innerGap;
            var selectedPillWidth = parseInt(window.getComputedStyle(selectedPill).getPropertyValue('width'));
            var parentScrollOffset = inner.scrollLeft;

            if (selectedPillLeftOffset < parentScrollOffset) {
                this.scrollInputArea(isFrom, selectedPillLeftOffset);
            }

            if (selectedPillLeftOffset + selectedPillWidth > parentScrollOffset + innerWidth) {
                this.scrollInputArea(isFrom, selectedPillLeftOffset - innerWidth + selectedPillWidth);
            }
        };

        /**
         * @param {Boolean} isFrom
         * @returns {NodeListOf<Element>}
         */
        this.getDomElements = function (isFrom) {
            var resultItemSelector = isFrom
                ? ('#' + CITY_HELPER.DIRECTION_HOLDER_ID_FROM) + ' .' + CITY_HELPER.DROPDOWN_RESULT_CLASS
                : ('#' + CITY_HELPER.DIRECTION_HOLDER_ID_TO) + ' .' + CITY_HELPER.DROPDOWN_RESULT_CLASS;

            return document.querySelectorAll(resultItemSelector);
        };

        /**
         * @param {Boolean} isFrom
         */
        this.removeActiveClasses = function (isFrom) {
            this.getDomElements(isFrom).forEach(function (el) {
                el.classList.remove('active');
            });
        };

        /**
         * @param {Boolean} isFrom
         * @param {Number} elementIndex
         * @param {Object} [$scope]
         */
        this.addActiveClass = function (isFrom, elementIndex, $scope) {
            var self = this;

            $timeout(function () {
                if (elementIndex !== -1) {
                    self.getDomElements(isFrom)[elementIndex].classList.add('active');
                }

                if ($scope) {
                    $scope.status.isEnterKeyLocked = false;
                }
            });
        };

        /**
         * @param {Object} cth
         * @return {Boolean}
         */
        this.isNoResults = function (cth) {
            return !cth.results.length;
        };

        /**
         * @param {Object} cth
         * @return {Boolean}
         */
        this.isSearched = function (cth) {
            return cth.inputValue.length >= 2;
        };

        /**
         * @param {Number} index
         * @param {Object} cth
         * @return {Boolean}
         */
        this.isLocDefaultResult = function (index, cth) {
            return index > (cth.locations.length - 1);
        };

        /**
         * @param {Object} cth
         * @return {CityHelperLocation[]}
         */
        this.getApiResultsWithoutTitles = function (cth) {
            return cth.results.filter(function (result) {
                return result.type !== 'title';
            });
        };

        /**
         * @param {Object} cth
         * @return {CityHelperLocation[]}
         */
        this.getDataElements = function (cth) {
            var yourSelection = cth.locations;
            var apiResults = this.getApiResultsWithoutTitles(cth);

            return !this.isSearched(cth)
                ? yourSelection.concat(apiResults)
                : apiResults;
        };

        /**
         * @param {Array} arr
         * @return {Number}
         */
        this.getMaxIndex = function (arr) {
            return arr.length - 1;
        };

        /**
         * @param {MouseEvent} $event
         * @return {Boolean}
         */
        this.isLocationItem = function ($event) {
            return $event.target.classList.contains(CITY_HELPER.DROPDOWN_RESULT_CLASS);
        };
    };

    CthUtils.$inject = [
        '$timeout',
        'CITY_HELPER'
    ];

    angular
        .module('cityHelper')
        .service('CthUtils', CthUtils);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/services/location-autocomplete.api.js
(function (angular) {

    var LocationAutocompleteApi = function ($http, $q, AppConfig, LocationAutocompleteService) {
        var getUrl = function () {
            return (
                AppConfig.getWebsiteSettings().autocomplete.endpoint ||
                'https://api.ith.toys/gateway/autocomplete'
            );
        };

        var getHeaders = function () {
            var headers = {
                'Accept-Language': AppConfig.getUserLanguage()
            };

            if (AppConfig.getNextGenSearchAbTest()) {
                headers['x-api-version'] = 2;
            }

            return headers;
        };

        var getRecommendationFilter = function (isCountry) {
            if (!isCountry) {
                return 'affiliate:' + AppConfig.getAffiliateName();
            }

            return 'country:' + AppConfig.getDefaultCountryCode();
        };

        var getPopularRequest = function (selectedOrigins, selectedDestinations, searchFor) {
            return $http({
                url: getUrl(),
                params: {
                    limit: 4,
                    searchFor: searchFor,
                    selectedOrigins: selectedOrigins,
                    selectedDestinations: selectedDestinations,
                    recommendationFilter: getRecommendationFilter(true)
                },
                headers: getHeaders()
            }).then(function (result) {
                return LocationAutocompleteService.parseResults(result);
            });
        };

        this.canceler = null;

        this.getPopularOrigins = function (selectedOrigins, selectedDestinations) {
            return getPopularRequest(
                selectedOrigins,
                selectedDestinations,
                'ORIGIN'
            );
        };

        this.getPopularDestinations = function (selectedOrigins, selectedDestinations) {
            return getPopularRequest(
                selectedOrigins,
                selectedDestinations,
                'DESTINATION'
            );
        };

        /**
         * @param {String} query
         * @param {String} searchFor
         * @return {CityHelperLocation[]}
         */
        this.search = function (query, searchFor, selectedOrigins, selectedDestinations) {
            if (this.canceler !== null) {
                this.canceler.resolve();
            }

            this.canceler = $q.defer();

            return $http({
                url: getUrl(),
                timeout: this.canceler.promise,
                params: {
                    query: query,
                    limit: 3,
                    searchFor: searchFor,
                    selectedOrigins: selectedOrigins,
                    selectedDestinations: selectedDestinations,
                    recommendationFilter: getRecommendationFilter(true)
                },
                headers: getHeaders()
            }).then(function (result) {
                return LocationAutocompleteService.parseResults(result);
            });
        };

        this.codesToLocation = function (commaSeparatedCodes) {
            return $http({
                url: '/api/location/codesToLocation/' + commaSeparatedCodes,
                headers: {
                    'Accept-Language': AppConfig.getUserLanguage()
                }
            });
        };
    };

    LocationAutocompleteApi.$inject = ['$http', '$q', 'appConfig', 'LocationAutocompleteService'];

    angular.module('cityHelper').service('LocationAutocompleteApi', LocationAutocompleteApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/cityHelper/services/location-autocomplete.service.js
(function (angular, underscore) {

    var LocationAutocompleteService = function (LocationTranslator, CITY_HELPER, CityHelperLocation, $translate) {
        this.parseResults = function (newResults) {
            var results = [];
            var cityName = '';
            var countryName = '';
            var translations = newResults.data.translations;

            var combined = underscore.sortBy(
                underscore.union(
                    newResults.data.cities,
                    newResults.data.countries
                ),
                function (item) {
                    return -item.score;
                }
            );

            angular.forEach(combined, function (entry) {
                countryName = translations.countries[entry.countryCode] || entry.countryCode;

                if (!entry.cityCode) {
                    results.push(
                        new CityHelperLocation({
                            countryCode: entry.countryCode,
                            countryName: countryName,
                            type: CITY_HELPER.TYPE_COUNTRY
                        })
                    );

                    return;
                }

                cityName = translations.cities[entry.cityCode] || entry.cityCode;

                results.push(
                    new CityHelperLocation({
                        cityCode: entry.cityCode,
                        cityName: cityName,
                        countryCode: entry.countryCode,
                        countryName: countryName,
                        type: CITY_HELPER.TYPE_CITY
                    })
                );

                angular.forEach(entry.cityAirports, function (airport) {
                    results.push(
                        new CityHelperLocation({
                            airportCode: airport.iataCode,
                            airportName: translations.airports[airport.iataCode] || airport.iataCode,
                            cityCode: entry.cityCode,
                            cityName: cityName,
                            countryCode: entry.countryCode,
                            countryName: countryName,
                            type: CITY_HELPER.TYPE_AIRPORT,
                            distanceFromCityCenterKm: airport.distanceFromCityCenterKm
                        })
                    );
                });
            });

            return results;
        };

        this.getAnyCity = function () {
            return new CityHelperLocation({
                cityName: $translate.instant('LANGM_JS_ANY_CITY'),
                type: CITY_HELPER.TYPE_ANY
            });
        };

        this.convertLocationsToStringParam = function (locations) {
            return locations
                .map(function (location) {
                    if (location.isCity()) {
                        return 'city:' + location.getCityCode();
                    }

                    if (location.isAirport()) {
                        return 'airport:' + location.getAirportCode();
                    }

                    if (location.isCountry()) {
                        return 'country:' + location.getCountryCode();
                    }

                    return '';
                })
                .join(',');
        };

        this.translateLocation = function (location) {
            if (location.isAnyCity()) {
                location = this.getAnyCity();
            }

            if (location.countryCode !== '') {
                location.countryName = LocationTranslator.iataDictionary.getCountryName(location.countryCode);
            }

            if (location.cityCode !== '') {
                location.cityName = LocationTranslator.iataDictionary.getCityName(location.cityCode);
            }

            if (location.airportCode !== '') {
                location.airportName = LocationTranslator.iataDictionary.getAirportName(location.airportCode);
            }

            return location;
        };
    };

    LocationAutocompleteService.$inject = ['LocationTranslator', 'CITY_HELPER', 'CityHelperLocation', '$translate'];

    angular.module('cityHelper').service('LocationAutocompleteService', LocationAutocompleteService);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/cityHelper/services/location-history.service.js
(function (angular, underscore) {

    var MAX_HISTORY_ITEMS = 5;

    var LocationHistoryService = function ($localStorage, CITY_HELPER, AppConfig) {
        var getTarget = function (flightType) {
            if (flightType === CITY_HELPER.FLIGHT_TYPE_FROM) {
                return 'lastSearchedFrom-v2-' + AppConfig.getUserLanguage();
            }

            return 'lastSearchedTo-v2-' + AppConfig.getUserLanguage();
        };

        this.add = function (locations, flightType) {
            var collection = this.get(flightType) || [];

            locations.forEach(function (location) {
                collection.unshift(location);
            });

            $localStorage[getTarget(flightType)] = underscore.first(
                underscore.uniq(collection, function (item) {
                    return item.cityCode + item.airportCode + item.countryCode;
                }),
                MAX_HISTORY_ITEMS
            );

            $localStorage.$apply();
        };

        this.get = function (flightType) {
            return $localStorage[getTarget(flightType)];
        };
    };

    LocationHistoryService.$inject = ['$localStorage', 'CITY_HELPER', 'appConfig'];

    angular
        .module('cityHelper')
        .service('LocationHistory', LocationHistoryService);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/cityHelper/services/search-history.service.js
(function (angular) {

    var SearchHistoryService = function ($localStorage) {
        this.save = function (searchQueryParams) {
            $localStorage.searchHistory = {
                fromCities: searchQueryParams.getDepCityCode(),
                fromAirports: searchQueryParams.getDepAirportCode(),
                toCities: searchQueryParams.getDesCityCode(),
                toAirports: searchQueryParams.getDesAirportCode(),
                toCountries: searchQueryParams.getDesCountryCode(),
                departureDate: searchQueryParams.getDepDate(),
                returnDate: searchQueryParams.getRetDate(),
                oneWay: searchQueryParams.isOneWay(),
                adults: searchQueryParams.getAdults(),
                children: searchQueryParams.getChildren(),
                youths: searchQueryParams.getYouths(),
                infants: searchQueryParams.getInfants(),
                flexDaysFrom: searchQueryParams.getFlexDaysFrom(),
                flexDaysTo: searchQueryParams.getFlexDaysTo(),
                isFlex: searchQueryParams.getIsFlex()
            };

            $localStorage.$apply();
        };

        this.get = function () {
            return $localStorage.searchHistory || {
                fromCities: '',
                fromAirports: '',
                toCities: '',
                toAirports: '',
                departureDate: null,
                returnDate: null,
                oneWay: false,
                adults: 1,
                children: 0,
                youths: 0,
                infants: 0,
                flexDaysFrom: null,
                flexDaysTo: null
            };
        };
    };

    SearchHistoryService.$inject = ['$localStorage'];

    angular
        .module('cityHelper')
        .service('SearchHistory', SearchHistoryService);

}(angular));
;

// Source: ../shared/public_html/assets/js/discounts/models/Campaign.js
angular.module('discount')

/**
 * @name        Campaign
 * @namespace   dsc
 * @description Class that describes a campaign
 */
.factory('dsc.Campaign',
[
function CampaignFactory() {
/**
   * Campaign constructor
   *
   * @constructor
   * @class Campaign
   */

  /**
   * Campaign constructor
   *
   * @param {Object} campaign The campaign data
   */
  var Campaign = function (campaign) {
    campaign = campaign || {};

    /**
     * Campaign id
     *
     * @type {Number}
     */
    this.id = campaign.id;

    /**
     * Campaign name
     *
     * @type {String}
     */
    this.name = campaign.name;

    /**
     * Campaign title
     *
     * @type {String}
     */
    this.title = campaign.title;

    /**
     * Campaign end date
     *
     * @type {Date}
     */
    this.dateEnd = campaign.date_end;

    /**
     * Campaign supports multiple cupons (permits adding vouchers together with the applied search discount)
     * Possible values: { 0 || 1 }
     *
     * @type {Number}
     */
    this.doubleCoupon = campaign.double_coupon;

    /**
     * Discount is subtracted from service fee
     * Possible values: { 0 || 1 }
     *
     * @type {Number}
     */
    this.decreasesTf = campaign.decreases_tf;

    /**
     * Discount is set for flights
     * Possible values: { 0 || 1 }
     *
     * @type {Number}
     */
    this.forFlight = campaign.flight;

    /**
     * Discount is set for insurances
     * Possible values: { 0 || 1 }
     *
     * @type {Number}
     */
    this.forInsurance = campaign.insurance;

    /**
     * Types of insurance affected by discount (if discount is set for insurances)
     * The array contains array of insurance types (ex: ["msimple", "complex"])
     *
     * @type {Array}
     */
    this.insuranceTypes = campaign.insurance_types;

    /**
     * Type of discount calculation
     * Possible values: { 0 - percent based, 1 - amount based }
     *
     * @type {Number}
     */
    this.percent = campaign.percent;

    /**
     * The percentile discoint, if any
     *
     * @type {float}
     */
    this.percentage = campaign.percentage;

    /**
     * Discount is set from loyalityProgram
     * Possible values: { 0 || 1 }
     *
     * @type {Number}
     */
    this.loyalityProgram = campaign.loyalityProgram;


    /**
     *
     * Possible values: { 0 || 1 }
     * @type {Number}
     */
    this.massCampain = campaign.massCampain;

    /**
     * Coupon tag
     *
     * @type {Number}
     */
    this.tag = campaign.tag;
  };

  /**
   * Baggage
   *
   * @constant
   * @type {String}
   */
  Campaign.TAG_ORANGE = 1;

  // Add instance methods
  Campaign.prototype = /** @lends Campaign.prototype */ {
    /**
     * Returns campaign id
     *
     * @return {Number}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Returns campaign title
     *
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Get double coupon property
     *
     * @return {Number}
     */
    getDoubleCoupon: function () {
      return this.doubleCoupon;
    },

    /**
     * Should discount decrease from TF?
     *
     * @return {Number}
     */
    getDecreasesTf: function () {
      return this.decreasesTf;
    },

    /**
     * Is current discount set for flights?
     *
     * @return {Boolean}
     */
    isForFlight: function () {
      return !!this.forFlight;
    },

    /**
     * Is current discount set for insurances?
     *
     * @return {Boolean}
     */
    isForInsurance: function () {
      return !!this.forInsurance;
    },

    /**
     * Returns array of insurance types
     *
     * @return {Array}
     */
    getInsuranceTypes: function () {
      return this.insuranceTypes;
    },

    /**
     * Checks if current campaign discount amount is percent based or fixed amount
     *
     * @return {Number}
     */
    isPercent: function () {
      return this.percent;
    },

    /**
     * @return {Boolean}
     */
    isMassCampain: function () {
      return !!this.massCampain;
    },

    /**
     * @return {Boolean}
     */
    isLoyalityProgram: function () {
      return !!this.loyalityProgram;
    },

    getTag: function () {
      return this.tag;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      return {
        id: this.getId(),
        title: this.getTitle(),
        double: this.getDoubleCoupon(),
        decTf: this.getDecreasesTf(),
        percent: this.isPercent(),
        flight: this.isForFlight(),
        ins: this.isForInsurance(),
        insTypes: this.getInsuranceTypes()
      };
    }
  };

  Campaign.prototype.constructor = Campaign;

  return Campaign;
}]);

;

// Source: ../shared/public_html/assets/js/discounts/models/Coupon.js
// @redesign: this file is newer than the one in the redesign branch

angular.module('discount')

/**
 * @name        Coupon
 * @namespace   dsc
 * @description Class that describes a coupon
 */
.factory('dsc.Coupon',
['dsc.Campaign',
function CouponFactory(Campaign) {
/**
   * Coupon constructor
   *
   * @constructor
   * @class Coupon
   */
  var Coupon = function (coupon) {
    coupon = coupon || {};

    /**
     * Discount value
     *
     * @type {Number}
     */
    this.value = coupon.discount || 0.0;

    /**
     * The discount code
     *
     * @type {String}
     */
    this.discountCode = coupon.discount_code || '';

    /**
     * Available funds
     *
     * @type {number}
     */
    this.availableFunds   = coupon.availableFunds || 0.0;

    /**
     * Discount campaign
     *
     * @type {Campaign}
     */
    this.campaign = new Campaign(coupon.campaign);

    /**
     * Type of the coupon
     *
     * @type {Number}
     */
    this.type = 0;

    /**
     * Coupon owner email
     *
     * @type {String}
     */
    this.owner = coupon.owner || null;
  };

  // Add instance methods
  Coupon.prototype = /** @lends Coupon.prototype */ {

    /**
     * Get discount value
     *
     * @return {Number}
     */
    getValue: function () {
      return this.value;
    },

    /**
     * Returns discount code
     *
     * @return {String}
     */
    getDiscountCode: function () {
      return this.discountCode;
    },

    /**
     * Returns the coupon campaign
     *
     * @return {Campaign}
     */
    getCampaign: function () {
      return this.campaign;
    },

    /**
     * Returns available funds
     *
     * @returns {number}
     */
    getAvailableFunds: function () {
      return this.availableFunds;
    },

    /**
     * Returns calculated discount price
     *
     * @param {number} price
     * @returns {number}
     */
    getDiscount: function(price){
      price = parseFloat(price || 0);

      if (this.availableFunds <= 0 || this.campaign.getDecreasesTf()) {
        return this.value;
      }

      if (this.availableFunds - price <= 0) {
        return (this.value + this.availableFunds);
      }

      return (this.value + price);
    },

    /**
     * Get campaign id
     *
     * @return {Number}
     */
    getCampaignId: function () {
      return this.campaign.getId();
    },

    /**
     * Get campaign title
     *
     * @return {String}
     */
    getCampaignTitle: function () {
      return this.campaign.getTitle();
    },

    /**
     * Get rule of adding vouchers together with the applied search discount
     *
     * @return {Number} Possible values: {0 || 1}
     */
    getCampaignDoubleCoupon: function () {
      return this.campaign.getDoubleCoupon();
    },

    /**
     * Check to see if there is a discount
     *
     * @return {Boolean}
     */
    hasDiscount: function () {
      return this.value > 0;
    },

    /**
     * Set the type of the current coupon
     *
     * Possible values:
     * 0 - discount automatically added on a specific route
     * 1 - voucher added by the user
     *
     * @param {int} type
     *
     * @return {Coupon}
     */
    setType: function (type) {
      this.type = type;

      return this;
    },

    /**
     * Get coupon type
     *
     * @return {Number}
     */
    getType: function () {
      return this.type;
    },

    /**
     * Get owner email
     *
     * @return {String}
     */
    getOwner: function () {
      return this.owner;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      return {
        code: this.getDiscountCode(),
        value: this.getValue(),
        type: this.getType(),
        camp: this.getCampaign().getSrvObj(),
        owner: this.getOwner()
      };
    }
  };

  Coupon.prototype.constructor = Coupon;

  return Coupon;
}]);
;

// Source: ../shared/public_html/assets/js/discounts/models/CouponStorage.js
angular.module('discount')

  /**
   * @name        CouponStorage
   * @namespace   dsc
   * @description Class
   */
  .factory('dsc.CouponStorage',
    ['$cookies',
      function CouponStorageFactory($cookies) {
var requestId = 'default';

        var lastCoupons = {};
        /**
         * CouponStorage
         *
         * @constructor
         * @class CouponStorage
         */
        var CouponStorage = function () {
        };

        CouponStorage.prototype = {

          /**
           * save coupon in local storage
           *
           * @param couponCode
           */
          addCoupon: function (couponCode) {

            if (!lastCoupons.hasOwnProperty(requestId)) {
              lastCoupons[requestId] = []
            }

            if (lastCoupons[requestId].indexOf(couponCode) == -1) {
              lastCoupons[requestId].push(couponCode)
            }

            this.saveInLocalStorage();
          },

          /**
           * set booking request id
           *
           * @param id
           */
          setRequestId: function (id) {
            requestId = id || requestId;
          },

          /**
           * remove coupon from local storage
           *
           * @param couponCode
           */
          removeCoupon: function (couponCode) {
            lastCoupons[requestId] = _.filter(lastCoupons[requestId], function (code) {
              return code != couponCode;
            });

            this.saveInLocalStorage();
          },

          /**
           * get coupons
           *
           * @returns {*}
           */
          getCouponCodes: function () {
            return lastCoupons[requestId];
          },

          /**
           * save coupons in local storage
           */
          saveInLocalStorage: function () {
            var date = moment();
            date.add(2, 'days');

            $cookies.put('lastCoupons', JSON.stringify(lastCoupons), {
              domain: _js_app_config_.facebook_domain,
              expires: date.toDate()
            });
          },

          /**
           * get coupons from local storage
           *
           * @returns {*}
           */
          loadFromStorage: function () {
            var cookieData = $cookies.get('lastCoupons');
            if (cookieData) {
              lastCoupons = JSON.parse(cookieData) || {};
            }

            return this.getCouponCodes();

          }
        };

        CouponStorage.prototype.constructor = CouponStorage;

        return CouponStorage;
      }]);

;

// Source: ../shared/public_html/assets/js/discounts/models/Discount.js
// @redesign: this file is newer than the one in the redesign branch
/*global _: false */

angular.module('discount')

/**
 * @name        Discount
 * @namespace   dsc
 * @description Class that describes a discount
 */
.factory('dsc.Discount',
['dsc.Coupon', '$filter',
function DiscountFactory(Coupon, $filter) {
/**
   * Discount
   *
   * @constructor
   * @class Discount
   */
  var Discount = function () {
    /**
     * Contains all discount coupons
     *
     * @type {Coupon[]}
     */
    this.coupons = [];
  };

  Discount.prototype = /** @lends Discount.prototype */ {

    /**
     * Add array of discounts from flight details response
     *
     * @param {Array} discounts
     */
    addDiscounts: function (discounts) {
      if (!discounts.length) return;

      _.each(discounts, function (discount) {
        // Add coupon
        this.addCoupon(discount, 0);
      }, this);
    },

    /**
     * Adds a new coupon in the coupons array
     *
     * @param {Object} couponData Data containing coupon information
     * @param {int}    type       Type of coupon (0 - discount on a specific route, 1 - voucher added by user)
     */
    addCoupon: function (couponData, type) {
      // Don't add any coupon if no coupon data is present or if it has 0 value
      if (!couponData || couponData.discount == 0)
      {
        return {success: false, error: $filter('translate')('LANGM_JS_COUPONS_DATA_NOT_DISCOUNT', {})};
      }

      // Create a new coupon
      var coupon = new Coupon(couponData);
      if (type == 0 && !coupon.getCampaignDoubleCoupon()) {
        type = 1;
      }

      if (type == 0 && this.hasCouponsByType(0)) {
        return {success: false, error: $filter('translate')('LANGM_JS_COUPONS_ALREADY_CONTAIN_MASSCAPAIGN', {})};
      }

      if(type == 1)
      {
        var coupons = [], loyalCoupons = [];
        _.each(this.getCoupons(), function (c) {
          if(c.getType() == 1)
          {
            if (!c.getCampaign().isLoyalityProgram())
            {
              coupons.push(c.getSrvObj());
            }
            else
            {
              loyalCoupons.push(c.getSrvObj());
            }
          }
        }, this);

        /*if (coupon.getCampaign().isMassCampain()) {
          return {success: false, error: $filter('translate')('LANGM_JS_COUPONS_CAN_ADD_ONLY_COUPONS', {})};
        }*/

        /*if(!coupon.getCampaign().isLoyalityProgram() && loyalCoupons.length > 0)
        {
          return {success: false, error: $filter('translate')('LANGM_JS_COUPONS_CANT_ADD_TO_ALREADY_ADDED_ONLY_LOYALITY_ALLOWED', {})};
        }
        else if(coupon.getCampaign().isLoyalityProgram() && coupons.length > 0)
        {
          return {success: false, error: $filter('translate')('LANGM_JS_COUPONS_CANT_ADD_TO_ALREADY_ADDED', {})};
        }*/
      }

      var alreadyAdded = false;
      _.each(this.getCoupons(), function (c) {
        if(coupon.getDiscountCode() == c.getDiscountCode())
        {
          alreadyAdded = true;
        }
      }, this);

      if(alreadyAdded)
      {
        return {success: false, error: $filter('translate')('LANGM_JS_COUPON_IS_ALREADY_ADDED', {})};
      }

      // Set the coupon type
      coupon.setType(type);

      // Add coupon to discounts
      this.coupons.push(coupon);
      return {success: true, error: ''};
    },

    /**
     * Check to see if there are coupons added
     *
     * @return {Boolean}
     */
    hasCoupons: function () {
      return this.coupons.length > 0;
    },

    /**
     * Check to see if discount has decrease service fee
     *
     * @return {Boolean}
     */
    hasDecreaseTf: function (type) {
      type = typeof type == 'undefined' ? 0 : type;
      return _.reduce(this.coupons, function (memo, coupon) {
        return memo || (coupon.getType() == type && coupon.getCampaign().getDecreasesTf());
      }, false);
    },

    /**
     * Check to see if there are coupons added and does not have decrease service fee
     *
     * @param {Boolean} [asString=false] Set to true to return string instead of boolean value. Needed in templates.
     *
     * @return {Boolean|String}
     */
    showDiscountBox: function (asString) {
      asString = asString || false;
      asString = !!asString;

      var ret = this.hasCoupons() && !this.decreaseTf();

      return asString ? '' + ret : ret;
    },

    /**
     * exist decreases in campaign
     *
     * @return {Boolean}
     */
    decreaseTf: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        return memo || coupon.getCampaign().getDecreasesTf();
      }, false);
    },


    /**
     * Checks to see if coupons are added by type
     *
     * @param  {Number}  type Type of coupon.
     *
     * Possible values:
     * - 0: default search discount (added from admin)
     * - 1: voucher added by client
     * - 2: coupon added by a promotion
     *
     * @return {Boolean}
     */
    hasCouponsByType: function (type) {
      return _.reduce(this.coupons, function (memo, coupon) {
        return memo || coupon.getType() == type;
      }, false);
    },

    /**
     * Checks if new coupon can be added
     *
     * @return {Boolean}
     */
    canAddCoupon: function () {
      var coupons = [];
      _.each(this.getCoupons(), function (coupon) {
        if (coupon.getType() == 1 && !coupon.getCampaign().isLoyalityProgram())
        {
          coupons.push(coupon.getSrvObj());
        }
      }, this);

      return coupons.length < 1;
    },

    /**
     * Returns the voucher codes added by the user
     *
     * @return {string[]} The voucher code
     */
    getVoucherCodes: function () {
      var codes = [];

      _.each(this.coupons, function (coupon) {
        if (coupon.getType() != 0) {
          codes.push({
            code: coupon.getDiscountCode(),
            owner: coupon.getOwner()
          });
        }
      }, this);

      return codes;
    },

    /**
     * Returns all voucher codes
     *
     * @return {string[]} The voucher code
     */
    getCodes: function () {
      var codes = [];

      _.each(this.coupons, function (coupon) {
        codes.push(coupon.getDiscountCode());
      }, this);

      return codes;
    },

    /**
     * Removes a coupon by type
     *
     * @param {int} type The coupon type (0: discount | 1: voucher)
     */
    removeCoupon: function (type) {
      if (!this.hasCouponsByType(type)) return;

      this.coupons = _.filter(this.coupons, function (coupon) {
        return coupon.getType() != type;
      });
    },

    removeCouponOnDiscountCode: function(code){
      this.coupons = _.filter(this.coupons, function (coupon) {
        return coupon.getDiscountCode() != code;
      });
    },
    /**
     * Get total discount amount
     *
     * @return {Number}
     */
    getTotalDiscount: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().isForFlight()) {
          // Return coupon value only if it applies to flights
          return memo + coupon.getValue();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     *
     * @returns {Number}
     */
    getTotalCouponsDiscount: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().isForFlight() && !coupon.getCampaign().isMassCampain()) {
          return memo + (coupon.showDiscount || coupon.getValue());
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     *
     * @returns {Number}
     */
    getTotalMassCampaign: function(){
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().isForFlight() && coupon.getCampaign().isMassCampain()) {
          return memo + coupon.getValue();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     *
     * @returns {Number}
     */
    getCalculatedCoupons : function(price){
      var coupons = [];

      angular.forEach(this.coupons,function(coupon){
        coupon.showDiscount = coupon.getDiscount(price);
        coupons.push(coupon);
      });

      return coupons;
    },

    /**
     *
     * @returns {Number}
     */
    getTotalAvailableFunds: function(){
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().isForFlight() && !coupon.getCampaign().isMassCampain() && coupon.getCampaign().getDecreasesTf() != 1) {
          return memo + coupon.getAvailableFunds();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     * Get total discount amount
     *
     * @return {Number}
     */
    getTotalNoTfDiscount: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().isForFlight() && coupon.getCampaign().getDecreasesTf() != 1) {
          // Return coupon value only if it applies to flights
          return memo + coupon.getValue();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     * Get total default discount amount (discount set in admin)
     *
     * @return {Number}
     */
    getTotalDefaultDiscount: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        if (coupon.getCampaign().getDecreasesTf() == 1) {
          return memo + coupon.getValue();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     * Get total insurance discount amount
     *
     * @return {Number}
     */
    getTotalInsuranceDiscount: function () {
      return _.reduce(this.coupons, function (memo, coupon) {
        // Return coupon value only if it applies to insurances
        if (coupon.getCampaign().isForInsurance()) {
          return memo + coupon.getValue();
        }
        else {
          return memo;
        }
      }, 0);
    },

    /**
     * Returns the insurance coupon (assuming there's always going to be only one)
     *
     * @return {Coupon}
     */
    getInsuranceCoupon: function () {
      return _.find(this.coupons, function (coupon) {
        return coupon.getCampaign().isForInsurance();
      });
    },

    /**
     * Is adding of vouchers permitted by discount
     *
     * @return {bool}
     */
    hasCumulativeDiscount: function () {
      if (this.hasCoupons() && this.coupons[0].getType() == 0) {
        return !!this.coupons[0].getCampaignDoubleCoupon();
      }

      return false;
    },

    /**
     * Returns all discount coupons
     *
     * @return {Coupon[]} All the added coupons
     */
    getCoupons: function () {
      return this.coupons;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      var coupons = [];
      _.each(this.getCoupons(), function (coupon) {
        coupons.push(coupon.getSrvObj());
      }, this);

      return {
        coup: coupons,
        tot: this.getTotalDiscount(),
        def: this.getTotalDefaultDiscount(),
        ins: this.getTotalInsuranceDiscount(),
        cumul: this.hasCumulativeDiscount()
      };
    }
  };

  Discount.prototype.constructor = Discount;

  return Discount;
}]);

;

// Source: ../shared/public_html/assets/js/discounts/services/CouponServ.js
angular.module('discount')

/**
 * @name        CouponServ
 * @namespace   dsc
 * @description Class that handles coupon communication with the API
 */
.factory('dsc.CouponServ', ['ApiTools', 'appConfig',
function CouponServFactory(ApiTools, AppConfig) {
var
    /**
     * The API endpoints configuration
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Add coupon
      addCoupon: {
        url: AppConfig.getUriPrefix() + '/api/coupons/checkFlightCoupon/:requestId/:priceGroupId/:depLegId/:retLegId',
        method: 'POST',
        respParser: couponParser
      }
    },

    /**
     * @class CouponServ
     * @constructor
     */
    CouponServ = function () {};

  CouponServ.prototype = /** @lends CouponServ.prototype */ {

    /**
     * Send coupon code to backend for validation
     *
     * @param {String} couponCode  The coupon/voucher code
     * @param {String} customerEmail  The coupon/voucher code
     * @param {Object} routeParams The route parameters
     * @param {Array} usedCodes already used coupon/voucher codes
     */
    addCoupon: function (couponCode, customerEmail, routeParams, usedCodes) {
      if (!routeParams.retLegId) {
        routeParams.retLegId = '';
      }

      if (!usedCodes) {
        usedCodes = [];
      }

      return ApiTools.fetch(this, endpoints.addCoupon,
        {
          code: couponCode,
          usedCodes: usedCodes,
          customerEmail: customerEmail
        }, routeParams);
    }
  };

  CouponServ.prototype.constructor = CouponServ;

  /**
   * Parse example response
   *
   * @param {Object} response
   *
   * @return {Object}
   */
  function couponParser(response) {
    return response.response;
  }

  return new CouponServ();
}]);

;

// Source: ../shared/public_html/assets/js/faq/controllers/FaqCtrl.js
angular.module('faq')

  /**
   * @name Home Controller
   */
.controller('FaqHomeCtrl',
  ['$scope', 'FaqSrv', '$rootScope', '$location', '$timeout', '$document', '$window',
    function ($scope, FaqSrv, $rootScope, $location, $timeout, $document, $window)
    {
$scope.faq = $scope.faq || {};
  $scope.faq.items = $scope.faq.items || {};
  $scope.faq.userBar = 'home';
  $scope.fixed = false;

  /**
   * Variables for menu
   */
  var wrapper = 0,
    menu = 0,
    wrapperOffset = 0,
    wrapperHeight = 0,
    menuHeight = 0,
    windowOffset = 0;

  FaqSrv.getData('home', {}).then
  (
    function success(items) {
      $scope.faq.items = items;
    }
  );

  $timeout(function () {
    wrapper = $document[0].getElementsByClassName('main-faq');
    menu = $document[0].getElementsByClassName('faq-menu');
    if ($location.hash()) {
      var hash = $location.hash(),
        hashPosition = angular.element(document.getElementById(hash));

            if (hashPosition)
            {
              $document.scrollToElementAnimated(hashPosition);
            }
          }
          var modifier = 0;
          $rootScope.showBackToOld ? modifier = 87 : modifier = 55;

          /**
           * Scroll menu
           */
          angular.element($window).bind("scroll", function ()
          {
            windowOffset = $window.pageYOffset || 0;
            wrapperOffset = wrapper[0].offsetTop - modifier || 0;
            wrapperHeight = wrapper[0].offsetHeight || 0;
            menuHeight = menu[0].offsetHeight + modifier || 0;

            $scope.$apply(function ()
            {
              if ((windowOffset >= wrapperOffset) && windowOffset <= (wrapperHeight + wrapperOffset - menuHeight))
              {
                $scope.fixed = true;
                $scope.bottom = false;
              }
              if (windowOffset >= (wrapperHeight + wrapperOffset - menuHeight))
              {
                $scope.fixed = false;
                $scope.bottom = true;
              }
              if ((windowOffset < wrapperOffset))
              {
                $scope.fixed = false;
                $scope.bottom = false;
              }
            });
          });



  });

  $scope.$on('$destruct', function () {
    angular.element($window).unbind("scroll");
  });

}])

/**
 * @todo teach devs that global configs should be set from a central location,
 * not sprinkled around the app willy-nilly like this
 */
.value('duScrollOffset', 100)

/**
 * @name Show Controller
 */
.controller('FaqShowCtrl',
['$scope', '$stateParams', 'FaqSrv',
function ($scope, $stateParams, FaqSrv) {
  $scope.faq = $scope.faq || {};
  $scope.faq.items = $scope.faq.items || {};
  $scope.faq.userBar = 'home';
  $scope.faq.categoryTitle = $stateParams.categoryTitle;
  $scope.faq.pageTitle = $stateParams.pageTitle;

  // Show page
  if ($scope.faq.categoryTitle && $scope.faq.pageTitle) {
    FaqSrv.getData('show', {category_title: $scope.faq.categoryTitle, page_title: $scope.faq.pageTitle}).then
    (
      function success(items) {
        $scope.faq.items = items;
      }
    );
  }
}])

/**
 * @name ShowTag Controller
 */
.controller('FaqShowTagCtrl',
['$scope', '$stateParams', 'FaqSrv',
function ($scope, $stateParams, FaqSrv) {
  $scope.faq = $scope.faq || {};
  $scope.faq.items = $scope.faq.items || {};
  $scope.faq.userBar = 'home';
  $scope.faq.tagName = $stateParams.tagName;

  // Show page
  if ($scope.faq.tagName) {
    $scope.faq.items.loading = true;
    FaqSrv.getData('showTag', {tag_name: $scope.faq.tagName}).then
    (
      function success(items) {
        $scope.faq.items = items;
      }
    );
  }
}]);
;

// Source: ../shared/public_html/assets/js/faq/directives/navBar.js
angular.module('faq')

/**
 * @name        faqNavbar
 * @description directive for faqNavbar zone
 */
.directive('faqNavbar', function () {
return {
    restrict: 'A',
    controller: ['$scope', function ($scope) {
      $scope.userBarCurrent = 'home';
      $scope.currentPage = window.location.pathname;
    }]
  };
});

;

// Source: ../shared/public_html/assets/js/faq/services/FaqSrv.js
angular.module('faq')

/**
 * @name FAQ Service
 *
 * @description Example service responsibility description
 */
.factory('FaqSrv', ['ApiTools',
function FaqSrvFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints =
    {
      get_data: {url: '/ngFaq/getNgData', method: 'POST', respParser: getResponse}
    },

    /**
     * @class FaqSrv
     * @constructor
     */
    FaqSrv = function () {};

  /**
   * @lends ExampleService.prototype
   */
  FaqSrv.prototype =
  {
    /**
     * Get Data
     *
     * @return {Promise}
     */
    getData: function (type, value) {
      return ApiTools.fetch(this, endpoints.get_data, {type: type, value: value});
    }

  };

  FaqSrv.prototype.constructor = FaqSrv;

  /**
   * Get Response
   *
   * @param {Object} response
   * @return Object
   */
  function getResponse(response) {
    return response.response;
  }

  return new FaqSrv();
}]);




;

// Source: ../shared/public_html/assets/js/flight/components/ith-cell-summary-bar.js
(function(angular) {
/**
     * @name        CellSummaryBarComponent
     * @description Bar for short flight summary
     */
    var ithCellSummaryBar = {
        bindings: {
            cellSummary: '<',
        },
        templateUrl: '/tpl/show/jsShared/templates/flights/components/cellSummaryBar',
        controller: function () {
            var ctrl = this;
            this.$onInit = function () {
                ctrl.isOneWay = !ctrl.cellSummary.getRetCityName();
            };
        }
    };

    angular
        .module('flight')
        .component('ithCellSummaryBar', ithCellSummaryBar);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/constants/FlightSearchTabNames.js
/*global angular: false */

angular.module('flight')
/**
 * @name        FlightSearchTabNames
 * @namespace   flt
 * @description FlightSearchTabNames
 * @type        {Object}
 */
.constant('flt.FlightSearchTabNames', {
  YOUR_SEARCH: 'yourSearch',
  MATRIX: 'matrix',
  CALENDAR: 'calendar'
});;

// Source: ../shared/public_html/assets/js/flight/controllers/OrderSummaryController.js
(function(angular, underscore) {
/**
     * @name        OrderSummaryController
     * @description Manages the order summary (basket?)
     */
    var OrderSummaryController = function ($scope, $rootScope, $filter, Dictionaries, ResponsiveTooltipService, TextBox) {
        $scope.depCityName = Dictionaries.getCityNameByCode($scope.flightBooking.getFlightDetails().getDepLeg().getDepCityCode(), false);
        $scope.arrCityName = Dictionaries.getCityNameByCode($scope.flightBooking.getFlightDetails().getDepLeg().getArrCityCode(), false);
        $scope.isRoundTrip = $scope.flightBooking.getFlightDetails().isRoundTrip();

        $scope.tfDetails = null;

        //Order Summary Flight Details Modal
        $scope.showDetailsModal = function () {
            ResponsiveTooltipService.open('itineraryRevisit');
        };

        $scope.closeFloatingSummary = function () {
            $rootScope.$broadcast('closeFloatingSummary');
        };

        $scope.additionalServicesSummary = function(basket) {
            var summary = 0;

            if(basket) {
                summary += parseFloat(basket.getTotalLuggagePrice());
                summary += parseFloat(basket.getTotalInsurancePrice());
            }
            return summary;
        };

        $scope.additionalFeesSummary = function(basket) {
            var feesSummary = 0;

            if(basket) {
                feesSummary += parseFloat(basket.getExpensivePaymentOptions());
                feesSummary += parseFloat(basket.getMassCampaignTransFee());
                feesSummary += $scope.flightBooking ? basket.getTotalPaymentFee($scope.flightBooking.getPayment().getType()) : 0;
                feesSummary += $scope.flightBooking ? underscore.reduce(underscore.pluck($scope.flightBooking.basket.getMandatoryFees(), 'price'), function(memo, num) {
                    return parseFloat(memo) + parseFloat(num);
                }, 0) : 0;
            }

            return $filter('roundPrice')(feesSummary);
        };

        $scope.checkTotalPrice = function () {
            var priceRef = $scope.flightBooking.getTestSell() !== null
                ? $scope.flightBooking.basket.getTotalPrice(true)
                : $scope.flightBooking.basket.getTotalPrice();

            if (priceRef !== $scope.flightBooking.basket.totalPriceReference) {
                $scope.flightBooking.basket.totalPriceReference = priceRef;
                $rootScope.$broadcast('totalPriceChanged');
            }
        };

        $scope.checkItemCount = function () {
            var countRef = underscore.reduce(
                $scope.flightBooking.basket.getBasketItems(),
                function (memo, item) {
                    return memo + item.quantity;
                },
                0
            );

            if (countRef !== $scope.flightBooking.basket.itemCountReference) {
                $scope.flightBooking.basket.itemCountReference = countRef;
                $rootScope.$broadcast('totalCountChanged');
            }
        };

        $scope.removeCoupon = function (code) {
            $scope.flightBooking.basket.removeCouponOnDiscountCode(code);
        };

        this.$onInit = function () {
            var tfInfoTextBox = 'text_box_rf_info';

            if ($scope.flightBooking.basket.flightDetails.flightType === 'HUB') {
                tfInfoTextBox = 'text_box_rf_info_hub';
            }

            // Load text box
            TextBox
                .getByName(tfInfoTextBox)
                .then(function (response) {
                    $scope.tfDetails = response.text;
                });
        };

        this.$doCheck = function () {
            $scope.checkTotalPrice();
            $scope.checkItemCount();
        };
    };

    OrderSummaryController.$inject = [
        '$scope',
        '$rootScope',
        '$filter',
        'Dictionaries',
        'ResponsiveTooltipService',
        'TextBox'
    ];

    angular.module('base')
        .controller('OrderSummaryController', OrderSummaryController);

})(angular, _);
;

// Source: ../shared/public_html/assets/js/flight/controllers/order-summary-watcher.factory.js
(function (angular) {
var OrderSummaryWatcherFactory = function ($rootScope, SplitFunnelAnalytics) {
        var getDiffItems = function (prevList, currList) {
            var newItems = [];
            var found;

            for (var i = 0; i < currList.length; i++) {
                found = false;

                for (var j = 0; j < prevList.length; j++) {
                    var idCondition = currList[i].id === prevList[j].id;
                    var priceCondition = currList[i].price === prevList[j].price;
                    var quantityCondition = currList[i].quantity === prevList[j].quantity;

                    if (idCondition && priceCondition && quantityCondition) {
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    newItems.push(currList[i]);
                }
            }

            return newItems;
        };

        var OrderSummaryWatcher = function (booking, steps) {
            this.booking = booking;
            this.steps = steps;
            this.basketItemCache = booking.basket.getBasketItems();
            var self = this;

            var evaluate = function () {
                var boundEvaluateBasketItems = self.evaluateBasketItems.bind(self);
                boundEvaluateBasketItems();
            };

            this.events = {
                unregisterTotalPriceChanged: $rootScope.$on('totalPriceChanged', evaluate),
                unregisterTotalCountChanged: $rootScope.$on('totalCountChanged', evaluate)
            };
        };

        OrderSummaryWatcher.prototype.evaluateBasketItems = function () {
            var newBasketItems = this.booking.basket.getBasketItems();
            var addedItems = getDiffItems(this.basketItemCache, newBasketItems);
            var removedItems = getDiffItems(newBasketItems, this.basketItemCache);
            var currentStepIndex = this.steps.getCurrentStepIndex();
            this.basketItemCache = newBasketItems;

            angular.forEach(removedItems, function (item) {
                SplitFunnelAnalytics.updateCart(this.booking, currentStepIndex, item, false);
            }.bind(this));

            angular.forEach(addedItems, function (item) {
                SplitFunnelAnalytics.updateCart(this.booking, currentStepIndex, item, true);
            }.bind(this));
        };

        OrderSummaryWatcher.prototype.unsetEvents = function () {
            this.events.unregisterTotalPriceChanged();
            this.events.unregisterTotalCountChanged();
        };

        OrderSummaryWatcher.prototype.constructor = OrderSummaryWatcher;

        return OrderSummaryWatcher;
    };

    OrderSummaryWatcherFactory.$inject = ['$rootScope', 'SplitFunnelAnalytics'];

    angular
        .module('base')
        .factory('OrderSummaryWatcher', OrderSummaryWatcherFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/directives/checkbox.js
angular.module('flight')

/**
 * @name        flightUiCheckbox
 * @description UI checkbox directive
 */
.directive('flightUiCheckbox',
['appConfig',
/**
 * @param {AppConfig} appConfig
 */
function flightUiCheckbox(appConfig) {
return {
    restrict: 'E',
    template: '<span class="boolean" base-' + (appConfig.isTablet() || appConfig.isMobile() ? 'touchstart' : 'click') + '="toggle()" ng-class="{ on: checked }"><span class="toggler"></span></span>',
    replace: true,
    scope: {
      checked: '=?',
      toggle: '&?'
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/details/basicSubmitButton.js
angular.module('flight')

/**
 * @name        basicSubmitButton
 * @description Funnel basic submit button directive
 */
  .directive('basicSubmitButton',
    [
      function basicSubmitButton() {
return {
          restrict: 'EA',
          replace: true,
          templateUrl: function (element, attrs) {
            return attrs.templateUrl;
          },
          scope: {
            chosenButton: '=chosenButton',
            flightBooking: '=flightBooking',
            checkButtonsConfig: '=checkButtonsConfig',
            statuses: '=statuses',
            insurance: '=insurance'
          },
          link: function (scope) {
            var insurance = scope.flightBooking.getNewInsurance();
            scope.insurancePrice = 0;
            if (insurance.selectedInsurance) {
              scope.insurancePrice = insurance.selectedInsurance.totalPrice
            } else if (insurance.defaultInsurance) {
              scope.insurancePrice = insurance.defaultInsurance.totalPrice
            }
          }
        };
      }]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/details/flightDetailsData.js
angular.module('flight')

    /**
    * @name        flightDetailsData
     * @description Flight details data directive
     */
    .directive('flightDetailsData',
        [
            function flightDetailsData() {
return {
                    restrict: 'A',
                    scope: {
                        fareRule: '=?',
                        modelData: '='
                    },
                    replace: true,
                    templateUrl: function (element, attrs) {
                        return attrs.templateUrl;
                    },
                    controller: 'flightDetailsDataCtrl'
                };
            }]);

;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/details/travelInsuranceAdBox.js
(function (angular) {
var TravelInsuranceAdBoxController = function ($stateParams, InsuranceApi, PaxAgeCheckerService) {
        /**
         * On init hook
         */
        this.$onInit = function () {
            InsuranceApi
                .resetInsurance({}, angular.copy($stateParams))
                .then(function (success) {
                    this.flightBooking.getNewInsurance().setInitialResponse(success);
                }.bind(this))
                .catch(function (error) {
                    console.error(error);
                });
        };

        /**
         * Should loading be visible?
         *
         * @returns {Boolean}
         */
        this.isLoadingVisible = function () {
            return !this.flightBooking.getNewInsurance().isLoaded;
        };

        /**
         * Should product be visible?
         *
         * @returns {Boolean}
         */
        this.isProductVisible = function () {
            return (
                this.flightBooking.getNewInsurance().isLoaded &&
                this.flightBooking.getNewInsurance().isInsuranceAllow &&
                !PaxAgeCheckerService.isAnyPaxReached75Years(this.flightBooking.paxes) &&
                !this.flightBooking.isEditMode
            );
        };
    };

    TravelInsuranceAdBoxController.$inject = [
        '$stateParams',
        'dsc.InsuranceServ',
        'PaxAgeCheckerService'
    ];

    angular
        .module('ITH.insurance')
        .component('travelInsuranceAdBox', {
            templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/covid-travel-insurance',
            bindings: {
                flightBooking: '='
            },
            controller: TravelInsuranceAdBoxController
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/fdSegment.js
angular.module('flight')

/**
 * @name        fdSegment
 * @description Flight details segment directive
 */
.directive('fdSegment',
[ 'Dictionaries', 'bok.FlightBooking', '$modal', 'appConfig',
function fdSegment(Dictionaries, FlightBooking, $modal, appConfig) {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    scope: {
      /**
       * Required model for the flight price group
       *
       * @type {TBD}
       */
      segment: '=?ngModel',

      /**
       * The previous segment in the leg
       * NOTE: this may be missing
       *
       * @type {Segment}
       */
      nextSegment: '='
    },
    link: function ($scope) {

      $scope.FlightBooking = FlightBooking;
      /**
       * Dictionaries
       *
       * @type {Dictionaries}
       */
      $scope.dictionaries = Dictionaries;

      /**
       * Return true if flight is HUB
       *
       * @return {boolean}
       */
      $scope.isHub = function () {
        return $scope.segment.flightType === 'HUB';
      };

      /**
       * Check if there is airport change during the travel
       * @returns {boolean}
       */
      $scope.isAirportChange = function () {
          return $scope.nextSegment && $scope.segment.getArrAirportCode() !== $scope.nextSegment.getDepAirportCode();
      };

      $scope.isOperatedBy = function () {
        return $scope.segment.operCarr !== $scope.segment.mktgCarr;
      };

      $scope.getProperCarrier = function () {
        if ($scope.isOperatedBy()) {
          return $scope.segment.operCarr;
        }

        return $scope.segment.mktgCarr;
      };

      $scope.isChangedButtonsFlow = function () {
        return appConfig.getIsChangedButtonFlowAbTest();
      }

      /**
       * Check if there is terminal change during the travel
       * @returns {boolean}
       */
      $scope.isTerminalChange = function () {
          return $scope.nextSegment && $scope.segment.getArrAirportCode() === $scope.nextSegment.getDepAirportCode() &&
              $scope.segment.getEndTerminal() !== $scope.nextSegment.getStartTerminal();
      };

      /**
       * Display comma for airport or terminal change
       * @returns {string}
       */
      $scope.placeChangeComma = function () {
          return $scope.isAirportChange() || $scope.isTerminalChange() ? ',' : '';
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/thankYou/InsuranceThPageBox.js
angular.module('flight')

/**
 * @name        insuranceThPageBox
 * @description Travel Insurance Advertisement box directive
 */
  .directive('insuranceThPageBox',
    [
      function insuranceThPageBox() {
return {
          restrict: 'EA',
          replace: true,
          templateUrl: function (element, attrs) {
            return attrs.templateUrl;
          },
          controller: 'InsuranceThPageCtrl'
        };
      }]);

;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightDetails/thankYou/flightDetailsBoxes.js
angular.module('flight')

/**
 * @name        flightDetailsBoxes
 * @description Flight details boxes directive
 */
.directive('flightDetailsBoxes',
[
function flightDetailsBoxes() {
return {
    restrict: 'E',
    scope: {
      modelPromise: '=?ngModel',
      fareRule: '=?'
    },
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    controller: "flightDetailsBoxesCtrl"
  };
}]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightPriceGroupPaxModal.js
angular.module('flight')

/**
 * @name        flightPriceGroupPaxModal
 * @description Flight price group pax modal directive
 *
 * Used on:
 * - modules/base/views/jsShared/templates/flights/priceGroup/priceGroup.php
 * - modules/base/views/jsShared/templates/base/directives/landingPages/flightsScheduleBox.php
 *
 * Template:
 * - modules/redesign/views/templates/components/flights/priceGroupPaxModal.php
 */
.directive('flightPriceGroupPaxModal',
['$location', 'Tools',
function flightPriceGroupPaxModal($location, Tools) {
return {
    restrict: 'EC',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl || "/tpl/show/jsShared/templates/flights/directives/priceGroupPaxModal";
    },
    scope: {
      /**
       * Function to execute when we click on button in modal
       */
      action: '&',
      /**
       * @type {PriceGroupPaxModal}
       */
      priceGroupPaxModal: '=',
      /**
       * @type {Number}
       */
      adtPrice: '=',
      /**
       * @type {String}
       */
      langButton: '@', // Ex. LANGM_JS_FS_DETAILS
      /**
       * optional close callback
       */
      onClose: '&?',
    },

    link: function ($scope) {
      $scope.Math = Math;

      $scope.btnClick = function () {
        if ($scope.priceGroupPaxModal.isValid()) {
          $scope.action();
        }
      };

      $scope.closeClick = function () {
        if (angular.isFunction($scope.onClose)) {
          $scope.onClose();
        }
        $scope.priceGroupPaxModal.close();
        $scope.priceGroupPaxModal.restoreDefaults();
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/flightStops.js
angular.module('flight')

  /**
   * @name        flightStops
   * @description Flight details segment directive
   */
  .directive('flightStops', ['Dictionaries', function flightStops(Dictionaries) {
return {
      restrict: 'EA',
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl;
      },
      scope: {
        /**
         * Required model for the flight price group
         *
         * @type {TBD}
         */
        leg: '=',

        /**
         * TODO: document this
         * @type {String}
         */
        flightType: '@?'
      },
      link: function ($scope) {
        /**
         * Math reference
         * TODO: why is it needed?
         * @type {Math}
         */
        $scope.Math = Math;

        /**
         * Dictionaries
         *
         * @type {Dictionaries}
         */
        $scope.dictionaries = Dictionaries;
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/orderSummary.js
angular.module('base')

/**
 * @name        orderSummary
 * @description Flight order summary(basket) directive
 */
.directive('orderSummary',
[
function orderSummary() {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl || '/tpl/show/jsShared/templates/flights/orderSummary';
    },
    scope: {
      flightBooking: '=flightBooking'
    },
    controller: 'OrderSummaryController'
  };
}]);

;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/priceGroup/flightPriceGroup.js
angular.module('flight')

/**
 * @name        flightPriceGroup
 * @description Flight price group directive
 */
    .directive('flightPriceGroup',
      ['$window', '$filter', '$modal', '$stateParams', '$location', '$document', '$rootScope', '$localStorage', 'appConfig', 'Tools', 'Preloader', 'Dictionaries', 'flt.PriceGroupPaxModal', 'sch.SearchQueryParams', 'DropZoneService', 'FavoritesSrv', 'Base64', 'sch.SearchAPI', 'Refund', '$translate',
        function flightPriceGroup($window, $filter, $modal, $stateParams, $location, $document, $rootScope, $localStorage, appConfig, Tools, Preloader, Dictionaries, PriceGroupPaxModal, sqp, DropZoneService, FavoritesSrv, Base64, SearchAPI, Refund, $translate) {
var doc = angular.element(document);

        return {
          restrict: 'E',
          replace: true,
          templateUrl: function (element, attrs) {
            return attrs.templateUrl || '/tpl/show/jsShared/templates/flights/priceGroup/priceGroup';
          },
          scope: {
            priceGroup: '=?ngModel',
            requestId: '=requestId',
            numberOfPassengers: '=',
            resetSelection: '=',
            product: '@',
            index: '<'
          },

          link: function ($scope, element, attrs) {
            $scope.product = $scope.product || 'flight';

            $scope.isTablet = appConfig.isTablet();

            var priceGroupPaxModal = $scope.priceGroupPaxModal = new PriceGroupPaxModal();

            var translator = $filter('translate');

            var addingState = false;

            var device = appConfig.getDeviceType();

            var refundTotalPrice = $scope.priceGroup.getRefundTotalPrice();

            var totalPrice = $scope.priceGroup.getTotalPrice();

            var prepareGAData = function () {
              var object = [
                $scope.priceGroup.getDepartureDate(),
                $scope.priceGroup.getReturnDate(),
                $scope.priceGroup.isOneWay() ? 'OW' : 'RT',
                $scope.priceGroup.getDepCarriers().concat($scope.priceGroup.getRetCarriers()).join('-').toLowerCase(),
                $scope.priceGroup.getDepAirportCode() + '-' + $scope.priceGroup.getRetAirportCode(),
                $scope.priceGroup.getPaxCount(),
                $scope.priceGroup.getRefundTotalPrice(),
                $scope.priceGroup.getRefundPrice()
              ];
              return object.join('|');
            };

            var saveRefundSelection = function (toogle) {
              Refund.saveSelection($scope.priceGroup.id, toogle);
            };

            $scope.Math = Math;

            $scope.favExist = false;

            $scope.detailsLang = translator('LANGM_JS_FS_DETAILS');

            $scope.dictionaries = Dictionaries;

            $scope.rootScope = $rootScope;

            if (device.tablet || device.mobile) {
              $scope.isDevice = true;
            }

            /**
             * @param {Object} params
             * @param {Object} params.$event
             * @param {String} type
             */
            $scope.clickDetailsBtn = function (params, type) {
              params.$event.stopPropagation();
              //hide search bar
              $rootScope.searchBarVisible = false;

              if (type === 'noRefund' && !$rootScope.isCalendarPage) {
                if (typeof ga != 'undefined') {
                  ga('send', 'event', 'RefundableFlow', 'Non_RefundableFlowWasClicked_on_search', prepareGAData(), 1);
                }
                saveRefundSelection(false);
                $scope.showFlightDetails();
              }

              if ($rootScope.isCalendarPage) {
                $scope.priceGroup.paxModalAdtPrice = type === 'refund' ? refundTotalPrice : totalPrice;
                saveRefundSelection(type === 'refund');
                // Tracking Tab Click
                if (typeof ga != 'undefined') {
                  ga('send', {
                    hitType: 'event',
                    eventCategory: 'Flight_Calendar_Page',
                    eventAction: 'Trip_Details_Click',
                    nonInteraction: true
                  });
                }
                priceGroupPaxModal.open();
                doc.bind('click touchstart', function close () {
                  priceGroupPaxModal.close();
                  doc.unbind('click touchstart', close);
                  $scope.$digest();
                });
              }
            };

            $scope.closest = function (el, selector) {
              var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

              while (el) {
                if (matchesSelector.call(el, selector)) {
                  break;
                }
                el = el.parentElement;
              }
              return el;
            };

            /**
             * Click Compare BTN
             */
            $scope.clickCompareBtn = function () {
              var checkItem = $scope.checkFavorites();
              var baseId = '';

              if ($scope.priceGroup.routes[1]) {
                baseId = Base64.encode($scope.priceGroup.id + $scope.priceGroup.routes[0].selectedLeg.id + $scope.priceGroup.routes[1].selectedLeg.id);
              }
              else {
                baseId = Base64.encode($scope.priceGroup.id + $scope.priceGroup.routes[0].selectedLeg.id);
              }
              if (!addingState && !checkItem) {
                addingState = true;
                var reqData = {};
                reqData.requestId = $scope.requestId;
                reqData.priceGroupId = $scope.priceGroup.id;
                reqData.depLegId = $scope.priceGroup.routes[0].selectedLeg.id;
                reqData.base64Id = baseId;

                if ($scope.priceGroup.routes[1]) {
                  reqData.retLegId = $scope.priceGroup.routes[1].selectedLeg.id;
                }

                if ($scope.priceGroup.discount.coupons.length > 0) {
                  reqData.discountId = $scope.priceGroup.discount.coupons[0].campaign.id;
                  reqData.discountValue = $scope.priceGroup.discount.coupons[0].value;
                  reqData.discountInfo = $scope.priceGroup.discount.coupons[0].campaign;
                }

                reqData.flightStorageUniqueId = $scope.priceGroup.fsId;
                reqData.type = 'flights';
                reqData.ngData = 1;

                SearchAPI.prepareBasketForPGr($scope.requestId, $scope.priceGroup, {}).then(function (response) {
                  reqData.link = response.basketUrl;
                  reqData.priceGroupId = response.priceGroup.pgIdDecode;
                  reqData.depLegId = response.priceGroup.depLegIdDecode;
                  if (response.priceGroup.retLegIdDecode) {
                    reqData.retLegId = response.priceGroup.retLegIdDecode;
                  }

                  DropZoneService.add(reqData).then(function (results) {
                    $rootScope.showFavBar = true;
                    $rootScope.showlastSearchesBar = false;
                    var addedFav = FavoritesSrv.sortResults(results).splice(0, 1)[0];
                    if (addedFav) {
                      $rootScope.favorites.unshift(addedFav);
                    }
                    $scope.favExist = true;
                    addingState = false;
                  }, function () {
                    console.warn(data);
                    addingState = false;
                  });
                });
              }
              else {
                if (!addingState && checkItem) {
                  addingState = true;
                  $rootScope.favorites = _.reject($rootScope.favorites, function (val) {
                    return val.baseId == baseId;
                  });
                  if ($rootScope.favorites.length == 0) {
                    $rootScope.showFavBar = false;
                  }

                  DropZoneService.deleteItem(checkItem).then(function (res) {
                    addingState = false;
                    $scope.favExist = false;
                  }, function () {
                    addingState = false;
                  });
                }
              }
            };

            /**
             * Check fav existing
             */
            $scope.checkFavorites = function () {
              $scope.favExist = FavoritesSrv.checkFlightsFavorites($scope.priceGroup);
              return $scope.favExist;
            };

            $scope.checkFavorites();

            /**
             * Watch for change legs for departure and return
             */
            if ($scope.priceGroup.routes[1] && $scope.priceGroup.routes[0]) {
              $scope.$watchGroup(['priceGroup.routes[0].selectedLeg.id', 'priceGroup.routes[1].selectedLeg.id'], function () {
                $scope.checkFavorites();
              });

            }

            /**
             *  Change status on mouseOver
             *
             */
            $scope.mouseHoverStatus = function (event) {
              if (event == 'enter') {
                $scope.mouseHover = true;
              }
              if (event == 'leave') {
                $scope.mouseHover = false;
              }
            };

            /**
             * Get number of tab
             */
            var getTabNumber = function () {
              var tab = 1;
              if ($rootScope.isCalendarPage) {
                tab = 3;
              }
              else {
                if ($rootScope.isFlexPage) {
                  tab = 2;
                }
                else {
                  if (!$rootScope.searchComplited) {
                    $rootScope.forceReloadSearch = true;
                    tab = 4;
                  }
                }
              }
              return tab;
            };

            /**
             * Redirects to flight details / flight search of the selected legs
             */
            $scope.clickModalBtn = function () {
              if ($scope.priceGroupPaxModal.adults != $scope.priceGroupPaxModal.count()) {
                if (!$scope.priceGroupPaxModal.isValid()) {
                  return;
                }
                var depDate = $scope.priceGroup.getDepRoute().getBestLeg().getFirstSegment().getDepDateMoment().format('YYYY-MM-DD'),
                  retDate = $scope.priceGroup.isOneWay() ? depDate : $scope.priceGroup.getRetRoute().getBestLeg().getLastSegment().getDepDateMoment().format('YYYY-MM-DD'),
                  depCity = $scope.priceGroup.getDepRoute().getBestLeg().getDepCityCode(),
                  arrCity = $scope.priceGroup.getDepRoute().getBestLeg().getArrCityCode();

                sqp.setAdults($scope.priceGroupPaxModal.adults);
                sqp.setChildren($scope.priceGroupPaxModal.children);
                sqp.setInfants($scope.priceGroupPaxModal.infants);
                sqp.setYouths($scope.priceGroupPaxModal.youth);
                sqp.setDepDate(depDate);
                sqp.setRetDate(retDate);
                sqp.setDepCityCode(depCity);
                sqp.setDesCityCode(arrCity);

                sqp.saveToStorage();
                $localStorage.$apply();
                var newLocation = sqp.generateUrl();

                if (newLocation == $location.path()) {
                  $window.location.reload();
                } else {
                  $location.path(newLocation);
                }
                return;
              } else {
                if (!$scope.priceGroupPaxModal.isValid()) {
                  return;
                }

                var params = {
                  recalculatePaxCount: 1,
                  adt: $scope.priceGroupPaxModal.adults,
                  chd: $scope.priceGroupPaxModal.children,
                  inf: $scope.priceGroupPaxModal.infants,
                  sen: $scope.priceGroupPaxModal.seniors,
                  tab: getTabNumber()
                };

                SearchAPI.prepareBasketForPGr($scope.requestId, $scope.priceGroup, params).then(function (response) {
                  Refund.saveSelection(response.priceGroup.pgIdDecode, Refund.loadSelection($scope.priceGroup.id));
                  $location.path(response.basketUrl);
                });
              }
            };

            /**
             * Redirects to flight details of the selected legs
             */
            $scope.showFlightDetails = function () {
              /**
               * Go to flight details page
               */
              SearchAPI.prepareBasketForPGr($scope.requestId, $scope.priceGroup, {tab: getTabNumber()}).then(function (response) {
                Refund.saveSelection(response.priceGroup.pgIdDecode, Refund.loadSelection($scope.priceGroup.id));
                $location.path(response.basketUrl);
              });
            };

            /**
             * Show price per one pax
             */
            $scope.showPricePerPax = function () {
              return false;
            };

            /**
             * Closing pax modal
             */
            $scope.closeModal = function () {
              $scope.priceGroupPaxModal.close();
            };
          }
        };
      }]);
;

// Source: ../shared/public_html/assets/js/flight/directives/desktop/priceGroup/priceGroupPricing.js
angular.module('flight')

/**
 * @name        priceGroupPricing
 * @description Flight price group pricing directive
 */
  .directive('priceGroupPricing', [function priceGroupPricing() {
return {
      restrict: 'E',
      replace: true,
      templateUrl: function (element, attrs) {
        return attrs.templateUrl;
      }
    };
  }]);
;

// Source: ../shared/public_html/assets/js/flight/directives/disableStickyBox.js
angular.module('flight')

    /**
     * @name        disableStickyBox
     * @description disable sticky on to small devices
     */
    .directive('disableStickyBox',
    ['$window',
        /**
         * @param $window
         */
        function disableStickyBox($window) {
return {
                restrict: 'A',
                link: function (scope, element, attribute) {
                    var watchResize = function () {
                        scope.isDisableSticky = true;
                        var windowsSize = $window.innerHeight;
                        var elementSize = element[0].offsetHeight;
                        var navHeight = 100;
                        scope.isDisableSticky = (windowsSize - elementSize - navHeight) <= 0;
                    }

                    watchResize();
                    angular.element($window).bind('resize', function () {
                        watchResize();
                        scope.$digest();
                    });
                }
            };
        }]);

;

// Source: ../shared/public_html/assets/js/flight/directives/funnelSteps.js
angular.module('flight')

.directive('funnelSteps', ['bok.FlightBooking','sch.SearchQueryParams', 'funnelStepsObserver', function(FlightBooking,SearchQueryParams,stepsObserver) {
var link = function(scope, elem, attrs, ctrl) {
    /**
     * Get details step URL
     *
     * @returns {String}
     * @todo replace this with something that's not so tightly coupled to specific URLs
     */
    scope.states = [];
    scope.unsubscribe =  stepsObserver.subscribe(function(statesArray){

      var steps = statesArray.processSteps;
      var NavState = function(name, calculateCssClass){
        this.name = 'LANGM_JS_FANNEL_' + name ;
        this.additionalCssClass = null;
        if(calculateCssClass){
          this.additionalCssClass =  statesArray.currentState == name ?  'activeStep' : 'disableStep';
        }
      };

      scope.firstNav = new NavState(steps[0]);
      scope.secondtNav = new NavState(steps[1],true);
      scope.lastNav = new NavState(steps[2], true);

    });
    var _getDetailsUrl = function() {
      var activeLink = scope.activeLink + '';
      return activeLink.replace('paxDetails', 'flightDetails');
    };

    /**
     * Back to details
     * @returns {*|undefined}
     * @todo replace this $digest-level getter method with a stabilized value
     */
    scope.funnelToSearch = function () {

      if (SearchQueryParams.getBaseSearchUrl()) {
        return SearchQueryParams.getBaseSearchUrl();
      }

      if (FlightBooking.flightDetails && FlightBooking.flightDetails.searchUrl) {
        return FlightBooking.flightDetails.searchUrl;
      }
    };

    scope.linkToDetails = _getDetailsUrl();
  };

  return {
    restrict: 'A',
    link: link
  };
}]);
;

// Source: ../shared/public_html/assets/js/flight/models/CheapestFlightsRequestParams.model.js
(function (angular, underscore) {

    var CheapestFlightsRequestParamsModel = function () {
        var CheapestFlightsRequestParams = function () {
            this.params = [];
        };

        /**
         * Adds a new parameter
         *
         * @param {string} key
         * @param {string} value
         */
        CheapestFlightsRequestParams.prototype.add = function (key, value) {
            var entry = {};
            entry[key] = value;

            this.params.push(entry);
        };

        /**
         * Creates URL query string from all the parameters
         *
         * @returns {string}
         */
        CheapestFlightsRequestParams.prototype.getQueryString = function () {
            return underscore
                .map(this.params, function (entry) {
                    return Object.keys(entry)[0] + '=' + Object.values(entry)[0];
                })
                .join('&');
        };

        CheapestFlightsRequestParams.prototype.constructor = CheapestFlightsRequestParams;

        return CheapestFlightsRequestParams;
    };

    angular
        .module('flight')
        .service('CheapestFlightsRequestParams', CheapestFlightsRequestParamsModel);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flight/models/LoadingScreen.js
angular.module('flight')

/**
 * @name        LoadingScreen
 * @namespace   flt
 * @description Factory returning LoadingScreen constructor
 */
  .factory('flt.LoadingScreen',
  [

    /**
     * LoadingScreen class
     *
     * @return {LoadingScreen}
     */
    function LoadingScreenFactory() {
/**
       * LoadingScreen constructor
       *
       * @class LoadingScreen
       * @constructor
       */
      var LoadingScreen = function () {
        /**
         * @type {LoadingScreenCarrier[]}
         */
        this.carriers = [];
      };

      // Add instance methods
      LoadingScreen.prototype = /** @lends LoadingScreen.prototype */ {

        /**
         * @returns {LoadingScreenCarrier[]}
         */
        getCarriers: function() {
          return this.carriers;
        },

        /**
         * @param {String} code
         * @returns {LoadingScreenCarrier|undefined}
         */
        getCarrierByCode: function(code) {
          return this.carriers.filter(function(carrier) {
            return carrier.code === code;
          })[0];
        },

        /**
         * @param {LoadingScreenCarrier[]} carriers
         */
        addCarriers: function(carriers) {
          this.carriers = _.unique(this.carriers.concat(carriers));
        },

        /**
         * @param {Number} limit
         */
        limitCarriers: function(limit) {
          this.carriers = this.carriers.slice(0, limit);
        },

        /**
         * @returns {Number}
         */
        countCarriers: function() {
          return this.carriers.length;
        }

      };

      LoadingScreen.prototype.constructor = LoadingScreen;

      return LoadingScreen;
    }]);
;

// Source: ../shared/public_html/assets/js/flight/models/LuggageRule.js
angular.module('flight')

/**
 * @name        LuggageRule
 * @namespace   flt
 * @description Class holding information about luggage rules
 */
.factory('flt.LuggageRule',
[
function LuggageRuleFactory() {
/**
   * LuggageRule
   *
   * @class LuggageRule
   * @constructor
   *
   * @param {Object} info    The response luggage rule object
   * @param {Leg}    leg     The leg this luggage rule belongs to
   * @param {Number} index   The index of the luggage rule in response lug array
   */
  var LuggageRule = function (info, leg, index) {

    /**
     * Passenger type
     *
     * @type {String}
     */
    this.paxType = info.pax_type;

    /**
     * Cabin luggage rules
     *
     * @type {String}
     */
    this.cabin = info.cabin || '';

    /**
     * Registered luggage rules
     *
     * @type {String}
     */
    this.registered = info.registered || '';

    /**
     * The index of the luggage rule in response lug array
     *
     * @var {Number}
     */
    this.index = index;

    /**
     * The leg this luggage rule belongs to
     *
     * @type {Leg}
     */
    this.leg = leg;
  };

  // Set instance methods
  LuggageRule.prototype = /** @lends LuggageRule.prototype */ {

    /**
     * Get pax type
     *
     * @return {String}
     */
    getPaxType: function () {
      return this.paxType;
    },

    /**
     * Get cabin luggage rules
     *
     * @return {String}
     */
    getCabin: function () {
      return this.cabin;
    },

    /**
     * Get registered luggage rules
     *
     * @return {String}
     */
    getRegistered: function () {
      return this.registered;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      return {
        pax: this.getPaxType(),
        cab: this.getCabin(),
        reg: this.getRegistered(),
      };
    },

  };

  LuggageRule.prototype.constructor = LuggageRule;

  return LuggageRule;
}]);
;

// Source: ../shared/public_html/assets/js/flight/models/TestSell.js
(function (angular, underscore) {
/**
     * @name testSellResponse
     * @type {{
     *  SOOW: bool,
     *  addToBlackList: bool,
     *  verificationTime: int,
     *  description: string
     *  checkinOptions: Array,
     *  status: number
     * }}
     */
    var TestSellFactory = function TestSellFactory(Base64, TEST_SELL_STATUSES, AnalyticsServiceHelper, $q, ErrorMixin, SouthParkApi, $timeout) {

        var
            /**
             * TestSell
             *
             * @constructor
             */
            TestSell = function (booking) {
                this.booking = booking;

                /**
                 * The IBE request id
                 *
                 * @type {String}
                 */
                this.requestId = '';

                /**
                 * The price group id
                 *
                 * @type {String}
                 */
                this.priceGroupId = '';

                /**
                 * The departure leg id we are doing test sell for
                 *
                 * @type {String}
                 */
                this.depLegId = '';

                /**
                 * The return leg id we are doing test sell for
                 *
                 * The null value will be for one ways flights
                 *
                 * @type {String|null}
                 */
                this.retLegId = '';

                /**
                 * Test sell note
                 *
                 * @type {String}
                 */
                this.testSellNote = '';

                /**
                 * The status of the test sell
                 *
                 * @type {Number}
                 */
                this.status = TEST_SELL_STATUSES.NOT_DONE;

                /**
                 * Promotion id
                 *
                 * @type {Boolean|Number}
                 */
                this.promId = false;

                /**
                 * The status human readable description
                 *
                 * @type {String}
                 */
                this.description = '';

                /**
                 * Test sell verification time
                 * @type {int}
                 */
                this.verificationTime = 0;

                /**
                 * Test sell verification id
                 *
                 * @type {String}
                 */
                this.verificationId = '';

                /**
                 * Add price group to black list
                 *
                 * @type {Boolean}
                 */
                this.addToBlacklist = false;

                /**
                 * Blacklist id
                 *
                 * @type {Number}
                 */
                this.blackListId = 0;


                this.newPrice = 0;

                /**
                 * The price diff after test sell
                 *
                 * @type {Number}
                 */
                this.priceDiff = 0;

                /**
                 * The amount how much price diff is reduced due to smartPriceDiff
                 *
                 * @type {Number}
                 */
                this.priceDiffAdjustment = 0;

                /**
                 * PNR number
                 *
                 * @type {String|Integer}
                 */
                this.pnrNo = '';

                /**
                 * Auto ticket
                 *
                 * @type {Number}
                 */
                this.autoTicket = 0;

                /**
                 * The instance of FlightDetails that was used to do this test sell
                 *
                 * @type {FlightDetails}
                 */
                this.flightDetails = null;

                /**
                 * Set to true if test sell is already in progress
                 *
                 * @type {Boolean}
                 */
                this.inProgress = false;

                /**
                 * Default test sell version
                 *
                 * @type {Number}
                 */
                this.version = 0;

                /**
                 * Test sell true version
                 * Default: 3 (no test sell)
                 *
                 * @type {Number}
                 */
                this.trueVersion = 3;

                /**
                 * Is flight white listed?
                 *
                 * @type {Boolean}
                 */
                this.isWhiteListed = false;

                /**
                 * Is flight white listed?
                 *
                 * @type {Array}
                 */
                this.sellingUnits = [];

                /**
                 * Errors object
                 *
                 * Used in templates to mark error fields and show error messages
                 * The keys are filed names and values are error messages or instances.
                 *
                 * Example:
                 *
                 * {
                 *  property_name: "error message",
                 *  property_with_some_instance: that instance
                 * }
                 *
                 * @type {Object}
                 */
                this.errors = {};
            };

        // Add instance methods
        TestSell.prototype = /** @lends TestSell.prototype */ {
            /**
             * Resets test sell object to default state
             *
             * @return {TestSell}
             */
            reset: function () {
                this.requestId = '';
                this.priceGroupId = '';
                this.depLegId = '';
                this.retLegId = '';
                this.testSellNote = '';
                this.status = TEST_SELL_STATUSES.NOT_DONE;
                this.promId = false;
                this.description = '';
                this.verificationTime = 0;
                this.addToBlacklist = false;
                this.blackListId = 0;
                this.newPrice = 0;
                this.priceDiff = 0;
                this.priceDiffAdjustment = 0;
                this.pnrNo = '';
                this.autoTicket = 0;
                this.flightDetails = null;
                this.inProgress = false;
                this.version = 0;
                this.trueVersion = 3;
                this.isWhiteListed = false;
                this.errors = {};
                this.sellingUnits = [];

                return this;
            },

            /**
             * Do test sell
             *
             * @param {String}      requestId
             * @param {String}      priceGroupId
             * @param {String}      depLegId
             * @param {String|null} retLegId
             * @param {String|null} fulfillmentToken
             *
             * @return {Promise}
             */
            doTestSell: function (requestId, priceGroupId, depLegId, retLegId, fulfillmentToken) {
                var
                /**
                 * @type {Object}
                 */
                    requestData = {},
                    self = this,

                    /**
                 * @type Deferred
                 */
                    deferred;

                this.inProgress = true;

                // We already have this test sell data
                if (this.requestId === requestId && this.priceGroupId === priceGroupId && this.depLegId === depLegId && this.retLegId === retLegId) {
                    deferred = $q.defer();
                    this.inProgress = false;
                    deferred.resolve(this);
                    return deferred.promise;
                }

                // Set instance values
                this.requestId = requestId;
                this.priceGroupId = priceGroupId;
                this.depLegId = depLegId;
                this.retLegId = retLegId;

                requestData.requestId = requestId;
                requestData.priceGroupId = Base64.encode(priceGroupId);
                requestData.depLegId = Base64.encode(depLegId);

                // Handle one ways
                requestData.retLegId = retLegId !== null ? Base64.encode(retLegId) : null;

                return SouthParkApi.initTestSell(decodeURIComponent(fulfillmentToken), requestData.requestId, requestData.priceGroupId)
                    .then(function (tsInitResult) {
                        if (tsInitResult.data.response.state === 'DONE') {
                            self.resolveVerificationData(tsInitResult.data.response);
                            AnalyticsServiceHelper.sendTestSellFinished(self.booking);
                            return $q.reject();
                        }

                        var verificationId = tsInitResult.data.response.verificationId;
                        self.verificationId = verificationId;
                        requestData.verificationId = verificationId;
                        return self.pollTestSell(verificationId, fulfillmentToken, requestData);
                    }, function (error) {
                        self.status = TEST_SELL_STATUSES.NO_SEATS;
                        self.setInProgress(false);
                        self.resolveVerificationData(null);
                        return $q.reject(error);
                    })
                    .then(function () {
                        return SouthParkApi.finishTestSell(requestData);
                    }, function (error) {
                        if (error && error.status === 'TS_TIMEOUT') {
                            return SouthParkApi.finishTestSellTimeout(requestData);
                        }
                        return $q.reject(error);
                    })
                    .then(function (legacyTsResult) {
                        self.resolveVerificationData(legacyTsResult.data.response);
                        AnalyticsServiceHelper.sendTestSellFinished(self.booking);
                        var respParser = angular.bind(self, testSellParser);
                        return respParser(legacyTsResult.data);
                    });
            },

            pollTestSell: function (verificationId, fulfillmentToken, requestData) {
                var retiesLeft = 45;
                var retryDelay = 2000;
                var self = this;
                return $q(function (resolve, reject) {
                    var attempt = function () {
                        SouthParkApi.pollTestSell(verificationId, fulfillmentToken, requestData).then(function (tsPollResponse) {
                            self.resolveVerificationData(tsPollResponse.data.response);

                            if (tsPollResponse.data.response.state === 'DONE') {
                                resolve();
                            } else if (retiesLeft > 0) {
                                retiesLeft -= 1;
                                $timeout(attempt, retryDelay);
                            } else {
                                self.resolveVerificationData({ state: 'DONE' });
                                reject({status: 'TS_TIMEOUT', msg: 'Test-sell timed out after 45 polls'});
                            }
                        }, reject);
                    };
                    attempt();
                });
            },

            /**
             * Helper method to do test sell where parameter is an instance of FlightDetails
             *
             * @param {FlightDetails} flightDetails
             */
            doTestSellFD: function (flightDetails) {
                var retLegId = null, retLeg = flightDetails.getRetLeg();

                if (retLeg) {
                    retLegId = retLeg.getId();
                }

                // Save flight details we used to do this test sell
                this.flightDetails = flightDetails;

                return this.doTestSell(
                    flightDetails.getRequestId(),
                    flightDetails.getPriceGroupId(),
                    flightDetails.getDepLeg().getId(),
                    retLegId,
                    flightDetails.getFulfillmentToken()
                );
            },

            /**
             * Set initial test sell data from flight details
             *
             * @param {Object} data The test sell data
             * @param {string} verificationId
             *
             * @return {TestSell}
             */
            setInitialTestSell: function (data, verificationId) {
                if (!data) {
                    // In this case we got data from booking page and
                    // we have no test sell
                    return this;
                }

                // Set blocking of credit card form
                this.verificationId = verificationId;

                // Set blocking of credit card form
                this.setVerificationTime(data.verificationTime);

                // Set if flight is white listed
                this.setWhiteListed(data.flightIsWhiteListed);

                if (data.hasOwnProperty('priceDiff')) {
                    // Set price difference
                    this.setPriceDiff(data.priceDiff);
                }

                if (data.hasOwnProperty('priceDiffAdjustment')) {
                    // Set price difference adjust
                    this.setPriceDiffAdjustment(data.priceDiffAdjustment);
                }

                // Set status
                this.setStatus(data.status);

                // Set version
                this.setVersion(data.version);

                // Set true version
                this.setTrueVersion(data.true_version);

                // set unit opts
                this.setSellingUnits(data.sellingUnits);

                // Adjust parameters
                this._adjustParameters();

                return this;
            },

            /**
             * Get test sell price diff
             *
             * @return {Number}
             */
            getPriceDiff: function () {
                return this.priceDiff;
            },

            getNewPrice: function () {
                return this.newPrice;
            },

            /**
             * Get test sell price diff adjust
             *
             * @return {Number}
             */
            getPriceDiffAdjustment: function () {
                return this.priceDiffAdjustment;
            },

            /**
             * Set price diff
             *
             * @param {float} priceDiff
             *
             * @return {TestSell}
             */
            setPriceDiff: function (priceDiff) {
                this.priceDiff = priceDiff;

                return this;
            },

            setNewPrice: function (newPrice) {
                this.newPrice = newPrice;
                return this;
            },

            /**
             * Set price diff adjust
             *
             * @param {float} priceDiffAdjustment
             *
             * @return {TestSell}
             */
            setPriceDiffAdjustment: function (priceDiffAdjustment) {
                this.priceDiffAdjustment = priceDiffAdjustment || 0;
                return this;
            },

            /**
             * Is flight white listed?
             *
             * @return {Boolean}
             */
            getWhiteListed: function () {
                return this.isWhiteListed;
            },

            /**
             * Set white list status
             *
             * @param {Boolean} isWhiteListed
             *
             * @return {TestSell}
             */
            setWhiteListed: function (isWhiteListed) {
                this.isWhiteListed = isWhiteListed;

                return this;
            },

            /**
             * Is flight white listed?
             *
             * @return {Array}
             */
            getSellingUnits: function () {
                return this.sellingUnits;
            },

            /**
             * Set white list status
             *
             * @param {Array} sellingUnits
             *
             * @return {TestSell}
             */
            setSellingUnits: function (sellingUnits) {
                this.sellingUnits = sellingUnits;

                return this;
            },

            /**
             * Get test sell version
             *
             * @return {Number}
             */
            getVersion: function () {
                return this.version;
            },

            /**
             * Set test sell version
             *
             * @param {Number} version
             *
             * @return {TestSell}
             */
            setVersion: function (version) {
                this.version = version;

                return this;
            },

            /**
             * Set test sell true version
             *
             * @param {Number} trueVersion
             *
             * @return {TestSell}
             */
            setTrueVersion: function (trueVersion) {
                this.trueVersion = trueVersion;

                return this;
            },

            /**
             * Returns true if test sell is in progress
             *
             * @return {Boolean}
             */
            isInProgress: function () {
                return this.inProgress;
            },

            /**
             * set test sell is in progress
             *
             * @return {Boolean}
             */
            setInProgress: function (bool) {
                this.inProgress = !!bool;
            },

            /**
             * @return {int}
             */
            getVerificationTime: function () {
                return this.verificationTime;
            },

            /**
             * @param {int} verificationTime
             *
             * @return {TestSell}
             */
            setVerificationTime: function (verificationTime) {
                this.verificationTime = verificationTime;

                return this;
            },
            /**
             * Set blacklist id
             *
             * @param {Number} id
             *
             * @return {TestSell}
             */
            setBlackListId: function (id) {
                this.blackListId = id;

                return this;
            },

            /**
             * Set PNR number
             *
             * @param {String} pnr
             *
             * @return {TestSell}
             */
            setPnrNo: function (pnr) {
                this.pnrNo = pnr;

                return this;
            },

            /**
             * Get test sell status
             *
             * @return {Number}
             */
            getStatus: function () {
                return this.status;
            },

            /**
             * Set test sell status
             *
             * @param {Number} status
             *
             * @return {TestSell}
             */
            setStatus: function (status) {
                // If status is undefined we set it to -1
                this.status = +status || TEST_SELL_STATUSES.NOT_DONE;
                return this;
            },

            isLower: function () {
                return this.status === TEST_SELL_STATUSES.LOWER_PRICE;
            },

            /**
             * Set auto ticketing
             *
             * @param {Number} autoTicket
             *
             * @return {TestSell}
             */
            setAutoTicket: function (autoTicket) {
                this.autoTicket = autoTicket;
                return this;
            },

            /**
             * Returns if flight can be autocketed or not
             *
             * @return {Number}
             */
            getAutoTicket: function () {
                return this.autoTicket;
            },

            /**
             * Returns test sell note
             *
             * @return {String}
             */
            getTestSellNote: function () {
                return this.testSellNote;
            },

            /**
             * Returns if test sell note is strong
             *
             * @return {Boolean}
             */
            isStrongDiff: function () {
                return (this.getTestSellNote() == 'strong');
            },

            hasPriceDiffOrNoSeats: function () {
                return [
                    TEST_SELL_STATUSES.HIGHER_PRICE,
                    TEST_SELL_STATUSES.LOWER_PRICE,
                    TEST_SELL_STATUSES.NO_SEATS
                ].includes(this.getStatus());
            },

            setStatusNoSeats: function () {
                this.setStatus(TEST_SELL_STATUSES.NO_SEATS);
                return this;
            },

            setStatusDone: function () {
                this.setStatus(TEST_SELL_STATUSES.DONE);
                return this;
            },

            enableAutoticket: function () {
                this.setAutoTicket(1);
                return this;
            },

            /**
             * Resolves verification data
             *
             * @param {Object} verificationData
             */
            resolveVerificationData: function (verificationData) {
                this.flightDetails.verificationHandler.setVerificationData(verificationData);
                this.booking.luggageHandler.populate();
            },

            /**
             * Adjusts autoTicket and status parameters after test sell response
             * These are required in this form for the desktop version booking process
             */
            _adjustParameters: function () {
                if (this.getVersion() === 0) {
                    this.setStatusDone();
                }

                var autoTicketValue = (this.getStatus() === TEST_SELL_STATUSES.DONE) ? 1 : 0;
                this.setAutoTicket(autoTicketValue);
            },

            /**
             * Returns this instance as simple object for communicating with API
             *
             * @return {Object}
             */
            srvObj: function () {
                return {
                    'add_to_blacklist': this.addToBlacklist,
                    'price_diff': this.priceDiff,
                    'status': this.status,
                    'prom_id': this.promId,
                    'ts_note': this.testSellNote,
                    'black_list_id': this.blackListId,
                    'pnr_no': this.pnrNo,
                    'auto_ticket': this.autoTicket,
                    'version': this.trueVersion,
                    'verificationTime': this.verificationTime,
                    'verificationId': this.verificationId
                };
            },

            /**
             * Set errors form server
             *
             * @param errors
             *
             * @return {TestSell}
             */
            srvErrors: function (errors) {
                // Reset errors
                this.resetErrors();

                // If errors is not an object we bail out
                if (!underscore.isObject(errors)) errors = {};

                // TODO

                return this;
            }
        };

        /**
         * Process test sell server response
         *
         * @private
         * @param {apiResponse}      response
         * @param {testSellResponse} response.response
         *
         * @return {TestSell}
         */
        function testSellParser(response) {
            var resp = (response.response) ? response.response : response;

            this.addToBlacklist = resp.addToBlackList || this.addToBlacklist;
            this.blackListId = resp.blackListId || this.blackListId;
            this.verificationTime = resp.verificationTime || this.verificationTime;
            this.description = resp.description || this.description;
            this.testSellNote = resp.TSNote || this.testSellNote;
            this.status = +resp.status || this.status;
            this.priceDiff = resp.priceDiff || this.priceDiff;
            this.newPrice = resp.newPrice || this.newPrice;
            this.priceDiffAdjustment = resp.priceDiffAdjustment || this.priceDiffAdjustment;
            this.promId = resp.promId || this.promId;
            this.pnrNo = resp.pnr_no || this.pnrNo;
            this.sellingUnits = resp.sellingUnits || resp.unitOptions || this.sellingUnits;

            // Adjust parameters
            this._adjustParameters();

            this.inProgress = false;

            return this;
        }

        TestSell.prototype.constructor = TestSell;

        // Add mixins
        underscore.extend(TestSell.prototype, ErrorMixin);

        // Return constructor
        return TestSell;
    };

    TestSellFactory.$inject = [
        'Base64',
        'TEST_SELL_STATUSES',
        'AnalyticsServiceHelper',
        '$q',
        'ErrorMixin',
        'SouthParkApi',
        '$timeout',
    ];

    /**
     * @name        TestSell
     * @namespace   flt
     * @description Class holding flight test sell information
     */
    angular.module('flight')
        .factory('flt.TestSell', TestSellFactory);

})(angular, _);
;

// Source: ../shared/public_html/assets/js/flight/models/UnitOpts.js
/* global _: false */

angular.module('flight')

/**
 * @name        UnitOpts
 * @namespace   fdt
 * @description Class that describes a unit selectable options
 */
.factory('fdt.UnitOpts',
['bok.Baggage', '$filter', 'CONST',
function UnitOptsFactory(Baggage, $filter, CONST) {
/**
   * UnitOpts constructor
   *
   * @constructor
   * @class UnitOpts
   */
  var UnitOpts = function (unit) {
    /**
     * unitId
     *
     * @type {String}
     */
    this.unitId = unit.unitId;

    /**
     * From Code
     *
     * @type {String}
     */
    this.fromCode = unit.fromCode;

    /**
     * To Code
     *
     * @type {String}
     */
    this.toCode = unit.toCode;

    /**
     * To Code
     *
     * @type {String}
     */
    this.route = unit.route;

    /**
     * To Code
     *
     * @type {Array}
     */
    this.drawTypes = unit.drawTypes;

    /**
     * Baggage options
     *
     * @type {Object}
     */
    this.baggageOptions = unit.baggageOptions;

    /**
     * Hand baggage options
     *
     * @type {Object}
     */
    this.cabinBagOptions = unit.cabinBagOptions;

    /**
     * One select options
     *
     * @type {Object}
     */
    this.oneBaggOpts = unit.oneBaggOpts;

    /**
     * Is opt gr are related to another SU
     */
    this.optionsAlreadySelected = unit.optionsAlreadySelected;

    /**
     * Is opt gr are related to another SU
     */
    this.overrideLuggageAbility = unit.overrideLuggageAbility;

    /**
     * 0 - outbound, 1 - inbound
     */
    this.flightRoute = unit.flightRoute;

    /**
     * The carrier code
     *
     * @type {String}
     */
    this.carrier = unit.carrier || '';

    /**
     * The carriers codes
     *
     * @type {Array}
     */
    this.carriers = unit.carriers || [];
    if (_.isEmpty(this.carriers)) {
      this.carriers.push(this.carrier);
    }

    /**
     * is WizzAir airline
     *
     * @returns {boolean}
     */
    this.isWizzAir = function(){
      return this.carrier == 'W6' ? true : false;
    };

    /**
     * is gds unit
     */
    this.isGds = unit.isGds;

    /**
     * baggageRules
     *
     * @type {Object}
     */
    this.baggageRules = unit.baggageRules;

    /**
     * Airline locator.
     * 
     * @type {String}
     */
    this.airlineLocator = unit.airlineLocator;

    this.parse();
  };

  /**
   * Baggage
   *
   * @constant
   * @type {String}
   */
  UnitOpts.TYPE_BAGGAGE = 'BAGGAGE';

  /**
   * Cabin Baggage
   *
   * @constant
   * @type {String}
   */
  UnitOpts.TYPE_CABIN = 'BAGGAGE2';

  /**
   * One select baggage
   *
   * @constant
   * @type {String}
   */
  UnitOpts.TYPE_ONE_BAG = 'ONEBAG';

  /**
   * @type {String}
   */
  UnitOpts.ONE_BAG_HIDE_ID = 'ONE_BAG_HIDE_ID';

  // Add instance methods
  UnitOpts.prototype = /** @lends UnitOpts.prototype */ {
    
    /**
     * Price filter.
     * 
     * @type {Function}
     */
    filterPrice: $filter('flPriceVal'),

    /**
     * Parsing
     */
    parse: function () {
      var emptyOpt, tmpBagg = {}, tmpCabBag = {}, self = this, currency;

      this.baggageOptions.default = null;
      this.baggageOptions.isEmpty = this.baggageOptions.options.length == 0;
      this.baggageOptions.options.forEach(function (element, index, array) {
        element = new Baggage(element, Baggage.KIND_BAGGAGE);
        self.baggageOptions.options[index] = element;

        if (!element.getPrice()) {
          self.baggageOptions.default = element;
        }

        currency = element.getCurrency() != 'PLN' ? element.getCurrency() : 'zł';
        element.setDescSelect($filter('translate')('LANGM_JS_BASKET_BAGGAGE_SELECT', {
          count: element.getCount(),
          weight: element.getWeight(),
          price: self.filterPrice(element.getPrice(), 2),
          currency: currency,
          size: element.getSize()
        }));
        tmpBagg[element.id] = element;
      });
      if (!this.baggageOptions.default) {
        emptyOpt = self.getEmptyBaggOpt(Baggage.KIND_BAGGAGE);
        this.baggageOptions.options.unshift(emptyOpt);
        this.baggageOptions.default = emptyOpt;
      }


      this.cabinBagOptions.default = null;
      this.cabinBagOptions.isEmpty = this.cabinBagOptions.options.length == 0;
      this.cabinBagOptions.options.forEach(function (element, index, array) {
        element = new Baggage(element, Baggage.KIND_CABIN);
        self.cabinBagOptions.options[index] = element;

        if (!element.getPrice()) {
          self.cabinBagOptions.default = element;
        }
        currency = element.getCurrency() != 'PLN' ? element.getCurrency() : 'zł';
        element.setDescSelect($filter('translate')('LANGM_JS_BASKET_CABIN_BAGGAGE_SELECT', {
          count: element.getCount(),
          weight: element.getWeight(),
          price: self.filterPrice(element.getPrice(), 2),
          currency: currency,
          size: element.getSize()
        }));
        tmpCabBag[element.id] = element;
      });
      if (!this.cabinBagOptions.default) {
        emptyOpt = self.getEmptyBaggOpt(Baggage.KIND_CABIN);
        this.cabinBagOptions.options.unshift(emptyOpt);
        this.cabinBagOptions.default = emptyOpt;
      }


      this.oneBaggOpts.default = null;
      this.oneBaggOpts.isEmpty = this.oneBaggOpts.options.length == 0;
      if (this.oneBaggOpts.options) {
        this.oneBaggOpts.options.forEach(function (element, index, array) {
          var baggDetails = {};
          element = new Baggage(element, Baggage.KIND_ONE_BAG);
          self.oneBaggOpts.options[index] = element;

          if (!element.getPrice()) {
            self.oneBaggOpts.default = element;
          }

          var keeper = element.id.split(":"), priceKeeper = [], tmpElem, onlyCabin = true;
          if (keeper.length > 0 && keeper[0] && typeof(tmpCabBag[keeper[0]]) != 'undefined') {
            tmpElem = tmpCabBag[keeper[0]];
            baggDetails.cabBaggageCount = tmpElem.getCount();
            baggDetails.cabBaggageWeight = tmpElem.getWeight();
            baggDetails.cabBaggageSize = tmpElem.getSize();
            baggDetails.currency = tmpElem.getCurrency();
            priceKeeper.push(tmpElem.getPrice());
            //desc.push(tmpElem.getName() + ' ' + tmpElem.getCount() + 'x' + tmpElem.getWeight() + 'kg');
            //currKeeper = tmpElem.getCurrency();
          }
          if (keeper.length > 1 && keeper[1] && typeof(tmpBagg[keeper[1]]) != 'undefined') {
            onlyCabin = false;
            tmpElem = tmpBagg[keeper[1]];
            baggDetails.baggageCount = tmpElem.getCount();
            baggDetails.baggageWeight = tmpElem.getWeight();
            baggDetails.baggageSize = tmpElem.getSize();
            baggDetails.currency = tmpElem.getCurrency();
            priceKeeper.push(tmpElem.getPrice());
            //desc.push(' + ' + tmpElem.getName() + ' ' + tmpElem.getCount() + 'x' + tmpElem.getWeight() + 'kg');
            //currKeeper = tmpElem.getCurrency();
          }
          baggDetails.price = self.filterPrice(priceKeeper.reduce(function (a, b) {return a + b;}, 0).toFixed(2), 2);

          if (onlyCabin) {
            element.setDescSelect($filter('translate')('LANGM_JS_BASKET_ONEBAG_BAGGAGE_SELECT', baggDetails));
          }
          else {
            element.setDescSelect($filter('translate')('LANGM_JS_BASKET_ONEBAG_BAGGAGE_SELECT_2', baggDetails));
          }
        });
        if (!this.oneBaggOpts.default) {
          emptyOpt = self.getEmptyBaggOpt(Baggage.KIND_ONE_BAG);
          this.oneBaggOpts.options.unshift(emptyOpt);
          this.oneBaggOpts.default = emptyOpt;
        }
        emptyOpt = self.getEmptyBaggOpt(Baggage.KIND_ONE_BAG, UnitOpts.ONE_BAG_HIDE_ID, 'LANGM_JS_BASKET_BAGGAGE_SELECT_SHOW_ALL_OPTIONS');
        this.oneBaggOpts.options.push(emptyOpt);
      }
    },

    /**
     * Get baggageRules
     *
     * @returns {Object}
     */
    getBaggageRules: function () {
      return this.baggageRules;
    },

    /**
     * Get selling unit option by id
     *
     * @param {String} type
     * @param {String} id
     *
     * @returns {Baggage}
     */
    getById: function (type, id) {
      var ret = null;
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:

          this.baggageOptions.options.forEach(function (element, index, array) {
            if (element.getId() == id) {
              ret = element;
              return ret;
            }
          });
          break;

        case UnitOpts.TYPE_CABIN:
          this.cabinBagOptions.options.forEach(function (element, index, array) {
            if (element.getId() == id) {
              ret = element;
              return ret;
            }
          });
          break;

        case UnitOpts.TYPE_ONE_BAG:
          this.oneBaggOpts.options.forEach(function (element, index, array) {
            if (element.getId() == id) {
              ret = element;
              return ret;
            }
          });
          break;

        default:
      }

      return ret;
    },

    /**
     * Create empty Baggage obj
     *
     * @param {String} kind
     * @param {String} id
     * @param {String} desc
     *
     * @returns {Baggage}
     */
    getEmptyBaggOpt: function (kind, id, desc) {
      var id = typeof id !== 'undefined' ? id : '0',
        desc = typeof desc !== 'undefined' ? desc : 'LANGM_JS_BASKET_BAGGAGE_SELECT_CHOSE_OPTION',
        kind = typeof kind !== 'undefined' ? kind : Baggage.KIND_BAGGAGE;

      var emptyOpt = {
        count: 0,
        currency: "",
        descr: desc,
        descrRaw: desc,
        descSelect: $filter('translate')(desc, {}),
        id: id,
        maxWeightPerPax: 0,
        price: 0,
        type: "",
        size: "",
        weight: 0
      };

      return new Baggage(emptyOpt, kind);
    },

    /**
     * Get from code
     *
     * @return {String}
     */
    getFromCode: function () {
      return this.fromCode;
    },

    /**
     * Get unitId
     *
     * @return {String}
     */
    getUnitId: function () {
      return this.unitId;
    },

    /**
     * Get flightRoute
     *
     * @return {int}
     */
    getFlightRoute: function () {
      return this.flightRoute;
    },

    /**
     * Get to code
     *
     * @return {String}
     */
    getToCode: function () {
      return this.toCode;
    },

    /**
     * Get from code
     *
     * @return {String}
     */
    getRouteCode: function () {
      return this.route;
      //return this.getFromCode() + this.getToCode();
      //return Array.isArray(this.drawTypes) ? this.drawTypes[0] : this.getFromCode() + this.getToCode();
    },

    /**
     * Get the carrier
     *
     * @returns {String}
     */
    getCarrier: function () {
      return this.carrier;
    },

    /**
     * Get show infoBox flag by type
     *
     * @param {String} type
     *
     * @returns int
     */
    getOptionsType: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions.showInfoBox;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions.showInfoBox;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts.showInfoBox;

        default:
          return -1;
      }
    },

    /**
     * Flag if unit contain option
     *
     * @param {String} type
     *
     * @returns {Boolean}
     */
    isOptionsEmpty: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions.isEmpty;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions.isEmpty;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts.isEmpty;

        default:
          return true;
      }
    },

    /**
     * Get all available options
     *
     * @param {String} type
     *
     * @returns {Array}
     */
    getOptions: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions.options;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions.options;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts.options;

        default:
          return [];
      }
    },

    /**
     * Get info text
     *
     * @param {String} type
     *
     * @returns {String}
     */
    getTextInfo: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions.text_info;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions.text_info;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts.text_info;

        default:
          return '';
      }
    },

    /**
     * Get modal text
     *
     * @param {String} type
     *
     * @returns {String}
     */
    getModalText: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions.text_modal;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions.text_modal;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts.text_modal;

        default:
          return '';
      }
    },

    /**
     * Get option
     *
     * @param {String} type
     *
     * @returns {Object}
     */
    getOptionObj: function (type) {
      switch (type) {
        case UnitOpts.TYPE_BAGGAGE:
          return this.baggageOptions;

        case UnitOpts.TYPE_CABIN:
          return this.cabinBagOptions;

        case UnitOpts.TYPE_ONE_BAG:
          return this.oneBaggOpts;

        default:
          return null;
      }
    },

    isOptionsAlreadySelected: function () {
      return this.optionsAlreadySelected;
    },

    isOverrideLuggageAbility: function () {
      return this.overrideLuggageAbility;
    },

    isGds: function () {
      return this.isGds;
    },

    getAirlineLocator: function () {
      return this.airlineLocator;
    },

    /**
     * Return true if there's a luggage with id BAG2.2 in cabinBagOptions
     */
    hasPriorityBoardingBag: function(){
      var cabinBags = this.getOptionObj(UnitOpts.TYPE_CABIN);
      var hasPriorityBoardingBag = false;

      cabinBags.options.forEach(function(option){
        if(option.id === CONST.LUGGAGE.PRIORITY_BAG){
          hasPriorityBoardingBag = true;
        }
      });

      return hasPriorityBoardingBag;
    },

    getPriorityBoardingPrice: function(){
      var cabinBags = this.getOptionObj(UnitOpts.TYPE_CABIN);
      var priorityBag = _.find(cabinBags.options, function(option){
          return option.id === CONST.LUGGAGE.PRIORITY_BAG;
      });

      return {
        price: priorityBag ? priorityBag.price : 0,
        currency: priorityBag ? priorityBag.currency : '',
      };
    },

    /**
     * Returns this instance as simple object for communicating with API
     *
     * @return {Object}
     */
    srvObj: function () {
      return {
        unitId: this.unitId,
        fromCode: this.fromCode,
        toCode: this.toCode,
        route: this.getRouteCode(),
        drawTypes: this.drawTypes,
        //baggageOptions: this.baggageOptions,
        //cabinBagOptions: this.cabinBagOptions,
        //oneBaggOpts: this.oneBaggOpts,
        optionsAlreadySelected: this.optionsAlreadySelected,
        overrideLuggageAbility: this.overrideLuggageAbility,
        isGds: this.isGds
      };
    }

  };

  UnitOpts.prototype.constructor = UnitOpts;

  return UnitOpts;
}]);

;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/Leg.js
/*global _: false, moment: false */

angular.module('flight')

/**
 * @name        Leg
 * @namespace   flt
 * @description Class holding flight leg information
 */
.factory('flt.Leg',
['$filter', 'flt.Segment', 'flt.LuggageRule', 'Base64', 'Dictionaries',
function LegFactory($filter, Segment, LuggageRule, Base64, Dictionaries) {
/**
   * Constructor for Leg
   *
   * @class Leg
   * @constructor
   *
   * @param {apiLeg} leg
   * @param {Number} legType
   * @param {Route|belongsTo} [belongsTo] The Route or PriceGroup this leg belongs to
   */
  var Leg = function (leg, legType, belongsTo) {
    var self = this;

    /**
     *
     * @type {Route|PriceGroup|null}
     */
    this.belongsTo = belongsTo || null;

    /**
     * One of the Leg.LEG_TYPE_DEP or Leg.LEG_TYPE_RET
     *
     * @type {Number} legType
     */
    this.legType = legType;

    /**
     * Leg id
     *
     * @type {String}
     */
    this.id = leg.id;

    /**
     * Base64 encoded leg id
     *
     * @type {String}
     */
    this.idBase64 = null;

    /**
     * Flight duration in minutes
     *
     * @type {Number}
     */
    this.dur = leg.dur;

    /**
     * Layover duration in minutes
     *
     * @type {Number|null}
     */
    this.layoverDur = null;

    /**
     * Departure city code
     *
     * @type {String}
     */
    this.dep = leg.dep;

    /**
     * Arrival (destination) city code
     *
     * @type {String}
     */
    this.arr = leg.arr;

    /**
     * Departure time
     *
     * @type {String}
     */
    this.depT = leg.depT;

    /**
     * Arrival time
     *
     * @type {String}
     */
    this.arrT = leg.arrT;

    /**
     * Is GDS leg?
     *
     * @type {Boolean}
     */
    this.gds = leg.gds;

    /**
     * Number of segments in this leg
     *
     * @type {Number}
     */
    this.segmentsCount = leg.seg ? leg.seg.length : 0;

    /**
     * Leg segments
     *
     * @type {Segment[]}
     */
    this.segments = _.map(leg.seg, function (segment, index) {
      return new Segment(segment, this, index);
    }, this);

    /**
     * Leg luggage rules
     *
     * @type {LuggageRule[]}
     */
    this.luggageRules = _.map(leg.lug, function (info, index) {
      return new LuggageRule(info, this, index);
    }, this);

    /**
     * Leg option groups
     *
     * @type {Object}
     */
    this.og = leg.og;

    /**
     * True if leg should be visible on view
     *
     * @type {Boolean}
     */
    this.visible = true;

    /**
     * True if arrive the next day
     * Use moment, because new Date() throw error for date in YYYY-MM-DD HH:MM:SS format
     *
     * @type {Boolean}
     */
    this.arriveNextDay = (function () {
      var depDate = moment(self.depT).toDate(), arrDate = moment(self.arrT).toDate();

      // Add 1 day to departure date
      depDate.setDate(depDate.getDate() + 1);

      return depDate.getDate() === arrDate.getDate();
    })();

    /**
     * True if arrive the another day
     *
     * @type {Boolean}
     */
    this.arriveAnotherDay = (function () {
      var depDate = moment(self.depT)._d, arrDate = moment(self.arrT)._d;

      return depDate.getDate() !== arrDate.getDate();
    })();

    /**
     * True if there is any change of airport
     *
     * @type {Boolean}
     */
    this.airportChange = (function () {
      var change = false;

      angular.forEach(self.getSegments(), function (segment, index) {
        var next = self.getSegments()[index + 1];

        if (next && segment.getArrAirportCode() !== next.getDepAirportCode()) {
          change = true;
        }
      });

      return change;
    })();

    /**
     * @type {string[]}
     */
    this.carriers = _.uniq(_.map(this.segments, function (seg) {
      return seg.getOperCarrier();
    }));

    /**
     * @type {Object[]}
     */
    this.stopovers = _.map(
      _.filter(this.segments, function (segment) { return segment.getLayoverDur() > 0; }),
      function (segment) {
        return {
          marketingCarrier: false,
          duration: segment.getLayoverDur(),
          originCity: Dictionaries.getCityCodeByAirportCode(segment.getDepAirportCode()),
          destinationCity: Dictionaries.getCityCodeByAirportCode(segment.getArrAirportCode()),
          originAirport: segment.getDepAirportCode(),
          destinationAirport: segment.getArrAirportCode(),
          departure: segment.getArrDateMoment().format('YYYY-MM-DDTHH:mm:ss'),
          arrival: segment.getDepDateMoment().format('YYYY-MM-DDTHH:mm:ss'),
          flightNumber: segment.getFlightNumber(),
          equipment: null,
          stopovers: segment.stops
        };
      });

    /**
     * Ex.: "Lufthansa, LOT"
     *
     * @type {String}
     */
    this.carriersAsString = _.uniq(_.map(this.segments, function (seg) {
      return Dictionaries.getCarrierNameByCode(seg.getOperCarrier());
    })).join(', ');


  };

  /**
   * AngularJS filter
   *
   * @type {Function}
   */
  var filter = $filter('filter');

  /**
   * Departure leg
   *
   * @type {Number}
   * @constant
   */
  Leg.LEG_TYPE_DEP = 0;

  /**
   * Return leg
   *
   * @type {Number}
   */
  Leg.LEG_TYPE_RET = 1;

  // Define instance methods
  Leg.prototype = /** @lends Leg.prototype */ {

    /**
     * Get carrier code of the first segment
     *
     * @return {String}
     */
    getCarrierCode: function () {
      return this.segments[0].carr;
    },

    /**
     *
     * @returns {string[]}
     */
    getCarriers: function () {
      return this.carriers;
    },

    /**
     *
     * @returns {String}
     */
    getCarriersAsString: function () {
      return this.carriersAsString;
    },

    /**
     * @returns {Object[]}
     */
    getStopovers: function () {
      return this.stopovers;
    },

    /**
     * Is departure leg
     *
     * @return {Boolean}
     */
    isDep: function () {
      return this.legType === Leg.LEG_TYPE_DEP;
    },

    /**
     * Is return leg
     *
     * @return {Boolean}
     */
    isRet: function () {
      return this.legType === Leg.LEG_TYPE_RET;
    },

    /**
     * Get leg id
     *
     * @return {String}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Get base64 encoded leg id
     *
     * @return {String}
     */
    getIdBase64: function () {
      if (!this.idBase64) {
        this.idBase64 = Base64.encode(this.id);
      }

      return this.idBase64;
    },

    /**
     * Get departure city code
     *
     * @return {String}
     */
    getDepCityCode: function () {
      return this.dep;
    },

    /**
     * Get arrival city code
     *
     * @return {String}
     */
    getArrCityCode: function () {
      return this.arr;
    },

    /**
     * Get departure date
     *
     * @return {String} The departure date in YYYY-MM-DD format
     */
    getDepDate: function () {
      return moment(this.depT).format('YYYY-MM-DD');
    },

    /**
     * Get departure time
     *
     * @return {String} The time in HH:mm format
     */
    getDepTime: function () {
      return moment(this.depT).format('HH:mm');
    },

    /**
     * Returns departure date and time
     *
     * @returns {String}
     */
    getDepDateTime: function () {
      return this.depT;
    },

    /**
     * Get departure time as moment
     *
     * @return {Moment} The time as moment instance
     */
    getDepTimeMoment: function () {
      return moment(this.depT);
    },

    /**
     * Get arrival date
     *
     * @return {String} The departure date in YYYY-MM-DD format
     */
    getArrDate: function () {
      return moment(this.arrT).format('YYYY-MM-DD');
    },

    /**
     * Get arrival time
     *
     * @return {String} The time in HH:mm format
     */
    getArrTime: function () {
      return moment(this.arrT).format('HH:mm');
    },

    /**
     * Returns arrival date and time
     *
     * @returns {String}
     */
    getArrDateTime: function () {
      return this.arrT;
    },

    /**
     * Get arrival time as moment
     *
     * @return {Moment} The time as moment
     */
    getArrTimeMoment: function () {
      return moment(this.arrT);
    },

    /**
     * Get flight duration
     *
     * @return {String} The flight duration ex. 1h 20m
     */
    getDuration: function () {
      return parseInt(this.dur / 60) + 'h ' + this.dur % 60 + 'm';
    },

    /**
     * Get flight duration - full hours
     *
     * @return {String} The flight duration ex. 1h 20m
     */
    getDurationFullHours: function () {
      if(this.dur % 60 > 39){
        return parseInt((this.dur / 60) + 1) + 'h';
      }
      else{
        return parseInt(this.dur / 60) + 'h';
      }
    },

    /**
     * Returns true if flight is direct flight
     *
     * @return {Boolean}
     */
    isDirect: function () {
      return this.getStops() == 0;
    },

    /**
     * Get number of stops between origin and destination
     *
     * @return {int}
     */
    getStops: function () {
      // 1 segment is 0 stops
      return this.segments.length - 1;
    },

    /**
     * Get segment for index
     *
     * @param index
     * @returns {Segment}
     */
    getSegment: function(index) {
      return (this.segments[index] !== undefined) ? this.segments[index] : null;
    },

    /**
     * Get all segments for this leg
     *
     * @return {Segment[]}
     */
    getSegments: function () {
      return this.segments;
    },

    /**
     * Get overnight segments for this leg
     *
     * @return {Segment[]}
     */
    getOvernightSegments: function () {
      return filter(this.segments, function (seg) {
        return seg.isOvernight();
      });
    },

    /**
     * Get first segment in this leg
     *
     * @return {Segment}
     */
    getFirstSegment: function () {
      return this.segments[0];
    },

    /**
     * Get last segment in this leg
     *
     * @return {Segment}
     */
    getLastSegment: function () {
      return this.segments[this.segmentsCount - 1];
    },

    /**
     * The wait time in minutes between segments
     *
     * @returns {Number}
     */
    getLayoverDuration: function () {
      var self;

      if (this.layoverDur === null) {
        self = this;
        angular.forEach(this.getSegments(), function (segment) {
          self.layoverDur += segment.getLayoverDur();
        });
      }

      return this.layoverDur;
    },

    /**
     * The max wait time in minutes between segments
     *
     * @returns {Number}
     */
    getMaxLayoverDuration: function () {
      return _.max(_.map(this.getSegments(), function (segment) {
        return segment.getLayoverDur();
      }));
    },

    /**
     * Is any of the leg segments overnight
     *
     * @return {Boolean}
     */
    isAnySegOvernight: function () {
      return _.reduce(this.segments, function (memo, seg) { return memo || seg.overnight; }, false);
    },

    /**
     * Get luggage rules by pax type
     *
     * @param  {String} paxType
     * @param  {String} luggageType
     *
     * @return {LuggageRule|''}
     */
    getLuggageRules: function (paxType, luggageType) {
      var rule = _.find(this.luggageRules, function (rule) {
        return rule.getPaxType() == paxType;
      });

      return rule != undefined ? rule[luggageType] : '';
    },

    /**
     * Returns leg option groups
     *
     * @return {Object}
     */
    getOptionGroups: function () {
      return this.og;
    },

    /**
     * Is the leg GDS?
     *
     * @return {Boolean}
     */
    isGDS: function () {
      return this.gds;
    },

    /**
     * Returns true if arrive the next day
     *
     * @returns {Boolean}
     */
    isArriveNextDay: function () {
      return this.arriveNextDay;
    },

    /**
     * Returns true if arrive the another day
     *
     * @returns {Boolean}
     */
    isArriveAnotherDay: function () {
      return this.arriveAnotherDay;
    },

    /**
     * Returns true if there is any change of airport
     *
     * @returns {Boolean}
     */
    isAnyAirportChange: function () {
      return this.airportChange;
    },

    setFlightType: function (flightType) {
      this.getSegments().forEach(function (segment) {
        segment.setFlightType(flightType);
      });
    },

    /**
     * Mark/unmark as visible
     *
     * @param {Boolean} [isVisible] if isVisible is not passed, leg will be marked as visible
     */
    markAsVisible: function (isVisible) {
      // If isVisible is not passed, leg will be marked as visible
      isVisible = isVisible === undefined ? true : isVisible;

      // Make sure it's boolean
      isVisible = !!isVisible;

      // Did visibility changed
      var hasChanged = this.visible !== isVisible;

      this.visible = isVisible;

      if (hasChanged && this.belongsTo) {
        this.belongsTo.setVisibleLegsDelta(this.visible ? 1 : -1, this.legType);
      }
    },

    /**
     * Returns true if this is marked as visible
     *
     * @returns {Boolean}
     */
    isVisible: function () {
      return this.visible;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      var segments = [],
        overnightSegments = [],
        luggageRules = [];

      _.each(this.getSegments(), function (segment) {
        var srvObj = segment.getSrvObj();

        segments.push(srvObj);

        if (segment.isOvernight()) {
          overnightSegments.push(srvObj);
        }
      }, this);

      //_.each(this.getLuggageRules(), function(rule)
      //{
      //  luggageRules.push(rule.getSrvObj());
      //}, this);

      return {
        id: this.getId(),
        idB64: this.getIdBase64(),
        gds: this.isGDS(),
        carr: this.getCarrierCode(),
        dep: this.getDepCityCode(),
        arr: this.getArrCityCode(),
        depT: this.getDepTimeMoment().format('YYYY-MM-DD HH:mm'),
        arrT: this.getArrTimeMoment().format('YYYY-MM-DD HH:mm'),
        dur: this.dur,
        seg: segments,
        oSeg: overnightSegments,
        stp: this.getStops(),
        wt: this.getLayoverDuration(),
        nextDay: this.isArriveNextDay(),
        arpChg: this.isAnyAirportChange(),
        dir: this.isDirect(),
        //lug:               luggageRules,
        //og:                this.getOptionGroups(),
      };
    }

  };

  Leg.prototype.constructor = Leg;

  return Leg;
}]);

;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/PriceGroup.js
/*global _: false */

angular.module('flight')

/**
 * @name        PriceGroup
 * @namespace   flt
 * @description Factory returning PriceGroup constructor
 */
.factory('flt.PriceGroup',
['flt.Route', 'flt.Leg', 'Base64', 'dsc.Discount', '$filter', 'sch.SearchQueryParams',

/**
 * Price group class
 *
 * @param  {Route} Route
 * @param  {Leg} Leg
 * @param  {Base64} Base64
 * @param  {Discount} Discount
 * @param  {Function} $filter
 *
 * @return {PriceGroup}
 */
function PriceGroupFactory(Route, Leg, Base64, Discount, $filter, sqp) {
/**
   * PriceGroup constructor
   *
   * @class PriceGroup
   * @constructor
   *
   * @param {apiPriceGroup} priceGroup The JSON object representing price group
   */
  var PriceGroup = function (priceGroup) {

    /**
     * The price group id
     *
     * @type {String}
     */
    this.id = priceGroup.id;

    /**
     * Base64 encoded price group id
     *
     * @type {String}
     */
    this.idBase64 = null;

    /**
     * The price group fsid
     *
     * @type {String}
     */
    this.fsId = priceGroup.fsid;

    /**
     * The price group ninja box id
     *
     * @type {String}
     */
    this.nbId = priceGroup.nbId;

    /**
     * The price group uid
     *
     * @type {String}
     */
    this.uId = priceGroup.uid;

    /**
     * Base64 encoded price group fsid
     *
     * @type {String}
     */
    this.fsIdBase64 = null;

    /**
     * The price group total price
     *
     * @type {Number}
     */
    this.total = priceGroup.price.total;

    /**
     * The price group total net price
     *
     * @type {Number}
     */
    this.totalNetPrice = priceGroup.price.total_netto;

    /**
     * The price group total price
     *
     * @type {Array}
     */
    this.paxes = priceGroup.price.paxes;

    /**
     * Price per one adult
     *
     * @type {Number}
     */
    this.adtPrice = priceGroup.adtPrice.total;

    /**
     * Service fee for this flight
     *
     * @type {Number}
     */
    this.tf = priceGroup.price.tf || 0;

    /**
     * Service fee for this flight
     *
     * @type {Number}
     */
    this.adtTf = priceGroup.tf ? priceGroup.tf.ADT : 0;

    /**
     * The price group discount
     *
     * @type {Discount}
     */
    this.discount = new Discount();

    // Add discounts
    this.discount.addDiscounts(priceGroup.price.discounts);

    /**
     * The available seats
     *
     * @type {int|null}
     */
    this.seats = priceGroup.seats;

    /**
     * The max stops route
     *
     * @type {Route|null}
     */
    this.maxStopsRoute = null;

    /**
     * The route having shortest layover duration
     *
     * @type {Route|null}
     */
    this.minLayoverRoute = null;

    /**
     * The route having longest layover duration
     *
     * @type {Route|null}
     */
    this.maxLayoverRoute = null;

    /**
     * The shortest duration (the best return leg duration + the best departure leg duration)
     *
     * @type {Number|null} in minutes
     */
    this.bestDuration = null;

    /**
     * True if is marked as cheapest
     *
     * @type {Boolean}
     */
    this.cheapest = false;

    /**
     * True if is marked as fastest
     *
     * @type {Boolean}
     */
    this.fastest = false;

    /**
     * True if is marked as cheap&fast
     *
     * @type {Boolean}
     */
    this.cheapAndFast = false;

    /**
     * The flight type
     *
     * @type {String} One of the: LOWCOST, MIXED, REGULAR
     */
    this.flightType = priceGroup.flight_type;

    /**
     * Routes collection
     *
     * @type {Route[]}
     */
    this.debug = priceGroup.debug;

    /**
     * True if price group should be visible on view
     *
     * @type {Boolean}
     */
    this.visible = true;

    /**
     * The number of visible legs
     *
     * @type {int}
     */
    this.visibleLegsCount = [0, 0];

    /**
     * Routes collection
     *
     * @type {Route[]}
     */
    this.routes = [];

    /**
     * Is pGr from instant search
     *
     * @type {boolean}
     */
    this.instantSearch = false;

    /**
     * True if price group is fresh
     *
     * @type {Boolean}
     */
    this.fresh = false;

    /**
     * Region
     * @type {string}
     */
    this.region = priceGroup.region || '';

    /**
     * Region
     * @type {string}
     */
    this.dataLayerType = priceGroup.dataLayerType || '';

    // Push departure route
    this.routes.push(new Route(priceGroup.dep, Leg.LEG_TYPE_DEP, this));
    this.visibleLegsCount[0] = this.routes[0].getLegsCount();

    if (priceGroup.ret.length > 0) {
      // Not one-way flight, push return route
      this.routes.push(new Route(priceGroup.ret, Leg.LEG_TYPE_RET, this));
      this.visibleLegsCount[1] = this.routes[1].getLegsCount();
    }

    /**
     * Refund availability data
     * @type {object}
     */
    this.refund = priceGroup.refund;

    this.paxModalAdtPrice = 0;
  };

// Add instance methods
  PriceGroup.prototype = /** @lends PriceGroup.prototype */ {

    /**
     * Price filter.
     *
     * @type {Function}
     */
    filterPrice: $filter('flPrice'),

    /**
     * Get price group paxes
     *
     * @return {Array}
     */
    getPaxes: function () {
      return this.paxes;
    },

    /**
     * Get price group paxes
     *
     * @return {Array}
     */
    getPaxCount: function () {
      var count = 0;
      this.paxes.map(function (element) {
        count += element.count;
      });
      return count;
    },

    /**
     * get departure carriers
     *
     * @return {Array}
     */
    getDepCarriers: function () {
      return this.routes[0].selectedLeg.carriers;
    },

    getDepAirportCode: function (){
      return this.routes[0].selectedLeg.getFirstSegment().getDepAirportCode();
    },

    getRetAirportCode: function (){
      return this.isOneWay() ? "" : this.routes[1].selectedLeg.getFirstSegment().getDepAirportCode();
    },

    /**
     * get return carriers
     *
     * @return {Array}
     */
    getRetCarriers: function () {
      return this.isOneWay() ? [] : this.routes[1].selectedLeg.carriers;
    },

    /**
     * Get Data For tracking
     * @returns {string}
     */
    getDataLayerType:function()
    {
      return this.dataLayerType;
    },

    /**
     * Get price group id
     *
     * @return {String}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Get price group fsid
     *
     * @return {String}
     */
    getFsId: function () {
      return this.fsId;
    },

    /**
     * Get ninja box id
     *
     * @return {String}
     */
    getNbId: function () {
      return this.nbId;
    },

    /**
     * Get price group uid
     *
     * @return {String}
     */
    getUId: function () {
      return this.uId;
    },

    /**
     * Is price group one way?
     *
     * @return {Boolean}
     */
    isOneWay: function () {
      return this.getRetRoute() == null;
    },

    /**
     * Is price group round-trip?
     *
     * @return {Boolean}
     */
    isRoundTrip: function () {
      return !this.isOneWay();
    },


    /**
     * Returns flight type
     *
     * @return {String} One of the: LOWCOST, MIXED, REGULAR
     */
    getFlightType: function () {
      return this.flightType;
    },

    /**
     * Is Lowcost
     * @returns {boolean}
     */
    isLowCost:function(){

      return this.getFlightType() === 'LOWCOST';

    },
    /**
     * Is Gds
     * @returns {boolean}
     */
    isRegularFlight:function(){

      return this.getFlightType() === 'REGULAR';

    },

    /**
     * @return {boolean}
     */
    hasSenior: function () {
      var hasSenior = this.getPaxes().find(function (element) {
        return element.type === 'SRC';
      });

      return !!hasSenior || sqp.seniors !== "";
    },

    /**
     * Is refundable flight?
     * @return {boolean}
     */
    isRefundable: function () {
      return typeof this.refund === 'object' && !this.hasSenior();
    },

    /**
     * Is Soow
     * @returns {boolean}
     */
    isSoowFlight:function(){
      return this.getFlightType() === 'MIXED';

    },

    /**
     * Is Hub
     * @returns {boolean}
     */
    isHubFlight:function(){
      return this.getFlightType() === 'HUB';

    },

    /**
     * Is Charter
     * @returns {boolean}
     */
    isCharter:function(){
      return this.getFlightType === 'CHARTER';

    },

    /**
     * Return base64 encoded id
     *
     * @return {String}
     */
    getIdBase64: function () {
      if (!this.idBase64) {
        this.idBase64 = Base64.encode(this.id);
      }

      return this.idBase64;
    },
    /**
     * Return base64 encoded fsid
     *
     * @return {String}
     */
    getFsIdBase64: function () {
      if (!this.fsIdBase64) {
        this.fsIdBase64 = Base64.encode(this.fsId);
      }

      return this.fsIdBase64;
    },

    /**
     * Get price (without discount)
     *
     * @return {Number}
     */
    getPrice: function () {
      return this.total;
    },

    /**
     * Returns the discount object
     *
     * @return {Discount}
     */
    getDiscount: function () {
      return this.discount;
    },

    /**
     * Returns the service fee amount
     *
     * @return {Number}
     */
    getTf: function () {
      return this.tf;
    },

    /**
     * Returns the service fee amount for one adult
     *
     * @return {Number}
     */
    getAdtTf: function () {
      return this.adtTf;
    },

    /**
     * Get total price
     *
     * @return {Number}
     */
    getTotalPrice: function () {
      return this.getPrice() - this.getDiscount().getTotalNoTfDiscount();
    },

    /**
     * Get refund price
     *
     * @return {Number}
     */
    getRefundPrice: function () {
      return typeof this.refund === 'object' ? this.refund.price : 0;
    },

    /**
     * Get refund total price
     *
     * @return {*|Number}
     */
    getRefundTotalPrice: function () {
      return this.getRefundPrice() ? this.getTotalPrice() + this.getRefundPrice() : this.getTotalPrice();
    },

    /**
     * Get total price as string.
     *
     * @return {String}
     */
    getTotalPriceAsString: function() {
      return this.filterPrice(this.getTotalPrice());
    },
    /**
     * Check if user has agent role and has permissions
     *
     * @returns {Boolean}
     */
    isAgentWithPermissions: function() {
      return _.isObject(_user_) && _user_.isAgent;
    },

    /**
     * Get price per one adult
     *
     * @return {Number}
     */
    getAdtPrice: function () {
      return this.adtPrice;
    },

    /**
     * Get price per one adult as string.
     *
     * @return {String}
     */
    getAdtPriceAsString: function() {
      return this.filterPrice(this.getAdtPrice());
    },

    getRegion:function(){
      return this.region;
    },

    /**
     * Returns total price - service fee amount
     *
     * @return {Number}
     */
    getPriceWithoutTf: function () {
      return this.totalNetPrice;
    },

    /**
     * @returns {Number}
     */
    getAdtPriceWithDiscount: function () {
      if (this.getDiscount().hasCoupons() && !this.getDiscount().hasDecreaseTf(1)) {
        return this.getAdtPrice() - this.getDiscount().getTotalDiscount();
      }
      else {
        return this.getAdtPrice();
      }
    },

    /**
     * Returns the flight routes for this price group
     *
     * @return {Route[]}
     */
    getRoutes: function () {
      return this.routes;
    },

    /**
     * Returns departure route
     *
     * @return {Route}
     */
    getDepRoute: function () {
      return this.routes[0];
    },

    /**
     * Returns return route
     *
     * @return {Route|null}
     */
    getRetRoute: function () {
      return this.routes[1] || null;
    },

    /**
     * Calculate number of combinations of departures and returns
     *
     * @return {Number}
     */
    getCombinations: function () {
      if (this.getRetRoute() != null) {
        return this.getDepRoute().getLegs().length * this.getRetRoute().getLegs().length;
      }
      else {
        return this.getDepRoute().getLegs().length;
      }
    },

    /**
     * Get available seats
     *
     * @return {int|null}
     */
    getSeatsCount: function () {
      return this.seats;
    },

    /**
     * Get departure date.
     *
     * @return {String}
     */
    getDepartureDate: function () {
      return this.routes[0].selectedLeg.depT.split(' ')[0];
    },

    /**
     * Get return date.
     *
     * @return {String}
     */
    getReturnDate: function () {
      return this.isOneWay() ? '' : this.routes[1].selectedLeg.depT.split(' ')[0];
    },

    /**
     * Return number of stops
     *
     * @returns {Number}
     */
    getStops: function () {
      return this.getMaxStopsRoute().getMinStopsLeg().getStops();
    },

    /**
     * Get max stops route
     *
     * @returns {Route}
     */
    getMaxStopsRoute: function () {
      if (this.maxStopsRoute == null) {
        this.maxStopsRoute = _.max(this.getRoutes(), function (route) {
          return route.getMinStopsLeg().getStops();
        });
      }

      return this.maxStopsRoute;
    },

    /**
     * Pick the min layover route
     *
     * @return {Route}
     */
    getMinLayoverRoute: function () {
      if (this.minLayoverRoute == null) {
        this.minLayoverRoute = _.min(this.getRoutes(), function (route) {
          return route.getMinLayoverLeg().getLayoverDuration();
        });
      }

      return this.minLayoverRoute;
    },

    /**
     * Pick the max layover route
     *
     * @return {Route}
     */
    getMaxLayoverRoute: function () {
      if (this.maxLayoverRoute == null) {
        this.maxLayoverRoute = _.max(this.getRoutes(), function (route) {
          return route.getMaxLayoverLeg().getLayoverDuration();
        });
      }

      return this.maxLayoverRoute;
    },

    /**
     * Get the best(shortest) duration
     *
     * @returns {Number}
     */
    getBestDuration: function () {
      if (this.bestDuration == null) {
        this.bestDuration = this.getDepRoute().getBestLeg().dur;

        if (!this.isOneWay()) {
          this.bestDuration += this.getRetRoute().getBestLeg().dur;
        }
      }

      return this.bestDuration;
    },

    /**
     * Get longest route
     *
     * @returns {Route}
     */
    getLongestRoute: function () {
      if (this.isOneWay()) {
        return this.getDepRoute();
      }

      return this.getDepRoute().getBestLeg().dur >= this.getRetRoute().getBestLeg().dur ? this.getDepRoute() : this.getRetRoute();
    },

    /**
     * Mark/unmark as cheapest
     *
     * @param {Boolean} [isCheapest] if isCheapest is not passed, price group will be marked as cheapest
     */
    markAsCheapest: function (isCheapest) {
      this.cheapest = isCheapest !== false;
    },

    /**
     * Returns true if this is marked as cheapest
     *
     * @returns {Boolean}
     */
    isMarkedAsCheapest: function () {
      return this.cheapest;
    },

    /**
     * Mark/unmark as fastest
     *
     * @param {Boolean} [isFastest] if isFastest is not passed, price group will be marked as fast
     */
    markAsFastest: function (isFastest) {
      this.fastest = isFastest !== false;
    },

    /**
     * Returns true if this is marked as fastest
     *
     * @returns {Boolean}
     */
    isMarkedAsFastest: function () {
      return this.fastest;
    },

    /**
     * Mark/unmark as cheap&fast
     *
     * @param {Boolean} [isCheapAndFast] if isCheapAndFast is not passed, price group will be marked as cheap&fast
     */
    markAsCheapAndFast: function (isCheapAndFast) {
      this.cheapAndFast = isCheapAndFast !== false;
    },

    /**
     * Returns true if this is marked as cheap&fast
     *
     * @returns {Boolean}
     */
    isMarkedAsCheapAndFast: function () {
      return this.cheapAndFast;
    },

    /**
     * Mark/unmark as visible
     *
     * @param {Boolean} [isVisible] if isVisible is not passed, price group will be marked as visible
     */
    markAsVisible: function (isVisible) {
      this.visible = isVisible !== false;
    },

    /**
     * Mark all legs as visible
     */
    markLegsAsVisible: function () {
      angular.forEach(this.routes, function (route) {
        angular.forEach(route.legs, function (leg) {
          leg.markAsVisible();
        });
      });
    },

    /**
     * Add or subtract number of visible legs
     *
     * @param {int} delta The 1 or -1
     * @param {int} legType One of the Leg.LEG_TYPE_DEP or Leg.LEG_TYPE_RET
     *
     * @return PriceGroup
     */
    setVisibleLegsDelta: function (delta, legType) {
      if (legType == Leg.LEG_TYPE_DEP) {
        this.visibleLegsCount[0] += delta;
      }
      else {
        this.visibleLegsCount[1] += delta;
      }

      return this;
    },

    /**
     * Returns visible leg count
     *
     * @return {int}
     */
    getVisibleLegCount: function () {
      return this.visibleLegsCount[0] + this.visibleLegsCount[1];
    },

    /**
     * Set instant search flag
     */
    setInstantSearch: function (isInstant) {
      this.instantSearch = isInstant;
    },

    /**
     * Is flight is from instant search
     *
     * @returns {Boolean}
     */
    isInstantSearch: function () {
      return this.instantSearch;
    },

    /**
     * Flag as fresh price group
     *
     * @param {Boolean} flag
     */
    markAsFresh: function (flag) {
      this.fresh = !!flag;
    },

    /**
     * Check if fresh
     *
     * @returns {Boolean}
     */
    isFresh: function () {
      return this.fresh;
    },

    /**
     * Returns true if this is marked as visible
     *
     * @returns {Boolean}
     */
    isVisible: function () {
      return this.visible;
    }
  };

  PriceGroup.prototype.constructor = PriceGroup;

  return PriceGroup;
}]);

;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/PriceGroupPaxModal.js
(function(angular, underscore) {
/**
   * @name        PriceGroupPaxModalFactory
   * @description Manage price group pax modal
   * @constructor
   * @author
   */
  var PriceGroupPaxModalFactory = function($filter, SearchQueryParams, AppConfig) {

    /**
     * Factory desc
     *
     * @constructor
     * @interface
     */
    var PriceGroupPaxModal = function() {
      this.adults = 1;
      this.children = 0;
      this.infants = 0;
      this.youth = 0;
      this.opened = false;
      this.valid = {};
      this.cellSummary = undefined;
      this.restoreDefaults();
    };

    var translator = $filter('translate');
    var filterPrice = $filter('flPrice');

    /**
     * Factory method desc
     */
    PriceGroupPaxModal.prototype = /** @lends PriceGroupPaxModal.prototype */ {

      open: function () {
        this.opened = true;
      },

      close: function () {
        this.opened = false;
      },

      /**
       * Calculate price logic
       *
       * used on:
       * - modules/redesign/views/templates/components/flights/priceGroupPaxModal.php
       *
       * @param {Number} price
       * @returns {Number}
       */
      calculatePrice: function (price) {
        var roundedPrice = Math.round(price);
        return roundedPrice * this.adults;
      },

      adultPrice: function (price) {
        var roundedPrice = Math.round(price);
        return roundedPrice * this.adults;
      },

      getAdultPrice: function (formatted) {
        var price = Math.round(this.cellSummary.getPrice());

        if (formatted) {
          return filterPrice(price * this.adults);
        }

        return price;
      },

      getAdultsSelectOptions: function () {
        return underscore.object(underscore.map(underscore.range(0, 10), function (num) {
          return [num + ' ' + translator('LANGM_JS_FS_ADULT'), num];
        }));
      },

      /**
       * Total pax count
       *
       * @returns {Number}
       */
      count: function () {
        return this.adults + this.children + this.infants + this.youth;
      },

      /**
       * Count adult paxes
       *
       * @returns {Number}
       */
      countAdt: function () {
        return this.adults;
      },

      restoreDefaults: function () {
        this.valid = {};
        this.adults = SearchQueryParams.getAdults();
        this.children = SearchQueryParams.getChildren();
        this.infants = SearchQueryParams.getInfants();
        this.youth = SearchQueryParams.getYouths();
      },

      openEmptyPriceGroupPax: function(){
        this.opened = true;
        this.valid = {};
        this.adults = 1;
        this.children = 0;
        this.infants = 0;
        this.youth = 0;
      },

      /**
       * @return {Boolean}
       */
      isValid: function () {
        var count = this.count();

        this.valid = {};

        if (count <= 9) {
          this.valid.status = true;
        }

        if (this.adults == 0) {
          this.valid.status = false;
          this.valid.message = translator('LANGM_JS_PM_NO_PAX');
        }

        if (count > 9) {
          this.valid.status = false;
          this.valid.message = translator('LANGM_JS_PAX_ERROR_SELECTED_MORE_THAN_9_PEOPLE');
        }

        if (this.infants > this.adults) {
          this.valid = {
            status: false,
            message: translator('LANGM_JS_PM_TOO_MUCH_INFANTS'),
            infantsError: true
          };
        }

        if (this.adults == 0 && this.youth > 0) {
          this.valid = {
            status: false,
            message: translator('LANGM_JS_PM_TOO_YOUTH_ALONE'),
            youthError: true
          };
        }

        if (this.children > 0 && this.adults == 0) {
          this.valid = {
            status: false,
            message: translator('LANGM_JS_PAX_ERROR_ONE_CHILD_BUT'),
            infantsError: true
          };
        }

        if (this.infants == 1 && this.adults == 0) {
          this.valid = {
            status: false,
            message: translator('LANGM_JS_PAX_ERROR_ONE_INFANT_BUT'),
            infantsError: true,
            adultsError: true
          };
        }


        if (this.youths == 1 && this.adults == 0) {
          this.valid = {
            status: false,
            message: translator('LANGM_JS_PAX_ERROR_ONE_YOUTH_PASSENGER_BUT'),
            youthsError: true,
            seniorsError: true,
            adultsError: true
          };
        }

        return this.valid.status;
      }
    };

    PriceGroupPaxModal.prototype.constructor = PriceGroupPaxModal;

    /**
     * Check if feature test is enabled
     *
     * @returns {boolean}
     */
    PriceGroupPaxModal.isFeatureTestEnabled = function (){
      return true;
    };

    return PriceGroupPaxModal;
  };

  PriceGroupPaxModalFactory.$inject = [
    '$filter',
    'sch.SearchQueryParams',
    'appConfig'
  ];

  angular.module('flight')
    .factory('flt.PriceGroupPaxModal', PriceGroupPaxModalFactory);
})(angular, _);
;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/PriceGroups.js
/*global angular: false, _: false */

angular.module('flight')

/**
 * @name        PriceGroups
 * @namespace   flt
 * @description Factory returning PriceGroups constructor
 */
.factory('flt.PriceGroups',
['$filter', 'Dictionaries', 'flt.PriceGroup', 'flt.pgDecorator', 'sch.RespSummary',

/**
 * PriceGroups class
 *
 * @param {Function} $filter
 * @param {Dictionaries} Dictionaries
 * @param {PriceGroup} PriceGroup
 * @param {Function} pgDecorator
 * @param {RespSummary} RespSummary
 *
 * @return {PriceGroups}
 */
function PriceGroupsFactory($filter, Dictionaries, PriceGroup, pgDecorator, RespSummary) {
/**
   * PriceGroups constructor
   *
   * @class PriceGroups
   * @constructor
   */
  var PriceGroups = function () {
    /**
     * Price groups
     *
     * @type {PriceGroup[]}
     */
    this.priceGroups = [];

    /**
     * The cheapest price group
     *
     * @type {PriceGroup|null}
     */
    this.cheapest = null;

    /**
     * The cheapest no hub price group
     *
     * @type {PriceGroup|null}
     */
    this.cheapestNoHub = null;

    /**
     * The cheapest hub price group
     *
     * @type {PriceGroup|null}
     */
    this.cheapestHub = null;

    /**
     * The best price group (shortest  the best return leg duration + the best departure leg duration)
     *
     * @type {PriceGroup|null}
     */
    this.best = null;

    /**
     * The most expensive price group
     *
     * @type {PriceGroup|null}
     */
    this.mostExpensive = null;

    /**
     * Summary of all price groups
     *
     * @type {RespSummary}
     */
    this.summary = new RespSummary({});

    /**
     * Visible priceGroup cache
     * @type {Array}
     */
    this.visibleCache = [];
  };

  // Add instance methods
  PriceGroups.prototype = /** @lends PriceGroups.prototype */ {

    /**
     * Get all priceGroups
     *
     * @return {PriceGroup[]}
     */
    get: function () {
      return this.priceGroups;
    },

    /**
     * Get priceGroups which should be shown on view (marked as visible)
     * method with cache
     *
     * @return {PriceGroup[]}
     */
    getVisible: function () {
      return this.visibleCache;
    },

    /**
     *  Refresh cache with visible price groups
     *
     * @return void
     */
    refreshVisible: function() {
      this.visibleCache = $filter('orderBy')($filter('filter')(this.priceGroups, {visible: true}), function (priceGroup) {
        return priceGroup.getPriceWithoutTf();
      });
    },

    /**
     * Returns true if collection is empty
     *
     * @returns {Boolean}
     */
    isEmpty: function () {
      return this.get().length === 0;
    },

    /**
     * Add priceGroups
     *
     * @param {Object[]} priceGroups
     * @param {boolean} isFreshResult
     *
     * @returns {PriceGroups}
     */
    add: function (priceGroups, isFreshResult) {
      var self = this;

      priceGroups = pgDecorator(priceGroups);

      angular.forEach(priceGroups, function (priceGroup) {
        priceGroup.markAsFresh(isFreshResult);
        self.addOne(priceGroup);
      });

      this.resetBest();
      this.resetCheapest();
      this.resetLabels();
      this.resetMostExpensive();

      this.calculateSummary();
      return this;
    },

    /**
     * Add one price group
     *
     * @param {PriceGroup} newPriceGroup
     */
    addOne: function (newPriceGroup) {
      var found = false, priceGroups = this.priceGroups, addToList = true;

      // Remove duplicates
      angular.forEach(priceGroups, function (priceGroup, index) {
        if (found || priceGroup.getUId() !== newPriceGroup.getUId()) {
          // skip if already found or price group not fit
          return;
        }

        found = true;

        var
          bothFresh = priceGroup.isFresh() && newPriceGroup.isFresh(),
          isNewMoreExpensive = priceGroup.getPrice() + priceGroup.getTf() < newPriceGroup.getPrice() + newPriceGroup.getTf();

        if (bothFresh && isNewMoreExpensive) {
          // do not add to list if price group is already there and is cheaper then new one
          // RT flight vs SOOW with the same carrier
          addToList = false;
          return;
        }

        priceGroups.splice(index, 1);
      });

      if (addToList) {
        this.get().push(newPriceGroup);
      }
    },

    /**
     * Get the cheapest price group
     *
     * @returns {PriceGroup}
     */
    getCheapest: function () {
      if (!this.cheapest && !this.isEmpty()) {
        this.cheapest = _.min(this.get(), function (priceGroup) {
          return priceGroup.getPriceWithoutTf();
        });
      }

      return this.cheapest;
    },

    /**
     * Get the cheapest price group (no hub)
     *
     * @returns {PriceGroup}
     */
    getCheapestNoHub: function () {
      var noHubPriceGroups;

      if (!this.cheapestNoHub) {
        noHubPriceGroups = this.getNoHubPriceGroups();

        if (noHubPriceGroups.length > 0) {
          this.cheapestNoHub = _.min(noHubPriceGroups, function (priceGroup)
          {
            return priceGroup.getPriceWithoutTf();
          });
        }
      }

      return this.cheapestNoHub;
    },

    /**
     * Get the cheapest hub price group
     *
     * @returns {PriceGroup}
     */
    getCheapestHub: function () {
      var hubPriceGroups;

      if (!this.cheapestHub) {
        hubPriceGroups = this.getHubPriceGroups();

        if (hubPriceGroups.length > 0) {
          this.cheapestHub = _.min(hubPriceGroups, function (priceGroup)
          {
            return priceGroup.getPriceWithoutTf();
          });
        }
      }

      return this.cheapestHub;
    },

    /**
     * @returns {Number}
     */
    getPriceDiffCheapestHubAndNoHub: function() {
      var
        cheapestHub = this.getCheapestHub(),
        cheapestNoHub = this.getCheapestNoHub();

      if (cheapestHub && cheapestNoHub) {
        return cheapestNoHub.getTotalPrice() - cheapestHub.getTotalPrice();
      }

      return 0;
    },

    /**
     * @returns {PriceGroup[]}
     */
    getNoHubPriceGroups: function () {
      return $filter('filter')(this.get(), function (priceGroup) {
        return priceGroup.flightType !== 'HUB';
      });
    },

    /**
     * @returns {PriceGroup[]}
     */
    getHubPriceGroups: function () {
      return $filter('filter')(this.get(), function (priceGroup) {
        return priceGroup.flightType === 'HUB';
      });
    },

    /**
     * Get the best price group
     *
     * @returns {PriceGroup}
     */
    getBest: function () {
      if (!this.best && !this.isEmpty()) {
        this.best = _.min(this.get(), function (priceGroup) {
          return priceGroup.getBestDuration();
        });
      }

      return this.best;
    },

    /**
     * Get the most expensive price group
     *
     * @returns {PriceGroup}
     */
    getMostExpensive: function () {
      if (!this.mostExpensive && !this.isEmpty()) {
        this.mostExpensive = _.max(this.get(), function (priceGroup) {
          return priceGroup.getPriceWithoutTf();
        });
      }

      return this.mostExpensive;
    },

    /**
     * Reset the best price group
     */
    resetBest: function () {
      this.best = null;
    },

    /**
     * Reset the cheapest price group
     */
    resetCheapest: function () {
      this.cheapest = null;
    },

    /**
     * Reset the most expensive price group
     */
    resetMostExpensive: function () {
      this.mostExpensive = null;
    },

    /**
     * Reset labels ("cheapest flight", "fastest flight", "cheap&fast flight")
     */
    resetLabels: function () {
      if (this.isEmpty()) {
        return;
      }

      // Find min price
      var minPrice = this.getCheapest().getPriceWithoutTf();

      // Find the best(shortest) duration
      var bestDuration = this.getBest().getBestDuration();

      angular.forEach(this.get(), function (priceGroup) {
        // Add "cheapest flight" label
        priceGroup.markAsCheapest(priceGroup.getPriceWithoutTf() === minPrice);

        // Add "fastest flight" label
        priceGroup.markAsFastest(priceGroup.getBestDuration() === bestDuration);

        // Add "cheap&fast flight" label
        //priceGroup.markAsCheapAndFast(priceGroup.getBestDuration() < bestDuration*1.2 && priceGroup.getPriceWithoutTf() < minPrice*1.2);
      });
    },

    /**
     *
     * @returns {Boolean}
     */
    isOneWay: function () {
      return this.get().length && this.get()[0].isOneWay();
    },

    /**
     *
     * @returns {Leg[]}
     */
    getAllLegs: function () {
      var legs = [];

      angular.forEach(this.get(), function (priceGroup) {
        angular.forEach(priceGroup.getRoutes(), function (route) {
          legs = legs.concat(route.getLegs());
        });
      });

      return legs;
    },

    /**
     *
     * @returns {Leg[]}
     */
    getDepLegs: function () {
      var legs = [];

      angular.forEach(this.get(), function (priceGroup) {
        legs = legs.concat(priceGroup.getDepRoute().getLegs());
      });

      return legs;
    },

    /**
     *
     * @returns {Leg[]}
     */
    getRetLegs: function () {
      var legs = [];

      if (!this.isOneWay()) {
        angular.forEach(this.get(), function (priceGroup) {
          legs = legs.concat(priceGroup.getRetRoute().getLegs());
        });
      }

      return legs;
    },

    /**
     *
     * @returns {Segment[]}
     */
    getAllSegments: function () {
      var segments = [];

      angular.forEach(this.getAllLegs(), function (leg) {
        segments = segments.concat(leg.getSegments());
      });

      return segments;
    },

    /**
     * Returns summary
     *
     * @returns {RespSummary}
     */
    getSummary: function () {
      return this.summary;
    },

    /**
     * Extend summary
     *
     * @param {RespSummary} newSummary
     *
     * @returns {RespSummary}
     */
    extendSummary: function (newSummary) {
      var summary = new RespSummary({}),
        oldSummary = this.summary,
        secondsSinceMidnight = $filter('secondsSinceMidnight');

      if (this.isEmpty()) {
        return summary;
      }

      angular.forEach(this.get(), function (priceGroup) {
        // Number of stops for this priceGroup
        var priceGroupStops = priceGroup.getMaxStopsRoute().getMinStopsLeg().getStops(),
          flightType = priceGroup.getFlightType();

        summary.stops[priceGroupStops] = !isNaN(summary.stops[priceGroupStops]) ? summary.stops[priceGroupStops] + 1 : 1;
        summary.flightTypes[flightType] = summary.flightTypes[flightType] ? summary.flightTypes[flightType] + 1 : 1;
      });

      // Min price
      summary.minPrice = this.getCheapest().getTotalPrice();

      // Max price
      summary.maxPrice = this.getMostExpensive().getTotalPrice();

      // Price groups count
      summary.pgCount = oldSummary.pgCount + newSummary.pgCount;

      // Quantity of price groups filtered out
      summary.pgFOut = oldSummary.pgFOut + newSummary.pgFOut;

      // Quantity of legs filtered out
      summary.lgFOut = oldSummary.lgFOut + newSummary.lgFOut;

      // Quantity of segments filtered out
      summary.sgFOut = oldSummary.sgFOut + newSummary.sgFOut;

      // Min duration
      summary.minDur = Math.min(oldSummary.minDur, newSummary.minDur);

      // Max duration
      summary.maxDur = Math.max(oldSummary.maxDur, newSummary.maxDur);

      // Min layover duration
      summary.minLayoverDur = _.min(this.get(), function (priceGroup) {
        return priceGroup.getMinLayoverRoute().getMinLayoverLeg().getLayoverDuration();
      }).getMinLayoverRoute().getMinLayoverLeg().getLayoverDuration();

      // Max layover duration
      summary.maxLayoverDur = _.max(this.get(), function (priceGroup) {
        return priceGroup.getMaxLayoverRoute().getMaxLayoverLeg().getLayoverDuration();
      }).getMaxLayoverRoute().getMaxLayoverLeg().getLayoverDuration();

      // The earliest departure takeoff time
      summary.minDepDepT = _.min([oldSummary.minDepDepT, newSummary.minDepDepT], function (value) {
        return secondsSinceMidnight(value);
      });

      // The latest departure arrival time
      summary.maxDepArrT = _.max([oldSummary.maxDepArrT, newSummary.maxDepArrT], function (value) {
        return secondsSinceMidnight(value);
      });

      // The earliest return takeoff time
      summary.minRetDepT = _.min([oldSummary.minRetDepT, newSummary.minRetDepT], function (value) {
        return secondsSinceMidnight(value);
      });

      // The latest return arrival time
      summary.maxRetArrT = _.max([oldSummary.maxRetArrT, newSummary.maxRetArrT], function (value) {
        return secondsSinceMidnight(value);
      });

      // True if the summary is for one way flights
      summary.oneWaySummary = newSummary.oneWaySummary;

      // Extends carriers
      summary.carriers = angular.extend({}, oldSummary.carriers, newSummary.carriers);

      // Extends airports
      summary.airports = angular.extend({}, oldSummary.airports, newSummary.airports);

      return summary;
    },

    /**
     * Calculate summary
     */
    calculateSummary: function () {
      var summary = new RespSummary({}),
        secondsSinceMidnight = $filter('secondsSinceMidnight'),
        allLegs = this.getAllLegs(),
        depLegs = this.getDepLegs(),
        retLegs = this.getRetLegs();

      if (this.isEmpty()) {
        return;
      }

      angular.forEach(this.get(), function (priceGroup) {
        // Number of stops for this priceGroup
        var priceGroupStops = priceGroup.getMaxStopsRoute().getMinStopsLeg().getStops(),
          flightType = priceGroup.getFlightType();

        summary.stops[priceGroupStops] = !isNaN(summary.stops[priceGroupStops]) ? summary.stops[priceGroupStops] + 1 : 1;
        summary.flightTypes[flightType] = summary.flightTypes[flightType] ? summary.flightTypes[flightType] + 1 : 1;
      });

      // Min price
      summary.minPrice = this.getCheapest().getTotalPrice();

      // Max price
      summary.maxPrice = this.getMostExpensive().getTotalPrice();

      // Price groups count
      summary.pgCount = this.get().length;

      // Min duration
      summary.minDur = _.min(this.get(), function (priceGroup) {
        return _.max(priceGroup.getRoutes(), function (route) {
          return route.getBestLeg().dur;
        }).getBestLeg().dur;
      }).getLongestRoute().getBestLeg().dur;

      // Max duration
      summary.maxDur = _.max(allLegs, function (leg) {
        return leg.dur;
      }).dur;

      // Min layover duration
      summary.minLayoverDur = _.min(this.get(), function (priceGroup) {
        return priceGroup.getMinLayoverRoute().getMinLayoverLeg().getLayoverDuration();
      }).getMinLayoverRoute().getMinLayoverLeg().getLayoverDuration();

      // Max layover duration
      summary.maxLayoverDur = _.max(this.get(), function (priceGroup) {
        return priceGroup.getMaxLayoverRoute().getMaxLayoverLeg().getLayoverDuration();
      }).getMaxLayoverRoute().getMaxLayoverLeg().getLayoverDuration();

      // The earliest departure takeoff time
      summary.minDepDepT = _.min(depLegs, function (leg) {
        return secondsSinceMidnight(leg.getDepTime());
      }).getDepTime();

      // The latest departure arrival time
      summary.maxDepArrT = _.max(depLegs, function (leg) {
        return secondsSinceMidnight(leg.getArrTime());
      }).getArrTime();

      if (!this.isOneWay()) {
        // The earliest return takeoff time
        summary.minRetDepT = _.min(retLegs, function (leg) {
          return secondsSinceMidnight(leg.getDepTime());
        }).getDepTime();

        // The latest return arrival time
        summary.maxRetArrT = _.max(retLegs, function (leg) {
          return secondsSinceMidnight(leg.getArrTime());
        }).getArrTime();
      }

      // True if the summary is for one way flights
      summary.oneWaySummary = this.isOneWay();

      // Carriers
      summary.carriers = {};

      // Airports
      summary.airports = {};

      angular.forEach(this.getAllSegments(), function (segment) {
        addCarrier(segment.getCarrier());
        addCarrier(segment.getOperCarrier());
        addAirport(segment.getDepAirportCode());
        addAirport(segment.getArrAirportCode());
      });

      /**
       * Add airport to summary
       *
       * @param {String} airportCode
       */
      function addAirport(airportCode) {
        var cityCode;

        if (!summary.airports[airportCode]) {
          cityCode = Dictionaries.getCityCodeByAirportCode(airportCode);

          summary.airports[airportCode] = {
            airport_name: Dictionaries.getAirportNameByCode(airportCode, false),
            airport_code: airportCode,
            city_name: Dictionaries.getCityNameByAirportCode(airportCode, false),
            city_code: cityCode,
            country_name: Dictionaries.getCountryNameByAirportCode(airportCode),
            country_code: Dictionaries.getCountryCodeByCityCode(cityCode)
          };
        }
      }

      /**
       * Add carrier to summary
       *
       * @param {String} carrierCode
       */
      function addCarrier(carrierCode) {
        if (!summary.carriers[carrierCode]) {
          summary.carriers[carrierCode] = Dictionaries.getCarrierNameByCode(carrierCode);
        }
      }

      this.summary = summary;

      this.calculateMinStops();
      this.calculateMaxStops();
    },

    /**
     * Calculate minimum number of stopovers
     */
    calculateMinStops: function () {
      this.getSummary().minStops = +_.min(Object.keys(this.getSummary().stops), function (noOfStops) {
        return +noOfStops;
      });
    },

    /**
     * Calculate maximum number of stopovers
     */
    calculateMaxStops: function () {
      this.getSummary().maxStops = +_.max(Object.keys(this.getSummary().stops), function (noOfStops) {
        return +noOfStops;
      });
    },

    /**
     * Mark all price groups as visible
     */
    markAllAsVisible: function () {
      angular.forEach(this.priceGroups, function (priceGroup) {
        priceGroup.markAsVisible();
        priceGroup.markLegsAsVisible();
      });
    },

    /**
     * Remove all price groups
     */
    clear: function () {
      this.priceGroups.length = 0;
    }

  };

  PriceGroups.prototype.constructor = PriceGroups;

  return PriceGroups;
}]);

;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/Route.js
/*global _: false */

angular.module('flight')

/**
 * @name        Route
 * @namespace   flt
 * @description Class holding route legs
 */
.factory('flt.Route',
['$filter', 'flt.Leg',
function RouteFactory($filter, Leg)
{
/**
   * Constructor for route
   *
   * @class Route
   * @constructor
   *
   * @param {apiLeg} legs
   * @param {Number} legType
   * @param {PriceGroup} [priceGroup]
   */
  var Route = function(legs, legType, priceGroup)
  {
    var self = this;

    /**
     * The price group this leg belongs to
     *
     * @type {PriceGroup|null}
     */
    this.priceGroup = priceGroup || null;

    /**
     * Collection of route legs
     *
     * @type {Leg[]}
     */
    this.legs = _.map(legs, function(leg)
    {
        return new Leg(leg, legType);
    });

    /**
     * The number of visible legs
     *
     * @type {int}
     */
    this.visibleLegsCount = this.legs.length;

    /**
     * One of the Leg.LEG_TYPE_DEP or Leg.LEG_TYPE_RET
     *
     * @type {Number} legType
     */
    this.routeType = legType;

    /**
     * The best leg (shortest)
     *
     * @type {Leg}
     */
    this.bestLeg = null;

    /**
     * The min stops leg
     *
     * @type {Leg}
     */
    this.minStopsLeg = null;

    /**
     * The leg having shortest layover duration
     *
     * @type {Leg}
     */
    this.minLayoverLeg = null;

    /**
     * The leg having longest layover duration
     *
     * @type {Leg}
     */
    this.maxLayoverLeg = null;

    /**
     * Selected leg for this route
     *
     * @type {Leg}
     */
    this.selectedLeg = this.getBestLeg();
  };

  // Define instance methods
  Route.prototype = /** @lends Route.prototype */ {
    /**
     * Returns this route legs
     *
     * @return {Leg[]}
     */
    getLegs: function()
    {
      return this.legs;
    },

    /**
     * Get legs which should be shown on view (marked as visible)
     *
     * @return {Leg[]}
     */
    getVisibleLegs: function ()
    {
      // TODO: Optimize - to many calls
      return $filter('filter')(this.legs, { visible: true });
    },

    /**
     * Returns true if there are visible legs
     *
     * @return {Boolean}
     */
    hasVisibleLegs: function()
    {
      return this.visibleLegsCount > 0;
      //return this.getVisibleLegs().length > 0;
    },

    /**
     * Returns true if there is selected, visible leg
     *
     * @param {Leg[]} visibleLegs
     *
     * @returns {Boolean}
     */
    hasVisibleSelectedLeg: function(visibleLegs)
    {
      var selectedLeg = this.getSelectedLeg();

      if (!selectedLeg) return false;

      visibleLegs = visibleLegs || this.getVisibleLegs();

      return _.contains(_.map(visibleLegs, function(leg){ return leg.getId(); }), selectedLeg.getId());
    },

    /**
     * Returns all legs for departure and compatible legs for return
     * It also selects the best compatible leg in case the previous
     * selected one is not in the filtered list
     *
     * @param  {PriceGroup} priceGroup
     *
     * @return {Leg[]}
     */
    getValidLegs: function(priceGroup)
    {
      // Check if this route is a return route
      if(this.getType() == 1)
      {
        // This is a return route, choose legs that are compatible with selected departure leg
        var
          depLeg = priceGroup.getDepRoute().getSelectedLeg(),
          compatibleLegs = [];

        // Check if a departure leg was selected
        if(depLeg === null) return this.getLegs();

        // Get all compatible return legs for the departure leg
        compatibleLegs = _.filter(this.getLegs(), function(leg)
        {
          return leg.getDepTimeMoment().isAfter(depLeg.getArrTimeMoment());
        }, this);

        // Check to see if selected leg is in the compatible legs
        var selCheck = _.find(compatibleLegs, function(leg)
        {
          return leg.getId() == this.getSelectedLeg().getId();
        }, this);

        if(selCheck === undefined)
        {
          // Selected leg is not in the compatible array
          // so we need to find the best compatible leg
          // and select it by default
          this.selectLeg(this.resetBestLeg().getBestLeg(compatibleLegs));
        }

        // Return all compatible legs
        return compatibleLegs;
      }
      else
      {
        // This is not a return route, return all legs
        return this.getLegs();
      }
    },

    /**
     * Pick the best (shortest) leg
     *
     * @return {Leg|null} [legs]
     */
    getBestLeg: function(legs)
    {
      var legArray = legs || this.getLegs(),
          bestLeg;

      if (this.bestLeg === null)
      {
        bestLeg = _.min(legArray, function(leg)
        {
          return leg.dur;
        });

        if (!_.isObject(bestLeg)) bestLeg = null;

        this.bestLeg = bestLeg;
      }

      return this.bestLeg;
    },

    /**
     * Resets the best leg
     *
     * @return {Route}
     */
    resetBestLeg: function()
    {
      this.bestLeg = null;
      return this;
    },

    /**
     * Pick the min stops leg
     *
     * @return {Leg}
     */
    getMinStopsLeg: function()
    {
      if (this.minStopsLeg == null)
      {
        this.minStopsLeg = _.min(this.getLegs(), function(leg)
        {
          return leg.getStops();
        });
      }

      return this.minStopsLeg;
    },

    /**
     * Pick the min layover leg
     *
     * @return {Leg}
     */
    getMinLayoverLeg: function()
    {
      if (this.minLayoverLeg == null)
      {
        this.minLayoverLeg = _.min(this.getLegs(), function(leg)
        {
          return leg.getLayoverDuration();
        });
      }

      return this.minLayoverLeg;
    },

    /**
     * Pick the max layover leg
     *
     * @return {Leg}
     */
    getMaxLayoverLeg: function()
    {
      if (this.maxLayoverLeg == null)
      {
        this.maxLayoverLeg = _.max(this.getLegs(), function(leg)
        {
          return leg.getLayoverDuration();
        });
      }

      return this.maxLayoverLeg;
    },

    /**
     * Returns the selected leg for this route
     *
     * @return {Leg}
     */
    getSelectedLeg: function()
    {
      return this.selectedLeg;
    },

    /**
     * Returns type of route (departure 0, return 1)
     *
     * @return {Number}
     */
    getType: function()
    {
      return this.routeType;
    },

    /**
     * Sets the selected leg for this route
     *
     * @param {Leg} leg
     *
     * @return Route
     */
    selectLeg: function(leg)
    {
      this.selectedLeg = leg;

      return this;
    },

    /**
     * Return total number of legs this route has
     *
     * @return {Number}
     */
    getLegsCount: function()
    {
      return this.legs.length;
    },

    /**
     * Add or subtract number of visible legs
     *
     * @param {int} delta The 1 or -1
     * @param {int} legType One of the Leg.LEG_TYPE_DEP or Leg.LEG_TYPE_RET
     *
     * @return Route
     */
    setVisibleLegsDelta: function(delta, legType)
    {
      this.visibleLegsCount += delta;

      if (this.priceGroup)
      {
        this.priceGroup.setVisibleLegsDelta(delta, legType);
      }

      return this;
    }
  };

  Route.prototype.constructor = Route;

  return Route;
}]);
;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/Segment.js
/*global moment: false */

angular.module('flight')

/**
 * @name        Segment
 * @namespace   flt
 * @description Factory returning Segment constructor
 */
.factory('flt.Segment',
[
function SegmentFactory() {
/**
   * Segment
   *
   * @param {Object} segment The mobile response segment object
   * @param {Leg}    leg     The leg this segment belongs to
   * @param {Number} index   The index of the segment in mobile response seg array
   *
   * @class Segment
   */
  var Segment = function (segment, leg, index) {
    /**
     * Carrier code
     *
     * @type {String}
     */
    this.carr = segment.carr;

    /**
     * The operating carrier code
     *
     * @type {String}
     */
    this.operCarr = segment.operCarr;

    /**
     * The marketing carrier code
     *
     * @type {String}
     */
    this.mktgCarr = segment.mktgCarr;

    /**
     * Flight number
     *
     * @type {String}
     */
    this.fNum = segment.fNum;

    /**
     * Full flight number (Carrier code + flight number)
     */
    this.fullFNum = segment.fullFNum;

      /**
       * Flight stops ex refuel
       *
       * @type {String}
       */
    this.stops = segment.stops;
    /**
     * Departure airport code
     *
     * @type {String}
     */
    this.dep = segment.dep;

    /**
     * Arrival (destination) airport code
     *
     * @type {String}
     */
    this.arr = segment.arr;

    /**
     * Flight duration in minutes
     *
     * @type {Number}
     */
    this.dur = segment.dur;

    /**
     * The wait time in minutes for the next segment
     *
     * @type {Number}
     */
    this.wait = segment.wt;

    /**
     * The wait time for the next segment (as string, ex.: 1h 20m)
     *
     * @type {String}
     */
    this.waitFormatted = parseInt(this.wait / 60) + 'h ' + this.wait % 60 + 'm';

    /**
     * Set to true if waiting for next leg is marked as overnight
     *
     * @type {Boolean}
     */
    this.overnight = segment.ovn ? true : false;

    /**
     * Departure time
     *
     * @type {String}
     */
    this.depT = segment.depT;

    /**
     * Arrival time
     *
     * @type {String}
     */
    this.arrT = segment.arrT;

    /**
     * Starting terminal
     *
     * @type {String}
     */
    this.sTer = segment.sTer;

    /**
     * Ending terminal
     *
     * @type {String}
     */
    this.eTer = segment.eTer;

    /**
     * The index of the segment in mobile response seg array
     *
     * @var {Number}
     */
    this.index = index;

    /**
     * The leg this segment belongs to
     *
     * @type {Leg}
     */
    this.leg = leg;

    /**
     * This segment requires a passport
     *
     * @type {number}
     */
    this.passReq = segment.passReq | false;

      /**
       * This fly or train segment
       *
       * @type {string}
       */
    this.plane = segment.plane;

    /**
     * Set the conveyance type (as string, ex.: train, bus, flight).
     *
     * @type {string}
     */
    this.conveyance = segment.conveyance;

    /**
     * End time of layover
     *
     * @type {String}
     */
    this.layoverEndTime = moment(this.arrT).add(this.wait * 60000).format('HH:mm');

    /**
     *Search provider name
     *
     * @type string
     */
    this.provider = segment.provider;

    this.flightType = null;
  };

  // Class consonances
  Segment.NO_LAYOVER = 'NO_LAYOVER';
  Segment.LONG_LAYOVER = 'LONG_LAYOVER';
  Segment.OVERNIGHT_LAYOVER = 'OVERNIGHT_LAYOVER';

  // Set instance methods
  Segment.prototype = {

    /**
     * Get carrier code
     *
     * @return {String}
     */
    getCarrier: function () {
      return this.carr;
    },

    /**
     * Get operating carrier code
     *
     * @return {String}
     */
    getOperCarrier: function () {
      return this.operCarr;
    },

    /**
     * Get departure airport code
     *
     * @return {String}
     */
    getDepAirportCode: function () {
      return this.dep;
    },

    /**
     * Get arrival airport code
     *
     * @return {String}
     */
    getArrAirportCode: function () {
      return this.arr;
    },

    /**
     * Get flight number
     *
     * @return {String}
     */
    getFlightNumber: function () {
      return this.fNum;
    },

    /**
     * Get segment duration
     *
     * @return {String}
     */
    getSegmentDuration: function () {
      var dur = moment.duration(this.dur, 'minutes'),
        hours = dur.hours(),
        minutes = dur.minutes();

      if (minutes === 0) {
        minutes = '00';
      }

      return hours + 'h' + ' ' + minutes + 'm';
    },

    /**
     * Get departure day
     *
     * @return {String} Long name of the week with capital letter
     */
    getDepDay: function () {
      return moment(this.depT).format('dddd');
    },

    /**
     * Get departure date as moment
     *
     * @return {Moment} The time as moment instance
     */
    getDepDateMoment: function () {
      return moment(this.depT);
    },

    /**
     * Get arrival day
     *
     * @return {String} Long name of the week with capital letter
     */
    getArrDay: function () {
      return moment(this.arrT).format('dddd');
    },

    /**
     * Get arrival date as moment
     *
     * @return {Moment} The time as moment
     */
    getArrDateMoment: function () {
      return moment(this.arrT);
    },

    /**
     * Get departure date
     *
     * @return {String} Date in DD.MM.YYYY format
     */
    getDepDate: function () {
      return moment(this.depT).format('DD.MM.YYYY');
    },

    /**
     * Get arrival date
     *
     * @return {String} Date in DD.MM.YYYY format
     */
    getArrDate: function () {
      return moment(this.arrT).format('DD.MM.YYYY');
    },

    /**
     * Get departure time
     *
     * @return {String} The time in HH:mm format
     */
    getDepTime: function () {
      return moment(this.depT).format('HH:mm');
    },

    /**
     * Get arrival time
     *
     * @return {String} The time in HH:mm format
     */
    getArrTime: function () {
      return moment(this.arrT).format('HH:mm');
    },

    /**
     * Get layover type
     *
     * @return {String}
     */
    getLayoverType: function () {
      if (this.overnight) {
        return Segment.OVERNIGHT_LAYOVER;
      }

      return Segment.NO_LAYOVER;
    },

    /**
     * Is overnight layover?
     *
     * @return {Boolean}
     */
    isOvernight: function () {
      return this.overnight;
    },

    /**
     * Get start terminal
     *
     * @return {String} Name of terminal
     */
    getStartTerminal: function () {
      return this.sTer;
    },

    /**
     * Get end terminal
     *
     * @return {String} Name of terminal
     */
    getEndTerminal: function () {
      return this.eTer;
    },

    /**
     * Get layover (wait time) between this segment and the next one.
     *
     * @return {Number}
     */
    getLayoverDur: function () {
      return this.wait;
    },

    /**
     * Get end time of layover
     *
     * @return {Date}
     */
    getLayoverEndTime: function () {
      return this.layoverEndTime;
    },

    /**
     * Get layover formatted (wait time) between this segment and the next one.
     *
     * @return {String}
     */
    getLayoverDurFormatted: function () {
      return this.waitFormatted;
    },

    /**
     * Get layover formatted (wait time) between this segment and the next one - rounded.
     *
     * @return {String}
     */
    getLayoverDurFormattedShort: function () {
      if(this.wait % 60 > 39){
        return parseInt((this.wait / 60) + 1) + 'h';
      }
      else {
        if (this.wait >= 60) {
          return parseInt(this.wait / 60) + 'h';
        }
        return parseInt(this.wait) + 'm';
      }
    },

    /**
     * This segment requires a passport
     *
     * @returns {number}
     */
    isPassportRequired : function(){
      return this.passReq;
    },

    /**
     * Get leg
     *
     * @return {Leg}
     */
    getLeg: function () {
      return this.leg;
    },

    /**
     * Get provider name
     *
     * @returns {string}
     */
    getProvider: function () {
      return this.provider;
    },

    setFlightType: function (flightType) {
      this.flightType = flightType;
    },

    /**
     * Return server object
     *
     * @returns {Object}
     */
    getSrvObj: function () {
      return {
        carr: this.getCarrier(),
        fNum: this.getFlightNumber(),
        dep: this.getDepAirportCode(),
        arr: this.getArrAirportCode(),
        dur: this.dur,
        wt: this.getLayoverDur(),
        ovn: this.isOvernight(),
        depT: this.getDepDateMoment().format('YYYY-MM-DD HH:mm'),
        arrT: this.getArrDateMoment().format('YYYY-MM-DD HH:mm'),
        sTer: this.getStartTerminal(),
        eTer: this.getEndTerminal(),
        layType: this.getLayoverType(),
        provider: this.getProvider()
      };
    }

  };

  Segment.prototype.constructor = Segment;

  return Segment;
}]);

;

// Source: ../shared/public_html/assets/js/flight/models/pricegroup/pgDecorator.js
angular.module('flight')

/**
 * @name        pgDecorator
 * @namespace   flt
 * @description Factory returning price group decorator function
 */
.factory('flt.pgDecorator',
['flt.PriceGroup',
function pgDecoratorFactory(PriceGroup) {
/**
   * Return array of initialized PriceGroups
   *
   * @param  {apiPriceGroup[]} priceGroups The array of JSON objects representing price groups
   *
   * @return {PriceGroup[]}
   */
  return function (priceGroups) {
    return priceGroups.map(function (priceGroup) {
      return new PriceGroup(priceGroup);
    });
  };
}]);

;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-offer-actions.component.js
(function(angular) {
var IthFlightOfferActionsComponent = {
        controller: 'FlightOfferActions',
        templateUrl: '/tpl/show/jsShared/templates/flights/offer/actions',
        transclude: true,
        bindings: {
            index: '<',
            data: '<',
            requestId: '<',
            sessionId: '<',
            searchQueryParams: '<',
            showComboDeal: '<'
        }
    };

    angular
        .module('flight')
        .component('ithFlightOfferActions', IthFlightOfferActionsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-offer-actions.controller.js
(function(angular) {
var IthFlightOfferActionsController = function ($window, $location, $translate, SouthParkApi, SouthParkHelper, FlightOfferHelper, AnalyticsServiceHelper, FeedbackPopup, SouthParkFlightCache, FareLockHelper, AppConfig, $scope, PageLoading) {
        /**
         * Flag that determines if flight details redirect is loading
         *
         * @type {Boolean}
         */
        this.isLoading = false;

        /**
         * @type {boolean}
         */
        this.isLoadingFlightDetails = false;

        /**
         * @type {boolean}
         */
        this.isLoadingFareLock = false;

        this.getSearchUrl = function () {
            return $location.url().split('#')[0];
        };

        /**
         * Loads flight details link from backend and redirects to it
         */
        this.goToDetails = function () {
            if (this.sessionId === undefined || this.sessionId === null) {
                this.sessionId = AppConfig.getGaSession();
            }

            var self = this;
            this.isLoading = true;
            this.isLoadingFlightDetails = true;

            if (AppConfig.getIsChangedButtonFlowAbTest()) {
                PageLoading.on();
            }

            // Send analytics data
            AnalyticsServiceHelper.sendSearchData(
                this.index,
                this.data,
                SouthParkHelper,
                this.searchQueryParams
            );

            SouthParkApi
                .getFlightDetailsLink(this.requestId, this.sessionId, this.data.fulfillmentToken)
                .then(function (success) {
                    var backToSearchUrl = self.getSearchUrl();
                    $location.path(success.data.response.basketUrl).search('backToSearchUrl', backToSearchUrl);
                })
                .catch(function (error) {
                    var titleLang = 'LANGM_JS_FS_CONTINUE_ERROR_TITLE';
                    var textLang = 'LANGM_JS_FS_CONTINUE_ERROR_TEXT';
                    var buttonLang = 'LANGM_JS_CLOSE';

                    if (error.status === 404) {
                        titleLang = 'LANGM_JS_FS_CONTINUE_NOT_FOUND_TITLE';
                        textLang = 'LANGM_JS_FS_CONTINUE_NOT_FOUND_TEXT';

                        // Add flight to blacklist and remove it from results
                        SouthParkFlightCache
                            .clear()
                            .then(function () {
                                SouthParkHelper.refreshFlightList();
                            });
                    }

                    if (error.status === 400) {
                        titleLang = 'LANGM_JS_FS_CONTINUE_REFRESH_TITLE';
                        textLang = 'LANGM_JS_FS_CONTINUE_REFRESH_TEXT';
                        buttonLang = 'LANGM_JS_REFRESH_FLIGHTS';

                        // // Refresh flights
                        SouthParkFlightCache
                            .clear()
                            .then(function () {
                                SouthParkHelper.search();
                            });
                    }

                    $translate([titleLang, textLang, buttonLang])
                        .then(function (translations) {
                            FeedbackPopup.openErrorPopup(
                                translations[titleLang],
                                translations[textLang],
                                translations[buttonLang]
                            );
                        });
                })
                .finally(function () {
                    self.isLoading = false;
                    self.isLoadingFlightDetails = false;
                });
        };
        var ctrl = this;

        $scope.$on('flight-offer-clicked', function (event, uniqueId) {
            if (uniqueId === ctrl.data.uniqueId && AppConfig.isMobile() && AppConfig.getIsChangedButtonFlowAbTest()) {
                ctrl.goToDetails();
            }
        })

        this.isMobileContinueButtonVisible = function () {
            return !AppConfig.getIsChangedButtonFlowAbTest();
        }

        this.isChangedButtonsFlow = function () {
            return AppConfig.getIsChangedButtonFlowAbTest();
        }

        this.isFareLockAvailable = function () {
            return !!this.data.fareLock && AppConfig.getFareLockAbTest();
        };

        this.getFareLockPrice = function () {
            if (!this.data.fareLock) {
                return null;
            }

            return this.data.fareLock.pricing[0].price.amount;
        };

        this.getFareLockCoveredAmount = function () {
            if (!this.data.fareLock) {
                return null;
            }

            return this.data.fareLock.coveringAmount.amount;
        };

        //todo: to remove
        this.getFareLockId = function () {
            if (!this.data.fareLock) {
                return null;
            }

            return this.data.fareLock.pricing[0].id;
        };

        /**
         * Loads flight details link from backend and redirects to it
         */
        this.goToFareLock = function () {
            var self = this;
            this.isLoading = true;
            this.isLoadingFareLock = true;

            FareLockHelper
                .goToFareLock(this.data.fulfillmentToken, self.getSearchUrl(), 'search_flight')
                .finally(function () {
                    self.isLoading = false;
                    self.isLoadingFareLock = false;
                });
        };

        /**
         * Returns pax count
         *
         * @returns {String} ONE / MANY
         */
        this.getPaxCountType = function () {
            if (this.searchQueryParams.getPaxTotalFromLink() === 1) {
                return 'ONE';
            }

            return 'MANY';
        };

        /**
         * Returns price with TF for agents and price without TF for users
         *
         * @returns {Number}
         */
        this.getPrice = function () {
            return FlightOfferHelper.getOfferPrice(this.data);
        };
    };

    IthFlightOfferActionsController.$inject = [
        '$window',
        '$location',
        '$translate',
        'SouthParkApi',
        'SouthParkHelper',
        'FlightOfferHelper',
        'AnalyticsServiceHelper',
        'FeedbackPopup',
        'SouthParkFlightCache',
        'FareLockHelper',
        'appConfig',
        '$scope',
        'PageLoading'
    ];

    angular
        .module('funnel')
        .controller('FlightOfferActions', IthFlightOfferActionsController);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-offer-airlines.component.js
(function(angular) {
var IthFlightOfferAirlinesController = function (AppConfig) {

        this.extraValue = 3;

        this.getImgVersion = AppConfig.getJsCacheBuster;

        /**
         * Returns array name containing translated airline names
         *
         * @returns {String[]}
         */
        this.getAirlineNames = function () {
            var a = [];
            var self = this;

            angular.forEach(this.airlines, function (airlineCode) {
                a.push(self.dictionary.getAirlineName(airlineCode));
            });

            return a;
        };

        /**
         * Returns number of airlines above max value
         *
         * @returns {Number}
         */
        this.getExtraCount = function () {
            return this.airlines.length - this.extraValue + 1;
        };
    };

    IthFlightOfferAirlinesController.$inject = [
        'appConfig'
    ];

    var IthFlightOfferAirlinesComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/offer/airlines',
        bindings: {
            airlines: '<',
            dictionary: '<'
        },
        controller: IthFlightOfferAirlinesController
    };

    angular
        .module('flight')
        .component('ithFlightOfferAirlines', IthFlightOfferAirlinesComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-offer-journey.component.js
(function(angular) {
var IthFlightOfferJourneyComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/offer/journey',
        bindings: {
            data: '<',
            dictionary: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFlightOfferJourney', IthFlightOfferJourneyComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-offer.component.js
(function(angular) {
var IthFlightOfferComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/offer/flight-offer',
        transclude: true,
        bindings: {
            index: '<',
            data: '<',
            requestId: '<',
            sessionId: '<',
            dictionary: '<',
            searchQueryParams: '<',
            isChangedButtonsFlow: '<'
        }
    };

    angular
        .module('flight')
        .component('ithFlightOffer', IthFlightOfferComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/offer/ith-flight-stage.component.js
(function (angular) {
var controller = function (appConfig) {
        /**
         * Returns enum for lang
         *
         * @returns {String}
         */
        this.getStopEnum = function () {
            if (this.stage.stopovers.length === 0) {
                return 'direct';
            }

            if (this.stage.stopovers.length === 1) {
                return 'one';
            }

            return 'many';
        };

        this.isMobile = function () {
            return appConfig.isMobile();
        };

        this.isChangedButtonsFlow = function () {
            return appConfig.getIsChangedButtonFlowAbTest();
        }
    };

    controller.$inject = [
        'appConfig'
    ];

    var IthFlightStageComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/offer/stage',
        controller: controller,
        bindings: {
            stage: '<',
            index: '<',
            dictionary: '<'
        }
    };

    angular
        .module('flight')
        .component('ithFlightStage', IthFlightStageComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/loading-carousel/loading-carousel.component.js
(function(angular) {
/**
     * @name        loadingCarousel
     * @description component to trigger loading box on pax reconfiguration modal.
     */

    var loadingCarousel = {
        selector: 'loading-carousel',
        templateUrl: "/tpl/show/jsShared/templates/flights/flightDetails/paxReconfiguration/loadingCarousel",
        controller: 'LoadingCarouselController'
    };

    angular.module('ITH.Flyhacks.Flight.LoadingCarousel')
        .component('loadingCarousel', loadingCarousel);

})(angular);;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/loading-carousel/loading-carousel.controller.js
(function(angular) {
/**
     * @name        LoadingCarouselController
     * @description Controller for loading carousel on pax reconfiguration modal.
     */
    var LoadingCarouselController = function($interval, $filter) {
        var self = this;

        var translate = $filter('translate');

        /**
         * Interval time in seconds.
         * @type {number}
         */
        var intervalTime = 15;

        /**
         * Translated langs object for carousel.
         * @type {Array}
         */
        var langs = [
            translate('LANGM_JS_ADDPAX_LOADING_1'),
            translate('LANGM_JS_ADDPAX_LOADING_2'),
            translate('LANGM_JS_ADDPAX_LOADING_3')
        ];

        /**
         * @type {number}
         */
        var currentIndex = 0;

        /**
         * carousel main function.
         */
        var carousel = function() {
            var interval = $interval(function() {
                currentIndex = currentIndex + 1;
                self.current = langs[currentIndex];

                if(currentIndex === 2) {
                    $interval.cancel(interval);
                }
            }, intervalTime * 1000)
        };

        /**
         * Current shown lang.
         * @type {String}
         */
        this.current = langs[0];

        /**
         * run carousel.
         */
        carousel();
    };

    LoadingCarouselController.$inject = [
        '$interval',
        '$filter'
    ];

    angular.module('ITH.Flyhacks.Flight.LoadingCarousel')
        .controller('LoadingCarouselController', LoadingCarouselController);

})(angular);




;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/pax-reconfiguration-modal.controller.js
(function (angular, underscore) {
/**
     * @name        PaxReconfigurationModalController
     * @description Ctrl for changing pax configuration on pax details.
     */
    var PaxReconfigurationModalController = function ($modalInstance, paxModel, flightType, $timeout, $filter, $location, prs, appConfig) {

        var constans = {
            TEST_SELL_STATUS_NO_SEATS: 4,
            TEST_SELL_STATUS_ERROR: 13,
        }

        var self = this;

        var translate = $filter('translate');

        /**
         * New request id for change paxDetails. It come form test sell.
         *
         * @type {string}
         */
        var newRequestId = '';

        /**
         * Object for ga where analytics want to know how many paxes user add on this step.
         *
         * @type {{adults: number, children: number, infants: number, youths: number, seniors: number}}
         */
        var paxChanges = {
            adults: 0,
            children: 0,
            infants: 0,
            youths: 0,
            seniors: 0
        };

        /**
         * Function for serializing pax object which is send to test sell.
         *
         * @param model {Object}
         * @return {Object}
         */
        var serializePaxData = function (model) {
            var types = {
                adults: 'adt',
                children: 'chd',
                infants: 'inf',
                youths: 'yth',
                seniors: 'src',
            };

            var summary = '';

            var setup = {};

            for (var pax in types) {
                var count = model[pax].count;
                if (count) {
                    setup[types[pax]] = count;
                }
            }

            summary = JSON.stringify(setup);

            return {
                setup: setup,
                summary: summary
            };
        };

        /**
         * Function for calculation summary price for all paxes.
         *
         * @param testSellResponse
         * @return {number}
         */
        var getSummaryPrice = function (testSellResponse) {

            var summary = 0;

            angular.forEach(testSellResponse, function (pax) {
                summary += pax.totalNettoPrice;
            });

            return summary;
        };

        /**
         * Function for closing modal & reloading pax details page.
         */
        this.goToNewPaxDetails = function () {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Flight Details - Add New Passenger',
                eventAction: 'Accept New Price',
                nonInteraction: true
            });

            $modalInstance.close({
                status: 'newPaxDetails',
                newRequestId: newRequestId
            });
        };

        /**
         * Test sell success function.
         *
         * @param response
         */
        var testSellSuccess = function (response) {
            self.testSellInProgres = false;

            response.pricing = mapPaxes(response.pricing);

            switch (response.test_sell_status) {
                case constans.TEST_SELL_STATUS_NO_SEATS:
                    self.testSellError = true;
                    self.errorTitle = translate('LANGM_JS_PD_TITLE_NO_SEATS');
                    self.errorDesc = translate('LANGM_JS_PD_INFO_DESC');
                    break;
                case constans.TEST_SELL_STATUS_ERROR:
                    self.testSellError = true;
                    self.errorTitle = translate('LANGM_JS_PD_BOOKING_ERROR_DESC');
                    self.errorDesc = translate('LANGM_JS_ADDPAX_ERROR');
                    break;
                default:
                    self.testSellResponse = response;
                    self.summaryPrice = getSummaryPrice(response.pricing);
                    newRequestId = response.request_id;
                    self.showSummaryBox = true;
                    break;
            }
        };

        /**
         * Test sell fail function.
         *
         */
        var testSellFail = function () {
            self.testSellInProgres = false;
            self.testSellError = true;
            self.errorTitle = translate('LANGM_JS_PD_BOOKING_ERROR_DESC');
            self.errorDesc = translate('LANGM_JS_ADDPAX_ERROR');
        };

        /**
         * Function for mapping pricing from test sell to proper order (same as on paxSelect section).
         * Input: Object with Pricings for each pax type.
         * Output: Sorted array with types which was selected by user (in keys: ['ADT', 'CHD', 'INF', 'YTH', 'SRC']).
         *
         * @param data
         * @return {Array}
         */
        var mapPaxes = function (data) {
            var keys = ['ADT', 'CHD', 'INF', 'YTH', 'SRC'];
            var result = [];
            var mapped = {};

            angular.forEach(data, function (val) {
                mapped[val['type']] = val;
            });

            angular.forEach(keys, function (value) {
                if (mapped[value]) {
                    result.push(mapped[value]);
                }
            });

            return result;
        };

        /**
         * Object with translated langs for summaryBox.
         *
         * @type {Object}
         */
        this.summaryBoxLangs = {
            ADT: translate('LANGM_JS_ADDPAX_ADULT'),
            CHD: translate('LANGM_JS_ADDPAX_KID'),
            INF: translate('LANGM_JS_ADDPAX_INFANT'),
            YTH: translate('LANGM_JS_ADDPAX_TEEN'),
            SRC: translate('LANGM_JS_ADDPAX_SENIOR')
        };

        this.selectingBox = true;

        /**
         * @type {boolean}
         */
        this.noSeatsStatus = false;

        /**
         * @type {boolean}
         */
        this.testSellError = false;

        /**
         * pax model form PaxReconfigurationController.
         */
        this.paxModel = paxModel;

        /**
         * Initial pax configuration.
         * @type {Object}
         */
        var initialPaxState = serializePaxData(this.paxModel.model.group).summary;

        /**
         * Flag for showing loading box on modal.
         * @type {boolean}
         */
        this.testSellInProgres = false;

        /**
         * Flag for showing summary box on modal.
         * @type {boolean}
         */
        this.showSummaryBox = false;

        /**
         * Flag blocking accept button.
         * @type {boolean}
         */
        this.blockDoTestSell = true;

        /**
         * Close modal.
         */
        this.cancel = function (sendEventToGA) {
            if (sendEventToGA) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Flight Details - Add New Passenger',
                    eventAction: 'Reject New Price',
                    nonInteraction: true
                });
            }
            $modalInstance.dismiss('cancel');
        };

        this.backToSearch = function () {
            $modalInstance.close({
                status: 'backToSearch'
            });
        };

        /**
         * Check that paxModel is changed & modify paxChange obj for analytics.
         */
        this.modelChange = function (key, action) {
            (action === 'add') ? paxChanges[key] = paxChanges[key] + 1 : paxChanges[key] = paxChanges[key] - 1;

            self.blockDoTestSell = initialPaxState === serializePaxData(self.paxModel.model.group).summary
        };

        /**
         * Function for hiding seniors selector on vola.
         * @param {String} key 
         */
        this.showPaxSelector = function (key) {
            return key !== 'seniors';
        }

        /**
         * Trigger test sell for new pax configuration.
         */
        this.doTestSell = function () {
            var newConfiguration = serializePaxData(self.paxModel.model.group);

            ga('send', {
                hitType: 'event',
                eventCategory: 'Flight Details - Add New Passenger',
                eventAction: newConfiguration.summary,
                eventLabel: 'A:' + paxChanges['adults'] + ';K:' + paxChanges['children'] + ';B:' + paxChanges['infants'] + ';T:' + paxChanges['youths'] + ';S:' + paxChanges['seniors'],
                nonInteraction: true
            });

            this.selectingBox = false;
            this.testSellInProgres = true;

            prs.callTestSell(newConfiguration.setup).then(testSellSuccess, testSellFail);
        };
    };

    PaxReconfigurationModalController.$inject = [
        '$modalInstance',
        'paxModel',
        'flightType',
        '$timeout',
        '$filter',
        '$location',
        'PaxReconfigurationService',
        'appConfig',
    ];

    angular.module('ITH.Flyhacks.Flight.PaxReconfiguration')
        .controller('PaxReconfigurationModalController', PaxReconfigurationModalController);

})(angular, _);




;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/pax-reconfiguration.component.js
(function (angular) {
/**
     * @name        paxReconfiguration
     * @description component to trigger pax configuration modal.
     */
    // var paxReconfiguration = {
    //     selector: 'pax-reconfiguration',
    //     bindings: {
    //         flightType: "<"
    //     },
    //     templateUrl: "/tpl/show/jsShared/templates/flights/flightDetails/paxReconfiguration/paxReconfiguration",
    //     controller: 'PaxReconfigurationController'
    // };
    //
    // angular.module('ITH.Flyhacks.Flight.PaxReconfiguration')
    //     .component('paxReconfiguration', paxReconfiguration);

})(angular);
;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/pax-reconfiguration.controller.js
(function (angular) {
/**
     * @name        PaxReconfigurationController
     * @description The alert ctrl for train and bus segments.
     */
    var PaxReconfigurationController = function ($modal, $location, $state, FlightBooking, FlightPaxModel) {

        var sefl = this;

        /**
         * Function for setting paxModel from flightBooking.
         *
         * @return {Object}
         */
        var setPaxModel = function () {
            /**
             * Flight booking pricings where is info about paxes.
             */
            var paxConfiguration = FlightBooking.flightDetails.getPaxesPricing().getPricings();

            /**
             * Pax model.
             */
            var paxModel = angular.copy(FlightPaxModel);

            angular.forEach(paxConfiguration, function (obj) {
                if (paxModel.model.group.hasOwnProperty('seniors')) {
                    paxModel.model.group.seniors.count = 0;
                };

                switch (obj.paxType) {
                    case 'ADT':
                        paxModel.model.group.adults.count = obj.count;
                        break;
                    case 'YTH':
                        paxModel.model.group.youths.count = obj.count;
                        break;
                    case 'CHD':
                        paxModel.model.group.children.count = obj.count;
                        break;
                    case 'INF':
                        paxModel.model.group.infants.count = obj.count;
                        break;
                    case 'SRC':
                        paxModel.model.group.seniors.count = obj.count;
                        break
                    default:
                        return;
                }
            });

            return paxModel;
        };

        /**
         * Pax configuration modal trigger.
         */
        this.showPaxConfigurationModal = function () {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Flight Details - Add New Passenger',
                eventAction: 'Add New Passenger Click',
                nonInteraction: true
            });

            var paxReconfigurationModal = $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/paxReconfiguration/paxReconfigurationModal',
                controller: 'PaxReconfigurationModalController',
                controllerAs: '$ctrl',
                windowClass: 'pax-reconfiguration enabled-window-back-btn',
                animation: false,
                backdrop: 'static',
                resolve: {
                    paxModel: function () {
                        return setPaxModel();
                    },
                    flightType: function () {
                        return sefl.flightType;
                    }
                }
            });

            paxReconfigurationModal.result.then(function (data) {
                if (data.status === 'backToSearch') {
                    var backToSearchUrl = FlightBooking.getFlightDetails().getSearchUrl();
                    var locationSearch = $location.search();

                    if (locationSearch.hasOwnProperty('backToSearchUrl')) {
                        backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
                    }

                    $location.path(backToSearchUrl);
                }

                if (data.status === 'newPaxDetails') {
                    $state.transitionTo($state.current, {
                        requestId: data.newRequestId
                    }, {
                            reload: true,
                            inherit: true,
                            notify: true
                        });
                }
            });
        }
    };

    PaxReconfigurationController.$inject = [
        '$modal',
        '$location',
        '$state',
        'bok.FlightBooking',
        'FlightPaxModel',
    ];

    angular.module('ITH.Flyhacks.Flight.PaxReconfiguration')
        .controller('PaxReconfigurationController', PaxReconfigurationController);

})(angular);




;

// Source: ../shared/public_html/assets/js/flight/paxReconfiguration/pax-reconfiguration.service.js
(function (angular) {
/**
     * @name        PaxReconfigurationService.
     * @description Handles luggage data.
     * @constructor
     */
    var PaxReconfigurationService = function ($stateParams, ApiTools) {

            // TODO:
            // we should consider changing this endpoint to 'POST'
            // (since mixing "slash" params with query params is ugly and error-like)

            /**
             * Base configuration for `ApiTools.fetch`.
             *
             * @type {object}
             */
            var endpointConfig = {
                url: '/api/testSell/changePaxSetup/:requestId/:priceGroupId/:depLegId/:retLegId/:fsId'
                + '?abv=' + _js_app_config_.ab_version,
                method: 'GET',
                respParser: function (res) {
                    return res.response;
                }
            };

            /**
             * Pax reconfiguration (changePaxSetup) endpoint interface.
             * This method forms the URL params.
             * Server will prepare new flight-details setup with new pax configuration,
             * including test-sell to check new prices and availability.
             * Flight params required to identify flight:
             * - requestId
             * - priceGroupId
             * - depLegId
             * - retLegId (might be empty/null for one-ways)
             * These are all `flight_details` state params and by default they are read from current `$stateParams`.
             * But calling this method on different state without providing these params results in ugly error.
             * To be honest, using `$stateParams` here is bad design (but saves us from passing them through components).
             *
             * @param paxConfiguration
             * @param flightParams
             * @return Promise (really slow one)
             */
            function callTestSell(paxConfiguration, flightParams) {
                var allParams = angular.extend({}, $stateParams, flightParams);
                var params = {
                    requestId: allParams.requestId,
                    priceGroupId: allParams.priceGroupId,
                    depLegId: allParams.depLegId,
                    retLegId: allParams.retLegId || 0,
                    fsId: allParams.fsId
                };
                angular.extend(params, paxConfiguration);
                return ApiTools.fetch(this, endpointConfig, null, params);
            }

            return {
                callTestSell: callTestSell
            };
        };

    PaxReconfigurationService.$inject = [
        '$stateParams',
        'ApiTools'
    ];

    angular.module('ITH.Flyhacks.Flight.PaxReconfiguration').service('PaxReconfigurationService', PaxReconfigurationService);
})(angular);
;

// Source: ../shared/public_html/assets/js/flight/price-trends/chart/chart-generator.factory.js
(function(angular) {
var ChartGeneratorFactory = function (SvgCreator, ChartPoint) {
        var ChartGenerator = function (element, chartData, referencePrice, formatter) {
            this.element = element;
            this.chartData = chartData;
            this.referencePrice = referencePrice;
            this.formatter = formatter || '{value}';
        };

        ChartGenerator.prototype.render = function () {
            if (this.chartData === undefined) {
                console.error('Chart data is missing!');
                return;
            }

            if (!this.chartData.hasOwnProperty('series') || this.chartData.series.length === 0) {
                console.error('Chart data series is missing!');
                return;
            }

            function getPositionY(value) {
                return height - value * (height - topBoundary - bottomBoundary) / maxValue - bottomBoundary;
            }

            var width = this.element.children(0)[0].clientWidth;
            var height = this.element.children(0)[0].clientHeight;
            var svgCreator = new SvgCreator(width, height);

            var topBoundary = 30;
            var bottomBoundary = 20;
            var leftBoundary = 80;
            var rightBoundary = 20;

            var maxValue = Math.max.apply(null, this.chartData.series);
            var dotsPositions = [];

            var self = this;

            this.chartData.series.forEach(function (value, index) {
                var xValue;
                var yValue = getPositionY(value);

                if (self.chartData.series.length === 1) {
                    xValue = width / 2 + leftBoundary / 2 - rightBoundary / 2;
                }

                if (self.chartData.series.length > 1) {
                    xValue = index * ((width - rightBoundary - leftBoundary) / (self.chartData.series.length - 1)) + leftBoundary;
                }

                dotsPositions.push(new ChartPoint(xValue, yValue));
            });

            var polylinePositions;

            if (dotsPositions.length > 1) {
                polylinePositions = [].concat(
                    new ChartPoint(dotsPositions[0].x, height - bottomBoundary),
                    dotsPositions,
                    new ChartPoint(dotsPositions[dotsPositions.length - 1].x, height - bottomBoundary)
                );
            }

            if (dotsPositions.length === 1) {
                polylinePositions = [
                    new ChartPoint(leftBoundary, height - bottomBoundary),
                    new ChartPoint(leftBoundary, dotsPositions[0].y),
                    new ChartPoint(width - rightBoundary, dotsPositions[0].y),
                    new ChartPoint(width - rightBoundary, height - bottomBoundary)
                ];
            }

            svgCreator.addPolyline(polylinePositions, 'trend-chart__background');
            svgCreator.addPolyline(dotsPositions, 'trend-chart__line');

            dotsPositions.forEach(function (point, index) {
                svgCreator.addCircle(point.x, point.y, 7, 'trend-chart__dot fade-animation fade-animation--index' + index);
                svgCreator.addText(point.x, point.y - 16, self.formatter.split('{value}').join(self.chartData.series[index]), 'trend-chart__dot-text fade-animation fade-animation--index' + index);

                if (self.chartData.labels !== undefined) {
                    svgCreator.addText(point.x, height, self.chartData.labels[index], 'trend-chart__series-text');
                }
            });

            if (this.referencePrice !== undefined) {
                // Create reference price element
                var refPriceY = getPositionY(this.referencePrice);
                var refPriceRectangleWidth = leftBoundary - 20;
                var refPriceRectangleHeight = 20;

                svgCreator.addLine(refPriceRectangleWidth, refPriceY, width - rightBoundary, refPriceY, 'trend-chart__reference-price__line');
                svgCreator.addRect(0, refPriceY - refPriceRectangleHeight / 2, refPriceRectangleWidth, refPriceRectangleHeight, refPriceRectangleHeight / 2, 'trend-chart__reference-price__rectangle');
                svgCreator.addText(refPriceRectangleWidth / 2, refPriceY + 5, this.formatter.split('{value}').join(this.referencePrice), 'trend-chart__reference-price__text');
            }

            this.element.children(0).empty();
            this.element.children(0).append(svgCreator.generate());
        };

        ChartGenerator.prototype.constructor = ChartGenerator;

        return ChartGenerator;
    };

    ChartGeneratorFactory.$inject = [
        'SvgCreator',
        'ChartPoint'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .service('ChartGenerator', ChartGeneratorFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/chart/chart-point.factory.js
(function(angular) {
var ChartPointFactory = function () {
        var ChartPoint = function (x, y) {
            this.x = x;
            this.y = y;
        };

        ChartPoint.prototype.constructor = ChartPoint;

        return ChartPoint;
    };

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .factory('ChartPoint', ChartPointFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/chart/svg-creator.factory.js
(function(angular) {
var SvgCreatorFactory = function () {
        /**
         * Creates a SVG node and returns it
         *
         * @param {String} nodeType
         * @param {Object} data
         * @param {String} content
         *
         * @returns {SVGElement}
         */
        function getNode(nodeType, data, content) {
            var node = document.createElementNS('http://www.w3.org/2000/svg', nodeType);
            for (var prop in data) {
                node.setAttributeNS(null, prop.replace(/[A-Z]/g, function (m, p, o, s) {
                    return '-' + m.toLowerCase();
                }), data[prop]);
            }

            if (content) {
                node.textContent = content;
            }

            return node;
        }

        /**
         * @constructor
         *
         * @param {Number} width
         * @param {Number} height
         */
        var SvgCreator = function (width, height) {
            this.svgData = [{
                type: 'svg',
                data: {
                    viewBox: '0 0' + ' ' + width + ' ' + height
                }
            }];
        };

        /**
         * Generates the SVG
         */
        SvgCreator.prototype.generate = function () {
            var result;
            this.svgData.forEach(function (elem, index) {
                if (index) {
                    result.appendChild(getNode(elem.type, elem.data, elem.contents));
                    return;
                }

                result = getNode(elem.type, elem.data, null);
            });
            return result;
        };

        /**
         * Creates a SVG Polyline
         *
         * @param {ChartPoint[]} points
         * @param {String}       cls
         */
        SvgCreator.prototype.addPolyline = function (points, cls) {
            var pointString = points.map(function (point) { return point.x + ',' + point.y; }).join(' ');

            this.svgData.push({
                type: 'polyline',
                data: {
                    points: pointString,
                    class: cls
                }
            });
        };

        /**
         * Creates a SVG Circle
         *
         * @param {Number} x
         * @param {Number} y
         * @param {Number} r
         * @param {String} cls
         */
        SvgCreator.prototype.addCircle = function (x, y, r, cls) {
            this.svgData.push({
                type: 'circle',
                data: {
                    cx: x,
                    cy: y,
                    r: r,
                    class: cls
                }
            });
        };

        /**
         * Creates a SVG text
         *
         * @param {Number} x
         * @param {Number} y
         * @param {String} text
         * @param {String} cls
         */
        SvgCreator.prototype.addText = function (x, y, text, cls) {
            this.svgData.push({
                type: 'text',
                data: {
                    x: x,
                    y: y,
                    class: cls
                },
                contents: text
            });
        };

        SvgCreator.prototype.addLine = function (x1, y1, x2, y2, cls) {
            this.svgData.push({
                type: 'line',
                data: {
                    class: cls,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                }
            });
        };

        SvgCreator.prototype.addRect = function (x, y, width, height, rx, cls) {
            this.svgData.push({
                type: 'rect',
                data: {
                    class: cls,
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    rx: rx
                }
            });
        };

        SvgCreator.prototype.constructor = SvgCreator;

        return SvgCreator;
    };

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .factory('SvgCreator', SvgCreatorFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/chart/trend-chart.directive.js
(function (angular) {
var TrendChartDirective = function ($window, $timeout, ChartGenerator) {
        return {
            template: '<div class="trend-chart"></div>',
            restrict: 'E',
            scope: {
                chartData: '<',
                referencePrice: '<',
                formatter: '@'
            },
            link: function (scope, element) {
                function generateChart() {
                    var generator = new ChartGenerator(element, scope.chartData, scope.referencePrice, scope.formatter);
                    generator.render();
                }

                function onResize() {
                    generateChart();
                }

                function cleanUp() {
                    angular.element($window).off('resize', onResize);
                }

                angular.element($window).on('resize', onResize);
                scope.$on('$destroy', cleanUp);

                // Init
                $timeout(generateChart, 100);
            }
        };
    };

    TrendChartDirective.$inject = [
        '$window',
        '$timeout',
        'ChartGenerator'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .directive('trendChart', TrendChartDirective);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/pricegroup-marker/pricegroup-marker-helper.service.js
(function (angular, underscore, moment) {
var IthPricegroupMarkerHelperService = function ($q, AppConfig, PriceGroupMarkerApi) {
        /**
         * Only discounts that are lower than this are considered discounts.
         *
         * @type {Number}
         */
        var discountTreshold = 2;

        /**
         * How much should infant price affect the discounted price
         *
         * @type {Number}
         */
        var infantPriceSlash = 0.3;

        /**
         * Reference prices for the campaign.
         *
         * @type {Object}
         */
        var referencePrices = {};

        /**
         * Reference prices are considered until this date.
         *
         * @type {Number}
         */
        var referenceDepMonth = 0;

        /**
         * Rotates array by count
         *
         * @param {Array}  arr
         * @param {Number} count
         *
         * @returns {Array}
         */
        var rotateArray = function (arr, count) {
            var rArr = [].concat(arr);
            while (count > 0) {
                rArr.push(rArr.shift());
                count--;
            }
            return rArr;
        };

        /**
         * Checks if there are reference prices set.
         *
         * @param {string} flightRoute
         *
         * @returns {Boolean}
         */
        var hasReferencePrices = function (flightRoute) {
            return referencePrices.hasOwnProperty(flightRoute) && referencePrices[flightRoute].length > 0;
        };

        /**
         * Returns data only until departure date.
         *
         * @param {string} flightRoute
         *
         * @returns {Object[]}
         */
        var getFilteredData = function (flightRoute) {
            var hasDepMonth = underscore.find(referencePrices[flightRoute], function (pricing) {
                return parseInt(pricing.month) === referenceDepMonth+1;
            });

            if (!hasDepMonth) {
                return [];
            }

            // Get months until departure (included)
            var rangeResults = underscore.filter(referencePrices[flightRoute], function (pricing) {
                return parseInt(pricing.month) <= referenceDepMonth+1;
            });

            return rangeResults;
        };

        /**
         * Checks if future prices (until departure month) are bigger.
         *
         * @param {string} flightRoute
         * @param {number} price
         * @returns {Boolean}
         */
        var futurePricesAreBigger = function (flightRoute, price) {
            var filteredData = getFilteredData(flightRoute);

            // Find prices smaller that the price group price
            var minimumPriceData = underscore.find(filteredData, function (entry) {
                return entry.price < price;
            });

            return minimumPriceData === undefined;
        };

        /**
         * Margin of price on this route.
         *
         * @param {string} flightRoute
         *
         * @returns {Number}
         */
        var getPriceMargin = function (flightRoute) {
            var filteredData = getFilteredData(flightRoute);

            // Find month reference price
            var monthReferencePrice = underscore.find(filteredData, function (pricing) {
                return parseInt(pricing.month) === referenceDepMonth + 1;
            });

            return monthReferencePrice !== undefined ? parseFloat(monthReferencePrice.price) : Math.infinity;
        };

        /**
         * Calculates rounded percent based on two values.
         *
         * @returns {Number}
         */
        var calculateRoundedPercent = function (value1, value2) {
            return Math.round((parseFloat(value2) - parseFloat(value1)) / parseFloat(value2) * 100);
        };

        /**
         * Calculates reference prices based on prices per adult and pax setup
         *
         * @param {string} route
         * @param {Array}  refPricesPerAdult
         * @param {Number} adults
         * @param {Number} children
         * @param {Number} infants
         * @param {Number} youths
         */
        var setReferencePrices = function (route, refPricesPerAdult, adults, children, infants, youths) {
            referencePrices[route] = [];

            underscore.each(refPricesPerAdult, function (adtRefPrice) {
                adtRefPrice.price = estimatePrice(adtRefPrice.price, adults, children, infants, youths);
                referencePrices[route].push(adtRefPrice);
            });
        };

        /**
         * Estimates reference price
         *
         * @param {Number} price
         * @param {Number} adults
         * @param {Number} children
         * @param {Number} infants
         * @param {Number} youths
         *
         * @returns {Number}
         */
        var estimatePrice = function (price, adults, children, infants, youths) {
            return (
                price * (adults + children + youths) + price * infants * infantPriceSlash
            );
        };

        /**
         * Determines if marker should be shown on price group.
         *
         * @param {string} flightRoute
         * @param {number} price
         *
         * @returns {Boolean}
         */
        this.showMarker = function (flightRoute, price) {
            return this.isCampaignActive() && hasReferencePrices(flightRoute) && futurePricesAreBigger(flightRoute, price) && this.getIeftinuarieDiscount(flightRoute, price) > discountTreshold;
        };

        /**
         * Decides if campaign message fallback is shown on the price group.
         *
         * @param   {Number}  price
         * @param   {Number}  index
         * @returns {Boolean}
         */
        this.showCampaignMessage = function (flightRoute, price, index) {
            return !this.showMarker(flightRoute, price) && this.isCampaignActive() && (index < 10 || index === undefined);
        };

        /**
         * Returns amount of discount based on price.
         *
         * @param {string} flightRoute
         * @param {number} price
         * @returns {string}
         */
        this.getIeftinuarieDiscount = function (flightRoute, price) {
            var priceMargin = getPriceMargin(flightRoute);
            return calculateRoundedPercent(price, priceMargin);
        };

        /**
         * Returns reference prices by flight type and until departure month.
         *
         * @returns {Object[]}
         */
        this.getGraphData = function (flightRoute) {
            var currentMonth = moment().month();
            var rotatedReferencePrices = rotateArray(referencePrices[flightRoute], currentMonth);

            // Consider only until dep date month
            var untilDepartureData = [];
            var depDateReached = false;

            underscore.forEach(rotatedReferencePrices, function (pricing) {
                if (!depDateReached) {
                    untilDepartureData.push(pricing);
                }

                if (parseInt(pricing.month) - 1 === parseInt(referenceDepMonth)) {
                    depDateReached = true;
                }
            });

            // Build in chartist format
            var chartistData = {
                labels: [],
                series: []
            };

            underscore.each(untilDepartureData, function (pricing) {
                chartistData.labels.push(moment().month(pricing.month - 1).format('MMM'));
                chartistData.series.push(Math.round(pricing.price));
            });

            return chartistData;
        };

        /**
         * Decides if campaign is visible or not.
         *
         * @returns {Boolean}
         */
        this.isCampaignActive = function () {
            return AppConfig.getPriceTrendsConfig();
        };

        /**
         * Flag for ieftinuarie campaign
         *
         * @type {Boolean}
         */
        this.isIeftinuarieActive = function () {
            return AppConfig.getIeftinuarieConfig() === true;
        };

        /**
         * Loads reference prices from API
         *
         * @param {String} origCity
         * @param {String} origAirport
         * @param {String} destCity
         * @param {String} destAirport
         * @param {String} depDate
         * @param {String} isOneWay
         * @param {Number} adults
         * @param {Number} children
         * @param {Number} infants
         * @param {Number} youths
         */
        this.loadReferencePrices = function (origCity, origAirport, destCity, destAirport, depDate, isOneWay, adults, children, infants, youths) {
            if (!this.isCampaignActive()) {
                return;
            }

            // Reset reference prices
            referencePrices = {};

            // Prepare params
            var owRt = isOneWay ? 1 : 0;
            referenceDepMonth = moment(depDate).month();
            var q = $q.defer();

            var origins = [origCity, origAirport].filter(function (entry) {
                return entry != '';
            }).join(',');

            var destinations = [destCity, destAirport].filter(function (entry) {
                return entry != '';
            }).join(',');

            PriceGroupMarkerApi
                .getData(origins, destinations, depDate, owRt)
                .then(function (success) {
                    // Set reference prices
                    angular.forEach(Object.keys(success.data.response), function (route) {
                        if (route !== 'data') {
                            setReferencePrices(route, success.data.response[route], adults, children, infants, youths);
                        }
                    });

                    q.resolve(success);
                })
                .catch(function (error) {
                    q.reject(error);
                });

            return q.promise;
        };
    };

    IthPricegroupMarkerHelperService.$inject = [
        '$q',
        'appConfig',
        'PriceGroupMarkerApi'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .service('PricegroupMarkerHelper', IthPricegroupMarkerHelperService);

}(angular, _, moment));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/pricegroup-marker/pricegroup-marker.api.js
(function(angular) {
var PriceGroupMarkerApi = function ($http) {
        var endpoint = '/api/marketing/referencePrices/';

        /**
         * Makes backend request to bring back departure flight prices for an array of months
         *
         * @param  {String}   origCity
         * @param  {String}   destCity
         * @param  {String}   depDate
         * @param  {Number}   owRt
         *
         * @return {Promise}
         */
        this.getData = function (origCity, destCity, depDate, owRt) {
            return $http.get(endpoint + origCity + '/' + destCity + '/' + owRt + '/' + depDate);
        };

        return this;
    };

    PriceGroupMarkerApi.$inject = [
        '$http'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .service('PriceGroupMarkerApi', PriceGroupMarkerApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/pricegroup-marker/pricegroup-marker.component.js
(function(angular) {
var IthPricegroupMarkerComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/price-trends/pricegroup-marker',
        controller: 'PricegroupMarkerController',
        bindings: {
            price: '<',
            paxes: '<',
            index: '<',
            flightRoute: '<'
        }
    };

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .component('priceTrendsPricegroupMarker', IthPricegroupMarkerComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/pricegroup-marker/pricegroup-marker.controller.js
(function(angular) {
var IthPricegroupMarkerController = function ($modal, PricegroupMarkerHelper, AppConfig) {
        /**
         * Reference to campagin service.
         *
         * @type {PricegroupMarkerHelper}
         */
        this.logic = PricegroupMarkerHelper;

        /**
         * Flag for ieftinuarie campaign
         *
         * @type {boolean}
         */
        this.isIeftinuarieActive = AppConfig.getIeftinuarieConfig();

        /**
         * Flag for free rebooing campaign
         *
         * @type {boolean}
         */
        this.isFreeRebookingActive = AppConfig.isFreeRebookingFlow();

        this.getHurryUpLang = function () {
            if (this.isIeftinuarieActive) {
                return 'LANGM_JS_PRICE_TRENDS_HURRY_UP_JAN';
            }

            if (this.isFreeRebookingActive) {
                return 'LANGM_JS_PRICE_TRENDS_HURRY_UP_FR';
            }

            return 'LANGM_JS_PRICE_TRENDS_HURRY_UP';
        };

        /**
         * Opens the graph modal.
         *
         * @param {string} flightRoute
         * @param {number} price
         */
        this.openGraphModal = function (flightRoute, price) {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/base/components/price-trends/pricegroup-modal',
                controller: 'PriceTrendsModalController',
                windowClass: 'mobile-modal--fullscreen price-trends__modal',
                resolve: {
                    pricegroupRoute: function () {
                        return flightRoute;
                    },
                    pricegroupPrice: function () {
                        return price;
                    },
                    discountPercent: function () {
                        return PricegroupMarkerHelper.getIeftinuarieDiscount(flightRoute, price);
                    }
                }
            });
        };
    };

    IthPricegroupMarkerController.$inject = [
        '$modal',
        'PricegroupMarkerHelper',
        'appConfig'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .controller('PricegroupMarkerController', IthPricegroupMarkerController);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/price-trends/pricegroup-modal/price-trends-modal.controller.js
(function (angular) {
var PriceTrendsModalController = function ($scope, $timeout, PricegroupMarkerHelper, pricegroupRoute, pricegroupPrice, discountPercent, AppConfig) {
        /**
         * Data needed for the chart component
         *
         * @type {Object[]}
         */
        $scope.chartData = PricegroupMarkerHelper.getGraphData(pricegroupRoute);

        /**
         * Flag for ieftinuarie campaign
         *
         * @type {Boolean}
         */
        $scope.isIeftinuarieActive = AppConfig.getIeftinuarieConfig() === true;

        /**
         * Currency symbol
         *
         * @type {String}
         */
        $scope.currencySymbol = AppConfig.getCurrencySymbol();

        /**
         * Price of the current flight
         *
         * @type {Number}
         */
        $scope.pricegroupPrice = Math.round(pricegroupPrice);

        /**
         * Variables for the dynamically loaded text box
         *
         * @var {Object}
         */
        $scope.textBoxVariables = {
            monthDiscount: discountPercent
        };

        /**
         * Chart on/off switch
         *
         * @type {Boolean}
         */
        $scope.showChart = false;

        $timeout(function () {
            $scope.showChart = true;
        }, 300);
    };

    PriceTrendsModalController.$inject = [
        '$scope',
        '$timeout',
        'PricegroupMarkerHelper',
        'pricegroupRoute',
        'pricegroupPrice',
        'discountPercent',
        'appConfig'
    ];

    angular
        .module('ITH.Shared.Flight.PriceTrends')
        .controller('PriceTrendsModalController', PriceTrendsModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/services/CheapestFlightsApi.service.js
(function(angular) {
/**
     * Service that makes AJAX requests to the new IBE API endpoints
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthCheapestFlightsApiService = function ($http, AppConfig, ErrorLogService) {
        /**
         * Returns data from the calendar endpoint
         *
         * @param {CheapestFlightsRequestParams} params The api GET parameters
         * @returns {Promise}
         */
        this.getCalendarData = function (params) {
            var promise = $http(buildEndpoint(params, 'v2/calendar'));
            watchForErrors(promise, 'Cheapest API calendar endpoint error');
            return promise;
        };

        this.getNewCalendarData = function (params) {
            var promise = $http(buildEndpoint(params, 'new/v2/calendar'));
            watchForErrors(promise, 'Cheapest API calendar endpoint error');
            return promise;
        };

        /**
         * Returns data from the matrix endpoint
         *
         * @param {CheapestFlightsRequestParams} params The api GET parameters
         * @returns {Promise}
         */
        this.getMatrixData = function (params) {
            var promise = $http(buildEndpoint(params, 'v2/matrix'));
            watchForErrors(promise, 'Cheapest API matrix endpoint error');
            return promise;
        };

        this.getNewMatrixData = function (params) {
            var promise = $http(buildEndpoint(params, 'new/v2/matrix'));
            watchForErrors(promise, 'Cheapest API matrix endpoint error');
            return promise;
        };

        this.getCarrierNewData = function (params) {
            var promise = $http(buildEndpoint(params, 'api/gerald2/public/carriers'));
            watchForErrors(promise, 'Gerald 2 API carrier endpoint error');
            return promise;
        };

        /**
         * Builds an endpoint object based on properties
         *
         * @param {CheapestFlightsRequestParams} params
         * @param {String} endpointName
         * @returns {Object}
         */
        function buildEndpoint(params, endpointName) {
            return {
                method: 'GET',
                url: AppConfig.getShelfConfig().api + '/' + endpointName + '?' + params.getQueryString(),
                headers: {
                    'Accept-Language': AppConfig.getUserLanguage(),
                    'X-Affiliate': AppConfig.getAffiliateName(),
                    'Slot': AppConfig.getAbConfig().ibe_slot_version,
                    'Content-Type': 'application/json'
                }
            };
        }

        /**
         * Logs API errors
         *
         * @param {Promise} promise
         * @param {String} message
         */
        function watchForErrors(promise, message) {
            promise.catch(function (error) {
                ErrorLogService.sendErrorLog(new Error(message + ': ' + formatHttpError(error)));
            });
        }

        /**
         * @param {*} error
         * @returns {String}
         */
        function formatHttpError(error) {
            if (!error) {
                return '[empty]';
            }
            if (angular.isString(error)) {
                return error;
            }
            if (angular.isString(error.message)) { // JS error or usual response body
                return error.message;
            }
            if (error.config && error.headers) { // usual ngHttp response object
                return 'Failed HTTP request (status ' + error.status + '): ' + formatHttpError(error.data);
            }
            return angular.toJson(error);
        }
    };

    IthCheapestFlightsApiService.$inject = [
        '$http',
        'appConfig',
        'ErrorLogService'
    ];

    angular
        .module('flight')
        .service('CheapestFlightsApi', IthCheapestFlightsApiService);

}(angular));
;

// Source: ../shared/public_html/assets/js/flight/services/FlightSearchCache.js
angular.module('flight')

/**
 * @name        FlightSearchCache
 * @namespace   flt
 * @description Factory returning FlightSearchCache constructor
 */
.factory('flt.FlightSearchCache',
['flt.FlightSearchTabNames',

/**
 * FlightSearchCache class
 *
 * @param {FlightSearchTabNames} tabNames
 *
 * @return {FlightSearchCache}
 */
function FlightSearchCacheFactory(tabNames) {
/**
   * FlightSearchCache constructor
   *
   * @class FlightSearchCache
   * @constructor
   */
  var FlightSearchCache = function () {
    /**
     * Object to keep flight search results
     *
     * @type {Object}
     */
    this.results = {};

    /**
     * @type {SearchResult|null}
     */
    this.results[tabNames.YOUR_SEARCH] = null;

    /**
     * @type {SearchResult|null}
     */
    this.results[tabNames.MATRIX] = null;

    /**
     * @type {SearchResult|null}
     */
    this.results[tabNames.CALENDAR] = null;

    /**
     * Object to keep flight search filters
     *
     * @type {Object}
     */
    this.filters = {};

    /**
     * @type {SearchResult|null}
     */
    this.filters[tabNames.YOUR_SEARCH] = null;

    /**
     * @type {SearchResult|null}
     */
    this.filters[tabNames.MATRIX] = null;

    /**
     * @type {SearchResult|null}
     */
    this.filters[tabNames.CALENDAR] = null;

    /**
     * @type {Matrix|null}
     */
    this.matrix = null;

    /**
     * @type {Calendar|null}
     */
    this.calendar = null;

    /**
     * @type {CityHelperItem|null}
     */
    this.cityHelperFrom = null;

    /**
     * @type {CityHelperItem|null}
     */
    this.cityHelperTo = null;

    /**
     * Number of price groups to display
     *
     * @type {Number}
     */
    this.priceGroupsLimit = 5;

    /**
     * Name of active tab
     *
     * @type {string}
     */
    this.activeTabName = '';

    /**
     * @type {Date|null}
     */
    this.expiryDate = null;

    /**
     * @type {Date|null}
     */
    this.searchDate = null;
  };

  // Add instance methods
  FlightSearchCache.prototype = /** @lends FlightSearchCache.prototype */ {

    /**
     * @returns {Object}
     */
    getResults: function () {
      return this.results;
    },

    /**
     * @returns {Object}
     */
    getFilters: function () {
      return this.filters;
    },

    /**
     * @returns {Matrix|null}
     */
    getMatrix: function () {
      return this.matrix;
    },

    /**
     * @returns {Calendar|null}
     */
    getCalendar: function () {
      return this.calendar;
    },

    /**
     * @returns {CityHelperItem|null}
     */
    getCityHelperFrom: function() {
      return this.cityHelperFrom;
    },

    /**
     * @returns {CityHelperItem|null}
     */
    getCityHelperTo: function() {
      return this.cityHelperTo;
    },

    /**
     * @returns {Number}
     */
    getPriceGroupsLimit: function()
    {
      return this.priceGroupsLimit;
    },

    /**
     * @returns {string}
     */
    getActiveTabName: function () {
      return this.activeTabName;
    },

    /**
     * @returns {Date|null}
     */
    getExpiryDate: function () {
      return this.expiryDate;
    },

    /**
     * get search date
     *
     * @returns {Date|null}
     */
    getSearchDate: function () {
      return this.searchDate;
    },

    /**
     * @returns {Boolean}
     */
    isExpired: function () {
      return this.expiryDate && (this.expiryDate < new Date());
    },

    /**
     * @param {Object} results
     */
    setResults: function (results) {
      this.results = results;
    },

    /**
     * @param {Object} filters
     */
    setFilters: function (filters) {
      this.filters = filters;
    },

    /**
     * @param {Matrix} matrix
     */
    setMatrix: function (matrix) {
      this.matrix = matrix;
    },

    /**
     * @param {Calendar} calendar
     */
    setCalendar: function (calendar) {
      this.calendar = calendar;
    },

    /**
     * @param {CityHelperItem} cityHelperFrom
     */
    setCityHelperFrom: function(cityHelperFrom) {
      this.cityHelperFrom = cityHelperFrom;
    },

    /**
     * @param {CityHelperItem} cityHelperTo
     */
    setCityHelperTo: function(cityHelperTo) {
      this.cityHelperTo = cityHelperTo;
    },

    /**
     * @param {Number} limit
     */
    setPriceGroupsLimit: function(limit)
    {
      this.priceGroupsLimit = limit;
    },

    /**
     * @param {String} name
     */
    setActiveTabName: function (name) {
      this.activeTabName = name;
    },

    /**
     * @param {Date} date
     */
    setExpiryDate: function (date) {
      this.expiryDate = date;
    },

    /**
     * set search date
     *
     * @param {Date} date
     */
    setSearchDate: function (date) {
      this.searchDate = date;
    }
  };

  FlightSearchCache.prototype.constructor = FlightSearchCache;

  return new FlightSearchCache();
}]);
;

// Source: ../shared/public_html/assets/js/flight/services/scrollToPriceGroups.js
angular.module('flight')

/**
 * @name        scrollToPriceGroups
 * @description Service to scroll window to price groups
 */
.service('sch.scrollToPriceGroups',
['$timeout', '$document',
function scrollToPriceGroups($timeout, $document) {
return function (id) {
    $timeout(function () {
      var element = document.getElementById(id);
      $document.scrollToElementAnimated(element, 120);
    });
  };
}]);
;

// Source: ../shared/public_html/assets/js/flight/test-sell-statuses.constant.js
(function (angular) {
angular.module('flight').constant('TEST_SELL_STATUSES', {
        NOT_DONE: -1,
        DONE: 1,
        HIGHER_PRICE: 2,
        LOWER_PRICE: 3,
        NO_SEATS: 4
    });

})(angular);
;

// Source: ../shared/public_html/assets/js/flightDetails/components/floating-summary/ith-floating-summary.component.js
(function(angular) {
angular
        .module('flightDetails')
        .component('ithFloatingSummary', {
            template: '<div\
                class="floating-summary"\
                ng-click="$ctrl.toggle()"\
                ng-class="{\
                    \'floating-summary--extended\': $ctrl.isExtended,\
                    \'floating-summary--offscreen\': $ctrl.isOffscreen()\
                }">\
                <div order-summary flight-booking="$ctrl.flightBooking"></div>\
            </div>',
            bindings: {
                flightBooking: '<',
                steps: '<'
            },
            controller: ['$document', '$scope', '$timeout', '$rootScope', function ($document, $scope, $timeout, $rootScope) {
                var self = this;

                /**
                 * Is summary extended?
                 *
                 * @type {Boolean}
                 */
                this.isExtended = false;

                /**
                 *
                 */
                this.isTransitioning = false;

                /**
                 *
                 */
                this.isHidden = false;

                this.unregisterEvent = null;

                /**
                 * Toggles extended status on/off
                 */
                this.toggle = function () {
                    if (this.isExtended) {
                        return;
                    }

                    runAnimation(!this.isExtended);
                };

                this.isOffscreen = function () {
                    return this.isTransitioning || this.isHidden;
                };

                this.$onInit = function () {
                    $document.on('scroll', scrollHandler);

                    this.unregisterEvent = $rootScope.$on('closeFloatingSummary', function () {
                        runAnimation(false);
                    });
                };

                this.$onDestroy = function () {
                    $document.off('scroll', scrollHandler);
                    this.unregisterEvent();
                };

                /**
                 *
                 * @param {Boolean} extendedValue
                 */
                var runAnimation = function (extendedValue) {
                    if (self.isTransitioning) {
                        return;
                    }

                    $scope.$evalAsync(function () {
                        self.isTransitioning = true;
                    });

                    $timeout(function () {
                        self.isTransitioning = false;
                        updateExtendedValue(extendedValue);
                    }, 300);
                };

                /**
                 * Handles scroll event
                 */
                var scrollHandler = function () {
                    $scope.$evalAsync(function () {
                        self.isHidden = isBasketInView();
                    });

                    if (!self.isExtended) {
                        return;
                    }

                    runAnimation(false);
                };

                /**
                 *
                 * @param {Boolean} newValue
                 */
                var updateExtendedValue = function (newValue) {
                    self.isExtended = newValue;
                };

                /**
                 * Checks if basket is in view
                 *
                 * @returns {Boolean}
                 */
                var isBasketInView = function () {
                    if (!self.steps.isLastStep()) {
                        return false;
                    }

                    var mobileSummaryElement = document.querySelector('#mobile-summary');

                    if (mobileSummaryElement === null) {
                        return false;
                    }

                    var rect = mobileSummaryElement.getBoundingClientRect();
                    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

                    return rect.top < viewportHeight;
                };
            }]
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-box.component.js
(function(angular) {
var template = '\
        <article ng-class="$ctrl.getClassMap()">\
            <ith-selectable-box selected="$ctrl.isRecommended()" label="{{ $ctrl.getLabel() | translate }}">\
                <header>\
                    <div>\
                        <h3>{{ $ctrl.getName() }}</h3>\
                        <div class="ith-frola-assistance-box__pricing">\
                            <strong>{{ $ctrl.getTotalPrice() | flPrice:2 }}</strong> <span translate>LANGM_JS_PRICING_PER_BOOKING</span>\
                        </div>\
                    </div>\
                    <img ng-src="{{ $ctrl.getIconSrc() }}" />\
                </header>\
                <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
                <button ng-click="$ctrl.select()" ng-class="$ctrl.getCtaClassMap()" translate>{{ $ctrl.getCtaText() }}</button>\
            </ith-selectable-box>\
        </div>\
    ';

    var IthFrolaAssistanceBoxComponent = {
        template: template,
        controller: ['$rootScope', 'FrolaAssistanceHelper', '$translate', function ($rootScope, FrolaAssistanceHelper, $translate) {
            /**
             *
             * @returns {String}
             */
            this.getLabel = function () {
                if (this.isRecommended() === true) {
                    return 'LANGM_JS_FD_FROLA_ASSISTANCE_LABEL';
                }

                return null;
            };

            /**
             *
             * @returns {Boolean}
             */
            this.isRecommended = function () {
                return (
                    this.option.flags &&
                    this.option.flags.recommended &&
                    this.option.flags.recommended == true
                );
            };

            /**
             *
             * @returns {String}
             */
            this.getCtaClassMap = function () {
                return {
                    'btn': true,
                    'btn-lg': true,
                    'btn-block': true,
                    'btn-outline': !this.isRecommended(),
                    'btn-primary': this.isRecommended()
                };
            };

            /**
             *
             * @returns {String}
             */
            this.getCtaText = function () {
                return 'LANGM_JS_CONTINUE_FA_' + this.option.type.toUpperCase();
            };

            /**
             *
             * @returns {String}
             */
            this.getIconSrc = function () {
                return FrolaAssistanceHelper.getPackageIconSrc(this.option.type);
            };

            /**
             *
             * @returns {Boolean}
             */
            this.isSelected = function () {
                return this.booking.frolaAssistance.selectedId === this.option.id;
            };

            /**
             *
             */
            this.select = function () {
                this.booking.frolaAssistance.selectedId = this.option.id;
                $rootScope.$broadcast('frolaAssistanceSelected');
            };

            /**
             *
             * @returns {Object}
             */
            this.getClassMap = function () {
                return {
                    'ith-frola-assistance-box': true,
                    'ith-frola-assistance-box--selected': this.isSelected()
                };
            };

            /**
             *
             * @returns {Number}
             */
            this.getPricePerPax = function () {
                return this.option.totalPrice / this.booking.paxes.length;
            };

            /**
             *
             * @returns {Number}
             */
            this.getTotalPrice = function () {
                return this.option.totalPrice;
            };

            /**
             *
             * @returns {String}
             */
            this.getName = function () {
                return $translate.instant(FrolaAssistanceHelper.getPackageName(this.option.type));
            };

            /**
             *
             * @returns {String}
             */
            this.getDescriptionTextBox = function () {
                return FrolaAssistanceHelper.getDescriptionTextBox(
                    this.option.id,
                    'fd'
                );
            };
        }],
        bindings: {
            option: '<',
            booking: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFrolaAssistanceBox', IthFrolaAssistanceBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-details-link.component.js
(function (angular) {
var IthFrolaAssistanceDetailsLinkComponent = {
        template: '<ith-event-link event="frolaAssistanceModal:open"><ng-transclude></ng-transclude></ith-event-link>',
        transclude: true
    };

    angular
        .module('flightDetails')
        .component('assistanceDetailsLink', IthFrolaAssistanceDetailsLinkComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-helper.service.js
(function(angular) {
var IthFrolaAssistanceHelperService = function (FrolaAssistanceTypes, appConfig) {
        this.getPackageName = function (type) {
            if (type === FrolaAssistanceTypes.chat) {
                return 'LANGM_JS_FD_FROLA_ASSISTANCE_STANDARD_NAME';
            }

            if (type === FrolaAssistanceTypes.phone) {
                return 'LANGM_JS_FD_FROLA_ASSISTANCE_PREMIUM_NAME';
            }

            return 'LANGM_JS_FD_FROLA_ASSISTANCE_LOW_PRIORITY_NAME';
        };

        this.getDescriptionTextBox = function (id, suffix) {
            return [
                'frola_assistance',
                id,
                'desc',
                suffix
            ].join('_').toLowerCase();
        };

        this.getPackageIconName = function (type) {
            var icon = 'low-priority';

            if (type === FrolaAssistanceTypes.chat)
                icon = 'standard';

            if (type === FrolaAssistanceTypes.phone) {
                icon = 'premium';

                if (appConfig.isVola()) {
                    icon = 'premium247';
                }
            }

            return icon;
        };

        this.getPackageIconSrc = function (type) {
            return '/assets/img/product-logos/frola-assistance/' + this.getPackageIconName(type) + '.svg';
        };

        this.getListOrderStyleMap = function (pack) {
            return {
                order: pack.flags.order
            };
        };
    };

    IthFrolaAssistanceHelperService.$inject = ['FrolaAssistanceTypes', 'appConfig'];

    angular
        .module('flightDetails')
        .service('FrolaAssistanceHelper', IthFrolaAssistanceHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-modal-info.component.js
(function (angular) {
var template = '\
    <div class="ith-frola-assistance-modal-info">\
        <ith-frola-assistance-modal-package\
            ng-if="$ctrl.compatibleOptions.length"\
            ng-repeat="option in $ctrl.compatibleOptions track by option.id"\
            booking="$ctrl.booking"\
            option="option"\
            ng-style="$ctrl.getStyleMap(option)">\
        </ith-frola-assistance-modal-package>\
    </div>\
    ';

    var controller = function (FrolaAssistanceHelper) {
        this.compatibleOptions = [];

        this.isCompatible = function (option) {
            return option.packages.indexOf(this.booking.ticketType.getSelectedPackage().type) !== -1;
        };

        this.getStyleMap = function (pack) {
            return FrolaAssistanceHelper.getListOrderStyleMap(pack);
        };

        this.$onInit = function () {
            this.compatibleOptions = this.booking.frolaAssistance.getPackagesByTicketType(
                this.booking.ticketType.getSelectedPackage().type
            );
        };
    };

    controller.$inject = ['FrolaAssistanceHelper'];

    var IthFrolaAssistanceModalInfoComponent = {
        template: template,
        bindings: {
            booking: '<'
        },
        controller: controller
    };

    angular
        .module('flightDetails')
        .component('ithFrolaAssistanceModalInfo', IthFrolaAssistanceModalInfoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-modal-package.component.js
(function (angular) {
var template = '\
    <article>\
        <img ng-src="{{ $ctrl.getIconSrc() }}" style="margin-top: 20px; margin-bottom: -10px" />\
        <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
        <p>&nbsp;</p>\
    </article>\
    ';

    var IthFrolaAssistanceModalPackageComponent = {
        template: template,
        controller: ['FrolaAssistanceHelper', function (FrolaAssistanceHelper) {
            /**
             *
             * @returns {String}
             */
            this.getDescriptionTextBox = function () {
                return FrolaAssistanceHelper.getDescriptionTextBox(
                    this.option.id,
                    'modal'
                );
            };

            /**
             *
             * @returns {String}
             */
            this.getIconSrc = function () {
                return FrolaAssistanceHelper.getPackageIconSrc(this.option.type);
            };
        }],
        bindings: {
            booking: '<',
            option: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFrolaAssistanceModalPackage', IthFrolaAssistanceModalPackageComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-select.component.js
(function(angular) {
var template = '\
        <div class="ith-frola-assistance-select ith-selectable-boxes">\
            <ith-frola-assistance-box\
                ng-repeat="option in $ctrl.compatibleOptions track by option.id"\
                option="option"\
                booking="$ctrl.booking"\
                ng-class="{ \'recommended\': option.flags.recommended === true }"\
                ng-style="$ctrl.getStyleMap(option)">\
            </ith-frola-assistance-box>\
        </div>\
    ';

    var controller = function ($rootScope, $modal, $window, SelectableBoxContentService, FrolaAssistanceHelper) {
        var self = this;

        this.compatibleOptions = [];

        this.eventRefs = {
            stepChangedUnregister: null,
            frolaAssistanceModalUnregister: null
        };

        this.$onInit = function () {
            this.eventRefs.stepChangedUnregister = $rootScope.$on('stepChanged', this.onStepChanged);
            this.eventRefs.frolaAssistanceModalUnregister = $rootScope.$on('frolaAssistanceModal:open', this.openModal);

            angular.element($window).bind('resize', function () {
                SelectableBoxContentService.readjustRows('.ith-frola-assistance-box');
            });
        };

        this.$onDestroy = function () {
            // Unregister event listeners
            this.eventRefs.stepChangedUnregister();
            this.eventRefs.frolaAssistanceModalUnregister();
        };

        this.isCompatible = function (option) {
            return option.packages.indexOf(this.booking.ticketType.getSelectedPackage().type) !== -1;
        };

        this.$doCheck = function () {
            SelectableBoxContentService.readjustRows('.ith-frola-assistance-box');
        };

        this.onStepChanged = function () {
            if (!self.steps.showAssistanceStep) {
                return;
            }

            self.compatibleOptions = self.booking.frolaAssistance.getPackagesByTicketType(
                self.booking.ticketType.getSelectedPackage().type
            );

            setTimeout(function () {
                SelectableBoxContentService.readjustRows('.ith-frola-assistance-box');
            }, 100);
        };

        this.getStyleMap = function (pack) {
            return FrolaAssistanceHelper.getListOrderStyleMap(pack);
        };

        this.openModal = function () {
            var ModalController = function (sharedData) {
                this.data = sharedData;
            };

            ModalController.$inject = [
                'sharedData'
            ];

            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/flights/frola-assistance-modal',
                windowClass: 'mobile-modal--fullscreen upsell-modal',
                controller: ModalController,
                controllerAs: '$ctrl',
                resolve: {
                    sharedData: function () {
                        return self.booking;
                    }
                }
            });
        };
    };

    controller.$inject = [
        '$rootScope',
        '$modal',
        '$window',
        'SelectableBoxContentService',
        'FrolaAssistanceHelper'
    ];

    var IthFrolaAssistanceSelectComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<',
            steps: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFrolaAssistanceSelect', IthFrolaAssistanceSelectComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-ty-box.component.js
(function (angular) {
var template = '\
    <div>\
        <ith-upsell-presentation-box ng-if="$ctrl.booking.frolaAssistance.isPopulated && $ctrl.getSelectedId() !== null">\
            <logo-pane>\
                <ith-product-logo\
                    image-name="{{ $ctrl.getIcon() }}"\
                    show-affiliate-name="false"\
                    name="{{ $ctrl.getName() }}">\
                </ith-product-logo>\
            </logo-pane>\
            <description-pane>\
                <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
            </description-pane>\
        </ith-upsell-presentation-box>\
    </div>\
    ';

    var controller = function ($translate, FrolaAssistanceHelper) {
        this.getSelectedId = function () {
            if (this.booking.ticketType.isPaidContactIncluded()) {
                return this.booking.ticketType.getPaidContactProduct().type;
            }

            return this.booking.frolaAssistance.selectedId;
        };

        this.getIcon = function () {
            return 'frola-assistance/' + FrolaAssistanceHelper.getPackageIconName(
                this.getSelectedId()
            );
        };

        this.getName = function () {
            return $translate.instant(
                FrolaAssistanceHelper.getPackageName(
                    this.getSelectedId()
                ) + '_BASKET'
            );
        };

        this.getDescriptionTextBox = function () {
            return FrolaAssistanceHelper.getDescriptionTextBox(
                this.getSelectedId(),
                'ty'
            );
        };
    };

    controller.$inject = ['$translate', 'FrolaAssistanceHelper'];

    var IthFrolaAssistanceTyBoxComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('base')
        .component('ithFrolaAssistanceTyBox', IthFrolaAssistanceTyBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance-types.enum.js
(function(angular) {
var IthFrolaAssistanceTypesEnum = {
        email: 'email',
        chat: 'chat',
        phone: 'phone'
    };

    angular
        .module('flightDetails')
        .constant('FrolaAssistanceTypes', IthFrolaAssistanceTypesEnum);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/frola-assistance/ith-frola-assistance.model.js
(function(angular) {
var IthFrolaAssistanceModel = function (FrolaAssistanceHelper) {
        var IthFrolaAssistance = function () {
            this.options = [];
            this.selectedId = null;
            this.isAllowed = false;
            this.isPopulated = false;
        };

        IthFrolaAssistance.prototype.initWithFlightDetails = function (data) {
            if (this.isPopulated || !data.additionalServices.paidContact) {
                return;
            }

            this.options = data.additionalServices.paidContact.options;
            this.isAllowed = data.additionalServices.paidContact.isAllowed;
            this.isPopulated = true;
        };

        IthFrolaAssistance.prototype.initWithBookingData = function (data) {
            this.isPopulated = true;
            this.isAllowed = true;
            this.options = [{
                id: data.type,
                type: data.type,
                totalPrice: data.totalPrice
            }];

            this.selectedId = data.type;
        };

        IthFrolaAssistance.prototype.getSelectedPackage = function () {
            var foundPackage = null;
            var self = this;

            angular.forEach(this.options, function (pack) {
                if (pack.id === self.selectedId) {
                    foundPackage = pack;
                }
            });

            return foundPackage;
        };

        IthFrolaAssistance.prototype.getRecommendedPackage = function (ticketType) {
            var foundPackage = null;
            var packagesForTicketType = this.getPackagesByTicketType(ticketType);

            angular.forEach(packagesForTicketType, function (pack) {
                if (pack.flags.recommended) {
                    foundPackage = pack;
                }
            });

            if (foundPackage === null) {
                console.error('No recommended assistance package was set from config. Falling back to phone option');

                angular.forEach(packagesForTicketType, function (pack) {
                    if (pack.type === 'phone') {
                        pack.flags.recommended = true;
                        foundPackage = pack;
                    }
                });
            }

            return foundPackage;
        };

        IthFrolaAssistance.prototype.getPackageName = function () {
            if (this.selectedId === null) {
                return '';
            }

            return this.getPackageNameByType(
                this.getSelectedPackage().type
            );
        };

        IthFrolaAssistance.prototype.getPackageNameByType = function (type) {
            return FrolaAssistanceHelper.getPackageName(type);
        };

        IthFrolaAssistance.prototype.selectNone = function () {
            this.selectedId = null;
        };

        IthFrolaAssistance.prototype.getTotalPrice = function () {
            var total = 0;
            var self = this;

            angular.forEach(this.options, function (option) {
                if (option.id === self.selectedId) {
                    total = option.totalPrice;
                }
            });

            return total;
        };

        IthFrolaAssistance.prototype.getPackageByType = function (assistanceType, ticketType) {
            var found = null;

            angular.forEach(this.getPackagesByTicketType(ticketType), function (option) {
                if (option.type === assistanceType) {
                    found = option;
                }
            });

            return found;
        };

        IthFrolaAssistance.prototype.getPackagesByTicketType = function (ticketType) {
            var compatibleOptions = [];

            angular.forEach(this.options, function (option) {
                if (option.packages.indexOf(ticketType) !== -1) {
                    compatibleOptions.push(option);
                }
            });

            return compatibleOptions;
        };

        IthFrolaAssistance.prototype.isSelected = function () {
            return this.selectedId !== null;
        };

        IthFrolaAssistance.prototype.isPremium = function (pack) {
            if (!pack) {
                return false;
            }

            return pack.type === 'phone';
        };

        IthFrolaAssistance.prototype.srvObj = function () {
            if (this.getSelectedPackage() === null) {
                return false;
            }

            return this.getSelectedPackage().id;
        };

        IthFrolaAssistance.prototype.constructor = IthFrolaAssistance;

        return IthFrolaAssistance;
    };

    IthFrolaAssistanceModel.$inject = ['FrolaAssistanceHelper'];

    angular
        .module('flightDetails')
        .factory('FrolaAssistance', IthFrolaAssistanceModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-checked-radio.component.js
(function(angular) {
var template = '\
        <div ng-class="$ctrl.getClassMap()">\
            <span>\
                <svg-icon id="checkmark"></svg-icon>\
            </span>\
            <strong>{{ $ctrl.label }}</strong>\
        </div>\
    ';

    var IthCheckedRadioComponent = {
        controller: function () {
            this.getClassMap = function () {
                return {
                    'ith-checked-radio': true,
                    'ith-checked-radio--selected': this.selected
                };
            };
        },
        template: template,
        bindings: {
            selected: '<',
            label: '@'
        }
    };

    angular
        .module('flightDetails')
        .component('ithCheckedRadio', IthCheckedRadioComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-contact-form.component.js
(function(angular) {
angular.module('flightDetails').component('ithFdContactForm', {
        templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/passengerDetails/contactInfoForm',
        controller: ['BookingFormCache', function (BookingFormCache) {
            /**
             * Returns pax form by index
             *
             * @returns {NgForm}
             */
            this.getControlForm = function () {
                return this.form[this.formName];
            };

            this.onChange = function () {
                BookingFormCache.cacheContact(this.contact);
            };
        }],
        bindings: {
            form: '<',
            contact: '<',
            submitting: '<',
            formName: '@'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-contact.component.js
(function (angular) {
var template = '\
        <div>\
            <ith-fd-contact-form\
                ng-show="!$ctrl.bookingState.loadingProfileData()"\
                form="$ctrl.bookingForm"\
                contact="$ctrl.flightBooking.getContact()"\
                submitting="$root.orderInProgress"\
                form-name="{{ $ctrl.formName }}">\
            </ith-fd-contact-form>\
            <ith-preloader ng-show="$ctrl.bookingState.loadingProfileData()">\
                <translate>LANGM_JS_BASKET_CONTACT_INFO_LOADING</translate>\
            </ith-preloader>\
            \
            <div class="fd-form">\
                <div class="fd-form__wrapper">\
                    <ith-sms-notification-box\
                        booking="$ctrl.flightBooking">\
                    </ith-sms-notification-box>\
                </div>\
            </div>\
        </div>\
    ';

    angular.module('flightDetails').component('ithFdContact', {
        template: template,
        bindings: {
            bookingForm: '<',
            bookingState: '<',
            flightBooking: '<',
            formName: '@'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-continue-popups.factory.js
(function(angular) {
/**
     * Handler for push popups in split funnel
     */
    var IthContinuePopupsFactory = function (IbeLuggageSummaryHelper, ResponsiveTooltipService, TicketTypesEnum) {
        /**
         * Constructor
         *
         * @param {Booking} booking
         * @param {Steps} steps
         */
        var ContinuePopupsFactory = function (booking, steps) {
            /**
             * Booking ref
             *
             * @type {Booking}
             */
            this.booking = booking;

            /**
             * Steps ref
             *
             * @type {Steps}
             */
            this.steps = steps;

            /**
             * Enum of popups
             *
             * @type {Object}
             */
            this.popupIds = {
                luggageWarning: 'luggageWarning',
                ticketTypeWarning: 'ticketTypeWarning',
                tripProtectWarning: 'tripProtectWarning'
            };

            /**
             * Array containing ids of popups that were shown
             *
             * @type {String[]}
             */
            this.shownIds = [];

            /**
             * Maximum number of popups shown to user
             *
             * @type {Number}
             */
            this.maxCount = 3;
        };

        /**
         * Checks if a popup id was previously opened
         *
         * @param {String} id
         * @returns {Boolean}
         */
        ContinuePopupsFactory.prototype.wasPreviouslyOpened = function (id) {
            return this.shownIds.indexOf(id) !== -1;
        };

        /**
         * Opens a popup by id
         *
         * @param {String} id
         */
        ContinuePopupsFactory.prototype.open = function (id) {
            ResponsiveTooltipService.open(id);
            this.shownIds.push(id);
        };

        /**
         * Closes a popup by id
         *
         * @param {String} id
         */
        ContinuePopupsFactory.prototype.close = function (id) {
            ResponsiveTooltipService.close(id);
        };

        /**
         * Checks if a popup can be opened by id
         *
         * @param {String} id
         * @param {Boolean} isMobileResolution
         *
         * @returns {Boolean}
         */
        ContinuePopupsFactory.prototype.canOpen = function (id, isMobileResolution) {
            if (isMobileResolution || this.wasPreviouslyOpened(id) || this.shownIds.length >= this.maxCount) {
                return false;
            }

            if (id === this.popupIds.luggageWarning) {
                var luggageIsAvailable = this.booking.luggageHandler.isAvailable();
                var noPaidLuggageSelected = IbeLuggageSummaryHelper.getTotalPrice(this.booking) === 0;
                var paidLuggageIsAvailable = this.booking.luggageHandler.isPaidLuggageAvailable();

                return luggageIsAvailable && noPaidLuggageSelected && paidLuggageIsAvailable;
            }

            if (id === this.popupIds.ticketTypeWarning) {
                var isTicketTypeStep = this.steps.isTicketType();
                var isNotAssistanceStep = this.steps.showAssistanceStep === false;
                var isBasicTicketTypeSelected = this.booking.ticketType.getSelectedPackage().type === TicketTypesEnum.basic;

                return isTicketTypeStep && isNotAssistanceStep && isBasicTicketTypeSelected;
            }

            if (id === this.popupIds.tripProtectWarning) {
                var isTripProtectStep = this.steps.isProtectTrip();
                var isTripProtectAvailable = this.booking.tripGuarantee.enabled;
                var noTripProtectSelected = !this.booking.tripGuarantee.isChosen();

                return isTripProtectStep && isTripProtectAvailable && noTripProtectSelected;
            }

            return false;
        };

        ContinuePopupsFactory.prototype.constructor = ContinuePopupsFactory;

        return ContinuePopupsFactory;
    };

    IthContinuePopupsFactory.$inject = ['IbeLuggageSummaryHelper', 'ResponsiveTooltipService', 'TicketTypesEnum'];

    angular
        .module('flightDetails')
        .factory('ContinuePopupsFactory', IthContinuePopupsFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-continue.component.js
(function(angular) {
var template = '\
        <article>\
            <div class="fd-continue">\
                <button class="btn btn-lg btn-outline ng-animate-disabled" ng-disabled="$ctrl.isDisabled()" ng-click="$ctrl.back()" ng-if="$ctrl.isPrevButtonVisible()">\
                    <svg-icon id="caret"></svg-icon>\
                    <span translate>LANGM_JS_BACK</span>\
                </button>\
                <button class="btn btn-lg btn-primary ng-animate-disabled" ng-disabled="$ctrl.isDisabled()" ng-click="$ctrl.continue()" ng-if="$ctrl.isNextButtonVisible()">\
                    <span ng-if="$ctrl.isLoading()" class="spin-loader ng-animate-disabled"></span>\
                    <span ng-if="!$ctrl.isLoading()">{{ $ctrl.getNextButtonText() | translate }}</span>\
                </button>\
                <button class="btn btn-lg btn-primary ng-animate-disabled" ng-click="$ctrl.selectSmartPackage(); $ctrl.continue();" ng-if="$ctrl.isContinueWithSmartVisible()" translate>\
                    LANGM_JS_CONTINUE_TT_SMART\
                </button>\
                <div id="google-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isGooglePayPayment() || $ctrl.isLoading()">\
                </div>\
                <div id="apple-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isApplePayPayment() || $ctrl.isLoading()">\
                </div>\
                <div id="revolut-pay-btn-div" class="ng-animate-disabled" ng-hide="!$ctrl.isRevolutPayPayment() || $ctrl.isLoading()">\
                </div>\
                <ith-preloader class="ng-animate-disabled pull-right" size="38" ng-if="($ctrl.isGooglePayPayment() || $ctrl.isApplePayPayment() || $ctrl.isRevolutPayPayment()) && $ctrl.isLoading()"></ith-preloader>\
                <button class="btn btn-lg btn-primary ng-animate-disabled" ng-click="$ctrl.continueWithNoPopups(); $ctrl.selectRecommendedAssistance()" ng-if="$ctrl.isContinueWithRecommendedAssistanceVisible()">\
                    {{ $ctrl.getRecommendedAssistanceCtaLang() | translate }}\
                </button>\
            </div>\
            <ith-responsive-tooltip id="{{ $ctrl.continuePopups.popupIds.luggageWarning }}" title="{{ \'LANGM_JS_FD_LUGGAGE_WARNING_TITLE\' | translate }}" show-close-button="false" show-close-x="false">\
                <content ng-bind-html="$ctrl.getTranslatedLang(\'LANGM_JS_FD_LUGGAGE_WARNING_DESC\')"></content>\
                <footer>\
                    <button class="btn btn-lg btn-block btn-primary" ng-click="$ctrl.luggageWarningPopup.selectLuggage()" translate>LANGM_JS_FD_LUGGAGE_WARNING_BTN_SELECT</button>\
                    <button class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.luggageWarningPopup.continueWithoutLuggage()" translate>LANGM_JS_FD_LUGGAGE_WARNING_BTN_CONTINUE</button>\
                </footer>\
            </ith-responsive-tooltip>\
            <ith-responsive-tooltip id="{{ $ctrl.continuePopups.popupIds.ticketTypeWarning }}" title="{{ \'LANGM_JS_FD_BASIC_TICKET_WARNING_TITLE\' | translate }}" show-close-button="false" show-close-x="false">\
                <content>\
                    <div text-box-body="{{ $ctrl.getBasicTicketTypeWarningDescription() }}" show-loader="true"></div>\
                </content>\
                <footer>\
                    <button class="btn btn-lg btn-block btn-primary" ng-click="$ctrl.ticketTypeWarningPopup.upgradeToSmart()" translate translate-values="{ upgradePrice: $ctrl.getUpgradePrice() }">LANGM_JS_FD_BASIC_TICKET_WARNING_BTN_UPGRADE</button>\
                    <button class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.ticketTypeWarningPopup.continueWithBasic()" translate>LANGM_JS_FD_BASIC_TICKET_WARNING_BTN_CONTINUE</button>\
                </footer>\
            </ith-responsive-tooltip>\
            <ith-responsive-tooltip id="{{ $ctrl.continuePopups.popupIds.tripProtectWarning }}" title="{{ \'LANGM_JS_FD_TRIP_PROTECT_WARNING_TITLE\' | translate }}" show-close-button="false" show-close-x="false">\
                <content ng-bind-html="$ctrl.getTranslatedLang(\'LANGM_JS_FD_TRIP_PROTECT_WARNING_DESC\')"></content>\
                <footer>\
                    <button class="btn btn-lg btn-block btn-primary" ng-click="$ctrl.tripProtectWarningPopup.addTripProtect()" translate translate-values="{ tripGuaranteePrice: $ctrl.getTripGuaranteePrice() }">LANGM_JS_FD_TRIP_PROTECT_WARNING_BTN_UPGRADE</button>\
                    <button class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.tripProtectWarningPopup.continueWithoutTripProtect()" translate>LANGM_JS_FD_TRIP_PROTECT_WARNING_BTN_CONTINUE</button>\
                </footer>\
            </ith-responsive-tooltip>\
        </article>\
    ';

    var controller = function ($window, $rootScope, $timeout, $filter, $q, ContinuePopupsFactory, $translate, BookingFormHelper, BookingServ, OrderValidation, TicketTypeHelper, SplitFunnelAnalytics, AppConfig, MediaMatch) {
        /**
         * @type {controller}
         */
        var self = this;

        /**
         * Is current step being validated?
         *
         * @type {Boolean}
         */
        this.validatingStep = false;

        /**
         * Is mobile?
         *
         * @type {Boolean}
         */
        this.isMobileResolution = true;

        /**
         * Push popups handler
         */
        this.continuePopups = new ContinuePopupsFactory(this.booking, this.steps);

        this.rootEvents = {
            ticketTypeSelected: null,
            frolaAssistanceSelected: null,
            locationChangeStart: null,
            GooglePayTokenGenerated: null,
            ApplePayTokenGenerated: null,
            RevolutPayTriggered: null,
        };

        this.luggageWarningPopup = {
            selectLuggage: function () {
                self.continuePopups.close(self.continuePopups.popupIds.luggageWarning);

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'luggage',
                    self.steps.getCurrentStepIndex(),
                    'select luggage'
                );
            },
            continueWithoutLuggage: function () {
                self.continuePopups.close(self.continuePopups.popupIds.luggageWarning);
                self.validateFirstStep();

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'luggage',
                    self.steps.getCurrentStepIndex(),
                    'continue without luggage'
                );
            }
        };

        this.ticketTypeWarningPopup = {
            upgradeToSmart: function () {
                self.continuePopups.close(self.continuePopups.popupIds.ticketTypeWarning);
                self.selectSmartPackage();
                self.activateAssistanceStep();

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'package',
                    self.steps.getCurrentStepIndex(),
                    'upgrade to smart'
                );
            },
            continueWithBasic: function () {
                self.continuePopups.close(self.continuePopups.popupIds.ticketTypeWarning);
                self.activateAssistanceStep();

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'package',
                    self.steps.getCurrentStepIndex(),
                    'continue with basic'
                );
            }
        };

        this.tripProtectWarningPopup = {
            addTripProtect: function () {
                self.booking.tripGuarantee.toggle(true);
                self.continuePopups.close(self.continuePopups.popupIds.tripProtectWarning);
                self.continueWithNoPopups();

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'trip protect',
                    self.steps.getCurrentStepIndex(),
                    'add trip protect'
                );
            },
            continueWithoutTripProtect: function () {
                self.continuePopups.close(self.continuePopups.popupIds.tripProtectWarning);
                self.continueWithNoPopups();

                SplitFunnelAnalytics.splitFunnelPopupButtonClick(
                    'trip protect',
                    self.steps.getCurrentStepIndex(),
                    'continue without trip protect'
                );
            }
        };

        /**
         * Determines if buttons are disabled
         *
         * @returns {Boolean}
         */
        this.isDisabled = function () {
            return this.validatingStep || !this.isTicketTypePopulated() || $rootScope.orderInProgress || this.booking.luggageHandler.isLoading;
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isGooglePayPayment = function() {
            return (this.booking.payment.type === 'GP' || this.booking.payment.type === 'GP2') && this.steps.isLastStep();
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isApplePayPayment = function() {
            return (this.booking.payment.type === 'AP' || this.booking.payment.type === 'AP2') && this.steps.isLastStep();
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isRevolutPayPayment = function() {
            return this.booking.payment.type === 'RP' && this.steps.isLastStep();
        };

        /**
         * Determines if loading should be displayed on the next button
         *
         * @returns {Boolean}
         */
        this.isLoading = function () {
            return this.validatingStep || !this.isTicketTypePopulated() || $rootScope.orderInProgress || this.booking.luggageHandler.isLoading;
        };

        /**
         * Determines if ticket type has been populated
         *
         * @returns {Boolean}
         */
        this.isTicketTypePopulated = function () {
            return this.booking.ticketType.isPopulated;
        };

        /**
         * Determines if previous button should be visible
         *
         * @returns {Boolean}
         */
        this.isPrevButtonVisible = function () {
            return !this.steps.isFirstStep();
        };

        /**
         * Determines if next button should be visible
         *
         * @returns {Boolean}
         */
        this.isNextButtonVisible = function () {
            if (this.isGooglePayPayment() || this.isApplePayPayment() || this.isRevolutPayPayment()) {
                return false;
            }

            return !this.steps.isTicketType();
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isContinueWithSmartVisible = function () {
            return this.steps.isTicketType() && !this.steps.showAssistanceStep;
        };

        /**
         * @returns {Boolean}
         */
        this.isContinueWithRecommendedAssistanceVisible = function () {
            return this.steps.isTicketType() && this.steps.showAssistanceStep;
        };

        this.selectRecommendedAssistance = function () {
            var ticketType = this.booking.ticketType.getSelectedPackage().type;
            this.booking.frolaAssistance.selectedId = this.booking.frolaAssistance.getRecommendedPackage(ticketType).id;
        };

        this.getRecommendedAssistanceCtaLang = function () {
            var ticketType = this.booking.ticketType.getSelectedPackage().type;
            if (this.booking.frolaAssistance.getRecommendedPackage(ticketType).type === 'chat') {
                return 'LANGM_JS_CONTINUE_FA_CHAT';
            }

            return 'LANGM_JS_CONTINUE_FA_PHONE';
        };

        /**
         * Returns text for the next button
         *
         * @returns {Strign}
         */
        this.getNextButtonText = function () {
            if (this.steps.isLastStep()) {
                return 'LANGM_JS_PAY';
            }

            return 'LANGM_JS_CONTINUE';
        };

        /**
         * Returns price for Smart ticket
         *
         * @returns {String}
         */
        this.getUpgradePrice = function () {
            return $filter('flPrice')(self.booking.ticketType.getSmartPackage().price , 2);
        };

        /**
         * Returns price for trip guarantee
         *
         * @returns {String}
         */
        this.getTripGuaranteePrice = function () {
            return $filter('flPrice')(self.booking.tripGuarantee.getPrice(), 2);
        };

        /**
         * Activates assistance step
         */
        this.activateAssistanceStep = function () {
            if (!this.booking.frolaAssistance.isAllowed) {
                this.continueWithNoPopups();
                return;
            }

            self.steps.toggleAssistanceStep(true);
            scrollToTop();
        };

        /**
         * Advances user to next step with validation:
         * - checks if form is valid
         * - checks if any popup notifications should be displayed to user
         */
        this.continue = function () {
            if (this.steps.isFlightInfo()) {
                var firstStepForms = BookingFormHelper.getFirstStepForms(
                    this.form,
                    this.booking.paxes.length
                );

                angular.forEach(firstStepForms, function (subForm) {
                    subForm.$setSubmitted(true);
                });

                if (!BookingFormHelper.areAllFormsValid(firstStepForms)) {
                    return;
                }

                if (this.continuePopups.canOpen(this.continuePopups.popupIds.luggageWarning, this.isMobileResolution)) {
                    this.continuePopups.open(this.continuePopups.popupIds.luggageWarning);
                    SplitFunnelAnalytics.splitFunnelPopupDisplay('luggage', this.steps.getCurrentStepIndex());
                    return;
                }

                this.validateFirstStep();
                return;
            }

            if (this.continuePopups.canOpen(this.continuePopups.popupIds.ticketTypeWarning, this.isMobileResolution)) {
                this.continuePopups.open(this.continuePopups.popupIds.ticketTypeWarning);
                SplitFunnelAnalytics.splitFunnelPopupDisplay('package', this.steps.getCurrentStepIndex());
                return;
            }

            if (this.continuePopups.canOpen(this.continuePopups.popupIds.tripProtectWarning, this.isMobileResolution)) {
                this.continuePopups.open(this.continuePopups.popupIds.tripProtectWarning);
                SplitFunnelAnalytics.splitFunnelPopupDisplay('trip protect', this.steps.getCurrentStepIndex());
                return;
            }

            if (this.steps.isTicketType() && !this.steps.showAssistanceStep) {
                if (this.booking.ticketType.isBasic() || this.booking.ticketType.isSmart()) {
                    this.steps.toggleAssistanceStep(true);
                    return;
                }
            }

            if (this.steps.isLastStep()) {
                SplitFunnelAnalytics.payEvent(
                    this.booking,
                    this.steps.getCurrentStepIndex()
                );

                var lastStepForms = BookingFormHelper.getLastStepForms(
                    this.form,
                    this.booking.paxes.length
                );

                angular.forEach(lastStepForms, function (subForm) {
                    subForm.$setSubmitted(true);
                });

                if (!BookingFormHelper.areAllFormsValid(lastStepForms)) {
                    return;
                }

                $rootScope.$broadcast('bookingFormSubmit', ''); // Closes the coupon form in order to skip its validation

                $timeout(function () {
                    // Send data to backend
                    self.bookingFormSync();
                }, 50);

                return;
            }

            this.continueWithNoPopups();
        };

        /**
         * Advances user to next step
         */
        this.continueWithNoPopups = function () {
            $timeout(function () {
                self.steps.goToNextStep();

                $timeout(function () {
                    scrollToTop();

                    if (self.steps.isLastStep() && self.booking.getTestSell().hasPriceDiffOrNoSeats() && !self.booking.getTestSell().isLower()) {
                        self.changedPriceModal();
                    }
                }, 251);
            }, 50);
        };

        /**
         * Takes user to previous step
         */
        this.back = function () {
            if (self.steps.isTicketType() && this.steps.showAssistanceStep) {
                this.steps.toggleAssistanceStep(false);
                return;
            }

            self.steps.goToPrevStep();
            scrollToTop();
        };

        /**
         *
         */
        this.getTranslatedLang = function (lang) {
            return $translate.instant(lang);
        };

        this.getBasicTicketTypeWarningDescription = function () {
            return [
                'basic_ticket_warning',
                this.booking.ticketType.version,
                'desc'
            ].join('_').toLowerCase();
        };

        /**
         * Validates first step forms by sending data to backend API
         */
        this.validateFirstStep = function () {
            if (AppConfig.getAbConfig()['dfs_forms_position'] === 'end') {
                self.continueWithNoPopups();
                return;
            }

            this.validateFormData().then(function () {
                self.continueWithNoPopups();
            });
        };

        this.validateFormData = function () {
            var payload = this.booking.srvObj();
            self.validatingStep = true;

            return $q(function (resolve, reject) {
                BookingServ
                    .validateSplitFunnelFirstStep({
                        depDate: self.booking.flightDetails.getDepLeg().getDepDate(),
                        retDate: self.booking.flightDetails.getRetLeg() ? self.booking.flightDetails.getRetLeg().getArrDate() : null,
                        paxes: payload.paxes,
                        contact: payload.contact
                    })
                    .then(function (response) {
                        if (response.success === 0) {
                            OrderValidation.setServerErrors(self.form, self.booking, response.errors);
                            reject(response);
                        }

                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    })
                    .finally(function () {
                        self.validatingStep = false;
                    });
            });
        };

        this.selectSmartPackage = function () {
            this.booking.ticketType.selectSmartPackage();
            TicketTypeHelper.toggleIncludedProducts(this.booking);
        };

        this.$onInit = function () {
            this.rootEvents.ticketTypeSelected = $rootScope.$on('ticketTypeSelected', function () {
                self.continue();
            });

            this.rootEvents.frolaAssistanceSelected = $rootScope.$on('frolaAssistanceSelected', function () {
                self.continue();
            });

            this.rootEvents.locationChangeStart = $rootScope.$on('$locationChangeStart', function () {
                self.steps.checkStep();
            });

            this.rootEvents.GooglePayTokenGenerated = $rootScope.$on('GooglePayTokenGenerated', function () {
                self.continue();
            });

            this.rootEvents.ApplePayTokenGenerated = $rootScope.$on('ApplePayTokenGenerated', function () {
                self.continue();
            });

            this.rootEvents.RevolutPayTriggered = $rootScope.$on('RevolutPayTriggered', function () {
                self.continue();
            });

            var matchMediaQuery = MediaMatch.listen('(min-width: 768px)', function (event) {
                self.isMobileResolution = !event.matches;
            });

            self.isMobileResolution = !matchMediaQuery.matches;
        };

        this.$onDestroy = function () {
            this.rootEvents.ticketTypeSelected();
            this.rootEvents.frolaAssistanceSelected();
            this.rootEvents.locationChangeStart();
            this.rootEvents.GooglePayTokenGenerated();
            this.rootEvents.ApplePayTokenGenerated();
            this.rootEvents.RevolutPayTriggered();
        };

        /**
         * Scrolls to top of page
         */
        var scrollToTop = function () {
            $window.scrollTo(0, 0);
        };
    };

    controller.$inject = [
        '$window',
        '$rootScope',
        '$timeout',
        '$filter',
        '$q',
        'ContinuePopupsFactory',
        '$translate',
        'BookingFormHelper',
        'bok.BookingServ',
        'OrderValidation',
        'TicketTypeHelper',
        'SplitFunnelAnalytics',
        'appConfig',
        'MediaMatch'
    ];

    var IthFdContinueComponent = {
        template: template,
        controller: controller,
        bindings: {
            steps: '<',
            booking: '<',
            form: '<',
            googlePayClient: '<',
            applePayClient: '<',
            bookingFormSync: '&',
            changedPriceModal: '&'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFdContinue', IthFdContinueComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-mobile-steps.component.js
(function(angular) {
var template = '\
        <div>\
            <div class="basicBox fd-mobile-steps" ng-click="$ctrl.open()">\
                <span translate translate-values="{ current: $ctrl.steps.getCurrentStepIndex() + 1, total: $ctrl.steps.getTotalSteps() }">LANGM_JS_FD_MOBILE_CURRENT_STEP</span>\
                <svg-icon id="caret"></svg-icon>\
            </div>\
            <ith-responsive-tooltip id="stepSelect" show-close-x="false">\
                <content class="text-bigger">\
                    <ith-fd-steps steps="$ctrl.steps" booking="$ctrl.booking"></ith-fd-steps>\
                </content>\
            </ith-responsive-tooltip>\
        </div>\
    ';

    var IthFdMobileStepsComponent = {
        template: template,
        controller: ['$scope', 'ResponsiveTooltipService', function ($scope, ResponsiveTooltipService) {
            this.open = function () {
                ResponsiveTooltipService.open('stepSelect');
            };

            this.$onInit = function () {
                $scope.$on('stepClick', function () {
                    ResponsiveTooltipService.close('stepSelect');
                });
            };
        }],
        bindings: {
            steps: '<',
            booking: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFdMobileSteps', IthFdMobileStepsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-pax-form.component.js
(function(angular) {
angular.module('flightDetails').component('ithFdPaxForm', {
        templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/passengerDetails/paxForm',
        controller: ['BookingFormCache', '$timeout', 'BookingFormFiller', function (BookingFormCache, $timeout, BookingFormFiller) {
            this.getFormName = function () {
                return this.formName + this.index;
            };

            /**
             * Returns pax form by index
             *
             * @returns {NgForm}
             */
            this.getControlForm = function () {
                return this.form[this.getFormName()];
            };

            this.cacheFormData = function () {
                BookingFormCache.cachePaxes(this.booking.getPaxes());
            };

            this.isDocumentRequired = function () {
                return this.booking.flightDetails.getVerification().isDocumentRequired();
            };

            this.idDocumentIssueDateRequired = function () {
                return this.booking.flightDetails.getVerification().idDocumentIssueDateRequired();
            };

            this.onNameChange = function () {
                if (this.index === 0) {
                    $timeout(function () {
                        BookingFormFiller.autofillBilling(
                            this.booking.paxes[0].person,
                            this.booking.billing
                        );
                    }.bind(this));
                }

                this.cacheFormData();
            };

            this.onPaxNationalityUpdate = function () {
                this.cacheFormData();
            };
        }],
        bindings: {
            index: '<',
            form: '<',
            passenger: '<',
            booking: '<',
            submitting: '<',
            countries: '<',
            formName: '@'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-step-header.component.js
(function(angular) {
var template = '\
        <div ng-if="$ctrl.getPageTitle()">\
            <h2 class="fd-title" ng-bind-html="$ctrl.getPageTitle()"></h2>\
            <p class="fd-step-desc" ng-if="$ctrl.hasDesc()" compile="$ctrl.getDesc()"></p>\
        </div>\
    ';

    var IthFdStepHeaderComponent = {
        controller: ['$translate', 'appConfig', function ($translate, appConfig) {
            this.getPageTitle = function () {
                if (appConfig.getIsChangedButtonFlowAbTest() && this.getStep().title === 'LANGM_JS_FD_FLIGHT_INFO_PAGE_TITLE') {
                    return false;
                }

                return $translate.instant(this.getStep().title);
            };

            this.getDesc = function () {
                return $translate.instant(this.getStep().desc);
            };

            this.hasDesc = function () {
                return this.getStep().desc !== '';
            };

            this.getStep = function () {
                if (this.steps.isTicketType() && this.steps.showAssistanceStep) {
                    return this.steps.assistanceStep;
                }

                return this.steps.getCurrentStep();
            };
        }],
        template: template,
        bindings: {
            steps: '<',
            number: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFdStepHeader', IthFdStepHeaderComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-steps.component.js
(function(angular) {
var template = '\
        <ul class="fd-steps">\
            <li ng-repeat="step in $ctrl.steps.getSteps()" ng-class="$ctrl.getClassMap($index)" ng-click="$ctrl.select(step)">\
                <svg-icon id="checkmark"></svg-icon>\
                <span>{{ step.name | translate }}</span>\
            </li>\
        </ul>\
    ';

    var IthFdStepsComponent = {
        template: template,
        controller: ['$scope', '$window', '$location', function ($scope, $window, $location) {
            /**
             * Returns classes for steps
             *
             * @param {Number}
             * @returns {Object}
             */
            this.getClassMap = function (index) {
                var currentStepIndex = this.steps.getCurrentStepIndex();

                return {
                    'fd-steps__item': true,
                    'fd-steps__item--accesible': index < currentStepIndex,
                    'fd-steps__item--current': index === currentStepIndex,
                    'fd-steps__item--disabled': index > currentStepIndex
                };
            };

            /**
             * Selects step
             *
             * @param {Object} step
             */
            this.select = function (step) {
                if (step.id === null) {
                    // Go to search results
                    var locationSearch = $location.search();
                    var backToSearchUrl = this.booking.getFlightDetails().getSearchUrl();

                    if (locationSearch.hasOwnProperty('backToSearchUrl')) {
                        backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
                    }

                    $location.hash('');
                    $location.path(backToSearchUrl).search('');
                    $scope.$emit('stepClick');
                    return;
                }

                var targetStepIndex = this.steps.getStepIndex(step.id);
                var currentStepIndex = this.steps.getCurrentStepIndex();

                if (targetStepIndex < currentStepIndex) {
                    this.steps.goToStep(step.id);
                    $window.scrollTo(0, 0);
                    $scope.$emit('stepClick');
                }
            };
        }],
        bindings: {
            steps: '<',
            booking: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithFdSteps', IthFdStepsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-fd-steps.enum.js
(function() {
angular
        .module('flightDetails')
        .constant('StepsEnum', {
            FLIGHT_INFO: 'FLIGHT_INFO',
            TICKET_TYPE: 'TICKET_TYPE',
            CONFIGURE_TRIP: 'CONFIGURE_TRIP',
            PROTECT_TRIP: 'PROTECT_TRIP',
            BILLING: 'BILLING'
        });

}());
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ith-selectable-box.component.js
(function(angular) {
var template = '\
        <div ng-class="$ctrl.getClassMap()">\
            <span ng-if="$ctrl.label" class="ith-selectable-box__label">{{ $ctrl.label }}</span>\
            <ng-transclude></ng-transclude>\
        </div>\
    ';

    var IthSelectableBoxComponent = {
        controller: function () {
            this.getClassMap = function () {
                return {
                    'basicBox': true,
                    'ith-selectable-box': true,
                    'ith-selectable-box--selected': this.selected
                };
            };
        },
        bindings: {
            label: '@',
            selected: '<'
        },
        transclude: true,
        template: template
    };

    angular
        .module('flightDetails')
        .component('ithSelectableBox', IthSelectableBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/order-check/order-check-contact.component.js
(function(angular) {
var template = '\
    <div class="order-check__section order-check-contact">\
        <div class="order-check__section__title">\
            <h4 id="check-contact-title" translate>LANGM_JS_CI_TITLE</h4>\
            <ith-icon-link icon-id="edit" ng-if="!$ctrl.states.showForm" ng-click="$ctrl.edit()">\
                <span translate>LANGM_JS_EDIT</span>\
            </ith-icon-link>\
        </div>\
        <div class="order-check__section__row fade-in-anim" ng-if="!$ctrl.states.showForm">\
            <div class="order-check__section__column">\
                <div class="order-check__section__label" translate>LANGM_JS_EMAIL_ADDRESS</div>\
                <p>{{ $ctrl.booking.getContact().email }}</p>\
            </div>\
            <div class="order-check__section__column">\
                <div class="order-check__section__label" translate>LANGM_JS_PHONE_NUMBER</div>\
                <p>{{ $ctrl.booking.getContact().phone.prefix }} {{ $ctrl.booking.getContact().phone.number }}</p>\
            </div>\
        </div>\
        <div class="fd-form fade-in-anim" ng-if="$ctrl.states.showForm">\
            <div class="fd-form__wrapper">\
                <ith-fd-contact-form\
                    form="$ctrl.bookingForm"\
                    contact="$ctrl.booking.contactDetails"\
                    submitting="$ctrl.states.submitting"\
                    form-name="editContactInfo">\
                </ith-fd-contact-form>\
                \
                <button class="btn btn-lg btn-primary btn-block ng-animate-disabled" ng-click="$ctrl.submit()" ng-disabled="$ctrl.isDisabled()">\
                    <span ng-show="!$ctrl.states.submitting" translate>LANGM_JS_SAVE</span>\
                    <span ng-show="$ctrl.states.submitting" class="spin-loader ng-animate-disabled"></span>\
                </button>\
                <button class="btn btn-lg btn-outline btn-block ng-animate-disabled" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isDisabled()" translate>LANGM_JS_CANCEL</button>\
            </div>\
        </div>\
    </div>';

    var controller = function (ContactDetails, BookingServ, OrderValidation, BookingFormCache, ScrollService) {
        var ctrl = this;

        this.states = {
            showForm: false,
            submitting: false,
            contactBackup: null
        };

        this.isDisabled = function () {
            return this.states.submitting;
        };

        this.edit = function () {
            this.states.contactBackup = new ContactDetails();
            this.states.contactBackup.srvSet(this.booking.getContact().srvObj());
            this.booking.getContact().resetErrors();
            this.booking.getContact().getPhone().resetErrors();
            this.states.showForm = true;
        };

        this.submit = function () {
            this.states.submitting = true;
            var bookingPayload = this.booking.srvObj();

            BookingServ
                .validateSplitFunnelFirstStep({
                    depDate: this.booking.flightDetails.getDepLeg().getDepDate(),
                    retDate: this.booking.flightDetails.getRetLeg() ? this.booking.flightDetails.getRetLeg().getArrDate() : null,
                    paxes: bookingPayload.paxes,
                    contact: bookingPayload.contact
                })
                .then(function (response) {
                    if (response.success === 0) {
                        OrderValidation.setServerErrors(
                            ctrl.bookingForm,
                            ctrl.booking,
                            response.errors
                        );

                        return;
                    }

                    BookingFormCache.cacheContact(ctrl.booking.getContact());
                    ctrl.states.showForm = false;
                    ScrollService.to('#check-contact-title', 50);
                })
                .finally(function () {
                    ctrl.states.submitting = false;
                });
        };

        this.cancel = function () {
            this.booking.getContact().srvSet(
                this.states.contactBackup.srvObj()
            );
            this.states.showForm = false;
        };
    };

    controller.$inject = ['bil.ContactDetails', 'bok.BookingServ', 'OrderValidation', 'BookingFormCache', 'ScrollService'];

    angular.module('flightDetails').component('ithOrderCheckContact', {
        template: template,
        controller: controller,
        bindings: {
            booking: '<',
            bookingForm: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/order-check/order-check-itinerary.component.js
(function(angular) {
var template = '\
        <div class="order-check__section order-check-itinerary">\
            <div class="order-check__section__title">\
                <h4 translate>LANGM_JS_TRIP_ITINERARY</h4>\
                <ith-icon-link icon-id="info"ng-click="$ctrl.openItinerary()">\
                    <span translate>LANGM_JS_DISPLAY_TRIP_ITINERARY</span>\
                </ith-icon-link>\
            </div>\
            <div class="order-check-itinerary__leg" ng-repeat="leg in $ctrl.flightDetails.getLegs()">\
                <span class="order-check-itinerary__route">{{ :: $ctrl.getCityName(leg.getDepCityCode()) }} - {{ :: $ctrl.getCityName(leg.getArrCityCode()) }}</span>\
                <span class="order-check-itinerary__summary">\
                    {{ :: leg.getDuration() }},\
                    <span ng-switch="::$ctrl.getSegmentValues(leg.segmentsCount)">\
                        <span ng-switch-when="direct" translate>LANGM_JS_DIRECT_SHORT</span>\
                        <span ng-switch-when="one" translate>LANGM_JS_STOP_SHORT</span>\
                        <span ng-switch-when="many" translate translate-values="{ stops: leg.segmentsCount - 1 }">LANGM_JS_STOPS_SHORT</span>\
                    </span>\
                </span>\
                <span class="order-check-itinerary__datetimes">{{ :: $ctrl.formatDate(leg.getDepTimeMoment()) }}, {{ :: leg.getDepTime() }} - {{ :: $ctrl.formatDate(leg.getArrTimeMoment()) }}, {{ :: leg.getArrTime() }}</span>\
            </div>\
        </div>\
    ';

    var controller = function (Dictionaries) {
        this.getCityName = function (cityCode) {
            return Dictionaries.getCityNameByCode(cityCode, false);
        };

        this.formatDate = function (momentDate) {
            return momentDate.format('D MMM');
        };

        this.getSegmentValues = function (segmentsCount) {
            if (segmentsCount === 1) return 'direct';
            if (segmentsCount === 2) return 'one';
            return 'many';
        };
    };

    controller.$inject = ['Dictionaries', 'ResponsiveTooltipService'];

    angular.module('flightDetails').component('ithOrderCheckItinerary', {
        controller: controller,
        template: template,
        bindings: {
            flightDetails: '<',
            openItinerary: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/order-check/order-check-paxes.component.js
(function(angular, moment, underscore) {
var template = '\
    <div class="order-check__section order-check-paxes">\
        <div class="order-check__section__title">\
            <h4 id="check-pd-title" translate>LANGM_JS_PD_TITLE</h4>\
            <ith-icon-link icon-id="edit" ng-show="!$ctrl.states.showForm" ng-click="$ctrl.edit()">\
                <span translate>LANGM_JS_EDIT</span>\
            </ith-icon-link>\
        </div>\
        <div class="order-check__section__row fade-in-anim" ng-repeat="pax in $ctrl.booking.getPaxes()" ng-if="!$ctrl.states.showForm">\
            <div class="order-check__section__column">\
                <div class="order-check__section__label" translate>LANGM_JS_PAX_PERSONAL_INFORMATION</div>\
                <div><strong>{{ pax.getPerson().getFirstName() }} {{ pax.getPerson().getLastName() }}</strong></div>\
                <div>{{ $ctrl.formatDate(pax.getPerson().getBirthDate()) }} ({{ $ctrl.getPaxTypeLang(pax.getPerson().getType()) | translate }})</div>\
                <div>{{ $ctrl.getCountryName(pax.getPerson().getNationality()) }}</div>\
                <small>&nbsp;</small>\
                <div class="order-check__section__label" translate>LANGM_JS_YOUR_LUGGAGE</div>\
                <ith-ibe-pax-luggage\
                    booking="$ctrl.booking"\
                    pax="pax">\
                </ith-ibe-pax-luggage>\
            </div>\
            <div class="order-check__section__column" ng-if="$ctrl.isDocumentRequired()">\
                <div class="order-check__section__label" translate>LANGM_JS_PAX_TRAVEL_DOCUMENT</div>\
                <div>{{ pax.getPerson().getIdCard().getNumber() }}</div>\
                <div>{{ $ctrl.getCountryName(pax.getPerson().getIdCard().getIssuingCountry()) }}</div>\
                <div><span ng-if="$ctrl.idDocumentIssueDateRequired()">{{ $ctrl.formatDate(pax.getPerson().getIdCard().getIssueDate()) }} - </span>{{ $ctrl.formatDate(pax.getPerson().getIdCard().getExpDate()) }}</div>\
            </div>\
        </div>\
        <div class="fd-form fade-in-anim" ng-if="$ctrl.states.showForm">\
            <div class="fd-form__wrapper">\
                <div ng-repeat="pax in $ctrl.booking.getPaxes()">\
                    <h6>{{ pax.getPerson().getFirstName() }} {{ pax.getPerson().getLastName() }}</h6>\
                    <ith-fd-pax-form\
                        index="$index"\
                        booking="$ctrl.booking"\
                        form="$ctrl.bookingForm"\
                        passenger="pax"\
                        submitting="$ctrl.states.submitting"\
                        countries="$ctrl.countries"\
                        form-name="editPassengerDetails">\
                    </ith-fd-pax-form>\
                    <small>&nbsp;</small>\
                    <ibe-luggage-selector\
                        show-push="false"\
                        is-loading="false"\
                        passenger-option="$ctrl.booking.luggageHandler.passengerOptions.getOptionByPaxType(pax.getPerson().getType())"\
                        modifiers="$ctrl.booking.luggageHandler.passengerOptions.getModifiers()"\
                        pax-luggage="pax.luggage">\
                    </ibe-luggage-selector>\
                    <small>&nbsp;</small>\
                </div>\
                \
                <button class="btn btn-lg btn-primary btn-block ng-animate-disabled" ng-click="$ctrl.submit()" ng-disabled="$ctrl.states.submitting">\
                    <span ng-show="!$ctrl.states.submitting" translate>LANGM_JS_SAVE</span>\
                    <span ng-show="$ctrl.states.submitting" class="spin-loader ng-animate-disabled"></span>\
                </button>\
                <button class="btn btn-lg btn-outline btn-block ng-animate-disabled" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isDisabled()" translate>LANGM_JS_CANCEL</button>\
            </div>\
        </div>\
    </div>\
    ';

    var controller = function (BookingServ, OrderValidation, Pax, BookingFormCache, ScrollService, PaxAgeCheckerService) {
        /**
         *
         */
        var ctrl = this;

        this.states = {
            submitting: false,
            showForm: false,
            paxesBackup: []
        };

        this.isDocumentRequired = function () {
            return this.booking.flightDetails.getVerification().isDocumentRequired();
        };

        this.idDocumentIssueDateRequired = function () {
            return this.booking.flightDetails.getVerification().idDocumentIssueDateRequired();
        };

        this.edit = function () {
            this.booking.isEditMode = true;
            this.states.paxesBackup = [];

            angular.forEach(this.booking.getPaxes(), function (pax) {
                pax.resetErrors();
                var paxCopy = new Pax();
                paxCopy.srvSet(pax.srvObj());
                ctrl.states.paxesBackup.push(paxCopy);
            });

            this.states.showForm = true;
        };

        this.submit = function () {
            this.states.submitting = true;
            var bookingPayload = this.booking.srvObj();

            BookingServ
                .validateSplitFunnelFirstStep({
                    depDate: this.booking.flightDetails.getDepLeg().getDepDate(),
                    retDate: this.booking.flightDetails.getRetLeg() ? this.booking.flightDetails.getRetLeg().getArrDate() : null,
                    paxes: bookingPayload.paxes,
                    contact: bookingPayload.contact
                })
                .then(function (response) {
                    if (response.success === 0) {
                        OrderValidation.setServerErrors(
                            ctrl.bookingForm,
                            ctrl.booking,
                            response.errors
                        );

                        return;
                    }

                    if (PaxAgeCheckerService.isAnyPaxReached75Years(ctrl.booking.getPaxes())) {
                        ctrl.booking.getNewInsurance().deselectInsurance();
                    }

                    BookingFormCache.cachePaxes(ctrl.booking.getPaxes());
                    ctrl.states.showForm = false;
                    ScrollService.to('#check-pd-title', 50);
                })
                .finally(function () {
                    ctrl.states.submitting = false;
                    ctrl.booking.isEditMode = false;
                });
        };

        this.cancel = function () {
            for (var i = 0; i < ctrl.booking.getPaxes().length; i++) {
                var realPax = ctrl.booking.getPaxes()[i];
                var backupPax = ctrl.states.paxesBackup[i];
                realPax.getPerson().srvSet(backupPax.getPerson().srvObj());
                realPax.luggage = backupPax.luggage;
            }

            this.states.showForm = false;
            this.booking.isEditMode = false;
        };

        /**
         *
         * @param {string} date
         * @returns {string}
         */
        this.formatDate = function (date) {
            return moment(date).format('DD.MM.YYYY');
        };

        /**
         *
         * @param {string} paxType
         * @returns {string}
         */
        this.getPaxTypeLang = function (paxType) {
            return 'LANGM_JS_' + paxType + '_PAX_TYPE';
        };

        /**
         *
         * @param {string} countryCode
         * @returns {string}
         */
        this.getCountryName = function (countryCode) {
            var countryEntry = underscore.find(this.countries, function (country) {
                return country.code === countryCode;
            });

            if (!countryEntry) {
                return countryCode;
            }

            return countryEntry.name;
        };
    };

    controller.$inject = ['bok.BookingServ', 'OrderValidation', 'bok.Pax', 'BookingFormCache', 'ScrollService', 'PaxAgeCheckerService'];

    angular.module('flightDetails').component('ithOrderCheckPaxes', {
        template: template,
        controller: controller,
        bindings: {
            bookingForm: '<',
            booking: '<',
            countries: '<'
        }
    });

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/order-check/order-check.component.js
(function(angular) {
var template = '\
    <div class="basicBox">\
        <div class="heading" translate>LANGM_JS_ORDER_CHECK_TITLE</div>\
        <div class="basicBox__container order-check">\
            <ith-order-check-itinerary\
                flight-details="$ctrl.booking.getFlightDetails()"\
                open-itinerary="$ctrl.openItinerary">\
            </ith-order-check-itinerary>\
            \
            <ith-ab-test-switcher feature-name="dfs_forms_position" slot-a="end" slot-b="start" slot-c="">\
                <feature-a>\
                    <div class="order-check__section">\
                        <div class="order-check__section__title">\
                            <h4 translate>LANGM_JS_CI_TITLE</h4>\
                            <ith-icon-link icon-id="user" ng-if="!$root.UserSessionData.isLogged()" ng-click="$ctrl.openLoginModal()">\
                                <translate>LANGM_JS_FAST_SIGN</translate>\
                            </ith-icon-link>\
                        </div>\
                        <ith-fd-contact\
                            booking-form="$ctrl.bookingForm"\
                            booking-state="$ctrl.bookingState"\
                            flight-booking="$ctrl.booking"\
                            form-name="editContactInfo">\
                        </ith-fd-contact>\
                    </div>\
                    \
                    <div class="order-check__section">\
                        <div class="order-check__section__title"><h4 translate>LANGM_JS_PD_TITLE</h4></div>\
                        <div\
                            passenger-details-box\
                            template-url="/tpl/show/jsShared/templates/flights/flightDetails/pax/passengerDetails/passengerDetailsPaxDetails"\
                            state="$ctrl.bookingState"\
                            form="$ctrl.bookingForm"\
                            ng-model="$ctrl.booking"\
                            steps="$ctrl.steps"\
                            is-luggage-selectable="false"\
                            form-name="editPassengerDetails">\
                        </div>\
                    </div>\
                </feature-a>\
                <feature-b>\
                    <ith-order-check-contact\
                        booking="$ctrl.booking"\
                        booking-form="$ctrl.bookingForm">\
                    </ith-order-check-contact>\
                    \
                    <ith-order-check-paxes\
                        booking="$ctrl.booking"\
                        booking-form="$ctrl.bookingForm"\
                        countries="$ctrl.countries">\
                    </ith-order-check-paxes>\
                </feature-b>\
                <feature-c>\
                </feature-c>\
            </ith-ab-test-switcher>\
        </div>\
    </div>\
    ';

    var controller = function (Locations, ResponsiveTooltipService, AuthService) {
        /**
         *
         */
        var self = this;

        /**
         *
         */
        this.countries = [];

        /**
         *
         */
        this.$onInit = function () {
            Locations.getCountries().then(function (resp) {
                self.countries = resp;
            });
        };

        /**
         *
         */
        this.openItinerary = function () {
            ResponsiveTooltipService.open('itineraryRevisit');
        };

        this.openLoginModal = function () {
            AuthService.showLoginModal();
        };
    };

    controller.$inject = ['Locations', 'ResponsiveTooltipService', 'AuthService'];

    angular
        .module('flightDetails')
        .component('ithOrderCheck', {
            controller: controller,
            template: template,
            bindings: {
                bookingState: '<',
                bookingForm: '<',
                booking: '<',
                steps: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/pax-luggage-select/pax-luggage-select.component.js
(function (angular) {
var template = '\
        <div>\
            \
            <div>\
                <span class="h4">{{ $ctrl.index + 1 }}. {{ \'LANGM_JS_\'+$ctrl.pax.getPerson().getType() + \'_PAX_TYPE\' | translate }}</span>\
                <small ng-if="$ctrl.showExtraInfo()">{{ \'LANGM_JS_\' + $ctrl.pax.getPerson().getType() + \'_OVER_YEARS_OLD\' | translate }}</small>\
            </div>\
            \
            <ibe-luggage-selector\
                is-loading="false"\
                show-push="false"\
                passenger-option="$ctrl.luggageHandler.passengerOptions.getOptionByPaxType($ctrl.pax.getPerson().getType())"\
                modifiers="$ctrl.luggageHandler.passengerOptions.getModifiers()"\
                pax-luggage="$ctrl.pax.luggage">\
            </ibe-luggage-selector>\
        </div>\
    ';

    angular.module('flightDetails').component('ithPaxLuggageSelect', {
        template: template,
        controller: function () {
            this.showExtraInfo = function () {
                return this.pax.getPerson().getType() === 'ADT' || this.pax.getPerson().getType() === 'YTH';
            };
        },
        bindings: {
            pax: '<',
            index: '<',
            luggageHandler: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/pax-luggage-select/paxes-luggage-select.component.js
(function (angular) {
var template = '\
        <div class="basicBox">\
            <div class="heading" translate>LANGM_JS_SELECT_LUGGAGE_PER_PAX</div>\
            <div class="basicBox__container">\
                <div class="fd-form">\
                    <div class="fd-form__wrapper" ng-if="!$ctrl.isLoading">\
                        <ith-luggage-push></ith-luggage-push>\
                        <ith-pax-luggage-select\
                            class="fligthDetailsPax"\
                            ng-repeat="pax in $ctrl.paxes track by $index"\
                            pax="pax"\
                            index="$index"\
                            luggage-handler="$ctrl.luggageHandler">\
                        </ith-pax-luggage-select>\
                    </div>\
                    <div class="fd-form__wrapper" ng-if="$ctrl.isLoading">\
                        <ith-preloader>\
                            <translate>LANGM_JS_SIMPLIFIED_LUGGAGE_LOADING</translate>\
                        </ith-preloader>\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    angular.module('flightDetails').component('ithPaxesLuggageSelect', {
        template: template,
        bindings: {
            paxes: '<',
            luggageHandler: '<',
            isLoading: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/selectable-box-content.service.js
(function(angular) {
var SelectableBoxContentService = function () {
        this.readjustRows = function (wrapperClass) {
            var heights = {};

            angular.forEach(document.querySelectorAll(wrapperClass), function (ticketTypeBoxElement) {
                var row = 0;
                angular.forEach(ticketTypeBoxElement.querySelectorAll('ul.hidden-xs > li'), function (ticketTypeListElement) {
                    ticketTypeListElement.style = 'height: auto';
                    var liHeight = ticketTypeListElement.offsetHeight;
                    if (!heights.hasOwnProperty(row) || heights[row] < liHeight) {
                        heights[row] = liHeight;
                    }
                    row++;
                });
            });

            angular.forEach(document.querySelectorAll(wrapperClass), function (ticketTypeBoxElement) {
                var row = 0;
                angular.forEach(ticketTypeBoxElement.querySelectorAll('ul.hidden-xs > li'), function (ticketTypeListElement) {
                    ticketTypeListElement.style = 'height: ' + heights[row] + 'px';
                    row++;
                });
            });
        };
    };

    angular
        .module('flightDetails')
        .service('SelectableBoxContentService', SelectableBoxContentService);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/split-funnel-analytics.service.js
(function(angular, dataLayer) {
/**
     *
     * @param {Remarketing} Remarketing
     */
    var SplitFunnelAnalyticsService = function (Remarketing, SplitFunnelDatalayerHelper, AppConfig) {
        var isFareLocked = function (booking) {
            return booking.getFlightDetails().fareLockUuid !== null;
        };

        /**
         *
         * @param {*} id
         * @param {*} index
         * @param {*} booking
         * @returns
         */
        this.splitFunnelStepChange = function (id, index, booking) {
            if (typeof dataLayer === 'undefined') {
                return;
            }

            // Clear the previous ecommerce
            dataLayer.push({ ecommerce: null });

            Remarketing.dataLayerPush({
                event: SplitFunnelDatalayerHelper.getSplitFunnelStepEventNameById(id),
                event_type: 'ecommerce',
                step: index + 1,
                lock_fare: isFareLocked(booking),
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(),
                    value: booking.basket.getTotalPrice(),
                    items: SplitFunnelDatalayerHelper.getEcommerceItems(
                        booking.basket.getBasketItems(),
                        booking.getFlightDetails()
                    )
                }
            });
        };

        /**
         *
         * @param {string} name
         * @param {number} step
         */
        this.splitFunnelPopupDisplay = function (name, step) {
            Remarketing.dataLayerPush({
                event: 'banner_interactions',
                category: 'page interactions',
                name: name,
                type: 'display',
                step: step + 1
            });
        };

        /**
         *
         * @param {string} name
         * @param {number} step
         * @param {string} select
         */
        this.splitFunnelPopupButtonClick = function (name, step, select) {
            Remarketing.dataLayerPush({
                event: 'banner_interactions',
                category: 'page interactions',
                name: name,
                type: 'button click',
                select: select,
                step: step + 1
            });
        };

        /**
         *
         * @param {Booking} booking
         * @param {number} step
         * @param {string} itemNameWildcard
         * @param {boolean} isAdd
         * @returns
         */
        this.updateCart = function (booking, step, item, isAdd) {
            var items = SplitFunnelDatalayerHelper.getEcommerceItems(
                [item],
                booking.getFlightDetails()
            );

            Remarketing.dataLayerPush({
                event: isAdd ? 'add_to_cart' : 'remove_from_cart',
                event_type: 'ecommerce',
                step: step + 1,
                lock_fare: isFareLocked(booking),
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(),
                    value: items[0].price,
                    items: items
                }
            });
        };

        /**
         *
         * @param {Booking} booking
         * @param {number} step
         */
        this.payEvent = function (booking, step) {
            // Clear the previous ecommerce
            dataLayer.push({ ecommerce: null });

            Remarketing.dataLayerPush({
                event: 'add_payment_info',
                event_type: 'ecommerce',
                step: step + 2,
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(),
                    value: booking.basket.getTotalPrice(),
                    payment_type: booking.getPayment().type,
                    items: SplitFunnelDatalayerHelper.getEcommerceItems(
                        booking.basket.getBasketItems(),
                        booking.getFlightDetails()
                    )
                }
            });
        };
    };

    SplitFunnelAnalyticsService.$inject = ['goo.Remarketing', 'SplitFunnelDatalayerHelper', 'appConfig'];

    angular
        .module('flightDetails')
        .service('SplitFunnelAnalytics', SplitFunnelAnalyticsService);

}(angular, dataLayer));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-box-pricing.component.js
(function(angular) {
var template = '\
        <div ng-class="$ctrl.getClassMap()">\
            <div class="prices" ng-if="$ctrl.hasDiscount()">\
                <span class="old-price">{{ $ctrl.oldPrice | flPrice:2 }}</span>\
                <span class="saving">-{{ $ctrl.getSaving() }}%</span>\
                <inline-tooltip content="{{ $ctrl.discountPricingTable }}" placement="top"><svg-icon class="size--16 color--muted" id="info"></svg-icon></inline-tooltip>\
            </div>\
            <span class="price" ng-class="{ \'has-discount\': $ctrl.hasDiscount() }">{{ $ctrl.price | flPrice:2 }}</span>\
            <div translate>LANGM_JS_PRICING_PER_PAX</div>\
        </div>\
    ';

    var controller = function ($filter, $translate, FrolaAssistanceHelper) {
        /**
         * Content for the tooltip
         *
         * @type {string}
         */
        this.discountPricingTable = '';

        /**
         *
         * @returns {Boolean}
         */
        this.hasDiscount = function () {
            return (
                this.price < this.oldPrice &&
                this.oldPrice > 0 &&
                this.getSaving() >= 5
            );
        };

        /**
         *
         * @returns {Object}
         */
        this.getClassMap = function () {
            var classMap = {
                'ith-ticket-type-box__pricing': true,
                'ith-ticket-type-box__pricing--with-discount': this.hasDiscount()
            };

            classMap['ith-ticket-type-box__pricing--' + this.zone] = true;
            return classMap;
        };

        /**
         *
         * @returns {number}
         */
        this.getSaving = function () {
            return Math.round(100 - this.price * 100 / this.oldPrice);
        };

        this.$onChanges = function (changes) {
            if (!changes.priceElements || !changes.priceElements.currentValue) {
                return;
            }
            var parsed = JSON.parse(changes.priceElements.currentValue);

            if (parsed.length === 0) {
                return;
            }

            var html = '<div>' + $translate.instant('LANGM_JS_TT_DISCOUNT_BREAKDOWN_DESC') + '</div><div class="discount-breakdown">';

            var getName = function (item) {
                switch (item.name) {
                    case 'checkin': return $translate.instant('LANGM_JS_CHECKIN_NAME');
                    case 'fast_refund': return $translate.instant('LANGM_JS_FAST_REFUND_NAME');
                    case 'cfar': return $translate.instant('LANGM_JS_CFAR_NAME');
                    case 'paid_contact': return $translate.instant(FrolaAssistanceHelper.getPackageName(item.type) + '_BASKET');
                    default: return item.name;
                }
            };

            angular.forEach(parsed, function (item) {
                html += '<p><span>' + getName(item) + '</span><strong>' + $filter('flPrice')(item.price, 2) + '</strong></p>';
            });

            html += '<p><span>' + $translate.instant('LANGM_JS_OS_TOTAL_PRICE') + '</span><strong>' + $filter('flPrice')(this.oldPrice, 2) + '</strong></p>';
            html += '</div>';

            this.discountPricingTable = html;
        };
    };

    controller.$inject = ['$filter', '$translate', 'FrolaAssistanceHelper'];

    angular
        .module('flightDetails')
        .component('ithTicketTypeBoxPricing', {
            controller: controller,
            template: template,
            bindings: {
                oldPrice: '<',
                price: '<',
                priceElements: '@',
                zone: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-box.component.js
(function (angular) {
var template = '\
        <article ng-class="$ctrl.getClassMap()">\
            <ith-selectable-box selected="$ctrl.isRecommended()" label="{{ $ctrl.getLabel() | translate }}">\
                <header>\
                    <h3>{{ $ctrl.getName() }}</h3>\
                    <ith-ticket-type-box-pricing\
                        old-price="$ctrl.getOldPricePerPax()"\
                        price="$ctrl.getPricePerPax()"\
                        price-elements="{{ $ctrl.getPricingElements() }}"\
                        zone="header">\
                    </ith-ticket-type-box-pricing>\
                </header>\
                <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
                <ith-ticket-type-box-pricing\
                    old-price="$ctrl.getOldPricePerPax()"\
                    price="$ctrl.getPricePerPax()"\
                    price-elements="{{ $ctrl.getPricingElements() }}"\
                    zone="bottom">\
                </ith-ticket-type-box-pricing>\
                <button ng-click="$ctrl.select()" ng-class="$ctrl.getCtaClassMap()" translate>{{ $ctrl.getCtaText() }}</button>\
            </ith-selectable-box>\
        </div>\
    ';

    var IthTicketTypeBoxComponent = {
        template: template,
        controller: ['$rootScope', 'TicketTypeHelper', '$translate', function ($rootScope, TicketTypeHelper, $translate) {
            this.getLabel = function () {
                if (this.isRecommended()) {
                    return 'LANGM_JS_FD_TICKET_TYPE_LABEL';
                }

                return null;
            };

            this.getName = function () {
                return $translate.instant(TicketTypeHelper.getPackageName(this.package.type));
            };

            this.getDescriptionTextBox = function () {
                return TicketTypeHelper.getDescriptionTextBox(
                    this.package.type,
                    this.booking.ticketType.version,
                    'fd'
                );
            };

            this.isSelected = function () {
                return this.booking.ticketType.selectedId === this.package.packageId;
            };

            this.isRecommended = function () {
                return this.package.flags.recommended === true;
            };

            this.getCtaClassMap = function () {
                return {
                    'btn': true,
                    'btn-lg': true,
                    'btn-block': true,
                    'btn-outline': !this.isRecommended(),
                    'btn-primary': this.isRecommended()
                };
            };

            this.getCtaText = function () {
                return 'LANGM_JS_CONTINUE_TT_' + this.package.type.toUpperCase();
            };

            this.select = function () {
                this.booking.ticketType.selectedId = this.package.packageId;
                TicketTypeHelper.toggleIncludedProducts(this.booking);
                $rootScope.$broadcast('ticketTypeSelected');
            };

            this.getPricePerPax = function () {
                return this.package.price / this.booking.paxes.length;
            };

            this.getOldPricePerPax = function () {
                return TicketTypeHelper.getOldPrice(this.package, this.booking);
            };

            this.getPricingElements = function () {
                return JSON.stringify(TicketTypeHelper.getPricingElements(this.package, this.booking));
            };

            this.getClassMap = function () {
                var classes = {
                    'ith-ticket-type-box': true,
                    'ith-ticket-type-box--selected': this.isSelected(),
                    'ith-ticket-type-box--recommended': this.isRecommended()
                };

                classes['ith-ticket-type-box--' + this.package.type] = true;

                return classes;
            };
        }],
        bindings: {
            package: '<',
            booking: '<'
        },
        transclude: true
    };

    angular
        .module('flightDetails')
        .component('ithTicketTypeBox', IthTicketTypeBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-details-link.component.js
(function(angular) {
var IthTicketTypeDetailsLinkComponent = {
        template: '<ith-event-link event="ticketTypeModal:open"><ng-transclude></ng-transclude></ith-event-link>',
        transclude: true
    };

    angular
        .module('flightDetails')
        .component('ticketTypeDetailsLink', IthTicketTypeDetailsLinkComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-helper.service.js
(function(angular) {
var IthTicketTypeHelperService = function (TicketTypesEnum, AutomatedCheckinHelper) {
        this.getPackageName = function (type) {
            if (type === TicketTypesEnum.basic)
                return 'LANGM_JS_FD_TICKET_TYPE_BASIC_NAME';

            if (type === TicketTypesEnum.smart)
                return 'LANGM_JS_FD_TICKET_TYPE_SMART_NAME';

            return 'LANGM_JS_FD_TICKET_TYPE_SUPERFLEX_NAME';
        };

        this.getDescriptionTextBox = function (packageType, version, suffix) {
            return [
                'ticket_type',
                packageType.toUpperCase(),
                version.toUpperCase(),
                'desc',
                suffix
            ].join('_').toLowerCase();
        };

        this.toggleIncludedProducts = function (booking) {
            if (booking.ticketType.isCheckinIncluded()) {
                // Remove check-in
                booking.paidCheckin.toggle(false);
            }

            if (booking.ticketType.isFastRefundIncluded()) {
                // Remove fast refund
                booking.fastRefund.toggle(false);
            }

            if (booking.ticketType.isCfarIncluded()) {
                // Remove cfar
                booking.cfar.toggle(false);
            }

            if (booking.ticketType.isPaidContactIncluded()) {
                // Remove paid contact
                booking.frolaAssistance.selectNone();
            }
        };

        this.getListOrderStyleMap = function (pack) {
            return {
                order: pack.flags.order
            };
        };

        this.getPricingElements = function (pack, booking) {
            var elements = [];

            if (booking.ticketType.isCheckinIncluded(pack) && AutomatedCheckinHelper.isCheckinAvailable(booking)) {
                elements.push({
                    name: 'checkin',
                    price: (+booking.paidCheckin.getTotalPrice() / +booking.paxes.length)
                });
            }

            if (booking.ticketType.isFastRefundIncluded(pack)) {
                elements.push({
                    name: 'fast_refund',
                    price: (+booking.fastRefund.getTotalPrice() / +booking.paxes.length)
                });
            }

            if (booking.ticketType.isCfarIncluded(pack)) {
                elements.push({
                    name: 'cfar',
                    price: (+booking.cfar.getTotalPrice() / +booking.paxes.length)
                });
            }

            if (booking.ticketType.isPaidContactIncluded(pack)) {
                var paidContact = booking.ticketType.getPaidContactProduct(pack);
                var paidContactPack = booking.frolaAssistance.getPackageByType(paidContact.type, 'basic');

                if (paidContactPack) {
                    elements.push({
                        name: 'paid_contact',
                        type: paidContactPack.type,
                        price: (+paidContactPack.totalPrice / +booking.paxes.length)
                    });
                }
            }

            return elements;
        };

        this.getOldPrice = function (pack, booking) {
            var old = 0;

            angular.forEach(
                this.getPricingElements(pack, booking),
                function (item) {
                    old += item.price;
                });

            return old;
        };
    };

    IthTicketTypeHelperService.$inject = [
        'TicketTypesEnum',
        'AutomatedCheckinHelper'
    ];

    angular
        .module('flightDetails')
        .service('TicketTypeHelper', IthTicketTypeHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-modal-info.component.js
(function(angular) {
var template = '\
    <div class="ith-ticket-types-modal-info">\
        <ith-ticket-type-modal-package\
            ng-if="$ctrl.booking.ticketType.packages.length"\
            ng-repeat="package in $ctrl.booking.ticketType.packages track by package.packageId"\
            booking="$ctrl.booking"\
            package="package"\
            ng-style="$ctrl.getStyleMap(package)">\
        </ith-ticket-type-modal-package>\
    </div>\
    ';

    var controller = function (TicketTypeHelper) {
        this.getStyleMap = function (pack) {
            return TicketTypeHelper.getListOrderStyleMap(pack);
        };
    };

    controller.$inject = ['TicketTypeHelper'];

    var IthTicketTypeModalInfoComponent = {
        template: template,
        bindings: {
            booking: '<'
        },
        controller: controller
    };

    angular
        .module('flightDetails')
        .component('ithTicketTypeModalInfo', IthTicketTypeModalInfoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-modal-package.component.js
(function(angular) {
var template = '\
    <article>\
        <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
        <p ng-if="false && $ctrl.hasUpsell()">\
            <button class="btn btn-lg ith-ticket-type-upsell-button btn-primary" ng-click="$ctrl.upgrade()">{{ $ctrl.getButtonLabel() | translate }}</button>\
        </p>\
        <p>&nbsp;</p>\
    </article>\
    ';

    var IthTicketTypeModalPackageComponent = {
        template: template,
        controller: ['TicketTypesEnum', 'TicketTypeHelper', function (TicketTypesEnum, TicketTypeHelper) {
            this.getDescriptionTextBox = function () {
                return TicketTypeHelper.getDescriptionTextBox(
                    this.package.type,
                    this.booking.ticketType.version,
                    'modal'
                );
            };

            this.hasUpsell = function () {
                return (
                    this.booking.ticketType.selectedId !== this.package.packageId &&
                    this.package.type !== TicketTypesEnum.basic &&
                    (
                        this.booking.ticketType.getSelectedPackage() === null ||
                        parseFloat(this.booking.ticketType.getSelectedPackage().price) < parseFloat(this.package.price)
                    )
                );
            };

            this.upgrade = function () {
                this.booking.ticketType.selectedId = this.package.packageId;
                TicketTypeHelper.toggleIncludedProducts(this.booking);
            };

            this.getButtonLabel = function () {
                if (this.package.type === TicketTypesEnum.smart) {
                    return 'LANGM_JS_FD_TICKET_TYPE_INFO_MODAL_UPGRADE_TO_SMART';
                }

                return 'LANGM_JS_FD_TICKET_TYPE_INFO_MODAL_UPGRADE_TO_SUPERFLEX';
            };
        }],
        bindings: {
            booking: '<',
            package: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithTicketTypeModalPackage', IthTicketTypeModalPackageComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-select.component.js
(function(angular) {
var template = '\
        <div class="ith-ticket-types ith-selectable-boxes">\
            <ith-ticket-type-box\
                ng-if="$ctrl.booking.ticketType.packages.length"\
                ng-repeat="package in $ctrl.booking.ticketType.packages track by package.packageId"\
                package="package"\
                booking="$ctrl.booking"\
                ng-class="{ \'recommended\': package.flags.recommended === true }"\
                ng-style="$ctrl.getStyleMap(package)">\
            </ith-ticket-type-box>\
        </div>\
    ';

    var controller = function ($rootScope, $window, $modal, TicketTypeApi, TicketTypeHelper, SelectableBoxContentService) {
        var self = this;

        this.eventRefs = {
            ticketTypeModalUnregister: null,
            stepChangedUnregister: null
        };

        this.$onInit = function () {
            this.loadTicketTypes();

            this.eventRefs.ticketTypeModalUnregister = $rootScope.$on('ticketTypeModal:open', this.openModal);
            this.eventRefs.stepChangedUnregister = $rootScope.$on('stepChanged', this.onStepChanged);

            angular.element($window).bind('resize', function () {
                SelectableBoxContentService.readjustRows('.ith-ticket-type-box');
            });
        };

        this.$onDestroy = function () {
            // Unregister event listeners
            this.eventRefs.ticketTypeModalUnregister();
            this.eventRefs.stepChangedUnregister();
        };

        this.$doCheck = function () {
            SelectableBoxContentService.readjustRows('.ith-ticket-type-box');
        };

        this.openModal = function () {
            var ModalController = function (sharedData) {
                this.data = sharedData;
            };

            ModalController.$inject = [
                'sharedData'
            ];

            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/flights/ticket-type-modal',
                windowClass: 'mobile-modal--fullscreen upsell-modal',
                controller: ModalController,
                controllerAs: '$ctrl',
                resolve: {
                    sharedData: function () {
                        return self.booking;
                    }
                }
            });
        };

        this.onStepChanged = function () {
            if (!self.steps.isTicketType() || self.steps.showAssistanceStep) {
                return;
            }

            setTimeout(function () {
                SelectableBoxContentService.readjustRows('.ith-ticket-type-box');
            }, 100);
        };

        this.loadTicketTypes = function () {
            var cfarRequestId = this.booking.ticketType.isCfarIncluded()
                ? this.booking.ticketType.getCfarProduct().responseQuote.requestId
                : null;

            TicketTypeApi
                .get({
                    requestId: this.booking.flightDetails.getRequestId(),
                    priceGroupId: this.booking.flightDetails.getPriceGroupId(),
                    depLegId: this.booking.flightDetails.getDepLegId(),
                    retLegId: this.booking.flightDetails.getRetLegId(),
                    discountAmount: this.booking.basket.getTotalDiscount(),
                    bagsPrice: this.booking.basket.getTotalLuggagePrice(),
                    withDiff: false,
                    seatsPrice: this.booking.basket.getTotalSeatsPrice(),
                    smsAmount: this.booking.basket.getTotalSmsNotification(),
                    ancillariesRequestIds: {
                        basic: null,
                        smart: null,
                        flex: cfarRequestId
                    }
                })
                .then(function (response) {
                    self.booking.ticketType.populate(response.data.response);
                    self.booking.cfar.initWithTicketTypes(response.data.response);
                });
        };

        this.getStyleMap = function (pack) {
            return TicketTypeHelper.getListOrderStyleMap(pack);
        };
    };

    controller.$inject = [
        '$rootScope',
        '$window',
        '$modal',
        'TicketTypeApi',
        'TicketTypeHelper',
        'SelectableBoxContentService'
    ];

    var IthTicketTypeSelectComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<',
            steps: '<'
        }
    };

    angular
        .module('flightDetails')
        .component('ithTicketTypeSelect', IthTicketTypeSelectComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-ty-box.component.js
(function(angular) {
var template = '\
    <div>\
        <ith-upsell-presentation-box ng-if="$ctrl.booking.ticketType.isPopulated">\
            <logo-pane>\
                <ith-product-logo\
                    image-name="ticket"\
                    show-affiliate-name="false"\
                    name="{{ $ctrl.getName() }}">\
                </ith-product-logo>\
            </logo-pane>\
            <description-pane>\
                <div text-box-body="{{ $ctrl.getDescriptionTextBox() }}" show-loader="true"></div>\
            </description-pane>\
        </ith-upsell-presentation-box>\
    </div>\
    ';

    var controller = function ($translate, TicketTypeHelper) {
        this.getName = function () {
            return $translate.instant(
                TicketTypeHelper.getPackageName(
                    this.booking.ticketType.getSelectedPackage().type
                ) + '_BASKET'
            );
        };

        this.getDescriptionTextBox = function () {
            return TicketTypeHelper.getDescriptionTextBox(
                this.booking.ticketType.getSelectedPackage().type,
                this.booking.ticketType.getSelectedPackage().packageId,
                'ty'
            );
        };
    };

    controller.$inject = ['$translate', 'TicketTypeHelper'];

    var IthTicketTypeTyBoxComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('base')
        .component('ithTicketTypeTyBox', IthTicketTypeTyBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type-upsell.component.js
(function(angular) {
var template = '\
        <div class="ith-ticket-type-upsell">\
            <ith-upsell-box ng-if="$ctrl.isVisible()">\
                <logo-pane>\
                    <ith-product-logo\
                        image-name="save"\
                        show-affiliate-name="false"\
                        name="">\
                    </ith-product-logo>\
                </logo-pane>\
                <description-pane>\
                    <div ng-if="$ctrl.getUpgradePrice() === 0">\
                        <h3 translate>LANGM_JS_SMART_UPSELL_SAME_PRICE_TITLE</h3>\
                        <div text-box-body="{{ $ctrl.getDescriptionTextBox(\'same-price\') }}" show-loader="true"></div>\
                    </div>\
                    <div ng-if="$ctrl.getUpgradePrice() > 0">\
                        <h3 translate translate-values="{ diff: ($ctrl.getUpgradePrice() | flPrice:2:0) }">LANGM_JS_SMART_UPSELL_MORE_EXPENSIVE_TITLE</h3>\
                        <div text-box-body="{{ $ctrl.getDescriptionTextBox(\'more-expensive\') }}" show-loader="true"></div>\
                    </div>\
                    <div ng-if="$ctrl.getUpgradePrice() < 0">\
                        <h3 translate translate-values="{ diff: ($ctrl.getUpgradePrice() | flPrice:2:0) }">LANGM_JS_SMART_UPSELL_CHEAPER_TITLE</h3>\
                        <div text-box-body="{{ $ctrl.getDescriptionTextBox(\'cheaper\') }}" show-loader="true"></div>\
                    </div>\
                </description-pane>\
                <action-pane>\
                    <div class="upsell-box__action__pricing"><strong><span ng-show="$ctrl.getUpgradePrice() > 0">&plus;</span>{{ $ctrl.getUpgradePrice() | flPrice:2:0 }}</strong></div>\
                    <p class="upsell-box__action__pricing-total" translate>LANGM_JS_AUTOMATED_CHECKIN_PRICING_PER_PAX</p>\
                    <a class="btn btn-block btn-lg btn-primary ng-animate-disabled" ng-click="$ctrl.upgrade()" translate>LANGM_JS_SMART_UPSELL_CTA_TEXT</a>\
                </action-pane>\
            </ith-upsell-box>\
        </div>\
    ';

    var controller = function (TicketTypeHelper) {
        /**
         * Is last ditch visible?
         *
         * @returns {boolean}
         */
        this.isVisible = function () {
            var smartPackage = this.booking.ticketType.getSmartPackage();

            if (!smartPackage) {
                return false;
            }

            var hasSmartAssistance = (
                this.booking.frolaAssistance.isSelected() &&
                (
                    this.booking.frolaAssistance.getSelectedPackage().type ===
                    this.booking.ticketType.getPaidContactProduct(smartPackage).type
                )
            );

            var hasAdditionalProductInBasket = (
                this.booking.fastRefund.isSelected() ||
                this.booking.paidCheckin.isSelected() ||
                hasSmartAssistance
            );

            var hasPremiumAssistance = (
                this.booking.frolaAssistance.isSelected() &&
                this.booking.frolaAssistance.isPremium(
                    this.booking.frolaAssistance.getSelectedPackage()
                )
            );

            var hasAllSmartProducts = (
                this.booking.ticketType.isCheckinIncluded(smartPackage) && this.booking.paidCheckin.isSelected() &&
                this.booking.ticketType.isFastRefundIncluded(smartPackage) && this.booking.fastRefund.isSelected() &&
                this.booking.ticketType.isPaidContactIncluded(smartPackage) && hasSmartAssistance
            );

            var someProductsAndUpgradedPrice = (
                this.booking.ticketType.isBasic() &&
                hasAdditionalProductInBasket &&
                !hasPremiumAssistance &&
                !hasAllSmartProducts &&
                this.getUpgradePrice() > 0
            );

            var allProductsAndPriceIsLower = (
                hasAllSmartProducts &&
                this.getUpgradePrice() < 0
            );

            return someProductsAndUpgradedPrice || allProductsAndPriceIsLower;
        };

        /**
         * Upgrade price
         *
         * @returns {number}
         */
        this.getUpgradePrice = function () {
            var smartPrice = this.booking.ticketType.getSmartPackage().price;
            var fastRefundPrice = this.booking.fastRefund.isSelected() ? this.booking.fastRefund.getTotalPrice() : 0;
            var frolaAssistancePrice = this.booking.frolaAssistance.getTotalPrice();
            var checkinPrice = this.booking.paidCheckin.isSelected() ? this.booking.paidCheckin.getTotalPrice() : 0;

            var selectedAssistancePackage = this.booking.frolaAssistance.getSelectedPackage();

            if (selectedAssistancePackage !== null) {
                var equivalentSmartAssistance = this.booking.frolaAssistance.getPackageByType(
                    selectedAssistancePackage.type,
                    'smart'
                );

                if (equivalentSmartAssistance !== null) {
                    frolaAssistancePrice -= equivalentSmartAssistance.totalPrice;
                }

            }

            return (smartPrice - fastRefundPrice - frolaAssistancePrice - checkinPrice) / this.booking.getPaxes().length;
        };

        /**
         * Description text box name for last ditch
         *
         * @param {string} type
         * @returns {string}
         */
        this.getDescriptionTextBox = function (type) {
            return TicketTypeHelper.getDescriptionTextBox(
                'smart',
                this.booking.ticketType.version,
                'upsell_' + type
            );
        };

        /**
         * Selects smart ticket type
         */
        this.upgrade = function () {
            var selectedAssistancePackage = this.booking.frolaAssistance.getSelectedPackage();

            this.booking.ticketType.selectSmartPackage();
            TicketTypeHelper.toggleIncludedProducts(this.booking);

            var equivalentSmartAssistance = this.booking.frolaAssistance.getPackageByType(
                selectedAssistancePackage.type,
                'smart'
            );

            if (equivalentSmartAssistance !== null) {
                this.booking.frolaAssistance.selectedId = equivalentSmartAssistance.id;
            }
        };
    };

    controller.$inject = ['TicketTypeHelper'];

    var IthTicketTypeUpsellComponent = {
        template: template,
        controller: controller,
        bindings: {
            booking: '<'
        }
    };

    angular
        .module('base')
        .component('ithTicketTypeUpsell', IthTicketTypeUpsellComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type.api.js
(function(angular) {
var IthTicketTypeApi = function ($http, AppConfig) {
        this.get = function (payload) {
            return $http({
                method: 'POST',
                url: AppConfig.getUriPrefix() + '/api/ancillaries/getServicePackagesPrice',
                data: payload
            });
        };
    };

    IthTicketTypeApi.$inject = ['$http', 'appConfig'];

    angular
        .module('flightDetails')
        .service('TicketTypeApi', IthTicketTypeApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-type.model.js
(function(angular) {
var TicketTypeModel = function (TicketTypesEnum, TicketTypeHelper) {
        /**
         * @constructor
         */
        var TicketType = function () {
            /**
             * Array of available packages
             *
             * @type {Object[]}
             */
            this.packages = [];

            /**
             * Version of ticket type packages
             *
             * @type {String}
             */
            this.version = '';

            /**
             * Id of the selected package
             *
             * @type {String}
             */
            this.selectedId = null;

            /**
             * Flag determining if this was already populated
             *
             * @type {Boolean}
             */
            this.isPopulated = false;
        };

        /**
         * Populates packages from API response
         *
         * @param {Object} response
         */
        TicketType.prototype.populate = function (response) {
            this.isPopulated = true;
            this.packages = Object.values(response.packages);
            this.version = response.version;
        };

        /**
         * Populates data from booking response
         *
         * @param {Object} data
         */
        TicketType.prototype.initWithBookingData = function (data) {
            if (data.type === null) {
                return;
            }

            this.isPopulated = true;
            this.packages = [{
                packageId: data.id,
                price: parseFloat(data.price),
                type: data.type,
                includes: data.includes
            }];
            this.selectedId = this.packages[0].packageId;
            this.version = this.selectedId.slice(-2);
        };

        /**
         * Returns selected package by selected id
         *
         * @returns {Object}
         */
        TicketType.prototype.getSelectedPackage = function () {
            var foundPackage = null;
            var self = this;

            angular.forEach(this.packages, function (pack) {
                if (pack.packageId === self.selectedId) {
                    foundPackage = pack;
                }
            });

            return foundPackage;
        };

        TicketType.prototype.selectSmartPackage = function () {
            this.selectedId = this.getSmartPackage().packageId;
        };

        TicketType.prototype.getSmartPackage = function () {
            var foundPackage = null;

            angular.forEach(this.packages, function (pack) {
                if (pack.type === TicketTypesEnum.smart) {
                    foundPackage = pack;
                }
            });

            return foundPackage;
        };

        /**
         * Returns total price of package
         *
         * @returns {Number}
         */
        TicketType.prototype.getTotalPrice = function () {
            if (this.getSelectedPackage() === null) {
                return 0;
            }

            return parseFloat(this.getSelectedPackage().price);
        };

        /**
         * Checks if a product is included in the package
         *
         * @param {String} name
         * @param {Object} pack
         * @returns {Boolean}
         */
        TicketType.prototype.isProductIncluded = function (name, pack) {
            if (!pack) {
                pack = this.getSelectedPackage();
            }

            if (pack == null) {
                return null;
            }

            var isIncluded = false;

            angular.forEach(pack.includes, function (product) {
                if (product.name === name) {
                    isIncluded = true;
                }
            });

            return isIncluded;
        };

        /**
         * Checks if selected package is basic
         *
         * @returns {Boolean}
         */
        TicketType.prototype.isBasic = function () {
            if (this.getSelectedPackage() === null) {
                return false;
            }

            return this.getSelectedPackage().type === TicketTypesEnum.basic;
        };

        /**
         * Checks if selected package is smart
         *
         * @returns {Boolean}
         */
        TicketType.prototype.isSmart = function () {
            if (this.getSelectedPackage() === null) {
                return false;
            }

            return this.getSelectedPackage().type === TicketTypesEnum.smart;
        };

        /**
         * Checks if selected package is flex
         *
         * @returns {Boolean}
         */
        TicketType.prototype.isFlex = function () {
            if (this.getSelectedPackage() === null) {
                return false;
            }

            return this.getSelectedPackage().type === TicketTypesEnum.flex;
        };

        /**
         * Checks if checkin is included in the selected package
         * @returns {Boolean}
         */
        TicketType.prototype.isCheckinIncluded = function (pack) {
            return this.isProductIncluded('CHECKIN', pack);
        };

        /**
         * Checks if fast refund is included in the selected package
         * @returns {Boolean}
         */
        TicketType.prototype.isFastRefundIncluded = function (pack) {
            return this.isProductIncluded('FAST_REFUND', pack);
        };

        /**
         * Checks if cfar is included in the selected package
         * @returns {Boolean}
         */
        TicketType.prototype.isCfarIncluded = function (pack) {
            return this.isProductIncluded('CFAR', pack);
        };

        /**
         * Checks if paid contact is included in the selected package
         * @returns {Boolean}
         */
        TicketType.prototype.isPaidContactIncluded = function (pack) {
            return this.isProductIncluded('PAID_CONTACT', pack);
        };

        /**
         * Retrieves cfar product from the selected package
         *
         * @returns {Object|null}
         */
        TicketType.prototype.getCfarProduct = function (pack) {
            return this.getIncludedProduct('CFAR', pack);
        };

        /**
         * Retrieves paid contact product from the selected package
         *
         * @returns {Object|null}
         */
        TicketType.prototype.getPaidContactProduct = function (pack) {
            return this.getIncludedProduct('PAID_CONTACT', pack);
        };

        /**
         * Retrieves an included product by name
         *
         * @param {String} name
         * @returns {Object|null}
         */
        TicketType.prototype.getIncludedProduct = function (name, pack) {
            var includedProduct = null;

            if (!pack) {
                pack = this.getSelectedPackage();
            }

            angular.forEach(pack.includes, function (product) {
                if (product.name === name) {
                    includedProduct = product;
                }
            });

            return includedProduct;
        };

        /**
         * Checks if there's a paid package selected
         *
         * @returns {Boolean}
         */
        TicketType.prototype.isSelected = function () {
            return this.selectedId !== null;
        };

        /**
         * Returns package name by selected id
         *
         * @returns {String}
         */
        TicketType.prototype.getPackageName = function () {
            if (this.selectedId === null) {
                return '';
            }

            return TicketTypeHelper.getPackageName(
                this.getSelectedPackage().type
            );
        };

        /**
         * Serialisation for backend
         *
         * @returns {String}
         */
        TicketType.prototype.srvObj = function () {
            var cfarRequestId = this.isCfarIncluded()
                ? this.getCfarProduct().responseQuote.requestId
                : null;

            return {
                id: this.selectedId,
                cfarRequestId: cfarRequestId
            };
        };

        TicketType.prototype.constructor = TicketType;

        return TicketType;
    };

    TicketTypeModel.$inject = ['TicketTypesEnum', 'TicketTypeHelper'];

    angular
        .module('flightDetails')
        .factory('TicketType', TicketTypeModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/ticket-type/ith-ticket-types.enum.js
(function(angular) {
angular
        .module('flightDetails')
        .constant('TicketTypesEnum', {
            basic: 'basic',
            smart: 'smart',
            flex: 'flex'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/trust-builder/ith-fd-steps-provider.service.js
(function() {
angular
        .module('flightDetails')
        .service('FlightDetailsStepsProvider', ['StepsEnum', 'appConfig', function (StepsEnum, AppConfig) {
            /**
             *
             */
            this.get = function () {
                var flightInfoNameLang = 'LANGM_JS_FD_FLIGHT_INFO_TITLE';
                var flightInfoTitleLang = 'LANGM_JS_FD_FLIGHT_INFO_PAGE_TITLE';

                if (AppConfig.getAbConfig()['dfs_forms_position'] === 'end') {
                    flightInfoNameLang = 'LANGM_JS_FD_LUGGAGE_INFO_TITLE';
                    flightInfoTitleLang = 'LANGM_JS_FD_LUGGAGE_INFO_PAGE_TITLE';
                }

                return [
                    {
                        id: null,
                        name: 'LANGM_JS_FD_SEARCH_RESULTS_TITLE',
                        title: 'LANGM_JS_FD_SEARCH_RESULTS_PAGE_TITLE',
                        desc: '',
                    },
                    {
                        id: StepsEnum.FLIGHT_INFO,
                        name: flightInfoNameLang,
                        title: flightInfoTitleLang,
                        desc: ''
                    },
                    {
                        id: StepsEnum.TICKET_TYPE,
                        name: 'LANGM_JS_FD_TICKET_TYPE_TITLE',
                        title: 'LANGM_JS_FD_TICKET_TYPE_PAGE_TITLE',
                        desc: 'LANGM_JS_FD_TICKET_TYPE_DESC'
                    },
                    {
                        id: StepsEnum.BILLING,
                        name: 'LANGM_JS_FD_BILLING_CONFIGURE_PAYMENT_TITLE',
                        title: 'LANGM_JS_FD_BILLING_CONFIGURE_PAYMENT_PAGE_TITLE',
                        desc: ''
                    }
                ];
            };

            /**
             *
             */
            this.getAssistanceStep = function () {
                return {
                    name: 'LANGM_JS_FD_SELECT_ASSISTANCE_TITLE',
                    title: 'LANGM_JS_FD_SELECT_ASSISTANCE_PAGE_TITLE',
                    desc: 'LANGM_JS_FD_SELECT_ASSISTANCE_DESC'
                };
            };
        }]);

}());
;

// Source: ../shared/public_html/assets/js/flightDetails/components/trust-builder/trust-builder-widget.component.js
(function(angular) {
/**
     * @name        ithTrustBuilderComponent
     * @description Component that displays trust building banners
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var ithTrustBuilderComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/trustBuilders/pax-details-top',
        controller: 'TrustBuilderController'
    };

    angular
        .module('flightDetails')
        .component('ithTrustBuilderWidget', ithTrustBuilderComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/components/trust-builder/trust-builder-widget.controller.js
(function (angular) {
/**
     * @name        TrustBuilderController
     * @description Controller for trust builder component
     * @constructor
     */
    var TrustBuilderController = function (AppConfig) {
        /**
         * AppConfig reference
         *
         * @type {AppConfig}
         */
        this.appConfig = AppConfig;
    };

    TrustBuilderController.$inject = [
        'appConfig'
    ];

    angular
        .module('flightDetails')
        .controller('TrustBuilderController', TrustBuilderController);
})(angular);



;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-package.component.js
(function(angular) {
var template = '\
        <div class="ibe-luggage__package">\
            <div ng-if="$ctrl.serviceChoose.isNoOption()" class="ibe-luggage__package__service ibe-luggage__package__service--none">\
                <span ng-show="$ctrl.isCabinCategory()" translate>LANGM_JS_IBE_LUGGAGE_NO_CABIN</span>\
                <span ng-show="!$ctrl.isCabinCategory()" translate>LANGM_JS_IBE_LUGGAGE_NO_CHECKED</span>\
            </div >\
            <div ng-if="!$ctrl.serviceChoose.isNoOption()" class="ibe-luggage__package__services">\
                <div class="ibe-luggage__package__service" ng-repeat="service in $ctrl.serviceChoose.services | orderBy: \'order\'">\
                    <div class="ibe-luggage__package__luggage">\
                        <img ng-src="{{ $ctrl.IbeLuggageServiceHelper.getIconFile(service) }}" />\
                        <div ng-if="!service.isPriority()">\
                            <strong class="ibe-luggage__package__service__name">{{ service.count }} × {{ $ctrl.IbeLuggageServiceHelper.getServiceTitle(service) | translate }}</strong>\
                            <small>\
                                <span ng-if="$ctrl.IbeLuggageServiceHelper.hasSize(service)">{{ service.parameters.height }} × {{ service.parameters.length }} × {{ service.parameters.width }} cm,</span>\
                                <span ng-if="!$ctrl.IbeLuggageServiceHelper.hasSize(service) && $ctrl.IbeLuggageServiceHelper.hasTotalSum(service)">{{ \'LANGM_JS_IBE_LUGGAGE_MAX_DIMENSIONS\' | translate:{ max: service.parameters.total } }},</span>\
                                <span ng-if="$ctrl.IbeLuggageServiceHelper.hasWeight(service)">{{ service.parameters.weight }} kg</span>\
                            </small>\
                        </div>\
                        <div ng-if="service.isPriority()">\
                            <strong class="ibe-luggage__package__service__name" translate>LANGM_JS_IBE_LUGGAGE_PRIORITY</strong>\
                            <small>{{ $ctrl.IbeLuggageServiceHelper.getPriorityRouteTranslation(service) }}</small>\
                        </div>\
                    </div>\
                </div>\
            </div >\
            <strong ng-if="!$ctrl.serviceChoose.isNoOption()" class="ibe-luggage__package__pricing">\
                <span ng-if="$ctrl.serviceChoose.price > 0">{{ $ctrl.serviceChoose.price | flPrice:2 }}</span>\
                <span class="ibe-luggage__package__pricing--free" ng-if="$ctrl.serviceChoose.price === 0" translate>LANGM_JS_INCLUDED</span>\
            </strong>\
        </div>\
    ';

    var IbeLuggagePackageComponent = {
        template: template,
        bindings: {
            type: '<',
            serviceChoose: '<'
        },
        controller: function (IbeLuggageServiceHelper, IBE_LUGGAGE_COMBINATION_TYPES) {
            /**
             * @type {IbeLuggageServiceHelper}
             */
            this.IbeLuggageServiceHelper = IbeLuggageServiceHelper;

            /**
             * Checks if this package is of type cabin
             *
             * @returns {Boolean}
             */
            this.isCabinCategory = function () {
                return this.type === IBE_LUGGAGE_COMBINATION_TYPES.CABIN;
            };
        }
    };

    IbeLuggagePackageComponent.controller.$inject = [
        'IbeLuggageServiceHelper',
        'IBE_LUGGAGE_COMBINATION_TYPES'
    ];

    angular
        .module('ibe-luggage')
        .component('ibeLuggagePackage', IbeLuggagePackageComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-selector-category.component.js
(function (angular) {
var template = '\
        <div ng-if="!$ctrl.combination.isChecked()" class="ibe-luggage__category" ng-class="$ctrl.getClassMap()">\
            <h6>{{ :: ($ctrl.getTitleLang() | translate) }}</h6>\
            <div ng-if="!$ctrl.isWarningActive()" ng-repeat="serviceChoose in $ctrl.combination.serviceChooses track by serviceChoose.token">\
                <ibe-luggage-service-choose\
                    siblings="$ctrl.combination.serviceChooses.length"\
                    select-model="$ctrl.selectModel"\
                    select-value="serviceChoose.token">\
                    <ibe-luggage-package\
                        service-choose="serviceChoose"\
                        type="$ctrl.type">\
                    </ibe-luggage-package>\
                </ibe-luggage-service-choose>\
            </div>\
            <ith-alert-box ng-if="$ctrl.isWarningActive()" type="warning">\
                <div text-box-body="text_box_short_layover_no_checked_bag" show-loader="true"></div>\
            </ith-alert-box>\
        </div>\
        \
        \
        \
        <div ng-if="$ctrl.combination.isChecked() && !$ctrl.isWarningActive()" class="ibe-luggage__category" ng-class="$ctrl.getClassMap()">\
            <h6>{{ :: ($ctrl.getTitleLang() | translate) }}</h6>\
            <div class="ibe-luggage__wrapper">\
            \
                <div class="ibe-luggage__info-box">\
                    <svg-icon id="lost-luggage"></svg-icon>\
                    <div>\
                        <h6 translate>LANGM_JS_LOST_LUGGAGE_COMPENSATION</h6>\
                        <div>\
                            <span translate>LANGM_JS_LOST_LUGGAGE_INFO_BOX_1</span>\
                            <b translate>LANGM_JS_LOST_LUGGAGE_INFO_BOX_PRICE</b>\
                            <span translate>LANGM_JS_LOST_LUGGAGE_INFO_BOX_2</span>\
                            <span>\
                                <button \
                                    class="ibe-luggage__info-box-button" \
                                    type="button"\
                                    translate \
                                    ng-click="$ctrl.clickHandler()"\
                                >\
                                    LANGM_JS_LOST_LUGGAGE_INFO_BOX_BTN\
                                </button>\
                            </span>\
                        </div>\
                    </div>\
                </div>\
            \
                <div class="ibe-luggage__inner">\
                    <div ng-repeat="serviceChoose in $ctrl.combination.serviceChooses track by serviceChoose.token">\
                        <ibe-luggage-service-choose\
                            siblings="$ctrl.combination.serviceChooses.length"\
                            select-model="$ctrl.selectModel"\
                            select-value="serviceChoose.token">\
                            <ibe-luggage-package\
                                service-choose="serviceChoose"\
                                type="$ctrl.type">\
                            </ibe-luggage-package>\
                        </ibe-luggage-service-choose>\
                        <div class="ibe-luggage__separator"></div>\
                    </div>\
                </div>\
            </div>\
        </div>\
            \
        <ith-alert-box ng-if="$ctrl.combination.isChecked() && $ctrl.isWarningActive()" type="warning">\
            <div text-box-body="text_box_short_layover_no_checked_bag" show-loader="true"></div>\
        </ith-alert-box>\
    ';

    var controller = function ($modal) {
        this.getTitleLang = function () {
            if (this.combination.isCabin()) {
                return this.combination.serviceChooses.length > 1
                    ? 'LANGM_JS_IBE_LUGGAGE_CABIN_SELECT'
                    : 'LANGM_JS_IBE_LUGGAGE_CABIN';
            }

            if (this.combination.isChecked()) {
                return this.combination.serviceChooses.length > 1
                    ? 'LANGM_JS_IBE_LUGGAGE_CHECKED_SELECT'
                    : 'LANGM_JS_IBE_LUGGAGE_CHECKED';
            }

            return this.combination.serviceChooses.length > 1
                ? 'LANGM_JS_IBE_LUGGAGE_MIXED_SELECT'
                : 'LANGM_JS_IBE_LUGGAGE_MIXED';
        };

        this.isWarningActive = function () {
            return (
                this.combination.isChecked() &&
                this.modifiers.indexOf('HOLD_LUGGAGE_EXCLUDED_DUE_TO_SHORT_TRANSFER_TIME') !== -1
            );
        };

        this.getClassMap = function () {
            return {
                'ibe-luggage__category--cabin': this.combination.isCabin(),
                'ibe-luggage__category--checked': this.combination.isChecked(),
                'ibe-luggage__category--mixed': !this.combination.isCabin() && !this.combination.isChecked(),
            };
        };

        this.clickHandler = function () {
            $modal.open({
                templateUrl: 'lostLuggageCompensationModal.html',
                controller: 'LostLuggageCompensationModalController',
                controllerAs: '$ctrl',
                size: 'md',
                windowClass: 'profile-modal-wrapper',
            });
        };
    };

    var IbeLuggageSelectorCategory = {
        template: template,
        bindings: {
            selectModel: '=',
            combination: '<',
            modifiers: '<'
        },
        controller: controller
    };

    controller.$inject = ['$modal'];

    angular
        .module('ibe-luggage')
        .component('ibeLuggageSelectorCategory', IbeLuggageSelectorCategory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-selector.component.js
(function(angular) {
var template = '\
        <div class="ibe-luggage-selector">\
            <div ng-if="$ctrl.isLoading">\
                <h6 translate>LANGM_JS_IBE_LUGGAGE</h6>\
                <ith-preloader>\
                    <translate>LANGM_JS_SIMPLIFIED_LUGGAGE_LOADING</translate>\
                </ith-preloader>\
            </div>\
            <div ng-if="!$ctrl.isLoading && $ctrl.isLuggageAvailable()">\
                <p style="color: black; font-weight: 700; font-size: 18px; margin: 25px 0 20px;" translate>LANGM_JS_LUGGAGE</p>\
                <ith-luggage-push ng-if="$ctrl.showPush"></ith-luggage-push>\
                <ibe-luggage-selector-category\
                    ng-repeat="combination in $ctrl.passengerOption.combinations"\
                    combination="combination"\
                    modifiers="$ctrl.modifiers"\
                    select-model="$ctrl.paxLuggage[$index]">\
                </ibe-luggage-selector-category>\
            </div>\
            <div ng-if="!$ctrl.isLoading && !$ctrl.isLuggageAvailable()">\
                <h6 translate>LANGM_JS_IBE_LUGGAGE</h6>\
                <ith-alert-box type="warning">\
                    <div translate>LANGM_JS_IBE_LUGGAGE_UNAVAILABLE</div>\
                </ith-alert-box>\
            </div>\
        </div>\
    ';

    var IbeLuggageSelectorComponent = {
        template: template,
        bindings: {
            isLoading: '<',
            passengerOption: '<',
            paxLuggage: '=',
            showPush: '<',
            modifiers: '<'
        },
        controller: function () {
            this.isLuggageAvailable = function () {
                if (
                    !this.passengerOption ||
                    this.passengerOption.combinations.length === 0 ||
                    (
                        this.passengerOption.combinations.length === 1 &&
                        this.passengerOption.combinations[0].isNoOption()
                    )
                ) {
                    return false;
                }

                return true;
            };
        }
    };

    angular
        .module('ibe-luggage')
        .component('ibeLuggageSelector', IbeLuggageSelectorComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-service-choose.component.js
(function(angular) {
var template = '\
        <div class="ibe-luggage__service-choose" ng-class="{ \'ibe-luggage__service-choose--chosen\': $ctrl.isChosen() }" ng-click="$ctrl.choose()">\
            <ith-ui-radio ng-if="$ctrl.siblings > 1" ng-model="$ctrl.selectModel" value="$ctrl.selectValue"></ith-ui-radio>\
            <ng-transclude></ng-transclude>\
        </div>\
    ';

    var IbeLuggageServiceChooseComponent = {
        template: template,
        bindings: {
            selectModel: '=',
            selectValue: '<',
            siblings: '<'
        },
        transclude: true,
        controller: function () {
            /**
             * Choose this service
             */
            this.choose = function () {
                this.selectModel = this.selectValue;
            };

            /**
             * Checks if this service is chosen
             *
             * @returns {Boolean}
             */
            this.isChosen = function () {
                return this.selectModel === this.selectValue;
            };
        }
    };

    angular
        .module('ibe-luggage')
        .component('ibeLuggageServiceChoose', IbeLuggageServiceChooseComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-summary.component.js
(function(angular) {
var template = '\
        <div class="ibe-luggage-summary">\
            <div ng-repeat="item in $ctrl.getItems() track by item.type">\
                <div class="orderSummary__table__item" ng-if="item.count > 0">\
                    <div class="orderSummary__table__product" ng-html="">{{ item.count }} &times; {{ $ctrl.getProductText(item) | translate }}</div>\
                    <div class="orderSummary__table__price orderSummary__table__price--free" ng-if="item.totalPrice === 0" translate>LANGM_JS_INCLUDED</div>\
                    <div class="orderSummary__table__price" ng-if="item.totalPrice > 0">{{ item.totalPrice | flPrice:2 }}</div>\
                </div>\
            </div>\
        </div>\
    ';

    var IbeLuggageSummaryComponent = {
        template: template,
        bindings: {
            booking: '<'
        },
        controller: function (IbeLuggageSummaryHelper, IBE_LUGGAGE_COMBINATION_TYPES) {
            /**
             * Basket items
             *
             * @type {Object[]}
             */
            this.items = [];

            /**
             * Processes and returns items
             *
             * @returns {Object[]}
             */
            this.getItems = function () {
                var items = IbeLuggageSummaryHelper.getItems(this.booking);

                if (this.items.length) {
                    this.items[0].count = items[0].count;
                    this.items[0].totalPrice = items[0].totalPrice;

                    this.items[1].count = items[1].count;
                    this.items[1].totalPrice = items[1].totalPrice;
                }

                if (!this.items.length) {
                    this.items = items;
                }

                return this.items;
            };

            /**
             * Returns cabin and checked text
             *
             * @param {IbeLuggageService} item
             * @returns {String}
             */
            this.getProductText = function (item) {
                if (item.type === IBE_LUGGAGE_COMBINATION_TYPES.CABIN) {
                    return 'LANGM_JS_IBE_LUGGAGE_BASKET_CABIN';
                }

                if (item.type === IBE_LUGGAGE_COMBINATION_TYPES.CHECKED) {
                    return 'LANGM_JS_IBE_LUGGAGE_BASKET_CHECKED';
                }

                return 'LANGM_JS_IBE_LUGGAGE_BASKET_MIXED';
            };
        }
    };

    IbeLuggageSummaryComponent.controller.$inject = [
        'IbeLuggageSummaryHelper',
        'IBE_LUGGAGE_COMBINATION_TYPES'
    ];

    angular
        .module('ibe-luggage')
        .component('ibeLuggageSummary', IbeLuggageSummaryComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-pax-luggage.component.js
(function (angular) {
var template = '\
        <div>\
            <div ng-repeat="service in $ctrl.services track by $index" class="pax-luggage-service">\
                <img class="pax-luggage-service__icon" ng-src="{{ $ctrl.IbeLuggageServiceHelper.getIconFile(service) }}" />\
                <div class="pax-luggage-service__details">\
                    <strong class="pax-luggage-service__title"><span ng-if="!service.isPriority()">{{ service.count }} × </span>{{ $ctrl.IbeLuggageServiceHelper.getServiceTitle(service) | translate }}</strong>\
                    <span class="pax-luggage-service__desc" ng-if="!service.isPriority()">\
                        <span ng-if="$ctrl.IbeLuggageServiceHelper.hasSize(service)">{{ service.parameters.height }} × {{ service.parameters.length }} × {{ service.parameters.width }} cm,</span>\
                        <span ng-if="!$ctrl.IbeLuggageServiceHelper.hasSize(service) && $ctrl.IbeLuggageServiceHelper.hasTotalSum(service)">{{ \'LANGM_JS_IBE_LUGGAGE_MAX_DIMENSIONS\' | translate:{ max: service.parameters.total } }},</span>\
                        <span ng-if="$ctrl.IbeLuggageServiceHelper.hasWeight(service)">{{ service.parameters.weight }} kg</span>\
                    </span>\
                    <span class="pax-luggage-service__desc" ng-if="service.isPriority()">{{ $ctrl.IbeLuggageServiceHelper.getPriorityRouteTranslation(service) }}</span>\
                </div>\
            </div>\
            <div ng-if="$ctrl.services.length === 0" translate="{{ $ctrl.getNoLuggageLang() }}"></div>\
        </div>\
    ';

    var controller = function (IbeLuggageServiceHelper) {
        this.IbeLuggageServiceHelper = IbeLuggageServiceHelper;
        this.services = [];

        this.$onInit = function () {
            this.services = IbeLuggageServiceHelper.getServicesByPax(
                this.pax,
                this.booking
            );
        };

        this.getNoLuggageLang = function () {
            if (this.pax.canHaveBaggage()) {
                return 'LANGM_JS_PAX_NO_LUGGAGE_BOUGHT';
            }

            return 'LANGM_JS_PAX_NO_LUGGAGE_INFANT';
        };

        this.$doCheck = function () {
            this.services = IbeLuggageServiceHelper.getServicesByPax(
                this.pax,
                this.booking
            );
        };
    };

    controller.$inject = ['IbeLuggageServiceHelper'];

    var IthPaxLuggageComponent = {
        template: template,
        controller: controller,
        bindings: {
            pax: '<',
            booking: '<'
        }
    };

    angular
        .module('ibe-luggage')
        .component('ithIbePaxLuggage', IthPaxLuggageComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/lost-luggage-compensation-modal.controller.js
(function (angular) {
var controller = function ($modalInstance) {
        this.closeModal = function () {
            $modalInstance.dismiss();
        }
    };

    controller.$inject = [
        '$modalInstance'
    ];

    angular
        .module('base')
        .controller('LostLuggageCompensationModalController', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/components/luggage-push.component.js
(function() {
var IthLuggagePushComponent = {
        template:
        '<div>\
            <div class="luggage-push">\
                <img src="/assets/img/ui/icons/luggage/push-icon-2.svg" />\
                \
                <div>\
                    <p class="luggage-push__title"><b translate>LANGM_JS_LUGGAGE_PUSH_TITLE</b></p>\
                    <p translate>LANGM_JS_LUGGAGE_PUSH_DESCRIPTION</p>\
                </div>\
            </div>\
            \
            \
            \
        <style>\
        .luggage-push { display: flex; background-color: #CAF8F5; padding: 15px; border-radius: 12px; margin-bottom: 20px }\
        .luggage-push img { margin-right: 15px; }\
        .luggage-push p { color: black; }\
        .luggage-push__title { margin-bottom: 5px; }\
        .luggage-push p:last-of-type { margin-bottom: 0; }\
        </style>\
        </div>'
    };

    angular
        .module('ibe-luggage')
        .component('ithLuggagePush', IthLuggagePushComponent);

}());
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/helpers/ibe-luggage-handler.helper.js
(function(angular) {
/**
     * Service responsible for loading luggage for flights
     * and parsing it into models
     */
    var IbeLuggageHandler = function (IbeLuggagePassengerOptions, OldLuggageHandler) {
        /**
         * Constructor
         *
         * @param {Booking} booking
         */
        var LuggageHandler = function (booking) {
            /**
             * Flight booking reference
             *
             * @type {Object}
             */
            this.booking = booking;

            /**
             * Loading state
             *
             * @type {Boolean}
             */
            this.isLoading = true;

            /**
             * Passenger options model
             *
             * @type {IbeLuggagePassengerOptions}
             */
            this.passengerOptions = new IbeLuggagePassengerOptions();
        };

        LuggageHandler.prototype.populate = function () {
            if (this.passengerOptions.passengerOptions.length > 0) {
                return;
            }

            var luggageInformation = this.booking.flightDetails.verification.luggageInformation;

            var luggageIsLoaded = (
                luggageInformation &&
                luggageInformation.passengerOptions &&
                luggageInformation.passengerOptions.length > 0
            );

            var verificationDone = (
                (
                    this.booking.testSell !== null &&
                    !this.booking.testSell.isInProgress()
                ) ||
                this.booking.flightDetails.verification.isDone()
            );

            if (luggageIsLoaded || verificationDone) {
                this.isLoading = false;

                var passengerOptions = [];
                var modifiers = [];

                if (luggageInformation !== null) {
                    passengerOptions = luggageInformation.passengerOptions;
                    modifiers = luggageInformation.modifiers;
                }

                if (luggageInformation === null && this.booking.reservationNumber !== '') {
                    // Populate new luggage using old luggage (only on thank you page)
                    passengerOptions = OldLuggageHandler.convertToIbeFormat(
                        this.booking.paxes,
                        this.booking.flightDetails.oldLuggage
                    );
                }

                this.passengerOptions.populate(passengerOptions, modifiers);
                setPaxData(this);
            }
        };

        LuggageHandler.prototype.isAvailable = function () {
            return this.passengerOptions.passengerOptions.length > 0;
        };

        LuggageHandler.prototype.isPaidLuggageAvailable = function () {
            if (!this.isAvailable()) {
                return false;
            }

            return this.passengerOptions.isPaidLuggageAvailable();
        };

        LuggageHandler.prototype.constructor = LuggageHandler;

        /**
         * Assigns free luggage to each pax
         *
         * @param {IbeLuggageHandler} context
         */
        var setPaxData = function (context) {
            angular.forEach(context.booking.paxes, function (pax) {
                var paxType = pax.person.paxType;

                var paxTypeLuggageOptions = context.passengerOptions.getOptionByPaxType(paxType);

                if (paxTypeLuggageOptions === undefined) {
                    return;
                }

                angular.forEach(paxTypeLuggageOptions.combinations, function (combination, key) {
                    var includedLuggage = combination.getFreeServiceChoose();

                    if (includedLuggage !== undefined && pax.luggage[key] === undefined) {
                        pax.luggage[key] = includedLuggage.token;
                    }
                });
            });
        };

        return LuggageHandler;
    };

    IbeLuggageHandler.$inject = [
        'IbeLuggagePassengerOptions',
        'OldLuggageHandler'
    ];

    angular
        .module('flightDetails')
        .factory('IbeLuggageHandler', IbeLuggageHandler);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/helpers/ibe-luggage-service.helper.js
(function(angular, underscore) {
var IbeLuggageServiceHelper = function (Dictionaries, $translate) {
        /**
         * Checks if service has all size parameters set
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {Boolean}
         */
        this.hasSize = function (service) {
            return (
                service.parameters.width &&
                service.parameters.width !== null &&

                service.parameters.height &&
                service.parameters.height !== null &&

                service.parameters.length &&
                service.parameters.length !== null
            );
        };

        /**
         * Checks if service has weight parameter set
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {Boolean}
         */
        this.hasWeight = function (service) {
            return service.parameters.weight && service.parameters.weight !== null;
        };

        /**
         * Checks if service has sum parameter set
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {Boolean}
         */
        this.hasTotalSum = function (service) {
            return service.parameters.total !== null;
        };

        /**
         * Returns icon file based on service type
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {String}
         */
        this.getIconFile = function (service) {
            var iconName = 'cabin';

            if (!service.isCabin()) {
                iconName = 'registered';
            }

            if (service.isPriority()) {
                iconName = 'priority';
            }

            if (service.isPersonalItem()) {
                iconName = 'personal-item';
            }

            return '/assets/img/ui/icons/luggage/' + iconName + '.svg';
        };

        /**
         * Returns service title based on service type
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {String}
         */
        this.getServiceTitle = function (service) {
            if (service.isPersonalItem()) {
                return 'LANGM_JS_IBE_LUGGAGE_PERSONAL';
            }

            if (service.isHandBaggage()) {
                return 'LANGM_JS_IBE_LUGGAGE_CABIN';
            }

            if (service.isPriority()) {
                return 'LANGM_JS_IBE_LUGGAGE_PRIORITY';
            }

            return 'LANGM_JS_IBE_LUGGAGE_CHECKED';
        };

        /**
         * Returns route translation for priority
         *
         * @param {IbeLuggageServiceModel} service
         * @returns {String}
         */
        this.getPriorityRouteTranslation = function (service) {
            if (service.parameters.route === '*') {
                return $translate.instant('LANGM_JS_IBE_LUGGAGE_PRIORITY_ROUNDTRIP');
            }

            var fromCode = service.parameters.route.substring(0, 3);
            var toCode = service.parameters.route.substring(3, 6);

            return Dictionaries.getCityNameByAirportCode(fromCode, false) + ' - ' + Dictionaries.getCityNameByAirportCode(toCode, false);
        };

        var addServicesByToken = function (targetArray, passengerOptions, token) {
            angular.forEach(passengerOptions, function (passengerOption) {
                angular.forEach(passengerOption.combinations, function (combination) {
                    angular.forEach(combination.serviceChooses, function (serviceChoose) {
                        if (serviceChoose.token === token) {
                            angular.forEach(serviceChoose.services, function (service) {
                                if (service.type !== 'NO_OPTION') {
                                    targetArray.push(service);
                                }
                            });
                        }
                    });
                });
            });
        };

        this.getServicesByPax = function (pax, booking) {
            var services = [];

            var passengerOptionsByPax = underscore.filter(
                booking.luggageHandler.passengerOptions.passengerOptions,
                function (passengerOption) {
                    return underscore.contains(passengerOption.applicablePassengerTypes, pax.person.getType());
                });

            angular.forEach(pax.luggage, function (luggageToken) {
                addServicesByToken(
                    services,
                    passengerOptionsByPax,
                    luggageToken
                );
            });

            services = underscore.sortBy(services, function (service) {
                if (service.type === 'HAND_BAGGAGE') {
                    return 1;
                }

                if (service.type === 'HOLD_BAGGAGE') {
                    return 2;
                }

                return 3;
            });

            return services;
        };
    };

    IbeLuggageServiceHelper.$inject = ['Dictionaries', '$translate'];

    angular
        .module('ibe-luggage')
        .service('IbeLuggageServiceHelper', IbeLuggageServiceHelper);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/helpers/ibe-luggage-summary.helper.js
(function(angular, underscore) {
var IbeLuggageSummaryHelper = function (IBE_LUGGAGE_COMBINATION_TYPES) {
        /**
         * Returns array of service chooses from luggage options
         *
         * @param {String} paxType
        * @param {IbeLuggagePassengerOption} passengerOption
         * @returns {IbeLuggageServiceChooseModel[]}
         */
        var getServiceChooses = function (passengerOption) {
            var serviceChooses = [];

            if (!passengerOption) {
                return [];
            }

            angular.forEach(passengerOption.combinations, function (combination) {
                serviceChooses = underscore.union(serviceChooses, combination.serviceChooses);
            });

            return serviceChooses;
        };

        /**
         * Updates total luggage price by token
         *
         * @param {String} token
         * @param {IbeLuggageServiceChooseModel[]} serviceChooses
         * @param {ItemCount} cabinCountObject
         * @param {ItemCount} checkedCountObject
         * @param {ItemCount} mixedCountObject
         */
        var updateLuggagePriceByToken = function (token, serviceChooses, cabinCountObject, checkedCountObject, mixedCountObject) {
            angular.forEach(serviceChooses, function (serviceChoose) {
                if (serviceChoose.token === token) {
                    if (serviceChoose.isCabin()) {
                        cabinCountObject.totalPrice += serviceChoose.price;
                    }

                    if (serviceChoose.isChecked()) {
                        checkedCountObject.totalPrice += serviceChoose.price;
                    }

                    if (serviceChoose.isMixed()) {
                        mixedCountObject.totalPrice += serviceChoose.price;
                    }
                }
            });
        };

        /**
         * Updates luggage count by token
         *
         * @param {String} token
         * @param {IbeLuggageServiceChooseModel[]} serviceChooses
         * @param {ItemCount} cabinCountObject
         * @param {ItemCount} checkedCountObject
         * @param {ItemCount} mixedCountObject
         */
        var updateLuggageCountByToken = function (token, serviceChooses, cabinCountObject, checkedCountObject, mixedCountObject) {
            angular.forEach(serviceChooses, function (serviceChoose) {
                if (serviceChoose.token === token) {
                    angular.forEach(serviceChoose.services, function (service) {
                        var isCabinLuggage = service.isHandBaggage() || service.isPersonalItem();
                        var isCheckedLuggage = !service.isCabin() && !service.isNoOption();

                        var isLuggage = isCabinLuggage || isCheckedLuggage;

                        if (!serviceChoose.isMixed() && isCabinLuggage) {
                            cabinCountObject.count += service.count;
                        }

                        if (!serviceChoose.isMixed() && isCheckedLuggage) {
                            checkedCountObject.count += service.count;
                        }

                        if (serviceChoose.isMixed() && isLuggage) {
                            mixedCountObject.count += service.count;
                        }
                    });
                }
            });
        };

        /**
         * Updates count and total price for a summary object
         *
         * @param {String} token
         * @param {IbeLuggageServiceChooseModel[]} serviceChooses
         * @param {ItemCount} cabinCountObject
         * @param {ItemCount} checkedCountObject
         * @param {ItemCount} mixedCountObject
         */
        var updateCategoryParams = function (token, serviceChooses, cabinCountObject, checkedCountObject, mixedCountObject) {
            updateLuggageCountByToken(token, serviceChooses, cabinCountObject, checkedCountObject, mixedCountObject);
            updateLuggagePriceByToken(token, serviceChooses, cabinCountObject, checkedCountObject, mixedCountObject);
        };

        /**
         * Returns array of items containing count and total price grouped by type
         *
         * @param {FlightBooking} booking
         * @returns {ItemCount[]}
         */
        this.getItems = function (booking) {
            var countedByType = {};

            /**
             * Item count model
             * @type {ItemCount}
             */
            var ItemCount = function (type) {
                this.type = type;
                this.count = 0;
                this.totalPrice = 0;
            };

            countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CABIN] = new ItemCount(IBE_LUGGAGE_COMBINATION_TYPES.CABIN);
            countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CHECKED] = new ItemCount(IBE_LUGGAGE_COMBINATION_TYPES.CHECKED);
            countedByType[IBE_LUGGAGE_COMBINATION_TYPES.MIXED] = new ItemCount(IBE_LUGGAGE_COMBINATION_TYPES.MIXED);

            angular.forEach(booking.paxes, function (pax) {
                var serviceChooses = getServiceChooses(
                    booking.luggageHandler.passengerOptions.getOptionByPaxType(pax.person.paxType)
                );

                angular.forEach(pax.luggage, function (luggageToken) {
                    updateCategoryParams(
                        luggageToken,
                        serviceChooses,
                        countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CABIN],
                        countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CHECKED],
                        countedByType[IBE_LUGGAGE_COMBINATION_TYPES.MIXED]
                    );
                });
            });

            return [
                countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CABIN],
                countedByType[IBE_LUGGAGE_COMBINATION_TYPES.CHECKED],
                countedByType[IBE_LUGGAGE_COMBINATION_TYPES.MIXED]
            ];
        };

        /**
         * Returns total luggage price for basket
         *
         * @param {FlightBooking} booking
         * @returns {Number}
         */
        this.getTotalPrice = function (booking) {
            var total = 0;

            angular.forEach(this.getItems(booking), function (item) {
                total += item.totalPrice;
            });

            return total;
        };
    };

    IbeLuggageSummaryHelper.$inject = [
        'IBE_LUGGAGE_COMBINATION_TYPES'
    ];

    angular
        .module('ibe-luggage')
        .service('IbeLuggageSummaryHelper', IbeLuggageSummaryHelper);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/helpers/old-luggage-handler.helper.js
(function(angular) {
var OldLuggageHandler = function () {
        /**
         * Converts old luggage (simplified luggage) to new IBE format
         *
         * @param {Pax[]} paxes
         * @param {SimplifiedLuggage} oldLuggage
         * @returns
         */
        this.convertToIbeFormat = function (paxes, oldLuggage) {
            var passengerOption = {
                applicablePassengerTypes: ['SRC', 'ADT', 'YTH', 'CHD'],
                combinations: [
                    { serviceChooses: [] },
                    { serviceChooses: [] }
                ]
            };

            angular.forEach(paxes, function (pax) {
                var paxCabin = getOldSelectedLuggage(pax.oldLuggage.cabin);
                var paxChecked = getOldSelectedLuggage(pax.oldLuggage.checked);

                if (paxCabin !== null) {
                    assignPaxSelection(
                        passengerOption.combinations[0].serviceChooses,
                        oldLuggage.options,
                        paxCabin,
                        pax,
                        'HAND_BAGGAGE'
                    );
                }

                if (paxChecked !== null) {
                    assignPaxSelection(
                        passengerOption.combinations[1].serviceChooses,
                        oldLuggage.options,
                        paxChecked,
                        pax,
                        'HOLD_BAGGAGE'
                    );
                }
            });

            return [passengerOption];
        };

        /**
         * Iterates over old luggage values on pax and returns a value with
         * count > 1
         *
         * @param {object} baggage
         * @returns {object}
         */
        var getOldSelectedLuggage = function (baggage) {
            var found = null;

            if (!baggage) {
                return null;
            }

            angular.forEach(Object.values(baggage), function (entry) {
                if (entry.count > 0) {
                    found = entry;
                }
            });

            return found;
        };

        /**
         * Returns simplified luggage option matched by id (collectionName)
         *
         * @param {SimplifiedLuggageOption[]} simplifiedLuggageOptions Array of simplified luggage options
         * @param {string} collectionName Collection name on pax luggage
         * @returns
         */
        var getSimplifiedLuggageOption = function (simplifiedLuggageOptions, collectionName) {
            var found = null;

            angular.forEach(simplifiedLuggageOptions, function (option) {
                if (option.id === collectionName) {
                    found = option;
                }
            });

            return found;
        };

        /**
         * Creates a new ibe service choose based on simplified luggage pax selection
         * and assings it to pax
         *
         * @param {ServiceChooses} serviceChooses Target object where the newly created service choose will be added to
         * @param {SimplifiedLuggageOptions} simplifiedLuggageOptions
         * @param {object} oldLuggageEntry
         * @param {Pax} pax
         * @param {string} newBaggageType
         */
        var assignPaxSelection = function (serviceChooses, simplifiedLuggageOptions, oldLuggageEntry, pax, newBaggageType) {
            var token = Math.random() + '' + oldLuggageEntry.price;

            var option = getSimplifiedLuggageOption(simplifiedLuggageOptions, oldLuggageEntry.collectionName);

            var countMap = {
                ID_BAGGAGE_PAYABLE_2: 2,
                ID_BAGGAGE_PAYABLE_3: 3
            };

            var count = countMap.hasOwnProperty(option.id) ? countMap[option.id] : oldLuggageEntry.count;

            var serviceChoose = {
                price: {
                    amount: option.price,
                },
                services: [{
                    count:  count,
                    type: newBaggageType,
                    parameters: {
                        width: option.size.width,
                        height: option.size.height,
                        length: option.size.length,
                        weight: option.weight
                    }
                }],
                token: token
            };

            if (option.id === 'ID_PRIORITY_BOARDING') {
                serviceChoose.services.push({
                    count: 1,
                    type: 'PRIORITY_BOARDING',
                    parameters: {
                        route: '*',
                        width: 0,
                        height: 0,
                        length: 0,
                        weight: 0
                    }
                });
            }

            serviceChooses.push(serviceChoose);

            pax.luggage.push(token);
        };
    };

    angular
        .module('flightDetails')
        .service('OldLuggageHandler', OldLuggageHandler);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/ibe-luggage-constants.js
(function(angular) {
angular
        .module('ibe-luggage')
        .constant('IBE_LUGGAGE_COMBINATION_TYPES', {
            CABIN: 'CABIN',
            CHECKED: 'CHECKED'
        })
        .constant('IBE_LUGGAGE_SERVICE_TYPES', {
            NO_OPTION: 'NO_OPTION',
            HAND_BAGGAGE: 'HAND_BAGGAGE',
            PRIORITY_BOARDING: 'PRIORITY_BOARDING',
            HOLD_BAGGAGE: 'HOLD_BAGGAGE'
        })
        .constant('IBE_LUGGAGE_SERVICE_VIEW_TYPES', {
            NO_OPTION: 'NO_OPTION',
            PERSONAL_ITEM: 'PERSONAL_ITEM',
            CABIN_TROLLEY: 'CABIN_TROLLEY',
            PRIORITY_BOARDING: 'PRIORITY_BOARDING',
            HOLD_BAGGAGE: 'HOLD_BAGGAGE'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/models/ibe-luggage-combination.model.js
(function(angular, underscore) {
/**
     * Model holding luggage combinations
     */
    var IbeLuggageCombinationModel = function (IbeLuggageServiceChoose) {
        /**
         * Constructor
         *
         * @param {Object} data
         */
        var LuggageCombination = function (data) {
            /**
             * Array of services to choose from
             *
             * @type {IbeLuggageServiceChoose[]}
             */
            this.serviceChooses = [];

            populateServiceChooses(data.serviceChooses, this);
        };

        /**
         * Populates service chooses array with models
         *
         * @param {Object[]} serviceArray
         * @param {Object} context
         * @private
         */
        var populateServiceChooses = function (serviceArray, context) {
            angular.forEach(serviceArray, function (service) {
                this.serviceChooses.push(new IbeLuggageServiceChoose(service));
            }, context);
        };

        /**
         * Checks if service chooses are hand luggage
         *
         * @returns {Boolean}
         */
        LuggageCombination.prototype.isCabin = function () {
            var lastServiceChoose = underscore.last(this.serviceChooses);

            if (!lastServiceChoose) {
                return false;
            }

            return lastServiceChoose.isCabin();
        };

        /**
         * Checks if service chooses are checked luggage
         *
         * @returns {Boolean}
         */
        LuggageCombination.prototype.isChecked = function () {
            var lastServiceChoose = underscore.last(this.serviceChooses);

            if (!lastServiceChoose) {
                return false;
            }

            return !lastServiceChoose.isCabin();
        };

        /**
         * @returns {Boolean}
         */
        LuggageCombination.prototype.isNoOption = function () {
            return this.serviceChooses[0].isNoOption() && this.serviceChooses.length === 1;
        };

        /**
         * Returns the free service choose
         *
         * @returns {IbeLuggageServiceChoose}
         */
        LuggageCombination.prototype.getFreeServiceChoose = function () {
            return underscore.find(this.serviceChooses, function (serviceChoose) {
                return serviceChoose.price <= 0;
            });
        };

        LuggageCombination.prototype.isPaidLuggageAvailable = function () {
            var paidServiceChoose = underscore.find(this.serviceChooses, function (serviceChoose) {
                return serviceChoose.price > 0;
            });

            return paidServiceChoose !== null && paidServiceChoose !== undefined;
        };

        LuggageCombination.prototype.constructor = LuggageCombination;

        return LuggageCombination;
    };

    IbeLuggageCombinationModel.$inject = [
        'IbeLuggageServiceChoose'
    ];

    angular
        .module('ibe-luggage')
        .factory('IbeLuggageCombination', IbeLuggageCombinationModel);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/models/ibe-luggage-passenger-option.model.js
(function(angular) {
/**
     * Model storing luggage combinations for pax types
     */
    var IbeLuggagePassengerOption = function (IbeLuggageCombination) {
        /**
         * Constructor
         *
         * @param {Object} passengerOption
         */
        var LuggagePassengerOption = function (passengerOption) {
            /**
             * Array of pax type
             *
             * @type {String[]}
             */
            this.applicablePassengerTypes = passengerOption.applicablePassengerTypes;

            /**
             * Array of combinations
             *
             * @type {IbeLuggageCombination[]}
             */
            this.combinations = [];

            angular.forEach(passengerOption.combinations, function (combination) {
                this.combinations.push(new IbeLuggageCombination(combination));
            }, this);
        };

        LuggagePassengerOption.prototype.isPaidLuggageAvailable = function () {
            var isPaidAvailable = false;

            angular.forEach(this.combinations, function (combination) {
                if (combination.isPaidLuggageAvailable()) {
                    isPaidAvailable = true;
                }
            });

            return isPaidAvailable;
        };

        LuggagePassengerOption.prototype.constructor = LuggagePassengerOption;

        return LuggagePassengerOption;
    };

    IbeLuggagePassengerOption.$inject = [
        'IbeLuggageCombination'
    ];

    angular
        .module('ibe-luggage')
        .factory('IbeLuggagePassengerOption', IbeLuggagePassengerOption);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/models/ibe-luggage-passenger-options.model.js
(function(angular, underscore) {
/**
     * Model storing passenger luggage options
     */
    var IbeLuggagePassengerOptionsModel = function (IbeLuggagePassengerOption) {
        /**
         * Constructor
         */
        var LuggagePassengerOptions = function () {
            /**
             * @type {string[]}
             */
            this.modifiers = [];

            /**
             * Passenger options
             *
             * @type {PassengerOption[]}
             */
            this.passengerOptions = [];
        };

        /**
         * Populates passenger options array with models
         *
         * @param {Object[]} passengerOptionsArray
         * @param {string[]} modifiers
         */
        LuggagePassengerOptions.prototype.populate = function (passengerOptionsArray, modifiers) {
            this.reset();

            this.modifiers = modifiers || [];

            angular.forEach(passengerOptionsArray, function (passengerOption) {
                this.passengerOptions.push(new IbeLuggagePassengerOption(passengerOption));
            }, this);
        };

        /**
         * Resets passenger options
         */
        LuggagePassengerOptions.prototype.reset = function () {
            this.modifiers = [];
            this.passengerOptions = [];
        };

        /**
         * Returns luggage option by pax type
         *
         * @param {String} paxType
         * @returns {IbeLuggagePassengerOption}
         */
        LuggagePassengerOptions.prototype.getOptionByPaxType = function (paxType) {
            return underscore.find(this.passengerOptions, function (passengerOption) {
                return passengerOption.applicablePassengerTypes.indexOf(paxType) !== -1;
            }, this);
        };

        LuggagePassengerOptions.prototype.isPaidLuggageAvailable = function () {
            var isPaidAvailable = false;

            angular.forEach(this.passengerOptions, function (passengerOption) {
                if (passengerOption.isPaidLuggageAvailable()) {
                    isPaidAvailable = true;
                }
            });

            return isPaidAvailable;
        };

        LuggagePassengerOptions.prototype.getModifiers = function () {
            return this.modifiers;
        };

        LuggagePassengerOptions.prototype.constructor = LuggagePassengerOptions;

        return LuggagePassengerOptions;
    };

    IbeLuggagePassengerOptionsModel.$inject = [
        'IbeLuggagePassengerOption'
    ];

    angular
        .module('ibe-luggage')
        .factory('IbeLuggagePassengerOptions', IbeLuggagePassengerOptionsModel);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/models/ibe-luggage-service-choose.model.js
(function(angular, underscore) {
/**
     * Model holding data related to a selectable luggage service
     */
    var IbeLuggageServiceChooseModel = function (IbeLuggageService) {
        /**
         * Constructor
         *
         * @param {Object} data
         */
        var IbeLuggageServiceChoose = function (data) {
            /**
             * Service price
             *
             * @type {Number}
             */
            this.price = data.price.amount;

            /**
             * Service array
             *
             * @type {IbeLuggageService[]}
             */
            this.services = [];

            /**
             * Token for this service choose
             *
             * @type {String}
             */
            this.token = data.token;

            populateServices(data.services, this);
        };

        /**
         * Populates services array with models
         *
         * @param {Object[]} serviceArray
         * @param {Object} context
         */
        var populateServices = function (serviceArray, context) {
            angular.forEach(serviceArray, function (service) {
                this.services.push(new IbeLuggageService(service));
            }, context);
        };

        /**
         * Checks if services are cabin services
         *
         * @returns {Boolean}
         */
        IbeLuggageServiceChoose.prototype.isCabin = function () {
            var allCabin = true;

            angular.forEach(this.services, function (service) {
                if (!service.isCabin()) {
                    allCabin = false;
                }
            });

            return allCabin;
        };

        /**
         * Checks if services are checked services
         *
         * @returns {Boolean}
         */
        IbeLuggageServiceChoose.prototype.isChecked = function () {
            var allChecked = true;

            angular.forEach(this.services, function (service) {
                if (service.isCabin()) {
                    allChecked = false;
                }
            });

            return allChecked;
        };

        /**
         * Checks if services are mixed of cabin and checked
         *
         * @returns {Boolean}
         */
        IbeLuggageServiceChoose.prototype.isMixed = function () {
            return !this.isCabin() && !this.isChecked();
        };

        /**
         * Checks if this service choose is no option
         *
         * @returns {Boolean}
         */
        IbeLuggageServiceChoose.prototype.isNoOption = function () {
            var firstService = underscore.first(this.services);

            if (!firstService) {
                return false;
            }

            return firstService.isNoOption();
        };

        IbeLuggageServiceChoose.prototype.constructor = IbeLuggageServiceChoose;

        return IbeLuggageServiceChoose;
    };

    IbeLuggageServiceChooseModel.$inject = [
        'IbeLuggageService'
    ];

    angular
        .module('ibe-luggage')
        .factory('IbeLuggageServiceChoose', IbeLuggageServiceChooseModel);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/ibe-luggage/models/ibe-luggage-service.model.js
(function(angular) {
/**
     * Model holding luggage service information
     */
    var IbeLuggageServiceModel = function (IBE_LUGGAGE_SERVICE_TYPES, IBE_LUGGAGE_SERVICE_VIEW_TYPES) {
        /**
         * Constructor
         *
         * @param {Object} data
         */
        var IbeLuggageService = function (data) {
            /**
             * Number of this type in the luggage package
             *
             * @type {Number}
             */
            this.count = data.count;

            /**
             * Width, height, length and weight
             *
             * @type {Object}
             */
            this.parameters = data.parameters;

            /**
             * Luggage type
             *
             * Ex: NO_OPTION, HAND_BAGGAGE, PRIORITY_BOARDING, HOLD_BAGGAGE
             */
            this.type = data.type;

            /**
             * Luggage view type
             *
             * Ex: NO_OPTION, PERSONAL_ITEM, CABIN_TROLLEY, PRIORITY_BOARDING, HOLD_BAGGAGE
             *
             */
            this.viewType = data.viewType;

            /**
             * Sort order for display
             *
             * @type {Number}
             */
            this.order = getSortingOrder(this);
        };

        /**
         * Checks if this service is no option
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isNoOption = function () {
            return this.type === IBE_LUGGAGE_SERVICE_TYPES.NO_OPTION;
        };

        /**
         * Checks if this service is a hand luggage service
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isCabin = function () {
            return (
                this.type === IBE_LUGGAGE_SERVICE_TYPES.HAND_BAGGAGE ||
                this.type === IBE_LUGGAGE_SERVICE_TYPES.PRIORITY_BOARDING
            );
        };

        /**
         * Checks if this service is a personal item
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isPersonalItem = function () {
            return (
                !this.isNoOption() &&
                this.isCabin() &&
                this.viewType === IBE_LUGGAGE_SERVICE_VIEW_TYPES.PERSONAL_ITEM
            );
        };

        /**
         * Checks id this service is a hand baggage
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isHandBaggage = function () {
            return this.isCabin() && !this.isPersonalItem() && !this.isPriority();
        };

        /**
         * Checks id this service is a checked baggage
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isCheckedBaggage = function () {
            return this.type === IBE_LUGGAGE_SERVICE_TYPES.HOLD_BAGGAGE;
        };

        /**
         * Checks id this service is priority boarding
         *
         * @returns {Boolean}
         */
        IbeLuggageService.prototype.isPriority = function () {
            return this.type === IBE_LUGGAGE_SERVICE_TYPES.PRIORITY_BOARDING;
        };

        IbeLuggageService.prototype.constructor = IbeLuggageService;

        /**
         * Returns sorting order for UI based on type
         */
        var getSortingOrder = function (context) {
            if (context.isHandBaggage()) {
                return 2;
            }

            if (context.isPriority()) {
                return 3;
            }

            return 1;
        };

        return IbeLuggageService;
    };

    IbeLuggageServiceModel.$inject = [
        'IBE_LUGGAGE_SERVICE_TYPES',
        'IBE_LUGGAGE_SERVICE_VIEW_TYPES'
    ];

    angular
        .module('ibe-luggage')
        .factory('IbeLuggageService', IbeLuggageServiceModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/models/BookingReq.js
angular.module('flightDetails')

/**
 * @name        BookingReq
 * @namespace   fdt
 * @description Class that holds all flight booking requirements
 */
.factory('fdt.BookingReq',
[
function BookingReqFactory() {
/**
   * Preferences constructor
   *
   * @class BookingReq
   * @constructor
   *
   * @param {Object} [bookingReq={}] The booking requirements we got from the back end
   */
  var BookingReq = function (bookingReq) {
    bookingReq = bookingReq || {};

    /**
     * Is passport data required
     *
     * @type {Boolean}
     */
    this.passportRequired = bookingReq.passportRequired || false;

    /**
     * Is id card required
     *
     * @type {Boolean}
     */
    this.idCardRequired = bookingReq.idCardRequired || false;

    /**
     * Is birthday required
     *
     * @type {Boolean}
     */
    this.birthdayRequired = bookingReq.birthdayRequired || false;
    /**
     * set default birth date
     *
     * @type {String}
     */
    this.defaultBirthDate = bookingReq.defaultBirthDate;

    /**
     * Is LTD flight?
     *
     * @type {Boolean}
     */
    this.LTD = bookingReq.ltd || false;

    /**
     * Is LTD flight?
     *
     * @type {Boolean}
     */
    this.blockPage = bookingReq.blockPage || false;
  };

  // Add instance methods
  BookingReq.prototype = /** @lends BookingReq.prototype */ {

    /**
     * Returns if passport is required or not
     *
     * @return {Boolean}
     */
    isPassportRequired: function () {
      return this.passportRequired;
    },

    /**
     * Checks if id card is required
     *
     * @returns {Boolean}
     */
    isIdCardRequired: function () {
      return this.idCardRequired;
    },

    /**
     * Returns if birthday is required or not
     *
     * @return {Boolean}
     */
    isBirthdayRequired: function () {
      return this.birthdayRequired;
    },

    /**
     * Returns if flight is LTD
     *
     * @return {Boolean}
     */
    isLTD: function () {
      return this.LTD;
    },

    isBlockPage: function () {
      return this.blockPage;
    }
  };

  BookingReq.prototype.constructor = BookingReq;

  return BookingReq;
}]);

;

// Source: ../shared/public_html/assets/js/flightDetails/models/DocumentRequirement.js
(function(angular) {
var IthDocumentRequirementModel = function () {
        /**
         * @constructor
         */
        var DocumentRequirement = function () {
            /**
             * Passport required to fly
             *
             * @type {Boolean}
             */
            this.passportRequired = false;

            /**
             * Any document required to fly
             *
             * @type {Boolean}
             */
            this.anyDocumentRequired = false;
        };

        /**
         * Returns passport requirement
         *
         * @returns {Boolean}
         */
        DocumentRequirement.prototype.getPassportRequired = function () {
            return this.passportRequired;
        };

        /**
         * Sets passport requirement
         *
         * @param {Boolean} value
         */
        DocumentRequirement.prototype.setPassportRequired = function (value) {
            this.passportRequired = value;
        };

        /**
         * Returns any document requirement
         *
         * @returns {Boolean}
         */
        DocumentRequirement.prototype.getAnyDocumentRequired = function () {
            return this.anyDocumentRequired;
        };

        /**
         * Sets any document requirement
         *
         * @param {Boolean} value
         */
        DocumentRequirement.prototype.setAnyDocumentRequired = function (value) {
            this.anyDocumentRequired = value;
        };

        DocumentRequirement.prototype.constructor = DocumentRequirement;

        return DocumentRequirement;
    };

    angular
        .module('flightDetails')
        .factory('DocumentRequirement', IthDocumentRequirementModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/models/FlightDetails.js
(function(angular) {
/**
     * @name        FlightDetails
     * @namespace   fdt
     * @description
     */
    function FlightDetailsFactory(Leg, Base64, Dictionaries, Tools, $q, BookingReq, Verification, Discount, InsuranceOptions,
        MandatoryFee, PaymentOptions, ErrorMixin, Pricings, PaymentInfo, UnitOpts,
        VerificationHandler) {
        /**
         * FlightDetails
         *
         * @constructor
         * @class FlightDetails
         */
        var FlightDetails = function() {
            /**
             * The request ID.
             *
             * @type {String}
             */
            this.requestId = '';

            /**
             * The price group ID.
             *
             * @type {String}
             */
            this.priceGroupId = '';

            /**
             * The outbound leg ID.
             *
             * @type {String}
             */
            this.depLegId = '';

            /**
             * fee
             *
             * @type {Number}
             */
            this.tFee = 0.0;

            /**
             * The inbound leg ID.
             *
             * @type {String}
             */
            this.retLegId = '';

            /**
             * The array of legs.
             *
             * The index:
             *
             *  - 0 is the departure leg
             *  - 1 id the return leg
             *
             * The array might have only 0 index for one ways.
             *
             * @type {Leg[]}
             */
            this.legs = [];

            /**
             * The paxes pricing information.
             *
             * @type {Pricings}
             */
            this.paxesPricing = new Pricings();

            /**
             * The flight type: REGULAR, LOWCOST, MIXED, HUB
             *
             * @type {String}
             */
            this.flightType = 'UNKNOWN';

            /**
             * Booking requirements library.
             *
             * @type {BookingReq}
             */
            this.bookingReq = new BookingReq();

            /**
             * Verification
             *
             * @type {Verification}
             */
            this.verification = new Verification();

            /**
             * Verification handler
             *
             * @type {VerificationHandler}
             */
            this.verificationHandler = new VerificationHandler(this);

            /**
             * Initial test sell data.
             *
             * @todo: this should be its own class
             *
             * @type {Object}
             */
            this.testSell = null;

            /**
             * Luggage information.
             *
             * @todo: this should be its own class
             *
             * @type {Object}
             */
            this.og = null;

            /**
             * Payment information (we store exchange rate here).
             *
             * @type {PaymentInfo}
             */
            this.paymentInfo = null;

            /**
             * Insurance options for this flight.
             *
             * @type {InsuranceOptions}
             */
            this.insuranceOptions = new InsuranceOptions();

            /**
             * Mandatory fees.
             *
             * @type {MandatoryFee[]}
             */
            this.mandatoryFees = [];

            /**
             * Payment options.
             *
             * @type {PaymentOptions}
             */
            this.paymentOptions = new PaymentOptions();

            /**
             * Discount.
             *
             * @type {Discount}
             */
            this.discount = new Discount();

            /**
             * Is call center open?
             *
             * @type {Boolean}
             */
            this.callCenterOpen = false;

            /**
             * Region of flight.
             * Possible values: E (European Union), W (World), D (Domestic).
             *
             * @type {String}
             */
            this.region = '';

            /**
             * Creation date of flight details request.
             *
             * @type {Number}
             */
            this.requestCreateDate = 0;

            /**
             * Request age in seconds (time() - requestCreateDate).
             *
             * @type {Number}
             */
            this.requestAge = 0;

            /**
             * Errors object.
             *
             * Used in templates to mark error fields and show error messages.
             * The keys are filed names and values are error messages or instances.
             *
             * Example: { property_name: "error message", property_with_some_instance: that instance }.
             *
             * @type {Object}
             */
            this.errors = {};

            /**
             * Selling units col.
             *
             * @type {Array}
             */
            this.unitOpts = [];

            /**
             * Search url.
             *
             * @type {String}
             */
            this.searchUrl = '';

            /**
             * Cash Back Campaign.
             *
             * @type {Object}
             */
            this.cashBack = {};

            /**
             * Package token (booking number) for agent.
             *
             * @type {String}
             */
            this.packageToken = '';

            /**
             * @type {Object}
             */
            this._debug = null;

            /**
             *
             *
             */
            this.defaultPayment = false;

            /**
             * Basket ID that was generated on flight details page
             * We use it in Emarsys Marketing integration
             *
             * @type {string}
             */
            this.basketId = null;

            /**
             * ID from shelf management flights
             *
             * @type {String}
             */
            this.travelHash = null;

            /**
             * Token from shelf management flights
             *
             * @type {String}
             */
            this.fulfillmentToken = null;

            /**
             * Encrypted provider ID
             *
             * @type {String}
             */
            this.providerId = null;


            this.fareLockUuid = null;
            this.searchResultId = null;

            /**
             * Raw Refund data from API response
             *
             * @type {Object}
             */
            this.refund = null;

            /**
             * Raw Fast Refund data from API response
             *
             * @type {Object}
             */
            this.fastRefund = null;

            /**
             * Flag indicating short hub layover warning.
             * (Too short layover time to allow check-in luggage)
             *
             * @type {Boolean}
             */
            this.hubLayoverWarning = false;

            /**
             * Flight additional services
             *
             * @type {Object}
             */
            this.additionalServices = {};

            /**
             *
             */
            this.fareLock = null;

            /**
             * AB Tests
             *
             * @type {Object}
             */
            this.abTests = {};

            this.oldLuggage = null;

            this.expires = null;
        };

        FlightDetails.prototype = /** @lends FlightDetails.prototype */ {

            /**
             * Reset to default states.
             *
             * @return {FlightDetails}
             */
            reset: function () {
                this.requestId = '';
                this.priceGroupId = '';
                this.depLegId = '';
                this.retLegId = '';
                this.legs = [];
                this.paxesPricing = new Pricings();
                this.flightType = 'UNKNOWN';
                this.bookingReq = new BookingReq();
                this.verification = new Verification();
                this.testSell = null;
                this.searchResultId = null;
                this.og = null;
                this.paymentInfo = null;
                this.insuranceOptions = new InsuranceOptions();
                this.mandatoryFees = [];
                this.paymentOptions = new PaymentOptions();
                this.discount = new Discount();
                this.callCenterOpen = false;
                this.region = '';
                this.requestCreateDate = 0;
                this.requestAge = 0;
                this.unitOpts = [];
                this.searchUrl = '';
                this.cashBack = {};
                this.packageToken = '';
                this.basketId = '';
                this.refund = null;
                this.fastRefund = null;
                this.hubLayoverWarning = false;
                this.additionalServices = {};
                this.fareLock = null;
                this.abTests = {};
                this._debug = null;

                return this;
            },

            /**
             * Returns request id.
             *
             * @return {String}
             */
            getRequestId: function() {
                return this.requestId;
            },

            /**
             * Get selling units.
             *
             * @return {Array}
             */
            getUnitOpts: function() {
                return this.unitOpts;
            },

            /**
             * Get selling units.
             *
             * @return {Array}
             */
            setUnitOpts: function(unitOpts) {
                this.unitOpts = unitOpts || [];
            },

            /**
             * Get search url.
             *
             * @return {String}
             */
            getSearchUrl: function() {
                return this.searchUrl;
            },

            /**
             * Returns price group id.
             *
             * @return {String}
             */
            getPriceGroupId: function() {
                return this.priceGroupId;
            },

            /**
             * Returns booking requirements.
             *
             * @return {BookingReq}
             */
            getBookingReq: function() {
                return this.bookingReq;
            },

            /**
             * Returns booking verification
             *
             * @returns {Verification}
             */
            getVerification: function () {
                return this.verification;
            },

            /**
             * Returns departure leg id.
             *
             * @return {String}
             */
            getDepLegId: function() {
                return this.depLegId;
            },

            /**
             * Returns return leg id.
             *
             * @return {String|null}
             */
            getRetLegId: function() {
                return this.retLegId;
            },

            /**
             * Returns legs.
             *
             * @return {Leg[]}
             */
            getLegs: function() {
                return this.legs;
            },

            /**
             * @return {String|null}
             */
            getSearchResultId: function() {
                return this.searchResultId;
            },

            /**
             * Get Cash Back.
             *
             * @returns {{}|*}
             */
            getCashBack: function() {
                var cashbackParams = {value: '', currency: ''};
                if(this.cashBack) {

                    if(this.cashBack.percent_discount) {
                        cashbackParams.value = this.cashBack.percent_discount + '%';
                    }
                    else {
                        if(this.cashBack.flat_discount) {
                            cashbackParams.value = this.cashBack.flat_discount * this.getPaxCountTf();

                            if(this.cashBack.currency) {
                                cashbackParams.currency = this.cashBack.currency;
                            }
                        }
                    }
                }
                return cashbackParams;
            },

            /**
             * Get pax count that have tf.
             *
             * @returns {number}
             */
            getPaxCountTf: function() {
                var sum = 0;
                var pricings = this.paxesPricing.pricings;
                var i = 0;
                var total = pricings.length;
                for(i; i < total; i++) {
                    if(pricings[i].totalTf > 0) {
                        sum = parseInt(pricings[i].count) + sum;
                    }
                }
                return sum;
            },

            /**
             * Get departure leg.
             *
             * @return {Leg}
             */
            getDepLeg: function() {
                return this.legs[0];
            },

            /**
             * Get return leg.
             *
             * @return {Leg|null}
             */
            getRetLeg: function() {
                return this.legs[1] || null;
            },

            /**
             * Get segment by flight number
             *
             * @param {String} flightNumber
             */
            getSegmentByFlightNumber: function (flightNumber) {
                var foundSegment = null;

                this.legs.forEach(function (leg) {
                    leg.getSegments().forEach(function (segment) {
                        if (segment.getFlightNumber() === flightNumber + '') {
                            foundSegment = segment;
                        }
                    });
                });

                return foundSegment;
            },

            /**
             * Returns total segment count
             *
             * @returns {Number}
             */
            getSegmentCount: function () {
                var retSegmentCount = this.getRetLeg() === null ? 0 : this.getRetLeg().getSegments().length;
                return this.getDepLeg().getSegments().length + retSegmentCount;
            },

            /**
             * Get paxes pricing information.
             *
             * @return {Pricings}
             */
            getPaxesPricing: function() {
                return this.paxesPricing;
            },

            setPaxesPricing: function (paxesArray) {
                this.paxesPricing = new Pricings(paxesArray);
            },

            /**
             * Returns discount.
             *
             * @return {Discount}
             */
            getDiscount: function() {
                return this.discount;
            },

            /**
             * Returns payment options.
             *
             * @return {PaymentOptions}
             */
            getPaymentOptions: function() {
                return this.paymentOptions;
            },
            /**
             * Returns payment options.
             *
             * @return {PaymentOptions}
             */
            getDefaultPayment: function() {
                return this.defaultPayment;
            },
            /**
             * Returns payment.
             *
             * @return {PaymentInfo}
             */
            getPaymentInfo: function() {
                return this.paymentInfo;
            },

            /**
             * Get test sell associated with flight details.
             *
             * @return {Object}
             */
            getTestSell: function() {
                return this.testSell;
            },

            /**
             * Returns insurance options.
             *
             * @return {InsuranceOptions}
             */
            getInsuranceOptions: function() {
                return this.insuranceOptions;
            },

            /**
             * Checks if current flight has insurance options.
             *
             * @return {Boolean}
             */
            hasInsuranceOptions: function() {
                return (this.getInsuranceOptions().getOptionsCount() > 0);
            },

            /**
             * Returns flight type.
             *
             * @return {String} One of the: LOWCOST, MIXED, REGULAR.
             */
            getFlightType: function() {
                return this.flightType;
            },

            /**
             * Returns package token.
             *
             * @return {String}
             */
            getPackageToken: function() {
                return this.packageToken;
            },

            /**
             * Returns debug data.
             *
             * @return {Object}
             */
            getDebug: function() {
                return this._debug;
            },

            /**
             * Returns true if regular flight.
             *
             * @return {Boolean}
             */
            isRegularFlight: function() {
                return Tools.isRegularFlight(this.getFlightType());
            },

            /**
             * Returns true if hub.
             *
             * @return {Boolean}
             */
            isHubFlight: function() {
                return Tools.isHubFlight(this.getFlightType());
            },

            /**
             * Returns true if sum of one ways.
             *
             * @return {Boolean}
             */
            isSoowFlight: function() {
                return Tools.isSoowFlight(this.getFlightType());
            },

            /**
             * Returns true if low cost flight.
             *
             * @return {Boolean}
             */
            isLowCost: function() {
                return Tools.isLowCost(this.getFlightType());
            },

            /**
             * Returns true if charter flight.
             *
             * @returns {Boolean}
             */
            isCharter: function() {
                return Tools.isCharter(this.getFlightType());
            },

            /**
             * Checks if the current flight is domestic (departure country and arrival country are the same).
             *
             * @param  {String}  countryCode The country code in which we test departure and arrival.
             * @return {Boolean}
             */
            isDomestic: function(countryCode) {
                var
                    depCountryCode = Dictionaries.getCountryCodeByCityCode(this.getDepLeg().getDepCityCode()),
                    arrCountryCode = Dictionaries.getCountryCodeByCityCode(this.getDepLeg().getArrCityCode());

                return (depCountryCode == countryCode && arrCountryCode == countryCode);
            },

            /**
             * Returns the trip length in case of round-trip flights or 0 for one-way.
             *
             * @return {Number} The trip length.
             */
            getTripLength: function() {
                if(!this.isRoundTrip()) {
                    // There is no trip length for one-way flights
                    return 0;
                }

                var
                    // Difference between moments
                    diff = this.getRetLeg().getArrTimeMoment().diff(this.getDepLeg().getDepTimeMoment()),

                    // Moment duration
                    dur = moment.duration(diff);

                // Return number of days
                return dur.asDays();
            },

            /**
             * Returns the trip length in case of round-trip flights or 0 for one-way.
             *
             * @return {Number} The trip length.
             */
            getDayDiff: function() {
                if(!this.isRoundTrip()) {
                    // There is no trip length for one-way flights
                    return 0;
                }

                var
                    // Difference between moments
                    diff = moment(this.getRetLeg().getArrDate()).diff(moment(this.getDepLeg().getDepDate())),
                    // Moment duration
                    dur = moment.duration(diff);

                return Math.round(dur.asDays() + 1);
            },

            /**
             * Get formatted city name.
             *
             * @param  {String}  code
             * @param  {Boolean} withCountry
             * @return {String}
             */
            getCityName: function(code, withCountry) {
                return Dictionaries.getCityNameByCode(code, withCountry);
            },

            /**
             * Get formatted airport name.
             *
             * @param  {String}  code
             * @param  {Boolean} withCountry
             * @return {String}
             */
            getAirportName: function(code, withCountry) {
                return Dictionaries.getAirportNameByCode(code, withCountry);
            },

            /**
             * Get formatted carrier name.
             *
             * @return {String}
             */
            getCarrierName: function(code) {
                return Dictionaries.getCarrierNameByCode(code);
            },

            /**
             * Returns true if flight is round trip.
             *
             * @return {Boolean}
             */
            isRoundTrip: function() {
                return this.getRetLeg() !== null;
            },

            /**
             * Returns when flight is from or to USA.
             *
             * @return {Boolean}
             */
            isUSA: function() {
                return _.reduce(this.getLegs(), function(memo, leg) {
                    var countryCode = Dictionaries.getCountryCodeByAirportCode(leg.getDepCityCode());
                    return memo || (countryCode == 'US' || countryCode == 'CA');
                }, false, this);
            },

            /**
             * Returns payment method fees.
             *
             * @return {Object}
             */
            getPaymentFees: function() {
                return this.paymentInfo.paymentFees;
            },

            /**
             * Returns all mandatory fees.
             *
             * @return {MandatoryFee[]}
             */
            getMandatoryFees: function() {
                return this.mandatoryFees;
            },

            /**
             * Returns the total of mandatory fees.
             *
             * @return {Number}
             */
            getTotalMandatoryFees: function() {
                return _.reduce(this.mandatoryFees, function(memo, fee) {
                    return memo + fee.getPrice();
                }, 0);
            },

            /**
             * Unique hash for flight details.
             *
             * @return {String}
             */
            hash: function() {
                var hash = this.getRequestId() + this.getPriceGroupId() + this.getDepLeg().getId(),
                    retLeg = this.getRetLeg();

                if(retLeg) {
                    hash += retLeg.getId();
                }

                return hash;
            },

            /**
             * Returns flight details hash based on URL parameters.
             *
             * @param  {Object} routeParams
             * @return {String}
             */
            hashFromRouteParams: function(routeParams) {
                if(routeParams.hash) {
                    // confirmation page
                    return routeParams.hash;
                }
                var hash = routeParams.requestId + Base64.decode(routeParams.priceGroupId) + Base64.decode(routeParams.depLegId);

                if(routeParams.retLegId && routeParams.retLegId != '0') {
                    hash += Base64.decode(routeParams.retLegId);
                }

                return hash;
            },

            /**
             * Returns comparison of hash for flight details and flight details hash based on URL parameters.
             *
             * @param  {Object} routeParams
             * @return {Boolean}
             */
            hashesEquality: function(routeParams) {
                return this.hash() == this.hashFromRouteParams(routeParams);
            },
            /**
             * Get desktop equivalent URL for flight details.
             *
             * @return {String}
             */
            getDeskURL: function() {
                return Base64.encode(this.priceGroupId) + '/' + this.requestId + '/0/' + Base64.encode(this.depLegId) + '/' + Base64.encode(this.retLegId);
            },

            /**
             * Get all request ids encoded.
             *
             * @return {Object}
             */
            getEncodedParams: function() {
                return {
                    priceGroupId: Base64.encode(this.priceGroupId),
                    requestId: this.requestId,
                    depLegId: Base64.encode(this.depLegId),
                    retLegId: Base64.encode(this.retLegId)
                };
            },

            /**
             * Set mandatory fees from og object.
             *
             * If mandatory fees already exist they will be removed.
             *
             * @param {Array} mandatoryFees
             *
             * @return {FlightDetails}
             */
            setMandatoryFees: function(mandatoryFees) {
                this.mandatoryFees = [];

                _.each(mandatoryFees, function(fee) {
                    this.mandatoryFees.push(new MandatoryFee(fee));
                }, this);

                return this;
            },

            /**
             * Returns true if call center is open.
             *
             * @return {Boolean}
             */
            isCallCenterOpen: function() {
                return this.callCenterOpen;
            },

            /**
             * Returns option groups for this flight.
             *
             * @return {Object}
             */
            getOptionGroups: function() {
                return this.og;
            },

            /**
             * Returns the flight region.
             *
             * @return {String}
             */
            getRegion: function() {
                return this.region;
            },

            /**
             * Get request creation date.
             *
             * @return {Number}
             */
            getRequestCreateDate: function() {
                return +this.requestCreateDate;
            },

            /**
             * Get request age.
             *
             * @return {Number}
             */
            getRequestAge: function() {
                return +this.requestAge;
            },

            /**
             * Get fulfillment token
             *
             * @return {String}
             */
            getFulfillmentToken: function() {
                return this.fulfillmentToken;
            },

            /**
             * Get basket Id
             *
             * @return {string}
             */
            getBasketId: function() {
                return this.basketId;
            },

            /**
             * Get serviceFee
             *
             * @return {Number}
             */
            getTFee: function() {
                return this.tFee;
            },

            isOneWay: function() {
                return typeof this.getLegs()[1] === 'undefined';
            },

            getDepDate: function() {
                return this.getDepLeg().getDepDate();
            },

            getRetDate: function() {
                return this.isOneWay() ? null : this.getRetLeg().getDepDate();
            },

            getCarriers: function() {
                var depCarriers = this.getDepLeg().carriers;
                var retCarriers = this.isOneWay() ? [] : this.getRetLeg().carriers;

                return depCarriers.concat(retCarriers).join('-').toLowerCase();
            },

            getOriginPort: function() {
                return this.getDepLeg().segments[0].getDepAirportCode();
            },

            getReturnPort: function() {
                return this.isOneWay() ? '' : this.getRetLeg().segments[0].getDepAirportCode();
            },

            getPaxCount: function() {
                var count = 0;
                this.paxesPricing.pricings.map(function (element) {
                    count += element.count;
                });
                return count;
            },

            /**
             * Set data from server.
             *
             * @param {apiFlightDetails} apiFlightDetails The response from server.
             * @return {FlightDetails}
             */
            srvSet: function(apiFlightDetails) {
                // Reset to default state
                this.reset();

                // Set dictionaries
                Dictionaries.addDictionary(apiFlightDetails.dictionary, apiFlightDetails.languageCode);

                // Set IDs
                this.requestId = apiFlightDetails.requestId;
                this.priceGroupId = apiFlightDetails.priceGroupId;
                this.flightType = apiFlightDetails.flight_type;

                // Set legs
                this.legs.push(new Leg(apiFlightDetails.depLeg));
                this.depLegId = this.getDepLeg().getId();
                this.getDepLeg().setFlightType(this.flightType);

                if(apiFlightDetails.retLeg) {
                    this.legs.push(new Leg(apiFlightDetails.retLeg, Leg.LEG_TYPE_RET));
                    this.retLegId = this.getRetLeg().getId();
                    this.getRetLeg().setFlightType(this.flightType);
                }

                // Set paxes pricing
                this.setPaxesPricing(apiFlightDetails.pricing.paxes);
                this.tFee = apiFlightDetails.pricing.tFee;

                // Set option groups
                this.og = apiFlightDetails.og;

                // Set pricing mandatory fees

                this.setMandatoryFees(this.og.mandatoryFeeOptions);

                // Set payment options
                this.paymentOptions.srvSet(apiFlightDetails.po);

                // Add default discount(s)
                this.discount.addDiscounts(apiFlightDetails.price.discounts);

                // TODO: for reservation there is only one insurance which must replace all others
                // TODO: for flight details request there might be many insurance options

                // Set insurance option only if they are not set and present in apiFlightDetails
                if(!_.isEmpty(apiFlightDetails.insurance) && this.insuranceOptions.getOptions().length == 0) {
                    // Set insurance options
                    this.insuranceOptions.srvSet(apiFlightDetails.insurance);
                }

                this.bookingReq = new BookingReq(apiFlightDetails.bookingReq);
                this.verification = new Verification(apiFlightDetails.verification);

                // TODO: use classes not anonymous objects
                this.testSell = apiFlightDetails.testSell;
                this.paymentInfo = new PaymentInfo(apiFlightDetails.paymentInfo);
                this.defaultPayment = apiFlightDetails.po.defaultPayment;
                this.callCenterOpen = apiFlightDetails.callCenter.isOpen;

                this.region = apiFlightDetails.region || '';

                this.requestCreateDate = apiFlightDetails.createDate;
                this.requestAge = apiFlightDetails.requestAge;
                this.searchUrl = apiFlightDetails.searchUrl;

                var self = this;
                apiFlightDetails.unitOpts.forEach(function(unitOption) {
                    self.unitOpts.push(new UnitOpts(unitOption));
                });

                this.region = apiFlightDetails.region || '';
                this.cashBack = apiFlightDetails.cashBack || {};
                this.packageToken = apiFlightDetails.packageToken || '';
                this._debug = apiFlightDetails._debug || null;

                this.basketId = apiFlightDetails.basketId;

                this.travelHash = apiFlightDetails.identifier ? apiFlightDetails.identifier.travelHash : null;
                this.fulfillmentToken = apiFlightDetails.identifier ? apiFlightDetails.identifier.fulfillmentToken : null;
                this.providerId = apiFlightDetails.identifier ? (apiFlightDetails.identifier.providerId ? apiFlightDetails.identifier.providerId : null) : null;
                this.branch = apiFlightDetails.identifier ? (apiFlightDetails.identifier.branch ? apiFlightDetails.identifier.branch : null) : null;
                this.fareLockUuid = apiFlightDetails.identifier ? (apiFlightDetails.identifier.fareLockUuid ? apiFlightDetails.identifier.fareLockUuid : null) : null;
                this.searchResultId = apiFlightDetails.identifier ? (apiFlightDetails.identifier.searchResultId ? apiFlightDetails.identifier.searchResultId : null) : null;

                this.refund = apiFlightDetails.refund;
                this.fastRefund = apiFlightDetails.fastRefund;

                this.hubLayoverWarning = apiFlightDetails.warningFlagHubDurationLayover;

                this.paymentCredentials = apiFlightDetails.po.credentials;

                this.additionalServices = apiFlightDetails.additionalServices;

                this.abTests = apiFlightDetails.abTests;
                this.oldLuggage = apiFlightDetails.simplifiedLuggage;

                this.fareLock = apiFlightDetails.fareLock || null;
                this.initialTotalValue = apiFlightDetails.initialTotalValue || null;

                this.reservation = apiFlightDetails.reservation || {};

                this.expires = apiFlightDetails.expires || null;

                return this;
            },

            /**
             * Returns true if object is in error state.
             *
             * @return {bool}
             */
            hasErrors: function() {
                return _.reduce(this.errors, function(memo, err) {
                    if(_.isObject(err)) {
                        return memo || err.hasErrors();
                    }
                    else {
                        return memo || !!err;
                    }
                }, false);
            },

            /**
             * Set errors form server.
             *
             * @param errors
             * @return {FlightDetails}
             */
            srvErrors: function(errors) {
                // Reset errors
                this.resetErrors();

                // If errors is not an object we bail out
                if(!_.isObject(errors)) {
                    errors = {};
                }
                // TODO

                return this;
            }
        };

        FlightDetails.prototype.constructor = FlightDetails;

        // Add mixins
        _.extend(FlightDetails.prototype, ErrorMixin);

        return new FlightDetails();
    }

    FlightDetailsFactory.$inject = [
        'flt.Leg',
        'Base64',
        'Dictionaries',
        'Tools',
        '$q',
        'fdt.BookingReq',
        'Verification',
        'dsc.Discount',
        'ins.InsuranceOptions',
        'fdt.MandatoryFee',
        'fdt.PaymentOptions',
        'ErrorMixin',
        'fdt.Pricings',
        'bok.PaymentInfo',
        'fdt.UnitOpts',
        'VerificationHandler'
    ];

    angular
        .module('flightDetails')
        .factory('fdt.FlightDetails', FlightDetailsFactory);

})(angular);
;

// Source: ../shared/public_html/assets/js/flightDetails/models/MandatoryFee.js
angular.module('flightDetails')

/**
 * @name        MandatoryFee
 * @namespace   fdt
 * @description Class that describes a mandatory fee
 */
.factory('fdt.MandatoryFee',
[
function MandatoryFeeFactory() {
/**
   * MandatoryFee constructor
   *
   * @constructor
   * @class MandatoryFee
   */
  var MandatoryFee = function (fee) {
    /**
     * Mandatory fee currency
     *
     * @type {String}
     */
    this.currency = fee.currency;

    /**
     * Fee title
     *
     * @type {String}
     */
    this.title = fee.descr;

    /**
     * Fee price
     *
     * @type {Number}
     */
    this.price = fee.price;

    /**
     * Fee type
     *
     * @type {String}
     */
    this.type = fee.type;
  };

  // Add instance methods
  MandatoryFee.prototype = /** @lends MandatoryFee.prototype */ {
    /**
     * Returns the fee title
     *
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Get fee price
     *
     * @return {Number}
     */
    getPrice: function () {
      return this.price;
    }
  };

  MandatoryFee.prototype.constructor = MandatoryFee;

  return MandatoryFee;
}]);

;

// Source: ../shared/public_html/assets/js/flightDetails/models/PaymentOption.js
/* global moment: false */

angular.module('flightDetails')

/**
 * @name        PaymentOption
 * @namespace   fdt
 * @description Class that holds payment option information
 */
.factory('fdt.PaymentOption',
[
function PaymentOptionFactory() {
/**
   * PaymentOption constructor
   *
   * @constructor
   * @class PaymentOption
   */
  var PaymentOption = function (option) {
    /**
     * Option description
     *
     * @type {String}
     */
    this.desc = option.desc || '';

    /**
     * Option details (payment type)
     *
     * @type {String}
     */
    this.details = option.details || '';

    /**
     * Last payment date
     *
     * @type {String} The date in YYYY-MM-DD HH:MM format
     */
    this.lastPaymentDate = option.last_payment_date || '';

    /**
     * Option price
     *
     * @type {Number}
     */
    this.price = option.price || 0;

    /**
     * Option type ex: CA, CC, BT, ...
     *
     * @type {String}
     */
    this.type = option.type || '';
  };

  // Add instance methods
  PaymentOption.prototype = /** @lends PaymentOption.prototype */ {

    /**
     * Returns true if payment option is valid
     *
     * @return {Boolean}
     */
    isValid: function () {
      return this.lastPaymentDate != '' && this.type != '';
    },

    /**
     * Returns option price
     *
     * @return {Number}
     */
    getPrice: function () {
      return this.price;
    },

    /**
     * Returns last payment date
     *
     * @param {bool} [asMoment=false]
     * @return {Moment}
     */
    getLastPaymentDate: function (asMoment) {
      return asMoment ? moment(this.lastPaymentDate) : this.lastPaymentDate;
    }
  };

  PaymentOption.prototype.constructor = PaymentOption;

  return PaymentOption;
}]);
;

// Source: ../shared/public_html/assets/js/flightDetails/models/PaymentOptions.js
/*global _: false */

angular.module('flightDetails')

/**
 * @name        PaymentOptions
 * @namespace   fdt
 * @description A collection of PaymentOption classes
 */
.factory('fdt.PaymentOptions',
['fdt.PaymentOption',
function PaymentOptionsFactory(PaymentOption) {
/**
   * PaymentOptions constructor
   *
   * @constructor
   * @class PaymentOptions
   */
  var PaymentOptions = function () {
    /**
     * Payment option array
     *
     * @type {PaymentOption[]}
     */
    this.options = [];

    /**
     * Available payment types
     * Ex: CA, CC, BT
     *
     * @type {Array}
     */
    this.available = [];

    /**
     * Force bank transfer
     *
     * @type {Boolean}
     */
    this.forceBT = false;

    /**
     * Available PBL Vendors
     *
     * @type {Array}
     */
    this.vendorData = [];

    /**
     * @type {Object[]}
     */
    this.credentials = [];
  };

  // Add instance methods
  PaymentOptions.prototype = /** @lends PaymentOptions.prototype */ {
    /**
     * Set the payment options
     *
     * @param {Object[]} options
     */
    setOptions: function (options) {
      _.each(options, function (option) {
        this.addOption(option);
      }, this);

      return this;
    },

    addOption: function(option) {
      var po = new PaymentOption(option);
      if (po.isValid()) {
        this.options.push(po);
      }
    },

    /**
     * Returns all the payment options
     *
     * @return {PaymentOption[]}
     */
    getOptions: function () {
      return this.options;
    },

    /**
     * Returns an Object containing PBL vendors
     *
     * @return {Object}
     */
    getVendorData: function () {
      return this.vendorData;
    },

    /**
     * Get the cheapest option
     *
     * @return {Number}
     */
    getCheapest: function () {
      if (this.options.length == 0) {
        // No options available
        return 0;
      }

      // Find the cheapest option
      var cheapest = _.min(this.options, function (option) {
        return option.getPrice();
      });

      return cheapest.getPrice();
    },

    /**
     * Get the expensive option
     *
     * @return {Number}
     */
    getExpensive: function () {
      if (this.options.length == 0) {
        // No options available
        return 0;
      }

      // Find the cheapest option
      var expensive = _.max(this.options, function (option) {
        return option.getPrice();
      });

      return expensive.getPrice();
    },

    /**
     * Returns available payment types
     *
     * @return {Array}
     */
    getAvailable: function () {
      return this.available;
    },

    /**
     *
     * @returns {Object[]}
     */
    getCredentials: function () {
      return this.credentials;
    },

    /**
     * Checks if a payment type is available
     *
     * @param  {String} paymentId Ex: CC, CC4, BT, CA
     *
     * @return {Boolean}
     */
    isAvailable: function (paymentId) {
      return _.find(this.available, function (available) {
        return available == paymentId;
      }, this);
    },

    /**
     * Remove option from available options array
     *
     * @param paymentType {String}
     * @returns {PaymentOptions}
     */
    removeOptionFromAvailable: function (paymentType) {
      this.available = _.without(this.available, paymentType);
      return this;
    },

    /**
     * Force bank transfer if this returns true
     *
     * @returns {bool}
     */
    isForceBT: function () {
      return this.forceBT;
    },

    /**
     * Validate PBL Vendor data
     *
     * @returns {Array}
     */
    validateVendorData: function(data) {
      return _.filter(data || [], function(currencyVendors) {
        currencyVendors.vendors = _.filter(currencyVendors.vendors || [], function(vendor) {
          return vendor.isAvailable === true;
        });
        return currencyVendors.vendors.length > 0;
      });
    },

    /**
     * Set Payment option from API object
     *
     * @param {Object[]} srvData
     *
     * @return {PaymentOptions}
     */
    srvSet: function (srvData) {
      this.setOptions(srvData.options);
      this.available = srvData.availableOptions;
      this.forceBT = srvData.forceBT;
      this.defaultPayment = srvData.defaultPayment;
      this.credentials = srvData.credentials;
      this.vendorData = this.validateVendorData((srvData.additionalData && srvData.additionalData.pbl) || []);
      return this;
    }
  };

  PaymentOptions.prototype.constructor = PaymentOptions;

  return PaymentOptions;
}]);

;

// Source: ../shared/public_html/assets/js/flightDetails/models/Pricing.js
angular.module('flightDetails')

/**
 * @name        Pricing
 * @namespace   fdt
 * @description Class that describes a pricing
 */
.factory('fdt.Pricing',
['appConfig', 'bok.Pax',
function PricingFactory(appConfig, Pax) {
/**
   * Pricing
   *
   * @param {Object} priceObj The pricing object
   * @constructor
   * @class Pricing
   */
  var Pricing = function (priceObj) {
    priceObj = priceObj || {};

    /**
     * The pax type this pricing is for
     *
     * @type {String}
     */
    this.paxType = priceObj.type || Pax.UNKNOWN;

    /**
     * The pax count
     *
     * @type {int}
     */
    this.count = priceObj.count || 0;

    /**
     * Total netto price
     *
     * @type {Number}
     */
    this.totalNettoPrice = priceObj.totalNettoPrice || 0;

    /**
     * Total service (transaction) fee
     *
     * @type {Number}
     */
    this.totalTf = priceObj.totalTf || 0;

    /**
     * Total mandatory fees
     *
     * @type {Number}
     */
    this.totalMf = priceObj.totalMf || 0;

    /**
     * Total service (transaction) fee
     *
     * @type {number}
     */
    this.dynamicTf = priceObj.dynamicTf || 0;

    /**
     * The currency code ex: EUR, PLN, RON, ...
     *
     * @type {String}
     */
    this.currencyCode = priceObj.currencyCode || appConfig.getCurrencyCode();
  };

  // Add instance methods
  Pricing.prototype = /** @lends Pricing.prototype */ {

    /**
     * Get pax type
     *
     * @return {String} The one of Pax.ADT, Pax.CHD, ... constants
     */
    getPaxType: function () {
      return this.paxType;
    },

    /**
     * Returns pax count
     *
     * @return {int}
     */
    getPaxCount: function () {
      return this.count;
    },

    /**
     * Returns total netto price
     *
     * @return {Number}
     */
    getTotalNettoPrice: function () {
      return this.totalNettoPrice;
    },

    /**
     * Get total transaction fee
     *
     * @return {Number}
     */
    getTotalTf: function () {
      return this.totalTf;
    },

    /**
     * Get total mandatory fee
     *
     * @return {Number}
     */
    getTotalMandatoryFee: function () {
      return this.totalMf;
    },

    /**
     * Get currency code
     *
     * @return {String} Ex: EUR
     */
    getCurrencyCode: function () {
      return this.currencyCode;
    }
  };

  Pricing.prototype.constructor = Pricing;

  return Pricing;
}]);

;

// Source: ../shared/public_html/assets/js/flightDetails/models/Pricings.js
/* global _: false */

angular.module('flightDetails')

/**
 * @name        Pricings
 * @namespace   fdt
 * @description A collection of Pricing classes
 */
.factory('fdt.Pricings',
['fdt.Pricing',
function PricingsFactory(Pricing) {
/**
   * Pricings constructor
   *
   * @param {Object[]} pricingArr The raw pricing objects
   *
   * @constructor
   * @class Pricings
   */
  var Pricings = function (pricingArr) {
    if (!_.isArray(pricingArr)) pricingArr = [];

    /**
     * The array of pricings
     *
     * @type {Pricing[]}
     */
    this.pricings = [];

    _.each(pricingArr, function (pricingObj) {
      this.pricings.push(new Pricing(pricingObj));
    }, this);
  };

  // Add instance methods
  Pricings.prototype = /** @lends Pricings.prototype */ {

    /**
     * Get total netto price
     *
     * @return {Number}
     */
    getTotalNettoPrice: function () {
      return _.reduce(this.pricings, function (memo, pricing) {
        return memo + pricing.getTotalNettoPrice() * 1000;
      }, 0) / 1000;
    },

    /**
     * Get total transaction fee
     *
     * @return {Number}
     */
    getTotalTf: function () {
      return _.reduce(this.pricings, function (memo, pricing) {
        return memo + pricing.getTotalTf();
      }, 0);
    },

    /**
     * Return total number of paxes
     *
     * @return {int}
     */
    getPaxCount: function () {
      return _.reduce(this.pricings, function (memo, pricing) {
        return memo + pricing.getPaxCount();
      }, 0);
    },
    /**
     * Get collection of pricings
     *
     * @return {Pricing[]}
     */
    getPricings: function () {
      return this.pricings;
    },

    getFirstPricing: function () {
      return this.pricings[0];
    },

    /**
     * @returns {String}
     */
    getCurrencyCode: function () {
      return this.getFirstPricing().getCurrencyCode();
    }
  };

  Pricings.prototype.constructor = Pricings;

  return Pricings;
}]);

;

// Source: ../shared/public_html/assets/js/flightDetails/models/Verification.js
(function(angular) {
var IthVerificationFactory = function (DocumentRequirement) {
        /**
         * @constructor
         *
         * @param {Object} verificationData
         */
        var Verification = function (verificationData) {
            /**
             * Document requirements per nationality
             *
             * @type {Object{ Nationality: DocumentRequirement }}
             */
            this.documentRequirements = {};

            /**
             * Fields required to ticket
             *
             * @type {String[]}
             */
            this.fieldsRequiredToTicket = [];

            /**
             * Luggage information
             *
             * @type {Object | null}
             */
            this.luggageInformation = null;

            /**
             * Verification ID
             *
             * @type {String}
             */
            this.verificationId = null;

            /**
             * Verification status
             *
             * @type {Number}
             */
            this.statusInt = null;

            /**
             * Verification status
             *
             * @type {String}
             */
            this.statusStr = null;

            /**
             * Verification state
             *
             * @type { INITIALIZATION | IN_PROGRESS | DONE }
             */
            this.state = null;

            this.setVerificationData(verificationData);
        };

        /**
         * Checks if verification state is DONE
         *
         * @returns {Boolean}
         */
        Verification.prototype.isDone = function () {
            return this.state === 'DONE';
        };

        /**
         * Get booking required fields
         *
         * @returns {String[]}
         */
        Verification.prototype.getFieldsRequired = function () {
            return this.fieldsRequiredToTicket;
        };

        /**
         * Get verification ID
         *
         * @returns {String}
         */
        Verification.prototype.getVerificationId = function () {
            return this.verificationId;
        };

        /**
         * Get verification ID
         *
         * @returns {Number}
         */
        Verification.prototype.getStatusInt = function () {
            return this.statusInt;
        };

        /**
         * Get verification ID
         *
         * @returns {String}
         */
        Verification.prototype.getStatusStr = function () {
            return this.statusStr;
        };

        /**
         * Checks if flight requires document
         *
         * @returns {Boolean}
         */
        Verification.prototype.isDocumentRequired = function () {
            return (
                this.getFieldsRequired().length > 0 &&
                this.getFieldsRequired().indexOf('document') !== -1
            );
        };

        /**
         * Checks if document issue date is required
         *
         * @returns  {Boolean}
         */
        Verification.prototype.idDocumentIssueDateRequired = function () {
            return (
                this.isDocumentRequired() &&
                this.getFieldsRequired().indexOf('documentIssueDate') != -1
            );
        };

        /**
         * Checks if flight requires birthDate
         *
         * @returns {Boolean}
         */
        Verification.prototype.isBirthdayRequired = function () {
            return (
                this.getFieldsRequired().length > 0 &&
                (
                    this.getFieldsRequired().indexOf('dateOfBirth') != -1 ||
                    this.getFieldsRequired().indexOf('birthDate') != -1
                )
            );
        };

        /**
         * Sets verification data
         *
         * @param {Object} verificationData
         */
        Verification.prototype.setVerificationData = function (verificationData) {
            if (!verificationData) {
                return;
            }

            if (verificationData.hasOwnProperty('fieldsRequiredToTicket') && verificationData.fieldsRequiredToTicket.length > 0) {
                this.fieldsRequiredToTicket = verificationData.fieldsRequiredToTicket;
            }

            if (verificationData.hasOwnProperty('luggageInformation')) {
                this.luggageInformation = verificationData.luggageInformation;
            }

            if (verificationData.hasOwnProperty('verificationId')) {
                this.verificationId = verificationData.verificationId;
            }

            if (verificationData.hasOwnProperty('state')) {
                this.state = verificationData.state;
            }

            if (verificationData.hasOwnProperty('verifyStatus')) {
                this.statusStr = verificationData.verifyStatus;
            } else if (verificationData.hasOwnProperty('statusMeaning')) {
                this.statusStr = verificationData.statusMeaning;
            }

            if (verificationData.hasOwnProperty('status')) {
                this.statusInt = verificationData.status;
            }
        };

        /**
         * Sets document requirements based on nationality id
         *
         * @param {String} nationalityId
         * @param {Object} documentData
         */
        Verification.prototype.setDocumentRequirement = function (nationalityId, documentData) {
            var documentRequirement = new DocumentRequirement();

            if (documentData.ticketingDocument === 'PASSPORT') {
                documentRequirement.setPassportRequired(true);
            }

            if (documentData.ticketingDocument === 'ANY') {
                documentRequirement.setAnyDocumentRequired(true);
            }

            this.documentRequirements[nationalityId] = documentRequirement;
        };

        Verification.prototype.constructor = Verification;

        return Verification;
    };

    IthVerificationFactory.$inject = [
        'DocumentRequirement'
    ];

    angular
        .module('flightDetails')
        .factory('Verification', IthVerificationFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/models/flight-details-steps.model.js
(function(angular, underscore) {
var FlightDetailsStepsFactory = function ($timeout, $window, $rootScope, $location, StepsEnum, FlightDetailsStepsProvider, SplitFunnelAnalytics) {
        /**
         * @constructor
         */
        var FlightDetailsSteps = function (flightBooking) {
            /**
             * @type {FlightBooking}
             */
            this.flightBooking = flightBooking;

            /**
             * @type {Object}
             */
            this.assistanceStep = FlightDetailsStepsProvider.getAssistanceStep();

            /**
             * @type {Boolean}
             */
            this.showAssistanceStep = false;

            /**
             * @type {Boolean}
             */
            this.changingStep = false;

            /**
             * @type {Object[]}
             */
            this.steps = FlightDetailsStepsProvider.get();

            /**
             * @type {String}
             */
            this.currentStepId = StepsEnum.FLIGHT_INFO;

            this.visitedSteps = [
                '',
                StepsEnum.FLIGHT_INFO
            ];
        };

        FlightDetailsSteps.prototype.checkStep = function () {
            if (this.visitedSteps.indexOf($location.hash()) === -1) {
                var lastVisitedStep = this.visitedSteps[this.visitedSteps.length - 1];
                this.goToStep(lastVisitedStep);
                return;
            }

            this.onStepChange();
        };

        /**
         * Processes and returns available steps
         *
         * @returns {Object[]}
         */
        FlightDetailsSteps.prototype.getSteps = function () {
            var self = this;

            return underscore.filter(this.steps, function (step) {
                return !Object.prototype.hasOwnProperty.call(step, 'isCountable') || step.isCountable(self.flightBooking);
            });
        };

        /**
         * Returns total number of steps
         *
         * @returns {Number}
         */
        FlightDetailsSteps.prototype.getTotalSteps = function () {
            return this.getSteps().length;
        };

        /**
         * Returns step by index
         *
         * @param {Number} index
         * @returns {Object}
         */
        FlightDetailsSteps.prototype.getStep = function (index) {
            return this.getSteps()[index];
        };

        /**
         * Returns index by step id
         *
         * @param {String} stepId
         * @returns {Number}
         */
        FlightDetailsSteps.prototype.getStepIndex = function (stepId) {
            var stepsList = this.getSteps();

            for (var i = 0; i < stepsList.length; i++) {
                if (stepsList[i].id === stepId) {
                    return i;
                }
            }

            return 1;
        };

        /**
         * Returns index of current step
         *
         * @returns {Number}
         */
        FlightDetailsSteps.prototype.getCurrentStepIndex = function () {
            return this.getStepIndex(this.getCurrentStep().id);
        };

        /**
         * Returns current step
         *
         * @returns {Object}
         */
        FlightDetailsSteps.prototype.getCurrentStep = function () {
            var hash = $location.hash();
            var stepsList = this.getSteps();

            for (var i = 0; i < stepsList.length; i++) {
                if (stepsList[i].id === hash) {
                    return this.getStep(i);
                }
            }

            return this.getStep(1);
        };

        /**
         * Returns previous step
         *
         * @returns {Object}
         */
        FlightDetailsSteps.prototype.getPrevStep = function () {
            var currentStepIndex = this.getStepIndex(this.getCurrentStep().id);
            return this.getStep(currentStepIndex - 1);
        };

        /**
         * Returns next step
         *
         * @returns {Object}
         */
        FlightDetailsSteps.prototype.getNextStep = function () {
            var currentStepIndex = this.getStepIndex(this.getCurrentStep().id);
            return this.getStep(currentStepIndex + 1);
        };

        /**
         * Checks if current step is flight info
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isFlightInfo = function () {
            return this.getCurrentStep().id === StepsEnum.FLIGHT_INFO;
        };

        /**
         * Checks if current step is ticket type
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isTicketType = function () {
            return this.getCurrentStep().id === StepsEnum.TICKET_TYPE;
        };

        /**
         * Checks if current step is configure trip
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isConfigureTrip = function () {
            return this.getCurrentStep().id === StepsEnum.CONFIGURE_TRIP;
        };

        /**
         * Checks if current step is protect trip
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isProtectTrip = function () {
            return this.getCurrentStep().id === StepsEnum.PROTECT_TRIP;
        };

        /**
         * Checks if current step is billing
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isBilling = function () {
            return this.getCurrentStep().id === StepsEnum.BILLING;
        };

        /**
         * Checks if current step is last step
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isLastStep = function () {
            return this.isBilling();
        };

        /**
         * Checks if current step is first step
         *
         * @returns {Boolean}
         */
        FlightDetailsSteps.prototype.isFirstStep = function () {
            return this.isFlightInfo();
        };

        /**
         * Sets current step to next step
         */
        FlightDetailsSteps.prototype.goToNextStep = function () {
            this.goToStep(this.getNextStep().id);
        };

        /**
         * Sets current step to previous step
         */
        FlightDetailsSteps.prototype.goToPrevStep = function () {
            this.goToStep(this.getPrevStep().id);
        };

        /**
         * Sets current step by step id
         *
         * @param {String} id
         */
        FlightDetailsSteps.prototype.goToStep = function (id) {
            if (this.visitedSteps.indexOf(id) === -1) {
                this.visitedSteps.push(id);
            }

            this.currentStepId = id;
            this.showAssistanceStep = false;

            $location.hash(id);

            var ctx = this;

            $timeout(function () {
                SplitFunnelAnalytics.splitFunnelStepChange(
                    id,
                    ctx.getStepIndex(id),
                    ctx.flightBooking
                );
            }, 100);
        };

        /**
         * Callback on step change
         * @summary Used as animation delay for steps, notification that step changed, etc
         */
        FlightDetailsSteps.prototype.onStepChange = function () {
            var self = this;

            this.changingStep = true;
            $rootScope.$broadcast('stepChanged');

            $timeout(function () {
                self.changingStep = false;
            }, 10);
        };

        /**
         * Sets assistance step flat to true
         */
        FlightDetailsSteps.prototype.toggleAssistanceStep = function (newValue) {
            this.showAssistanceStep = newValue;
            this.onStepChange();
        };

        FlightDetailsSteps.prototype.constructor = FlightDetailsSteps;
        return FlightDetailsSteps;
    };

    FlightDetailsStepsFactory.$inject = [
        '$timeout',
        '$window',
        '$rootScope',
        '$location',
        'StepsEnum',
        'FlightDetailsStepsProvider',
        'SplitFunnelAnalytics'
    ];

    angular
        .module('flightDetails')
        .factory('FlightDetailsStepsFactory', FlightDetailsStepsFactory);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/models/payment-inject.js
(function(angular, underscore) {
var PaymentInjectFactory = function (AppConfig, ScriptInject) {
        /**
         * @constructor
         *
         * @param {GooglePayClient} googlePayClient
         * @param {ApplePay} applePayClient
         * @param {RevolutCheckoutClient} revolutCheckoutClientForGooglePay
         * @param {RevolutCheckoutClient} revolutCheckoutClientForApplePay
         */
        var PaymentInject = function (googlePayClient, applePayClient, revolutCheckoutClientForGooglePay, revolutCheckoutClientForApplePay, revolutCheckoutClientForRevolutPay) {
            /**
             * @type {GooglePayClient}
             */
            this.googlePayClient = googlePayClient;

            /**
             * @type {ApplePay}
             */
            this.applePayClient = applePayClient;

            /**
             * @type {RevolutCheckoutClient}
             */
            this.revolutCheckoutClientForGooglePay = revolutCheckoutClientForGooglePay;

            /**
             * @type {RevolutCheckoutClient}
             */
            this.revolutCheckoutClientForApplePay = revolutCheckoutClientForApplePay;

            /**
             * @type {RevolutCheckoutClient}
             */
            this.revolutCheckoutClientForRevolutPay = revolutCheckoutClientForRevolutPay;
        };

        PaymentInject.prototype.constructor = PaymentInject;

        /**
         * 1. Checks for available GooglePay or ApplePay
         * 2. Injects the proper scripts
         * 3. Populates the proper classes
         *
         * @param {PaymentOptions} paymentOptions
         */
        PaymentInject.prototype.check = function (paymentOptions) {
            if (paymentOptions.isAvailable('GP')) {
                var googlePayCredentials = underscore.find(paymentOptions.getCredentials(), function (credentials) {
                    return (
                        credentials.conditions.paymentType === 'GP' &&
                        credentials.conditions.currency === AppConfig.getCurrencyCode() &&
                        credentials.clientData
                    );
                });

                if (googlePayCredentials) {
                    if (ScriptInject.isInjected('gpayScript')) {
                        this.googlePayClient.init(googlePayCredentials.clientData);
                    } else {
                        ScriptInject
                            .inject('gpayScript', 'https://pay.google.com/gp/p/js/pay.js')
                            .then(function () {
                                this.googlePayClient.init(googlePayCredentials.clientData);
                            }.bind(this));
                    }
                }
            }

            if (paymentOptions.isAvailable('GP2')) {
                var googlePayRevolutWidgetCredentials = underscore.find(paymentOptions.getCredentials(), function (credentials) {
                    return (
                        credentials.conditions.paymentType === 'GP2' &&
                        credentials.conditions.currency === AppConfig.getCurrencyCode() &&
                        credentials.publicKey
                    );
                });

                if (googlePayRevolutWidgetCredentials) {
                    this.revolutCheckoutClientForGooglePay.init(googlePayRevolutWidgetCredentials.publicKey, 'googlePay');
                }
            }

            var ios = true; // can check for ios here not to load the script needlessly
            if (ios && paymentOptions.isAvailable('AP')) {
                var applePayCredentials = underscore.find(paymentOptions.getCredentials(), function (credentials) {
                    return (
                        credentials.conditions.paymentType === 'AP' &&
                        credentials.conditions.currency === AppConfig.getCurrencyCode() &&
                        credentials.clientData
                    );
                });

                if (applePayCredentials) {
                    if (ScriptInject.isInjected('apayScript')) {
                        this.applePayClient.init(applePayCredentials.clientData);
                    } else {
                        ScriptInject
                            .inject('apayScript', 'https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js')
                            .then(function () {
                                this.applePayClient.init(applePayCredentials.clientData);
                            }.bind(this));
                    }
                }
            }

            if (paymentOptions.isAvailable('AP2')) {
                var applePayRevolutWidgetCredentials = underscore.find(paymentOptions.getCredentials(), function (credentials) {
                    return (
                        credentials.conditions.paymentType === 'AP2' &&
                        credentials.conditions.currency === AppConfig.getCurrencyCode() &&
                        credentials.publicKey
                    );
                });

                if (applePayRevolutWidgetCredentials) {
                    this.revolutCheckoutClientForApplePay.init(applePayRevolutWidgetCredentials.publicKey, 'applePay');
                }
            }

            if (paymentOptions.isAvailable('RP')) {
                var revolutPayCredentials = underscore.find(paymentOptions.getCredentials(), function (credentials) {
                    return (
                        credentials.conditions.paymentType === 'RP' &&
                        credentials.conditions.currency === AppConfig.getCurrencyCode() &&
                        credentials.publicKey
                    );
                });

                if (revolutPayCredentials) {
                    this.revolutCheckoutClientForRevolutPay.init(revolutPayCredentials.publicKey, 'revolutPay');
                }
            }
        };

        return PaymentInject;
    };

    PaymentInjectFactory.$inject = ['appConfig', 'ScriptInject'];

    angular
        .module('flightDetails')
        .factory('PaymentInject', PaymentInjectFactory);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/flightDetails/services/FlightDetailsServ.js
(function (angular) {
/**
     * @name FlightDetailsServFactory
     * @description Flight details serv factory
     *
     * @namespace fdt
     *
     * @param AppConfig
     * @param ApiTools
     * @param FlightDetails
     *
     * @returns {FlightDetailsServ}
     * @constructor
     */
    var FlightDetailsServFactory = function (AppConfig, ApiTools, FlightDetails) {

        var
            /**
             * The API endpoints configuration
             *
             * Each endpoint is a configuration object which must have following properties:
             *
             * - {String}   url        The URL to the API with optional parameters as :parameterName
             * - {String}   method     The one of HTTP verbs (POST, GET...)
             * - {Function} respParser The function called by SearchAPI before returning results to caller.
             *                         It always receives two arguments the SearchAPI instance and the server JSON response
             *                         object. It must return whatever should be returned to the SearchAPI caller.
             *                         Returning $q.reject from this function will trigger error handler on calling code.
             */
            endpoints = {
                // Search flights
                apiGetFlightDetails: {
                    url: AppConfig.getUriPrefix() + '/api/flightDetails/getFlightDetails/:requestId/:fsId/:priceGroupId/:depLegId/:retLegId',
                    method: 'GET',
                    respParser: flightDetailsParser
                },
                apiGetFareRules: {
                    url: AppConfig.getUriPrefix() + '/api/fareRules/getFareRules/:requestId/:fsId/:priceGroupId/:depLegId/:retLegId',
                    method: 'GET',
                    respParser: defaultParser
                },
                apiContinueDesktop: {
                    url: AppConfig.getUriPrefix() + '/api/flightDetails/email/:requestId/:fsId/:priceGroupId/:depLegId/:retLegId' + '?abv=' + _js_app_config_.ab_version,
                    method: 'POST',
                    respParser: defaultParser
                },
                apiGetCarrierConditionLinks: {
                  url: AppConfig.getUriPrefix() + '/api/location/getGeneralConditionsCarriersLinks',
                  method: 'POST',
                  respParser: defaultParser
                },
                apiRequestMerchantSession: {
                    url: AppConfig.getUriPrefix() + '/api/payment/session',
                    method: 'POST',
                    respParser: defaultParser
                },
            },

            /**
             * @class FlightDetailsServ
             * @constructor
             */
            FlightDetailsServ = function () {
            };

        FlightDetailsServ.prototype = /** @lends FlightDetailsServ.prototype */ {

            /**
             * Get flight details from the server
             *
             * @param  {Object} routeParams The object with requestId, priceGroupId, depLegId, retLegId properties.
             *
             * @return {Promise}
             */
            get: function (routeParams) {
                var requestUrlData = {};

                requestUrlData.requestId = routeParams.requestId;
                requestUrlData.priceGroupId = routeParams.priceGroupId;
                requestUrlData.fsId = routeParams.fsId;
                requestUrlData.depLegId = routeParams.depLegId;
                requestUrlData.retLegId = routeParams.retLegId ? routeParams.retLegId : '0'; // For one way: 0
                requestUrlData.abv = _js_app_config_.ab_version;
                if (routeParams.pax) {
                    requestUrlData.retLegId += routeParams.pax;
                }

                var flightDetails = endpoints.apiGetFlightDetails;
                return ApiTools.fetch(this, flightDetails, null, requestUrlData);
            },
            /**
             * Get flight details fare rules
             *
             * @param  {Object} routeParams The object with requestId, priceGroupId, depLegId, retLegId properties.
             *
             * @return {Promise}
             */
            getFareRules: function (routeParams) {
                var requestUrlData = {};

                requestUrlData.requestId = routeParams.requestId;
                requestUrlData.priceGroupId = routeParams.priceGroupId;
                requestUrlData.fsId = routeParams.fsId;
                requestUrlData.depLegId = routeParams.depLegId;
                requestUrlData.retLegId = routeParams.retLegId ? routeParams.retLegId : 0; // For one way: 0
                requestUrlData.abv = _js_app_config_.ab_version;
                return ApiTools.fetch(this, endpoints.apiGetFareRules, null, requestUrlData);
            },

            /**
             * Get carriers' condition links.
             *
             * @param  {Array} carriers The list of all carriers on all legs.
             *
             * @return {Promise}
             */
            getCarrierConditionLinks: function (carriers) {
              var requestUrlData = {
                carriers: carriers
              };

              return ApiTools.fetch(this, endpoints.apiGetCarrierConditionLinks, requestUrlData);
            },

            /**
             * Get information about flight
             *
             * @param {Object} routeParams
             * @returns {Promise}
             */
            getContinueDesktopDetails: function (data, routeParams) {
                var requestUrlData = {};

                requestUrlData.requestId = routeParams.requestId;
                requestUrlData.fsId = routeParams.fsId;
                requestUrlData.priceGroupId = routeParams.priceGroupId;
                requestUrlData.depLegId = routeParams.depLegId;
                requestUrlData.retLegId = routeParams.retLegId ? routeParams.retLegId : 0; // For one way: 0

                return ApiTools.fetch(this, endpoints.apiContinueDesktop, data, requestUrlData);
            },

            requestMerchantSession: function(data) {
                return ApiTools.fetch(this, endpoints.apiRequestMerchantSession, data);
            }
        };

        FlightDetailsServ.prototype.constructor = FlightDetailsServ;

        /**
         * Parse example response
         *
         * @param {Object} response
         *
         * @return {FlightDetails}
         */
        function flightDetailsParser(response) {
            return angular.copy(FlightDetails).srvSet(response.response);
        }

        /**
         * Parse response
         *
         * @param {Object} response
         * @return {Object}
         */
        function defaultParser(response) {
            return response.response;
        }

        return new FlightDetailsServ();
    };

    FlightDetailsServFactory.$inject = [
        'appConfig',
        'ApiTools',
        'fdt.FlightDetails'
    ];

    angular.module('flightDetails')
        .factory('fdt.FlightDetailsServ', FlightDetailsServFactory);

})(angular);
;

// Source: ../shared/public_html/assets/js/flightDetails/services/Scroll.service.js
(function(angular) {
var service = function ($document) {
        this.to = function (selector, offset, duration) {
            offset = offset || 0;
            duration = duration || 500;

            $document.scrollToElement(
                angular.element(document.querySelector(selector)),
                offset,
                duration
            );
        };
    };

    service.$inject = ['$document'];

    angular.module('base').service('ScrollService', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/flightDetails/services/VerificationHandler.js
(function(angular) {
var IthVerificationHandler = function () {
        /**
         * @constructor
         *
         * @param {FlightDetails} flightDetails
         */
        var VerificationHandler = function (flightDetails) {
            /**
             * Flight booking reference
             *
             * @type {FlightDetails}
             */
            this.flightDetails = flightDetails;
        };

        /**
         * Sets verification data in the verification class and checks for documents
         *
         * @param {Object} verificationData
         */
        VerificationHandler.prototype.setVerificationData = function (verificationData) {
            this.flightDetails.getVerification().setVerificationData(verificationData);
        };

        /**
         * Send Gov id, passport or none based on pax nationality and verification data
         *
         * @param {Pax[]} paxes
         * @returns {Pax[]}
         */
        VerificationHandler.prototype.preparePaxes = function (paxes) {
            var verification = this.flightDetails.getVerification();

            angular.forEach(paxes, function (pax) {
                pax.getPerson().serializeIdCard = verification.isDocumentRequired();
                pax.getPerson().getIdCard().serializeIssueDate = verification.idDocumentIssueDateRequired();
            });

            return paxes;
        };

        VerificationHandler.prototype.constructor = VerificationHandler;

        return VerificationHandler;
    };

    angular
        .module('flightDetails')
        .factory('VerificationHandler', IthVerificationHandler);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/address-field.component.js
(function (angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('address');
        };

        this.getPlaceholderLang = function () {
            return 'LANGM_JS_' + this.type.toUpperCase() + '_STREET_ADDRESS_PLACEHOLDER';
        };

        this.getLabelLang = function () {
            return 'LANGM_JS_' + this.type.toUpperCase() + '_STREET_ADDRESS_LABEL';
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithAddressField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/addressField',
            controller: controller,
            bindings: {
                elementId: '@?',
                type: '@',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/ba-code-field.component.js
(function (angular) {
var controller = function (FieldMessages) {
        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            this.minLength = 6;
            this.maxLength = 6;

            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         *
         */
        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };
    };

    controller.$inject = [
        'FieldMessages'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithBaCodeInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/baCodeField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                tooltipImage: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/birthdate-field.component.js
(function () {
var IthBirthdateFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/birthdateField',
        controller: 'BirthdateFieldCtrl',
        bindings: {
            elementId: '@?',
            form: '<',
            name: '@',
            paxType: '<?',
            date: '=',
            backendError: '=?',
            disabled: '<',
            required: '<',
            disableNgMessages: '@',
            changeEvent: '&?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithBirthdateField', IthBirthdateFieldComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/birthdate-field.controller.js
(function(angular, _) {
var IthBirthdateFieldController = function (DateUtils, Tools) {
        /**
         * Self reference.
         *
         * @type {IthBirthdateFieldController}
         */
        var ctrl = this;

        /**
         * Objct containing days, months and years.
         *
         * @type {Object}
         */
        this.dateRange = DateUtils.getRegularDate();

        /**
         *
         */
        this.$onInit = function () {
            updateDateRange();
        };

        /**
         *
         */
        this.$onChanges = function () {
            updateDateRange();
        };

        /**
         * Updates date range according to pax type.
         */
        function updateDateRange() {
            if (!isNaN(ctrl.paxType)) {
                ctrl.paxType = Tools.customerPaxTypeTranslation(+ctrl.paxType);
            }

            switch (ctrl.paxType) {
                case 'INF': ctrl.dateRange.years = DateUtils.getInfYearRange(); break;
                case 'CHD': ctrl.dateRange.years = DateUtils.getChdYearRange(); break;
                case 'ADT': ctrl.dateRange.years = DateUtils.getAdtYearRange(); break;
                case 'YTH': ctrl.dateRange.years = DateUtils.getYthYearRange(); break;
            }
        }
    };

    IthBirthdateFieldController.$inject = [
        'DateUtils',
        'Tools'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('BirthdateFieldCtrl', IthBirthdateFieldController);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/form/components/cc-cvc-field.component.js
(function (angular) {
var controller = function (FieldMessages) {
        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            this.minLength = 3;
            this.maxLength = 3;

            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         *
         */
        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };
    };

    controller.$inject = [
        'FieldMessages'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithCcCvcInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/ccCvcField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                tooltipImage: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/cc-exp-field.component.js
(function (angular) {
var controller = function (FieldMessages, ValidationService) {
        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            validate(this.form, this.name, this.model);

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            this.minLength = 5;
            this.maxLength = 5;

            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
            validate(this.form, this.name, this.model);
        };

        /**
         *
         */
        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         *
         */
        var validate = function (form, fieldName, value) {
            FieldMessages.updateFormCustomError(form, fieldName, 'expirationDate', ValidationService.isExpirationDate(value));
        };
    };

    controller.$inject = [
        'FieldMessages',
        'ValidationService'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithCcExpInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/ccExpField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                tooltipImage: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/cc-input-field.component.js
(function (angular) {
var controller = function (AppConfig, CreditCard, FieldMessages) {
        this.inputMask = '9999 9999 9999 9?9?9?9?9?9?9?';
        this.minLength = 12;
        this.maxLength = 22;
        this.creditCardHelper = new CreditCard();

        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            var cardInfo = this.creditCardHelper.cardFromNumber(this.model);

            this.ccType = cardInfo.type;
            this.ccId = cardInfo.id;

            validate(this.creditCardHelper, this.form, this.name, this.model);

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);

            if (!AppConfig.isVola()) {
                this.inputMask = '9999 9999 9999 99?9?9?';
                this.minLength = 13;
                this.maxLength = 19;
            }

            validate(this.creditCardHelper, this.form, this.name, this.model);
        };

        /**
         *
         */
        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         *
         */
        var validate = function (ccHelper, form, fieldName, value) {
            FieldMessages.updateFormCustomError(form, fieldName, 'ccnumber', ccHelper.validateCardNumber(value));
        };
    };

    controller.$inject = [
        'appConfig',
        'bok.CreditCard',
        'FieldMessages'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithCcInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/ccField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                ccType: '=',
                ccId: '=',
                backendError: '=?',
                disabled: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/checkbox-field.component.js
(function(angular) {
var IthCheckboxFieldController = function () {
        this.hasError = function () {
            return (
                this.required &&
                this.form &&
                this.form.$submitted &&
                this.model === false
            );
        };
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithCheckboxField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/checkboxField',
            controller: IthCheckboxFieldController,
            transclude: true,
            bindings: {
                elementId: '@?',
                form: '<',
                name: '@',
                model: '=',
                disabled: '<',
                required: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/city-field.component.js
(function (angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('basicText');
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithCityField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/cityField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/date-field.component.js
(function() {
var IthDateFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/dateField',
        controller: 'DateFieldCtrl',
        bindings: {
            elementId: '@?',
            label: '@',
            form: '<',
            name: '@',
            date: '=',
            dateRange: '<',
            minDate: '<?',
            maxDate: '<?',
            backendError: '=?',
            disabled: '<',
            required: '<',
            disableNgMessages: '@',
            changeEvent: '&?',
            customMessages: '<?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithDateField', IthDateFieldComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/date-field.controller.js
(function(angular, moment) {
var IthDateFieldController = function ($scope, FieldMessages) {
        var self = this;

        /**
         * @type {Object}
         */
        this.dateSplit = {
            date: null,
            month: null,
            year: null
        };

        /**
         * @returns {String}
         */
        this.getDayFieldName = function () {
            return this.name + 'Day';
        };

        /**
         * @returns {String}
         */
        this.getMonthFieldName = function () {
            return this.name + 'Month';
        };

        /**
         * @returns {String}
         */
        this.getYearFieldName = function () {
            return this.name + 'Year';
        };

        /**
         *
         */
        this.onSelectChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);
            FieldMessages.clearFormBackendError(this.form, this.getDayFieldName());
            FieldMessages.clearFormBackendError(this.form, this.getMonthFieldName());
            FieldMessages.clearFormBackendError(this.form, this.getYearFieldName());

            updateFormMessages();
            convertObjectToDate();

            if (self.changeEvent !== undefined) {
                self.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            if (this.disabled === undefined || this.disabled === null) {
                this.disabled = false;
            }

            convertDateToObject();
            updateFormMessages();

            $scope.$watch(function () {
                return self.date;
            }, function () {
                convertDateToObject();
                updateFormMessages();
            });
        };

        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         * Converts date string to object
         */
        var convertDateToObject = function () {
            var m = moment(self.date);

            self.dateSplit = self.date !== null && m.isValid()
                ? { date: m.date(), month: m.month(), year: m.year() }
                : { date: null, month: null, year: null };
        };

        /**
         * Converts object to string
         */
        var convertObjectToDate = function () {
            var m = moment();
            m.year(self.dateSplit.year);
            m.month(self.dateSplit.month);
            m.date(self.dateSplit.date);

            var allFieldsSelected = (
                Object.values(self.dateSplit).indexOf(null) === -1 &&
                Object.values(self.dateSplit).indexOf(undefined) === -1
            );

            if (allFieldsSelected && m.isValid()) {
                self.dateSplit.date = m.date();
                self.dateSplit.month = m.month();
                self.dateSplit.year = m.year();
                self.date = m.format('YYYY-MM-DD');
            }
        };

        /**
         * @returns {Boolean}
         */
        var hasMinDateError = function () {
            if (!self.minDate || !self.date) {
                return false;
            }

            var currDate = moment(self.date).startOf('day');
            var minDate = moment(self.minDate).startOf('day');
            return currDate.isBefore(minDate);
        };

        /**
         * @returns {Boolean}
         */
        var hasMaxDateError = function () {
            if (!self.maxDate || !self.date) {
                return false;
            }

            var currDate = moment(self.date).startOf('day');
            var maxDate = moment(self.maxDate).startOf('day');
            return currDate.isAfter(maxDate);
        };

        var updateFormMessages = function () {
            if (!Object.values(self.dateSplit).includes(null)) {
                if (self.form && self.form.hasOwnProperty(self.name)) {
                    self.form[self.name].$setDirty();
                }
            }

            $scope.$evalAsync(function () {
                FieldMessages.updateFormCustomError(self.form, self.name, 'minDate', !hasMinDateError());
                FieldMessages.updateFormCustomError(self.form, self.name, 'maxDate', !hasMaxDateError());

                if (self.required === true) {
                    FieldMessages.updateFormCustomError(self.form, self.name, 'required', self.date !== null);
                }
            });
        };
    };

    IthDateFieldController.$inject = [
        '$scope',
        'FieldMessages',
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('DateFieldCtrl', IthDateFieldController);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/form/components/document-number-field.component.js
(function (angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = this.preventAsterisks
                ? PatternHelper.getPatternAndMessages('idCardNoAsterisks')
                : PatternHelper.getPatternAndMessages('idCard');
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithDocumentNumberField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/documentNumberField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                disabled: '<',
                preventAsterisks: '<?',
                backendError: '=?',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/document-type-field.component.js
(function () {
var IthDocumentTypeFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/documentTypeField',
        controller: 'DocumentTypeFieldCtrl',
        bindings: {
            elementId: '@?',
            form: '<',
            name: '@',
            model: '=',
            backendError: '=?',
            disabled: '<',
            required: '<'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithDocumentTypeField', IthDocumentTypeFieldComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/document-type-field.controller.js
(function(angular) {
var IthDocumentTypeFieldController = function (CHECKIN_DOCUMENT_TYPES) {
        this.docTypes = CHECKIN_DOCUMENT_TYPES;
    };

    IthDocumentTypeFieldController.$inject = [
        'CHECKIN_DOCUMENT_TYPES'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('DocumentTypeFieldCtrl', IthDocumentTypeFieldController);

}(angular));;

// Source: ../shared/public_html/assets/js/form/components/email-input-field.component.js
(function(angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('email');
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithEmailInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/emailInputField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                placeholder: '@',
                label: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                autocomplete: '@?',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/field-validation.component.js
(function(angular) {
var template = '\
        <span\
            ng-messages="$ctrl.form[$ctrl.name].$error"\
            ng-show="$ctrl.form[$ctrl.name].$invalid && ($ctrl.form[$ctrl.name].$dirty || $ctrl.form.$submitted)"\
            class="ng-animate-disabled">\
            <span\
                ng-messages-include="/tpl/show/jsShared/templates/base/directives/errors/validationMessages">\
            </span>\
        </span>\
    ';

    var ctrl = function ($translate) {
        /**
         * Returns custom message or default lang
         *
         * @param {string} customMessage
         * @param {string} defaultLang
         * @returns string
         */
        this.getValidationMessage = function (customMessage, defaultLang) {
            var message = defaultLang;
            var translateParams = {};

            if (this.customMessages && this.customMessages.hasOwnProperty(customMessage)) {
                message = this.customMessages[customMessage];
            }

            if (this.customMessages && this.customMessages.hasOwnProperty('langParams')) {
                translateParams = this.customMessages['langParams'];
            }

            return $translate.instant(message, translateParams);
        };
    };

    ctrl.$inject = ['$translate'];

    angular
        .module('ITH.Shared.Form')
        .component('fieldValidation', {
            template: template,
            controller: ctrl,
            bindings: {
                form: '<',
                name: '@',
                backendError: '<',
                customMessages: '<?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/form-group.component.js
(function(angular) {
var template = '\
        <div\
            class="form-group ng-animate-disabled"\
            ng-class="{\
                \'has-error\': $ctrl.form[$ctrl.name].$invalid && ($ctrl.form[$ctrl.name].$dirty || $ctrl.form.$submitted),\
                \'has-success\': $ctrl.form[$ctrl.name].$valid,\
                \'no-margin\': $ctrl.disableNgMessages === \'true\'\
            }">\
            <ng-transclude></ng-transclude>\
        </div>\
    ';

    angular
        .module('ITH.Shared.Form')
        .component('ithFormGroup', {
            template: template,
            transclude: true,
            bindings: {
                form: '<',
                name: '<',
                disableNgMessages: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/input-field.component.js
(function (angular) {
var IthInputFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/inputField',
        controller: 'InputFieldCtrl',
        bindings: {
            elementId: '@?',
            type: '@',
            name: '@',
            size: '@',
            label: '@',
            placeholder: '@',
            autocomplete: '@?',
            disabled: '<',
            form: '<',
            model: '=',
            backendError: '=?',
            required: '<',
            minLength: '@',
            maxLength: '@',
            pattern: '<',
            disableNgMessages: '@',
            changeEvent: '&?',
            customMessages: '<?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithInputField', IthInputFieldComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/input-field.controller.js
(function(angular) {
var IthInputFieldController = function (FieldMessages) {
        /**
         *
         */
        this.$onInit = function () {
            // Set defaults
            this.disabled = (this.disabled) ? this.disabled : false;
            this.type = (this.type) ? this.type : 'text';
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        /**
         *
         */
        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };
    };

    IthInputFieldController.$inject = [
        'FieldMessages'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('InputFieldCtrl', IthInputFieldController);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/input-label.component.js
(function() {
var InputLabelComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/inputLabel',
        bindings: {
            elementId: '@?',
            label: '@',
            required: '<'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithInputLabel', InputLabelComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/loading-submit.component.js
(function(angular) {
var template = '\
        <button type="submit" class="btn btn-lg btn-block" ng-class="$ctrl.getClassMap()" ng-disabled="$ctrl.isLoading">\
            <span ng-if="$ctrl.isLoading" class="spin-loader ng-animate-disabled"></span>\
            <span ng-if="!$ctrl.isLoading" class="ng-animate-disabled">\
                <ng-transclude></ng-transclude>\
            </span>\
        </button>\
    ';

    angular
        .module('ITH.Shared.Form')
        .component('ithLoadingSubmit', {
            template: template,
            transclude: true,
            bindings: {
                isLoading: '<',
                buttonType: '@?'
            },
            controller: function () {
                this.getClassMap = function () {
                    return {
                        'btn-primary': this.buttonType === 'primary' || !this.buttonType,
                        'btn-secondary': this.buttonType === 'secondary',
                        'btn-danger': this.buttonType === 'danger'
                    };
                };
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/name-input-field.component.js
(function(angular) {
var controller = function (PatternHelper) {
        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('name');
        };
    };

    controller.$inject = ['PatternHelper'];

    angular
        .module('ITH.Shared.Form')
        .component('ithNameInputField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/nameInputField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                placeholder: '@',
                label: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                autocomplete: '@?',
                changeEvent: '&?',
                customMessages: '<?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/passport-field.component.js
(function() {
var IthPassportFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/passportDateField',
        controller: 'PassportFieldCtrl',
        bindings: {
            elementId: '@?',
            label: '@',
            form: '<',
            name: '@',
            date: '=',
            minDate: '<?',
            maxDate: '<?',
            type: '@',
            backendError: '=?',
            disabled: '<',
            required: '<',
            changeEvent: '&?',
            customMessages: '<?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithPassportField', IthPassportFieldComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/passport-field.controller.js
(function(angular) {
var IthPassportFieldController = function (DateUtils, $filter) {
        /**
         * Objct containing days, months and years.
         *
         * @type {Object}
         */
        this.dateRange = (this.type === 'expiration') ? DateUtils.getPassportDate() : DateUtils.getPassportIssueDate();

        this.$onInit = function () {
            if (this.disabled === undefined || this.disabled === null) {
                this.disabled = false;
            }

            if (this.type !== 'expiration') {
                this.maxDate = DateUtils.dateToString(new Date());

                this.customMessages = {
                    maxDate: $filter('translate')('LANGM_JS_VALIDATION_DOCUMENT_ISSUE_MAX_DATE')
                };
            }
        };
    };

    IthPassportFieldController.$inject = [
        'DateUtils',
        '$filter'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('PassportFieldCtrl', IthPassportFieldController);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/password-field.component.js
(function(angular) {
var controller = function ($scope, FieldMessages, PatternHelper) {
        var self = this;

        /**
         *
         */
        this.onChange = function () {
            updateValidation();

            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            updateValidation();

            $scope.$watch(
                function () {
                    return self.form[self.name].$viewValue;
                },
                function () {
                    updateValidation();
                }
            );
        };

        var updateValidation = function () {
            self.patternValidation = PatternHelper.getPatternAndMessages('password');
            var illegalCharactersFound = getIllegalCharacters();

            if (illegalCharactersFound.length === 0) {
                self.patternValidation = PatternHelper.getPatternAndMessages('passwordStrength');
            } else {
                self.patternValidation = PatternHelper.getPatternAndMessages('password', {
                    character: illegalCharactersFound.join(' ')
                });
            }

            if (!self.equals) {
                return;
            }

            $scope.$evalAsync(function () {
                FieldMessages.updateFormCustomError(
                    self.form,
                    self.name,
                    'equals',
                    self.form[self.name].$viewValue === self.equals
                );
            });
        };

        var getIllegalCharacters = function () {
            var illegalCharactersFound = [];
            var inputValue = self.form[self.name] ? self.form[self.name].$viewValue : '';

            for (var i = 0; i < inputValue.length; i++) {
                if (inputValue[i].search(self.patternValidation.pattern) === -1) {
                    illegalCharactersFound.push(inputValue[i]);
                }
            }

            return illegalCharactersFound;
        };
    };

    controller.$inject = ['$scope', 'FieldMessages', 'PatternHelper'];

    angular
        .module('ITH.Shared.Form')
        .component('ithPasswordField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/passwordField',
            controller: controller,
            bindings: {
                elementId: '@?',
                form: '<',
                name: '@',
                placeholder: '@',
                label: '@',
                model: '=',
                equals: '<?',
                backendError: '=?',
                disabled: '<',
                showHint: '<?',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/password-fields.component.js
(function (angular) {
var controller = function () {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.onPasswordInputChange = function () {
            this.passwordConfirm = '';
            this.onChange();
        };
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithPasswordFields', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/passwordFields',
            controller: controller,
            bindings: {
                elementId: '@?',
                form: '<',
                password: '=',
                passwordConfirm: '=',
                disabled: '<',
                passwordBackendError: '<',
                passwordConfirmBackendError: '<',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/phone-field.component.js
(function () {
var IthPhoneFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/phoneField',
        controller: 'PhoneFieldCtrl',
        bindings: {
            elementId: '@?',
            label: '@',
            form: '<',
            name: '@',
            phone: '=',
            backendError: '=?',
            disabled: '<',
            required: '<',
            changeEvent: '&?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithPhoneField', IthPhoneFieldComponent);

}());
;

// Source: ../shared/public_html/assets/js/form/components/phone-field.controller.js
(function (angular) {
var IthPhoneFieldController = function ($scope, FieldMessages, PhoneFieldService, PatternHelper) {
        var self = this;

        this.countries = [];

        this.getPrefixName = function () {
            return this.name + 'Prefix';
        };

        this.getNumberName = function () {
            return this.name + 'Number';
        };

        /**
         *
         */
        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            updateFormMessages();

            if (self.changeEvent !== undefined) {
                self.changeEvent();
            }
        };

        /**
         *
         */
        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('phone');

            PhoneFieldService
                .loadCountries()
                .then(function (countries) {
                    self.countries = countries;

                    var countryInfo = PhoneFieldService.findCountryByDialCode(self.phone.prefix, countries, true);
                    self.phone.prefix = countryInfo.dial_code;

                });

            if (this.disabled === undefined || this.disabled === null) {
                this.disabled = false;
            }

            $scope.$watch(function () {
                return self.form[self.getNumberName()].$error;
            }, function () {
                updateFormMessages();
            }, true);

            $scope.$watch(function () {
                return self.phone.number;
            }, function () {
                updateFormMessages();
            });

            updateFormMessages();
        };

        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        var updateFormMessages = function () {
            $scope.$evalAsync(function () {
                if (
                    !Object.keys(self.form).includes(self.getPrefixName()) ||
                    !Object.keys(self.form).includes(self.getNumberName())
                ) {
                    return;
                }

                if (self.form[self.getPrefixName()].$dirty || self.form[self.getNumberName()].$dirty) {
                    self.form[self.name].$setDirty();
                }

                FieldMessages.copyError(self.form, self.getNumberName(), self.name, 'required');
                FieldMessages.copyError(self.form, self.getNumberName(), self.name, 'minlength');
                FieldMessages.copyError(self.form, self.getNumberName(), self.name, 'maxlength');
                FieldMessages.copyError(self.form, self.getNumberName(), self.name, 'pattern');
            });
        };
    };

    IthPhoneFieldController.$inject = [
        '$scope',
        'FieldMessages',
        'PhoneFieldService',
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('PhoneFieldCtrl', IthPhoneFieldController);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/select-field.component.js
(function (angular) {
var IthSelectFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/selectField',
        controller: 'SelectFieldCtrl',
        bindings: {
            elementId: '@?',
            name: '@',
            label: '@',
            placeholder: '@?',
            data: '<',
            options: '@',
            disabled: '<',
            form: '<',
            model: '=',
            backendError: '=?',
            required: '<',
            disableNgMessages: '@',
            changeEvent: '&?',
            customMessages: '<?'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithSelectField', IthSelectFieldComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/select-field.controller.js
(function(angular) {
var IthSelectFieldController = function (FieldMessages, $timeout) {
        var self = this;

        this.$onInit = function () {
            // Set defaults
            this.disabled = (this.disabled) ? this.disabled : false;
            this.disableNgMessages = (this.disableNgMessages) ? this.disableNgMessages : false;
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);

            if (this.changeEvent !== undefined) {
                $timeout(function () {
                    self.changeEvent();
                });
            }
        };

        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };
    };

    IthSelectFieldController.$inject = [
        'FieldMessages',
        '$timeout'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('SelectFieldCtrl', IthSelectFieldController);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/sensitive-input-field.component.js
(function (angular) {
var IthSensitiveInputFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/sensitiveInputField',
        controller: 'InputFieldCtrl',
        bindings: {
            elementId: '@?',
            type: '@',
            name: '@',
            size: '@',
            label: '@',
            placeholder: '@',
            disabled: '<',
            form: '<',
            model: '=',
            backendError: '=?',
            required: '<',
            minLength: '@',
            maxLength: '@',
            pattern: '<'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithSensitiveInputField', IthSensitiveInputFieldComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/textarea-field.component.js
(function (angular) {
var IthInputFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/textareaField',
        controller: 'TextareaFieldCtrl',
        bindings: {
            elementId: '@?',
            name: '@',
            rows: '@',
            size: '@',
            label: '@',
            placeholder: '@',
            disabled: '<',
            form: '<',
            model: '=',
            backendError: '=?',
            required: '<',
            minLength: '@',
            maxLength: '@',
            pattern: '<'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithTextareaField', IthInputFieldComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/textarea-field.controller.js
(function (angular) {
var IthTextareaFieldController = function (FieldMessages) {
        this.$onInit = function () {
            // Set defaults
            this.disabled = (this.disabled) ? this.disabled : false;
            this.type = (this.type) ? this.type : 'text';
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };

        this.onChange = function () {
            this.backendError = null;
            FieldMessages.clearFormBackendError(this.form, this.name);
        };

        this.$doCheck = function () {
            FieldMessages.updateFormBackendError(this.form, this.name, this.backendError);
        };
    };

    IthTextareaFieldController.$inject = [
        'FieldMessages'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('TextareaFieldCtrl', IthTextareaFieldController);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/title-field.component.js
(function (angular) {
var IthTitleFieldComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/views/forms/titleField',
        controller: 'TitleFieldCtrl',
        bindings: {
            elementId: '@?',
            name: '@',
            label: '@',
            disabled: '<',
            form: '<',
            model: '=',
            backendError: '=?',
            required: '@'
        }
    };

    angular
        .module('ITH.Shared.Form')
        .component('ithTitleField', IthTitleFieldComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/title-field.controller.js
(function(angular) {
var IthTitleFieldController = function ($filter) {
        this.titles = [
            {
                label: 'LANGM_JS_MR',
                value: 'MR'
            },
            {
                label: 'LANGM_JS_MS',
                value: 'MS'
            }
        ];
    }; 

    IthTitleFieldController.$inject = [
        '$filter'
    ];

    angular
        .module('ITH.Shared.Form')
        .controller('TitleFieldCtrl', IthTitleFieldController);

}(angular));;

// Source: ../shared/public_html/assets/js/form/components/vat-number-field.component.js
(function (angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('vat');
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithVatNumberField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/vatNumberField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                autocomplete: '@?',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/components/zip-code-field.component.js
(function (angular) {
var controller = function (PatternHelper) {
        /**
         *
         */
        this.onChange = function () {
            if (this.changeEvent !== undefined) {
                this.changeEvent();
            }
        };

        this.$onInit = function () {
            this.patternValidation = PatternHelper.getPatternAndMessages('postalCode');
        };
    };

    controller.$inject = [
        'PatternHelper'
    ];

    angular
        .module('ITH.Shared.Form')
        .component('ithZipcodeField', {
            templateUrl: '/tpl/show/jsShared/templates/base/views/forms/zipcodeField',
            controller: controller,
            bindings: {
                elementId: '@?',
                name: '@',
                form: '<',
                model: '=',
                backendError: '=?',
                disabled: '<',
                autocomplete: '@?',
                changeEvent: '&?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/form/directives/ValidationDirective.js
(function(angular) {
/**
     * @name        ValidatorDirective
     * @description Validates input along given settings
     */
    var FormValidationDirective = function($timeout, validation) {
return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attributes, ctrl) {
                var settings = scope.$eval(attributes.ithFormValidator);
                var updateOn = _.isArray(settings.updateOn) ? settings.updateOn.join(' ') : settings.updateOn;
                var settingsKey = element.attr('name');
                var settingsKeyObserver;
                var validateOnSubmitObserver;

                if (settingsKey && settingsKey.match(/{{.*}}/)) {
                    settingsKey = scope.$eval(settingsKey.replace(/[{}]/g, ''));
                }

                var validate = function validateInputCallback() {
                    $timeout(function timeoutValidate() {
                        var inputSettings = settings[settingsKey];
                        var validators = inputSettings.validators;
                        var value = inputSettings.valueModifier ? validation.modifyValue(inputSettings.valueModifier, ctrl.$viewValue) : ctrl.$viewValue;

                        _.every(validators, function(validator) {
                            var rule = validator.rule;
                            var isValid = validation[rule].apply(null, [value].concat(validator.params));
                            var messageKey = validator.messageKey ? validator.messageKey : rule.toLowerCase();

                            ctrl.$setValidity(messageKey, isValid);

                            return isValid;
                        });
                    }, 0);
                };

                if(_.has(attributes, 'ithFormValidatorSettingsKey')) {
                    settingsKeyObserver = attributes.$observe('ithFormValidatorSettingsKey', function(value) {
                        settingsKey = value;

                        validate();
                    });
                }

                element.on(updateOn, validate);

                validateOnSubmitObserver = scope.$on('form-submit:validate', _.debounce(function(){
                    validate();
                }, 300, true));

                scope.$on('$destroy', function() {
                    element.off(updateOn, validate);

                    validateOnSubmitObserver();

                    if(typeof settingsKeyObserver !== 'undefined') {
                        settingsKeyObserver();
                    }
                });
            }
        };
    };

    FormValidationDirective.$inject = [
        '$timeout',
        'ValidationService'
    ];

    angular.module('ITH.Shared.Form').directive('ithFormValidator', FormValidationDirective);
})(angular);;

// Source: ../shared/public_html/assets/js/form/services/ValidationService.js
(function(angular) {
/**
     * @name        ValidationService
     * @description Validates input along given rule
     */
    var FormValidationService = function() {

        var valueModifiers = {
            /**
             * Remove whitespaces from value
             * @param value
             * @returns {*}
             */
            removeWhitespaces: function removeWhitespacesModifier(value) {
                return value.replace(/\s+/g, '');
            },

            removeLeadingZeros: function (str) {
                if (!str) {
                    return '';
                }

                return str.replaceAll(/^0+/g, '');
            },

            onlyDigits: function (str) {
                var onlyDigitsValue = str.match(/\d+/g);

                if (onlyDigitsValue === null) {
                    return '';
                }

                return str.match(/\d+/g).join('');
            },

            /**
             * Removes + at the start and spaces.
             *
             * @param {string} text
             * @return {string}
             */
            removePlusSign: function (text) {
                if (!text) {
                    return '';
                }

                return text.replace(/[ ]*/g, '');
            }
        };

        /**
         *
         * @param value
         * @param min
         * @returns {boolean} Return false if given value is greater or equal than minimal value
         */
        function hasMinLength(value, min) {
            return value.length >= min;
        }

        /**
         *
         * @param value
         * @param max
         * @returns {boolean} Return false if given value is less or equal than maximum value
         */
        function hasMaxLength(value, max) {
            return value.length <= max;
        }

        /**
         *
         * @param value
         * @returns {boolean} Return false if value is empty string
         */
        function isRequired(value) {
            return value !== '';
        }

        /**
         *
         * @param value
         * @returns {boolean} Return false if month part is bigger than 12, or given date is before today
         */
        function isExpirationDate(value) {
            var expirationDateArray  = value.split('/');
            var momentExpirationDate = moment(['20' + expirationDateArray[1], expirationDateArray[0], '01'].join('-'));
            var presentDate = new Date;

            return momentExpirationDate.isSameOrAfter(presentDate,'year') && momentExpirationDate.isSameOrAfter(presentDate, 'month');
        }

        /**
         * If value has a + char, min length must be 10
         *
         * @returns {boolean} Returns false if given value is not a phone (+?[0-9]+)
         */
        function isPhoneNumber(value) {
            if (!value) {
                return false;
            }

            return /^[0-9 ]+$/.test(value);
        }

        function numeric(value) {
            return /^\d+$/.test(value);
        }

        function isCreditCard(value, cardModel) {
            return cardModel.validateCardNumber(value);
        }

        /**
         * Modify value by given modifier
         *
         * @param {string|Function} modifier If is a string internal modifier is used, else - must be a Function
         * @param {string} value
         * @returns {string}
         */
        function modifyValue(modifier, value) {
            if(_.isString(modifier)) {
                return valueModifiers[modifier](value);
            } else {
                return modifier(value);
            }
        }

        function applyModifiers(modifiers, value) {
            modifiers.forEach(function (modifier) {
                value = modifyValue(modifier, value);
            });

            return value;
        }

        return {
            hasMinLength: hasMinLength,
            hasMaxLength: hasMaxLength,
            isRequired: isRequired,
            isExpirationDate: isExpirationDate,
            isPhoneNumber: isPhoneNumber,
            isCreditCard: isCreditCard,
            numeric: numeric,
            modifyValue: modifyValue,
            applyModifiers: applyModifiers
        };
    };

    FormValidationService.$inject = [];

    angular.module('ITH.Shared.Form').service('ValidationService', FormValidationService);
})(angular);



;

// Source: ../shared/public_html/assets/js/form/services/field-messages.service.js
(function(angular) {
var FieldMessagesService = function () {
        /**
         * Updates an ng-form with backend data for validation.
         *
         * @param {NgForm} form          The ng-form
         * @param {String} name          Name of the field
         * @param {String} backendError  Error coming from backend
         */
        function updateFormBackendError(form, name, backendError) {
            if (!form || !backendError || !form.hasOwnProperty(name)) {
                return;
            }

            var isValid = (!backendError) ? true : false;
            updateFormCustomError(form, name, 'backend', isValid);

            if (!isValid) {
                form[name].$setDirty();
            }
        }

        function clearFormBackendError(form, name) {
            updateFormCustomError(form, name, 'backend', true);
        }

        function updateFormCustomError(form, name, validationName, validationValue) {
            if (!form || !form.hasOwnProperty(name)) {
                return;
            }
            form[name].$setValidity(validationName, validationValue);
        }

        function copyError(form, sourceName, destinationName, category) {
            updateFormCustomError(
                form,
                destinationName,
                category,
                !(
                    form[sourceName].$error.hasOwnProperty(category) &&
                    form[sourceName].$error[category] === true
                )
            );
        }

        /**
         * Checks to see if form element has validation error.
         *
         * @param   {NgForm} form
         * @param   {String} name
         * @returns {Boolean}
         */
        function hasError(form, name) {
            if (!form || !form.hasOwnProperty(name)) {
                return false;
            }

            return (form[name].$invalid && form[name].$dirty) || (form[name].$invalid && form.$submitted);
        }

        /**
         * Checks to see if a form element is valid.
         *
         * @param   {NgForm} form
         * @param   {String} name
         * @returns {Boolean}
         */
        function hasSuccess(form, name) {
            if (!form || !form.hasOwnProperty(name)) {
                return true;
            }

            return (form[name].$valid && form[name].$dirty);
        }

        /**
         * Checks to see if ng-messages should be displayed for a form element
         *
         * @param   {NgForm} form
         * @param   {String} name
         * @returns {Boolean}
         */
        function showNgMessages(form, name) {
            if (!form || !form.hasOwnProperty(name)) {
                return false;
            }

            return hasError(form, name);
        }

        return {
            updateFormBackendError: updateFormBackendError,
            clearFormBackendError: clearFormBackendError,
            updateFormCustomError: updateFormCustomError,
            hasError: hasError,
            hasSuccess: hasSuccess,
            showNgMessages: showNgMessages,
            copyError: copyError
        };
    };

    angular
        .module('ITH.Shared.Form')
        .service('FieldMessages', FieldMessagesService);

}(angular));
;

// Source: ../shared/public_html/assets/js/form/services/phone-field.service.js
(function (angular, cacheVersion, fly) {
function PhoneFieldService(appConfig, $http, $q) {
        /**
         * @type {Array}
         */
        var countries = [];

        /**
         * @param {string} prefix
         * @param {Array} countryList
         * @param {boolean} setDefaultIfEmpty
         * @return {null|Object}
         */
        this.findCountryByDialCode = function(prefix, countryList, setDefaultIfEmpty) {
            for (var i = 0, length = countryList.length; i < length; i++) {
                if (cleanNumber(countryList[i].dial_code) === prefix) {
                    return countryList[i];
                }
            }

            if (setDefaultIfEmpty) {
                for (var i = 0, length = countryList.length; i < length; i++) {
                    if (countryList[i].code === appConfig.getDefaultCountryCode()) {
                        return countryList[i];
                    }
                }
            }

            return null;
        };

        /**
         * @param countriesList
         */
        var setupCountries = function(countriesList) {
            countries.splice(0, countries.length);
            countries = angular.extend(countries, countriesList);
        };

        /**
         * @param {string} [overrideLangCode] - loads this lang over default.
         * @return {Promise}
         */
        this.loadCountries = function(overrideLangCode) {
            var self = this;
            var lang = overrideLangCode || appConfig.getLanguageCode();
            var deferred = $q.defer();

            if (angular.isObject(fly.countriesInfo) && angular.isObject(fly.countriesInfo[lang])) {
                return fly.countriesInfo[lang].then(function(countriesList) {
                    setupCountries(countriesList);

                    return countriesList;
                });
            }

            var countriesInfo = {};
            countriesInfo[lang] = deferred.promise;

            $http
                .get('/assets/v-'+ cacheVersion +'/js/dist/countries_info/' + lang + '.json')
                .then(function(countriesList) {
                    setupCountries(countriesList.data);

                    deferred.resolve(countriesList.data);
                }, function() {
                    self.loadCountries('en').then(function(countriesList) {
                        setupCountries(countriesList);
                        deferred.resolve(countriesList);
                    });
                });

            fly = angular.extend(fly, {
                countriesInfo: countriesInfo
            });

            return deferred.promise;
        };

        /**
         * Removes + at the start and spaces.
         *
         * @param {string} text
         * @return {string}
         */
        var cleanNumber = function (text) {
            if (!text) {
                return '';
            }
            return text.replace(/[ ]*/g, '');
        };
    }

    PhoneFieldService.$inject = [
        'appConfig',
        '$http',
        '$q'
    ];

    angular.module('funnel')
        .service('PhoneFieldService', PhoneFieldService);

}(angular, _template_cache_buster, window.fly = window.fly || {}));
;

// Source: ../shared/public_html/assets/js/form/services/validation-patterns.service.js
(function(angular) {
var patterns = {
        phone: {
            regex: /^[0-9 ().-]*$/,
            lang: 'LANGM_JS_VALIDATION_PHONE_INVALID',
        },
        password: {
            regex: /^[a-zA-Z0-9-@$!%*#?&-]+$/,
            lang: 'LANGM_JS_VALIDATION_PASSWORD_ILLEGAL_CHARACTER',
        },
        passwordStrength: {
            regex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*#?&-])[A-Za-z\d$@$!%*#?&-]{8,32}$/,
            lang: 'LANGM_JS_VALIDATION_PATTERN_INVALID_V2',
        },
        idCard: {
            regex: /^[A-Za-z0-9*]+/,
            lang: 'LANGM_JS_VALIDATION_ID_CARD_INVALID',
        },
        idCardNoAsterisks: {
            regex: /^[A-Za-z0-9]+$/,
            lang: 'LANGM_JS_VALIDATION_ID_CARD_INVALID',
        },
        idCardMasked: {
            regex: /^[a-zA-Z0-9*\s]*$/,
            lang: '',
        },
        vat: {
            regex: /^[a-zA-Z0-9\s-]*$/,
            lang: 'LANGM_JS_VALIDATION_VAT_NUMBER_INVALID',
        },
        postalCode: {
            regex: /^[\d-]*$/,
            lang: 'LANGM_JS_VALIDATION_POSTAL_CODE_INVALID',
        },
        address: {
            regex: /^[^!@#$^'&%*()+=~|:<>?[\]\\{}]{2,255}$/,
            lang: 'LANGM_JS_VALIDATION_ADDRESS_INVALID',
        },
        basicText: {
            regex: /^[^!@#$^'&%*()+=~|:<>?,[\].\\/{}0-9]{2,255}$/,
            lang: 'LANGM_JS_VALIDATION_TEXT_INVALID',
        },
        email: {
            regex: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.[a-zA-Z]{2,15})?$/i,
            lang: 'LANGM_JS_VALIDATION_EMAIL_INVALID',
        },
        name: {
            regex: /^[- a-zA-Z]+$/,
            lang: 'LANGM_JS_VALIDATION_NAME_INVALID_LATIN',
        },
        fullname: {
            regex: /^[a-zA-Z]{2,100} [a-zA-Z]{2,100}$/,
            lang: 'LANGM_JS_VALIDATION_FULLNAME_INVALID',
        }
    };

    var service = function () {
        this.getPatternAndMessages = function (name, langParams) {
            if (!langParams) {
                langParams = {};
            }

            return {
                pattern: patterns[name].regex,
                customMessages: {
                    pattern: patterns[name].lang,
                    langParams: langParams
                }
            };
        };

        return this;
    };

    angular
        .module('ITH.Shared.Form')
        .service('PatternHelper', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/ancillaries/ancillaries-api-payload.model.js
(function(angular) {
var AncillariesApiPayloadModel = function () {
        /**
         * Constructor
         *
         * @param {String} socketId
         * @param {String} requestId
         * @param {String} priceGroupId
         * @param {String} depLegId
         * @param {String} retLegId
         */
        var AncillariesApiPayload = function (socketId, requestId, priceGroupId, depLegId, retLegId) {
            /**
             * Payload object
             */
            this.payload = {
                commonData: {
                    requestId: requestId,
                    priceGroupId: priceGroupId,
                    depLegId: depLegId,
                    retLegId: retLegId,
                    socketId: socketId
                },
                targets: {}
            };
        };

        /**
         * Adds CFAR in payload
         *
         * @param {String} requestId
         * @param {Number} basketPrice
         */
        AncillariesApiPayload.prototype.addCfar = function (requestId, basketPrice) {
            this.payload.targets.cfar = {
                requestId: requestId,
                basketPrice: basketPrice
            };

            return this;
        };

        /**
         * Adds seats in payload
         *
         * @param {String} searchMode determines what kind of seat offer is expected in response e.g. "FALLBACK_ONLY", "SEAT_MAP_OR_FALLBACK"
         */
        AncillariesApiPayload.prototype.addSeats = function (searchMode) {
            this.payload.targets.seats = {
                trigger: true
            };

            if (searchMode) {
                this.payload.targets.seats.searchMode = searchMode;
            }

            return this;
        };

        AncillariesApiPayload.prototype.addTripGuarantee = function () {
            this.payload.targets.trip_guarantee = {
                trigger: true
            };

            return this;
        };

        AncillariesApiPayload.prototype.addSmsNotification = function () {
            this.payload.targets.sms_notification = {
                trigger: true
            };

            return this;
        };

        /**
         * Adds seats in payload
         *
         * @param {String} requestUuid
         */
        AncillariesApiPayload.prototype.addFareLock = function (requestUuid) {
            this.payload.targets.fare_lock = {
                requestUuid: requestUuid
            };

            return this;
        };

        AncillariesApiPayload.prototype.constructor = AncillariesApiPayload;

        return AncillariesApiPayload;
    };

    angular
        .module('ITH.Funnel.Ancillaries')
        .factory('AncillariesApiPayload', AncillariesApiPayloadModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/ancillaries/ancillaries-socket-handler.factory.js
(function(angular) {
var AncillariesSocketHandlerFactory = function ($q, Socket, AncillariesApiPayload, AncillariesApi, UUID, AppConfig) {
        /**
         * Constructor
         *
         * @param {Booking} flightBooking
         */
        var AncillariesSocketHandler = function (flightBooking) {
            /**
             * Flight booking reference
             *
             * @type {Booking}
             */
            this.flightBooking = flightBooking;

            /**
             * Socket id for pusher communication
             *
             * @type {String}
             */
            this.socketId = '';

            /**
             * Flag set to true once seat request was made
             *
             * @type {Boolean}
             */
            this.madeSeatsSearch = false;
        };

        /**
         * Handles web socket response
         *
         * @param {AncillariesSocketHandler} context
         * @param {object} message
         */
        var onSearchCompletedMessage = function (context, message) {
            switch (message.type) {
                case 'SEAT':
                    context.flightBooking.seatsInitialData.populateFromWebSocket(
                        message
                    );
                    break;

                case 'trip_guarantee':
                    context.flightBooking.tripGuarantee.populateFromWebSocket(
                        message.data,
                        message.code,
                        context.flightBooking.basket.getRefundBasePrice()
                    );
                    break;

                case 'sms_notification':
                    context.flightBooking.smsNotification.populateFromWebSocket(
                        message.data,
                        message.code
                    );
                    break;

                case 'fare_lock':
                    context.flightBooking.fareLock.populateFromWebSocket(
                        message.data,
                        message.code
                    );
                    break;

                default:
                    console.error('Ancillaries web socket responsed with unimplemented type', message.type);
                    break;
            }
        };

        /**
         * Initiates socket script search request to Ancillaries service
         *
         * @returns {Promise}
         */
        AncillariesSocketHandler.prototype.init = function () {
            var self = this;
            var deferred = $q.defer();

            Socket.init().then(function () {
                self.socketId = UUID.v4();
                deferred.resolve();

                Socket.subscribe(self.socketId, 'search_completed', function (message) {
                    onSearchCompletedMessage(self, message);
                });

                Socket.subscribe(self.socketId, 'possible_seats_checked', function (message) {
                    self.flightBooking.seatsInitialData.populatePossibleSeatsCheck(message);
                });

                var payload = new AncillariesApiPayload(
                    self.socketId,
                    self.flightBooking.getFlightDetails().getRequestId(),
                    self.flightBooking.getFlightDetails().getPriceGroupId(),
                    self.flightBooking.getFlightDetails().getDepLegId(),
                    self.flightBooking.getFlightDetails().getRetLegId()
                );

                payload
                    .addTripGuarantee()
                    .addSmsNotification()

                AncillariesApi.initSearch(payload);
            });

            return deferred.promise;
        };

        /**
         * Makes additional request to api to search for seats
         */
        AncillariesSocketHandler.prototype.requestSeats = function () {
            if (this.madeSeatsSearch) {
                // Only make seats search once
                return;
            }

            var payload = new AncillariesApiPayload (
                this.socketId,
                this.flightBooking.getFlightDetails().getRequestId(),
                this.flightBooking.getFlightDetails().getPriceGroupId(),
                this.flightBooking.getFlightDetails().getDepLegId(),
                this.flightBooking.getFlightDetails().getRetLegId()
            );

            payload.addSeats(AppConfig.getSeatsSearchMode());
            AncillariesApi.initSearch(payload);
            this.madeSeatsSearch = true;
        };

        /**
         *
         * @returns {string}
         */
        AncillariesSocketHandler.prototype.getSocketId = function () {
            return this.socketId;
        };

        /**
         * Unsubscribe from socket
         */
        AncillariesSocketHandler.prototype.destroy = function () {
            Socket.unsubscribe();
        };

        AncillariesSocketHandler.prototype.constructor = AncillariesSocketHandler;

        return AncillariesSocketHandler;
    };

    AncillariesSocketHandlerFactory.$inject = [
        '$q',
        'Socket',
        'AncillariesApiPayload',
        'AncillariesApi',
        'UUID',
        'appConfig'
    ];

    angular
        .module('ITH.Funnel.Ancillaries')
        .factory('AncillariesSocketHandler', AncillariesSocketHandlerFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/ancillaries/ancillaries.api.js
(function(angular) {
var AncillariesApi = function ($http, AppConfig) {
        var baseUrl = AppConfig.getUriPrefix() + '/api/ancillaries/';

        /**
         * Initiates the search
         *
         * @param {AncillariesApiPayload} payload
         * @returns {Promise}
         */
        this.initSearch = function (payload) {
            return $http({
                url: baseUrl + 'initSearch',
                method: 'POST',
                data: payload.payload
            });
        };

        /**
         * Initiates the search
         *
         * @param {AncillariesApiPayload} payload
         * @returns {Promise}
         */
        this.initFareConfirm = function (payload) {
            return $http({
                url: baseUrl + 'initFareConfirm',
                method: 'POST',
                data: payload.payload
            });
        };

        this.confirmSeats = function (provider, requestId) {
            return $http({
                url: baseUrl + 'confirmSeats',
                method: 'POST',
                data: {
                    provider: provider,
                    requestId: requestId
                }
            });
        };
    };

    AncillariesApi.$inject = ['$http', 'appConfig'];

    angular
        .module('ITH.Funnel.Ancillaries')
        .service('AncillariesApi', AncillariesApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/cfar/cfar.api.js
(function(angular) {
var CfarApi = function ($http, AppConfig) {
        /**
         * Returns CFAR quote
         *
         * @param {String} basketPrice
         * @param {String} requestId
         * @param {String} ancillariesRequestId
         * @param {String} priceGroupId
         * @param {String} depLegId
         * @param {String} retLegId
         *
         * @returns {Promise}
         */
        this.getQuote = function (basketPrice, requestId, ancillariesRequestId, priceGroupId, depLegId, retLegId) {
            return $http({
                method: 'POST',
                url: '/api/ancillaries/getcfarquote?abv=' + AppConfig.getAppAbVersion(),
                data: {
                    basketPrice: basketPrice,
                    requestId: requestId,
                    ancillariesRequestId: ancillariesRequestId,
                    priceGroupId: priceGroupId,
                    depLegId: depLegId,
                    retLegId: retLegId
                }
            });
        };

        /**
         * Returns CFAR claim details
         *
         * @param {String} reservationNumber
         * @param {String} email
         * @returns {Promise}
         */
        this.getClaimDetails = function (reservationNumber, email) {
            return $http({
                method: 'POST',
                url: '/api/ancillaries/showCfarClaimDetails',
                data: {
                    reservationNumber: reservationNumber,
                    email: email
                }
            });
        };

        /**
         * Claims refund for a reservation
         *
         * @param {String} reservationNumber
         * @param {String} email
         * @param {Boolean} isRebook
         * @returns {Promise}
         */
        this.claim = function (reservationNumber, email, isRebook) {
            return $http({
                method: 'POST',
                url: '/api/ancillaries/claimCfar',
                data: {
                    reservationNumber: reservationNumber,
                    email: email,
                    isRebook: isRebook
                }
            });
        };
    };

    CfarApi.$inject = ['$http', 'appConfig'];

    angular
        .module('ITH.Funnel.CFAR')
        .service('CfarApi', CfarApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/cfar/frola-cfar-logo.component.js
(function (angular) {
var IthFrolaCfarLogoComponent = {
        template: '<ith-product-logo show-affiliate-name="false" image-name="cfar" name="{{ \'LANGM_JS_CFAR_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.Funnel.CFAR')
        .component('ithFrolaCfarLogo', IthFrolaCfarLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/cfar/ith-cfar-box.component.js
(function (angular) {
var templateUrl = function ($attrs) {
        var templateName = 'fd-box';

        if ($attrs.zone === 'ty') {
            templateName = 'ty-box';
        }

        return '/tpl/show/jsShared/templates/funnel/cfar/' + templateName;
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    var IthCfarBoxComponent = {
        templateUrl: templateUrl,
        bindings: {
            booking: '<',
            steps: '<',
            zone: '@'
        },
        controller: 'CfarBoxController'
    };

    angular
        .module('ITH.Funnel.CFAR')
        .component('ithCfarBox', IthCfarBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/cfar/ith-cfar-box.controller.js
(function (angular) {
var IthCfarBoxController = function ($filter, CfarApi) {
        /**
         * Context
         */
        var ctrl = this;

        /**
         * Previous price (cache)
         *
         * @type {Number}
         */
        this.prevPrice = 0;

        /**
         * Flag for showing limit exceeded
         *
         * @type {Boolean}
         */
        this.limitExceeded = false;

        this.limitExceededChecked = false;

        /**
         * Do check hook
         */
        this.$doCheck = function () {
            if (this.zone === 'ty' || !this.booking.cfar.isAllowed) {
                return;
            }

            if (!this.limitExceededChecked) {
                this.limitExceeded = this.booking.basket.getRefundBasePrice() > this.booking.cfar.basketLimitAmount;
                this.limitExceededChecked = true;
            }
        };

        /**
         * Variables for the text boxes
         *
         * @returns {Object}
         */
        this.getTextBoxVariables = function () {
            return {
                basketLimitAmount: $filter('flPrice')(ctrl.booking.cfar.basketLimitAmount, 2),
                customerRefundAmount: $filter('flPrice')(ctrl.booking.cfar.customerRefundAmount, 2),
                deadlineDate: $filter('date')(new Date(ctrl.booking.cfar.deadlineDate).getTime(), 'dd MMMM yyyy, HH:mm')
            };
        };

        /**
         * Decides if box is visible
         *
         * @returns {Boolean}
         */
        this.isVisible = function () {
            if (
                this.zone === 'ty' &&
                this.booking &&
                (
                    this.booking.cfar.isSelected() ||
                    this.booking.ticketType.isCfarIncluded()
                )
            ) {
                // Thank you page with option selected
                return true;
            }

            if (!this.booking.cfar.isAllowed) {
                return false;
            }

            if (this.zone !== 'ty' && this.booking.cfar.getTotalPrice() > 0) {
                // Flight details page with price loaded from API
                return true;
            }

            return false;
        };

        /**
         * Returns price calculated per pax
         * It will add a cent when price per pax multiplied by pax count is lower than total product price
         *
         * @returns {Number}
         */
        this.getPricePerPax = function () {
            var pricePerPax = parseFloat((this.booking.cfar.getTotalPrice() / this.booking.paxes.length).toFixed(2));

            if (pricePerPax * this.booking.paxes.length < this.booking.cfar.getTotalPrice()) {
                pricePerPax += 0.01;
            }

            return pricePerPax;
        };
    };

    IthCfarBoxController.$inject = ['$filter', 'CfarApi'];

    angular
        .module('ITH.Funnel.CFAR')
        .controller('CfarBoxController', IthCfarBoxController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/combo-deal.component.js
(function (angular) {
var template = '\
        <span \
            class="combo-deal"\
            ng-class="{ \'combo-deal--inside-actions\': $ctrl.isInsideActions }"\
            tooltip="{{ \'LANGM_JS_COMBO_DEAL_TOOLTIP\' | translate }}"\
            tooltip-class="ith-flight-offer__combo-deal-tooltip"\
        >\
            <span translate>LANGM_JS_COMBO_DEAL</span>\
        </span>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('base')
        .component('comboDeal', {
            template: template,
            controller: controller,
            bindings: {
                isInsideActions: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-controls.component.js
(function (angular) {
var template = '\
        <div class="explore-mode-controls">\
            <div>\
                <p class="explore-mode-controls__heading" translate>\
                    LANGM_JS_EXPLORE_MODE_HEADING\
                </p>\
                <p class="explore-mode-controls__description" translate>\
                    LANGM_JS_EXPLORE_MODE_DESCRIPTION\
                </p>\
            </div>\
            <div ng-if="!$ctrl.loading" class="explore-mode-controls__switcher-holder">\
                <span class="explore-mode-controls__switcher-text" translate>LANGM_JS_DIRECT_FLIGHTS_ONLY</span>\
                <ith-ui-checkbox \
                    ng-model="$ctrl.switcherModel" \
                    switcher="true"\
                    disabled="$ctrl.disabled" \
                ></ith-ui-checkbox>\
            </div>\
            <div ng-if="$ctrl.loading" class="explore-mode-controls__spinner-holder">\
                <span class="loading-spinner"></span>\
                <span translate>LANGM_JS_FS_LOADING</span>\
            </div>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [
    ];

    angular
        .module('funnel')
        .component('exploreModeControls', {
            template: template,
            controller: controller,
            bindings: {
                switcherModel: '=',
                disabled: '<',
                loading: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-error.component.js
(function (angular) {
var template = '\
        <div class="ith-flight-no-offers text-center">\
            <img src="/assets/img/ui/icons/svg/empty-state.svg" class="ith-flight-no-offers__image" />\
            \
            <article>\
                <h3 class="ith-flight-no-offers__title" translate>LANGM_JS_FS_SEARCH_ERROR_TITLE</h3>\
                <p class="ith-flight-no-offers__message" translate>LANGM_JS_FS_SEARCH_ERROR_TEXT</p>\
                <button class="btn btn-outline" ng-click="$ctrl.onRefreshButtonClick()" translate>LANGM_JS_REFRESH</button>\
            </article>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('funnel')
        .component('exploreModeError', {
            template: template,
            controller: controller,
            bindings: {
                onRefreshButtonClick: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-filters-loader.component.js
(function (angular) {
var template = '\
        <div class="explore-mode-filters-loader">\
            <span class="loading-spinner loading-spinner-md"></span>\
            <div class="explore-mode-filters-loader__text" translate>LANGM_JS_PAGE_LOADING</div>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [];

    angular
        .module('funnel')
        .component('exploreModeFiltersLoader', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-loading-placeholder.component.js
(function (angular) {
var template = '\
        <div class="explore-mode-loading-placeholder">\
            <div class="explore-mode-loading-placeholder__header">\
                <div class="explore-mode-loading-placeholder__header-title"></div>\
                <div class="explore-mode-loading-placeholder__header-description"></div>\
                <div class="explore-mode-loading-placeholder__header-switcher"></div>\
            </div>\
            \
            <div class="explore-mode-loading-placeholder__items-holder">\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--1"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--2"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--3"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--4"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--5"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--6"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--7"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--8"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--9"></div>\
                <div class="explore-mode-loading-placeholder__item explore-mode-loading-placeholder__item--10"></div>\
            </div>\
            \
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('funnel')
        .component('exploreModeLoadingPlaceholder', {
            template: template,
            controller: controller,
            bindings: {

            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-nothing-found.component.js
(function (angular) {
var template = '\
        <div class="explore-mode-nothing-found">\
            \
            <article ng-if="!$ctrl.isNothingFoundDueToFilters">\
                <h3 \
                    class="explore-mode-nothing-found__title"\
                    translate\
                >\
                    LANGM_JS_EXPLORE_MODE_NOTHING_FOUND_TITLE\
                </h3>\
                <p \
                    class="explore-mode-nothing-found__description" \
                    translate\
                >\
                    LANGM_JS_EXPLORE_MODE_NOTHING_FOUND_DESCRIPTION\
                </p>\
            </article>\
            \
            <article ng-if="$ctrl.isNothingFoundDueToFilters">\
                <h3 \
                    class="explore-mode-nothing-found__title"\
                    translate\
                >\
                    LANGM_JS_EXPLORE_MODE_NOTHING_FOUND_DUE_TO_FILTERS_TITLE\
                </h3>\
                <p \
                    class="explore-mode-nothing-found__description" \
                    translate\
                >\
                    LANGM_JS_EXPLORE_MODE_NOTHING_FOUND_DUE_TO_FILTERS_DESCRIPTION\
                </p>\
                <button \
                    class="explore-mode-nothing-found__reset-filters-button btn btn-outline" \
                    ng-click="$ctrl.onResetFilters()" \
                    translate\
                >\
                    LANGM_JS_RESET_FILTERS\
                </button>\
            </article>\
            \
            <img \
                src="/assets/img/ui/icons/svg/empty-state-explore-mode.svg" \
                class="explore-mode-nothing-found__image" \
            />\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('funnel')
        .component('exploreModeNothingFound', {
            template: template,
            controller: controller,
            bindings: {
                isNothingFoundDueToFilters: '<',
                onResetFilters: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-results.component.js
(function (angular) {
var template = '\
        <div class="explore-mode-results">\
            <div \
                ng-repeat="item in $ctrl.results" \
                class="explore-mode-results__item" \
                ng-click="$ctrl.resultClickHandler(item.destinationCityCode)" \
            >\
            \
                <img \
                    class="explore-mode-results__item-image-placeholder"\
                    ng-src="/assets/img/ui/image-placeholder.svg" \
                    alt=""\
                >\
                <div \
                    class="explore-mode-results__item-background-holder"\
                    style="background-image:url({{ $ctrl.getImageUrl(item.imageUrls, $index, false) }})"\
                ></div>\
                <div \
                    class="explore-mode-results__item-background-holder explore-mode-results__item-background-holder--mobile"\
                    style="background-image:url({{ $ctrl.getImageUrl(item.imageUrls, $index, true) }})"\
                ></div>\
                \
                <div class="explore-mode-results__item-footer">\
                    <div>\
                        <p class="explore-mode-results__item-location">\
                            {{ $ctrl.getCityName(item.destinationCityCode) }}\
                        </p>\
                        <p class="explore-mode-results__item-price">\
                            <span \
                                class="explore-mode-results__item-price-from" \
                                translate\
                            >\
                                LANGM_JS_FROM_PRICE\
                            </span>\
                            <span class="explore-mode-results__item-price-amount">\
                                {{ $ctrl.getPrice(item.price.amount, item.price.currency) }}\
                            </span>\
                        </p>\
                    </div>\
                   <svg-icon id="caret"></svg-icon>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function (PriceFormatterService, $location, ExploreModeIdService) {
        var isNthChild10nPlusOne = function (index) { return index % 10 === 0; }
        var isNthChild10nPlusTwo = function (index) { return index % 10 === 1; }
        var isNthChild10nPlusFive = function (index) { return (index - 4) % 10 === 0 && index >= 4; }
        var isNthChild10nPlusTen = function (index) { return (index - 9) % 10 === 0 && index >= 9; }

        this.getCityName = function (code) {
            return this.translations.cities[code] || code;
        };

        this.getPrice = function (amount, currency) {
            return PriceFormatterService.formatPrice(amount, currency);
        };

        this.getImageUrl = function (urlObj, itemIndex, isMobile) {
            if (!isMobile) {
                // At this point this layout could be dictated entirely by JS instead of CSS
                if (isNthChild10nPlusOne(itemIndex)) {
                    return urlObj.desktop.square.big;
                }

                if (isNthChild10nPlusTwo(itemIndex) || isNthChild10nPlusFive(itemIndex) || isNthChild10nPlusTen(itemIndex)) {
                    return urlObj.desktop.rectangle.big;
                }

                return urlObj.desktop.square.medium;
            }

            // for now desktop images are used for mobile due to bad quality of mobile images...
            return urlObj.desktop.rectangle.big;
        };

        this.resultClickHandler = function (cityCode) {
            var url = $location.url();
            var countryMatch = url.match(/\/to_country_code\/[^/]*/);
            var airportMatch = url.match(/\/to_airport_code\/[^/]*/);
            var cityMatch = url.match(/\/to_code\/[^/]*/);

            ExploreModeIdService.setIncludeInPayload(true);

            if (countryMatch) {
                url = url.replace(countryMatch[0], '');
            }

            if (airportMatch) {
                url = url.replace(airportMatch[0], '');
            }

            if (cityMatch) {
                url = url.replace(cityMatch[0], '/to_code/' + cityCode);
            }

            $location.url(url);
        };
    };

    controller.$inject = [
        'PriceFormatterService',
        '$location',
        'ExploreModeIdService'
    ];

    angular
        .module('funnel')
        .component('exploreModeResults', {
            template: template,
            controller: controller,
            bindings: {
                results: '<',
                translations: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/explore-mode/explore-mode-view.component.js
(function (angular) {
var template = '\
        <section>\
            <!-- Search summary information box (only on mobile) -->\
            <ith-search-summary search-query-params="SearchQueryParams"></ith-search-summary>\
            \
            <div class="container">\
                <explore-mode-controls \
                    ng-show="!$ctrl.isError && !$ctrl.isLoading"\
                    switcher-model="$ctrl.isDirectFlightsOnly"\
                    disabled="$ctrl.isLoadingFiltering"\
                    loading="$ctrl.isDuringPolling"\
                ></explore-mode-controls>\
                \
                <explore-mode-loading-placeholder ng-if="$ctrl.isLoading"></explore-mode-loading-placeholder>\
                \
                <explore-mode-filters-loader ng-if="$ctrl.isLoadingFiltering"></explore-mode-filters-loader>\
                \
                <explore-mode-error \
                    ng-if="$ctrl.isError"\
                    on-refresh-button-click="$ctrl.makeNewSearch()"\
                ></explore-mode-error>\
                \
                <explore-mode-nothing-found\
                    ng-if="$ctrl.isNotFound()"\
                    is-nothing-found-due-to-filters="$ctrl.results.length && !$ctrl.resultsToShow.length"\
                    on-reset-filters="$ctrl.resetFilters()"\
                ></explore-mode-nothing-found>\
                \
                <explore-mode-results\
                    ng-if="$ctrl.isFound()"\
                    results="$ctrl.resultsToShow"\
                    translations="$ctrl.translations"\
                ></explore-mode-results>\
            </div>\
        </section>\
    ';

    var controller = function ($scope, SearchQueryParams, ExploreModeService, SouthParkHelper, ExploreModeIdService) {
        $scope.SearchQueryParams = SearchQueryParams;
        var ctrl = this;

        this.isLoading = true;
        this.isDuringPolling = true;
        this.isLoadingFiltering = false;
        this.isError = false;
        this.isDirectFlightsOnly = false;
        this.results = [];
        this.resultsToShow = [];
        this.translations = {};
        this.timeOutId = null;

        this.makeDelay = function (ms) {
            return new Promise(function (resolve) {
                setTimeout(function () {
                    resolve();
                }, ms);
            });
        };

        this.filterResults = function () {
            var newResults = this.results;

            if (this.isDirectFlightsOnly) {
                newResults = newResults.filter(function (item) {
                    return item.isDirect;
                });
            }

            this.resultsToShow = newResults;
        };

        this.disableLoaderWithDelay = function () {
            this.makeDelay(300)
                .then(function () {
                    ctrl.isLoadingFiltering = false;
                    $scope.$apply();
                });
        };

        this.directFilterChangeHandler = function () {
            this.isLoadingFiltering = true;
            this.filterResults();
            this.disableLoaderWithDelay();
        };

        this.mergeNewResultsWithExisting = function (existingResultsArr, newResultsArr) {
            var output = existingResultsArr;

            newResultsArr.forEach(function (newResult) {
                var found = output.find(function (existingResult) {
                    return existingResult.destinationCityCode === newResult.destinationCityCode;
                });

                if (found) {
                    // price for the same result is different with each polling :)
                    found.price = newResult.price;
                }

                if (!found) {
                    output.push(newResult);
                }
            });

            return output;
        };

        this.mergeNewTranslationsWithExisting = function (existingTranslationsObj, newTranslationsObj) {
            var existingCopy = JSON.parse(JSON.stringify(existingTranslationsObj));

            for (var key in newTranslationsObj.cities) {
                if (!existingCopy.cities) {
                    existingCopy.cities = {};
                    existingCopy.cities[key] = newTranslationsObj.cities[key];
                } else {
                    existingCopy.cities[key] = newTranslationsObj.cities[key];
                }
            }

            return existingCopy;
        };

        this.isFound = function () {
            return !this.isError && !this.isLoading && !this.isLoadingFiltering && this.resultsToShow.length;
        };

        this.isNotFound = function () {
            return !this.isError && !this.isLoading && !this.isLoadingFiltering && !this.isDuringPolling && !this.resultsToShow.length;
        };

        this.search = function (pollId) {
            SouthParkHelper.reset();

            ExploreModeService
                .getResults(pollId)
                .then(function (response) {
                    var pollingId = response.data.explore.id;
                    var pollingStatus = response.data.explore.status; // IN_PROGRESS | FINISHED
                    var POLLING_INTERVAL_MS = 1000;

                    ExploreModeIdService.setId(pollingId);

                    ctrl.results = ctrl.mergeNewResultsWithExisting(ctrl.results, response.data.explore.results);
                    ctrl.resultsToShow = ctrl.results;
                    ctrl.translations = ctrl.mergeNewTranslationsWithExisting(ctrl.translations, response.data.explore.translations);

                    if (pollingStatus === 'IN_PROGRESS') {
                        ctrl.timeOutId = setTimeout(function () {
                            ctrl.search(pollingId);
                        }, POLLING_INTERVAL_MS);
                    }

                    if (pollingStatus === 'FINISHED') {
                        ctrl.isDuringPolling = false;
                        ctrl.isLoading = false;
                    }

                    if (ctrl.results.length) {
                        ctrl.isLoading = false;
                    }
                })
                .catch(function (e) {
                    ctrl.isError = true;
                    ctrl.isLoading = false;
                    ctrl.isDuringPolling = false;
                    console.error(e);
                });
        };

        this.makeNewSearch = function () {
            ctrl.isError = false;
            ctrl.isLoading = true;
            ctrl.isDuringPolling = true;

            this.search();
        };

        this.resetFilters = function () {
            ctrl.isDirectFlightsOnly = false;
        };

        this.$onInit = function () {
            this.search();
        };

        this.$onDestroy = function () {
            clearTimeout(this.timeOutId);
        };

        $scope.$on('search-button-clicked-broadcast', this.resetFilters);

        $scope.$watch(
            function () {
                return ctrl.isDirectFlightsOnly;
            },
            function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    ctrl.directFilterChangeHandler();
                }
            }
        );
    };

    controller.$inject = [
        '$scope',
        'sch.SearchQueryParams',
        'ExploreModeService',
        'SouthParkHelper',
        'ExploreModeIdService'
    ];

    angular
        .module('funnel')
        .component('exploreModeView', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/feedback-popup/ith-feedback-popup.controller.js
(function(angular) {
var IthFeedbackPopupController = function ($scope, type, title, message, button) {
        $scope.data = {
            type: type,
            title: title,
            message: message,
            button: button
        };
    };

    IthFeedbackPopupController.$inject = [
        '$scope',
        'type',
        'title',
        'message',
        'button'
    ];

    angular
        .module('funnel')
        .controller('FeedbackPopupController', IthFeedbackPopupController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/feedback-popup/ith-feedback-popup.service.js
(function(angular) {
var IthFeedbackPopupService = function ($modal) {
        /**
         * Opens an success modal popup
         *
         * @param {String} title
         * @param {String} message
         * @param {String} button
         */
        this.openSuccessPopup = function (title, message, button) {
            openPopup('success', title, message, button);
        };

        /**
         * Opens an error modal popup
         *
         * @param {String} title
         * @param {String} message
         * @param {String} button
         */
        this.openErrorPopup = function (title, message, button) {
            openPopup('error', title, message, button);
        };

        /**
         * Opens a modal popup
         *
         * @param {String} type 'success' | 'error'
         * @param {String} title
         * @param {String} message
         * @param {String} button
         */
        var openPopup = function (type, title, message, button) {
            $modal.open({
                controller: 'FeedbackPopupController',
                templateUrl: '/tpl/show/jsShared/templates/funnel/feedback-popup',
                backdrop: 'static',
                windowClass: 'ith-flights-outdated',
                resolve: {
                    type: function () { return type; },
                    title: function () { return title; },
                    message: function () { return message; },
                    button: function () { return button; }
                }
            });
        };

        return this;
    };

    IthFeedbackPopupService.$inject = [
        '$modal'
    ];

    angular
        .module('funnel')
        .service('FeedbackPopup', IthFeedbackPopupService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/checklist-filter/checklist-filter.component.js
(function (angular) {
var ChecklistFilterComponent = {
        bindings: {
            title: '@',
            checklist: '=',
            orderBy: '@',
            spHelper: '<'
        },
        controller: 'ChecklistFilterController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/checklist'
    };

    angular
        .module('funnel')
        .component('ithChecklistFilter', ChecklistFilterComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/checklist-filter/checklist-filter.controller.js
(function(angular) {
var ChecklistFilterController = function () {
        /**
         * Self reference
         *
         * @type {ChecklistFilterController}
         */
        var self = this;

        this.$onInit = function () {
            if (!this.orderBy) {
                this.orderBy = 'translation';
            }
        };

        /**
         * Formats the value with a translate function (if set)
         *
         * @returns {String}
         */
        this.functionAdapter = function (value) {
            return self.translateFn ? self.translateFn({ value: value }) : value;
        };

        /**
         * Toggles all values in the checklist
         *
         * @param {Boolean} value
         */
        this.toggleAll = function (value) {
            angular.forEach(this.checklist, function (item) {
                item.selected = value;
            });

            self.spHelper.applyFilters();
        };

        this.onCheckboxClick = function () {
            self.spHelper.applyFilters();
        };
    };

    angular
        .module('funnel')
        .controller('ChecklistFilterController', ChecklistFilterController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-categories/filter-categories.component.js
(function(angular) {
var IthFilterCategoriesComponent = {
        transclude: true,
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/categories/categories',
        controller: 'FilterCategoriesController',
        bindings: {
            filters: '=',
            spHelper: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFilterCategories', IthFilterCategoriesComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-categories/filter-categories.controller.js
(function(angular) {
var IthFilterCategoriesController = function ($document, $element, $scope, $location, $timeout, $rootScope, MediaMatch, ModalHelper) {
        /**
         * Self reference
         *
         * @type {IthFilterCategoriesController}
         */
        var self = this;

        /**
         * Array of tab data
         *
         * @type {Object[]}
         */
        this.tabs = [];

        /**
         * Active tab index, -1 means no active tab
         *
         * @type {Number}
         */
        this.activeTab = -1;

        /**
         * Object containing tab element x offset coordinate on the page relative to this element
         *
         * @type {Object}
         */
        this.tabOffset = 0;

        /**
         * Flag for mobile resolution
         *
         * @type {Boolean}
         */
        var isMobileResolution = true;

        var unregisterMobileFiltersWindow = null;

        /**
         * On init hook
         */
        this.$onInit = function () {
            var matchMediaQuery = MediaMatch.listen('(min-width: 768px)', function (event) {
                isMobileResolution = !event.matches;
            });

            isMobileResolution = !matchMediaQuery.matches;

            $scope.$on('filters', function () {
                // Filters triggered from outside. Ex: from the floating button on mobile
                self.switchTab(0);

                $location.hash('filters');

                $timeout(function () {
                    unregisterMobileFiltersWindow = $rootScope.$on('$locationChangeStart', function () {
                        self.closeActiveTab();
                    });
                });
            });
        };

        /**
         * On destroy hook
         */
        this.$onDestroy = function () {
            unbindEvents();
        };

        /**
         * Adds tab data to tabs array and returns its index
         *
         * @property {Object} tabData
         * @returns {Number}
         */
        this.addTab = function (tabData) {
            this.tabs.push(tabData);
            return this.tabs.length-1;
        };

        /**
         * Returns currently selected active tab index
         *
         * @returns {Number}
         */
        this.getCurrentActiveTab = function () {
            return this.activeTab;
        };

        /**
         * Returns current active tab x offset coordindate
         *
         * @returns {Number}
         */
        this.getCurrentActiveTabOffset = function () {
            return this.tabOffset;
        };

        /**
         * Toggles the active tab on/off
         *
         * @param {Number} index
         * @param {Event} $event
         */
        this.toggleActiveTab = function (index, $event) {
            var activeTabBounds = $event.target.getBoundingClientRect();
            var thisElementBouns = $element[0].getBoundingClientRect();
            this.tabOffset = activeTabBounds.x - thisElementBouns.x;

            this.switchTab(this.activeTab === index ? -1 : index);

            if (this.activeTab !== -1) {
                $event.stopPropagation();
                bindEvents();
            }

            if (this.activeTab === -1) {
                unbindEvents();
            }
        };

        /**
         * Switches active tab  by index
         *
         * @param {Number} index
         */
        this.switchTab = function (index) {
            this.activeTab = index;

            if (this.activeTab !== -1 && isMobileResolution) {
                ModalHelper.lockBodyScroll();
            }

            if (this.activeTab === -1  && isMobileResolution) {
                ModalHelper.unlockBodyScroll();
            }
        };

        /**
         * Closes active tab
         */
        this.closeActiveTab = function () {
            this.switchTab(-1);
            if (unregisterMobileFiltersWindow) {
                unregisterMobileFiltersWindow();
            }
        };

        /**
         * Checks if a categoryName contains one filter category or many
         *
         * @param {String} categoryName
         * @returns {Boolean}
         */
        this.isSingleCategory = function (categoryName) {
            return categoryName !== 'ALL';
        };

        /**
         * Returns category property from filters object based on category name
         *
         * @param {String} categoryName
         * @returns {String}
         */
        var getCategories = function (categoryName) {
            var categories = [];

            switch (categoryName) {
                case 'STOPS': categories.push('stops', 'stopDuration'); break;
                case 'FLIGHT_DURATION': categories.push('flightDuration'); break;
                case 'AIRPORTS': categories.push('originAirports', 'destinationAirports', 'layoverAirports'); break;
                case 'AIRLINES': categories.push('airlines'); break;
                case 'FLIGHT_HOURS': default: categories.push('hours'); break;
            }

            return categories;
        };

        /**
         * Check if a tab is "dirty" (modified)
         *
         * @param {String} categoryName
         * @returns {Boolean}
         */
        this.isTabDirty = function (categoryName) {
            var isDirty = false;

            angular.forEach(getCategories(categoryName), function (category) {
                if (self.filters.isDirty(category)) {
                    isDirty = true;
                }
            });

            return isDirty;
        };

        /**
         * Returns current active tab data
         *
         * @returns {Object}
         */
        this.getActiveTabData = function () {
            return this.tabs[this.activeTab];
        };

        /**
         * Resets a filter category by category name
         *
         * @param {String} categoryName
         * @param {Event} $event
         */
        this.resetCategory = function (categoryName, $event) {
            $event.stopPropagation();

            angular.forEach(getCategories(categoryName), function (category) {
                self.filters.resetCategory(category);
            });

            self.spHelper.applyFilters();
        };

        /**
         * Resets all filters
         */
        this.resetAll = function () {
            self.filters.resetAll();
            self.spHelper.applyFilters();
        };

        /**
         * Binds events for document clicks
         */
        var bindEvents = function () {
            $document.on('mousedown', onDocumentClick);
        };

        /**
         * Unbinds events for document clicks
         */
        var unbindEvents = function () {
            $document.off('mousedown', onDocumentClick);
        };

        /**
         * On document click handler, checks if click is outside of
         * current dropdown filter and if not, it closes it
         *
         * @param {Event} event
         */
        var onDocumentClick = function (event) {
            if (self.activeTab === -1 || isMobileResolution) {
                return;
            }

            var shouldCloseActiveTab = (
                // Click is outside of the open category
                !self.getActiveTabData().element.contains(event.target) &&

                // Click is not on the toggle button
                !event.target.classList.contains('ith-flight-filters__category__toggler')
            );

            if (shouldCloseActiveTab) {
                $scope.$evalAsync(function () {
                    self.closeActiveTab();
                });

                // Unbind the events
                unbindEvents();
            }
        };

        $scope.$on('search-button-clicked-broadcast', this.resetAll);
    };

    IthFilterCategoriesController.$inject = [
        '$document',
        '$element',
        '$scope',
        '$location',
        '$timeout',
        '$rootScope',
        'MediaMatch',
        'ModalHelper'
    ];

    angular
        .module('funnel')
        .controller('FilterCategoriesController', IthFilterCategoriesController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-categories/filter-category.component.js
(function (angular) {
var IthFilterCategoryComponent = {
        controller: 'FilterCategoryController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/categories/category',
        require: {
            ithFilterCategories: '^ithFilterCategories'
        },
        bindings: {
            title: '@',
            type: '@',
            offersCount: '<',
            spHelper: '<'
        },
        transclude: true
    };

    angular
        .module('funnel')
        .component('ithFilterCategory', IthFilterCategoryComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-categories/filter-category.controller.js
(function(angular) {
var IthFilterCategoryController = function ($element, $window, FlightOfferHelper) {
        /**
         * This category index
         *
         * @type {Number}
         */
        this.myIndex = 0;

        /**
         * Flight offer helper refrence
         *
         * @type {FlightOfferHelper}
         */
        this.flightOfferHelper = FlightOfferHelper;

        /**
         * On init hook
         */
        this.$onInit = function () {
            this.myIndex = this.ithFilterCategories.addTab({
                type: this.type,
                title: this.title,
                element: $element[0]
            });
        };

        /**
         * Checks if this category is active
         *
         * @returns {Boolean}
         */
        this.isActive = function () {
            return this.ithFilterCategories.getCurrentActiveTab() === this.myIndex;
        };

        /**
         * Closes this active category
         */
        this.close = function () {
            this.ithFilterCategories.closeActiveTab();
            $window.scrollTo(0, 0);
        };

        /**
         * Returns x offset coordinate for the dropdown element
         *
         * @returns {String}
         */
        this.getOffset = function () {
            return this.ithFilterCategories.getCurrentActiveTabOffset() + 'px';
        };

        /**
         * Checks if this tab is the general one (contains all filters)
         *
         * @returns {Boolean}
         */
        this.isGeneralTab = function () {
            return this.type === 'ALL';
        };

        /**
         * Resets all filters
         */
        this.resetAll = function () {
            this.ithFilterCategories.resetAll();
        };
    };

    IthFilterCategoryController.$inject = [
        '$element',
        '$window',
        'FlightOfferHelper'
    ];

    angular
        .module('funnel')
        .controller('FilterCategoryController', IthFilterCategoryController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-drawer/ith-filter-drawer.component.js
(function(angular) {
/**
     * @name        IthFilterDrawerComponent
     * @description Renders a slideable "drawer" component
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthFilterDrawerComponent = {
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/drawer',
        controller: 'FilterDrawerController',
        bindings: {
            isOpen: '=',
            title: '@',
            isLast: '<'
        },
        transclude: true
    };

    angular
        .module('funnel')
        .component('ithFilterDrawer', IthFilterDrawerComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-drawer/ith-filter-drawer.controller.js
(function (angular) {
/**
     * @name        IthFilterDrawerController
     * @description Manages data in the filter drawer component
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthFilterDrawerController = function () {
        /**
         * Toggles open/closed status
         */
        this.toggle = function () {
            this.isOpen = !this.isOpen;
        };
    };

    angular
        .module('funnel')
        .controller('FilterDrawerController', IthFilterDrawerController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-group/filter-group.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        var templateName = '';

        switch ($attrs.type) {
            case 'STOPS':
                templateName = 'stops';
                break;

            case 'FLIGHT_DURATION':
                templateName = 'flight-duration';
                break;

            case 'AIRPORTS':
                templateName = 'airports';
                break;

            case 'AIRLINES':
                templateName = 'airlines';
                break;

            case 'FLIGHT_HOURS':
                templateName = 'flight-hours';
                break;

            case 'PROVIDERS':
                templateName = 'providers';
                break;
        }

        return '/tpl/show/jsShared/templates/funnel/flight-filters/groups/' + templateName;
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    var IthFilterGroupComponent = {
        templateUrl: templateUrl,
        controller: 'FilterGroupController',
        bindings: {
            filters: '=',
            dictionary: '<',
            searchQueryParams: '<',
            spHelper: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFilterGroup', IthFilterGroupComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/filter-group/filter-group.controller.js
(function(angular) {
var IthFilterGroupController = function (FilterFormatters, LocationTranslator) {
        /**
         * Filter formatters reference
         *
         * @type {FilterFormatters}
         */
        this.formatters = FilterFormatters;

        /**
         *
         * @param {string} cityCode
         * @returns {string}
         */
        this.getCityName = function (cityCode) {
            return LocationTranslator.iataDictionary.getCityName(cityCode);
        };
    };

    IthFilterGroupController.$inject = [
        'FilterFormatters',
        'LocationTranslator'
    ];

    angular
        .module('funnel')
        .controller('FilterGroupController', IthFilterGroupController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/flight-filters.component.js
(function(angular) {
var IthFlightFiltersComponent = {
        controller: 'FlightFiltersController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/filters-bar',
        bindings: {
            filters: '=',
            dictionary: '<',
            searchQueryParams: '<',
            offersCount: '<',
            spHelper: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFlightFilters', IthFlightFiltersComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/flight-filters.controller.js
(function(angular) {
var IthFlightFiltersController = function ($scope, $window, $document, $translate, AppConfig, IthSearchFormTrigger) {
        /**
         * Self reference
         *
         * @type {IthFlightFiltersController}
         */
        var self = this;

        /**
         * Keeps track of opened drawers in the group view
         *
         * @type {Object}
         */
        this.drawers = {
            stops: false,
            flightDuration: false,
            airports: false,
            airlines: false,
            hours: false,
            providers: false
        };

        /**
         * Flag for displaying floating filters on mobile
         *
         * @type {Boolean}
         */
        this.showFloatingFilters = false;

        /**
         * On init hook
         */
        this.$onInit = function () {
            angular.element($window).bind('scroll', onScroll);
        };

        /**
         * On destroy hook
         */
        this.$onDestroy = function () {
            angular.element($window).unbind('scroll', onScroll);
        };

        /**
         * Returns category title lang
         *
         * @returns {String}
         */
        this.getCategoryTitleLang = function (type) {
            return $translate.instant('LANGM_JS_' + type + '_FILTER_CATEGORY');
        };

        /**
         * Opens general filters on mobile
         */
        this.openMobileFilters = function () {
            IthSearchFormTrigger.close();
            $scope.$broadcast('filters');
        };

        this.openChangeSearch = function () {
            IthSearchFormTrigger.open();
            this.scrollToTop();
        };

        this.getAppliedFilterCount = function () {
            return Object.keys(this.filters.appliedFilters).length;
        };

        /**
         * Scrolls to top of the page using animation
         */
        this.scrollToTop = function () {
            $document[0].body.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        };

        this.isAgent = function () {
            return AppConfig.isAgent();
        };

        /**
         * On scroll handler - shows/hides floating filters button on mobile
         */
        var onScroll = function () {
            var showFiltersOffset = 250;

            if ($window.scrollY >= showFiltersOffset && !self.showFloatingFilters) {
                $scope.$evalAsync(function () {
                    self.showFloatingFilters = true;
                });
            }

            if ($window.scrollY < showFiltersOffset && self.showFloatingFilters) {
                $scope.$evalAsync(function () {
                    self.showFloatingFilters = false;
                });
            }
        };
    };

    IthFlightFiltersController.$inject = [
        '$scope',
        '$window',
        '$document',
        '$translate',
        'appConfig',
        'IthSearchFormTrigger'
    ];

    angular
        .module('funnel')
        .controller('FlightFiltersController', IthFlightFiltersController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/slider-filter/slider-filter.component.js
(function(angular) {
var SliderFilterComponent = {
        bindings: {
            title: '@',
            model: '=',
            high: '=?',
            floor: '<',
            ceil: '<',
            step: '<',
            translateFn: '&',
            spHelper: '<'
        },
        controller: 'SliderFilterController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/slider'
    };

    angular
        .module('funnel')
        .component('ithSliderFilter', SliderFilterComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/slider-filter/slider-filter.controller.js
(function(angular) {
var SliderFilterController = function ($scope) {
        /**
         * Self reference
         * @type {SliderFilterController}
         */
        var self = this;

        /**
         * Re-renders rz-slider
         *
         * @private
         */
        var reRenderSlider = function () {
            $scope.$broadcast('reCalcViewDimensions');
            $scope.$broadcast('rzSliderForceRender');
        };

        /**
         * On init hook
         */
        this.$onInit = function () {
            $scope.$evalAsync(function () {
                reRenderSlider();
            });
        };

        /**
         * Formats the value with a translate function (if set)
         *
         * @returns {String}
         */
        this.functionAdapter = function (value) {
            return self.translateFn ? self.translateFn({ value: value }) : value;
        };

        /**
         * Slider plugin config
         *
         * @type {Object}
         */
        this.options = {
            step: this.step || 1,
            showSelectionBar: true,
            floor: this.floor || 0,
            ceil: this.ceil || 100,
            translate: this.functionAdapter,
            onEnd: function () {
                self.spHelper.applyFilters();
            }
        };
    };

    SliderFilterController.$inject = [
        '$scope'
    ];

    angular
        .module('funnel')
        .controller('SliderFilterController', SliderFilterController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/tab-filters/tab-filter-types.constant.js
(function(angular) {
angular
        .module('funnel')
        .constant('TabFilterTypes', {
            best: 'best',
            cheapest: 'cheapest',
            fastest: 'fastest'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/tab-filters/tab-filter.component.js
(function(angular) {
var IthTabFilterComponent = {
        controller: 'TabFilterController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/tab-filter',
        bindings: {
            tabData: '<',
            isActive: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithTabFilter', IthTabFilterComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/tab-filters/tab-filter.controller.js
(function(angular) {
var IthTabFilterController = function (FlightOfferHelper, $filter, TabFilterTypes) {
        /**
         * Returns title lang
         *
         * @returns {String}
         */
        this.getLang = function () {
            return 'LANGM_JS_SM_TAB_' + this.tabData.id.toUpperCase();
        };

        /**
         * Checks if this tab is the best tab
         *
         * @returns {Boolean}
         */
        this.isBestTab = function () {
            return this.tabData.id === TabFilterTypes.best;
        };

        /**
         * Returns best tab info tooltip content
         *
         * @returns {String}
         */
        this.getBestTabDescription = function () {
            return $filter('translate')('LANGM_JS_FS_BEST_TAB_INFO');
        };

        /**
         * Returns price (with TF for agents, without TF for users)
         *
         * @returns {Number}
         */
        this.getPrice = function () {
            return FlightOfferHelper.getOfferPrice(this.tabData.offer);
        };
    };

    IthTabFilterController.$inject = [
        'FlightOfferHelper',
        '$filter',
        'TabFilterTypes'
    ];

    angular
        .module('funnel')
        .controller('TabFilterController', IthTabFilterController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/tab-filters/tab-filters.component.js
(function(angular) {
var IthTabFiltersComponent = {
        controller: 'TabFiltersController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-filters/tab-filters',
        bindings: {
            data: '<',
            activeTab: '='
        }
    };

    angular
        .module('funnel')
        .component('ithTabFilters', IthTabFiltersComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-filters/tab-filters/tab-filters.controller.js
(function(angular) {
var IthTabFiltersController = function ($scope) {
        /**
         * Switches active tab
         *
         * @param {String} tabId
         */
        this.switchTab = function (tabId) {
            var self = this;

            $scope.$applyAsync(function () {
                self.activeTab = tabId;
            });
        };

        /**
         * Checks if tab is active
         *
         * @param {String} tabId
         * @returns {Boolean}
         */
        this.isTabActive = function (tabId) {
            return this.activeTab === tabId;
        };
    };

    IthTabFiltersController.$inject = [
        '$scope'
    ];

    angular
        .module('funnel')
        .controller('TabFiltersController', IthTabFiltersController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-no-offers/ith-flight-no-offers.component.js
(function(angular) {
var IthFlightNoOffersComponent = {
        controller: 'FlightNoOffersController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-no-offers',
        bindings: {
            originalOffers: '<',
            filteredOffers: '<',
            filters: '=',
            southParkHelper: '<',
            isError: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFlightNoOffers', IthFlightNoOffersComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-no-offers/ith-flight-no-offers.controller.js
(function(angular) {
var IthFlightNoOffersController = function () {
        /**
         * Refreshes current state
         */
        this.refresh = function () {
            this.southParkHelper.search();
        };

        /**
         * Resets all filters
         */
        this.resetFilters = function () {
            this.filters.resetAll();
            this.southParkHelper.applyFilters();
        };
    };

    angular
        .module('funnel')
        .controller('FlightNoOffersController', IthFlightNoOffersController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/fake-flight-offer.model.js
(function (angular) {
var IthFakeFlightOfferModel = function (FlightOfferModel) {
        /**
         * @constructor
         */
        var FakeFlightOfferModel = function (isOneWay) {
            var returnStage = {
                'originCity': 'LON',
                'destinationCity': 'BUH',
                'departure': '2020-11-21T06:25:00',
                'arrival': '2020-11-21T08:45:00',
                'segments': [
                    {
                        'marketingCarrier': 'AF',
                        'operatingCarrier': 'AF',
                        'duration': 80,
                        'originAirport': 'LHR',
                        'destinationAirport': 'OTP',
                        'originCity': 'LON',
                        'destinationCity': 'BUH',
                        'departure': '2020-11-21T06:25:00',
                        'arrival': '2020-11-21T08:45:00'
                    }
                ],
                'duration': 80
            };

            var mock = {
                'score': {
                    'best': 12.895149076068554,
                    'price': 283.9,
                    'duration': 870.0
                },
                'stages': [
                    {
                        'originCity': 'BUH',
                        'destinationCity': 'LON',
                        'departure': '2020-11-10T14:25:00',
                        'arrival': '2020-11-10T16:35:00',
                        'segments': [
                            {
                                'marketingCarrier': 'AF',
                                'operatingCarrier': 'AF',
                                'duration': 190,
                                'originAirport': 'OTP',
                                'destinationAirport': 'LHR',
                                'originCity': 'BUH',
                                'destinationCity': 'LON',
                                'departure': '2020-11-10T14:25:00',
                                'arrival': '2020-11-10T16:35:00',
                                'flightNumber': '1889'
                            }
                        ],
                        'duration': 190
                    }
                ],
                'fees': {
                    'transactionFee': {
                        'amount': 15.00,
                        'currency': 'EUR'
                    },
                    'transactionFeeVersion': 'a'
                },
                'travelHash': '',
                'fulfillmentToken': ''
            };

            if (!isOneWay) {
                mock.stages.push(returnStage);
            }

            return new FlightOfferModel(mock);
        };

        FakeFlightOfferModel.prototype.constructor = FakeFlightOfferModel;

        return FakeFlightOfferModel;
    };

    IthFakeFlightOfferModel.$inject = [
        'FlightOfferModel'
    ];

    angular
        .module('funnel')
        .factory('FakeFlightOfferModel', IthFakeFlightOfferModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offer-journey-entry.model.js
(function(angular) {
var IthFlightOfferJourneyEntryModel = function ($filter, FlightOfferJourneyTypes) {
        /**
         * @constructor
         *
        * @param {FlightOfferJourneyTypes} type
        * @param {String} hour
        * @param {Number} duration
         */
        var FlightOfferJourneyEntryModel = function (type, hour, duration) {
            this.type = type;
            this.hour = hour || '';
            this.hourFormatted = $filter('date')(hour, 'HH:mm');
            this.duration = duration || '';
            this.durationFormatted = $filter('formatDuration')(duration);
        };

        FlightOfferJourneyEntryModel.prototype.isDuration = function () {
            return this.type === FlightOfferJourneyTypes.flight || this.type === FlightOfferJourneyTypes.stopover;
        };

        FlightOfferJourneyEntryModel.prototype.isHour = function () {
            return this.type === FlightOfferJourneyTypes.city;
        };

        FlightOfferJourneyEntryModel.prototype.isStopover = function () {
            return this.type === FlightOfferJourneyTypes.stopover;
        };

        FlightOfferJourneyEntryModel.prototype.constructor = FlightOfferJourneyEntryModel;

        return FlightOfferJourneyEntryModel;
    };

    IthFlightOfferJourneyEntryModel.$inject = [
        '$filter',
        'FlightOfferJourneyTypes'
    ];

    angular
        .module('funnel')
        .factory('FlightOfferJourneyEntryModel', IthFlightOfferJourneyEntryModel)
        .constant('FlightOfferJourneyTypes', {
            stopover: 'stopover',
            flight: 'flight',
            city: 'city'
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offer-stage-segment.model.js
(function(angular) {
var IthFlightOfferStageSegmentModel = function () {
        /**
         * @constructor
         */
        var FlightOfferStageSegmentModel = function (segment) {
            /**
             * Departure date
             *
             * @type {String}
             */
            this.departure = segment.departure;

            /**
             * Arrival date
             *
             * @type {String}
             */
            this.arrival = segment.arrival;

            /**
             * Origin city code
             *
             * @type {String}
             */
            this.originCity = segment.originCity;

            /**
             * Destination city code
             *
             * @type {String}
             */
            this.destinationCity = segment.destinationCity;

            /**
             * Origin airport code
             *
             * @type {String}
             */
            this.originAirport = segment.originAirport;

            /**
             * Destination airport code
             *
             * @type {String}
             */
            this.destinationAirport = segment.destinationAirport;

            /**
             * Segment duration
             *
             * @type {Number}
             */
            this.duration = segment.duration;

            /**
             * Equipment ?
             *
             * @type {String}
             */
            this.equipment = segment.equipment;

            /**
             * Flight number
             *
             * @type {String}
             */
            this.flightNumber = segment.flightNumber;

            /**
             * Marketing carrier code
             *
             * @type {String}
             */
            this.marketingCarrier = segment.marketingCarrier;

            /**
             * Operating carrier code
             *
             * @type {String}
             */
            this.operatingCarrier = segment.operatingCarrier;

            /**
             * Refueling stopovers
             *
             * @type {Array}
             */
            this.stopovers = segment.stopovers;
        };

        FlightOfferStageSegmentModel.prototype.constructor = FlightOfferStageSegmentModel;

        return FlightOfferStageSegmentModel;
    };

    angular
        .module('funnel')
        .factory('FlightOfferStageSegmentModel', IthFlightOfferStageSegmentModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offer-stage.model.js
(function(angular) {
var IthFlightOfferStageModel = function ($filter, FlightOfferStageSegmentModel, FlightOfferHelper, FilterFormatters, appConfig) {
        /**
         * @constructor
         */
        var FlightOfferStageModel = function (stage, previousStage) {
            /**
             * Self reference
             *
             * @type {FlightOfferStageModel}
             */
            var self = this;

            /**
             * Departure date
             *
             * @type {String}
             */
            this.departure = stage.departure;

            /**
             * Departure hour
             *
             * @type {String}
             */
            this.departureHour = $filter('date')(stage.departure, 'HH:mm');

            /**
             * Departure date formatted
             *
             * @type {String}
             */
            this.departureDateFormatted = $filter('date')(stage.departure, 'dd MMM yyyy');
            var isFake = moment(stage.departure).format('YYYY') === '2020';
            this.departureDateFormatted2 = isFake
                ? ''
                : moment(stage.departure)
                    .format(appConfig.getIsChangedButtonFlowAbTest () ? 'dd, DD MMM' : 'ddd, DD.MM.YY');
            /**
             * Arrival date
             *
             * @type {String}
             */
            this.arrival = stage.arrival;

            /**
             * Arrival hour
             *
             * @type {String}
             */
            this.arrivalHour = $filter('date')(stage.arrival, 'HH:mm');

            /**
             * Arrival date formatted
             *
             * @type {String}
             */
            this.arrivalDateFormatted = $filter('date')(stage.arrival, 'dd MMM yyyy');

            /**
             * Origin city code
             *
             * @type {String}
             */
            this.originCity = stage.originCity;

            /**
             * Origin airport code
             *
             * @type {String}
             */
            this.originAirport = FlightOfferHelper.getStageOriginAriport(stage);

            /**
             * Destination city code
             *
             * @type {String}
             */
            this.destinationCity = stage.destinationCity;

            /**
             * Destination airport code
             *
             * @type {String}
             */
            this.destinationAirport = FlightOfferHelper.getStageDestinationAirport(stage);

            /**
             * Stage duration
             *
             * @type {Number}
             */
            this.duration = stage.duration;

            /**
             * Stage duration formatted
             *
             * @type {String}
             */
            this.durationFormatted = $filter('formatDuration')(stage.duration);

            /**
             * Airline codes
             *
             * @type {String[]}
             */
            this.airlines = FlightOfferHelper.getStageAirlines(stage);

            /**
             * Stopovers
             *
             * @type {Array}
             */
            this.stopovers = FlightOfferHelper.getStageStops(stage);

            /**
             * Segments
             *
             * @type {FlightOfferStageSegmentModel[]}
             */
            this.segments = [];

            /**
             * Has airport change between stages
             *
             * @type {Boolean}
             */
            this.hasAirportChange = previousStage !== null && previousStage.destinationAirport !== this.originAirport;

            /**
             * Has airport change between segments
             *
             * @type {Boolean}
             */
            this.hasStopoverAirportChange = FlightOfferHelper.hasStopoverAirportChange(this.stopovers);

            /**
             * Has any overnight stopovers
             *
             * @type {Boolean}
             */
            this.hasStopoverOvernight = FlightOfferHelper.hasStopoverOvernight(this.stopovers);

            /**
             * Flight arrives same day
             *
             * @type {Boolean}
             */
            this.arrivesSameDay = FilterFormatters.isSameDay(this.departure, this.arrival);

            /**
             * Journey information for tooltip
             *
             * @type {Object}
             */
            this.journey = FlightOfferHelper.getJourneyData(stage);

            angular.forEach(stage.segments, function (segment) {
                self.segments.push(new FlightOfferStageSegmentModel(segment));
            });
        };

        FlightOfferStageModel.prototype.getFirstSegment = function () {
            return this.segments[0];
        };

        FlightOfferStageModel.prototype.getLastSegment = function () {
            return this.segments[this.segments.length - 1];
        };

        FlightOfferStageModel.prototype.constructor = FlightOfferStageModel;

        return FlightOfferStageModel;
    };

    IthFlightOfferStageModel.$inject = [
        '$filter',
        'FlightOfferStageSegmentModel',
        'FlightOfferHelper',
        'FilterFormatters',
        'appConfig'
    ];

    angular
        .module('funnel')
        .factory('FlightOfferStageModel', IthFlightOfferStageModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offer.helper.js
(function(angular, underscore) {
var IthFlightOfferHelper = function ($filter, FilterFormatters, FlightOfferJourneyEntryModel, FlightOfferJourneyTypes, AuthService) {
        /**
         * Returns data used for filtering for a flight offer
         *
         * @param {Object} offer
         * @returns {Object}
         */
        this.getOfferFilterData = function (offer) {
            var airlines = [];
            var airports = [];
            var originAirports = [];
            var destinationAirports = [];
            var layoverAirports = [];
            var airportCityMapping = {};
            var stops = [];
            var maxStopDuration = 0;
            var maxFlightDuration = 0;
            var depTakeoff = 0;
            var depLanding = 0;
            var retTakeoff = 0;
            var retLanding = 0;
            var providers = [];

            underscore.forEach(offer.stages, function (stage, stageIndex) {
                var prevSegment = null;

                if (stageIndex === 0) {
                    depTakeoff = FilterFormatters.minutesSinceMidnight(stage.departure);
                    depLanding = FilterFormatters.minutesSinceMidnight(stage.arrival);
                    originAirports.push(stage.originAirport);
                    destinationAirports.push(stage.destinationAirport);
                }

                if (stageIndex === 1) {
                    retTakeoff = FilterFormatters.minutesSinceMidnight(stage.departure);
                    retLanding = FilterFormatters.minutesSinceMidnight(stage.arrival);
                    originAirports.push(stage.destinationAirport);
                    destinationAirports.push(stage.originAirport);
                }

                // Set airport city mapping
                airportCityMapping[stage.originAirport] = stage.originCity;
                airportCityMapping[stage.destinationAirport] = stage.destinationCity;

                maxFlightDuration = stage.duration > maxFlightDuration ? stage.duration : maxFlightDuration;
                stops.push(stage.segments.length - 1);

                underscore.forEach(stage.segments, function (segment) {
                    if (prevSegment != null) {
                        var stopDuration = FilterFormatters.minuteDateDiff(new Date(prevSegment.arrival), new Date(segment.departure));
                        maxStopDuration = stopDuration > maxStopDuration ? stopDuration : maxStopDuration;
                    }

                    airlines.push(segment.marketingCarrier);
                    airports.push(segment.originAirport, segment.destinationAirport);

                    if (segment.originCity !== stage.originCity) {
                        layoverAirports.push(segment.originAirport);
                        airportCityMapping[segment.originAirport] = segment.originCity;
                    }

                    if (segment.destinationCity !== stage.destinationCity) {
                        layoverAirports.push(segment.destinationAirport);
                        airportCityMapping[segment.destinationAirport] = segment.destinationCity;
                    }

                    prevSegment = segment;
                });
            });

            underscore.forEach(offer.tickets, function (ticket) {
                if (ticket.hasOwnProperty('provider') && ticket.provider) {
                    providers.push(ticket.provider.name);
                }
            });

            return {
                airlines: underscore.uniq(airlines),
                airports: underscore.uniq(airports),
                originAirports: underscore.uniq(originAirports),
                destinationAirports: underscore.uniq(destinationAirports),
                layoverAirports: underscore.uniq(layoverAirports),
                providers: underscore.uniq(providers),
                airportCityMapping: airportCityMapping,
                stops: underscore.max(stops),
                maxStopDuration: maxStopDuration,
                maxFlightDuration: maxFlightDuration,
                depTakeoff: depTakeoff,
                depLanding: depLanding,
                retTakeoff: retTakeoff,
                retLanding: retLanding
            };
        };

        /**
         * Returns stage number of stopovers
         *
         * @param {Object} stage
         * @returns {Number}
         */
        this.getStageStopCount = function (stage) {
            return stage.segments.length - 1;
        };

        /**
         * Returns stage stopover array
         *
         * @param {Object} stage
         * @returns {Object[]}
         */
        this.getStageStops = function (stage) {
            var stops = [];

            underscore.each(stage.segments, function (segment, index) {
                if (typeof stage.segments[index + 1] !== 'undefined') {
                    var nextSegment = stage.segments[index + 1];

                    stops.push({
                        id: segment.destinationCity + index,
                        cityCode: segment.destinationCity,
                        originCityCode: segment.originCity,
                        originAirport: segment.originAirport,
                        landingAirport: segment.destinationAirport,
                        landingTime: segment.arrival,
                        landingTimeFormatted: $filter('date')(segment.arrival, 'HH:mm'),
                        takeoffTime: nextSegment.departure,
                        takeoffTimeFormatted: $filter('date')(nextSegment.departure, 'HH:mm'),
                        takeoffAirport: nextSegment.originAirport,
                        duration: FilterFormatters.minuteDateDiff(new Date(nextSegment.departure), new Date(segment.arrival)),
                        isOvernight: isOvernight(segment.arrival, nextSegment.departure),
                        hasAirportChange: segment.destinationAirport !== nextSegment.originAirport,
                        flightNumber: segment.flightNumber,
                        operatingCarrier: segment.operatingCarrier,
                        marketingCarrier: segment.marketingCarrier,
                        stops: segment.stopovers
                    });
                }
            });

            return stops;
        };

        /**
         * Returns stage airline codes
         *
         * @param {Object} stage
         * @returns {String[]}
         */
        this.getStageAirlines = function (stage) {
            return underscore.uniq(underscore.map(stage.segments, function (segment) {
                if (segment.marketingCarrier) {
                    return segment.marketingCarrier;
                }

                return segment.operatingCarrier;
            }));
        };

        /**
         * Returns stage origin airport code
         *
         * @param {Object} stage
         * @returns {String}
         */
        this.getStageOriginAriport = function (stage) {
            return stage.segments[0].originAirport;
        };

        /**
         * Returns stage destination airport code
         *
         * @param {Object} stage
         * @returns {String}
         */
        this.getStageDestinationAirport = function (stage) {
            return stage.segments[stage.segments.length - 1].destinationAirport;
        };

        /**
         * Retuens stage journey data used for the stops tooltip
         *
         * @param {Stage}
         * @returns {Object}
         */
        this.getJourneyData = function (stage) {
            var data = {
                cities: [],
                hours: []
            };

            underscore.each(stage.segments, function (segment, index, list) {
                if (index > 0 && index < list.length - 1 && list.length > 2) {
                    data.cities.push(null);
                }

                if (index === 0) {
                    data.cities.push(segment.originCity);
                }

                data.cities.push(segment.destinationCity);

                if (index > 0) {
                    var stopoverDuration = FilterFormatters.minuteDateDiff(
                        new Date(list[index - 1].arrival),
                        new Date(segment.departure)
                    );

                    data.hours.push(
                        new FlightOfferJourneyEntryModel(FlightOfferJourneyTypes.stopover, null, stopoverDuration)
                    );
                }

                data.hours.push(
                    new FlightOfferJourneyEntryModel(FlightOfferJourneyTypes.city, segment.departure, null),
                    new FlightOfferJourneyEntryModel(FlightOfferJourneyTypes.flight, null, segment.duration),
                    new FlightOfferJourneyEntryModel(FlightOfferJourneyTypes.city, segment.arrival, null)
                );
            });

            return data;
        };

        /**
         * Returns price with TF for agents and price without TF for users
         *
         * @param {FlightOfferModel} offer
         * @returns {Number}
         */
        this.getOfferPrice = function (offer) {
            if (!offer) {
                return 0;
            }

            if (AuthService.isAgent()) {
                return offer.getPriceWithTf();
            }

            return offer.getPriceWithoutTf();
        };

        /**
         * Checks if any stopover has airport change
         *
         * @param {Object[]} stopovers
         * @returns {Boolean}
         */
        this.hasStopoverAirportChange = function (stopovers) {
            var airportChangeStop = underscore.findWhere(stopovers, { hasAirportChange: true });
            return typeof airportChangeStop !== 'undefined';
        };

        /**
         * Checks if any stopover is overnight
         *
         * @param {Object[]} stopovers
         * @returns {Boolean}
         */
        this.hasStopoverOvernight = function (stopovers) {
            var overnightStop = underscore.findWhere(stopovers, { isOvernight: true });
            return typeof overnightStop !== 'undefined';
        };

        /**
         * Checks if a layover is overnight based on landing and takeoff dates
         *
         * @param {String} landingDate
         * @param {String} takeoffDate
         * @returns {Boolean}
         */
        var isOvernight = function (landingDate, takeoffDate) {
            var landingMinsSinceMidnight = FilterFormatters.minutesSinceMidnight(landingDate);
            var takeoffMinsSinceMidnight = FilterFormatters.minutesSinceMidnight(takeoffDate);
            var isSameDay = FilterFormatters.isSameDay(landingDate, takeoffDate);
            return landingMinsSinceMidnight <= 1380 && takeoffMinsSinceMidnight >= 300 && !isSameDay;
        };
    };

    IthFlightOfferHelper.$inject = [
        '$filter',
        'FilterFormatters',
        'FlightOfferJourneyEntryModel',
        'FlightOfferJourneyTypes',
        'AuthService'
    ];

    angular
        .module('funnel')
        .service('FlightOfferHelper', IthFlightOfferHelper);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offer.model.js
(function(angular) {
var IthFlightOfferModel = function (FlightOfferStageModel, appConfig) {
        /**
         * Returns id for grouping offers. In case of deduplicated flights the travelHash format
         * will be travelHash_Provider
         *
         * @param {String} travelHash
         * @returns {String}
         */
        var getCleanTravelHash = function (travelHash) {
            return travelHash.split('_')[0];
        };

        var getUniqueCarriers = function (stages) {
            var airlines = [];

            stages.forEach(function (stage) {
                stage.airlines.forEach(function (al) {
                    airlines.push(al)
                })
            })

            airlines = airlines.filter(function (value, index, array) {
                return array.indexOf(value) === index;
            })

            return airlines;
        }

        /**
         * @constructor
         */
        var FlightOfferModel = function (offerData) {
            /**
             * Self reference
             *
             * @type {FlightOfferModel}
             */
            var self = this;

            /**
             * Debug information
             *
             * @type {Object}
             */
            this.debug = appConfig.isAgent() && offerData.debug || null;

            /**
             * Flag for hiding/displaying the debug infor
             *
             * @type {Boolean}
             */
            this.showDebug = false;

            /**
             * Flight offer fulfillment token
             *
             * @type {String}
             */
            this.fulfillmentToken = offerData.fulfillmentToken;

            /**
             * Travel hash
             *
             * @type {String}
             */
            this.travelHash = getCleanTravelHash(offerData.travelHash);

            /**
             * A combination of travel hash and timestamp of retrieval
             *
             * @type {String}
             */
            this.uniqueId = offerData.travelHash;

            /**
             * Unique id for rendering the list on frontend correctly
             *
             * @type {String}
             */
            this.listId = offerData.travelHash + '-' + Date.now();

            /**
             * Score
             *
             * @type {Object}
             */
            this.score = offerData.score;

            /**
             * Transaction fees object
             *
             * @type {Object}
             */
            this.fees = offerData.fees;

            /**
             * Tickets
             *
             * @type {Object[]}
             */
            this.tickets = offerData.tickets;

            /**
             * Flight category
             *
             * @type {String}
             */
            this.category = offerData.category || null;

            /**
             * Flight subtype
             *
             * @type {String}
             */
            this.subtype = offerData.subtype || null;

            /**
             * Flight type
             *
             * @type {String}
             */
            this.type = offerData.type || null;

            /**
             * Stages
             *
             * @type {FlightOfferStageModel[]}
             */
            this.stages = [];

            // Remember price with no service fee for sorting
            this.score.priceNoSf = this.getPriceWithoutTf();

            angular.forEach(offerData.stages, function (stage, index) {
                var previousStageModel = index === 1 ? self.stages[0] : null;
                var stageModel = new FlightOfferStageModel(stage, previousStageModel);
                self.stages.push(stageModel);
            });

            this.uniqueCarriers = getUniqueCarriers(this.stages);

            this.hasManyAirlines = this.uniqueCarriers.length > 1;

            /**
             * Fare lock
             *
             * @type {Object}
             */
            this.fareLock = offerData.fareLock;
        };

        /**
         * Checks if IBE sent debug information
         *
         * @returns {Boolean}
         */
        FlightOfferModel.prototype.hasDebug = function () {
            return this.debug !== null;
        };

        FlightOfferModel.prototype.toggleDebug = function (event) {
            event.stopPropagation();
            this.showDebug = !this.showDebug;
        };

        /**
         * Returns price with tf (for agents)
         *
         * @returns {Number}
         */
        FlightOfferModel.prototype.getPriceWithTf = function() {
            return this.score.price;
        };

        /**
         * Returns price without TF (for users)
         *
         * @returns {Number}
         */
        FlightOfferModel.prototype.getPriceWithoutTf = function () {
            return this.score.price - this.fees.transactionFee.amount;
        };

        /**
         * Returns price per ADT pax or fallback to any type
         *
         * @returns {Object}
         */
        FlightOfferModel.prototype.getPricePerPax = function () {
            var total = 0;
            var currency = this.tickets[0].fares[0].pricePerPassenger[0].total.currency;

            angular.forEach(this.tickets, function (ticket) {
                total += ticket.fares[0].pricePerPassenger[0].total.amount;
            });

            return {
                amount: total,
                currency: currency
            };
        };

        /**
         * Checks if flight is round-trip
         *
         * @returns {Boolean}
         */
        FlightOfferModel.prototype.isRoundTrip = function () {
            return this.stages.length > 1;
        };

        FlightOfferModel.prototype.constructor = FlightOfferModel;

        return FlightOfferModel;
    };

    IthFlightOfferModel.$inject = [
        'FlightOfferStageModel',
        'appConfig',
    ];

    angular
        .module('funnel')
        .factory('FlightOfferModel', IthFlightOfferModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offers.component.js
(function(angular) {
var IthFlightOffersComponent = {
        templateUrl: '/tpl/show/jsShared/templates/funnel/flight-offers',
        controller: 'FlightOffersController',
        bindings: {
            offers: '<',
            requestId: '<',
            sessionId: '<',
            searchQueryParams: '<',
            dictionary: '<',
            flightsLoading: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFlightOffers', IthFlightOffersComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offers.controller.js
(function(angular) {
var FlightOffersController = function ($timeout, FlightOfferHelper, $scope, appConfig) {
        /**
         * Offers per page config value
         *
         * @type {Number}
         */
        var offersPerPageStep = appConfig.getIsChangedButtonFlowAbTest() ? 15 : 30;

        /**
         * Loading more flights flag
         *
         * @type {Boolean}
         */
        var loadingMoreFlights = false;

        /**
         * Visible offers timeout promise
         *
         * @type {Promise}
         */
        var visibleOffersTimeout;

        /**
         * How many offers to display on the page
         *
         * @type {Number}
         */
        this.limit = offersPerPageStep;

        /**
         * Collection of flight offers displayed in the search page
         *
         * @type {FlightOfferModel[]}
         */
        this.visibleOffers = [];

        /**
         * On binding update
         */
        this.$onChanges = function (changes) {
            // Reset list to 30 flights when flight list changes
            // This will happen when user changes the tab or filters flights
            // Keeping a shorter list makes the page more responsive
            if (changes.hasOwnProperty('offers')) {
                this.limit = offersPerPageStep;

                if (!this.flightsLoading) {
                    var self = this;

                    if (visibleOffersTimeout) {
                        $timeout.cancel(visibleOffersTimeout);
                    }

                    visibleOffersTimeout = $timeout(function () {
                        self.visibleOffers = self.offers;
                    });
                }

                if (this.flightsLoading) {
                    this.visibleOffers = this.offers;
                }
            }
        };

        /**
         * Increases limit of displayed offers
         */
        this.loadMoreClick = function () {
            var self = this;
            loadingMoreFlights = true;

            $timeout(function () {
                self.limit += offersPerPageStep;
                loadingMoreFlights = false;
            }, 300);
        };

        /**
         * Checks if the "show more" button shoiuld be displayed
         *
         * @returns {Boolean}
         */
        this.shouldShowMoreButton = function () {
            return this.limit < this.visibleOffers.length && !loadingMoreFlights;
        };

        /**
         * Checks if loading more flights loader should be displayed
         *
         * @returns {Boolean}
         */
        this.shouldShowLoadingMoreLoader = function () {
            return loadingMoreFlights;
        };

        /**
         * Returns proper offer price
         *
         * @param {FlightOfferModel}
         * @returns {Number}
         */
        this.getOfferPrice = function (data) {
            return FlightOfferHelper.getOfferPrice(data);
        };

        /**
         *
         * @param {FlightOfferModel} offer
         * @returns {string}
         */
        this.getFlightRoute = function (offer) {
            return offer.stages[0].originCity + offer.stages[0].destinationCity;
        };

        this.clickHandler = function (offer) {
            $scope.$broadcast('flight-offer-clicked', offer.uniqueId);

        }

        this.isChangedButtonsFlow = function () {
            return appConfig.getIsChangedButtonFlowAbTest();
        }
    };

    FlightOffersController.$inject = [
        '$timeout',
        'FlightOfferHelper',
        '$scope',
        'appConfig',
    ];

    angular
        .module('funnel')
        .controller('FlightOffersController', FlightOffersController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-offers/flight-offers.filter.js
(function (angular, underscore) {
var IthFlightOffersFilter = function (FlightOfferHelper) {
        /**
         * Get a list of all selected items from a fiter checklist
         *
         * @param {Object[]} checkList
         * @returns {String[]}
         */
        var getSelectedChecklistItems = function (checkList) {
            return underscore.pluck(
                underscore.where(checkList, { selected: true }),
                'code'
            );
        };

        /**
         * Filters offer list by selected airline codes
         *
         * @param {Object[]} offerFilterData
         * @param {Object[]} airlineFilterChecklist
         * @returns {Object[]}
         */
        var filterByAirlineCodes = function (offerFilterData, airlineFilterChecklist) {
            return underscore.every(offerFilterData.airlines, function (airline) {
                return underscore.contains(
                    getSelectedChecklistItems(airlineFilterChecklist),
                    airline
                );
            });
        };

        /**
         * Filters offer list by selected providers
         *
         * @param {Object[]} offerFilterData
         * @param {Object[]} airlineFilterChecklist
         * @returns {Object[]}
         */
        var filterByProviders = function (offerFilterData, providerFilterChecklist) {
            return underscore.every(offerFilterData.providers, function (provider) {
                return underscore.contains(
                    getSelectedChecklistItems(providerFilterChecklist),
                    provider
                );
            });
        };

        /**
         * Filters offer list by selected airport codes
         *
         * @param {Object[]} offerFilterData
         * @param {Object} filterData
         * @param {String} property
         * @returns {Object[]}
         */
        var filterByAirportCodes = function (offerFilterData, filterData, property) {
            return underscore.every(offerFilterData[property], function (airport) {
                return underscore.contains(
                    getSelectedChecklistItems(filterData[property]),
                    airport
                );
            });
        };

        /**
         * Filters offer list by number of stops
         *
         * @param {Object[]} offerFilterData
         * @param {Object[]} stopsChecklist
         * @returns {Object[]}
         */
        var filterByStops = function (offerFilterData, stopsChecklist) {
            return underscore.contains(
                getSelectedChecklistItems(stopsChecklist),
                offerFilterData.stops
            );
        };

        /**
         * Checks to see if value is lower or equal to slider value
         *
         * @param {Number} value
         * @param {Number} sliderValue
         * @returns {Boolean}
         */
        var filterByMaxSliderValue = function (value, sliderValue) {
            return value <= sliderValue;
        };

        /**
         * Checks to see if value is between range slider values
         *
         * @param {Number} value
         * @param {Object} sliderRange
         * @returns {Boolean}
         */
        var filterBetweenRangeValues = function (value, sliderRange) {
            return value >= sliderRange.start && value <= sliderRange.end;
        };

        /**
         * AngularJS Filter
         *
         * @param {FlightOffer[]} offers
         * @param {Object} filterData
         * @returns {FlightOffer[]}
         */
        return function (offers, filterData) {
            return underscore.filter(offers, function (offer) {
                var offerFilterData = FlightOfferHelper.getOfferFilterData(offer);

                return (
                    filterByAirlineCodes(offerFilterData, filterData.airlines) &&
                    filterByAirportCodes(offerFilterData, filterData, 'originAirports') &&
                    filterByAirportCodes(offerFilterData, filterData, 'destinationAirports') &&
                    filterByAirportCodes(offerFilterData, filterData, 'layoverAirports') &&
                    filterByStops(offerFilterData, filterData.stops) &&
                    filterByProviders(offerFilterData, filterData.providers) &&

                    filterByMaxSliderValue(offerFilterData.maxStopDuration, filterData.stopDuration.value) &&
                    filterByMaxSliderValue(offerFilterData.maxFlightDuration, filterData.flightDuration.value) &&

                    filterBetweenRangeValues(offerFilterData.depTakeoff, filterData.hours.departure.takeoff) &&
                    filterBetweenRangeValues(offerFilterData.depLanding, filterData.hours.departure.landing) &&
                    filterBetweenRangeValues(offerFilterData.retTakeoff, filterData.hours.return.takeoff) &&
                    filterBetweenRangeValues(offerFilterData.retLanding, filterData.hours.return.landing)
                );
            });
        };
    };

    IthFlightOffersFilter.$inject = [
        'FlightOfferHelper'
    ];

    angular
        .module('funnel')
        .filter('filterOffers', IthFlightOffersFilter);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-outdated-alert/ith-flight-outdated-handler.component.js
(function(angular) {
var IthFlighOutdatedHandlerComponent = {
        controller: 'FlightOutdatedHandlerController',
        bindings: {
            southParkHelper: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithFlightOutdatedHandler', IthFlighOutdatedHandlerComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-outdated-alert/ith-flight-outdated-handler.controller.js
(function(angular) {
var IthFlightOutdatedHandlerController = function ($timeout, $modal, AppConfig) {
        /**
         * Reference for $timeout promise
         *
         * @type {Promise}
         */
        var timeoutReference = null;

        /**
         * Self reference
         *
         * @type {IthFlightOutdatedHandlerController}
         */
        var self = this;

        /**
         * Opens the outdated alert modal
         */
        var openOutdatedAlertModal = function () {
            var outdatedModal = $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/funnel/flights-outdated',
                backdrop: 'static',
                windowClass: 'ith-flights-outdated'
            });

            outdatedModal.result.then(function () {
                self.southParkHelper.search();
            });
        };

        /**
         * On init hook
         */
        this.$onInit = function () {
            timeoutReference = $timeout(
                openOutdatedAlertModal,
                AppConfig.getShelfConfig().outdated_alert_cache_time * 1000
            );
        };

        /**
         * On destroy hook
         */
        this.$onDestroy = function () {
            $timeout.cancel(timeoutReference);
        };
    };

    IthFlightOutdatedHandlerController.$inject = [
        '$timeout',
        '$modal',
        'appConfig'
    ];

    angular
        .module('funnel')
        .controller('FlightOutdatedHandlerController', IthFlightOutdatedHandlerController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-search-banner/ith-flight-search-banner.component.js
(function (angular) {
    var template = '\
        <div>\
            <ith-newsletter-subscribe-box></ith-newsletter-subscribe-box>\
        </div>\
    ';

    angular
        .module('funnel')
        .component('ithSearchBannerComponent', {
            template: template
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-summary/ith-search-summary.component.js
(function(angular) {
var IthSearchSummaryComponent = {
        controller: 'SearchSummaryController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/search-summary',
        bindings: {
            searchQueryParams: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithSearchSummary', IthSearchSummaryComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/flight-summary/ith-search-summary.controller.js
(function (angular) {
var IthSearchSummaryController = function (LocationTranslator, IthSearchFormTrigger) {
        /**
         * Format for dates in the summary
         *
         * @type {String}
         */
        this.dateFormat = 'EEE, dd MMM';

        this.LocationTranslator = LocationTranslator;
        this.searchFormTrigger = IthSearchFormTrigger;

        this.formatFlexDate = function (date) {
            return moment(date).format('MMM YYYY');
        }

        this.translateCodes = function (codesString, getWhat) {
            var codesArray = codesString ? codesString.split(',') : [];
            var translated = codesArray.map(function (code) {
                return LocationTranslator.iataDictionary[getWhat](code);
            });

            return translated.join(', ');
        };
    };

    IthSearchSummaryController.$inject = ['LocationTranslator', 'IthSearchFormTrigger'];

    angular
        .module('funnel')
        .controller('SearchSummaryController', IthSearchSummaryController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/ieftinuarie-search-banner.component.js
(function (angular) {

    angular
        .module('funnel')
        .component('ithIeftinuarieSearchBanner', {
            template: '\
                <article class="basicBox search-nl-box blue-border-box ieftinuarie-search-box">\
                    <section class="search-nl-box__group">\
                        <section class="search-nl-box__group__content">\
                            <h3 class="search-nl-box__group__content__title" translate>LANGM_JS_IEFTINUARIE_SEARCH_BOX_TITLE</h3>\
                            <p class="search-nl-box__group__content__desc" translate>LANGM_JS_IEFTINUARIE_SEARCH_BOX_DESC</p>\
                        </section>\
                        <section class="search-nl-box__group__key-visual">\
                            <img src="/assets/img/general/ieftinuarie/2024/search-banner.svg" />\
                        </section>\
                    </section>\
                    <section class="search-nl-box__action">\
                        <a class="btn btn-lg btn-primary btn-block" ng-href="/{{ $ctrl.AppConfig.getIeftinuarieStaticPagePath() }}" target="_blank" translate>LANGM_JS_IEFTINUARIE_SEARCH_BOX_CTA</a>\
                    </section>\
                </article>\
            ',
            controller: ['appConfig', function (AppConfig) {
                this.AppConfig = AppConfig;
            }]
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/ith-frola-flex-advert.component.js
(function(angular) {
var IthFrolaFlexAdvertController = function (AppConfig) {
        this.href = '';
        this.isEnabled = function () {
            if (AppConfig.getAbConfig().hasOwnProperty('floating_cfar')) {
                return AppConfig.getAbConfig()['floating_cfar'] !== 'Off';
            }

            return false;
        };

        this.$onInit = function () {
            if (this.zone !== 'jumbotron') {
                return;
            }

            if (AppConfig.isVola()) {
                this.href = AppConfig.getLanguageCode() === 'en' ? 'https://en.vola.ro/flex' : 'https://www.vola.ro/flex';
                return;
            }

            this.href = AppConfig.getLanguageCode() === 'en' ? 'https://en.fru.pl/flex' : 'https://www.fru.pl/flex';
        };
    };

    IthFrolaFlexAdvertController.$inject = [
        'appConfig'
    ];

    angular
        .module('funnel')
        .component('ithFrolaFlexInfo', {
            templateUrl: '/tpl/show/jsShared/templates/funnel/cfar/advert',
            bindings: {
                zone: '@'
            },
            controller: IthFrolaFlexAdvertController
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/newsletter-subscribe/ith-newsletter-subscribe-box.component.js
(function(angular) {
var IthNewsletterSubscribeBoxComponent = {
        templateUrl: '/tpl/show/jsShared/templates/funnel/newsletter-subscribe/box',
        controller: 'NewsletterSubscribeBoxController'
    };

    angular
        .module('funnel')
        .component('ithNewsletterSubscribeBox', IthNewsletterSubscribeBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/newsletter-subscribe/ith-newsletter-subscribe-box.controller.js
(function(angular) {
var IthNewsletterSubscribeBoxController = function ($modal, appConfig) {
        /**
         * Opens the subscribe modal
         */
        this.openModal = function () {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/funnel/newsletter-subscribe/modal',
                controller: 'NewsletterSubscribeModalController',
                windowClass: 'search-nl-modal'
            });
        };

        this.isCheapanuaryEnabled = appConfig.getIeftinuarieConfig();
    };

    IthNewsletterSubscribeBoxController.$inject = [
        '$modal',
        'appConfig'
    ];

    angular
        .module('funnel')
        .controller('NewsletterSubscribeBoxController', IthNewsletterSubscribeBoxController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/newsletter-subscribe/ith-newsletter-subscribe-modal.controller.js
(function(angular) {
var IthNewsletterSubscribeModalController = function ($scope, RodoService, NewsletterSrv) {
        /**
         * Data to be sent to endpoint
         *
         * @type {Object}
         */
        $scope.formData = {
            /**
             * User's email address
             *
             * @type {String}
             */
            email: '',

            /**
             * Subscription source required for endpoint
             *
             * @type {String}
             */
            nl_place_name: 'search-results'
        };

        /**
         * Form states
         *
         * @type {Object}
         */
        $scope.states = {
            /**
             * Form is saving?
             *
             * @type {Boolean}
             */
            isSaving: false,

            /**
             * Form data was sent successfuly
             *
             * @type {Boolean}
             */
            isSuccess: false,

            /**
             * There was an error submitting the data
             *
             * @type {Boolean}
             */
            isError: false,

            /**
             * Terms checkbox data
             */
            terms: {
                /**
                 * User agreed with the terms
                 *
                 * @type {Boolean}
                 */
                agree: false,

                /**
                 * RODO error (user didn't agree when submitting)
                 *
                 * @type {Boolean}
                 */
                error: false
            }
        };

        /**
         * Submits the form
         *
         * @param {Event} event
         * @param {NgForm} nlForm
         */
        $scope.submit = function (event, nlForm) {
            event.preventDefault();

            if (!nlForm.$valid) {
                return;
            }

            $scope.states.isSaving = true;
            $scope.states.isSuccess = false;
            $scope.states.isError = false;

            if (RodoService.isEnabled('nlRegister') && RodoService.getSettings().nlSubscribeConsent && !$scope.states.terms.agree) {
                // User must agree terms to continue
                $scope.states.terms.error = true;
                $scope.states.isSaving = false;
                return;
            }

            NewsletterSrv
                .addToNewsletter($scope.formData)
                .then(function () {
                    $scope.states.isSuccess = true;
                    $scope.states.isError = false;
                })
                .catch(function () {
                    $scope.states.isSuccess = false;
                    $scope.states.isError = true;
                })
                .finally(function () {
                    $scope.states.isSaving = false;
                });
        };
    };

    IthNewsletterSubscribeModalController.$inject = [
        '$scope',
        'RodoService',
        'NewsletterSrv'
    ];

    angular
        .module('funnel')
        .controller('NewsletterSubscribeModalController', IthNewsletterSubscribeModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/payment/ith-payment-option.component.js
(function (angular) {
var template = '\
        <div class="paymentList__item">\
            <div id="{{ \'ith-payment-option-\' + $ctrl.paymentOption.type }}" class="paymentList__item__heading" ng-click="$ctrl.selectPaymentType($ctrl.paymentOption.type)">\
                <div class="paymentList__item__desc-heading">\
                    <ith-ui-radio ng-model="$ctrl.ngModel" value="$ctrl.paymentOption.type"></ith-ui-radio>\
                    <strong translate>{{ $ctrl.getTitle() }}</strong>\
                </div>\
                <img class="pay-logo" ng-if="$ctrl.hasImage()" ng-src="{{ \'/assets/img/payment/\' + $ctrl.getPaymentImage() }}" />\
            </div>\
            <div class="paymentList__item__desc fade-in-anim" ng-show="$ctrl.ngModel === $ctrl.paymentOption.type">\
                <div ng-if="$ctrl.isRevolutPayMethod()" id="revolut-pay-promotional-banner-wide"></div>\
                <p ng-if="!$ctrl.isRevolutPayMethod()" translate>{{ $ctrl.paymentOption.descr }}</p>\
                <ng-transclude></ng-transclude>\
            </div>\
        </div>\
    ';

    var controller = function ($timeout) {
        this.getPaymentImage = function () {
            switch (this.paymentOption.type) {
                case 'CT': return 'pos-terminal.svg';
                case 'CA': return 'cash.svg';
                case 'BC': return 'bitcoin.svg';
                case 'CC': return 'visa-mastercard.svg';
                case 'GP': return 'google-pay-mark_800.svg';
                case 'GP2': return 'google-pay-mark_800.svg';
                case 'AP': return 'Apple_Pay_Mark_RGB_041619.svg';
                case 'AP2': return 'Apple_Pay_Mark_RGB_041619.svg';
                case 'EP': return 'przelewy24.svg';
                case 'BT': return 'bank-transfer.svg';
                case 'PP': return 'paypal.svg';
                case 'BA': return 'blik.png';
                case 'PBL': return 'payu.png';
                case 'RP': return 'RevolutPay-Logotype-Black.svg';
                default: return null;
            }
        };

        this.getTitle = function () {
            return 'LANGM_JS_' + this.paymentOption.type + '_PAYMENT_TYPE';
        };

        this.isRevolutPayMethod = function () {
            return this.paymentOption.type === 'RP';
        };

        this.hasImage = function () {
            return this.getPaymentImage() !== null;
        };

        this.selectPaymentType = function (type) {
            this.ngModel = type;
            var el = document.getElementById('ith-payment-option-' + type);

            $timeout(function () {
                if (el) {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            }, 100);
        };
    };

    controller.$inject = [
        '$timeout'
    ];

    angular
        .module('funnel')
        .component('ithPaymentOption', {
            controller: controller,
            template: template,
            transclude: true,
            bindings: {
                ngModel: '=',
                paymentOption: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/product-logo.component.js
(function(angular) {
var IthProductLogoComponent = {
        template:
            '<div class="product-logo">' +
                '<img class="product-logo__hero" ng-src="/assets/img/product-logos/{{ $ctrl.imageName }}.svg?v={{ :: $ctrl.getImgVersion() }}" alt="{{ $ctrl.affiliate }} {{ $ctrl.name }}">' +
                '<span class="product-logo__typeface">' +
                    '<span class="product-logo__typeface__affiliate" ng-if="$ctrl.showAffiliateName">{{ \'LANGM_JS_AFFILIATE_NAME\' | translate }}</span> ' +
                    '<span class="product-logo__typeface__name">{{ $ctrl.name }}</span>' +
                '</span>' +
            '</div>'
        ,
        bindings: {
            imageName: '@',
            name: '@',
            showAffiliateName: '<'
        },
        controller: ['appConfig', function (AppConfig) {
            this.getImgVersion = AppConfig.getJsCacheBuster;
        }]
    };

    angular
        .module('funnel')
        .component('ithProductLogo', IthProductLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-form/ith-search-form-trigger.service.js
(function(angular) {
var IthSearchFormTriggerService = function () {
        /**
         * State that triggers search form on mobile
         *
         * @type {Boolean}
         */
        this.isOpen = false;

        this.toggle = function () {
            this.isOpen = !this.isOpen;
        };

        this.open = function () {
            this.isOpen = true;
        };

        /**
         * Cloes the search form
         */
        this.close = function () {
            this.isOpen = false;
        };

        return this;
    };

    angular
        .module('funnel')
        .service('IthSearchFormTrigger', IthSearchFormTriggerService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-form/ith-search-form.component.js
(function (angular) {
var ctrl = function ($stateParams, IthSearchFormTrigger, CITY_HELPER) {
        /**
         * @param {string | ''} [codesStr]
         * @param {CITY_HELPER.TYPE_AIRPORT | CITY_HELPER.TYPE_CITY | CITY_HELPER.TYPE_COUNTRY} [type]
         * @returns {({code: string, type: CITY_HELPER.TYPE_AIRPORT | CITY_HELPER.TYPE_CITY | CITY_HELPER.TYPE_COUNTRY}[]) | []}
         */
        var getDirections = function (codesStr, type) {
            var codesArr = codesStr ? codesStr.split(',') : [];

            return codesArr.map(function (code) {
                return {
                    code: code,
                    type: type
                };
            });
        };

        /**
         * @param {string | ''} [airportCodesStr]
         * @param {string | ''} [cityCodesStr]
         * @param {string | ''} [countryCodesStr]
         * @returns {{code: string, type: CITY_HELPER.TYPE_AIRPORT | CITY_HELPER.TYPE_CITY | CITY_HELPER.TYPE_COUNTRY}[]}
         */
        this.generateDirections = function (airportCodesStr, cityCodesStr, countryCodesStr) {
            return [].concat(
                getDirections(airportCodesStr, CITY_HELPER.TYPE_AIRPORT),
                getDirections(cityCodesStr, CITY_HELPER.TYPE_CITY),
                countryCodesStr ? getDirections(countryCodesStr, CITY_HELPER.TYPE_COUNTRY) : []
            );
        };

        this.searchFormTrigger = IthSearchFormTrigger;
        this.fromDirections = [];
        this.toDirections = [];

        this.$onInit = function () {
            this.fromDirections = this.generateDirections($stateParams.depAirportCode, $stateParams.depCode);
            this.toDirections = this.generateDirections($stateParams.arrAirportCode, $stateParams.arrCode, $stateParams.arrCountryCode);
        };
    };

    ctrl.$inject = ['$stateParams', 'IthSearchFormTrigger', 'CITY_HELPER'];

    var template = '\
        <div class="ith-search-form" ng-class="{ \'ith-search-form--mobile-visible\': $ctrl.searchFormTrigger.isOpen }">\
            <div class="container">\
                <div class="ith-search-form__header">\
                    <h3 class="ith-search-form__header__title" translate>LANGM_JS_CHANGE_SEARCH</h3>\
                    <button class="ith-search-form__header__close" ng-click="$ctrl.searchFormTrigger.close()">\
                        <svg-icon id="modal-close"></svg-icon>\
                    </button>\
                </div>\
                <div \
                    flights-form \
                    from="$ctrl.fromDirections"\
                    to="$ctrl.toDirections">\
                </div>\
            </div>\
        </div>\
    ';

    var IthSearchFormComponent = {
        template: template,
        controller: ctrl
    };

    angular
        .module('funnel')
        .component('ithSearchForm', IthSearchFormComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-loading/ith-search-fake-results.component.js
(function(angular) {
var IthSearchFakeResultsComponent = {
        controller: 'SearchFakeResultsController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/search-fake-results',
        bindings: {
            searchQueryParams: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithSearchFakeResults', IthSearchFakeResultsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-loading/ith-search-fake-results.controller.js
(function(angular) {
var IthSearchFakeResultsController = function (FakeFlightOfferModel, IataDictionary, TabFilterTypes) {
        /**
         * Fake flight offer collection
         *
         * @type {FakeFlightOfferModel[]}
         */
        this.fakeOffers = [];

        /**
         * Empty iata dictionary instance
         *
         * @type {IataDictionary}
         */
        this.dictionary = new IataDictionary();

        /**
         * Sorting tab collections
         *
         * @type {Object[]}
         */
        this.sortingTabs = [];

        this.$onInit = function () {
            var fakeOffer = new FakeFlightOfferModel(this.searchQueryParams.isOneWay());

            this.dictionary = new IataDictionary();
            this.activeSortingTab = TabFilterTypes.best;

            this.sortingTabs.push(
                { id: TabFilterTypes.best, offer: fakeOffer },
                { id: TabFilterTypes.cheapest, offer: fakeOffer },
                { id: TabFilterTypes.fastest, offer: fakeOffer }
            );

            this.fakeOffers.push(fakeOffer, fakeOffer, fakeOffer);
        };
    };

    IthSearchFakeResultsController.$inject = [
        'FakeFlightOfferModel',
        'IataDictionary',
        'TabFilterTypes'
    ];

    angular
        .module('funnel')
        .controller('SearchFakeResultsController', IthSearchFakeResultsController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-loading/ith-search-loading.component.js
(function(angular) {
var IthSearchLoadingComponent = {
        controller: 'SearchLoadingController',
        templateUrl: '/tpl/show/jsShared/templates/funnel/search-loading',
        bindings: {
            sortingTabs: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithSearchLoading', IthSearchLoadingComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/search-loading/ith-search-loading.controller.js
(function(angular) {
var IthSearchLoadingController = function ($timeout, $filter, FlightOfferHelper) {
        /**
         * Cache for the cheapest price loaded
         *
         * @type {Number}
         */
        this.cheapestPriceLoaded = Infinity;

        /**
         * Flag for displaying the "better price found" message
         *
         * @type {Boolean}
         */
        this.showBetterPrice = false;

        /**
         * Self reference
         *
         * @type {IthSearchLoadingController}
         */
        var self = this;

        /**
         * On changes hook
         *
         * @param {Object} changesObj
         */
        this.$onChanges = function (changesObj) {
            if (!changesObj.hasOwnProperty('sortingTabs')) {
                return;
            }

            var previousCheapestPrice = getCheapestSortingTabPrice(changesObj.sortingTabs.previousValue);
            var cheapestPrice = getCheapestSortingTabPrice(changesObj.sortingTabs.currentValue);

            if (cheapestPrice < previousCheapestPrice && previousCheapestPrice < Infinity) {
                this.cheapestPriceLoaded = cheapestPrice;
                this.showBetterPrice = true;

                $timeout(function () {
                    self.showBetterPrice = false;
                }, 4000);
            }
        };

        /**
         * Returns cheapest price formatted with currency
         *
         * @returns {String}
         */
        this.getCheapestPrice = function () {
            return $filter('flPrice')(this.cheapestPriceLoaded);
        };

        /**
         * Returns the cheapest price from the sortig tab data
         *
         * @param {Object[]} sortingTabsData
         * @returns {Number}
         */
        var getCheapestSortingTabPrice = function (sortingTabsData) {
            if (Array.isArray(sortingTabsData) && sortingTabsData.length == 3) {
                // Cheapest tab is index 1
                return FlightOfferHelper.getOfferPrice(sortingTabsData[1].offer);
            }

            return Infinity;
        };
    };

    IthSearchLoadingController.$inject = [
        '$timeout',
        '$filter',
        'FlightOfferHelper'
    ];

    angular
        .module('funnel')
        .controller('SearchLoadingController', IthSearchLoadingController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/upsell-box/upsell-box.component.js
(function(angular) {
var IthUpsellBoxComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/upsell-box/box',
        transclude: {
            logo: 'logoPane',
            description: 'descriptionPane',
            action: '?actionPane'
        },
        bindings: {
            isNew: '<',
            showActions: '<'
        },
        controller: function () {
            this.$onInit = function () {
                if (this.showActions === undefined) {
                    this.showActions = true;
                }
            };
        }
    };

    angular
        .module('funnel')
        .component('ithUpsellBox', IthUpsellBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/upsell-box/upsell-modal.component.js
(function(angular) {
var IthUpsellModalComponent = {
        template: '<a ng-click="$ctrl.openModal()" translate>LANGM_JS_VIEW_PRODUCT_DETAILS</a>',
        controller: 'UpsellModalController',
        bindings: {
            modalUrl: '@',
            data: '<'
        }
    };

    angular
        .module('funnel')
        .component('ithUpsellModal', IthUpsellModalComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/upsell-box/upsell-modal.controller.js

(function (angular) {
var UpsellModalController = function ($modal) {
        /**
         * Opens the upsell modal
         */
        this.openModal = function () {
            var self = this;

            var ModalController = function (sharedData) {
                this.data = sharedData;
            };

            ModalController.$inject = [
                'sharedData'
            ];

            $modal.open({
                templateUrl: this.modalUrl,
                windowClass: 'mobile-modal--fullscreen upsell-modal',
                controller: ModalController,
                controllerAs: '$ctrl',
                resolve: {
                    sharedData: function () {
                        return self.data;
                    }
                }
            });
        };
    };

    UpsellModalController.$inject = [
        '$modal'
    ];

    angular
        .module('funnel')
        .controller('UpsellModalController', UpsellModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/components/upsell-box/upsell-presentation-box.component.js
(function (angular) {
var IthUpsellPresentationBoxComponent = {
        templateUrl: '/tpl/show/jsShared/templates/flights/upsell-box/presentation-box',
        transclude: {
            logo: 'logoPane',
            description: 'descriptionPane'
        }
    };

    angular
        .module('funnel')
        .component('ithUpsellPresentationBox', IthUpsellPresentationBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/consents/consents.helper.js
(function (angular) {

    angular.module('base').service('ConsentsHelper', function () {
        this.getConsentModel = function (consentData) {
            if (consentData.type === 'checkbox') {
                consentData.value = false;
            }

            if (consentData.type === 'revealing-checkbox') {
                consentData.value = false;
            }

            if (consentData.type === 'text') {
                consentData.value = true;
            }

            return consentData;
        };

        this.getConsentModels = function (consentDataArray) {
            return consentDataArray.map(function (consentData) {
                return this.getConsentModel(consentData);
            }.bind(this));
        };

        this.serialize = function (consentModelArray) {
            var consentObject = {};

            consentModelArray.forEach(function (consentModel) {
                if (consentModel.type === 'revealing-checkbox') {
                    consentObject[consentModel.id] = !consentModel.value;
                } else {
                    consentObject[consentModel.id] = consentModel.value;
                }
            });

            return consentObject;
        };

        this.isValid = function (consentModelArray) {
            var isValid = true;

            consentModelArray.forEach(function (consentModel) {
                if (consentModel.required && !consentModel.value) {
                    isValid = false;
                }
            });

            return isValid;
        };
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/consents/ith-checkbox-consent.component.js
(function (angular) {

    angular
        .module('base')
        .component('ithCheckboxConsent', {
            template: '<ith-checkbox-field model="$ctrl.consent.value" form="$ctrl.form" name="{{ :: $ctrl.consent.id }}" required="$ctrl.consent.required"><span class="disclaimer-text" ng-bind-html="$ctrl.consent.label"></span></ith-checkbox-field>',
            bindings: {
                consent: '<',
                form: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/consents/ith-consents-display.component.js
(function (angular) {

    angular
        .module('base')
        .component('ithConsentsDisplay', {
            template: '\
                <section class="margin-bottom-large">\
                    <div ng-repeat="consent in $ctrl.consents">\
                        <div ng-switch="consent.type">\
                            <ith-text-consent ng-switch-when="text" consent="consent"></ith-text-consent>\
                            <ith-checkbox-consent ng-switch-when="checkbox" consent="consent" form="$ctrl.form"></ith-checkbox-consent>\
                            <ith-revealing-checkbox-consent ng-switch-when="revealing-checkbox" consent="consent" form="$ctrl.form"></ith-revealing-checkbox-consent>\
                        </div>\
                    </div>\
                </section>',
            bindings: {
                consents: '<',
                form: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/consents/ith-revealing-checkbox-consent.component.js
(function (angular) {

    angular.module('base').component('ithRevealingCheckboxConsent', {
        template: '\
            <div>\
                <ith-text-consent consent="$ctrl.consent" ng-if="!$ctrl.showCheckbox"></ith-text-consent>\
                <ith-checkbox-consent consent="$ctrl.consent" ng-if="$ctrl.showCheckbox"></ith-checkbox-consent>\
            </div>\
        ',
        controller: ['$element', '$timeout', function ($element, $timeout) {
            var ctrl = this;

            this.showCheckbox = false;

            var linkElement = null;

            var clickFn = function () {
                $timeout(function () {
                    ctrl.showCheckbox = true;
                    ctrl.consent.value = true;
                });
            };

            this.$onInit = function () {
                $timeout(function () {
                    linkElement = $element.find('a');
                    linkElement.bind('click', clickFn);
                });
            };

            this.$destroy = function () {
                linkElement.unbind('click', clickFn);
            };
        }],
        bindings: {
            consent: '<',
            form: '<'
        }
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/consents/ith-text-consent.component.js
(function (angular) {

    angular
        .module('base')
        .component('ithTextConsent', {
            template: '<p class="disclaimer-text" ng-bind-html="$ctrl.consent.lang"></p>',
            bindings: {
                consent: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/FlightDetailsCtrl.js
/* eslint-disable indent */
(function (angular, underscore) {
/**
   * @name FlightDetailsCtrl
   * @description Flight details controller
   */
  var FlightDetailsCtrl = function ($rootScope,
                                    $localStorage,
                                    $scope,
                                    $filter,
                                    $anchorScroll,
                                    $modal,
                                    Dictionaries,
                                    appConfig,
                                    $stateParams,
                                    $location,
                                    $window,
                                    $timeout,
                                    FlightDetailsServ,
                                    FlightBooking,
                                    BookingState,
                                    BackToBasket,
                                    $q,
                                    Remarketing,
                                    FlightAnalytics,
                                    BookingServ,
                                    $sce,
                                    OrderValidation,
                                    PageLoadingService,
                                    $exceptionHandler,
                                    OutdatedAlertSrv,
                                    stepsObserver,
                                    FlightDetailsStepsFactory,
                                    Refund,
                                    CONST,
                                    PaymentTokenize,
                                    ErrorLogService,
                                    PaymentApi,
                                    AnalyticsServiceHelper,
                                    SouthParkFlightCache,
                                    CheckinApi,
                                    AutomatedCheckinHelper,
                                    AncillariesSocketHandler,
                                    FunnelErrorLogCollector,
                                    StepsEnum,
                                    SplitFunnelAnalytics,
                                    OrderSummaryWatcher,
                                    BookingFormCache,
                                    AuthService,
                                    SeatsFlow,
                                    PaymentToken,
                                    PaymentInject
  ) {
    $scope.flightBooking = null;
    $scope.steps = null;
    $scope.ancillariesSocketHandler = null;

    $scope.eventRefs = {
      unregisterStepChangeEvent: null,
      unregisterSplitFunnelNoSeatsEvent: null
    };

    if ($localStorage.redirectLink && $localStorage.redirectLink !== null) {
      // There's a cached link in local storage, redirect
      // $location.path($localStorage.redirectLink);
      // return;
    }

    /**
     * Very elaborate condition that checks if we want to show various components (3 or so)
     * loosely connected to picking luggage and pax details
     *
     * @returns {boolean}
     */
    $scope.shouldShowPaxDetails = function() {
      return !$scope.isLtd()
        || $scope.allowBooking() && $scope.isLtd()
        || !$scope.isLtd();
    };

    $scope.addToGiveawayPool = function() {
      return appConfig.getAbConfig().assign_into_giveaway && appConfig.getAbConfig().assign_into_giveaway !== 'Off';
    };

    var createGAEvnetString = function (bookingObject, response){
      var object = [
        'yes',
        $scope.flightBooking.carriers.join('-').toLowerCase(),
        $scope.flightBooking.flightDetails.flightType,
        bookingObject.insurance.type ? 'yes' : 'no',
        bookingObject.refund ? 'yes' : 'no',
        bookingObject.payment.type,
        response['http_code'] || 'null',
        response.response['error_code']|| 'null',
        response.response['msg']|| 'null'
      ];
      return object.join('|');
    };

    PageLoadingService.on();

    var bookingModal = false;

    /**
     * Status object for UI
     *
     * @type {Object}
     */
    $scope.statuses = {
      error: false,               // Set to true in case of loading error or booking is not possible
      showBasket: false,               // Switch to show basket in the UI
      bookPressed: false,               // Book button has been pressed
      online: $rootScope.online,   // Reports if application is online or offline
      showBaggageBox: false,
      showDebug: false
    };

    $rootScope.orderInProgress = false;
    $rootScope.funnelIsOpen = true;

    $scope.buttonBookingPress = false;
    /**
     * A/B switches
     */
    stepsObserver.reset();

    /**
     * Call Google Analytics and Google AdWords trackers
     *
     * @param {Object} response Object containing reservation/booking success information
     */
    var callTrackers = function (response) {
      AnalyticsServiceHelper.sendPaxData($scope.flightBooking, response.reservationNumber);
      new FlightAnalytics(FlightBooking, response).makeTransaction();
    };
    $scope.isLtd = function () {
      return true;
    };
    $scope.shouldBlockPage = function () {
      return false;
    };
    $scope.elapsedTime = function () {
      return true;
    };
    $scope.allowBooking = function () {
      return false;
    };

    $scope.seatsFlowInitialized = false;

    function onStepChanged() {
      setFlightDetailsMetaTitle();

      if ($scope.steps.isTicketType() && $scope.ancillariesSocketHandler.getSocketId() !== '' && !$scope.seatsFlowInitialized) {
        SeatsFlow.init(
          $scope.ancillariesSocketHandler,
          $scope.flightBooking.getFlightDetails().fulfillmentToken,
          $scope.flightBooking.seatsInitialData
        );

        $scope.seatsFlowInitialized = true;
      }
    }

    function setFlightDetailsMetaTitle() {
      document.querySelector('title').innerHTML = $filter('translate')('LANGM_JS_FLIGHT_DETAILS_META_TITLE', {
        flight_from: Dictionaries.getCityNameByCode($scope.flightBooking.flightDetails.legs[0].dep, false),
        flight_to: Dictionaries.getCityNameByCode($scope.flightBooking.flightDetails.legs[0].arr, false),
        step_name: $filter('translate')($scope.steps.getCurrentStep().name)
      });
    }

    /**
     * Reset flight booking
     */
    if (!FlightBooking.getFlightDetails() || !FlightBooking.flightDetails.hashesEquality($stateParams) || FlightBooking.getReservationNumber()) {
      FlightBooking.reset();
    }

    $scope.setButtonBookingPress = function () {
      $scope.buttonBookingPress = true;
    };

    $scope.getPaymentType = function () {
      return '';
    };

    $location.hash('');

    $scope.isFareLocked = function () {
      return $scope.flightBooking.getFlightDetails().fareLockUuid !== null;
    };

    $scope.isFareLockEnabled = function () {
      return appConfig.getFareLockAbTest() && $scope.flightBooking.getFlightDetails().fareLock !== null;
    };

    $scope.bookingState = BookingState;
    $scope.bookingState.setOrderState();
    $scope.antiFraud = false;
    $scope.flightBookingPromise = $scope.bookingState.getOrderState();
    $scope.flightBookingPromise.then(function (result) {
        $scope.flightBooking = result;
        $scope.steps = new FlightDetailsStepsFactory($scope.flightBooking);
        $scope.orderSummaryWatcher = new OrderSummaryWatcher($scope.flightBooking, $scope.steps);
        $scope.flightBooking.cashback = false;
        PaymentTokenize.setCredentials(result.flightDetails.paymentCredentials);
        setFlightDetailsMetaTitle();
        $scope.eventRefs.unregisterStepChangeEvent = $scope.$on('stepChanged', onStepChanged);

        if ($scope.flightBooking.getFlightDetails()) {
          $scope.cashBack = $scope.flightBooking.flightDetails.getCashBack();
          $scope.charter = $scope.flightBooking.flightDetails.isCharter();
          Remarketing.flightProduct($scope.flightBooking, 'PaxDetails:');
        }

        $scope.getPaymentType = $scope.flightBooking.getPayment().getType;

        $scope.departureDataSet = $scope.flightBooking.flightDetails.getDepLeg();
        $scope.arrivalDataSet = $scope.flightBooking.flightDetails.isRoundTrip() ? $scope.flightBooking.flightDetails.getRetLeg() : null;

        // Page Tracking
      Remarketing.flightProduct($scope.flightBooking, 'FlightDetails:');
      Remarketing.trackNewFlightDetails($scope.flightBooking.getFlightDetails());

        CheckinApi
          .getAirlineRules(
            AutomatedCheckinHelper.getRulesPayload(
              $scope.flightBooking.getFlightDetails()
            )
          )
          .then(function (success) {
            $scope.flightBooking.paidCheckinRules.setRules(
              success.data.data.rules
            );
          });

          ////////////////////////
          $scope.flightBooking.fareLock.onExpiredStatus(function () {
            var fareLockExpiredModal = $modal.open({
              templateUrl: '/tpl/show/templates/components/modals/funnel/fareLockExpired',
              controller: ['$modalInstance', 'fareLock', function ($modalInstance, fareLock) {
                this.dismiss = function () {
                  $modalInstance.dismiss('cancel');
                };

                this.fareLock = fareLock;
              }],
              controllerAs: '$ctrl',
              backdrop: 'static',
              resolve: {
                fareLock: function () {
                  return $scope.flightBooking.fareLock;
                }
              }
            });

            // Wait for promise response
            fareLockExpiredModal.result.catch(function () {
              $scope.toSearchWithRefresh();
            });
          });

          $scope.ancillariesSocketHandler = new AncillariesSocketHandler($scope.flightBooking);

          $scope.ancillariesSocketHandler.init().then(function () {
            SeatsFlow.init(
              $scope.ancillariesSocketHandler,
              $scope.flightBooking.getFlightDetails().fulfillmentToken,
              $scope.flightBooking.seatsInitialData
            );
          });
          ////////////////////////

          $scope.flightBooking.payment.googlePayClient.setFlightBooking($scope.flightBooking);
          $scope.flightBooking.payment.applePayClient.setFlightBooking($scope.flightBooking);

          $scope.flightBooking.payment.revolutCheckoutClientForGooglePay.setFlightBooking($scope.flightBooking);
          $scope.flightBooking.payment.revolutCheckoutClientForApplePay.setFlightBooking($scope.flightBooking);
          $scope.flightBooking.payment.revolutCheckoutClientForRevolutPay.setFlightBooking($scope.flightBooking);

          $scope.paymentInject = new PaymentInject(
            $scope.flightBooking.payment.googlePayClient,
            $scope.flightBooking.payment.applePayClient,
            $scope.flightBooking.payment.revolutCheckoutClientForGooglePay,
            $scope.flightBooking.payment.revolutCheckoutClientForApplePay,
            $scope.flightBooking.payment.revolutCheckoutClientForRevolutPay
          );

          $scope.paymentInject.check(
            $scope.flightBooking.getFlightDetails().getPaymentOptions()
          );
          $scope.flightBooking.payment.pbl.setVendorData(result.flightDetails.paymentOptions.getVendorData());
      },
      //error
      function () {
        PageLoadingService.off();
      }).then(function success() {
        PageLoadingService.off();

        if (typeof($scope.flightBooking) !== 'undefined' && underscore.isObject($scope.flightBooking.flightDetails)) {
          $scope.cashBack = $scope.flightBooking.flightDetails.getCashBack();
          $scope.charter = $scope.flightBooking.flightDetails.isCharter();

          Remarketing.sendPaxData($scope.flightBooking.flightDetails);
          SplitFunnelAnalytics.splitFunnelStepChange(StepsEnum.FLIGHT_INFO, 1, $scope.flightBooking);

          if (typeof ga !== 'undefined') {
            var flightDetails = $scope.flightBooking.flightDetails;
            var gaCommandString = flightDetails.getDepLeg().arr + '|' + flightDetails.getDepLeg().dep + '|' + flightDetails.legs[0].getDepDate();

            if (flightDetails.isRoundTrip()) {
              gaCommandString += '|' + flightDetails.getRetLeg().getDepDate();
            }
            else {
              gaCommandString += '|' + flightDetails.getDepLeg().getArrDate();
            }
            ga('send', 'event', 'Flight Details', gaCommandString, '1', {
              nonInteraction: true
            });
          }

        }
        else {
          $scope.cashBack = {};
          $scope.charter = false;
          return false;
        }

        FlightDetailsServ.getFareRules($stateParams).then(
          function (result) {
            $scope.fareRule = result.fareRule;
          });


        $scope.allowBooking = function () {
          if (underscore.isObject(_user_) && _user_.isAgent) {
            return true;
          }

          if ($scope.flightBooking.getFlightDetails().getBookingReq().isBlockPage()) {
            return false;
          }

          return !$scope.flightBooking.getFlightDetails().getBookingReq().isLTD();
        };

        $scope.isChangedButtonsFlow = function () {
          return appConfig.getIsChangedButtonFlowAbTest();
        };

        $scope.isFru = function () {
          return appConfig.isFru();
        };

        $scope.isLtd = function () {
          return $scope.flightBooking.getFlightDetails().getBookingReq().isLTD();
        };

        $scope.shouldBlockPage = function () {
          return $scope.flightBooking.getFlightDetails().getBookingReq().isBlockPage();
        };

        $scope.isAgentAndHasPermissions = function () {
          return underscore.isObject(_user_) && _user_.isAgent;
        };

        $scope.elapsedTime = function () {
          var legs = $scope.flightBooking.getFlightDetails().legs || [];
          if (legs.length < 1) {
            return true;
          }

          if (legs[0].arrT) {
            var date = moment(legs[0].arrT);
            var now = moment();
            if (now > date) {
              return true;
            }
          }

          return false;
        };

        $scope.getPaymentType = $scope.flightBooking.getPayment().getType;

        //Save basket
        BackToBasket.saveFlight($scope.flightBooking.flightDetails);

        getTestSellPromise().then(function () {
          if ($scope.flightBooking.getTestSell().hasPriceDiffOrNoSeats()) {
            // Clear south park cache
            SouthParkFlightCache.clear();
          }

          if ($scope.flightBooking.getTestSell().isLower()) {
            BookingServ
                .replacePricing(angular.copy($stateParams))
                .then(function (response) {
                    $scope.flightBooking.getFlightDetails().setPaxesPricing(response.pricing.paxes);
                    $scope.flightBooking.getTestSell().setStatusDone().enableAutoticket();
                });
          }
        });
      },
      //error
      function () {
        PageLoadingService.off();
      });

    /**
     * clear data kept i.e. in localStorage
     */
    function clearStorage() {
      $scope.flightBooking.getNewInsurance().reset();
      Refund.clearSelection($scope.flightBooking.flightDetails.priceGroupId);
    }

    $scope.setBookingForm = function (bookingForm) {
      $scope.bookingForm = bookingForm;
    };

    $scope.bookingFormSync = function () {
      $scope.setButtonBookingPress();
      // $scope.bookingForm = this.bookingForm;
      $scope.bookingProcess();
    };

    var getTestSellPromise = function () {
      if (!getTestSellPromise.$promise) {
        var deferred = $q.defer();

        var $interval = setInterval(function () {
          if ($scope.flightBooking.getTestSell() && !$scope.flightBooking.getTestSell().isInProgress()) {
            clearInterval($interval);
            deferred.resolve();
          }
        }, 100);

        getTestSellPromise.$promise = deferred.promise;
      }

      return getTestSellPromise.$promise;
    };

    /**
     * Store redirect link in local storage
     */
    var cacheRedirectLink = function (link) {
      $localStorage.redirectLink = link;
      $localStorage.$apply();
    };

    var showBookingErrorModal = function () {
      var bookingErrorModal = $modal.open({
        templateUrl: '/tpl/show/templates/components/modals/funnel/bookingError',
        controller: 'BookingErrorModalCtrl',
        controllerAs: '$ctrl',
        backdrop: 'static',
      });

      bookingErrorModal.result.then(function () {
        $scope.toSearchWithRefresh();
      });
    };

    var processedBookingProcess = function () {
      BookingServ.sendBookingData(FlightBooking.srvObj(), angular.copy($stateParams)).then(
        /**
         * Manage success response
         *
         * @param {apiBookingResponse} response
         */
        function (response) {

          /**/
          if (response) {
            $scope.flightBooking.bookingResponse = response.response;
          }

          if (response.redirectLink) {
            // Cache redirect link
            cacheRedirectLink(response.redirectLink);
          }

          switch (response.version) {
            //case PaymentTokenize.checkType(response.version):
            //  console.log( 'sendBookingData', response );
            //
            //  break;
            case CONST.RESPONSE.VERSION.CONFIRMATION:
              // Call trackers
              callTrackers(response);

              $timeout(function () {
                // Redirect to confirmation page
                $location.path(response.redirectLink);
                clearStorage();
                PageLoadingService.on();
              }, 1500);

              break;

            case CONST.RESPONSE.VERSION.PAYMENT:
              // Call trackers
              callTrackers(response);

              $timeout(function () {
                if (response.bookingResponse.paymentForm) {
                  // Submit form
                  $rootScope.$broadcast('paymentGateway', {
                    url: $sce.trustAsResourceUrl(response.bookingResponse.paymentForm.url),
                    method: 'post',
                    data: response.bookingResponse.paymentForm.fields,
                    id: 'PAEnrollForm'
                  });
                } else {
                  if (response.bookingResponse.redirectLink) {
                    $location.path(response.bookingResponse.redirectLink);
                  } else {
                    // Send data to auto-submit form
                    $timeout(function () {
                      $rootScope.$broadcast('paymentGateway',
                        {
                          url: $sce.trustAsResourceUrl(response.paymentForm.url),
                          method: 'post',
                          data: response.paymentForm.fields,
                          id: 'cardPaymentGateway'
                        });
                    }, 2000);
                  }
                }
                clearStorage();
              }, 1500);

              break;

            case CONST.RESPONSE.VERSION.PRICE_DIFF:
              priceDiff(response);
              break;

            case CONST.RESPONSE.VERSION.BASIC_REDIRECT:
              callTrackers(response);

              $timeout(function () {
                clearStorage();
                $window.location.href = response.bookingResponse.redirectLink;
              }, 1500);
              break;

            default:
              genericBookingError(response);
              break;
          }
        },
          function (response) {
            processBookingError(response);
          }
      ).finally(function () {
        if (bookingModal != false) {
          bookingModal.close();
          bookingModal = false;
        }
      });
    };

    function priceDiff(response) {
      if (response.bookingResponse.blackListId) {
        // Set blacklist id
        $scope.flightBooking.getTestSell().setBlackListId(response.bookingResponse.blackListId);
      }

      if (response.bookingResponse.pnr_no) {
        // Set PNR number
        $scope.flightBooking.getTestSell().setPnrNo(response.bookingResponse.pnr_no);
      }

      $scope.changedPriceModal(response);

      // Re-enable the book button
      $scope.statuses.bookPressed = false;

      $scope.flightBooking.payment.setRevolutOrderTokenError();

      // Clear south park cache
      SouthParkFlightCache.clear();
    }

    function genericBookingError(response) {
      // Booking error
      $scope.statuses.error = true;
      $scope.flightBooking.getTestSell().setStatusNoSeats();
      $scope.changedPriceModal(response);

      // Re-enable the book button
      $scope.statuses.bookPressed = false;

      $scope.flightBooking.payment.setRevolutOrderTokenError();
    }

    function processBookingError(response) {
      if (typeof response !== 'undefined' && response['http_code'] >= 500) {
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'StatusCodes_On_FlightDetails_AfterButtonBuyNowClick', createGAEvnetString(FlightBooking.srvObj(), response));
        }
        showBookingErrorModal();
      }

      $scope.statuses.bookPressed = false;
      $scope.flightBooking.payment.setRevolutOrderTokenError();

      /**
       * Set server errors
       */
      if (response) {
        try {
          OrderValidation.setServerErrors($scope.bookingForm, $scope.flightBooking, response.response);
          if (response.response.antiFraud) {
            FlightBooking.getPayment().setType('');
            $scope.antiFraud = true;

          }

          if (response.response.discounts && response.response.discounts[0].code === 'CAMPAIGN_ALREADY_REDEEM') {
            $modal.open({
              templateUrl: 'bookingCouponInvalid.html',
              controller: ['$modalInstance', function ($modalInstance) {
                this.modalInstance = $modalInstance;
              }],
              controllerAs: '$ctrl'
            });
          }
        } catch (e) {
          console.error(e);
        }

        /**
         * Scroll to first invalid form (in case of server errors)
         */
        try {
          var goTo = 'booking-errors';

          if ($scope.antiFraud) {
            goTo = 'paymentInfo';
          }

          $location.hash(goTo);
          $anchorScroll();
        } catch (e) {
          console.error(e);
          throw new Error(e);
        }
      }
      $rootScope.orderInProgress = false;
    }

    /**
     *
     * @returns {string}
     */
    function getPaymentType() {
        return $scope.flightBooking.payment.type;
    }

    /**
     *
     * @returns {string}
     */
    function getCreditCardCurrency() {
      return $scope.flightBooking.payment.creditCard.getCurrencyCode() || appConfig.getCurrencyCode();
    }

    function tokenPreBookingProcess(credentials) {
      return PaymentTokenize.init(credentials)
          .then(function() {
            // here we should already have a google/apple/blik code/pbl from frontend logic
            var tokenString = '{}';

            if (credentials.type === PaymentToken.GOOGLE_PAY_TOKEN) {
              tokenString = $scope.flightBooking.payment.googlePayClient.getPaymentTokenString();
            }

            if (credentials.type === PaymentToken.APPLE_PAY_TOKEN) {
              tokenString = $scope.flightBooking.payment.applePayClient.getPaymentTokenString();
            }

            if (credentials.type === PaymentToken.BLIK_AUTH_CODE) {
              tokenString = JSON.stringify($scope.flightBooking.payment.blikCode.srvObj());
            }

            if (credentials.type === PaymentToken.PBL_TOKEN) {
              tokenString = JSON.stringify($scope.flightBooking.payment.pbl.srvObj());
            }

            if (credentials.type === PaymentToken.PAYMENT_INIT_FLOW && credentials.conditions.paymentType === 'BT') {
              tokenString = JSON.stringify({type: 'transfer'});
            }

            if (credentials.type === PaymentToken.CREDIT_CARD_INSTALLMENTS_TOKEN && credentials.conditions.paymentType === 'CC4') {
              tokenString = JSON.stringify({installments: $scope.flightBooking.payment.installments});
            }

            if (credentials.type === PaymentToken.PAYMENT_INIT_FLOW && credentials.conditions.paymentType === 'CA') {
              tokenString = JSON.stringify({type: 'cash'});
            }

            if (credentials.type === PaymentToken.PAYMENT_INIT_FLOW && credentials.conditions.paymentType === 'CT') {
              tokenString = JSON.stringify({type: 'terminal'});
            }

            if (credentials.type === PaymentToken.GOOGLE_PAY_REVOLUT_WIDGET_TOKEN && credentials.conditions.paymentType === 'GP2') {
              tokenString = JSON.stringify({type: 'google_pay_revolut_widget'});
            }

            if (credentials.type === PaymentToken.APPLE_PAY_REVOLUT_WIDGET_TOKEN && credentials.conditions.paymentType === 'AP2') {
              tokenString = JSON.stringify({type: 'apple_pay_revolut_widget'});
            }

            if (credentials.type === PaymentToken.REVOLUT_PAY_TOKEN && credentials.conditions.paymentType === 'RP') {
              tokenString = JSON.stringify({type: 'revolut_pay'});
            }

            return PaymentTokenize.parseToken(tokenString);
          })
          .then(function(tokenData) {
            $scope.flightBooking.payment.paymentToken.tokenize(tokenData);
          })
          .catch(function(error) {
            if (!appConfig.isEnvProd()) {
              console.warn('PaymentTokenize', error);
            }
            if (!(error instanceof TypeError) && error instanceof Error) {
              // dont log 'Wrong driver' tokenization problem
              // @see PaymentTokenize.init
              ErrorLogService.sendErrorLog(error);
            }
          });
    }

    /**
     *
     */
    function preBookingProcess() {
      var paymentType = getPaymentType();
      var currency = ['GP', 'GP2', 'AP', 'AP2', 'BA', 'PBL', 'RP', 'BT', 'CA', 'CT'].indexOf(paymentType) !== -1
        ? appConfig.getCurrencyCode()
        : getCreditCardCurrency();

      if (paymentType === 'CC4') {
        currency = appConfig.getCurrencyForCreditCardInstallments();
      }

      // need to resolve currencies here, should not take currency from credit card setting for gp/ap etc
      var credentials = PaymentTokenize.findCredential({
        currency: currency,
        paymentType: paymentType,
      });

      if (
          paymentType === 'GP' ||
          paymentType === 'GP2' ||
          paymentType === 'AP' ||
          paymentType === 'AP2' ||
          paymentType === 'BA' ||
          paymentType === 'PBL' ||
          paymentType === 'RP' ||
          paymentType === 'BT' ||
          paymentType === 'CC4' ||
          paymentType === 'CA' ||
          paymentType === 'CT'
      ) {
        return tokenPreBookingProcess(credentials);
      }

      return PaymentTokenize.init(credentials)
          .then(function() {
            var cardObj = $scope.flightBooking.payment.creditCard.srvObj();

            return PaymentTokenize.tokenize(cardObj);
          })
          .then(function(tokenized) {
            $scope.flightBooking.payment.creditCard.tokenize(tokenized);
          })
          .catch(function(error) {
            if (!appConfig.isEnvProd()) {
              console.warn('PaymentTokenize', error);
            }
            if (!(error instanceof TypeError) && error instanceof Error) {
              // dont log 'Wrong driver' tokenization problem
              // @see PaymentTokenize.init
              ErrorLogService.sendErrorLog(error);
            }
          });
    }

    function paymentMicroserviceFlow() {
      var redirectLink, paymentData;
      if ($scope.flightBooking.payment.paymentToken.tokenized) {
        paymentData = $scope.flightBooking.payment.paymentToken;
      } else {
        paymentData = $scope.flightBooking.payment.creditCard;
      }
      var credentialsType = paymentData.getCredentialsType();

      BookingServ
          .sendBookingData(FlightBooking.srvObj(), angular.copy($stateParams))
          .then(function (response) {
            if (response.redirectLink) {
              // Cache redirect link
              cacheRedirectLink(response.redirectLink);
            }
            if (response.version !== credentialsType) {
              handleResponseVersion(response);
            } else {
              redirectLink = response.redirectLink;
              var bookingResponse = response;

              return PaymentApi
                  .initPurchase(response.bookingResponse.paymentServiceParams, paymentData, credentialsType)
                  .then(function (response) {
                    callTrackers(bookingResponse);
                    $timeout(function () {
                      clearStorage();
                      handleInitPurchaseResponse(response, redirectLink);
                    }, 1500);
                  }).catch(function (error) {
                    showBookingErrorModal();
                    $scope.statuses.bookPressed = false;
                    $scope.flightBooking.payment.setRevolutOrderTokenError();
                    $rootScope.orderInProgress = false;
                    $exceptionHandler(error instanceof Error ? error : new Error('Payment error'));
                  });
            }
          }).catch(function (error) {
            processBookingError(error);
          }).finally(function () {
            if (bookingModal != false) {
              bookingModal.close();
              bookingModal = false;
            }
          });
    }

    function handleResponseVersion(response) {
      if (response.version === CONST.RESPONSE.VERSION.PRICE_DIFF) {
        priceDiff(response);
      } else {
        genericBookingError(response);
      }
    }

    function handleInitPurchaseResponse(initPurchaseResponse, redirectLink) {
      if (initPurchaseResponse.redirect_type === 'form') {
        submitForm(initPurchaseResponse.redirect_attributes, initPurchaseResponse.redirect_url);
      } else if (initPurchaseResponse.redirect_type === 'revolut_widget') {
        $scope.flightBooking.payment.setRevolutOrderToken(initPurchaseResponse.redirect_attributes[0].value);
        $scope.flightBooking.payment.setRevolutRedirectUrl(redirectLink);
      } else if (initPurchaseResponse.redirect_url) {
        window.location.href = initPurchaseResponse.redirect_url;  // 3DS
      } else {
        $location.path(redirectLink);
      }
    }

    function submitForm(redirectAttributes, redirectUrl) {
      var formAttributes = redirectAttributes.reduce(function (attributes, current) {
        attributes[current.name] = current.value;
        return attributes;
      }, {});

      $timeout(function () {
        $rootScope.$broadcast('paymentGatewayMicroservice', {
          url: $sce.trustAsResourceUrl(redirectUrl),
          method: 'post',
          data: formAttributes,
          id: 'cardPaymentGatewayMicroservice'
        });
      }, 2000);
    }

    /**
     * Booking process
     */
    $scope.bookingProcess = function () {
      $rootScope.orderInProgress = true;
      OutdatedAlertSrv.destroy();
      if (
        $scope.bookingForm.paymentInfo.creditCardForm
        && angular.isObject($scope.bookingForm.paymentInfo.creditCardForm.expiration)
      ) {
        /**
         * expiration backend erorr must be removed before validation, because it block whole validation
         */
        $scope.bookingForm.paymentInfo.creditCardForm.expiration.$setValidity('backend', true);
      }

      OrderValidation.validateForms($scope.bookingForm, FlightBooking);
      if (typeof ga !== 'undefined' && underscore.isObject($scope.flightBooking.getPayment())) {
        ga('send', 'event', 'Website Clicks', 'Book this flight', $scope.flightBooking.getPayment().type,
          $scope.flightBooking.getNewInsurance().isSelectedInsurance() | 0, {
            nonInteraction: true
          });
      }

      Remarketing.sendFlightBookData($scope.flightBooking.getPayment().type);

      $rootScope.$broadcast('form-submit:validate');

      if ($scope.bookingForm.$valid) {
        if (FlightBooking.getTestSell().hasPriceDiffOrNoSeats() && !FlightBooking.getTestSell().isLower()) {
          $scope.changedPriceModal();
          return;
        }

        $scope.statuses.bookPressed = true;
        $scope.blockRes();

        Promise
          .all([
            getTestSellPromise(),
            preBookingProcess()
          ])
          .then(function () {
            if (
                $scope.flightBooking.payment.creditCard.tokenized ||
                $scope.flightBooking.payment.paymentToken.tokenized
            ) {
              paymentMicroserviceFlow();
            } else {
              processedBookingProcess();
            }
          });
      }
      else {
        $rootScope.orderInProgress = false;

        try {
          FunnelErrorLogCollector.collect($scope.bookingForm);
          $location.hash('booking-errors');
          $anchorScroll();
        }
        catch (e) {
          console.error(e);
          throw new Error(e);
        }

        OutdatedAlertSrv.show(_js_app_config_.outdatedAlert.flightDetails.delay);
      }
    };

    /**
     * Block Res modal
     */
    $scope.blockRes = function (response) {
      if (_js_app_config_.bookModal == true) {
        // Open only one modal check
        if (bookingModal === false) {
          bookingModal = $modal.open({
            templateUrl: 'reservation.html',
            backdrop: 'static',
            controller: 'ReservationModalController',
            resolve: {
              flightBooking: function () {
                return $scope.flightBooking;
              }
            }
          });
        }
      }
    };

    $scope.debugBookingErrorModal = function () {
      showBookingErrorModal();
    };

    $scope.changedPriceModal = function () {
      var priceDiffModal = $modal.open({
        templateUrl: '/tpl/show/templates/components/modals/funnel/changedPrice',
        controller: 'ChangedPriceModalCtrl',
        controllerAs: '$ctrl',
        backdrop: 'static',
        resolve: {
          flightBooking: function () {
            return $scope.flightBooking;
          }
        }
      });

      var eventName = $scope.flightBooking.flightDetails.verification.getStatusStr() === 'HIGHER_PRICE' ?
        "price diff" : "test sell modal";

      AnalyticsServiceHelper.sendTestSellModalDisplayed($scope.flightBooking);
      Remarketing.dataLayerPush({
        event: 'banner_interactions',
        category: 'page interactions',
        name: eventName,
        type: 'display',
        step: 5,
      });

      // Wait for promise response
      priceDiffModal.result.then(
        function (action) {
          if (action === 'accept') {
            // Request change price
            $scope.flightBooking.getTestSell().setStatusDone().enableAutoticket();

            BookingServ
              .replacePricing(angular.copy($stateParams))
              .then(function (response) {
                $scope.flightBooking.getFlightDetails().setPaxesPricing(response.pricing.paxes);
              });
            AnalyticsServiceHelper.sendTestSellPriceDiffAccepted($scope.flightBooking);
            Remarketing.dataLayerPush({
              event: 'banner_interactions',
              category: 'page interactions',
              name: eventName,
              type: 'button click',
              step: 5,
              select: "accept"
            });
          }
        },
        function (action) {
          // Redirect to search results
          $scope.toSearchWithRefresh();
        });
    };

    $scope.toSearch = function () {
      $location.path(FlightBooking.getFlightDetails().getSearchUrl());
    };

    $scope.toSearchWithRefresh = function (){
      // $window.location.href = FlightBooking.getFlightDetails().getSearchUrl();

      var backToSearchUrl = $scope.flightBooking.getFlightDetails().getSearchUrl();
      var locationSearch = $location.search();

      if (locationSearch.hasOwnProperty('backToSearchUrl')) {
        backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
      }

      $location.hash('');
      $location.path(backToSearchUrl).search('');
    };

    /**
     * Login Modal
     */
    $scope.loginModal = function () {
      AuthService.showLoginModal();
    };

    $scope.cacheFormData = function () {
      $timeout(function () {
        BookingFormCache.cacheContact($scope.flightBooking.getContact());
      });
    };

    OutdatedAlertSrv.displayModal = _js_app_config_.outdatedAlert.flightDetails.displayModal;
    OutdatedAlertSrv.show(_js_app_config_.outdatedAlert.flightDetails.delay);

    $scope.$on('$destroy', function () {
      OutdatedAlertSrv.destroy();
      $scope.eventRefs.unregisterStepChangeEvent();

      if ($scope.eventRefs.unregisterSplitFunnelNoSeatsEvent) {
        $scope.eventRefs.unregisterSplitFunnelNoSeatsEvent();
      }
      $scope.orderSummaryWatcher.unsetEvents();
      $scope.ancillariesSocketHandler.destroy();
    });
  };

  FlightDetailsCtrl.$inject = [
    '$rootScope',
    '$localStorage',
    '$scope',
    '$filter',
    '$anchorScroll',
    '$modal',
    'Dictionaries',
    'appConfig',
    '$stateParams',
    '$location',
    '$window',
    '$timeout',
    'fdt.FlightDetailsServ',
    'bok.FlightBooking',
    'BookingState',
    'BackToBasket',
    '$q',
    'goo.Remarketing',
    'goo.FlightAnalytics',
    'bok.BookingServ',
    '$sce',
    'OrderValidation',
    'PageLoading',
    '$exceptionHandler',
    'OutdatedAlertSrv',
    'funnelStepsObserver',
    'FlightDetailsStepsFactory',
    'Refund',
    'CONST',
    'PaymentTokenize',
    'ErrorLogService',
    'PaymentApi',
    'AnalyticsServiceHelper',
    'SouthParkFlightCache',
    'CheckinApi',
    'AutomatedCheckinHelper',
    'AncillariesSocketHandler',
    'FunnelErrorLogCollector',
    'StepsEnum',
    'SplitFunnelAnalytics',
    'OrderSummaryWatcher',
    'BookingFormCache',
    'AuthService',
    'SeatsFlow',
    'bok.PaymentToken',
    'PaymentInject'
  ];

  angular.module('funnel')
    .controller('FlightDetailsCtrl', FlightDetailsCtrl);

})(angular, _);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/GeneralConditionsModal.js
(function (angular) {
    var GeneralConditionsModal = function (Dictionaries, $scope, carrierList, $modalInstance, FlightDetailsServ) {

        $scope.list = [];

        FlightDetailsServ.getCarrierConditionLinks(carrierList).then(function (result) {
            $scope.list = result;
        });

        $scope.getCarrierNameByCode = function() {
            return Dictionaries.getCarrierNameByCode();
        };

        $scope.close = function () {
            $modalInstance.close();
        }

    };

    GeneralConditionsModal.$inject = ['Dictionaries', '$scope', 'carrierList', '$modalInstance', 'fdt.FlightDetailsServ'];

    angular.module('funnel')
        .controller('GeneralConditionsModal', GeneralConditionsModal);

})(angular);;

// Source: ../shared/public_html/assets/js/funnel/controllers/ResultsCtrl.js
(function (angular) {
/**
     * Flight search results controller
     * @constructor
     */
    var ResultsCtrl = function ($scope, $filter, $document, AppConfig, SearchQueryParams, $stateParams, SouthParkHelper, PricegroupMarkerHelper, AuthService, SearchHistory) {
        /**
         * SouthPark helper service reference
         *
         * @type {SouthParkHelper}
         */
        $scope.southParkHelper = SouthParkHelper;

        /**
         * Search query params reference
         *
         * @type {SearchQueryParams}
         */
        $scope.searchQueryParams = SearchQueryParams;

        /**
         * App config reference
         *
         * @type {AppConfig}
         */
        $scope.appConfig = AppConfig;

        /**
         * AuthService reference
         *
         * @type {AuthService}
         */
        $scope.authService = AuthService;

        /**
         * @type {null | 'explore' | 'search'}
         */
        $scope.mode = null;

        /**
         * Method called on initialization
         */
        var init = function () {
            $scope.searchQueryParams.reset().setFromLinkParameters();
            $scope.mode = $scope.searchQueryParams.getDesCountryCode() ? 'explore' : 'search';

            if ($scope.mode === 'search') {
                SouthParkHelper.search();

                // Price trends campaign
                PricegroupMarkerHelper.loadReferencePrices(
                    $scope.searchQueryParams.getDepCityCode(),
                    $scope.searchQueryParams.getDepAirportCode(),
                    $scope.searchQueryParams.getDesCityCode(),
                    $scope.searchQueryParams.getDesAirportCode(),
                    $scope.searchQueryParams.getDepDate(),
                    $scope.searchQueryParams.isOneWay(),
                    $scope.searchQueryParams.getAdults(),
                    $scope.searchQueryParams.getChildren(),
                    $scope.searchQueryParams.getInfants(),
                    $scope.searchQueryParams.getYouths()
                );
            }

            setPageTitle();

            SearchHistory.save($scope.searchQueryParams);
        };

        /**
         * Sets page title using dom manipulation based on stte params
         * DISCLAIMER:
         * Solution is copied from old results controller.
         * This could be done more elegantly but it would need an app level refactoring
         */
        var setPageTitle = function () {
            var langName = $stateParams.ow === '1' ? 'LANGM_JS_FS_OW_META_TITLE' : 'LANGM_JS_FS_META_TITLE';

            $document[0].querySelector('title').innerHTML = $filter('translate')(langName, {
                flight_from: $stateParams.depCityName,
                flight_to: $stateParams.desCityName,
                departure_date: $stateParams.depDate,
                return_date: $stateParams.arrDate
            });
        };

        /**
         * Decides if offers should be displayed
         *
         * @returns {Boolean}
         */
        $scope.shouldShowOffers = function () {
            return (
                $scope.southParkHelper.iataDictionary.isPopulated() &&
                $scope.southParkHelper.processedOffers.best.length > 0
            );
        };

        $scope.shouldShowFakeOffers = function () {
            return (
                $scope.southParkHelper.isLoading &&
                $scope.southParkHelper.processedOffers.best.length == 0 &&
                !$scope.southParkHelper.apiError
            );
        };

        /**
         * Decides if loading sequence should be displayed
         *
         * @returns {Boolean}
         */
        $scope.shouldShowLoadingSequence = function () {
            return $scope.southParkHelper.isLoading;
        };

        /**
         * Decides if filters should be displayed
         *
         * @returns {Boolean}
         */
        $scope.shouldShowFilters = function () {
            return (
                !$scope.southParkHelper.isLoading &&
                $scope.southParkHelper.filters.computed &&
                $scope.southParkHelper.originalOffers.length > 1
            );
        };

        $scope.shouldShowExtraTitles = function () {
            return $scope.southParkHelper.uniquePerRouteOffers[
                $scope.southParkHelper.activeSortingTab
                ].length > 1;
        };

        $scope.getExtraTitleLang = function () {
            return 'LANGM_JS_' + $scope.southParkHelper.activeSortingTab.toUpperCase() + '_FLIGHT_RESULTS';
        };

        // Initialize
        init();

        $scope.$on('search-button-clicked-emit', function () {
            $scope.$broadcast('search-button-clicked-broadcast');
        });
    };

    ResultsCtrl.$inject = [
        '$scope',
        '$filter',
        '$document',
        'appConfig',
        'sch.SearchQueryParams',
        '$stateParams',
        'SouthParkHelper',
        'PricegroupMarkerHelper',
        'AuthService',
        'SearchHistory'
    ];

    angular
        .module('funnel')
        .controller('ResultsCtrl', ResultsCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/ThankYouCtrl.js
angular.module('funnel')

    /**
     * @name        basic ThankYouCtrl
     * @description Manages the thank you page
     */
    .controller('basicThankYouCtrl',
        ['$rootScope', '$q', '$scope', '$filter', '$stateParams', '$timeout', '$localStorage', 'bok.FlightBooking', 'bok.BookingServ',
            'bas.Basket', '$modal', 'thy.ThankYouServ', 'appConfig', 'PageLoading', '$location',
            'PaymentStatusService', 'PaymentTokenize', 'PaymentPage', 'CheckinApi', 'AutomatedCheckinHelper', 'TextBox',
            function basicThankYouCtrl($rootScope, $q, $scope, $filter, $stateParams, $timeout, $localStorage, FlightBooking,
                                       BookingServ, Basket, $modal, ThankYouServ, appConfig, PageLoadingService,
                                        $location, PaymentStatusService, PaymentTokenize, PaymentPage, CheckinApi, AutomatedCheckinHelper, TextBoxService) {
var token = $stateParams.hash,
                    error = $stateParams.error,
                    debugConfRules = 0,
                    location_vars = $location.search();

                PageLoadingService.on();
                document.querySelector('title').innerHTML = $filter('translate')('LANGM_JS_THANK_YOU_META_TITLE');

                // Remove cached redirect link
                $localStorage.redirectLink = null;
                $localStorage.$apply();

                // Force reloading if page is loaded from back-forward cache
                window.addEventListener('pageshow', function (event) {
                    if (event.persisted) {
                        PageLoadingService.on();
                        window.location.reload(true);
                    }
                });

                $scope.paymentStatusService = PaymentStatusService;
                $scope.paymentStatuses = PaymentStatusService.statuses;

                $scope.paymentButtonIsLoading = false;
                $scope.retryPayment = false;

                /**
                 * As we want to bind status value to scope, we need to wrap it in function
                 *
                 * $scope.name = service.method doesn't work (watcher is not created)
                 *
                 * @returns {number}
                 */
                $scope.getPaymentStatus = function getPaymentStatus() {
                    return PaymentStatusService.getStatus();
                };

                /**
                 * Indicates whether retry payment options should be displayed
                 *
                 * @returns {boolean}
                 */
                $scope.showPaymentRetryForm = function showPaymentRetryForm() {
                    return $scope.retryPayment;
                };

                /**
                 * Indicates whether booking status should be displayed
                 *
                 * @returns {boolean}
                 */
                $scope.showBookingStatus = function showBookingStatus() {
                    return PaymentStatusService.isSuccess() || PaymentStatusService.isDisabled();
                };

                /**
                 * Indicates whether payment status should be displayed
                 *
                 * @returns {boolean}
                 */
                $scope.showPaymentStatus = function showPaymentStatus() {
                    return !PaymentStatusService.isSuccess() && !PaymentStatusService.isDisabled();
                };

                $scope.openPaymentRetryForm = function () {
                    $scope.retryPayment = true;
                };

                $scope.makeNewSearch = function () {
                    $location.url(
                        $scope.flightBooking.getFlightDetails().getSearchUrl()
                    );
                };

                $scope.getPaymentStatusAsync = function getPaymentStatusAsync() {
                    return PaymentStatusService.isSuccess();
                };

                if(location_vars.confirmation_rules) {
                    debugConfRules = 1
                }

                $rootScope.funnelIsOpen = false;

                $scope.statuses = {
                    showBasket: false,
                    error: false
                };

                /**
                 * Get confirmation message request
                 *
                 * @param response
                 */
                var getConfirmationSuccess = function(response) {
                    $scope.pageData = ThankYouServ.prepareData(response);
                    $rootScope.orderInProgress = false;

                    $timeout(
                        function() {
                            var paymentButton = document.getElementById(appConfig.getPaymentButton());

                            if (paymentButton) {
                                $scope.paymentButtonIsLoading = true;

                                var data = {
                                    id: $scope.pageData.hash,
                                    ngData: 1
                                };

                                PaymentPage
                                    .transaction(data)
                                    .then(function success(response) {
                                        var credentials = response.credentials ? response.credentials : [];
                                        PaymentTokenize.setCredentials(credentials);

                                        if (response.expiredLink) {
                                            PaymentStatusService.setStatus(PaymentStatusService.statuses.EXPIRED);
                                            return;
                                        }

                                        if (response.choosed_payment_type === 'CC3') {
                                            paymentButton.addEventListener("click", redirectToCustomPaymentLink, false);
                                        } else {
                                            paymentButton.addEventListener("click", $scope.ePaymentsModal, false);
                                        }
                                    }).finally(function () {
                                    $scope.paymentButtonIsLoading = false;
                                });
                            }
                        }
                    );
                };

                function redirectToCustomPaymentLink() {
                    $scope.paymentButtonIsLoading = true;

                    var data = {
                        id: $scope.pageData.hash,
                        ngData: 1
                    };

                    PaymentPage.getPaymentLink(data).then(function success(response) {
                        if (response.expiredLink) {
                            PaymentStatusService.setStatus(PaymentStatusService.statuses.EXPIRED);
                            return;
                        }

                        if (null === response.paymentLink) {
                            handlePaymentLinkUnavailable();
                            return;
                        }

                        window.location.href = response.paymentLink;
                    }, function () {
                        handlePaymentLinkUnavailable();
                    });
                }

                var handlePaymentLinkUnavailable = function () {
                    $scope.expiredPaymentLink = true;
                    TextBoxService.getByName('payment_link_unavailable_message').then(function (response) {
                        $scope.pageData.content = response.text;
                    }, function () {
                        $scope.pageData.content = 'add payment_link_unavailable_message text box';
                    }).finally(function () {
                        PageLoadingService.off();
                    });
                };

                /**
                 * 'flow' distinguishes between legacy payments and microservice
                 * when null, payment-related TYP components are not loaded
                 *
                 * 'waitForPaymentStatus' determines whether it's necessary to check status
                 * when false, TYP with success component is loaded
                 *
                 * @param response
                 */
                function handleAsyncPaymentStatus(response) {
                    if (!response.flow || response.flow === 'PaymentInitFlow') {
                        PaymentStatusService.setStatus(PaymentStatusService.statuses.DISABLED);
                        PaymentStatusService.initPaymentDeadlineCountdown(response.payableUntil);
                        return;
                    }

                    if (response.payment.type === "CC3") {
                        // Don't show current status of custom payment transactions - show button to redirect instead
                        PaymentStatusService.setStatus(PaymentStatusService.statuses.DISABLED);
                        PaymentStatusService.initPaymentDeadlineCountdown(response.payableUntil);
                        return;
                    }

                    if (!response.waitForPaymentStatus) {
                        PaymentStatusService.setStatus(PaymentStatusService.statuses.SUCCESS);
                        return;
                    }

                    PaymentStatusService
                        .fetchStatus({reservationNumber: response.reservationNumber})
                        .then(function (status) {
                            PaymentStatusService.setStatus(status);

                            if (PaymentStatusService.isPending()) {
                                if (PaymentStatusService.getRedirectUrl()) {
                                    PaymentStatusService.redirectAfterDelay();
                                }

                                $timeout(function () {
                                    handleAsyncPaymentStatus(response);
                                }, PaymentStatusService.statusInterval);
                            }

                            PaymentStatusService.initPaymentDeadlineCountdown(response.payableUntil);
                        });
                }

                /**
                 *
                 * @param response
                 */
                var getFromHashSuccess = function(response) {
                    $scope.flightBooking = FlightBooking;
                    FlightBooking.setFlightDetails(response.flightDetails || {});
                    $scope.cashBack = $scope.flightBooking.flightDetails.getCashBack();
                    $scope.charter = $scope.flightBooking.flightDetails.isCharter();
                    $scope.statuses.showBasket = true;
                    // luggageDetails.initSharedLuggagesIfMissing(function() {
                    //     return {
                    //         paxes: $scope.flightBooking.basket.dataProvider.getPaxes(),
                    //         unitOpts: $scope.flightBooking.flightDetails.unitOpts
                    //     };
                    // });

                    $scope.departureDataSet = $scope.flightBooking.flightDetails.getDepLeg();
                    $scope.arrivalDataSet = $scope.flightBooking.flightDetails.isRoundTrip() ? $scope.flightBooking.flightDetails.getRetLeg(): null;

                    handleAsyncPaymentStatus(response);

                    CheckinApi
                        .getAirlineRules(
                            AutomatedCheckinHelper.getRulesPayload(
                                $scope.flightBooking.getFlightDetails()
                            )
                        )
                        .then(function (success) {
                            $scope.flightBooking.paidCheckinRules.setRules(
                                success.data.data.rules
                            );
                        });
                };

                delete ($rootScope.sharedLuggageData);

                $scope.pageData = {};
                $scope.controllerName = $scope.controllerName || 'Order';
                $scope.flightBooking = FlightBooking;
                $scope.affiliateId = _js_app_config_.affiliateId;

                var confirmationMessagePromise = ThankYouServ.getConfirmation(
                    {
                        token: token,
                        debug_confirmation_rules: debugConfRules,
                        controller: $scope.controllerName,
                        error: error
                    }
                );

                var bookingDetailsPromise = BookingServ.getFromHash($stateParams.hash);

                bookingDetailsPromise.then(
                  function (response) {
                      getFromHashSuccess(response);
                      confirmationMessagePromise.then(getConfirmationSuccess);
                  },
                  function (failure) {
                      if (failure.http_code && failure.http_code === 302 && failure.response.expectedUri) {
                          $location.path(failure.response.expectedUri);
                      }
                  }
                );

                $q
                    .all([confirmationMessagePromise, bookingDetailsPromise])
                    .catch(function(response) {
                        $scope.statuses.error = true;
                        $scope.errorMessage = _.isArray(response.response) ? _.first(response.response).msg :
                            $filter('translate')('LANGM_JS_THANK_YOU_ERROR_MESSAGE');
                    })
                    .finally(function() {
                        PageLoadingService.off();
                    });

                $scope.paymentLinkRedirect = function() {
                    window.location.href = $scope.pageData.customPayment.link;
                };

                /**
                 * Serves cases when agent adds insurance to unpaid reservation and changes payment type to EP
                 *
                 * @deprecated EP is about to be removed from ThankYouPage
                 */
                $scope.ePaymentsModal = function() {
                    var paymentType = $scope.pageData.paymentType.substr(0, 2);
                    $scope.pageData.paymentType = paymentType;
                    if(paymentType === 'EP' || paymentType === 'PP' || paymentType === 'BT') {
                        $modal.open({
                            templateUrl: '/tpl/show/templates/components/modals/funnel/ePayments-hyb',
                            controller: 'ePaymentsCtrl',
                            backdrop: 'static',
                            size: 'custom-md',
                            resolve: {
                                ModalArgs: function() {
                                    var newMsg = {};
                                    newMsg.flightBooking = $scope.flightBooking;
                                    if($scope.pageData.paymentType == 'PP') {
                                        newMsg.forcePayPal = 1;
                                    }
                                    return newMsg;
                                }
                            }
                        });
                    } else {
                        if(paymentType === 'CC') {
                            $modal.open({
                                templateUrl: '/tpl/show/jsShared/templates/payment/modal',
                                controller: 'paymentModalCtrl',
                                backdrop: 'static',
                                size: 'modal-payment',
                                resolve: {
                                    getMessage: function() {
                                        var newMsg = {};
                                        newMsg.hash = $scope.pageData.hash;
                                        newMsg.flightBooking = $scope.flightBooking;
                                        return newMsg;
                                    }
                                }
                            });
                        }
                    }
                };
            }])

    /**
     * @name        ThankYouCtrl
     * @description Manages the thank you page
     */
    .controller('ThankYouCtrl',
        ['$scope', '$controller',
            function ThankYouCtrl($scope, $controller) {
                $scope.controllerName = 'Order';
                angular.extend(this, $controller('basicThankYouCtrl', {$scope: $scope}));
            }])

    /**
     * @name        ThankYouOrderCtrl
     * @description Manages the thank you page
     */
    .controller('ThankYouOrderCtrl',
        ['$scope', '$controller',
            function ThankYouOrderCtrl($scope, $controller) {
                $scope.controllerName = 'Order';
                angular.extend(this, $controller('basicThankYouCtrl', {$scope: $scope}));

            }])

    /**
     * @name        ThankYouOrderArchiveCtrl
     * @description Manages the thank you page
     */
    .controller('ThankYouOrderArchiveCtrl',
        ['$scope', '$controller',
            function ThankYouOrderArchiveCtrl($scope, $controller) {
                $scope.controllerName = 'Order';
                angular.extend(this, $controller('basicThankYouCtrl', {$scope: $scope}));

            }])

    /**
     * @name        ThankYouConfirmationShowCtrl
     * @description Manages the thank you page
     */
    .controller('ThankYouConfirmationShowCtrl',
        ['$scope', '$controller',
            function ThankYouConfirmationShowCtrl($scope, $controller) {
                $scope.controllerName = 'Confirmation';
                angular.extend(this, $controller('basicThankYouCtrl', {$scope: $scope}));

            }])

    /**
     * @name        ThankYouConfirmationArchiveCtrl
     * @description Manages the thank you page
     */
    .controller('ThankYouConfirmationArchiveCtrl',
        ['$scope', '$controller',
            function ThankYouConfirmationArchiveCtrl($scope, $controller) {
                $scope.controllerName = 'Confirmation';
                angular.extend(this, $controller('basicThankYouCtrl', {$scope: $scope}));

            }]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/InsuranceThPageCtrl.js
angular.module('flight')

/**
 * @name        InsuranceThPageCtrl
 * @description Manages the travelInsuranceAdBox directive
 */
  .controller('InsuranceThPageCtrl',
    ['$scope', '$stateParams', '$timeout', 'dsc.InsuranceServ', 'InsuranceServices',
      function InsuranceThPageCtrl($scope, $stateParams, $timeout, InsuranceServ, InsuranceServices) {
$scope.insuranceLoaded = true;

        function updateSelectedInsurance() {
          $scope.insuranceSelected = InsuranceServices.selectedInsurance;
        }

        function updatePosibleOption() {
          $scope.insurances = InsuranceServices.insurances;
        }
var numberOfDaysOneWay = 0
        $scope.updateInsurancePackages = function ($event) {
          var param = angular.copy($stateParams)
          numberOfDaysOneWay =param.owNoOfDays = $event.newDates
          var oldSelect = InsuranceServices.selectedInsurance;
          InsuranceServ.getForReservation(param, param).then(function (answer) {
            $scope.isInsuranceAllow = answer.isInsuranceAllow;
            InsuranceServices.reset().setInsuraceAllow(answer.isInsuranceAllow)
            InsuranceServices
              .fetchProviders(answer.providers)
              .setInsuraceAllow(answer.isInsuranceAllow)
              .fetchInsurances(
                InsuranceServ.mapInsuranceObjectToArray(answer.providers, answer.insurance)
              )
              .setDefaultInsurance(answer.defaultProvider, answer.defaultType)
            if (oldSelect) {
              InsuranceServices.selectInsurance(oldSelect.provider, oldSelect.type)
            }
            updateSelectedInsurance()
            updatePosibleOption()

          });
        }
        $scope.chooseInsurance = function (event, provider, type) {
          InsuranceServices.selectInsurance(provider, type)
          updateSelectedInsurance()
          $timeout(
            function () {
              $stateParams.provider = provider;
              $stateParams.type = type;
              var param = angular.copy($stateParams)
              param.owNoOfDays = numberOfDaysOneWay

              InsuranceServ.addToOrder(param, {}).then(
                function (answer) {
                  location.reload();
                }
              );
            }
          )
        };
        console.log('InsuranceServ')
        InsuranceServ.getForReservation($stateParams, {}).then(
          // Success response
          function (answer) {
            $scope.isInsuranceAllow = answer.isInsuranceAllow;
            if (!answer.isInsuranceAllow) {
              InsuranceServices.reset().setInsuraceAllow(answer.isInsuranceAllow)
            }

            InsuranceServices
              .fetchProviders(answer.providers)
              .setInsuraceAllow(answer.isInsuranceAllow)
              .fetchInsurances(
                InsuranceServ.mapInsuranceObjectToArray(answer.providers, answer.insurance)
              )
              .setDefaultInsurance(answer.defaultProvider, answer.defaultTyoe)

            updateSelectedInsurance()
            updatePosibleOption()
          },
          // Failure response
          function (answer) {
            console.error(answer)
          })
          .then(function () {
            $scope.insuranceLoaded = true;
          })
        ;
      }]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/blikForm/blikFormCtrl.js
(function(angular) {
/**
     * @name        blikFormCtrl
     * @description Manages the Blik Form directive
     */
    var BlikFormController = function() {};

    angular.module('book').controller('blikFormCtrl', BlikFormController);
})(angular);;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/ccForm/ccFormCtrl.js
(function(angular) {
/**
     * @name        ccFormCtrl
     * @description Manages the Credit Card Form directive
     */
    var CreditCardFromController = function($rootScope, $scope, ValidationUtils) {
        $scope.creditCartImage = (function(){
            var ln = _js_app_config_.language_code;
            return {
                front:'front_tooltip_' + ln + '.png',
                back:'back_tooltip_' + ln + '.png'
            }
        })();
        var cardSettings = {
            vola: {
                mask: '9999 9999 9999 9?9?9?9?9?9?9?',
                minLength: 12,
                maxLength: 19
            },
            other: {
                mask: '9999 9999 9999 99?9?9?',
                minLength: 13,
                maxLength: 16
            }
        };
        var cardSettingsKey = $rootScope.affiliate === 'vola' ? 'vola' : 'other';

        $scope.masks = {
            ccNumber: cardSettings[cardSettingsKey].mask,
            expiration: '19/99',
            cvc: '999'
        };

        $scope.validators = {
            updateOn: 'blur',
            ccNumber: {
                valueModifier: 'removeWhitespaces',
                validators: [
                    {rule: 'isRequired', messageKey: 'required'},
                    {rule: 'hasMinLength', messageKey: 'minlength', params: cardSettings[cardSettingsKey].minLength},
                    {rule: 'hasMaxLength', messageKey: 'maxlength', params: cardSettings[cardSettingsKey].maxLength},
                    {rule: 'isCreditCard', messageKey: 'ccnumber', params: $scope.model}
                ]
            },
            expiration: {
                valueModifier: 'removeWhitespaces',
                validators: [
                    {rule: 'isRequired', messageKey: 'required'},
                    {rule: 'hasMinLength', messageKey: 'minlength', params: 5},
                    {rule: 'hasMaxLength', messageKey: 'maxlength', params: 5},
                    {rule: 'isExpirationDate', messageKey: 'expirationDate'}
                ]
            },
            cvc: {
                valueModifier: 'removeWhitespaces',
                validators: [
                    {rule: 'isRequired', messageKey: 'required'},
                    {rule: 'hasMinLength', messageKey: 'minlength', params: 3},
                    {rule: 'hasMaxLength', messageKey: 'maxlength', params: 3}
                ]
            }
        };

        $scope.currentYearInFormat = moment().format('YY');
        $scope.expMaxYear = parseInt($scope.currentYearInFormat) + 12;

        var allowed = [
            48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105 /*, 65, 86, 88, 90*/
        ];
        var allowedSpecialChar = [
            8, 9, 13, 17, 27, 35, 36, 37, 38, 39, 40, 46
        ];

        var regex = ValidationUtils.getExpirationRegex();

        function checkSlash() {
            var inputValue = document.getElementById('expDateForm').value,
                slashIndex = inputValue.search("/"),
                monthValue, remainingValue;

            if(slashIndex != -1) {
                var start;
                monthValue = inputValue.substring(0, slashIndex > 1 ? 2 : slashIndex).replace(/\//g, '');
                start = slashIndex > 1 ? 2 : slashIndex + 1;
                remainingValue = inputValue.substring(start, start + 3).replace(/\//g, '');
            } else {
                monthValue = inputValue.substring(0, 2);
                remainingValue = inputValue.substring(2, 4);
            }

            var addSlash = monthValue.length > 1;
            document.getElementById('expDateForm').value = addSlash ? monthValue + '/' + remainingValue : monthValue + remainingValue;

            return addSlash;
        }

        $scope.addSlashAfterMonth = function($event) {
            var key = $event ? $event.which : $event.keyCode,
                position = $event.target.selectionStart;

            var addSlash = checkSlash();
            $event.target.selectionEnd = position + (addSlash ? 1 : 0);
        };

        function ctrlCombinations($event) {
            return $event.ctrlKey && _.indexOf([65, 67, 86, 88, 90], $event.keyCode) != -1;
        }

        function specialCombinations($event) {
            return $event.shiftKey && _.indexOf(_.range(48, 58), $event.keyCode) != -1;
        }

        //on keydown
        $scope.validatePrevent = function($event) {
            if(!$event) {
                return false;
            }

            var key = $event ? $event.which : $event.keyCode;

            var expDateForm = document.getElementById('expDateForm');
            var inputValue = expDateForm.value;
            var oldValue = angular.element(expDateForm).data('oldValue') || "";
            angular.element(expDateForm).data('oldValue', inputValue.match(regex) || inputValue.length < 2 ? inputValue : oldValue);

            if(!ctrlCombinations($event)) {
                if((allowed.indexOf(key) == -1 && allowedSpecialChar.indexOf(key) == -1) || specialCombinations($event)) {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            }
        };

        //on keyup
        $scope.validateExpDate = function($event) {
            //var expDateForm = document.getElementById('expDateForm');

            if(!$event) {
                return false;
            }

            $scope.checkLength($event);

            var key = $event ? $event.which : $event.keyCode;


            if(!ctrlCombinations($event)) {
                if(((allowed.indexOf(key) == -1 && key != 191) || specialCombinations($event) /*&& allowedSpecialChar.indexOf(key) == -1*/ ) /* || (inputValue.length > 4 && allowedSpecialChar.indexOf(key) == -1)*/) {
                    $event.preventDefault();
                    $event.stopPropagation();
                } else {
                    $scope.addSlashAfterMonth($event);
                }
            }
            return false;

        };

        function limitInputLength($event, limit, value) {
            if(!$event) {
                return false;
            }
            value = value || $event.target.value;
            var textSelected = false;
            var key = $event.which || $event.keyCode || 0;

            if(_.has($event.target, 'selectionStart')) {
                textSelected = $event.target.selectionStart != $event.target.selectionEnd;
            }

            if(!ctrlCombinations($event) && !specialCombinations($event) && !textSelected) {
                if(value.length === limit && key !== 8) {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            }
        }

        $scope.checkLength = function($event) {
            var inputValue = document.getElementById('expDateForm').value;

            return limitInputLength($event, 5, inputValue);
        };

        $scope.onChange = function() {
            checkSlash();
        };

        $scope.limitCvc = function($event) {
            return limitInputLength($event, 3);
        };
    };

    CreditCardFromController.$inject = [
        '$rootScope',
        '$scope',
        'ValidationUtils'
    ];

    angular.module('book').controller('ccFormCtrl', CreditCardFromController);
})(angular);;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/ccForm/credit-card-exchange-info.controller.js
(function(angular) {
/**
   * @name        CreditCardExchangeInfoController
   * @description Handles exchange info for credit card payments
   * @constructor
   * @author Floares Bogdan <bogdan.floares@vola.ro>
   */
  var CreditCardExchangeInfoController = function($scope, appConfig) {

    /**
     * Get total price
     * NOTE: it works for payment error page and all booking pages: flights, local escapes, hotels ...
     *
     * @returns {String}
     */
    this.getTotalPrice = function() {
      var price =  $scope.basket ? $scope.basket.getTotalPrice() : '0.00';

      return typeof(price)==='number' ? price.toFixed(2) : price;
    };

    /**
     * Get total ron price
     * NOTE: it works for payment error page and all booking pages: flights, local escapes, hotels ...
     *
     * @returns {number}
     */
    this.getTotalRonPrice = function() {
      return $scope.basket ? $scope.basket.getTotalRonPrice() : 0;
    };

    /**
     * Get information to display in view
     *
     * @returns {string}
     */
    this.getPaymentTotalPrice = function()
    {
      return $scope.model.currency === 'RON' ?
        this.getTotalRonPrice().toFixed(2) + ' RON' :
        this.getTotalPrice() + ' €';
    };

    /**
     * Get information to display in view
     *
     * @returns {string}
     */
    this.getPaymentTotalPriceCurr = function (currency) {
      var price = $scope.basket ? $scope.basket.getTotalPriceCurrency(currency) : 0;

      return $scope.model.currency === currency ?
        price.toFixed(2) + ' ' + currency :
        this.getTotalPrice() + ' ' + this.getFlightCurrency();
    };

    /**
     * Get price exchanged information
     *
     * @returns {string}
     */
    this.getPaymentTotalPriceExchanged = function () {
      return $scope.model.currency !== this.getFlightCurrency() ?
        '(' + this.getTotalPrice() + ' ' + appConfig.getCurrencyCode() + ')' :
        '';
    };

    /**
     * Get basket currency code
     *
     * @returns {string}
     */
    this.getFlightCurrency = function () {
      return $scope.basket ? $scope.basket.getPaxesPricing().getCurrencyCode() : appConfig.getCurrencyCode();
    };
  };

  CreditCardExchangeInfoController.$inject = [
    '$scope',
    'appConfig'
  ];

  angular.module('book')
    .controller('CreditCardExchangeInfoCtrl', CreditCardExchangeInfoController);

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/flightDetailsBoxesCtrl.js
angular.module('flight')

/**
 * @name        flightDetailsBoxesCtrl
 * @description Manages the travelInsuranceAdBox directive
 */
.controller('flightDetailsBoxesCtrl',
['$scope', 'Dictionaries',
function flightDetailsBoxesCtrl($scope, Dictionaries) {
if (angular.isFunction($scope.modelPromise.then)) {
    $scope.modelPromise.then(function (model) {
      $scope.flightBooking = model;
    });
  }
  else {
    $scope.flightBooking = $scope.modelPromise;
  }

  /**
   * Dictionaries
   *
   * @type {Dictionaries}
   */
  $scope.dictionaries = Dictionaries;

}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/details/flightDetailsDataCtrl.js
angular.module('flight')

/**
 * @name        flightDetailsDataCtrl
 * @description Manages the flightDetailsData directive
 */
.controller('flightDetailsDataCtrl',
['$scope', 'Dictionaries',
function flightDetailsDataCtrl($scope, Dictionaries) {
$scope.Dictionaries = Dictionaries;


}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/ePaymentsCtrl.js
angular.module('funnel')

/**
 * @name        ePaymentsCtrl
 * @description Manages the thank you page
 */
.controller('ePaymentsCtrl',
['$scope', '$modalInstance', 'ModalArgs',
function ePaymentsCtrl($scope, $modalInstance, ModalArgs) {
if(ModalArgs &&_.isObject(ModalArgs.flightBooking))
  {
    $scope.total_price = ModalArgs.flightBooking.basket.getTotalPrice().toFixed(2);
  }

  // For insurance fix
  if(ModalArgs && ModalArgs.price)
  {
    $scope.total_price = ModalArgs.price;
  }

  if(ModalArgs && ModalArgs.forcePayPal)
  {
    $scope.forcePayPal = 1;
  }



  $scope.setBankId = function (id) {
    console.log(id);

    var form = document.getElementById("paymentForm"),
      inputs = form ? form.getElementsByTagName("input") : [];
    for (var i = 0; i < inputs.length; i++) {

      if (inputs[i].getAttribute('id') == "p24_metoda") {
        inputs[i].value = id;
        form.submit();
        return;
      }
    }
  };

  /**
   * Close Modal
   * @type {*}
   */
  $scope.closeModal = function () {
    $modalInstance.close();
  };
}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/PassengerDetailsBoxCtrl.js
angular.module('funnel')

/**
 * @name        PassengerDetailsBoxCtrl
 * @description Manages the luggageInfoBox directive
 */
.controller('PassengerDetailsBoxCtrl',
['$scope', '$controller',
function PassengerDetailsBoxCtrl($scope, $controller) {
angular.extend(this, $controller('basicPassengerDetailsBoxCtrl', {$scope: $scope}));

}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/PaymentInfoBoxCtrl.js
angular.module('funnel')

/**
 * @name        PaymentInfoBoxCtrl
 * @description Manages the payment info box directive
 */
.controller('PaymentInfoBoxCtrl',
['$scope', '$controller',
function ($scope, $controller) {
angular.extend(this, $controller('basicPaymentInfoBoxCtrl', {$scope: $scope}));
}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/basicBillingInfoCtrl.js
(function(angular) {
/**
     * @name        basicBillingInfoCtrl
     * @description Manages the billingInfoBox directive.
     */
    var basicBillingInfoCtrl = function($rootScope, $scope, Locations, appConfig) {
        $scope.activePerson = true;
        $scope.activeCompany = false;
        $scope.globalVariable = $rootScope;
        $scope.locations = {};

        /**
         * Get countries and provinces and inject them into scope.
         */
        function getLocations() {
            // Locations object storing countries and provinces
            $scope.locations = {};

            // Get countries
            Locations.getCountries(true).then(function(resp) {
                $scope.locations.countries = resp;
            });
        }

        function actions() {
            getLocations();

            $scope.$watch(function() {
                return $scope.model.getBilling().isPerson();
            }, function(value) {
                $scope.activePerson = value;
            });

            $scope.$watch(function() {
                return $scope.model.getBilling().isCompany();
            }, function(value) {
                $scope.activeCompany = value;
            });

            try {
                //useful for copying person billing data from first passenger
                $scope.model.billing.changedBillingPerson = false;
            }
            catch(e) {
                console.error(e);
                throw new Error(e);
            }
        }

        if(angular.isFunction($scope.modelPromise.then)) {
            $scope.modelPromise.then(function(model) {
                $scope.model = model;
                actions();
            });
        }
        else {
            $scope.model = $scope.modelPromise;
            actions();
        }
    };

    basicBillingInfoCtrl.$inject = [
        '$rootScope',
        '$scope',
        'Locations',
        'appConfig'
    ];

    angular
        .module('funnel')
        .controller('basicBillingInfoCtrl', basicBillingInfoCtrl);

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/basicPassengerDetailsBoxCtrl.js
/* eslint-disable indent */
(function () {
angular.module('funnel')

    /**
     * @name        basicPassengerDetailsBoxCtrl
     * @description Manages the passenger details box directive
     */
    .controller('basicPassengerDetailsBoxCtrl',
      ['$scope', '$rootScope', '$stateParams', '$window', '$translate', 'DateUtils', '$location', '$modal', '$timeout', 'Locations', '$sessionStorage', 'appConfig', 'BookingFormCache', 'BookingFormFiller',
        function ($scope, $rootScope, $stateParams, $window, $translate, DateUtils, $location, $modal, $timeout, Locations, $sessionStorage, appConfig, BookingFormCache, BookingFormFiller) {
        $scope.model = null; //todo separate flight details part
        $scope.bookingForm = $scope.form;
        $scope.passengerDetails = {};
        $scope.statuses = {};
        $scope.statuses.popoverIsOpen = false;

        $scope.forRomania = function () {
          return appConfig.getDefaultCountryCode() == 'RO';
        };

          $scope.shouldShowPaxForm = function () {
            return appConfig.getAbConfig()['dfs_forms_position'] === 'end' || $scope.steps.isFirstStep();
          };

        $scope.buddies = [];
        $scope.adtBuddies = [];
        $scope.chdBuddies = [];
        $scope.infBuddies = [];
        $scope.srcBuddies = [];

        $scope.loadingProfileData = _.noop;

        $scope.infRange = DateUtils.getInfYearRange();
        $scope.chdRange = DateUtils.getChdYearRange();
        $scope.adtRange = DateUtils.getAdtYearRange();
        $scope.ythRange = DateUtils.getYthYearRange();

        $scope.resetShowYoungerFlag = function () {
          _.forEach($scope.model.getPaxes(), function (elem) {
            elem.getPerson().showYounger = false;
          });
        };

        $scope.showSearchPanelTooltip = function () {
          $scope.resetShowYoungerFlag();
          $rootScope.searchBarVisible = true;
          $rootScope.$broadcast('openPaxDropdown', true);
          $sessionStorage.openPaxDropdown = true;
        };

        $scope.showYoungerModal = function () {
          $modal.open({
            size: 'sm',
            scope: $scope,
            templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/passengerDetails/youngerPopover'
          });
        };

        $scope.goToHomepage = function () {
          $window.location.href = "\\";
          $scope.showSearchPanelTooltip();
        };

        $scope.$on('storeFormData', function () {
          $scope.cacheFormData();
        });

        if (angular.isFunction($scope.modelPromise.then)) {
          $scope.modelPromise.then(function (model) {
            $scope.model = model;
            whenOrderLoaded();
          });
        }
        else {
          $scope.model = $scope.modelPromise;
          whenOrderLoaded();
        }

        function whenOrderLoaded() {
          $scope.resetShowYoungerFlag();

          var cachedPaxes = BookingFormCache.getPaxes();
          var cachedContact = BookingFormCache.getContact();
          var cachedBilling = BookingFormCache.getBilling();

          if (cachedPaxes && cachedPaxes.length) {
            angular.forEach(cachedPaxes, function (paxData, index) {
              if ($scope.model.paxes[index]) {
                var person = $scope.model.paxes[index].getPerson();

                if (person.getType() === paxData.person.type) {
                  person.srvSet(paxData.person);
                }
              }
            });
          }

          if (cachedContact) {
            $scope.model.getContact().srvSet(cachedContact);
          }

          if (cachedBilling) {
            $scope.model.getBilling().srvSet(cachedBilling);
          }

          var formStatuses = [];

          /**
           * Return array of form statuses for every pax (if form $dirty)
           *
           * @returns {Array}
           */
          function setFormStatuses() {
            var formStatuses = [], formState;

            try {
              if ($scope.bookingForm) {
                for (var i = 0; i < $scope.model.getPaxCount(); i++) {
                  formState = false;

                  if ($scope.bookingForm["passengerDetails" + i]) {
                    formState = $scope.bookingForm["passengerDetails" + i].$dirty;
                  }

                  if (i == 0 && $scope.bookingForm.contactInfo) {
                    formState = formState || $scope.bookingForm.contactInfo.$dirty;
                  }

                  formStatuses.push(formState);
                }
              }
            }
            catch (e) {
              formStatuses = [];
              throw new Error(e);
            }

            return formStatuses;
          }

          /**
           * Timeout because of forms loading
           */

          $timeout(function () {
            formStatuses = setFormStatuses();
            $scope.state.loadUserData($rootScope.auth ? $rootScope.auth.loggedIn : false, formStatuses);

            $rootScope.$on('userLogged', function (event, data) {
              formStatuses = setFormStatuses();
              $scope.state.loadUserData(data, formStatuses);
            });

            $rootScope.$on('userLoggedOut', function (event, data) {
              BookingFormCache.clear();
              $scope.model.getBilling().reset();
              $scope.state.resetUserDataProvidedState();
              $scope.bookingForm.$setPristine();

              if ($scope.state && $scope.state.loadingProfileData()) {
                $scope.state.stopLoadingUserData();
              }
            });

            var generateBuddySelectData = function (allBuddies, paxType) {
              var buddiesByPaxType = _.filter(allBuddies, { paxType: paxType });

              if (buddiesByPaxType.length === 0) {
                return [];
              }

              return _.union(
                [{ id: '', name: $translate.instant('LANGM_JS_SELECT_' + paxType + '_BUDDY') }],
                buddiesByPaxType
              );
            };

            /**
             * Arrays of buddies of every type
             */
            $scope.state.getUserProfileData().then(function (profileBuddies) {
              _.forEach(profileBuddies, function (buddy) {
                buddy.name = buddy.firstName + ' ' + buddy.lastName;
              });

              $scope.buddies = profileBuddies.slice(0);
              $scope.adtBuddies = generateBuddySelectData(profileBuddies, 'ADT');
              $scope.chdBuddies = generateBuddySelectData(profileBuddies, 'CHD');
              $scope.infBuddies = generateBuddySelectData(profileBuddies, 'INF');
              $scope.ythBuddies = generateBuddySelectData(profileBuddies, 'YTH');
            });

            $scope.getCountries();
            $scope.birthDateSelect = DateUtils.getRegularDate();
            $scope.passportExpiration = DateUtils.getPassportDate();
          });
        }

        $scope.updatePax = _.noop;



        if (!_.isObject($scope.statuses)) {
          $scope.statuses = {};
        }

        $scope.showBirthdayLink = function (type) {
          return type == 'ADT' || type == 'YTH';
        };

          $scope.hasBuddiesByPaxType = function (paxType) {
            return $scope.getBuddiesByPaxType(paxType).length > 0;
          };

          $scope.getBuddiesByPaxType = function (paxType) {
            if (paxType === 'ADT') { return $scope.adtBuddies || []; }
            if (paxType === 'CHD') { return $scope.chdBuddies || []; }
            if (paxType === 'INF') { return $scope.infBuddies || []; }
            if (paxType === 'YTH') { return $scope.ythBuddies || []; }

            return $scope.srcBuddies || [];
          };

        /**
         * Get countries method
         */
        $scope.getCountries = function () {
          Locations.getCountries().then(function (resp) {
            $scope.countries = resp;

            // We need paxes past this point
            if (!$scope.model.getPaxes().length || !$stateParams.passengerIndex) return;

            // Get user selected country code or default (RO)
            var
              paxPassport = $scope.model.getPax($stateParams.passengerIndex).getPerson().getPassport(),
              prevIssuingCountryCode = paxPassport.getIssuingCountry() || 'PL';

            // Find Romania in countries
            var prevIssuingCountry = _.find(resp, function (country) {
              return country.getCode() == prevIssuingCountryCode;
            });

            var prevNationality = _.find(resp, function (country) {
              return country.getCode() == 'PL';
            });

            // Set Romania as default selection (after temporary passenger is set)
            paxPassport.setIssuingCountry(prevIssuingCountry);
            paxPassport.setNationality(prevNationality);
          });
        };

        /**
         * Translate change success event
         */
        $rootScope.$on('$translateChangeSuccess', function () {
          // Reload locations
          $scope.getCountries();
        });

        $scope.toSearch = function () {
          $location.path($scope.model.flightDetails.getSearchUrl());
        };

          /**
           *
           * @param personId (person id)
           * @param paxIndex (modified pax form index)
           */
          $scope.assignTravelBuddy = function (paxIndex) {
            var person = $scope.model.paxes[paxIndex].person;
            var buddyId = person.id;

            person.reset();

            if (buddyId !== null && buddyId !== '') {
              var foundBuddy = _.find($scope.buddies, { id: buddyId });
              person.srvSet(foundBuddy.srvObj());
              person.setAddToProfile(false);
            }

            BookingFormCache.cachePaxes($scope.model.paxes);
          };

        $scope.addToProfile = function (personId, paxIndex) {
          if (!personId) {
            $scope.model.paxes[paxIndex].person.addToProfile = true;
          }
        };

          $scope.toggledLuggage = {};

          $scope.editLuggage = function (index) {
            $scope.toggledLuggage[index] = true;
          };

      }]);
})();
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/basicPaymentInfoBoxCtrl.js
/* eslint-disable indent */
angular.module('funnel')

/**
 * @name        basicPaymentInfoBoxCtrl
 * @description Manages the payment info box directive
 */
.controller('basicPaymentInfoBoxCtrl',
['$scope', 'appConfig', '$rootScope', 'PaymentTokenize',
function ($scope, appConfig, $rootScope, PaymentTokenize) {
$scope.model = null;
  $scope.modelPromise = $scope.modelPromise || null;
  $scope.paymentContentPostfix = $scope.paymentContentPostfix || '';

  $scope.customToggle = function(selection, paymentOption){
    selection.selectedNode = paymentOption;
    $scope.model.getPayment().type = paymentOption.type;
  };
  $scope.isActive = function(selection, paymentOption) {
    if (selection.selectedNode === null) {
      return paymentOption.type === 'CC';
    }
    return selection.selectedNode === paymentOption;
  };

  $scope.shouldRenderPaymentOption = function(paymentOption) {
    if (paymentOption.type === 'CC3') {
      return true;
    }

    if (paymentOption.type === 'CC4') {
      return PaymentTokenize.hasCredential({
        currency: appConfig.getCurrencyForCreditCardInstallments(),
        paymentType: paymentOption.type
      });
    }

    if (!PaymentTokenize.hasCredential({
      currency: appConfig.getCurrencyCode(),
      paymentType: paymentOption.type,
    })) {
      return false;
    }

    if (paymentOption.type === 'AP') {
      return $scope.model.payment.applePayClient.isReadyToPay;
    }

    if (paymentOption.type === 'AP2') {
      return $scope.model.payment.revolutCheckoutClientForApplePay.isReadyToPay;
    }

    if (paymentOption.type === 'GP') {
      return $scope.model.payment.googlePayClient.isReadyToPay;
    }

    if (paymentOption.type === 'GP2') {
      return $scope.model.payment.revolutCheckoutClientForGooglePay.isReadyToPay;
    }

    if (paymentOption.type === 'RP') {
      return $scope.model.payment.revolutCheckoutClientForRevolutPay.isReadyToPay;
    }

    if (paymentOption.type === 'PBL') {
      return $scope.model.payment.pbl.getAvailableVendors().length > 0;
    }

    return true;
  };

  /**
   * Validate available options, check ApplePay/GooglePay initializations
   *
   * @returns {array}
   */
  $scope.getValidatedPaymentOptions = function() {
    var paymentOptions = ($scope.model && $scope.model.paymentOptions) || [];
    return _.filter(paymentOptions, function(paymentOption) {
      return $scope.shouldRenderPaymentOption(paymentOption);
    });
  };
  $scope.defaultCountry = appConfig.getDefaultCountryCode();

  $scope.forRomania = function(){
    return $scope.defaultCountry === 'RO';
  };
$scope.isVola = $rootScope.affiliate === 'vola';
  /**
   * choose and assign default payment
   *
   * @param availablePayments
   * @param forceBT
   * @returns {string}
   */
  var getDefaultPayment = function(availablePayments, forceBT, defPayment){
    availablePayments = typeof availablePayments !== 'undefined' ?  availablePayments : [];
    forceBT = typeof forceBT !== 'undefined' ?  forceBT : false;
    var defaultPayment = typeof defPayment !== 'undefined' ?  defPayment : false;
    var bankTransfer = 'BT';
    if (_.contains(availablePayments, bankTransfer) && forceBT) {
      defaultPayment = bankTransfer;
    }
    else if(defaultPayment === false)
    {
      defaultPayment = availablePayments[0];
    }

    return defaultPayment;
  };

  $scope._getDefaultPayment = getDefaultPayment;

  /**
   * move payment to the end of array
   *
   * @param payments
   * @param type
   * @returns {*}
   */
  var movePaymentToTheEnd = function(payments, type){
    var sortedPayments = _.clone(payments);
    var index = sortedPayments.indexOf(type);
    if(index != -1){
      var payment = sortedPayments.splice(index, 1); //splice returns array
      sortedPayments.push(payment[0]);
    }
    return sortedPayments;
  };

  $scope._movePaymentToTheEnd = movePaymentToTheEnd;

  var handlePayments = function () {
    //for flight booking
    if ($scope.model && _.isFunction($scope.model.getFlightDetailsPromise)) {
      $scope.model.getFlightDetailsPromise().then(function (flightDetails) {

        var paymentOptions = flightDetails.getPaymentOptions(),
          availablePayments = paymentOptions.available || [];
        //choose default payment
        var defaultPaymentType = getDefaultPayment(availablePayments, paymentOptions.forceBT, flightDetails.getDefaultPayment());
        $scope.model.getPayment().setType(defaultPaymentType);
        $scope.model.getPayment().setPaymentOptions(flightDetails.getPaymentOptions());
        $scope.model.setPaymentOptions(availablePayments);
      });
    }
    //for other booking
    else if($scope.model && $scope.paymentOptionsPromise){
      $scope.paymentOptionsPromise.then(function(options){
          var defaultPaymentType = getDefaultPayment(options);
          $scope.model.getPayment().setType(defaultPaymentType);
          $scope.model.setPaymentOptions(options);
        },
        function(response){
          $scope.model.getPayment().setType(getDefaultPayment());
        });
    }
    else if($scope.model){
      $scope.model.getPayment().setType(getDefaultPayment());
    }
  };

  if ($scope.modelPromise && angular.isFunction($scope.modelPromise.then)) {
    $scope.modelPromise.then(function (model) {
      $scope.model = model;
      handlePayments();
    });
  }
  else {
    $scope.model = $scope.modelPromise;
    handlePayments();
  }
}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/biling-switch-fru-wrapper/billing-switch-fru-wrapper.component.js
(function (angular) {
/**
     * @name        BillingSwitchFruWrapperCtrl
     * @description responsible for handle billing from scope and set billing type & isFake flag (in Poland we don't need personal billing)
     * when isFake eq tru then data from billing has not been procesed by backend
     * @autor Dominik Kajzar <dominik.kajzar@fru.pl>
     */
    var BillingSwitchFruWrapperCtrl = function ($timeout, BookingFormCache) {
        /**
         * Flag for showing/hiding billing form
         *
         * @type {Boolean}
         */
        this.needCompanyInvoice = false;

        /**
         * handle onUpdate event fom billing-switch
         * set bill type personal or company
         * also set fake flag for person bill type
         */
        this.switchContext = function () {
            var self = this;

            $timeout(function () {
                var billType = self.needCompanyInvoice ? 'company' : 'person';
                self.billingModel.setType(billType);
                self.billingModel.setFake(billType === 'person');
            });
        };

        this.$onInit = function () {
            updateValue(this);
        };

        this.$onChanges = function () {
            updateValue(this);
        };

        var updateValue = function (context) {
            if (!context.billingModel) {
                return;
            }

            context.needCompanyInvoice = context.billingModel.type === 'company';
            context.billingModel.setFake(context.billingModel.type === 'person');

            $timeout(function () {
                BookingFormCache.cacheBilling(context.billingModel);
            });
        };
    };

    BillingSwitchFruWrapperCtrl.$inject = [
        '$timeout',
        'BookingFormCache'
    ];

    var BillingSwitchFruWrapper = {
        bindings: {
            billingModel: '<',
            billingType: '<'
        },
        template: '<ith-ui-checkbox ng-model="$ctrl.needCompanyInvoice" callback="$ctrl.switchContext()" switcher="true"></ith-ui-checkbox>',
        controller: BillingSwitchFruWrapperCtrl
    };

    angular
        .module('ITH.Funnel.BillingSwitchFruWrapper', [])
        .component('billingSwitchFruWrapper', BillingSwitchFruWrapper);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billing-form.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        return ($attrs.type && $attrs.type === 'personal')
            ? '/tpl/show/jsShared/templates/flights/flightDetails/pax/billing-personal-form/billing-personal-form'
            : '/tpl/show/jsShared/templates/flights/flightDetails/pax/billing-company-form/billing-company-form';
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    var billingFormComponent = {
        templateUrl: templateUrl,
        bindings: {
            billingParent: '<?',
            billingModel: '<',
            locations: '<',
            type: '@'
        },
        controller: ['appConfig', 'BookingFormCache', '$timeout', function (AppConfig, BookingFormCache, $timeout) {
            this.isRo = function () {
                return this.billingModel.getAddress().getCountry() === 'RO';
            };

            this.isVola = function () {
                return AppConfig.isVola();
            };

            this.getLangIfRo = function (roLang, otherLang) {
                return this.isRo() ? roLang : otherLang;
            };

            this.cacheBillingData = function () {
                if (!this.billingParent) {
                    return;
                }

                var self = this;
                $timeout(function () {
                    BookingFormCache.cacheBilling(self.billingParent);
                });
            };
        }]
    };

    angular
        .module('funnel')
        .component('billingForm', billingFormComponent);

})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billing-radio-selector/billing-radio-selector.component.js
(function(angular, underscore) {
/**
     * @name        BillingRadioSelector
     * @description main component fo billing functionalty
     */
    var BillingRadioSelectorCtrl = function ($rootScope, $timeout, UserService, appConfig, BookingFormCache, BookingFormFiller, AuthValuesConverter, UserSessionData, UserServiceV2) {
        var self = this;
        this.billing = [];
        this.prevBillId = null;
        this.newBill = 'newBill';

        /**
         * @name        isBillingInitializete
         * @description flag for orderState for unInitialize Billing
         */

        $rootScope.isBillingInitializete = false;

        this.$onInit = function () {
            $rootScope.$on('userLogged', function () {
                self.loggedIn();
            });

            if (UserSessionData.isLogged()) {
                self.loggedIn();
            }
        }

        this.loggedIn = function () {
            UserServiceV2.getBillings()
                .then(function (response) {
                    var billings = UserServiceV2.adaptBillingsResponse(response);

                    self.billing = AuthValuesConverter.getBillingsArray(billings);

                    if (self.billing.length) {
                        self.newBillingSelected = self.billing[0].id;
                        self.chooseSavedBill(self.billing[0]);
                    }

                    if (!self.billing.length) {
                        self.addNewBill();
                    }
                })
                .catch(function () {
                    self.newBillingSelected = self.newBill;
                });
        };

        this.isAgent = function () {
            return appConfig.isAgent();
        };

        this.chooseSavedBill = function (bill) {
            if (bill.id === this.prevBillId) {
                return;
            }

            $rootScope.isBillingInitializete = true;
            this.bookingModel.billing.reset();
            this.newBillingSelected = bill.id;
            this.prevBillId = bill.id;

            if (bill.hasOwnProperty('name')) {
                this.bookingModel.billing.setType('company');
                this.bookingModel.billing.getCompany().srvSet(bill.srvObj());
                this.cacheBilling();
                return;
            }

            this.bookingModel.billing.setType('person');
            this.bookingModel.billing.getPerson().srvSet(bill.srvObj());
            this.cacheBilling();
        };

        this.addNewBill = function () {
            $rootScope.isBillingInitializete = false;
            this.bookingModel.billing.reset();
            this.prevBillId = this.newBill;
            this.newBillingSelected = this.newBill;

            if (self.bookingModel.hasOwnProperty('paxes')) {
                BookingFormFiller.autofillBilling(
                    self.bookingModel.paxes[0].person,
                    self.bookingModel.billing
                );
            }

            this.cacheBilling();
        };

        this.cacheBilling = function () {
            var self = this;
            $timeout(function () {
                BookingFormCache.cacheBilling(self.bookingModel.billing);
            });
        };

        this.switchContext = function () {
            this.cacheBilling();
        };

        this.getCountry = function (countryCode) {
            var foundCountryObject = underscore.find(this.locations.countries, function (country) {
                return country.code === countryCode;
            });

            return foundCountryObject ? foundCountryObject.name : '';
        };

        this.isPersonal = function (billing) {
            return billing.hasOwnProperty('firstName');
        };
    };

    var BillingRadioSelector = {
        selector: 'billing-radio-selector',
        templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/pax/billing-radio-selector/billing-radio-selector',
        bindings: {
            bookingModel: '<',
            locations: '<',
            isLoggedUser: '<'
        },
        controller: BillingRadioSelectorCtrl
    };
    BillingRadioSelectorCtrl.$inject = [
        '$rootScope',
        '$timeout',
        'UserService',
        'appConfig',
        'BookingFormCache',
        'BookingFormFiller',
        'AuthValuesConverter',
        'UserSessionData',
        'UserServiceV2'
    ];


    angular
        .module('ITH.Funnel.BillingRadio', ['user'])
        .component('billingRadioSelector', BillingRadioSelector);

})(angular, _);



;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billing-radio-selector/ui-checkbox-component.js
(function(angular) {
/**
     * @name        uiCheckbox
     * @description component contain billing personal form logic
     */
    var uiCheckboxCtrl = function() {
        this.toogleCheck = function(value) {
            this.toggle({
                $event: {
                    selected: value
                }
            })
        }

    }


    var uiCheckbox = {
        selector: 'ui-checkbox',
        template: '<span class="boolean ui-checkbox" \
                   ng-click="$ctrl.toogleCheck(!$ctrl.model)"  \
                   ng-class="{ on: $ctrl.model }">\
                       <span class="toggler">\
                       </span>\
                       <span translate>{{::$ctrl.label}}</span>\
                   </span>',
        bindings: {
            'model': '<',
            'label': '<',
            'toggle': '&'
        },
        controller: uiCheckboxCtrl
    };
    uiCheckboxCtrl.$inject = [];


    angular.module('ITH.Funnel.UiCheckboxForm', [])
        .component('uiCheckbox', uiCheckbox);

})(angular);




;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billing-switch-vola-wrapper.component.js
(function (angular) {
var BillingSwitchVolaWrapperCtrl = function ($timeout, BookingFormCache) {
        /**
         *
         */
        this.needInvoice = false;

        /**
         *
         */
        this.onValueChangeCallback = function () {
            var self = this;

            $timeout(function () {
                self.billingModel.setFake(!self.needInvoice);
                BookingFormCache.cacheBilling(self.billingModel);
            });
        };

        this.$onInit = function () {
            updateValue(this);
        };

        this.$onChanges = function () {
            updateValue(this);
        };

        var updateValue = function (context) {
            if (!context.billingModel) {
                return;
            }

            context.needInvoice = !context.billingModel.fake;
            context.billingModel.setFake(!context.needInvoice);

            $timeout(function () {
                BookingFormCache.cacheBilling(context.billingModel);
            });
        };
    };

    BillingSwitchVolaWrapperCtrl.$inject = [
        '$timeout',
        'BookingFormCache'
    ];

    var template = '<ith-ui-checkbox ng-model="$ctrl.needInvoice" callback="$ctrl.onValueChangeCallback()" switcher="true"></ith-ui-checkbox>';

    var BillingSwitchVolaWrapper = {
        bindings: {
            billingModel: '<'
        },
        template: template,
        controller: BillingSwitchVolaWrapperCtrl
    };

    angular
        .module('ITH.Funnel.BillingSwitchVolaWrapper', [])
        .component('billingSwitchVolaWrapper', BillingSwitchVolaWrapper);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billing-switch/billing-switch.component.js
(function (angular) {
/**
   * @name        BillingSwitchCtrl
   * @description BillingSwitchCtrl component for the blue switch
   */
  var BillingSwitchCtrl = function () {
    this.types = {
      PERSON: 'person',
      COMPANY: 'company'
    };
  };

  var BillingSwitch = {
    selector: 'billing-switch',
    bindings: {
      type: '=',
      switchContext: '&?'
    },
    templateUrl: "/tpl/show/jsShared/templates/flights/flightDetails/pax/billing-switch/billing-switch",
    controller: BillingSwitchCtrl
  };

  angular.module('ITH.Funnel.BillingSwitch', [])
    .component('billingSwitch', BillingSwitch);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/billingInfoCtrl.js
angular.module('funnel')

/**
 * @name        billingInfoCtrl
 * @description Manages the billingInfoBox directive
 */
.controller('billingInfoCtrl', ['$scope', '$controller', function ($scope, $controller) {
angular.extend(this, $controller('basicBillingInfoCtrl', {$scope: $scope}));

    if (angular.isFunction($scope.modelPromise.then)) {
        $scope.modelPromise.then(function (model) {
            $scope.model = model;
        });
    } else {
        $scope.model = $scope.modelPromise;
    }
}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/modals/bookingErrorModalCtrl.js
(function (angular) {
/**
   * @name        IthBookingErrorModalCtrl.
   * @description Control data on price diff modal.
   * @constructor
   * @author      Rafał Podraza <rafal.podraza@fru.pl>
   */
  var IthBookingErrorModalCtrl = function ($modalInstance, FlightBooking, appConfig) {
    /**
     * Payment type.
     *
     * @type {String}
     */
    var paymetType = FlightBooking.getPayment().getType();

    /**
     * Send event to GA.
     *
     * @param lang
     */
    var sendGAEvent = function (lang) {
      if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Errors', '500 - btn on modal', lang, 1);
      }
    };

    /**
     * Get payment type.
     *
     * @return {String}
     */
    this.getPaymentType = function () {
      return paymetType;
    };

    this.isFastPayment = function () {
      return (
        this.getPaymentType() === 'CC' ||
        this.getPaymentType() === 'AP' ||
        this.getPaymentType() === 'AP2' ||
        this.getPaymentType() === 'GP' ||
        this.getPaymentType() === 'GP2' ||
        this.getPaymentType() === 'BA' ||
        this.getPaymentType() === 'PBL' ||
        this.getPaymentType() === 'RP'
      );
    };

    /**
     * Get phone number.
     *
     * @return {String}
     */
    this.getPhoneNumber = function () {
      return appConfig.getPhoneNumbers().general.replace(/ /g, '');
    };

    /**
     * Close modal and redirect to search.
     */
    this.backToSearch = function () {
      sendGAEvent('LANGM_JS_BOOKING_ERROR_BUTTON');
      $modalInstance.close();
    };

    /**
     * Trigger call to call center & close modal without action.
     */
    this.clickToCall = function () {
      sendGAEvent('LANGM_JS_BOOKING_ERROR_BUTTON_CALL');
    };
  };

  IthBookingErrorModalCtrl.$inject = [
    '$modalInstance',
    'bok.FlightBooking',
    'appConfig'
  ];

  angular
    .module('funnel')
    .controller('BookingErrorModalCtrl', IthBookingErrorModalCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/modals/changedPriceModalCtrl.js
(function(angular) {
/**
     * @name        IthChangedPriceModalCtrl.
     * @description Control data on price diff modal.
     * @constructor
     * @author      Rafał Podraza <rafal.podraza@fru.pl>
     */
    var IthChangedPriceModalCtrl = function (flightBooking, $modalInstance, $scope, $filter, PriceDiffHelper, FARE_LOCK_STATES) {
        /**
         * Test sell status.
         * 1 - test sell done
         * 2 - higher price
         * 3 - lower price
         * 4 - no seats
         * 22 - strong higher price
         *
         * @type {Number}
         */
        var tsStatus = (flightBooking.getTestSell().isStrongDiff()) ? 22 : flightBooking.getTestSell().getStatus();

        /**
         * Reference to FlightBooking instance
         *
         * @type {FlightBooking}
         */
        this.flightBooking = flightBooking;

        this.$modalInstance = $modalInstance;

        /**
         * Payment type
         *
         * @type {String}
         */
        var paymetType = flightBooking.getPayment().getType();

        /**
         * Is strong price diff.
         *
         * @type {Boolean}
         */
        var strongPriceDiff = flightBooking.getTestSell().isStrongDiff();

        /**
         * Accept and close modal.
         *
         */
        this.accept = function() {
            $modalInstance.close('accept');
        };

        /**
         * Reject and close modal.
         *
         */
        this.dismiss = function() {
            $modalInstance.dismiss('cancel');
        };

        /**
         * Get status of test sell.
         *
         * @return {Number}
         */
        this.getTsStatus = function () {
            return tsStatus;
        };

        /**
         * Get payment type.
         *
         * @return {String}
         */
        this.getPaymentType = function () {
            return paymetType;
        };

        /**
         * Get price diff value.
         *
         * @return {Number}
         */
        this.getPriceDiff = function () {
            return $filter('flPrice')(PriceDiffHelper.getPriceDiff(this.flightBooking), 2);
        };

        this.isNoSeats = function () {
            return tsStatus === 4;
        };

        this.isFareLock = function () {
            return this.flightBooking.fareLock.isPopulated() && this.flightBooking.fareLock.isConfirmed();
        };

        this.isFareLockConfirmed = function () {
            return this.flightBooking.fareLock.status === FARE_LOCK_STATES.CONFIRMED;
        };

        this.showFareLockPriceDiff = function () {
            return this.isFareLockConfirmed() && tsStatus === 2;
        };

        this.showFareLockNoSeats = function () {
            return this.isFareLockConfirmed() && tsStatus === 4;
        };

        /**
         * Get old price value.
         *
         * @return {Price}
         */
        this.getOldPrice = function () {
            return $filter('flPrice')(PriceDiffHelper.getOldPrice(this.flightBooking), 2);
        };

        /**
         * Get new price value.
         *
         * @return {Price}
         */
        this.getNewPrice = function () {
            return $filter('flPrice')(PriceDiffHelper.getNewPrice(this.flightBooking), 2);
        };

        /**
         * Show price diff.
         *
         * @return {Boolean}
         */
        this.showPriceDiff = function () {
            return tsStatus !== 4 && PriceDiffHelper.getPriceDiff(this.flightBooking);
        };

        /**
         * Show price diff accept button.
         *
         * @return {Boolean}
         */
        this.showPriceDiffBtn = function () {
            return tsStatus === 2 && !strongPriceDiff;
        };

        /**
         * Show new search button.
         *
         * @return {Boolean}
         */
        this.showNewSearchBtn = function () {
            return tsStatus === 2 || tsStatus === 22 || tsStatus === 4;
        };

        /**
         * Show subtitle.
         *
         * @return {Boolean}
         */
        this.showSubtitle = function () {
            return tsStatus === 22 || tsStatus === 4;
        };

        /**
         * Return true if strong price diff.
         *
         * @return {Boolean}
         */
        this.isStrongPriceDiff = function () {
            return strongPriceDiff;
        };

        this.shouldShowCardNotProcessed = function () {
            return (
                this.getPaymentType() === 'CC' ||
                this.getPaymentType() === 'AP' ||
                this.getPaymentType() === 'AP2' ||
                this.getPaymentType() === 'GP' ||
                this.getPaymentType() === 'GP2' ||
                this.getPaymentType() === 'RP'
            );
        };

        /**
         * Return translated lang for modal title.
         *
         * @return {Boolean}
         */
        this.getTitle = function () {
            var title = '';

            switch (tsStatus) {
                case 2:
                default:
                    title = 'LANGM_JS_SPF_PD_TITLE';
                    break;
                case 22:
                    title = 'LANGM_JS_SPF_PD_HIGHER_TITLE';
                    break;
                case 4:
                    title = 'LANGM_JS_SPF_PD_NO_SEATS_TITLE';
                    break;
            }

            if (strongPriceDiff) {
                title = 'LANGM_JS_SPF_PD_HIGHER_TITLE';
            }

            return $filter('translate')(title);
        };

        /**
         * Return translated main description lang.
         *
         * @return {Boolean}
         */
        this.getMainDesc = function () {
            var desc = '';

            switch(tsStatus){
                case 22:
                case 4:
                    desc = 'LANGM_JS_SPF_PD_DESC';
                    break;
                default:
                    desc = 'LANGM_JS_SPF_PD_MAIN_DIFF_DESC';
            }

            return $filter('translate')(desc);
        };
    };

    IthChangedPriceModalCtrl.$inject = [
        'flightBooking',
        '$modalInstance',
        '$scope',
        '$filter',
        'PriceDiffHelper',
        'FARE_LOCK_STATES'
    ];

    angular
        .module('funnel')
        .controller('ChangedPriceModalCtrl', IthChangedPriceModalCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/modals/paymentErrorModalCtrl.js
(function (angular) {
var IthPaymentErrorModalCtrl = function ($modalInstance, FlightBooking) {
    /**
     * Payment type.
     *
     * @type {String}
     */
    var paymentType = FlightBooking.getPayment().getType();

    /**
     * Send event to GA.
     *
     * @param lang
     */
    var sendGAEvent = function (lang) {
      if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Errors', '500 - btn on modal', lang, 1);
      }
    };

    /**
     * Get payment type.
     *
     * @return {String}
     */
    this.getPaymentType = function () {
      return paymentType;
    };

    /**
     * Close modal
     */
    this.back = function () {
      sendGAEvent('LANGM_JS_PAYMENT_ERROR_BUTTON');
      $modalInstance.close();
    };
  };

  IthPaymentErrorModalCtrl.$inject = [
    '$modalInstance',
    'bok.FlightBooking'
  ];

  angular
    .module('funnel')
    .controller('PaymentErrorModalCtrl', IthPaymentErrorModalCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/modals/paymentProcessingCtrl.js
angular.module('funnel')

.controller('paymentProcessingCtrl',
['$scope', 'items', '$modalInstance',
function ($scope, response) {
$scope.response = response;
  $scope.paymentModal = response.bookingResponse.html;

}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/pax/modals/saferPayCtrl.js
angular.module('funnel')

/**
 * @name        changedPriceModalCtrl
 * @description Manages the luggageInfoBox directive
 */
.controller('saferPayCtrl',
['$scope', 'items', '$modalInstance', 'bok.FlightBooking', 'bas.Basket', '$timeout', '$compile',
function ($scope, response, $modalInstance, FlightBooking, Basket, $timeout, $compile) {
$scope.response = response;
  $scope.formSafer = response.bookingResponse.html;

  $timeout(function () {
    document.getElementById("payment").submit();
  }, 2000);

}]);
;

// Source: ../shared/public_html/assets/js/funnel/controllers/price-diff.helper.js
(function(angular) {
var IthPriceDiffHelperService = function () {
        /**
         * Returns price diff amount
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        this.getPriceDiff = function (flightBooking) {
            return this.getNewPrice(flightBooking) - this.getOldPrice(flightBooking);
        };

        /**
         * Returns total price without price diff
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        this.getOldPrice = function (flightBooking) {
            return flightBooking.basket.getTotalPrice();
        };

        /**
         * Returns total price with price diff
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        this.getNewPrice = function (flightBooking) {
            return flightBooking.basket.getTotalPrice(true);
        };
    };

    angular
        .module('funnel')
        .service('PriceDiffHelper', IthPriceDiffHelperService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/controllers/reservation-modal.controller.js
(function(angular) {
var IthReservationModalController = function ($scope, flightBooking) {
        /**
         * Checks if test sell is in progress
         *
         * @returns {Boolean}
         */
        $scope.isTestSellInProgress = function () {
            return flightBooking.getTestSellStatus();
        };
    };

    IthReservationModalController.$inject = [
        '$scope',
        'flightBooking'
    ];

    angular
        .module('funnel')
        .controller('ReservationModalController', IthReservationModalController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/directives/dynamicHtml.js
angular.module('funnel')

/**
 * @name        clickOut
 * @description Execute an angular expression when we click out of the current element.
 */
.directive('dynamic',
[
function () {
return {
    restrict: 'A',
    replace: true,
    link: function (scope, ele, attrs) {
      console.log(attrs);
      var replacementText = attrs.dynamic;
      console.log(replacementText);
      var svg = angular.element();
      ele.append(svg);
    }
  };

}]);
;

// Source: ../shared/public_html/assets/js/funnel/directives/funnelWrapper.js
angular.module('funnel')

/**
 * @name
 * @description
 */
.directive('funnelWrapper', function () {
  return {
    restrict: 'A',
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    transclude: true
  };
});
;

// Source: ../shared/public_html/assets/js/funnel/directives/pax/billingInfoBox.js
angular.module('funnel')

/**
 * @name        billingInfoBox
 * @description Billing information box directive
 */
.directive('billingInfoBox',
[
function billingInfoBox() {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    scope: {
      modelPromise: '=?ngModel'
    },
    controller: 'billingInfoCtrl'
  };
}]);

;

// Source: ../shared/public_html/assets/js/funnel/directives/pax/passengerDetailsBox.js
angular.module('funnel')

/**
 * @name        passengerDetailsBox
 * @description Passenger details box directive
 */
.directive('passengerDetailsBox',
[
function () {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    scope: {
      modelPromise: '=?ngModel',
      state: '=state',
      form: '=form',
      steps: '<',
      isLuggageSelectable: '<',
      ancillariesSocketHandler: '<',
      boxTitle: '@',
      hideYoungerBirthDateControl: '=?hideYoungerBirthDateControl',
      hideAddPassenger: '=?hideAddPassenger',
      hideExtraEmail: '=?hideExtraEmail',
      formName: '@'
    },
    link: function (scope) {
      scope.hideAddPassenger = !!scope.hideAddPassenger;
      scope.hideYoungerBirthDateControl = !!scope.hideYoungerBirthDateControl;
      scope.hideExtraEmail = !!scope.hideExtraEmail;
      scope.boxTitle = scope.boxTitle ? scope.boxTitle : 'LANGM_JS_PD_TITLE';
    },
    controller: "PassengerDetailsBoxCtrl"
  };
}]);

;

// Source: ../shared/public_html/assets/js/funnel/directives/pax/paymentInfoBox.js
angular.module('funnel')

/**
 * @name        paymentInfoBox
 * @description Payment information box directive
 */
.directive('paymentInfoBox',
[
function paymentInfoBox() {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    scope: {
      modelPromise: '=ngModel',
      paymentContentPostfix: '@',
      paymentOptionsPromise: '=?paymentOptionsPromise',
      boxTitle: '@',
      displayInBasicBox: '<?',
    },
    link: function (scope) {
      scope.boxTitle = scope.boxTitle ? scope.boxTitle : 'LANGM_JS_PD_PAYMENT_INFO';
      scope.displayInBasicBox = scope.displayInBasicBox === undefined ? true : scope.displayInBasicBox;
    },
    controller: "PaymentInfoBoxCtrl"
  };
}]);

;

// Source: ../shared/public_html/assets/js/funnel/directives/showChangeSearch.js
angular.module('funnel')

  /**
   * @name        clickOut
   * @description Execute an angular expression when we click out of the current element.
   */
  .directive('showChangeSearch', [function () {
return {
      restrict: 'A',
      controller: ['$scope', '$window', 'IthSearchFormTrigger', function ($scope, $window, IthSearchFormTrigger) {
        /**
         * Opens the change search zone in the header (mobile only)
         */
        $scope.openChangeSearch = function () {
          IthSearchFormTrigger.toggle();
          $window.scrollTo(0, 0);
        };
      }]
    };

  }]);
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-contact.model.js
(function (angular, underscore) {
var FareLockContactModel = function (ErrorMixin, ContactPhone) {
        var FareLockContact = function () {
            this.firstName = '';
            this.lastName = '';
            this.email = '';
            this.phone = new ContactPhone();
            this.errors = {};
        };

        FareLockContact.prototype.srvObj = function () {
            return {
                firstName: this.firstName,
                lastName: this.lastName,
                contact: {
                    email: this.email,
                    phone: {
                        prefix: this.phone.srvObj().prefix,
                        number: this.phone.srvObj().number
                    }
                },
            };
        };

        FareLockContact.prototype.srvErrors = function (errors) {
            this.errors = {};

            this.errors.firstName = errors.firstName;
            this.errors.lastName = errors.lastName;
            this.errors.email = errors.contact && errors.contact.email ? errors.contact.email : null;
            this.errors.phone = errors.contact && errors.contact.phone ? errors.contact.phone.number : null;
        };

        FareLockContact.prototype.constructor = FareLockContact;

        underscore.extend(FareLockContact.prototype, ErrorMixin);

        return FareLockContact;
    };

    FareLockContactModel.$inject = ['ErrorMixin', 'ContactPhone'];

    angular
        .module('ITH.Funnel.FareLock')
        .factory('FareLockContact', FareLockContactModel);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-datalayer.helper.js
(function (angular) {

    var FareLockDatalayerHelper = function (Remarketing, AppConfig, DataLayerHelper) {
        /**
         *
         * @param {FareLockOrder} fareLockOrder
         */
        var getFareLockItem = function (fareLockOrder, option) {
            var variant = option.duration
                .split('PT').join('')
                .split('H').join(' hours');

            return {
                item_id: DataLayerHelper.getFlightIdentifier(fareLockOrder.getFlightDetails()) + '_LOCKF', //destination + suffix
                item_name: 'Lock Fare', // constant
                item_brand: DataLayerHelper.getItemBrand(),
                item_category: 'Lock Fare', // constant
                item_variant: variant, // Lock Fare variant
                price: option.price.amount, // price for 1 item
                quantity: 1 // constant
            };
        };

        this.onDetailsPageEnterEvent = function (fareLockOrder) {
            var items = fareLockOrder.fareLock.pricing.map(function (option) {
                return getFareLockItem(fareLockOrder, option);
            });

            var data = {
                event: 'view_item', // constant
                event_type: 'ecommerce', // constant
                funnel_type: 'lock fare', // constant
                lock_fare: true, // constant
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(), //currency
                    items: items
                }
            };

            Remarketing.clearEcommerce();
            Remarketing.dataLayerPush(data);
        };

        this.onAddToCartEvent = function (fareLockOrder) {
            var data = {
                event: 'add_to_cart', //constant
                event_type: 'ecommerce', //constant
                funnel_type: 'lock fare', //constant
                lock_fare: true, //constant
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(), //currency
                    value: fareLockOrder.getSelectedOption().price.amount, //value added products
                    items: [
                        getFareLockItem(fareLockOrder, fareLockOrder.getSelectedOption())
                    ]
                }
            };

            Remarketing.clearEcommerce();
            Remarketing.dataLayerPush(data);
        };

        this.onRemoveFromCartEvent = function (fareLockOrder, removedOption) {
            var data = {
                event: 'remove_from_cart', //constant
                event_type: 'ecommerce', //constant
                funnel_type: 'lock fare', //constant
                lock_fare: true, //constant
                ecommerce: {
                    currency: AppConfig.getCurrencyCode(), //currency
                    value: fareLockOrder.getSelectedOption().price.amount, //value added products
                    items: [
                        getFareLockItem(fareLockOrder, removedOption)
                    ]
                }
            };

            Remarketing.clearEcommerce();
            Remarketing.dataLayerPush(data);
        };

        this.onPriceDiffTriggerEvent = function () {
            var data = {
                event: 'banner_interactions', //constant
                category: 'page interactions', //constant
                funnel_type: 'lock fare', //constant
                lock_fare: true, //constant
                name: 'Lock Fare price diff - higher price', //higher price if new price is higher from old one, lower price, when lower
                type: 'display', //constant
            };

            Remarketing.dataLayerPush(data);
        };

        var onPriceDiffButtonClickEvent = function (select) {
            var data = {
                event: 'banner_interactions', //constant
                category: 'page interactions', //constant
                funnel_type: 'lock fare', //constant
                lock_fare: true, //constant
                name: 'Lock Fare price diff - higher price', //higher price if new price is higher from old one, lower price, when lower
                type: 'button click', //constant
                select: select, //clicked button
            };

            Remarketing.dataLayerPush(data);
        };

        this.onPriceDiffNewSearchEvent = function () {
            onPriceDiffButtonClickEvent('New Search');
        };

        this.onPriceDiffAcceptEvent = function () {
            onPriceDiffButtonClickEvent('Accept');
        };

        this.onContinueToBookingEvent = function () {
            var data = {
                event: 'button_interactions', //constant
                category: 'page interactions', //constant
                funnel_type: 'lock fare', //constant
                lock_fare: true, //constant
                name: 'Lock Fare TYP', //constant
                type: 'button click', //constant
                select: 'Pay tickets', //clicked button
            };

            Remarketing.dataLayerPush(data);
        };
    };

    FareLockDatalayerHelper.$inject = ['goo.Remarketing', 'appConfig', 'DataLayerHelper'];

    angular
        .module('ITH.Funnel.FareLock')
        .service('FareLockDatalayerHelper', FareLockDatalayerHelper);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-details-test-sell-handler.helper.js
(function (angular) {
    var service = function ($q, $timeout, SouthParkApi, FareLockApi) {
        /**
         * Possible test sell statuses
         */
        this.statuses = {
            DONE: 'DONE',
            DIFF: 'DIFF',
            NA: 'NOT_AVAILABLE',
            TIMEOUT: 'TS_TIMEOUT',
            RELOAD: 'RELOAD'
        };

        /**
         * Starts the test sell process
         *
         * @param {string} fullfilmentToken
         * @param {string} uuid
         * @returns {Promise}
         */
        this.startTestSell = function (fullfilmentToken, uuid) {
            var self = this;
            var verificationId = null;

            return $q(function (resolve, reject) {
                SouthParkApi
                    .initTestSell(decodeURIComponent(fullfilmentToken), null, null)
                    .then(function (tsInitResult) {
                        if (tsInitResult.data.response.state === self.statuses.DONE) {
                            return resolve({
                                status: self.statuses.DONE
                            });
                        }

                        verificationId = tsInitResult.data.response.verificationId;
                        return self.pollTestSell(verificationId);
                    }, function () {
                        return reject({
                            status: self.statuses.NA
                        });
                    })
                    .then(function () {
                        return SouthParkApi
                            .finishFulfilmentOfferTestSell({
                                'offerUuid': uuid,
                                'verificationId': verificationId
                            })
                            .catch (function () {
                                return reject({
                                    status: self.statuses.NA
                                });
                            });
                    })
                    .then(function (legacyTsResult) {
                        try {
                            if (legacyTsResult.data.response.status.toUpperCase() === self.statuses.RELOAD) {
                                return reject({
                                    status: self.statuses.DIFF,
                                    data: legacyTsResult.data.response.offer
                                });
                            }

                            resolve({
                                status: self.statuses.DONE
                            });
                        } catch (error) {
                            return reject({
                                status: self.statuses.NA
                            });
                        }
                    }, function () {
                        return reject({
                            status: self.statuses.NA
                        });
                    });
            });
        };

        /**
         * Polls the test sell
         *
         * @param {string} verificationId
         * @returns {Promise}
         */
        this.pollTestSell = function (verificationId) {
            var retiesLeft = 45;
            var retryDelay = 2000;

            return $q(function (resolve, reject) {
                var attempt = function () {
                    SouthParkApi
                        .pollTestSell(verificationId, null, {})
                        .then(function (tsPollResponse) {
                            if (tsPollResponse.data.response.state === 'DONE') {
                                return resolve();
                            }

                            if (retiesLeft > 0) {
                                retiesLeft -= 1;
                                $timeout(attempt, retryDelay);
                                return;
                            }

                            reject({ status: 'TS_TIMEOUT', msg: 'Test-sell timed out after 45 polls' });
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                };

                attempt();
            });
        };
    };

    service.$inject = ['$q', '$timeout', 'SouthParkApi', 'FareLockApi'];

    angular
        .module('ITH.Funnel.FareLock')
        .service('FareLockDetailsTestSellHandler', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-details.controller.js
(function (angular) {
var FareLockDetailsCtrl = function ($state, $q, $window, $rootScope, $scope, $location, FareLockApi, PageLoading, FareLockOrder, Locations, AuthService, UserService, UserServiceV2, FareLockDetailsTestSellHandler, FareLockDiffHandler, FareLockHelper, FareLockDatalayerHelper, ConsentsHelper, FareLockExpiryHandler, UserSessionData) {
        /**
         * @type {FareLockDetailsCtrl}
         */
        var ctrl = this;

        /**
         * Loads data and populates order details
         */
        var loadUserData = function () {
            UserServiceV2.getPassengersData(true).then(function (response) {
                var resp = UserServiceV2.adaptResponse(response);

                ctrl.state.order.populateUserData(resp);
            });
        };

        /**
         * Redirects back to search results
         */
        var backToSearch = function () {
            var backToSearchUrl = ctrl.state.order.flightDetails.getSearchUrl();
            var locationSearch = $location.search();

            if (locationSearch.hasOwnProperty('backToSearchUrl')) {
                backToSearchUrl = decodeURIComponent(locationSearch.backToSearchUrl).split('#')[0];
            }

            $location.hash('');
            $location.path(backToSearchUrl).search('');
        };

        /**
         * Called when a modal button is clicked
         *
         * @param {string} reason
         */
        var onModalButtonClick = function (reason) {
            switch (reason) {
                case 'new-search':
                    FareLockDatalayerHelper.onPriceDiffNewSearchEvent();
                    backToSearch();
                    break;

                case 'accept':
                    FareLockDatalayerHelper.onPriceDiffAcceptEvent();
                    var previousSelectedFareLockRuleId = ctrl.state.order.selectedFareLockRuleId;
                    ctrl.state.order.srvSet(ctrl.state.priceDiffData, []);
                    ctrl.state.order.selectedFareLockRuleId = previousSelectedFareLockRuleId;
                    ctrl.submitOrder();
                    break;

                default:
                    ctrl.submitOrder();
                    break;
            }
        };

        /**
         * Possible view states
         */
        this.states = {
            LOADING: 'loading',
            SUCCESS: 'success',
            ERROR: 'error'
        };

        /**
         * All view state data
         */
        this.state = {
            submittingFareLockData: false,
            loadingPriceDiff: false,
            countries: [],
            order: new FareLockOrder(),
            current: this.states.LOADING,
            tsStatus: null,
            priceDiffData: null,
            templateParams: {},
            consents: []
        };

        /**
         *
         * @returns {boolean}
         */
        this.isPayButtonLoading = function () {
            return (
                this.state.submittingFareLockData ||
                this.state.loadingPriceDiff
            );
        };

        /**
         * Verifies validation and test sell status before submitting data
         *
         * @param {NgForm} form
         */
        this.trySubmitOrder = function (form) {
            form.$setSubmitted();

            if (form.hasOwnProperty('flContactDetails')) {
                form.flContactDetails.$setSubmitted();
            }

            if (form.hasOwnProperty('billingPerson')) {
                form.billingPerson.$setSubmitted();
            }

            if (form.hasOwnProperty('billingCompany')) {
                form.billingCompany.$setSubmitted();
            }

            if (form.$invalid || !ConsentsHelper.isValid(ctrl.state.order.consents)) {
                return;
            }

            switch (this.state.tsStatus) {
                case FareLockDetailsTestSellHandler.statuses.DIFF:
                    ctrl.state.templateParams = FareLockHelper.getDetailsTemplateVars(
                        ctrl.state.order,
                        ctrl.state.priceDiffData
                    );

                    FareLockDiffHandler
                        .openPriceDiff(ctrl.state.templateParams)
                        .then(onModalButtonClick);

                    FareLockDatalayerHelper.onPriceDiffTriggerEvent();
                    break;

                case FareLockDetailsTestSellHandler.statuses.NA:
                    FareLockDiffHandler
                        .openNotAvailable()
                        .then(onModalButtonClick);
                    break;

                default:
                    this.submitOrder();
                    break;
            }
        };

        /**
         * Submits order data
         */
        this.submitOrder = function () {
            this.state.submittingFareLockData = true;

            FareLockApi
                .purchase(
                    $state.params.uuid,
                    this.state.order.srvObj(),
                    window.gaDimensions || {}
                )
                .then(function (purchaseResponse) {
                    $window.location.href = purchaseResponse.data.response.redirectUrl;
                })
                .catch(function (errorResponse) {
                    ctrl.state.order.srvErrors(errorResponse.data.response);
                    ctrl.state.submittingFareLockData = false;
                });
        };

        /**
         * Displays the login modal
         */
        this.loginModal = function () {
            AuthService.showLoginModal();
        };

        this.$onInit = function () {
            PageLoading.on();

            $rootScope.$on('userLogged', function () {
                loadUserData();
            });

            if (UserSessionData.isLogged()) {
                loadUserData();
            }

            $q
                .all({
                    countryResponse: Locations.getCountries(),
                    fareLockResponse: FareLockApi.getDetails($state.params.uuid),
                    consentResponse: FareLockApi.getConsents()
                })
                .then(function (responses) {
                    ctrl.state.countries = responses.countryResponse;
                    ctrl.state.order.srvSet(
                        responses.fareLockResponse.data.response,
                        responses.consentResponse.data.response.consents
                    );
                    ctrl.state.current = ctrl.states.SUCCESS;
                    ctrl.state.loadingPriceDiff = true;

                    ctrl.state.templateParams = FareLockHelper.getDetailsTemplateVars(
                        ctrl.state.order
                    );

                    FareLockDatalayerHelper.onDetailsPageEnterEvent(ctrl.state.order);

                    // Expiry handling
                    FareLockExpiryHandler.onEnter(ctrl.state.order);

                    $scope.$on('$destroy', function () {
                        FareLockExpiryHandler.onExit();
                    });

                    $scope.$watch(
                        function () {
                            return ctrl.state.order.getSelectedOption();
                        },
                        function (newOption, oldOption) {
                            if (oldOption && oldOption !== newOption) {
                                FareLockDatalayerHelper.onRemoveFromCartEvent(ctrl.state.order, oldOption);
                            }

                            if (newOption) {
                                FareLockDatalayerHelper.onAddToCartEvent(ctrl.state.order);
                            }
                        }
                    );

                    FareLockDetailsTestSellHandler
                        .startTestSell(ctrl.state.order.getFlightDetails().getFulfillmentToken(), $state.params.uuid)
                        .then(function () {
                            ctrl.state.tsStatus = FareLockDetailsTestSellHandler.statuses.DONE;
                        })
                        .catch(function (error) {
                            ctrl.state.tsStatus = error.status;
                            ctrl.state.priceDiffData = error.data || null;
                        })
                        .finally(function () {
                            ctrl.state.loadingPriceDiff = false;
                        });

                    PageLoading.off();
                })
                .catch(function () {
                    ctrl.state.current = ctrl.states.ERROR;
                    PageLoading.off();
                });
        };

        this.$onInit();
    };

    FareLockDetailsCtrl.$inject = [
        '$state',
        '$q',
        '$window',
        '$rootScope',
        '$scope',
        '$location',
        'FareLockApi',
        'PageLoading',
        'FareLockOrder',
        'Locations',
        'AuthService',
        'UserService',
        'UserServiceV2',
        'FareLockDetailsTestSellHandler',
        'FareLockDiffHandler',
        'FareLockHelper',
        'FareLockDatalayerHelper',
        'ConsentsHelper',
        'FareLockExpiryHandler',
        'UserSessionData'
    ];

    angular
        .module('ITH.Funnel.FareLock')
        .controller('FareLockDetailsCtrl', FareLockDetailsCtrl);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-diff-handler.service.js
(function (angular) {
    var service = function ($modal) {
        /**
         * Opens the modal
         *
         * @param {string} templateUrl
         * @param {object?} context
         * @returns {Promise}
         */
        var openModal = function (templateUrl, context) {
            var modalInstance = $modal.open({
                backdrop: 'static',
                templateUrl: templateUrl,
                controller: ['$modalInstance', 'context', '$translate', function ($modalInstance, context, $translate) {
                    this.context = context;

                    this.title = $translate.instant('LANGM_JS_FL_DETAILS_PRICE_DIFF_TITLE', context);

                    this.close = function (reason) {
                        $modalInstance.close(reason);
                    };
                }],
                controllerAs: '$ctrl',
                resolve: {
                    context: context
                }
            });

            return modalInstance.result;
        };

        /**
         * Opens the price diff modal
         *
         * @param {object} diffData
         * @returns {Promise}
         */
        this.openPriceDiff = function (diffData) {
            return openModal(
                '/tpl/show/templates/components/modals/funnel/fareLockDetailsPriceDiff',
                diffData
            );
        };

        /**
         * Opens the flight not available modal
         *
         * @returns {Promise}
         */
        this.openNotAvailable = function () {
            return openModal(
                '/tpl/show/templates/components/modals/funnel/fareLockDetailsNotAvailable',
                null
            );
        };
    };

    service.$inject = ['$modal'];

    angular
        .module('ITH.Funnel.FareLock')
        .service('FareLockDiffHandler', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-expiry-handler.service.js
(function (angular, moment) {

    var FareLockExpiryHandlerService = function ($timeout, $rootScope, $modal, FareLockHelper) {
        var srv = this;

        this.almostDoneTimer = null;
        this.doneTimer = null;
        this.order = null;

        this.almostDoneModalInstance = null;
        this.doneModalInstance = null;

        this.locationChangeEvent = null;

        var modalCtrl = ['$modalInstance', function ($modalInstance) {
            this.modalInstance = $modalInstance;
        }];

        var openAlmostDoneModal = function () {
            srv.almostDoneModalInstance = $modal.open({
                template: '\
                <ith-modal-layout title="" instance="$ctrl.modalInstance" class="text-center fare-lock-modal">\
                    <ith-status-notification status="waiting">\
                        <pane-title translate>LANGM_JS_FL_WILL_EXPIRE_MODAL_TITLE</pane-title>\
                        <pane-text translate>LANGM_JS_FL_WILL_EXPIRE_MODAL_DESC</pane-text>\
                    </ith-status-notification>\
                    <a class="btn btn-lg btn-primary" ng-click="$ctrl.modalInstance.close()" translate>LANGM_JS_FL_WILL_EXPIRE_MODAL_CTA</a>\
                </ith-modal-layout>\
                ',
                size: 'md',
                controller: modalCtrl,
                controllerAs: '$ctrl',
                windowClass: 'ith-flights-outdated'
            });
        };

        var openDoneModal = function () {
            if (srv.almostDoneModalInstance !== null) {
                srv.almostDoneModalInstance.close();
            }

            srv.doneModalInstance = $modal.open({
                template: '\
                <ith-modal-layout title="" class="text-center fare-lock-modal">\
                    <ith-status-notification status="waiting">\
                        <pane-title translate>LANGM_JS_FL_SESSION_EXPIRED_MODAL_TITLE</pane-title>\
                        <pane-text translate>LANGM_JS_FL_SESSION_EXPIRED_MODAL_DESC</pane-text>\
                    </ith-status-notification>\
                    <a class="btn btn-lg btn-primary" ng-click="$ctrl.modalInstance.close()" translate>LANGM_JS_FL_SESSION_EXPIRED_MODAL_CTA</a>\
                </ith-modal-layout>\
                ',
                size: 'md',
                controller: modalCtrl,
                controllerAs: '$ctrl',
                backdrop: 'static',
                windowClass: 'ith-flights-outdated'
            });

            srv.doneModalInstance.result.then(function () {
                FareLockHelper.getBackToSearch(srv.order.getFlightDetails());
            });
        };

        this.onEnter = function (order) {
            this.order = order;
            this.almostDoneTimer = $timeout(angular.noop);

            var secondsLeft = moment(this.order.getFlightDetails().expires).diff(moment(), 'seconds');

            if (secondsLeft > 300) {
                this.almostDoneTimer = $timeout(openAlmostDoneModal, (secondsLeft - 300) * 1000);
            }

            this.doneTimer = $timeout(openDoneModal, secondsLeft * 1000);

            this.locationChangeEvent = $rootScope.$on(
                '$locationChangeStart',
                function () {
                    if (this.almostDoneModalInstance !== null) {
                        this.almostDoneModalInstance.close();
                    }

                    if (this.doneModalInstance !== null) {
                        this.doneModalInstance.close();
                    }
                }.bind(this)
            );
        };

        this.onExit = function () {
            $timeout.cancel(this.almostDoneTimer);
            $timeout.cancel(this.doneTimer);
            this.locationChangeEvent();
        };
    };

    FareLockExpiryHandlerService.$inject = ['$timeout', '$rootScope', '$modal', 'FareLockHelper'];

    angular
        .module('ITH.Funnel.FareLock')
        .service('FareLockExpiryHandler', FareLockExpiryHandlerService);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-form-errors.component.js
(function (angular) {

    var template = '\
        <ith-alert-box type="error" class="ng-animate-disabled" id="booking-errors" ng-show="$ctrl.isVisible()">\
            <h6 translate>LANGM_JS_BOOKING_FORM_ERRORS_SUMMARY</h6>\
            \
            <div ng-if="$ctrl.shouldShowForm(\'flContactDetails\')">\
                <ith-form-error-item\
                    element-id="flFirstName"\
                    label="{{ \'LANGM_JS_FIRST_NAME\' | translate }}"\
                    form="$ctrl.getChildForm(\'flContactDetails\')"\
                    name="firstName"\
                    backend-error="$ctrl.order.contact.errors.firstName">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="flContactOrderLastName"\
                    label="{{ \'LANGM_JS_LAST_NAME\' | translate }}"\
                    form="$ctrl.getChildForm(\'flContactDetails\')"\
                    name="lastName"\
                    backend-error="$ctrl.order.contact.errors.lastName">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="flContactOrderEmail"\
                    label="{{ \'LANGM_JS_EMAIL_ADDRESS\' | translate }}"\
                    form="$ctrl.getChildForm(\'flContactDetails\')"\
                    name="email"\
                    backend-error="$ctrl.order.contact.errors.email">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="flContactOrderPhone"\
                    label="{{ \'LANGM_JS_PHONE_NUMBER\' | translate }}"\
                    form="$ctrl.getChildForm(\'flContactDetails\')"\
                    name="phone"\
                    backend-error="$ctrl.order.contact.errors.phone">\
                </ith-form-error-item>\
            </div>\
            \
            <div ng-if="$ctrl.shouldShowForm(\'billingPerson\')">\
                <ith-form-error-item\
                    element-id="billingPersonFirstName"\
                    label="{{ \'LANGM_JS_FIRST_NAME\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="firstName"\
                    backend-error="$ctrl.order.billing.person.errors.firstName">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonLastName"\
                    label="{{ \'LANGM_JS_LAST_NAME\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="lastName"\
                    backend-error="$ctrl.order.billing.person.errors.lastName">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonAddress"\
                    label="{{ \'LANGM_JS_STREET_ADDRESS\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="street"\
                    backend-error="$ctrl.order.billing.person.errors.street">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonCity"\
                    label="{{ \'LANGM_JS_CITY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="city"\
                    backend-error="$ctrl.order.billing.person.errors.city">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonCountry"\
                    label="{{ \'LANGM_JS_SELECT_COUNTRY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="country"\
                    backend-error="$ctrl.order.billing.person.errors.country">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonCounty"\
                    label="{{ \'LANGM_JS_COUNTY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="county"\
                    backend-error="$ctrl.order.billing.person.errors.county">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingPersonCnp"\
                    label="{{ \'LANGM_JS_ID_NUMBER\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingPerson\')"\
                    name="cnp"\
                    backend-error="$ctrl.order.billing.person.errors.cnp">\
                </ith-form-error-item>\
            </div>\
            \
            <div ng-if="$ctrl.shouldShowForm(\'billingCompany\')">\
                <ith-form-error-item\
                    element-id="billingCompanyName"\
                    label="{{ \'LANGM_JS_COMPANY_NAME\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="name"\
                    backend-error="$ctrl.order.billing.company.errors.name">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyVat"\
                    label="{{ \'LANGM_JS_VAT_NO\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="vatNumber"\
                    backend-error="$ctrl.order.billing.company.errors.vatNumber">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyAddress"\
                    label="{{ \'LANGM_JS_STREET_ADDRESS\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="street"\
                    backend-error="$ctrl.order.billing.company.errors.street">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyCity"\
                    label="{{ \'LANGM_JS_CITY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="city"\
                    backend-error="$ctrl.order.billing.company.errors.city">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyPostalCode"\
                    label="{{ \'LANGM_JS_POSTAL_CODE\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="zipCode"\
                    backend-error="$ctrl.order.billing.company.errors.zipCode">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyCountry"\
                    label="{{ \'LANGM_JS_SELECT_COUNTRY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="country"\
                    backend-error="$ctrl.order.billing.company.errors.country">\
                </ith-form-error-item>\
                \
                <ith-form-error-item\
                    element-id="billingCompanyCounty"\
                    label="{{ \'LANGM_JS_COUNTY\' | translate }}"\
                    form="$ctrl.getChildForm(\'billingCompany\')"\
                    name="county"\
                    backend-error="$ctrl.order.billing.company.errors.province">\
                </ith-form-error-item>\
            </div>\
        </ith-alert-box>\
    ';

    angular
        .module('ITH.Funnel.FareLock')
        .component('fareLockFormErrors', {
            template: template,
            controller: function () {
                this.isVisible = function () {
                    return (
                        this.shouldShowForm('flContactDetails') ||
                        this.shouldShowForm('billingPerson') ||
                        this.shouldShowForm('billingCompany')
                    );
                };

                /**
                 *
                 */
                this.getChildForm = function (name) {
                    if (this.form.hasOwnProperty(name)) {
                        return this.form[name];
                    }

                    return null;
                };

                /**
                 *
                 */
                this.shouldShowForm = function (name) {
                    return (
                        this.getChildForm(name) !== null &&
                        this.getChildForm(name).$invalid &&
                        this.getChildForm(name).$submitted
                    );
                };
            },
            bindings: {
                order: '<',
                form: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-option.component.js
(function (angular) {
var template = '\
        <div class="fare-lock-option" ng-class="$ctrl.getClassMap()" ng-click="$ctrl.onClick()">\
            <div class="fare-lock-option__heading">\
                <div class="fare-lock-option__heading__left">\
                    <span class="fare-lock-option__toggler">\
                        <svg-icon id="checkmark" class="size--12"></svg-icon>\
                    </span>\
                    <strong translate translate-values="{ hours: $ctrl.getHours() }">LANGM_JS_FARE_LOCK_HOURS</strong>\
                </div>\
                <div class="fare-lock-option__heading__right">{{ $ctrl.option.price.amount | flPrice:2:\'\':$ctrl.option.price.currency }}</div>\
            </div>\
            <div class="fare-lock-option__details" translate translate-values="{ difference: ($ctrl.getDifference() | flPrice:2), until: $ctrl.getUntil() }">\
                LANGM_JS_FARE_LOCK_OPTION_DESC\
            </div>\
        </div>\
    ';

    var FareLockOptionController = function () {
        this.onClick = function () {
            this.model = this.option.id;
        };

        this.isSelected = function () {
            return this.model === this.option.id;
        };

        this.getClassMap = function () {
            return {
                'fare-lock-option--selected': this.isSelected()
            };
        };

        this.getDifference = function () {
            return parseFloat(this.coveringAmount) - this.option.price.amount;
        };

        this.getHours = function () {
            return this.option.duration.split('PT').join('').split('H').join('');
        };

        this.getUntil = function () {
            return moment().add(this.getHours(), 'hours').format('DD.MM.YYYY, HH:mm');
        };
    };

    angular
        .module('ITH.Funnel.FareLock')
        .component('ithFareLockOption', {
            controller: FareLockOptionController,
            template: template,
            bindings: {
                option: '<',
                coveringAmount: '<',
                model: '='
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-order.model.js
(function (angular) {
var FareLockOrderModel = function (FlightDetails, FareLockContact, Billing, ConsentsHelper) {
        var FareLockOrder = function () {
            this.flightDetails = FlightDetails;
            this.contact = new FareLockContact;
            this.billing = new Billing();
            this.fareLock = {};
            this.selectedFareLockRuleId = null;
            this.consents = [];
        };

        FareLockOrder.prototype.getFlightDetails = function () {
            return this.flightDetails;
        };

        FareLockOrder.prototype.getContact = function () {
            return this.contact;
        };

        FareLockOrder.prototype.getBilling = function () {
            return this.billing;
        };

        FareLockOrder.prototype.getSelectedOption = function () {
            var found = null;

            this.fareLock.pricing.forEach(function (fareLockOption) {
                if (fareLockOption.id === this.selectedFareLockRuleId) {
                    found = fareLockOption;
                }
            }.bind(this));

            return found;
        };

        FareLockOrder.prototype.srvSet = function (data, consents) {
            this.getFlightDetails().srvSet(data);
            this.fareLock = data.fareLock;

            if (consents && consents.length > 0) {
                this.consents = ConsentsHelper.getConsentModels(consents);
            }

            this.selectedFareLockRuleId = data.fareLock.pricing[0].id;
        };

        FareLockOrder.prototype.srvErrors = function (backendErrors) {
            if (backendErrors.hasOwnProperty('customer')) {
                this.contact.srvErrors(backendErrors.customer);
            }

            if (backendErrors.hasOwnProperty('billing')) {
                this.billing.srvErrors(backendErrors.billing);
            }
        };

        FareLockOrder.prototype.srvObj = function () {
            return {
                token: this.getFlightDetails().getFulfillmentToken(),
                contact: this.getContact().srvObj(),
                billing: this.getBilling().srvObj(),
                pricingRuleId: this.selectedFareLockRuleId,
                consents: ConsentsHelper.serialize(this.consents)
            };
        };

        FareLockOrder.prototype.populateUserData = function (data) {
            this.contact.firstName = data.customer.person.first_name;
            this.contact.lastName = data.customer.person.last_name;
            this.contact.email = data.customer.contact.email;
            this.contact.phone.setPrefix(data.customer.contact.phone.prefix);
            this.contact.phone.setNumber(data.customer.contact.phone.number);
        };

        FareLockOrder.prototype.constructor = FareLockOrder;

        return FareLockOrder;
    };

    FareLockOrderModel.$inject = [
        'fdt.FlightDetails',
        'FareLockContact',
        'bil.Billing',
        'ConsentsHelper'
    ];

    angular
        .module('ITH.Funnel.FareLock')
        .factory('FareLockOrder', FareLockOrderModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-steps-content.component.js
(function (angular) {

    var template = '\
        <ul class="fd-steps">\
            <li class="fd-steps__item fd-steps__item--accesible" ng-click="$ctrl.backToSearch()">\
                <svg-icon id="checkmark"></svg-icon>\
                <span translate>LANGM_JS_SEARCH_RESULTS</span>\
            </li>\
            <li class="fd-steps__item fd-steps__item--current">\
                <svg-icon id="checkmark"></svg-icon>\
                <span translate>LANGM_JS_DETAILS</span>\
            </li>\
            <li class="fd-steps__item fd-steps__item--disabled">\
                <svg-icon id="checkmark"></svg-icon>\
                <span translate>LANGM_JS_PAYMENT</span>\
            </li>\
        </ul>\
    ';

    angular
        .module('ITH.Funnel.FareLock')
        .component('ithFareLockStepsContent', {
            template: template,
            controller: ['$scope', 'FareLockHelper', function ($scope, FareLockHelper) {
                this.backToSearch = function () {
                    FareLockHelper.getBackToSearch(this.flightDetails);
                    $scope.$emit('stepClick');
                };
            }],
            bindings: {
                flightDetails: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock-steps.component.js
(function (angular) {

    var template = '\
        <article>\
            <div class="visible-xs" style="margin-bottom: 30px;">\
                <div class="basicBox fd-mobile-steps" ng-click="$ctrl.open()">\
                    <span translate translate-values="{ current: 2, total: 3 }">LANGM_JS_FD_MOBILE_CURRENT_STEP</span>\
                    <svg-icon id="caret"></svg-icon>\
                </div>\
                <ith-responsive-tooltip id="stepSelect" show-close-x="false">\
                    <content class="text-bigger">\
                        <ith-fare-lock-steps-content flight-details="$ctrl.flightDetails"></ith-fare-lock-steps-content>\
                    </content>\
                </ith-responsive-tooltip>\
            </div>\
            <ith-fare-lock-steps-content flight-details="$ctrl.flightDetails" class="hidden-xs"></ith-fare-lock-steps-content>\
        </article>\
    ';

    angular
        .module('ITH.Funnel.FareLock')
        .component('ithFareLockSteps', {
            template: template,
            controller: ['$scope', 'ResponsiveTooltipService', function ($scope, ResponsiveTooltipService) {
                this.open = function () {
                    ResponsiveTooltipService.open('stepSelect');
                };

                this.$onInit = function () {
                    $scope.$on('stepClick', function () {
                        ResponsiveTooltipService.close('stepSelect');
                    });
                };
            }],
            bindings: {
                flightDetails: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fare-lock/fare-lock.api.js
(function (angular) {
var endpoints = {
        flightDetails: '/api/flightDetails/getFulfilmentFlightDetails/',
        fareLockPurchase: '/api/fareLock/purchase',
        flightInformation: '/api/flightDetails/getFareLockFlightDetails/',
        requestVoucher: '/api/fareLock/requestVoucher/',
        requestRefund: '/api/fareLock/requestRefund/',
        consents: '/api/fareLock/getConsents'
    };

    var FareLockApi = function ($http, AppConfig) {
        this.getDetails = function (uuid) {
            return $http({
                method: 'GET',
                url: AppConfig.getUriPrefix() + endpoints.flightDetails + uuid
            });
        };

        this.getConsents = function () {
            return $http({
                method: 'GET',
                url: AppConfig.getUriPrefix() + endpoints.consents
            });
        };

        this.prepareOffer = function (fareLockUuid, debughttpcode) {
            var headers = {};
            if (debughttpcode) {
                headers.Debughttpcode = debughttpcode;
            }

            return $http({
                method: 'POST',
                url: AppConfig.getUriPrefix() + '/api/offerDetails/prepareOffer/' + fareLockUuid,
                data: {},
                headers: headers,
            });
        };

        this.purchase = function (uuid, fareLockOrderData, gaDimensions) {
            return $http({
                method: 'POST',
                url: AppConfig.getUriPrefix() + endpoints.fareLockPurchase,
                data: {
                    fareTempUuid: uuid,
                    ffToken: fareLockOrderData.token,
                    customer: fareLockOrderData.contact,
                    billing: fareLockOrderData.billing,
                    pricingRuleId: fareLockOrderData.pricingRuleId,
                    gaDimensions: gaDimensions,
                    consents: fareLockOrderData.consents
                }
            });
        };

        this.getFlightInformation = function (uuid) {
            return $http({
                method: 'GET',
                url: AppConfig.getUriPrefix() + endpoints.flightInformation + uuid
            });
        };

        this.initiateRefund = function (type, fareLockId) {
            var endpoint = type === 'cash'
                ? endpoints.requestRefund
                : endpoints.requestVoucher;

            return $http({
                method: 'GET',
                url: AppConfig.getUriPrefix() + endpoint + fareLockId
            });
        };
    };

    FareLockApi.$inject = ['$http', 'appConfig'];

    angular
        .module('ITH.Funnel.FareLock')
        .service('FareLockApi', FareLockApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fast-refund/frola-fast-refund-logo.component.js
(function (angular) {
var IthFrolaFastRefundLogoComponent = {
        template: '<ith-product-logo show-affiliate-name="false" image-name="fast-refund" name="{{ \'LANGM_JS_FAST_REFUND_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.Funnel.FastRefund')
        .component('ithFrolaFastRefundLogo', IthFrolaFastRefundLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fast-refund/ith-fast-refund-box.component.js
(function(angular) {
var templateUrl = function ($attrs) {
        var templateName = 'fd-box';

        if ($attrs.zone === 'ty') {
            templateName = 'ty-box';
        }

        return '/tpl/show/jsShared/templates/funnel/fast-refund/' + templateName;
    };

    templateUrl.$inject = [
        '$attrs'
    ];

    var IthFastRefundBoxComponent = {
        templateUrl: templateUrl,
        bindings: {
            booking: '<',
            zone: '@'
        },
        controller: 'FastRefundBoxController'
    };

    angular
        .module('ITH.Funnel.FastRefund')
        .component('ithFastRefundBox', IthFastRefundBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/fast-refund/ith-fast-refund-box.controller.js
(function() {
var IthFastRefundBoxController = function () {
        /**
         *
         */
        var ctrl = this;

        /**
         * Decides if box is visible
         *
         * @returns {Boolean}
         */
        this.isVisible = function () {
            if (!this.booking.fastRefund.isAllowed) {
                return false;
            }

            return isVisibleOnTyPage() || this.zone !== 'ty';
        };

        /**
         *
         * @returns {Boolean}
         */
        var isVisibleOnTyPage = function () {
            if (ctrl.zone !== 'ty' || !ctrl.booking) {
                return false;
            }

            return (
                ctrl.booking.fastRefund.selected ||
                ctrl.booking.ticketType.isFastRefundIncluded()
            );
        };
    };

    angular
        .module('ITH.Funnel.FastRefund')
        .controller('FastRefundBoxController', IthFastRefundBoxController);

}());
;

// Source: ../shared/public_html/assets/js/funnel/filters/filter-checklist.model.js
(function (angular) {
var IthFilterChecklistModel = function () {
        /**
         * @constructor
         */
        function FilterChecklist(code, translation, selected) {
            this.code = code;
            this.translation = translation;
            this.selected = selected || true;
        }

        FilterChecklist.prototype.constructor = FilterChecklist;

        return FilterChecklist;
    };

    angular
        .module('funnel')
        .factory('FilterChecklistModel', IthFilterChecklistModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/filters/filter-formatters.service.js
(function (angular) {
var FilterFormattersService = function () {
        /**
         * Return time passed since midnight for a dateTime string
         *
         * @param {String} date
         * @returns {Number}
         */
        this.minutesSinceMidnight = function (date) {
            var ddt = new Date(date);
            var ddtMidnight = new Date(date);
            ddtMidnight.setHours(0, 0, 0, 0);
            return this.minuteDateDiff(ddtMidnight, ddt);
        };

        /**
         * Returns diff of two dates in minutes
         *
         * @param {Date} date1
         * @param {Date} date2
         * @returns {Number}
         */
        this.minuteDateDiff = function (date1, date2) {
            var msDiff = Math.abs(date1 - date2); // Get diff in miliseconds
            return Math.floor((msDiff / 1000) / 60);
        };

        /**
         * Returns duration in HH:mm format for minutes
         *
         * @param {Number} minuteDuration
         * @returns {String}
         */
        this.formatMinutes = function (minuteDuration) {
            if (isNaN(minuteDuration)) {
                return '00:00';
            }

            var hoursMinutes = getHoursMinutes(minuteDuration);

            // Make values zero based
            hoursMinutes.h = hoursMinutes.h < 10 ? '0' + hoursMinutes.h : hoursMinutes.h;
            hoursMinutes.m = hoursMinutes.m < 10 ? '0' + hoursMinutes.m : hoursMinutes.m;

            return hoursMinutes.h + ':' + hoursMinutes.m;
        };

        /**
         * Returns duration in a more traditiona format. Ex: 5h 30m
         *
         * @param {Number} minuteDuration
         * @returns {String}
         */
        this.formatTimeLength = function (minuteDuration) {
            if (isNaN(minuteDuration)) {
                return '0h 0m';
            }

            var hoursMinutes = getHoursMinutes(minuteDuration);
            return hoursMinutes.h + 'h ' + hoursMinutes.m + 'm';
        };

        this.isSameDay = function (date1, date2) {
            var firstDate = new Date(date1);
            var secondDate = new Date(date2);

            return (
                firstDate.getFullYear() === secondDate.getFullYear() &&
                firstDate.getMonth() === secondDate.getMonth() &&
                firstDate.getDate() === secondDate.getDate()
            );
        };

        /**
         * Returns object containing hours and minutes
         *
         * @param {Number} minuteDuration
         * @returns {Object}
         */
        var getHoursMinutes = function (minuteDuration) {
            var hours = (minuteDuration / 60);
            var rhours = Math.floor(hours);
            var minutes = (hours - rhours) * 60;
            var rminutes = Math.round(minutes);

            return {
                h: rhours,
                m: rminutes
            };
        };

        return this;
    };

    angular
        .module('funnel')
        .service('FilterFormatters', FilterFormattersService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/filters/min-max-filter.model.js
(function(angular) {
var IthMinMaxFilterModel = function () {
        /**
         * @constructor
         */
        function MinMaxFilter() {
            this.min = 0;
            this.max = 0;
            this.value = 0;
        }

        MinMaxFilter.prototype.constructor = MinMaxFilter;

        return MinMaxFilter;
    };

    angular
        .module('funnel')
        .factory('MinMaxFilterModel', IthMinMaxFilterModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/filters/range-filter.model.js
(function (angular) {
var IthRangeFilterModel = function () {
        /**
         * @constructor
         */
        function RangeFilter() {
            this.start = 0;
            this.end = 1440;
            this.min = 0;
            this.max = 1440;
        }

        RangeFilter.prototype.constructor = RangeFilter;

        return RangeFilter;
    };

    angular
        .module('funnel')
        .factory('RangeFilterModel', IthRangeFilterModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/filters/southpark-filters.service.js
(function(angular, underscore) {
var SouthParkFiltersService = function ($filter, MinMaxFilterModel, TakeoffLandingModel, FilterChecklistModel, FlightOfferHelper) {
        /**
         * Main filter data (modified by user)
         *
         * @type {Object}
         */
        this.filters = {};

        /**
         * Applied filters data
         *
         * @type {Object}
         */
        this.appliedFilters = {};

        /**
         * Object keeping track of dirty statuses per each filter main category
         *
         * @type {Object}
         */
        this.filtersDirtyStatus = {};

        /**
         * Cache of default filters (for comparison with modified ones)
         *
         * @type {Object}
         */
        this.defaultFilters = {};

        /**
         * Flag that determines if filters were processed based on flights loaded
         *
         * @type {Boolean}
         */
        this.computed = false;

        /**
         * Creates default filter object with "empty" data
         */
        var initFilterObject = function () {
            return {
                stops: [],
                airports: [],
                originAirports: [],
                destinationAirports: [],
                layoverAirports: [],
                airlines: [],
                stopDuration: new MinMaxFilterModel(),
                flightDuration: new MinMaxFilterModel(),
                hours: {
                    departure: new TakeoffLandingModel(),
                    return: new TakeoffLandingModel()
                },
                providers: []
            };
        };

        /**
         * Returns an array of checklists based on a filter array of objects
         *
         * @param {Object[]} array
         * @param {Function} translateFunction
         * @returns {FilterChecklistModel[]}
         */
        var computeUniqueChecklist = function (array, translateFunction) {
            return underscore.map(underscore.uniq(array), function (code) {
                return new FilterChecklistModel(code, translateFunction(code), true);
            });
        };

        /**
         * Computes all filter parameters based on final offer list
         *
         * @param {Object[]} offers
         * @param {Object} shortDictionary
         */
        this.compute = function (offerGroups, shortDictionary) {
            this.filters = initFilterObject();

            var airports = [];
            var airportCityMapping = {};
            var airlines = [];
            var originAirports = [];
            var destinationAirports = [];
            var layoverAirports = [];
            var stops = [];
            var maxStopDuration = 0;
            var minFlightDuration = Infinity;
            var maxFlightDuration = 0;
            var providers = [];

            underscore.each(offerGroups, function (offerGroup) {
                underscore.each(offerGroup, function (offer) {
                    // Get offer filter data
                    var offerFilterData = FlightOfferHelper.getOfferFilterData(offer);

                    // Process collections
                    airports = underscore.union(airports, offerFilterData.airports);
                    originAirports = underscore.union(originAirports, offerFilterData.originAirports);
                    destinationAirports = underscore.union(destinationAirports, offerFilterData.destinationAirports);
                    layoverAirports = underscore.union(layoverAirports, offerFilterData.layoverAirports);
                    airlines = underscore.union(airlines, offerFilterData.airlines);
                    providers = underscore.union(providers, offerFilterData.providers);
                    airportCityMapping = underscore.extend(airportCityMapping, offerFilterData.airportCityMapping);
                    stops.push(offerFilterData.stops);

                    // Process values
                    maxStopDuration = offerFilterData.maxStopDuration > maxStopDuration ? offerFilterData.maxStopDuration : maxStopDuration;
                    minFlightDuration = offerFilterData.maxFlightDuration < minFlightDuration ? offerFilterData.maxFlightDuration : minFlightDuration;
                    maxFlightDuration = offerFilterData.maxFlightDuration > maxFlightDuration ? offerFilterData.maxFlightDuration : maxFlightDuration;
                });
            });

            // Set filter data
            this.filters.stops = computeUniqueChecklist(
                stops,
                function (stopCount) {
                    return $filter('translate')('LANGM_JS_FILTERS_STOPS_' + stopCount);
                }
            );

            /**
             * Returns translation for airport checklist item
             *
             * @param {String} airportCode
             * @returns {String}
             */
            var translateAirport = function (airportCode) {
                return shortDictionary.getCityName(airportCityMapping[airportCode]) + ': ' + shortDictionary.getAirportName(airportCode);
            };

            var translateProvider = function (providerName) {
                return providerName;
            };

            this.filters.airports = computeUniqueChecklist(airports, translateAirport);
            this.filters.originAirports = computeUniqueChecklist(originAirports, translateAirport);
            this.filters.destinationAirports = computeUniqueChecklist(destinationAirports, translateAirport);
            this.filters.layoverAirports = computeUniqueChecklist(layoverAirports, translateAirport);
            this.filters.providers = computeUniqueChecklist(providers, translateProvider);

            this.filters.airlines = computeUniqueChecklist(
                airlines,
                function (airlineCode) {
                    return shortDictionary.getAirlineName(airlineCode);
                }
            );

            this.filters.stopDuration.max = maxStopDuration;
            this.filters.stopDuration.value = maxStopDuration;
            this.filters.flightDuration.min = minFlightDuration;
            this.filters.flightDuration.max = maxFlightDuration;
            this.filters.flightDuration.value = maxFlightDuration;

            // Cache the filters
            this.defaultFilters = JSON.parse(angular.toJson(this.filters));

            this.onUpdate();

            // Mark as computed
            this.computed = true;
        };

        /**
         * Resets all filters to the default state
         */
        this.resetAll = function () {
            this.filters = JSON.parse(angular.toJson(this.defaultFilters));
            this.onUpdate();
        };

        /**
         * Resets a category of filters to the default state
         *
         * @param {String} property
         */
        this.resetCategory = function (property) {
            this.filters[property] = JSON.parse(angular.toJson(this.defaultFilters[property]));
            this.onUpdate();
        };

        /**
         * Checks if a filter category is dirty
         *
         * @param {String} property
         * @returns {Boolean}
         */
        this.isDirty = function (property) {
            return this.filtersDirtyStatus[property];
        };

        /**
         * Method called whenever something changes in the filters
         * to do extra processing (like computing dirty statuses)
         */
        this.onUpdate = function () {
            var self = this;

            // Compute dirties
            angular.forEach(Object.keys(this.filters), function (property) {
                self.filtersDirtyStatus[property] = angular.toJson(self.filters[property]) !== angular.toJson(self.defaultFilters[property]);
            });

            // Create object containing only applied filters (for analytics)
            this.appliedFilters = {};
            processUsedFilters(JSON.parse(angular.toJson(this.filters)), this.appliedFilters);
        };

        /**
         * Takes each filter category and caches applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         */
        var processUsedFilters = function (filters, appliedFilters) {
            processUsedChecklistFilters(filters, appliedFilters, 'stops');
            processUsedChecklistFilters(filters, appliedFilters, 'airlines');
            processUsedChecklistFilters(filters, appliedFilters, 'originAirports');
            processUsedChecklistFilters(filters, appliedFilters, 'layoverAirports');
            processUsedChecklistFilters(filters, appliedFilters, 'destinationAirports');
            processUsedChecklistFilters(filters, appliedFilters, 'providers');
            processUsedSliderFilter(filters, appliedFilters, 'stopDuration');
            processUsedSliderFilter(filters, appliedFilters, 'flightDuration');
            processUsedHoursFilter(filters, appliedFilters);
        };

        /**
         * Goes through the filter category checklist
         * and adds all modified items to applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         * @param {String} category
         */
        var processUsedChecklistFilters = function (filters, appliedFilters, category) {
            angular.forEach(filters[category], function (checklistItem) {
                if (checklistItem.selected === false) {
                    if (!appliedFilters.hasOwnProperty(category)) {
                        appliedFilters[category] = [];
                    }

                    appliedFilters[category].push({
                        code: checklistItem.code,
                        selected: checklistItem.selected
                    });
                }
            });
        };

        /**
         * Checks if a slider filter category is modified
         * and adds it to applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         * @param {String} category
         */
        var processUsedSliderFilter = function (filters, appliedFilters, category) {
            if (filters[category].value < filters[category].max) {
                appliedFilters[category] = filters[category];
            }
        };

        /**
         * Checks if departure and returns hours filter categories are modified
         * and adds them to applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         */
        var processUsedHoursFilter = function (filters, appliedFilters) {
            processUsedHoursStage(filters, appliedFilters, 'departure');
            processUsedHoursStage(filters, appliedFilters, 'return');
        };

        /**
         * Checks if stage hour filter category is modified
         * and adds it to applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         * @param {String} category
         */
        var processUsedHoursStage = function (filters, appliedFilters, category) {
            processUsedHoursStagePart(filters, appliedFilters, category, 'takeoff');
            processUsedHoursStagePart(filters, appliedFilters, category, 'landing');
        };

        /**
         * Checks if takeoff or landing hours category is modified
         * and adds it to applied filters
         *
         * @param {Object} filters
         * @param {Object} appliedFilters
         * @param {String} category
         * @param {String} part
         */
        var processUsedHoursStagePart = function (filters, appliedFilters, category, part) {
            if (
                filters.hours[category][part].start === filters.hours[category][part].min &&
                filters.hours[category][part].end === filters.hours[category][part].max
            ) {
                return;
            }

            if (!appliedFilters.hasOwnProperty('hours')) {
                appliedFilters.hours = {};
            }

            if (!appliedFilters.hours.hasOwnProperty(category)) {
                appliedFilters.hours[category] = {};
            }

            if (!appliedFilters.hours[category].hasOwnProperty(part)) {
                appliedFilters.hours[category][part] = {};
            }

            appliedFilters.hours[category][part] = filters.hours[category][part];
        };
    };

    SouthParkFiltersService.$inject = [
        '$filter',
        'MinMaxFilterModel',
        'TakeoffLandingModel',
        'FilterChecklistModel',
        'FlightOfferHelper'
    ];

    angular
        .module('funnel')
        .service('SouthParkFilters', SouthParkFiltersService);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/filters/takeoff-landing-filter.model.js
(function (angular) {
var IthTakeoffLandingModel = function (RangeFilterModel) {
        /**
         * @constructor
         */
        function TakeoffLanding() {
            this.takeoff = new RangeFilterModel();
            this.landing = new RangeFilterModel();
        }

        TakeoffLanding.prototype.constructor = TakeoffLanding;

        return TakeoffLanding;
    };

    IthTakeoffLandingModel.$inject = [
        'RangeFilterModel'
    ];

    angular
        .module('funnel')
        .factory('TakeoffLandingModel', IthTakeoffLandingModel);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/InsuranceServices.js
(function () {
/**
   * @name        InsuranceServices
   * @description Base on vuex philosophy contain model modified by action
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var InsuranceServices = function ($filter) {
    /**
     *
     * @param insurance
     * @returns {string|*|null}
     */
   var getOwuLang = function (insurance) {
      if (!insurance) return null
      return $filter('translate')('LANGM_JS_INSURENCE_TERMS_LINK', {owiLinkUrl: insurance.descriptions.owuLink || null});
    }

    var InsuranceModel = {
      isLoaded: false,

      /**
       * @name  selectedInsurance
       * @description variable contain selected insurance package or null
       * @type  insurancePackage|null,
       */
      selectedInsurance: null,
      /**
       * @name  isInsuranceAllow
       * @description flag responsible for define if insurance for flight is allowed
       * @type  boolean,
       */
      isInsuranceAllow: false,
      /**
       * @name  insurances
       * @description array of possible insurance package
       * @type  Array<insurancePackage>
       */
      insurances: [],
      /**
       * @name  providers
       * @description Array of insurance provider names
       * @type  Array<String>
       */
      providers: [],
      /**
       * @name  defaultInsurance
       * @description variable contain default insurance.
       *              This insurance will be copy to selectedInsurance after call
       *              selectInsurance function without arguments
       * @type  insurancePackage|null,
       */
      defaultInsurance: null,

      reset: function () {
        this.selectedInsurance = null;
        this.isInsuranceAllow = false;
        this.insurances = [];
        this.providers = [];
        this.defaultInsurance = null;
        return this
      },


      /**
       * @description function  set list of  insurance provider
       * @param providersArray
       * @returns {InsuranceModel}
       */
      fetchProviders: function (providersArray) {
        this.providers = [].concat(providersArray);
        return this;
      },
      /**
       *
       * @param insurances <Array<object>>
       * @returns {InsuranceModel}
       */
      fetchInsurances: function (insurances) {
        insurances = Array.isArray(insurances) ? insurances : [insurances]

        this.insurances = [].concat(
          insurances.map(function (insurance) {
            if (insurance.descriptions && insurance.descriptions.owuLink) {
              insurance.owuLang = getOwuLang(insurance);
            }
            return insurance
          })
        ).filter(
          function (insurance) {
            return this.providers.indexOf(insurance.provider) > -1;
          }
            .bind(this));
        if (this.insurances.indexOf(this.selectedInsurance) == -1) {
          this.selectedInsurance = null
        }
        return this;
      },

      mapInsuranceObjectToArray: function (providers, insurances) {
        return providers
          .map(function (provider) {
            var result = [];
            var insuranceObject = insurances[provider];

            for (var key in insuranceObject) {
              result.push(insuranceObject[key]);
            }
            return result
          })
          .reduce(function (prev, next) {
            return prev.concat(next);
          }, []);
      },

      /**
       * @description set selected insurance
       call without argument set default insurance.
       In case call inexistent provider package param , leaves prev selected insurance type
       * @param providerName string
       * @param insuranceType string
       * @returns {InsuranceModel}
       */
      selectInsurance: function (providerName, insuranceType) {
        if (providerName === undefined && insuranceType === undefined && this.defaultInsurance) {
          return this.selectInsurance(this.defaultInsurance.provider, this.defaultInsurance.type)
        }
        function isInsuranceMatch(insurance) {
          return insurance.type === insuranceType && insurance.provider === providerName
        }

        var selectedInsurance = this.insurances.filter(isInsuranceMatch)
        selectedInsurance = selectedInsurance.length > 0 ? selectedInsurance[0] : this.selectedInsurance;
        this.selectedInsurance = angular.copy(selectedInsurance)
        return this;
      },
      /**
       * @description set selectedInsurance to null
       * @returns {InsuranceModel}
       */
      deselectInsurance: function () {
        this.selectedInsurance = null;
        return this;
      },
      /**
       *
       * @param providerName
       * @param insuranceType
       * @returns {InsuranceModel}
       */
      setDefaultInsurance: function (providerName, insuranceType) {
        function isInsuranceMatch(insurance) {
          return insurance.type === insuranceType && insurance.provider === providerName
        }

        var defaultInsurance = this.insurances.filter(isInsuranceMatch)
        defaultInsurance = defaultInsurance.length > 0 ? defaultInsurance[0] : this.defaultInsurance;
        this.defaultInsurance = angular.copy(defaultInsurance)
        return this;
      },
      /**
       * @description output insurance object used in book process
       * @returns {{type: string, provider: string, owNoOfDays: number}}
       */
      getDataToBook: function () {
        var selectedInsurance = this.selectedInsurance || {};
        return {
          type: selectedInsurance.type || '',
          provider: selectedInsurance.provider || '',
          owNoOfDays: selectedInsurance.days || 0
        }
      },
      /**
       *
       * @param isAllow
       * @returns {InsuranceModel}
       */
      setInsuraceAllow: function (isAllow) {
        this.isInsuranceAllow = isAllow;
        if (!isAllow) {
          this.selectedInsurance = null;
        }
        return this;
      },

      /**
       *
       * @returns {boolean}
       */
      isSelectedInsurance: function () {
        return !!this.selectedInsurance;
      },

      /**
       *
       * @returns {boolean}
       */
      isDefaultInsuranceSet: function () {
        return !!this.defaultInsurance;
      },

      /**
       *
       * @returns {*|string|null}
       */
      getInsuranceOwu: function () {
        var insurance = this.selectedInsurance || this.defaultInsurance
        return !!insurance ? insurance.owuLang : null
      },

      setInitialResponse: function (response) {
        var insurancesArray = this.mapInsuranceObjectToArray(response.providers, response.insurance);

        this
          .fetchProviders(response.providers)
          .setInsuraceAllow(response.isInsuranceAllow)
          .fetchInsurances(insurancesArray)
          .setDefaultInsurance(response.defaultProvider, response.defaultType);

        this.isLoaded = true;
      },

      setOneWayRecalculatedResponse: function (response) {
        var insurancesArray = this.mapInsuranceObjectToArray(response.providers, response.insurance);

        this
          .fetchProviders(response.providers)
          .setInsuraceAllow(response.isInsuranceAllow)
          .fetchInsurances(insurancesArray)
          .setDefaultInsurance(response.defaultProvider, response.defaultType);
      }
    }


    return InsuranceModel;
  }
  InsuranceServices.$inject = [
    '$filter'
  ]
  angular.module('ITH.insurance')
    .factory('InsuranceServices', InsuranceServices);

})();
;

// Source: ../shared/public_html/assets/js/funnel/insurances/covid-insurance/covid-insurance-details.component.js
(function(angular) {
var IthCovidInsuranceDetailsComponent = {
        template: '<a ng-click="$ctrl.openModal()" translate>LANGM_JS_COVID_INSURANCE_DETAILS</a>',
        controller: 'IthCovidInsuranceDetailsController'
    };

    angular
        .module('ITH.insurance')
        .component('ithCovidInsuranceDetails', IthCovidInsuranceDetailsComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/covid-insurance/covid-insurance-modal.controller.js
(function(angular) {
var IthCovidInsuranceDetailsController = function ($modal) {
        /**
         * Opens the covid insurance details modal
         */
        this.openModal = function () {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/covid-insurance-modal',
                windowClass: 'mobile-modal--fullscreen'
            });
        };
    };

    IthCovidInsuranceDetailsController.$inject = [
        '$modal'
    ];

    angular
        .module('ITH.insurance')
        .controller('IthCovidInsuranceDetailsController', IthCovidInsuranceDetailsController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/covid-insurance/covid-insurance-top-box.component.js
(function (angular) {
var templateUrl = function (AppConfig) {
        if (AppConfig.isFreeRebookingFlow()) {
            return '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/fd-top-box-free-rebooking';
        }

        return '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/fd-top-box';
    };

    templateUrl.$inject = ['appConfig'];

    var IthCovidInsuranceTopBoxComponent = {
        controller: 'IthCovidInsuranceTopBoxController',
        bindings: {
            flightBookingPromise: '<',
            flightBooking: '<'
        },
        templateUrl: templateUrl
    };

    angular
        .module('ITH.insurance')
        .component('ithCovidInsuranceTopBox', IthCovidInsuranceTopBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/covid-insurance/covid-insurance-top-box.controller.js
(function (angular) {
var IthCovidInsuranceTopBoxController = function (PricegroupMarkerHelper, AppConfig) {
        /**
         * Self reference
         *
         * @type {IthCovidInsuranceTopBoxController}
         */
        var self = this;

        /**
         * Flight booking reference
         *
         * @type {FlightBooking}
         */
        this.flightBooking = null;

        /**
         * Price trends loaded switch
         *
         * @type {Boolean}
         */
        this.priceTrendsLoaded = false;

        /**
         * On init hook
         */
        this.$onInit = function () {
            if (!this.shouldCheckPriceTrends()) {
                return;
            }

            this.flightBookingPromise.then(function (success) {
                self.flightBooking = success;

                if (!PricegroupMarkerHelper.isCampaignActive()) {
                    self.priceTrendsLoaded = true;
                    return;
                }

                PricegroupMarkerHelper
                    .loadReferencePrices(
                        self.flightBooking.getFlightDetails().getDepLeg().getDepCityCode(),
                        self.flightBooking.getFlightDetails().getDepLeg().getFirstSegment().getDepAirportCode(),
                        self.flightBooking.getFlightDetails().getDepLeg().getArrCityCode(),
                        self.flightBooking.getFlightDetails().getDepLeg().getLastSegment().getArrAirportCode(),
                        self.flightBooking.getFlightDetails().getDepDate(),
                        self.flightBooking.getFlightDetails().isOneWay(),
                        getPaxCount('ADT'),
                        getPaxCount('CHD'),
                        getPaxCount('INF'),
                        getPaxCount('YTH')
                    )
                    .then(function () {
                        self.priceTrendsLoaded = true;
                    });
            });
        };

        /**
         * Chcks if should show a loader (in case price trend check is active)
         *
         * @returns {Boolean}
         */
        this.shouldShowLoader = function () {
            return this.shouldCheckPriceTrends() && !this.priceTrendsLoaded;
        };

        this.getRoute = function () {
            return self.flightBooking.getFlightDetails().getDepLeg().getDepCityCode() + '' + self.flightBooking.getFlightDetails().getDepLeg().getArrCityCode();
        };

        /**
         * Checks if should show the content (price trends loaded or price trends deactivated)
         *
         * @returns {Boolean}
         */
        this.shouldShowContent = function () {
            return (this.shouldCheckPriceTrends() && this.priceTrendsLoaded) || !this.shouldCheckPriceTrends();
        };

        /**
         * Checks if this flight is cheaper than month average
         *
         * @returns {Boolean}
         */
        this.isCheaper = function () {
            return this.priceTrendsLoaded && PricegroupMarkerHelper.showMarker(
                self.getRoute(),
                self.flightBooking.basket.getTotalNettoPrice()
            );
        };

        /**
         * Returns percent of discount
         *
         * @returns {Number}
         */
        this.getPercent = function () {
            return this.priceTrendsLoaded && PricegroupMarkerHelper.getIeftinuarieDiscount(
                this.getRoute(),
                self.flightBooking.basket.getTotalNettoPrice()
            );
        };

        /**
         * Should we check price trends for this flight?
         *
         * @returns {Boolean}
         */
        this.shouldCheckPriceTrends = function () {
            return AppConfig.getCovidInsuranceConfig().paxPriceTrends === true;
        };

        /**
         * Flag for ieftinuarie campaign
         *
         * @type {Boolean}
         */
        this.isIeftinuarieActive = function () {
            return AppConfig.getIeftinuarieConfig() === true;
        };

        /**
         * Get flight pax cound by pax type
         *
         * @private
         * @returns {Number}
         */
        var getPaxCount = function (paxType) {
            var found = self.flightBooking.getFlightDetails().getPaxesPricing().getPricings().find(function (pax) {
                return pax.getPaxType() === paxType;
            });

            return found ? found.getPaxCount() : 0;
        };
    };

    IthCovidInsuranceTopBoxController.$inject = [
        'PricegroupMarkerHelper',
        'appConfig'
    ];

    angular
        .module('ITH.insurance')
        .controller('IthCovidInsuranceTopBoxController', IthCovidInsuranceTopBoxController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/covid-insurance/frola-medical-logo.component.js
(function (angular) {
var IthFrolaMedicalLogoComponent = {
        template: '<ith-product-logo show-affiliate-name="true" image-name="medical" name="{{ \'LANGM_JS_COVID_INSURANCE_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.insurance')
        .component('ithFrolaMedicalLogo', IthFrolaMedicalLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance-add/insurance-add-policy-info/formatCurrency.filter.js
(function (angular) {
/**
   * @name        formatCurrencyFilter
   * @description format currency number  to language  national currency format
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var formatCurrencyFilter=   function () {
    return function (number, currency) {

      if(!number) return number
      currency = currency? currency : 'EUR'
      var num = Number(number);
      return num  ? num.toLocaleString('de-DE',
          {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0
          }
        ) : number;
    };
  }

  angular.module('ITH.insurance')
    .filter('formatCurrency',formatCurrencyFilter);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance-add/insurance-add-policy-info/insurance-add-policy-info.component.js
(function (angular) {
/**
   * @name        ithInsuranceAdd
   * @description responsible for display insurance package in basked/thx page
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */

  var ithInsuranceAddPolicyInfo = {
    templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/insuranceInfo-hyb',
    bindings: {
      medicalExpenses: '<',
      accidents: '<',
      luggageLost: '<',
      flyCancellation: '<',
      currency: '<',
      owuLink: '<',
      isAgent: '<',
      agentInfo: '<?',
      luggageDelay: '<?',
      flyInterruption: '<?',
    }
  };
  angular.module('ITH.insurance')
    .component('ithInsuranceAddPolicyInfo', ithInsuranceAddPolicyInfo)
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance-add/insurance-add-popover/insurance-add-popover.component.js
(function (angular) {
/**
   * @name        ithInsuranceAddPopover
   * @description repsonsible for dsplay  insurance check detail popover
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var ithInsuranceAddPopoverController = function ($filter) {

    this.$onInit = function () {
      var translate = $filter('translate')
      var owu = translate(this.owuLink);
      this.popoverText = translate('LANGM_JS_AGREE_TERMS_AXA_INSURANCEBOX', {
        owuLink: owu
      });
    }
  }

  ithInsuranceAddPopoverController.$inject = [
    '$filter'
  ];
  var ithInsuranceAddPopover = {
    templateUrl: '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/insurance-add-popover',
    controller: ithInsuranceAddPopoverController,
    bindings: {
      owuLink: '<'
    }
  };

  angular.module('ITH.insurance').component('ithInsuranceAddPopover', ithInsuranceAddPopover);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance-add/insurance-add.component.js
(function (angular) {
var templateUrl = function ($attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/flights/flightDetails/details/insurance/insurance-add';
  };

  templateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        ithInsuranceAdd
   * @description responsible for display insurance package in basked/thx page
   * @author Dominik Kajzar <dominik.kajzar@fru.pl>
   */
  var ithInsuranceAdd = {
    templateUrl: templateUrl,
    controller:'ithInsuranceAddController',
    bindings: {
      insurance: '<',
      flightBooking: '<',
      oneWayRangeChange: '&'
    }
  };
  angular.module('ITH.insurance').component('ithInsuranceAdd', ithInsuranceAdd);
})(angular);



;

// Source: ../shared/public_html/assets/js/funnel/insurances/insurance-add/insurance-add.controller.js
(function (angular) {
/**
     * @name InsuranceAddController
     * @description Controller for InsuranceAddComponent
     * @constructor
     */
    var InsuranceAddController = function ($rootScope, $stateParams, InsuranceApi) {
        this.isAgent = $rootScope.isAgent ? $rootScope.isAgent() : false;

        if (this.agent) {
            this.isAgent = true;
        }

        /**
         * @name insuranceToogle
         * @description event handler for add insurance button click.
         * emit onInsuranceUpdate event
         */
        this.insuranceToogle = function () {
            if (this.isInsuranceAdded()) {
                this.flightBooking.getNewInsurance().deselectInsurance();
                return;
            }

            this.flightBooking.getNewInsurance().selectInsurance(
                this.insurance.provider,
                this.insurance.type
            );
        };

        this.getInsuranceService = function () {
            return this.flightBooking.getNewInsurance();
        };

        this.getSelectedInsurance = function () {
            return this.flightBooking.getNewInsurance().selectedInsurance;
        };

        this.isInsuranceAdded = function () {
            if (!this.getSelectedInsurance()) {
                return false;
            }

            return (
                this.getSelectedInsurance().provider === this.insurance.provider &&
                this.getSelectedInsurance().type === this.insurance.type
            );
        };

        /**
         *
         */
        this.updateInsurance = function () {
            var param = angular.copy($stateParams);
            param.owNoOfDays = this.insurance.days;

            var oldSelect = this.getInsuranceService().selectedInsurance;

            InsuranceApi
                .resetInsurance(param, param)
                .then(function (answer) {
                    this.getInsuranceService().setOneWayRecalculatedResponse(answer);

                    if (oldSelect) {
                        this.getInsuranceService().selectInsurance(oldSelect.provider, oldSelect.type);
                    }
                }.bind(this));
        };

        /**
         * Is flight one way?
         *
         * @returns {Boolean}
         */
        this.isOneWay = function () {
            return !this.flightBooking.flightDetails.isRoundTrip();
        };

        this.getPossibleDays = function (max) {
            var min = 2;
            var days = [];
            for (; min <= max; min++) {
                days.push(min);
            }
            return days;
        };
    };

    InsuranceAddController.$inject = [
        '$rootScope',
        '$stateParams',
        'dsc.InsuranceServ'
    ];

    angular
        .module('ITH.insurance')
        .controller('ithInsuranceAddController', InsuranceAddController);

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/non-stop-assist-benefits/non-stop-assist-benefits.component.js
(function (angular) {
var template = '\
        <div class="non-stop-assist-benefits">\
            <p \
                class="non-stop-assist-benefits__title" \
                translate\
            >\
                LANGM_JS_NON_STOP_BENEFITS_TITLE\
            </p>\
            <p \
                class="non-stop-assist-benefits__desc" \
                translate\
            >\
                LANGM_JS_NON_STOP_BENEFITS_DESC\
            </p>\
            \
            <div class="non-stop-assist-benefits__inner">\
                <div class="non-stop-assist-benefits__item">\
                    <svg-icon id="headset"></svg-icon>\
                    <div>\
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-md hidden-lg"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_1\
                        </p>\
                        \
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-xs hidden-sm"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_1_DESKTOP\
                        </p>\
                        <p \
                            class="non-stop-assist-benefits__item-desc"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_DESC_1\
                        </p>\
                    </div>\
                </div>\
                \
                <div class="non-stop-assist-benefits__item">\
                    <svg-icon id="chip"></svg-icon>\
                    <div>\
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-md hidden-lg"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_2\
                        </p>\
                        \
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-xs hidden-sm"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_2_DESKTOP\
                        </p>\
                        <p \
                            class="non-stop-assist-benefits__item-desc"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_DESC_2\
                        </p>\
                    </div>\
                </div>\
                \
                <div class="non-stop-assist-benefits__item">\
                    <svg-icon id="plane5"></svg-icon>\
                    <div>\
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-md hidden-lg"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_3\
                        </p>\
                        \
                        <p \
                            class="non-stop-assist-benefits__item-title hidden-xs hidden-sm"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_TITLE_3_DESKTOP\
                        </p>\
                        <p \
                            class="non-stop-assist-benefits__item-desc"\
                            translate\
                        >\
                            LANGM_JS_NON_STOP_BENEFITS_ITEM_DESC_3\
                        </p>\
                    </div>\
                </div>\
            </div>\
            \
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('base')
        .component('nonStopAssistBenefits', {
            template: template,
            controller: controller,
            bindings: {

            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/refunds/Refund.js
(function (angular) {
angular.module('ITH.Funnel.Refunds').factory('Refund', factory);

  factory.$inject = ['$localStorage', '$rootScope'];

  function factory ($localStorage, $rootScope) {

    /**
     * @constructor
     */
    function Refund () {
      this.fd = [];
      this.inited = false;
      this.priceGroupId = '';
      this.available = false;
      this.added = false;
      this.cost = 0;
      this.minimalPrice = 0;
      this.price = 0;
      this.totalPrice = 0;
    }

    /**
     * @param {boolean} added
     */
    Refund.prototype.toggleAdded = function (added) {
      if (!this.inited || !this.available) {
        return;
      }
      if (angular.isUndefined(added)) {
        added = !this.added;
      }
      this.added = added;
      Refund.saveSelection(this.priceGroupId, added);
      this.sendGAEvent();
    };

    Refund.prototype.sendGAEvent = function () {
      var title = this.added ? 'RefundableOfferWasAdded_on_Details' : 'RefundableOfferWasRemoved_od_Details';
      ga('send', 'event', 'RefundableFlow', title, this.createGADataString(), 1);
    };

    /**
     * @param {object} data
     */
    Refund.prototype.initWithBookingData = function (data) {
      this.inited = true;
      if (data.refund) {
        this.added = true;
        this.available = true;
        this.price = data.refund.price;
      }
    };

    /**
     * @param {FlightDetails} flightDetails
     */
    Refund.prototype.initWithFlightDetails = function (flightDetails) {
      if (this.inited) {
        return;
      }
      this.inited = true;
      if (flightDetails.refund) {
        this.fd = flightDetails;
        this.available = true;
        this.priceGroupId = flightDetails.priceGroupId;
        this.added = Refund.loadSelection(this.priceGroupId);
        this.cost = flightDetails.refund.cost;
        this.minimalPrice = flightDetails.refund.minimalPrice;
      }
    };

    Refund.prototype.createGADataString = function () {
      var object = [
        this.fd.getDepDate(),
        this.fd.getRetDate(),
        this.fd.isOneWay() ? 'OW' : 'RT',
        this.fd.getCarriers(),
        '(' + this.fd.getOriginPort() + ')-(' + this.fd.getReturnPort() + ')',
        this.fd.getPaxCount(),
        this.totalPrice + this.price,
        this.price
      ];
      return object.join('|');
    };

    /**
     * @param {number} base
     * @param {number} totalPrice
     */
    Refund.prototype.updatePrice = function (base,totalPrice) {
      this.totalPrice = totalPrice;
      if (this.cost && base) {
        var basePrice = Math.round(base * this.cost * 100) / 100;
        this.price = Math.max(this.minimalPrice, basePrice);
      }
    };

    /**
     * @param {number} price
     */
    Refund.prototype.surchargeIfAdded = function (price) {
      if (!this.added) {
        return price;
      }

      return price + this.cost * price;
    };

    /**
     * @return {boolean}
     */
    Refund.prototype.serializeForBookingRequest = function () {
      return this.added;
    };

    /**
     * @type {Refund}
     */
    Refund.prototype.constructor = Refund;

    Refund.storagePrefix = 'REFUND_ADDED_';

    Refund.saveSelection = function (priceGroupId, toggle) {
      $localStorage[Refund.storagePrefix + priceGroupId] = toggle;
    };

    Refund.loadSelection = function (priceGroupId) {
      return $localStorage[Refund.storagePrefix + priceGroupId];
    };

    Refund.clearSelection = function (priceGroupId) {
      delete $localStorage[Refund.storagePrefix + priceGroupId];
    };

    return Refund;
  }

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/refunds/frola-refundable-logo.component.js
(function (angular) {
var IthFrolaRefundableLogoComponent = {
        template: '<ith-product-logo show-affiliate-name="true" image-name="refundable" name="{{ \'LANGM_JS_REFUNDABLE_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.Funnel.Refunds')
        .component('ithFrolaRefundableLogo', IthFrolaRefundableLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/refunds/refunds-box.component.js
(function (angular) {
/**
   * @name        ithRefundsBox
   * @description Refund box component.
   * @author      Rafał Podraza
   */
  var teplateUrlMethod = function ($attrs) {
    var link = '/tpl/show/jsShared/templates/funnel/refunds/';
    return $attrs.template ? link + $attrs.template : link + 'box';
  };

  teplateUrlMethod.$inject = [
    '$attrs'
  ];

  angular.module('ITH.Funnel.Refunds').component('ithRefundsBox', {
    templateUrl: teplateUrlMethod,
    bindings: {
      refund: '<',
    },
    controller: 'RefundsController'
  });

})(angular);;

// Source: ../shared/public_html/assets/js/funnel/refunds/refunds-box.controller.js
(function (angular) {
/**
   * @name        RefundsController
   * @description Box with Refund offer.
   * @author      Rafał Podraza
   */
  var RefundsController = function ($modal) {
    this.openHowItWorksModal = function () {
      $modal.open({
        templateUrl: '/tpl/show/jsShared/templates/funnel/refunds/howItWorksModal',
        windowClass: 'mobile-modal--fullscreen'
      });
    };
  };

  RefundsController.$inject = [
    '$modal',
  ];

  angular
    .module('ITH.Funnel.Refunds')
    .controller('RefundsController', RefundsController);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/refunds/refunds.service.js
(function (angular) {
angular.module('ITH.Funnel.Refunds').factory('Refunds', factory);

    factory.$inject = ['appConfig', 'Refund'];

    function factory(appConfig, Refund) {

        var config = appConfig.getRefundsConfig();

        return {
            config: config,
            make: function () {
                return new Refund();
            }
        };
    }

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/fallback-item.component.js
(function(angular) {
var controller = function (FallbackTypesHelper) {
        this.helper = FallbackTypesHelper;

        this.clickHandler = function () {
            if (this.model === this.value) {
                this.model = null;
            } else {
                this.model = this.value;
            }
        }
    };

    controller.$inject = ['FallbackTypesHelper'];

    var template = '\
        <label ng-click="$ctrl.clickHandler()" class="ith-seat-fallback-option" ng-class="{ \'ith-seat-fallback-option--selected\': $ctrl.isSelected }">\
            <div class="ith-seat-fallback-option__info">\
                <img ng-src="{{ \'/assets/img/ui/icons/seats/\' + $ctrl.helper.getIconName($ctrl.value) + \'.svg\' }}" />\
                <span>{{ $ctrl.helper.getTranslation($ctrl.value) }}</span>\
            </div>\
            <div class="ith-seat-fallback-option__right">\
                <p class="ith-seat-fallback-option__price">{{ $ctrl.price | flPrice:2 }}</p>\
                <p class="ith-seat-fallback-option__per-passenger" translate>\
                    LANGM_JS_SEATS_PER_PASSENGER\
                </p>\
            </div>\
        </label>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatSelectFallbackItem', {
        bindings: {
            isSelected: '<',
            value: '<',
            price: '<',
            model: '='
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/popup-footer.component.js
(function(angular) {
var controller = function ($scope, SeatHelper, SeatPricingHelper, ResponsiveTooltipService) {
        this.$onInit = function () {
            $scope.$on('closeSummary', this.closeIncompleteSeating);
            $scope.$on('infantWarning', this.openInfantSelectWarning);
        };

        this.seatHelper = SeatHelper;
        this.SeatPricingHelper = SeatPricingHelper;

        this.isPrevPossible = function () {
            return this.seatSelect.selections.currentSegmentIndex > 0;
        };

        this.prevSeatingClick = function () {
            if (this.seatSelect.selections.currentSegmentIndex === 0) {
                $scope.$emit('close');

                return;
            }

            this.seatSelect.selections.currentSegmentIndex--;

            if (this.seatSelect.selections.currentSegmentIndex < 0) {
                this.seatSelect.selections.currentSegmentIndex = 0;
            }

            $scope.$emit('segmentChange');
        };

        this.isLastSegment = function () {
            return SeatHelper.isLastSegment(this.seatSelect);
        };

        this.nextSeatingClick = function () {
            var isCurrentSegmentIncomplete = SeatHelper.notAllPaxesHaveSeatsInCurrentSegment(this.seatSelect) && !this.isLastSegment();
            var isAnySegmentIncomplete = SeatHelper.notAllPaxesHaveSeatsInAnySegment(this.seatSelect) && this.isLastSegment();

            if ((isCurrentSegmentIncomplete || isAnySegmentIncomplete) && this.isLastSegment()) {
                this.openIncompleteSeating();
                return;
            }

            this.goToNextSeating();
        };

        this.goToNextSeating = function () {
            if (SeatHelper.shouldShowInfantSelectWarning(this.seatSelect)) {
                this.openInfantSelectWarning();
                return;
            }

            if (this.isLastSegment()) {
                $scope.$emit('finish');
                return;
            }

            this.seatSelect.selections.currentSegmentIndex++;

            if (this.seatSelect.selections.currentSegmentIndex > this.seatSelect.getSegments().length - 1) {
                this.opened = false;
            }

            $scope.$emit('segmentChange');
        };

        this.openSummary = function () {
            $scope.$emit('openSummary');
        };

        this.openIncompleteSeating = function () {
            ResponsiveTooltipService.open('incomplete');
        };

        this.closeIncompleteSeating = function () {
            ResponsiveTooltipService.close('incomplete');
        };

        this.openInfantSelectWarning = function () {
            ResponsiveTooltipService.open('infant');
        };

        this.closeInfantSelectWarning = function () {
            ResponsiveTooltipService.close('infant');
        };

        this.getRandomSeatPaxes = function () {
            return this.seatHelper.getRandomSeatPaxes(this.seatSelect);
        };

        this.getRandomSeatPaxByIndex = function (index) {
            return this.getRandomSeatPaxes()[index];
        };

        this.getPaxFullName = function (pax) {
            return this.seatHelper.getPaxFullName(pax, this.seatSelect.getPaxes());
        };
    };

    controller.$inject = ['$scope', 'SeatHelper', 'SeatPricingHelper', 'ResponsiveTooltipService'];

    var template = '\
        <div>\
            <ith-responsive-tooltip id="incomplete" title="{{ \'LANGM_JS_SEATS_INCOMPLETE_TITLE\' | translate }}" show-close-button="false">\
                <content>\
                    <p class="alert alert-warning" ng-if="!$ctrl.isLastSegment() && $ctrl.getRandomSeatPaxes().length === 1" ng-bind-html="\'LANGM_JS_SEATS_INCOMPLETE_SINGLE_DESC\' | translate:{ name: $ctrl.getPaxFullName($ctrl.getRandomSeatPaxByIndex(0)) }"></p>\
                    <div class="alert alert-warning" ng-if="!$ctrl.isLastSegment() && $ctrl.getRandomSeatPaxes().length > 1">\
                        <p ng-bind-html="\'LANGM_JS_SEATS_INCOMPLETE_MULTI_DESC\' | translate"></p>\
                        <ul>\
                            <li ng-repeat="pax in $ctrl.getRandomSeatPaxes() track by pax.seats.uuid"><strong>{{ $ctrl.getPaxFullName(pax) }}</strong></li>\
                        </ul>\
                    </div>\
                    <div ng-if="$ctrl.isLastSegment()">\
                        <p class="alert alert-warning" ng-bind-html="\'LANGM_JS_SEATS_INCOMPLETE_OVERALL_DESC\' | translate"></p>\
                        <ith-seat-select-popup-summary\
                            seat-select="$ctrl.seatSelect">\
                        </ith-seat-select-popup-summary>\
                    </div>\
                </content>\
                <footer>\
                    <button ng-click="$ctrl.goToNextSeating(); $ctrl.closeIncompleteSeating()" class="btn btn-block btn-lg btn-outline">{{ \'LANGM_JS_SEATS_INCOMPLETE_CONTINUE\' | translate }}</button>\
                    <button ng-click="$ctrl.closeIncompleteSeating()" class="btn btn-block btn-lg btn-primary">{{ \'LANGM_JS_SEATS_INCOMPLETE_BACK\' | translate }}</button>\
                </footer>\
            </ith-responsive-tooltip>\
            <ith-responsive-tooltip id="infant" title="{{ \'LANGM_JS_SEATS_INCOMPLETE_INFANT\' | translate }}" show-close-button="false">\
                <content>\
                    <p class="alert alert-warning" ng-bind-html="\'LANGM_JS_SEATS_INCOMPLETE_INFANT_DESC\' | translate"></p>\
                    <footer>\
                        <button ng-click="$ctrl.closeInfantSelectWarning()" class="btn btn-block btn-lg btn-primary">{{ \'LANGM_JS_SEATS_INCOMPLETE_BACK\' | translate }}</button>\
                    </footer>\
                </content>\
            </ith-responsive-tooltip>\
            <div class="next">\
                <div>\
                    <button class="btn btn-outline" ng-click="$ctrl.prevSeatingClick()" translate>LANGM_JS_BACK</button>\
                </div>\
                <div class="next__price" ng-click="$ctrl.openSummary()">\
                    <strong>{{ $ctrl.SeatPricingHelper.getTotalPrice($ctrl.seatSelect) | flPrice:2 }}</strong>\
                    <button>?</button>\
                </div>\
                <div class="text-right">\
                    <button class="btn btn-primary" ng-click="$ctrl.nextSeatingClick()">{{ $ctrl.isLastSegment() ? (\'LANGM_JS_FINISH\' | translate) : (\'LANGM_JS_CONTINUE\' | translate) }}</button>\
                </div>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatSelectPopupFooter', {
        bindings: {
            seatSelect: '<',
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/popup-header.component.js
(function(angular) {
var controller = function ($scope, SeatHelper) {
        this.SeatHelper = SeatHelper;

        this.close = function () {
            $scope.$emit('close');
        };
    };

    controller.$inject = ['$scope', 'SeatHelper'];

    var template = '\
        <div class="selectors">\
            <div class="selectors__flight">\
                <img ng-src="/assets/img/uploaded/airlines/logos/{{ $ctrl.seatSelect.getCurrentSegment().marketingCarrier }}.png" />\
                <div>\
                    <small class="text-muted">{{ \'LANGM_JS_SEATS_POPUP_SEATING_COUNT\' | translate:{ current: $ctrl.seatSelect.selections.getCurrentSegmentCount(), total: $ctrl.seatSelect.selections.getTotalSegmentCount() } }}</small><br>\
                    <strong>{{ $ctrl.SeatHelper.getSegmentDepartureCity($ctrl.seatSelect.getCurrentSegment()) }} &rarr; {{ $ctrl.SeatHelper.getSegmentArrivalCity($ctrl.seatSelect.getCurrentSegment()) }}</strong>\
                </div>\
            </div>\
            <ith-close-button ng-click="$ctrl.close()"></ith-close-button>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatSelectPopupHeader', {
        bindings: {
            seatSelect: '<'
        },
        controller: controller,
        template: template
    });

}(angular));

;

// Source: ../shared/public_html/assets/js/funnel/seats/components/popup-summary.component.js
(function(angular) {
var controller = function ($scope, $filter, FallbackTypesHelper, SeatHelper, SeatPricingHelper, ResponsiveTooltipService) {
        this.seatHelper = SeatHelper;
        this.FallbackTypesHelper = FallbackTypesHelper;
        this.SeatPricingHelper = SeatPricingHelper;

        this.switchSeatingByIndex = function (index) {
            if (index === this.seatSelect.selections.currentSegmentIndex) {
                $scope.$emit('closeSummary');
                return;
            }

            if (SeatHelper.shouldShowInfantSelectWarning(this.seatSelect)) {
                $scope.$emit('closeSummary');
                ResponsiveTooltipService.open('infant');
                return;
            }

            this.seatSelect.selections.currentSegmentIndex = index;
            $scope.$emit('segmentChange');
            $scope.$emit('closeSummary');
        };

        this.getSelectionDescription = function (segmentId, passengerId) {
            var selection = this.seatSelect.selections.getSelection(segmentId, passengerId);

            if (selection === null) {
                return $filter('translate')('LANGM_JS_SEATS_SEATING_RANDOM');
            }

            if (!this.seatSelect.selections.isFallbackSegment(segmentId)) {
                return SeatHelper.getSelectionDescription(this.seatSelect, segmentId, passengerId);
            }

            return FallbackTypesHelper.getTranslation(selection);
        };

        this.getPaxFullName = function (pax) {
            return SeatHelper.getPaxFullName(pax, this.seatSelect.getPaxes());
        };

        this.getClassMap = function (index, last, segmentId) {
            return {
                past: this.seatSelect.selections.currentSegmentIndex > index,
                active: this.seatSelect.selections.currentSegmentIndex === index,
                future: this.seatSelect.selections.currentSegmentIndex < index,
                last: last,
                incomplete: SeatHelper.hasSegmentRandomSeating(this.seatSelect, segmentId)
            };
        };

        this.showExclamation = function (segment, passenger) {
            return (
                this.seatHelper.hasPaxRandomSeating(this.seatSelect, segment.id, passenger.seats.uuid) &&
                (
                    segment.hasSeatmap() ||
                    segment.hasFallbackOptions()
                )
            );
        };
    };

    controller.$inject = ['$scope', '$filter', 'FallbackTypesHelper', 'SeatHelper', 'SeatPricingHelper', 'ResponsiveTooltipService'];

    var template = '\
        <div class="seat-select__summary">\
            <div ng-repeat="segment in $ctrl.seatSelect.getSegments()" class="seat-select__summary__segment" ng-class="$ctrl.getClassMap($index, $last, segment.id)">\
                <span class="indicator">\
                    <span class="bubble"></span>\
                </span>\
                <div class="data">\
                    <h5 class="route">\
                        <span>\
                            {{ $ctrl.seatHelper.getSegmentDepartureCity(segment) }} - {{ $ctrl.seatHelper.getSegmentArrivalCity(segment) }}\
                        </span>\
                    </h5>\
                    <div ng-repeat="passenger in $ctrl.seatSelect.getPaxes() track by passenger.seats.uuid" class="seat-select__summary__pax">\
                        <span class="name">{{ $ctrl.getPaxFullName(passenger) }}</span>\
                        <span class="selection">\
                            <span class="exclamation" ng-if="$ctrl.showExclamation(segment, passenger)">!</span>\
                            <span>{{ $ctrl.getSelectionDescription(segment.id, passenger.seats.uuid) }}</span>\
                        </span>\
                        <strong class="price">{{ $ctrl.SeatPricingHelper.getSummaryPrice($ctrl.seatSelect, segment.id, passenger.seats.uuid) | flPrice:2 }}</strong>\
                    </div>\
                </div>\
            </div>\
            <h4 class="flex-split" style="margin-bottom: 0; margin-top: 0">\
                <span>{{ \'LANGM_JS_SEATS_TOTAL_PRICE\' | translate }}</span>\
                <span>{{ $ctrl.SeatPricingHelper.getTotalPrice($ctrl.seatSelect) | flPrice:2 }}</span>\
            </h4>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatSelectPopupSummary', {
        bindings: {
            seatSelect: '<'
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-legend-category.component.js
(function(angular) {
var controller = function (SeatTypesService) {
        this.SeatTypesService = SeatTypesService;

        this.getName = function () {
            if (this.isStaticType()) {
                return SeatTypesService.getName(this.category);
            }

            return SeatTypesService.getName(this.category.name);
        };

        this.getRank = function () {
            if (this.isStaticType()) {
                return SeatTypesService.getRank(this.category);
            }

            return SeatTypesService.getRank(this.category.name);
        };

        this.isStaticType = function () {
            return typeof this.category === 'string';
        };

        this.getContent = function () {
            if (this.getRank() === 'unavailable') {
                return '×';
            }

            return '';
        };

        this.isInfant = function () {
            return this.category === 'INFANT';
        };
    };

    controller.$inject = ['SeatTypesService'];

    var template = '\
        <div class="ith-seat-legend__category">\
            <div class="seat-color" ng-class="{ \'seat-color--rank-{{ $ctrl.getRank() }}\': true }">\
                <svg-icon ng-if="$ctrl.isInfant()" id="baby"></svg-icon>\
                <span ng-if="!$ctrl.isInfant()">{{ :: $ctrl.getContent() }}</span>\
            </div>\
            <div class="seat-desc">\
                <span class="seat-desc__name">{{ $ctrl.getName() }}</span>\
                <span ng-if="!$ctrl.isStaticType()"><span style="text-transform:lowercase;">{{ \'LANGM_JS_STARTING_FROM\' | translate }}</span> <strong class="seat-desc__price">{{ $ctrl.category.startPrice | flPrice:2 }}</strong></span>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatLegendCategory', {
        bindings: {
            category: '<',
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-legend.component.js
(function(angular) {
var controller = function () {
        this.extraCategs = ['UNAVAILABLE', 'INFANT', 'SELECTED'];

        this.isVisible = function (category) {
            if (category === 'INFANT' && this.infantCount === 0) {
                return false;
            }

            return true;
        };
    };

    var template = '\
        <div class="ith-seat-legend">\
            <h4 class="ith-seat-legend__title">{{ \'LANGM_JS_SEATS_LEGEND\' | translate }}</h4>\
            <ith-seat-legend-category\
                ng-repeat="category in $ctrl.seatCategories track by category.value"\
                category="category">\
            </ith-seat-legend-category>\
            <hr>\
            <ith-seat-legend-category\
                ng-repeat="category in $ctrl.extraCategs"\
                ng-if="$ctrl.isVisible(category)"\
                category="category">\
            </ith-seat-legend-category>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatLegend', {
        bindings: {
            seatCategories: '<',
            infantCount: '<'
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-route-notification.component.js
(function(angular) {
var controller = function (SeatHelper) {
        this.SeatHelper = SeatHelper;
    };

    controller.$inject = ['SeatHelper'];

    var template = '\
        <div class="seat-route-notification angular-animate" ng-if="$ctrl.isVisible">\
            <div>\
                <ist-status-indicator size="32"></ist-status-indicator>\
                <span>{{ \'LANGM_JS_SEATS_POPUP_SEATING_COUNT\' | translate:{ current: $ctrl.currentSeatingCount, total: $ctrl.totalSeatingCount } }}</span>\
                <h2 class="seat-route-notification__title">{{ $ctrl.SeatHelper.getSegmentDepartureCity($ctrl.currentSegment) }} - {{ $ctrl.SeatHelper.getSegmentArrivalCity($ctrl.currentSegment) }}</h2>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatRouteNotification', {
        bindings: {
            currentSeatingCount: '<',
            totalSeatingCount: '<',
            currentSegment: '<',
            isVisible: '<'
        },
        template: template,
        controller: controller
    });

}(angular));

;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-select-popup.component.js
(function(angular) {
var controller = function ($scope, $rootScope, $timeout, SeatHelper, SeatPricingHelper, SeatsService, ModalHelper, ResponsiveTooltipService) {
        /**
         * Self reference
         */
        var self = this;

        /**
         * @type {SeatPricingHelper}
         */
        this.SeatPricingHelper = SeatPricingHelper;

        /**
         * @type {boolean}
         */
        this.routeChangedNotificationVisible = false;

        /**
         *
         */
        this.$onInit = function () {
            ModalHelper.lockBodyScroll();
            this.showNotification();
            this.seatSelect.selections.cacheSelections();

            // Set events
            $scope.$on('close', this.dismiss);
            $scope.$on('finish', this.finish);
            $scope.$on('segmentChange', this.postSegmentChange);
            $scope.$on('openSummary', this.openSummary);
            $scope.$on('closeSummary', this.closeSummary);
            $rootScope.$on('$stateChangeSuccess', this.close);
        };

        this.dismiss = function () {
            self.seatSelect.selections.revertSelections();
            self.close();
        };

        /**
         * Closes seat selection popup
         */
        this.close = function () {
            ModalHelper.unlockBodyScroll();
            self.opened = false;
        };

        /**
         * Adds seats to basket and closes the popup
         */
        this.finish = function () {
            self.close();

            SeatsService.addToBasket(
                self.seatSelect.booking.seatsInitialData.basketUuid,
                self.seatSelect.selections.serialize(
                    self.seatSelect.getPaxes()
                )
            );
        };

        /**
         * Displays the segment change notification then hides it after a while
         */
        this.showNotification = function () {
            this.routeChangedNotificationVisible = true;

            $timeout(function () {
                self.routeChangedNotificationVisible = false;
            }, 1000);
        };

        /**
         * Things to do after a segment is changed:
         * - show notification
         * - scroll seatmap up
         */
        this.postSegmentChange = function () {
            self.showNotification();
            document.querySelector('.ith-seat-select__popup').scrollTop = 0;
        };

        /**
         * Opens summary tooltip
         */
        this.openSummary = function () {
            ResponsiveTooltipService.open('summary');
        };

        /**
         * Closes summary tooltip
         */
        this.closeSummary = function () {
            ResponsiveTooltipService.close('summary');
        };

        this.getClassMap = function () {
            return {
                'ith-seat-select__popup--wide': SeatHelper.isSeatmapVeryWide(
                    this.seatSelect.getCurrentSegment()
                )
            };
        };
    };

    controller.$inject = ['$scope', '$rootScope', '$timeout', 'SeatHelper', 'SeatPricingHelper', 'SeatsService', 'ModalHelper', 'ResponsiveTooltipService'];

    var template = '\
        <div class="ith-seat-select__popup" ng-class="$ctrl.getClassMap()">\
            <ith-seat-select-popup-header\
                seat-select="$ctrl.seatSelect">\
            </ith-seat-select-popup-header>\
            <div class="ith-seat-select__popup__scroll-area">\
                <ith-seat-route-notification\
                    current-seating-count="$ctrl.seatSelect.selections.getCurrentSegmentCount()"\
                    total-seating-count="$ctrl.seatSelect.selections.getTotalSegmentCount()"\
                    current-segment="$ctrl.seatSelect.getCurrentSegment()"\
                    is-visible="$ctrl.routeChangedNotificationVisible">\
                </ith-seat-route-notification>\
                <ith-responsive-tooltip id="summary" title="{{ \'LANGM_JS_SEATS_SUMMARY_TITLE\' | translate }}">\
                    <content>\
                        <ith-seat-select-popup-summary\
                            seat-select="$ctrl.seatSelect">\
                        </ith-seat-select-popup-summary>\
                    </content>\
                </ith-responsive-tooltip>\
                <ith-seatmap\
                    ng-repeat="segment in $ctrl.seatSelect.getSegments()"\
                    ng-if="$ctrl.seatSelect.getCurrentSegment().id === segment.id"\
                    segment="segment"\
                    seat-select="$ctrl.seatSelect"\
                    segments="$ctrl.seatSelect.getSegments()"\
                    current-segment-id="$ctrl.seatSelect.getCurrentSegment().id"\
                    passengers="$ctrl.seatSelect.getPaxes()"\
                    is-infant-present="$ctrl.seatSelect.infantCount"\
                    passenger-selections="$ctrl.seatSelect.selections">\
                </ith-seatmap>\
            </div>\
            <ith-seat-select-popup-footer\
                seat-select="$ctrl.seatSelect">\
            </ith-seat-select-popup-footer>\
        </div>\
    ';

    angular
        .module('ITH.Funnel.Seats')
        .component('ithSeatSelectPopup', {
            bindings: {
                seatSelect: '<',
                opened: '='
            },
            controller: controller,
            template: template
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-select-summary.component.js
(function (angular) {
var controller = function ($filter, FallbackTypesHelper, SeatHelper, SeatPricingHelper) {
        this.seatHelper = SeatHelper;
        this.FallbackTypesHelper = FallbackTypesHelper;
        this.SeatPricingHelper = SeatPricingHelper;

        this.getSelectionDescription = function (segmentId, passengerId) {
            var selection = this.seatSelect.selections.getSelection(segmentId, passengerId);

            if (selection === null) {
                return $filter('translate')('LANGM_JS_SEATS_SEATING_RANDOM');
            }

            if (!this.seatSelect.selections.isFallbackSegment(segmentId)) {
                return selection;
            }

            return FallbackTypesHelper.getTranslation(selection);
        };

        this.isSegmsentVisible = function (segmentId) {
            return SeatHelper.hasSegmentAnySeating(this.seatSelect, segmentId);
        };

        this.isFallbackSegment = function (segmentId) {
            return this.seatSelect.selections.isFallbackSegment(segmentId);
        };

        this.getPaxesWithSeatSelections = function (segmentId) {
            var paxesWithSelections = [];
            var self = this;

            angular.forEach(
                this.seatSelect.getPaxes(),
                function (pax) {
                    if (SeatHelper.paxHasSelectedSeating(self.seatSelect, segmentId, pax.seats.uuid)) {
                        paxesWithSelections.push(pax);
                    }
                }
            );

            return paxesWithSelections;
        };
    };

    controller.$inject = ['$filter', 'FallbackTypesHelper', 'SeatHelper', 'SeatPricingHelper'];

    var template = '\
        <div class="seat-select__summary">\
            <h3>{{ \'LANGM_JS_SEATS_SUMMARY_TITLE\' | translate }}</h3>\
            <div ng-repeat="segment in $ctrl.seatSelect.getSegments()" class="flex-split" ng-show="$ctrl.isSegmsentVisible(segment.id)">\
                <span>{{ $ctrl.seatHelper.getSegmentDepartureCity(segment) }} - {{ $ctrl.seatHelper.getSegmentArrivalCity(segment) }}</span>\
                <span ng-if="!$ctrl.isFallbackSegment(segment.id)">\
                    <span ng-repeat="passenger in $ctrl.getPaxesWithSeatSelections(segment.id) track by passenger.seats.uuid">\
                    <strong>{{ $ctrl.getSelectionDescription(segment.id, passenger.seats.uuid) }}<span ng-show="!$last">,</span></strong>\
                    </span>\
                </span>\
                <strong ng-if="$ctrl.isFallbackSegment(segment.id)">{{ $ctrl.getSelectionDescription(segment.id, $ctrl.getPaxesWithSeatSelections(segment.id)[0].seats.uuid) }}</strong>\
            </div>\
            <hr />\
            <h6 class="flex-split" style="margin-bottom: 0; margin-top: 0">\
                <span>{{ \'LANGM_JS_SEATS_TOTAL_PRICE\' | translate }}</span>\
                <span>{{ $ctrl.SeatPricingHelper.getTotalPrice($ctrl.seatSelect) | flPrice:2 }}</span>\
            </h6>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatSelectSummary', {
        bindings: {
            seatSelect: '<'
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat-select.component.js
(function(angular) {
var controller = function ($filter, SeatsService, AnalyticsServiceHelper, ResponsiveTooltipService) {
        var self = this;
        var LOADING_MODAL_ID = 'seat-selection-loading';

        this.opened = false;
        this.populated = false;
        this.loaderModalOpen = false;

        this.selectSeats = function () {
            if (!this.populated) {
                this.requestSeats();
                this.getInitialData().initLoading();
                this.openLoader();
                return;
            }

            this.openWidget();
        };

        this.openWidget = function () {
            AnalyticsServiceHelper.sendSeatWidgetOpen(this.booking);
            this.booking.seatSelect.selections.currentSegmentIndex = 0;
            this.opened = true;
        };

        this.openLoader = function () {
            ResponsiveTooltipService.open(LOADING_MODAL_ID);
            this.loaderModalOpen = true;
        };

        this.closeLoader = function () {
            ResponsiveTooltipService.close(LOADING_MODAL_ID);
            this.loaderModalOpen = false;
        };

        this.getInitialData = function () {
            return this.booking.seatsInitialData;
        };

        this.isActionsZoneVisible = function () {
            return (
                !this.getInitialData().isChecking &&
                this.getInitialData().isAllowed
            );
        };

        this.hasSelections = function () {
            return this.booking.seatSelect.getTotalSelections() > 0;
        };

        this.getCtaLang = function () {
            return this.hasSelections() ? 'LANGM_JS_SEAT_SELECT_CHANGE' : 'LANGM_JS_SEAT_SELECT_CTA';
        };

        this.getInitialBoxTitleLang = function () {
            if (isMiddleSeatAvailable()) {
                return 'LANGM_JS_SEAT_SELECT_TITLE_MIDDLE_AVAILABLE';
            }

            return 'LANGM_JS_SEAT_SELECT_TITLE_DEFAULT';
        };

        this.getInitialBoxTextLang = function () {
            if (isMiddleSeatAvailable()) {
                return 'LANGM_JS_SEAT_SELECT_TEXT_MIDDLE_AVAILABLE';
            }

            return 'LANGM_JS_SEAT_SELECT_TEXT_DEFAULT';
        };

        this.getLowestPrice = function () {
            return $filter('flPrice')(this.getInitialData().lowestPrice, 2);
        };

        this.shouldShowPrice = function () {
            return this.getInitialData().lowestPrice > 0;
        };

        this.isCtaLoading = function () {
            return this.getInitialData().isLoading;
        };

        this.$onInit = function () {
            this.getInitialData().addCallback(onWsPopulate);
        };

        var onWsPopulate = function () {
            if (!self.getInitialData().isAllowed) {
                self.getInitialData().isLoading = false;
                return;
            }

            SeatsService
                .loadSeatmap(self.getInitialData().basketUuid)
                .then(function (success) {
                    self.getInitialData().isLoading = false;
                    self.booking.seatSelect.populate(success.data.body);
                    self.populated = true;

                    if (self.loaderModalOpen) {
                        self.closeLoader();
                        self.openWidget();
                    }
                });
        };

        var isMiddleSeatAvailable = function () {
            return self.getInitialData().isMiddleSeatAvailable;
        };
    };

    controller.$inject = ['$filter', 'SeatsService', 'AnalyticsServiceHelper', 'ResponsiveTooltipService'];

    angular
        .module('ITH.Funnel.Seats')
        .component('ithSeatSelect', {
            templateUrl: '/tpl/show/jsShared/templates/funnel/seats/select',
            controller: controller,
            bindings: {
                booking: '<',
                requestSeats: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seat.component.js
(function(angular) {
var controller = function ($scope, SeatTypesService, SeatHelper, ResponsiveTooltipService) {
        var self = this;

        this.isSelectedByAny = function () {
            return SeatHelper.isSeatSelectedByAny(this.seatSelect, this.currentSegmentId, this.seat.id);
        };

        this.paxHasSelection = function (paxId) {
            return SeatHelper.paxHasSelectedSeating(this.seatSelect, this.currentSegmentId, paxId);
        };

        this.getPaxSeatIdentifier = function (paxId) {
            if (this.paxHasSelection(paxId)) {
                return SeatHelper.getSelectionDescription(this.seatSelect, this.currentSegmentId, paxId);
            }

            return '';
        };

        this.openAssign = function () {
            ResponsiveTooltipService.open(this.seat.id);
        };

        this.closeAssign = function () {
            ResponsiveTooltipService.close(this.seat.id);
        };

        this.select = function () {
            if (this.isSeatUnavailable()) {
                return;
            }

            if (this.isSelectedByAny()) {
                angular.forEach(
                    Object.keys(this.passengerSelections.seats[this.currentSegmentId]),
                    function (paxId) {
                        if (self.passengerSelections.seats[self.currentSegmentId][paxId] === self.seat.id) {
                            self.passengerSelections.seats[self.currentSegmentId][paxId] = null;
                        }
                    }
                );

                return;
            }

            if (this.passengers.length === 1) {
                this.passengerSelections.seats[this.currentSegmentId][this.passengers[0].seats.uuid] = this.seat.id;
                return;
            }

            this.openAssign();
        };

        this.selectSeat = function (passenger) {
            if (!this.isPaxAllowed(passenger)) {
                return;
            }

            $scope.$evalAsync(function () {
                self.passengerSelections.seats[self.currentSegmentId][passenger.seats.uuid] = self.seat.id;
                self.closeAssign();
            });
        };

        this.getSeatType = function () {
            return SeatTypesService.getName(this.seat.seatCategory);
        };

        this.isSeatOfRank = function (number) {
            if (this.seat.available === false) {
                return false;
            }

            if (this.seat.seatCategory === null) {
                return false;
            }

            return SeatTypesService.getRank(this.seat.seatCategory) === number;
        };

        this.getSeatIdentifier = function () {
            if (this.seat.hollow) {
                return '';
            }

            if (this.isSelectedByAny()) {
                var paxId = SeatHelper.getPaxIdBySeatId(this.seatSelect, this.currentSegmentId, this.seat.id);
                var pax = SeatHelper.getPaxByPaxId(this.seatSelect, paxId);

                if (pax !== null) {
                    return SeatHelper.getPaxInitials(pax, this.seatSelect.getPaxes());
                }
            }

            return this.seat.row + '' + this.seat.column;
        };

        this.getPaxFullName = function (pax) {
            return SeatHelper.getPaxFullName(pax, this.seatSelect.getPaxes());
        };

        this.isPaxAllowed = function (pax) {
            var childNotAllowed = pax.person.paxType === 'CHD' && !this.seat.childAllowed;
            var infantNotAllowed = pax.person.paxType === 'INF' && !this.seat.infantAllowed;
            var youthNotAllowedOnEmergencyExitSeat = pax.person.paxType === 'YTH' && this.seat.emergencyExit;

            if (childNotAllowed || infantNotAllowed || youthNotAllowedOnEmergencyExitSeat) {
                return false;
            }

            return true;
        };

        this.isSeatUnavailable = function () {
            return (
                this.seat.available === false ||
                (
                    this.passengers.length === 1 &&
                    !this.isPaxAllowed(this.passengers[0])
                ) ||
                (
                    this.seatSelect.infantCount === this.seatSelect.adultCount &&
                    this.seatSelect.childCount === 0 &&
                    this.seatSelect.youthCount === 0 &&
                    this.seat.infantAllowed === false
                )
            );
        };

        this.isInfantMarking = function () {
            // Mark infant seat visually only when infants are less than adults
            return (
                this.seat.available &&
                this.seat.infantAllowed &&
                this.seatSelect.infantCount > 0
            );
        };

        this.getClassMap = function () {
            return {
                'ith-seat__button': true,
                'seat-color--rank-unavailable': this.isSeatUnavailable(),
                'seat-color--rank-hollow': this.seat.hollow === true,
                'seat-color--rank-0': this.isSeatOfRank('0'),
                'seat-color--rank-1': this.isSeatOfRank('1'),
                'seat-color--rank-2': this.isSeatOfRank('2'),
                'seat-color--selected': this.isSelectedByAny(),
                'seat-mark--infant': this.isInfantMarking()
            };
        };
    };

    controller.$inject = ['$scope', 'SeatTypesService', 'SeatHelper', 'ResponsiveTooltipService'];

    var template = '\
        <div class="ith-seat">\
            <div ng-class="$ctrl.getClassMap()" ng-click="$ctrl.select()">\
                <svg-icon ng-show="$ctrl.isInfantMarking()" id="baby"></svg-icon>\
                {{ $ctrl.getSeatIdentifier() }}\
            </div>\
            <div class="ith-seat__price text-center text-muted">\
                <small ng-if="!$ctrl.isSeatUnavailable()">{{ :: $ctrl.seat.price.amount | flPrice:0 }}</small>\
            </div>\
            <ith-responsive-tooltip id="{{ $ctrl.seat.id }}" title="{{ \'LANGM_JS_SEAT_ASSIGN_TITLE\' | translate:{ identifier: $ctrl.getSeatIdentifier() } }}">\
                <content>\
                    <div class="seat-select__pax-assign">\
                        <p ng-bind-html="\'LANGM_JS_SEAT_ASSIGN_DESC\' | translate:{ identifier: $ctrl.getSeatIdentifier() }"></p>\
                        <p>&nbsp;</p>\
                        <div\
                            ng-repeat="passenger in $ctrl.passengers track by passenger.seats.uuid"\
                            ng-click="$ctrl.selectSeat(passenger)"\
                            class="seat-select__pax-assign__pax">\
                            <div class="name"><strong>{{ $ctrl.getPaxFullName(passenger) }}</strong> (<span>{{ \'LANGM_JS_\' + passenger.person.paxType | translate }}</span>)</div>\
                            <span class="selection">{{ $ctrl.getPaxSeatIdentifier(passenger.seats.uuid) }}</span>\
                            <span ng-if="!$ctrl.isPaxAllowed(passenger)">N/A</span>\
                            <button class="btn btn-outline btn-sm" ng-if="$ctrl.isPaxAllowed(passenger)">\
                                <span ng-if="$ctrl.paxHasSelection(passenger.seats.uuid)">{{ \'LANGM_JS_SEAT_ASSIGN_CHANGE\' | translate }}</span>\
                                <span ng-if="!$ctrl.paxHasSelection(passenger.seats.uuid)">{{ \'LANGM_JS_SEAT_ASSIGN_SELECT\' | translate }}</span>\
                            </button>\
                        </div>\
                    </div>\
                </content>\
            </ith-responsive-tooltip>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeat', {
        bindings: {
            seat: '<',
            seatSelection: '<',
            passengerSelections: '<',
            currentSegmentId: '<',
            passengers: '<',
            seatCategories: '<',
            seatSelect: '<'
        },
        controller: controller,
        template: template
    });

}(angular));

;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seatmap-columns.component.js
(function(angular) {
var template = '\
        <div class="ith-seatmap-row ith-seatmap-row--header">\
            <div ng-repeat="column in $ctrl.definition track by $index" class="ith-seatmap-row__column">\
                <span ng-if="column !== null">{{ column }}</span>\
                <span ng-if="column === null">&nbsp;</div>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatmapColumns', {
        bindings: {
            definition: '<'
        },
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seatmap-row.component.js
(function(angular) {
var controller = function () {
        this.getClassMap = function (seat) {
            return {
                'ith-seatmap-row__column': true,
                'ith-seatmap-row__column--aisle': seat === null
            };
        };
    };

    var template = '\
        <div>\
            <div class="ith-seatmap-row ith-seatmap-row--emergency" ng-if="$ctrl.row.emergencyExit">\
                <span>EXIT</span>\
                <span>EXIT</span>\
            </div>\
            <div class="ith-seatmap-row">\
                <div ng-repeat="seat in $ctrl.row.seats track by $index" ng-class="$ctrl.getClassMap(seat)">\
                    <ith-seat\
                        ng-if="seat !== null"\
                        seat="seat"\
                        seat-select="$ctrl.seatSelect"\
                        passenger-selections="$ctrl.passengerSelections"\
                        current-segment-id="$ctrl.currentSegmentId"\
                        passengers="$ctrl.passengers"\
                        seat-categories="$ctrl.seatCategories">\
                    </ith-seat>\
                    <div class="ith-seatmap-row__number" ng-if="seat === null">{{ $ctrl.row.number }}</div>\
                </div>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatmapRow', {
        bindings: {
            row: '<',
            currentSegmentId: '<',
            passengers: '<',
            passengerSelections: '<',
            seatCategories: '<',
            seatSelect: '<'
        },
        controller: controller,
        template: template
    });

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seatmap.component.js
(function(angular) {
var controller = function (SeatHelper) {
        this.getClassMap = function () {
            return {
                'ith-seatmap--hidden': this.currentSegmentId !== this.segment.id,
                'ith-seatmap--wide': SeatHelper.isSeatmapVeryWide(this.segment)
            };
        };
    };

    controller.$inject = ['SeatHelper'];

    var template = '\
        <div class="ith-seatmap" ng-class="$ctrl.getClassMap()">\
            <div class="ith-seatmap__wrapper box-shadow" ng-if="$ctrl.segment.hasSeatmap()">\
                <ith-seat-legend\
                    ng-if="$ctrl.segment.hasSeatmap()"\
                    seat-categories="$ctrl.segment.seatmap.categories"\
                    infant-count="$ctrl.seatSelect.infantCount">\
                </ith-seat-legend>\
                <div class="ith-seatmap__wrapper__overscroll">\
                    <ith-seatmap-columns\
                        definition="$ctrl.segment.seatmap.decks[0].header">\
                    </ith-seatmap-columns>\
                    <ith-seatmap-row\
                        ng-repeat="row in $ctrl.segment.seatmap.decks[0].rows"\
                        row="row"\
                        seat-select="$ctrl.seatSelect"\
                        current-segment-id="$ctrl.currentSegmentId"\
                        passengers="$ctrl.passengers"\
                        passenger-selections="$ctrl.passengerSelections"\
                        seat-categories="$ctrl.segment.seatmap.categories">\
                    </ith-seatmap-row>\
                    <ith-seatmap-columns\
                        definition="$ctrl.segment.seatmap.decks[0].header">\
                    </ith-seatmap-columns>\
                </div>\
            </div>\
            <div class="ith-fallback__wrapper" ng-if="!$ctrl.segment.hasSeatmap() && $ctrl.segment.hasFallbackOptions()">\
                <h3 ng-if="$ctrl.passengers.length < 2" class="ith-fallback__wrapper-title">{{ \'LANGM_JS_SEATMAP_UNAVAILABLE_TITLE\' | translate }}</h3>\
                <h3 ng-if="$ctrl.passengers.length > 1" class="ith-fallback__wrapper-title">{{ \'LANGM_JS_SEATMAP_UNAVAILABLE_TITLE_2_PAX\' | translate }}</h3>\
                <p ng-if="$ctrl.passengers.length < 2" class="ith-fallback__wrapper-description" ng-bind-html="\'LANGM_JS_SEATMAP_UNAVAILABLE_TEXT\' | translate:{ dep: $ctrl.segment.departureAirport, arr: $ctrl.segment.arrivalAirport }"></p>\
                <p ng-if="$ctrl.passengers.length > 1" class="ith-fallback__wrapper-description" ng-bind-html="\'LANGM_JS_SEATMAP_UNAVAILABLE_TEXT_2_PAX\' | translate:{ dep: $ctrl.segment.departureAirport, arr: $ctrl.segment.arrivalAirport }"></p>\
                <p ng-if="$ctrl.isInfantPresent" class="ith-fallback__wrapper-description" translate>LANGM_JS_SEATS_INFANT_IS_FREE</p>\
                <ith-seat-select-fallback-item\
                    ng-repeat="option in $ctrl.segment.fallbackOptions"\
                    is-selected="$ctrl.passengerSelections.options[$ctrl.segment.id] === option.type"\
                    value="option.type"\
                    price="option.price.amount"\
                    model="$ctrl.passengerSelections.options[$ctrl.segment.id]">\
                </ith-seat-select-fallback-item>\
            </div>\
            <div class="ith-fallback__wrapper" ng-if="!$ctrl.segment.hasSeatmap() && !$ctrl.segment.hasFallbackOptions()">\
                <h3>{{ \'LANGM_JS_SEATMAP_UNSELECTABLE_TITLE\' | translate }}</h3>\
                <p ng-bind-html="\'LANGM_JS_SEATMAP_UNSELECTABLE_TEXT\' | translate:{ dep: $ctrl.segment.departureAirport, arr: $ctrl.segment.arrivalAirport }"></p>\
            </div>\
        </div>\
    ';

    angular.module('ITH.Funnel.Seats').component('ithSeatmap', {
        bindings: {
            segment: '<',
            segments: '<',
            currentSegmentId: '<',
            passengers: '<',
            passengerSelections: '<',
            seatSelect: '<',
            isInfantPresent: '<'
        },
        controller: controller,
        template: template
    });

}(angular));

;

// Source: ../shared/public_html/assets/js/funnel/seats/components/seats-logo.component.js
(function (angular) {
var IthFrolaSeatsLogoComponent = {
        template: '<ith-product-logo image-name="seats" show-affiliate-name="false" name="{{ \'LANGM_JS_SEATS_NAME\' | translate }}"></ith-product-logo>'
    };

    angular
        .module('ITH.Funnel.Seats')
        .component('ithFrolaSeatsLogo', IthFrolaSeatsLogoComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-deck.factory.js
(function(angular) {
var SeatSelectDeckFactory = function (SeatSelectRow) {
        /**
         * Constructor
         */
        var SeatSelectDeck = function (data) {
            this.config = data.config || null;
            this.rows = [];
            this.header = [];

            for (var i = 0; i < this.config.length; i++) {
                this.rows.push(new SeatSelectRow(
                    this.config.width,
                    this.config.startSeatRow + i
                ));
            }

            var seatsArray = data.seats;

            for (var j = 0; j < seatsArray.length; j++) {
                var seatData = seatsArray[j];
                if (this.rows.hasOwnProperty(seatData.coordinates.x)) {
                    this.rows[seatData.coordinates.x].addSeat(seatData);
                }
            }

            var firstRow = this.rows[1].seats;
            for (var k = 0; k < firstRow.length; k++) {
                this.header.push(
                    firstRow[k] === null ? null : firstRow[k].column
                );
            }

            // Readjust seats
            for (i = 0; i < this.rows.length; i++) {
                var row = this.rows[i];
                for (j = 0; j < row.seats.length; j++) {
                    var seat = row.seats[j];

                    if (seat === null && this.header[j] !== null) {
                        row.addSeat({
                            coordinates: { y: j },
                            column: this.header[j],
                            hollow: true
                        });
                    }
                }
            }
        };

        SeatSelectDeck.prototype.constructor = SeatSelectDeck;

        SeatSelectDeck.prototype.getSeatById = function (seatId) {
            var foundSeat = null;

            for (var i = 0; i < this.rows.length; i++) {
                var row = this.rows[i];

                if (row.getSeatById(seatId) !== null) {
                    foundSeat = row.getSeatById(seatId);
                }
            }

            return foundSeat;
        };

        return SeatSelectDeck;
    };

    SeatSelectDeckFactory.$inject = [
        'SeatSelectRow'
    ];

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectDeck', SeatSelectDeckFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-fallback.factory.js
(function (angular) {
var SeatSelectFallbackFactory = function () {
        /**
         * Constructor
         */
        var SeatSelectFallback = function (data) {
            this.price = data.price;
            this.type = data.type;
        };

        SeatSelectFallback.prototype.constructor = SeatSelectFallback;

        return SeatSelectFallback;
    };

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectFallback', SeatSelectFallbackFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-row.factory.js
(function (angular) {
var SeatSelectRowFactory = function (SeatSelectSeat) {
        /**
         * Constructor
         */
        var SeatSelectRow = function (width, number) {
            this.number = number;
            this.seats = [];
            this.emergencyExit = false;

            for (var i = 0; i < width; i++) {
                this.seats[i] = null;
            }
        };

        /**
         *
         */
        SeatSelectRow.prototype.addSeat = function (seatData) {
            var newSeatInstance = new SeatSelectSeat(seatData);
            this.seats[seatData.coordinates.y] = newSeatInstance;

            if (seatData.row) {
                this.number = parseInt(seatData.row);
            }

            if (newSeatInstance.emergencyExit) {
                this.emergencyExit = true;
            }
        };

        SeatSelectRow.prototype.constructor = SeatSelectRow;

        SeatSelectRow.prototype.getSeatById = function (seatId) {
            var foundSeat = null;

            for (var i = 0; i < this.seats.length; i++) {
                var seat = this.seats[i];

                if (seat !== null && seat.id === seatId) {
                    foundSeat = seat;
                }
            }

            return foundSeat;
        };

        return SeatSelectRow;
    };

    SeatSelectRowFactory.$inject = ['SeatSelectSeat'];

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectRow', SeatSelectRowFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-seat.factory.js
(function(angular) {
var SeatSelectSeatFactory = function () {
        /**
         * Constructor
         */
        var SeatSelectSeat = function (data) {
            this.id = data.designator;

            this.aisle = data.attrAisle || false;
            this.childAllowed = data.attrChildAllowed || false;
            this.emergencyExit = data.attrEmergencyExit || false;
            this.extraLeg = data.attrExtraLeg || false;
            this.fastExit = data.attrFastExit || false;
            this.infantAllowed = data.attrInfantAllowed || false;
            this.priorityBoarding = data.attrPriorityBoarding || false;
            this.window = data.attrWindow || false;

            this.available = data.available || false;
            this.hollow = data.hollow || false;
            this.column = data.column;
            this.row = data.row;
            this.price = data.price || { amount: 0, currency: '' };
            this.seatCategory = data.seatCategory;
        };

        SeatSelectSeat.prototype.constructor = SeatSelectSeat;

        return SeatSelectSeat;
    };

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectSeat', SeatSelectSeatFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-seatmap-category.factory.js
(function(angular) {
var SeatSelectSeatmapCategoryFactory = function () {
        /**
         * @constructor
         * @param {*} data
         */
        var SeatSelectSeatmapCategory = function (data) {
            this.name = data.category;
            this.value = data.category;
            this.startPrice = data.startPrice.amount;
            this.endPrice = data.endPrice.amount;
        };

        SeatSelectSeatmapCategory.prototype.constructor = SeatSelectSeatmapCategory;

        return SeatSelectSeatmapCategory;
    };

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectSeatmapCategory', SeatSelectSeatmapCategoryFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-seatmap.factory.js
(function (angular) {
var SeatSelectSeatmapFactory = function (SeatSelectDeck, SeatSelectSeatmapCategory) {
        /**
         * Constructor
         */
        var SeatSelectSeatmap = function (data) {
            this.decks = [];
            this.categories = [];
            this.lowestPrice = Infinity;

            for (var i = 0; i < data.decks.length; i++) {
                this.decks.push(new SeatSelectDeck(
                    data.decks[i]
                ));
            }

            for (i = 0; i < data.seatCategories.length; i++) {
                this.categories.push(new SeatSelectSeatmapCategory(
                    data.seatCategories[i]
                ));
            }
        };

        SeatSelectSeatmap.prototype.constructor = SeatSelectSeatmap;

        return SeatSelectSeatmap;
    };

    SeatSelectSeatmapFactory.$inject = [
        'SeatSelectDeck',
        'SeatSelectSeatmapCategory'
    ];

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectSeatmap', SeatSelectSeatmapFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select-segment.factory.js
(function(angular) {
var SeatSelectSegmentFactory = function (SeatSelectSeatmap, SeatSelectFallback) {
        /**
         * @constructor
         */
        var SeatSelectSegment = function (data) {
            this.departure = data.departure;
            this.arrival = data.arrival;
            this.departureAirport = data.departureAirport;
            this.arrivalAirport = data.arrivalAirport;
            this.id = data.segmentUuid;
            this.providerId = data.providerId;
            this.provider = data.provider;
            this.marketingCarrier = data.marketingCarrier;
            this.operatingCarrier = data.operatingCarrier;

            this.seatmap = null;
            this.fallbackOptions = [];

            if (data.hasOwnProperty('seatMap')) {
                this.seatmap = new SeatSelectSeatmap(data.seatMap);
            }

            if (data.hasOwnProperty('fallbackOptions')) {
                this.populateFallback(data.fallbackOptions);
            }
        };

        SeatSelectSegment.prototype.constructor = SeatSelectSegment;

        SeatSelectSegment.prototype.hasSeatmap = function () {
            return this.seatmap !== null;
        };

        SeatSelectSegment.prototype.hasFallbackOptions = function () {
            return this.fallbackOptions.length > 0;
        };

        SeatSelectSegment.prototype.populateFallback = function (fallbackOptions) {
            for (var i = 0; i < fallbackOptions.length; i++) {
                this.fallbackOptions.push(new SeatSelectFallback(
                    fallbackOptions[i]
                ));
            }
        };

        SeatSelectSegment.prototype.getSeatById = function (seatId) {
            var foundSeat = null;

            if (!this.hasSeatmap()) {
                return null;
            }

            for (var i = 0; i < this.seatmap.decks.length; i++) {
                var deck = this.seatmap.decks[i];

                if (deck.getSeatById(seatId) !== null) {
                    foundSeat = deck.getSeatById(seatId);
                }
            }

            return foundSeat;
        };

        SeatSelectSegment.prototype.getOptionByValue = function (value) {
            var foundOption = null;

            for (var i = 0; i < this.fallbackOptions.length; i++) {
                if (this.fallbackOptions[i].type === value) {
                    foundOption = this.fallbackOptions[i];
                }
            }

            return foundOption;
        };

        return SeatSelectSegment;
    };

    SeatSelectSegmentFactory.$inject = [
        'SeatSelectSeatmap',
        'SeatSelectFallback'
    ];

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelectSegment', SeatSelectSegmentFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-select.factory.js
(function(angular, underscore) {
var SeatSelectFactory = function (SeatSelectSegment, SeatSelections, SeatPricingHelper) {
        /**
         * @constructor
         *
         * @param {Booking} booking
         */
        var SeatSelect = function (booking) {
            this.booking = booking;
            this.paxes = [];
            this.infantCount = 0;
            this.adultCount = 0;
            this.childCount = 0;
            this.youthCount = 0;

            this.tyPageData = {
                chosen: false,
                price: 0,
                totalCount: 0
            };
        };

        /**
         * @param {{ passengers: Object, segments: Object }} seatData
         */
        SeatSelect.prototype.populate = function (seatData) {
            var self = this;

            this.paxes = underscore.filter(
                this.booking.getPaxes(),
                function (pax) {
                    return pax.person.paxType !== 'INF';
                }
            );

            // Count pax types
            angular.forEach(
                this.booking.getPaxes(),
                function (pax) {
                    if (pax.person.paxType === 'INF') {
                        self.infantCount++;
                    }

                    if (pax.person.paxType === 'ADT') {
                        self.adultCount++;
                    }

                    if (pax.person.paxType === 'CHD') {
                        self.childCount++;
                    }

                    if (pax.person.paxType === 'YTH') {
                        self.youthCount++;
                    }
                }
            );

            this.segments = populateSegments(seatData.segments);
            populatePaxes(this.getPaxes(), seatData.passengers);
            this.selections = new SeatSelections(this.segments, this.getPaxes());
            this.lowestPrice = computeLowestPrice(this.segments);
            this.selectionsAvailable = computeAvailability(this.segments);
        };

        /**
         *
         * @returns {SeatSelectSegment[]}
         */
        SeatSelect.prototype.getSegments = function () {
            return this.segments;
        };

        /**
         *
         * @param {string} segmentId
         * @returns {SeatSelectSegment}
         */
        SeatSelect.prototype.getSegmentById = function (segmentId) {
            var foundSegment = null;

            for (var i = 0; i < this.segments.length; i++) {
                if (this.segments[i].id === segmentId) {
                    foundSegment = this.segments[i];
                }
            }

            return foundSegment;
        };

        /**
         *
         * @returns {SeatSelectSegment}
         */
        SeatSelect.prototype.getCurrentSegment = function () {
            return this.segments[this.selections.currentSegmentIndex];
        };

        /**
         *
         * @returns {Pax[]}
         */
        SeatSelect.prototype.getPaxes = function () {
            return this.paxes;
        };

        SeatSelect.prototype.getTotalPrice = function () {
            if (this.tyPageData.chosen) {
                return this.tyPageData.price;
            }

            if (!this.getSegments()) {
                return 0;
            }

            return SeatPricingHelper.getTotalPrice(this);
        };

        SeatSelect.prototype.getTotalSelections = function () {
            if (this.tyPageData.chosen) {
                return this.tyPageData.totalCount;
            }

            var count = 0;
            var self = this;

            angular.forEach(this.getSegments(), function (segment) {
                angular.forEach(
                    self.getPaxes(),
                    function (pax) {
                        if (self.selections.getSelection(segment.id, pax.seats.uuid) !== null) {
                            count++;
                        }
                    }
                );
            });

            return count;
        };

        SeatSelect.prototype.constructor = SeatSelect;

        /**
         * Populates segments
         *
         * @param {object[]} segmentArray
         * @returns {SeatSelectSegment[]}
         */
        var populateSegments = function (segmentArray) {
            var segments = [];

            for (var i = 0; i < segmentArray.length; i++) {
                segments.push(new SeatSelectSegment(segmentArray[i]));
            }

            return segments;
        };

        /**
         * Populates paxes
         *
         * @param {Pax[]} bookingPaxesNoInfant
         * @param {object[]} paxArray
         */
        var populatePaxes = function (bookingPaxesNoInfant, paxArray) {
            populatePaxesByPaxType(bookingPaxesNoInfant, paxArray, 'ADT');
            populatePaxesByPaxType(bookingPaxesNoInfant, paxArray, 'YTH');
            populatePaxesByPaxType(bookingPaxesNoInfant, paxArray, 'CHD');
        };

        /**
         * Populates paxes with seat ids by pax type (because seats can send paxes in random order)
         *
         * @param {Pax[]} bookingPaxesNoInfant
         * @param {Object[]} paxArray
         * @param {string} paxType
         */
        var populatePaxesByPaxType = function (bookingPaxesNoInfant, paxArray, paxType) {
            var bookingPaxesFiltered = underscore.filter(bookingPaxesNoInfant, function (pax) {
                return pax.person.getType() === paxType;
            });

            var seatPaxesFiltered = underscore.filter(paxArray, function (pax) {
                return pax.type === paxType;
            });

            for (var p = 0; p < seatPaxesFiltered.length; p++) {
                bookingPaxesFiltered[p].seats.uuid = seatPaxesFiltered[p].uuid;
            }
        };

        /**
         * Stores the lowest seat price
         *
         * @param {SeatSelectSegment[]} segments
         * @returns {number}
         */
        var computeLowestPrice = function (segments) {
            var lowestPrice = Infinity;

            angular.forEach(segments, function (segment) {
                if (segment.hasSeatmap()) {
                    angular.forEach(segment.seatmap.decks, function (deck) {
                        angular.forEach(deck.rows, function (row) {
                            angular.forEach(row.seats, function (seat) {
                                if (seat !== null && seat.available && seat.price.amount < lowestPrice) {
                                    lowestPrice = seat.price.amount;
                                }
                            });
                        });
                    });
                }

                if (segment.hasFallbackOptions()) {
                    angular.forEach(segment.fallbackOptions, function (fallbackOption) {
                        if (fallbackOption.price.amount < lowestPrice) {
                            lowestPrice = fallbackOption.price.amount;
                        }
                    });
                }
            });

            return lowestPrice;
        };

        /**
         * Checks if there are selectable seats in any segment
         *
         * @param {SeatSelectSegment[]} segments
         * @returns {boolean}
         */
        var computeAvailability = function (segments) {
            var selectionsAvailable = false;

            angular.forEach(segments, function (segment) {
                if (segment.hasSeatmap() || segment.hasFallbackOptions()) {
                    selectionsAvailable = true;
                }
            });

            return selectionsAvailable;
        };

        return SeatSelect;
    };

    SeatSelectFactory.$inject = ['SeatSelectSegment', 'SeatSelections', 'SeatPricingHelper'];

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelect', SeatSelectFactory);


}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seat-selections.factory.js
(function(angular) {
var SeatSelectionsFactory = function () {
        var SeatSelections = function (segmentArray, paxArray) {
            this.currentSegmentIndex = 0;
            this.totalSegmentCount = segmentArray.length;
            this.init(segmentArray, paxArray);
        };

        SeatSelections.prototype.constructor = SeatSelections;

        SeatSelections.prototype.init = function (segmentArray, paxArray) {
            this.seats = {};
            this.cachedSeats = {};

            this.options = {};
            this.cachedOptions = {};

            this.segmentsInOrder = [];

            for (var i = 0; i < segmentArray.length; i++) {
                var segmentId = segmentArray[i].id;
                var isFallback = segmentArray[i].seatmap === null;
                this.segmentsInOrder.push(segmentId);

                if (!isFallback) {
                    this.seats[segmentId] = {};
                    for (var p = 0; p < paxArray.length; p++) {
                        var paxId = paxArray[p].seats.uuid;
                        this.seats[segmentId][paxId] = null;
                    }
                }

                if (isFallback) {
                    this.options[segmentId] = null;
                }
            }
        };

        SeatSelections.prototype.isFallbackSegment = function (segmentId) {
            return this.options.hasOwnProperty(segmentId);
        };

        SeatSelections.prototype.getSelection = function (segmentId, paxId) {
            if (this.seats.hasOwnProperty(segmentId)) {
                return this.seats[segmentId][paxId];
            }

            return this.options[segmentId];
        };

        SeatSelections.prototype.isCompleted = function (segmentId) {
            if (this.isFallbackSegment(segmentId)) {
                return this.options[segmentId] !== null;
            }

            var completed = true;

            angular.forEach(
                Object.values(this.seats[segmentId]),
                function (paxSelection) {
                    if (paxSelection === null) {
                        completed = false;
                    }
                }
            );

            return completed;
        };

        SeatSelections.prototype.getCurrentSegmentCount = function () {
            return this.currentSegmentIndex + 1;
        };

        SeatSelections.prototype.getTotalSegmentCount = function () {
            return this.totalSegmentCount;
        };

        SeatSelections.prototype.cacheSelections = function () {
            this.cachedSeats = JSON.parse(JSON.stringify(this.seats));
            this.cachedOptions = JSON.parse(JSON.stringify(this.options));
        };

        SeatSelections.prototype.revertSelections = function () {
            this.seats = JSON.parse(JSON.stringify(this.cachedSeats));
            this.options = JSON.parse(JSON.stringify(this.cachedOptions));
        };

        SeatSelections.prototype.serialize = function (paxes) {
            var searialized = [];
            var self = this;

            angular.forEach(this.segmentsInOrder, function (segmentId) {
                // Seats
                if (self.seats.hasOwnProperty(segmentId) && self.seats[segmentId] !== null) {
                    angular.forEach(paxes, function (pax) {
                        if (self.seats[segmentId][pax.seats.uuid] !== null) {
                            searialized.push({
                                segmentUuid: segmentId,
                                passengerUuid: pax.seats.uuid,
                                designator: self.seats[segmentId][pax.seats.uuid]
                            });
                        }
                    });
                }

                // Fallback options
                if (self.options.hasOwnProperty(segmentId) && self.options[segmentId] !== null) {
                    angular.forEach(paxes, function (pax) {
                        if (self.options[segmentId] !== null) {
                            searialized.push({
                                segmentUuid: segmentId,
                                passengerUuid: pax.seats.uuid,
                                designator: self.options[segmentId]
                            });
                        }
                    });
                }
            });

            return searialized;
        };

        return SeatSelections;
    };

    angular
        .module('ITH.Funnel.Seats')
        .factory('SeatSelections', SeatSelectionsFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/models/seats-initial-data.factory.js
(function() {
angular
        .module('ITH.Funnel.Seats')
        .factory('SeatsInitialData', function () {
            var SeatsInitialData = function () {
                /**
                 * Is checking seats availability
                 */
                this.isChecking = true;

                /**
                 * Is loading seat data
                 */
                this.isLoading = false;

                /**
                 * Is seat selection allowed
                 */
                this.isAllowed = true;

                this.basketUuid = '';

                this.lowestPrice = null;

                this.isAisleSeatAvailable = false;

                this.isWindowSeatAvailable = false;

                this.isMiddleSeatAvailable = true;

                this.callbacks = [];
            };

            SeatsInitialData.prototype.setNotAllowed = function () {
                this.isChecking = false;
                this.isAllowed = false;
            };

            SeatsInitialData.prototype.populatePossibleSeatsCheck = function (data) {
                if (data.has_possible_seats === false) {
                    this.setNotAllowed();
                    return;
                }

                this.isChecking = false;
                this.isAllowed = true;
                this.lowestPrice = 0;

                if (data.lowest_price !== null && typeof data.lowest_price.amount === 'string') {
                    this.lowestPrice = data.lowest_price.amount.includes('.')
                        ? parseFloat(data.lowest_price.amount) || 0
                        : (parseFloat(data.lowest_price.amount) / 100) || 0;
                }
            };

            SeatsInitialData.prototype.populateFromWebSocket = function (data) {
                this.basketUuid = data.basketId || '';

                angular.forEach(this.callbacks, function (callback) {
                    callback();
                });
            };

            SeatsInitialData.prototype.addCallback = function (callbackFn) {
                this.callbacks.push(callbackFn);
            };

            SeatsInitialData.prototype.initLoading = function () {
                this.isLoading = true;
            };

            SeatsInitialData.prototype.constructor = SeatsInitialData;

            return SeatsInitialData;
        });

}());
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/fallback-types.helper.js
var FallbackTypesHelper = function ($filter) {
    this.getTranslation = function (type) {
        switch (type) {
            case 'aisle': return $filter('translate')('LANGM_JS_SEATS_SEATING_AISLE');
            case 'window': return $filter('translate')('LANGM_JS_SEATS_SEATING_WINDOW');
            case 'extra_legroom': return $filter('translate')('LANGM_JS_SEATS_SEATING_LEGROOM');
            case 'sit_together': return $filter('translate')('LANGM_JS_SEATS_SEATING_TOGETHER');
            case 'sit_together_aisle_and_aisle': return $filter('translate')('LANGM_JS_SEATS_SEATING_TOGETHER_AISLE_AISLE');
            case 'sit_together_aisle_and_middle': return $filter('translate')('LANGM_JS_SEATS_SEATING_TOGETHER_AISLE_MIDDLE');
            case 'sit_together_window_and_middle': return $filter('translate')('LANGM_JS_SEATS_SEATING_TOGETHER_WINDOW_MIDDLE');
            case 'sit_together_window_and_window': return $filter('translate')('LANGM_JS_SEATS_SEATING_TOGETHER_WINDOW_WINDOW');
            default: return $filter('translate')('LANGM_JS_SEATS_SEATING_RANDOM');
        }
    };

    this.getIconName = function (type) {
        switch (type) {
            case 'aisle': return 'aisle';
            case 'window': return 'window';
            case 'extra_legroom': return 'extra-legroom';
            case 'sit_together': return 'sit-together';
            case 'sit_together_aisle_and_aisle': return 'sit-together-aisle-aisle';
            case 'sit_together_aisle_and_middle': return 'aisle';
            case 'sit_together_window_and_middle': return 'window';
            case 'sit_together_window_and_window': return 'sit-together-window-window';
            default: return 'random';
        }
    };
};

FallbackTypesHelper.$inject = ['$filter'];

angular
    .module('ITH.Funnel.Seats')
    .service('FallbackTypesHelper', FallbackTypesHelper);
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/seat-pricing.helper.js
angular.module('ITH.Funnel.Seats').service('SeatPricingHelper', function () {
    var self = this;

    /**
     *
     * @param {SeatSelect} seatSelect
     * @param {string} segmentId
     * @param {string} seatId
     * @returns {number}
     */
    this.getSeatPrice = function (seatSelect, segmentId, seatId) {
        var segment = seatSelect.getSegmentById(segmentId);
        var seat = segment.getSeatById(seatId);

        if (seat === null) {
            return 0;
        }

        return Number(seat.price.amount);
    };

    /**
     *
     * @param {SeatSelect} seatSelect
     * @param {string} segmentId
     * @param {string} optionValue
     * @returns {number}
     */
    this.getOptionPrice = function (seatSelect, segmentId, optionValue) {
        var option = seatSelect.getSegmentById(segmentId).getOptionByValue(optionValue);
        return Number(option.price.amount) * seatSelect.getPaxes().length;
    };

    /**
     *
     * @param {SeatSelect} seatSelect
     * @returns {number}
     */
    this.getTotalPrice = function (seatSelect) {
        var total = 0;

        angular.forEach(
            Object.keys(seatSelect.selections.seats),
            function (segmentId) {
                var segmentSelections = seatSelect.selections.seats[segmentId]

                angular.forEach(
                    Object.values(segmentSelections),
                    function (seatId) {
                        if (seatId !== null) {
                            total += self.getSeatPrice(seatSelect, segmentId, seatId);
                        }
                    }
                );
            }
        );

        angular.forEach(
            Object.keys(seatSelect.selections.options),
            function (segmentId) {
                var optionValue = seatSelect.selections.options[segmentId];

                if (optionValue !== null) {
                    total += self.getOptionPrice(seatSelect, segmentId, optionValue);
                }
            }
        );

        return total;
    };

    /**
     *
     * @param {SeatSelect} seatSelect
     * @param {string} segmentId
     * @param {string} passengerId
     * @returns {number}
     */
    this.getSummaryPrice = function (seatSelect, segmentId, passengerId) {
        var segment = seatSelect.getSegmentById(segmentId);
        var value = seatSelect.selections.getSelection(segmentId, passengerId);

        if (segment.hasSeatmap()) {
            return this.getSeatPrice(seatSelect, segmentId, value);
        }

        if (value === null) {
            return 0;
        }

        return this.getOptionPrice(seatSelect, segmentId, value) / seatSelect.getPaxes().length;
    };
});
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/seat-types.helper.js
(function(angular) {
var types = {
        EXTRA_LEG: {
            name: 'LANGM_JS_SEATS_CATEGORY_EXTRA_LEG'
        },
        FRONT_ROW: {
            name: 'LANGM_JS_SEATS_CATEGORY_FRONT_ROW'
        },
        STANDARD: {
            name: 'LANGM_JS_SEATS_CATEGORY_STANDARD'
        },
        MOST_POPULAR: {
            name: 'LANGM_JS_SEATS_CATEGORY_MOST_POPULAR'
        },
        UNAVAILABLE: {
            name: 'LANGM_JS_SEATS_CATEGORY_UNAVAILABLE'
        },
        SELECTED: {
            name: 'LANGM_JS_SEATS_CATEGORY_SELECTED'
        },
        INFANT: {
            name: 'LANGM_JS_SEAT_CATEGORY_ADULT_WITH_INFANT'
        }
    };

    var SeatTypeService = function ($filter) {
        this.getName = function (seatType) {
            if (!types.hasOwnProperty(seatType)) {
                return seatType;
            }

            return $filter('translate')(types[seatType].name);
        };

        this.getRank = function (seatType) {
            if (seatType === 'UNAVAILABLE') {
                return 'unavailable';
            }

            if (seatType === 'SELECTED') {
                return 'selected';
            }

            if (seatType === 'INFANT') {
                return 'infant';
            }

            if (seatType === 'EXTRA_LEG') {
                return '0';
            }

            if (seatType === 'FRONT_ROW' || seatType === 'MOST_POPULAR') {
                return '1';
            }

            return '2';
        };

        this.getCategory = function (seat, categories) {
            return seat.seatCategory;
        };
    };

    SeatTypeService.$inject = ['$filter'];

    angular.module('ITH.Funnel.Seats').service('SeatTypesService', SeatTypeService);


}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/seat.helper.js
var SeatHelperService = function ($filter, Dictionaries) {
    /**
     *
     * @param {SeatSelect} seatSelect
     * @param {string} segmentId
     * @param {string} passengerId
     * @returns {string}
     */
    this.getSeatPlacement = function (seatSelect, segmentId, passengerId) {
        var segment = seatSelect.getSegmentById(segmentId);
        var seatId = seatSelect.selections.getSelection(segmentId, passengerId);
        var seat = segment.getSeatById(seatId);

        if (seat === null) {
            return '';
        }

        if (seat.window === true) {
            return $filter('translate')('LANGM_JS_SEATS_SEATING_WINDOW');
        }

        if (seat.aisle === true) {
            return $filter('translate')('LANGM_JS_SEATS_SEATING_AISLE');
        }

        return $filter('translate')('LANGM_JS_SEATS_SEATING_MIDDLE');
    };

    this.getSelectionDescription = function (seatSelect, segmentId, passengerId) {
        var output = seatSelect.selections.getSelection(segmentId, passengerId);
        var seatPlacement = this.getSeatPlacement(seatSelect, segmentId, passengerId);

        if (seatPlacement !== '') {
            output += ' • ' + seatPlacement;
        }

        return output;
    };

    this.notAllPaxesHaveSeatsInCurrentSegment = function (seatSelect) {
        return this.notAllPaxesHaveSeatsInSegment(
            seatSelect,
            seatSelect.getCurrentSegment()
        );
    };

    this.notAllPaxesHaveSeatsInAnySegment = function (seatSelect) {
        var self = this;
        var allHaveSeats = true;

        angular.forEach(seatSelect.getSegments(), function (segment) {
            if (self.notAllPaxesHaveSeatsInSegment(seatSelect, segment)) {
                allHaveSeats = false;
            }
        });

        return !allHaveSeats;
    };

    this.notAllPaxesHaveSeatsInSegment = function (seatSelect, segment) {
        return (
            !seatSelect.selections.isCompleted(segment.id) &&
            (
                segment.hasSeatmap() ||
                segment.hasFallbackOptions()
            )
        );
    };

    this.isLastSegment = function (seatSelect) {
        return seatSelect.selections.currentSegmentIndex === seatSelect.getSegments().length - 1;
    };

    this.getPaxIndex = function (targetPax, allPaxes) {
        var index = 0;

        angular.forEach(allPaxes, function (pax, idx) {
            if (pax.seats.uuid === targetPax.seats.uuid) {
                index = idx;
            }
        });

        return index;
    };

    this.getPaxFullName = function (pax, allPaxes) {
        if (pax.person.firstName && pax.person.lastName) {
            return pax.person.firstName + ' ' + pax.person.lastName;
        }

        return $filter('translate')('LANGM_JS_PASSENGER') + ' ' + (this.getPaxIndex(pax, allPaxes) + 1);
    };

    this.getPaxInitials = function (pax, allPaxes) {
        if (pax.person.firstName && pax.person.lastName) {
            return pax.person.firstName[0] + pax.person.lastName[0];
        }

        return 'P' + (this.getPaxIndex(pax, allPaxes) + 1);
    };

    this.getRandomSeatPaxes = function (seatSelect) {
        var randomSeatPaxes = [];
        var currentSegmentId = seatSelect.getCurrentSegment().id;

        angular.forEach(
            seatSelect.getPaxes(),
            function (pax) {
                if (seatSelect.selections.getSelection(currentSegmentId, pax.seats.uuid) === null) {
                    randomSeatPaxes.push(pax);
                }
            }
        );

        return randomSeatPaxes;
    };

    this.hasPaxRandomSeating = function (seatSelect, segmentId, passengerId) {
        return seatSelect.selections.getSelection(segmentId, passengerId) === null;
    };

    this.paxHasSelectedSeating = function (seatSelect, segmentId, passengerId) {
        return !this.hasPaxRandomSeating(seatSelect, segmentId, passengerId);
    };

    this.isSeatSelectedByAny = function (seatSelect, segmentId, seatId) {
        var isSelected = false;

        angular.forEach(
            Object.values(seatSelect.selections.seats[segmentId]),
            function (id) {
                if (id === seatId) {
                    isSelected = true;
                }
            }
        );

        return isSelected;
    };

    this.getPaxIdBySeatId = function (seatSelect, segmentId, seatId) {
        var foundPaxId = null;

        angular.forEach(
            Object.keys(seatSelect.selections.seats[segmentId]),
            function (paxId) {
                if (seatSelect.selections.seats[segmentId][paxId] === seatId) {
                    foundPaxId = paxId;
                }
            }
        );

        return foundPaxId;
    };

    this.getPaxByPaxId = function (seatSelect, paxId) {
        var foundPax = null;

        angular.forEach(seatSelect.getPaxes(), function (passenger) {
            if (passenger.seats.uuid === paxId) {
                foundPax = passenger;
            }
        });

        return foundPax;
    };

    this.hasSegmentRandomSeating = function (seatSelect, segmentId) {
        var allSelected = true;
        var self = this;

        angular.forEach(
            seatSelect.getPaxes(),
            function (pax) {
                if (self.hasPaxRandomSeating(seatSelect, segmentId, pax.seats.uuid)) {
                    allSelected = false;
                }
            }
        );

        return !allSelected;
    };

    this.hasSegmentAnySeating = function (seatSelect, segmentId) {
        var anySelected = false;
        var self = this;

        angular.forEach(
            seatSelect.getPaxes(),
            function (pax) {
                if (!self.hasPaxRandomSeating(seatSelect, segmentId, pax.seats.uuid)) {
                    anySelected = true;
                }
            }
        );

        return anySelected;
    };

    this.isSeatmapVeryWide = function (segment) {
        if (segment.seatmap === null) {
            return false;
        }

        return segment.seatmap.decks[0].config.width > 9;
    };

    this.getSegmentDepartureCity = function (segment) {
        return Dictionaries.getCityNameByAirportCode(segment.departureAirport, false);
    };

    this.getSegmentArrivalCity = function (segment) {
        return Dictionaries.getCityNameByAirportCode(segment.arrivalAirport, false);
    };

    this.getInfantSeatCount = function (seatSelect) {
        var segment = seatSelect.getCurrentSegment();
        var count = 0;

        angular.forEach(
            seatSelect.getPaxes(),
            function (pax) {
                var seatId = seatSelect.selections.getSelection(segment.id, pax.seats.uuid);
                var seat = segment.getSeatById(seatId);

                if (seat !== null && seat.infantAllowed) {
                    count++;
                }
            }
        );

        return count;
    };

    this.shouldShowInfantSelectWarning = function (seatSelect) {
        return (
            seatSelect.getCurrentSegment().hasSeatmap() &&
            !this.notAllPaxesHaveSeatsInCurrentSegment(seatSelect) &&
            this.getInfantSeatCount(seatSelect) < seatSelect.infantCount
        );
    };
};

SeatHelperService.$inject = ['$filter', 'Dictionaries'];

angular.module('ITH.Funnel.Seats').service('SeatHelper', SeatHelperService);
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/seats-flow.helper.js
(function (angular) {
var SeatsFlowHelper = function (AppConfig, SeatsService, Market) {
        /**
         *
         * @param {AncillariesSocketHandler} ancillariesSocketHandler
         * @param {string} fulfillmentToken
         * @param {SeatsInitialData} seatsInitialData
         */
        this.init = function (ancillariesSocketHandler, fulfillmentToken, seatsInitialData) {
            SeatsService
                .checkForPossibleSeats(
                    ancillariesSocketHandler.getSocketId(),
                    AppConfig.getAbConfig()['product_package'],
                    decodeURIComponent(fulfillmentToken),
                    new Market()
                )
                .catch(function () {
                    seatsInitialData.setNotAllowed();
                });
        };
    };

    SeatsFlowHelper.$inject = ['appConfig', 'SeatsService', 'Market'];

    angular.module('ITH.Funnel.Seats').service('SeatsFlow', SeatsFlowHelper);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/seats/services/seats-service.api.js
(function(angular) {
var IthSeatsService = function ($http, appConfig) {
        var apiUrl = appConfig.getSeatsConfig().host + '/v1/public/seat/';

        this.checkForPossibleSeats = function (socketId, productPackageVersion, fulfillmentToken, market) {
            return $http({
                method: 'POST',
                url: apiUrl + 'check-for-possible-seats',
                headers: {
                    Accept: 'application/json'
                },
                data: {
                    meta: {
                        market: market.getData(),
                        socket: {
                            id: socketId
                        },
                        featureTests: {
                            product_package_version: productPackageVersion
                        },
                        searchMode: appConfig.getSeatsSearchMode()
                    },
                    payload: {
                        fulfillmentToken: fulfillmentToken,
                        affiliate: market.getAffiliate(),
                        language: market.getLanguage(),
                        currency: market.getCurrency()
                    }
                }
            });
        };

        this.loadSeatmap = function (basketUuid) {
            return $http({
                method: 'GET',
                url: apiUrl + basketUuid,
                headers: {
                    Accept: 'application/json'
                }
            });
        };

        this.addToBasket = function (basketUuid, payload) {
            return $http({
                method: 'POST',
                url: apiUrl + basketUuid + '/order',
                headers: {
                    Accept: 'application/json'
                },
                data: payload
            });
        };
    };

    IthSeatsService.$inject = ['$http', 'appConfig'];

    angular
        .module('ITH.Funnel.Seats')
        .service('SeatsService', IthSeatsService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/AnalyticsServiceApi.js
(function (angular) {
var IthAnalyticsServiceApi = function ($http, AppConfig) {
        /**
         * Posts a message in the analytics service
         *
         * @param {String} type
         * @param {Any} payload
         * @returns {Promise}
         */
        this.postMessage = function (type, payload) {
            var data = {
                type: type,
                targets: ['bigquery'],
                payload: payload,
                category: 'search_frontend'
            };

            var config = AppConfig.getAnalyticsMicroserviceConfig();

            return $http({
                method: 'POST',
                url: config.endpoints.message,
                data: data,
                headers: {
                    Accept: 'application/json'
                }
            });
        };

        /**
         * @param {string[]} translationIdsList
         * @returns {Promise}
         */
        this.sendTranslationIdsList = function (translationIdsList) {
            if (!AppConfig.isLangsCollectorEnabled()) {
                return false;
            }

            var generatePayload = function (translationIdsList) {
                return {
                    type: 'used_langs',
                    targets: [
                        'bigquery'
                    ],
                    category: 'langs_in_use',
                    payload: JSON.stringify({
                        langs: translationIdsList,
                        referer: window.location.href,
                        type: 'lang',
                        source: 'frontend-js',
                        locale: AppConfig.getUserLanguage(),
                        timestamp: Math.round(new Date() / 1000),
                        affiliate: AppConfig.getAffiliateName()
                    })
                };
            };

            return $http({
                method: 'POST',
                url: AppConfig.getAnalyticsMicroserviceConfig().endpoints.message,
                data: generatePayload(translationIdsList),
                headers: {
                    Accept: 'application/json'
                }
            });
        };
    };

    IthAnalyticsServiceApi.$inject = [
        '$http',
        'appConfig'
    ];

    angular
        .module('funnel')
        .service('AnalyticsServiceApi', IthAnalyticsServiceApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/AnalyticsServiceHelper.js
(function(angular, moment, underscore) {
var IthAnalyticsServiceHelper = function ($window, $location, $localStorage, $log, AppConfig, AuthService, AnalyticsServiceApi, Dictionaries, AutomatedCheckinHelper, IbeLuggageSummaryHelper) {
        /**
         * Returns object containing multiple information about a date
         *
         * @param {Date|String}
         * @returns {Object}
         */
        var getMomentDate = function (date) {
            return {
                date: moment(date).format('YYYY-MM-DDTHH:mm:ss'),
                utcDate: moment(date).locale('en').utc().format(),
                month: moment(date).locale('en').format('MMMM'),
                week: moment(date).locale('en').isoWeek(),
                year: moment(date).year(),
                day: moment(date).locale('en').format('dddd')
            };
        };

        /**
         * Returns user analytical data
         *
         * @returns {Object}
         */
        var getUserFingerprint = function () {
            var adBlockUse = !$window.google_tag_manager;
            var affiliate = AppConfig.getAffiliateId();
            var applicationVersion = AppConfig.getAppVersion();
            var clientTimezone = new Date().getTimezoneOffset();
            var doNotTrack = $window.navigator.doNotTrack || '';
            var domain = $location.host();
            var language = AppConfig.getLanguageCode();
            var mobile = AppConfig.isPhone();
            var platform = $window.navigator.platform;
            var referer = $window.navigator.referer;
            var screenResolution = $window.screen.width + 'x' + $window.screen.height;
            var sessionId = AppConfig.getGaSession();
            var userAgent = $window.navigator.userAgent;
            var userId = (AppConfig.getUser() && AppConfig.getUser().id) ? AppConfig.getUser().id : 0;

            return {
                adBlockUse: adBlockUse,
                affiliate: affiliate,
                applicationVersion: applicationVersion,
                clientTimezone: clientTimezone,
                doNotTrack: doNotTrack,
                domain: domain,
                language: language,
                mobile: mobile,
                platform: platform,
                referer: referer,
                screenResolution: screenResolution,
                sessionId: sessionId,
                userAgent: userAgent,
                userId: userId
            };
        };

        /**
         * Returns payload from search results
         *
         * @param {SouthParkHelper} spHelper
         * @param {SearchQueryParams} sqp
         * @returns {Object}
         */
        var getShelfSearchPayload = function (spHelper, sqp) {
            var searchDateInfo = getMomentDate(spHelper.searchDate);
            var searchDepartureDate = getMomentDate(sqp.getDepDate());
            var searchReturnDate = getMomentDate(sqp.getRetDate());

            var slot = '';
            if (AppConfig.getAbConfig().hasOwnProperty('ibe_slot_version')) {
                slot = AppConfig.getAbConfig().ibe_slot_version;
            }

            return {
                search_results_id: spHelper.requestId,
                search_affiliate: AppConfig.getAffiliateName(),
                search_date: searchDateInfo.utcDate,
                search_date_month: searchDateInfo.month,
                search_date_week: searchDateInfo.week,
                search_date_year: searchDateInfo.year,
                search_date_day: searchDateInfo.day,
                search_no_of_results: spHelper.originalOffers.length,
                search_param_origin_city_code: sqp.getDepCityCode(),
                search_param_origin_country_code: sqp.getDepCountryCode(),
                search_param_origin_airport_code: sqp.getDepAirportCode(),
                search_param_destination_city_code: sqp.getDesCityCode(),
                search_param_destination_airport_code: sqp.getDesAirportCode(),
                search_param_destination_country_code: sqp.getDesCountryCode(),
                search_param_domestic: sqp.getDepCountryCode() === sqp.getDesCountryCode(),
                search_param_trip_type: sqp.isOneWay() ? 'oneway' : 'roundtrip',
                search_param_pax_no: sqp.getPaxTotalFromLink(),
                search_param_start_date: searchDepartureDate.date,
                search_param_start_date_month: searchDepartureDate.month,
                search_param_start_date_week: searchDepartureDate.week,
                search_param_start_date_year: searchDepartureDate.year,
                search_param_start_date_day: searchDepartureDate.day,
                search_param_end_date: searchReturnDate.date,
                search_param_end_date_month: searchReturnDate.month,
                search_param_end_date_week: searchReturnDate.week,
                search_param_end_date_year: searchReturnDate.year,
                search_param_end_date_day: searchReturnDate.day,
                search_param_stays: moment(sqp.getRetDate()).diff(moment(sqp.getDepDate()), 'days'),
                search_shelf: spHelper.activeSortingTab,
                search_filters: spHelper.filters.appliedFilters,
                search_avg_price: spHelper.avgPrice.toFixed(2),
                search_max_price: spHelper.maxPrice.toFixed(2),
                search_min_price: spHelper.minPrice.toFixed(2),
                search_bought: false,
                search_no_adults: sqp.getAdults(),
                search_no_children: sqp.getChildren(),
                search_no_infants: sqp.getInfants(),
                search_no_youths: sqp.getYouths(),
                search_session_id: spHelper.sessionId,
                search_triggered_by_agent: AuthService.isAgent() ? true : false,
                ibe_slot_version: slot
            };
        };

        /**
         * Get search payload for pax details by reading it from flight storage
         *
         * @param {String} travelHash
         * @returns {Object}
         */
        var getPaxSearchPayload = function (travelHash) {
            if ($localStorage.shelfSearchAnalytics && $localStorage.shelfSearchAnalytics.travelHash === travelHash) {
                return $localStorage.shelfSearchAnalytics.payload;
            }

            return {
                search_results_id: null,
                search_affiliate: null,
                search_date: null,
                search_date_month: null,
                search_date_week: null,
                search_date_year: null,
                search_date_day: null,
                search_no_of_results: null,
                search_param_origin_city_code: null,
                search_param_origin_country_code: null,
                search_param_origin_airport_code: null,
                search_param_destination_city_code: null,
                search_param_destination_airport_code: null,
                search_param_destination_country_code: null,
                search_param_domestic: null,
                search_param_trip_type: null,
                search_param_pax_no: null,
                search_param_start_date: null,
                search_param_start_date_month: null,
                search_param_start_date_week: null,
                search_param_start_date_year: null,
                search_param_start_date_day: null,
                search_param_end_date: null,
                search_param_end_date_month: null,
                search_param_end_date_week: null,
                search_param_end_date_year: null,
                search_param_end_date_day: null,
                search_param_stays: null,
                search_shelf: null,
                search_filters: null,
                search_avg_price: null,
                search_max_price: null,
                search_min_price: null,
                search_bought: true,
                search_no_adults: null,
                search_no_children: null,
                search_no_infants: null,
                search_session_id: null,
                search_triggered_by_agent: null,
            };
        };

        /**
         * Returns flight payload based on shelf flight model
         *
         * @param {FlightOfferModel} flightData
         * @param {Number} index
         * @returns {Object}
         */
        var getShelfFlightPayload = function (flightData, index) {
            var flightGeneralPayload = {
                flight_id: flightData.travelHash,
                flight_price: flightData.getPricePerPax().amount,
                flight_currency: flightData.getPricePerPax().currency,
                flight_displayed_price: Math.round(flightData.getPriceWithoutTf()),
                flight_displayed_transaction_fee: Math.round(flightData.fees.transactionFee.amount),
                flight_total_displayed_price: Math.round(flightData.getPriceWithTf()),
                flight_search_results_position: index + 1,
                flight_type: flightData.type,
                flight_sub_type: flightData.subtype,
                flight_category: flightData.category,
                ibe_fee_version: flightData.fees.transactionFeeVersion
            };

            flightGeneralPayload = underscore.extend(
                flightGeneralPayload,
                getShelfFlightStagePayload(flightData.stages[0], 'departure')
            );

            if (flightData.isRoundTrip()) {
                flightGeneralPayload = underscore.extend(
                    flightGeneralPayload,
                    getShelfFlightStagePayload(flightData.stages[1], 'return')
                );
            }

            return flightGeneralPayload;
        };

        /**
         * Rounds and returns hour
         * Ex: 7:29 -> 7, 7:30 -> 8
         *
         * @param {Date|String} date
         * @returns {Number}
         */
        var getRoundedHour = function (date) {
            var hour = parseInt(moment(date).format('HH'));
            var minutes = parseInt(moment(date).format('mm'));

            if (minutes >= 30) {
                hour += 1;
            }

            return hour;
        };

        /**
         * Returns payload for a shelf flight stage
         *
         * @param {FlightOfferStageModel} flightStage
         * @param {String} alias
         * @returns {Object}
         */
        var getShelfFlightStagePayload = function (flightStage, alias) {
            var stagePayload = {};

            /**
             * Sets an alias entry on the payload object
             *
             * @param {String} name
             * @param {Any} value
             */
            var setAliasEntry = function (name, value) {
                stagePayload['flight_' + alias + '_' + name] = value;
            };

            var stageFromMomentDate = getMomentDate(flightStage.getFirstSegment().departure);
            var stageToMomentDate = getMomentDate(flightStage.getLastSegment().arrival);
            var stageJourneyStopovers = underscore.filter(flightStage.journey.hours, function (entry) {
                return entry.type === 'stopover';
            });

            var stageStayTimeMinutes = underscore.reduce(stageJourneyStopovers, function (sum, journeyEntry) {
                return sum + journeyEntry.duration;
            }, 0);

            setAliasEntry('carrier', { carrier: flightStage.airlines });
            setAliasEntry('duration', flightStage.duration);
            setAliasEntry('duration_hours', Math.round(flightStage.duration / 60));
            setAliasEntry('no_of_layovers', flightStage.segments.length - 1);
            setAliasEntry('night_flight', flightStage.hasStopoverOvernight);
            setAliasEntry('same_carrier', flightStage.airlines.length === 1);
            setAliasEntry('stay_time', stageStayTimeMinutes);
            setAliasEntry('stay_time_hours', Math.round(stageStayTimeMinutes / 60));
            setAliasEntry('layovers_data', { layovers: JSON.parse(angular.toJson(getShelfStageSegments(flightStage.segments))) });
            setAliasEntry('fit_to_search_query', flightStage.arrivesSameDay);

            setAliasEntry('from_time', moment(flightStage.getFirstSegment().departure).format('HH:mm'));
            setAliasEntry('from_hour', getRoundedHour(flightStage.getFirstSegment().departure));
            setAliasEntry('from_date', stageFromMomentDate.date);
            setAliasEntry('from_date_month', stageFromMomentDate.month);
            setAliasEntry('from_date_week', stageFromMomentDate.week);
            setAliasEntry('from_date_year', stageFromMomentDate.year);
            setAliasEntry('from_date_day', stageFromMomentDate.day);
            setAliasEntry('from_city_code', flightStage.originCity);
            setAliasEntry('from_airport_code', flightStage.originAirport);

            setAliasEntry('to_time', moment(flightStage.getLastSegment().arrival).format('HH:mm'));
            setAliasEntry('to_hour', getRoundedHour(flightStage.getLastSegment().arrival));
            setAliasEntry('to_date', stageToMomentDate.date);
            setAliasEntry('to_date_month', stageToMomentDate.month);
            setAliasEntry('to_date_week', stageToMomentDate.week);
            setAliasEntry('to_date_year', stageToMomentDate.year);
            setAliasEntry('to_date_day', stageToMomentDate.day);
            setAliasEntry('to_city_code', flightStage.destinationCity);
            setAliasEntry('to_airport_code', flightStage.destinationAirport);

            return stagePayload;
        };

        /**
         * @param {Pax[]} paxes
         * @param {String} paxType
         * @returns {Pax[]}
         */
        var filterPaxesByType = function (paxes, paxType) {
            return underscore.filter(paxes, function (pax) {
                return pax.person.getType() === paxType;
            });
        };

        /**
         * Returns type of check-in
         *
         * @param {Array} airlineRules
         * @returns {String}
         */
        var getCheckinType = function (airlineRules) {
            var hasFreeCheckin = AutomatedCheckinHelper.hasFreeCheckin(airlineRules);
            var hasPaidCheckin = AutomatedCheckinHelper.hasPaidCheckin(airlineRules);

            var checkInType = 'free';

            if (hasFreeCheckin && hasPaidCheckin) {
                checkInType = 'partially_paid';
            }

            if (!hasFreeCheckin && hasPaidCheckin) {
                checkInType = 'paid';
            }

            return checkInType;
        };

        /**
         * Returns checkin price per pax
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        var getCheckinPaxPrice = function (flightBooking) {
            if (!flightBooking.getFlightDetails().additionalServices.hasOwnProperty('paidCheckin')) {
                return 0;
            }

            return flightBooking.getFlightDetails().additionalServices.paidCheckin.paxPrice;
        };

        /**
         * Returns total price for check-in
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        var getCheckinTotalPrice = function (flightBooking) {
            if (!flightBooking.getFlightDetails().additionalServices.hasOwnProperty('paidCheckin')) {
                return 0;
            }

            return flightBooking.getFlightDetails().additionalServices.paidCheckin.totalPrice;
        };

        var getFreeLuggage = function (booking) {
            var freeLuggageServiceChooses = [];

            underscore.each(booking.getPaxes(), function (pax) {
                var options = booking.luggageHandler.passengerOptions.getOptionByPaxType(pax.person.getType());

                if (typeof (options) === 'undefined') {
                    return;
                }

                underscore.each(options.combinations, function (combination) {
                    underscore.each(combination.serviceChooses, function (serviceChoose) {
                        var services = underscore.map(serviceChoose.services, function (service) {
                            return service.type;
                        });

                        if (serviceChoose.price === 0 && !underscore.contains(services, 'NO_OPTION')) {
                            freeLuggageServiceChooses.push({
                                type: combination.isCabin() ? 'CABIN' : 'HOLD_BAGGAGE',
                                services: services
                            });
                        }
                    });
                });
            });

            return freeLuggageServiceChooses;
        };

        /**
         * Checks if free luggage is included
         *
         * @param {Array} freeLuggage
         * @returns {Boolean}
         */
        var isFreeLuggageIncluded = function (freeLuggage) {
            return freeLuggage.length > 0;
        };

        /**
         * Returns id of free luggage
         *
         * @param {Array} freeLuggage
         * @returns {String}
         */
        var getFreeLuggageId = function (freeLuggage) {
            if (freeLuggage.length === 0) {
                return null;
            }

            return freeLuggage[0].services[0];
        };

        /**
         * Returns type of free luggage
         *
         * @param {Array} freeLuggage
         * @returns {String}
         */
        var getFreeLuggageType = function (freeLuggage) {
            if (freeLuggage.length === 0) {
                return null;
            }

            return freeLuggage[0].services.join('+');
        };

        /**
         * Returns additional hand luggage
         *
         * @param {Array} ibeSelectedLuggageEntries
         * @returns {Array}
         */
        var getAdditionalHandLuggage = function (ibeSelectedLuggageEntries) {
            return getAdditionalLuggage(ibeSelectedLuggageEntries, function (entry) {
                return (entry.type === 'CABIN') && entry.count > 0 && entry.totalPrice > 0;
            });
        };

        /**
         * Returns additional checked luggage
         *
         * @param {Array} ibeSelectedLuggageEntries
         * @returns {Array}
         */
        var getAdditionalCheckedLuggage = function (ibeSelectedLuggageEntries) {
            return getAdditionalLuggage(ibeSelectedLuggageEntries, function (entry) {
                return entry.type === 'CHECKED' && entry.count > 0 && entry.totalPrice > 0;
            });
        };

        /**
         * Returns additional luggage
         *
         * @param {Array} ibeSelectedLuggageEntries
         * @param {Function} filterFunction
         * @returns {Array}
         */
        var getAdditionalLuggage = function (ibeSelectedLuggageEntries, filterFunction) {
            var entries = underscore.filter(ibeSelectedLuggageEntries, filterFunction);
            var retData = { count: 0, totalPrice: 0 };

            if (entries === undefined) {
                return retData;
            }

            return underscore.reduce(entries, function (prevEntry, entry) {
                return {
                    count: prevEntry.count + entry.count,
                    totalPrice: prevEntry.totalPrice + entry.totalPrice
                };
            }, retData);
        };

        /**
         * Converts currency number to float with 2 decimals
         *
         * @param {Number} value
         * @returns {Number}
         */
        var currencyFilter = function (value) {
            return parseFloat(parseFloat(value).toFixed(2));
        };

        /**
         * Returns selected insurance
         *
         * @param {FlightBooking} flightBooking
         * @returns {Object}
         */
        var getSelectedInsurance = function (flightBooking) {
            return flightBooking.getNewInsurance().selectedInsurance;
        };

        /**
         * Returns selected insurance type
         *
         * @param {Object} insurance
         */
        var getInsuranceType = function (insurance) {
            if (insurance === null) {
                return null;
            }

            return insurance.type;
        };

        /**
         * Returns insurance price per pax
         *
         * @param {Insurance}
         * @returns {Number}
         */
        var getInsurancePrice = function (insurance) {
            if (insurance === null) {
                return 0;
            }

            return insurance.price;
        };

        /**
         * Returns insurance total price
         *
         * @param {Insurance}
         * @returns {Number}
         */
        var getInsuranceTotalPrice = function (insurance) {
            if (insurance === null) {
                return 0;
            }

            return insurance.totalPrice;
        };

        /**
         * Returns insurance days
         *
         * @param {Object} insurance;
         * @returns {Number}
         */
        var getInsuranceDays = function (insurance) {
            if (insurance === null) {
                return 0;
            }

            return insurance.days;
        };

        /**
         * Returns flight booking total price
         *
         * @param {FlightBooking} flightBooking
         * @returns {Number}
         */
        var getFlightTotalPrice = function (flightBooking) {
            if (hasPriceDiff(flightBooking)) {
                return flightBooking.basket.getTotalPrice(true);
            }

            return flightBooking.basket.getTotalPrice();
        };

        /**
         * Checks if flight has price diff
         *
         * @param {FlightBooking} flightBooking
         * @returns {Boolean}
         */
        var hasPriceDiff = function (flightBooking) {
            var priceDiff = flightBooking.getTestSell().getPriceDiff();
            return !isNaN(priceDiff) && priceDiff > 0;
        };

        /**
         * Returns array of products included in the split funnel package
         *
         * @param {TicketTypeModel} splitFunnelPackage
         * @returns {Object[]}
         */
        var getSplitFunnelIncludes = function (splitFunnelPackage) {
            if (splitFunnelPackage === null) {
                return [];
            }

            return underscore.map(splitFunnelPackage.includes, function (entry) {
                return { name: entry.name };
            });
        };

        /**
         * @see apps/shared/public_html/assets/js/flightDetails/ibe-luggage/components/ibe-luggage-selector.component.js
         * @param passengerOption
         * @returns {number}
         */
        var isLuggageAvailable = function (passengerOption) {
            if (!passengerOption || passengerOption.combinations.length === 0 || (
              passengerOption.combinations.length === 1 &&
              passengerOption.combinations[0].isNoOption()
            )) {
                return 0;
            }

            return 1;
        };

        var isLuggageTypeAvailable = function (passengerOption, type) {
            if (!passengerOption || passengerOption.combinations.length === 0) {
                return 0;
            }

            var matched = underscore.find(passengerOption.combinations, function (combination) {
                if ('cabin' === type) {
                    return combination.isCabin();
                }
                if ('checked' === type) {
                    return combination.isChecked();
                }
                return false;
            });

            if (matched && matched.serviceChooses && matched.serviceChooses.length > 0) {
                if (1 === matched.serviceChooses.length && matched.serviceChooses[0].isNoOption()) {
                    return 0;
                }
                return 1;
            }
            return 0;
        };

        /**
         * Returns flight details payload based on old pax details code
         *
         * @param {FlightBooking} basket
         * @param {String} reservationNumber
         * @returns {Object}
         */
        var getFlightDetailsPayload = function (flightBooking, reservationNumber) {
            var flightId = flightBooking.basket.flightDetails.travelHash;
            var flightPrice = flightBooking.basket.getPaxesPricing().getFirstPricing().totalNettoPrice / flightBooking.basket.getPaxesPricing().getFirstPricing().count;
            var flightCurrency = AppConfig.getCurrencyCode();
            var flightDisplayedPrice = flightBooking.basket.getTotalNettoPrice();
            var flightDisplayedTransactionFee = flightBooking.basket.getTotalTransFee();
            var flightTotalDisplayedPrice = flightBooking.basket.getTotalNettoPrice() + flightBooking.basket.getTotalTransFee();

            var numberOfPaxes = flightBooking.getPaxes().length;
            var numberOfAdults = filterPaxesByType(flightBooking.getPaxes(), 'ADT').length;
            var numberOfChildren = filterPaxesByType(flightBooking.getPaxes(), 'CHD').length;
            var numberOfInfants = filterPaxesByType(flightBooking.getPaxes(), 'INF').length;
            var numberOfYouth = filterPaxesByType(flightBooking.getPaxes(), 'YTH').length;

            var selectedInsurance = getSelectedInsurance(flightBooking);

            var ibeSelectedLuggageEntries = IbeLuggageSummaryHelper.getItems(flightBooking);

            var additionalHandLuggage = getAdditionalHandLuggage(ibeSelectedLuggageEntries);
            var additionalCheckedLuggage = getAdditionalCheckedLuggage(ibeSelectedLuggageEntries);
            var freeLuggage = getFreeLuggage(flightBooking);
            var luggageOptions = flightBooking.luggageHandler.passengerOptions.getOptionByPaxType('ADT');

            var flightGeneralPayload = {
                flight_id: flightId,
                flight_price: currencyFilter(flightPrice),
                flight_currency: flightCurrency,
                flight_displayed_price: currencyFilter(flightDisplayedPrice),
                flight_displayed_transaction_fee: flightDisplayedTransactionFee,
                flight_total_displayed_price: currencyFilter(flightTotalDisplayedPrice),
                flight_search_results_position: null,
                flight_type: null,
                flight_sub_type: null,
                flight_category: null,

                number_of_paxes: numberOfPaxes,
                number_of_adults: numberOfAdults,
                number_of_children: numberOfChildren,
                number_of_infants: numberOfInfants,
                number_of_youth: numberOfYouth,

                payment_type: flightBooking.getPayment().type,
                payment_processing_fee: flightBooking.basket.getCheapestPaymentOption(),
                payment_taxes: currencyFilter(flightBooking.basket.getTotalPaymentFee(flightBooking.payment.type)),
                payment_currency: flightBooking.getPayment().type === 'CC' ? flightBooking.getPayment().creditCard.currency : AppConfig.getCurrencyCode(),
                total_price_paid_by_user: currencyFilter(getFlightTotalPrice(flightBooking)),
                original_total_price_displayed_to_user: currencyFilter(flightBooking.basket.getTotalPrice()),
                price_diff: hasPriceDiff(flightBooking),
                ab_test: flightBooking.flightDetails.abTests,
                provider_id: flightBooking.flightDetails.providerId,
                provider_branch: flightBooking.flightDetails.branch,

                paid_check_in: flightBooking.paidCheckin.isSelected(),
                check_in_type: getCheckinType(flightBooking.paidCheckinRules.checkinAirlineRules),
                check_in_price: currencyFilter(getCheckinPaxPrice(flightBooking)),
                check_in_total_price: currencyFilter(getCheckinTotalPrice(flightBooking)),

                insurance: selectedInsurance !== null,
                insurance_type: getInsuranceType(selectedInsurance),
                insurance_number_of_days: getInsuranceDays(selectedInsurance),
                insurance_price: currencyFilter(getInsurancePrice(selectedInsurance)),
                insurance_total_price: currencyFilter(getInsuranceTotalPrice(selectedInsurance)),

                refundable: flightBooking.refund.added === true,
                refundable_total_price: currencyFilter(flightBooking.refund.price),

                fast_refund: flightBooking.fastRefund.isSelected(),
                fast_refund_price: currencyFilter(flightBooking.fastRefund.getTotalPrice() / numberOfPaxes),
                fast_refund_total_price: currencyFilter(flightBooking.fastRefund.getTotalPrice()),

                cfar: flightBooking.cfar.isSelected(),
                cfar_price: currencyFilter(flightBooking.cfar.getTotalPrice() / numberOfPaxes),
                cfar_total_price: currencyFilter(flightBooking.cfar.getTotalPrice()),

                reservation_number: reservationNumber,

                seats: flightBooking.seatSelect.getTotalPrice() > 0,
                seats_total_price: currencyFilter(flightBooking.seatSelect.getTotalPrice()),
                seats_number_of_seats: flightBooking.seatSelect.getTotalSelections(),

                guarantee: flightBooking.tripGuarantee.isChosen(),
                guarantee_total_price: flightBooking.tripGuarantee.getPrice(),

                split_funnel_package_type: flightBooking.ticketType.getSelectedPackage() !== null ? flightBooking.ticketType.getSelectedPackage().type : null,
                split_funnel_package_id: flightBooking.ticketType.getSelectedPackage() !== null ? flightBooking.ticketType.getSelectedPackage().packageId : null,
                split_funnel_package_price: flightBooking.ticketType.getSelectedPackage() !== null ? flightBooking.ticketType.getSelectedPackage().price : null,
                split_funnel_package_includes: getSplitFunnelIncludes(flightBooking.ticketType),
                paid_contact: flightBooking.frolaAssistance.isSelected(),
                paid_contact_type: flightBooking.frolaAssistance.getSelectedPackage() !== null ? flightBooking.frolaAssistance.getSelectedPackage().type : null,
                paid_contact_price: flightBooking.frolaAssistance.getSelectedPackage() !== null ? flightBooking.frolaAssistance.getSelectedPackage().totalPrice : null,

                luggage_free_included: isFreeLuggageIncluded(freeLuggage),
                luggage_free_id: getFreeLuggageId(freeLuggage),
                luggage_free_type: getFreeLuggageType(freeLuggage),
                luggage_additional_hand_luggage: additionalHandLuggage.count > 0,
                luggage_additional_hand_luggage_total_price: currencyFilter(additionalHandLuggage.totalPrice),
                luggage_number_of_additional_hand_luggages: additionalHandLuggage.count,
                luggage_additional_checked_luggage: additionalCheckedLuggage.count > 0,
                luggage_additional_checked_luggage_total_price: currencyFilter(additionalCheckedLuggage.totalPrice),
                luggage_number_of_additional_checked_luggages: additionalCheckedLuggage.count,
                luggage_modifiers: flightBooking.luggageHandler.passengerOptions.getModifiers().join(','),
                luggage_is_available: isLuggageAvailable(luggageOptions),
                luggage_cabin_is_available: isLuggageTypeAvailable(luggageOptions, 'cabin'),
                luggage_checked_is_available: isLuggageTypeAvailable(luggageOptions, 'checked'),

                ibe_slot_version: flightBooking.flightDetails.abTests.hasOwnProperty('ibe_slot_version') ? flightBooking.flightDetails.abTests.ibe_slot_version : '',
                ibe_fee_version: flightBooking.flightDetails.abTests.hasOwnProperty('ibe_fee_version') ? flightBooking.flightDetails.abTests.ibe_fee_version : ''
            };

            flightGeneralPayload = underscore.extend(
                flightGeneralPayload,
                getPaxFlightLegPayload(flightBooking.basket.flightDetails.getDepLeg(), 'departure')
            );

            if (flightBooking.basket.flightDetails.isRoundTrip()) {
                flightGeneralPayload = underscore.extend(
                    flightGeneralPayload,
                    getPaxFlightLegPayload(flightBooking.basket.flightDetails.getRetLeg(), 'return')
                );
            }

            if (flightBooking.basket.flightDetails.getSearchResultId()) {
                flightGeneralPayload['search_results_id'] = flightBooking.basket.flightDetails.getSearchResultId();
            }

            return flightGeneralPayload;
        };

        /**
         * Returns price group leg payload
         *
         * @param {Leg} leg
         * @param {String} alias
         */
        var getPaxFlightLegPayload = function (leg, alias) {
            var legPayload = {};

            /**
             * Sets an alias entry on the payload object
             *
             * @param {String} name
             * @param {Any} value
             */
            var setAliasEntry = function (name, value) {
                legPayload['flight_' + alias + '_' + name] = value;
            };

            var legFromMomentDate = getMomentDate(leg.getDepDateTime());
            var legToMomentDate = getMomentDate(leg.getArrDateTime());
            var legStayTimeMinutes = underscore.reduce(leg.getSegments(), function (sum, segment) {
                return sum + segment.getLayoverDur();
            }, 0);

            setAliasEntry('carrier', { carrier: leg.getCarriers() });
            setAliasEntry('duration', leg.dur);
            setAliasEntry('duration_hours', Math.round(leg.dur / 60));
            setAliasEntry('no_of_layovers', leg.getStops());
            setAliasEntry('night_flight', leg.getOvernightSegments().length > 0);
            setAliasEntry('same_carrier', leg.getCarriers().length === 1);
            setAliasEntry('stay_time', legStayTimeMinutes);
            setAliasEntry('stay_time_hours', Math.round(legStayTimeMinutes / 60));
            setAliasEntry('layovers_data', { layovers: JSON.parse(angular.toJson(getPaxLegSegments(leg.segments))) });
            setAliasEntry('fit_to_search_query', !leg.isArriveAnotherDay());

            setAliasEntry('from_time', moment(leg.getDepDateTime()).format('HH:mm'));
            setAliasEntry('from_hour', getRoundedHour(leg.getDepDateTime()));
            setAliasEntry('from_date', legFromMomentDate.date);
            setAliasEntry('from_date_month', legFromMomentDate.month);
            setAliasEntry('from_date_week', legFromMomentDate.week);
            setAliasEntry('from_date_year', legFromMomentDate.year);
            setAliasEntry('from_date_day', legFromMomentDate.day);
            setAliasEntry('from_city_code', leg.getDepCityCode());
            setAliasEntry('from_airport_code', leg.getFirstSegment().getDepAirportCode());

            setAliasEntry('to_time', moment(leg.getArrDateTime()).format('HH:mm'));
            setAliasEntry('to_hour', getRoundedHour(leg.getArrDateTime()));
            setAliasEntry('to_date', legToMomentDate.date);
            setAliasEntry('to_date_month', legToMomentDate.month);
            setAliasEntry('to_date_week', legToMomentDate.week);
            setAliasEntry('to_date_year', legToMomentDate.year);
            setAliasEntry('to_date_day', legToMomentDate.day);
            setAliasEntry('to_city_code', leg.getArrCityCode());
            setAliasEntry('to_airport_code', leg.getLastSegment().getArrAirportCode());

            return legPayload;
        };

        /**
         * Returns segment information
         *
         * @param {Object[]} stageSegments
         * @returns {Object[]}
         */
        var getShelfStageSegments = function (stageSegments) {
            var segments = [];

            angular.forEach(stageSegments, function (segment) {
                segments.push({
                    marketingCarrier: segment.operatingCarrier === segment.marketingCarrier,
                    duration: segment.duration,
                    originCity: segment.originCity,
                    destinationCity: segment.destinationCity,
                    originAirport: segment.originAirport,
                    destinationAirport: segment.destinationAirport,
                    departure: moment(segment.departure).format('YYYY-MM-DDTHH:mm:ss'),
                    arrival: moment(segment.arrival).format('YYYY-MM-DDTHH:mm:ss'),
                    flightNumber: segment.flightNumber,
                    equipment: null,
                    stopovers: segment.stopovers
                });
            });

            return segments;
        };

        /**
         * Returns segment information
         *
         * @param {Object[]} stageSegments
         * @returns {Object[]}
         */
        var getPaxLegSegments = function (legSegments) {
            return underscore.map(legSegments, function (segment) {
                return {
                    marketingCarrier: segment.carr === segment.mktgCarr,
                    duration: segment.dur,
                    originCity: Dictionaries.getCityCodeByAirportCode(segment.dep),
                    destinationCity: Dictionaries.getCityCodeByAirportCode(segment.arr),
                    originAirport: segment.dep,
                    destinationAirport: segment.arr,
                    departure: moment(segment.depT).format('YYYY-MM-DDTHH:mm:ss'),
                    arrival: moment(segment.arrT).format('YYYY-MM-DDTHH:mm:ss'),
                    flightNumber: segment.fNum,
                    equipment: null,
                    stopovers: segment.stops
                };
            });
        };

        /**
         * Returns payload common for all events
         *
         * @returns {Object}
         */
        var getCommonPayload = function () {
            var appVersionParts = AppConfig.getAppVersion().split('.');
            var fingerprint = getUserFingerprint();

            return {
                timestamp: Date.now() / 1000,
                affiliate: AppConfig.getAffiliateName(),
                app_version: appVersionParts[0] + '.' + appVersionParts[1],
                app_ab_version: AppConfig.getAppAbVersion(),
                app_market: AppConfig.getMarket(),
                fingerprint: JSON.stringify(fingerprint)
            };
        };

        /**
         * Returns customer information payload
         *
         * @param {String} customerEmail
         * @returns {Object}
         */
        var getCustomerPayload = function (customerEmail) {
            return {
                flight_customer_email: customerEmail
            };
        };

        /**
         * Returns seats uuid
         *
         * @param {Booking} flightBooking
         * @returns {Object}
         */
        var getSeatWidgetUuidPayload = function (flightBooking) {
            return {
                seats_basket_uuid: flightBooking.seatsInitialData.basketUuid
            };
        };

        /**
         * Returns seats uuid
         *
         * @param {Verification} verify
         * @returns {Object}
         */
        var getVerifyPayload = function (verify) {
            return {
                test_sell_verification_id: verify.getVerificationId(),
                test_sell_status: verify.getStatusInt(),
                test_sell_status_const: verify.getStatusStr(),
            };
        };

        /**
         * Sends search data to BQ endpoint
         *
         * @param {Number} index
         * @param {FlightOfferModel} flightData
         * @param {SouthParkHelper} spHelper
         * @param {SearchQueryParams} sqp
         */
        this.sendSearchData = function (index, flightData, spHelper, sqp) {
            try {
                var commonPayload = getCommonPayload();
                var searchPayload = getShelfSearchPayload(spHelper, sqp);
                var flightPayload = getShelfFlightPayload(flightData, index);
                var customerPayload = getCustomerPayload(null);

                // Save search analytics data to local storage
                $localStorage.shelfSearchAnalytics = {
                    travelHash: flightData.travelHash,
                    payload: searchPayload
                };

                AnalyticsServiceApi.postMessage(
                    'user_select_flight',
                    JSON.stringify(underscore.extend(
                        commonPayload,
                        searchPayload,
                        flightPayload,
                        customerPayload
                    ))
                );
            } catch (error) {
                $log.error(error);
            }
        };

        /**
         * Event sent when user opens seat wisget
         *
         * @param {Booking} flightBooking
         */
        this.sendSeatWidgetOpen = function (flightBooking) {
            var commonPayload = getCommonPayload();
            var searchPayload = getPaxSearchPayload(flightBooking.flightDetails.travelHash);
            var flightDetailsPayload = getFlightDetailsPayload(flightBooking, '');
            var customerPayload = getCustomerPayload(null);
            var seatUuidPayload = getSeatWidgetUuidPayload(flightBooking);

            AnalyticsServiceApi.postMessage(
                'user_open_seat_widget',
                JSON.stringify(underscore.extend(
                    commonPayload,
                    searchPayload,
                    flightDetailsPayload,
                    customerPayload,
                    seatUuidPayload
                ))
            );
        };

        /**
         * Event sent when TS ends
         *
         * @param {Booking} flightBooking
         */
        this.sendTestSellFinished = function (flightBooking) {
            var commonPayload = getCommonPayload();
            var searchPayload = getPaxSearchPayload(flightBooking.flightDetails.travelHash);
            var flightDetailsPayload = getFlightDetailsPayload(flightBooking, '');
            var customerPayload = getCustomerPayload(null);
            var verifyPayload = getVerifyPayload(flightBooking.flightDetails.verification);

            AnalyticsServiceApi.postMessage(
                'flight_details_test_sell_finished',
                JSON.stringify(underscore.extend(
                    commonPayload,
                    searchPayload,
                    flightDetailsPayload,
                    customerPayload,
                    verifyPayload
                ))
            );
        };

        /**
         * Event sent when TS modal displayed
         *
         * @param {Booking} flightBooking
         */
        this.sendTestSellModalDisplayed = function (flightBooking) {
            var commonPayload = getCommonPayload();
            var searchPayload = getPaxSearchPayload(flightBooking.flightDetails.travelHash);
            var flightDetailsPayload = getFlightDetailsPayload(flightBooking, '');
            var customerPayload = getCustomerPayload(null);
            var verifyPayload = getVerifyPayload(flightBooking.flightDetails.verification);

            AnalyticsServiceApi.postMessage(
                'flight_details_test_sell_modal_displayed',
                JSON.stringify(underscore.extend(
                    commonPayload,
                    searchPayload,
                    flightDetailsPayload,
                    customerPayload,
                    verifyPayload
                ))
            );
        };

        /**
         * Event sent when TS price diff accepted
         *
         * @param {Booking} flightBooking
         */
        this.sendTestSellPriceDiffAccepted = function (flightBooking) {
            var commonPayload = getCommonPayload();
            var searchPayload = getPaxSearchPayload(flightBooking.flightDetails.travelHash);
            var flightDetailsPayload = getFlightDetailsPayload(flightBooking, '');
            var customerPayload = getCustomerPayload(null);
            var verifyPayload = getVerifyPayload(flightBooking.flightDetails.verification);

            AnalyticsServiceApi.postMessage(
                'flight_details_test_sell_price_diff_accepted',
                JSON.stringify(underscore.extend(
                    commonPayload,
                    searchPayload,
                    flightDetailsPayload,
                    customerPayload,
                    verifyPayload
                ))
            );
        };

        /**
         * Sends pax data to BQ endpoint
         *
         * @param {Booking} flightBooking
         * @param {String} reservationNumber
         */
        this.sendPaxData = function (flightBooking, reservationNumber) {
            try {
                var commonPayload = getCommonPayload();
                var searchPayload = getPaxSearchPayload(flightBooking.flightDetails.travelHash);
                var flightDetailsPayload = getFlightDetailsPayload(flightBooking, reservationNumber);
                var customerPayload = getCustomerPayload(flightBooking.getContact().getEmail());
                var seatUuidPayload = getSeatWidgetUuidPayload(flightBooking);
                var verifyPayload = getVerifyPayload(flightBooking.flightDetails.verification);

                searchPayload.search_bought = true;

                AnalyticsServiceApi.postMessage(
                    'user_book_flight',
                    JSON.stringify(underscore.extend(
                        commonPayload,
                        searchPayload,
                        flightDetailsPayload,
                        customerPayload,
                        seatUuidPayload,
                        verifyPayload
                    ))
                );
            } catch (error) {
                $log.error(error);
            }
        };
    };

    IthAnalyticsServiceHelper.$inject = [
        '$window',
        '$location',
        '$localStorage',
        '$log',
        'appConfig',
        'AuthService',
        'AnalyticsServiceApi',
        'Dictionaries',
        'AutomatedCheckinHelper',
        'IbeLuggageSummaryHelper'
    ];

    angular
        .module('funnel')
        .service('AnalyticsServiceHelper', IthAnalyticsServiceHelper);

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/funnel/services/ExploreModeService.js
(function (angular) {

    var ExploreModeService = function (SouthParkApi, SouthParkPayload, SouthParkSession, SearchQueryParams, appConfig) {
        this.getResults = function (pollingId) {
            var payload = SouthParkPayload.makePayloadFromSearchQueryParams(SearchQueryParams);

            if (!pollingId) {
                return SouthParkApi.initSearch(
                    appConfig.getAffiliateName(),
                    payload,
                    SouthParkSession.get(),
                    false
                );
            }

            return SouthParkApi.exploreModePollSearch(pollingId)
        };
    };

    ExploreModeService.$inject = [
        'SouthParkApi',
        'SouthParkPayload',
        'SouthParkSession',
        'sch.SearchQueryParams',
        'appConfig'
    ];

    angular
        .module('funnel')
        .service('ExploreModeService', ExploreModeService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/FunnelErrorLogCollector.service.js
(function(angular) {
var FunnelErrorLogCollectorService = function (LogCollectorServ) {
        /**
         *
         * @param {ngForm} contactForm
         * @param {Object} data
         */
        var collectContactFormErrors = function (contactForm, data) {
            if (contactForm.$valid) {
                return;
            }

            data.contactInfo = [];

            if (contactForm.email.$invalid) {
                data.contactInfo.push({
                    Invalid_email: {
                        value: contactForm.email.$viewValue
                    }
                });
            }
            if (contactForm.phone.$invalid) {
                data.contactInfo.push({
                    Invalid_phone_number: {
                        value: contactForm.phoneNumber.$viewValue
                    }
                });
            }
        };

        /**
         *
         * @param {ngForm} bookingForm
         * @param {Object} data
         */
        var collectPassengerFormsLogs = function (bookingForm, data) {
            var passengerFormKeys = [];

            Object.keys(bookingForm).forEach(function (key) {
                if (key.includes('passengerDetails')) {
                    passengerFormKeys.push(key);
                }
            });

            passengerFormKeys.forEach(function (passengerFormKey) {
                collectPassengerFormLogs(bookingForm[passengerFormKey], data);
            });
        };

        var getDateFieldValue = function (passengerForm, dateFieldName) {
            var dayValue = passengerForm[dateFieldName + 'Day'].$viewValue || 'x';
            var monthValue = passengerForm[dateFieldName + 'Month'].$viewValue || 'x';
            var yearValue = passengerForm[dateFieldName + 'Year'].$viewValue || 'x';

            return dayValue + '-' + monthValue + '-' + yearValue;
        };

        /**
         *
         * @param {ngForm} passengerForm
         * @param {Object} data
         */
        var collectPassengerFormLogs = function (passengerForm, data) {
            if (passengerForm.$valid) {
                return;
            }

            if (!data.hasOwnProperty('pax')) {
                data.pax = [];
            }

            var passengerIndex = parseInt(passengerForm.$name.replace('passengerDetails', ''));
            var passengerNumber = passengerIndex + 1;
            var tmp = {};

            if (passengerForm.firstName.$invalid) {
                tmp['Invalid_name_p_no_' + passengerNumber] = {
                    value: passengerForm.firstName.$viewValue
                };
            }

            if (passengerForm.lastName.$invalid) {
                tmp['Invalid_last_name_p_no_' + passengerNumber] = {
                    value: passengerForm.lastName.$viewValue
                };
            }

            if (passengerForm.birthDate && passengerForm.birthDate.$invalid) {
                tmp['Invalid_person_birthDate_no_' + passengerNumber] = {
                    value: getDateFieldValue(passengerForm, 'birthDate')
                };
            }

            // Id card number
            var govIdNumberFieldName = 'govIdNumber-' + passengerIndex;

            if (passengerForm[govIdNumberFieldName] && passengerForm[govIdNumberFieldName].$invalid) {
                tmp['Invalid_person_passportNumber_p_no_' + passengerNumber] = {
                    value: passengerForm[govIdNumberFieldName].$viewValue
                };
            }

            // Id card issue
            var govIdIssueFieldName = 'govIdIssue--' + passengerIndex;
            var govIdIssueField = passengerForm[govIdIssueFieldName] || null;

            if (govIdIssueField && govIdIssueField.$invalid) {
                tmp['Invalid_person_passportIssue_no_' + passengerNumber] = {
                    value: getDateFieldValue(passengerForm, govIdIssueFieldName)
                };
            }

            // Id card expiration
            var govIdExpirationFieldName = 'govIdExpiration--' + passengerIndex;
            var govIdExpirationField = passengerForm[govIdExpirationFieldName] || null;

            if (govIdExpirationField && govIdExpirationField.$invalid) {
                tmp['Invalid_person_passportExp_no_' + passengerNumber] = {
                    value: getDateFieldValue(passengerForm, govIdExpirationFieldName)
                };
            }

            data.pax.push(tmp);
        };

        var collectPersonalBillingFormLogs = function (personalBillingForm, data) {
            if (personalBillingForm.$valid) {
                return;
            }

            data.billingForm = [];

            if (personalBillingForm.city.$invalid) {
                data.billingForm.push({
                    Invalid_personal_city: {
                        value: personalBillingForm.city.$viewValue
                    }
                });
            }

            if (personalBillingForm.cnp && personalBillingForm.cnp.$invalid) {
                data.billingForm.push({
                    Invalid_personal_cnp: {
                        value: personalBillingForm.cnp.$viewValue
                    }
                });
            }

            if (personalBillingForm.country.$invalid) {
                data.billingForm.push({
                    Invalid_personal_country: {
                        value: personalBillingForm.country.$viewValue
                    }
                });
            }

            if (personalBillingForm.county.$invalid) {
                data.billingForm.push({
                    Invalid_personal_province: {
                        value: personalBillingForm.county.$viewValue
                    }
                });
            }

            if (personalBillingForm.firstName.$invalid) {
                data.billingForm.push({
                    Invalid_personal_firstName: {
                        value: personalBillingForm.firstName.$viewValue
                    }
                });
            }

            if (personalBillingForm.lastName.$invalid) {
                data.billingForm.push({
                    Invalid_personal_lastName: {
                        value: personalBillingForm.lastName.$viewValue
                    }
                });
            }

            if (personalBillingForm.street.$invalid) {
                data.billingForm.push({
                    Invalid_personal_street: {
                        value: personalBillingForm.street.$viewValue
                    }
                });
            }
        };

        var collectCompanyBillingFormLogs = function (companyBillingForm, data) {
            if (companyBillingForm.$valid) {
                return;
            }

            data.billingForm = [];

            if (companyBillingForm.name.$invalid) {
                data.billingForm.push({
                    Invalid_company_name: {
                        value: companyBillingForm.name.$viewValue
                    }
                });
            }

            if (companyBillingForm.city.$invalid) {
                data.billingForm.push({
                    Invalid_company_city: {
                        value: companyBillingForm.city.$viewValue
                    }
                });
            }

            if (companyBillingForm.vatNumber.$invalid) {
                data.billingForm.push({
                    Invalid_company_vatNumber: {
                        value: companyBillingForm.vatNumber.$viewValue
                    }
                });
            }

            if (companyBillingForm.street.$invalid) {
                data.billingForm.push({
                    Invalid_company_street: {
                        value: companyBillingForm.street.$viewValue
                    }
                });
            }

            if (companyBillingForm.zipCode && companyBillingForm.zipCode.$invalid) {
                data.billingForm.push({
                    Invalid_company_zipCode: {
                        value: companyBillingForm.zipCode.$viewValue
                    }
                });
            }

            if (companyBillingForm.country.$invalid) {
                data.billingForm.push({
                    Invalid_company_country: {
                        value: companyBillingForm.country.$viewValue
                    }
                });
            }

            if (companyBillingForm.province && companyBillingForm.province.$invalid) {
                data.billingForm.push({
                    Invalid_company_province: {
                        value: companyBillingForm.province.$viewValue
                    }
                });
            }
        };

        /**
         *
         * @param {ngForm} bookingForm
         * @param {Object} data
         */
        var collectBillingFormLogs = function (bookingForm, data) {
            if (bookingForm.billingPerson) {
                collectPersonalBillingFormLogs(bookingForm.billingPerson, data);
            }

            if (bookingForm.collectCompanyBillingFormLogs) {
                collectCompanyBillingFormLogs(bookingForm.billingCompany, data);
            }
        };

        /**
         *
         * @param {ngForm} bookingForm
         * @param {Object} data
         */
        var collectPaymentFormLogs = function (bookingForm, data) {
            if (!bookingForm.paymentInfo.creditCardForm || bookingForm.paymentInfo.creditCardForm.$valid) {
                return;
            }

            var paymentForm = bookingForm.paymentInfo.creditCardForm;
            data.creditCard = [];

            if (paymentForm.cardnumber.$invalid) {
                data.creditCard.push({
                    Invalid_cc_number: {
                        value: paymentForm.cardnumber.$viewValue ? '***' : ''
                    }
                });
            }

            if (paymentForm.cvc.$invalid) {
                data.creditCard.push({
                    Invalid_cc_cvc: {
                        value: paymentForm.cvc.$viewValue ? '***' : ''
                    }
                });
            }

            if (paymentForm.fullName.$invalid) {
                data.creditCard.push({
                    Invalid_cc_name: {
                        value: paymentForm.fullName.$viewValue
                    }
                });
            }

            if (paymentForm.expiration.$invalid) {
                data.creditCard.push({
                    Invalid_cc_exp: {
                        value: paymentForm.expiration.$viewValue
                    }
                });
            }
        };

        /**
         *
         * @param {ngForm} bookingForm
         */
        this.collect = function (bookingForm) {
            var data = {};

            collectContactFormErrors(bookingForm.contactInfo, data);
            collectPassengerFormsLogs(bookingForm, data);
            collectBillingFormLogs(bookingForm, data);
            collectPaymentFormLogs(bookingForm, data);

            LogCollectorServ.sendErrorLogs(data);
        };

        return this;
    };

    FunnelErrorLogCollectorService.$inject = ['LogCollectorServ'];

    angular
        .module('funnel')
        .factory('FunnelErrorLogCollector', FunnelErrorLogCollectorService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/IataDictionary.factory.js
(function(angular, underscore) {
var IataDictionaryFactory = function () {
        /**
         * @constructor
         */
        function IataDictionary() {
            this.database = {};
        }

        /**
         * Inserts dictionary database
         *
         * @param {Object} database
         */
        IataDictionary.prototype.populate = function (database) {
            this.database = database;
        };

        /**
         * Returns the raw database object
         *
         * @returns {Object}
         */
        IataDictionary.prototype.getDatabase = function () {
            return this.database;
        };

        /**
         * Checks if database is empty
         *
         * @returns {boolean}
         */
        IataDictionary.prototype.isPopulated = function () {
            return this.database !== {};
        };

        /**
         * Returns airline name by code
         *
         * @param {string} airlineCode
         * @returns {string}
         */
        IataDictionary.prototype.getAirlineName = function (airlineCode) {
            return getDatabasePropertyValue(this.database, 'airlines', airlineCode);
        };

        /**
         * Returns airport name by code
         *
         * @param {string} airportCode
         * @returns {string}
         */
        IataDictionary.prototype.getAirportName = function (airportCode) {
            return getDatabasePropertyValue(this.database, 'airports', airportCode);
        };

        /**
         * Returns city name by code
         *
         * @param {string} cityCode
         * @returns {string}
         */
        IataDictionary.prototype.getCityName = function (cityCode) {
            return getDatabasePropertyValue(this.database, 'cities', cityCode);
        };

        /**
         * Returns country name by code
         *
         * @param {string} countryCode
         * @returns {string}
         */
        IataDictionary.prototype.getCountryName = function (countryCode) {
            return getDatabasePropertyValue(this.database, 'countries', countryCode);
        };

        /**
         * Returns a short version of the database containing only data
         * present in the flight offer list because binding the whole database
         * to each flight component crippled the performance
         *
         * @param {Object[]} flightOffers
         * @returns {Object}
         */
        IataDictionary.prototype.getShort = function (flightOffers) {
            var self = this;
            var airlines = [];
            var airports = [];
            var cities = [];
            var continents = [];
            var countries = [];
            var planes = [];

            underscore.each(flightOffers, function (flightOffer) {
                underscore.each(flightOffer.stages, function (stage) {
                    cities.push(stage.originCity, stage.destinationCity);

                    underscore.each(stage.segments, function (segment) {
                        cities.push(segment.originCity, segment.destinationCity);
                        airports.push(segment.originAirport, segment.destinationAirport);
                        airlines.push(segment.marketingCarrier, segment.operatingCarrier);
                    });
                });
            });

            var _cities = {};
            var _airports = {};
            var _airlines = {};

            underscore.each(underscore.uniq(cities), function (city) {
                _cities[city] = self.database.cities[city];
            });

            underscore.each(underscore.uniq(airports), function (airport) {
                _airports[airport] = self.database.airports[airport];
            });

            underscore.each(underscore.uniq(airlines), function (airline) {
                _airlines[airline] = self.database.airlines[airline];
            });

            return {
                cities: _cities,
                airports: _airports,
                airlines: _airlines,
                continents: {},
                countries: {},
                planes: {}
            };
        };

        /**
         * Retrieves a translation from dictionary
         *
         * @param {Object[]} database
         * @param {string} property
         * @param {string} key
         * @returns {string}
         */
        var getDatabasePropertyValue = function (database, property, key) {
            if (!database.hasOwnProperty(property)) {
                return key;
            }

            return database[property][key] || key;
        };

        IataDictionary.prototype.constructor = IataDictionary;

        return IataDictionary;
    };

    angular
        .module('funnel')
        .factory('IataDictionary', IataDictionaryFactory);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/services/IndexedDbExpiryCache.factory.js
(function(angular, indexedDB) {
/**
     * Class responsible for storing data in IndexedDB with expiration date
     * and auto removal
     */
    var IndexedDbExpiryCacheFactory = function ($q) {
        /**
         * @constructor
         *
         * @param {String} dbName
         */
        var ExpiryCache = function (dbName) {
            this.dbName = dbName;
            this.tableName = null;
            this.keyPath = 'id';
            this.cacheDuration = 1800;
            this.version = 1;
            this.indexes = [];
            return this;
        };

        /**
         * @constructor
         */
        ExpiryCache.prototype.constructor = ExpiryCache;

        /**
         * Sets a table name
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setTableName = function (value) {
            this.tableName = value;
            return this;
        };

        /**
         * Sets a table key path
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setKeyPath = function (value) {
            this.keyPath = value;
            return this;
        };

        /**
         * Sets the entry cache duration
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setCacheDuration = function (value) {
            this.cacheDuration = value;
            return this;
        };

        /**
         * Sets a table version
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setVersion = function (value) {
            this.version = value;
            return this;
        };

        /**
         * Adds a table index
         *
         * @param {String} name
         * @param {String} keyPath
         * @param {Object} params
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.addIndex = function (name, keyPath, params) {
            this.indexes.push({
                name: name,
                keyPath: keyPath,
                params: params
            });
            return this;
        };

        /**
         * Opens a new indexedDB database
         *
         * @returns {Promise}
         */
        ExpiryCache.prototype.open = function () {
            var deferred = $q.defer();
            var db = null;
            var self = this;
            var request;

            try {
                request = indexedDB.open(
                    this.dbName,
                    this.version
                );
            } catch (e) {
                deferred.reject('IndexedDB is not supported');
                return deferred.promise;
            }

            request.onerror = function () {
                deferred.reject('IndexedDB error');
            };

            request.onsuccess = function (event) {
                db = event.target.result;
                deferred.resolve(db);
            };

            request.onupgradeneeded = function (event) {
                db = event.target.result;

                // Delete store?
                if (db.objectStoreNames.contains(self.tableName)) {
                    db.deleteObjectStore(self.tableName);
                }

                // Create store
                var objectStore = db.createObjectStore(
                    self.tableName,
                    { keyPath: self.keyPath }
                );

                // Add indexes
                angular.forEach(self.indexes, function (index) {
                    objectStore.createIndex(index.name, index.keyPath, index.params);
                });
            };

            return deferred.promise;
        };

        /**
         * Inserts one entry
         *
         * @param {String} id
         * @param {Object} entity
         * @returns {Promise}
         */
        ExpiryCache.prototype.insertOne = function (id, entity) {
            entity[this.keyPath] = id;
            return this.insertMany([entity]);
        };

        /**
         * Inserts multiple entries
         *
         * @param {Object[]} entities
         * @returns {Promise}
         */
        ExpiryCache.prototype.insertMany = function (entities) {
            var self = this;
            var deferred = $q.defer();

            this
                .open()
                .then(function (db) {
                    var store = db
                        .transaction([self.tableName], 'readwrite')
                        .objectStore(self.tableName);

                    angular.forEach(entities, function (entity) {
                        // Add exipry date
                        entity.expires = Date.now() + self.cacheDuration;

                        // Insert in DB
                        store.put(entity);
                    });

                    deferred.resolve();
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        /**
         * Returns an entry by key
         *
         * @param {String} key
         * @returns {Promise}
         */
        ExpiryCache.prototype.get = function (key) {
            var deferred = $q.defer();
            var self = this;

            this
                .open()
                .then(function (db) {
                    var store = db
                        .transaction([self.tableName])
                        .objectStore(self.tableName);

                    var request = store.get(key);

                    request.onsuccess = function (e) {
                        var result = e.target.result;

                        if (result && result.expires <= Date.now()) {
                            // Remove expired entry
                            self.remove(result[self.keyPath]);
                            deferred.resolve(null);
                            return;
                        }

                        if (result) {
                            deferred.resolve(result);
                        }

                        deferred.resolve(null);
                    };

                    request.onerror = function (e) {
                        deferred.reject(e);
                    };
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        /**
         * Returns all entries
         *
         * @returns {Promise}
         */
        ExpiryCache.prototype.getCursor = function () {
            var deferred = $q.defer();
            var self = this;

            this
                .open()
                .then(function (db) {
                    var store = db
                        .transaction([self.tableName])
                        .objectStore(self.tableName);

                    var request = store.openCursor();
                    var validEntries = [];
                    var expiredEntries = [];

                    request.onsuccess = function (e) {
                        var cursor = e.target.result;

                        if (cursor) {
                            var expired = cursor.value.expires <= Date.now();

                            if (expired) {
                                expiredEntries.push(cursor.value);
                            }

                            if (!expired) {
                                validEntries.push(cursor.value);
                            }

                            cursor.continue();
                            return;
                        }

                        deferred.resolve(validEntries);

                        // Remove expired entries
                        angular.forEach(expiredEntries, function (expiredEntry) {
                            self.remove(expiredEntry[self.keyPath]);
                        });
                    };

                    request.onerror = function (e) {
                        deferred.reject(e);
                    };
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        /**
         * Removes an entry by key
         *
         * @param {*} key
         * @returns {Promise}
         */
        ExpiryCache.prototype.remove = function (key) {
            var deferred = $q.defer();
            var self = this;

            this
                .open()
                .then(function (db) {
                    var request = db
                        .transaction([self.tableName], 'readwrite')
                        .objectStore(self.tableName)
                        .delete(key);

                    request.onsuccess = function (e) {
                        deferred.resolve(e);
                    };

                    request.onerror = function (e) {
                        deferred.reject(e);
                    };
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        /**
         * Empties this database
         *
         * @returns {Promise}
         */
        ExpiryCache.prototype.empty = function () {
            var self = this;
            var deferred = $q.defer();

            this
                .getCursor()
                .then(function (results) {
                    angular.forEach(results, function (result) {
                        self
                            .remove(result[self.keyPath])
                            .catch(function (error) {
                                deferred.reject(error);
                            });
                    });

                    deferred.resolve();
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        };

        return ExpiryCache;
    };

    IndexedDbExpiryCacheFactory.$inject = [
        '$q'
    ];

    angular
        .module('funnel')
        .factory('IndexedDbExpiryCache', IndexedDbExpiryCacheFactory);

}(angular, indexedDB));
;

// Source: ../shared/public_html/assets/js/funnel/services/MemoryExpiryCache.factory.js
(function(angular, underscore) {
var MemoryExpiryCacheFactory = function ($q) {
        /**
         * Constructor
         */
        var ExpiryCache = function () {
            this.db = [];
            this.keyPath = 'id';
            this.cacheDuration = 1800;
        };

        /**
         * @constructor
         */
        ExpiryCache.prototype.constructor = ExpiryCache;

        /**
         * Sets a table name
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setTableName = function (value) {
            // Do nothing
            return this;
        };

        /**
         * Sets cache duration for entries
         *
         * @param {Number} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setCacheDuration = function (value) {
            this.cacheDuration = value;
            return this;
        };

        /**
         * Sets a table key path
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setKeyPath = function (value) {
            this.keyPath = value;
            return this;
        };

        /**
         * Sets a table version
         *
         * @param {String} value
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.setVersion = function (value) {
            // Do nothing
            return this;
        };

        /**
         * Adds a table index
         *
         * @param {String} name
         * @param {String} keyPath
         * @param {Object} params
         * @returns {ExpiryCache}
         */
        ExpiryCache.prototype.addIndex = function (name, keyPath, params) {
            // Do nothing
            return this;
        };

        /**
         * Insert one entry in memory
         *
         * @param {String} id
         * @param {Object} payload
         */
        ExpiryCache.prototype.insertOne = function (id, payload) {
            var deferred = $q.defer();

            try {
                payload[this.keyPath] = id;
                payload.expires = Date.now() + this.cacheDuration;
                this.db.push(payload);
                deferred.resolve();
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        /**
         * Returns an cache entry by id
         *
         * @param {String} id
         * @returns {Object}
         */
        ExpiryCache.prototype.get = function (id) {
            var deferred = $q.defer();
            var self = this;

            try {
                var foundEntry = underscore.find(this.db, function (entry) {
                    return entry[self.keyPath] === id;
                });

                if (foundEntry !== undefined) {
                    if (foundEntry.expiries <= Date.now()) {
                        // Remove expired entry
                        this.remove(id);
                        deferred.resolve(null);
                        return deferred.promise;
                    }

                    deferred.resolve(foundEntry);
                    return deferred.promise;
                }

                deferred.resolve(null);
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        /**
         * Empties cache
         */
        ExpiryCache.prototype.empty = function () {
            var deferred = $q.defer();

            try {
                this.db = [];
                deferred.resolve();
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        /**
         * Removes a cache entry by id
         *
         * @param {String} id
         */
        ExpiryCache.prototype.remove = function (id) {
            var deferred = $q.defer();
            var self = this;

            try {
                this.db = underscore.reject(this.db, function (entry) {
                    return entry[self.keyPath] !== id;
                });
                deferred.resolve();
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        /**
         * Returns all valid entries from cache
         *
         * @returns {Object[]}
         */
        ExpiryCache.prototype.getCursor = function () {
            var deferred = $q.defer();

            try {
                var valid = [];

                angular.forEach(this.db, function (entry) {
                    if (entry.expiries <= Date.now()) {
                        valid.push(entry);
                    }
                });

                deferred.resolve(valid);
            } catch (e) {
                deferred.reject(e);
            }

            return deferred.promise;
        };

        return ExpiryCache;
    };

    MemoryExpiryCacheFactory.$inject = ['$q'];

    angular
        .module('funnel')
        .factory('MemoryExpiryCache', MemoryExpiryCacheFactory);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/services/SouthPark.api.js
(function(angular) {
var SouthParkApi = function ($http, AppConfig, Monitoring) {
        /**
         * SouthPark API endpoints
         *
         * @type {Object}
         */
        var endpoints = {
            travelOffers: '/travelOffers/',
            agentTravelOffers: '/agent/travelOffers/',
            initTestSell: AppConfig.getUriPrefix() + '/api/testSell/verifyPolling?abv=' + AppConfig.getAppAbVersion(),
            pollTestSell: AppConfig.getUriPrefix() + '/api/testSell/verifyPolling?abv=' + AppConfig.getAppAbVersion(),
            finishTestSell: AppConfig.getUriPrefix() + '/api/testSell/finishPolling?abv=' + AppConfig.getAppAbVersion(),
            finishFulfilmentOfferTestSell: AppConfig.getUriPrefix() + '/api/testSell/finishFulfilmentOfferTestSell?abv=' + AppConfig.getAppAbVersion(),
            finishTestSellTimeout: AppConfig.getUriPrefix() + '/api/testSell/finishPollingTimeout?abv=' + AppConfig.getAppAbVersion(),
            offersEncoded: '/offers/encoded',
            iataDictionary: '/iataDictionary',
            flightDetailsRedirect: AppConfig.getUriPrefix() + '/api/offerDetails/prepareBasket?abv=' + AppConfig.getAppAbVersion(),
            prepareFulfilmentOffer: AppConfig.getUriPrefix() + '/api/offerDetails/prepareFulfilmentOffer?abv=' + AppConfig.getAppAbVersion(),
            fareLockPurchase: AppConfig.getUriPrefix() + '/api/fareLock/purchase?abv=' + AppConfig.getAppAbVersion(),
            offerVerify: '/offer/verify',
            mode: '/api/discovery/public/discover/mode',
            discover: '/discover'
        };

        /**
         * Returns header object for api endpoints
         *
         * @param {String} affiliate
         * @param {String} sessionHeader
         * @param {Boolean} searchDeduplicated
         * @param {Boolean} lang
         * @returns {Object}
         */
        var getHeaders = function (affiliate, sessionHeader, searchDeduplicated, lang) {
            var headers = {
                'content-type': 'application/json',
                'x-affiliate': affiliate || AppConfig.getAffiliateName()
            };

            if (searchDeduplicated === true) {
                headers['disableDeduplication'] = true;
            }

            if (AppConfig.getAbConfig().hasOwnProperty('ibe_slot_version') && AppConfig.getAbConfig().ibe_slot_version) {
                headers['slot'] = AppConfig.getAbConfig().ibe_slot_version;
            }

            if (sessionHeader) {
                headers['session'] = sessionHeader;
            }

            if (lang) {
                headers['Accept-Language'] = AppConfig.getUserLanguage()
            }

            return headers;
        };

        /**
         * @returns {{mode: 'SEARCH' | 'EXPLORE'}}
         */
        this.getMode = function (affiliate, payload, sessionHeader, searchDeduplicated) {
            return $http({
                method: 'POST',
                url: AppConfig.getShelfConfig().api + endpoints.mode,
                data: payload,
                headers: getHeaders(affiliate, sessionHeader, searchDeduplicated)
            });
        };

        this.initSearch = function (affiliate, payload, sessionHeader, searchDeduplicated) {
            return $http({
                method: 'POST',
                url: AppConfig.getShelfConfig().api + endpoints.discover,
                data: payload,
                headers: getHeaders(affiliate, sessionHeader, searchDeduplicated, true)
            });
        };

        this.exploreModePollSearch = function (pollingId) {
            return $http({
                method: 'GET',
                url: AppConfig.getShelfConfig().api + endpoints.discover + '/' + pollingId,
                headers: {
                    'Slot': AppConfig.getAbConfig().ibe_slot_version,
                    'Accept-Language': AppConfig.getUserLanguage()
                }
            });
        };

        /**
         * Makes additional request to flight search
         *
         * @param {String} affiliate
         * @param {String} id
         * @param {String} sessionHeader
         * @returns {Promise}
         */
        this.retrySearch = function (affiliate, id, sessionHeader) {
            var endpoint = AppConfig.isAgent() ? endpoints.agentTravelOffers : endpoints.travelOffers;

            return $http({
                method: 'GET',
                url: AppConfig.getShelfConfig().api + endpoint + id,
                headers: getHeaders(affiliate, sessionHeader, false),
            });
        };

        this.initTestSell = function (token, requestId, priceGroupId) {
            return $http({
                method: 'POST',
                url: endpoints.initTestSell,
                data: {
                    fulfillmentToken: token,
                    requestId: requestId,
                    priceGroupId: priceGroupId,
                },
                headers: getHeaders(),
            });
        };

        this.pollTestSell = function (id, token, requestData) {
            return $http({
                method: 'POST',
                url: endpoints.pollTestSell,
                data: {
                    fulfillmentToken: token,
                    verificationId: id,
                    requestId: requestData.requestId,
                    priceGroupId: requestData.priceGroupId,
                },
                headers: getHeaders(),
            });
        };

        this.finishTestSell = function (requestData) {
            return $http({
                method: 'POST',
                url: endpoints.finishTestSell,
                data: requestData,
            });
        };

        this.finishFulfilmentOfferTestSell = function (requestData) {
            return $http({
                method: 'POST',
                url: endpoints.finishFulfilmentOfferTestSell,
                data: requestData,
            });
        };

        this.finishTestSellTimeout = function (requestData) {
            return $http({
                method: 'POST',
                url: endpoints.finishTestSellTimeout,
                data: requestData,
            });
        };

        /**
         * Returns required document data
         *
         * @param {String} verifcationId
         * @param {String} nationality
         * @returns {Promise}
         */
        this.getRequiredDocument = function (verificationId, nationality) {
            return $http({
                method: 'GET',
                url: AppConfig.getShelfConfig().api + endpoints.offerVerify + '/' + verificationId + '/requiredDocument/' + nationality,
                headers: getHeaders()
            });
        };

        /**
         * Calls the offer verify endpoint
         *
         * @param {String} fulfillmentToken
         * @returns {Promise}
         */
        this.verifyOffer = function (fulfillmentToken) {
            return $http({
                method: 'POST',
                url: AppConfig.getShelfConfig().api + endpoints.offerVerify,
                headers: getHeaders(),
                data: { fulfillmentToken: fulfillmentToken }
            });
        };

        /**
         * Returns offer verification data
         *
         * @param {String} verificationId
         * @returns {Promise}
         */
        this.checkVerification = function (verificationId) {
            return $http({
                method: 'GET',
                url: AppConfig.getShelfConfig().api + endpoints.offerVerify + '/' + verificationId,
                headers: getHeaders()
            });
        };

        /**
         * Returns IATA dictionary
         *
         * @param {String} affiliate
         * @param {String} language
         */
        this.getIataDictionary = function (affiliate, language) {
            var commonHeaders = getHeaders(affiliate);
            commonHeaders['accept-language'] = language;

            return $http({
                method: 'GET',
                url: AppConfig.getShelfConfig().api + endpoints.iataDictionary,
                headers: commonHeaders
            });
        };

        /**
         * Returns flight details link from monolith API
         *
         * @param {String} requestId
         * @param {String} sessionId
         * @param {String} token
         * @returns {Promise}
         */
        this.getFlightDetailsLink = function (requestId, sessionId, token) {
            var request = {
                method: 'POST',
                url: endpoints.flightDetailsRedirect,
                data: {
                    requestId: requestId,
                    sessionId: sessionId,
                    token: token
                }
            };
            var httpPromise = $http(request);

            Monitoring.ngHttpCall(
                'prepareBasketHttp',
                httpPromise,
                function (response) {
                    return {
                        status: response.status,
                        url: request.url,
                        requestId: request.data.requestId,
                        sessionId: request.data.sessionId,
                        token: request.data.token,
                    };
                },
                function (httpCode) {
                    return httpCode < 200 || 300 < httpCode;
                }
            );

            return httpPromise;
        };

        this.getFulfilmentOfferUuid = function (token, orderingSource) {
            return $http({
                method: 'POST',
                url: endpoints.prepareFulfilmentOffer,
                data: {
                    ffToken: token,
                    orderingSource: orderingSource
                }
            });
        };

        return this;
    };

    SouthParkApi.$inject = [
        '$http',
        'appConfig',
        'Monitoring',
    ];

    angular
        .module('funnel')
        .service('SouthParkApi', SouthParkApi);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/SouthPark.helper.js
(function (angular, underscore) {
var SouthParkHelper = function ($q, $filter, $timeout, $localStorage, SouthParkApi, SouthParkFlightCache, SouthParkPayload, SouthParkSession, FlightOfferModel, SouthParkFilters, IataDictionary, TabFilterTypes, Remarketing, AppConfig, SearchQueryParams) {
        /**
         * Offers kept in the original form sent by IBE
         *
         * @type {Object[]}
         */
        this.originalOffers = [];

        /**
         * Offers sorted by best / cheapest / fastest
         *
         * @type {Object}
         */
        this.processedOffers = {
            /**
             * Offers sorted by best prop
             *
             * @type {Object[]}
             */
            best: [],

            bestByRoute: [],

            /**
             * Offers sorted by cheapest prop
             *
             * @type {Object[]}
             */
            cheapest: [],

            cheapestByRoute: [],

            /**
             * Offers sorted by fastest prop
             *
             * @type {Object[]}
             */
            fastest: [],

            fastestByRoute: []
        };

        this.uniquePerRouteOffers = {
            best: [],
            cheapest: [],
            fastest: []
        };

        this.availableOffersCount = 0;

        /**
         * Current active sorting tab
         *
         * @type {String}
         */
        this.activeSortingTab = TabFilterTypes.best;

        /**
         * Encoded query cached for next requests
         *
         * @type {String}
         */
        this.encodedQuery = '';

        /**
         * Deferred object for retry promises
         *
         * @type {Object}
         */
        this.deferred = null;

        /**
         * Iata dictionary instance
         *
         * @type {IataDictionary}
         */
        this.iataDictionary = new IataDictionary();

        /**
         * Loading flag
         *
         * @type {Boolean}
         */
        this.isLoading = false;

        /**
         * Refreshing flag
         *
         * @type {Boolean}
         */
        this.isRefreshing = false;

        /**
         * Flag for when an API error occurs
         *
         * @type {Boolean}
         */
        this.apiError = false;

        /**
         * Short dictionary (contains only data found on current offers)
         *
         * @type {Object}
         */
        this.shortDictionary = {};

        /**
         * Filters reference
         *
         * @type {SouthParkFilters}
         */
        this.filters = SouthParkFilters;

        /**
         * Sorting tabs array
         *
         * @type {Object[]}
         */
        this.sortingTabs = [];

        /**
         * IBE request id
         *
         * @type {String}
         */
        this.requestId = '';

        /**
         * Search UTC date
         *
         * @type {Date}
         */
        this.searchDate = null;

        /**
         * Minimum flight price
         *
         * @type {Number}
         */
        this.minPrice = 0;

        /**
         * Maximum flight price
         *
         * @type {Number}
         */
        this.maxPrice = 0;

        /**
         * Average flight price
         *
         * @type {Number}
         */
        this.avgPrice = 0;

        this.SouthParkSession = SouthParkSession;

        /**
         * Retry timer instance
         *
         * @type {Number}
         */
        var retryTimerId;

        /**
         * Search start time
         *
         * @type {Number}
         */
        var searchStartTime;

        /**
         * IBE request payload cached
         *
         * @type {Object}
         */
        var searchPayloadCache;

        /**
         * Self reference
         *
         * @type {SouthParkHelper}
         */
        var self = this;

        /**
         * Sorts and filters the best/cheapest/fastest offers
         * using an "intent" delay for increased performance
         */
        this.applyFilters = function () {
            $timeout(function () {
                var filteredCollection = getFilteredCollection();
                applySorting(filteredCollection);
                countAvailableOffers(filteredCollection);
                computeSortingTabs();
            }, 10);
        };

        /**
         * Initiates search sequence and sets proper flags
         */
        this.search = function () {
            this
                .loadDictionary()
                .then(function () {
                    self.reset();
                    initSearch();
                });
        };

        /**
         * Loads dictionary data from API and populates the IataDictionary class
         */
        this.loadDictionary = function () {
            self.reset();
            self.isLoading = true;
            var deferred = $q.defer();

            SouthParkFlightCache
                .getDictionary()
                .then(function (dictionaryCache) {
                    if (dictionaryCache !== null) {
                        setTimeout(function () {
                            self.iataDictionary.populate(dictionaryCache.data);
                            deferred.resolve();
                        }, 10);
                    }

                    if (dictionaryCache === null) {
                        SouthParkApi
                            .getIataDictionary(AppConfig.getAffiliateName(), AppConfig.getLanguageCode())
                            .then(function (success) {
                                var dict = {
                                    airlines: success.data.airlines,
                                    airports: success.data.airports,
                                    cities: success.data.cities,
                                    countries: success.data.countries,
                                    lang: success.data.lang
                                };

                                self.iataDictionary.populate(dict);
                                SouthParkFlightCache.addDictionary(dict);
                                deferred.resolve();
                            })
                            .catch(function () {
                                self.isLoading = false;
                                self.apiError = true;
                            });
                    }
                });

            return deferred.promise;
        };

        this.resetSession = function () {
            SouthParkSession.clear();
            SouthParkFlightCache.remove(JSON.stringify(searchPayloadCache));
            self.search();
        };

        /**
         * Resets all data
         */
        this.reset = function () {
            self.deferred = $q.defer();
            self.originalOffers = [];
            self.processedOffers.best = [];
            self.processedOffers.cheapest = [];
            self.processedOffers.fastest = [];
            self.uniquePerRouteOffers.best = [];
            self.uniquePerRouteOffers.cheapest = [];
            self.uniquePerRouteOffers.fastest = [];
            self.availableOffersCount = 0;
            self.encodedQuery = '';
            self.activeSortingTab = TabFilterTypes.best;
            self.apiError = false;
            self.searchDate = new Date();
            self.minPrice = 0;
            self.maxPrice = 0;
            self.avgPrice = 0;
            stopPreviousSearch();
        };

        /**
         * Computes new offers: updates all necessary data for search results
         *
         * @param {Object[]} newOffers
         */
        var computeOffers = function (newOffers) {
            var deferred = $q.defer();

            if (newOffers.length === 0) {
                deferred.resolve();
                return deferred.promise;
            }

            newOffers = underscore.map(newOffers, function (newOffer) {
                return new FlightOfferModel(newOffer);
            });

            SouthParkFlightCache
                .getBlacklist()
                .then(function (blacklist) {
                    // Remove blacklisted flights
                    var whitelistedOffers = underscore.reject(newOffers, function (offer) {
                        return underscore.contains(blacklist, offer.fulfillmentToken);
                    });

                    var deduplicatedNewOffers = underscore.map(
                        underscore.groupBy(newOffers, function (offer) {
                            return offer.uniqueId;
                        }),
                        function (group) {
                            return group[0];
                        }
                    );

                    // Remove new offers from old list (some flights get updated in later IBE iterations, newer is more relevant)
                    var deduplicatedOriginalOffers = underscore.reject(self.originalOffers, function (offer) {
                        var uniqueIdList = underscore.pluck(whitelistedOffers, 'uniqueId');
                        var contains = underscore.contains(uniqueIdList, offer.uniqueId);
                        return contains;
                    });

                    // Add new offers to list
                    self.originalOffers = underscore.union(deduplicatedOriginalOffers, deduplicatedNewOffers);
                    self.refreshFlightList().then(function () {
                        deferred.resolve();
                    });
                });

            return deferred.promise;
        };

        /**
         * Returns flight list with blacklisted flights removed
         *
         * @param {FlightOfferModel[]}
         * @returns {FlightOfferModel[]}
         */
        var getWhitelisted = function (offers) {
            var deferred = $q.defer();
            SouthParkFlightCache
                .getBlacklist()
                .then(function (success) {
                    var blacklist = underscore.map(success, function (entry) {
                        return entry.token;
                    });

                    deferred.resolve(
                        underscore.reject(offers, function (offer) {
                            return underscore.contains(
                                blacklist,
                                offer.fulfillmentToken
                            );
                        })
                    );
                })
                .catch(function () {
                    deferred.resolve(offers);
                });

            return deferred.promise;
        };

        /**
         * Refreshes flight list:
         *  - removes blacklisted flights
         *  - calculates min, max and avg price
         *  - populates short dictionary
         *  - applies sorting
         *  - applies filters
         */
        this.refreshFlightList = function () {
            var deferred = $q.defer();
            self.isRefreshing = true;

            // Remove blacklisted flights from flight offers list
            getWhitelisted(self.originalOffers)
                .then(function (offers) {
                    self.originalOffers = offers;

                    // Calculate min, max and avg price
                    var offerPrices = underscore.map(self.originalOffers, function (offer) {
                        return offer.getPriceWithoutTf();
                    });

                    self.minPrice = underscore.min(offerPrices);
                    self.maxPrice = underscore.max(offerPrices);
                    self.avgPrice = underscore.reduce(offerPrices, function (memo, num) {
                        return memo + num;
                    }, 0) / offerPrices.length || 0;

                    // Short IATA dictionary
                    self.shortDictionary = new IataDictionary();
                    self.shortDictionary.populate(self.iataDictionary.getShort(self.originalOffers));

                    // Sort
                    applySorting(self.originalOffers);
                    countAvailableOffers(self.originalOffers);
                    computeSortingTabs();
                    self.filters.compute(self.processedOffers.best, self.shortDictionary);
                })
                .finally(function () {
                    self.isRefreshing = false;
                    deferred.resolve();
                });

            return deferred.promise;
        };

        /**
         * Sorts best/cheapest/fastest based on original offers
         *
         * @param {Object[]} offers
         */
        var applySorting = function (offers) {
            self.processedOffers.best = groupByTravelHash(
                underscore
                    .map(offers, underscore.clone)
                    .sort(dynamicSorter('best'))
            );

            self.processedOffers.cheapest = groupByTravelHash(
                underscore
                    .map(offers, underscore.clone)
                    .sort(multipleDynamicSorter('priceNoSf', 'duration'))
            );

            self.processedOffers.fastest = groupByTravelHash(
                underscore
                    .map(offers, underscore.clone)
                    .sort(multipleDynamicSorter('duration', 'priceNoSf'))
            );

            self.uniquePerRouteOffers.best = uniqueGrouped(self.processedOffers.best);
            self.uniquePerRouteOffers.cheapest = uniqueGrouped(self.processedOffers.cheapest);
            self.uniquePerRouteOffers.fastest = uniqueGrouped(self.processedOffers.fastest);
        };

        var uniqueGrouped = function (offers) {
            var ungrouped = underscore.map(offers, function (offerGroup) {
                return offerGroup[0];
            });

            var groupped = underscore.groupBy(ungrouped, function (offer) {
                return offer.stages[0].originCity + offer.stages[0].destinationCity;
            });

            return groupByTravelHash(
                underscore.map(groupped, function (offerGroup) {
                    return offerGroup[0];
                })
            );
        };

        var countAvailableOffers = function (offers) {
            self.availableOffersCount = offers.length;
        };

        var groupByTravelHash = function (offers) {
            var groupped = underscore.groupBy(offers, function (offer) {
                return offer.travelHash;
            });

            return Object.values(groupped);
        };

        /**
         * Sorts an array of flights by a property
         *
         * @param {String} property
         * @returns {Function}
         */
        function dynamicSorter(property) {
            var sortOrder = 1;
            if (property[0] === '-') {
                sortOrder = -1;
                property = property.substr(1);
            }

            return function (a, b) {
                var aProp = (property === 'price') ? Math.round(a.score[property]) : +a.score[property];
                var bProp = (property === 'price') ? Math.round(b.score[property]) : +b.score[property];

                var result = (aProp < bProp) ? -1 : (aProp > bProp) ? 1 : 0;
                return result * sortOrder;
            };
        }

        /**
         * Sorts an array of flights by multiple criteria
         *
         * @returns {Function}
         */
        function multipleDynamicSorter() {
            var props = arguments;

            return function (obj1, obj2) {
                var i = 0;
                var result = 0;
                var numberOfProperties = props.length;

                while (result === 0 && i < numberOfProperties) {
                    result = dynamicSorter(props[i])(obj1, obj2);
                    i++;
                }

                return result;
            };
        }

        /**
         * Initiates search using the cached data
         */
        var initSearch = function () {
            SearchQueryParams.reset().setFromLinkParameters();
            searchPayloadCache = SouthParkPayload.makePayloadFromSearchQueryParams(SearchQueryParams);
            var searchDeduplicated = (SearchQueryParams.getSearchDeduplicatedFlights() && AppConfig.isAgent()) ? true : false;

            if (searchDeduplicated !== SouthParkSession.isDeduplicated()) {
                SouthParkSession.clear();
            }

            if (SouthParkSession.getMarketCode() && AppConfig.getMarket() !== SouthParkSession.getMarketCode()) {
                $localStorage.marketCode = AppConfig.getMarket();
                self.resetSession();
            }

            self.searchDate = new Date();
            searchStartTime = Date.now();
            Remarketing.sendSearchStartData(searchPayloadCache);

            // Try to get results from cache
            SouthParkFlightCache
                .getFromCache(searchPayloadCache)
                .then(function (cacheResult) {
                    if (cacheResult) {
                        self.requestId = cacheResult.requestId;

                        SouthParkSession.set(
                            cacheResult.sessionId,
                            searchDeduplicated,
                            AppConfig.getMarket()
                        );

                        computeOffers(cacheResult.flights).then(function () {
                            self.isLoading = false;
                        });
                        return;
                    }

                    SouthParkApi
                        .initSearch(
                            AppConfig.getAffiliateName(),
                            searchPayloadCache,
                            SouthParkSession.get(),
                            searchDeduplicated
                        )
                        .then(function (success) {
                            if (success.headers('session')) {
                                SouthParkSession.set(
                                    success.headers('session'),
                                    searchDeduplicated,
                                    AppConfig.getMarket()
                                );
                            }
                            self.requestId = success.data.search.searchId;

                            // Cache request id for marketing automation
                            $localStorage.searchRequestId = self.requestId;

                            perfomRetryableSearch(
                                self.requestId,
                                AppConfig.getAffiliateName(),
                                SouthParkSession.get()
                            );
                        })
                        .catch(function () {
                            self.isLoading = false;
                            self.apiError = true;
                        });
                });

            return self.deferred.promise;
        };

        /**
         * Performs and retries search until refreshStats.continue is false
         *
         * @param {String} requestId
         * @param {String} affiliate
         */
        var perfomRetryableSearch = function (requestId, affiliate) {
            SouthParkApi
                .retrySearch(affiliate, requestId, SouthParkSession.get())
                .then(function (success) {
                    if (requestId !== self.requestId) {
                        return;
                    }

                    computeOffers(success.data.offers)
                        .then(function () {
                            self.encodedQuery = success.data.encodedQuery;

                            var elapsedTime = (Date.now() - searchStartTime) / 1000; // Time in seconds

                            if (success.data.refreshStatus.continue === true && elapsedTime < 45) {
                                retryTimerId = setTimeout(function () {
                                    perfomRetryableSearch(requestId, affiliate);
                                }, 1000);
                                return;
                            }

                            if (self.originalOffers.length > 0) {
                                // Add all found flights to cache
                                SouthParkFlightCache.addToCache(
                                    searchPayloadCache,
                                    self.originalOffers,
                                    self.requestId,
                                    SouthParkSession.get()
                                );
                            }

                            $timeout(function () {
                                self.isLoading = false;
                                self.deferred.resolve();

                                if (self.processedOffers.best.length) {
                                    Remarketing.sendSearchFinishData(
                                        self.processedOffers.best[0][0],
                                        searchPayloadCache
                                    );
                                }
                            }, 10);
                        });
                })
                .catch(function () {
                    self.isLoading = false;
                    self.apiError = true;
                });
        };

        /**
         * Stops retryable search timeout
         */
        var stopPreviousSearch = function () {
            clearTimeout(retryTimerId);
        };

        /**
         * Filters a list of offers based on currently set filters
         *
         * @returns {Object[]}
         */
        var getFilteredCollection = function () {
            self.filters.onUpdate();
            return $filter('filterOffers')(self.originalOffers, self.filters.filters);
        };

        /**
         * Computes sorting tabs based on best/cheapest/fastest collections
         */
        var computeSortingTabs = function () {
            self.sortingTabs = [];

            var createSortingTab = function (id, list) {
                return { id: id, offer: list[0][0] };
            };

            if (self.processedOffers.best.length > 0) {
                self.sortingTabs.push(createSortingTab(TabFilterTypes.best, self.processedOffers.best));
                self.sortingTabs.push(createSortingTab(TabFilterTypes.cheapest, self.processedOffers.cheapest));
                self.sortingTabs.push(createSortingTab(TabFilterTypes.fastest, self.processedOffers.fastest));
            }
        };

        return this;
    };

    SouthParkHelper.$inject = [
        '$q',
        '$filter',
        '$timeout',
        '$localStorage',
        'SouthParkApi',
        'SouthParkFlightCache',
        'SouthParkPayload',
        'SouthParkSession',
        'FlightOfferModel',
        'SouthParkFilters',
        'IataDictionary',
        'TabFilterTypes',
        'goo.Remarketing',
        'appConfig',
        'sch.SearchQueryParams'
    ];

    angular
        .module('funnel')
        .service('SouthParkHelper', SouthParkHelper);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/funnel/services/SouthParkFlightCache.js
(function (angular, indexedDB) {
var IthSouthParkFlightCache = function ($q, AppConfig, IndexedDbExpiryCache, MemoryExpiryCache) {
        /**
         * In-memory flight results cache
         *
         * @type {MemoryExpiryCache}
         */
        var shelfFlightCacheDb = null;

        /**
         * In-memory dictionary cache
         *
         * @type {MemoryExpiryCache}
         */
        var shelfDictionaryDb = null;

        /**
         * In-memory flight blacklist cache
         *
         * @type {MemoryExpiryCache}
         */
        var shelfBlacklistDb = null;

        /**
         * IndexedDB table cache version
         *
         * @type {Number}
         */
        var indexedDbCacheVersion = 5;

        /**
         * Checks if IndexedDB is available
         *
         * @returns {Boolean}
         */
        var isIndexedDbAbtestEnabled = function () {
            // AB test
            if (!AppConfig.getAbConfig().hasOwnProperty('idb_cache') || AppConfig.getAbConfig().idb_cache !== 'On') {
                return false;
            }

            return true;
        };

        /**
         * Checks if indexedDB works
         *
         * @returns {Promise}
         */
        var isIndexedDbFunctional = function () {
            var deferred = $q.defer();
            var request;

            if (!indexedDB) {
                deferred.reject('IndexedDB is not available');
                return deferred.promise;
            }

            try {
                request = indexedDB.open('test', 1);
            } catch (e) {
                deferred.reject('IndexedDB open error', e);
                return deferred.promise;
            }

            request.onerror = function (e) {
                deferred.reject('IndexedDB error', e);
            };

            request.onsuccess = function () {
                deferred.resolve();
            };

            request.onupgradeneeded = function () {
                deferred.resolve();
            };

            return deferred.promise;
        };

        /**
         * Returns cache time from config
         *
         * @param {String} prop
         * @returns {Number}
         */
        var getCacheTime = function (prop) {
            return AppConfig.getShelfConfig()[prop] * 1000;
        };

        /**
         * Returns shelf flight cache driver
         *
         * @returns {Promise}
         */
        var getShelfFlightsCache = function () {
            var deferred = $q.defer();

            if (shelfFlightCacheDb != null) {
                deferred.resolve(shelfFlightCacheDb);
                return deferred.promise;
            }

            var getCacheWithParameters = function (cacheObj) {
                var cacheDuration = isIndexedDbAbtestEnabled() ? getCacheTime('results_cache_time') : 0;

                return cacheObj
                    .setTableName('cache')
                    .setCacheDuration(cacheDuration)
                    .setVersion(indexedDbCacheVersion)
                    .addIndex('id', 'id', { unique: true });
            };

            if (!isIndexedDbAbtestEnabled()) {
                shelfFlightCacheDb = getCacheWithParameters(new MemoryExpiryCache());
                deferred.resolve(shelfFlightCacheDb);
                return deferred.promise;
            }

            isIndexedDbFunctional()
                .then(function () {
                    shelfFlightCacheDb = getCacheWithParameters(new IndexedDbExpiryCache('shelf-cache'));
                    deferred.resolve(shelfFlightCacheDb);
                })
                .catch(function () {
                    shelfFlightCacheDb = getCacheWithParameters(new MemoryExpiryCache());
                    deferred.resolve(shelfFlightCacheDb);
                });

            return deferred.promise;
        };

        /**
         * Returns shelf dictionary cache driver
         *
         * @returns {Promise}
         */
        var getShelfDictionaryCache = function () {
            var deferred = $q.defer();

            if (shelfDictionaryDb != null) {
                deferred.resolve(shelfDictionaryDb);
                return deferred.promise;
            }

            var getCacheWithParameters = function (cacheObj) {
                return cacheObj
                    .setTableName('dictionary')
                    .setCacheDuration(getCacheTime('iata_dictionary_cache_time'))
                    .setVersion(indexedDbCacheVersion);
            };

            isIndexedDbFunctional()
                .then(function () {
                    shelfDictionaryDb = getCacheWithParameters(new IndexedDbExpiryCache('shelf-dictionary-cache'));
                    deferred.resolve(shelfDictionaryDb);
                })
                .catch(function () {
                    shelfDictionaryDb = getCacheWithParameters(new MemoryExpiryCache());
                    deferred.resolve(shelfDictionaryDb);
                });

            return deferred.promise;
        };

        /**
         * Returns shelf blacklist cache driver
         *
         * @returns {Promise}
         */
        var getShelfBlacklistCache = function () {
            var deferred = $q.defer();

            if (shelfBlacklistDb != null) {
                deferred.resolve(shelfBlacklistDb);
                return deferred.promise;
            }

            var getCacheWithParameters = function (cacheObj) {
                return cacheObj
                    .setTableName('blacklist')
                    .setKeyPath('token')
                    .setCacheDuration(getCacheTime('blacklist_cache_time'))
                    .setVersion(indexedDbCacheVersion)
                    .addIndex('token', 'token', { unique: true });
            };

            isIndexedDbFunctional()
                .then(function () {
                    shelfBlacklistDb = getCacheWithParameters(new IndexedDbExpiryCache('shelf-blacklist'));
                    deferred.resolve(shelfBlacklistDb);
                })
                .catch(function () {
                    shelfBlacklistDb = getCacheWithParameters(new MemoryExpiryCache());
                    deferred.resolve(shelfBlacklistDb);
                });

            return deferred.promise;
        };

        /**
         * Adds shelf data to local storage
         *
         * @param {Object} searchPayload
         * @param {FlightOffer[]} flights
         * @param {String} requestId
         * @param {String} sessionId
         */
        this.addToCache = function (searchPayload, flights, requestId, sessionId) {
            var id = JSON.stringify(searchPayload);
            var payload = {
                payload: searchPayload,
                flights: flights,
                requestId: requestId,
                sessionId: sessionId
            };

            getShelfFlightsCache()
                .then(function (cache) {
                    cache.insertOne(id, payload);
                });
        };

        /**
         * remove from local storage
         *
         * @param {String} id
         */
        this.remove = function (id) {
            getShelfFlightsCache()
                .then(function (cache) {
                    cache.remove(id);
                });
        };

        /**
         * Adds dictionary to local storage
         *
         * @param {Object} dictionaryData
         */
        this.addDictionary = function (dictionaryData) {
            var id = 'iata-' + AppConfig.getUserLanguage();
            var payload = {
                data: dictionaryData
            };

            getShelfDictionaryCache()
                .then(function (cache) {
                    cache.empty().then(function () {
                        cache.insertOne(id, payload);
                    });
                });
        };

        /**
         * Returns dictionary from local storage
         *
         * @returns {Object|null}
         */
        this.getDictionary = function () {
            var deferred = $q.defer();

            getShelfDictionaryCache()
                .then(function (cache) {
                    cache
                        .get('iata-' + AppConfig.getUserLanguage())
                        .then(function (result) {
                            deferred.resolve(result);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                });

            return deferred.promise;
        };

        /**
         * Returns cache entry if not expired
         *
         * @param {Object} searchPayload
         * @returns {Object}
         */
        this.getFromCache = function (searchPayload) {
            var deferred = $q.defer();
            var id = JSON.stringify(searchPayload);

            if (searchPayload.hasOwnProperty('deduplicate') && searchPayload.deduplicate === '1') {
                deferred.resolve(false);
                return deferred.promise;
            }

            getShelfFlightsCache()
                .then(function (cache) {
                    cache
                        .get(id)
                        .then(function (result) {
                            deferred.resolve(result);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                });

            return deferred.promise;
        };

        /**
         * Clears the cache
         */
        this.clear = function () {
            return getShelfFlightsCache()
                .then(function (cache) {
                    return cache.empty();
                });
        };

        /**
         * Blacklists a flight by fulfillmentToken
         *
         * @param {String} fulfillmentToken
         */
        this.blacklist = function (fulfillmentToken) {
            var data = {
                token: fulfillmentToken
            };

            return getShelfBlacklistCache()
                .then(function (cache) {
                    return cache.insertOne(fulfillmentToken, data);
                });
        };

        /**
         * Returns blackist array
         *
         * @returns {Promise}
         */
        this.getBlacklist = function () {
            var deferred = $q.defer();

            getShelfBlacklistCache()
                .then(function (cache) {
                    cache
                        .getCursor()
                        .then(function (result) {
                            deferred.resolve(result);
                        })
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                });

            return deferred.promise;
        };
    };

    IthSouthParkFlightCache.$inject = [
        '$q',
        'appConfig',
        'IndexedDbExpiryCache',
        'MemoryExpiryCache'
    ];

    angular
        .module('funnel')
        .service('SouthParkFlightCache', IthSouthParkFlightCache);

}(angular, indexedDB));
;

// Source: ../shared/public_html/assets/js/funnel/services/SouthParkPayload.service.js
(function (angular) {
/**
     * Service responsible for creating payloads for south park flight search
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var SouthParkPayloadService = function (LOCATION_TYPES, ExploreModeIdService) {
        function getParsedLocations(codesString, type) {
            var codesArray = codesString ? codesString.split(',') : [];

            return codesArray.map(function (code) {
                return {
                    code: code,
                    type: type
                };
            });
        }

        function generateLocations(cityCodes, airportCodes, countryCodes) {
            return [].concat(
                getParsedLocations(cityCodes, LOCATION_TYPES.CITY),
                getParsedLocations(airportCodes, LOCATION_TYPES.AIRPORT),
                countryCodes ? getParsedLocations(countryCodes, LOCATION_TYPES.COUNTRY) : []
            );
        }

        this.makePayloadFromSearchQueryParams = function (searchQueryParams) {
            var payload = {
                dates: {
                    departureFrom: searchQueryParams.getDepDate(),
                    departureTo: searchQueryParams.getDepDate(),
                    returnFrom: !searchQueryParams.isOneWay() ? searchQueryParams.getRetDate() : '',
                    returnTo: !searchQueryParams.isOneWay() ? searchQueryParams.getRetDate() : '',
                },
                passengers: {
                    adults: searchQueryParams.getAdults(),
                    children: searchQueryParams.getChildren(),
                    infants: searchQueryParams.getInfants(),
                    youth: searchQueryParams.getYouths(),
                },
                locations: {
                    origins: generateLocations(
                        searchQueryParams.getDepCityCode(),
                        searchQueryParams.getDepAirportCode()
                    ),
                    destinations: generateLocations(
                        searchQueryParams.getDesCityCode(),
                        searchQueryParams.getDesAirportCode(),
                        searchQueryParams.getDesCountryCode()
                    )
                },
                deduplicate: searchQueryParams.getSearchDeduplicatedFlights()
            };

            // regular search started after click on city from explore mode
            if (ExploreModeIdService.getId() && ExploreModeIdService.getIncludeInPayload()) {
                payload.parentExploreId = ExploreModeIdService.getId();

                ExploreModeIdService.setId(null);
                ExploreModeIdService.setIncludeInPayload(false);
            }

            // if flex search
            if (searchQueryParams.getIsFlex()) {
                payload.dates.departureFrom = searchQueryParams.getDepDate();
                payload.dates.departureTo = searchQueryParams.getRetDate();
                payload.dates.returnFrom = !searchQueryParams.isOneWay() ? searchQueryParams.getDepDate() : '';
                payload.dates.returnTo = !searchQueryParams.isOneWay() ? searchQueryParams.getRetDate() : '';

                if (!searchQueryParams.isOneWay()) {
                    payload.dates.stayTime = {
                        min: searchQueryParams.getFlexDaysFrom(),
                        max: searchQueryParams.getFlexDaysTo()
                    };
                }
            }

            return payload;
        };

        return this;
    };

    SouthParkPayloadService.$inject = [
        'LOCATION_TYPES',
        'ExploreModeIdService'
    ];

    angular
        .module('funnel')
        .service('SouthParkPayload', SouthParkPayloadService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/SouthParkSession.service.js
(function(angular) {
var SouthParkSession = function ($localStorage) {
        /**
         * IBE session id
         *
         * @type {String}
         */
        this.sessionId = '';

        this.set = function (value, isDeduplicated, marketCode) {
            $localStorage.sessionId = value;
            $localStorage.sessionDeduplicated = isDeduplicated;
            $localStorage.marketCode = marketCode;
        };

        this.isDeduplicated = function () {
            return $localStorage.sessionDeduplicated || false;
        };

        this.getMarketCode = function () {
            return $localStorage.marketCode || null;
        };

        this.get = function () {
            return $localStorage.sessionId;
        };

        this.clear = function () {
            this.sessionId = null;
            $localStorage.sessionId = null;
        };
    };

    SouthParkSession.$inject = ['$localStorage'];

    angular
        .module('funnel')
        .service('SouthParkSession', SouthParkSession);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/ThankYouServ.js
angular.module('funnel')

/**
 * @name FAQ Service
 *
 * @description Example service responsibility description
 */
.factory('thy.ThankYouServ',
['ApiTools', '$sce',
function ThankYouServFactory(ApiTools, $sce) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints =
    {
      getConfirmation: function (args) {
        var insurance = args.insurance ? '/0/' + args.insurance : '',
            queryStr = args.debug_confirmation_rules ? '?confirmation_rules=1' : '';

        return {
          url: '/thankYou/getConfirmationData/' + args.token + '/' + args.controller + insurance + queryStr  +'?abv='+_js_app_config_.ab_version ,
          method: 'POST',
          respParser: getResponse
        };
      }
    },

    /**
     * @class ThankYouServ
     * @constructor
     */
    ThankYouServ = function () {};

  /**
   * @lends ThankYouServ.prototype
   */
  ThankYouServ.prototype =
  {
    /**
     * Get Confirmation Data
     *
     * @param  {Object} args
     *
     * @return {Promise}
     */
    getConfirmation: function (args) {
      return ApiTools.fetch(this, endpoints.getConfirmation(args), args);
    },
    prepareData: function (response) {
      var pageData = {};

      if (response.pageData && response.pageData.html) {
        if (response.pageData.html) {
          pageData.headerInfo = $sce.trustAsHtml(response.pageData.headerInfo);
          pageData.content = $sce.trustAsHtml(response.pageData.html);
          pageData.paymentType = response.pageData.paymentType;
          pageData.hash = response.pageData.hash;
          pageData.paymentPrice = response.pageData.paymentPrice;
          pageData.transactionCurrency = response.pageData.transactionCurrency;
          pageData.transactionExRate   = response.pageData.transactionExRate;
        }

        if (response.pageData.redirectUrl) {
          pageData.redirectUrl = response.pageData.redirectUrl;
        }
      }

      return pageData;
    }
  };

  ThankYouServ.prototype.constructor = ThankYouServ;

  /**
   * Get Response
   *
   * @param {Object} response
   * @return Object
   */
  function getResponse(response) {
    return response.response;
  }

  return new ThankYouServ();
}]);

;

// Source: ../shared/public_html/assets/js/funnel/services/authValuesConverter.js
(function(angular) {
var AuthValuesConverter = function (Person, ContactDetails, BillingPerson, Company) {
        this.getPersonInstance = function (personData) {
            var personInstance = new Person();

            if (personData) {
                personInstance.srvSet(personData);
            }

            return personInstance;
        };

        this.getContactDetailsInstance = function (contactDetailsData) {
            var contactDetailsInstance = new ContactDetails();

            if (contactDetailsData) {
                contactDetailsInstance.srvSet(contactDetailsData);
            }

            return contactDetailsInstance;
        };

        this.getBillingInstance = function (billingData) {

            var billingInstance = billingData.type === 'company' || (billingData.name !== null && billingData.name !== '')
                ? new Company()
                : new BillingPerson();
            billingInstance.srvSet(billingData);

            return billingInstance;
        };

        this.getTravelBuddiesArray = function (travelBuddiesData, customerData) {
            var travelBuddies = [];
            var self = this;

            if (customerData) {
                travelBuddies.push(self.getPersonInstance(customerData));
            }

            travelBuddiesData.forEach(function (travelBuddyData) {
                travelBuddies.push(self.getPersonInstance(travelBuddyData));
            });

            return travelBuddies;
        };

        this.getBillingsArray = function (billingsData) {
            var self = this;

            if (!billingsData.length)
                return [];

            return billingsData.map(function (billingData) {
                return self.getBillingInstance(billingData);
            });
        };
    };

    AuthValuesConverter.$inject = [
        'bil.Person',
        'bil.ContactDetails',
        'bil.BillingPerson',
        'bil.Company'
    ];

    angular
        .module('base')
        .service('AuthValuesConverter', AuthValuesConverter);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/booking-form-cache.service.js
(function(angular) {
var BookingFormCache = function ($localStorage) {
        /**
         *
         * @param {Pax[]} paxes
         */
        this.cachePaxes = function (paxes) {
            var cachedPaxes = [];

            _.forEach(paxes, function (pax) {
                var serializedPax = pax.srvObj();

                // Remove document number
                if (serializedPax.person.id_card) {
                    serializedPax.person.id_card.number = '';
                }

                cachedPaxes.push({
                    person: serializedPax.person
                });
            });

            $localStorage.formCachePaxes = cachedPaxes;
        };

        /**
         *
         * @returns {Object[]}
         */
        this.getPaxes = function () {
            return $localStorage.formCachePaxes;
        };

        /**
         *
         * @param {ContactDetails} contact
         */
        this.cacheContact = function (contact) {
            $localStorage.formCacheContact = contact;
        };

        /**
         *
         * @returns {Object}
         */
        this.getContact = function () {
            return $localStorage.formCacheContact;
        };

        /**
         *
         * @param {Billing} billing
         */
        this.cacheBilling = function (billing) {
            $localStorage.formCacheBilling = billing.srvObj();
        };

        /**
         *
         * @returns {Object}
         */
        this.getBilling = function () {
            return $localStorage.formCacheBilling;
        };

        /**
         *
         */
        this.clear = function () {
            $localStorage.formCachePaxes = null;
            $localStorage.formCacheContact = null;
            $localStorage.formCacheBilling = null;
        };
    };

    BookingFormCache.$inject = ['$localStorage'];

    angular
        .module('funnel')
        .service('BookingFormCache', BookingFormCache);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/booking-form-filler.js
(function(angular) {
var BookingFormFillerService = function () {
        this.autofillBilling = function (firstPax, billing) {
            if (billing.getPerson().id !== '') {
                return;
            }

            billing
                .getPerson()
                .setFirstName(firstPax.getFirstName())
                .setLastName(firstPax.getLastName());
        };
    };

    angular
        .module('funnel')
        .service('BookingFormFiller', BookingFormFillerService);

}(angular));
;

// Source: ../shared/public_html/assets/js/funnel/services/bookingState.js
/*global angular: false, _: false */
(function (angular, underscore) {
/**
     * @name        BookingState
     * @description Handles smooth scroll on anchor interaction
     */
    var BookingStateFactory = function BookingStateFactory($rootScope, $q, $stateParams, $localStorage, Dictionaries, OrderState, FlightBooking, Basket, FlightDetailsServ, $location) {

        /**
         * BookingState
         *
         * @constructor
         */
        var BookingState = function () {};

        /**
         * Sets booking state, loads flight details
         *
         */
        var methods = {
            setOrderState: function () {
                var self = this;

                self.order = FlightBooking;

                if (!$stateParams.hash && !self.order.getFlightDetails()) {
                    self.deferred = $q.defer();
                    self.orderPromise = self.deferred.promise;
                    self.userDataProvided = false;

                    FlightDetailsServ.get($stateParams).then(
                        function (result) {
                            self.order.setFlightDetails(result);
                            self.deferred.resolve(self.order);
                        },
                        function (failure) {
                            if (failure.http_code && failure.http_code === 302 && failure.response.expectedUri) {
                                $location.path(failure.response.expectedUri);
                            }
                            self.deferred.reject();
                        });
                }
            }
        };

        BookingState.prototype = OrderState;

        // Add methods
        underscore.extend(BookingState.prototype, methods);

        BookingState.prototype.constructor = BookingState;

        return new BookingState();
    };

    BookingStateFactory.$inject = [
        '$rootScope',
        '$q',
        '$stateParams',
        '$localStorage',
        'Dictionaries',
        'OrderState',
        'bok.FlightBooking',
        'bas.Basket',
        'fdt.FlightDetailsServ',
        '$location'
    ];

    angular.module('base')
        .factory('BookingState', BookingStateFactory);

})(angular, _);
;

// Source: ../shared/public_html/assets/js/funnel/services/logCollectorServ.js
angular.module('user')

/**
 * @name UserService
 *
 * @description UserService
 */
.factory('LogCollectorServ',
['ApiTools',
function (ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     *                         https://en.vola.ro/profile/save_traveler
     */
    endpoints =
    {
        apiSendErrorLogs: { url: '/api/debug/funnelcollector/', method: 'POST', respParser:defaultParser }
    },


    /**
     * @class UserService
     * @constructor
     */
    LogCollectorServ = function () {

    };


  LogCollectorServ.prototype = /** @lends UserService.prototype */
  {

    /**
     * Create Function
     *
     * @param {String} username
     * @param {String} password
     * @return {Promise}
     */
    sendErrorLogs: function (data) {
      return ApiTools.fetch(this, endpoints.apiSendErrorLogs, {data:data});
    }
  };

  LogCollectorServ.prototype.constructor = LogCollectorServ;


  /**
   * Parse response fro login
   *
   * @param {Object} response
   * @return {Object}
   */
  function defaultParser(response) {
    return response.response;
  }

  return new LogCollectorServ();
}
]);
;

// Source: ../shared/public_html/assets/js/funnel/services/orderState.js
(function(angular, underscore) {
    /**
     * @name        OrderState
     * @description Handles smooth scroll on anchor interaction.
     */
    var OrderState = function($rootScope, $q, Order, UserService, UserServiceV2, AuthValuesConverter, appConfig, UserSessionData) {
var OrderState = function() { //todo too complicated, needs refactoring
            this.order = new Order();
            this.deferred = null;
            this.udeffered = null;
            this.orderPromise = null;
            this.userDataProvided = false;
            this.userBuddiesPromise = null;
            this.userPreferencesPromise = null;
            this.loadingProfileDataInProgress = false;
            this.cancelUserDataLoading = false;
            this.userDataDeferred = $q.defer();
        };

        /**
         * Sets booking state.
         */
        OrderState.prototype.setOrderState = function() {
            this.deferred = $q.defer();
            this.orderPromise = this.deferred.promise;
            this.deferred.resolve(this.order);
        };

        /**
         * Loads data from user profile to booking paxes.
         *
         * @param logged Is user logged. (old auth service)
         * @param formStatuses Paxes forms states - $dirty.
         * @returns {Promise}
         */
        OrderState.prototype.loadUserData = function(logged, formStatuses) {
            var self = this;
            self.udeffered = $q.defer();
            formStatuses = typeof formStatuses !== 'undefined' ? formStatuses : [];

            function finishLoadingProcess() {
                self.loadingProfileDataInProgress = false;
                self.udeffered.resolve();
            }

            function onAllDataIsLoaded(resp) {
                if (self.cancelUserDataLoading && !resp) {
                    self.resetUserDataLoadingCancellation();
                    finishLoadingProcess();
                    return;
                }

                // convert response
                resp = UserServiceV2.adaptResponse(resp);

                var buddiesArray, billingInfo, mainPerson;

                /**
                 * Create buddies array and user preferences.
                 */
                try {
                    buddiesArray = AuthValuesConverter.getTravelBuddiesArray(resp.buddies, resp.customer.person);

                    if (resp.billing.length) {
                        billingInfo = AuthValuesConverter.getBillingInstance(resp.billing[0]);
                    }

                    mainPerson = AuthValuesConverter.getPersonInstance(resp.customer.person);
                }
                catch(e) {
                    console.error(e);
                    buddiesArray = [];
                }

                var newArray = [];
                angular.forEach(buddiesArray, function(el) {
                    newArray.push(underscore.clone(el));
                });

                self.userDataDeferred.resolve(newArray);

                var mapPaxes = function () {
                    var buddiesArrayCopy = underscore.map(
                        buddiesArray,
                        function (buddy) {
                            return buddy;
                        }
                    );

                    return underscore.map(
                        self.order.paxes,
                        function (pax) {
                            var foundBuddyIndex = underscore.findIndex(buddiesArrayCopy, {
                                paxType: pax.person.paxType
                            });

                            if (foundBuddyIndex !== -1) {
                                pax.person.srvSet(buddiesArrayCopy[foundBuddyIndex].srvObj());
                                buddiesArrayCopy.splice(foundBuddyIndex, 1);
                            }

                            return pax;
                        });
                };

                var newPaxes = [];

                try {
                    newPaxes = mapPaxes();
                }
                catch(e) {
                    console.error(e);
                    newPaxes = self.order.paxes;
                }

                try {
                    self.order.getContact().srvSet(resp.customer.contact);

                    if(!$rootScope.isBillingInitializete) {
                        if (billingInfo) {
                            self.order.getBilling().setPerson(mainPerson);

                            var isPerson = resp.billing[0].type !== 'company';

                            if (isPerson) {
                                self.order.getBilling().setType('person');
                                self.order.getBilling().getPerson().srvSet(billingInfo.srvObj());
                            }

                            if (!isPerson) {
                                self.order.getBilling().setType('company');
                                self.order.getBilling().getCompany().srvSet(billingInfo.srvObj());
                            }
                        }
                        else {
                            self.order.getBilling().setType('person');
                            self.order.getBilling().setPerson(mainPerson);
                        }
                    }
                }
                catch(e) {
                    console.error(e);
                }

                self.order.paxes = newPaxes;
                self.userDataProvided = true;
                finishLoadingProcess();
            }

            function onAllDataIsFailed(resp) {
                self.loadingProfileDataInProgress = false;
                self.userDataDeferred.reject();
                self.udeffered.resolve();
            }

            if (UserSessionData.isLogged()) {
                self.loadingProfileDataInProgress = true;
                // self.userBuddiesPromise = UserService.getPassengersDataAndCache(self.udeffered.promise);
                self.userBuddiesPromise = UserServiceV2.getPassengersData();
                self.userBuddiesPromise.then(onAllDataIsLoaded, onAllDataIsFailed);
            }
            else {
                self.udeffered.resolve();
            }
            return self.udeffered.promise;
        };


        /**
         * Returns loading profile data status.
         *
         * @returns {Boolean}
         */
        OrderState.prototype.loadingProfileData = function() {
            return this.loadingProfileDataInProgress;
        };

        /**
         * Cancel user data loading.
         */
        OrderState.prototype.stopLoadingUserData = function() {
            var self = this;
            if((self.userBuddiesPromise && self.userBuddiesPromise.$$state && self.userBuddiesPromise.$$state.status === 0)
                || (self.userPreferencesPromise && self.userPreferencesPromise.$$state && self.userPreferencesPromise.$$state.status === 0)) {
                self.udeffered.resolve(false);
            }

            return this.cancelUserDataLoading = true;
        };

        /**
         * Reset cancelUserDataLoading.
         */
        OrderState.prototype.resetUserDataLoadingCancellation = function() {
            return this.cancelUserDataLoading = false;
        };

        /**
         * Reset user data provided state.
         */
        OrderState.prototype.resetUserDataProvidedState = function() {
            this.userDataProvided = false;
        };

        /**
         * Returns booking promise.
         *
         * @returns {Promise}
         */
        OrderState.prototype.getOrderState = function() {
            return this.orderPromise;
        };

        /**
         * Returns user profile data promise.
         *
         * @returns {Promise}
         */
        OrderState.prototype.getUserProfileData = function() {
            return this.userDataDeferred.promise;
        };

        OrderState.prototype.constructor = OrderState;

        return new OrderState();
    };

    OrderState.$inject = [
        '$rootScope',
        '$q',
        'bok.Order',
        'UserService',
        'UserServiceV2',
        'AuthValuesConverter',
        'appConfig',
        'UserSessionData'
    ];

    angular.module('base').factory('OrderState', OrderState);

})(angular, _);

;

// Source: ../shared/public_html/assets/js/funnel/services/stepsObserver.js
angular.module('base')

    /**
     * @name FAQ watcher to funnel steps state
     *
     * @description factory used to communication between flights details crt funnel steps (watcher) and nav bar(observer)
     */
    .factory('funnelStepsObserver',
        [
            function funnelStepsObserver() {
var stepsObserver = function() {
                };

                var processConfig = {
                    '2steps': ['SEARCH_RESULT', 'PASSENGER_DETAILS', 'FLIGHT_BOOKING'],
                    '3steps': ['SEARCH_RESULT', 'FLIGHT_DETAILS', 'PASSENGER_DETAILS']
                };
                var processType, processSteps, activeStepNo ;
                var subscribers = [];

                var deleteSubscription = function(id) {
                    subscribers.forEach(function(subscriber, index) {
                        if(subscriber.id === id) {
                            subscribers.splice(index, 1);
                            return false;
                        }
                    });
                };
                var subscriber = function(id, callback) {
                    var self = this;
                    self.id = id;
                    self.callback = callback;
                    self.deleteSubscription = function() {
                        deleteSubscription(self.id);
                    };
                };
                var calculateReturnSteps = function() {
                    if(!processType || !processSteps|| !activeStepNo){
                     return null;
                    }
                    return {
                        currentState: processSteps[activeStepNo],
                        processSteps: processSteps
                    };
                };
                var updateState = function() {
                    var returnProcessSteps = calculateReturnSteps();
                    if (!returnProcessSteps){
                        return;
                    }
                    subscribers.forEach(function(subscriber) {
                        subscriber.callback(returnProcessSteps);
                    });
                };


                stepsObserver.prototype.subscribe = function(callback) {
                    var newSubscriber = new subscriber(subscribers.length, callback);
                    subscribers.push(newSubscriber);
                     var returnProcessSteps = calculateReturnSteps();
                    if (returnProcessSteps){
                        callback(returnProcessSteps);
                    }
                    return newSubscriber.deleteSubscription;
                };

                stepsObserver.prototype.nextStep = function() {
                    if(activeStepNo + 1 < processSteps.length) {
                        activeStepNo++;
                        updateState();
                    }
                };

                stepsObserver.prototype.setStep = function(step) {
                    if(activeStepNo + 1 < processSteps.length) {
                        activeStepNo = step;
                        updateState();
                    }
                    updateState();
                };

                stepsObserver.prototype.reset = function() {
                    processType = '2steps';
                    processSteps = processConfig[processType];
                    activeStepNo = 1;
                    updateState();
                };
                return new stepsObserver();
            }
        ]
    );
;

// Source: ../shared/public_html/assets/js/funnel/terms-and-conditions-text/termAndCondition.constans.js
(function(angular) {
/**
   * Defined langs name for new axa term & condition
   *
   * @constant
   * @type {object}
   */
  var termsAndConditionsTextLangs = {
    NO_AXA_TEMPLATE:'LANGM_JS_AGREE_TERMS_AXA_NO_INSURANCE_TEMPLATE',
    TWO_BUTTONS_TEMPLATES:'LANGM_JS_AGREE_TERMS_AXA_TWO_BUTTONS_TEMPLATES',
    AXA_INCLUDED_TEMPLATE:'LANGM_JS_AGREE_TERMS_AXA_INSURANCE_INCLUDED_TEMPLATE',
    TERMS_AXA:'LANGM_JS_AGREE_TERMS_AXA',
    FRU_TERMS:'LANGM_JS_AGREE_TERMS_FRU',
    FLIGHT_TYPE_TERMS:{
      CHARTER:'LANGM_JS_AGREE_TERMS_AXA_CHARTER',
      HUB:'LANGM_JS_AGREE_TERMS_AXA_HUB',
      MIXED:'LANGM_JS_AGREE_TERMS_AXA_MIXED',
      REGULAR:'LANGM_JS_AGREE_TERMS_AXA_REGULAR',
      LOWCOST:'LANGM_JS_AGREE_TERMS_AXA_LOWCOST'
    }
  };

  angular.module('ITH.Funnel.TermsAndConditionsText')
    .constant('termsAndConditionsLangs', termsAndConditionsTextLangs);

})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/terms-and-conditions-text/termsAndConditionsText.component.js
(function (angular) {
/**
   * @name        TermsAndConditionsText
   * @description responsible for choose terms and conditions lang context
   */


  var TermsAndConditionsText = {
    bindings: {
      isInsuranceAdded: '<',
      canChooseInsurance: '<',
      flightType: '<',
      insurance: '<?',
      insuranceOwuLink:'<?',
      carriers: '<'
    },
    template: ' <div class="disclaimer-text" ng-click="$ctrl.agreeTermClick($event)" ng-bind-html="$ctrl.template"></div>',
    controller: 'termsAndConditionsTextCtrl'
  };

  angular.module('ITH.Funnel.TermsAndConditionsText')
    .component('termsAndConditionsText', TermsAndConditionsText);
})(angular);
;

// Source: ../shared/public_html/assets/js/funnel/terms-and-conditions-text/termsAndConditionsText.controller.js
(function (angular) {
/**
   * @name        TermsAndConditionsText
   * @description responsible for choose terms and conditions lang context
   */


  var termsAndConditionsTextCtrl = function ($filter, $modal, $sce, termsAndConditionsLangs) {


    var termsAndRegulations = $filter('translate')(termsAndConditionsLangs.FRU_TERMS);
    var flightTypesTerms;

    var self = this;

    this.$onChanges = function ($change) {
      if (!flightTypesTerms && this.flightType) {
        flightTypesTerms = getFlightTypesTerms(this.flightType);
      }
      this.template = $sce.trustAsHtml(chooseTermTemplate(!!this.isInsuranceAdded, !!this.canChooseInsurance));
    };

    var showGeneralConditionsModal = function () {
      var generalConditionModal = $modal.open({
        templateUrl: '/tpl/show/jsShared/templates/base/modals/generalConditionsModal',
        backdrop: 'static',
        size: 'fareRules',
        controller: 'GeneralConditionsModal',
        resolve: {
          carrierList: function () {
            return self.carriers;
          }
        }
      });
    };

    this.agreeTermClick = function ($event) {
      if ($event.target.getAttribute('ng-click') === 'showGeneralConditionsModal()') {
        $event.preventDefault();
        $event.stopPropagation();
        showGeneralConditionsModal();
      }
    };

    /**
     * set terms templates used in flight detail context
     * @param isInsuranceAdded
     * @param canChooseInsurance
     * choose main template
     */
    var chooseTermTemplate = function (isInsuranceAdded, canChooseInsurance) {
      if (!canChooseInsurance) {
        return translate(termsAndConditionsLangs.NO_AXA_TEMPLATE, canChooseInsurance);
      }
      else if (isInsuranceAdded) {
        return translate(termsAndConditionsLangs.AXA_INCLUDED_TEMPLATE, canChooseInsurance);
      }
      else {
        return translate(termsAndConditionsLangs.TWO_BUTTONS_TEMPLATES, canChooseInsurance);
      }
    };
    /**
     * function add parametrisation for terms template lang
     * @param lang
     * @param canChooseInsurance
     * @returns {string}
     */
    var translate = function (lang, canChooseInsurance) {

      var config = {
        termsAndRegulations: termsAndRegulations,
        flyTypeTermsAndRegulations: flightTypesTerms
      };

      if (canChooseInsurance && this.insuranceOwuLink) {
        config.insuranceTerms = this.insuranceOwuLink ? $filter('translate')(this.insuranceOwuLink ): null;
      }

      return $filter('translate')(lang, config);

    }.bind(this);

    /**
     * get flight terms link
     * @param flightType
     * @returns {string}
     */
    var getFlightTypesTerms = function (flightType) {
      return $filter('translate')(termsAndConditionsLangs.FLIGHT_TYPE_TERMS[flightType]);
    }

  };

  termsAndConditionsTextCtrl.$inject = [
    '$filter',
    '$modal',
    '$sce',
    'termsAndConditionsLangs'
  ];

  angular.module('ITH.Funnel.TermsAndConditionsText')
    .controller('termsAndConditionsTextCtrl', termsAndConditionsTextCtrl);
})(angular);
;

// Source: ../shared/public_html/assets/js/google/services/AnalyticsTracker.js
angular.module('google')

/**
 * @name        AnalyticsTracker
 * @namespace   goo
 * @description Abstract Google analytics framework
 */
.factory('goo.AnalyticsTracker',
[
function AnalyticsTrackerFactory() {
/**
   * AnalyticsTracker constructor
   *
   * @constructor
   * @class AnalyticsTracker
   */
  var AnalyticsTracker = function () {};

  // Add instance methods
  AnalyticsTracker.prototype = /** @lends AnalyticsTracker.prototype */ {
    /**
     * Require the Google Analytics ecommerce plugin
     *
     * @return {AnalyticsTracker}
     */
    requireEcommerce: function () {
      if (typeof ga == 'function') {
        ga('require', 'ecommerce', 'ecommerce.js');
      }

      return this;
    },

    /**
     * Initialize Google Anaytics transaction
     *
     * @param {String} transId      Transaction Id
     * @param {float}  transRevenue Transaction revenue
     *
     * @return {AnalyticsTracker}
     */
    initializeTransaction: function (transId, transRevenue) {
      if (typeof ga == 'function') {
        ga('ecommerce:addTransaction',
          {
            id: transId,
            affiliation: 'vola',
            revenue: transRevenue,
            shipping: '0',
            tax: '0'
          });
      }

      return this;
    },

    /**
     * Add item to current Google Analytics transaction
     *
     * @param {String}  transId      Transaction Id
     * @param {String}  itemSku      Item unique code
     * @param {String}  itemName     Item name
     * @param {String}  itemCategory Item category
     * @param {float}   itemPrice    Item price
     * @param {Number} qty          Quantity of items
     *
     * @return {AnalyticsTracker}
     */
    addItem: function (transId, itemSku, itemName, itemCategory, itemPrice, qty) {
      if (typeof ga == 'function') {
        ga('ecommerce:addItem',
          {
            id: transId,
            sku: itemSku,
            name: itemName,
            category: itemCategory,
            price: itemPrice,
            quantity: qty
          });
      }

      return this;
    },

    /**
     * Send the transaction to Google Analytics
     *
     * @return {AnalyticsTracker}
     */
    sendEcommerce: function () {
      if (typeof ga == 'function') {
        ga('ecommerce:send');
      }

      return this;
    }
  };

  AnalyticsTracker.prototype.constructor = AnalyticsTracker;

  return AnalyticsTracker;
}]);
;

// Source: ../shared/public_html/assets/js/google/services/DataLayerHelper.service.js
(function (angular) {

    var DataLayerHelper = function (AppConfig) {
        /**
         *
         * @param {FlightDetails} flightDetails
         * @returns
         */
        this.getFlightIdentifier = function (flightDetails) {
            var identifier = flightDetails.getDepLeg().getDepCityCode() + flightDetails.getDepLeg().getArrCityCode();

            if (flightDetails.isRoundTrip()) {
                identifier += flightDetails.getDepLeg().getDepCityCode();
            }

            return identifier;
        };

        this.getItemBrand = function () {
            if (AppConfig.isVola()) return 'Vola';
            if (AppConfig.isFru()) return 'FRU';
            if (AppConfig.isGovola()) return 'Govola';

            return '?';
        };
    };

    DataLayerHelper.$inject = ['appConfig'];

    angular
        .module('google')
        .service('DataLayerHelper', DataLayerHelper);

}(angular));
;

// Source: ../shared/public_html/assets/js/google/services/PackagesAnalytics.js
angular.module('google')

/**
 * @name        PackagesAnalytics
 * @namespace   goo
 * @description
 */
.factory('goo.PackageAnalytics',
['bas.Basket', '$stateParams', 'pkg.analytics',
  function PackageAnalyticsFactory(Basket, $stateParams, analytics) {
/**
     * @constructor
     */
    var PackageAnalytics = function() {
      this.type_pax     = [];
      this.form_errors  = []
    };

    // Add instance methods
    PackageAnalytics.prototype = /** @lends PackagesAnalytics.prototype */ {

      /**
       * get offer id
       * @return number
       */
      getOfferId: function () {
        return $stateParams.offerId;
      },

      /**
       * check if GA is active
       * @returns {Boolean}
       */
      isActiveGA: function () {
        return ga != undefined;
      },

      /**
       * ga / virtual pageviews
       * @param {String} page
       * @param {String} title
       */
      firePrimaryGA: function (page, title) {
        if (!this.isActiveGA()) {
          return;
        }
        ga('send',
            {
              'hitType' : 'pageview',
              'page'    : page,
              'title'   : title
            }
        );
      },

      /**
       * send ga with nonInteraction
       * @param {String} option
       * @param {String} type
       */
      fireNonInteractionGA: function (option, type, interaction) {
        if (!this.isActiveGA()) {
          return;
        }
        ga('send', 'event', 'Website Clicks', option, type, { nonInteraction: interaction });
      },

      /**
       * first click in calendar
       */
      eventCalendarFirstDate: function () {
        this.firePrimaryGA(analytics.CB_CALENDAR_PAGE_1, analytics.CB_CALENDAR_TITLE_1 )
      },

      /**
       * second click in calendar
       */
      eventCalendarSecondDate: function () {
        this.firePrimaryGA(analytics.CB_CALENDAR_PAGE_2, analytics.CB_CALENDAR_TITLE_2 )
      },

      /**
       * click the open gallery
       */
      eventGallery: function () {
        this.fireNonInteractionGA(analytics.CB_GALLERY_BUTTON, this.getOfferId(), false);
      },

      /**
       * month tab for rates
       */
      eventMonthBar: function () {
        this.fireNonInteractionGA(analytics.CB_MONTH_BAR, this.getOfferId(), false);
      },

      /**
       * Change calendar month
       */
      eventMonthArrow: function () {
        this.fireNonInteractionGA(analytics.CB_MONTH_ARROW, this.getOfferId(), false);
      },

      /**
       * click result search in breadcrumb
       */
      eventSearchResult: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_RESULTS, this.getOfferId(), true);
      },

      /**
       * Open gallery popup with given picture active
       */
      eventGalleryOpen: function () {
        this.fireNonInteractionGA(analytics.CB_GALLERY_OPEN, this.getOfferId(), false);
      },

      /**
       * Navigate relative to active page
       * @param {Integer} direction
       */
      eventGalleryNext: function (direction) {
        if (direction == 1) {
          this.fireNonInteractionGA(analytics.CB_GALLERY_NEXT, this.getOfferId(), false);
        }
      },

      /**
       * Navigate relative to active page
       * @param {Integer} direction
       */
      eventGallerySmallNext: function (direction) {
        if (direction == 1) {
          this.fireNonInteractionGA(analytics.CB_GALLERY_SMALL_NEXT, this.getOfferId(), false);
        }
      },

      /**
       * send information tabs
       * extended to 5 digits, example offer_id info: 00145
       * @param {Integer} index
       * @param {Object} list
       */
      eventInformationTab: function (index, list) {
        if (!_.isEmpty(list) && !_.isEmpty(list[index])) {
          var offer = '',
              length = 5 - this.getOfferId().length;
          for (var i = 0; i < length; i++) {
            offer += 0;
          }
          offer += this.getOfferId();
          this.fireNonInteractionGA(
              analytics.CB_INFORMATION,
              offer + '_' + list[index].key,
              false
          );
        }
      },

      /**
       * Reset the rate selection
       */
      eventChangeDate: function () {
        this.fireNonInteractionGA(analytics.CB_CHANGE_DATE, this.getOfferId(), false);
      },

      /**
       * Flag the add coupon form as visible
       */
      eventCouponEnter: function () {
        this.fireNonInteractionGA(analytics.CB_COUPON_ENTER, this.getOfferId(), false);
      },

      /**
       * Check a coupon code and visually apply it if valid
       */
      eventCouponUsed: function () {
        this.fireNonInteractionGA(analytics.CB_COUPON_USED, this.getOfferId(), false);
      },

      /**
       * send form field error
       * @param {String} type
       * @param {String|Boolean} value
         */
      eventFormError: function (type, value) {
        if ((_.indexOf(this.form_errors, type) == -1) && (value === false || !_.isEmpty(value))) {
          this.fireNonInteractionGA(
              analytics.CB_FORM_ERROR,
              type,
              false
          );
          this.form_errors.push(type);
        }
      },

      /**
       * scroll to calendar
       */
      eventChooseDates: function () {
        this.fireNonInteractionGA(analytics.CB_CHOOSE_DATES, this.getOfferId(), false);
      },

      /**
       * Get next review page
       */
      eventMoreOpinions: function () {
        this.fireNonInteractionGA(analytics.CB_MORE_OPINIONS, this.getOfferId(), false);
      },

      /**
       * change paxes
       */
      eventPaxConfig: function () {
        this.fireNonInteractionGA(analytics.CB_PAX_CONFIG, this.getOfferId(), false);
      },

      /**
        * Add a new room
        */
      eventAddRoom: function () {
        this.fireNonInteractionGA(analytics.CB_ADD_ROOM, this.getOfferId(), false);
      },

      /**
       * send event with tab information
       * @param {String} tab
       */
      eventCbTabContent: function (tab) {
        if (!angular.isObject(tab)) {
          return;
        }
        var name = '';
        try {
          switch (tab.slug) {
            case  analytics.CB_HELPER_ATTRACTION_TAB  :
                  name = 'landmarks';
                  break;
            case analytics.CB_HELPER_TRANSPORT_TAB    :
                  name = 'transport';
                  break;
            default:
                  name = tab.slug;
                  break;
          }
        } catch(e) {
          name = '';
        }
        if (name != '') {
          this.fireNonInteractionGA(analytics.CB_, this.getOfferId() + '_' + name, false);
        }
      },

      /**
       * set unique type paxes
       * @param {String} type
         */
      helperSetPaxes: function (type) {
        if (type) {
          this.type_pax.push(type);
          this.type_pax = _.uniq(this.type_pax);
        }
      },

      /**
       * send event if type: [ADT|CHD]
       */
      eventAddPax: function () {
        if (!_.isEmpty(this.type_pax)) {
          var self = this;
          _.each(this.type_pax, function (el) {
            self.fireNonInteractionGA(
                el == analytics.CB_HELPER_ADULT ? analytics.CB_ADD_ADULT : analytics.CB_ADD_CHILDREN,
                self.getOfferId(),
                false
            );
          });
          this.type_pax = [];
        }
      },

      /**
       *  SEARCH PANEL FUNCTIONS
       */

      /**
       * User Clicked Departure Selection Field
       */
      eventDepartureSelectionField: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_DEPARTURE_FIELD, 'label', false);
      },

      /**
       *  User Clicked "X" in Departure City modal.
       */
      eventDepartureCloseDropDown: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_DEPARTURE_CLOSE, 'label', false);
      },

      /**
       * User Clicked Destination Selection Field
       */
      eventDestinationSelectionField: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_DESTINATION_FIELD, 'label', false);
      },

      /**
       * User Clicked select all
       */
      eventPeriodAllMonth: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_PERIOD_ALLMONTHS, 'label', false);
      },

      /**
       * User Clicked uncheck all
       */
      eventPeriodDeselectAllMonth: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_PERIOD_RESETMONTHS, 'label', false);
      },

      /**
       * User clicked "X" button after opening period search modal
       */
      eventPeriodCloseDropDown: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_PERIOD_CLOSE, 'label', false);
      },

      /**
       * USER CLICKED "SEARCH" BUTTON
       */
      eventSearchButton: function () {
        this.fireNonInteractionGA(analytics.CB_SEARCH_BUTTON, 'label', false);
      },


      /**
       * Creates a booking transaction for Google Analytics
       *
       * @return {FlightAnalytics}
       */
      makeTransaction: function (data) {

        if(dataLayer)
        {
          dataLayer.push(
              {
            'transactionId': 'BC9840D', // CityBreak Booking number
            'transactionAffiliation': 'fru', // Affiliate
            'transactionTotal': 270.00, // TF revenue
            'transactionTax': 0, // We don't use this
            'transactionShipping': 0, // We don't use this
            'transactionProducts': [{
              'sku': 'WMICRLWMI', // Origin and Destination City Codes
              'name': 'CityBreak', // Name consist of 'Hotel -' and hotel provider, column 'Provider' in Admin: 'Gta','Hotelspro' or 'Booking'
              'category': 'FR', // Carrier
              'price': 1570.00, // Price of the product
              'quantity': 3 // Number of PAXs
            }],
            'event' : 'transactionComplete' // Event fired when transaction is completed
          });
        }
      }
    };


    PackageAnalytics.prototype.constructor = PackageAnalytics;

    return new PackageAnalytics();
  }]);
;

// Source: ../shared/public_html/assets/js/google/services/Remarketing.js
(function (angular, dataLayer, _js_app_config_) {
angular.module('google')

        /**
         * @name        Remarketing
         * @namespace   goo
         * @description
         */
        .factory('goo.Remarketing', ['appConfig', '$log',
            function RemarketingFactory(appConfig, $log) {
/**
                 *
                 * @param {Object} targetObject
                 */
                var populateDimensions = function (targetObject) {
                    for (var i = 1; i <= 20; i++) {
                        targetObject['cd' + i] = Object.prototype.hasOwnProperty.call(window.gaDimensions || {}, i) ? window.gaDimensions[i] : null;
                    }
                };

                var combineCodes = function (locations) {
                    return locations.reduce(function (acc, location) {
                        return acc
                            ? acc + (',' + location.code)
                            : location.code
                    }, '')
                }

                /**
                 *
                 * @param {Object} dataLayerData
                 * @returns
                 */
                var dataLayerPush = function (dataLayerData) {
                    if (typeof dataLayer === 'undefined') {
                        return;
                    }

                    populateDimensions(dataLayerData);
                    dataLayer.push(dataLayerData);
                };

                var clearEcommerce = function () {
                    if (typeof dataLayer === 'undefined') {
                        return;
                    }

                    dataLayer.push({ ecommerce: null });
                };

                /**
                 * Remarketing
                 *
                 * @constructor
                 */
                var Remarketing = function () {
                };

                Remarketing.prototype = /** @lends Remarketing.prototype */ {
                    dataLayerPush: dataLayerPush,

                    clearEcommerce: clearEcommerce,

                    /**
                     * Tracks Google AdWords remarketing
                     *
                     * @return {Remarketing}
                     */
                    changeParams: function (url, old) {
                        if (typeof dataLayer === 'undefined') {
                            return;
                        }

                        if (url.indexOf('flightDetails/get') !== -1) {
                            window.google_tag_params.flight_pagetype = 'cart_pax_details';
                            dataLayer.push({
                                'event': 'cart_pax_details',
                                'google_tag_params': window.google_tag_params
                            });

                            // Make funnel steps look more like links
                            url = url.split('#').join('/');
                        }

                        if (url.indexOf('thankYou/show') !== -1) {
                            window.google_tag_params.flight_pagetype = 'purchase';
                            dataLayer.push({
                                'event': 'purchase',
                                'google_tag_params': window.google_tag_params
                            });
                        }

                        dataLayerPush({
                            'CustomURL': url,
                            'CustomPageTitle': document.title,
                            'CustomReferer': (old === url) ? _js_app_config_.referer : old,
                            'event': 'NewPageView'
                        });
                    },

                    /**
                     * Event For step 2 & 3 on the basket
                     * @param flightDetails
                     */
                    flightProduct: function (flightBooking, prefix) {
                        var string = prefix;
                        var flightDetails = flightBooking.flightDetails;
                        var flightType = '';

                        if (flightDetails.isRegularFlight()) {
                            string += 'GDS ';
                            flightType = 'GDS';
                        } else if (flightDetails.isSoowFlight()) {
                            string += 'SOOW ';
                            flightType = 'SOOW';
                        } else if (flightDetails.isLowCost()) {
                            string += 'Lowcost ';
                            flightType = 'LCC';
                        } else if (flightDetails.isCharter()) {
                            string += 'Charter ';
                            flightType = 'Charter';
                        } else if (flightDetails.isHubFlight()) {
                            string += 'SmartConnection ';
                            flightType = 'SmartConnection';
                        } else {
                            string += 'LCC ';
                            flightType = 'LCC';
                        }

                        var region = flightDetails.getRegion();

                        if (region == 'E') {
                            region = 'EU';
                        }

                        if (region == 'W') {
                            region = ' WORLD';
                        }

                        if (region == 'D') {
                            if (_js_app_config_.affiliateId == 1) {
                                region = 'RO';
                            } else if (_js_app_config_.affiliateId == 3) {
                                region = 'PL';
                            } else if (_js_app_config_.affiliateId === 101) {
                                region = 'BG';
                            } else {
                                region = 'DOMESTIC';
                            }

                        }

                        var oneWay = flightDetails.isRoundTrip() ? 0 : 1;
                        var stops = flightDetails.legs[0].getStops();

                        if (flightDetails.isRoundTrip()) {
                            stops = flightDetails.legs[0].getStops() + flightDetails.legs[1].getStops();
                        }

                        if (typeof dataLayer != 'undefined') {
                            var refData = {
                                'FlightDetails': [
                                    {'Price': flightBooking.basket.getTotalPrice()},
                                    {'TF_Revenue': flightBooking.basket.getTotalTransFee()},
                                    {'Type': flightType + ' ' + region},
                                    {'Stops': stops},
                                    {'pax': flightBooking.basket.getPaxCount()},
                                    {'one-way': oneWay},
                                    {'ibe-slot-version': Object.prototype.hasOwnProperty.call(flightDetails.abTests, 'ibe_slot_version') ? flightDetails.abTests.ibe_slot_version : ''}
                                ]
                            };

                            dataLayer.push(refData);
                            dataLayer.push({'event': string});
                        }
                    },


                    /**
                     * State params on search
                     * @param state
                     */
                    flightDetails: function (state) {
                        if (window.google_tag_params) {
                            window.google_tag_params.flight_destid = _.isUndefined(state.arrCode) ? '' : state.arrCode;
                            window.google_tag_params.flight_originid = _.isUndefined(state.depCode) ? '' : state.depCode;
                            window.google_tag_params.flight_startdate = _.isUndefined(state.depDate) ? '' : state.depDate;
                            window.google_tag_params.flight_enddate = _.isUndefined(state.arrDate) ? '' : state.arrDate;
                            window.google_tag_params.flight_pagetype = 'searchresults';

                            if (typeof dataLayer != 'undefined') {
                                dataLayer.push({
                                    'event': 'searchresults',
                                    'google_tag_params': window.google_tag_params
                                });
                            }
                        } else {
                            $log.warn('window.google_tag_params is not defined');
                        }
                    },

                    /**
                     * State params on landing Page
                     * @param state
                     */
                    landingPage: function (data, trackingData) {
                        if (window.google_tag_params) {
                            window.google_tag_params.flight_destid = _.isUndefined(trackingData.to.cityCode) ? '' : trackingData.to.cityCode;
                            window.google_tag_params.flight_originid = _.isUndefined(trackingData.from.cityCode) ? '' : trackingData.from.cityCode;
                            window.google_tag_params.flight_startdate = _.isUndefined(data.departure_date) ? '' : data.departure_date;
                            window.google_tag_params.flight_enddate = _.isUndefined(data.return_date) ? '' : data.return_date;
                            window.google_tag_params.flight_pagetype = 'landingpage';
                            if (typeof dataLayer != 'undefined') {
                                dataLayer.push({
                                    'event': 'landingpage',
                                    'google_tag_params': window.google_tag_params
                                });
                            }
                        } else {
                            $log.warn('window.google_tag_params is not defined');

                        }
                    },

                    trackRemarketing: function (customParams, conversionLabel, remarketingOnly) {
                        var conversionData = {
                            google_conversion_id: appConfig.getGoogleRemarketingId(),
                            google_remarketing_only: remarketingOnly
                        };

                        // Add custom parameters?
                        if (customParams) {
                            conversionData.google_custom_params = customParams;
                        }

                        // Add conversion label?
                        if (conversionLabel) {
                            conversionData.google_conversion_label = conversionLabel;
                        }

                        // Call Google conversion tracker
                        this._send(conversionData);

                        return this;
                    },

                    /**
                     * Not Used
                     * Tracks Google AdWords conversion
                     *
                     * @param  {Booking} bookingDetails
                     *
                     * @return {Remarketing}
                     */
                    trackConversion: function (bookingDetails) {
                        // Flight details is required
                        if (!bookingDetails.getFlightDetails()) return;

                        var flightType = bookingDetails.getFlightDetails().getFlightType();
                        var region = bookingDetails.getFlightDetails().getRegion();

                        var conversionConfig = appConfig.getGoogleConversions();

                        _.each(conversionConfig.accounts, function (account, index) {
                            // Set initial conversion data
                            var conversionData = {
                                google_conversion_id: account.google_conversion_id,
                                google_conversion_language: account.google_conversion_language,
                                google_conversion_format: '3',
                                google_conversion_color: 'ffffff',
                                google_conversion_value: 1.00,
                                google_conversion_currency: 'RON',
                                google_remarketing_only: false
                            };

                            // Insert conversion label according to flight type and region
                            // SOOW is not treated here
                            if (flightType == 'REGULAR') {
                                // GDS
                                switch (region) {
                                    case 'D':
                                        conversionData.google_conversion_label = conversionConfig.labels.gds.domestic[index];
                                        break;
                                    case 'E':
                                        conversionData.google_conversion_label = conversionConfig.labels.gds.eu[index];
                                        break;
                                    case 'W':
                                        conversionData.google_conversion_label = conversionConfig.labels.gds.world[index];
                                        break;
                                }
                            } else if (flightType == 'LOWCOST') {
                                // LCC
                                conversionData.google_conversion_label = conversionConfig.labels.lcc[index];
                            }

                            // Call Google conversion tracker
                            this._send(conversionData);

                            return this;
                        }, this);
                    },

                    /**
                     * Send conversion data to Google
                     *
                     * @param {Object} data
                     *
                     * @return {Remarketing}
                     */
                    _send: function (data) {
                        // Check to see if script from Google is loaded
                        if (typeof window.google_trackConversion == 'function') {
                            // It is, function can be called
                            window.google_trackConversion(data);
                        }
                    },

                    trackCalendarClick: function (action, label) {
                        dataLayerPush({
                            event: 'autoEvent',
                            eventCategory: 'Flight_Calendar_Page',
                            eventAction: action,
                            eventLabel: label
                        });
                    },

                    trackMonthBarClick: function () {
                        dataLayerPush({
                            event: 'autoEvent',
                            eventCategory: 'Website Clicks',
                            eventAction: 'cb_month_bar'
                        });
                    },

                    /**
                     * Sends search start data to remarketing
                     *
                     * @param {Object} searchPayload
                     */
                    sendSearchStartData: function (searchPayload) {
                        dataLayerPush({
                            event: 'searchresults',
                            google_tag_params: {
                                flight_pagetype: 'searchresults',
                                flight_originid: combineCodes(searchPayload.locations.origins),
                                flight_destid: combineCodes(searchPayload.locations.destinations),
                                flight_startdate: searchPayload.dates.departureFrom,
                                flight_enddate: searchPayload.dates.returnFrom
                            }
                        });
                    },

                    /**
                     * Sends search finish data to remarketing
                     *
                     * @param {FlightOfferModel} firstFlight
                     * @param {Object} searchPayload
                     */
                    sendSearchFinishData: function (firstFlight, searchPayload) {
                        var flightStops = firstFlight.stages[0].stopovers.length;

                        if (firstFlight.isRoundTrip()) {
                            flightStops += firstFlight.stages[1].stopovers.length;
                        }

                        var dataLayerData = {
                            event: 'FirstFlightResultEnded',
                            FirstFlightResult: [
                                {Price: firstFlight.getPriceWithoutTf()},
                                {TF_Revenue: firstFlight.fees.transactionFee.amount},
                                {Type: ''},
                                {Stops: flightStops},
                                {pax: searchPayload.passengers.adults},
                                {pax_ch: searchPayload.passengers.children},
                                {pax_inf: searchPayload.passengers.infants},
                                {pax_yht: searchPayload.passengers.youth},
                                {pax_se: searchPayload.passengers.seniors},
                                {'one-way': searchPayload.dates.returnFrom === ''}
                            ]
                        };

                        dataLayerPush(dataLayerData);
                    },

                    /**
                     * Sends pax data to remarketing
                     *
                     * @param {FlightDetails} flightDetails
                     */
                    sendPaxData: function (flightDetails) {
                        dataLayerPush({
                            event: 'FlightDetails'
                        });

                        dataLayerPush({
                            event: 'cart_flight_details',
                            google_tag_params: {
                                flight_pagetype: 'cart_flight_details',
                                flight_originid: flightDetails.getDepLeg().getDepCityCode(),
                                flight_destid: flightDetails.getDepLeg().getArrCityCode(),
                                flight_startdate: flightDetails.getDepDate(),
                                flight_enddate: flightDetails.isOneWay() ? '' : flightDetails.getRetDate()
                            }
                        });
                    },

                    /**
                     * Send LP data
                     *
                     * @param {Object[]} flights
                     */
                    sendLpFlightLoad: function (flights) {
                        if (flights.length === 0) {
                            return;
                        }

                        dataLayerPush({
                            'FirstFlightResult': [
                                {'Price': flights[0].price}
                            ]
                        });

                        dataLayerPush({'event': 'lpLoad'});
                    },

                    /**
                     * Send flight book data
                     *
                     * @param {String} paymentMethod
                     */
                    sendFlightBookData: function (paymentMethod) {
                        dataLayerPush({
                            'event': 'websiteClicks',
                            'action': 'Book this flight',
                            'label': paymentMethod
                        });
                    },

                    trackCouponSent: function () {
                        dataLayerPush({
                            event: 'autoEvent',
                            evetnCategory: 'Coupon Sent'
                        });
                    },

                    trackFareAlert: function () {
                        dataLayerPush({
                            event: 'autoEvent',
                            eventCategory: 'Flight Search Filter',
                            eventAction: 'Create fare alert'
                        });
                    },

                    trackNewFlightDetails: function (flightDetails) {
                        var eventAction = flightDetails.getDepLeg().getDepCityCode();
                        eventAction += '|' + flightDetails.getDepLeg().getArrCityCode();
                        eventAction += '|' + flightDetails.getDepLeg().getDepDate();

                        var hasBadger = false;
                        angular.forEach(flightDetails.getDepLeg().getSegments(), function (segm) {
                            if (segm.getProvider() == 'badger') {
                                hasBadger = true;
                            }
                        });

                        if (flightDetails.isRoundTrip()) {
                            eventAction += '|' + flightDetails.getRetLeg().getDepDate();
                            angular.forEach(flightDetails.getRetLeg().getSegments(), function (segm) {
                                if (segm.getProvider() == 'badger') {
                                    hasBadger = true;
                                }
                            });
                        }

                        var newRefData = {
                            event: 'autoEvent',
                            eventCategory: 'Flight Details',
                            eventAction: eventAction
                        };
                        dataLayerPush(newRefData);

                        dataLayerPush({
                            event: 'autoEvent',
                            eventCategory: 'ibe-slot-version',
                            eventAction: Object.prototype.hasOwnProperty.call(flightDetails.abTests, 'ibe_slot_version') ? flightDetails.abTests.ibe_slot_version : ''
                        });
                    }
                };

                Remarketing.prototype.constructor = Remarketing;

                return new Remarketing();
            }])

        /**
         * Init phase
         */
        .run(['$rootScope', 'goo.Remarketing', function ($rootScope, Remarketing) {
            // Wait for location changes and init remarketing main tracker
            $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
                // Call default tracker on other pages except selected ones
                // var currentPath = (typeof($rootScope.currentPath) == 'function') ? $rootScope.currentPath() : 'home';
                Remarketing.changeParams(newUrl, oldUrl);
            });
        }]);

}(angular, dataLayer, _js_app_config_));
;

// Source: ../shared/public_html/assets/js/google/services/SplitFunnelDatalayerHelper.js
(function (angular) {
var SplitFunnelDatalayerHelper = function (Dictionaries, DataLayerHelper, StepsEnum) {
        /**
         *
         * @param {string} id
         * @param {FlightDetails} flightDetails
         * @returns
         */
        var getItemId = function (id, flightDetails) {
            var itemId = DataLayerHelper.getFlightIdentifier(flightDetails);

            switch (id) {
                case 'smsNotification':
                    itemId += '_SMS';
                    break;

                case 'cabinLuggage':
                case 'checkedLuggage':
                    itemId += '_LUGG';
                    break;

                case 'ticketType':
                    itemId += '_PKG';
                    break;

                case 'frolaAssistance':
                    itemId += '_SUPP';
                    break;

                case 'paidCheckin':
                    itemId += '_PCI';
                    break;

                case 'seatSelect':
                    itemId += '_SEA';
                    break;

                case 'insurance':
                    itemId += '_INS';
                    break;

                case 'tripGuarantee':
                    itemId += '_TG';
                    break;

                case 'fastRefund':
                    itemId += '_FR';
                    break;

                case 'cfar':
                    itemId += '_CFAR';
                    break;
            }

            return itemId;
        };

        /**
         *
         * @param {Object} item
         * @returns
         */
        var getItemName = function (item, flightDetails) {
            var name = '';

            switch (item.id) {
                case 'flight':
                    name = Dictionaries.getCityNameByCode(flightDetails.getDepLeg().getDepCityCode(), false);
                    name += ' - ';
                    name += Dictionaries.getCityNameByCode(flightDetails.getDepLeg().getArrCityCode(), false);

                    if (flightDetails.isRoundTrip()) {
                        name += ' - ' + Dictionaries.getCityNameByCode(flightDetails.getDepLeg().getDepCityCode(), false);
                    }
                    break;

                case 'smsNotification':
                    name = 'SMS Notifications';
                    break;

                case 'cabinLuggage':
                    name = 'Cabin luggage';
                    break;

                case 'checkedLuggage':
                    name = 'Checked luggage';
                    break;

                case 'ticketType':
                    name = 'Basic Package';

                    if (item.variant === 'smart') {
                        name = 'Smart Package';
                    }

                    if (item.variant === 'flex') {
                        name = 'Super Flex Package';
                    }
                    break;

                case 'frolaAssistance':
                    name = 'No Priority Support';

                    if (item.variant === 'chat') {
                        name = 'Standard Support';
                    }

                    if (item.variant === 'phone') {
                        name = 'Premium Support';
                    }
                    break;

                case 'paidCheckin':
                    name = 'Paid Check-in';
                    break;

                case 'seatSelect':
                    name = 'Seats';
                    break;

                case 'insurance':
                    name = 'Insurance';
                    break;

                case 'tripGuarantee':
                    name = 'Trip Guarantee';
                    break;

                case 'fastRefund':
                    name = 'Fast Refund';
                    break;

                case 'cfar':
                    name = 'CFAR';
                    break;
            }

            return name;
        };

        /**
         *
         * @param {Object} basketItem
         * @returns
         */
        var getItemCategory = function (basketItem) {
            var category = '';

            switch (basketItem.id) {
                case 'flight': category = 'TF'; break;
                case 'smsNotification': category = 'SMS'; break;
                case 'cabinLuggage': category = 'Cabin Luggage'; break;
                case 'checkedLuggage': category = 'Checked Luggage'; break;
                case 'ticketType': category = 'Package Type'; break;
                case 'frolaAssistance': category = 'Support Type'; break;
                case 'paidCheckin': category = 'Check-in'; break;
                case 'seatSelect': category = 'Seats'; break;
                case 'insurance': category = 'Insurance'; break;
                case 'tripGuarantee': category = 'Guarantee'; break;
                case 'fastRefund': category = 'Refund'; break;
                case 'cfar': category = 'Flex'; break;
            }

            return category;
        };

        /**
         *
         * @param {Object} basketItem
         * @returns
         */
        var getItemVariant = function (basketItem, flightDetails) {
            var variant = 'No Variant';

            switch (basketItem.id) {
                case 'flight':
                    variant = 'GDS';

                    if (flightDetails.isSoowFlight()) {
                        variant = 'SOOW';
                    }

                    if (flightDetails.isHubFlight()) {
                        variant = 'HUB';
                    }

                    if (flightDetails.isCharter()) {
                        variant = 'Charter';
                    }

                    if (flightDetails.isLowCost()) {
                        variant = 'LCC';
                    }

                    if (flightDetails.isRegularFlight()) {
                        variant = 'GDS';
                    }

                    var region = flightDetails.getRegion();

                    if (region ==- 'E') {
                        variant += ' EU';
                    }

                    if (region === 'W') {
                        variant += ' WORLD';
                    }

                    if (region === 'D') {
                        variant += ' DOMESTIC';
                    }

                    break;

                case 'ticketType':
                    variant = 'Basic';

                    if (basketItem.variant === 'smart') {
                        variant = 'Smart Package';
                    }

                    if (basketItem.variant === 'flex') {
                        variant = 'Super Flex Package';
                    }
                    break;

                case 'frolaAssistance':
                    variant = 'No Priority';

                    if (basketItem.variant === 'chat') {
                        variant = 'Standard';
                    }

                    if (basketItem.variant === 'phone') {
                        variant = 'Premium';
                    }
                    break;
            }

            return variant;
        };

        /**
         *
         * @param {string} id
         * @returns
         */
        this.getSplitFunnelStepEventNameById = function (id) {
            var event = '';

            switch (id) {
                case StepsEnum.TICKET_TYPE:
                    event = 'select_ticket_type_step';
                    break;

                case StepsEnum.CONFIGURE_TRIP:
                    event = 'configure_your_trip_step';
                    break;

                case StepsEnum.PROTECT_TRIP:
                    event = 'protect_your_trip_step';
                    break;

                case StepsEnum.BILLING:
                    event = 'billing_and_payment_step';
                    break;

                default:
                    event = 'begin_checkout';
                    break;
            }

            return event;
        };

        /**
         *
         * @param {Object[]} basketItems
         * @param {FlightDetails} flightDetails
         * @returns {Object[]}
         */
        this.getEcommerceItems = function (basketItems, flightDetails) {
            var items = [];

            angular.forEach(basketItems, function (basketItem) {
                items.push({
                    item_id: getItemId(basketItem.id, flightDetails),
                    item_name: getItemName(basketItem, flightDetails),
                    item_brand: DataLayerHelper.getItemBrand(),
                    item_category: getItemCategory(basketItem),
                    item_variant: getItemVariant(basketItem, flightDetails),
                    price: basketItem.price,
                    quantity: basketItem.quantity
                });
            });

            return items;
        };
    };

    SplitFunnelDatalayerHelper.$inject = ['Dictionaries', 'DataLayerHelper', 'StepsEnum'];

    angular
        .module('google')
        .service('SplitFunnelDatalayerHelper', SplitFunnelDatalayerHelper);

}(angular));
;

// Source: ../shared/public_html/assets/js/google/services/flightanalytics.factory.js
(function(angular) {
/**
   * @name FlightAnalyticsFactory
   * @description Factory for flight analytics model.
   * @constructor
   */
    var FlightAnalyticsFactory = function(Basket, Remarketing, AppConfig, SplitFunnelDatalayerHelper) {

        /**
     * Flight analytics model.
     *
     * @param {Booking}            bookingDetails   Instance of booking details class
     * @param {apiBookingResponse} bookingResponse  Success response from booking API
     * @constructor
     */
        var FlightAnalytics = function (bookingDetails, bookingResponse) {

            // FlightAnalytics requires reservation number
            if (!_.isObject(bookingResponse) || !bookingResponse.reservationNumber) {
                throw 'FlightAnalytics expects reservation number';
            }

            /**
       * Booking details.
       *
       * @type {Booking}
       */
            this.bookingDetails = bookingDetails;

            /**
       * API booking response.
       *
       * @type {Object}
       */
            this.bookingResponse = bookingResponse;

            /**
       * Flight basket instance.
       *
       * @type {Basket}
       */
            this.basket = new Basket(this.bookingDetails);
        };

        /**
     * Creates a booking transaction for Google Analytics.
     */
        FlightAnalytics.prototype.makeTransaction = function () {
            var avgPrice = (this.basket.getTotalTransFee() + this.basket.getTFee()) / this.basket.getPaxCount();
            if (typeof dataLayer != 'undefined') {
                var affiliateName = AppConfig.getAffiliateName();
                var segmentCount = 0;

                try {
                    if (this.basket.flightDetails.isRoundTrip()) {
                        segmentCount = this.basket.flightDetails.getDepLeg().segmentsCount + (this.basket.flightDetails.getRetLeg() ? this.basket.flightDetails.getRetLeg().segmentsCount : 0);
                    } else {
                        segmentCount = this.basket.flightDetails.getDepLeg().segmentsCount;
                    }
                }
                catch(e){
                    segmentCount = 0;
                }

                dataLayer.push({'payment': this.basket.dataProvider.payment.getType()});
                dataLayer.push({'payment fees': this.basket.getTotalPaymentFee()});
                dataLayer.push({'discounts': this.basket.getTotalDiscount()});
                dataLayer.push({ 'segments': segmentCount });

                this.completeTransaction(affiliateName, avgPrice);

                dataLayer.push({ 'event': 'purchase' });
            }
        };

        /**
         * Complete transaction.
         *
         * @param {string} affiliateName
         * @param {number} avgPrice
         */
        FlightAnalytics.prototype.completeTransaction = function(affiliateName, avgPrice) {
            var transactionData = {
                transactionId: this.bookingResponse.reservationNumber, // Booking number
                transactionAffiliation: affiliateName, // Affiliate
                transactionTotal: this.basket.getTotalPrice(), // TF revenue
                transactionTax: 0, // We don't use this
                transactionShipping: 0, // We don't use this
                transactionProducts: [{
                    sku: this.getItemSku(), // Origin City + Destination City
                    name: this.getItemName(), // Product Type
                    category: this.getItemCategory(), // Carrier
                    price: avgPrice, // TF per ticket
                    quantity: this.basket.getPaxCount() // Number of Passengers/PAXs
                }],
                event: 'transactionComplete', // Event fired when transaction is completed
                lock_fare: this.bookingDetails.fareLock.isPopulated() && this.bookingDetails.fareLock.isConfirmed(),
                paymentMethod: this.bookingDetails.getPayment().type,
                currency: AppConfig.getCurrencyCode(),
                items: SplitFunnelDatalayerHelper.getEcommerceItems(
                    this.basket.getBasketItems(),
                    this.bookingDetails.getFlightDetails()
                )
            };

            angular.forEach(this.basket.getCalculatedCoupons(), function (coupon) {
                transactionData.coupon = coupon.getCampaignTitle();
            });

            Remarketing.dataLayerPush(transactionData);
        };

        /**
     * Returns item SKU for addItem analytics method
     * In case of flights it is a combination of city codes
     * Ex: BUHPARBUH (round-trip), BUHPAR (one-way)
     *
     * @return {string}
     */
        FlightAnalytics.prototype.getItemSku = function () {
            var sku =
        this.bookingDetails.getFlightDetails().getDepLeg().getDepCityCode() +
        this.bookingDetails.getFlightDetails().getDepLeg().getArrCityCode();

            // Check for round-trip
            if (this.bookingDetails.getFlightDetails().isRoundTrip()) {
                sku += this.bookingDetails.getFlightDetails().getRetLeg().getArrCityCode();
            }

            return sku;
        };

        /**
     * Returns item name for addItem analytics method
     * In case of flights this is represented by type of flight, type of booking and destination area
     * Ex: GDS Booking EU
     *
     * @return {string}
     */
        FlightAnalytics.prototype.getItemName = function () {
            var name = '';

            // Determine flight type
            if (this.bookingDetails.getFlightDetails().isRegularFlight()) {
                var region = this.bookingDetails.getFlightDetails().getRegion();
                name = 'GDS ';

                if (region == 'E') {
                    name += 'EU';
                }

                if (region == 'W') {
                    name += ' WORLD';
                }

                if (region == 'D') {
                    if (_js_app_config_.affiliateId == 1) {
                        name += 'RO';
                    }
                    else if (_js_app_config_.affiliateId == 3) {
                        name += 'PL';
                    }
                    else if (_js_app_config_.affiliateId == 101) {
                        name += 'BG';
                    }
                    else {
                        name += 'DOMESTIC';
                    }

                }
            }
            else if (this.bookingDetails.getFlightDetails().isSoowFlight()) {
                name += 'SOOW';
            }
            else if (this.bookingDetails.getFlightDetails().isCharter()) {
                name = 'Charter ';
            }
            else if (this.bookingDetails.getFlightDetails().isLowCost()) {
                name = 'Lowcost ';
            }
            else if (this.bookingDetails.getFlightDetails().isHubFlight()) {
                name = 'Smart Connection';
            }
            else {
                name = 'Lowcost';
            }

            return name;
        };

        /**
     * Returns item category for addItem analytics method
     * In case of flights this is the carrier code
     * Ex: W6
     *
     * @return {string}
     */
        FlightAnalytics.prototype.getItemCategory = function () {
            return this.bookingDetails.getFlightDetails().getDepLeg().getCarrierCode();
        };

        FlightAnalytics.prototype.constructor = FlightAnalytics;

        return FlightAnalytics;
    };

    FlightAnalyticsFactory.$inject = [
        'bas.Basket',
        'goo.Remarketing',
        'appConfig',
        'SplitFunnelDatalayerHelper'
    ];

    angular.module('google').factory('goo.FlightAnalytics', FlightAnalyticsFactory);
})(angular);
;

// Source: ../shared/public_html/assets/js/insurance/controllers/InsuranceStCalculateCtrl.js
angular.module('insurance')

/**
 * @name InsuranceStCalculateCtrl
 * @description Insurance Calculate Controller
 */
.controller('InsuranceStCalculateCtrl',
['$scope', 'RangeDatepicker', 'ins.InsuranceStArgs', 'ins.InsuranceStSrv', '$location', '$anchorScroll', '$rootScope', '$document', 'sch.SearchQueryParams', '$timeout', '$filter', 'appConfig', 'PageLoading', '$modal',
function ($scope, RangeDatepicker, InsuranceArgs, InsuranceSrv, $location, $anchorScroll, $rootScope, $document, SearchQueryParams, $timeout, $filter, appConfig, PageLoadingService, $modal) {
PageLoadingService.on();

  $timeout(function () {
    $scope.loaded = true;
    PageLoadingService.off();
  }, 200);

  $scope.image = '/media/img/uploaded/packages/homepages/About-insurance.png';
  $scope.device = appConfig.isMobile() || appConfig.isTablet();

  var currencySymbolFilter = $filter('currencySymbolStatic');

  var $this = this,
    minDays = _js_app_config_.insurance.minDays || 1,
    maxDays = _js_app_config_.insurance.maxDays || 90,
    enableStandalone = _user_ && _user_.isAgent || _js_app_config_.insurance.enableStandalone,
    startDate = SearchQueryParams.getDepDate(true),
    endDate = SearchQueryParams.getRetDate(true),
    insurance = new InsuranceArgs(
      {
        'enable' : enableStandalone,
        'step': 1,
        'minDays': minDays,
        'maxDays': maxDays,
        'paxCount': "1",
        'paxNumbers': [1, 2, 3, 4, 5, 6, 7, 8, 9],
        'zone': "International",
        'zones': {
          'International': $filter('translate')('LANGM_JS_ZONE_EUROPE'),
          'Intercontinental': $filter('translate')('LANGM_JS_ZONE_WORLD')
        },
        'startDate': startDate.format('DD-MM-YYYY'),
        'endDate': endDate.format('DD-MM-YYYY'),
        'totalPrices': {},
        /**
         * @navBarType [1 - home-hyb, 2 - insuranceSteps]
         */
        'navBarType': 1
      }
    );

  $rootScope.insurance = $scope.insurance = insurance || {};

  if(startDate.diff(moment(),'days') < 0 ) {
    startDate = moment(startDate).add(1, 'days');
  }
  if(endDate.diff(startDate,'days') <= 0) {
    endDate = moment(startDate).add( 6, 'days');
  }
  $scope.dateRange =
  {
    range: {
      start: startDate.toDate(),
      end: endDate.toDate(),
      endCache: endDate.toDate()
    }
  };

  $scope.chooseInsurance = function (event, item, url) {
    $scope.insurance.showDetails(url, item);
  };

  $scope.rangeDatepicker = new RangeDatepicker({
    minDate : moment().add(1, 'days'),
    maxDays : maxDays,
    scope: $scope,
    range: $scope.dateRange.range,
    isInsurance:true,
    minTripLength:1
  });

    var scrollToElement = function(id){
        $location.hash(id);
        $anchorScroll();
    };
    var scrollToInsuranceOption = function(element){

      $anchorScroll.yOffset = function(){
         var nav = document.getElementsByClassName('navbar-content');
          var navHeight = 50;
          if(nav.length > 0 ){
            navHeight = nav[0].clientHeight;
          }
          return navHeight;
      }
      scrollToElement('insurance-boxs');
      setTimeout(function(){
        $anchorScroll.yOffset = 0;
      },300);

    }
  $scope.insurance.scrollTo = function (id) {
    $scope.rangeDatepicker.toggleStartDatepicker();
      scrollToElement(id);
  };

  /**
   * Object holding errors messages
   *
   * @type {Object}
   */
  $scope.errorMessages = {
    dateDepartureInvalid: $filter('translate')('LANGM_JS_CHOOSE_DATE_DEPARTURE'),
    dateReturnInvalid: $filter('translate')('LANGM_JS_CHOOSE_DATE_RETURN')
  };

  $scope.errors = {
    custom: false
  };

  /**
   * Open errors modal
   */
  var openErrorsModal = function () {
    $modal.open({
      templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsFormErrors',
      controller: 'flightsFormErrorsModalCtrl',
      windowClass: 'flight-modal-message',
      resolve: {
        errors: function () {
          return $scope.errors;
        }
      }
    });
  };

  $scope.insurance.calculate = function (id) {
    $timeout(function () //wait for scope refresh
    {
      insurance.startDate = $scope.insurance.startDate = moment($scope.dateRange.range.start).format('DD-MM-YYYY');
      insurance.endDate = $scope.insurance.endDate = moment($scope.dateRange.range.end).format('DD-MM-YYYY');

      if (!($scope.dateRange.range.start instanceof Date)) {
        $scope.errors.custom = $scope.errorMessages.dateDepartureInvalid;
        openErrorsModal();
        return;
      }

      if (!($scope.dateRange.range.end instanceof Date)) {
        $scope.errors.custom = $scope.errorMessages.dateReturnInvalid;
        openErrorsModal();
        return;
      }
      $scope.insurance.provider = _js_app_config_.insurance.provider;
      InsuranceSrv.getPackages($scope.insurance).then
      (
        function success(resp) {
          if (resp.insurance) {

            transformOffers(resp.insurance);

            $scope.insurance.calculations = resp.insurance;

            $scope.insurance.setNavBarType(2);
            insurance.setStep(2);
              scrollToInsuranceOption();
          }
            $rootScope.refreshMenu();
        }
      );
    });
  };

  $scope.insurance.showDetails = function (url, item) {
    window.location.href = '/' + [
      url,
      insurance.getStartDate(),
      insurance.getEndDate(),
      item.type,
      insurance.getPaxCount(),
      insurance.getZone()
    ].join('/');
  };

  function transformOffers(insuranceOffers) {
    angular.forEach(insuranceOffers, transformOffer);
  }

  function transformOffer(insuranceOffer) {
    insuranceOffer.descriptions.currency = currencySymbolFilter(insuranceOffer.descriptions.currency);
  }

}]);
;

// Source: ../shared/public_html/assets/js/insurance/controllers/InsuranceStConfirmationCtrl.js
angular.module('insurance')

/**
 * @name InsuranceCalculateCtrl
 * @description Insurance Calculate Controller
 */
    .controller('InsuranceStConfirmationCtrl',
    ['$scope', 'ins.InsuranceStArgs', 'ins.InsuranceStSrv', '$location', '$anchorScroll', '$rootScope', '$stateParams','appConfig','$timeout','$modal', 'PageLoading', 'TextBox',
        function ($scope, InsuranceArgs, InsuranceSrv, $location, $anchorScroll, $rootScope, $stateParams,appConfig,$timeout,$modal, PageLoadingService, TextBoxService) {
PageLoadingService.on();
            // /insurance/details/{depDate}/{retDate}/{insuranceType}/{paxCount}/{zone}
            var error = $stateParams.error;
            var hash  = $stateParams.hash,

                insurance = new InsuranceArgs(
                    {
                        'step': 4
                    });

            $rootScope.insurance = $scope.insurance = insurance || {};

            /**
             * Payment Modal
             */
            $scope.ePaymentsModal = function () {
              var paymentType = $scope.paymentType.substr(0, 2);

              if (paymentType == 'CC') {
                // this need to implement payment micro-service first
                console.log('InsuranceStConfirmationCtrl CC form deprecated.');
              }

              /*
                $modal.open({
                  templateUrl: '/tpl/show/jsShared/templates/payment/modal',
                  controller: 'paymentModalCtrl',
                  backdrop: 'static',
                  size: 'modal-payment',
                  scope: $scope,
                  resolve: {
                    getMessage: function () {
                      return {
                        hash: hash,
                        disableCurrencySwitch: true
                      };
                    }
                  }
                });
               */

              $modal.open({
                templateUrl: '/tpl/show/templates/components/modals/funnel/ePayments-hyb',
                controller: 'ePaymentsCtrl',
                backdrop: 'static',
                size: 'custom-md',
                resolve: {
                  ModalArgs: function () {
                    var newMsg = {};
                    newMsg.price = $scope.price;
                    if ($scope.paymentType == 'PP') {
                      newMsg.forcePayPal = 1;
                    }
                    return newMsg;
                  }
                }
              });

            };

          $scope.handlePaymentLinkUnavailable = function () {
            TextBoxService.getByName('payment_link_unavailable_message').then(function (response) {
              $scope.confirmationContent = response.text;
            }, function () {
              $scope.pageData.content = 'add payment_link_unavailable_message text box';
            }).finally(function () {
              PageLoadingService.off();
            });
          };

          $scope.redirectToCustomPaymentLink = function () {
            PageLoadingService.on();

            var data = {
              hash: hash,
              error:error
            };

            InsuranceSrv.getPaymentLink(data).then(function success(response) {
              if (null === response.paymentLink) {
                $scope.handlePaymentLinkUnavailable();
                PageLoadingService.off();
                return;
              }

              window.location.href = response.paymentLink;
            }, function () {
              $scope.handlePaymentLinkUnavailable();
              PageLoadingService.off();
            });
          };

            /**
             * Get insurance
             */
            InsuranceSrv.getConfirmation({
                hash: hash,
                error:error
            }).then(
                function success(resp) {
                    if (resp.confirmation) {
                        $scope.confirmationContent = resp.confirmation;
                        $scope.price               = resp.price;
                        $scope.paymentType         = resp.paymentType;
                        $timeout(
                            function () {
                              var paymentButton = document.getElementById(appConfig.getPaymentButton());

                              if (!paymentButton) {
                                return;
                              }

                              if (resp.paymentType === 'EP') {
                                paymentButton.addEventListener("click", $scope.ePaymentsModal, false);
                                return;
                              }

                              paymentButton.addEventListener("click", $scope.redirectToCustomPaymentLink, false);
                            }
                        );
                    }
                    PageLoadingService.off();
                },
              function error(){
                  PageLoadingService.off();
              }
            );


        }]);
;

// Source: ../shared/public_html/assets/js/insurance/controllers/InsuranceStDetailsCtrl.js
angular.module('insurance')

/**
 * @name InsuranceCalculateCtrl
 * @description Insurance Calculate Controller
 */
.controller('InsuranceStDetailsCtrl',
['$scope', 'ins.InsuranceStArgs', 'ins.InsuranceStSrv', '$location', '$anchorScroll', '$rootScope', '$stateParams', 'bil.Billing', 'OrderState', 'AnchorSmoothScroll', '$filter', 'OrderValidation','$sce', 'PageLoading', 'appConfig', '$modal', 'PageLoading', '$timeout',
function ($scope, InsuranceArgs, InsuranceSrv, $location, $anchorScroll, $rootScope, $stateParams, Billing, OrderState, AnchorSmoothScroll, $filter, OrderValidation, $sce, PageLoadingService, appConfig, $modal, PageLoading, $timeout) {
$scope.flightBooking = null;
  $scope.showInsuranceLoading = false;
  $scope.getDefaultCountryCode = appConfig.getDefaultCountryCode;
    $scope.isVola = $rootScope.affiliate === 'vola';
  PageLoadingService.on();
  // /insurance/details/{depDate}/{retDate}/{insuranceType}/{paxCount}/{zone}
  var now = new Date(),
      departureDays = moment($stateParams.startDate, 'DD-MM-YYYY').diff(moment(now.getDate(), 'DD-MM-YYYY'), 'days'),
      insurance = new InsuranceArgs(
      {
        'step': 3,
        'paxCount': $stateParams.paxCount || 1,
        'paxNumbers': [1, 2, 3, 4, 5, 6, 7, 8, 9],
        'zone': $stateParams.zone,
        'zones': {
          'International': $filter('translate')('LANGM_JS_ZONE_EUROPE'),
          'Intercontinental': $filter('translate')('LANGM_JS_ZONE_WORLD')
        },
        'startDate': $stateParams.startDate || '',
        'endDate': $stateParams.endDate || '',
        'insuranceType': $stateParams.insuranceType || '',
        'totalPrices': {}
      }
    );

  insurance.payment.creditCard.setDisableCurrencySwitch(true);

  $scope.showPassportSelect = function () { return false; };

  var scrollToForm = function() {
    var goTo = OrderValidation.scrollIfClient($scope.bookingForm);
    $location.hash(goTo);
    AnchorSmoothScroll.scrollTo(goTo);
  };

  /**
   * Dirty fix for not showing error for birthdate (#11401)
   *
   * Set errors after backend validation for birthday field
   * @param errors
   */
    var setServerBirthdayValidationErrors = function(errors) {
      //Passenger's birthdate
      if(_.has(errors, 'pax') && !_.isEmpty(errors.pax)) {

          _.forEach(errors.pax, function(pax, key) {
              var passengerDetailsKey = 'passengerDetails' + key;

              if($scope.bookingForm && $scope.bookingForm[passengerDetailsKey]) {
                  $scope.flightBooking.paxes[key].getPerson().srvErrors({
                      birthDate: errors.pax[key].birthdate
                  });
                  $scope.bookingForm[passengerDetailsKey].birthDate.$setValidity('backend', false);
              }
          });
      }

      //name on card
      if(_.has(errors, 'payment') && !_.isEmpty(errors.payment)) {
          var creditCardForm = $scope.bookingForm.paymentInfo.creditCardForm;

          $scope.flightBooking.payment.creditCard.srvErrors({
              fullName: errors.payment.details.firstName
          });

          creditCardForm.fullName.$setValidity('backend', false);
      }

      scrollToForm();
    };

  function setInitialPaxes() {
    var i = 0;
    for (i; i < insurance.paxCount; i++) {
      $scope.flightBooking.addPaxByType('ADT');
    }
  }

  $scope.orderState = OrderState;

  $scope.orderState.setOrderState();
  $scope.flightBookingPromise = $scope.orderState.getOrderState();
  $scope.flightBookingPromise.then(function (booking) {
    $scope.flightBooking = booking;
    setInitialPaxes();
    $scope.flightBooking = _.extend($scope.flightBooking, insurance);
    PageLoadingService.off();
  }, function error(){
    PageLoadingService.off();
  });

  $scope.passengers = {};
  $scope.passengers.person = {};
  //$scope.passengers.person.contact = {};

  $rootScope.insurance = $scope.insurance = insurance || {};

  var unwatch = $rootScope.$watch('auth', function (newValue) {
    (newValue) ? $scope.logged = false : $scope.logged = true;
    unwatch();
  });

  /**
   * Get insurance
   */
  InsuranceSrv.getDetails($scope.insurance).then
  (
    function success(resp) {

      if (resp.insurance) {
        var option = resp.insurance.option;

        $scope.insurance.setOptions({
          'days': option.days,
          'totalPrices': option.totalPrice,
          'box': resp.insurance.box,
          'insuranceType': option.type
        });

        PageLoading.getLoadingPromise().then(function(){

          // Show alert modal
          $timeout(function(){
            if(InsuranceSrv.isShowAlertModal(insurance.insuranceType, departureDays)) {
              $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/base/modals/insuranceAlertModal-hyb',
                windowClass: 'flight-modal-message',
                controller: 'customModalCtrl',
                backdrop: false,
                animation: false,
                resolve: {}
              });
            }
          }, 800);

        });

      }
    }
  );

  /**
   * Save insurance
   */
  $scope.bookingSave = function () {
    var paymentType = ['CC' , 'BT', 'CA', 'EP', 'PP'];
    $scope.bookingForm = this.bookingForm;

    $rootScope.$broadcast('form-submit:validate');
    if($scope.bookingForm.paymentInfo && $scope.bookingForm.paymentInfo.paymentType){
      $scope.bookingForm.paymentInfo.paymentType.$setDirty();

      if(paymentType.indexOf($scope.flightBooking.payment.type) == -1){
        return;
      }
    }

    if($scope.bookingForm && $scope.flightBooking) {
      OrderValidation.validateForms($scope.bookingForm, $scope.flightBooking);

      if ($scope.bookingForm.$valid) {
        $scope.flightBooking.payment.creditCard.expiration = _.clone($scope.flightBooking.payment.creditCard.newExp);
        $scope.showInsuranceLoading = true;

        if(!$scope.isVola){
          $scope.flightBooking.billing.setFake(true);
          $scope.flightBooking.billing.setType('person');
        }

        InsuranceSrv.bookingSave($scope.flightBooking).then(function successInsurance(resp) {
              if (resp.errors) {
                setServerBirthdayValidationErrors(resp.errors);
              }

              if (resp.redirectUrl) {
                window.location.href = resp.redirectUrl;
              }

              if(resp.paymentForm) {
                $rootScope.$broadcast('paymentGateway', {
                  url: $sce.trustAsResourceUrl(resp.paymentForm.url),
                  method: "post",
                  data: resp.paymentForm.fields,
                  id: "cardPaymentGateway"
                });
              }
            }
        ).finally(function finallyInsurance() {
            $scope.showInsuranceLoading = false;
        });
      } else {
        try {
          scrollToForm();
        } catch (e) {
          console.error(e);
          throw new Error(e);
        }
      }
    }
  };
}
]);

;

// Source: ../shared/public_html/assets/js/insurance/directives/insuranceContactDetails.js
angular.module('insurance')

/**
 * @name        insuranceContactDetails
 * @description insuranceContactDetails directive
 */
.directive('insuranceContactDetails', [
'$rootScope',
function insuranceContactDetails($rootScope) {
return {
    restrict: 'EA',
    replace: true,
    templateUrl: function (element, attrs) {
      return attrs.templateUrl;
    },
    link: function ($scope) {

      // Is User logged
      if ($rootScope.auth.error) {

      }
    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/insurance/models/InsuranceOption.js
angular.module('insurance')

/**
 * @name        InsuranceOption
 * @namespace   ins
 * @description Class that describes an insurance option
 */
.factory('ins.InsuranceOption',
[
function InsuranceOptionFactory() {
/**
   * InsuranceOption constructor
   *
   * @constructor
   * @class InsuranceOption
   */
  var InsuranceOption = function (opt) {
    /**
     * The insurance option price
     *
     * @type {Number}
     */
    this.price = opt.price;

    /**
     * The insurance total price
     *
     * @type {Number}
     */
    this.totalPrice = opt.totalPrice;

    /**
     * The insurance option type
     *
     * @type {String}
     */
    this.type = opt.type;
  };

  // Add instance methods
  InsuranceOption.prototype = /** @lends InsuranceOption.prototype */ {

    /**
     * Returns the insurance option price
     *
     * @return {Number}
     */
    getPrice: function () {
      if (this.totalPrice) {
        return this.totalPrice;
      }
      return this.price;
    },

    /**
     * Returns the insurance option type
     *
     * @return {String}
     */
    getType: function () {
      return this.type;
    },

    /**
     * Calculate price per day
     *
     * @param {Number} dayCount
     * @returns {Number}
     */
    calculatePricePerDay: function (dayCount) {
      return dayCount > 0 ? this.getPrice() / dayCount : 0;
    }
  };

  InsuranceOption.prototype.constructor = InsuranceOption;

  return InsuranceOption;
}]);

;

// Source: ../shared/public_html/assets/js/insurance/models/InsuranceOptions.js
/*global _: false */

angular.module('insurance')

/**
 * @name        InsuranceOptions
 * @namespace   ins
 * @description A collection of InsuranceOption class
 */
.factory('ins.InsuranceOptions',
['ins.InsuranceOption',
function InsuranceOptionsFactory(InsuranceOption) {
/**
   * InsuranceOptions constructor
   *
   * @constructor
   * @class InsuranceOptions
   */
  var InsuranceOptions = function () {
    /**
     * All the insurance options
     *
     * @type {InsuranceOption[]}
     */
    this.options = [];

    /**
     * @type {Number}
     */
    this.minInsuredDays = 0;

    /**
     * @type {Number}
     */
    this.maxInsuredDays = 0;

    /**
     * @type {Number}
     */
    this.defultInsuredDaysOW = 0;
  };

  // Add instance methods
  InsuranceOptions.prototype = /** @lends InsuranceOptions.prototype */ {

    /**
     * Clear object
     *
     * @returns {InsuranceOptions}
     */
    reset: function () {
      this.options = [];
      this.minInsuredDays = 0;
      this.maxInsuredDays = 0;
      this.defultInsuredDaysOW = 0;

      return this;
    },

    /**
     *
     * @param string type
     *
     * @returns {Object|null}
     */
    getOptionByType: function (type) {
      for (var index = 0; index < this.options.length; ++index) {
        if (this.options[index].getType() == type) {
          return this.options[index];
        }
      }

      return null;
    },

    /**
     * @returns {Number}
     */
    getMinInsuredDays: function () {
      return this.minInsuredDays;
    },

    /**
     * @returns {Number}
     */
    getMaxInsuredDays: function () {
      return this.maxInsuredDays;
    },

    /**
     * @returns {Number}
     */
    getDefultInsuredDaysOW: function () {
      return this.defultInsuredDaysOW;
    },

    /**
     * Set option from API object
     *
     * @param {Object} srvData
     *
     * @return {InsuranceOptions}
     */
    srvSet: function (srvData) {
      this.addOptions(srvData.options);
      this.minInsuredDays = srvData.minInsuredDays;
      this.maxInsuredDays = srvData.maxInsuredDays;
      this.defultInsuredDaysOW = srvData.defultInsuredDaysOW;

      return this;
    },

    /**
     * Get the insurance options
     *
     * @return {InsuranceOption[]}
     */
    getOptions: function () {
      return this.options;
    },

    /**
     * Returns total number of available insurance options
     *
     * @return {int}
     */
    getOptionsCount: function () {
      return this.options.length;
    },

    /**
     * Add the insurance options
     *
     * @param {Object} opts
     */
    addOptions: function (opts) {
      _.each(opts, function (opt) {
        this.addOption(opt);
      }, this);
    },

    /**
     * Add an insurance option
     *
     * @param {Object} opt
     */
    addOption: function (opt) {
      this.options.push(new InsuranceOption(opt));
    },

    /**
     * Returns a summarized price for given insurance type
     *
     * NOTE: You may pass null as type to sum them all
     *
     * @param {String|null} type The insurance type
     */
    getOptionsSum: function (type) {
      return _.reduce(this.options, function (memo, option) {
        if (type === null || type === undefined) {
          return memo + option.getPrice();
        }
        else if (option.getType() === type) {
          return memo + option.getPrice();
        }
        else {
          return memo;
        }
      }, 0);
    }
  };

  InsuranceOptions.prototype.constructor = InsuranceOptions;

  return InsuranceOptions;
}]);

;

// Source: ../shared/public_html/assets/js/insurance/models/InsuranceStArgs.js
/*global _: false */

angular.module('insurance')

/**
 * @name        InsuranceOptions
 * @namespace   ins
 * @description A collection of InsuranceStArgs class
 */
.factory('ins.InsuranceStArgs',
['bil.Billing', 'bok.Payment', 'appConfig',
function InsuranceStArgsFactory(Billing, Payment, appConfig) {
/**
   * InsuranceStArgs constructor
   *
   * @constructor
   * @class InsuranceStArgs
   */
  var InsuranceStArgs = function (options) {
    /**
     * Options
     * @type {Array}
     */
    this.options = [];

    /**
     * Enable standalone insurance.
     *
     * @type {boolean}
     */
    this.enable = false;

    /**
     * Step
     * @type {Number}
     */
    this.step = 1;

    /**
     * Days
     * @type {Number}
     */
    this.days = 0;

    /**
     * Pax count
     * @type {Number}
     */
    this.paxCount = 1;

    /**
     * Pax numbers
     * @type {Array}
     */
    this.paxNumbers = [];

    /**
     * Zone
     * @type {String}
     */
    this.zone = 'International';

    /**
     * Insurance type
     * @type {String}
     */
    this.insuranceType = '';

    /**
     * Zones
     * @type {Object}
     */
    this.zones = {};

    /**
     * Start date
     * @type {String}
     */
    this.startDate = '';

    /**
     * End date
     * @type {String}
     */
    this.endDate = '';

    /**
     * Total prices
     * @type {Object}
     */
    this.totalPrices = {};


    /**
     * Price per day / per pax
     * @type {Object}
     */
    this.perDayPerPaxPrices = {};

    /**
     * Box of selected Insurance
     * @type {Object}
     */
    this.box = {};

    /**
     * Billing information
     * @type {Billing}
     */
    this.billing = new Billing();

    /**
     * Payment information
     * @type {Payment}
     */
    this.payment = new Payment();

    /**
     * NavBar Template Url
     *
     * @type {int}
     */
    this.navBarType = 1;

    if (options) {
      this.setOptions(options);
    }

  };

  InsuranceStArgs.URL = (function() {
    var route = appConfig.getRoutes().filter(function(route) {
      return route.name === 'insStandalone';
    })[0];

    if (route) {
      return route.url;
    }
  })();

  // Add instance methods
  InsuranceStArgs.prototype = /** @lends InsuranceStArgs.prototype */ {

    setOptions: function (opts) {

      _.each(opts, function (val, key) {
        if (key in this) {
          this[key] = val;
        }
      }, this);
    },

    /**
     * Get billing
     *
     * @return {Billing}
     */
    getBilling: function () {
      return this.billing;
    },

    /**
     * Returns payment
     *
     * @return {Payment}
     */
    getPayment: function () {
      return this.payment;
    },

    /**
     * Get Pax Count Array
     * @returns {*}
     */
    getPaxCountArr: function () {
      return _.range(0, this.getPaxCount());
    },

    /**
     * Get Pax Count
     * @returns {Number}
     */
    getPaxCount: function () {
      return this.paxCount;
    },

    /**
     * Set Pax Count
     * @param {int} paxCount
     */
    setPaxCount: function (paxCount) {
      this.paxCount = paxCount;
    },

    /**
     * Get Pax Numbers
     * @returns {Array}
     */
    getPaxNumbers: function () {
      return this.paxNumbers;
    },

    /**
     * Get Insurance Type
     * @returns {String}
     */
    getInsuranceType: function () {
      return this.insuranceType;
    },

    /**
     * Get Insurance Days
     * @returns {Number}
     */
    getDays: function () {
      return this.days;
    },

    /**
     * Get Insurance Zone
     * @returns {String}
     */
    getZone: function () {
      return this.zone;
    },

    /**
     * Get Insurance Zones
     * @returns {Object}
     */
    getZones: function () {
      return this.zones;
    },

    /**
     * Get Departure Date
     * @returns {String}
     */
    getStartDate: function () {
      return this.startDate;
    },

    /**
     * Get Return Date
     * @returns {String}
     */
    getEndDate: function () {
      return this.endDate;
    },

    /**
     * Set Total Prices
     * @param prices
     */
    setTotalPrices: function (prices) {
      this.totalPrices = prices;
    },

    /**
     * Set perDay PerPax price
     * @param price
     */
    setPerDayPerPaxPrices: function (price) {
      this.perDayPerPaxPrices = price;
    },

    /**
     * Get perDay PerPax price
     */
    getPerDayPerPaxPrices: function (type) {
      if (this.perDayPerPaxPrices && this.perDayPerPaxPrices[type]) {
        return this.perDayPerPaxPrices[type];
      }
    },

    /**
     * Get Insurance Price by type
     * @param string type
     * @returns {*}
     */
    getPrice: function (type) {
      if (this.totalPrices && this.totalPrices[type]) {
        return this.totalPrices[type];
      }

      return 0;
    },
    getTotalPrice: function(){
      return this.totalPrices;
    },

    /**
     * Get Insurance Zone
     * @returns {Number}
     */
    getBox: function () {
      return this.box;
    },


    /**
     * Set Insurance Days
     * @param {int} days
     */
    setDays: function (days) {
      this.days = days;
    },

    setStep: function (step) {
      this.step = step;
    },

    /**
     * Check the step
     * @param int step
     * @returns {Boolean}
     */
    isStep: function (step) {
      if (this.step == step) {
        return true;
      }

      return false;
    },

    /**
     * Set NavBar type
     *
     * @param {int} type
     */
    setNavBarType: function (type) {
      this.navBarType = type;
    },

    /**
     * Get NavBar type
     *
     * @returns {int}
     */
    getNavBarType: function () {
      return this.navBarType;
    },

    /**
     * @returns {String}
     */
    getUrl: function() {
      return InsuranceStArgs.URL;
    }
  };

  InsuranceStArgs.prototype.constructor = InsuranceStArgs;

  return InsuranceStArgs;
}]);

;

// Source: ../shared/public_html/assets/js/insurance/service/InsuranceStSrv.js
angular.module('insurance')

/**
 * @name InsuranceStSrv
 *
 * @description Insurance Standalone service
 */
.factory('ins.InsuranceStSrv',
['ApiTools',
function InsuranceStSrvFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints =
    {
      getPackages: function () {
        return {url: '/ngInsurance/getPackages', method: 'POST', respParser: getResponse};
      },

      getDetails: function () {
        return {url: '/ngInsurance/getDetails', method: 'POST', respParser: getResponse};
      },

      getConfirmation: function () {
        return {url: '/ngInsurance/getConfirmation', method: 'POST', respParser: getResponse};
      },

      bookingSave: function () {
        return {url: '/ngInsurance/saveBooking', method: 'POST', respParser: getResponse};
      },

      getPaymentLink: function () {
        return {url: '/ngInsurance/getPaymentLink', method: 'POST', respParser: getResponse};
      }
    },

    /**
     * @class InsuranceStSrv
     * @constructor
     */
    InsuranceStSrv = function () {
    };

  /**
   * @lends InsuranceStSrv.prototype
   */
  InsuranceStSrv.prototype =
  {
    /**
     * Get confirmation details for standalone process.
     *
     * @param {Object} args
     * @return {Promise}
     */
    getConfirmation: function (args) {
      return ApiTools.fetch(this, endpoints.getConfirmation(), {args: args});
    },

    /**
     * Get payment link for standalone insurance
     *
     * @param {Object} args
     * @return {Promise}
     */
    getPaymentLink: function (args) {
      return ApiTools.fetch(this, endpoints.getPaymentLink(), {args: args});
    },

    /**
     * Get the provider packages for standalone process.
     *
     * @param {Object} args
     * @return {Promise}
     */
    getPackages: function (args) {
      return ApiTools.fetch(this, endpoints.getPackages(), {args: args});
    },

    /**
     * Get details for standalone process.
     *
     * @param {Object} args
     * @return {Promise}
     */
    getDetails: function (args) {
      return ApiTools.fetch(this, endpoints.getDetails(), {args: args});
    },

    /**
     * Save insurance booking
     *
     * @param {Object} args
     * @return {Promise}
     */
    bookingSave: function (args) {
      return ApiTools.fetch(this, endpoints.bookingSave(), args);
    },

    /**
     * Check if show alert modal
     * @param insuranceType
     * @returns {boolean}
     * @param departureDays
     */
    isShowAlertModal: function (insuranceType, departureDays) {

      // List of insurance types fo each we need show the modal
      var alertInsurances = ['optim', 'complex'],
          minDepartureDays = 31;

      return !!(departureDays <= minDepartureDays && alertInsurances.indexOf(insuranceType) != -1);

    }

  };

  InsuranceStSrv.prototype.constructor = InsuranceStSrv;

  /**
   * Get Response
   *
   * @param {Object} response
   * @return Object
   */
  function getResponse(response) {
    return response.response;
  }

  return new InsuranceStSrv();

}]);




;

// Source: ../shared/public_html/assets/js/landingPages/controllers/LandingPageCtrl.js
angular.module('landingPages')

    /**
     * @name        myModule.ExampleCtrl
     * @description Example controller responsibility description
     */
    .controller('LandingPageCtrl',
        ['flt.PriceGroupPaxModal', 'Dictionaries', '$timeout', '$rootScope', 'sch.scrollToPriceGroups', 'appConfig', '$scope', 'cal.Calendar', 'sch.SearchQueryParams', '$filter', 'goo.Remarketing', '$modal', 'CalendarCheapestService', 'CityHelperHandler', 'CITY_HELPER', 'CityHelperLocation', 'LocationAutocompleteService',
            function LandingPageCtrl(PriceGroupPaxModal, Dictionaries, $timeout, $rootScope, scrollToPriceGroups, appConfig, $scope, Calendar, SearchQueryParams, $filter, Remarketing, $modal, CalendarCheapestService, CityHelperHandler, CITY_HELPER, CityHelperLocation, LocationAutocompleteService) {
var priceGroupsPerPage = 10;

                $scope.pageLoaded = true;
                $scope.showLoadButton = true;
                $scope.monthNumber = null;
                $scope.showCalendar = true;
                $scope.showShortPg = true;
                $rootScope.autoscroll = false;
                $scope.priceGroupLimit = priceGroupsPerPage;
                $scope.loadingMorePriceGroups = false;

                $scope.cheapestFlight = {
                    price: 0
                };

                if (!$scope.lpFlightRange) {
                    $scope.lpFlightRange = {};
                }

                var autosizeInputFormatter = function (locations) {
                    if (locations[0].isCountry()) {
                        return locations[0].countryName;
                    }

                    return locations[0].cityName;
                };

                $scope.showMoreFlights = function () {
                    $scope.loadingMorePriceGroups = true;

                    $timeout(function () {
                        $scope.priceGroupLimit += priceGroupsPerPage;
                        $scope.loadingMorePriceGroups = false;
                    }, 1000);
                };

                $scope.shouldShowMoreButton = function () {
                    return $scope.priceGroupLimit < $scope.flightsSchedule.length && !$scope.loadingMorePriceGroups;
                };

                $scope.shouldShowLoadingMoreLoader = function () {
                    return $scope.loadingMorePriceGroups;
                };

                $scope.newPriceGroupPaxModal = function () {
                    return new PriceGroupPaxModal();
                };

                var
                    /**
                     * @type {Calendar}
                     */
                    calendar = $scope.calendar = new Calendar(),

                    clearResults = function () {
                        $scope.page = 0;

                        if ($scope.flightsSchedule) {
                            $scope.flightsSchedule.length = 0;
                        }
                        else {
                            $scope.flightsSchedule = [];
                        }
                        $scope.showStaticPriceGroups = false;
                    },

                    calculateBarsWidth = function () {
                        var
                            bars = $scope.rateBars,
                            width = 0;

                        if (bars.length > 8) {
                            width = 95 / bars.length;
                            bars.forEach(function (bar) {
                                bar.barWidth = width;
                            });
                        }
                    },

                    /**
                     *
                     */
                    reloadMonthBarsAndCalendar = function () {
                        reloadMonthBar().then(function () {
                            var cheapestMonth = _.where($scope.rateBars, { cheapest: true })[0];

                            if (cheapestMonth) {
                                calendar.goToMonth(cheapestMonth.month, (new Date(cheapestMonth.depDate)).getFullYear());
                                $scope.loadFlights(true, calendar.getDepDate(), calendar.getRetDate());
                                $scope.showCalendar = true;
                                $scope.showShortPg = true;
                            }
                            else {
                                //check if first loaded short pg is available
                                if (!$scope.showStaticPriceGroups) {
                                    $scope.showShortPg = false;
                                }
                                $scope.showCalendar = false;
                            }
                        });
                    };

                /**
                 * @type {SearchQueryParams}
                 */
                $scope.searchQueryParams = angular.copy(SearchQueryParams);

                /**
                 * @type {Number}
                 */
                $scope.defaultTripLengthFrom = 1;

                /**
                 * @type {Number}
                 */
                $scope.defaultTripLengthTo = 40;

                /**
                 * @type {Number}
                 */
                $scope.urlMonth;


                /**
                 * @param {Object} month
                 * @returns {Promise}
                 */
                $scope.selectCalendarMonth = function (month) {
                    setMonthDate(month.month);

                    calendar.clear();
                    $scope.monthNumber = month.month;
                    $scope.searchQueryParams.setParams({
                        flight_from_code: $scope.lpScheduleFrom && !$scope.lpScheduleFrom.locations[0].isCountry() ? $scope.lpScheduleFrom.locations[0].cityCode : undefined,
                        flight_to_code: $scope.lpScheduleTo && !$scope.lpScheduleTo.locations[0].isCountry() ? $scope.lpScheduleTo.locations[0].cityCode : undefined,
                        flight_from_country_code: $scope.lpScheduleFrom && $scope.lpScheduleFrom.locations[0].isCountry() ? $scope.lpScheduleFrom.locations[0].countryCode : undefined,
                        flight_to_country_code: $scope.lpScheduleTo && $scope.lpScheduleTo.locations[0].isCountry() ? $scope.lpScheduleTo.locations[0].countryCode : undefined
                    });

                    clearResults();
                    $scope.loadFlights(true, calendar.getDepDate(), calendar.getRetDate());

                    if (!PriceGroupPaxModal.isFeatureTestEnabled()) {
                        scrollToPriceGroups('rateBarsWrapper');
                    }

                    return calendar.goToMonth(month.month, (new Date(month.depDate)).getFullYear());
                };

                $scope.calendarLoadFlights = function () {
                    calendar.loading.setInProgress(true);
                    clearResults();
                    $scope.loadFlights(true, calendar.getDepDate(), calendar.getRetDate()).then(function () {
                        calendar.loading.setInProgress(false);

                        if (!PriceGroupPaxModal.isFeatureTestEnabled()) {
                            scrollToPriceGroups('priceGroups');
                        }

                    });
                };

                $scope.calDepSelected = function () {
                    clearResults();
                    $scope.loadFlights(true, calendar.getDepDate(), calendar.getRetDate());
                };

                $scope.retReset = function () {
                    clearResults();
                    $scope.calDepSelected();
                };

                var setMonthDate = function (monthNumber) {
                    angular.forEach($scope.bars, function (obj, key) {
                        obj.selected = false;
                        if (obj.month == monthNumber) {
                            obj.selected = true;
                        }
                    });
                };

                /**
                 * @returns {Calendar}
                 */
                var setCalendarParams = function () {
                    $scope.calendar
                        .setDepLocation($scope.lpScheduleFrom.locations[0])
                        .setDesLocation($scope.lpScheduleTo.locations[0]);
                };

                $scope.page = 1;
                $scope.limit = 5;

                $scope.hideButtonMoreFlight = function () {
                    var pages = $scope.lpPages ? parseInt($scope.lpPages) : 0;

                    if ($scope.page >= pages) {
                        $scope.showLoadButton = false;
                    }
                };

                /**
                 * @param reload
                 * @param {Date} depDate
                 * @param {Date} retDate
                 * @returns {Promise}
                 */
                $scope.loadFlights = function (reload, depDate, retDate) {
                    $scope.showMoreFlightLoader = true;
                    $scope.page++;
                    if (reload) {
                        $scope.page = 1;
                    }

                    var fromYearMonth = '';

                    if ($scope.monthNumber) {
                        var today = moment();
                        var fromYear = parseInt(today.format('YYYY'));
                        var todayMonth = parseInt(today.format('M'));
                        var fromMonth = parseInt($scope.monthNumber) >= 10 ? $scope.monthNumber : '0' + parseInt($scope.monthNumber);

                        if (parseInt($scope.monthNumber) < todayMonth) {
                            // It's next year's month
                            fromYear++;
                        }

                        fromYearMonth = fromYear + '-' + fromMonth;
                    }

                    return CalendarCheapestService
                        .getFlights({
                            cityFrom: $scope.lpScheduleFrom.locations[0].cityCode,
                            airportFrom: $scope.lpScheduleFrom.locations[0].airportCode,
                            countryFrom: $scope.lpScheduleFrom.locations[0].countryCode,
                            cityTo: $scope.lpScheduleTo.locations[0].cityCode,
                            airportTo: $scope.lpScheduleTo.locations[0].airportCode,
                            countryTo: $scope.lpScheduleTo.locations[0].countryCode,
                            depDate: depDate ? moment(depDate).format('YYYY-MM-DD') : '',
                            retDate: retDate ? moment(retDate).format('YYYY-MM-DD') : '',
                            fromMonth: fromYearMonth,
                            minStayTime: $scope.lpFlightRange.min,
                            maxStayTime: $scope.lpFlightRange.max,
                            forceCarrier: $scope.forceCarrier
                        })
                        .then(function (success) {
                            if (!success.data.hasOwnProperty('cells')) {
                                return;
                            }

                            // Add flights to page
                            $scope.flightsSchedule = _.sortBy(
                                _.map(success.data.cells, function (cell) {
                                    return {
                                        arr: cell.destinationCity,
                                        arrSeg: cell.inboundStopovers + 1,
                                        arrT: moment(cell.inboundDepartureDateTime).format('YYYY-MM-DD'),
                                        arrTime: moment(cell.inboundDepartureDateTime).format('HH:mm:ss'),
                                        carrDep: cell.outboundOperatingCarriers[0],
                                        carrRet: cell.inboundOperatingCarriers[0],
                                        currency: cell.price.value.currency,
                                        dep: cell.originCity,
                                        depSeg: cell.outboundStopovers + 1,
                                        depT: moment(cell.outboundDepartureDateTime).format('YYYY-MM-DD'),
                                        depTime: moment(cell.outboundDepartureDateTime).format('HH:mm:ss'),
                                        price: cell.price.value.amount,
                                        price_notRounded: cell.price.value.amount,
                                        priceGroupPaxModal: new PriceGroupPaxModal()
                                    };
                                }),
                                function (mapped) {
                                    return mapped.price;
                                }
                            );

                            // Add translations to dictionary
                            if (success.data.translations.cities) {
                                Object.keys(success.data.translations.cities).forEach(function (cityCode) {
                                    Dictionaries.addCity(
                                        { city_code: cityCode, city_name: success.data.translations.cities[cityCode] },
                                        appConfig.getLanguageCode()
                                    );
                                });
                            }

                            if (success.data.translations.carriers) {
                                Object.keys(success.data.translations.carriers).forEach(function (carrierCode) {
                                    Dictionaries.addCarrier(
                                        { code: carrierCode, name: success.data.translations.carriers[carrierCode] },
                                        appConfig.getLanguageCode()
                                    );
                                });
                            }

                            $scope.showStaticPriceGroups = false;
                            $scope.priceGroupLimit = priceGroupsPerPage;

                            // Send remarketing event
                            Remarketing.sendLpFlightLoad($scope.flightsSchedule);
                        });
                };

                $scope.onChSelect = function () {
                    $scope.monthNumber = null;
                    clearResults();
                    setCalendarParams();

                    if (
                        $scope.lpScheduleFrom.locations[0].getCityCode() === $scope.lpScheduleTo.locations[0].getCityCode() &&
                        $scope.lpScheduleFrom.locations[0].getCountryCode() === $scope.lpScheduleTo.locations[0].getCountryCode() &&
                        !$scope.lpScheduleFrom.locations[0].isAnyCity()
                    ) {
                        $modal.open({
                            templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/flightsFormErrors',
                            controller: 'flightsFormErrorsModalCtrl',
                            windowClass: 'flight-modal-message',
                            resolve: {
                                errors: function () {
                                    var errors = {
                                        custom: $filter('translate')('LANGM_JS_THE_SAME_CITIES')
                                    };
                                    return errors;
                                }
                            }
                        });

                        return;
                    }

                    reloadMonthBarsAndCalendar();
                };

                /**
                 * @param {Object} tripLength
                 * @param {Number} tripLength.min
                 * @param {Number} tripLength.max
                 */
                $scope.updateTripLength = function (tripLength) {
                    $scope.searchQueryParams.trip_length_from = tripLength.min;
                    $scope.searchQueryParams.trip_length_to = tripLength.max;
                    reloadMonthBarsAndCalendar();
                };

                calendar.setSearchQueryParams($scope.searchQueryParams);

                calendar.setOnMonthChangeFn(function (month) {
                    setMonthDate(month);
                });
                /**
                 * @param {Object} params
                 * @param {CityHelperItem} [params.from]
                 * @param {CityHelperItem} [params.to]
                 * @returns {Promise}
                 */
                var reloadMonthBar = function () {
                    $scope.rateBarsLoaded = false;
                    calendar.loading.setInProgress(true);
                    calendar.clear();

                    return CalendarCheapestService
                        .getMonthBars({
                            cityFrom: $scope.lpScheduleFrom.locations[0].cityCode,
                            cityTo: $scope.lpScheduleTo.locations[0].cityCode,
                            airportFrom: $scope.lpScheduleFrom.locations[0].airportCode,
                            airportTo: $scope.lpScheduleTo.locations[0].airportCode,
                            countryFrom: $scope.lpScheduleFrom.locations[0].countryCode,
                            countryTo: $scope.lpScheduleTo.locations[0].countryCode,
                            tripLengthFrom: $scope.lpFlightRange.min || $scope.defaultTripLengthFrom,
                            tripLengthTo: $scope.lpFlightRange.max || $scope.defaultTripLengthTo,
                            forceCarrier: $scope.forceCarrier || ''
                        })
                        .then(function (success) {
                            // Create object with cheapest cell per month
                            var cellsPerMonth = {};

                            _.forEach(success.data.cells, function (cell) {
                                var cellMonth = moment(cell.outboundDepartureDateTime).format('MM');

                                if (!cellsPerMonth.hasOwnProperty(cellMonth) || cell.price.value.amount < cellsPerMonth[cellMonth].price.value.amount) {
                                    cellsPerMonth[cellMonth] = cell;
                                }
                            });

                            // Get cheapest cell in cellsPerMonth
                            var cheapestCell = _.min(cellsPerMonth, function (cell) {
                                return cell.price.value.amount;
                            });

                            var mostExpensiveCell = _.max(cellsPerMonth, function (cell) {
                                return cell.price.value.amount;
                            });

                            var selected = false;

                            // Convert cheapest cells per month to expected format
                            $scope.rateBars = $scope.bars = _.map(cellsPerMonth, function (cell) {
                                // Calculate bar height between min and max
                                var cheapestPrice = cheapestCell.price.value.amount;
                                var mostExpensivePrice = mostExpensiveCell.price.value.amount;
                                var price = cell.price.value.amount;
                                var clampMin = 45;
                                var clampMax = 90;
                                var barHeightMinMax = 100 * (price - cheapestPrice) / (mostExpensivePrice - cheapestPrice);
                                var barHeightClamped = clampMin + (clampMax - clampMin) * barHeightMinMax / 100;
                                var isSelected = false;
                                var isCheapest = price === cheapestPrice;
                                var month = moment(cell.outboundDepartureDateTime).format('MM');

                                if (!selected && isCheapest) {
                                    isSelected = true;
                                    selected = true;
                                }

                                return {
                                    cheapest: isCheapest,
                                    cityFrom: cell.originCity,
                                    cityTo: cell.destinationCity,
                                    currency: cell.price.value.currency,
                                    depDate: moment(cell.outboundDepartureDateTime).format('YYYY-MM-DD'),
                                    month: month,
                                    name: moment(cell.outboundDepartureDateTime).format('MMMM'),
                                    price: price,
                                    retDate: moment(cell.outboundDepartureDateTime).format('YYYY-MM-DD'),
                                    selected: isSelected,
                                    shortMonthName: moment(cell.outboundDepartureDateTime).format('MMM'),
                                    barHeight: isNaN(barHeightClamped) ? clampMin : barHeightClamped
                                };
                            }).sort(function (a, b) {
                                return moment(a.depDate).valueOf() < moment(b.depDate).valueOf() ? -1 : 1;
                            });

                            $scope.rateBarsLoaded = true;
                            calendar.loading.setInProgress(false);

                            calculateBarsWidth();
                            $timeout(function () {
                                _.each($scope.rateBars, function (bar) {
                                    bar.height = bar.barHeight;
                                });
                            }, 100);
                        });
                };

                $scope.$on('LandingPageCtrl.paramsInitialized', function () {
                    $scope.searchQueryParams.trip_length_from = $scope.lpFlightRange.min || $scope.defaultTripLengthFrom;
                    $scope.searchQueryParams.trip_length_to = $scope.lpFlightRange.max || $scope.defaultTripLengthTo;
                    // Force Carrier on GuideStrip

                    if (_js_app_config_.forceCarrier) {
                        $scope.searchQueryParams.setForceCarrier($scope.forceCarrier);
                    }

                    $scope.monthNumber = $scope.urlMonth;

                    $scope.lpScheduleFrom = new CityHelperHandler(
                        [new CityHelperLocation({
                            cityCode: $scope.lpScheduleFromCityCode,
                            countryCode: $scope.lpScheduleFromCountryCode,
                            airportCode: $scope.lpScheduleFromAirportCode
                        })],
                        CITY_HELPER.FLIGHT_TYPE_FROM,
                        autosizeInputFormatter
                    );

                    $scope.lpScheduleTo = new CityHelperHandler(
                        [new CityHelperLocation({
                            cityCode: $scope.lpScheduleToCityCode,
                            countryCode: $scope.lpScheduleToCountryCode,
                            airportCode: $scope.lpScheduleToAirportCode
                        })],
                        CITY_HELPER.FLIGHT_TYPE_TO,
                        autosizeInputFormatter
                    );

                    var anyCityResults = [
                        LocationAutocompleteService.getAnyCity()
                    ];

                    $scope.lpScheduleFrom
                        .setPredefined(anyCityResults)
                        .setAllowCountries()
                        .setOpposing($scope.lpScheduleTo);

                    $scope.lpScheduleTo
                        .setPredefined(anyCityResults)
                        .setAllowCountries()
                        .setOpposing($scope.lpScheduleFrom);

                    // Remarketing LP
                    Remarketing.landingPage(_js_app_config_, {
                        from: $scope.lpScheduleFrom.locations[0],
                        to: $scope.lpScheduleTo.locations[0]
                    });

                    reloadMonthBar().then(function () {
                        var now = new Date();

                        var
                            /**
                             * @type {Number}
                             */
                            month = now.getMonth() + 1,
                            /**
                             * @type {Number}
                             */
                            year = now.getFullYear(),
                            /**
                             * @type {Object}
                             */
                            cheapestMonthBar = _.where($scope.rateBars, { cheapest: true })[0];

                        if ($scope.urlMonth) {
                            if ($scope.urlMonth < month) {
                                year += 1;
                            }

                            month = $scope.urlMonth;
                        }
                        else if ($scope.lpDateRangeFrom) {
                            month = +$scope.lpDateRangeFrom.match(/\d{2}/g)[1];
                            year = +$scope.lpDateRangeFrom.match(/\d{4}/)[0];
                        }
                        else if (cheapestMonthBar) {
                            month = cheapestMonthBar.month;
                            year = (new Date(cheapestMonthBar.depDate)).getFullYear();
                        }

                        calendar.setCalendarSrvParams({
                            lpUrl: $scope.lpUrl,
                            blackListMode: false
                        });

                        calendar.setActiveMonth(month, year).then(function () {
                            setCalendarParams();
                            if ($scope.rateBars && $scope.rateBars.length) {
                                calendar.reload();
                            }
                            else {
                                $scope.showCalendar = false;
                            }
                        });
                    });

                    $scope.areInitialPricesLoaded = false;

                    $scope.loadFlights(true, calendar.getDepDate(), calendar.getRetDate(), {
                        forceReload: true
                    }).then(function () {
                        if ($scope.flightsSchedule.length > 0) {
                            $scope.cheapestFlight = _.min($scope.flightsSchedule, function (flight) {
                                return flight.price;
                            });
                        }
                    }).catch(function (error) {
                        console.error(error);
                    }).finally(function () {
                        $scope.areInitialPricesLoaded = true;
                    });

                    $scope.hideButtonMoreFlight();
                });
            }]);
;

// Source: ../shared/public_html/assets/js/landingPages/directives/lpFlightsSchedules.js
angular.module('landingPages')

/**
 * @name        lpFlightsSchedules
 * @description
 */
.directive('lpFlightsSchedules',
['$location', 'sch.SearchQueryParams',
function ($location, SearchQueryParams) {
return {
    restrict: 'E',
    replace: true,
    controller: ['$scope', 'Dictionaries', 'appConfig', '$window',
      function ($scope, Dictionaries, appConfig, $window) {
        var sendEvent = true;

        $scope.dict = Dictionaries;
        $scope.lpScheduleCodeFrom = '';
        $scope.lpScheduleCodeTo = '';
        $scope.showStaticPriceGroups = true;
        $scope.flightsSchedule = [];
        $scope.showMoreFlightLoader = false;

        if (!$scope.lpFlightRange) {
          $scope.lpFlightRange = {};
        }

        $scope.clickModalBtn = function (flight) {
          var searchQueryParams = angular.copy(SearchQueryParams);

          searchQueryParams
            .setAdults(flight.priceGroupPaxModal.adults)
            .setChildren(flight.priceGroupPaxModal.children)
            .setInfants(flight.priceGroupPaxModal.infants)
            .setYouths(flight.priceGroupPaxModal.youth)
            .setDepDate(flight.depT)
            .setRetDate(flight.arrT)
            .setOneWay( false )
          ;

          searchQueryParams.flight_from_code = flight.dep;
          searchQueryParams.flight_to_code = flight.arr;
          searchQueryParams.flight_from = Dictionaries.getCityNameByCode(flight.dep, false);
          searchQueryParams.flight_to = Dictionaries.getCityNameByCode(flight.arr, false);

          $location.url(searchQueryParams.generateUrl());
        };
      }]
  };
}]);
;

// Source: ../shared/public_html/assets/js/landingPages/directives/lpFlightsSchedulesLoader.js
angular.module('landingPages')

/**
 * @name        lpFlightsSchedulesLoader
 * @description directive for loading flight schedule elements
 */
.directive('lpFlightsSchedulesLoader',
[
function () {
return {
    restrict: 'E',
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/base/directives/landingPages/flightsScheduleBox'
  };
}]);
;

// Source: ../shared/public_html/assets/js/landingPages/directives/lpSeoLinks.js
angular.module('landingPages')

.directive('lpSeoLinks', [function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      scope.activeTab = '1';
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/landingPages/directives/lpStaticPriceGroups.js
angular.module('landingPages')

.directive('lpStaticPriceGroups',
['$location', 'Dictionaries', 'flt.PriceGroupPaxModal', 'sch.SearchQueryParams', 'appConfig', '$window',
/**
 * @param {Object} $location
 * @param {Dictionaries} Dictionaries
 * @param {PriceGroupPaxModal} PriceGroupPaxModal
 * @param {SearchQueryParams} SearchQueryParams
 * @param {AppConfig} appConfig
 */
function lpStaticPriceGroups($location, Dictionaries, PriceGroupPaxModal, SearchQueryParams, appConfig, $window) {
return {
    restrict: 'A',
    link: function (scope) {
      /**
       * @returns {PriceGroupPaxModal}
       */
      scope.newPriceGroupPaxModal = function () {
        return new PriceGroupPaxModal();
      };

      scope.clickAllFlightsBtn = function (flight) {
        var range = flight.url.match(/\d{4}\-\d{2}\-\d{2}/g);
        var searchQueryParams = angular.copy(SearchQueryParams);

        searchQueryParams
          .setAdults(flight.priceGroupPaxModal.adults)
          .setChildren(flight.priceGroupPaxModal.children)
          .setInfants(flight.priceGroupPaxModal.infants)
          .setYouths(flight.priceGroupPaxModal.youth)
          .setDepDate(range[0])
          .setRetDate(range[1])
          .setOneWay( false )
        ;

        searchQueryParams.flight_from_code = flight.dep;
        searchQueryParams.flight_to_code = flight.arr;
        searchQueryParams.flight_from = Dictionaries.getCityNameByCode(flight.dep, false);
        searchQueryParams.flight_to = Dictionaries.getCityNameByCode(flight.arr, false);

        if (searchQueryParams.getIsRedirectSearch() === true) {
          window.location = searchQueryParams.generateUrl();
        }
        else {
          $location.url(searchQueryParams.generateUrl());
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/search/components/ith-flexible-tip-box.component.js
(function(angular) {
/**
   * @name        IthFlexibleTipBox
   * @description Manages a box in the flexible tips zone
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthFlexibleTipBox = {
    bindings: {
      flightData: '<',
      resultsCtrl: '<'
    },
    controller: 'IthFlexibleTipBoxController',
    templateUrl: '/tpl/show/jsShared/templates/search/tip-box'
  };

  angular
    .module('search')
    .component('ithFlexibleTipBox', IthFlexibleTipBox);
  
}(angular));
;

// Source: ../shared/public_html/assets/js/search/components/ith-flexible-tips.component.js
(function(angular) {
/**
   * @name        IthFlexibleTipBox
   * @description Manages flexible tips container
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthFlexibleTipsComponent = {
    bindings: {
      resultsCtrl: '<'
    },
    controller: 'IthFlexibleTipsController',
    templateUrl: '/tpl/show/jsShared/templates/search/tips'
  };

  angular
    .module('search')
    .component('ithFlexibleTips', IthFlexibleTipsComponent);
  
}(angular));
;

// Source: ../shared/public_html/assets/js/search/controllers/ith-flexible-tip-box.controller.js
(function(angular) {
/**
   * @name        IthFlexibleTipBoxController
   * @description Manages bindings inside the flexible tip box
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthFlexibleTipBoxController = function ($filter, $location, $window) {
    /**
     * Checks if flight is one way
     *
     * @returns {Boolean}
     */
    this.isOneWay = function () {
      return this.flightData.rd === undefined;
    };

    /**
     * Returns save amount
     *
     * @returns {String}
     */
    this.getSaveAmount = function () {
      return $filter('flPrice')(this.flightData.saving);
    };

    /**
     * Event triggered when box is clicked
     */
    this.onBoxClick = function () {
      this.toTop();

      ga('send', {
        hitType: 'event',
        eventCategory: 'Cheaper Flights',
        eventAction: this.flightData.saving,
        eventLabel: $location.url(),
        nonInteraction: true
      });
    };

    /**
     * Changes the dates of search with the cheapest dates
     * from the matrix
     *
     * @param {String} search url
     */
    this.toTop = function () {
      $window.scrollTo(0, 0);
    };
  };

  IthFlexibleTipBoxController.$inject = [
    '$filter',
    '$location',
    '$window'
  ];

  angular
    .module('search')
    .controller('IthFlexibleTipBoxController', IthFlexibleTipBoxController);

}(angular));
;

// Source: ../shared/public_html/assets/js/search/controllers/ith-flexible-tips.controller.js
(function(angular, moment, _) {
/**
   * @name        IthFlexibleTipsController
   * @description Manages bindings inside the flexible tips box
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthFlexibleTipsController = function ($document, $location, SearchQueryParams) {
    /**
     * Changes the visibility of the component
     *
     * @param   {ResultsCtrl} resultsCtrl
     * @param   {Array}       suggestions
     * @returns {Boolean}
     */
    var isTipsVisible = function (resultsCtrl, suggestions) {
      return resultsCtrl.matrix.hasOwnProperty('savedAmount') && resultsCtrl.matrix.savedAmount > 0 && suggestions.length > 0;
    };

    /**
     * Determines visibility of the whole component
     *
     * @type {Boolean}
     */
    this.selfVisible = false;

    /**
     * Suggestions sorted by proximity
     *
     * @type {Object[]}
     */
    this.suggestions = [];

    /**
     * Checks if current search is for one way flights
     *
     * @returns {Boolean}
     */
    this.isOneWay = function () {
      return SearchQueryParams.isOneWay();
    };

    /**
     * Angular hook that checks for changes
     */
    this.$doCheck = function () {
      // Sort matrix data
      this.makeSuggestions();

      // Adjust visibility
      this.selfVisible = isTipsVisible(this.resultsCtrl, this.suggestions);
    };

    /**
     * Opens the calendar tab
     */
    this.openCalendar = function () {
      $document.scrollTo(0, 0);
      this.resultsCtrl.activateCalendar();
      this.triggerGaEvent();
    };

    /**
     * Trigger GA event when plan your trip is clicked
     */
    this.triggerGaEvent = function () {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Cheaper Flights',
        eventAction: 'Plan your trip with calendar',
        eventLabel: $location.url(),
        nonInteraction: true
      });
    };

    /**
     * Decides which dates to show in the suggestion area in UI
     */
    this.makeSuggestions = function () {
      this.suggestions = [];

      if (this.resultsCtrl.priceGroups.length === 0) {
        return;
      }

      // Calculate minimum price
      var searchMinPrice = this.resultsCtrl.priceGroups[0].total;
      if (this.resultsCtrl.hubPriceGroups.length > 0 && this.resultsCtrl.hubPriceGroups[0].total < searchMinPrice) {
        searchMinPrice = this.resultsCtrl.hubPriceGroups[0].total;
      }

      // Sorted array containing cheaper flight suggestions
      var sortedArray = _
        .chain(this.resultsCtrl.matrix.cells)
        .sortBy(function (cellData) {
          var depDateDiff = moment(cellData.dd).diff(SearchQueryParams.getDepDate(true));
          var retDateDiff = moment(cellData.rd).diff(SearchQueryParams.getRetDate(true));
          return depDateDiff + retDateDiff;
        })
        .sortBy(function (cellData) {
          return cellData.price;
        })
        .value();

      angular.forEach(sortedArray, function (cellData) {
        // Calculate saving
        cellData.saving = Math.round(searchMinPrice - cellData.price);
        if (cellData.saving > 0) {
          this.suggestions.push(cellData);
        }
      }, this);

      // Limit to three results
      this.suggestions = this.suggestions.slice(0, 3);
    };
  };

  IthFlexibleTipsController.$inject = [
    '$document',
    '$location',
    'sch.SearchQueryParams'
  ];

  angular
    .module('search')
    .controller('IthFlexibleTipsController', IthFlexibleTipsController);

}(angular, moment, _));
;

// Source: ../shared/public_html/assets/js/search/directives/searchBar.js
angular.module('search')

  /**
   * @name          searchBar
   * @description   Directive for search bar shown on search results
   */
  .directive('searchBar', function() {

return {

    restrict: 'E',
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/base/directives/searchForm/searchBar-hyb',
    controller: ['$rootScope', '$scope',
      function($rootScope, $scope){
      }]
  }
});
;

// Source: ../shared/public_html/assets/js/search/models/Provider.js
angular.module('search')

/**
 * @name        Provider
 * @namespace   sch
 * @description Factory returning Provider constructor
 */
.factory('sch.Provider',
[
  /**
   * Provider factory
   *
   * @return {Provider}
   */
function ProviderFactory() {
/**
   * Provider constructor
   *
   * @class Provider
   * @constructor
   *
   * @param  {apiProvider} provider
   */
  var Provider = function (provider) {
    /**
     * Code of provider
     *
     * @type {String}
     */
    this.code = provider.providerCode;

    this.markAsCompleted(provider.completed);

    /**
     * True if provider has loaded results
     *
     * @type {Boolean}
     */
    this.loaded = false;
  };

  // Add instance methods
  Provider.prototype = /** @lends Provider.prototype */ {

    /**
     * Returns code
     *
     * @return {String}
     */
    getCode: function () {
      return this.code;
    },

    /**
     * Returns true if provider completed
     *
     * @return {Boolean}
     */
    isCompleted: function () {
      return this.completed;
    },

    /**
     * Returns true if provider has loaded results
     *
     * @return {Boolean}
     */
    isLoaded: function () {
      return this.loaded;
    },

    /**
     * Mark provider as loaded
     *
     * @return {Boolean}
     */
    markAsLoaded: function (loaded) {
      return this.loaded = !!loaded;
    },

    /**
     * If param "completed" true, mark as completed
     *
     * @param {Boolean} completed
     */
    markAsCompleted: function (completed) {
      this.completed = !!completed;
    }

  };

  Provider.prototype.constructor = Provider;

  return Provider;
}]);

;

// Source: ../shared/public_html/assets/js/search/models/Providers.js
angular.module('search')

/**
 * @name        Providers
 * @namespace   sch
 * @description Factory returning Providers constructor
 */
.factory('sch.Providers',
['$filter', 'sch.Provider',

  /**
   * Providers factory
   *
   * @param {Function} $filter
   *
   * @return {Providers}
   */
function ProvidersFactory($filter) {
/**
   * Providers constructor
   *
   * @class Providers
   * @constructor
   */
  var Providers = function () {
    /**
     * Array of providers
     *
     * @type {Provider[]}
     */
    this.providers = [];
  };

  // Add instance methods
  Providers.prototype = /** @lends Providers.prototype */ {

    /**
     * Add provider(if already exists, it will updated)
     *
     * @param  {Provider} newProvider
     */
    add: function (newProvider) {
      var provider = this.getByCode(newProvider.getCode());

      if (!provider) {
        this.providers.push(newProvider);
      }
      else {
        provider.markAsCompleted(newProvider.isCompleted());
      }
    },

    /**
     * Returns true if all providers completed
     *
     * @return {Boolean}
     */
    allCompleted: function () {
      return $filter('filter')(this.providers, function (provider) {
          return !provider.isCompleted();
        }).length === 0;
    },

    /**
     * Returns completed providers
     *
     * @returns {apiProvider}
     */
    getCompleted: function () {
      return $filter('filter')(this.providers, function (provider) {
        return provider.isCompleted();
      });
    },

    /**
     * Returns providers to load
     *
     * @returns {apiProvider}
     */
    getToLoad: function () {
      return $filter('filter')(this.getCompleted(), function (provider) {
        return !provider.isLoaded();
      });
    },

    /**
     * Returns all providers
     *
     * @returns {Provider[]}
     */
    get: function () {
      return this.providers;
    },

    /**
     * Get provider by code
     *
     * @param {String} code
     *
     * @returns {Provider|null}
     */
    getByCode: function (code) {
      /**
       * Array of providers by code
       *
       * @type {Provider[]}
       */
      var filtered = $filter('filter')(this.providers, {code: code});

      return filtered.length ? filtered[0] : null;
    },

    /**
     * Mark completed providers as loaded
     */
    markCompletedAsLoaded: function () {
      angular.forEach(this.getCompleted(), function (provider) {
        provider.loaded = true;
      });
    },

    /**
     * Clear array of providers
     */
    clear: function () {
      this.providers.length = 0;
    }

  };

  Providers.prototype.constructor = Providers;

  return Providers;
}]);
;

// Source: ../shared/public_html/assets/js/search/models/RespSummary.js
angular.module('search')

/**
 * @name        RespSummary
 * @namespace   sch
 * @description Class holding the response summary
 */
.factory('sch.RespSummary',
[
function RespSummaryFactory() {
/**
   * RespSummary
   *
   * @param {Object} summary
   * @class RespSummary
   */
  var RespSummary = function (summary) {
    /**
     * Total number of price groups in the response
     *
     * @type {Number}
     */
    this.pgCount = summary.pgCount || 0;

    /**
     * Minimum price
     *
     * @type {Number}
     */
    this.minPrice = summary.minPrice || 0;

    /**
     * Maximum price
     *
     * @type {Number}
     */
    this.maxPrice = summary.maxPrice || 0;

    /**
     * Minimum flight duration in minutes
     *
     * @type {Number}
     */
    this.minDur = summary.minDur || 0;

    /**
     * Maximum flight duration in minutes
     *
     * @type {Number}
     */
    this.maxDur = summary.maxDur || 0;

    /**
     * Minimum layover duration in minutes
     *
     * @type {Number}
     */
    this.minLayoverDur = summary.minLayoverDur || 0;

    /**
     * Maximum layover duration in minutes
     *
     * @type {Number}
     */
    this.maxLayoverDur = summary.maxLayoverDur || 0;

    /**
     * The earliest departure takeoff time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.minDepDepT = summary.minDepDepT || '00:00';

    /**
     * The latest departure takeoff time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.maxDepDepT = summary.maxDepDepT || '24:00';

    /**
     * The earliest departure arrival time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.minDepArrT = summary.minDepArrT || '00:00';

    /**
     * The latest departure arrival time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.maxDepArrT = summary.maxDepArrT || '24:00';

    /**
     * The earliest return takeoff time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.minRetDepT = summary.minRetDepT || '00:00';

    /**
     * The latest return takeoff time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.maxRetDepT = summary.maxRetDepT || '24:00';

    /**
     * The earliest return arrival time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.minRetArrT = summary.minRetArrT || '00:00';

    /**
     * The latest return arrival time
     *
     * Format: HH:MM
     *
     * @type {String}
     */
    this.maxRetArrT = summary.maxRetArrT || '24:00';

    /**
     * Carrier names in the response
     *
     * The key is the carrier code ex. LO, W6
     * The value is the carrier name
     *
     * var carr = this.carriers['LH']; // Lufthansa
     *
     * @type {Object}
     */
    this.carriers = summary.carriers || {};

    /**
     * Airport objects in the response
     *
     * The key is the airport code ex. JFK, EWR
     * The value is the airport object
     *
     * @type {Object}
     */
    this.airports = summary.airports || {};

    /**
     * The summary of stops in the response
     *
     * The key is the number of stops.
     * The value is the number of legs (Leg) having that many stops.
     *
     * @type {Object}
     */
    this.stops = summary.stops || {};

    /**
     * The summary of flight types in the response
     *
     * The key is the name of flight type.
     * The value is the number of price groups having that flight type.
     *
     * @type {Object}
     */
    this.flightTypes = summary.flightTypes || {};

    /**
     * The number of price groups removed by filters
     *
     * @type {Number}
     */
    this.pgFOut = summary.pgFOut || 0;

    /**
     * The number of legs removed by filters
     *
     * @type {Number}
     */
    this.lgFOut = summary.lgFOut || 0;

    /**
     * The number of segments removed by filters
     *
     * @type {Number}
     */
    this.sgFOut = summary.sgFOut || 0;

    /**
     * Indicates if the summary is for one way request
     *
     * @type {Boolean}
     */
    this.oneWaySummary = summary.oneWaySummary || false;

    /**
     * The search query parameters if available
     *
     * @type {Object}
     */
    this.searchReq = summary.searchReq || null;
  };

  // Instance methods
  RespSummary.prototype = {

    /**
     * Get number of price groups in the response
     *
     * Take into account the number of price groups removed by
     * current filters
     *
     * @return {Number}
     */
    getPriceGroupCount: function () {
      return this.pgCount - this.pgFOut;
    },

    /**
     * Checks if page number is valid considering the number of available price groups and page size
     *
     * @param  {int} pageNumber
     * @param  {int} pageSize
     *
     * @return {Boolean}
     */
    isPageValid: function (pageNumber, pageSize) {
      return pageNumber <= Math.ceil(this.getPriceGroupCount() / pageSize);
    },

    /**
     * Is summary for one way requests?
     *
     * @return {Boolean}
     */
    isOneWaySummary: function () {
      return this.oneWaySummary;
    }
  };

  RespSummary.prototype.constructor = RespSummary;

  return RespSummary;
}]);

;

// Source: ../shared/public_html/assets/js/search/models/SearchQueryParams.js
angular.module('search')
    /**
     * @name        SearchQueryParams
     * @namespace   sch
     * @description Default search params
     */
    .factory('sch.SearchQueryParams', ['appConfig', '$localStorage', 'Dictionaries', '$location', '$stateParams',
        function SearchQueryParamsFactory(appConfig, $localStorage, Dictionaries, $location, $stateParams) {
/**
             * Search query parameters
             * @class SearchQueryParams
             * @constructor
             */
            var SearchQueryParams = function () {
                var
                    // Try to get search query parameters from local storage
                    storage = (!appConfig.getIgnoreLS() && $localStorage.searchQueryParams && $localStorage.searchQueryParams[appConfig.getLanguageCode()]) ? $localStorage.searchQueryParams[appConfig.getLanguageCode()] : {},

                    // Prevent dates from being in the past when taking them from local storage
                    departureMoment = storage.departure_date ? moment(storage.departure_date.replace(/\//g, ' '), 'YYYY MM DD') : null;

                // Set dictionaries
                this.dictionaries = Dictionaries;

                // Flag if search redirect action is needed
                this.isRedirectSearch = false;

                // Default min and max dates
                this.min_date = appConfig.getMinDate();
                this.max_date = appConfig.getMaxDate();


                if (departureMoment && (departureMoment.isSame(this.min_date) || departureMoment.isAfter(this.min_date))) {
                    // From local storage
                    this.setDepDate(storage.departure_date);
                    this.setRetDate(storage.return_date);
                } else {
                    // From application config
                    if (this.getDateFromLink('dep')) {
                        this.departure_date = this.getDateFromLink('dep');
                    } else {
                        this.setDepDate(appConfig.getDepDate());
                    }

                    if (this.getDateFromLink('ret')) {
                        this.return_date = this.getDateFromLink('ret');
                    } else {
                        this.setRetDate(appConfig.getRetDate());
                    }
                }

                // Matrix min price
                this.matrix_min_price = storage.matrix_min_price || '';

                // Route
                this.oneway = storage.oneway || appConfig.isOneWay();
                this.is_flex = false;

                // Passengers
                this.adults = storage.adults || appConfig.getAdults();
                this.children = storage.children || appConfig.getChildren();
                this.infants = storage.infants || appConfig.getInfants();
                this.youths = storage.youths || appConfig.getYouths();

                // Departure data
                this.flight_from = storage.flight_from || appConfig.getDepCityName(); // City name
                this.flight_from_code = storage.flight_from_code || appConfig.getDepCityCode(); // City code
                this.flight_from_country_code = storage.flight_from_country_code || appConfig.getDepCountryCode(); // Country code
                this.flight_from_country_name = storage.flight_from_country_name || appConfig.getDepCountryName(); // County name
                this.flight_from_airport_code = storage.flight_from_airport_code || appConfig.getDepAirportCode(); // Airport code
                this.flight_from_airport_name = storage.flight_from_airport_name || appConfig.getDepAirportName(); // Airport name
                this.flex_days_from = null;

                // Destination data
                this.flight_to = storage.flight_to || appConfig.getDesCityName(); // City and airport name
                this.flight_to_code = storage.flight_to_code || appConfig.getDesCityCode(); // City code
                this.flight_to_country_code = storage.flight_to_country_code || appConfig.getDesCountryCode(); // County code
                this.flight_to_country_name = storage.flight_to_country_name || appConfig.getDesCountryName(); // County code
                this.flight_to_airport_code = storage.flight_to_airport_code || appConfig.getDesAirportCode(); // Airport code
                this.flight_to_airport_name = storage.flight_to_airport_name || appConfig.getDesAirportName(); // Airport name
                this.flex_days_to = null;

                // Filters
                this.minDepDepT = null; // string "HH:mm"
                this.maxDepDepT = null; // string "HH:mm"
                this.minDepArrT = null; // string "HH:mm"
                this.maxDepArrT = null; // string "HH:mm"
                this.minRetDepT = null; // string "HH:mm"
                this.maxRetDepT = null; // string "HH:mm"
                this.minRetArrT = null; // string "HH:mm"
                this.maxRetArrT = null; // string "HH:mm"

                this.stops = ''; // A string of stops ex. '1,2' , '1,3', '1,2,3'
                this.flightTypes = ''; // A string of flight types ex. 'LOWCOST,MIXED' , 'LOWCOST,REGULAR', 'LOWCOST,MIXED,REGULAR'
                this.carriers = ''; // A string of comma separated carrier codes. Ex: 'AF,W6'
                this.airports = ''; // A string of comma separated airport codes. Ex: 'JFK,EWR'
                this.forceCarrier = '';

                this.deduplicate = storage.deduplicate || false;

                // Add departure to dictionary
                Dictionaries.addCity({
                    city_code: this.flight_from_code,
                    city_name: this.flight_from,
                    country_code: this.flight_from_country_code,
                    country_name: this.flight_from_country_name
                }, appConfig.getLanguageCode());

                // Add destination to dictionary
                Dictionaries.addCity({
                    city_code: this.flight_to_code,
                    city_name: this.flight_to,
                    country_code: this.flight_to_country_code,
                    country_name: this.flight_to_country_name
                }, appConfig.getLanguageCode());

                // Trip length
                this.trip_length_from = storage.trip_length_from || appConfig.getTripLengthFrom();
                this.trip_length_to = storage.trip_length_to || appConfig.getTripLengthTo();

                // Selected date (for monthly fares, in format "YYYY-MM-DD")
                this.selected_date = '';

                // Get base search url
                this.base_search_url = '';
            };

            // Add instance methods
            SearchQueryParams.prototype = /** @lends SearchQueryParams.prototype */ {
                /**
                 * Get departure date
                 * @param {bool} [asMoment] Set to true to get moment js instance
                 * @return {String|Moment} Date in YYYY-MM-DD format
                 */
                getDepDate: function (asMoment) {
                    asMoment = asMoment || false;
                    return asMoment ? moment(this.departure_date) : this.departure_date;
                },

                /**
                 * Set departure date
                 * @param {String} date Date in YYYY-MM-DD format
                 */
                setDepDate: function (date) {
                    try {
                        if (!moment(date).isValid() || moment(date).hour(24) < moment()) {
                            throw 'Invalid or past date in SQP.setDepDate';
                        }
                    } catch (err) {
                        // Set date for tomorrow in case of error
                        date = moment().add(1, 'days').format('YYYY-MM-DD');
                    }

                    this.departure_date = date;
                    return this;
                },

                /**
                 * Get return date
                 * @param {bool} [asMoment] Set to true to get moment js instance
                 * @return {String|Moment} Date in YYYY-MM-DD format
                 */
                getRetDate: function (asMoment) {
                    asMoment = asMoment || false;
                    return asMoment ? moment(this.return_date) : this.return_date;
                },

                /**
                 * Set return date
                 * @param {String} date Date in YYYY-MM-DD format
                 */
                setRetDate: function (date) {
                    try {
                        if (!moment(date).isValid()) {
                            throw 'INVALID DATE in SQP.setRetDate';
                        }
                    } catch (err) {
                        // Set return date 7 days from now in case of error
                        date = moment().add(7, 'days').format('YYYY-MM-DD');
                    }

                    this.return_date = date;
                    return this;
                },

                setFlexDays: function (fromDays, toDays) {
                    this.flex_days_from = fromDays;
                    this.flex_days_to = toDays;

                    return this;
                },

                getFlexDaysFrom: function () {
                    return +this.flex_days_from;
                },

                getFlexDaysTo: function () {
                    return +this.flex_days_to;
                },

                setIsFlex: function (value) {
                    this.is_flex = value;

                    return this;
                },

                getIsFlex: function () {
                    return !!this.is_flex;
                },

                /**
                 * Get minimum date for calendar
                 * @return {String}
                 */
                getMinDate: function () {
                    return this.min_date;
                },

                /**
                 * Get maximum date for calendar
                 * @return {String}
                 */
                getMaxDate: function () {
                    return this.max_date;
                },

                setSearchDeduplicatedFlights: function (newValue) {
                    this.deduplicate = newValue;
                    return this;
                },

                /**
                 * Resets search query parameters
                 * @return {SearchQueryParams}
                 */
                reset: function () {
                    // Prices
                    this.matrix_min_price = 0;

                    // Dates
                    this.departure_date = null;
                    this.return_date = null;

                    // Flex
                    this.flex_days_from = null;
                    this.flex_days_to = null;

                    // Default min and max dates
                    this.min_date = null;
                    this.max_date = null;

                    // Default route
                    this.oneway = false;
                    this.is_flex = false;

                    // Passengers
                    this.adults = 0;
                    this.children = 0;
                    this.infants = 0;
                    this.youths = 0;

                    // From
                    this.flight_from = ''; // City name
                    this.flight_from_code = '';  // City code
                    this.flight_from_country_code = '';  // Country code
                    this.flight_from_country_name = ''; // County name
                    this.flight_from_airport_code = ''; // Airport code
                    this.flight_from_airport_name = ''; // Airport name

                    // To
                    this.flight_to = ''; // City and airport name
                    this.flight_to_code = ''; // City code
                    this.flight_to_country_code = ''; // County code
                    this.flight_to_country_name = ''; // County code
                    this.flight_to_airport_code = ''; // Airport code
                    this.flight_to_airport_name = ''; // Airport name
                    this.forceCarrier = ''; // Force carrier preference

                    this.deduplicate = false;

                    return this;
                },

                setFromLinkParameters: function () {
                    // Url Parameters
                    this.setParams({
                        flight_from_code: $stateParams.depCode,
                        flight_to_code: $stateParams.arrCode,
                        flight_from_airport_code: $stateParams.depAirportCode,
                        flight_to_airport_code: $stateParams.arrAirportCode,
                        flight_to_country_code: $stateParams.arrCountryCode,
                        departure_date: $stateParams.depDate,
                        return_date: $stateParams.arrDate,
                        adults: $stateParams.adt,
                        children: $stateParams.children,
                        infants: $stateParams.infants,
                        youths: $stateParams.yo,
                        oneway: $stateParams.ow,
                        deduplicate: $stateParams.deduplicate,
                        flex_days_from: $stateParams.flexDaysFrom,
                        flex_days_to: $stateParams.flexDaysTo,
                        is_flex: $stateParams.isFlex
                    });
                },

                /**
                 * Set new search parameters on the config object
                 * @param {Object} newSearchParams
                 * @return {SearchQueryParams}
                 */
                setParams: function (newSearchParams) {
                    // Override only properties that are present in SearchQueryParams class
                    newSearchParams = _.pick(newSearchParams, _.intersection(_.keys(this), _.keys(newSearchParams)));
                    _.extend(this, newSearchParams);
                    return this;
                },

                /**
                 * Returns all params as object.
                 * @return {Object}
                 */
                getAllParams: function () {
                    return {
                        flight_from: this.getDepCityName(),
                        flight_from_code: this.getDepCityCode(),
                        flight_from_airport_code: this.getDepAirportCode(),
                        flight_to: this.getDesCityName(),
                        flight_to_code: this.getDesCityCode(),
                        flight_to_airport_code: this.getDesAirportCode(),
                        date_departure: this.getDepDate(),
                        date_return: this.getRetDate(),
                        oneWay: this.isOneWay(),
                        adults: this.getAdults(),
                        children: this.getChildren(),
                        infants: this.getInfants(),
                        youths: this.getYouths()
                    };
                },

                /**
                 * Set matrix min price
                 */
                setMatrixMinPrice: function (price) {
                    this.matrix_min_price = price;
                },

                /**
                 * Get matrix min price
                 * @return {float}
                 */
                getMatrixMinPrice: function () {
                    return this.matrix_min_price;
                },

                /**
                 * Get departure city name
                 * @return {String}
                 */
                getDepCityName: function () {
                    return this.flight_from;
                },

                /**
                 * Returns origin airport name or city name
                 *
                 * @returns {String}
                 */
                getOrigin: function () {
                    return this.getDepAirportName() !== '' ? this.getDepAirportName() + ', ' + this.getDepCityName() : this.getDepCityName();
                },

                /**
                 * Returns destination airport name or city name
                 *
                 * @returns {String}
                 */
                getDestination: function () {
                    return this.getDesAirportName() !== '' ? this.getDesAirportName() + ', ' + this.getDesCityName() : this.getDesCityName();
                },

                /**
                 * Get departure city code
                 * @return {String} The three letter city code ex. KRK
                 */
                getDepCityCode: function () {
                    return this.flight_from_code;
                },

                /**
                 * Set departure city code
                 * @param {String} code The three letter city code ex. KRK
                 * @return SearchQueryParams
                 */
                setDepCityCode: function (code) {
                    this.flight_from_code = code;
                    return this;
                },

                /**
                 * Set destination city code
                 * @param {String} code The three letter city code ex. KRK
                 * @return SearchQueryParams
                 */
                setDesCityCode: function (code) {
                    this.flight_to_code = code;
                    return this;
                },

                /**
                 * Get departure country code
                 * @return {String} The two letter country code ex. PL
                 */
                getDepCountryCode: function () {
                    return this.flight_from_country_code;
                },

                /**
                 * Get departure country name
                 * @return {String}
                 */
                getDepCountryName: function () {
                    return this.flight_from_country_name;
                },

                /**
                 * Get departure airport name
                 * @return {String}
                 */
                getDepAirportName: function () {
                    return this.flight_from_airport_name;
                },

                /**
                 * Set departure airport code
                 */
                setDepAirportCode: function (code) {
                    this.flight_from_airport_code = code;
                    return this;
                },

                /**
                 * Get departure airport code
                 * @return {String} The three letter airport code ex. KRK
                 */
                getDepAirportCode: function () {
                    return this.flight_from_airport_code;
                },

                /**
                 * Get location name
                 * @param {String} code
                 * @param {bool}   withCountry
                 *
                 * @return {String}
                 */
                getLocationName: function (code, withCountry) {
                    return Dictionaries.getCityNameByCode(code, withCountry);
                },

                /**
                 * Get destination city name
                 * @return {String}
                 */
                getDesCityName: function () {
                    return this.flight_to;
                },

                /**
                 * Get destination city code
                 * @return {String} The three letter city code ex. KRK
                 */
                getDesCityCode: function () {
                    return this.flight_to_code;
                },

                setDesCountryCode: function (code) {
                    this.flight_to_country_code = code;

                    return this;
                },

                /**
                 * Get destination country code
                 * @return {String} The two letter country code ex. PL
                 */
                getDesCountryCode: function () {
                    return this.flight_to_country_code;
                },

                /**
                 * Get destination country name
                 * @return {String}
                 */
                getDesCountryName: function () {
                    return this.flight_to_country_name;
                },

                /**
                 * Get destination airport name
                 * @return {String}
                 */
                getDesAirportName: function () {
                    return this.flight_to_airport_name;
                },

                /**
                 * Set destination airport code
                 */
                setDesAirportCode: function (code) {
                    this.flight_to_airport_code = code;
                    return this;
                },

                /**
                 * Get destination airport code
                 * @return {String} The three letter airport code ex. KRK
                 */
                getDesAirportCode: function () {
                    return this.flight_to_airport_code;
                },

                /**
                 * Get route.
                 *
                 * @returns {String} concatenated code of departure and destination e.g. WAWLON
                 */
                getRoute: function () {
                    return this.flight_from_code + this.flight_to_code;
                },

                /**
                 * Get number of adults
                 * @return {Number}
                 */
                getAdults: function () {
                    return +this.adults;
                },

                /**
                 * Sets the total number of adults
                 * @param {Number} adults
                 */
                setAdults: function (adults) {
                    this.adults = adults;
                    return this;
                },

                /**
                 * Get number of children
                 * @return {Number}
                 */
                getChildren: function () {
                    return +this.children;
                },

                /**
                 * Set total number of children
                 * @param {Number} children
                 */
                setChildren: function (children) {
                    this.children = children;
                    return this;
                },

                /**
                 * Get number of infants
                 * @return {Number}
                 */
                getInfants: function () {
                    return +this.infants;
                },

                /**
                 * Set total number of infants
                 * @param {Number} infants
                 */
                setInfants: function (infants) {
                    this.infants = infants;
                    return this;
                },

                /**
                 * Get number of youths
                 * @return {Number}
                 */
                getYouths: function () {
                    return +this.youths;
                },

                /**
                 * Set total number of youths
                 * @param {Number} youths
                 */
                setYouths: function (youths) {
                    this.youths = youths;
                    return this;
                },

                /**
                 * Min trip length as number of days
                 * @return {Number}
                 */
                getTripLengthFrom: function () {
                    return this.trip_length_from;
                },

                /**
                 * Max trip length as number of days
                 * @return {Number}
                 */
                getTripLengthTo: function () {
                    return this.trip_length_to;
                },

                /**
                 * Set selected date
                 * @param {String} in format "YYYY-MM-DD"
                 */
                setSelectedDate: function (date) {
                    this.selected_date = date;
                },

                /**
                 * Get selected date
                 * @return {String}
                 */
                getSelectedDate: function () {
                    return this.selected_date;
                },

                /**
                 * Returns true if one way search
                 * @return {bool}
                 */
                isOneWay: function () {
                    return !!this.oneway;
                },

                getSearchDeduplicatedFlights: function () {
                    return this.deduplicate;
                },

                /**
                 * Set one way
                 * @param {Boolean} type
                 */
                setOneWay: function (type) {
                    // Set flight type
                    this.oneway = type;

                    // Check return date
                    if (!type && this.return_date === null) {
                        this.return_date = this.departure_date;
                    }
                    return this;
                },

                /**
                 * Save search query parameters to local storage
                 * @return {SearchQueryParams}
                 */
                saveToStorage: function () {
                    if (!$localStorage.searchQueryParams) {
                        // Set empty object
                        $localStorage.searchQueryParams = {};
                    }

                    $localStorage.searchQueryParams.departure_date = this.getDepDate();
                    $localStorage.searchQueryParams.return_date = this.getRetDate();
                    $localStorage.searchQueryParams.matrix_min_price = this.getMatrixMinPrice();
                    $localStorage.searchQueryParams.oneway = this.isOneWay();

                    $localStorage.searchQueryParams.adults = this.getAdults();
                    $localStorage.searchQueryParams.children = this.getChildren();
                    $localStorage.searchQueryParams.infants = this.getInfants();
                    $localStorage.searchQueryParams.youths = this.getYouths();

                    $localStorage.searchQueryParams.flight_from = this.getDepCityName();
                    $localStorage.searchQueryParams.flight_from_code = this.getDepCityCode();
                    $localStorage.searchQueryParams.flight_from_country_code = this.getDepCountryCode();
                    $localStorage.searchQueryParams.flight_from_country_name = this.getDepCountryName();
                    $localStorage.searchQueryParams.flight_from_airport_code = this.getDepAirportCode();
                    $localStorage.searchQueryParams.flight_from_airport_name = this.getDepAirportName();

                    $localStorage.searchQueryParams.flight_to = this.getDesCityName();
                    $localStorage.searchQueryParams.flight_to_code = this.getDesCityCode();
                    $localStorage.searchQueryParams.flight_to_country_code = this.getDesCountryCode();
                    $localStorage.searchQueryParams.flight_to_country_name = this.getDesCountryName();
                    $localStorage.searchQueryParams.flight_to_airport_code = this.getDesAirportCode();
                    $localStorage.searchQueryParams.flight_to_airport_name = this.getDesAirportName();
                    $localStorage.searchQueryParams.forceCarrier = this.getForceCarrier();
                    $localStorage.searchQueryParams.deduplicate = this.getSearchDeduplicatedFlights();

                    $localStorage.$apply();
                    return this;
                },

                /**
                 * Generate URL
                 *
                 * @returns {String}
                 */
                generateUrl: function () {
                    var url = appConfig.getUriPrefix() + '/flight_search' +
                        '/from_code/' + this.flight_from_code +
                        '/to_code/' + this.flight_to_code;

                    if (this.flight_from_airport_code) {
                        url += '/from_airport_code/' + this.flight_from_airport_code;
                    }

                    if (this.flight_to_airport_code) {
                        url += '/to_airport_code/' + this.flight_to_airport_code;
                    }

                    url += '/dd/' + this.getDepDate() + '/rd/' + this.getRetDate() + '/ad/' + this.getAdults();

                    if (this.getChildren()) {
                        url += '/ch/' + this.getChildren();
                    }

                    if (this.getInfants()) {
                        url += '/inf/' + this.getInfants();
                    }

                    if (this.getYouths()) {
                        url += '/yo/' + this.getYouths();
                    }

                    if (this.isOneWay()) {
                        url += '/ow/1';
                    }

                    if (this.isForceCarrier()) {
                        url += '/carrier/' + this.getForceCarrier();
                    }

                    if (this.deduplicate) {
                        url += '/deduplicate/1';
                    }

                    if (this.getIsFlex()) {
                        url += '/is_flex/1';
                    }

                    if (this.getIsFlex() && !this.isOneWay()) {
                        url += '/fdf/' + this.getFlexDaysFrom() + '/fdt/' + this.getFlexDaysTo();
                    }

                    if (this.getDesCountryCode()) {
                        url += '/to_country_code/' + this.getDesCountryCode();
                    }

                    this.setBaseSearchUrl(url);
                    return url;
                },

                /**
                 * Is force carrier empty
                 *
                 * @returns {boolean}
                 */
                isForceCarrier: function () {
                    if (this.forceCarrier !== '') {
                        return true;
                    }

                    return false;
                },

                /**
                 * Get force carrier
                 *
                 * @returns {*}
                 */
                getForceCarrier: function () {

                    if (this.forceCarrier !== '') {
                        return this.forceCarrier;
                    }

                    var url = $location.url(), regex, match;
                    regex = /\/carrier\/(\S\S)/g;
                    match = regex.exec(url);
                    if (match) {
                        return match[1];
                    }

                    return false;
                },

                /**
                 * Set Carrier
                 *
                 * @param carrier
                 */
                setForceCarrier: function (carrier) {
                    this.forceCarrier = carrier;
                },

                setIsRedirectSearch: function (action) {
                    this.isRedirectSearch = action;
                },

                getIsRedirectSearch: function () {
                    return this.isRedirectSearch;
                },

                getBaseSearchUrl: function () {
                    return this.base_search_url;
                },

                setBaseSearchUrl: function (url) {
                    this.base_search_url = url;
                },

                getDateFromLink: function (type) {
                    var url = $location.url(), regex, match;

                    if (type === 'dep') {
                        regex = /\/dd\/(.*?)\//g;
                    } else if (type === 'ret') {
                        regex = /\/rd\/(.*?)\//g;
                    } else {
                        return false;
                    }

                    match = regex.exec(url);

                    if (match) {
                        return new Date(match[1]);
                    }

                    return false;
                },

                getCityCodeFromLink: function (type) {
                    var url = $location.url(), regex, match;

                    if (type === 'dep') {
                        regex = /\/from_code\/(.*?)\//g;
                    } else if (type === 'dest') {
                        regex = /\/to_code\/(.*?)\//g;
                    } else {
                        return false;
                    }

                    match = regex.exec(url);

                    if (match) {
                        return match[1];
                    }

                    return false;
                },

                /**
                 * Counts total number of pax from link
                 * @return {Number}
                 */
                getPaxTotalFromLink: function () {
                    var
                        url = $location.url(),
                        total = 0,
                        arr = url.split('/'),
                        ad = _.indexOf(arr, 'ad'),
                        ch = _.indexOf(arr, 'ch'),
                        inf = _.indexOf(arr, 'inf'),
                        yo = _.indexOf(arr, 'yo'),
                        se = _.indexOf(arr, 'se');

                    if (ad > -1) {
                        total += parseInt(arr[ad + 1], 10) || 0;
                    }

                    if (ch > -1) {
                        total += parseInt(arr[ch + 1], 10) || 0;
                    }

                    if (inf > -1) {
                        total += parseInt(arr[inf + 1], 10) || 0;
                    }

                    if (yo > -1) {
                        total += parseInt(arr[yo + 1], 10) || 0;
                    }

                    if (se > -1) {
                        total += parseInt(arr[se + 1], 10) || 0;
                    }

                    return total;
                },

                getOneWayFromLink: function () {
                    return /ow\/1/g.exec(window.location.href) === null ? false : true;
                }
            };

            SearchQueryParams.prototype.constructor = SearchQueryParams;
            return new SearchQueryParams();
        }]);
;

// Source: ../shared/public_html/assets/js/search/services/AirportsSrv.js
angular.module('search')

/**
 * @name Airports Service
 *
 * @description airports service
 */
.factory('sch.AirportsSrv',
['$filter', '$q', 'ApiTools',
function AirportsSrvFactory($filter, $q, ApiTools) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by AirportSrv before returning results to caller.
     */
    endpoints = {
      getAirportsByCityCodes: {
        url: '/api/api/getAirportsByCityCode' +'?abv='+_js_app_config_.ab_version,
        method: 'POST',
        respParser: function (response) {
          return response.response;
        }
      }
    },

    filter = $filter('filter'),

    /**
     * @class AirportsSrv
     * @constructor
     */
    AirportsSrv = function () {
      /**
       * Cached airports grouped by city code, ex.:
       *
       {
        'WAW': [
          {
            airport_code: "WAW"
            airport_name: "F. Chopin"
            city_code: "WAW"
            city_name: null
            country_code: null
            country_name: null
          },
          {
            airport_code: "WMI"
            airport_name: "Modlin Mazovia Aeroport"
            city_code: "WAW"
            city_name: null
            country_code: null
            country_name: null
          }
        ],

        'BCN': [
          {
            airport_code: "BCN"
            airport_name: "International"
            city_code: "BCN"
            city_name: null
            country_code: null
            country_name: null
          },
          {
            airport_code: "GRO"
            airport_name: "Costa Brava"
            city_code: "BCN"
            city_name: null
            country_code: null
            country_name: null
          }
        ]
       }
       *
       * @type {Object}
       */
      this.cities = {};
    };

  /**
   * @lends AirportsSrv.prototype
   */
  AirportsSrv.prototype =
  {

    /**
     * Get airports by city codes
     *
     * @param {String[]} Array of city codes
     *
     * @return {Promise}
     */
    getAirportsByCityCodes: function (cityCodes) {
      var self = this,
        promise,
        deferred;

      if (this.hasAirportsForCities(cityCodes)) {
        deferred = $q.defer();

        deferred.resolve(this.getAirportsByCityCodesFromCache(cityCodes));

        return deferred.promise;
      }

      promise = ApiTools.fetch(this, endpoints.getAirportsByCityCodes, {code: cityCodes});

      promise.then(function (airports) {
        angular.forEach(cityCodes, function (cityCode) {
          self.cities[cityCode] = airports;
        });
      });

      return promise;
    },

    /**
     * Returns airports for specified city codes(from this.cities)
     *
     * @param {String[]} cityCodes
     * @returns {Object[]}
     */
    getAirportsByCityCodesFromCache: function (cityCodes) {
      var airports = [], self = this;

      angular.forEach(cityCodes, function (cityCode) {
        if (self.cities[cityCode]) {
          airports = airports.concat(self.cities[cityCode]);
        }
      });

      return airports;
    },

    /**
     * Returns true if all specified cities have cached airports
     *
     * @param {String[]} cityCodes
     */
    hasAirportsForCities: function (cityCodes) {
      var result = true, self = this;

      angular.forEach(cityCodes, function (cityCode) {
        if (!self.cities[cityCode]) {
          result = false;
        }
      });

      return result;
    }

  };

  AirportsSrv.prototype.constructor = AirportsSrv;

  return new AirportsSrv();
}]);
;

// Source: ../shared/public_html/assets/js/search/services/SearchAPI.js
(function (angular, _, _js_app_config_) {
/**
     * SearchAPI factory
     *
     * @param  {Object}            $location
     * @param  {SearchQueryParams} SearchQueryParams
     * @param  {ApiTools}          ApiTools
     * @param  {RespSummary}       RespSummary
     * @param  {PriceGroup}        PriceGroup
     * @param  {Dictionaries}      Dictionaries
     * @param  {AppConfig}         appConfig
     *
     * @return {SearchAPI}
     */
    var SearchAPIFactory = function ($location, SearchQueryParams, ApiTools, RespSummary, PriceGroup, Dictionaries, appConfig, SearchClientService, Base64) {
var extend = angular.extend,

          /**
           * The API endpoints configuration
           *
           * Each endpoint is a configuration object which must have following properties:
           *
           * - {String}   url        The URL to the API with optional parameters as :parameterName
           * - {String}   method     The one of HTTP verbs (POST, GET...)
           * - {Function} respParser The function called by SearchAPI before returning results to caller.
           *                         It always receives two arguments the SearchAPI instance and the server JSON response
           *                         object. It must return whatever should be returned to the SearchAPI caller.
           *                         Returning $q.reject from this function will trigger error handler on calling code.
           */
          endpoints = {
            // Search flights
            apiSearch: {url: '/api/search', method: 'POST', respParser: searchParser},

            // Get search results
            apiGetResult: {
              url: '/api/search/getResult/:requestId/:pageNumber',
              method: 'POST',
              respParser: responseParser
            },

            // Get random search results
            apiGetRandom: {url: '/api/search/searchFs' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: responseParser},

            // Get price group
            apiGetPriceGroup: {
              url: '/api/flightDetails/getPriceGroup/:requestId/:priceGroupId' +'?abv='+_js_app_config_.ab_version,
              method: 'GET',
              respParser: priceGroupParser
            },

            // DEPRECATED
            // Search flights with flight storage mechanism
            apiSearchFs: {url: '/api/search/searchFs' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: searchParser},

            // Search flights with flight storage mechanism
            apiSearchFsStart: {
              url: '/api/search/searchFsStart',
              method: 'POST',
              respParser: searchParser
            },

            // Search flights with NinjaBox - only given dates (NonFlex)
            startExactSearch: {
              url: '/api/search/searchStartCentralCell',
              method: 'POST',
              respParser: searchParser
            },

            // Search flights with NinjaBox - +/- 2 days (Flex/Matrix)
            startMatrixSearch: {
              url: '/api/search/searchStartMatrix',
              method: 'POST',
              respParser: searchParser
            },

            // Check if search result are loaded
            apiGetResultFs: {url: '/api/flightStorage/loadProviderResults' +'?abv='+_js_app_config_.ab_version, method: 'POST', respParser: searchParser},

            // NB
            apiPrepareNinjaBoxPGr: {
              url: '/api/flightDetails/prepareBasketForPGr/:requestId/:nbHash' + '?abv=' + _js_app_config_.ab_version,
              method: 'POST',
              respParser: function (response) {
                return response.response;
              }
            },

            // Check if search result are loaded
            apiCheckSearchFs: {
              url: '/api/flightStorage/checkResult/:requestId' + '?abv=' + _js_app_config_.ab_version + '&searchClient=' + SearchClientService.getType(),
              method: 'GET',
              respParser: function (response) { return response.response; }
            },

            // Get data for matrix +/-2 days
            apiMatrix: {
              url: '/api/flightStorage/getMatrix' +'?abv='+_js_app_config_.ab_version,
              method: 'GET',
              respParser: function (response) { return response.response; }
            },

            // Endpoint called when flight search finishes
            apiOnSearchFinish: {
              url: '/api/search/finish?abv=' + _js_app_config_.ab_version,
              method: 'POST',
              respParser: function (response) { return response.response; }
            }
          },

          preSearchPromise = null,

          preSearchIntermediateOptions = {
            skipFsResults:true
          },

          /**
           * SearchAPI
           *
           * @class {SearchAPI}
           */
          SearchAPI = function () {
          };

        SearchAPI.prototype = /** @lends SearchAPI.prototype */ {

          /**
           * Returns endpoints
           *
           * @returns {Object}
           */
          getEndpoints: function () {
            return endpoints;
          },

          /**
           * Returns a random list of flights from the promotions
           * database on a chosen route
           *
           * @param  {String} depCode
           * @param  {String} destCode
           * @param  {String} depDate
           * @param  {String} destDate
           * @param  {String} adt
           * @param  {String} ow
           *
           * @return {Promise}
           */
          getRandomResponse: function (depCode, destCode, depDate, destDate, adt, ow) {
            return ApiTools.fetch(this, endpoints.apiGetRandom, {
              "flight_from_code": depCode,
              "flight_to_code": destCode,
              "departure_date": depDate,
              "return_date": destDate,
              "adults": adt,
              "oneway": ow
            });
          },

          /**
           * Returns request ID and a cached list of flights(if exists)
           *
           * @param  {SearchQueryParams} searchQueryParams
           * @param  {Number} searchTime
           *
           * @return {Promise}
           */
          apiSearchFsStart: function (searchQueryParams, searchTime) {
            var payload = buildSearchRequestPayload(searchQueryParams, searchTime);
            var params = {
              abv: _js_app_config_.ab_version,
              searchClient: SearchClientService.getType(),
            };
            return ApiTools.fetch(this, endpoints.apiSearchFsStart, payload, params);
          },

          /**
           * Search flights with NinjaBox - only given dates (NonFlex)
           *
           * @param  {SearchQueryParams} searchQueryParams
           * @param  {Number} searchTime
           */
          startExactSearch: function (searchQueryParams, searchTime) {
            var payload = buildSearchRequestPayload(searchQueryParams, searchTime);
            var params = {
              abv: _js_app_config_.ab_version,
            };
            return ApiTools.fetch(this, endpoints.startExactSearch, payload, params);
          },

          /**
           * Search flights with NinjaBox - +/- 2 days (Flex/Matrix)
           *
           * @param  {SearchQueryParams} searchQueryParams
           * @param  {Number} searchTime
           * @param  {String} mainRequestId
           */
          startMatrixSearch: function (searchQueryParams, searchTime, mainRequestId) {
            var payload = buildSearchRequestPayload(searchQueryParams, searchTime);
            var params = {
              abv: _js_app_config_.ab_version,
              mainRequestId: mainRequestId,
            };
            return ApiTools.fetch(this, endpoints.startMatrixSearch, payload, params);
          },

          searchFsAndResults: function (options) {
              var self = this;
              var request;
              var searchQueryParams = options.searchQueryParams || angular.copy(SearchQueryParams); // dubious
              var searchDate = new Date();
              var searchTime = searchDate.getTime();
              var result = {
                intermediateOptions: preSearchIntermediateOptions,
                options: options,
                searchQueryParams: searchQueryParams,
                searchDate: searchDate
              };

              if (!options.fidelity) {
                  request = self.apiSearchFsStart(searchQueryParams, searchTime);
              } else if (options.fidelity === 'exact') {
                  request = self.startExactSearch(searchQueryParams, searchTime);
              } else if (options.fidelity === 'matrix') {
                  request = self.startMatrixSearch(searchQueryParams, searchTime, options.mainRequestId);
              }

              return request.then(function (res1) {
                  result.searchFsResponse = res1;
                  if (preSearchIntermediateOptions.changeCallback) {
                    preSearchIntermediateOptions.changeCallback();
                  }
                  if (preSearchIntermediateOptions.stop) {
                      result.stopped = true;
                      return result;
                  }
                  if (preSearchIntermediateOptions.abort) {
                      result.aborted = true;
                      throw result;
                  }

                  if (preSearchIntermediateOptions.skipFsResults) {
                    result.getResultsResponse = {};
                    result.getResultsResponse.flights = [];
                    result.getResultsResponse.summary = {};

                    return result;
                  }

                  return self.getResults([], res1.requestId, res1.searchUrl, false, searchTime).then(function (res2) {
                      result.getResultsResponse = res2;
                      return result;
                  });
              });
          },

          prepareBasketForPGr: function(requestId, priceGroup, params) {
            var nbHash = priceGroup.getNbId() ? priceGroup.getNbId() : '';

            angular.extend(params, {
              requestId: requestId,
              nbHash: nbHash,
              instantSearch: priceGroup.isInstantSearch(),
              fsIdEncoded: priceGroup.getFsIdBase64(),
              pgIdEncoded: priceGroup.getIdBase64(),
              depLegIdEncoded: Base64.encode(priceGroup.getDepRoute().getSelectedLeg().getId()),
              retLegIdEncoded: priceGroup.isRoundTrip() ? Base64.encode(priceGroup.getRetRoute().getSelectedLeg().getId()) : ''
            });

            return ApiTools.fetch(this, endpoints.apiPrepareNinjaBoxPGr, {}, params);
          },

          // in edge cases a new request may be fired before last one ends: called twice in a short time
          searchFsAndResultsPossiblyStarted: function(optionsGetter, contact) {
            if (preSearchPromise) {
              if (contact) {
                contact(preSearchIntermediateOptions);
              }
              var temp = preSearchPromise;
              preSearchPromise = null;
              return temp;
            } else {
              var options = optionsGetter();
              return this.searchFsAndResults(options);
            }
          },

          /**
           * Returns status for each provider
           *
           * @param {Number} requestId
           *
           * @return {Promise}
           */
          checkSearchFs: function (requestId) {
            return ApiTools.fetch(this, endpoints.apiCheckSearchFs, {}, {requestId: requestId});
          },

          /**
           * Returns results for specified providers
           *
           * @param {string} providerGroup - The group of requested providers, ex: WS+YP
           * @param {Number}   requestId
           * @param {String}   searchUrl
           * @param {Boolean}  isFromCalendar
           * @param {Number}  searchTime
           * @param {String}  searchType
           * @param {String}  activeTabId
           *
           * @return {Promise}
           */
          getResults: function (providerGroup, requestId, searchUrl, isFromCalendar, searchTime, searchType, activeTabId) { // getResultsByProviders
            return ApiTools.fetch(this, endpoints.apiGetResultFs, {
              requestId: requestId,
              providerGroup: providerGroup,
              searchUrl: searchUrl,
              isFromCalendar: isFromCalendar,
              searchTime: searchTime ? searchTime : null,
              searchType: searchType ? searchType : null,
              searchClient: SearchClientService.getType(),
              activeTabId: activeTabId
            });
          },

          /**
           * Returns prices for matrix +/-2 days
           *
           * @param {{timeout: number|Promise, searchQueryParams: SearchQueryParams}} options
           *  searchQueryParams
           *  [timeout] timeout in milliseconds, or promise that should abort the request when resolved
           *
           * @returns {Promise}
           */
          matrix: function (options) {
            // Defaults
            angular.extend(options, {});

            var params = {
              filters: this.getFilters(options.searchQueryParams),
              searchUrl: $location.path()
            };

            if (options.searchQueryParams.isOneWay()) {
              params.ow = 1;
            }

            return ApiTools.fetch(this, endpoints.apiMatrix, {}, params, options.timeout || undefined);
          },

          /**
           * Returns filters to send to API
           *
           * @param {SearchQueryParams} SearchQueryParams
           *
           * @returns {Object}
           */
          getFilters: function (SearchQueryParams) {
            var filters = {
              maxPriceNet: SearchQueryParams.maxPrice,
              minDepDepT: SearchQueryParams.minDepDepT,
              maxDepDepT: SearchQueryParams.maxDepDepT,
              minDepArrT: SearchQueryParams.minDepArrT,
              maxDepArrT: SearchQueryParams.maxDepArrT,
              minRetDepT: SearchQueryParams.minRetDepT,
              maxRetDepT: SearchQueryParams.maxRetDepT,
              minRetArrT: SearchQueryParams.minRetArrT,
              maxRetArrT: SearchQueryParams.maxRetArrT
            };

            if (SearchQueryParams.stops) {
              filters.stops = SearchQueryParams.stops;
            }

            if (SearchQueryParams.flightTypes) {
              filters.flightTypes = SearchQueryParams.flightTypes;
              filters.flightTypes = filters.flightTypes.replace('MIXED', 'MIXED,HUB');
            }

            if (SearchQueryParams.carriers) {
              filters.carriers = SearchQueryParams.carriers;
            }

            if (SearchQueryParams.depAirports) {
              //filters.depAirports = SearchQueryParams.depAirports;
            }

            if (SearchQueryParams.arrAirports) {
              //filters.arrAirports = SearchQueryParams.arrAirports;
            }

            if (SearchQueryParams.maxFlightDuration) {
              filters.maxFlightDuration = SearchQueryParams.maxFlightDuration / 60;
            }

            if (SearchQueryParams.maxLayoverDuration !== undefined && SearchQueryParams.maxLayoverDuration !== null) {
              filters.maxLayoverDuration = SearchQueryParams.maxLayoverDuration / 60;
            }

            return filters;
          },

          /**
           * Sends information about visible price groups to backend
           *
           * @param {Object} priceGroupsAnalytics
           */
          searchFinishRequest: function (priceGroupsAnalytics) {
            return ApiTools.fetch(this, endpoints.apiOnSearchFinish, priceGroupsAnalytics);
          }
        };

        SearchAPI.prototype.constructor = SearchAPI;

        // Response parsers

        /**
         * Set the request id of the search we are now performing on SearchAPI object.
         *
         * @param {Object} response The search response we got after triggering search.
         *                          It only has requestId property and _debug_ if not on production.
         */
        function searchParser(response) {
          // Add dictionaries
          if (angular.isObject(response.response.summary) && angular.isObject(response.response.summary.airports)) {
            Dictionaries.addDictionary(response.response.summary, appConfig.getLanguageCode());
          }

          // NOTE: at this point we do not know the request database row ID
          return response.response;
        }

        /**
         *
         * Parse the response
         *
         * @param {Object} response The response we got from the backend.
         */
        function responseParser(response) {
          // Add dictionaries
          if (angular.isObject(response.response.summary) && angular.isObject(response.response.summary.airports)) {
            Dictionaries.addDictionary(response.response.summary, appConfig.getLanguageCode());
          }

          this.requestRowId = response.response.requestRowId;

          if (response.pageNumber === 1) {
            this.priceGroups.clear();
          }
          this.priceGroups.add(response.response.flights, new RespSummary(response.response.summary));

          this.pagesLoaded = response.pageNumber;
          this.pageSize = response.pageSize;

          this.searchParams = extend(SearchQueryParams, this.getPriceGroups().getSummary().searchReq);

          // The filters that were applied to the request for the results
          // this.requestFilters = this.getRequestFilters().setFilters(response.response.filters, true);
          this.lastFiltersHash = this.requestFilters.getHash();

          // The sorter that was applied to the request for the results
          // this.requestSorter = new Sorter(response.response.sorter);
          // this.lastRequestSorter = this.requestSorter.getSorter();

          return this.priceGroups;
        }

        /**
         * Parse price group response
         *
         * @param {Object} response
         */
        function priceGroupParser(response) {
          this.priceGroup = new PriceGroup(response.response);
          return this.priceGroup;
        }

        /**
         * Build search request payload
         *
         * @param searchQueryParams
         * @param searchTime
         * @return {Object}
         */
        function buildSearchRequestPayload(searchQueryParams, searchTime) {
            return {
                "flight_from_code": searchQueryParams.getDepCityCode(),
                "flight_to_code": searchQueryParams.getDesCityCode(),
                "flight_from_airport_code": searchQueryParams.getDepAirportCode(),
                "flight_to_airport_code": searchQueryParams.getDesAirportCode(),
                "departure_date": searchQueryParams.getDepDate(),
                "return_date": searchQueryParams.getRetDate(),
                "adults": searchQueryParams.getAdults(),
                "children": searchQueryParams.getChildren(),
                "infants": searchQueryParams.getInfants(),
                "youths": searchQueryParams.getYouths(),
                "oneway": searchQueryParams.isOneWay() ? 1 : 0,
                "searchTime": searchTime,
            };
        }

        return new SearchAPI(SearchQueryParams);
    };


    SearchAPIFactory.$inject = [
        '$location',
        'sch.SearchQueryParams',
        'ApiTools',
        'sch.RespSummary',
        'flt.PriceGroup',
        'Dictionaries',
        'appConfig',
        'SearchClientService',
        'Base64'
    ];

    angular.module('search')
        .factory('sch.SearchAPI', SearchAPIFactory);


})(angular, _, _js_app_config_);
;

// Source: ../shared/public_html/assets/js/search/services/SearchClient.js
(function (angular) {
/**
   * @param AppConfig
   * @param {Provider} Provider
   *
   * @return {SearchClientService}
   */
  var SearchClientService = function (AppConfig, Provider) {
    /**
     * Returns code
     *
     * @return {String}
     */
    this.getType = function () {
      return AppConfig.getSearchClient().type || '';
    };

    /**
     * Get providerGroup list
     *
     * @returns {Provider[]}
     */
    this.getProviderGroups = function () {
      var groups = AppConfig.getSearchClient().providerGroups || [];
      var providers = [];

      groups.forEach(function (providerGroup) {
        providers.push(new Provider(providerGroup))
      });

      return providers;
    };
  };

  SearchClientService.$inject = [
    'appConfig',
    'sch.Provider'
  ];

  angular
    .module('search')
    .service('SearchClientService', SearchClientService);

}(angular));
;

// Source: ../shared/public_html/assets/js/search/values/FilterLevels.js
/*global angular: false */

angular.module('search')
/**
 * @name        FilterLevels
 * @namespace   sch
 * @description Filter levels list
 * @type        {Object}
 */
.value('sch.FilterLevels', {
  pg: 'price group',
  leg: 'leg',
  segment: 'segment'
});;

// Source: ../shared/public_html/assets/js/searchForm/hotel/HotelErrorsController.js
angular.module('searchForm.hotel')

/**
 * @name        HotelErrorsController
 * @description HotelErrorsController for errors modal in hotel module
 */
.controller('HotelErrorsController',
['$scope', '$modalInstance', 'errors',
function ($scope, $modalInstance, errors) {
/**
   * Errors data
   *
   * @type {Object}
   */
  $scope.errors = errors;


  console.log('open errors controller', errors);


  /**
   * Hide modal
   */
  $scope.hide = function () {
    $modalInstance.dismiss('cancel');
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/hotel/directives/hotelDatesForm.js
angular.module('searchForm.hotel')

/**
 * @name        hotelDatesForm
 * @description Search dates form directive
 */
.directive('hotelDatesForm',
['appConfig', '$timeout', 'htl.SearchFormService', 'RangeDatepicker',
function (appConfig, $timeout, SearchFormService, RangeDatepicker) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) {
      return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/hotel/hotelDatesForm';
    },
    scope: {
      formStatus: '=',
      format: '@'
    },
    link: function (scope, element, attributes, controllers) {

      /**
       * The travel period
       *
       * @type {Number}
       */
      scope.travelPeriod = 0;

      /**
       * Date format
       *
       * @type {String}
       */
      scope.format = attributes.format || 'd MMM';

      /**
       * Device info
       *
       * @type {Object}
       */
      scope.device = appConfig.getDeviceType();

      scope.SearchFormService = SearchFormService;

      /**
       * Dates
       *
       * @type {Object}
       */
      scope.dates = {
        range: {
          start: new Date(appConfig.getDepDate()),
          end: new Date(appConfig.getRetDate())
        }
      };

      scope.formStatus = scope.formStatus || {};
      angular.merge(scope.formStatus, SearchFormService.formStatus.default);

      var today = new Date();

      var minDate = moment(today.setHours(0,0,0,0)),
          maxDate = moment(today.setHours(23,59,59,0)).add(365, 'd'),
          maxRangeDate = moment(today.setHours(23,59,59,0)).add(365, 'd'),
          minTripLength = 1;

      scope.travelPeriod = 0;
      scope.dates = {};
      scope.dates.range = SearchFormService.dates.range;
      scope.dates.lastRange = angular.copy(scope.dates.range);
      scope.dates.minDate = minDate;
      scope.dates.maxDate = maxDate;

      /**
       * Init the dates
       */
      var _initForm = function () {
        SearchFormService.initDates();
        scope.dates.range = SearchFormService.dates.range;
        scope.travelPeriod = SearchFormService.getTravelPeriod();
      };

      /**
       * Update datepicker max date
       *
       * @param {Boolean} isStartDate
       * @private
       */
      var _updateDatepickerMaxDate = function (isStartDate) {
        isStartDate = isStartDate || false;

        var date = angular.copy(scope.rangeDatepicker.maxDate);
        var dateDiff = SearchFormService.dateDiff(date.toISOString(), maxRangeDate.toDate().toISOString());

        if (dateDiff) {
          date.setDate(date.getDate() + dateDiff);
        }

        if (isStartDate) {
          date.setDate(date.getDate() - minTripLength);
        }

        scope.dates.maxDate = moment(date);
        scope.rangeDatepicker.maxDate = date;
      };

      $timeout(function () {
        _initForm();
        _updateRange();
      });

      /**
       * Update intervals
       */
      scope.updateDates = function () {
        $timeout(function () {
          _updateRange();
          _updateDatepickerMaxDate(false);
        });
      };

      /**
       * Open start date
       */
      scope.openStartDate = function () {
        _updateDatepickerMaxDate(true);

        scope.rangeDatepicker.toggleStartDatepicker();
      };

      /**
       * Open end date
       */
      scope.openEndDate = function () {
        _updateDatepickerMaxDate(false);

        scope.rangeDatepicker.toggleEndDatepicker();
      };

      /**
       * Update range
       */
      var _updateRange = function () {

        var
          diff,
          start,
          minDate = scope.dates.minDate.toDate(),
          maxDate = scope.dates.maxDate.toDate();

        // Check interval for begin date
        if (typeof scope.dates.range.start != 'undefined' && scope.dates.range.start) {
          if (scope.dates.range.start >= minDate && scope.dates.range.start < maxDate) {
            scope.dates.lastRange.start = angular.copy(scope.dates.range.start);
          } else {
            scope.dates.range.start = angular.copy(scope.dates.lastRange.start);
          }
        } else {
          scope.dates.range.start = angular.copy(scope.dates.lastRange.start);
        }

        // Check interval for end date
        if (typeof scope.dates.range.end != 'undefined' && scope.dates.range.end) {
          if (scope.dates.range.end > minDate && scope.dates.range.end <= maxDate) {
            scope.dates.lastRange.end = angular.copy(scope.dates.range.end);
          } else {
            scope.dates.range.end = angular.copy(scope.dates.lastRange.end);
          }
        } else {
          scope.dates.range.end = angular.copy(scope.dates.lastRange.end);
        }

        diff = SearchFormService.dateDiff(scope.dates.range.start.toISOString(), scope.dates.range.end.toISOString());

        // Check end date
        if (scope.dates.range.start > scope.dates.range.end || diff <= 0) {
          start = angular.copy(scope.dates.lastRange.start);
          start.setDate(start.getDate() + 1);

          scope.dates.range.end = start;
        }

        _updateIntervals(scope.dates.range);

      };

      /**
       * Update intervals
       *
       * @param range
       */
      var _updateIntervals = function (range) {
        scope.travelPeriod = 0;

        $timeout(function () {
          SearchFormService.dates.range = range;
          scope.travelPeriod = SearchFormService.getTravelPeriod();
        });
      };

      scope.rangeDatepicker = new RangeDatepicker({
        scope: scope,
        range: scope.dates.range,
        minDate: scope.dates.minDate.toDate(),
        maxDate: scope.dates.maxDate.toDate(),
        minTripLength: minTripLength
      });

      /**
       * Show the check in date
       *
       * @type {Boolean}
       */
      scope.showCheckIn = false;

      /**
       * Show the check out date
       *
       * @type {Boolean}
       */
      scope.showCheckOut = false;

      /**
       * Hide departure interval
       */
      scope.hideCheckIn = function () {
        scope.showCheckIn = false;
      };

      /**
       * Hide return interval
       */
      scope.hideCheckOut = function () {
        scope.showCheckOut = false;
      };

      /**
       * Hide intervals
       */
      scope.hideDates = function () {
        scope.hideCheckIn();
        scope.hideCheckOut();
      };

      /**
       * Go to return interval
       */
      scope.goToCheckOut = function () {
        scope.showCheckIn = false;
        scope.showCheckOut = true;
      };

      /**
       * Hide drop downs
       */
      scope.hideDropDowns = function () {
        if (SearchFormService.cityHelper) {
          SearchFormService.cityHelper.hide();
        }
        scope.formStatus.destination.isOpen = false;
        scope.formStatus.rooms.isOpen = false;
      };

      scope.hideRoomsSelector = function() {
        _.defer(function() {
          angular.element(document.querySelectorAll('.rooms-zone [dropdown].open [dropdown-toggle]')).triggerHandler('click');
        });
      };

    }
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/hotel/directives/hotelDestinationForm.js
angular.module('searchForm.hotel')

/**
 * @name        hotelDestinationForm
 * @description Search destination form directive
 */
.directive('hotelDestinationForm',
['htl.SearchFormService',
function (SearchFormService) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) {
      return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/hotel/hotelDestinationForm';
    },
    scope: {
      formStatus: '='
    },
    link: function (scope, element, attributes, controllers) {

      scope.formStatus = scope.formStatus || {};
      angular.merge(scope.formStatus, SearchFormService.formStatus.default);

      /**
       * Selected
       *
       * @type {String}
       */
      scope.selectedDestinationLabel = {};

      /**
       * The city helper formatter
       */
      scope.cityHelperFormatter = SearchFormService.getCityHelperFormatter();

      scope.SearchFormService = SearchFormService;
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/directives/hotelForm.js
angular.module('searchForm.hotel')

/**
 * @name        hotelForm
 * @description Search form directive
 */
.directive('hotelForm',
['$rootScope', '$timeout', 'htl.SearchFormService', 'htl.SearchParamsService', 'SearchOpenerService', 'PageLoading',
function ($rootScope, $timeout, SearchFormService, SearchParamsService, SearchOpenerService, PageLoadingService) {
return {
    restrict: 'A',
    replace: true,
    templateUrl: function (element, attributes) {
      var tplUrl;

      switch (attributes.formLayout) {
        case 'availability':
          tplUrl = '/tpl/show/jsShared/templates/searchForm/hotel/hotelLandingPageForm';
          break;

        case 'navbar':
          tplUrl = '/tpl/show/jsShared/templates/searchForm/hotel/hotelNavbarForm';
          break;

        default:
          tplUrl = '/tpl/show/jsShared/templates/searchForm/hotel/hotelForm';
          break;
      }
      return tplUrl;
    },
    controller: ['$scope', '$rootScope', function($scope, $rootScope) {

      _.defer(function () {
        $rootScope.$apply(function(){
          $rootScope.isHotelLoaded = true;
          $scope.isHotelLoaded = true;
        });
      });

    }],
    link: function (scope, element, attributes) {

      /**
       * The layout
       * default, navbar
       */
      scope.layout = attributes.formLayout || 'default';

      /**
       * Set the form status
       *
       * @type {Object}
       */
      scope.formStatus = {};
      angular.merge(scope.formStatus, SearchFormService.formStatus[scope.layout]);

      var layoutCssClasses = [];
      layoutCssClasses.push('layout-' + scope.layout);

      /**
       * The panel type
       * 0 - external url (booking)
       * 1 - internal search url
       *
       * @type {Number}
       */
      var panelType = SearchFormService.getPanelType();

      /**
       * Disable rooms
       */
      if (panelType == 0) {
        SearchFormService.getRooms().setEnable(false);
        layoutCssClasses.push('layout-external');
      }

      /**
       * The rooms
       *
       * @type {Object}
       */
      scope.rooms = SearchFormService.getRooms();

      /**
       * Layout css classes
       *
       * @type {String}
       */
      scope.layoutCssClasses = layoutCssClasses.join(' ');

      /**
       * Lang
       *
       * @type {{btnSearch: string}}
       */
      scope.lang = {
        btnSearch: 'LANGM_JS_HOTEL_SEARCH_PANEL_BTN'
      };

      /**
       * Init the dates
       */
      var initForm = function () {
        /**
         * Set the defaults params
         */
        SearchParamsService.setDefaults();

        /**
         * Auto populate the search params
         */
        SearchParamsService.autoPopulate();

        var url = SearchParamsService.getUrl();

        if (!SearchParamsService.isSearchUrl(url)) {
          SearchParamsService.populateFromUrl(SearchFormService.getLastSearchUrl());
        } else {
          SearchParamsService.populateFromUrl(url);
        }
      };

      $timeout(function () {
        initForm();
      });

      /**
       * Set the city params
       */
      var setCityParams = function () {
        var city = SearchFormService.getCity();

        SearchParamsService.setPostValue('city_id', city.getCityId());
        SearchParamsService.setPostValue('destination', city.toString());
      };

      /**
       * Set the dates params
       */
      var setDatesPrams = function () {
        SearchParamsService.setPostValue('hotel_checkin', SearchFormService.getDates().getCheckIn());
        SearchParamsService.setPostValue('hotel_checkout', SearchFormService.getDates().getCheckOut());
      };

      /**
       * Clear all room params
       */
      var clearRoomsParams = function () {
        var rooms = SearchFormService.getRooms();

        for (var roomNr = 0; roomNr <= rooms.maxRooms; roomNr++) {
          var
            room = rooms.getList()[roomNr - 1],
            maxChd = (room === undefined ? rooms : room).maxChd;

          for (var childNr = 0; childNr <= maxChd; childNr++) {
            var k = 'room' + roomNr + '_child' + childNr + '_age';
            SearchParamsService.setPostValue(k, undefined);
          }

          SearchParamsService.setPostValue('adults_room' + roomNr, undefined);
        }
      };

      /**
       * Set the rooms params
       */
      var setRoomsParams = function () {
        var rooms = SearchFormService.getRooms();

        clearRoomsParams();

        if (rooms.isEnabled()) {
          _.each(rooms.getList(), function (room, index) {
            var roomNr = index + 1;

            if (room.isValid()) {
              // Set the adults
              SearchParamsService.setPostValue('adults_room' + roomNr, room.getAdults());

              // Set the children
              for (var childNr = 1; childNr <= room.getChildren(); childNr++) {
                if (room.getChdAge(childNr)) {
                  SearchParamsService.setPostValue('room' + roomNr + '_child' + childNr + '_age', room.getChdAge(childNr));
                }
              }
            }
          });
        }

        var roomsNumber = rooms.getList().length;

        // Set the rooms number
        if (roomsNumber) {
          SearchParamsService.setPostValue('no_rooms', roomsNumber);
        }

      };

      /**
       * Check if form is valid
       *
       * @returns {Boolean}
       */
      var formIsValid = function () {
        return SearchFormService.isValid();
      };

      /**
       * Check the search
       *
       * @returns {Boolean}
       */
      var checkSearchParams = function () {
        var valid = SearchParamsService.checkPostDestination() && SearchParamsService.checkPostDates();

        if (SearchFormService.getRooms().isEnabled()) {
          valid = valid && SearchParamsService.checkPostRooms();
        }

        return valid;
      };

      /**
       * Show warning regarding the adults/children in a room
       *
       * @returns {Boolean}
       */
      scope.showWarning = function () {
        var roomsList = SearchFormService.rooms.list;
        for (var i = 0; i < roomsList.length; i++) {
            var adtCount = Number(roomsList[i].adtCount);
            var chdCount = Number(roomsList[i].chdCount);
            var chdAge1 = Number(roomsList[i].chdAge1);
            var chdAge2 = Number(roomsList[i].chdAge2);
            if (adtCount > 3) {
              return chdCount > 0 && (chdAge1 > 2 || chdAge2 > 2);
            } else if (adtCount === 3) {
              return chdCount > 0 && (chdAge1 > 2 && chdAge2 > 2);
            }
        }
      };

      /**
       * Redirect url
       */
      var redirectUrl = function () {
        SearchParamsService.redirectUrl();
      };

      /**
       * Go to results page
       */
      scope.doSearch = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();

        var error = 0;

        if (formIsValid()) {

          PageLoadingService.on();

          // Set the params
          setCityParams();
          setDatesPrams();
          setRoomsParams();

          if (checkSearchParams()) {
            redirectUrl();
          } else {
            error = 2;
          }
        } else {
          error = 1;
        }

        if (error) {
          SearchFormService.openErrorsModal();
        }
      };

      /**
       * Toggle form
       */
      scope.SearchOpenerService = SearchOpenerService;

      /**
       * Go to results page
       */
      scope.doLpSearch = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();

        var searchParams = '';
        var hotelId = 0;

        if (formIsValid()) {

          $rootScope.$broadcast('beforeCheckHotelAvailability');

          // Set the params
          setCityParams();
          setDatesPrams();
          setRoomsParams();

          if (checkSearchParams()) {
            searchParams = SearchParamsService.setUrl().getUrl().replace('hotels/search/', '');
            hotelId = SearchFormService.getHotelId();
          }

          if (!_.isEmpty(searchParams)) {
            $rootScope.$broadcast('CheckHotelAvailability', {
              hotelId: hotelId,
              searchParams: searchParams
            });
          }
        }
      };

      /**
       * Flag for hotel unavailability
       *
       * @type {boolean}
       */
      scope.hotelNotAvailable = false;

      /**
       * Search link
       */
      scope.citySearchLink = '';

      $rootScope.$on('HotelAvailabilityWarning', function(event, warningFlag) {
        scope.hotelNotAvailable = warningFlag;
        scope.citySearchLink = '/' + SearchParamsService.setUrl().getUrl();
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/directives/hotelRoomsForm.js
angular.module('searchForm.hotel')

/**
 * @name        hotelRoomsForm
 * @description Search rooms form directive
 */
.directive('hotelRoomsForm',
['$timeout', 'htl.SearchFormService',
function ($timeout, SearchFormService) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) {
      return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/hotel/hotelRoomsForm';
    },
    scope: {
      formStatus: '=',
      format: '@'
    },
    link: function (scope, element, attributes, controllers) {

      scope.SearchFormService = SearchFormService;

      scope.formStatus = scope.formStatus || {};
      angular.merge(scope.formStatus, SearchFormService.formStatus.default);

      /**
       * The rooms model
       *
       * @type {SearchFormRooms}
       */
      scope.rooms = SearchFormService.getRooms();

      /**
       * Amount of info to diplay
       *
       * @type {String}
       */
      scope.format = attributes.format || 'short';

      /**
       * Init the rooms
       */
      var initForm = function () {
        SearchFormService.initRooms();
      };

      $timeout(function () {
        initForm();
      });

      /**
       * Add room
       *
       * @returns {Boolean}
       */
      scope.addRoom = function () {
        return SearchFormService.rooms.add();
      };

      /**
       * Remove the room
       *
       * @param index
       */
      scope.removeRoom = function (index) {
        return SearchFormService.rooms.remove(index);
      };

      /**
       * Show close button
       *
       * @returns {Boolean}
       */
      scope.showClose = function () {
        return SearchFormService.rooms.getTotalRooms() > 1;
      };

      /**
       * Show the add room button
       *
       * @returns {Boolean}
       */
      scope.showAddRoom = function (nr) {
        return SearchFormService.rooms.getMaxRooms() > SearchFormService.rooms.getTotalRooms();
      };

      /**
       * Set the pax number
       *
       * @param pax
       * @param room
       * @param nr
       */
      scope.setPaxNumber = function (pax, room, nr) {
        switch (pax) {
          case 'ADT':
            room.setAdults(nr);
            break;

          case 'CHD':
            room.setChildren(nr);
            break;
        }
      };

        /**
       * Show warning regarding the adults/children in a room
       *
       * @param index
       * @returns {Boolean}
       */
      scope.showWarn = function (index) {
        var adtCount = Number(SearchFormService.rooms.list[index].adtCount);
        var chdCount = Number(SearchFormService.rooms.list[index].chdCount);
        var chdAge1 = Number(SearchFormService.rooms.list[index].chdAge1);
        var chdAge2 = Number(SearchFormService.rooms.list[index].chdAge2);
        
        if (adtCount > 3) {
          return (chdCount > 0) && ((chdAge1 > 2) || (chdAge2 > 2));
        } else if (adtCount === 3) {
          return (chdCount > 1) && ((chdAge1 > 2) && (chdAge2 > 2));
        }
      };

    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/directives/warningChildren.js
angular.module('searchForm.hotel')

/**
 * @name        warningChildren
 * @description Modal warning on wrong room configuration with adults and children
 */
.directive('warningChildren',
['htl.SearchFormService', '$translate',
function (SearchFormService, $translate) {
return {
    restrict: 'E',
    replace: true,
    template: '<div class="alert alert-warning" role="alert"><div ng-repeat="room in rooms track by $index"><div ng-show="isRoomTooFull($index)"><span translate translate-values="{ roomNo: $index+1, adultsNo: room.adtCount-1, childNo: getChild($index) }">LANGM_JS_HOTELS_ROOM_CHILDREN_NUMBER_ADULTS</span></div></div></div>',
    link: function (scope, element, attributes, controllers) {
      scope.rooms = SearchFormService.rooms.list;

      scope.getChild = function (roomNo) {
        if (scope.rooms[roomNo].adtCount > 3 && scope.rooms[roomNo].chdCount > 0 && (scope.rooms[roomNo].chdAge1 > 2 || scope.rooms[roomNo].chdAge2 > 2)) {
          return '';
        } else if (scope.rooms[roomNo].adtCount == 3 && scope.rooms[roomNo].chdCount > 0 && (scope.rooms[roomNo].chdAge1 > 2 || scope.rooms[roomNo].chdAge2 > 2)) {
          return 2;
        }
      }

      scope.isRoomTooFull = function (roomNo) {
        if (scope.rooms[roomNo].adtCount > 3) {
          return scope.rooms[roomNo].chdCount > 0 && (scope.rooms[roomNo].chdAge1 > 2 || scope.rooms[roomNo].chdAge2 > 2);
        } else if (scope.rooms[roomNo].adtCount == 3) {
          return scope.rooms[roomNo].chdCount > 0 && (scope.rooms[roomNo].chdAge1 > 2 && scope.rooms[roomNo].chdAge2 > 2);
        }
      };
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/models/Error.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.Error
 * @description Hotel Error
 */
.factory('htl.Error',
[
function ErrorFactory() {
/**
   * Error constructor
   *
   * @constructor
   * @class Error
   *
   * @param {Object[]} list
   */
  var Error = function (message, code, id) {

    /**
     * Error code
     *
     * @type {String}
     */
    this.code = code || '';

    /**
     * Error message
     *
     * @type {String}
     */
    this.message = message || '';

  };

  // Add instance methods
  Error.prototype = /** @lends Error.prototype */ {

    /**
     * Set the error code
     *
     * @param code
     * @returns {Error}
     */
    setCode: function (code) {
      this.code = code;

      return this;
    },

    /**
     * Get the error code
     *
     * @returns {String|Error.code|*}
     */
    getCode: function () {
      return this.code;
    },

    /**
     * Set the error message
     *
     * @param message
     * @returns {Error}
     */
    setMessage: function (message) {
      this.message = message;

      return this;
    },

    /**
     * Get the error message
     *
     * @returns {String}
     */
    getMessage: function () {
      return this.message;
    }

  };

  Error.prototype.constructor = Error;

  return Error;
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/models/Errors.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.Errors
 * @description Hotel Errors
 */
.factory('htl.Errors',
['htl.Error',
function ErrorsFactory(Error) {
/**
   * Errors constructor
   *
   * @constructor
   */
  var Errors = function () {

    /**
     * The errors list
     *
     * @type {Array}
     */
    this.errors = [];

  };

  // Add instance methods
  Errors.prototype = /** @lends Errors.prototype */ {

    /**
     * Push error
     *
     * @param error
     */
    pushError: function (error) {
      this.errors.push(error);

      return this;
    },

    /**
     * Add error
     *
     * @param message
     * @param code
     * @returns {Errors}
     */
    addError: function (message, code) {
      return this.pushError(new Error(message, code));
    },

    /**
     * Get the errors
     *
     * @returns {*}
     */
    getErrors: function () {
      return this.errors;
    },

    /**
     * Check if has errors
     *
     * @returns {*}
     */
    hasErrors: function () {
      return this.errors.length;
    },

    /**
     * Reset errors list
     */
    reset: function () {
      this.errors.length = 0;
    },

    /**
     * Get errors by code
     *
     * @param code
     * @returns {Array}
     */
    getByCodes: function (code) {
      var errors = [];

      _.each(this.errors, function (error) {
        if (error.getCode() == code) {
          errors.push(error);
        }
      }, this);

      return errors;
    }

  };

  Errors.prototype.constructor = Errors;

  return Errors;
}
]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/models/SearchFormDates.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.SearchFormDates
 * @description Hotel search panel rooms
 */
.factory('htl.SearchFormDates',
['appConfig',
function SearchFormDatesFactory(appConfig) {
var config = appConfig.getHotelConfig();

  /**
   * SearchFormDates constructor
   *
   * @constructor
   * @class SearchFormDates
   *
   * @param {Object[]} list
   */
  var SearchFormDates = function () {

    /**
     * The range
     *
     * @type {{}}
     */
    this.range = {};

    /**
     * Check in
     *
     * @type {Date}
     */
    // this.range.start = new Date(config.defaultSearchParams.hotel_checkin);

    /**
     * Check in
     *
     * @type {Date}
     */
    // this.range.end = new Date(config.defaultSearchParams.hotel_checkin);
  };

  // Add instance methods
  SearchFormDates.prototype = /** @lends SearchFormDates.prototype */ {

    /**
     * Set the check in date
     *
     * @param checkIn
     * @returns {SearchFormDates}
     */
    setCheckIn: function (checkIn) {
      this.range.start = checkIn;

      return this;
    },

    /**
     * Get the check in date
     *
     * @returns {*}
     */
    getCheckIn: function () {
      return this.range.start;
    },

    /**
     * Set the check out date
     *
     * @param checkOut
     * @returns {SearchFormDates}
     */
    setCheckOut: function (checkOut) {
      this.range.end = checkOut;

      return this;
    },

    /**
     * Get the check out date
     *
     * @returns {Date|*}
     */
    getCheckOut: function () {
      return this.range.end;
    },

    /**
     * Get range
     *
     * @returns {{}}
     */
    getRange: function () {
      return this.range;
    }

  };

  SearchFormDates.prototype.constructor = SearchFormDates;

  return SearchFormDates;
}
]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/models/SearchFormRoom.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.SearchFormRoom
 * @description Hotel search panel room
 */
.factory('htl.SearchFormRoom',
['$filter', '$state',
function SearchFormRoomFactory($filter, $state) {
/**
   * Pluralize filter
   *
   * @type {Function}
   */
  var pluralize = $filter('langPluralize');

  var le = $state.current.name.indexOf('escapes') != -1;

  /**
   * SearchForm constructor
   *
   * @constructor
   * @class SearchFormRoom
   *
   * @param {Object[]} list
   */
  var SearchFormRoom = function (maxAdt, maxChd) {

    /**
     * The max number of adults
     *
     * @type {Number}
     */
    this.maxAdt = maxAdt || 4;

    /**
     * The max number of children
     *
     * @type {Number}
     */
    this.maxChd = maxChd || 2;

    /**
     * The adults count
     * @type {Number}
     */
    this.adtCount = 2;

    /**
     * The children count
     *
     * @type {Number}
     */
    this.chdCount = 0;

    /**
     * The infants count
     *
     * @type {Number}
     */
    this.infCount = 0;

    /**
     * The chd 2 age
     *
     * @type {Number}
     */
    this.chdAge1 = le ? 0 : 1;

    /**
     * The chd 2 age
     *
     * @type {Number}
     */
    this.chdAge2 = le ? 0 : 1;

    /**
     * Prepare extra children ages
     */
    if (this.maxChd > 2) {
      _.each(_.range(3, this.maxChd + 1), function (index) {
        this['chdAge' + index] = le ? 0 : 1;
      }, this);
    }

    /**
     * The children age range
     *
     * @type {Array}
     */
    this.chdAgeRange = [];

  };

  // Add instance methods
  SearchFormRoom.prototype = /** @lends SearchFormRoom.prototype */ {

    /**
     * Set the adults count
     *
     * @param adtCount
     * @returns {SearchFormRoom}
     */
    setAdults: function (adtCount) {
      this.adtCount = adtCount;

      return this;
    },

    /**
     * Get the adults count
     *
     * @returns {Number}
     */
    getAdults: function () {
      return parseInt(this.adtCount);
    },

    /**
     * Add an adult
     *
     * @returns {bool}
     */
    addAdult: function () {
      if (this.adtCount < this.maxAdt) {
        this.adtCount++;

        return true;
      }

      return false;
    },

    /**
     * Remove an adult
     *
     * @returns {bool}
     */
    removeAdult: function () {
      this.adtCount--;

      if (this.adtCount < 1) {
        this.adtCount = 1;

        return false;
      }

      return true;
    },

    /**
     * Set the children count
     *
     * @param chdCount
     * @returns {SearchFormRoom}
     */
    setChildren: function (chdCount) {
      this.chdCount = chdCount;

      for (var i = 1; i <= this.maxChd; i++) {
        if (i > this.chdCount) {
          this['chdAge' + i] = 1;
        }
      }

      return this;
    },

    /**
     * Get the children count
     *
     * @returns {Number}
     */
    getChildren: function () {
      return parseInt(this.chdCount);
    },

    /**
     * Add a child
     *
     * @returns {bool}
     */
    addChild: function () {
      if (this.chdCount < this.maxChd) {
        this.chdCount++;

        return true;
      }

      return false;
    },

    /**
     * Remove a child
     *
     * @returns {bool}
     */
    removeChild: function () {
      this.chdCount--;

      if (this.chdCount < 0) {
        this.chdCount = 0;

        return false;
      }

      return true;
    },

    /**
     * Get the total pax number
     *
     * @returns {Number}
     */
    getTotalPaxNumber: function () {
      return this.getAdults() + this.getChildren();
    },

    /**
     * Set the child age
     *
     * @param i
     * @param age
     */
    setChdAge: function (i, age) {
      this['chdAge' + i] = age;
    },

    /**
     * Get the child age
     *
     * @param i
     * @returns {*}
     */
    getChdAge: function (i) {
      if (typeof this['chdAge' + i] != 'undefined') {
        return parseInt(this['chdAge' + i]);
      }

      return 0;
    },

    /**
     * Check the room
     *
     * @returns {Boolean}
     */
    isValid: function () {
      var valid = true;

      // Check the adults number
      if (this.getAdults() <= 0) {
        valid = false;
      }

      // Check the children number and the children age
      if (this.getChildren()) {
        for (var i = 1; i <= this.getChildren(); i++) {
          if (this.getChdAge(i) <= 0) {
            valid = false;
          }
        }
      }

      return valid;
    },

    /**
     * Get the room title
     *
     * @returns {String}
     */
    getTitle: function (index) {
      index = typeof index != 'undefined' ? index : 0;

      return pluralize('LANGM_JS_SEARCH_PANEL_HOTEL_ROOM_NUMBER', index + 1);
    },

    /**
     * Get the adults range
     *
     * @returns {*}
     */
    getAdtRange: function () {
      return _.range(1, this.maxAdt + 1);
    },

    /**
     * Get the children range
     *
     * @returns {*}
     */
    getChdRange: function () {
      return _.range(0, this.maxChd + 1);
    },

    /**
     * Get the selected children range
     *
     * @returns {*}
     */
    getSelectedChdRange: function () {
      return _.range(1, this.getChildren() + 1);
    },

    /**
     * Get the child age range
     *
     * @returns {*}
     */
    getChdAgeRange: function () {
      if (_.isEmpty(this.chdAgeRange)) {
        for (var i = 1; i <= 17; i++) {
          this.chdAgeRange.push({age: i, label: this.getAgeLabel(i)});
        }
      }

      return this.chdAgeRange;
    },

    /**
     * Get the age label
     *
     * @param age
     * @returns {String}
     */
    getAgeLabel: function (age) {
      return pluralize('LANGM_JS_HOTEL_AGE', age);
    }

  };

  SearchFormRoom.prototype.constructor = SearchFormRoom;

  return SearchFormRoom;
}
]);

;

// Source: ../shared/public_html/assets/js/searchForm/hotel/models/SearchFormRooms.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.SearchFormRooms
 * @description Hotel search panel rooms
 */
.factory('htl.SearchFormRooms',
['$filter', '$translate', 'htl.SearchFormRoom',
function SearchFormRoomsFactory($filter, $translate, SearchFormRoom) {
/**
   * AngularJS translate filter
   *
   * @type {Function}
   */
  var translate = $filter('translate');

  /**
   * SearchFormRooms constructor
   *
   * @constructor
   * @class SearchFormRooms
   *
   * @param {Number} maxRooms
   * @param {Number} maxAdt
   * @param {Number} maxChd
   */
  var SearchFormRooms = function (maxRooms, maxAdt, maxChd) {

    /**
     * The maximum rooms number
     *
     * @type {Number}
     */
    this.maxRooms = maxRooms || 3;

    /**
     * The maximum number of adults in a room
     *
     * @type {Number}
     */
    this.maxAdt = maxAdt || 4;

    /**
     * The maximum number of children in a room
     *
     * @type {Number}
     */
    this.maxChd = maxChd || 2;

    /**
     * The rooms list
     *
     * @type {Array}
     */
    this.list = [];

    /**
     * The total pax number
     *
     * @type {Number}
     */
    this.totalPax = 0;

    /**
     * If this is false the rooms directive will be inactive
     *
     * @type {Boolean}
     */
    this.enable = true;

  };

  // Add instance methods
  SearchFormRooms.prototype = /** @lends SearchFormRooms.prototype */ {

    /**
     * Change the status
     *
     * @param {Boolean} status
     * @returns {SearchFormRooms}
     */
    setEnable: function (status) {
      this.enable = status;

      return this;
    },

    /**
     * Check if si enabled
     *
     * @returns {Boolean}
     */
    isEnabled: function () {
      return this.enable;
    },

    /**
     * Get all rooms
     *
     * @returns {*}
     */
    getList: function () {
      return this.list;
    },

    /**
     * Get total rooms
     *
     * @returns {Number}
     */
    getTotalRooms: function () {
      return this.list.length;
    },

    /**
     * Get the max rooms number
     *
     * @returns {Number}
     */
    getMaxRooms: function () {
      return this.maxRooms;
    },

    /**
     * Get a room by index
     *
     * @param {Number} index
     * @returns {SearchFormRoom}
     */
    get: function (index) {
      return this.list[index];
    },

    /**
     * Add room
     *
     * @param {SearchFormRoom} room
     * @returns {SearchFormRooms}
     */
    add: function (room) {
      if (typeof room == 'undefined') {
        room = new SearchFormRoom(this.maxAdt, this.maxChd);
      }

      this.list.push(room);

      return this;
    },

    /**
     * Remove room
     *
     * @param index
     * @returns {Boolean}
     */
    remove: function (index) {
      if (typeof this.list[index] != 'undefined') {
        this.list.splice(index, 1);

        return true;
      }

      return false;
    },

    /**
     * Get the total pax number
     *
     * @param {String} type
     * @returns {Number}
     */
    getTotalPax: function (type) {
      this.totalPax = 0;

      _.each(this.list, function (room) {
        switch (type) {
          case 'ADT':
            this.totalPax += room.getAdults();
            break;

          case 'CHD':
            this.totalPax += room.getChildren();
            break;

          default:
            this.totalPax += room.getTotalPaxNumber();
            break;
        }
      }, this);

      return this.totalPax;
    },

    /**
     * Get pax setup info
     * @param format
     */
    getPaxSetupInfo: function (format) {
      format = format || 'short';

      switch (format) {
        case 'extended':
          var pax = this.getTotalPax();
          var rooms = this.getTotalRooms();

          var text = pax + ' ' + $translate.instant('LANGM_JS_HOTEL_PAX_' + (pax > 1 ? 'MULTIPLE' : 'SINGLE'));

          if (rooms > 1) {
            text += ', ' + rooms + ' ' + $translate.instant('LANGM_JS_ROOM' + (rooms > 1 ? 'S' : ''));
          }

          return text;

        case 'short':
        default:
          return this.getTotalPax();
      }
    },

    /**
     * Get button lang
     *
     * @returns {*}
     */
    getAddButtonName: function () {
      var
        lang = 'LANGM_JS_HOTEL_ADD_ROOM';

      if (this.getTotalRooms()) {
        lang += '_';
        lang += this.getTotalRooms() + 1;
      }

      return translate(lang);
    },

    /**
     * Warn about one adult per room
     * @param {} type
     * @returns {Boolean}
     */
    showOneAdtWarning: function () {
      var i = 0;
      _.each(this.list, function (room) {
        if (room.getAdults() < 2) {
          i++;
        }
      }, this);
      return i > 0;
    },

    isValid: function () {
      var valid = true;

      _.each(this.list, function (room) {
        if (!room.isValid()) {
          valid = false;
        }
      }, this);

      return valid;
    },

    /**
     * Target serialize the pax setup
     *
     * @returns {{adtCount: (*|Number), chdCount: (*|Number)}}
     */
    srvSerialize: function () {
      var ret = {
        adtCount: this.getTotalPax('ADT'),
        chdCount: this.getTotalPax('CHD')
      };

      for(var i=1; i<=ret.chdCount; i++) {
        ret['chdAge' + i] = this.get(0).getChdAge(i);
      }

      return ret;
    }

  };

  SearchFormRooms.prototype.constructor = SearchFormRooms;

  return SearchFormRooms;
}
]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/services/HotelSearchFormService.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.SearchFormService
 * @description Handles hotel search panel
 */
.service('htl.SearchFormService', ['ApiTools', 'appConfig', '$location', '$filter', '$modal', 'htl.Errors', 'htl.SearchFormRoom', 'htl.SearchParamsService', 'htl.SearchFormRooms', 'htl.SearchFormDates', 'sch.CityHelperItem', 'htl.SearchMemoryService',
function SearchFormService(ApiTools, appConfig, $location, $filter, $modal, Errors, SearchFormRoom, SearchParamsService, SearchFormRooms, SearchFormDates, CityHelperItem, SearchMemoryService) {
var
    self = this,
    endpoints = {};

  /**
   * The loading state
   *
   * @type {Boolean}
   */
  this.loading = false;

  /**
   * Show search panel
   *
   * @type {Boolean}
   */
  this.isVisible = false;

  /**
   * The maximum rooms number
   *
   * @type {Number}
   */
  this.maxRoomsNumber = 3;

  /**
   * The rooms model
   *
   * @type {SearchFormRooms}
   */
  this.rooms = new SearchFormRooms();

  /**
   * The dates model
   *
   * @type {SearchFormDates}
   */
  this.dates = new SearchFormDates();

  /**
   * If is true form is valid
   *
   * @type {Boolean}
   */
  this.valid = false;

  /**
   * The errors
   *
   * @type {Object}
   */
  this.errors = new Errors();

  /**
   * The search panel config
   *
   * @type {Object}
   */
  this.config = appConfig.getHotelConfig();

  /**
   * CityHelperPrototype
   *
   * @type {{}}
   */
  this.cityHelper = null;

  /**
   * The city helper model
   *
   * @type {CityHelperItem}
   */
  this.city = new CityHelperItem({});

  /**
   * The hotel id
   *
   * @type {Number}
   */
  this.hotelId = 0;

  /**
   * Form status
   *
   * @type {{default: {layout: string, destination: {isOpen: boolean}, dates: {isOpen: boolean}, rooms: {isOpen: boolean}}, navbar: {layout: string, destination: {isOpen: boolean}, dates: {isOpen: boolean}, rooms: {isOpen: boolean}}}}
   */
  this.formStatus = {
    default: {
      layout: 'default',
      isOpen: true,
      destination: { isOpen: false },
      dates: { isOpen: false },
      rooms: { isOpen: false }
    },
    navbar: {
      layout: 'navbar',
      isOpen: false,
      destination: { isOpen: false },
      dates: { isOpen: false },
      rooms: { isOpen: false }
    },
    availability: {
      layout: 'availability',
      isOpen: false,
      destination: { isOpen: false },
      dates: { isOpen: false },
      rooms: { isOpen: false }
    }
  };

  /**
   * Set city helper
   *
   * @param cityHelper
   * @returns {SearchFormService}
   */
  this.setCityHelper = function(cityHelper){
    this.cityHelper = cityHelper;

    this.setCity(cityHelper.getFormData());

    return this;
  };

  /**
   * Set city helper from city
   *
   * @param city
   */
  this.setCityHelperFromCity = function (city) {

    if (this.cityHelper) {
      var defCity = {};
      defCity.city_id = city.getCityId();
      defCity.city_name = city.toString();
      this.cityHelper.setFormData(new CityHelperItem(defCity, 'city_name'));
      this.cityHelper.broadcastChange();

      this.setCityHelper(this.cityHelper);
    }

  };

  /**
   * Set the city
   *
   * @param city
   * @returns {*}
   */
  this.setCity = function (city) {
    this.city = city;

    return this;
  };

  /**
   * Get the selected city
   *
   * @returns {CityHelperItem}
   */
  this.getCity = function () {
    return this.city;
  };

  /**
   * Get the search panel config
   *
   * @returns {Object}
   */
  this.getPanelConfig = function () {
    return this.config.searchPanel || {};
  };

  /**
   * Get the panel type
   *
   * @returns {*}
   */
  this.getPanelType = function () {
    var panelConfig = this.getPanelConfig();

    if (typeof panelConfig.type == 'undefined') {
      panelConfig.type = 1;
    }

    return panelConfig.type;
  };

  /**
   * Get the difference
   *
   * @param start
   * @param end
   * @returns {*}
   */
  this.dateDiff = function (start, end) {
    return moment(end).diff(moment(start), 'days');
  };

  /**
   * Get the travel period
   *
   * @param start
   * @param end
   * @returns {Number}
   */
  this.getTravelPeriod = function (start, end) {
    if (typeof start == 'undefined' && typeof end == 'undefined') {
      start = this.dates.getCheckIn();
      end = this.dates.getCheckOut();
    }

    return this.dateDiff(start, end);
  };

  /**
   * Toggle the search panel display
   */
  this.toggle = function () {
    this.isVisible = !this.isVisible;
  };

  /**
   * Return TRUE if we need to show the search panel
   *
   * @returns {Boolean}
   */
  this.show = function () {
    return this.isVisible;
  };

  /**
   * Check if panel is loaded
   *
   * @returns {bool}
   */
  this.isLoaded = function () {
    return true;
  };

  /**
   * Check if panel is still loading
   *
   * @returns {Boolean|*}
   */
  this.isLoading = function () {
    return this.loading;
  };

  /**
   * Change the loading state
   *
   * @param loading
   * @returns {SearchFormService}
   */
  this.setLoading = function (loading) {
    this.loading = loading;

    return this;
  };

  /**
   * Set the city
   *
   * @param city
   * @returns {*}
   */
  this.setCity = function (city) {
    this.city = city;
    this.lastCityName = city.toString();
    return this;
  };

  /**
   * Set the hotel id
   *
   * @param {Number} id
   * @returns {this}
   */
  this.setHotelId = function (id) {
    this.hotelId = id;

    return this;
  };

  /**
   * Get the hotel id
   *
   * @returns {Number}
   */
  this.getHotelId = function () {
    return this.hotelId;
  };

  /**
   * Set the hotel id
   *
   * @param {Number} id
   * @returns {this}
   */
  this.setHotelId = function (id) {
    this.hotelId = id;

    return this;
  };

  /**
   * Get the hotel id
   *
   * @returns {Number}
   */
  this.getHotelId = function () {
    return this.hotelId;
  };

  /**
   * Get the city helper formatter
   *
   * @returns {String}
   */
  this.getCityHelperFormatter = function () {
    if (this.getPanelType() == 0) {
      return 'city_name';
    }

    return 'city_country_name';
  };

  /**
   * Populate from url
   *
   * @param url
   * @param loadMax
   * @returns {SearchFormService}
   */
  this.populateFromUrl = function (url, loadMax) {
    var self = this;

    loadMax = typeof loadMax != 'undefined' ? loadMax : 0;

    if (!this.isLoaded()) {
      if (loadMax < 100) {
        $timeout(function () {
          self.populateFromUrl(url, loadMax + 1);
        }, 500);
      }

      return this;
    }

    var
      cleanUrl = SearchParamsService.cleanUrl(url),
      currentUrl = SearchParamsService.cleanUrl(SearchParamsService.getUrl());

    if (currentUrl != cleanUrl) {
      SearchParamsService.populateFromUrl(url).setUrl();

      if (SearchParamsService.getUrl()) {
        this.populateAll();
      }
    }

    var paramsUrl = SearchParamsService.getUrl();

    if (paramsUrl) {
      this.saveLocalSearchUrl(paramsUrl);

      this.lastCityName = this.city.toString();
    }

    return this;
  };

  /**
   * Last city name
   *
   * @type {string}
   */
  this.lastCityName = '';

  /**
   * Get last city name
   *
   * @returns {string}
   */
  this.getLastCityName = function () {
    if (!this.lastCityName && this.city) {
      this.lastCityName = this.city.toString();
    }

    return this.lastCityName;
  };

  /**
   * Populate and set the selected departures, periods, range and destinations
   *
   * @returns {SearchFormService}
   */
  this.populateAll = function () {

    this
      .populateCity()
      .populateDates()
      .populateRooms();

    return this;
  };

  /**
   * Populate dates
   *
   * @returns {SearchFormService}
   */
  this.populateDates = function () {
    var
      checkIn = SearchParamsService.getPostValue('hotel_checkin'),
      checkOut = SearchParamsService.getPostValue('hotel_checkout');

    if (checkIn && moment(checkIn, SearchParamsService.urlDateFormat, true).isValid()) {
      this.dates.setCheckIn(new Date(moment(checkIn, SearchParamsService.urlDateFormat).format('YYYY-MM-DD')));
    }

    if (checkOut && moment(checkOut, SearchParamsService.urlDateFormat, true).isValid()) {
      this.dates.setCheckOut(new Date(moment(checkOut, SearchParamsService.urlDateFormat).format('YYYY-MM-DD')));
    }

    return this;
  };

  /**
   * Populate city
   *
   * @returns {SearchFormService}
   */
  this.populateCity = function () {
    if (this.cityHelper) {
      var defCity = {};
      defCity.city_id = SearchParamsService.getPostValue('city_id');
      defCity.city_name = SearchParamsService.getPostValue('destination');
      this.cityHelper.setFormData(new CityHelperItem(defCity, 'city_name'));
      this.cityHelper.broadcastChange();

      this.setCityHelper(this.cityHelper);
    }

    return this;
  };

  /**
   * Populate rooms
   *
   * @returns {SearchFormService}
   */
  this.populateRooms = function () {
    this.initRooms();

    return this;
  };

  /**
   * Init the dates
   *
   * @returns {SearchFormService}
   */
  this.initDates = function () {
    if (SearchParamsService.checkPost()) {
      var
        checkIn = SearchParamsService.getPostValue('hotel_checkin'),
        checkOut = SearchParamsService.getPostValue('hotel_checkout');

      if (checkIn && moment(checkIn, SearchParamsService.urlDateFormat, true).isValid()) {
        this.dates.setCheckIn(new Date(moment(checkIn, SearchParamsService.urlDateFormat).format('YYYY-MM-DD')));
      }

      if (checkOut && moment(checkOut, SearchParamsService.urlDateFormat, true).isValid()) {
        this.dates.setCheckOut(new Date(moment(checkOut, SearchParamsService.urlDateFormat).format('YYYY-MM-DD')));
      }
    }

    return this;
  };

  /**
   * Get the dates
   *
   * @returns {SearchFormDates|*}
   */
  this.getDates = function () {
    return this.dates;
  };

  /**
   * Init the rooms
   *
   * @returns {SearchFormService}
   */
  this.initRooms = function () {

    if (this.rooms.list.length) {
      this.rooms.list.length = 0;
    }

    var roomNr,
      room,
      roomAdults,
      childAge,
      childrenCount,
      roomsNumber = SearchParamsService.getPostValue('no_rooms'),
      totalRooms = this.getRooms().getTotalRooms();

    if (SearchParamsService.checkPost() && roomsNumber && !totalRooms) {
      for (roomNr = 1; roomNr <= roomsNumber; roomNr++) {
        roomAdults = SearchParamsService.getPostValue('adults_room' + roomNr);

        if (roomAdults) {
          room = new SearchFormRoom();
          room.setAdults(roomAdults);

          childrenCount = 0;
          for (var childNr = 1; childNr <= room.maxChd; childNr++) {
            childAge = SearchParamsService.getPostValue('room' + roomNr + '_child' + childNr + '_age');

            if (childAge) {
              room.setChdAge(childNr, parseInt(childAge));
              childrenCount++;
            }
          }
          room.setChildren(childrenCount);

          this.getRooms().add(room);
        }
      }
    } else {
      if (this.getRooms().getTotalRooms() <= 0) {
        this.getRooms().add();
      }
    }

    return this;
  };

  /**
   * Get the rooms
   *
   * @returns {Object}
   */
  this.getRooms = function () {
    return this.rooms;
  };

  /**
   * Get the errors
   *
   * @returns {Object}
   */
  this.getErrors = function () {
    return this.errors;
  };

  /**
   * Check if form is valid
   *
   * @returns {Boolean|*}
   */
  this.isValid = function () {
    this.errors.reset();

    this.valid = true;

    this.validateDestination();
    this.validateDates();
    if (this.getRooms().isEnabled()) {
      this.validateRooms();
    }

    return this.valid;
  };

  /**
   * validate destination
   *
   * @returns {Boolean}
   */
  this.validateDestination = function () {
    var cityId = 0;

    if (this.city && typeof this.city == 'object') {
      cityId = this.city.getCityId();
    }

    if (parseInt(cityId) <= 0) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_DESTINATION'), 'destination');

      return false;
    }

    return true;
  };

  /**
   * Validate dates
   *
   * @returns {Boolean}
   */
  this.validateDates = function () {
    var
      checkIn = this.dates.getCheckIn(),
      checkOut = this.dates.getCheckOut(),
      diff = this.dateDiff(checkIn, checkOut);

    if (!checkIn) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_CHECKIN'), 'dates');

      return false;
    }

    if (!checkOut) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_CHECKOUT'), 'dates');

      return false;
    }

    if (parseInt(diff) < 1) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_CHECKIN_CHECKOUT'), 'datesDiff');

      return false;
    }

    return true;
  };

  /**
   * Valdiate rooms
   *
   * @returns {Boolean}
   */
  this.validateRooms = function () {

    var
      childNr,
      totalRooms = this.getRooms().getTotalRooms();

    if (totalRooms <= 0) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_ROOMS'), 'rooms');

      return false;
    }

    var totalPax = this.getRooms().getTotalPax();

    if (totalPax <= 0) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_PAX_NUMBER'), 'rooms');

      return false;
    }

    _.each(this.getRooms().getList(), function (room) {
      if (room.getAdults() <= 0) {
        this.valid = false;

        this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_ADULTS_IN_ROOM'), 'rooms');

        return false;
      }

      if (room.getChildren()) {
        for (childNr = 1; childNr <= room.getChildren(); childNr++) {
          if (room.getChdAge(childNr) <= 0) {
            this.valid = false;

            this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_CHILD_AGE'), 'rooms');

            return false;
          }
        }
      }
    }, this);

    return true;
  };

  /**
   * Open errors modal
   */
  this.openErrorsModal = function () {
    var self = this;

    $modal.open({
      templateUrl: '/tpl/show/jsShared/templates/searchForm/hotel/formErrors',
      controller: 'HotelErrorsController',
      resolve: {
        errors: function () {
          return self.getErrors();
        }
      }
    });
  };

  /**
   * Get the last search url
   *
   * @param string defaultUrl
   * @returns {String}
   */
  this.getLastSearchUrl = function (defaultUrl) {
    var url = SearchMemoryService.getSearchUrl();

    return url ? url : defaultUrl;
  };

  /**
   * Save the search url
   *
   * @param url
   * @returns {SearchFormService}
   */
  this.saveLocalSearchUrl = function (url) {
    if (url) {
      url = SearchParamsService.cleanUrl(url);
      SearchMemoryService.saveSearchUrl(url);
    }

    return this;
  };

}
]);

;

// Source: ../shared/public_html/assets/js/searchForm/hotel/services/SearchMemoryService.js
angular.module('searchForm.hotel')

/**
 * @name        SearchMemoryService
 * @namespace   htl
 * @description Handles hotel search
 */
.service('htl.SearchMemoryService',
['$localStorage',
function SearchMemoryService($localStorage) {
/**
   * The local data
   *
   * @type {Array}
   */
  this.localData = {
    searchUrl: ''
  };

  /**
   * Set the local data
   *
   * @param data
   * @returns {SearchMemoryService}
   */
  this.setLocalData = function (data) {
    $localStorage.htlLocalData = data || {};

    return this;
  };

  /**
   * Get the local data
   *
   * @returns {*|{}}
   */
  this.getLocalData = function () {
    if (typeof $localStorage.htlLocalData == 'undefined') {
      $localStorage.htlLocalData = {};
    }

    return $localStorage.htlLocalData;
  };

  /**
   * Save local data
   *
   * @param data
   * @returns {SearchMemoryService}
   */
  this.saveLocalData = function () {
    $localStorage.$apply();

    return this;
  };

  /**
   * Save the search url
   *
   * @returns {SearchMemoryService}
   */
  this.saveSearchUrl = function (url) {
    this.getLocalData().searchUrl = url || '';

    return this.saveLocalData();
  };

  /**
   * Get the search url
   *
   * @returns {String}
   */
  this.getSearchUrl = function () {
    var localData = this.getLocalData();

    return typeof localData.searchUrl != 'undefined' ? localData.searchUrl : '';
  };

}]);
;

// Source: ../shared/public_html/assets/js/searchForm/hotel/services/SearchParamsService.js
angular.module('searchForm.hotel')

/**
 * @name        hotel.SearchParamsService
 * @namespace   htl
 * @description Hotel search params
 */
.service('htl.SearchParamsService',
['$location', '$filter', '$window', 'paramTypes', 'appConfig', 'htl.Errors',
function SearchParamsService($location, $filter, $window, _paramTypes, appConfig, Errors) {
/**
   * The url
   *
   * @type {String}
   */
  this.url = '';

  /**
   * The query string
   *
   * @type {Object}
   */
  this.queryString = {};

  /**
   * The url prefix
   *
   * @type {string[]}
   */
  this.urlPrefix = ['hotels', 'search'];

  /**
   * The url date format
   *
   * @type {String}
   */
  this.urlDateFormat = 'YYYY-MM-DD';

  /**
   * The params
   *
   * @type {Object}
   */
  this.params = {
    destination: {key: 'destination', type: _paramTypes.single, default: ''},
    destination_code: {key: 'destination_code', type: _paramTypes.single, default: ''},
    city_id: {key: 'city', type: _paramTypes.single, default: 0},
    hotel_checkin: {key: 'checkin', type: _paramTypes.sd, default: ''},
    hotel_checkout: {key: 'checkout', type: _paramTypes.sd, default: ''},
    no_rooms: {key: 'rooms', type: _paramTypes.single, default: 0},
    group_adults: {key: 'group_adults', type: _paramTypes.single, default: 0},
    adults_room1: {key: 'r1', type: _paramTypes.single, default: 0},
    adults_room2: {key: 'r2', type: _paramTypes.single, default: 0},
    adults_room3: {key: 'r3', type: _paramTypes.single, default: 0},
    //adults_room4: {key: 'r4', type: _paramTypes.single, default: 0},
    //adults_room5: {key: 'r5', type: _paramTypes.single, default: 0},
    room1_child1_age: {key: 'room1_child1_age', type: _paramTypes.single, default: 0},
    room1_child2_age: {key: 'room1_child2_age', type: _paramTypes.single, default: 0},
    room2_child1_age: {key: 'room2_child1_age', type: _paramTypes.single, default: 0},
    room2_child2_age: {key: 'room2_child2_age', type: _paramTypes.single, default: 0},
    room3_child1_age: {key: 'room3_child1_age', type: _paramTypes.single, default: 0},
    room3_child2_age: {key: 'room3_child2_age', type: _paramTypes.single, default: 0},
    room4_child1_age: {key: 'room4_child1_age', type: _paramTypes.single, default: 0},
    room4_child2_age: {key: 'room4_child2_age', type: _paramTypes.single, default: 0},
    room5_child1_age: {key: 'room5_child1_age', type: _paramTypes.single, default: 0},
    room6_child2_age: {key: 'room5_child2_age', type: _paramTypes.single, default: 0},
    hash: {key: 'hash', type: _paramTypes.single, default: ''},
    promoted: {key: 'promoted', type: _paramTypes.single, default: 0}
  };

  /**
   * The post
   *
   * @type {Array}
   */
  this.post = [];

  /**
   * If is true form is valid
   *
   * @type {Boolean}
   */
  this.valid = false;

  /**
   * The errors
   *
   * @type {Object}
   */
  this.errors = new Errors();

  /**
   * Set the post
   *
   * @param post
   * @returns {SearchParamsService}
   */
  this.setPost = function (post) {
    this.post = post;

    return this;
  };

  /**
   * Get the post
   *
   * @returns {Array}
   */
  this.getPost = function () {
    return this.post;
  };

  /**
   * Set the defaults
   *
   * @returns {SearchParamsService}
   */
  this.setDefaults = function () {
    var config = appConfig.getHotelConfig();

    this.params.city_id.default = config.defaultSearchParams.city_id;
    this.params.destination.default = config.defaultSearchParams.destination;
    this.params.hotel_checkin.default = moment(config.defaultSearchParams.hotel_checkin).format(this.urlDateFormat);
    this.params.hotel_checkout.default = moment(config.defaultSearchParams.hotel_checkout).format(this.urlDateFormat);
    this.params.no_rooms.default = config.defaultSearchParams.no_rooms;
    this.params.adults_room1.default = config.defaultSearchParams.adults_room1;

    return this;
  };

  /**
   * Auto populate
   *
   * @returns {SearchParamsService}
   */
  this.autoPopulate = function () {
    this.populateFromUrl($location.path());

    return this;
  };

  /**
   * Populate from url
   *
   * @param url
   * @returns {SearchParamsService}
   */
  this.populateFromUrl = function (url) {

    url = url || '';

    var
      urlArray = url.split('/'),
      urlValues = [],
      urlKeys = [],
      tmpValues = [],
      post = [],
      i = 1;

    _.each(urlArray, function (elem) {
      if (elem && _.indexOf(this.urlPrefix, elem) < 0) {
        if (i % 2 == 0) {
          urlValues.push(decodeURIComponent(elem));
        } else {
          urlKeys.push(decodeURIComponent(elem));
        }
        i++;
      }
    }, this);

    _.each(this.params, function (param, name) {
      tmpValues = [];

      _.each(urlKeys, function (paramKey, index) {
        if (paramKey == param.key) {
          tmpValues.push(urlValues[index]);
        }
      }, this);

      if (!_.isEmpty(tmpValues)) {
        switch (param.type) {
          case _paramTypes.mk:
            post[name] = tmpValues;
            break;
          case _paramTypes.mv:
            post[name] = tmpValues.join(',');
            break;
          case _paramTypes.single:
            post[name] = tmpValues.join('');
            break;

          case _paramTypes.sd:
            var dd, d = tmpValues.join('');
            if (/\d{2}-\d{2}-\d{4}/.test(d)) {
              d = d.split('-').reverse().join('-');
            }
            dd = $filter('date')(new Date(d),'yyyy-MM-dd');
            if (!moment(dd, 'YYYY-MM-DD', true).isValid()) {
              dd = param.default;
            }
            post[name] = dd;
            break;
        }
      }
    }, this);

    this.post = post;

    return this;
  };

  /**
   * Get clean url
   *
   * @returns {String}
   */
  this.getCleanUrl = function () {
    return this.cleanUrl($location.path());
  };

  /**
   * Clean the url
   *
   * @param url
   * @returns {String}
   */
  this.cleanUrl = function (url) {
    var cleanUrl = [],
      urlArray = url.split('/');

    _.each(urlArray, function (elem) {
      if (elem && _.indexOf(this.urlPrefix, elem) < 0) {
        cleanUrl.push(elem);
      }
    }, this);

    return cleanUrl.join('/');
  };


  /**
   * Check if is search url
   *
   * @param url
   * @returns {boolean}
   */
  this.isSearchUrl = function (url) {
    url = url !== undefined ? url : $location.path();

    var
      self = this,
      c = 0,
      cleanUrl = _.compact(url.split('/'));

    _.each(self.urlPrefix, function (elem, index) {
      if (cleanUrl[index] !== undefined && cleanUrl[index] == elem) {
        c++;
      }
    }, this);

    return c == self.urlPrefix.length;
  };

  /**
   * Check if is search url
   *
   * @param url
   * @returns {boolean}
   */
  this.isSearchUrl = function (url) {
    url = url !== undefined ? url : $location.path();

    var
      self = this,
      c = 0,
      cleanUrl = _.compact(url.split('/'));

    _.each(self.urlPrefix, function (elem, index) {
      if (cleanUrl[index] !== undefined && cleanUrl[index] == elem) {
        c++;
      }
    }, this);

    return c == self.urlPrefix.length;
  };

  /**
   * Set the url
   *
   * @param url
   * @returns {SearchParamsService}
   */
  this.setUrl = function (url) {
    if (url === undefined) {
      this.composeUrl();
    } else if (url) {
      this.url = url;
    }

    return this;
  };

  /**
   * Get the url params
   *
   * @returns {Array}
   */
  this.getUrl = function () {
    if (_.isEmpty(this.url)) {
      this.setUrl();
    }

    return this.url;
  };

  /**
   * Get the query string
   *
   * @returns {Object}
   */
  this.getQueryString = function () {
    return this.queryString;
  };

  /**
   * Compose the url
   *
   * @returns {SearchQueryParams}
   */
  this.composeUrl = function () {
    var url = [];
    var postUrl = this.getPostUrl();

    if (postUrl) {
      url.push(this.urlPrefix.join('/'));
      url.push(postUrl);

      this.url = url.join('/');
    }

    return this;
  };

  /**
   * Compose the url
   *
   * @returns {SearchQueryParams}
   */
  this.composeExternalUrl = function (config) {
    var checkIn = moment(new Date(moment(this.getPostValue('hotel_checkin'), this.urlDateFormat)));
    var checkOut = moment(new Date(moment(this.getPostValue('hotel_checkout'), this.urlDateFormat)));
    var destination = this.getPostValue('destination');
    var noRooms = this.getPostValue('no_rooms', false);
    var groupAdults = this.getPostValue('group_adults', false);

    this.queryString.error_url = config.ext_error_url;
    this.queryString.lang = config.lang;
    this.queryString.sid = config.ext_sid;
    this.queryString.si = config.ext_si;
    this.queryString.aid = config.ext_aid;

    this.queryString.ss = destination;

    this.queryString.checkin_monthday = checkIn.format('DD');
    this.queryString.checkin_year_month = checkIn.format('YYYY-MM');
    this.queryString.checkout_monthday = checkOut.format('DD');
    this.queryString.checkout_year_month = checkOut.format('YYYY-MM');

    this.queryString.hotel_year_arr = checkIn.format('YYYY');
    this.queryString.hotel_month_arr = checkIn.format('MM');
    this.queryString.hotel_day_arr = checkIn.format('DD');

    this.queryString.hotel_year_dep = checkOut.format('YYYY');
    this.queryString.hotel_month_dep = checkOut.format('MM');
    this.queryString.hotel_day_dep = checkOut.format('DD');

    if (noRooms !== null) {
        this.queryString.no_rooms = noRooms;
    }

    if (groupAdults !== null) {
        this.queryString.group_adults = groupAdults;
    }

    /*this.queryString.do_availability_check = 'on';
     this.queryString.class = [1, 2, 3, 4, 5];*/

    this.url = config.ext_baseLink;

    return this;
  };

  /**
   * To query string
   *
   * @param obj
   * @returns {String}
   */
  this.toQueryString = function (obj) {
    return _.map(obj, function (v, k) {
      if (_.isArray(v)) {

        return _.map(v, function (av, ak) {
          if (typeof ak === 'number') {
            return encodeURIComponent(k) + '[]=' + encodeURIComponent(av);
          } else {
            return encodeURIComponent(k) + '[' + ak + ']=' + encodeURIComponent(av);
          }
        }).join('&');

      } else {
        return encodeURIComponent(k) + '=' + encodeURIComponent(v);
      }
    }).join('&');
  };

  /**
   * Generate complete url.
   *
   * @param {Object} panelConfig
   */
  this.generateCompleteUrl = function (panelConfig) {
      this.composeExternalUrl(panelConfig);

      var queryString = this.toQueryString(this.getQueryString());
      var completeUrl = this.getUrl();

      if (queryString) {
        completeUrl += '?' + queryString;
      }

      return completeUrl;
  };

  /**
   * Get complete url.
   */
  this.getCompleteUrl = function () {
    var config = appConfig.getHotelConfig();
    var panelConfig = config.searchPanel;

    return this.generateCompleteUrl(panelConfig);
  };

  /**
   * Redirect url
   */
  this.redirectUrl = function () {
    var config = appConfig.getHotelConfig();
    var panelConfig = config.searchPanel;

    if (panelConfig.type == 0) {
      $window.location.href = this.generateCompleteUrl(panelConfig);
    } else {
      this.composeUrl();
      $location.url(this.getUrl());
    }
  };

  /**
   * Check the post
   *
   * @returns {Boolean}
   */
  this.checkPost = function () {
    this.valid = true;

    this.checkPostDestination();
    this.checkPostDates();
    this.checkPostRooms();

    return this.valid;
  };

  /**
   * Check the post
   *
   * @returns {Boolean}
   */
  this.checkPostDestination = function () {
    var
      city_id = this.getPostValue('city_id'),
      destination = this.getPostValue('destination');

    if (!city_id || !destination) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_DESTINATION'), 'destination');

      return false;
    }

    return true;
  };

  /**
   * Check the post
   *
   * @returns {Boolean}
   */
  this.checkPostDates = function () {
    var
      checkIn = this.getPostValue('hotel_checkin'),
      checkOut = this.getPostValue('hotel_checkout');

    if (!checkIn) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_CHECKIN'), 'dates');

      return false;
    }

    if (!checkOut) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_SET_CHECKOUT'), 'dates');

      return false;
    }

    return true;
  };

  /**
   * Check the post
   *
   * @returns {Boolean}
   */
  this.checkPostRooms = function () {
    var roomsNumber = this.getPostValue('no_rooms');

    if (!roomsNumber) {
      this.valid = false;

      this.getErrors().addError($filter('translate')('LANGM_JS_HOTEL_ERROR_ROOMS'), 'rooms');

      return false;
    }

    return true;
  };

  /**
   * Get the errors
   *
   * @returns {Object}
   */
  this.getErrors = function () {
    return this.errors;
  };

  /**
   * Get the url from params
   *
   * @returns {SearchQueryParams}
   */
  this.getPostUrl = function () {
    var url = [];

    _.each(this.params, function (param, name) {

      if (this.post[name] !== undefined) {
        switch (param.type) {
          case _paramTypes.mk:
            if (!_.isEmpty(this.post[name])) {
              _.each(this.post[name], function (value) {
                url.push(param.key, value);
              }, this.post[name]);
            }
            break;
          case _paramTypes.mv:
          case _paramTypes.single:
          case _paramTypes.sd:
            if (this.post[name]) {
              url.push(param.key, this.post[name]);
            }
            break;
        }
      }

    }, this);

    return url.join('/');
  };

  /**
   * Set the param value
   *
   * @param {String} name
   * @param value
   * @returns {SearchParamsService}
   */
  this.setPostValue = function (name, value) {
    if (name !== undefined && this.params[name] !== undefined) {
      var param = this.params[name];

      switch (param.type) {
        case _paramTypes.mk:
          if (value !== undefined) {
            this.post[name] = value;
          } else {
            this.post[name] = param.default;
          }
          break;
        case _paramTypes.mv:
          if (value !== undefined) {
            this.post[name] = value.join(',');
          } else {
            this.post[name] = param.default;
          }
          break;
        case _paramTypes.single:
          if (value !== undefined) {
            this.post[name] = value;
          } else {
            this.post[name] = param.default;
          }
          break;
        case _paramTypes.sd:
          if (value !== undefined) {
            this.post[name] = typeof value == 'string' ? value : moment(value).format(this.urlDateFormat);
          } else {
            this.post[name] = param.default;
          }
          break;
      }
    }

    return this;
  };

  /**
   * Get the param value
   *
   * @param name
   * @param getDefault
   * @returns {*}
   */
  this.getPostValue = function (name, getDefault) {
    if (name !== undefined) {
      if (this.post[name] !== undefined) {
        return this.post[name];
      }

      if (getDefault === undefined) {
        getDefault = true;
      }

      if (getDefault && this.params[name] !== undefined) {
        return this.params[name].default;
      }
    }

    return null;
  };

  /**
   * Check post value
   *
   * @param name
   * @param value
   * @returns {Boolean}
   */
  this.checkPostValue = function (name, value) {
    if (value !== undefined && name !== undefined && this.params[name] !== undefined && this.post[name] !== undefined) {
      switch (this.params[name].type) {
        case _paramTypes.mk:
          return _.indexOf(this.post[name], value) >= 0;
        case _paramTypes.mv:
          if (!_.isEmpty(this.post[name])) {
            return _.indexOf(this.post[name].split(','), value) >= 0;
          } else {
            return false;
          }
          break;
        case _paramTypes.single:
        case _paramTypes.sd:
          return this.post[name] == value;
      }
    }

    return false;
  };

  /**
   * Get the destination
   */
  this.getDestination = function () {
    return this.getPostValue('destination');
  };

  /**
   * Get the city id
   */
  this.getCityId = function () {
    return this.getPostValue('city_id');
  };

}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/components/ith-pkg-change-search.component.js
(function (angular) {
/**
     * @name        IthPkgChangeSearchComponent
     * @description Change search fixed bar on city breaks
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthPkgChangeSearchComponent = {
        templateUrl: '/tpl/show/jsShared/templates/searchForm/package/packagesChangeSearchBar',
        controller: 'IthPkgChangeSearchController',
        transclude: true
    };

    angular
        .module('searchForm.package')
        .component('ithPkgChangeSearch', IthPkgChangeSearchComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/searchForm/package/components/ith-pkg-change-search.controller.js
(function (angular) {
/**
     * @name        IthPkgChangeSearchController
     * @description Handles data inside the change search bar component
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthPkgChangeSearchController = function (SearchOpenerService) {
        /**
         * Search opener service reference.
         *
         * @type {SearchFormService}
         */
        this.searchOpenerService = SearchOpenerService;
    };

    IthPkgChangeSearchController.$inject = [
        'SearchOpenerService'
    ];

    angular
        .module('searchForm.package')
        .controller('IthPkgChangeSearchController', IthPkgChangeSearchController);

}(angular));
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/fixedViewport.js
angular.module('searchForm.package')

/**
* @name        fixedViewport
* @description add position fixed to viewport
*/
.directive('fixedViewport',
['$parse', 'appConfig',
function ($parse, AppConfig) {
var
    tablet = AppConfig.isTablet() || AppConfig.isMobile(),
    fixElement = document.querySelector('body');

  /**
   * Fix fixed position for tablet
   *
   * @param action
   */
  var fixFixed = function (action) {
    var
      modalClass = 'modal-open',
      fixedClass = 'fixed-viewport';

    if (tablet) {
      switch (action) {
        case true:
          fixElement.classList.add(modalClass);
          fixElement.classList.add(fixedClass);
          break;
        case false:
          fixElement.classList.remove(modalClass);
          fixElement.classList.remove(fixedClass);
          break;
      }
    }
  };

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attr) {
      var fixed = $parse(attr.fixedViewport);
      scope.$watch(fixed, function (value) {
        fixFixed(value);
      });
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesDeparturesForm.js
angular.module('searchForm.package')

/**
 * @name        packagesDeparturesForm
 * @description Search form directive - departures
 */
.directive('packagesDeparturesForm',
['pkg.SearchFormService', '$timeout', 'goo.PackageAnalytics',
function (SearchFormService, $timeout, PackageAnalytics) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) { return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/package/packagesDeparturesForm'; },
    scope: {
      formStatus: '=',
      pageType: '='
    },
    link: function (scope, iElement, attributes) {

      /**
       * Type
       * cs, vacations
       */
      scope.type = attributes.formType || 'cb';

      /**
       * Selected departures
       *
       * @type {*}
       */
      scope.selectedDepartures = SearchFormService.getSelectedDepartures();
      scope.formStatus = scope.formStatus || {};

      angular.merge(scope.formStatus, SearchFormService.formStatus[scope.layout]);

      /**
       * Search service
       */
      scope.SearchFormService = SearchFormService;

      /**
       * The departures model
       *
       * @type {SearchFormDepartures}
       */
      scope.pkgDepartures = SearchFormService.getDepartures();

      /**
       * The periods model
       * @type {SearchFormPeriods}
       */
      scope.periods = SearchFormService.getPeriods();

      /**
       * The periods model
       * @type {SearchFormPeriods}
       */
      scope.tabs = SearchFormService.getTabs();

      /**
       * The form lang
       */
      scope.formLang = {
        selectedPlaceholder: 'LANGM_JS_PACKAGES_SEARCH_PANEL_SELECT_DEPARTURES_' + scope.formStatus.layout.toUpperCase() + '_' + scope.type.toUpperCase()
      };

      /**
       *  Close dropdown
       */
      scope.pkgCloseDropDown = function () {
        PackageAnalytics.eventDepartureCloseDropDown();
        scope.formStatus.departures.isOpen = !scope.formStatus.departures.isOpen;
      };

      /**
       * Toggle
       */
      scope.pkgToggleDropDown = function () {
        scope.formStatus.departures.isOpen = !scope.formStatus.departures.isOpen;
        if (!scope.formStatus.departures.isOpen && scope.pageType === 'home') {
          $timeout(function() {
            if (!scope.tabs.isDestinationsSelected()) {
              scope.formStatus.destinations.isOpen = true;
            } else if (!scope.periods.hasDataForm()) {
              scope.formStatus.periods.isOpen = true;
            }
          },50);
        }
      };

    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesDestinationsColumnsForm.js
angular.module('searchForm.package')

/**
 * @name        packagesDestinationsColumnsForm
 * @description Search form directive
 */
.directive('packagesDestinationsColumnsForm',
['pkg.SearchFormService',
function (SearchFormService) {
return {
    restrict: 'E',
    require: '?ngModel',
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/searchForm/package/packagesDestinationsColumnsForm',
    scope: {
      model: '=?ngModel',
      currentTab: '=',
      column: '='
    },
    link: function (scope, element, attributes) {

      /**
       * Search service
       */
      scope.SearchFormService = SearchFormService;

      /**
       * The destinations
       */
      scope.destinations = _.toArray(scope.model);

      /**
       * Tab id
       */
      scope.tabId = scope.currentTab.getId();

    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesDestinationsForm.js
angular.module('searchForm.package')

/**
 * @name        packagesDestinationsForm
 * @description Search form directive - destinations
 */
.directive('packagesDestinationsForm',
['pkg.SearchFormService', 'appConfig', '$timeout', 'goo.PackageAnalytics',
function (SearchFormService, AppConfig, $timeout, PackageAnalytics) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) { return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/package/packagesDestinationsForm'; },
    scope: {
      formStatus: '=',
      type: '<',
      pageType: '='
    },
    link: function (scope, element, attributes) {

      /**
       * Form status
       *
       * @type {Object}
       */
      scope.formStatus = scope.formStatus || {};
      angular.merge(scope.formStatus, SearchFormService.formStatus[scope.layout]);

      /**
       * The layout
       * default, navbar
       */
      scope.layout = attributes.formLayout || 'default';

      /**
       * Search service
       */
      scope.SearchFormService = SearchFormService;

      /**
       * The destinations tabs model
       *
       * @type {SearchFormTabsDestinations}
       */
      scope.pkgTabs = SearchFormService.getTabs();

      /**
       * Selected destinations
       *
       * @type {Array}
       */
      scope.getSelectedDestinations = function () {
        return SearchFormService.getSelectedDestinations();
      };

      /**
       * The departures model
       *
       * @type {SearchFormDepartures}
       */
      scope.pkgDepartures = SearchFormService.getDepartures();

      /**
       * The periods model
       * @type {SearchFormPeriods}
       */
      scope.periods = SearchFormService.getPeriods();

      /**
       * Auto complete
       *
       * @type {String}
       */
      scope.formData = {};
      scope.formData.data = '';

      /**
       * Set default type when prop is missing
       */
      if (scope.type === undefined) {
        scope.type = 'cb';
      }

      /**
       * The form lang
       */
      scope.formLang = {
        autoCompletePlaceholder: 'LANGM_JS_PACKAGES_SEARCH_PANEL_SEARCH_DESTINATIONS',
        selectedPlaceholder: 'LANGM_JS_PACKAGES_SEARCH_PANEL_SELECT_DESTINATIONS_' + scope.formStatus.layout.toUpperCase() + '_' + scope.type.toUpperCase()
      };

      /**
       * Set the active tab by page type
       */
      if (scope.pkgTabs && scope.pkgTabs.isLoaded()) {
        scope.pkgTabs.setActiveTabByPageType(scope.type, scope.pageType);
      }

      /**
       * Auto complete changed
       *
       * @param $item
       * @param $model
       * @param $label
       */
      scope.pkgAutoCompleteChanged = function ($item, $model, $label) {
        var selectedDestination;

        if ($item !== undefined) {
          _.each(scope.pkgTabs.getList(), function (tab) {
            selectedDestination = null;

            _.each(tab.getDestinations(), function (destination) {
              if (destination.getChildrenCount()) {
                _.each(destination.getChildren(), function (child) {
                  if (child.getId() == $item.id) {
                    selectedDestination = child;
                  }
                }, this);
              }

              if (destination.getId() == $item.id) {
                selectedDestination = destination;
              }
            }, this);

            if (selectedDestination) {
              selectedDestination.setSelected(true);

              if (selectedDestination.getParentId()) {
                SearchFormService.manageDestinationTab(tab.getId(), selectedDestination);
              } else {
                SearchFormService.manageParentTab(tab.getId(), selectedDestination, selectedDestination.getChildren());
              }
            }
          }, this);

          scope.formData.data = '';
        }
      };

      /**
       * Auto complete destinations
       *
       * @param a
       */
      scope.pkgAutoCompleteKeyPress = function (event) {
        event.which === 13 && scope.pkgAutoCompleteChanged();
      };

      /**
       * Filter destinations
       *
       * @private
       */
      var _filterDestinations = function () {
        _.defer(function () {
          scope.$apply(function(){
            SearchFormService.filterDestinationsByDepartures();
          });
        });
      };

      /**
       *  Close dropdown
       */
      scope.pkgCloseDropDown = function () {
        scope.formStatus.destinations.isOpen = !scope.formStatus.destinations.isOpen;
      };

      /**
       * Toggle
       */
      scope.pkgToggleDropDown = function () {
        scope.formStatus.destinations.isOpen = !scope.formStatus.destinations.isOpen;
        scope.pkgOnToggle(scope.formStatus.destinations.isOpen);
        if (!scope.formStatus.destinations.isOpen && !scope.periods.hasDataForm() && scope.pageType === 'home') {
          $timeout(function() {
            scope.formStatus.periods.isOpen = true;
          },50);
        }
      };

      var preLoadDestinationsTabs = false;

      if (!preLoadDestinationsTabs) {
        _filterDestinations();
      }

      /**
       * Destinations is toggled
       * filter destinations
       *
       * @param open
       */
      scope.pkgOnToggle = function (open) {
        if (open) {
          _filterDestinations();

          if (!AppConfig.isMobile() && typeof element[0] != 'undefined') {
            var inputElement = element[0].querySelector('input.auto-focus');
            if (inputElement) {
              inputElement.focus();
            }
          }
        }
      };

      scope.formLoading = {};
      scope.formLoading.isOpen = false;

      /**
       * Check the loading state
       */
      scope.checkLoadingState = function () {
        if (scope.formLoading.isOpen) {
          scope.formStatus.destinations.isOpen = true;
          scope.pkgToggleDestinations(true);
        }
      };

    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesForm.js
angular.module('searchForm.package')

/**
 * @name        packagesForm
 * @description Search form directive
 */
.directive('packagesForm',
['$location', 'pkg.SearchParamsService', 'pkg.SearchFormService', 'SearchOpenerService', 'goo.PackageAnalytics', 'appConfig',
function ($location, SearchParamsService, SearchFormService, SearchOpenerService, PackageAnalytics, appConfig) {
var templateUrl = function ($element, $attributes) {
    var spTemplateUrl;

    switch ($attributes.formLayout) {
      case 'navbar':
        spTemplateUrl = '/tpl/show/jsShared/templates/searchForm/package/packagesNavbarForm';
        break;

      default:
        spTemplateUrl = '/tpl/show/jsShared/templates/searchForm/package/packagesForm';
        break;
    }

    return spTemplateUrl;
  };

  templateUrl.$inject = [
    '$element',
    '$attributes'
  ];

  return {
    restrict: 'A',
    replace: true,
    priority: 0,
    templateUrl: templateUrl,
    scope: {
      pageType: '@'
    },
    controller: ['$scope', '$rootScope', '$state', function($scope, $rootScope, $state) {
      if ($state.current.name === '') {
        /**
         * No route defined so it must be homepage
         * @type {String}
         */
        $scope.pageType = 'home';
      }

      /**
       * Device info
       *
       * @type {Object}
       */
      $scope.device = appConfig.getDeviceType();

      /**
       * Search service
       */
      $scope.SearchFormService = SearchFormService;

      /**
       * Load the search panel
       */
      SearchFormService.loadPanel();

      var $watch = setInterval(function()
      {
        if (SearchFormService.isLoaded() || !SearchFormService.isLoading())
        {
          clearInterval($watch);
          $rootScope.$apply(function(){
            $rootScope.isCBLoaded = true;
          });
        }
      }, 100);

    }],
    link: function (scope, iElement, attributes, controller, transcludeFn)
    {
      /**
       * Type
       * cs, vacations
       */
      scope.type = attributes.formType || 'cb';

      /**
       * The layout
       * default, navbar
       */
      scope.layout = attributes.formLayout || 'default';

      /**
       * Set the form status
       *
       * @type {Object}
       */
      scope.formStatus = {};
      angular.merge(scope.formStatus, SearchFormService.formStatus[scope.layout]);

      var layoutCssClasses = [];
      layoutCssClasses.push('layout-' + scope.layout);

      /**
       * Layout css classes
       *
       * @type {String}
       */
      scope.layoutCssClasses = layoutCssClasses.join(' ');

      /**
       * The form lang
       */
      scope.formLang = {
        btnSearch: 'LANGM_JS_PACKAGES_SEARCH_PANEL_BTN_' + scope.formStatus.layout.toUpperCase() + '_' + scope.type.toUpperCase()
      };

      /**
       * Selected list
       *
       * @type {Object}
       */
      scope.selectedList = SearchFormService.getSelectedList();

      /**
       * Set the departures params
       */
      var setDeparturesSearchParams = function () {
        scope.pkgDepartures = SearchFormService.getDepartures();
        scope.pkgDepartures.isLoaded() && SearchParamsService.setPostValue(scope.pkgDepartures.getPostKey(), scope.selectedList.departures);
      };

      /**
       * Set the destinations params
       */
      var setDestinationsSearchParams = function () {
        scope.pkgTabs = SearchFormService.getTabs();
        scope.pkgTabs.isLoaded() && SearchParamsService.setPostValue(scope.pkgTabs.getPostKey(), scope.selectedList.destinations);
      };

      /**
       * Set the periods params
       */
      var setPeriodsSearchParams = function () {
        scope.pkgPeriods = SearchFormService.getPeriods();

        scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue(scope.pkgPeriods.getPostKey(), []);
        scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue('departureDate', '');
        scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue('returnDate', '');

        if (scope.pkgPeriods.isRangeSelected() && scope.pkgPeriods.isRangeActive()) {
          var range = scope.pkgPeriods.getRange();

          scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue('departureDate', range.start);
          scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue('returnDate', range.end);
        } else if (scope.pkgPeriods.isPeriodsSelected && scope.pkgPeriods.isPeriodActive()) {
          scope.pkgPeriods.isLoaded() && SearchParamsService.setPostValue(scope.pkgPeriods.getPostKey(), scope.selectedList.periods);
        }
      };

      /**
       * Check the search
       *
       * @returns {Boolean}
       */
      var checkSearchParams = function () {
        if (SearchParamsService.checkPost()) {
          return true;
        }

        return false;
      };

      /**
       * Redirect url
       */
      var redirectUrl = function () {
        var url = SearchParamsService.composeUrl().getUrl();

        if (url) {
          SearchFormService.populateAndSetSelected(); // Populate all tabs

          $location.url(url);
        }
      };

      /**
       * Go to results page
       */
      scope.doSearch = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();

        PackageAnalytics.eventSearchButton();

        scope.selectedList = SearchFormService.getSelectedList();

        var error = 0;

        // Set the params
        setDeparturesSearchParams();
        setDestinationsSearchParams();
        setPeriodsSearchParams();

        if (checkSearchParams()) {
          redirectUrl();
        } else {
          error = 1;
        }

        scope.formStatus.departures.isOpen = false;
        scope.formStatus.destinations.isOpen = false;
        scope.formStatus.periods.isOpen = false;

        if (error) {
          scope.formStatus.destinations.isOpen = true;
        }
      };

      /**
       * Toggle form
       */
      scope.SearchOpenerService = SearchOpenerService;
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesNewSearch.js
angular.module('searchForm.package')

/**
 * @name        packagesNewSearch
 * @description Button for back to search directive
 */
.directive('packagesNewSearch',
[
function () {
return {
    restrict: 'A',
    templateUrl: '/tpl/show/jsShared/templates/searchForm/package/packagesNewSearch-hyb',
    controller: ['$scope', function ($scope) {

      $scope.$on('isCityBreak', function (event, data) {
        $scope.isCB = function () {
          return (data === 1);
        };
      });
    }]
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesPeriodsForm.js
angular.module('searchForm.package')

/**
 * @name        packagesPeriodsForm
 * @description Search form directive - periods
 */
.directive('packagesPeriodsForm',
['$timeout', 'appConfig', 'pkg.SearchFormService', 'RangeDatepicker', 'goo.PackageAnalytics',
function ($timeout, appConfig, SearchFormService, RangeDatepicker, PackageAnalytics) {
return {
    restrict: 'E',
    replace: true,
    templateUrl: function (el, attr) { return attr.templateUrl || '/tpl/show/jsShared/templates/searchForm/package/packagesPeriodsForm'; },
    scope: {
      formStatus: '='
    },
    link: function (scope, iElement, attributes, controller, transcludeFn) {

      //appConfig.setFirstEntryToFalse();

      /**
       * Device info
       *
       * @type {Object}
       */
      scope.device = appConfig.getDeviceType();

      /**
       * Form status
       *
       * @type {string|.scope.formStatus|{}|formStatus|Object}
       */
      scope.formStatus = scope.formStatus || {};
      angular.merge(scope.formStatus, SearchFormService.formStatus[scope.layout]);

      /**
       * Type
       * cs, vacations
       */
      scope.type = attributes.formType ? attributes.formType : 'cb';

      /**
       * The layout
       * default, navbar
       */
      scope.layout = attributes.formLayout || 'default';

      /**
       * If there is an uncommon resolution (1280x720)
       */
      scope.uncommonRes = function () {
        var wRes = window.screen.width;
        var hRes = window.screen.height;

        return (wRes >= 1280 && hRes <= 720);
      };

      /**
       * Search service
       */
      scope.SearchFormService = SearchFormService;

      /**
       * The periods model
       *
       * @type {SearchFormPeriods}
       */
      scope.pkgPeriods = SearchFormService.getPeriods();

      /**
       * Return true if merely one month is selected
       */
      var selectedMonths = angular.copy(scope.pkgPeriods.getList());
      scope.monthSelected = function () {
        var period = _.findWhere(selectedMonths, {selected: true});
        return !!period;
      };

      /**
       * Return searched months
       */
      scope.getSearchedMonths = function () {
        var months = _.where(selectedMonths, {selected: true});
        return months;
      };

      /**
       * Range
       *
       * @type {.periodTabs.interval|*}
       */
      scope.showRangeInfo = scope.pkgPeriods.isRangeActive();
      scope.selectedRange = scope.pkgPeriods.getRange();

      scope.pkgShowDepartureDate = false;
      scope.pkgShowReturnDate = false;
      scope.pkgShowRangeLayer = false;

      scope.pkgTravelPeriod             = 0;
      scope.pkgIntervals                = {};
      scope.pkgIntervals.range          = scope.pkgPeriods.range;
      scope.pkgIntervals.lastRange      = angular.copy(scope.pkgIntervals.range);
      scope.pkgIntervals.minDate        = scope.pkgPeriods.range.minDate;
      scope.pkgIntervals.maxDate        = scope.pkgPeriods.range.maxDate;
      scope.pkgIntervals.minReturnDate  = angular.copy(scope.pkgIntervals.range.start);

      var minDays = scope.pkgPeriods.range.minDays;

      scope.pkgPeriods.setRange(scope.pkgIntervals.range);


      /**
       * The form lang
       */
      scope.formLang = {
        selectedPlaceholder: 'LANGM_JS_PACKAGES_SEARCH_PANEL_SELECT_PERIODS_' + scope.formStatus.layout.toUpperCase() + '_' + scope.type.toUpperCase()
      };

      /**
       * Update range
       *
       * @param delay
       */
      scope.pkgUpdateRange = function (delay) {
        delay = typeof delay != 'undefined' ? delay : 0;

        $timeout(function () {
          _updateRange();
        }, delay);
      };

      /**
       * Update min return date
       */
      var _updateMinReturnDate = function () {
        scope.pkgIntervals.minReturnDate = angular.copy(scope.pkgIntervals.range.start);
        scope.pkgIntervals.minReturnDate.setDate(scope.pkgIntervals.minReturnDate.getDate() + minDays);
      };

      _updateMinReturnDate();

      /**
       * Update range
       */
      var _updateRange = function () {

        var
          diff,
          start,
          minDate = scope.pkgIntervals.minDate.toDate(),
          maxDate = scope.pkgIntervals.maxDate.toDate(),
          oldDate = angular.copy(scope.pkgIntervals.lastRange);

        // Check interval for begin date
        if (typeof scope.pkgIntervals.range.start != 'undefined' && scope.pkgIntervals.range.start) {
          if (scope.pkgIntervals.range.start > minDate && scope.pkgIntervals.range.start < maxDate) {
            scope.pkgIntervals.lastRange.start = angular.copy(scope.pkgIntervals.range.start);
          } else {
            scope.pkgIntervals.range.start = angular.copy(scope.pkgIntervals.lastRange.start);
          }
        } else {
          scope.pkgIntervals.range.start = angular.copy(scope.pkgIntervals.lastRange.start);
        }

        // Check interval for end date
        if (typeof scope.pkgIntervals.range.end != 'undefined' && scope.pkgIntervals.range.end) {
          if (scope.pkgIntervals.range.end > minDate && scope.pkgIntervals.range.end < maxDate) {
            scope.pkgIntervals.lastRange.end = angular.copy(scope.pkgIntervals.range.end);
          } else {
            scope.pkgIntervals.range.end = angular.copy(scope.pkgIntervals.lastRange.end);
          }
        } else {
          scope.pkgIntervals.range.end = angular.copy(scope.pkgIntervals.lastRange.end);
        }

        diff = SearchFormService.dateDiff(scope.pkgIntervals.range.start.toISOString(), scope.pkgIntervals.range.end.toISOString());

        // Check end date
        if (scope.pkgIntervals.range.start > scope.pkgIntervals.range.end || diff < 2) {
          start = angular.copy(scope.pkgIntervals.lastRange.start);
          start.setDate(start.getDate() + 2);

          scope.pkgIntervals.range.end = start;
        }

        _updateMinReturnDate();
        _updateIntervals(scope.pkgIntervals.range);


        /**
        * If the return date is selected and changed
        */
        if(oldDate.start.getDate() == scope.pkgIntervals.range.start.getDate() && oldDate.end.getDate() != scope.pkgIntervals.range.end.getDate()){
          scope.pkgToggleDropDown();
        }

      };

      /**
       * Update intervals
       *
       * @param range
       */
      var _updateIntervals = function (range) {
        scope.pkgTravelPeriod = 0;

        $timeout(function () {
          var start = range.start;
          var end = range.end;
          scope.pkgTravelPeriod = start && end ? parseInt((new Date(end.getFullYear(), end.getMonth(), end.getDate()) - new Date(start.getFullYear(), start.getMonth(), start.getDate())) / 86400000) + 1 : 0;
          scope.pkgPeriods.setRange(range);
        });
      };

      /**
       * Stop click
       *
       * @param $event
       */
      var stopClick = function ($event) {
        if (typeof $event != 'undefined') {
          $event.preventDefault();
          $event.stopPropagation();
        }
      };

      /**
       * Show departure intervals
       */
      scope.pkgShowDepartureInterval = function () {
        scope.pkgShowDepartureDate = true;
        scope.pkgShowRangeLayer = true;
      };

      /**
       * Show return interval
       */
      scope.pkgShowReturnInterval = function () {
        scope.pkgShowReturnDate = true;
        scope.pkgShowRangeLayer = true;
      };

      /**
       * Hide departure interval
       */
      scope.pkgHideDepartureInterval = function () {
        scope.pkgShowDepartureDate = false;
        scope.pkgShowRangeLayer = false;
      };

      /**
       * Hide return interval
       */
      scope.pkgHideReturnInterval = function () {
        scope.pkgShowReturnDate = false;
        scope.pkgShowRangeLayer = false;
      };

      /**
       * Hide intervals
       */
      scope.pkgHideIntervals = function () {
        scope.pkgHideDepartureInterval();
        scope.pkgHideReturnInterval();
      };

      /**
       * Hide departure intervals
       *
       * @param $event
       */
      scope.pkgOpenDepartureInterval = function ($event) {
        stopClick($event);
        scope.pkgHideReturnInterval();
        scope.pkgShowDepartureInterval();
      };

      /**
       * Open return interval
       *
       * @param $event
       */
      scope.pkgOpenReturnInterval = function ($event) {
        stopClick($event);
        scope.pkgHideDepartureInterval();
        scope.pkgShowReturnInterval();
      };

      /**
       * Go to return interval
       */
      scope.pkgGoToReturnInterval = function () {
        scope.pkgShowDepartureDate = false;
        scope.pkgShowReturnDate = true;
      };

      /**
       * Toggle intervals
       *
       * @param open
       */
      scope.pkgToggleIntervals = function (open) {
        scope.pkgHideIntervals();
      };

      /**
       * close dropDown
       */
      scope.pkgCloseDropDown = function () {
        scope.pkgToggleDropDown();
        PackageAnalytics.eventPeriodCloseDropDown();
      };

      /**
       * Toggle
       */
      scope.pkgToggleDropDown = function () {
        scope.formStatus.periods.isOpen = !scope.formStatus.periods.isOpen;
      };

      if (scope.pkgPeriods.isRangeSelected()) {
        _updateIntervals(scope.selectedRange);
        scope.pkgIntervals.range = scope.selectedRange;
      }

      scope.rangeDatepicker = new RangeDatepicker({
        scope: scope,
        range: scope.pkgIntervals.range
      });

      scope.isOpenedModal = function() {
        return scope.rangeDatepicker.isOpened();
      }
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/directives/packagesTabDestinationsForm.js
angular.module('searchForm.package')

/**
 * @name        packagesTabDestinationsForm
 * @description Search form directive
 */
.directive('packagesTabDestinationsForm',
['pkg.SearchFormService',
function (SearchFormService) {
return {
    restrict: 'E',
    require: '?ngModel',
    replace: true,
    templateUrl: '/tpl/show/jsShared/templates/searchForm/package/packagesTabDestinationsForm',
    scope: {
      model: '=?ngModel'
    },
    link: function (scope, element) {

      /**
       * Search service
       */
      scope.SearchFormService = SearchFormService;

      /**
       * The tab
       */
      scope.tab = scope.model;

      /**
       * Get the columns
       */
      var setColumnsDestinations = function () {
        SearchFormService.getTabColumns(scope.tab);
      };

      /**
       * Show disabled items
       *
       * @type {Boolean|*}
       */
      scope.showDisabled = SearchFormService.getDepartures().isSelected();
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/models/Departure.js
angular.module('searchForm.package')

/**
 * @name        Departure
 * @namespace   pkg
 * @description
 */
.factory('pkg.Departure',
[
function DepartureFactory() {
/**
   * Departure constructor
   *
   * @constructor
   * @class Departure
   */
  var Departure = function (departureObj) {

    departureObj = departureObj || {};

    /**
     * Key
     * @type {Number}
     */
    this.code = departureObj.key || '';

    /**
     * Title
     * @type {String}
     */
    this.title = departureObj.name || '';

    /**
     * Selected
     * @type {Boolean}
     */
    this.selected = departureObj.selected || false;

    /**
     * Disabled
     * @type {Boolean}
     */
    this.disabled = false;

  };

  // Add instance methods
  Departure.prototype = /** @lends Departure.prototype */ {

    /**
     * Get the id
     * @return {Number}
     */
    getCode: function () {
      return this.code;
    },

    /**
     * Get the title
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Set the selected
     * @param {Boolean} sel
     * @return {Departure}
     */
    setSelected: function (sel) {
      this.selected = sel;

      return this;
    },

    /**
     * Check if is selected
     * @return {Boolean}
     */
    isSelected: function () {
      return this.selected;
    },

    /**
     * Set the disabled
     *
     * @param disabled
     * @returns {Departure}
     */
    setDisabled: function (disabled) {
      this.disabled = disabled;

      return this;
    },

    /**
     * Ceck if is disabled
     * @return {Boolean}
     */
    isDisabled: function () {
      return this.disabled;
    }

  };

  Departure.prototype.constructor = Departure;

  return Departure;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/Destination.js
angular.module('searchForm.package')

/**
 * @name        Destination
 * @namespace   pkg
 * @description
 */
.factory('pkg.Destination',
['$filter',
function DestinationFactory($filter) {
/**
   * Destination constructor
   *
   * @constructor
   * @class Destination
   */
  var Destination = function (destinationObj) {

    destinationObj = destinationObj || {};

    /**
     * Id
     * @type {Number}
     */
    this.id = destinationObj.id || 0;

    /**
     * Title
     * @type {String}
     */
    this.title = destinationObj.title || '';

    /**
     * Slug
     * @type {String}
     */
    this.slug = destinationObj.slug || '';

    /**
     * Slug from title
     * @type {String}
     */
    this.titleSlug = destinationObj.titleSlug || this.slug;

    /**
     * Parent id
     * @type {Number}
     */
    this.parentId = destinationObj.parent_id || 0;

    /**
     * Latitude
     * @type {Number}
     */
    this.latitude = destinationObj.latitude || '';

    /**
     * Longitude
     * @type {Number}
     */
    this.longitude = destinationObj.longitude || '';

    /**
     * Allow country search
     * @type {Boolean}
     */
    this.allowSearchCountry = destinationObj.allow_search_country || false;

    /**
     * Popular
     * @type {Boolean}
     */
    this.popular = destinationObj.popular || false;

    /**
     * Selected
     * @type {Boolean}
     */
    this.selected = destinationObj.selected || false;

    /**
     * Show in search panel
     * @type {Boolean}
     */
    this.disabled = false;

    /**
     * Does this destination have a content kit associated with it?
     *
     * @type {Boolean}
     */
    this.showContentKit = destinationObj.showContentKit || false;

    /**
     * The destination departures
     * @type {Array}
     */
    this.departures = destinationObj.departures || [];

    /**
     * The children
     *
     * @type {Array}
     */
    this.children = [];

    /**
     * The parent
     *
     * @type {Destination}
     */
    this.parent = '';

    /**
     * The children list
     * @type {Array<Destination>}
     */
    this.setChildrenList(destinationObj.children || []);

    /**
     * Filters
     * @type {Object}
     */
    this.filter = {
      popular: this.popular ? true : false,
      enabledDepartures: true,
      disabledDepartures: false,
    };

    this.langAllDestinations = $filter('translate')('LANGM_JS_PACKAGES_SEARCH_PANEL_ALL_DESTINATIONS');

  };

  // Add instance methods
  Destination.prototype = /** @lends Destinations.prototype */ {

    /**
     * Apply the filters
     *
     * @param popular
     * @param enabledDepartures
     * @param disabledDepartures
     * @return {Destination}
     */
    applyFilters: function (popular, enabledDepartures, disabledDepartures) {
      popular = popular || false;
      enabledDepartures = enabledDepartures || [];
      disabledDepartures = disabledDepartures || [];

      var tmp = [];

      if (popular && !this.isPopular()) {
        this.setPopularFilter(false);
      }

      tmp = _.intersection(destination.getDepartures(), enabledDepartures);

      if (_.isEmpty(tmp)) {
        this.setEnabledDeparturesFilter(false);
      }

      tmp = _.intersection(destination.getDepartures(), disabledDepartures);

      if (_.isEmpty(tmp)) {
        this.setDisabledDeparturesFilter(false);
      }

      return this;
    },

    /**
     * Set the filter
     *
     * @param name
     * @param value
     * @return {Destination}
     */
    setFilter: function (name, value) {
      this.filter[name] = value;
      return this;
    },

    /**
     * Set the popular filter
     * @param value
     * @return {Destination}
     */
    setPopularFilter: function (value) {
      return this.setFilter('popular', value);
    },

    /**
     * Set the departure filter
     * @param value
     * @return {Destination}
     */
    setEnabledDeparturesFilter: function (value) {
      return this.setFilter('enabledDepartures', value);
    },

    /**
     * Set the disabled departures filter
     *
     * @param value
     * @return {Destination}
     */
    setDisabledDeparturesFilter: function (value) {
      return this.setFilter('disabledDepartures', value);
    },

    /**
     * Set the children list
     * @return {Destination}
     */
    setChildren: function (children) {
      this.children = children;
      return this;
    },

    /**
     * Set the parent
     *
     * @param parent
     * @returns {Destination}
     */
    setParent: function (parent) {
      this.parent = parent;

      return this;
    },

    /**
     * Set the children list
     * @param {Array} children
     * @return {Destination}
     */
    setChildrenList: function (children) {
      this.children = [];

      if (!_.isArray(children)) {
        children = [];
      }

      var child;

      if (children.length) {
        children.forEach(function (destination) {
          child = new Destination(destination);
          child.setParent(this);

          this.children.push(child);
        }, this);
      }

      return this;
    },

    /**
     * Get the id
     * @return {Number}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Get the title
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Get the search title
     *
     * @returns {String}
     */
    getSearchTitle: function () {
      if (this.getParentId() == 0) {
        return this.getTitle() + ' ' + this.langAllDestinations;
      }

      return this.getTitle() + ', ' + this.getParent().getTitle();
    },

    /**
     * Get the search
     *
     * @returns {Object}
     */
    getSearchValue: function () {
      var self = this;

      return {
        id: self.id,
        name: self.getSearchTitle(),
        selected: self.isSelected(),
        isDisabled: function () {
          return self.isDisabled();
        },
        setDisabled: function (disabled) {
          self.setDisabled(disabled);
        }
      };
    },

    /**
     * Get the slug
     *
     * @return {String}
     */
    getSlug: function () {
      return this.slug;
    },

    /**
     * Get the title slug
     *
     * @return {String}
     */
    getTitleSlug: function () {
      return this.titleSlug;
    },

    /**
     * Get the sorted slug
     *
     * @returns {String}
     */
    getSortedSlug: function () {
      var slug = this.getTitleSlug();

      if (this.getParentId()) {
        slug += '-' + this.getParent().getSortedSlug();
      }

      return slug;
    },

    /**
     * Get the parent id
     * @return {Number}
     */
    getParentId: function () {
      return this.parentId;
    },

    /**
     * Get the parent
     *
     * @returns {*}
     */
    getParent: function () {
      return this.parent;
    },

    /**
     * Set popular
     * @param popular
     * @return {Destination}
     */
    setPopular: function (popular) {
      this.popular = popular;

      return this;
    },

    /**
     * Get the popular
     */
    getPopular: function () {
      return this.popular;
    },

    /**
     * Set the disabled
     * @param show
     * @return {Destination}
     */
    setDisabled: function (disabled) {
      this.disabled = disabled;

      return this;
    },

    /**
     * Show in search panel
     * @return {Boolean}
     */
    isDisabled: function () {
      return this.disabled;
    },

    /**
     * Check if is popular
     * @return {Boolean}
     */
    isPopular: function () {
      return this.popular > 0;
    },

    /**
     * Set the selected
     * @param {Boolean} selected
     * @return {Destination}
     */
    setSelected: function (sel) {
      this.selected = sel;

      return this;
    },

    /**
     * Check if is selected
     * @return {Boolean}
     */
    isSelected: function () {
      return this.selected;
    },

    /**
     * Show tag
     * @return {Boolean|Number}
     */
    showTag: function () {
      return this.isSelected() && (this.getParentId() || this.isCountrySearchAllowed());
    },

    /**
     * Check if is allowed in search
     *
     * @returns {Boolean|Integer}
     */
    showInSearch: function () {
      return this.isSelected() && (this.getParentId() || this.isCountrySearchAllowed());
    },

    /**
     * Check if search is allowed on country
     * @return {Boolean}
     */
    isCountrySearchAllowed: function () {
      return this.allowSearchCountry;
    },

    /**
     * Get the children
     * @return {Array<Destination>}
     */
    getChildren: function () {
      return this.children;
    },

    /**
     * Get the filrst child
     * @return {Destination}
     */
    getFirstChild: function () {
      var children = this.getChildren();

      return typeof children[0] != 'undefined' ? children[0] : [];
    },

    /**
     * Get the children number
     * @return {Number}
     */
    getChildrenCount: function () {
      return this.getChildren().length;
    },

    /**
     * Get the departures
     * @return {Array}
     */

    getDepartures: function () {
      return this.departures;
    }

  };

  Destination.prototype.constructor = Destination;

  return Destination;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/SearchForm.js
angular.module('searchForm.package')

/**
 * @name        SearchForm
 * @namespace   pkg
 * @description packages search panel
 */
.factory('pkg.SearchForm',
['pkg.SearchFormTabs', 'pkg.SearchFormDepartures', 'pkg.SearchFormPeriods',
function SearchFormFactory(SearchFormTabs, SearchFormDepartures, SearchFormPeriods) {
/**
   * SearchForm constructor
   *
   * @constructor
   * @class SearchForm
   *
   * @param {Object[]} panelObj
   */
  var SearchForm = function (panelObj) {

    /**
     * The loaded state
     *
     * @type {Boolean}
     */
    this.loaded = false;

    /**
     * Tabs destinations
     *
     * @type {SearchFormTabs}
     */
    this.tabs = new SearchFormTabs();

    /**
     * The departures
     *
     * @type {SearchFormDepartures}
     */
    this.departures = new SearchFormDepartures();

    /**
     * The periods
     *
     * @type {SearchFormPeriods}
     */
    this.periods = new SearchFormPeriods();

    /**
     * Populate the object
     */
    this.populate(panelObj);

  };

  // Add instance methods
  SearchForm.prototype = /** @lends SearchForm.prototype */ {

    /**
     * Populate the object
     *
     * @param panelObj
     * @returns {SearchForm}
     */
    populate: function (panelObj) {

      panelObj = panelObj || {};

      /**
       * Tabs
       *
       * @type {Array}
       */
      this.tabs.populate(panelObj.tabs || []);

      /**
       * The departures
       *
       * @type {Object}
       */
      this.departures.populate(panelObj.departures || {});

      /**
       * The periods
       *
       * @type {Object}
       */
      this.periods.populate(panelObj.periods || {});

      /**
       * The the range
       *
       * @type {Object}
       */
      this.periods.populateRange(panelObj.range || {});

      /**
       * Change the loaded state
       */
      if (this.tabs.isLoaded() && this.departures.loaded && this.periods.loaded) {
        this.loaded = true;
      }

      return this;
    },

    /**
     * Check if panel is loaded
     *
     * @returns {Boolean}
     */
    isLoaded: function () {
      return this.loaded;
    },

    /**
     * Get the departures
     *
     * @returns {SearchFormDepartures}
     */
    getDepartures: function () {
      return this.departures;
    },

    /**
     * Get the periods
     *
     * @returns {SearchFormPeriods}
     */
    getPeriods: function () {
      return this.periods;
    },

    /**
     * Get the destinations
     *
     * @returns {SearchFormTabs}
     */
    getTabs: function () {
      return this.tabs;
    }

  };

  SearchForm.prototype.constructor = SearchForm;

  return SearchForm;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/SearchFormDepartures.js
angular.module('searchForm.package')

/**
 * @name        SearchFormDepartures
 * @namespace   pkg
 * @description packages search panel
 */
.factory('pkg.SearchFormDepartures',
['pkg.Departure',
function SearchFormDeparturesFactory(Departure) {
var postKey = 'departures';

  /**
   * SearchForm constructor
   *
   * @constructor
   * @class SearchFormDepartures
   *
   * @param {Object[]} list
   */
  var SearchFormDepartures = function (list) {

    /**
     * Set the list
     *
     * @type {Array}
     */
    this.list = [];

    /**
     * The loaded state
     *
     * @type {Boolean}
     */
    this.loaded = false;

    /**
     * Populate
     *
     * @type {Array}
     */
    this.populate(list);

    /**
     * Show the list
     *
     * @type {Boolean}
     */
    this.show = false;

    /**
     * Selected items
     *
     * @type {Array}
     */
    this.selected = {};

    /**
     * Disabled items
     *
     * @type {Array}
     */
    this.disabled = {};

    /**
     * Selected item names
     *
     * @type {Array}
     */
    this.selectedInfo = {};

    /**
     * Check is is selected
     *
     * @type {Boolean}
     */
    this.itemsIsSelected = false;

    /**
     * Check if is disabled items
     *
     * @type {Boolean}
     */
    this.itemsIsDisabled = false;

  };

  // Add instance methods
  SearchFormDepartures.prototype = /** @lends SearchFormDepartures.prototype */ {

    /**
     * Populate the object
     *
     * @param list
     * @returns {SearchFormDepartures}
     */
    populate: function (list) {
      if (!_.isArray(list)) list = [];

      this.list = [];

      var i, listItem;

      _.each(list, function (item) {
        var departure = new Departure(item);

        this.list.push(departure);
      }, this);

      this.loaded = !_.isEmpty(this.list);

      return this;
    },

    /**
     * Get the post key
     *
     * @returns {String}
     */
    getPostKey: function () {
      return postKey;
    },

    /**
     * Check if is empty
     *
     * @returns {*}
     */
    isLoaded: function () {
      return this.loaded;
    },

    /**
     * Get the list
     *
     * @returns {Object|Array}
     */
    getList: function () {
      return this.list;
    },

    /**
     * Show the list
     *
     * @param val
     */
    showList: function (val) {
      if (!this.loaded && typeof val != 'undefined') {
        this.show = val;
      }

      return this.show;
    },

    /**
     * Set the selected departures

     * @returns {SearchFormDepartures}
     */
    setSelected: function () {
      _.each(this.list, function (departure) {
        this.manageDeparture(departure);
      }, this);

      return this;
    },

    /**
     * Manage departure
     *
     * @param departure
     * @param filter
     * @returns {SearchFormDepartures}
     */
    manageDeparture: function (departure, filter) {

      filter = typeof filter != 'undefined' ? filter : true;

      if (departure.selected) {
        this.selected[departure.code] = departure;

        this.selectedInfo[departure.code] = departure.title;

        if (typeof this.disabled[departure.code] != 'undefined') {
          delete this.disabled[departure.code];
        }
      } else {
        if (typeof this.selected[departure.code] != 'undefined') {
          delete this.selected[departure.code];
        }

        if (typeof this.selectedInfo[departure.code] != 'undefined') {
          delete this.selectedInfo[departure.code];
        }

        this.disabled[departure.code] = departure;
      }

      this.checkSelected();

      return this;
    },

    /**
     * Manage the destination departures
     *
     * @param selectedDestinationsDepartures
     */
    manageDeparturesByDestinations: function (selectedDestinationsDepartures) {
      _.each(this.list, function (departure) {

        if (_.isEmpty(selectedDestinationsDepartures)) {
          departure.setDisabled(false);
        } else {
          if (typeof selectedDestinationsDepartures[departure.code] == 'undefined') {
            departure.setDisabled(true);
            departure.setSelected(false);
          } else {
            departure.setDisabled(!selectedDestinationsDepartures[departure.code]);

            if (departure.disabled) {
              departure.setSelected(false);
            }
          }
        }

        this.manageDeparture(departure);

      }, this);
    },

    /**
     * Get the selected departures
     *
     * @returns {*}
     */
    getSelected: function () {
      return this.selected;
    },

    /**
     * Get the disabled departures
     *
     * @returns {*}
     */
    getDisabled: function () {
      return this.disabled;
    },

    /**
     * Check the selected departures
     *
     * @returns {Boolean}
     */
    checkSelected: function () {
      this.itemsIsSelected = _.keys(this.selected).length > 0;
      this.itemsIsDisabled = _.keys(this.disabled).length > 0;

      return this.itemsIsSelected;
    },

    /**
     * Check if departures is selected
     *
     * @returns {Boolean|*}
     */
    isSelected: function () {
      return this.itemsIsSelected;
    },

    /**
     * Check if is disabled departures
     *
     * @returns {Boolean}
     */
    isItemsDisabled: function () {
      return this.itemsIsDisabled;
    },

    /**
     * Get the selected departures info
     *
     * @param defaultValue
     * @returns {Array}
     */
    getSelectedInfo: function (defaultValue) {
      return _.values(this.selectedInfo).sort().join(', ');
    }

  };

  SearchFormDepartures.prototype.constructor = SearchFormDepartures;

  return SearchFormDepartures;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/SearchFormPeriods.js
angular.module('searchForm.package')

/**
 * @name        SearchFormPeriods
 * @namespace   pkg
 * @description packages search panel
 */
.factory('pkg.SearchFormPeriods',
['$filter', 'goo.PackageAnalytics',
function SearchFormPeriodsFactory($filter, PackageAnalytics) {
var postKey = 'periods';

  /**
   * SearchForm constructor
   *
   * @constructor
   * @class SearchFormPeriods
   *
   * @param {Object[]} list
   */
  var SearchFormPeriods = function (list) {

    /**
     * Set the list
     *
     * @type {Array}
     */
    this.list = [];

    /**
     * The range
     *
     * @type {{start: string, end: string}}
     */
    this.range = {
      start: '',
      end: ''
    };

    /**
     * Active section
     *
     * @type {{period: boolean, range: boolean}}
     */
    this.periodToogle = {
      period: false,
      range: false
    };

    /**
     * The loaded state
     *
     * @type {Boolean}
     */
    this.loaded = false;

    var
      startDate,
      endDate,
      minDays = 2;

    startDate = new Date();
    startDate.setDate(startDate.getDate() + 1);
    endDate = angular.copy(startDate);
    endDate.setDate(endDate.getDate() + minDays);

    this.range.start    = angular.copy(startDate);
    this.range.end      = angular.copy(endDate);

    this.range.minDate        = moment(startDate);
    this.range.maxDate        = moment(startDate).add(329, 'd'); //+329 days, like on the production
    this.range.minDays = minDays;

    /**
     * Populate
     *
     * @type {Array}
     */
    this.populate(list);

  };

  // Add instance methods
  SearchFormPeriods.prototype = /** @lends SearchFormPeriods.prototype */ {

    /**
     * Populate the object
     *
     * @param list
     * @returns {SearchFormPeriods}
     */
    populate: function (list) {

      if (!_.isArray(list)) list = [];

      this.list = [];

      _.each(list, function (item) {
        this.list.push({
          name: item.name,
          date: item.key,
          selected: item.selected
        });
      }, this);

      this.loaded = this.list.length > 0;

      if(this.loaded){
        this.setPeriodToggle();
      }

      return this;
    },

    /**
     * Populate the range
     *
     * @param range
     * @returns {SearchFormPeriods}
     */
    populateRange: function (range) {

      /**
       * Set the range
       */
      if (!_.isEmpty(range) && !_.isEmpty(range.start) && !_.isEmpty(range.end)) {

        this.range.start = new Date(range.start);
        this.range.end = new Date(range.end);
        this.setRangeToggle();

        this.loaded = true;
      }

      return this;
    },

    /**
     * Get the post key
     *
     * @returns {String}
     */
    getPostKey: function () {
      return postKey;
    },

    /**
     * Check if is empty
     *
     * @returns {*}
     */
    isLoaded: function () {
      return this.loaded;
    },

    /**
     * Get the list
     *
     * @returns {Object|Array}
     */
    getList: function () {
      return this.list;
    },

    /**
     * toggle period
     */
    setPeriodToggle: function () {
      this.periodToogle.period  = this.isPeriodsSelected();
      this.periodToogle.range   = this.periodToogle.range ? !this.periodToogle.period : this.periodToogle.range;
      if (this.periodToogle.period) {
        this.enabledAll();
      }
    },

    /**
     *  toggle range
     *
     */
    setRangeToggle: function () {
      this.periodToogle.range   = true;
      this.periodToogle.period  = false;
      this.disabledAll();
    },

    /**
     * check if period is active
     * @returns {Boolean}
     */
    isPeriodActive: function () {
      return this.periodToogle.period;
    },

    /**
     * Check if range is active
     * @returns {Boolean}
     */
    isRangeActive: function () {
      return this.periodToogle.range;
    },

    /**
     * Set the range
     *
     * @param range
     * @returns {SearchFormPeriods}
     */
    setRange: function (range) {
      this.range = range;

      return this;
    },

    /**
     * Get the range
     *
     * @returns {{start: string, end: string}}
     */
    getRange: function () {
      return this.range;
    },

    /**
     * if data is set
     * @returns {Boolean}
     */
    hasDataForm: function () {
      return this.isRangeActive() || this.isPeriodActive() || this.isPeriodsSelected();
    },

    /**
     * Format the date
     *
     * @param date
     * @returns {Number}
     */
    formatDate: function (date, format) {
      format = typeof format != 'undefined' ? format : 'yyyy-MM-dd';

      return $filter('date')(date, format);
    },

    /**
     * Get the selected departures
     *
     * @returns {*}
     */
    getSelectedPeriods: function () {
      var selected = [];
      _.each(this.list, function (item) {
        if (item.selected) {
          selected.push(item);
        }
      }, this);

      return selected;
    },

    /**
     * Get the disabled departures
     *
     * @returns {*}
     */
    getDisabledPeriods: function () {
      var selected = [];
      _.each(this.list, function (item) {
        if (!item.selected) {
          selected.push(item);
        }
      }, this);

      return selected;
    },

    /**
     * Get selected flag
     *
     * @param {Object} month
     * @returns {Boolean}
     */
    isMonthSelected: function (month) {
      return month.selected;
    },

    /**
     * Set selected flag to true
     *
     * @param {Object} month
     */
    selectMonth: function (month) {
      month.selected = true;
    },

    /**
     * Set selected flag to false
     *
     * @param {Object} month
     */
    deselectMonth: function (month) {
      month.selected = false;
    },

    /**
     * Check if periods is visible
     *
     * @returns {Boolean|*}
     */
    isPeriodsSelected: function () {
      return this.hasSelected();
    },

    /**
     * Check if all the months are selected
     *
     * @returns {Boolean}
     */
    allSelected: function () {
      return _.every(this.list, this.isMonthSelected);
    },

    /**
     * Check if there is at least a month selected
     *
     * @returns {Boolean}
     */
    hasSelected: function () {
      return _.some(this.list, this.isMonthSelected);
    },

    /**
     * Select all months
     */
    selectAll: function () {
      _.each(this.list, this.selectMonth);
      PackageAnalytics.eventPeriodAllMonth();
    },

    /**
     * disabled months
     */
    disabledMonths: function (month) {
      month.disabled = true;
    },

    /**
     * check if month is disabled
     * @param month
     * @returns {Boolean}
     */
    isDisabled: function (month) {
      return month.disabled;
    },

    /**
     * check if months are disabled
     * @returns {Boolean}
     */
    isMonthsDisabled: function () {
      return _.some(this.list, this.isDisabled);
    },

    /**
     * disabled months
     */
    disabledAll: function () {
      _.each(this.list, this.disabledMonths);
    },

    /**
     * enabled month
     * @param month
     */
    enabledMonths: function (month) {
      month.disabled = false;
    },

    /**
     * enabled all monhts
     */
    enabledAll: function () {
      _.each(this.list, this.enabledMonths);
    },

    /**
     * Deselect all months
     */
    deselectAll: function () {
      _.each(this.list, this.deselectMonth);
    },

    /**
     * Check if range was selected
     *
     * @returns {*}
     */
    isRangeSelected: function () {
      return this.range.start && this.range.end ? true : false;
    },

    /**
     * Check if periods is active and selected
     *
     * @returns {Boolean|*}
     */
    isPeriodsActiveAndSelected: function () {
      return this.isPeriodActive() && this.isPeriodsSelected() ? true : false;
    },

    /**
     * Check if range tab is active and selected
     *
     * @returns {*}
     */
    isRangeActiveAndSelected: function () {
      return this.isRangeActive() && this.isRangeSelected() ? true : false;
    }

  };

  SearchFormPeriods.prototype.constructor = SearchFormPeriods;

  return SearchFormPeriods;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/SearchFormTabDestinations.js
angular.module('searchForm.package')

/**
 * @name        SearchFormTabDestinations
 * @namespace   pkg
 * @description packages search panel tab
 */
.factory('pkg.SearchFormTabDestinations',
['$filter', 'pkg.Destination', 'appConfig',
function SearchFormTabDestinationsFactory($filter, Destination, AppConfig) {
/**
   * AngularJS translate filter
   *
   * @type {Function}
   */
  var translate = $filter('translate');

  /**
   * SearchFormTabDestinations constructor
   *
   * @constructor
   * @class SearchFormTabDestinations
   *
   * @param {Object[]} tabObj
   */
  var SearchFormTabDestinations = function (tabObj) {

    tabObj = tabObj || {};

    /**
     * The default settings
     *
     * @type {{columns: number, layout: string}}
     */
    this.default = {
      columns: 3,
      layout: 'list'
    };

    /**
     * The lang prefix
     *
     * @type {String}
     */
    this.langPrefix = 'LANGM_JS_PACKAGES_SEARCH_PANEL';

    /**
     * Active
     *
     * @type {Number}
     */
    this.active = tabObj.active || false;

    /**
     * Id
     *
     * @type {Number}
     */
    this.id = tabObj.id || 0;

    /**
     * Active page
     *
     * @type {String}
     */
    this.activePage = tabObj.activePage || '';

    /**
     * The tab name
     *
     * @type {String}
     */
    this.name = tabObj.name || '';

    /**
     * Count the destinations
     *
     * @type {Number}
     */
    this.countDestinations = tabObj.count || 0;

    /**
     * Count the popular destinations
     *
     * @type {number}
     */
    this.countPopularDestinations = tabObj.countPopular || 0;

    /**
     * The layout type
     *
     * @type {String}
     */
    this.layout = tabObj.layout || this.default.layout;

    /**
     * The tab columns
     *
     * @type {Number}
     */
    this.columns = tabObj.columns || this.default.columns;

    /**
     * The destinations number
     *
     * @type {Number}
     */
    this.countDestinations = tabObj.count || 0;

    /**
     * The popular destinations number
     *
     * @type {Number}
     */
    this.countPopularDestinations = tabObj.countPopular || 0;

    /**
     * The array of Destinations
     *
     * @type {Destination[]}
     */
    this.destinations = [];

    /**
     * Set the destinations
     */
    this.setDestinations(tabObj.destinations || []);

    /**
     * Tab destinations
     *
     * @type {Object}
     */
    this.tabDestinations = {
      popular: {columns: [], items: {}, sorted: false, show: false},
      enabledDepartures: {columns: [], items: {}, sorted: false, show: false},
      disabledDepartures: {columns: [], items: {}, sorted: false, show: false}
    };

    /**
     * Selected destinations
     *
     * @type {Array}
     */
    this.selectedDestinations = [];

    this.columnsNumber = [0, 1, 2];
    this.bootstrapColumns = 4;
    this.setColumnsNumber();

  };

  // Add instance methods
  SearchFormTabDestinations.prototype = /** @lends SearchFormTabDestinations.prototype */ {

    /**
     * Set the columns number for mobile
     *
     * @returns {SearchFormTabDestinations}
     */
    setColumnsNumber: function () {
      if (AppConfig.isTablet()) {
        this.columnsNumber = [0, 1];
      } else if (AppConfig.isMobile()) {
        this.columnsNumber = [0];
      } else {
        this.columnsNumber = [0, 1, 2];
      }

      this.bootstrapColumns = 12 / this.columnsNumber.length;

      return this;
    },

    /**
     * Get the tab destinations
     *
     * @returns {Object}
     */
    getTabDestinations: function () {
      return this.tabDestinations;
    },

    /**
     * Get the popular group
     *
     * @returns {*}
     */
    getTabDestinationsPopularGroup: function () {
      return this.tabDestinations.popular;
    },

    /**
     * Get the enables departures group
     *
     * @returns {*}
     */
    getTabDestinationsEnabledDeparturesGroup: function () {
      return this.tabDestinations.enabledDepartures;
    },

    /**
     * Get the disabled departures group
     *
     * @returns {*}
     */
    getTabDestinationsDisabledDeparturesGroup: function () {
      return this.tabDestinations.disabledDepartures;
    },

    /**
     * Set the tab destinations
     *
     * @param destinations
     * @returns {SearchFormTabDestinations}
     */
    setDestinations: function (destinations) {
      _.each(destinations, function (destination) {
        var destinationObj = new Destination(destination);

        this.destinations.push(destinationObj);
      }, this);

      return this;
    },

    /**
     * Set active tab
     *
     * @param active
     * @returns {SearchFormTabDestinations}
     */
    setActive: function (active) {
      this.active = active;

      return this;
    },

    /**
     * Check if is active
     *
     * @returns {Array}
     */
    isActive: function () {
      return this.active;
    },

    /**
     * Get the id
     *
     * @returns {Array}
     */
    getId: function () {
      return this.id;
    },

    /**
     * Get the active page
     *
     * @returns {String}
     */
    getActivePage: function () {
      return this.activePage;
    },

    /**
     * Get the name
     *
     * @returns {Object}
     */
    getName: function () {
      var lang = this.langPrefix + '_TAB_' + this.id + '_NAME';

      //return this.name;
      return translate(lang, {});
    },

    /**
     * Get the destinations count
     *
     * @param popular
     * @returns {Object|*|Number}
     */
    getCount: function (popular) {
      popular = typeof popular != 'undefined' ? popular : false;

      if (popular) {
        return this.countPopularDestinations;
      } else {
        return this.countDestinations;
      }
    },

    /**
     * Get the nights info
     *
     * @returns {*}
     */
    getNightsInfo: function () {
      var lang = this.langPrefix + '_TAB_' + this.id + '_NIGHTS';

      return translate(lang, {});
    },

    /**
     * Get the tab info
     */
    getInfo: function (popular, content) {
      popular = typeof popular != 'undefined' ? popular : false;
      content = typeof content != 'undefined' ? content : false;

      var lang = this.langPrefix + '_TAB_' + this.id;

      if (popular) {
        lang += '_POPULAR';
      }

      if (content) {
        lang += '_CONTENT';
      }

      lang += '_INFO';

      var args = {destinations: this.getCount(popular), nights: this.getNightsInfo()};

      return translate(lang, args);
    },

    /**
     * Get the layout
     *
     * @returns {Object}
     */
    getLayout: function () {
      return this.layout;
    },

    /**
     * Get the tab columns
     *
     * @returns {Number}
     */
    getColumns: function () {
      return this.columns;
    },

    /**
     * Get the countPopularDestinations
     *
     * @returns {Boolean}
     */
    showPopularDestinations: function () {
      return this.countPopularDestinations > 0;
    },

    /**
     * Get the destinations
     *
     * @returns {Array<Destination>}
     */
    getDestinations: function () {
      return this.destinations;
    }
  };

  SearchFormTabDestinations.prototype.constructor = SearchFormTabDestinations;

  return SearchFormTabDestinations;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/models/SearchFormTabs.js
angular.module('searchForm.package')

/**
 * @name        SearchFormTabs
 * @namespace   pkg
 * @description packages search panel tab
 */
.factory('pkg.SearchFormTabs',
['pkg.SearchFormTabDestinations',
function SearchFormTabsFactory(SearchFormTabDestinations) {
var postKey = 'destinations';

  /**
   * SearchFormTabs constructor
   *
   * @constructor
   * @class SearchFormTabs
   */
  var SearchFormTabs = function (list) {

    /**
     * Set the list
     *
     * @type {SearchFormTabDestinations[]}
     */
    this.list = [];

    /**
     * Ng options tabs
     *
     * @type {Object}
     */
    this.ngOptions = {
      data: [],
      selectedOption: {id: 0, name: ''}
    };

    /**
     * The loaded state
     *
     * @type {Boolean}
     */
    this.loaded = false;

    /**
     * Show the list
     *
     * @type {Boolean}
     */
    this.show = false;

    /**
     * Active tab
     */
    this.activeTabId = 0;

    /**
     * The selected destinations
     *
     * @type {Object}
     */
    this.selectedDestinations = {};

    /**
     * The selected departures from destinations
     *
     * @type {Object}
     */
    this.selectedDepartures = {};

    /**
     * The selected tab destinations
     *
     * @type {Object}
     */
    this.selectedTabDestinations = {};

    /**
     * The selected destinations names
     *
     * @type {Object}
     */
    this.selectedDestinationsInfo = {};

    /**
     * The destinations tab names
     *
     * @type {Object}
     */
    this.destinationsSearchList = {};

    /**
     * Check is is selected
     *
     * @type {Boolean}
     */
    this.itemsIsSelected = false;

    /**
     * Populate
     *
     * @type {Array}
     */
    this.populate(list);

  };

  // Add instance methods
  SearchFormTabs.prototype = /** @lends SearchFormTabs.prototype */ {

    /**
     * Populate the object
     *
     * @param list
     * @returns {SearchFormTabs}
     */
    populate: function (list) {
      if (!_.isArray(list)) list = [];

      var active = true;

      _.each(list, function (tab) {
        var tabObj = new SearchFormTabDestinations(tab);
        tabObj.setActive(active);

        if (tabObj.isActive()) {
          this.activeTabId = tabObj.getId();
        }

        active = false;

        // Build ng-options
        this.addNgOption(tabObj)
            .setNgSelectedOption(tabObj);

        this.list.push(tabObj);
      }, this);

      this.loaded = !_.isEmpty(this.list);

      this.getActiveTabId();

      return this;
    },

    /**
     * Add option for ng-options
     *
     * @param tab
     * @returns {SearchFormTabs}
     */
    addNgOption: function(tab){
      this.ngOptions.data.push({id: tab.getId(), name: tab.getName()});

      return this;
    },

    /**
     * Set the selected option for ng-options
     *
     * @param tab
     * @returns {SearchFormTabs}
     */
    setNgSelectedOption: function(tab){
      if (tab.isActive()) {
        this.ngOptions.selectedOption.id    = tab.getId();
        this.ngOptions.selectedOption.name  = tab.getName();
      }

      return this;
    },

    /**
     * Get the post key
     *
     * @returns {String}
     */
    getPostKey: function () {
      return postKey;
    },

    /**
     * Set the active tab by id
     *
     * @param {Number} id
     * @returns {SearchFormTabs}
     */
    setActiveTab: function (id) {
      _.each(this.list, function (tab) {
        tab.setActive(tab.id == id);

        // Set ng-options
        this.setNgSelectedOption(tab);
      }, this);

      return this;
    },

    /**
     * Set the active tab by product and page type
     *
     * @param page
     * @param pageType
     */
    setActiveTabByPageType: function (product, pageType) {
      var pageTabId = this.list[0].id;

      if (pageType !== 'search') {
        _.each(this.list, function (tab) {
          if (tab.activePage === product) {
            pageTabId = tab.id;
          }
        }, this);
      }

      if (pageTabId) {
        this.setActiveTab(pageTabId);
      }
    },

    /**
     * Get the active tab id
     *
     * @returns {Number}
     */
    getActiveTabId: function () {
      _.each(this.list, function (tab) {
        if (tab.active && this.activeTabId != tab.id) {
          this.activeTabId = tab.id;
        }
      }, this);

      return this.activeTabId;
    },

    /**
     * Return TRUE if the list of cities is empty
     */
    isLoaded: function () {
      return this.loaded;
    },

    /**
     * Get the list
     *
     * @returns {Array}
     */
    getList: function () {
      return this.list;
    },

    /**
     * Show the list
     *
     * @param val
     */
    showList: function (val) {
      if (!this.loaded && typeof val != 'undefined') {
        this.show = val;
      }

      return this.show;
    },

    /**
     * Set the selected destinations
     *
     * @returns {SearchFormService}
     */
    setSelectedDestinations: function () {

      this.selectedDestinations = {};
      this.selectedDestinationsInfo = {};
      this.destinationsSearchList = {};

      _.each(this.list, function (tab) {
        _.each(tab.destinations, function (destination) {
          if (!destination.allowSearchCountry) {
            this.initSelectedTabDestination(tab.id, destination);
          }

          if (destination.children.length) {
            _.each(destination.children, function (child) {
              this.initSelectedTabDestination(tab.id, child);
            }, this);
          }

        }, this);
      }, this);

      return this;
    },

    /**
     * Get the destinations search list
     *
     * @param tabId
     * @returns {Array}
     */
    getDestinationsSearchList: function (tabId) {
      if (typeof tabId == 'undefined') {
        tabId = this.getActiveTabId();
      }

      return this.destinationsSearchList[tabId];
    },

    /**
     * Add tab destination name
     *
     * @param tabId
     * @param destination
     */
    addDestinationSearchList: function (tabId, destination) {

      if (tabId) {
        if (typeof this.destinationsSearchList[tabId] == 'undefined') {
          this.destinationsSearchList[tabId] = [];
        }

        this.destinationsSearchList[tabId].push(destination.getSearchValue());
        //this.destinationsSearchList[tabId][destination.id] = destination.getSearchValue();

        return true;
      }

      return false;
    },

    /**
     * Manage the selected destination
     *
     * @param tabId
     * @param destination
     * @returns {SearchFormService}
     */
    initSelectedTabDestination: function (tabId, destination) {

      var check = false;
      var destinationId = destination.id;

      if (destination.selected) {

        if (typeof this.selectedDestinations[destinationId] == 'undefined') {
          this.selectedDestinations[destinationId] = destination;
          this.selectedDestinationsInfo[destinationId] = destination.title;

          check = true;
        }

        if (tabId) {
          if (typeof this.selectedTabDestinations[tabId] == 'undefined') {
            this.selectedTabDestinations[tabId] = {};
          }

          if (typeof this.selectedTabDestinations[tabId][destinationId] == 'undefined') {
            this.selectedTabDestinations[tabId][destinationId] = destination;
          }
        }
      }

      this.addDestinationSearchList(tabId, destination);

      if (check) {
        this.checkSelectedDestinations();
      }

      return this;
    },

    /**
     * Manage a destination in all tabs
     *
     * @param destination
     * @returns {SearchFormService}
     */
    manageDestinationAllTabs: function (destination) {

      if (destination.allowSearchCountry) {
        _.each(this.list, function (tab) {
          _.each(tab.destinations, function (tabDestination) {
            if (tabDestination.id == destination.id) {

              if (tabDestination.children.length) {
                _.each(tabDestination.children, function (tabChild) {
                  if (!tabChild.disabled) {
                    if (tabChild.id == destination.id) { // Manage child
                      tabChild.setSelected(destination.selected);
                      this.manageDestinationTab(tab.id, tabChild);
                    }
                  }
                }, this);

                tabDestination.setSelected(destination.selected);
                this.manageDestinationTab(tab.id, tabDestination);
              }
            }
          }, this);
        }, this);
      } else if (destination.parentId == 0) {
        this.manageParentAllTabs(destination.parent, destination.parent.children);
      } else {
        this.manageChildAllTabs(destination, destination.parent, destination.parent.children);
      }

      return this;
    },

    /**
     * Manage the selected destination
     *
     * @param tabId
     * @param destination
     * @returns {SearchFormService}
     */
    manageDestinationTab: function (tabId, destination) {
      tabId = typeof tabId != 'undefined' ? tabId : 0;

      var
        action = -1,
        inOtherTabs = false,
        tmpDestination = null;

      // Manage tab first
      if (tabId) {
        if (destination.selected) {
          if (typeof this.selectedTabDestinations[tabId] == 'undefined') {
            this.selectedTabDestinations[tabId] = {};
          }
          this.selectedTabDestinations[tabId][destination.id] = destination;
          action = 1; // add
        } else {
          if (typeof this.selectedTabDestinations[tabId] != 'undefined' && typeof this.selectedTabDestinations[tabId][destination.id] != 'undefined') {
            delete this.selectedTabDestinations[tabId][destination.id];
            action = 0; // delete
          }
        }
      }

      if (action == 1) { // add
        if (typeof this.selectedDestinations[destination.id] == 'undefined') {
          this.selectedDestinations[destination.id] = destination;
          this.selectedDestinationsInfo[destination.id] = destination.title;
        }
      }

      if (action == 0) { // delete
        // Check other tabs
        _.each(this.list, function (tab) {
          if (inOtherTabs === false && tab.id != tabId && typeof this.selectedTabDestinations[tab.id] != 'undefined' && typeof this.selectedTabDestinations[tab.id][destination.id] != 'undefined') {
            inOtherTabs = true;
            tmpDestination = this.selectedTabDestinations[tab.id][destination.id];
          }
        }, this);

        if (typeof this.selectedDestinations[destination.id] != 'undefined') {
          delete this.selectedDestinations[destination.id];
        }

        if (typeof this.selectedDestinationsInfo[destination.id] != 'undefined') {
          delete this.selectedDestinationsInfo[destination.id];
        }

        if (inOtherTabs && tmpDestination) {
          this.selectedDestinations[tmpDestination.id] = tmpDestination;
          this.selectedDestinationsInfo[tmpDestination.id] = tmpDestination.title;
        }
      }

      this.checkSelectedDestinations();

      return this;
    },

    /**
     * Manage the parent destination in all tabs
     *
     * @param parent
     * @param children
     * @returns {SearchFormTabs}
     */
    manageParentAllTabs: function (parent, children) {

      var
        selectedTmp = [],
        selectedChildren = 0,
        activeChildren = 0;

      _.each(children, function (child) {
        selectedTmp[child.id] = parent.isSelected();
      });

      _.each(this.list, function (tab) {
        _.each(tab.destinations, function (tabParentDestination) {
          if (tabParentDestination.id == parent.id) {

            selectedChildren = 0;
            activeChildren = 0;

            if (tabParentDestination.children.length) { // Check children
              _.each(tabParentDestination.children, function (child) {
                if (!child.disabled) {
                  if (typeof selectedTmp[child.id] != 'undefined') { // Check children
                    child.setSelected(selectedTmp[child.id]);
                    this.manageDestinationTab(tab.id, child);
                  }

                  if (child.selected) {
                    selectedChildren++;
                  }

                  activeChildren++;
                }
              }, this);
            }

            // Manage parent
            if (selectedChildren > 0 && activeChildren > 0 && selectedChildren == activeChildren) {
              tabParentDestination.setSelected(true);
            } else {
              tabParentDestination.setSelected(false);
            }
            this.manageDestinationTab(tab.id, tabParentDestination);
          }
        }, this);
      }, this);

      return this;
    },

    /**
     * Manage the parent destination
     *
     * @param tabId
     * @param parent
     * @param children
     * @returns {SearchFormService}
     */
    manageParentTab: function (tabId, parent, children) {
      if (!_.isArray(children)) children = [];

      _.each(children, function (child) {
        if (!child.disabled) {
          child.setSelected(parent.selected);
          this.manageDestinationTab(tabId, child);
        }
      }, this);

      this.manageDestinationTab(tabId, parent);

      return this;
    },

    /**
     * Manage the child destination
     *
     * @param tabId
     * @param parent
     * @param siblings
     * @returns {SearchFormService}
     */
    manageChildTab: function (tabId, parent, siblings) {

      if (!_.isArray(siblings)) siblings = [];

      var countSelected = 0;

      _.each(siblings, function (child) {
        this.manageDestinationTab(tabId, child);
        if (child.selected) countSelected++;
      }, this);

      if (siblings.length && countSelected == siblings.length) {
        parent.setSelected(true);
      } else {
        parent.setSelected(false);
      }

      this.manageDestinationTab(tabId, parent);

      return this;
    },

    /**
     * Manage the child destination in all tabs
     *
     * @param child
     * @param parent
     * @param siblings
     * @returns {SearchFormTabs}
     */
    manageChildAllTabs: function (child, parent, siblings) {

      var
        selectedChildren = 0,
        activeChildren = 0;

      _.each(this.list, function (tab) {
        _.each(tab.destinations, function (tabParentDestination) {

          selectedChildren = 0;
          activeChildren = 0;

          if (tabParentDestination.id == parent.id && tabParentDestination.children.length) {
            _.each(tabParentDestination.children, function (tabChild) {
              if (!tabChild.disabled) {
                if (tabChild.id == child.id) { // Manage child
                  tabChild.setSelected(child.selected);
                  this.manageDestinationTab(tab.id, tabChild);
                }

                if (tabChild.selected) {
                  selectedChildren++;
                }

                activeChildren++;
              }
            }, this);

            // Manage parent
            if (selectedChildren > 0 && activeChildren > 0 && selectedChildren == activeChildren) {
              tabParentDestination.setSelected(true);
            } else {
              tabParentDestination.setSelected(false);
            }
            this.manageDestinationTab(tab.id, tabParentDestination);
          }

        }, this);
      }, this);

      return this;
    },

    /**
     * Clear destination tag
     *
     * @param destination
     * @param event
     * @returns {SearchFormTabs}
     */
    clearDestinationTag: function (destination, event) {
      if (typeof event != 'undefined') {
        event.preventDefault();
        event.stopPropagation();
      }

      _.each(this.selectedTabDestinations, function (destinations, tabId) {
        _.each(destinations, function (tabDestination) {
          if (tabDestination.id == destination.id) {
            // Manage child if allow country search is allowed
            if (tabDestination.allowSearchCountry && tabDestination.children.length) {
              _.each(tabDestination.children, function (child) {
                child.setSelected(false);
                this.manageDestinationTab(tabId, child);
              }, this);
            }

            // Manage tab destiantion
            tabDestination.setSelected(false);
            this.manageDestinationTab(tabId, tabDestination);

            // Parent
            if (tabDestination.parentId) {
              var parent = tabDestination.parent;
              parent.setSelected(false);
              this.manageDestinationTab(tabId, parent);
            }
          }
        }, this);
      }, this);

      return this;
    },

    /**
     * Clear all destinations tags
     *
     * @returns {SearchFormService}
     */
    clearAllDestinationsTags: function (event) {
      event.preventDefault();
      event.stopPropagation();

      _.each(this.getSelectedDestinations(), function (destination) {
        this.clearDestinationTag(destination);
      }, this);

      return this;
    },

    /**
     * Get the selected departures
     *
     * @returns {Object}
     */
    getSelectedDepartures: function () {
      return this.selectedDepartures;
    },

    /**
     * Get the selected destinations
     *
     * @returns {Array}
     */
    getSelectedDestinations: function () {
      return this.selectedDestinations;
    },

    /**
     * Make destinations tags visible
     *
     * @returns {Boolean}
     */
    checkSelectedDestinations: function () {
      this.itemsIsSelected = false;

      _.each(this.selectedDepartures, function (value, code) {
        if (typeof this.selectedDepartures[code] != 'undefined') {
          delete this.selectedDepartures[code];
        }
      }, this);

      _.each(this.selectedDestinations, function (destination) {
        if (destination.showTag()) {
          this.itemsIsSelected = true;

          //return this.itemsIsSelected;
        }

        // Set only the departure from child destinations
        if (destination.parentId || destination.allowSearchCountry) {
          _.each(destination.departures, function (code) {
            this.selectedDepartures[code] = true;
          }, this);
        }
      }, this);

      //this.itemsIsSelected = _.keys(this.selectedDestinations).length > 0;

      return this.itemsIsSelected;
    },

    /**
     * Check if destinations is visible
     *
     * @returns {Boolean|*}
     */
    isDestinationsSelected: function () {
      return this.itemsIsSelected;
    },

    /**
     * Get the selected destinations info
     *
     * @param defaultValue
     * @returns {Array}
     */
    getSelectedDestinationsInfo: function (defaultValue) {
      return _.values(this.selectedDestinationsInfo).sort().join(', ');
    }

  };

  SearchFormTabs.prototype.constructor = SearchFormTabs;

  return SearchFormTabs;
}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/packagesAutoCompleteFilter.js
angular.module('searchForm.package')

/**
 * @name        packagesAutoCompleteFilter
 * @description Search form filter
 */
.filter('packagesAutoCompleteFilter',
[
function () {
return function (input) {
    var out = [];

    _.each(input, function (destination) {
      if (!destination.isDisabled()) {
        out.push(destination);
      }
    }, this);

    return out;
  };

}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/services/SearchFormService.js
angular.module('searchForm.package')

/**
 * @name        SearchFormService
 * @namespace   pkg
 * @description Handles package search panel
 */
.service('pkg.SearchFormService',
['$timeout', 'ApiTools', 'pkg.SearchForm', 'pkg.SearchParamsService', 'pkg.SearchMemoryService',
function SearchFormService($timeout, ApiTools, SearchForm, SearchParamsService, SearchMemoryService) {
var self = this;

  var
    endpoints = {
      getPanel: {url: '/api/packages/searchPanel/get', method: 'POST', respParser: SearchFormParser}
    };

  /**
   * The config
   *
   * @type {Object}
   */
  this.config = {
    tabInfoPosition: 'left'
  };

  /**
   * The loading state
   *
   * @type {Boolean}
   */
  this.loading = false;

  /**
   * Tabs loading
   *
   * @type {Array}
   */
  this.loadingTabDestinations = [];

  /**
   * The search panel
   *
   * @type {SearchForm}
   */
  this.panel = new SearchForm();

  /**
   * Show search panel
   *
   * @type {Boolean}
   */
  this.isSearchPanelVisible = false;

  /**
   * The selected list
   *
   * @type {Object}
   */
  this.selectedList = {};

  /**
   * Package
   *
   * @type {null}
   */
  this.offer = null;

  /**
   * Get the difference
   *
   * @param start
   * @param end
   * @returns {*}
   */
  this.dateDiff = function (start, end) {
    var diff = moment(end).diff(moment(start), 'days');

    return diff;
  };

  /**
   * Populate the config
   *
   * @param panelObj
   * @returns {SearchFormService}
   */
  this.populateConfig = function (panelObj) {
    this.config = angular.extend(this.config, panelObj.config || {});

    return this;
  };

  /**
   * Form status
   *
   * @type {{default: {layout: string, destination: {isOpen: boolean}, dates: {isOpen: boolean}, rooms: {isOpen: boolean}}, navbar: {layout: string, destination: {isOpen: boolean}, dates: {isOpen: boolean}, rooms: {isOpen: boolean}}}}
   */
  this.formStatus = {
    default: {
      layout: 'default',
      isOpen: true,
      departures: { isOpen: false },
      destination: { isOpen: false },
      dates: { isOpen: false }
    },
    navbar: {
      layout: 'navbar',
      isOpen: false,
      departures: { isOpen: false },
      destination: { isOpen: false },
      dates: { isOpen: false }
    }
  };

  /**
   * Toggle the search panel display
   */
  this.toggleSearchPanel = function () {
    this.isSearchPanelVisible = !this.isSearchPanelVisible;
  };

  /**
   * Make search panel visible
   */
  this.displaySearchPanel = function () {
    this.isSearchPanelVisible = true;
  };

  /**
   * Check if panel is loaded
   *
   * @returns {bool}
   */
  this.isLoaded = function () {
    return this.panel.isLoaded();
  };

  /**
   * Check if panel is still loading
   *
   * @returns {Boolean|*}
   */
  this.isLoading = function () {
    return this.loading;
  };

  /**
   * Change the loading state
   *
   * @param loading
   * @returns {SearchFormService}
   */
  this.setLoading = function (loading) {
    this.loading = loading;

    return this;
  };

  /**
   * Load the search panel
   */
  this.loadPanel = function () {
    if (this.isLoading() || this.isLoaded()) {
      return true;
    }

    this.setLoading(true);

    var url = this.getSearchUrl();

    ApiTools.fetch(this, endpoints.getPanel, {url: url}, {});

    return true;
  };

  /**
   * Save the search url
   *
   * @param url
   * @returns {SearchFormService}
   */
  this.saveLocalSearchUrl = function (url) {
    if (url) {
      url = SearchParamsService.cleanUrl(url);
      SearchMemoryService.saveSearchUrl(url);
    }

    return this;
  };

  /**
   * Get the search url
   *
   * @returns {String}
   */
  this.getSearchUrl = function () {
    var
      isSearch = SearchParamsService.isSearchUrl(),
      storedUrl = SearchMemoryService.getSearchUrl();

    if (storedUrl && !isSearch) {
      return storedUrl;
    }

    if (isSearch) {
      return SearchParamsService.getCleanUrl();
    }

    return '';
  };

  /**
   * Get the last search url
   *
   * @param string defaultUrl
   * @returns {String}
   */
  this.getLastSearchUrl = function (defaultUrl) {
    var url = SearchMemoryService.getSearchUrl();

    return url ? url : defaultUrl;
  };

  /**
   * Get the offer search url
   *
   * @param Package offer
   * @param Boolean checkStorage
   * @param String defaultUrl
   * @param {Object} params
   * @returns {string}
   */
  this.getOfferSearchUrl = function (offer, checkStorage, defaultUrl, params) {
    offer = offer || false;
    checkStorage = checkStorage || false;
    defaultUrl = defaultUrl || '#';
    params = params || {};

    var
      url = '',
      requestUrl = offer.searchRequestUrl || '',
      destination,
      searchParams = angular.copy(SearchParamsService);

    searchParams.setPost([]);

    if (!url && offer && requestUrl) {
      searchParams.populateFromUrl(requestUrl);
      url = searchParams.getUrl();
    }

    if (!url && offer) {
      destination = offer.getDestinations().getSecondLevelDestination();

      if (destination && destination !== undefined) {
        searchParams.setPostValue('destinations', [destination.id]);
        url = searchParams.getUrl();
      }
    }

    if (!url && checkStorage) {
      searchParams.populateFromUrl(SearchMemoryService.getSearchUrl());
      url = searchParams.getUrl();
    }

    if (url) {
      if (params.departureDate) {
        searchParams.setPostValue('departureDate', params.departureDate);
      }

      if (params.returnDate) {
        searchParams.setPostValue('returnDate', params.returnDate);
      }

      searchParams.setUrl();
      url = searchParams.getUrl();
    }

    if (!url) {
      url = defaultUrl;
    }

    return url;
  };

  /**
   * Populate from url
   *
   * @param url
   * @param loadMax
   * @returns {SearchFormService}
   */
  this.populateFromUrl = function (url, loadMax) {
    var self = this;

    loadMax = typeof loadMax != 'undefined' ? loadMax : 0;

    if (!this.isLoaded()) {
      if (loadMax < 100) {
        $timeout(function () {
          self.populateFromUrl(url, loadMax + 1);
        }, 500);
      }

      return this;
    }

    var
      cleanUrl = SearchParamsService.cleanUrl(url),
      currentUrl = SearchParamsService.cleanUrl(SearchParamsService.getUrl());

    if (currentUrl != cleanUrl) {
      SearchParamsService.populateFromUrl(url).setUrl();

      if (SearchParamsService.getUrl()) {
        this.populateAndSetSelected();
      }
    }

    return this;
  };

  /**
   * Populate and set the selected departures, periods, range and destinations
   *
   * @returns {SearchFormService}
   */
  this.populateAndSetSelected = function () {

    this
      .populateDepartures()
      .populatePeriods()
      .populateRange()
      .populateDestinations()
      .setSelectedDepartures()
      .setSelectedDestinations();

    return this;
  };

  /**
   * Populate periods and range
   *
   * @returns {SearchFormService}
   */
  this.populatePeriods = function () {
    var periods = SearchParamsService.getPostValue('periods');
    _.each(this.panel.periods.list, function (period) {
      if (_.indexOf(periods, period.date) >= 0) {
        period.selected = true;
      }
    }, this);

    return this;
  };

  /**
   * Populate range
   *
   * @returns {SearchFormService}
   */
  this.populateRange = function () {
    if (SearchParamsService.getPostValue('departureDate') && SearchParamsService.getPostValue('returnDate')) {
      var range = {};
      range.start = SearchParamsService.getPostValue('departureDate');
      range.end = SearchParamsService.getPostValue('returnDate');
      this.panel.periods.populateRange(range);
    }

    return this;
  };

  /**
   * Populate departures
   *
   * @returns {SearchFormService}
   */
  this.populateDepartures = function () {
    var departures = SearchParamsService.getPostValue('departures');
    _.each(this.panel.departures.list, function (departure) {
      if (_.indexOf(departures, departure.code) >= 0) {
        departure.setSelected(true);
      }
    }, this);

    return this;
  };

  /**
   * Populate destinations
   *
   * @returns {SearchFormService}
   */
  this.populateDestinations = function () {
    var destinations = SearchParamsService.getPostValue('destinations');

    if (!_.isEmpty(destinations)) {
      destinations = _.map(destinations, function (num) {
        return parseInt(num);
      });

      _.each(this.panel.tabs.list, function (tab) {
        _.each(tab.getDestinations(), function (destination) {
          if (destination.getChildrenCount()) {
            _.each(destination.getChildren(), function (destinationChild) {
              destinationChild.setSelected(_.indexOf(destinations, destinationChild.getId()) >= 0);
            }, this);
          } else {
            destination.setSelected(_.indexOf(destinations, destination.id) >= 0);
          }
        }, this);
      }, this);
    }

    return this;
  };

  /**
   * Get the tab info position
   *
   * @returns {SearchForm.config.tabInfoPosition|*}
   */
  this.getTabInfoPosition = function () {
    return this.config.tabInfoPosition;
  };

  /**
   * Get the search panel
   *
   * @return {SearchForm}
   */
  this.getPanel = function () {
    return this.panel;
  };

  /**
   * Get the search panel destinations tabs
   *
   * @returns {SearchFormTabs}
   */
  this.getTabs = function () {
    return this.panel.tabs;
  };

  /**
   * Get the search panel departures
   *
   * @returns {SearchFormDepartures}
   */
  this.getDepartures = function () {
    return this.panel.departures;
  };

  /**
   * Get the search panel periods
   *
   * @returns {SearchFormPeriods}
   */
  this.getPeriods = function () {
    return this.panel.periods;
  };

  /**
   * Set the selected destinations
   *
   * @returns {SearchFormService}
   */
  this.setSelectedDestinations = function () {
    this.panel.tabs.setSelectedDestinations();

    return this;
  };

  /**
   * Get the destinations search list
   *
   * @param tabId
   * @returns {Array}
   */
  this.getDestinationsSearchList = function (tabId) {
    return this.panel.tabs.getDestinationsSearchList(tabId);
  };

  /**
   * Manage the selected destination
   *
   * @param tabId
   * @param destination
   * @returns {SearchFormService}
   */
  this.manageDestinationTab = function (tabId, destination) {
    this.panel.tabs.manageDestinationTab(tabId, destination);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Manage the selected destination
   *
   * @param destination
   * @returns {SearchFormService}
   */
  this.manageDestinationAllTabs = function (destination) {
    this.panel.tabs.manageDestinationAllTabs(destination);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Manage the parent destination
   *
   * @param tabId
   * @param parent
   * @param children
   * @returns {SearchFormService}
   */
  this.manageParentTab = function (tabId, parent, children) {
    this.panel.tabs.manageParentTab(tabId, parent, children);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Manage the parent destination
   *
   * @param parent
   * @param children
   * @returns {SearchFormService}
   */
  this.manageParentAllTabs = function (parent, children) {
    this.panel.tabs.manageParentAllTabs(parent, children);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Manage the child destination
   *
   * @param tabId
   * @param parent
   * @param siblings
   * @returns {SearchFormService}
   */
  this.manageChildTab = function (tabId, parent, siblings) {
    this.panel.tabs.manageChildTab(tabId, parent, siblings);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Manage the child destination
   *
   * @param child
   * @param parent
   * @param siblings
   * @returns {SearchFormService}
   */
  this.manageChildAllTabs = function (child, parent, siblings) {
    this.panel.tabs.manageChildAllTabs(child, parent, siblings);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Clear destination tag
   *
   * @param destination
   * @returns {SearchFormService}
   */
  this.clearDestinationTag = function (destination, event) {
    this.panel.tabs.clearDestinationTag(destination, event);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Clear all destinations tags
   *
   * @returns {SearchFormService}
   */
  this.clearAllDestinationsTags = function (event) {
    this.panel.tabs.clearAllDestinationsTags(event);
    this.panel.departures.manageDeparturesByDestinations(this.panel.tabs.selectedDepartures);

    return this;
  };

  /**
   * Get the selected destinations
   *
   * @returns {Array}
   */
  this.getSelectedDestinations = function () {
    return this.panel.tabs.selectedDestinations;
  };

  /**
   * Make destinations tags visible
   *
   * @returns {Boolean}
   */
  this.checkSelectedDestinations = function () {
    return this.panel.tabs.checkSelectedDestinations();
  };

  /**
   * Check if destinations is visible
   *
   * @returns {Boolean|*}
   */
  this.isDestinationsSelected = function () {
    return this.panel.tabs.itemsIsSelected;
  };

  /**
   * Get the selected destinations info
   *
   * @param defaultValue
   * @returns {Array}
   */
  this.getSelectedDestinationsInfo = function (defaultValue) {
    return this.panel.tabs.getSelectedDestinationsInfo(defaultValue);
  };

  /**
   * Set the selected departures
   *
   * @returns {SearchFormService}
   */
  this.setSelectedDepartures = function () {
    this.panel.departures.setSelected();

    return this;
  };

  /**
   * Manage departure
   *
   * @param departure
   * @returns {SearchFormService}
   */
  this.manageDeparture = function (departure, filter) {

    filter = typeof filter != 'undefined' ? filter : true;

    var self = this;

    self.getDepartures().manageDeparture(departure);

    if (filter) {
      self.loadingTabDestinations = [];

      self.filterSelectedDestinations();

      /*$timeout(function () {
       self.filterDestinationsByDepartures();
       }, 500);*/
    }

    return this;
  };

  /**
   * Get the selected departures
   *
   * @returns {*}
   */
  this.getSelectedDepartures = function () {
    return this.panel.departures.selected;
  };

  /**
   * Get the disabled departures
   *
   * @returns {*}
   */
  this.getDisabledDepartures = function () {
    return this.panel.departures.disabled;
  };

  /**
   * Check the selected departures
   *
   * @returns {Boolean}
   */
  this.checkSelectedDepartures = function () {
    return this.panel.departures.checkSelected();
  };

  /**
   * Check if departures is visible
   *
   * @returns {Boolean|*}
   */
  this.isDeparturesSelected = function () {
    return this.panel.departures.itemsIsSelected;
  };

  /**
   * Get the selected list
   *
   * @returns {Object}
   */
  this.getSelectedList = function () {
    this.selectedList = {};

    this.selectedList.destinations = [];
    this.selectedList.departures = [];
    this.selectedList.periods = [];
    this.selectedList.range = {};

    _.each(this.getSelectedDestinations(), function (destination) {
      if (destination.showInSearch()) {
        this.selectedList.destinations.push(destination.id);
      }
    }, this);

    _.each(this.getSelectedDepartures(), function (departure) {
      this.selectedList.departures.push(departure.code);
    }, this);

    _.each(this.panel.periods.getSelectedPeriods(), function (period) {
      this.selectedList.periods.push(period.date);
    }, this);

    this.selectedList.range = this.panel.periods.getRange();

    return this.selectedList;
  };

  /**
   * Filter selected destinations by selected departures
   *
   * @returns {Boolean}
   */
  this.filterSelectedDestinations = function () {

    var selectedDepartures = _.keys(this.getSelectedDepartures()),
      disabledDepartures = _.keys(this.getDisabledDepartures()),
      selectedDestinations = this.getSelectedDestinations(),
      tmpSelected = [],
      destinationDepartures = [];

    if (!_.isEmpty(selectedDepartures)) {
      _.each(selectedDestinations, function (destination) {
        destinationDepartures = destination.getDepartures();
        tmpSelected = _.intersection(destinationDepartures, selectedDepartures);

        if (_.isEmpty(tmpSelected)) {
          destination.setSelected(false);


        }
      }, this);
    }

    this.checkSelectedDestinations();

    return true;
  };

  /**
   * Filter destinations by departures
   *
   * @returns {Boolean}
   */
  this.filterDestinationsByDepartures = function () {
    var tabs = this.panel.tabs.list;

    _.each(tabs, function (tab) {
      this.getTabColumns(tab);
    }, this);

    this.checkSelectedDestinations();

    return true;
  };

  /**
   * Time
   *
   * @param String timerName
   * @param Boolean stop
   */
  this.time = function (timerName, stop) {
    stop = typeof stop != 'undefined' ? stop : true;

    if (stop) {
      console.timeEnd(timerName);
    } else {
      console.time(timerName);
    }
  };

  /**
   * Filter destination
   *
   * @param destination
   * @param filter
   * @returns {Boolean}
   */
  this.filterDestination = function (destination, filter) {

    filter = filter || {};
    filter.popular = filter.popular || false;

    var ok = true;

    if (filter.popular && !this.filterPopular(destination)) {
      ok = false;
    }

    if (this.panel.departures.isSelected() && !this.filterDepartures(destination, filter)) {
      ok = false;
    }

    return ok;
  };

  /**
   * Filter popular destinations
   *
   * @param destination
   * @returns {Boolean}
   */
  this.filterPopular = function (destination) {
    if (!_.isEmpty(destination) && destination.isPopular()) {
      return true;
    }

    return false;
  };

  /**
   * Filter the departures
   *
   * @param {Array} destinations
   * @param {Array} departures
   * @returns {Boolean}
   */
  this.filterDepartures = function (destination, filter) {
    filter = filter || {};

    var i,
      tmpSelected,
      tmpDisabled,
      checked = false,
      destinationDepartures = [];

    if (!_.isEmpty(destination)) {
      destinationDepartures = destination.getDepartures();
      tmpSelected = [];
      tmpDisabled = [];

      if (!_.isEmpty(filter.selectedDepartures)) {
        tmpSelected = _.intersection(destinationDepartures, filter.selectedDepartures);
      }

      if (!_.isEmpty(filter.disabledDepartures)) {
        tmpDisabled = _.intersection(destinationDepartures, filter.disabledDepartures);

        if (_.isEmpty(tmpSelected) && !_.isEmpty(tmpDisabled)) {
          checked = true;
        }
      } else {
        if (!_.isEmpty(tmpSelected)) {
          checked = true;
        }
      }
    }

    return checked;
  };

  /**
   * Get the tab columns
   */
  this.getTabColumns = function (tab) {

    tab = tab || {};

    if (_.indexOf(this.loadingTabDestinations, tab.getId()) >= 0) {
      return tab.getTabDestinations();
    }

    this.loadingTabDestinations.push(tab.getId());

    var args = {
      selectedDepartures: _.keys(this.getSelectedDepartures()),
      disabledDepartures: _.keys(this.getDisabledDepartures())
    };

    var filters = {};

    if (tab.showPopularDestinations()) {
      filters.popular = {
        tabId: tab.getId(),
        columns: tab.getColumns(),
        layout: 'list',
        showDisabled: false,
        popular: true,
        selectedDepartures: args.selectedDepartures,
        disabledDepartures: []
      };
    }

    filters.enabledDepartures = {
      tabId: tab.getId(),
      columns: tab.getColumns(),
      layout: tab.getLayout(),
      showDisabled: false,
      popular: false,
      selectedDepartures: args.selectedDepartures,
      disabledDepartures: []
    };

    if (this.panel.departures.isSelected() && this.panel.departures.isItemsDisabled()) {
      filters.disabledDepartures = {
        tabId: tab.getId(),
        columns: tab.getColumns(),
        layout: tab.getLayout(),
        showDisabled: true,
        popular: false,
        selectedDepartures: args.selectedDepartures,
        disabledDepartures: args.disabledDepartures
      };
    }

    this.formatTabDestinations(tab, filters);

    return tab.getTabDestinations();
  };

  /**
   * Format the tab destinations
   */
  this.formatTabDestinations = function (tab, filters) {

    var
      destinations = tab.getDestinations(),
      response = tab.getTabDestinations(),
      tmpResponse = {},
      columnsNr = tab.columnsNumber.length,
      filterKeys = _.keys(filters),
      columnsCounter = {},
      k = 0,
      parentId,
      countChildren = 0,
      countActiveChildren = 0,
      children = [],
      child = [],
      slug,
      parentSlug,
      childSlug,
      sortedItems = [];

    // Reset the items
    _.each(filterKeys, function (filterKey) {
      response[filterKey].show = false;
      _.each(response[filterKey].items, function (item) {
        item.active = 0;
        item.column = -1;
      }, this);

      columnsCounter[filterKey] = [];
      for (var i = 0; i < columnsNr; i++) {
        columnsCounter[filterKey][i] = 0;
      }
    }, this);

    _.each(this.getDestinationsSearchList(tab.getId()), function (destination) {
      destination.setDisabled(false);
    }, this);

    _.each(destinations, function (destination, key) {

      parentId = destination.getParentId();
      countChildren = destination.getChildrenCount();

      if (parentId == 0 && countChildren > 0) {

        if (countChildren == 1) {

          child = destination.getFirstChild();

          if (!_.isEmpty(child)) {
            //slug = child.getSlug() + '-' + destination.getSlug();
            slug = child.getSortedSlug();

            _.each(filters, function (filter, filterKey) {
              if (typeof response[filterKey].items[slug] == 'undefined') {
                response[filterKey].items[slug] = {};
              }
              response[filterKey].items[slug].showDisabled = filter.showDisabled;
              response[filterKey].items[slug].flagName = filter.showDisabled ? '' : 'selected';
              response[filterKey].items[slug].active = 0;
              response[filterKey].items[slug].column = -1;
              response[filterKey].items[slug].slug = slug;
              response[filterKey].items[slug].popular = child.getPopular();
              response[filterKey].items[slug].layout = 'list';
              response[filterKey].items[slug].parent = destination;
              response[filterKey].items[slug].children = [];
              response[filterKey].items[slug].activeChildren = {};
              response[filterKey].items[slug].activeChildrenNumber = 0;
              response[filterKey].items[slug].child = child;

              if (this.filterDestination(child, filter)) {
                response[filterKey].items[slug].active = 1;

                if (filter.showDisabled) {
                  child.setSelected(false).setDisabled(true);
                  destination.setSelected(false).setDisabled(true);
                }
              }

            }, this);
          }

        } else {

          // Set the destinations
          parentSlug = destination.getSortedSlug();

          _.each(filters, function (filter, filterKey) {
            if (typeof response[filterKey].items[parentSlug] == 'undefined') {
              response[filterKey].items[parentSlug] = {};
            }
            response[filterKey].items[parentSlug].showDisabled = filter.showDisabled;
            response[filterKey].items[parentSlug].flagName = filter.showDisabled ? '' : 'selected';
            response[filterKey].items[parentSlug].active = 0;
            response[filterKey].items[parentSlug].column = -1;
            response[filterKey].items[parentSlug].layout = filter.layout;
            response[filterKey].items[parentSlug].activeChildrenNumber = 0;
            response[filterKey].items[parentSlug].popular = destination.getPopular();
            if (typeof response[filterKey].items[parentSlug].slug == 'undefined') {
              response[filterKey].items[parentSlug].slug = parentSlug;
            }
            if (typeof response[filterKey].items[parentSlug].parent == 'undefined') {
              response[filterKey].items[parentSlug].parent = destination;
            }
            if (typeof response[filterKey].items[parentSlug].children == 'undefined') {
              response[filterKey].items[parentSlug].children = [];
            }
            if (typeof response[filterKey].items[parentSlug].activeChildren == 'undefined') {
              response[filterKey].items[parentSlug].activeChildren = {};
            }
            if (typeof response[filterKey].items[parentSlug].child == 'undefined') {
              response[filterKey].items[parentSlug].child = [];
            }

            countActiveChildren = 0;
            _.each(destination.getChildren(), function (child, childKey) {

              // Set the children
              childSlug = child.getSortedSlug();

              if (typeof response[filterKey].items == 'undefined') {
                response[filterKey].items = {};
              }
              if (typeof response[filterKey].items[childSlug] == 'undefined') {
                response[filterKey].items[childSlug] = {};
              }
              response[filterKey].items[childSlug].showDisabled = filter.showDisabled;
              response[filterKey].items[childSlug].flagName = filter.showDisabled ? '' : 'selected';
              response[filterKey].items[childSlug].active = 0;
              response[filterKey].items[childSlug].column = -1;
              response[filterKey].items[childSlug].activeChildrenNumber = 0;
              response[filterKey].items[childSlug].popular = child.getPopular();
              response[filterKey].items[childSlug].layout = 'list';

              if (typeof response[filterKey].items[childSlug].slug == 'undefined') {
                response[filterKey].items[childSlug].slug = childSlug;
              }
              if (typeof response[filterKey].items[childSlug].layout == 'undefined') {
                response[filterKey].items[childSlug].layout = 'list';
              }
              if (typeof response[filterKey].items[childSlug].parent == 'undefined') {
                response[filterKey].items[childSlug].parent = destination;
              }
              if (typeof response[filterKey].items[childSlug].children == 'undefined') {
                response[filterKey].items[childSlug].children = [];
              }
              if (typeof response[filterKey].items[childSlug].activeChildren == 'undefined') {
                response[filterKey].items[childSlug].activeChildren = {};
              }
              if (typeof response[filterKey].items[childSlug].child == 'undefined') {
                response[filterKey].items[childSlug].child = child;
              }

              if (typeof response[filterKey].items[parentSlug].activeChildren[child.getId()] == 'undefined') {
                response[filterKey].items[parentSlug].children.push(child);
              }

              // Set the active children
              response[filterKey].items[parentSlug].activeChildren[child.getId()] = false;

              if (this.filterDestination(child, filter)) {
                response[filterKey].items[parentSlug].activeChildren[child.getId()] = true;
                countActiveChildren++;

                if (filter.showDisabled) {
                  child.setSelected(false).setDisabled(true);
                }
              }

            }, this);

            response[filterKey].items[parentSlug].activeChildrenNumber = countActiveChildren;

            // Check the children
            if (countActiveChildren) {
              if (countActiveChildren == 1) {
                response[filterKey].items[parentSlug].active = 0;

                _.each(response[filterKey].items[parentSlug].children, function (child, childId) {
                  if (response[filterKey].items[parentSlug].activeChildren[child.getId()]) {
                    //childSlug = child.getSlug() + '-' + destination.getSlug();
                    childSlug = child.getSortedSlug();
                    response[filterKey].items[childSlug].active = 1;

                    if (child.isDisabled()) {
                      destination.setSelected(false).setDisabled(true);
                    }
                  }
                }, this);
              } else {
                if (response[filterKey].items[parentSlug].layout == 'tree') {
                  response[filterKey].items[parentSlug].active = 1;
                }

                if (response[filterKey].items[parentSlug].layout == 'list') {

                  var disabledChildren = 0;

                  _.each(response[filterKey].items[parentSlug].children, function (child, childId) {
                    if (response[filterKey].items[parentSlug].activeChildren[child.getId()]) {
                      //childSlug = child.getSlug() + '-' + destination.getSlug();
                      childSlug = child.getSortedSlug();
                      response[filterKey].items[childSlug].active = 1;
                    }

                    if (child.isDisabled()) {
                      disabledChildren++;
                    }
                  }, this);

                  if (disabledChildren >= countActiveChildren) {
                    destination.setSelected(false).setDisabled(true);
                  }
                }
              }
            } else {
              destination.setSelected(false).setDisabled(true);
            }
          }, this);
        }
      }
    }, this);


    _.each(filters, function (filter, filterKey) {

      // Sort the items
      if (response[filterKey].sorted == false) {
        sortedItems = _.toArray(response[filterKey].items);

        if (filter.popular) {
          sortedItems = _.sortBy(sortedItems, 'popular', this);
        } else {
          sortedItems = _.sortBy(sortedItems, 'slug', this);
        }

        response[filterKey].items = {};
        response[filterKey].sorted = true;
        _.each(sortedItems, function (sortedItem) {
          response[filterKey].items[sortedItem.slug] = sortedItem;
        }, this);
      }

      // Set the columns for each items
      _.each(response[filterKey].items, function (item) {
        if (item.active) {
          k = parseInt(_.indexOf(columnsCounter[filterKey], _.min(columnsCounter[filterKey])));
          item.column = k;
          columnsCounter[filterKey][k]++;

          if (item.layout == 'tree') {
            _.each(item.children, function (child) {
              if (item.activeChildren[child.getId()]) {
                columnsCounter[filterKey][k]++;
              }
            }, this);
          }

          if (response[filterKey].show == false) {
            response[filterKey].show = true;
          }
        }
      }, this);

    }, this);

    return response;
  };

  /**
   * Parse search results response
   *
   * @param {Object} response
   * @return {Object}
   */
  function SearchFormParser(response) {
    self.getPanel().populate(response.response);
    self.populateConfig(response.response);

    self.setSelectedDestinations();
    self.setSelectedDepartures();

    /*_.each(self.panel.tabs.list, function (tab) {
     self.getTabColumns(tab);
     }, this);*/

    self.setLoading(false);

    return response.response;
  }

}
]);
;

// Source: ../shared/public_html/assets/js/searchForm/package/services/SearchMemoryService.js
angular.module('searchForm.package')

/**
 * @name        SearchMemoryService
 * @namespace   pkg
 * @description Handles package search
 */
.service('pkg.SearchMemoryService',
['$localStorage',
function SearchMemoryService($localStorage) {
/**
   * The local data
   *
   * @type {Array}
   */
  this.localData = {};
  this.localData.searchUrl = '';

  /**
   * Set the local data
   *
   * @param data
   * @returns {SearchMemoryService}
   */
  this.setLocalData = function (data) {
    $localStorage.pkgLocalData = data || {};

    return this;
  };

  /**
   * Get the local data
   *
   * @returns {*|{}}
   */
  this.getLocalData = function () {
    if (typeof $localStorage.pkgLocalData == 'undefined') {
      $localStorage.pkgLocalData = {};
    }

    return $localStorage.pkgLocalData;
  };

  /**
   * Save local data
   *
   * @param data
   * @returns {SearchMemoryService}
   */
  this.saveLocalData = function () {
    $localStorage.$apply();

    return this;
  };

  /**
   * Save the search url
   *
   * @returns {SearchMemoryService}
   */
  this.saveSearchUrl = function (url) {
    if (typeof url != 'undefined') {
      this.getLocalData().searchUrl = url;
    }

    return this.saveLocalData();
  };

  /**
   * Get the search url
   *
   * @returns {String}
   */
  this.getSearchUrl = function () {
    var localData = this.getLocalData();

    return typeof localData.searchUrl != 'undefined' ? localData.searchUrl : '';
  };

}]);

;

// Source: ../shared/public_html/assets/js/searchForm/package/services/SearchParamsService.js
angular.module('searchForm.package')

/**
 * @name        SearchParamsService
 * @namespace   pkg
 * @description Handles package search requests
 */
.service('pkg.SearchParamsService',
['$location', 'paramTypes',
function SearchParamsService($location, _paramTypes) {
/**
   * The url
   *
   * @type {String}
   */
  this.url = '';

  /**
   * The url prefix
   *
   * @type {string[]}
   */
  this.urlPrefix = ['packages', 'search'];

  /**
   * The url date format
   *
   * @type {String}
   */
  this.urlDateFormat = 'YYYY-MM-DD';

  /**
   * The params
   *
   * @type {Object}
   */
  this.params = {
    destinations: {key: 'from', type: _paramTypes.mk, default: []},
    departures: {key: 'dep', type: _paramTypes.mk, default: []},
    amenities: {key: 'amenity', type: _paramTypes.mk, default: []},
    periods: {key: 'period', type: _paramTypes.mk, default: []},
    departureDate: {key: 'dd', type: _paramTypes.sd, default: ''},
    returnDate: {key: 'rd', type: _paramTypes.sd, default: ''},
    nights: {key: 'nights', type: _paramTypes.mk, default: []},
    stars: {key: 'stars', type: _paramTypes.mk, default: []},
    affiliateId: {key: 'affiliate_id', type: _paramTypes.single, default: ''},
    offerIds: {key: 'offer', type: _paramTypes.mk, default: []},
    offerType: {key: 'type', type: _paramTypes.mk, default: []},
    months: {key: 'months', type: _paramTypes.mv, default: ''},
    save: {key: 'save', type: _paramTypes.single, default: ''},
    noFallback: {key: 'nfb', type: _paramTypes.single, default: ''},
    fakeAmenity: {key: 'fam', type: _paramTypes.single, default: ''},
    searchTab: {key: 'tab', type: '', default: ''},
    providerId: {key: 'pr', type: '', default: ''}
  };

  /**
   * The post
   *
   * @type {Array}
   */
  this.post = [];

  /**
   * Set the post
   *
   * @param post
   * @returns {SearchParamsService}
   */
  this.setPost = function (post) {
    this.post = post;

    return this;
  };

  /**
   * Get the post
   *
   * @returns {Array}
   */
  this.getPost = function () {
    return this.post;
  };

  /**
   * Auto populate
   *
   * @param type
   * @returns {SearchParamsService}
   */
  this.autoPopulate = function (type) {
    this.populateFromUrl($location.path());

    return this;
  };

  /**
   * Populate from url
   *
   * @param url
   * @returns {SearchParamsService}
   */
  this.populateFromUrl = function (url) {

    if (url === undefined || !url) {
      return this;
    }

    var
      urlArray = url.split('/'),
      urlValues = [],
      urlKeys = [],
      tmpValues = [],
      post = [],
      i = 1;

    _.each(urlArray, function (elem) {
      if (elem && _.indexOf(this.urlPrefix, elem) < 0) {
        if (i % 2 == 0) {
          urlValues.push(elem);
        } else {
          urlKeys.push(elem);
        }
        i++;
      }
    }, this);

    _.each(this.params, function (param, name) {
      tmpValues = [];

      _.each(urlKeys, function (paramKey, index) {
        if (paramKey == param.key) {
          tmpValues.push(urlValues[index]);
        }
      }, this);

      if (!_.isEmpty(tmpValues)) {
        switch (param.type) {
          case _paramTypes.mk:
            post[name] = tmpValues;
            break;
          case _paramTypes.mv:
            post[name] = tmpValues.join(',');
            break;
          case _paramTypes.single:
          case _paramTypes.sd:
            post[name] = tmpValues.join('');
            break;
        }
      }
    }, this);

    this.post = post;

    return this;
  };

  /**
   * Get clean url
   *
   * @returns {String}
   */
  this.getCleanUrl = function () {
    return this.cleanUrl($location.path());
  };

  /**
   * Clean the url
   *
   * @param url
   * @returns {String}
   */
  this.cleanUrl = function (url) {
    var cleanUrl = [],
      urlArray = url.split('/');

    _.each(urlArray, function (elem) {
      if (elem && _.indexOf(this.urlPrefix, elem) < 0) {
        cleanUrl.push(elem);
      }
    }, this);

    return cleanUrl.join('/');
  };

  /**
   * Check if is search url
   *
   * @param url
   * @returns {boolean}
   */
  this.isSearchUrl = function (url) {
    url = url !== undefined ? url : $location.path();

    var
      self = this,
      c = 0,
      cleanUrl = _.compact(url.split('/'));

    _.each(self.urlPrefix, function (elem, index) {
      if (cleanUrl[index] !== undefined && cleanUrl[index] == elem) {
        c++;
      }
    }, this);

    return c == self.urlPrefix.length;
  };

  /**
   * Set the url
   *
   * @param url
   * @returns {SearchParamsService}
   */
  this.setUrl = function (url) {
    if (url === undefined) {
      this.composeUrl();
    } else if (url) {
      this.url = url;
    }

    return this;
  };

  /**
   * Get the url params
   *
   * @returns {Array}
   */
  this.getUrl = function () {
    if (_.isEmpty(this.url)) {
      this.setUrl();
    }

    return this.url;
  };

  /**
   * Compose the url
   *
   * @returns {SearchQueryParams}
   */
  this.composeUrl = function () {
    var url = [],
      postUrl = this.getPostUrl();

    if (postUrl) {
      url.push(this.urlPrefix.join('/'));
      url.push(postUrl);

      this.url = url.join('/');
    }

    return this;
  };

  /**
   * Check the post
   *
   * @returns {Boolean}
   */
  this.checkPost = function () {

    if (!_.isEmpty(this.post.destinations)) {
      return true;
    }

    if (!_.isEmpty(this.post.amenities)) {
      return true;
    }

    return false;
  };

  /**
   * Get the url from params
   *
   * @returns {SearchQueryParams}
   */
  this.getPostUrl = function () {
    var url = [];

    _.each(this.params, function (param, name) {

      if (this.post[name] !== undefined) {
        switch (param.type) {
          case _paramTypes.mk:
            if (!_.isEmpty(this.post[name])) {
              _.each(this.post[name], function (value) {
                url.push(param.key, value);
              }, this.post[name]);
            }
            break;
          case _paramTypes.mv:
          case _paramTypes.single:
          case _paramTypes.sd:
            if (this.post[name]) {
              url.push(param.key, this.post[name]);
            }
            break;
        }
      }

    }, this);

    return url.join('/');
  };

  /**
   * Set the param value
   *
   * @param name
   * @param value
   * @returns {SearchParamsService}
   */
  this.setPostValue = function (name, value) {
    if (name !== undefined && this.params[name] !== undefined) {
      var param = this.params[name];

      switch (param.type) {
        case _paramTypes.mk:
          if (value !== undefined) {
            this.post[name] = value;
          } else {
            this.post[name] = this.params[name].default;
          }
          break;
        case _paramTypes.mv:
          if (value !== undefined) {
            this.post[name] = value.join(',');
          } else {
            this.post[name] = this.params[name].default;
          }
          break;
        case _paramTypes.single:
          if (value !== undefined) {
            this.post[name] = value;
          } else {
            this.post[name] = this.params[name].default;
          }
          break;
        case _paramTypes.sd:
          if (value !== undefined) {
            this.post[name] = typeof value == 'string' ? value : moment(value).format(this.urlDateFormat);
          } else {
            this.post[name] = this.params[name].default;
          }
          break;
      }
    }

    return this;
  };

  /**
   * Get the param value
   *
   * @param name
   * @returns {Array|String}
   */
  this.getPostValue = function (name) {
    if (this.params[name] !== undefined) {
      if (name !== undefined && this.post[name] !== undefined) {
        return this.post[name];
      } else {
        return this.params[name].default;
      }
    }

    return '';
  };

  /**
   * Manage post value
   *
   * @param name
   * @param value
   * @returns {SearchParamsService}
   */
  this.managePostValue = function (name, value) {

    if (value !== undefined && name !== undefined && this.params[name] !== undefined) {
      var param = this.params[name],
        values,
        post = this.getPost(),
        i = -1;

      switch (param.type) {
        case _paramTypes.mk:
          if (value) {
            values = post[name] !== undefined ? post[name] : [];
            i = _.indexOf(values, value);

            if (i >= 0) {
              values = _.filter(values, function (elem) {
                return elem != value;
              });
            } else {
              values.push(value);
            }

            if (!_.isEmpty(values)) {
              post[name] = values;
            } else {
              delete post[name];
            }
          }
          break;
        case _paramTypes.mv:
          if (value) {
            values = post[name] !== undefined ? post[name] : '';
            values = values ? values.split(',') : [];
            i = _.indexOf(values, value);

            if (i >= 0) {
              values = _.filter(values, function (elem) {
                return elem != value;
              });
            } else {
              values.push(value);
            }

            if (!_.isEmpty(values)) {
              post[name] = values.join(',');
            } else {
              delete post[name];
            }
          }
          break;
        case _paramTypes.single:
          if (value) {
            post[name] = value;
          }
          break;
        case _paramTypes.sd:
          if (value) {
            this.post[name] = typeof value == 'string' ? value : moment(value).format(this.urlDateFormat);
          }
          break;
      }
    }

    this.setPost(post);

    return this;
  };

  /**
   * Check post value
   *
   * @param name
   * @param value
   * @returns {Boolean}
   */
  this.checkPostValue = function (name, value) {
    if (value !== undefined && name !== undefined && this.params[name] !== undefined && this.post[name] !== undefined) {
      switch (this.params[name].type) {
        case _paramTypes.mk:
          return _.indexOf(this.post[name], value) >= 0;
        case _paramTypes.mv:
          if (!_.isEmpty(this.post[name])) {
            return _.indexOf(this.post[name].split(','), value) >= 0;
          } else {
            return false;
          }
          break;
        case _paramTypes.single:
        case _paramTypes.sd:
          return this.post[name] == value;
      }
    }

    return false;
  };

  /**
   * Manage destinations
   *
   * @param value
   * @returns {SearchParamsService}
   */
  this.manageDestination = function (value) {
    this.managePostValue('destinations', value);
    //console.log('pkgLOG:', 'destinations: ', this);
    return this;
  };

  /**
   * Manage departures
   *
   * @param value
   * @returns {SearchParamsService}
   */
  this.manageDeparture = function (value) {
    this.managePostValue('departures', value);
    //console.log('pkgLOG:', 'departures: ', this);
    return this;
  };

  /**
   * Manage periods
   *
   * @param value
   * @returns {SearchParamsService}
   */
  this.managePeriod = function (value) {
    this.managePostValue('periods', value);
    //console.log('pkgLOG:', 'periods: ', this);
    return this;
  };

}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoExpandFilters.js
angular.module('searchOptions')

/**
 * @name        scoExpandFilters
 * @description
 */
.directive('scoExpandFilters', [
function scoExpandFilters() {
return {
    restrict: 'E',
    replace: true,
    scope: {
      isActive: '=',
      whenToggled: '&'
    },
    templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoExpandFilters'
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilter.js
angular.module('searchOptions')

/**
 * @name        scoFilter
 * @description Search filter
 */
.directive('scoFilter',
[ '$timeout',
function scoFilter($timeout) {
var link = function (scope) {

    /**
     * Reset filters
     *
     * @returns {*}
     */
    scope.resetFilters = function () {
      _.each(scope.model.subfilters, function(filter) {
        filter.reset();
      });

      scope.service.filters.apply();

      scope.closeFilters();
    };

    /**
     * Set the number of subfilters columns
     *
     * @returns {*}
     */
    scope.subfiltersLength = function () {
      return scope.model.subfilters.length;
    };

    /**
     * Toggle filter state
     *
     * @param filter
     */
    scope.toggleFilter = function(filter) {
      var filterStatus = !!filter.opened;

      scope.closeFilters();

      if (!filterStatus) {
        filter.opened = true;

        $timeout(function () { // TODO to fix rzslider to avoid this workaround
          scope.$broadcast('rzSliderForceRender');
        }, 50);

      }
    }

  };

  var templateUrl = function ($element, $attrs) {
    return $attrs.templateUrl || '/tpl/show/jsShared/templates/searchOptions/scoFilter';
  };

  templateUrl.$inject = [
    '$element',
    '$attrs'
  ];

  return {
    restrict: 'E',
    link:link,
    replace: true,
    scope: {
      model: '=?filterModel',
      service: '=',
      closeFilters: '='
    },
    templateUrl: templateUrl
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilterDistance.js
angular.module('searchOptions')

/**
 * @name        scoFilterDistance
 * @description
 */
  .directive('scoFilterDistance',
    ['$timeout',
      function scoFilterDistance($timeout) {
var link = function (scope) {
          scope.dropdownToggled = function (open) {
            open && $timeout(function () {
              scope.$broadcast('rzSliderForceRender');
            }, 50);
          };

          scope.$on('slideEnded', function () {
            scope.$apply(function () {
              scope.model.apply();
            });
          });
        };

        return {
          restrict: 'E',
          scope: {
            model: '=filterModel'
          },
          templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoFilterDistance',
          link: link
        };
      }]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilterMultiple.js
angular.module('searchOptions')

/**
 * @name        scoFilterMultiple
 * @description
 */
  .directive('scoFilterMultiple',
    [
      function scoFilterMultiple() {
var link = function (scope) {

          /**
           * Select filter
           *
           * @returns {*}
           */
           scope.select = function () {
             return scope.model.apply();
          };

        };

        return {
          restrict: 'E',
          link: link,
          scope: {
            model: '=filterModel'
          },
          templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoFilterMultiple'
        };
      }]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilterName.js
angular.module('searchOptions')

/**
 * @name        scoFilterName
 * @description
 */
.directive('scoFilterName',
[
function scoFilterName() {
var link = function (scope) {

    scope.changed = function () {
      scope.model.apply();
    };

    scope.reset = function () {
      if(scope.model.applied === true) {
        scope.model.reset();
        scope.model.apply();
      } else {
        scope.model.reset();
      }
    };

    scope.keypress = function (a) {
      a.which === 13 && scope.changed();
    };

    scope.keyup = function (a) {
      if ((a.which === 8 || a.which === 46) && scope.model.applied === true && scope.model.selection == '') {
        scope.model.reset();
        scope.model.apply();
      }
    };
  };

  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=filterModel'
    },
    templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoFilterName',
    link: link
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilterPrice.js
angular.module('searchOptions')

/**
 * @name        scoFilterPrice
 * @description
 */
  .directive('scoFilterPrice',
    ['$timeout',
      function scoFilterPrice($timeout) {
var link = function (scope, elem, attrs) {

          scope.$on('slideEnded', function () {
            scope.$apply(function () {
              scope.model.apply();
            });
          });
        };

        return {
          restrict: 'E',
          scope: {
            model: '=filterModel'
          },
          templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoFilterPrice',
          link: link
        };
      }]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoFilterStars.js
angular.module('searchOptions')

/**
 * @name        scoFilterStars
 * @description
 */
  .directive('scoFilterStars',
    [
      function scoFilterStars() {
var link = function (scope) {

          scope.nrStars = [];

          /**
           * Return an array for iterating through hotel stars icons
           *
           * @returns {Array}
           */
          scope.nrStars = function (nrStars) {
            return _.range(1, nrStars*1+1);
          };

          /**
           * Select filter
           *
           * @returns {*}
           */
           scope.select = function () {
             return scope.model.apply();
          };

        };

        return {
          restrict: 'E',
          link: link,
          scope: {
            model: '=filterModel'
          },
          templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoFilterStars'
        };
      }]);

;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoSearchOptions.js
angular.module('searchOptions')

/**
 * @name        scoSearchOptions
 * @description Search filter list
 */
.directive('scoSearchOptions',
['$timeout',
function scoSearchOptions($timeout) {
var link = function (scope) {
    scope.isExpanded = true;

    /**
     * Set langs for filter tabs
     */
    scope.tabsTitle = function (tab) {
      return 'LANGM_JS_SCO_FILTERS_TAB_' + tab.toUpperCase();
    };

    /**
     * Toggle search options expanded state
     */
    scope.toggleExpanded = function () {
      scope.isExpanded = !scope.isExpanded;
    };

    /**
     * Toggle filter state
     *
     * @param filter
     */
    scope.closeFilters = function() {
      _.each(scope.filters, function(f) {
        f.opened = false;
      });
    }

    /**
     * Toggle filter state
     *
     * @param filter
     */
    scope.toggleFilter = function(filter) {
      var filterStatus = !!filter.opened;

      scope.closeFilters();

      if (!filterStatus) {
        filter.opened = true;

        $timeout(function () { // TODO to fix rzslider to avoid this workaround
          scope.$broadcast('rzSliderForceRender');
        }, 50);

      }
    }
  };

  return {
    restrict: 'E',
    replace: true,
    scope: {
      filters: '=',
      service: '=',
      sorting: '='
    },
    templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoSearchOptions',
    link: link
  };
}]);
;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoSelectedFilters.js
angular.module('searchOptions')

/**
 * @name        scoSelectedFilters
 * @description
 */
  .directive('scoSelectedFilters',
    ['$rootScope', '$document',
      function scoSelectedFilters($rootScope, $document) {
var link = function (scope) {

          /**
           * List of filters
           */
          scope.filters = scope.service.filters.filterData;

          /**
           * Show selected filters only when filters are applied
           */
          scope.showFilters = function () {
            var filters = scope.service.filters.filterData;
            return !_.isEmpty(scope.service.filters.getPostData()) && _.findWhere(filters, {applied: true}) != undefined;
          };

          /**
           * Reset selected filter
           */
          scope.resetSelected = function (filter) {
            filter.reset();
            filter.apply();
          };

          /**
           * Show the button for resetting all selected filters
           */
          scope.showResetAll = function () {
            return (_.keys(scope.service.filters.getPostData()).length > 1);
          };

          /**
           * Reset all selected filters
           */
          scope.resetAllSelected = function () {
            _.each(scope.filters, function(filter) {
              filter.reset();
            });

            scope.service.filters.apply();
            scope.closeFilters();
          };

        };

        return {
          restrict: 'E',
          templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoSelectedFilters',
          scope: {
            service: '=',
            closeFilters: '='
          },
          link: link
        }

      }
    ]
  );
;

// Source: ../shared/public_html/assets/js/searchOptions/directives/scoSortingOptions.js
angular.module('searchOptions')

/**
 * @name        scoSortingOptions
 * @description
 */
.directive('scoSortingOptions',
[
 '$filter',
function scoSortingOptions($filter) {
var link = function (scope) {

    var selected = _.findWhere(scope.model.modes, {selected: true});

    if (selected !== undefined) {
      scope.model.selected = selected;
    }

    /**
     * Selected group of filters
     * NOTE: this is used when a group has more then one filter
     *
     * @type {null}
     */
    scope.selectedGroup = null;

    /**
     * Returns true if a group has more then one sorting options
     * NOTE: split in frontend logic
     *
      * @param group
     * @returns {boolean}
     */
    scope.multipleSortingOptions = function (group) {
      return (_.keys(group).length > 1);
    };

    /**
     * Apply sorting
     *
     * @param sort
     */
    scope.applySorting = function (sort) {

      if (!sort.selected) {
        scope.model.set(sort);
      }

      scope.selectedGroup = null;
    };

    scope.distanceSelected = function () {
      var distSelect = _.findWhere(scope.model.groupedModes.distance, {selected: true});

      return distSelect != undefined;
    };

    /**
     * Get group label
     *
     * @param key
     * @returns {*}
     */
    scope.getGroupLabel = function (key) {

      var label = 'LANGM_JS_PKG_SORTING_' + key.toUpperCase() + '_MULTIPLE_SELECTED',
        params = {},
        activatedOption = _.findWhere(scope.model.groupedModes[key], {selected: true});

      if (activatedOption == undefined) {
        activatedOption = _.findWhere(scope.model.groupedModes[key], {});
      }

        params.sorting = $filter('translate')(activatedOption.label);

      return $filter('translate')(label, params);
    };

    scope.getLabel = function (sort) {
      return $filter('translate')(sort.label);
    };

    scope.getLabelSingle = function (sort) {
      return $filter('translate')(sort.label + '_SORTING');
    };

    /**
     * Toggle group state
     *
     * @param key
     */
    scope.toggleGroup = function (key) {
      scope.selectedGroup = (!scope.selectedGroup || scope.selectedGroup!=key) ? key : null;
    };

  };

  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '=ngModel'
    },
    templateUrl: '/tpl/show/jsShared/templates/searchOptions/scoSortingOptions',
    link: link
  };
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/models/Filter.js
angular.module('searchOptions')

/**
 * @name        sco.Filter
 * @description
 */
.factory('sco.Filter',
[
function FilterFactory() {
/**
   * Filter constructor
   * @class
   * @param {String} key
   * @param {Object} filterObj
   */
  var Filter = function (key, filterObj) {
    this.key = key;
    this.type = filterObj.type;
    this.applied = false;
  };

  Filter.prototype = /** @lends Filter.prototype */ {
    /**
     * Apply filter change to its search service
     */
    apply: function () {
      this.parent.apply();
    },

    setDisabledState: _.noop
  };

  Filter.prototype.getPostData = function (postData) {
    if (this.isActive()) {
      postData[this.key] = this.selection;
    }
  };

  /**
   * Set filter as applied
   */
  Filter.prototype.setApplied = function () {
    this.applied = this.isActive();
  };

  /**
   * Is filter applied
   */
  Filter.prototype.isApplied = function () {
    return this.applied;
  };

  /**
   * Get a string of selected options labels
   * @returns {String}
   */
  Filter.prototype.selectedFilters = function () {
    return this.getSelectionLabels().join(', ');
  };

  Filter.prototype.constructor = Filter;

  return Filter;
}]);
;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterCollection.js
angular.module('searchOptions')

/**
 * @name        sco.FilterCollection
 * @description Collection of search filters
 */
.factory('sco.FilterCollection',
['$q', 'sco.FilterMultiple', 'sco.FilterName', 'sco.FilterTripLength', 'sco.FilterPrice','sco.FilterDistance',
function FilterCollectionFactory($q, FilterMultiple, FilterName, FilterTripLength, FilterPrice, FilterDistance) {
/**
   * FilterCollection constructor
   * @class
   */
  var FilterCollection = function () {
    this.defer = $q.defer();
    this.promise = this.defer.promise;

    this.filterKeys = [];
    this.filterData = {};
    this.groupedData = [];
  };

  var filterClasses = {
    select: FilterMultiple,
    stars: FilterMultiple,
    input: FilterName,
    length: FilterTripLength,
    price: FilterPrice,
    distance: FilterDistance
  };

  FilterCollection.prototype = {
    /**
     * @param {Object} apiFilters Raw API filter data
     */
    update: function (apiFilters) {
      // Massage data
      apiFilters = this.normalize(apiFilters);

      this.resetGroupedData();

      // Save filter key order
      this.filterKeys = _.keys(apiFilters);

      _.each(apiFilters, function (filterObj, key) {
        if (this.filterData.hasOwnProperty(key)) {
          this.filterData[key].update(filterObj);
        } else {
          this.filterData[key] = new filterClasses[filterObj.type](key, filterObj);
          this.filterData[key].parent = this;
        }

        this.filterData[key].setApplied();

        this.setFilterGroup(key, this.filterData[key]);
      }, this);

      this.defer.notify(this.filterData);
    },

    /**
     * Set filter group
     *
     * @param key
     * @param filter
     */
    setFilterGroup: function (key, filter) {
      this.setGroup(key, key, filter);
    },

    /**
     * Set filter in group
     *
     * @param groupKey
     * @param filterKey
     * @param filter
     */
    setGroup: function (groupKey, filterKey, filter) {

      if (this.groupedData[groupKey] == undefined) {
        this.groupedData[groupKey] = [];
      }

      this.groupedData[groupKey].push(filter);
    },

    /**
     * Reset grouped data
     */
    resetGroupedData: function() {
      this.groupedData.length = 0;
      for (var key in this.groupedData) {
        this.groupedData[key].length = 0;
      }
    },

    /**
     * Get filter
     *
     * @param {String} key
     * @returns {*}
     */
    getFilter: function(key) {

      if (this.filterData.hasOwnProperty(key)) {
        return this.filterData[key];
      }

      return null;
    },

    /**
     * Get filter selection
     *
     * @param {String} key
     * @returns {*}
     */
    getFilterSelection: function(key)
    {
      var filter  = this.getFilter(key);

      if(filter != null) {
        return this.getFilter(key).selection;
      }

      return [];
    },

    /**
     * Prepare API filter data
     */
    normalize: _.noop,

    /**
     * Apply filters
     */
    apply: function () {
      this.service.applyFilters();
    },

    /**
     * Returns all filters' selection POST data
     * @returns {Object} The POST data object
     */
    getPostData: function () {
      var postData = {};

      _.each(this.filterData, function (filterObj, filterKey) {
        if (typeof filterObj.getPostData === "function") {
          filterObj.getPostData(postData);
        } else {
          _.each(filterObj, function (childFilterObj, childKey) {
            if (typeof childFilterObj.getPostData === "function") {
              childFilterObj.getPostData(postData);
            }
          });
        }
      });

      return postData;
    },

    /**
     * Returns filter state
     * @returns {Boolean}
     */
    hasPostData: function () {
      return !_.isEmpty(this.getPostData());
    },

    /**
     * Returns filters loaded state
     * @returns {Boolean}
     */
    isLoaded: function () {
      return this.filterKeys.length > 0;
    },

    /**
     * Reset the filter
     */
    reset: function () {
      _.each(this.filterData, function (filterObj) {
        filterObj.reset();
      });
    },

    empty: function () {
      _.each(this.filterData, function (filterObj, key, list) {
        delete list[key];
      });
    },

    setDisabledState: function (toggle) {
      _.each(this.filterData, function (filterObj, filterKey) {
        filterObj.setDisabledState(toggle);
      });
    }
  };

  FilterCollection.prototype.constructor = FilterCollection;

  return FilterCollection;
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterDistance.js
angular.module('searchOptions')

/**
 * @name        sco.FilterDistance
 * @description
 */
.factory('sco.FilterDistance',
['sco.Filter', '$filter',
function FilterDistanceFactory(Filter, $filter) {
/**
   * FilterDistance constructor
   * @class
   * @param {String} key
   * @param {Object} filterObj
   */
  var FilterDistance = function (key, filterObj) {
    Filter.call(this, key, filterObj);
    this.pid = filterObj.pid;

    var self = this;

    this.translate = function (value) {
      return $filter('flKilometers')(value, 1);
    };

    this.update(filterObj);
  };

  FilterDistance.prototype = Object.create(Filter.prototype);

  /**
   * @param {Object} filterObj
   */
  FilterDistance.prototype.update = function (filterObj) {
    this.title = filterObj.subtitle;
    this.values = filterObj.values;

    this.range = {
      min: filterObj.values.min,
      max: filterObj.values.max
    };

    this.selection = filterObj.selected.hasOwnProperty('min') ? filterObj.selected : angular.copy(this.range);

    if (filterObj.hasOwnProperty('pid')) {
      this.selection.pid = filterObj.pid;
    }
  };

  /**
   * Get filter title
   * @returns {String} Filter selection values
   */
  FilterDistance.prototype.getTitle = function () {
    return [
      this.selection.min,
      this.selection.max
    ].join(' - ');
  }

  /**
   * Reset selection
   */
    FilterDistance.prototype.reset = function () {
      angular.extend(this.selection, this.range);
    };

  /**
   * Returns filter's selection state
   * @returns {Boolean}
   */
  FilterDistance.prototype.isActive = function () {
    return this.selection.min !== this.range.min || this.selection.max !== this.range.max;
  };

  /**
   * Get a string of selected options labels
   * @returns {String}
   */
  FilterDistance.prototype.selectedFilters = function () {
    return $filter('flKilometers')(this.selection.min, 1) + ' - ' + $filter('flKilometers')(this.selection.max, 1);
  };

  /**
   * Returns filter's POST data
   * @returns {Boolean}
   */
  FilterDistance.prototype.getPostData = function (postData) {
    if (this.isActive()) {
      if (!postData.hasOwnProperty('distances')) {
        postData.distances = {};
      }

      postData.distances[this.pid] = this.selection;
      delete postData[this.key];
    }
  };

  FilterDistance.prototype.constructor = FilterDistance;

  return FilterDistance;
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterMultiple.js
angular.module('searchOptions')

/**
 * @name        sco.FilterMultiple
 * @description
 */
.factory('sco.FilterMultiple',
['sco.Filter',
function FilterMultipleFactory(Filter) {
/**
   * FilterMultiple constructor
   * @class FilterMultiple
   * @param {String} key
   * @param {Object} filterObj
   */
  var FilterMultiple = function (key, filterObj) {
    Filter.call(this, key, filterObj);
    this.options = [];
    this.selection = [];
    this.disabled = false;
    this.update(filterObj);
  };

  FilterMultiple.prototype = Object.create(Filter.prototype);

  /**
   * Update selection with selected options keys
   */
  FilterMultiple.prototype.updateSelection = function () {
    this.selection = _.pluck(this.getSelectedOptions(), 'key');
  };

  /**
   * @param {Object} filterObj
   */
  FilterMultiple.prototype.update = function (filterObj) {
    this.title = filterObj.title;
    this.options.length = 0;
    this.selection.length = 0;

    _.each(filterObj.values, function (value) {
      this.options.push(value);
    }, this);

    if (this.key === 'periods') {
      _.each(filterObj.selected, function (v, k) {
        k = moment(k).startOf('month').format('YYYY-MM-DD');
        this.selection.push(k);
      }, this);
    }
    else {
      this.selection = _.keys(filterObj.selected);
    }
  };

  /**
   * Apply filter change to its search service
   */
  FilterMultiple.prototype.apply = function () {
    this.updateSelection();
    Filter.prototype.apply.apply(this);
  };

  /**
   * Get a list of selected options
   * @returns {Object[]}
   */
  FilterMultiple.prototype.getSelectedOptions = function () {
    return _.where(this.options, {selected: true});
  };

  /**
   * Get a list of selected option labels
   * @returns {string[]}
   */
  FilterMultiple.prototype.getSelectionLabels = function () {
    return _.pluck(this.getSelectedOptions(), 'label');
  };

  /**
   * Get filter title
   * @returns {String} Filter title or selection labels
   */
  FilterMultiple.prototype.getTitle = function () {
    var selection = this.getSelectionLabels();

    return this.title;
  };

  /**
   * Reset selection
   */
  FilterMultiple.prototype.reset = function () {
    this.selection = [];

    _.each(this.options, function (option) {
      option.selected = false;
    });
  };

  /**
   * Enable or disable all options
   * @param {Boolean} toggle
   */
  FilterMultiple.prototype.setDisabledState = function (toggle) {
    this.disabled = toggle;

    _.each(this.options, function (option) {
      option.disabled = toggle;
    });
  };

  /**
   * Returns filter's selection state
   * @returns {Boolean}
   */
  FilterMultiple.prototype.isActive = function () {
    return this.selection.length > 0;
  };

  FilterMultiple.prototype.constructor = FilterMultiple;

  return FilterMultiple;
}]);
;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterName.js
angular.module('searchOptions')

/**
 * @name        sco.FilterName
 * @description
 */
.factory('sco.FilterName',
['sco.Filter',
function FilterNameFactory(Filter) {
/**
   * FilterName constructor
   * @class
   * @param {String} key
   * @param {Object} filterObj
   */
  var FilterName = function (key, filterObj) {
    Filter.call(this, key, filterObj);
    this.update(filterObj);
  };

  FilterName.prototype = Object.create(Filter.prototype);

  /**
   * @param {Object} filterObj
   */
  FilterName.prototype.update = function (filterObj) {
    this.title = filterObj.title || 'LANGM_JS_HOTEL_FILTER_NAME';
    this.options = filterObj.values;
    this.selection = filterObj.hasOwnProperty('selected') && filterObj.selected ? filterObj.selected : '';
  };

  /**
   * Reset selection
   */
  FilterName.prototype.reset = function () {
    this.selection = '';
  };

  /**
   * Get a list of values
   * @returns {string[]}
   */
  FilterName.prototype.getSelectionLabels = function () {
    return [this.selection];
  };

  /**
   * Returns filter's selection state
   * @returns {Boolean}
   */
  FilterName.prototype.isActive = function () {
    return this.selection.length > 0;
  };

  FilterName.prototype.constructor = FilterName;

  return FilterName;
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterPrice.js
angular.module('searchOptions')

/**
 * @name        sco.FilterPrice
 * @description
 */
.factory('sco.FilterPrice',
['sco.Filter',
function FilterPriceFactory(Filter) {
/**
   * FilterPrice constructor
   * @class
   * @param {String} key
   * @param {Object} filterObj
   */
  var FilterPrice = function (key, filterObj) {
    Filter.call(this, key, filterObj);

    this.update(filterObj);
  };

  FilterPrice.prototype = Object.create(Filter.prototype);

  /**
   * @param {Object} filterObj
   */
  FilterPrice.prototype.update = function (filterObj) {
    this.title = filterObj.title;
    this.values = filterObj.values;

    this.range = {
      min: filterObj.values.min,
      max: filterObj.values.max
    };

    this.selection = filterObj.selected.hasOwnProperty('min') ? filterObj.selected : angular.copy(this.range);
    this.currency = filterObj.values.currency;
  };

  /**
   * Translate slider label
   * NOTE: 'this' is the slider object
   *
   * @param value
   * @returns {string}
   */
  FilterPrice.prototype.translate = function (value) {
    return value + ' ' + this.options.currency;
  };

  /**
   * Get a string of selected options labels
   * @returns {String}
   */
  FilterPrice.prototype.selectedFilters = function () {
    return this.selection.min + ' - ' + this.selection.max + this.currency;
  };

  /**
   * Get filter title
   * @returns {String} Filter selection values
   */
  FilterPrice.prototype.getTitle = function () {
    return this.title;
  };

  /**
   * Reset selection
   */
    FilterPrice.prototype.reset = function () {
      angular.extend(this.selection, this.range);
    };

  /**
   * Returns filter's selection state
   * @returns {Boolean}
   */
  FilterPrice.prototype.isActive = function () {
    return this.selection.min !== this.range.min || this.selection.max !== this.range.max;
  };

  FilterPrice.prototype.constructor = FilterPrice;

  return FilterPrice;
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/models/FilterTripLength.js
angular.module('searchOptions')

/**
 * @name        sco.FilterTripLength
 * @description
 */
.factory('sco.FilterTripLength',
['sco.FilterPrice', '$filter',
function FilterTripLengthFactory(FilterPrice, $filter) {
/**
   * FilterTripLength constructor
   * @class
   * @param {String} key
   * @param {Object} filterObj
   */
  var FilterTripLength = function (key, filterObj) {
    FilterPrice.call(this, key, filterObj);

    this.update(filterObj);
  };

  FilterTripLength.prototype = Object.create(FilterPrice.prototype);

  /**
   * Get filter title
   * @returns {String} Filter selection values
   */
  FilterTripLength.prototype.translate = function (value) {
    return  value + '';
  };

  /**
   * Get a string of selected options labels
   * @returns {String}
   */
  FilterTripLength.prototype.selectedFilters = function () {
    return this.selection.min + ' - ' + this.selection.max + ' ' + $filter('translate')($filter('langPluralize')('LANGM_JS_GENERAL_NIGHT', this.selection.max));
  };

  FilterTripLength.prototype.getPostData = function (postData) {
    if (this.isActive()) {
      postData[this.key] = _.range(this.selection.min, this.selection.max + 1);
    }
  };


  FilterTripLength.prototype.constructor = FilterTripLength;

  return FilterTripLength;
}]);

;

// Source: ../shared/public_html/assets/js/searchOptions/services/SelectedFiltersService.js
angular.module('searchOptions')

/**
 * @name        SelectedFiltersService
 * @namespace   pkg
 * @description Handles package search panel
 */
  .factory('pkg.SelectedFiltersService',
    ['$rootScope',
      function SelectedFiltersService($rootScope) {
var scope = this;

        scope.isOpen = false;

        return scope;

      }
    ]
  );
;

// Source: ../shared/public_html/assets/js/staticPage/footerComponent/footerComponent.controller.js
(function (angular) {
var controller = function () {
        this.getFullYear = function () {
            return new Date().getFullYear();
        }
    };

    controller.$inject = [];

    angular
        .module('base')
        .component('footerComponent', {
            templateUrl: '/tpl/show/jsShared/templates/footerComponent/footerComponent',
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/staticPage/footerComponent/footerComponentLowerPart.component.js
(function (angular) {
var template = '\
        <div class="footer-component-lower-part">\
            <p class="footer-component-lower-part__title" translate>\
                LANGM_JS_INTERNATIONAL\
            </p>\
            <div class="footer-component-lower-part__languages footer-component-lower-part__languages--desktop">\
                <span ith-language-select="" class="footerTop__international__languages"><a ng-class="{ selected: isLanguageVersion(\'ro\') }" ng-click="changeLanguageVersion(\'ro\')" class="selected"><img ng-src="/assets/img/ui/icons/svg/countries/ro.svg" style="" src="/assets/img/ui/icons/svg/countries/ro.svg"> România </a><a ng-class="{ selected: isLanguageVersion(\'en\') }" ng-click="changeLanguageVersion(\'en\')"><img ng-src="/assets/img/ui/icons/svg/countries/gb.svg" style="" src="/assets/img/ui/icons/svg/countries/gb.svg"> EN </a><a href="https://www.fru.pl" title="www.fru.pl" target="_blank"><img ng-src="/assets/img/ui/icons/svg/countries/pl.svg" style="" src="/assets/img/ui/icons/svg/countries/pl.svg"> Polonia </a><a ng-class="{ selected: isLanguageVersion(\'hu\') }" ng-click="changeLanguageVersion(\'hu\')"><img ng-src="/assets/img/ui/icons/svg/countries/hu.svg" style="" src="/assets/img/ui/icons/svg/countries/hu.svg"> Ungaria </a><a ng-class="{ selected: isLanguageVersion(\'sl\') }" ng-click="changeLanguageVersion(\'si-sl\')"><img ng-src="/assets/img/ui/icons/svg/countries/si.svg" style=" width: 20px;" src="/assets/img/ui/icons/svg/countries/si.svg"> Slovenia </a><a href="https://www.govola.com/bg-bg" title="www.govola.com/bg-bg"><img ng-src="/assets/img/ui/icons/svg/countries/bg.svg" style="" src="/assets/img/ui/icons/svg/countries/bg.svg"> Bulgaria&nbsp; </a></span>\
            </div>\
            \
            <div class="footer-component-lower-part__languages footer-component-lower-part__languages--mobile">\
                <span ith-language-select="" class="footerTop__international__languages"><a ng-class="{ selected: isLanguageVersion(\'ro\') }" ng-click="changeLanguageVersion(\'ro\')" class="selected"><img ng-src="/assets/img/ui/icons/svg/countries/ro.svg" style="" src="/assets/img/ui/icons/svg/countries/ro.svg"> Ro </a><a ng-class="{ selected: isLanguageVersion(\'en\') }" ng-click="changeLanguageVersion(\'en\')"><img ng-src="/assets/img/ui/icons/svg/countries/gb.svg" style="" src="/assets/img/ui/icons/svg/countries/gb.svg"> EN </a><a href="https://www.fru.pl" title="www.fru.pl" target="_blank"><img ng-src="/assets/img/ui/icons/svg/countries/pl.svg" style="" src="/assets/img/ui/icons/svg/countries/pl.svg"> PL </a><a ng-class="{ selected: isLanguageVersion(\'hu\') }" ng-click="changeLanguageVersion(\'hu\')"><img ng-src="/assets/img/ui/icons/svg/countries/hu.svg" style="" src="/assets/img/ui/icons/svg/countries/hu.svg"> HU </a><a ng-class="{ selected: isLanguageVersion(\'sl\') }" ng-click="changeLanguageVersion(\'si-sl\')"><img ng-src="/assets/img/ui/icons/svg/countries/si.svg" style=" width: 20px;" src="/assets/img/ui/icons/svg/countries/si.svg"> SI </a><a href="https://www.govola.com/bg-bg" title="www.govola.com/bg-bg"><img ng-src="/assets/img/ui/icons/svg/countries/bg.svg" style="" src="/assets/img/ui/icons/svg/countries/bg.svg"> BG </a></span>\
            </div>\
        </div>\
    ';

    var controller = function ($translate) {

    };

    controller.$inject = ['$translate'];

    angular
        .module('base')
        .component('footerComponentLowerPart', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/staticPage/footerComponent/footerComponentUpperPart.component.js
(function (angular) {
var template = '\
        <div class="footer-component-upper-part">\
            <div class="footer-component-upper-part__col">\
                <p class="footer-component-upper-part__title">\
                    17+\
                </p>\
                <p class="footer-component-upper-part__description" translate>\
                    LANGM_JS_YEARS_OF_EXPERIENCE\
                </p>\
            </div>\
            <div class="footer-component-upper-part__col">\
                <p class="footer-component-upper-part__title">\
                    24/7\
                </p>\
                <p class="footer-component-upper-part__description" translate>\
                    LANGM_JS_CUSTOMER_CARE\
                </p>\
            </div>\
            <div class="footer-component-upper-part__col">\
                <p class="footer-component-upper-part__title">\
                    <span>1</span><span translate>LANGM_JS_MLN</span>\
                </p>\
                <p class="footer-component-upper-part__description" translate>\
                    LANGM_JS_HAPPY_CUSTOMERS\
                </p>\
            </div>\
            <div class="footer-component-upper-part__col">\
                <p class="footer-component-upper-part__title">\
                    4.8/5\
                </p>\
                <p class="footer-component-upper-part__description" translate>\
                    LANGM_JS_AVERAGE_RATING\
                </p>\
            </div>\
        </div>\
    ';

    var controller = function ($translate) {

    };

    controller.$inject = ['$translate'];

    angular
        .module('base')
        .component('footerComponentUpperPart', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/staticPage/linksToLandingPages/linksToLandingPages.controller.js
(function (angular) {
var controller = function ($translate) {
        this.tabs = [
            {
                name: $translate.instant('LANGM_JS_POPULAR_DESTINATIONS'),
                value: 'popular destinations'
            },
            {
                name: $translate.instant('LANGM_JS_POPULAR_AIRLINES'),
                value: 'airlines'
            },
            {
                name: $translate.instant('LANGM_JS_POPULAR_COUNTRIES'),
                value: 'popular countries'
            }
        ];

        this.activeTab = this.tabs[0].value;

        this.setActiveTab = function (tab) {
            this.activeTab = tab.type;
        };
    };

    controller.$inject = ['$translate'];

    angular
        .module('base')
        .component('linksToLandingPages', {
            templateUrl: '/tpl/show/jsShared/templates/linksToLandingPages/linksToLandingPages',
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/staticPage/models/StaticBox.js
angular.module('staticPage')

/**
 * @name        StaticBox
 * @namespace   stp
 * @description Class holding static box information
 */
.factory('stp.StaticBox',
[
function StaticBoxFactory() {
/**
   * StaticBox constructor
   *
   * @constructor
   * @class StaticBox
   */
  var StaticBox = function (data) {
    /**
     * Static box header
     *
     * @type {String}
     */
    this.header = data.header || "";

    /**
     * Static box content in html format
     *
     * @type {String}
     */
    this.text = data.text || "";
  };

  // Add instance methods
  StaticBox.prototype = /** @lends StaticBox.prototype */ {
    /**
     * Returns text box html
     *
     * @return {String}
     */
    getText: function () {
      return this.text;
    }
  };

  StaticBox.prototype.constructor = StaticBox;

  return StaticBox;
}]);

;

// Source: ../shared/public_html/assets/js/staticPage/models/StaticPage.js
/* global _: false */


angular.module('staticPage')

/**
 * @name        StaticPage
 * @namespace   stp
 * @description Class holding static page information
 */
.factory('stp.StaticPage',
['stp.StaticBox',
function StaticPageFactory(StaticBox) {
/**
   * StaticPage constructor
   *
   * @constructor
   * @class StaticPage
   */
  var StaticPage = function (data) {
    /**
     * Static page title
     *
     * @type {String}
     */
    this.title = data.page.page_title || '';

    /**
     * Static page description
     *
     * @type {String}
     */
    this.description = data.page.description || '';

    /**
     * Text boxes contained by the static page
     *
     * @type {Array}
     */
    this.boxes = [];

    _.each(data.boxes, function (box) {
      this.boxes.push(new StaticBox(box));
    }, this);
  };

  // Add instance methods
  StaticPage.prototype = /** @lends StaticPage.prototype */ {
    /**
     * Retuns static page title
     *
     * @return {String}
     */
    getTitle: function () {
      return this.title;
    },

    /**
     * Returns static page description
     *
     * @return {String}
     */
    getDescription: function () {
      return this.description;
    },

    /**
     * Returns static page text boxes
     *
     * @return {Array}
     */
    getBoxes: function () {
      return this.boxes;
    }
  };

  StaticPage.prototype.constructor = StaticPage;

  return StaticPage;
}]);

;

// Source: ../shared/public_html/assets/js/staticPage/services/StaticPageServ.js
angular.module('staticPage')

/**
 * @name        StaticPageServ
 * @namespace   stp
 * @description
 */
.factory('stp.StaticPageServ',
['ApiTools',
function StaticPageServFactory(ApiTools) {
var
    /**
     * The API endpoints configuration
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     */
    endpoints = {
      // Add coupon
      staticPage: {url: '/api/staticPage/show/', method: 'GET', respParser: staticPageParser}
    },

    /**
     * @class StaticPageServ
     * @constructor
     */
    StaticPageServ = function () {};

  StaticPageServ.prototype = /** @lends StaticPageServ.prototype */  {

    /**
     * Get static page content
     *
     * @param {String} pageId The static page Id
     */
    getPageContent: function (pageId) {
      return ApiTools.fetch(this, endpoints.staticPage, null, {url: pageId.split('/').join('')});
    }
  };

  StaticPageServ.prototype.constructor = StaticPageServ;

  /**
   * Parse example response
   *
   * @param {Object} response
   * @return {FlApp.Example}
   */
  function staticPageParser(response) {
    return response.response;
  }

  return new StaticPageServ();
}]);

;

// Source: ../shared/public_html/assets/js/user/account-delete.component.js
(function(angular) {
var IthAccountDeleteModalFormController = function ($modalInstance, $location, UserService, AuthService, ProfileSettingsService, API_STATUSES_PROFILE, AuthService2, AuthGuard) {
        var self = this;

        this.error = false;
        this.unexpectedError = false;
        this.incorrectEmail = false;
        this.loading = false;
        this.confirm = false;

        this.modalInstance = $modalInstance;

        this.formData = {
            email: ''
        };

        this.confirmDelete = function () {
            this.confirm = true;
        };

        this.deleteAccount = function (ngForm) {
            if (!ngForm.$valid) {
                return;
            }

            this.unexpectedError = false;
            this.incorrectEmail = false;
            this.loading = true;

            ProfileSettingsService
                .deleteAccount(this.formData.email)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        AuthService2.logout().then(function() {
                            AuthService.logout().then(function() {
                                AuthGuard.redirectToMainPage();
                            });
                        });
                        return 0;
                    }

                    if (status === API_STATUSES_PROFILE.INCORRECT_CREDENTIALS) {
                        self.incorrectEmail = true;
                        self.loading = false;
                        return 0;
                    }

                    self.unexpectedError = true;
                    self.loading = false;
                });
        };
    };

    IthAccountDeleteModalFormController.$inject = [
        '$modalInstance',
        '$location',
        'UserService',
        'AuthService',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'AuthService2',
        'AuthGuard'
    ];

    var controller = function ($modal) {
        this.openForm = function () {
            $modal.open({
                templateUrl: 'deleteProfileModal.html',
                controller: IthAccountDeleteModalFormController,
                controllerAs: '$ctrl'
            });
        };
    };

    controller.$inject = ['$modal'];

    angular
        .module('user')
        .component('ithAccountDelete', {
            template: '<button translate class="btn btn-danger btn-outline" ng-click="$ctrl.openForm()">LANGM_JS_DELETE_ACCOUNT</button>',
            controller: controller
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/billing/add-billing.component.js
(function (angular) {
var IthAddBillingController = function (BillingFormService, BillingPerson) {
        var self = this;

        /**
         * Opens the form to add a new billing
         */
        this.openForm = function () {
            var billingFormModalInstance = BillingFormService.openForm(
                new BillingPerson(),
                this.defaultBillingId,
                this.countries,
                this.counties
            );

            billingFormModalInstance.result.then(function (updatedData) {
                if (updatedData.hasOwnProperty('refresh') && updatedData.refresh) {
                    self.refresh();
                }
            });
        };
    };

    IthAddBillingController.$inject = ['BillingFormService', 'bil.BillingPerson'];

    var template = '\
        <div class="row">\
            <div class="col-md-4 col-md-offset-4">\
                <button class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.openForm()" translate>LANGM_JS_ADD_BILLING</button>\
            </div>\
        </div>\
    ';

    angular
        .module('user')
        .component('ithAddBilling', {
            template: template,
            controller: IthAddBillingController,
            bindings: {
                defaultBillingId: '<',
                countries: '<',
                counties: '<',
                refresh: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/billing/billing-form.controller.js
(function(angular) {
var IthBillingFormController = function ($modalInstance, $translate, AppConfig, BillingPerson, Company, UserService, billingData, countries, counties, ProfileSettingsService, API_STATUSES_PROFILE) {
        /**
         * @type {IthBillingFormController}
         */
        var self = this;

        this.isVola = function () {
            return AppConfig.isVola();
        };

        this.billingType = billingData.hasOwnProperty('firstName') ? 'person' : 'company';

        if (!AppConfig.isVola()) {
            this.billingType = 'company';
        }

        this.personalBilling = new BillingPerson();
        if (this.billingType === 'person') {
            this.personalBilling.srvSet(billingData.srvObj());
        }

        this.companyBilling = new Company();
        if (this.billingType === 'company') {
            this.companyBilling.srvSet(billingData.srvObj());
        }

        this.countries = countries;
        this.counties = counties;
        this.locations = {
            countries: countries,
            provinces: counties
        };

        this.modalInstance = $modalInstance;
        this.isDuringSubmit = false;

        this.isDefaultBilling = function () {
            return false;
        };

        this.isPersonal = function () {
            return this.billingType === 'person';
        };

        this.getTargetModel = function () {
            return this.isPersonal() ? this.personalBilling : this.companyBilling;
        };

        this.isNewBilling = function () {
            return billingData.id === '';
        };

        this.getModalTitle = function () {
            if (this.isNewBilling()) {
                return $translate.instant('LANGM_JS_ADD_BILLING');
            }

            return $translate.instant('LANGM_JS_EDIT_BILLING_DETAILS');
        };

        this.submit = function (ngForm) {
            if (ngForm.hasOwnProperty('billingPerson')) {
                ngForm.billingPerson.$setSubmitted();
                if (ngForm.$invalid) {
                    return 0;
                }

                return ProfileSettingsService.setPersonalBilling(this.personalBilling)
                    .then(function (response) {
                        if (response.status === API_STATUSES_PROFILE.OK) {
                            $modalInstance.close({
                                refresh: true
                            });
                            self.isDuringSubmit = false;
                        }
                    });
            }

            if (ngForm.hasOwnProperty('billingCompany')) {
                ngForm.billingCompany.$setSubmitted();
                if (ngForm.$invalid) {
                    return 0;
                }

                return ProfileSettingsService.setCompanyBilling(this.companyBilling)
                    .then(function (response) {
                        if (response.status === API_STATUSES_PROFILE.OK) {
                            $modalInstance.close({
                                refresh: true
                            });
                            self.isDuringSubmit = false;
                        }
                    });

            }

            this.isDuringSubmit = true;

            getFormSubmitPromise()
                .then(function (response) {
                    if (!response.success) {
                        self.getTargetModel().srvErrors(response.errors);
                        return;
                    }

                    $modalInstance.close({
                        refresh: true
                    });
                })
                .finally(function () {
                    self.isDuringSubmit = false;
                });
        };

        /**
         *
         * @returns {void}
         */
        this.remove = function () {
            if (this.isNewBilling()) {
                return;
            }

            if (!confirm($translate.instant('LANGM_JS_CONFIRM_REMOVE_BILLING'))) {
                return;
            }

            ProfileSettingsService
                .deleteBilling(this.getTargetModel().id)
                .then(function success() {
                    $modalInstance.close({
                        refresh: true
                    });
                });
        };

        /**
         *
         * @returns {Promise}
         */
        var getFormSubmitPromise = function () {
            var billingPayload = self.getTargetModel().srvObj();

            if (self.isNewBilling()) {
                return UserService.AddBilling({
                    type: self.billingType,
                    billing: billingPayload
                });
            }

            return UserService.editBilling(billingPayload);
        };
    };

    IthBillingFormController.$inject = [
        '$modalInstance',
        '$translate',
        'appConfig',
        'bil.BillingPerson',
        'bil.Company',
        'UserService',
        'billingData',
        'countries',
        'counties',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE'
    ];

    angular
        .module('user')
        .controller('BillingFormController', IthBillingFormController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/billing/billing-form.service.js
(function(angular) {
var BillingFormService = function ($modal) {
        this.openForm = function (billingData, defaultBillingId, countries, counties) {
            return $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/user/components/billing-form',
                controller: 'BillingFormController',
                controllerAs: '$ctrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    billingData: function () {
                        return billingData;
                    },
                    countries: function () {
                        return countries;
                    },
                    counties: function () {
                        return counties;
                    }
                }
            });
        };
    };

    BillingFormService.$inject = ['$modal'];

    angular
        .module('user')
        .service('BillingFormService', BillingFormService);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/billing/list-billing.component.js
(function(angular, underscore) {
var IthListBillingController = function (BillingFormService, UserService, ProfileSettingsService) {
        var self = this;

        this.getTitle = function () {
            if (this.data.hasOwnProperty('firstName')) {
                return this.data.firstName + ' ' + this.data.lastName;
            }

            return this.data.name;
        };

        this.getCountry = function (countryCode) {
            var foundCountryObject = underscore.find(this.countries, function (country) {
                return country.code === countryCode;
            });

            return foundCountryObject ? foundCountryObject.name : '';
        };

        this.edit = function () {
            var billingFormModalInstance = BillingFormService.openForm(
                this.data,
                this.defaultBillingId,
                this.countries,
                this.counties
            );

            billingFormModalInstance.result.then(function (updatedData) {
                if (updatedData.hasOwnProperty('refresh')) {
                    self.refresh();
                }
            });
        };
    };

    IthListBillingController.$inject = [
        'BillingFormService',
        'UserService',
        'ProfileSettingsService'
    ];

    var template = '\
        <ith-profile-manage-box title="{{ :: $ctrl.getTitle() }}">\
            <content-pane>\
                <span>{{ :: $ctrl.data.address.street }},</span>\
                <span>{{ :: $ctrl.data.address.city }},</span>\
                <span>{{ :: $ctrl.getCountry($ctrl.data.address.country) }}</span>\
                <span ng-show="$ctrl.data.address.zipCode !== \'\'">, {{ :: $ctrl.data.address.zipCode }}</span>\
            </content-pane>\
            <actions-pane>\
                <a translate class="btn btn-outline" ng-click="$ctrl.edit()">LANGM_JS_EDIT</a>\
            </actions-pane>\
        </ith-profile-manage-box>\
    ';

    angular
        .module('user')
        .component('ithListBilling', {
            template: template,
            controller: IthListBillingController,
            bindings: {
                data: '<',
                defaultBillingId: '<',
                countries: '<',
                counties: '<',
                refresh: '&'
            }
        });

}(angular, _));
;

// Source: ../shared/public_html/assets/js/user/buddies/add-buddy.component.js
(function(angular) {
var IthAddBuddyController = function (BuddyFormService, Person) {
        var self = this;
        /**
         * Opens the form to add a new travel buddy
         */
        this.openForm = function () {
            var buddyFormModalInstance = BuddyFormService.openForm(
                new Person(),
                null,
                this.customerId,
                this.countries
            );

            buddyFormModalInstance.result.then(function (updatedData) {
                if (updatedData.hasOwnProperty('refresh') && updatedData.refresh) {
                    self.refresh();
                }
            });
        };
    };

    IthAddBuddyController.$inject = ['BuddyFormService', 'bil.Person'];

    var template = '\
        <div class="row">\
            <div class="col-md-4 col-md-offset-4">\
                <button class="btn btn-lg btn-block btn-outline" ng-click="$ctrl.openForm()" translate>LANGM_JS_ADD_TRAVEL_BUDDY</button>\
            </div>\
        </div>\
    ';

    angular
        .module('user')
        .component('ithAddBuddy', {
            template: template,
            controller: IthAddBuddyController,
            bindings: {
                customerId: '<',
                countries: '<',
                refresh: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/buddies/buddy-form.controller.js
(function(angular) {
var IthBuddyFormController = function ($modalInstance, $translate, Person, ContactDetails, UserService, travelBuddy, customerId, countries, contactDetails, ProfileSettingsService, API_STATUSES_PROFILE, UserSessionData) {
        /**
         * @type {IthBuddyFormController}
         */
        var self = this;

        /**
         * Travel buddy connected to the form
         *
         * @type {Person}
         */
        this.travelBuddy = new Person();
        this.travelBuddy.srvSet(travelBuddy.srvObj());

        /**
         * Contact details connected to the form
         *
         * @type {ContactDetails}
         */
        this.contactDetails = new ContactDetails();

        if (contactDetails) {
            this.contactDetails.srvSet(contactDetails.srvObj());
        }

        /**
         * Id of the main account (customer)
         *
         * @type {String}
         */
        this.customerId = customerId;

        /**
         * List of countries coming from backend
         *
         * @type {Object[]}
         */
        this.countries = countries;

        /**
         * Form submit flag
         *
         * @type {Boolean}
         */
        this.isDuringSubmit = false;

        /**
         * Object containing form errors sent by backend
         *
         * @ytype {Object}
         */
        this.backendErrors = {};

        /**
         * Modal instance
         *
         * @type {$modalInstance}
         */
        this.instance = $modalInstance;

        /**
         * Data needed in the pax type selector
         *
         * @type {Object[]}
         */
        this.paxTypeSelectData = ['ADT', 'CHD', 'INF', 'YTH'].map(function (paxType) {
            return {
                type: paxType,
                name: $translate.instant('LANGM_JS_' + paxType + '_PAX_TYPE')
            };
        });

        this.genderSelectData = [
            {
                type:'male',
                name: $translate.instant('LANGM_JS_GENDER_MALE')
            },
            {
                type:'female',
                name: $translate.instant('LANGM_JS_GENDER_FEMALE')
            },
        ].map(function (item) {
            return {
                type: item.type,
                name: item.name
            };
        });

        /**
         *
         * @returns {Boolean}
         */
        this.isAccountOwner = function () {
            return this.travelBuddy.id === this.customerId;
        };

        /**
         *
         * @returns {Boolean}
         */
        this.isNewTravelBuddy = function () {
            return this.travelBuddy.id === '';
        };

        /**
         *
         * @returns {String}
         */
        this.getModalTitle = function () {
            if (this.isAccountOwner()) {
                return $translate.instant('LANGM_JS_EDIT_ACCOUNT_OWNER');
            }

            if (this.isNewTravelBuddy()) {
                return $translate.instant('LANGM_JS_ADD_TRAVEL_BUDDY');
            }

            return $translate.instant('LANGM_JS_EDIT_TRAVEL_BUDDY');
        };

        /**
         * Submits the form
         */
        this.submit = function (ngForm) {
            if (ngForm.$invalid) {
                return;
            }

            this.isDuringSubmit = true;

            var promise = this.isAccountOwner() ? this.setOwnerProfile() : this.setPassenger();

            promise.then(function (status) {
                if (status === API_STATUSES_PROFILE.OK) {
                    self.isDuringSubmit = false;
                    $modalInstance.close({
                        refresh: true
                    });
                }
            });
        };

        /**
         *
         * @returns {void}
         */
        this.remove = function () {
            if (this.isNewTravelBuddy()) {
                return;
            }

            if (!confirm($translate.instant('LANGM_JS_CONFIRM_REMOVE_TRAVEL_BUDDY'))) {
                return;
            }

            ProfileSettingsService
                .deletePassenger(this.travelBuddy.id)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        $modalInstance.close({
                            refresh: true
                        });
                    }
                });
        };

        this.setOwnerProfile = function () {
            return ProfileSettingsService.setProfile(self.travelBuddy)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        UserSessionData.setFirstName(self.travelBuddy.firstName)
                        self.isDuringSubmit = false;
                        $modalInstance.close({
                            refresh: true
                        });
                    }
                });
        };

        this.setPassenger = function () {
            return ProfileSettingsService.setPassenger(self.travelBuddy)
                .then(function (response) {
                    if (response.status === API_STATUSES_PROFILE.OK) {
                        self.isDuringSubmit = false;
                        $modalInstance.close({
                            refresh: true
                        });
                    }
                });
        };
    };

    IthBuddyFormController.$inject = [
        '$modalInstance',
        '$translate',
        'bil.Person',
        'bil.ContactDetails',
        'UserService',
        'travelBuddy',
        'customerId',
        'countries',
        'contactDetails',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'UserSessionData'
    ];

    angular
        .module('user')
        .controller('BuddyFormController', IthBuddyFormController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/buddies/buddy-form.service.js
(function(angular) {
var BuddyFormService = function ($modal) {
        /**
         * Opens buddy form modal
         *
         * @param {Person} travelBuddy
         * @param {ContactDetails} contactDetails
         * @param {String} customerId
         * @param {Object[]} countries
         * @returns {Promise}
         */
        this.openForm = function (travelBuddy, contactDetails, customerId, countries) {
            return $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/user/components/buddy-form',
                controller: 'BuddyFormController',
                controllerAs: '$ctrl',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    travelBuddy: function () {
                        return travelBuddy;
                    },
                    contactDetails: function () {
                        return contactDetails;
                    },
                    customerId: function () {
                        return customerId;
                    },
                    countries: function () {
                        return countries;
                    }
                }
            });
        };
    };

    BuddyFormService.$inject = ['$modal'];

    angular
        .module('user')
        .service('BuddyFormService', BuddyFormService);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/buddies/list-buddy.component.js
(function (angular) {
var IthTravelBuddyListController = function (BuddyFormService, $translate) {
        var self = this;

        /**
         * Opens the form to edit this travel buddy
         */
        this.edit = function () {
            var buddyFormModalInstance = BuddyFormService.openForm(
                this.travelBuddy,
                this.contactDetails,
                this.customerId,
                this.countries
            );

            buddyFormModalInstance.result.then(function (updatedData) {
                if (updatedData.hasOwnProperty('refresh')) {
                    self.refresh();
                }
            });
        };

        this.getBoxTitle = function () {
            var title = this.travelBuddy.firstName + ' ' + this.travelBuddy.lastName;

            if (this.travelBuddy.id === this.customerId) {
                title += ' (' + $translate.instant('LANGM_JS_ACCOUNT_OWNER') + ')';
            }

            return title;
        };

        this.getPaxTypeTranslated = function () {
            return $translate.instant('LANGM_JS_' + this.travelBuddy.paxType + '_PAX_TYPE');
        };
    };

    IthTravelBuddyListController.$inject = ['BuddyFormService', '$translate'];

    var template = '\
        <ith-profile-manage-box title="{{ $ctrl.getBoxTitle() }}">\
            <content-pane>\
                <span ng-if="$ctrl.travelBuddy.paxType">\
                    <span ng-bind="$ctrl.getPaxTypeTranslated()"></span>\
                    <span> • </span>\
                </span>\
                <span ng-bind="$ctrl.travelBuddy.birthDate | date:\'d MMMM yyyy\'"></span>\
            </content-pane>\
            <actions-pane>\
                <a translate class="btn btn-outline" ng-click="$ctrl.edit()">LANGM_JS_EDIT</a>\
            </actions-pane>\
        </ith-profile-manage-box>\
    ';

    angular
        .module('user')
        .component('ithListBuddy', {
            template: template,
            controller: IthTravelBuddyListController,
            bindings: {
                travelBuddy: '<',
                contactDetails: '<',
                customerId: '<',
                countries: '<',
                refresh: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/components/fast-login-button.component.js
(function (angular) {
var template = '\
        <button type="button" class="btn-login">\
            <svg-icon id="{{ $ctrl.provider }}"></svg-icon>\
            <ng-transclude></ng-transclude>\
        </button>\
    ';

    angular
        .module('user')
        .component('fastLoginButton', {
            template: template,
            transclude: true,
            bindings: {
                provider: '@'
            },
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/components/ith-booking-item.component.js
(function(angular) {
/**
     * Booking item template url handler.
     *
     * @param {Object} attributes
     */  
    var TemplateUrl = function (attributes) {
        var tpl = 'tpl/show/jsShared/templates/user/components/';
        
        switch (attributes.type) {
        case 'cb': tpl += 'cb-booking'; break;
        default: tpl += 'flight-booking'; break;
        }
        return tpl;
    };

    TemplateUrl.$inject = [
        '$attrs'
    ];

    /**
     * @name        IthBookingItemComponent
     * @description Handles a booking ui item in my bookings section.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthBookingItemComponent = {
        templateUrl: TemplateUrl,
        bindings: {
            data: '<'
        },
        controller: 'BookingItemController'
    };

    angular
        .module('user')
        .component('ithFlightBooking', IthBookingItemComponent);
	
}(angular));
;

// Source: ../shared/public_html/assets/js/user/components/ith-history-item.component.js
(function(angular) {
/**
   * Search history item template url handler.
   *
   * @param {Object} attributes
   */
  var TemplateUrl = function (attributes) {
    var tpl = 'tpl/show/jsShared/templates/user/components/';

    switch (attributes.type) {
    case 'cb': tpl += 'cb-history-item'; break;
    default: tpl += 'flight-history-item'; break;
    }
    return tpl;
  };

  TemplateUrl.$inject = [
    '$attrs'
  ];

  /**
   * @name        IthHistoryItemComponent
   * @description Handles a history ui item in profile section.
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthHistoryItemComponent = {
    templateUrl: TemplateUrl,
    bindings: {
      data: '<',
      onRemove: '&'
    },
    controller: 'HistoryItemController'
  };

  angular
    .module('user')
    .component('ithHistoryItem', IthHistoryItemComponent);
	
}(angular));;

// Source: ../shared/public_html/assets/js/user/components/ith-user-cashback.component.js
(function(angular) {
/**
   * @name        IthUserCashbackComponent
   * @description Displays a chashback ui element in the cashback list.
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthUserCashbackComponent = {
    templateUrl: 'tpl/show/jsShared/templates/user/directives/userCashback',
    bindings: {
      data: '<'
    },
    controller: 'IthUserCashbackController'
  };

  angular
    .module('user')
    .component('ithUserCashback', IthUserCashbackComponent);
  
}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/accept-terms-and-conditions.controller.js
(function (angular) {
var AcceptTermsAndConditions = function (
        $modalInstance,
        UsersServiceClient,
        JwtTokenService,
        AuthService,
        AuthService2,
        AuthGuard
    ) {
        this.modalInstance = $modalInstance;
        this.isChecked = false;
        this.isLoading = false;

        this.setIsLoading = function (value) {
            this.isLoading = value;
        };

        this.submit = function () {
            var self = this;

            if (this.isChecked) {
                self.setIsLoading(true);
                UsersServiceClient
                    .acceptTermsAndConditions(JwtTokenService.getAuthJwtToken())
                    .then(function () {
                        $modalInstance.dismiss();
                        self.setIsLoading(false);
                    });
            }
        };

        this.decline = function () {
            var self = this;

            self.setIsLoading(true);
            AuthService2
                .logout()
                .then(function () {
                    AuthService
                        .logout()
                        .then(function () {
                            AuthGuard.redirectToMainPage();
                            $modalInstance.dismiss();
                            self.setIsLoading(false);
                        });
                });
        };
    };

    AcceptTermsAndConditions.$inject = [
        '$modalInstance',
        'UsersServiceClient',
        'JwtTokenService',
        'AuthService',
        'AuthService2',
        'AuthGuard'
    ];

    angular
        .module('user')
        .controller('AcceptTermsAndConditions', AcceptTermsAndConditions);

})(angular);




;

// Source: ../shared/public_html/assets/js/user/controller/cashBackCtrl.js
angular.module('user')

.controller('cashBackCtrl',
['$scope', 'UserService', '$rootScope', 'PageLoading',
function ($scope, UserService, $rootScope, PageLoadingService) {
PageLoadingService.on();

  $scope.cashBackForm = this.cashBackForm;

  /**
   * Init Data
   */
  $scope.loadCashBack = function () {
    //$scope.showLoading = 1;
    UserService.cashBack({}).then(
      function success(resp) {
        $scope.usedCoupons = resp.coupons.usedCoupons;
        $scope.validCoupons = resp.coupons.validCoupons;
        $scope.redirect = resp.routes;
        PageLoadingService.off();
      },
      function error(resp){
        PageLoadingService.off();
      }
    );
  };



  $scope.redirectToPage = function (type) {
    $rootScope.userBarCurrent = '';
    if (type.flight) {
      window.location.href = $scope.redirect.flight;
    }
    else if (type.hotel) {
      window.location.href = $scope.redirect.hotel;
    }
    else if (type.package) {
      window.location.href = $scope.redirect.package;
    }
    else if (type.insurance) {
      window.location.href = $scope.redirect.package;
    }
  };

  $scope.loadCashBack();

}]);
;

// Source: ../shared/public_html/assets/js/user/controller/checkInCtrl.js
(function(angular) {
var CheckInController = function ($scope, $rootScope, $stateParams, CheckInService) {
var paxStrategies = {
            fru: function (data) {
                data['citizenship'] = data['citizenship'] || 'PL';
                data['doc_country'] = data['doc_country'] || 'PL';

                return data;
            }
        };

        var paxStrategy = function (affiliate, data) {
            data = data || {};

            if (angular.isDefined(paxStrategies[affiliate])) {
                return paxStrategies[affiliate](data);
            }

            return data;
        };

        $scope.showLoading = 1;
        $scope.finished = false;
        $scope.currentYear = new Date().getFullYear();
        $scope.maxDoc = { min: $scope.currentYear - 100, max: $scope.currentYear + 20 };
        $scope.agreements = 0;
        $scope.special_needs = 0;

        /**
         * Load Check in
         */
        $scope.loadCheckIn = function () {
            var data = {};
            data.id = $stateParams.checkId;
            data.ngData = 1;

            CheckInService.index(data).then(
                function success(response) {
                    $scope.showLoading = 0;

                    $scope.boarding_pass = response.boarding_pass;
                    for (var i = 0; i < $scope.boarding_pass.length; i++) {
                        $scope.boarding_pass[i] = paxStrategy($rootScope.affiliate, $scope.boarding_pass[i]);
                    }

                    $scope.reservation = response.reservation;
                    $scope.countries = response.countries;
                    $scope.finished = response.finished;
                    $scope.issued_date_req = response.issued_date_req;
                    $scope.birthdateRange = response.birthdateRange;
                    $scope.expireRange = response.expireRange;
                    $scope.issuedRangeCheck = response.issuedRange;
                }
            );
        };
        $scope.loadCheckIn();

        /**
         * Submit checkin
         * @param isValid
         * @param data
         */
        $scope.checkInSub = function (isValid, data) {
            if ($scope.finished) {
                return;
            }

            $scope.errors = 0;
            $scope.checkInLoading = 1;
            var newData = {};
            newData.id = $stateParams.checkId;
            newData.ngData = 1;
            newData.submit = 1;
            newData.customer = data;
            newData.agreements = $scope.agreements;
            newData.special_needs = $scope.special_needs;

            CheckInService.index(newData).then(
                function success(response) {

                    if (response.finished) {
                        $scope.finished = true;
                    } else {
                        $scope.errors = response.bp_errors;
                    }
                }
            ).finally(function () {
                $scope.checkInLoading = 0;
            });
        };

        /**
         * Get Error for Form
         * @param paxData
         * @param toCheck
         * @returns {*}
         */
        $scope.giveError = function (paxData, toCheck) {
            if ($scope.errors) {
                var index = paxData.index;
                if (typeof $scope.errors[index] !== 'undefined') {
                    if (angular.isArray(toCheck)) {
                        var errors = '';
                        var i = 0;
                        for (i; i < toCheck.length; i++) {
                            if (!angular.isUndefined($scope.errors[index][toCheck[i]])) {
                                errors += $scope.errors[index][toCheck[i]];
                            }
                        }
                        return errors;
                    } else {
                        if (!angular.isUndefined($scope.errors[index][toCheck])) {
                            return $scope.errors[index][toCheck];
                        }
                    }
                }
            }
            return '&nbsp;';
        };

        /**
         * Agreement Term click
         */
        $scope.agreementsClick = function () {
            if ($scope.agreements == 0) {
                $scope.agreements = 1;
            } else {
                $scope.agreements = 0;
            }
        };

        /**
         * Range Helper
         * @param min
         * @param max
         * @param step
         * @returns {Array}
         */
        $scope.range = function (min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };
    };

    CheckInController.$inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        'CheckInService'
    ];

    angular
        .module('user')
        .controller('checkInCtrl', CheckInController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/confirmationResendCtrl.js
angular.module('user')

.controller('confirmationResendCtrl',
['$scope', 'UserService', '$modalInstance', 'transactionId',
function ($scope, UserService, $modalInstance, transactionId) {
$scope.confirmationSent = 0;
  $scope.showLoading = false;
  $scope.modalInstance = $modalInstance;

  /**
   * Close Modal
   * @type {*}
   */
  $scope.closeModal = function () {
    $modalInstance.close();
  };

  /**
   * Resend Confirmation
   * @param isValid
   * @param formData
   */
  $scope.reConf = function (isValid, formData) {
    $scope.confirmationSent = 0;
    if (isValid) {
      $scope.showLoading = true;
      formData.transactionId = transactionId;
      UserService.reConfirmation(formData).then(
          function success(response) {
            if (response == 1) {
              $scope.confirmationSent = 1;
            } else {
              $scope.confirmationSent = 2;
            }
            $scope.showLoading = false;
          },
          function error() {
            $scope.confirmationSent = 2;
            $scope.showLoading = false;
          }
      );
    }
  };
}]);
;

// Source: ../shared/public_html/assets/js/user/controller/ith-booking-item.controller.js
(function(angular, moment) {
/**
     * @name        IthBookingItemController
     * @description Handles data inside the IthBookingItemComponent
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthBookingItemController = function ($modal, $location, $document, $timeout, $state, UserService, CheckInService, Dictionaries, AppConfig) {
        /**
         * Self reference.
         *
         * @type {IthBookingItemController}
         */
        var ctrl = this;

        /**
         * Open/closed state for flight details.
         *
         * @type {Boolean}
         */
        this.isExtended = false;

        /**
         * Dictionaries reference.
         *
         * @type {Dictionaries}
         */
        this.dictionaries = Dictionaries;

        /**
         * Toggles between showing/hiding flight details.
         *
         * @param {Number} id Flight id
         */
        this.toggleDetails = function () {
            ctrl.isExtended = !ctrl.isExtended;
        };

        /**
         * Get Hours.
         *
         * @param   {Number} min
         * @returns {Number}
         */
        this.getTimeHours = function (min) {
            if (min) {
                var hours = Math.floor(min / 60);
                return hours;
            }
        };

        /**
         * Get Minutes.
         *
         * @param   {Number} min
         * @returns {Number}
         */
        this.getTimeMinutes = function (min) {
            if (min) {
                var minutes = min % 60;
                return minutes;
            }
        };

        /**
         * Get Viewed.
         *
         * @param   {Number} timestamp
         * @returns {String}
         */
        this.getViewed = function (timestamp) {
            if (timestamp) {
                return moment(timestamp * 1000).fromNow();
            }

            return '';
        };

        /**
         * Small Date.
         *
         * @param data
         * @returns {String}
         */
        this.smallDate = function (data) {
            var date = moment(data).format('D MMM');
            return date;
        };

        /**
         * Big Date.
         *
         * @param data
         * @returns {String}
         */
        this.bigDate = function (data) {
            var date = moment(data).format('D MMMM, dddd');
            return date;
        };

        /**
         * Send Confirmation Email Modal.
         *
         * @param {String} id
         */
        this.sendConfirmation = function (id) {
            $modal.open({
                templateUrl: 'confirmationRe.html',
                controller: 'confirmationResendCtrl',
                windowClass: 'confirmationRe',
                resolve: {
                    transactionId: id
                }
            });
        };

        /**
         * Open Confirmation.
         *
         * @param {String} pnr
         */
        this.openConfirmation = function (pnr) {
            window.open(pnr.info.confirmation, '', 'width=960,height=600,toolbar=no,menubar=no,scrollbars=yes');
        };

      /**
       * Open checkin form.
       *
       * @param {String} pnr
       */
      this.getCheckinFormLink = function (pnr) {
        return $state.href('checkin_standalone', {checkId: pnr.info.hash});
      };

        /**
         * Opens the info modal and shows the response inside.
         *
         * @param {String} response
         */
        var openInfoModal = function (response) {
            $modal.open({
                templateUrl: 'infoModal.html',
                controller: 'userModalCtrl',
                windowClass: 'infoModal',
                resolve: {
                    getMessage: function () {
                        return response;
                    }
                }
            });
        };

        /**
         * Modify Reservation.
         *
         * @param {String} id
         */
        this.modify = function (id) {
            UserService.modifyRes(id).then(openInfoModal, openInfoModal);
        };

        /**
         * Cancel Reservatrion.
         *
         * @param {String} id
         */
        this.cancel = function (id) {
            UserService.cancelRes(id).then(openInfoModal, openInfoModal);
        };

        /**
         * Checks to see if check-in is enabled
         *
         * @returns {Boolean}
         */
        this.isCheckinEnabled = function () {
            var cond1 = CheckInService.isSelfCheckinEnabled();
            var cond2 = this.data.hasCheckinInformation === true;
            var checkinCheckDate = this.data.info.oneWay ? this.data.model.departure_date : this.data.model.return_date;
            var cond3 = moment(checkinCheckDate).isAfter(moment().subtract(1, 'days').startOf('day'));
            return cond1 && cond2 && cond3;
        };
    };

    IthBookingItemController.$inject = [
        '$modal',
        '$location',
        '$document',
        '$timeout',
        '$state',
        'UserService',
        'CheckInService',
        'Dictionaries',
        'appConfig'
    ];

    angular
        .module('user')
        .controller('BookingItemController', IthBookingItemController);

}(angular, moment));
;

// Source: ../shared/public_html/assets/js/user/controller/ith-history-item.controller.js
(function(angular) {
/**
   * @name        IthHistoryItemController
   * @description Handles data inside the IthHistoryItemComponent
   * @constructor
   * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
   */
  var IthHistoryItemController = function ($location) {
    /**
     * Small Date.
     *
     * @param date
     * @returns {String}
     */
    this.smallDate = function (date) {
      return moment(date, 'YYYY-MM-DD').format('D MMM');
    };

    /**
     * Redirects to internal link.
     * 
     * @param {String} link
     */
    this.redirect = function (link) {
      $location.url(link);
    };
  };

  IthHistoryItemController.$inject = [
    '$location'
  ];

  angular
    .module('user')
    .controller('HistoryItemController', IthHistoryItemController);
	
}(angular));;

// Source: ../shared/public_html/assets/js/user/controller/ith-profile-avatar.controller.js
(function (angular) {
/**
     * @name        IthProfileAvatarController
     * @description Handles data inside the IthProfileAvatarController
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthProfileAvatarController = function (Tools) {
        /**
         * Self reference.
         *
         * @type {IthProfileAvatarController}
         */
        var ctrl = this;

        /**
         * Set proper image by pax type and title.
         */
        function generateAvatarImage() {
            if (ctrl.paxType === null || ctrl.paxType === undefined) {
                ctrl.avatarImage = null;
                return;
            }

            var paxType = angular.copy(ctrl.paxType);

            if (!isNaN(paxType)) {
                // Pax type is in number format, convert
                paxType = Tools.customerPaxTypeTranslation(+paxType);
            }

            if (ctrl.paxTitle === 'MS' || ctrl.paxTitle === 'MRS') {
                ctrl.avatarImage = paxType + '-F';
            } else {
                ctrl.avatarImage = paxType + '-M';
            }
        }

        /**
         * Avatar image file name.
         *
         * @type {String}
         */
        this.avatarImage = null;

        // Generate avatar image on init and on changes
        this.$onInit = function () { generateAvatarImage(); };
        this.$onChanges = function () { generateAvatarImage(); };
    };

    IthProfileAvatarController.$inject = [
        'Tools'
    ];

    angular
        .module('user')
        .controller('ProfileAvatarController', IthProfileAvatarController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/ith-user-cashback.controller.js
(function (angular) {
/**
     * @name        IthUserCashbackController
     * @description Handles data inside the IthUserCashbackComponent
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthUserCashbackController = function ($scope, $filter, PriceFormatterService) {
        /**
         * Self reference
         */
        var ctrl = this;

        this.showCopiedToClipboardMessage = false;

        /**
         * Transforms a value to int.
         *
         * @param   {*} myAcc
         * @returns {int}
         */
        var toInt = function (myAcc) {
            var intValue = parseInt(myAcc);
            if (_.isNaN(myAcc)) {
                intValue = 0;
            }
            return intValue;
        };

        /**
         * Returns coupon value.
         *
         * @returns {Number}
         */
        this.getCouponValue = function () {
            var cpVal = 0;

            if (toInt(ctrl.data.coupon.flat_discount) > 0) {
                cpVal = ctrl.data.coupon.flat_discount;
            } else if (ctrl.data.couponType.flat_discount && !ctrl.data.coupon.flat_discount) {
                cpVal = ctrl.data.couponType.flat_discount;
            } else if (ctrl.data.couponType.percent_discount != 0) {
                cpVal = ctrl.data.couponType.percent_discount;
            }

            return cpVal;
        };

        /**
         * Returns currency or percent for coupon type.
         *
         * @returns {String}
         */
        this.getValueType = function () {
            return (ctrl.data.couponType.percent_discount != 0) ? '%' : ctrl.data.couponType.currency;
        };

        this.getPrice = function () {
            return PriceFormatterService.formatPrice(this.getCouponValue(), this.getValueType());
        };

        this.copyButtonClickHandler = function () {
            if (this.showCopiedToClipboardMessage) {
                return;
            }

            navigator.clipboard
                .writeText(ctrl.data.coupon.code)
                .then(function success() {
                    ctrl.showCopiedToClipboardMessage = true;
                    $scope.$apply();
                    // hide message delay
                    setTimeout(function () {
                        ctrl.showCopiedToClipboardMessage = false;
                        $scope.$apply();
                    }, 2000);

                }, function error() {
                    console.error('Failed to copy');
                });
        };
    };

    IthUserCashbackController.$inject = [
        '$scope',
        '$filter',
        'PriceFormatterService'
    ];

    angular
        .module('user')
        .controller('IthUserCashbackController', IthUserCashbackController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/myBookingsCtrl.js
(function (angular) {
var MyBookingsController = function ($scope, UserService, $location, $filter, PageLoadingService, $translate) {
        // Sets title of the page
        document.querySelector('title').innerHTML = $filter('translate')('LANGM_JS_MYBOOKINGS_TITLE');

        var getCanceledBookings = function (cancelledBookings, isPastDate) {
            var result = [];


            result = cancelledBookings.filter(function (booking) {
                return isPastDate
                    ? moment(booking.model.departure_date, 'YYYY-MM-DD').isBefore(moment())
                    : moment(booking.model.departure_date, 'YYYY-MM-DD').isAfter(moment());
            });

            result.forEach(function (booking) {
                booking.categoryInfo = {
                    status: 'cancelled',
                    label: $translate.instant('LANGM_JS_STATUS_CANCELLED')
                };
            });

            return result;
        };

        var buildTraveledBookings = function (resp) {
            var result = [];

            if (resp.pnrs.traveled) {
                result = result.concat(resp.pnrs.traveled);
            }

            if (resp.pnrs.cancelled) {
                result = result.concat(getCanceledBookings(resp.pnrs.cancelled, true));
            }

            result.forEach(function (booking) {
                booking.isTraveled = true;
            })

            result.sort(function (a, b) {
                return b.bookDate - a.bookDate;
            });

            return result;
        };

        var buildUpcomingBookings = function (resp) {
            var result = [];

            if (resp.pnrs.active) {
                result = result.concat(resp.pnrs.active);
            }

            if (resp.pnrs.issued) {
                result = result.concat(resp.pnrs.issued);
            }

            if (resp.pnrs.cancelled) {
                result = result.concat(getCanceledBookings(resp.pnrs.cancelled, false));
            }

            result.sort(function (a, b) {
                return b.bookDate - a.bookDate;
            });

            return result;
        };

        $scope.allBookings = [];
        $scope.images = []; // { code: string, path: string }[]
        $scope.translations = {};
        $scope.activeFilter = 'upcoming'; // upcoming | traveled
        $scope.isFound = false;
        $scope.tabs = [
            {
                name: $translate.instant('LANGM_JS_UPCOMING_TRIPS'),
                value: 'upcoming'
            },
            {
                name: $translate.instant('LANGM_JS_TRAVELED_TRIPS'),
                value: 'traveled'
            }
        ];

        $scope.getBookings = function () {
            UserService
                .myBookings({})
                .then(function success(resp) {
                    if (!resp.pnrs || !resp.cities) {
                        // Go to homepage
                        $location.url('');
                    }

                    $scope.allBookings = {
                        upcoming: buildUpcomingBookings(resp),
                        traveled: buildTraveledBookings(resp)
                    };
                    $scope.translations = resp.cities;
                    $scope.activeFilter = 'upcoming';

                    if (resp.pnrs.length === 0) { // no results
                        PageLoadingService.off();
                    } else {
                        $scope.isFound = true;
                        $scope.getLocationPictures($scope.getLocationPicturesPayload());
                    }
                }, function error() {
                    PageLoadingService.off();
                });
        };

        $scope.setFilter = function (filter) {
            $scope.activeFilter = filter.type;
        };

        $scope.getLocationPicturesPayload = function () {
            var result = [];
            var categories = Object.keys($scope.allBookings);

            categories.forEach(function (category) {
                $scope.allBookings[category].forEach(function (pnr) {
                    result.push(pnr.flights[0].destination);
                });
            });

            return {
                codes: result
            };
        };

        $scope.getLocationPictures = function (payload) {
            UserService
                .getLocationPictures(payload)
                .then(function success(resp) {
                    $scope.images = resp.data.response;
                    PageLoadingService.off();
                }, function error() {
                    PageLoadingService.off();
                });
        };

        $scope.getSrc = function (pnr) {
            return $scope.images.find(function (img) {
                return img.code === pnr.flights[0].destination;
            });
        };

        // init
        PageLoadingService.on();
        $scope.getBookings();
    };

    MyBookingsController.$inject = ['$scope', 'UserService', '$location', '$filter', 'PageLoading', '$translate'];

    angular
        .module('user')
        .controller('myBookings', MyBookingsController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/password-change-warring.controller.js
(function (angular) {
/**
   * @name        PasswordChangeWarningModal
   * @description Ctrl for changing pax configuration on pax details.
   */
  var PasswordChangeWarningModal = function ($modalInstance) {
    this.close = function () {
      $modalInstance.close();
    };
  };

  PasswordChangeWarningModal.$inject = [
    '$modalInstance',
  ];

  angular.module('user')
    .controller('PasswordChangeWarningModal', PasswordChangeWarningModal);

})(angular);




;

// Source: ../shared/public_html/assets/js/user/controller/preferencesCtrl.js
angular
    .module('user')
    .controller('preferencesCtrl', [
        '$scope',
        '$q',
        'PageLoading',
        'Locations',
        'ProfileSettingsService',
        'AuthGuard',
        'PreferencesDataService',
        'CATEGORIES',
        '$location',
        function (
            $scope,
            $q,
            PageLoadingService,
            Locations,
            ProfileSettingsService,
            AuthGuard,
            PreferencesDataService,
            CATEGORIES,
            $location
        ) {
            $scope.CATEGORIES = CATEGORIES;
            $scope.isDataLoaded = false;

            function isHashValid() {
                return Object
                    .values($scope.CATEGORIES)
                    .some(function (category) {
                        return $location.hash() === category;
                    });
            }

            function resetHash() {
                $location.hash(null);
            }

            $scope.setView = function (view) {
                $location.hash(view);
            };

            $scope.shouldRenderView = function (category) {
                return $scope.isDataLoaded && $location.hash() === category;
            };

            $scope.shouldRenderStartScreen = function () {
                return !isHashValid();
            };

            $scope.backInHistory = function () {
                window.history.back();
            };

            $scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
                if (!isHashValid()) {
                    resetHash();
                }
            });

            this.loadData = function () {
                $q
                    .all({
                        accountOwner: ProfileSettingsService.getProfile(),
                        buddies: ProfileSettingsService.getPassengers(),
                        billings: ProfileSettingsService.getBillings(),
                        countries: Locations.getCountries(true)
                    })
                    .then(function (responses) {
                        PreferencesDataService.setAccountOwner(responses.accountOwner);
                        PreferencesDataService.setTravelBuddies(responses.buddies);
                        PreferencesDataService.setBillings(responses.billings);
                        PreferencesDataService.setCountries(responses.countries);
                        PreferencesDataService.setIsEmailVerified(responses.accountOwner.response.verified_email);
                        PreferencesDataService.setIsOldPasswordExists(!responses.accountOwner.response.can_set_password);
                        PreferencesDataService.setIsInitialized(true);
                        $scope.isDataLoaded = true;
                        PageLoadingService.off();
                    });
            };

            // onInit
            if (AuthGuard.checkAuth()) {
                PageLoadingService.on();
                this.loadData();

                if (!$scope.isDataLoaded) {
                    resetHash();
                }
            }
        }]);
;

// Source: ../shared/public_html/assets/js/user/controller/regenerateTokenCtrl.js
(function() {
/**
     * @name        IthRegenerateTokenCtrl
     * @description Manages data on the generate token page
     * @constructor
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthRegenerateTokenCtrl = function ($scope, $stateParams, $location, AuthService) {
        /**
         * Error messages
         * @type {String}
         */
        $scope.error = '';

        /**
         * Regenerates a token for user by password
         * @param {String} pass
         */
        $scope.regenerateToken = function (pass) {
            $scope.error = '';

            AuthService.regenerateToken({
                password: pass,
                token: $stateParams.profileToken
            }).then(function (data) {

                if (data.success) {
                    $location.url(data.url);
                } else {
                    $scope.error = data.msg;
                }
            });
        };
    };

    IthRegenerateTokenCtrl.$inject = [
        '$scope',
        '$stateParams',
        '$location',
        'AuthService'
    ];

    angular
        .module('user')
        .controller('regenerateTokenCtrl', IthRegenerateTokenCtrl);

}());
;

// Source: ../shared/public_html/assets/js/user/controller/reset-password.controller.js
(function (angular) {
var ResetPasswordController = function (UserService, $state, AuthService2, API_STATUSES_USERS) {
        var self = this;

        this.formData = {
            password: '',
            passwordConfirm: ''
        };

        this.viewStates = {
            CHECKING_TOKEN: 'CHECKING_TOKEN',
            CHECKING_TOKEN_ERROR: 'CHECKING_TOKEN_ERROR',
            TOKEN_SERVER_ERROR: 'TOKEN_SERVER_ERROR',
            FORM: 'FORM',
            CHANGING_PASS: 'CHANGING_PASS',
            PASS_CHANGED: 'PASS_CHANGED',
            CHANGING_PASS_SERVER_ERROR: 'CHANGING_PASS_SERVER_ERROR'
        };

        this.checkingTokenServerErrorCode = null;
        this.viewState = this.viewStates.CHECKING_TOKEN;
        this.backendErrors = {};

        this.submit = function (form) {
            if (form.$invalid) {
                return;
            }

            this.backendErrors = {};
            this.viewState = this.viewStates.CHANGING_PASS;

            AuthService2.setNewPassword($state.params.hash, self.formData.password)
                .then(function (status) {
                    if (status === API_STATUSES_USERS.OK) {
                        self.viewState = self.viewStates.PASS_CHANGED;
                        return;
                    }

                    if (status === API_STATUSES_USERS.UNEXPECTED_ERROR) {
                        self.viewState = self.viewStates.TOKEN_SERVER_ERROR;
                        return;
                    }

                    self.viewState = self.viewStates.CHECKING_TOKEN_ERROR;
                    self.checkingTokenServerErrorCode = status;
                });
        };

        AuthService2.checkResetPasswordToken($state.params.hash).then(function(status) {
            if (status === API_STATUSES_USERS.OK) {
                self.viewState = self.viewStates.FORM;
                return;
            }

            if (status === API_STATUSES_USERS.UNEXPECTED_ERROR) {
                self.viewState = self.viewStates.TOKEN_SERVER_ERROR;
                return;
            }

            self.viewState = self.viewStates.CHECKING_TOKEN_ERROR;
            self.checkingTokenServerErrorCode = status;
        });
    };

    ResetPasswordController.$inject = ['UserService', '$state', 'AuthService2', 'API_STATUSES_USERS'];

    angular
        .module('base')
        .controller('ResetPasswordCtrl', ResetPasswordController);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/controller/setPasswordCtrl.js
angular.module('user')

    .controller('setPasswordCtrl',
        ['$scope', '$stateParams', '$window', 'AuthService',
            function ($scope, $stateParams, $window, AuthService) {
$scope.setNewPassword = function (pass, passRepeat) {
                    AuthService.setPassword({
                        password: pass,
                        password_confirm: passRepeat,
                        token: $stateParams.profileToken
                    }).then(function (data) {
                        if (data.success) {
                            $window.location.href = data.url;
                        }
                        else {
                            $scope.unsuccess = true
                        }
                    })
                }

            }]);
;

// Source: ../shared/public_html/assets/js/user/controller/userModalCtrl.js
angular.module('user')

.controller('userModalCtrl',
['$scope', '$translate', 'AuthService', 'UserService', '$modalInstance', '$modal', '$location', 'AuthService2', 'API_STATUSES_USERS', 'AuthGuard', 'appConfig',
function ($scope, $translate, AuthService, UserService, $modalInstance, $modal, $location, AuthService2, API_STATUSES_USERS, AuthGuard, appConfig) {
$scope.error = 0;
  $scope.confirmationSent = 0;
  $scope.showLoading = false;
  $scope.registerLoader = false;
  $scope.title = 'MR';
  $scope.nlSubscribe = false;
  $scope.modalInstance = $modalInstance;

  $scope.loginData = {
    email: '',
    pass: '',
    keep: false
  };

  $scope.registerData = {
    firstName: '',
    lastName: '',
    password: '',
    passwordConfirm: '',
    contactDetails: {
      email: '',
      phone: {
        prefix: '',
        number: ''
      }
    },
    terms: false,
    newsletterSubscribe: false
  };

  $scope.registerErrors = {};

  $scope.forgotPassData = {
    email: '',
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    token: null
  };

  $scope.forgotPassStatesEnum = {
    INITIAL: 'initial',
    LOADING: 'loading',
    ERROR: 'error',
    SUCCESS: 'success'
  };
  $scope.forgotPassState = $scope.forgotPassStatesEnum.INITIAL;
  $scope.forgotPassError = null;

  var openPasswordChangeWarningModal = function () {
    $modal.open({
      templateUrl: '/tpl/show/jsShared/templates/base/modals/passwordChangeWarningModal',
      controller: 'PasswordChangeWarningModal',
      controllerAs: '$ctrl',
      windowClass: 'flight-modal-message'
    });
  };

  /**
   * Open login form and login tabs
   */
  $scope.loginTab = 'register';

  $scope.switchTab = function (tab) {
    $scope.loginTab = tab;
  };

  /**
   * Close Modal
   * @type {*}
   */
  $scope.closeModal = function () {
    $modalInstance.close();
  };

  /**
   * Login Function
   */
  $scope.login = function (isValid) {
    $scope.showLoading = true;
    $scope.error = false;
    $scope.notActivated = false;
    $scope.accountBlocked = false;

    if (isValid) {
      AuthService2
        .login($scope.loginData)
        .then(function (responseObj) {
          if (responseObj.status === API_STATUSES_USERS.OK) {
            $scope.closeModal();

            if (responseObj.passwordChangeWarning === true) {
              openPasswordChangeWarningModal();
            }

            return;
          }

          if (responseObj.status === API_STATUSES_USERS.NOT_ACTIVATED) {
            $scope.notActivated = true;
            return;
          }

          if (responseObj.status === API_STATUSES_USERS.ACCOUNT_BLOCKED) {
            $scope.accountBlocked = true;
            return;
          }

          $scope.error = true;
        })
        .catch(function () {
          $scope.error = true;
        })
        .finally(function () {
          $scope.showLoading = false;
        });
    }
    else {
      $scope.error = true;
      $scope.showLoading = false;
    }
  };

  /**
   * @param {'facebook' | 'google' | 'apple'} provider
   */
  $scope.loginWithSocial = function (provider) {
      AuthService2.redirectToSocialLoginUrl(provider);
  };

  $scope.canRenderAppleButton = function () {
    // TODO: remove next line when apple auth on backend is ready
    return false;

    var uA = navigator.userAgent;
    var vendor = navigator.vendor;

    if (/Safari/i.test(uA) && /Apple Computer/.test(vendor)) {
      return true;
    }
  }

  $scope.loginForm = function () {
    $scope.closeModal();
    AuthService.showLoginModal();
  };

  /**
   * Switch To Register From
   */
  $scope.registerForm = function () {
    $scope.closeModal();
    AuthService.showRegisterModal();
  };

  /**
   * Switch To Register From
   */
  $scope.forgotPassForm = function () {
    $scope.closeModal();
    AuthService.showForgotPasswordModal();
  };

  /**
   * Forgot Password
   * @param isValid
   */
  $scope.forgotPass = function (isValid) {
    if (!isValid) {
      return;
    }

    $scope.forgotPassState = $scope.forgotPassStatesEnum.LOADING;
    $scope.forgotPassError = null;

    AuthService2
        .resetPassword($scope.forgotPassData.email)
        .then(function (status) {
          if (status === API_STATUSES_USERS.OK) {
            $scope.forgotPassState = $scope.forgotPassStatesEnum.SUCCESS;
            return;
          }

          if (status === API_STATUSES_USERS.USER_NOT_EXISTS) {
            $scope.forgotPassState = $scope.forgotPassStatesEnum.ERROR;
            $scope.forgotPassError = $translate.instant('LANGM_JS_NO_ACCOUNT_FOR_PROVIDED_EMAIL');
            return;
          }

          $scope.forgotPassState = $scope.forgotPassStatesEnum.ERROR;
        });
  };

  /**
   * Delete Account
   * @param isValid
   * @param formData
   */
  $scope.deleteAccount = function (isValid, formData) {
    $scope.error = 0;
    if (isValid) {
      UserService.profileDelete(formData).then(
        function success(response) {
          if (response.status == 'ok') {
            $scope.error = 0;
            $modalInstance.close();
            AuthService.logout().then(function success() {
              $location.path('');
            });
          }
          else {
            $scope.error = 1;
          }

        },
        function error(response) {
          $scope.error = 1;
        }
      );
    }
  };

  /**
   * Register Submit
   */
  $scope.register = function (isValid) {
    $scope.registerSucces = false;

    if (!isValid || !$scope.registerData.terms) {
      return;
    }

    $scope.registerLoader = true;

    AuthService2
        .register(
            $scope.registerData.contactDetails.email,
            $scope.registerData.password,
            $scope.registerData.terms,
            $scope.registerData.newsletterSubscribe
        ).then(function (status) {
          if (status === API_STATUSES_USERS.OK) {
            $scope.registerErrors = {};
            $scope.registerSucces = true;
            return;
          }

          if (status === API_STATUSES_USERS.USER_EXISTS) {
            $scope.registerErrors = {
              contact: { email: $translate.instant('LANGM_JS_ACCOUNT_FOR_PROVIDED_EMAIL_ALREADY_EXISTS') }
            };
            $scope.registerSucces = false;
            return;
          }

          $scope.registerSucces = false;
        })
        .finally(function () {
          $scope.registerLoader = false;
        });
  };

  $scope.logout = function () {
    AuthService2.logout().then(function() {
      AuthService.logout().then(function() {
        AuthGuard.redirectToMainPage();
      });
    });
  };
}]);
;

// Source: ../shared/public_html/assets/js/user/directives/liveTranslate.js
var idOfLiveTranslateExecuted = 'liveTranslateModule';

angular.module('user')
/**
 * @name        liveTranslate
 * @description Module for admins to translate langs and textboxes directly on page. Needs directive liveTranslateCtrlHandler to work.
 */
    .directive('liveTranslate', ['$http', '$compile', function ($http, $compile) {
var urlSwitchEditLangMode = "/liveTranslate/switchEditLangMode",
            urlGenerateLangs = '/lang/generatelangs',
            urlSaveLangs = "/lang/savelang",
            getLangFormUrl = '/lang/getlangform?lang_key=',
            getTextboxUrl = '/text_box/getcontentbox?id=',
            saveTextboxUrl = '/text_box/savecontentbox',
            langFormClass = 'lang-form',
            langFormInputsClass = 'edit_lang_translate',
            popupContentClass = 'liveTranslate-form-content',
            textboxWrapDivIdPrefix = 'edit_contentbox-text-',
            langTextId = 0;

        return {
            restrict: 'E',
            replace: false,
            priority: 900,
            templateUrl: function (element, attrs) {
                return 'tpl/show/jsShared/templates/user/directives/liveTranslate-hyb';
            },
            controller: ['$scope', '$http', '$httpParamSerializerJQLike', function ($scope, $http, $httpParamSerializerJQLike) {
                var RemoveLiveTemplatesTagsFromA = function () {
                    var aTags = angular.element(document.getElementsByTagName('a'));
                    angular.forEach(aTags, function (value, key) {
                        value.href = value.href.replace(/%3C\/?.*?%3E/g, '').replace(/<lang.*?>/g, '').replace(/<\/lang>/g, '').replace(/\/&lt;lang.*?&gt;/g, '').replace(/&lt;\/lang&gt;/g, ''); //remove liveTranslate additional spans from "href" attr
                        value.innerHTML = value.innerHTML.replace(/&lt;lang/g, '<lang').replace(/\&lt;\/lang&gt;/g, '</lang>').replace(/lang&gt;/g, 'lang>');
                        RemoveWrapperFromAttributes(value);
                        $compile(angular.element(value).find('lang'))($scope);
                    });
                };
                var RemoveWrapperFromAttributes = function (value) {
                    angular.forEach(value.attributes, function (attribut, key) {
                        attribut.value = attribut.value.replace(/%3C\/?.*?%3E/g, '').replace(/<lang.*?>/g, '').replace(/<\/lang>/g, ''); //remove liveTranslate additional spans from attributes
                    });
                };
                var FixLiveTemplatesBrokenLangTag = function () {
                    replaceEntitiesInLangElements(angular.element(document.getElementsByTagName('*')));
                    recompileAllLangElements();
                };
                var replaceEntitiesInLangElements = function (elements) {
                    var regExp = new RegExp(/&lt;lang/);
                    angular.forEach(elements, function (value, key) {
                        if (regExp.test(value.innerHTML) && value.innerHTML.length < 2000) {
                            value.innerHTML = value.innerHTML.replace(/&lt;lang/g, '<lang').replace(/\&lt;\/lang&gt;/g, '</lang>').replace(/&gt;/g, '>');
                        }
                    });
                };
                var recompileAllLangElements = function () {
                    $compile(angular.element(document.getElementsByTagName('lang')))($scope);
                };
                var FixPlaceholders = function () {
                    var inputElements = angular.element(document.getElementsByTagName('input'));
                    var textareaElements = angular.element(document.getElementsByTagName('textarea'));
                    removeLiveTranslateTagFromPlaceholders(inputElements);
                    removeLiveTranslateTagFromPlaceholders(textareaElements);
                };
                var RunFixingRegexp = function () {
                    if (angular.element(document.getElementsByClassName('liveTranslate-panel')).hasClass('panel-on')) {
                        RemoveLiveTemplatesTagsFromA();
                        FixPlaceholders();
                        FixLiveTemplatesBrokenLangTag();
                    }
                };
                var removeLiveTranslateTagFromPlaceholders = function (elements) {
                    angular.forEach(elements, function (value, key) {
                        value.placeholder = value.placeholder.replace(/<lang.*?>/g, '').replace(/<\/lang>/g, ''); //remove liveTranslate additional spans from "placeholder" attr
                    });
                };
                var popupContentElement = function () {
                    return document.getElementsByClassName(popupContentClass);
                };
                var showLangPopup = function (event) {
                    $scope.langKey = event.target.attributes.default.value;
                    $scope.liveTranslateFormShow = true;
                    $scope.displayLoader = true;
                };
                var hideLangPopup = function () {
                    angular.element(popupContentElement()).html('');
                    $scope.liveTranslateFormShow = false;
                    $scope.displayLoader = false;
                };

                var searchClosestLangTag = function (element) {
                    var searchTagName = 'lang';
                    var langElement = '';
                    if (element.tagName == searchTagName) {
                        langElement = element;
                    } else {
                        if (element.getElementsByTagName(searchTagName).length) {
                            langElement = element.getElementsByTagName(searchTagName)[0];
                        } else {
                            langElement = element.parentNode.getElementsByTagName(searchTagName)[0];
                        }
                    }
                    return langElement;
                };

                $scope.showLangForm = function (event) {
                    if (!$scope.liveTranslateFormShow && event.ctrlKey) {
                        try {
                            var langElement = searchClosestLangTag(event.target);
                            var langKey = langElement.attributes.default.value;
                            var url = getLangFormUrl + langKey;
                            var newEvent = {target: langElement};
                            showLangPopup(newEvent);
                            $scope.widgetTextbox = false;
                        } catch (e) {
                            throw 'ERROR: liveTranslate::showLang';
                        }


                        $http.get(url).success(function (response) {
                            angular.element(popupContentElement()).html(response);
                            document.querySelector('[langid=EN]').focus();
                        });
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                $scope.showTextboxForm = function (event) {
                    if (!$scope.liveTranslateFormShow) {
                        try {
                            var textboxId = event.target.attributes.id.value;
                            var url = getTextboxUrl + textboxId;
                            showLangPopup(event);
                        } catch (e) {
                            throw 'ERROR: liveTranslate::showTextbox';
                        }

                        $http.get(url).success(function (response) {
                            $scope.widgetTinymceModel = response;
                            $scope.widgetTextbox = true;
                            langTextId = textboxId;
                        });
                    }
                };

                $scope.tinymceOptions = {
                    resize: false,
                    width: 600,
                    height: 300,
                    plugins: 'code',
                    verify_html: false
                };
                $scope.switchEditLangMode = function () {
                    $http.get(urlSwitchEditLangMode).success(function () {
                        window.location.reload();
                    });
                };
                $scope.generateLangs = function () {
                    $scope.displayLoader = true;
                    $http.get(urlGenerateLangs).success(function () {
                        window.location.reload();
                    });
                };
                $scope.popupClose = function () {
                    hideLangPopup();
                };
                $scope.saveShortcut = function (event) {
                    if (event.ctrlKey && event.keyCode == 13) {
                        $scope.popupLangSave();
                    }
                    if (event.keyCode == 27) {
                        $scope.popupClose();
                    }
                };
                $scope.popupLangSave = function () {
                    var values = {};
                    var langInputs = document.getElementsByClassName(langFormInputsClass);
                    try {
                        var langKey = document.getElementsByClassName(langFormClass)[0].attributes.lang.value;
                        for (var i = 0; i < langInputs.length; i++) {
                            values[langInputs[i].attributes.langId.value] = encodeURIComponent(langInputs[i].value);
                            langInputs[i].disabled = true;
                        }
                    } catch (e) {
                        throw 'ERROR: liveTranslate::save';
                    }

                    $http({
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                        method: "post",
                        url: urlSaveLangs,
                        data: $httpParamSerializerJQLike({
                            oper: 'edit',
                            value: values,
                            lang_key: langKey
                        })
                    }).success(function () {
                        try {
                            var currentLanguage = _js_app_config_.language_code.toUpperCase();
                            document.querySelector('lang[default="' + langKey + '"]').innerHTML = decodeURIComponent(values[currentLanguage]);
                            $scope.popupClose();
                        } catch (e) {
                            window.location.reload();
                        }
                    });
                };
                $scope.popupTextboxSave = function () {
                    if (langTextId > 0) {
                        $http({
                            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                            method: "post",
                            url: saveTextboxUrl,
                            data: $httpParamSerializerJQLike({
                                id: langTextId,
                                text: $scope.widgetTinymceModel
                            })
                        }).success(function () {
                            try {
                                document.getElementById(textboxWrapDivIdPrefix + langTextId).innerHTML = $scope.widgetTinymceModel;
                                $scope.popupClose();
                            } catch (e) {
                                window.location.reload();
                            }
                        });
                    }
                };

                $scope.renderLangs = function (event) {
                    FixLiveTemplatesBrokenLangTag();
                    event.preventDefault();
                    event.stopPropagation();
                };

                RunFixingRegexp();
            }]
        };
    }]);

angular.module('user')
/**
 * @name        liveTranslateCtrlHandler
 * @description Handle crt click and underline lang phrases. Part of Module for admins to translate langs and textboxes directly on page
 */
    .directive('liveTranslateCtrlHandler', ['$rootScope', function ($rootScope) {
return {
            restrict: 'A',
            replace: false,
            link: function ($scope, element, attrs, formController) {
                if (typeof angular.element(document.getElementById(idOfLiveTranslateExecuted))[0] != 'undefined') {
                    var bodyElement = angular.element(document.body),
                        bodyClass = 'liveTranslate-underline';

                    var isCtrlClicked = function (event) {
                        return (event.keyCode == 17);
                    };

                    element.bind("keydown", function (event) {
                        if (isCtrlClicked(event)) {
                            bodyElement.addClass(bodyClass);
                            event.preventDefault();
                        }
                    });
                    element.bind("keyup", function (event) {
                        if (isCtrlClicked(event)) {
                            bodyElement.removeClass(bodyClass);
                            event.preventDefault();
                        }
                    });
                }
            }
        }
    }]);

angular.module('user')
/**
 * @name        ngClick
 * @description Handle crt click on buttons etc. to prevent ng-click on that button
 */
    .directive('ngClick', ['$rootScope', function ($rootScope) {
return {
            restrict: 'A',
            priority: 500,
            link: function (scope, element, attr) {
                if (typeof angular.element(document.getElementById(idOfLiveTranslateExecuted))[0] != 'undefined') {
                    element.bind('click', function (event) {
                        if (event.ctrlKey) {
                            $rootScope.showLangForm(event);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    })
                }
            }
        }
    }]);

if (location.hostname == 'red.flyhacks.com' || location.hostname == 'red.vola.ro' || location.hostname == 'fru.local') {
    angular.module('user')
        .directive('translate', ['$rootScope', 'u.untranslatedLangsSrv', function ($rootScope, $untranslatedLangsSrv) {
return {
                restrict: 'AE',
                scope: true,
                priority: -1,
                compile: function (tElement, tAttr) {
                    var getQuery = {};
                    location.search.substr(1).split("&").forEach(function (item) {
                        getQuery[item.split("=")[0]] = item.split("=")[1]
                    });

                    if (tElement[0].innerHTML.length > 0) {
                        var innerString = tElement[0].innerHTML.trim();
                        var re = new RegExp(/LANG[_A-Z0-9]+/);
                        var langRegexp = innerString.match(re);
                        if (langRegexp !== null && typeof _js_app_config_._js_langs_[langRegexp[0]] === 'undefined') {
                            $untranslatedLangsSrv.add(langRegexp[0]);
                        }
                    }
                }
            }
        }]);

    angular.module('user')
        .filter('translate', ['$translate', 'u.untranslatedLangsSrv', function ($translate, $untranslatedLangsSrv) {
            return function (translationId, interpolateParams, interpolation) {
                var translatedLang = $translate.instant(translationId, interpolateParams, interpolation);
                var getQuery = {};
                location.search.substr(1).split("&").forEach(function (item) {
                    getQuery[item.split("=")[0]] = item.split("=")[1]
                });

                if (translationId && translationId.length > 0) {
                    var innerString = translationId.trim();
                    var re = new RegExp(/LANG[_A-Z0-9]+/);
                    var langRegexp = innerString.match(re);
                    if (langRegexp !== null && langRegexp[0] == translatedLang) {
                        $untranslatedLangsSrv.add(langRegexp[0]);
                    }
                }
                return translatedLang;
            };
        }]);

    angular.module('user').factory('u.untranslatedLangsSrv', ['ApiTools', '$timeout', function (ApiTools, $timeout) {
        function textParser(response) {
            return response.response;
        }

        var untranslatedLangs = function () {
            var untranslatedLangs = [];
            var checkingInterval;
            var delayTime = 500;
            var endpoints = {
                add: {url: 'untranslated_lang/addJsLang', method: 'POST', respParser: textParser}
            };

            this.run = function () {
                var data = {
                    url: location.pathname,
                    langs: untranslatedLangs
                };
                if (checkingInterval) {
                    clearTimeout(checkingInterval);
                }
                checkingInterval = $timeout(function () {
                    ApiTools
                        .fetch(untranslatedLangs, endpoints.add, data);
                }, delayTime);
            };

            this.add = function (lang) {
                if (untranslatedLangs.indexOf(lang) == -1) {
                    untranslatedLangs.push(lang);
                    this.run();
                }
            };
        };

        return new untranslatedLangs();
    }]);
}
;

// Source: ../shared/public_html/assets/js/user/directives/myBookings.js
angular.module('user')

/**
 * @name        myBookings
 * @description
 */
.directive('myBookings',
['$timeout',
function myBookings($timeout) {
return {
    restrict: 'E',
    templateUrl: 'tpl/show/jsShared/templates/user/directives/myBookings'
  };

}]);
;

// Source: ../shared/public_html/assets/js/user/directives/toBasket.js
angular.module('user')

/**
 * @name        toBasket
 * @description directive for toBasket zone
 */
.directive('toBasket',
[
function () {
return {

    restrict: 'EA',
    templateUrl: function (el, attr) {
      return 'tpl/show/jsShared/templates/user/directives/toBasket-hyb';
    },
    replace: false,
    controller: ['$scope', '$rootScope', '$state', 'BackToBasket', function ($scope, $rootScope, $state, BackToBasket) {

      $scope.toBasket = BackToBasket.getData();
      $scope.showToBasketMenu = false;

      /**
       * Format Date
       * @param date
       * @returns {*}
       */
      $scope.formatDate = function (date) {
        return moment(date).format('DD MMM');
      };

      /**
       * Format Date
       * @param date
       * @returns {*}
       */
      $scope.formatDate2 = function (date) {
        return moment(date).format('MMM');
      };
    }]
  };
}]);

;

// Source: ../shared/public_html/assets/js/user/ith-profile-manage-box.component.js
(function(angular) {
var template = '\
        <div class="basicBox profile-manage-box">\
            <div class="basicBox__container">\
                <div class="profile-manage-box__content">\
                    <h4 class="profile-manage-box__title">{{ $ctrl.title }}</h4>\
                    <div ng-transclude="content"></div>\
                </div>\
                <div class="profile-manage-box__actions">\
                    <div ng-transclude="actions"></div>\
                </div>\
            </div>\
        </div>\
    ';

    angular
        .module('user')
        .component('ithProfileManageBox', {
            template: template,
            transclude: {
                content: 'contentPane',
                actions: '?actionsPane'
            },
            bindings: {
                title: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/booking-ancillary-buttons.component.js
(function (angular) {
var template = '\
        <div class="booking-ancillary-buttons">\
            <button \
                ng-if="!$ctrl.isCancelled && !$ctrl.isTraveled"\
                class="booking-ancillary-buttons__button"\
                translate\
                ng-click="$ctrl.modifyClickHandler()" \
            >\
                LANGM_JS_BOOKIGNS_MODIFY\
            </button>\
            <button \
                ng-if="!$ctrl.isCancelled" \
                class="booking-ancillary-buttons__button"\
                translate\
                ng-click="$ctrl.sendByEmailClickHandler()" \
            >\
                LANGM_JS_BOOKIGNS_EMAIL\
            </button>\
            <button \
                class="booking-ancillary-buttons__button"\
                translate\
                ng-click="$ctrl.seeDetailsClickHandler()" \
            >\
                LANGM_JS_BOOKIGNS_SEE_DETAILS\
            </button>\
            <button \
                ng-if="$ctrl.isTicketed"\
                class="booking-ancillary-buttons__button"\
                translate\
                ng-click="$ctrl.cancelClickHandler()" \
            >\
                LANGM_JS_BOOKIGNS_CANCEL\
            </button>\
            <a \
                ng-if="$ctrl.isCheckinEnabled()"\
                ng-href="{{ $ctrl.getCheckinFormLink($ctrl.pnr) }}"\
                target="_blank"\
                class="booking-ancillary-buttons__button"\
                translate\
            >\
                LANGM_JS_BOOKIGNS_CHECK_IN\
            </a>\
        </div>\
    ';

    var controller = function ($modal, $state, UserService, CheckInService) {
        this.isCancelled = this.pnr.info.isCancelled;
        this.isTicketed = this.pnr.info.isTicketed;
        this.isTraveled = this.pnr.isTraveled;
        this.transactionId = this.pnr.model.transaction_id;

        var openInfoModal = function (response) {
            $modal.open({
                templateUrl: 'cancelBookingModal.html',
                controller: 'CancelBookingModal',
                resolve: {
                    cancelMessage: function () {
                        return response;
                    }
                }
            });
        };

        this.isCheckinEnabled = function () {
            var cond1 = CheckInService.isSelfCheckinEnabled();
            var cond2 = this.pnr.hasCheckinInformation;
            var checkinCheckDate = this.pnr.info.oneWay ? this.pnr.model.departure_date : this.pnr.model.return_date;
            var cond3 = moment(checkinCheckDate).isAfter(moment().subtract(1, 'days').startOf('day'));

            return cond1 && cond2 && cond3;
        };

        this.getCheckinFormLink = function (pnr) {
            return $state.href('checkin_standalone', {checkId: pnr.info.hash});
        };

        this.sendByEmailClickHandler = function () {
            $modal.open({
                templateUrl: 'confirmationRe.html',
                controller: 'confirmationResendCtrl',
                windowClass: 'confirmationRe',
                resolve: {
                    transactionId: this.transactionId
                }
            });
        };

        this.seeDetailsClickHandler = function () {
            window.open(this.pnr.info.confirmation, '', 'width=960,height=600,toolbar=no,menubar=no,scrollbars=yes');
        };

        this.modifyClickHandler = function () {
            $modal.open({
                controller: 'ModifyBookingModal',
                size: 'lg',
                resolve: {
                    pnr: this.pnr
                },
                template: '\
                    <ith-modal-layout title="{{ \'LANGM_JS_BOOKIGNS_MODIFY\' | translate }}" instance="modalInstance">\
                        <article ng-if="viewState === viewStates.LOADING_PROFILE_INFO" class="ng-animate-disabled">\
                            <ith-preloader><span translate>LANGM_JS_LOADING</span></ith-preloader>\
                        </article>\
                        <article ng-if="viewState === viewStates.FORM_ACTIVE" class="ng-animate-disabled">\
                            <ith-contact-form-email\
                                is-profile="true"\
                            ></ith-contact-form-email>\
                        </article>\
                    </ith-modal-layout>\
                '
            });
        };

        this.cancelClickHandler = function (id) {
            UserService.cancelRes(this.transactionId).then(openInfoModal, openInfoModal);
        };
    };

    controller.$inject = [
        '$modal',
        '$state',
        'UserService',
        'CheckInService'
    ];

    angular
        .module('user')
        .component('bookingAncillaryButtons', {
            template: template,
            controller: controller,
            bindings: {
                pnr: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/booking-item.component.js
(function (angular) {
var template = '\
        <div class="booking-item tile-box">\
            <div class="booking-item__mobile">\
                <image-with-label \
                    img-src="$ctrl.imgSrc"\
                    category-info="$ctrl.pnr.categoryInfo"\
                ></image-with-label>\
                <div class="booking-item__info-holder">\
                    <div class="booking-item__info-holder-content">\
                        <div>\
                            <p class="mmb-text-light" translate>LANGM_JS_PACK_DESC_LOCATION</p>\
                            <p class="mmb-text-dark">\
                                <span>{{ $ctrl.fromCode }}</span>\
                                <direction-arrows is-ow="$ctrl.isOw"></direction-arrows>\
                                <span>{{ $ctrl.toCode }}</span>\
                            </p>\
                        </div>\
                        <div>\
                            <p class="mmb-text-light" translate>LANGM_JS_BOOKING_NUMBER</p>\
                            <p class="mmb-text-dark">{{ $ctrl.bookingNumber }}</p>\
                        </div>\
                        <passengers-count-indicator pax-count="$ctrl.paxCount"></passengers-count-indicator>\
                        <travel-date-info \
                            heading-text="{{ \'LANGM_JS_DEPARTURE_DATE\' | translate }}"\
                            formatted-date="$ctrl.originDepDateFormatted"\
                        ></travel-date-info>\
                        <travel-date-info \
                            heading-text="{{ \'LANGM_JS_RETURN_DATE\' | translate }}"\
                            formatted-date="$ctrl.backArrDateFormatted"\
                        ></travel-date-info>\
                    </div>\
                </div>\
                \
                <div class="booking-item__details-btn-holder">\
                    <more-details-button \
                        is-open="$ctrl.isExpanded" \
                        ng-click="$ctrl.moreDetailsClickHandler()"\
                    ></more-details-button>\
                </div>\
            </div>\
            \
            <div class="booking-item__desktop">\
                <div class="booking-item__desktop-inner">\
                    <more-details-button \
                        is-open="$ctrl.isExpanded" \
                        ng-click="$ctrl.moreDetailsClickHandler()"\
                    ></more-details-button>\
                    <image-with-label \
                        img-src="$ctrl.imgSrc"\
                        category-info="$ctrl.pnr.categoryInfo"\
                    ></image-with-label>\
                    <div class="booking-item__plane-icon">\
                        <svg-icon id="plane-icon3"></svg-icon>\
                    </div>\
                    <div class="min-w-110">\
                        <p class="mmb-text-light" translate>LANGM_JS_PACK_DESC_LOCATION</p>\
                        <p class="mmb-text-dark">\
                            <span>{{ $ctrl.fromCode }}</span>\
                            <direction-arrows is-ow="$ctrl.isOw"></direction-arrows>\
                            <span>{{ $ctrl.toCode }}</span>\
                        </p>\
                    </div>\
                    <travel-date-info \
                        heading-text="{{ \'LANGM_JS_DEPARTURE_DATE\' | translate }}"\
                        formatted-date="$ctrl.originDepDateFormatted"\
                    ></travel-date-info>\
                    <travel-date-info \
                        heading-text="{{ \'LANGM_JS_RETURN_DATE\' | translate }}"\
                        formatted-date="$ctrl.backArrDateFormatted"\
                    ></travel-date-info>\
                    <div>\
                        <p class="mmb-text-light" translate>LANGM_JS_BOOKING_NUMBER</p>\
                        <p class="mmb-text-dark">{{ $ctrl.bookingNumber }}</p>\
                    </div>\
                    <passengers-count-indicator pax-count="$ctrl.paxCount"></passengers-count-indicator>\
                </div>\
                \
                <div class="booking-item__pay-button booking-item__pay-button--desktop">\
                    <pay-button-with-price \
                        ng-if="$ctrl.canShowPayButton" \
                        pnr="$ctrl.pnr"\
                        hash="$ctrl.hash"\
                    ></pay-button-with-price>\
                </div>\
            </div>\
            \
            <expandable without-button="true">\
                <div ng-repeat="flight in $ctrl.pnr.flights" class="booking-item__flight-details">\
                    <ith-mmb-flight-details flight="flight" cities="$ctrl.translations"></ith-mmb-flight-details>\
                </div>\
                <booking-ancillary-buttons pnr="$ctrl.pnr"></booking-ancillary-buttons>\
            </expandable>\
            \
            <div class="booking-item__pay-button booking-item__pay-button--mobile">\
                <pay-button-with-price \
                    ng-if="$ctrl.canShowPayButton" \
                    pnr="$ctrl.pnr"\
                    hash="$ctrl.hash"\
                ></pay-button-with-price>\
            </div>\
        </div>\
    ';

    var controller = function ($translate, $scope) {
        var ctrl = this;
        this.isOw = this.pnr.info.oneWay;
        this.bookingNumber = this.pnr.model.reservation_number;
        this.paxCount = this.pnr.search.pax.length;
        this.fromCode = this.pnr.flights[0].origin;
        this.toCode = this.pnr.flights[0].destination;
        this.canShowPayButton = !this.pnr.info.isCancelled && !this.pnr.info.isTicketed && !this.pnr.isPayed && !this.pnr.isTraveled;

        this.hash = this.pnr.info.hash;

        this.originDepDateInStringFormat = this.pnr.model.departure_date;
        this.originDepDate = this.pnr.flights[0].departureTime;
        this.originDepDateFormatted = moment(this.originDepDateInStringFormat).format('ddd') + ', ' + this.originDepDate.day + '.' + this.originDepDate.month + '.' + this.originDepDate.year;
        this.backArrDateInStringFormat = this.isOw ? null : this.pnr.model.return_date;
        this.backArrDate = this.isOw ? null : this.pnr.flights[1].arrivalTime;
        this.backArrDateFormatted = this.isOw
            ? $translate.instant('LANGM_JS_ONE_WAY')
            : moment(this.backArrDateInStringFormat).format('ddd') + ', ' + this.backArrDate.day + '.' + this.backArrDate.month + '.' + this.backArrDate.year;

        this.isExpanded = false;

        this.moreDetailsClickHandler = function () {
            $scope.$broadcast('expandable.toggleExpansion');
            this.isExpanded = !this.isExpanded;
        };

    };

    controller.$inject = [
        '$translate',
        '$scope'
    ];

    angular
        .module('user')
        .component('bookingItem', {
            template: template,
            controller: controller,
            bindings: {
                pnr: '<',
                imgSrc: '<',
                translations: '<',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/direction-arrows.component.js
(function (angular) {
var template = '\
        <span class="direction-arrows">\
            <span \
                ng-if="!$ctrl.isOw" \
                class="direction-arrows__arrow-svg"\
            >\
                <svg-icon id="double-arrows"></svg-icon>\
            </span>\
            \
            <span \
                ng-if="$ctrl.isOw" \
                class="direction-arrows__arrow-svg direction-arrows__arrow-svg--single"\
            >\
                <svg-icon id="single-arrow"></svg-icon>\
            </span>\
        </span>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('directionArrows', {
            template: template,
            controller: controller,
            bindings: {
                isOw: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/flight-details-stops.component.js
(function (angular) {
var template = '\
        <span>\
            <span ng-if="$ctrl.flight.direct" translate>LANGM_JS_FL_DIRECT</span>\
            <span ng-if="$ctrl.flight.noStops === 1 && !$ctrl.flight.direct">\
                <span translate>LANGM_JS_STOP</span>\
                <span>{{ $ctrl.flight.stops }}</span>\
            </span>\
            <span ng-if="$ctrl.flight.noStops > 1 && !$ctrl.flight.direct">\
                <span translate translate-values="{ stops: $ctrl.flight.noStops }">LANGM_JS_STOPS</span>\
                <span>{{ $ctrl.flight.stops }}</span>\
            </span>\
        </span>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('flightDetailsStops', {
            template: template,
            controller: controller,
            bindings: {
                flight: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/image-with-label.component.js
(function (angular) {
var template = '\
        <div class="image-with-label__image-holder">\
            <div \
                ng-if="$ctrl.categoryInfo"\
                class="image-with-label__image-label"\
                ng-class="{ \
                    \'image-with-label__image-label--cancelled\': $ctrl.categoryInfo.status === \'cancelled\'\
                }"\
            >\
                <span>{{ $ctrl.categoryInfo.label }}</span>\
            </div>\
            \
            <img \
                ng-src="{{ $ctrl.baseUrl + $ctrl.imgSrc.path }}" \
                alt=""\
            />\
        </div>\
    ';

    var controller = function (appConfig) {
        this.baseUrl = appConfig.isEnvLocal() ? 'https://en-tstx.fru.pl/' : '';
    };

    controller.$inject = [
        'appConfig'
    ];

    angular
        .module('user')
        .component('imageWithLabel', {
            template: template,
            controller: controller,
            bindings: {
                categoryInfo: '<',
                imgSrc: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/mmb-flight-details.component.js
(function (angular) {
var itemTemplate = '\
        <div class="ith-mmb-flight-details">\
            <div class="ith-mmb-flight-details__date">\
                <span class="ith-mmb-flight-details__date-text">{{ $ctrl.getDate($ctrl.flight.departureTime) | date:\'EEE, dd.MM.yyyy\' }}</span>\
            </div>\
            <div class="ith-mmb-flight-details__travel-from">\
                <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.getCityName($ctrl.flight.origin) }}</p>\
                <p class="ith-mmb-flight-details__info ith-mmb-flight-details__info--margin-bottom">{{ $ctrl.getAirportName($ctrl.flight.origin) }}</p>\
                <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.flight.departureTime.hour }}:{{$ctrl.flight.departureTime.minute}}</p>\
                <p class="ith-mmb-flight-details__info">{{ $ctrl.getDate($ctrl.flight.departureTime) | date:\'EEE, dd.MM.yyyy\' }}</p>\
            </div>\
            <div class="ith-mmb-flight-details__stops-arrow">\
                <div class="ith-mmb-flight-details__arrow">\
                    <span class="ith-mmb-flight-details-graphic__stop ith-mmb-flight-details-graphic__stop--termination-point"></span>\
                    <div class="ith-mmb-flight-details-graphic" ng-if="!$ctrl.flight.direct">\
                        <span class="ith-mmb-flight-details-graphic__stop" ng-repeat="n in [].constructor($ctrl.flight.noStops) track by $index"></span>\
                    </div>\
                    <div class="ith-mmb-flight-details-graphic" ng-if="$ctrl.flight.direct">\
                    </div>\
                    <span class="ith-mmb-flight-details-graphic__stop ith-mmb-flight-details-graphic__stop--termination-point"></span>\
                </div>\
                <div>\
                    <span>{{ $ctrl.getDurationFormatted($ctrl.flight.duration) }}, </span>\
                    <flight-details-stops flight="$ctrl.flight"></flight-details-stops>\
                </div>\
            </div>\
            <div class="ith-mmb-flight-details__travel-to">\
                <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.getCityName($ctrl.flight.destination) }} </p>\
                <p class="ith-mmb-flight-details__info ith-mmb-flight-details__info--margin-bottom">{{ $ctrl.getAirportName($ctrl.flight.destination) }}</p>\
                <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.flight.arrivalTime.hour }}:{{$ctrl.flight.arrivalTime.minute}}</p>\
                <p class="ith-mmb-flight-details__info">{{ $ctrl.getDate($ctrl.flight.arrivalTime) | date:\'EEE, dd.MM.yyyy\' }}</p>\
            </div>\
            <div class="ith-mmb-flight-details__logos">\
                <img ng-repeat="c in $ctrl.carriers" class="ith-mmb-flight-details__logo" ng-src="/assets/img/uploaded/airlines/logos/{{c}}.png" />\
            </div>\
        </div>\
        <div class="ith-mmb-flight-details__graphic-wrapper-mobile">\
            <div class="ith-mmb-flight-details__date-and-time-column">\
                <div>\
                    <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.flight.departureTime.hour }}:{{$ctrl.flight.departureTime.minute}}</p>\
                    <p class="ith-mmb-flight-details__info">{{ $ctrl.getDate($ctrl.flight.departureTime) | date:\'EEE, dd.MM.yyyy\' }}</p>\
                </div>\
                <div class="ith-mmb-flight-details__duration-mobile"><span>{{ $ctrl.getDurationFormatted($ctrl.flight.duration) }}<span></div>\
                <div>\
                    <p class="ith-mmb-flight-details__emphasized-info">{{ $ctrl.flight.arrivalTime.hour }}:{{$ctrl.flight.arrivalTime.minute}}</p>\
                    <p class="ith-mmb-flight-details__info">{{ $ctrl.getDate($ctrl.flight.arrivalTime) | date:\'EEE, dd.MM.yyyy\' }}</p>\
                </div>\
            </div>\
            <div class="ith-mmb-flight-details__graphic-column">\
                <vertical-arrow-with-stops is-direct="$ctrl.flight.direct" no-stops="$ctrl.flight.noStops"></vertical-arrow-with-stops>\
            </div>\
            <div class="ith-mmb-flight-details__city-column">\
                <div>\
                    <p class="ith-mmb-flight-details__emphasized-info ith-mmb-flight-details__emphasized-info--left">{{ $ctrl.getCityName($ctrl.flight.origin) }}</p>\
                    <p class="ith-mmb-flight-details__info ith-mmb-flight-details__info--left">{{ $ctrl.getAirportName($ctrl.flight.origin) }}</p>\
                </div>\
                <div>\
                    <flight-details-stops flight="$ctrl.flight"></flight-details-stops>\
                </div>\
                <div>\
                    <p class="ith-mmb-flight-details__emphasized-info ith-mmb-flight-details__emphasized-info--left">{{ $ctrl.getCityName($ctrl.flight.destination) }} </p>\
                    <p class="ith-mmb-flight-details__info ith-mmb-flight-details__info--left">{{ $ctrl.getAirportName($ctrl.flight.destination) }}</p>\
                </div>\
            </div>\
        </div>\
    ';

    var IthMmbFlightDetails = {
        bindings: {
            flight: '<',
            cities: '<'
        },
        template: itemTemplate,
        controller: function () {
            var ctrl = this;
            // deduplicated carriers
            ctrl.carriers = ctrl.flight.carriers.reduce(function (acc, c) {
                return acc.includes(c)
                    ? acc
                    : acc.concat([c]);
            }, []);

            ctrl.getDate = function (dateObject) {
                var year = parseInt(dateObject.year);
                var month = parseInt(dateObject.month) - 1;
                var day = parseInt(dateObject.day);
                var hour = parseInt(dateObject.hour);
                var minute = parseInt(dateObject.minute);
                var second = parseInt(dateObject.second);

                var date = new Date(year, month, day, hour, minute, second);

                return date;
            };

            ctrl.getDurationFormatted = function (minutes) {
                var hours = Math.floor(minutes / 60);
                var remainingMinutes = minutes % 60;

                var formattedDuration = '';
                if (hours > 0) {
                    formattedDuration += hours + 'h ';
                }
                if (remainingMinutes > 0 || hours === 0) {
                    formattedDuration += remainingMinutes + 'm';
                }

                return formattedDuration.trim();
            };

            ctrl.getCityName = function (cityCode) {
                return ctrl.cities[cityCode].city;
            };

            ctrl.getAirportName = function (cityCode) {
                return ctrl.cities[cityCode].airport_name;
            };
        }
    };

    angular.module('base').component('ithMmbFlightDetails', IthMmbFlightDetails);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/modals/cancelBookingModal.controller.js
(function (angular) {
var controller = function (
        $scope,
        $rootScope,
        $modalInstance,
        cancelMessage
    ) {
        $scope.cancelMessage = cancelMessage;
        $scope.$modalInstance = $modalInstance;

        $scope.closeModal = function () {
            $modalInstance.dismiss();
        }
    };

    controller.$inject = [
        '$scope',
        '$rootScope',
        '$modalInstance',
        'cancelMessage'
    ];

    angular
        .module('user')
        .controller('CancelBookingModal', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/mmb/modals/modifyBookingModal.controller.js
(function (angular) {
var controller = function (
        $scope,
        $rootScope,
        $modalInstance,
        $timeout,
        pnr,
        ProfileSettingsService,
        UserResponsesAdapterService,
        API_STATUSES_PROFILE,
        UserSessionData
    ) {
        $scope.viewStates = {
            LOADING_PROFILE_INFO: 0,
            FORM_ACTIVE: 1,
        };

        $scope.modalInstance = $modalInstance;
        $scope.viewState = $scope.viewStates.LOADING_PROFILE_INFO;

        ProfileSettingsService
            .getProfile()
            .then(function (response) {
                var accountOwner = {};

                if (response.status === API_STATUSES_PROFILE.OK) {
                    accountOwner = UserResponsesAdapterService.transformPassengerData(response.response);
                }

                if (response.status === API_STATUSES_PROFILE.PROFILE_NOT_EXISTS) {
                    // dummy data to create Person instance
                    accountOwner = {
                        id: response.response.passenger.id
                    };
                }

                $scope.viewState = $scope.viewStates.FORM_ACTIVE;

                $timeout(function () {
                    $rootScope.$broadcast('contact-profile-prefill', {
                        bookingNumber: pnr.model.reservation_number,
                        name: accountOwner.first_name + ' ' + accountOwner.last_name,
                        email: UserSessionData.getEmail(),
                        telephone: accountOwner.phone_prefix + accountOwner.phone_number,
                        departureDate: [
                            pnr.flights[0].departureTime.year,
                            pnr.flights[0].departureTime.month,
                            pnr.flights[0].departureTime.day
                        ].join('-')
                    });
                }, 10);
            });
    };

    controller.$inject = [
        '$scope',
        '$rootScope',
        '$modalInstance',
        '$timeout',
        'pnr',
        'ProfileSettingsService',
        'UserResponsesAdapterService',
        'API_STATUSES_PROFILE',
        'UserSessionData'
    ];

    angular
        .module('user')
        .controller('ModifyBookingModal', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/mmb/more-details-button.component.js
(function (angular) {
var template = '\
        <button class="more-details-button">\
            <span class="more-details-button__text" translate>LANGM_JS_MORE_DETAILS_BUTTON</span>\
            <span \
                class="more-details-button__icon" \
                ng-class="{ \'more-details-button__icon--open\': $ctrl.isOpen }"\
            >\
                <svg-icon id="caret"></svg-icon>\
            </span>\
        </button>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('moreDetailsButton', {
            template: template,
            controller: controller,
            bindings: {
                isOpen: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/passengers-count-indicator.component.js
(function (angular) {
var template = '\
        <span class="passengers-count-indicator">\
            <span class="mmb-text-dark">\
                {{ $ctrl.paxCount }}\
            </span>\
            <svg-icon id="user2"></svg-icon>\
        </span>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('passengersCountIndicator', {
            template: template,
            controller: controller,
            bindings: {
                paxCount: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/pay-button-with-price.component.js
(function (angular) {
var template = '\
        <a href="thankYou/show/{{$ctrl.hash}}" class="btn btn-lg btn-block btn-primary">\
            <span translate>LANGM_JS_PAY</span>\
            <span>{{ $ctrl.getPrice() }}</span>\
        </a>\
    ';

    var controller = function (PriceFormatterService) {
        this.getPrice = function () {
            return PriceFormatterService.formatPrice(this.pnr.model.price, this.pnr.model.currency);
        };
    };

    controller.$inject = [
        'PriceFormatterService'
    ];

    angular
        .module('user')
        .component('payButtonWithPrice', {
            template: template,
            controller: controller,
            bindings: {
                pnr: '<',
                hash: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/travel-date-info.component.js
(function (angular) {
var template = '\
        <div class="min-w-120">\
            <p class="mmb-text-light">{{ $ctrl.headingText }}</p>\
            <p class="mmb-text-dark">\
                {{ $ctrl.formattedDate }}\
            </p>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('travelDateInfo', {
            template: template,
            controller: controller,
            bindings: {
                headingText: '@',
                formattedDate: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/mmb/vertical-arrow-with-stops.js
(function (angular) {
var template = '\
        <div class="line-point line-point--start"></div>\
        <div ng-if="!$ctrl.isDirect" class="vertical-line">\
            <div class="line-point" ng-repeat="i in $ctrl.getStopsArray() track by $index"></div>\
        </div>\
        \
        <div ng-if="$ctrl.isDirect" class="vertical-line"></div>\
        <div class="line-point line-point--end"></div>\
    ';

    var controller = function () {
        var ctrl = this;

        ctrl.getStopsArray = function() {
            return new Array(ctrl.noStops);
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('verticalArrowWithStops', {
            template: template,
            controller: controller,
            bindings: {
                noStops: '<',
                isDirect: '<',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/password/password-change.component.js
(function(angular) {
var IthPasswordFormController = function (
        $modalInstance,
        $translate,
        UserService,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        canSetPassword,
        refreshFn
    ) {
        var self = this;

        this.modalInstance = $modalInstance;
        this.canSetPassword = canSetPassword;

        this.refreshFn = refreshFn;

        this.formData = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        };

        this.duringSubmit = false;
        this.gotResponse = false;
        this.errors = {};

        this.hasErrors = function () {
            return Object.values(this.errors).length > 0;
        };

        this.changePassword = function (ngForm) {
            if (!ngForm.$valid) {
                return;
            }

            this.duringSubmit = true;
            this.gotResponse = false;

            ProfileSettingsService
                .changePassword(this.formData.oldPassword, this.formData.newPassword)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        self.errors = {};
                        self.formData.oldPassword = '';
                        self.formData.newPassword = '';
                        self.formData.confirmNewPassword = '';
                        self.refreshFn.fn();
                        return;
                    }

                    if (status === API_STATUSES_PROFILE.USER_NOT_EXISTS) {
                        self.errors = {
                            oldPassword: $translate.instant('LANGM_JS_WRONG_PASSWORD')
                        };
                        return;
                    }
                })
                .finally(function () {
                    self.gotResponse = true;
                    self.duringSubmit = false;
                });
        };
    };

    IthPasswordFormController.$inject = [
        '$modalInstance',
        '$translate',
        'UserService',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'canSetPassword',
        'refreshFn'
    ];

    var IthPasswordChangeController = function ($modal) {
        var self = this;

        this.openForm = function () {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/user/directives/passwordForm',
                controller: IthPasswordFormController,
                controllerAs: '$ctrl',
                resolve: {
                    canSetPassword: self.canSetPassword,
                    refreshFn: { fn: self.refresh }
                }
            });
        };
    };

    IthPasswordChangeController.$inject = [
        '$modal',
    ];

    angular
        .module('user')
        .component('ithPasswordChange', {
            template: '<a class="btn btn-block btn-outline" ng-click="$ctrl.openForm()" translate>LANGM_JS_EDIT_MY_PASSWORD</a>',
            controller: IthPasswordChangeController,
            bindings: {
                canSetPassword: '<',
                refresh: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/account-settings.component.js
(function (angular) {
var template = '\
        <div class="category-container">\
            <back-button click="$ctrl.backButtonClicked()">\
                LANGM_JS_PREFERENCES\
            </back-button>\
            <div class="category-container__main">\
                <div class="category-container__left-col">\
                    <category-header \
                        icon-id="preferences-account-settings-inverted" \
                        title-text="LANGM_JS_TILE_TITLE_ACCOUNT_SETTINGS" \
                        description="LANGM_JS_TILE_DESCRIPTION_ACCOUNT_SETTINGS"\
                    >\
                    </category-header>\
                </div>\
                \
                <div class="category-container__right-col">\
                    <personal-details></personal-details>\
                    <travel-document></travel-document>\
                    <preferred-language></preferred-language>\
                    <billing-details></billing-details>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('accountSettings', {
            template: template,
            controller: controller,
            bindings: {
                backButtonClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/add-billing.component.js
(function (angular) {
var template = '\
        <div>\
            <expandable \
                add-type="true" \
                text="{{ \'LANGM_JS_PREFERENCES_ADD_BILLING\' | translate }}"\
            >\
                <div class="mt-24">\
                    <profile-tabs \
                        ng-if="$ctrl.canShowTypePicker()"\
                        on-tab-change="$ctrl.setBillingType({ type: type })"\
                        active-tab="$ctrl.activeBillingType"\
                        tabs="$ctrl.tabs"\
                    ></profile-tabs>\
                </div>\
                \
                <div class="mt-24">\
                    <form-billing-company \
                        ng-show="$ctrl.activeBillingType === \'company\'"\
                    ></form-billing-company>\
                    <form-billing-person \
                        ng-show="$ctrl.activeBillingType === \'person\'"\
                    ></form-billing-person>\
                </div>\
            </expandable>\
        </div>\
    ';

    var controller = function (appConfig, $translate) {
        this.activeBillingType = appConfig.isFru() ? 'company' : 'person';

        this.tabs = [
            {
                name: $translate.instant('LANGM_JS_BILLING_TYPE_PERSON'),
                value: 'person'
            },
            {
                name: $translate.instant('LANGM_JS_BILLING_TYPE_COMPANY'),
                value: 'company'
            }
        ];

        this.canShowTypePicker = function () {
            return !appConfig.isFru();
        };

        this.setBillingType = function (type) {
            this.activeBillingType = type.type;
        };

    };

    controller.$inject = [
        'appConfig',
        '$translate'
    ];

    angular
        .module('user')
        .component('addBilling', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/billing-details.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24">\
            <p class="tile-heading" translate>LANGM_JS_BILLING_INFO</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_BILLING_DETAILS</p>\
            \
            <billing-item \
                ng-repeat="b in PreferencesDataService.billings" \
                billing="b"\
                is-default="false"\
                fru-case="$ctrl.isOneBillingExistsForFru()"\
            ></billing-item>\
            \
            <div ng-if="!$ctrl.isOneBillingExistsForFru()" class="mt-24">\
                <add-billing></add-billing>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService, appConfig) {
        $scope.PreferencesDataService = PreferencesDataService;

        this.isOneBillingExistsForFru = function () {
            return appConfig.isFru() && PreferencesDataService.billings.length;
        };
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService',
        'appConfig'
    ];

    angular
        .module('user')
        .component('billingDetails', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/billing-item.component.js
(function (angular) {
var template = '\
        <div class="billing-item mt-16"  ng-class="{ \'billing-item--fru-case\': $ctrl.fruCase }">\
            <div class="billing-item__address-section">\
                <p class="tile-text tile-text--bold">{{ $ctrl.formatAddress() }}</p>\
                <span \
                    ng-if="$ctrl.isDefault" \
                    class="billing-item__default-badge" \
                    translate\
                >\
                    LANGM_JS_BILLING_DEFAULT\
                </span>\
            </div>\
            \
            <div class="mt-8">\
                <expandable \
                    with-make-default="false" \
                    with-delete="true"\
                    make-default-clicked="$ctrl.makeDefaultClickHandler()"\
                    delete-clicked="$ctrl.deleteClickHandler()"\
                >\
                    <form-billing-company \
                        ng-if="$ctrl.billing.type === \'company\'" \
                        edit-mode="true"\
                        billing="$ctrl.billing"\
                    ></form-billing-company>\
                    \
                    <form-billing-person \
                        ng-if="$ctrl.billing.type === \'person\'" \
                        edit-mode="true"\
                        billing="$ctrl.billing"\
                    ></form-billing-person>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, $modal, $translate, PreferencesDataService) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.formatAddress = function () {
            var country = PreferencesDataService.countries.find(function (c) {
                return c.code === self.billing.address.country;
            });

            var name = this.billing.type === 'company'
                ? this.billing.name
                : this.billing.firstName + ' ' + this.billing.lastName;

            return ''
                + name
                + ', '
                + this.billing.address.street
                + ', '
                + this.billing.address.city
                + ', '
                + country.name;
        };

        this.makeDefaultClickHandler = function () {
            console.log('make default');
        };

        this.deleteClickHandler = function () {
            $modal.open({
                templateUrl: 'deleteBilling.html',
                controller: 'DeleteBilling',
                controllerAs: '$ctrl',
                size: 'md',
                backdrop: 'static',
                windowClass: 'profile-modal-wrapper',
                resolve: {
                    billing: this.billing
                }
            });
        };

    };

    controller.$inject = [
        '$scope',
        '$modal',
        '$translate',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('billingItem', {
            template: template,
            controller: controller,
            bindings: {
                billing: '<',
                isDefault: '<?',
                fruCase: '<?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/form-billing-company.component.js
(function (angular) {
var template = '\
        <div class="form-holder form-width-limiter">\
            <form name="billingCompany" ng-submit="$ctrl.submit(billingCompany)" role="form" novalidate>\
                <ith-input-field\
                    form="billingCompany"\
                    name="name"\
                    model="$ctrl.billingModel.name"\
                    type="text"\
                    placeholder="{{ \'LANGM_JS_COMPANY_NAME_PLACEHOLDER\' | translate }}"\
                    label="{{ \'LANGM_JS_COMPANY_NAME\' | translate }}"\
                    required="true"\
                    min-length=3\
                    max-length=255\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-input-field>\
                \
                <ith-vat-number-field\
                    form="billingCompany"\
                    name="vatNumber"\
                    model="$ctrl.billingModel.vatNumber"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-vat-number-field>\
                \
                <ith-address-field\
                    form="billingCompany"\
                    name="street"\
                    model="$ctrl.billingModel.getAddress().street"\
                    type="company"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-address-field>\
                \
                <ith-city-field\
                    form="billingCompany"\
                    name="city"\
                    model="$ctrl.billingModel.getAddress().city"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-city-field>\
                \
                <ith-zipcode-field\
                    ng-if="$ctrl.canShowZipCode()" \
                    form="billingCompany"\
                    name="zipCode"\
                    model="$ctrl.billingModel.getAddress().zipCode"\
                    disabled="$ctrl.isDuringSubmit">\
                </ith-zipcode-field>\
                \
                <ith-select-field\
                    form="billingCompany"\
                    name="country"\
                    model="$ctrl.billingModel.getAddress().country"\
                    label="{{ \'LANGM_JS_SELECT_COUNTRY\' | translate }}"\
                    data="PreferencesDataService.countries"\
                    options="c.code as c.name for c in $ctrl.data"\
                    required="true"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-select-field>\
                \
                <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                    <translate>LANGM_JS_SUBMIT</translate>\
                </ith-loading-submit>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, Company, ProfileSettingsService, PostSubmitService, appConfig) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;

        this.billingModel = new Company();

        if (this.editMode && this.billing) {
            this.billingModel.srvSet(this.billing.srvObj());
        }

        this.resetForm = function () {
            self.billingModel = new Company();
            $scope.billingCompany.$setUntouched();
            $scope.billingCompany.$setPristine();
        };

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;
                var index = null;

                ProfileSettingsService.setCompanyBilling(self.billingModel)
                    .then(function (response) {
                        // add new billing case
                        if (!self.editMode) {
                            PreferencesDataService.addBilling(response);
                            self.resetForm();
                            PostSubmitService.advancedPostSubmitHandler($scope, 'billing-item', index);
                        }

                        // edit existing billing case
                        if (self.editMode) {
                            PreferencesDataService.editBilling(response);
                            index = PreferencesDataService.billings.findIndex(function (b) {
                                return b.id === self.billing.id;
                            });
                            PostSubmitService.advancedPostSubmitHandler($scope, 'billing-item', index);
                        }
                    })
                    .finally(function () {
                        self.isDuringSubmit = false;
                    });
            }
        };

        this.canShowZipCode = function () {
            return appConfig.isFru();
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'bil.Company',
        'ProfileSettingsService',
        'PostSubmitService',
        'appConfig',
    ];

    angular
        .module('user')
        .component('formBillingCompany', {
            template: template,
            controller: controller,
            bindings: {
                billing: '<?',
                editMode: '<?',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/form-billing-person.component.js
(function (angular) {
var template = '\
        <div class="form-holder form-width-limiter">\
            <form name="billingPerson" ng-submit="$ctrl.submit(billingPerson)" role="form" novalidate>\
                <ith-input-field\
                    form="billingPerson"\
                    name="firstName"\
                    model="$ctrl.billingModel.firstName"\
                    type="text"\
                    placeholder="{{ \'LANGM_JS_FIRST_NAME_PLACEHOLDER\' | translate }}"\
                    label="{{ \'LANGM_JS_FIRST_NAME\' | translate }}"\
                    required="true"\
                    min-length=3\
                    max-length=255\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-input-field>\
                \
                <ith-name-input-field\
                    form="billingPerson"\
                    name="lastName"\
                    model="$ctrl.billingModel.lastName"\
                    placeholder="{{ \'LANGM_JS_LAST_NAME_PLACEHOLDER\' | translate }}"\
                    label="{{ \'LANGM_JS_LAST_NAME\' | translate }}"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-name-input-field>\
                \
                <ith-address-field\
                    form="billingPerson"\
                    name="street"\
                    model="$ctrl.billingModel.getAddress().street"\
                    type="personal"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-address-field>\
                \
                <ith-city-field\
                    form="billingPerson"\
                    name="city"\
                    model="$ctrl.billingModel.getAddress().city"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-city-field>\
                \
                <ith-select-field\
                    form="billingPerson"\
                    name="country"\
                    model="$ctrl.billingModel.getAddress().country"\
                    label="{{ \'LANGM_JS_SELECT_COUNTRY\' | translate }}"\
                    data="PreferencesDataService.countries"\
                    options="c.code as c.name for c in $ctrl.data"\
                    required="true"\
                    disabled="$ctrl.isDuringSubmit"\>\
                </ith-select-field>\
                \
                <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                    <translate>LANGM_JS_SUBMIT</translate>\
                </ith-loading-submit>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, BillingPerson, ProfileSettingsService, PostSubmitService) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;

        this.billingModel = new BillingPerson();

        if (this.editMode && this.billing) {
            this.billingModel.srvSet(this.billing.srvObj());
        }

        this.resetForm = function () {
            self.billingModel = new BillingPerson();
            $scope.billingPerson.$setUntouched();
            $scope.billingPerson.$setPristine();
        };

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;
                var index = null;

                ProfileSettingsService.setPersonalBilling(self.billingModel)
                    .then(function (response) {
                        // add new billing case
                        if (!self.editMode) {
                            PreferencesDataService.addBilling(response);
                            self.resetForm();
                            PostSubmitService.advancedPostSubmitHandler($scope, 'billing-item', index);
                        }

                        // edit existing billing case
                        if (self.editMode) {
                            PreferencesDataService.editBilling(response);
                            index = PreferencesDataService.billings.findIndex(function (b) {
                                return b.id === self.billing.id;
                            });
                            PostSubmitService.advancedPostSubmitHandler($scope, 'billing-item', index);
                        }
                    })
                    .finally(function () {
                        self.isDuringSubmit = false;
                    });
            }
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'bil.BillingPerson',
        'ProfileSettingsService',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('formBillingPerson', {
            template: template,
            controller: controller,
            bindings: {
                billing: '<?',
                editMode: '<?',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/billing-details/profile-tabs.component.js
(function (angular) {
var template = '\
        <div class="profile-tabs">\
            <button \
                ng-repeat="tab in $ctrl.tabs"\
                class="profile-tabs__button"\
                ng-class="{ \'profile-tabs__button--active\': tab.value === $ctrl.activeTab }"\
                ng-click="$ctrl.click(tab.value)"\
            >\
                {{ tab.name }}\
            </button>\
        </div>\
    ';

    var controller = function () {
        this.click = function (type) {
            this.onTabChange({type: type});
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('profileTabs', {
            template: template,
            controller: controller,
            bindings: {
                tabs: '<',
                activeTab: '<',
                onTabChange: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/personal-details/form-profile-personal-details.component.js
(function (angular) {
var template = '\
        <div class="form-holder">\
            <form name="profilePersonalDetails" ng-submit="$ctrl.submit(profilePersonalDetails)" role="form" novalidate>\
                <p class="form-heading mb-16" translate>LANGM_JS_PREFERENCES_ACCOUNT_OWNER</p>\
                \
                <div class="form-width-limiter">\
                    <ith-name-input-field\
                        form="profilePersonalDetails"\
                        name="firstName"\
                        model="$ctrl.model.firstName"\
                        element-id="firstName"\
                        placeholder="{{ \'LANGM_JS_FIRST_NAME_PLACEHOLDER\' | translate }}"\
                        label="{{ \'LANGM_JS_FIRST_NAME\' | translate }}"\
                        disabled="$ctrl.isDuringSubmit"\>\
                    </ith-name-input-field>\
                    \
                    <ith-name-input-field\
                        form="profilePersonalDetails"\
                        name="lastName"\
                        model="$ctrl.model.lastName"\
                        element-id="lastName"\
                        placeholder="{{ \'LANGM_JS_LAST_NAME_PLACEHOLDER\' | translate }}"\
                        label="{{ \'LANGM_JS_LAST_NAME\' | translate }}"\
                        disabled="$ctrl.isDuringSubmit"\>\
                    </ith-name-input-field>\
                    \
                    <ith-select-field\
                        form="profilePersonalDetails"\
                        name="gender"\
                        model="$ctrl.model.gender"\
                        label="{{ \'LANGM_JS_PAX_GENDER\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_GENDER_PLACEHOLDER\' | translate }}"\
                        data="$ctrl.genderSelectData"\
                        options="c.type as c.name for c in $ctrl.data"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false"\>\
                    </ith-select-field>\
                    \
                    <ith-birthdate-field\
                        form="profilePersonalDetails"\
                        name="birth"\
                        date="$ctrl.model.birthDate"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="true">\
                    </ith-birthdate-field>\
                    \
                    <ith-select-field\
                            form="profilePersonalDetails"\
                            name="nationality"\
                            model="$ctrl.model.nationality"\
                            label="{{ \'LANGM_JS_PAX_NATIONALITY\' | translate }}"\
                            placeholder="{{ \'LANGM_JS_NATIONALITY_PLACEHOLDER\' | translate }}"\
                            data="PreferencesDataService.countries"\
                            options="c.code as c.name for c in $ctrl.data"\
                            disabled="$ctrl.isDuringSubmit"\
                            required="true">\
                    </ith-select-field>\
                </div>\
                \
                <p class="form-heading mt-24 mb-16" translate>LANGM_JS_CI_TITLE</p>\
                \
                <div class="form-width-limiter">\
                    <ith-email-input-field\
                        form="profilePersonalDetails"\
                        name="email"\
                        label="{{ \'LANGM_JS_EMAIL_RESET_PASS\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_EMAIL_REG_PLACE\' | translate }}"\
                        model="$ctrl.email"\
                        disabled="true">\
                    </ith-email-input-field>\
                    \
                    <ith-phone-field\
                        form="profilePersonalDetails"\
                        name="phone"\
                        placeholder="{{ \'LANGM_JS_PHONE_NUMBER_PLACEHOLDER\' | translate }}"\
                        label="{{ \'LANGM_JS_PHONE_NUMBER\' | translate }}"\
                        required="true"\
                        phone="$ctrl.model.phone"\
                        disabled="$ctrl.isDuringSubmit">\
                    </ith-phone-field>\
                    \
                    <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                        <translate>LANGM_JS_SUBMIT</translate>\
                    </ith-loading-submit>\
                </div>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, UserSessionData, ProfileSettingsService, Person, PostSubmitService) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;

        this.model = new Person();
        this.model.srvSet(PreferencesDataService.accountOwner.srvObj());
        this.email = UserSessionData.getEmail();

        this.genderSelectData = [
            {
                type: 'male',
                name: $translate.instant('LANGM_JS_GENDER_MALE')
            },
            {
                type: 'female',
                name: $translate.instant('LANGM_JS_GENDER_FEMALE')
            },
        ].map(function (item) {
            return {
                type: item.type,
                name: item.name
            };
        });

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;

                ProfileSettingsService
                    .setProfilePersonalDetailsOnly(self.model)
                    .then(function (response) {
                        PreferencesDataService.updatePersonalDetails(response);
                        self.isDuringSubmit = false;
                        PostSubmitService.postSubmitHandler($scope, '.personal-details-scroll-anchor');
                    });
            }
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'UserSessionData',
        'ProfileSettingsService',
        'bil.Person',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('formProfilePersonalDetails', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/personal-details/personal-details.component.js
(function (angular) {
var template = '\
        <div class="tile-box personal-details-scroll-anchor">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_PERSONAL_DETAILS</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_PERSONAL_DETAILS</p>\
            \
            <p \
                ng-if="PreferencesDataService.accountOwner.firstName" \
                class="tile-text mt-12"\
            >\
                <span class="tile-text--bold">\
                    {{ PreferencesDataService.accountOwner.getFullName() }}\
                </span>\
                (<translate>LANGM_JS_PREFERENCES_ACCOUNT_OWNER</translate>)\
            </p>\
            \
            <div class="tile-text-with-icon mt-4">\
                <svg-icon id="envelope"></svg-icon>\
                <p class="tile-text tile-text--bold">{{ UserSessionData.getEmail() }}</p>\
            </div>\
            \
            <div \
                ng-if="PreferencesDataService.accountOwner.phone.number" \
                class="tile-text-with-icon mt-4"\
            >\
                <svg-icon id="phone"></svg-icon>\
                <p class="tile-text tile-text--bold">{{ PreferencesDataService.accountOwner.getPhoneFormatted() }}</p>\
            </div>\
            \
            <div class="mt-16">\
                <expandable>\
                    <form-profile-personal-details></form-profile-personal-details>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService, UserSessionData) {
        $scope.PreferencesDataService = PreferencesDataService;
        $scope.UserSessionData = UserSessionData;
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService',
        'UserSessionData'
    ];

    angular
        .module('user')
        .component('personalDetails', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-airport/airport-picker/airport-picker-dropdown.component.js
(function (angular) {
var template = '\
        <div \
            class="airport-picker-dropdown" \
            ng-mousedown="$ctrl.dropdownClickHandler($event)"\
        >\
            <city-helper-no-results ng-if="$ctrl.isNothingFound"></city-helper-no-results>\
            <div ng-if="!$ctrl.isNothingFound">\
                <p \
                    class="airport-picker-dropdown__title" \
                    translate\
                >\
                    LANGM_JS_FS_FILTERS_FLY_TO_AIRPORT\
                </p>\
                \
                <airport-picker-result \
                    ng-repeat="result in $ctrl.results"\
                    result="result"\
                    ng-mousedown="$ctrl.locationClicked({ location: result })" \
                ></airport-picker-result>\
            </div>\
        </div>\
    ';

    var controller = function () {
        this.dropdownClickHandler = function (e) {
            e.preventDefault();
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('airportPickerDropdown', {
            template: template,
            controller: controller,
            bindings: {
                results: '<',
                isNothingFound: '<',
                locationClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-airport/airport-picker/airport-picker-result.component.js
(function (angular) {
var template = '\
        <div class="airport-picker-result">\
            <svg-icon id="takeoff"></svg-icon>\
            <p class="tile-text">\
                <span class="tile-text--bold">{{ $ctrl.result.airportName }}, </span>\
                <span>{{ $ctrl.result.cityName }}</span>\
                <span class="tile-text--grey">\
                    ({{ $ctrl.result.airportCode }})\
                </span>\
            </p>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [
    ];

    angular
        .module('user')
        .component('airportPickerResult', {
            template: template,
            controller: controller,
            bindings: {
                result: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-airport/airport-picker/airport-picker.component.js
(function (angular) {
var template = '\
        <div class="airport-picker form-holder">\
            <form \
                class="form-width-limiter"\
                name="preferredAirport"\
                ng-submit="$ctrl.saveClicked()"\
                role="form" \
                novalidate\
             >\
                <label \
                    class="airport-picker__label" \
                    for="airport-picker-input"\
                    translate\
                >\
                    LANGM_JS_FS_FILTERS_FLY_TO_AIRPORT\
                </label>\
                \
                <div class="airport-picker__input-holder">\
                    <input \
                        class="airport-picker__input" \
                        type="text" \
                        id="airport-picker-input"\
                        placeholder="{{ \'LANGM_JS_PREFERRED_AIRPORT_PLACEHOLDER\' | translate }}" \
                        \
                        ng-model="$ctrl.cityHelper.inputValue"\
                        ng-change="$ctrl.onChange()"\
                        ng-focus="$ctrl.onFocus()"\
                        ng-blur="$ctrl.onBlur()"\
                    >\
                    \
                    <airport-picker-dropdown \
                        ng-if="$ctrl.isFocused && $ctrl.cityHelper.inputValue.length >= 2"\
                        results="$ctrl.cityHelper.results"\
                        is-nothing-found="$ctrl.cityHelper.inputValue.length >= 2 && !$ctrl.cityHelper.results.length && !$ctrl.cityHelper.isSearching"\
                        location-clicked="$ctrl.locationClickedHandler(location)"\
                    ></airport-picker-dropdown>\
                </div>\
                \
                <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                    <translate>LANGM_JS_SUBMIT</translate>\
                </ith-loading-submit>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, CityHelperHandler, CITY_HELPER) {
        this.isFocused = false;
        this.cityHelper = new CityHelperHandler([], CITY_HELPER.FLIGHT_TYPE_FROM);

        this.onChange = function () {
            this.cityHelper.searchPreferredAirport();
        };

        this.onFocus = function () {
            this.isFocused = true;
            $scope.$emit('expandable.setOverflowToVisible');
        };

        this.onBlur = function () {
            this.isFocused = false;
            this.cityHelper.inputValue = '';
            this.cityHelper.results = [];
            $scope.$emit('expandable.setOverflowToHidden');
        };

        this.locationClickedHandler = function (location) {
            this.locationClicked({location: location});
            this.cityHelper.inputValue = '';
            this.cityHelper.results = [];
        };
    };

    controller.$inject = [
        '$scope',
        'CityHelperHandler',
        'CITY_HELPER'
    ];

    angular
        .module('user')
        .component('airportPicker', {
            template: template,
            controller: controller,
            bindings: {
                isDuringSubmit: '<',
                saveClicked: '&',
                locationClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-airport/preferred-airport.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24 preferred-airport-holder">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_PREFERRED_AIRPORT</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_PREFERRED_AIRPORT</p>\
            \
            <div \
                ng-if="$ctrl.location" \
                class="tile-text-with-icon mt-12"\
            >\
                <svg-icon id="takeoff"></svg-icon>\
                <p class="tile-text tile-text--bold">{{ $ctrl.formatLocation() }}</p>\
            </div>\
            \
            <div class="mt-16">\
                <expandable>\
                    <airport-picker \
                        is-during-submit="$ctrl.isDuringSubmit"\
                        save-clicked="$ctrl.saveClickHandler()"\
                        location-clicked="$ctrl.airportClickHandler(location)"\
                    ></airport-picker>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService, PreferredAirportService, PostSubmitService) {
        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;
        this.location = PreferencesDataService.preferredAirport;

        this.formatLocation = function () {
            return ''
                + this.location.airportName
                + ', '
                + this.location.cityName
                + ' '
                + '('
                + this.location.airportCode
                + ')';
        };

        this.saveClickHandler = function () {
            if (this.location) {
                this.isDuringSubmit = true;
                PreferencesDataService.setPreferredAirport(this.location);
                PreferredAirportService.set(this.location);
                this.isDuringSubmit = false;
                PostSubmitService.postSubmitHandler($scope, '.preferred-airport-holder',  true);
            }
        };

        this.airportClickHandler = function (location) {
            this.location = location;
        };
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService',
        'PreferredAirportService',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('preferredAirport', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-language/form-preferred-language.component.js
(function (angular) {
var template = '\
        <div class="form-holder">\
            <form name="preferredLanguage" ng-submit="$ctrl.submit(preferredLanguage)" role="form" novalidate>\
                <div class="form-width-limiter">\
                    <ith-select-field\
                        form="preferredLanguage"\
                        name="language"\
                        model="$ctrl.preferredLanguage"\
                        label="{{ \'LANGM_JS_TILE_TITLE_LANGUAGE\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_LANGUAGE_PLACEHOLDER\' | translate }}"\
                        data="$ctrl.languages"\
                        options="c.type as c.name for c in $ctrl.data"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="true"\>\
                    </ith-select-field>\
                    \
                    <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                        <translate>LANGM_JS_SUBMIT</translate>\
                    </ith-loading-submit>\
                </div>\
            </form>\
        </div>\
    ';

    var controller = function (
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        appConfig,
        LANG_NAMES,
        UserSessionData,
        $scope,
        PostSubmitService
    ) {
        var self = this;

        this.isDuringSubmit = false;

        this.preferredLanguage = UserSessionData.getLanguage();

        this.languages = (appConfig.getSupportedLangCodes() || ['en'])
            .map(function (langCode) {
                return {
                    type: langCode,
                    name: LANG_NAMES[langCode]
                };
            });

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;
                ProfileSettingsService
                    .setLanguage(self.preferredLanguage)
                    .then(function (response) {
                        if (response.status === API_STATUSES_PROFILE.OK) {
                            UserSessionData.setLanguage(response.response.data.language);
                        }
                        self.isDuringSubmit = false;
                        PostSubmitService.postSubmitHandler($scope, '.preferred-language-holder');
                    });
            }
        };
    };

    controller.$inject = [
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'appConfig',
        'LANG_NAMES',
        'UserSessionData',
        '$scope',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('formPreferredLanguage', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-language/language-display.component.js
(function (angular) {
var template = '\
        <div class="tile-text-with-icon">\
            <svg-icon id="{{ $ctrl.getIcon() }}"></svg-icon>\
            <p class="tile-text tile-text--bold">{{ $ctrl.getText() }}</p>\
        </div>\
    ';

    var controller = function () {
        this.getIcon = function () {
            var flags = {
                el: 'flag-gr',
                cs: 'flag-cz',
                sl: 'flag-si',
            };

            var lowerLang = this.language.toLowerCase();
            return flags[lowerLang] || 'flag-' + lowerLang || 'flag-en';
        };

        this.getText = function () {
            var languageList = {
                en: 'English',
                pl: 'Polski',
                ro: 'Română',
                hu: 'Magyar',
                es: 'Español',
                it: 'Italiano',
                gr: 'Ελληνικά',
                el: 'Ελληνικά',
                de: 'Deutsch',
                ru: 'Русский',
                bg: 'Български',
                cz: 'Čeština',
                cs: 'Čeština',
                al: 'Shqip',
                hr: 'Hrvatski',
                uk: 'English (UK)',
                sl: 'Slovinsko',
                sk: 'Slovensko'
            };

            return languageList[this.language.toLowerCase() || 'en'];
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('languageDisplay', {
            template: template,
            controller: controller,
            bindings: {
                language: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/preferred-language/preferred-language.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24 preferred-language-holder">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_LANGUAGE</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_LANGUAGE</p>\
            \
            <div class="mt-12">\
                <language-display language="UserSessionData.getLanguage()"></language-display>\
            </div>\
            <div class="mt-16">\
                <expandable>\
                    <form-preferred-language></form-preferred-language>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, UserSessionData) {
        $scope.UserSessionData = UserSessionData;
    };

    controller.$inject = [
        '$scope',
        'UserSessionData'
    ];

    angular
        .module('user')
        .component('preferredLanguage', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/travel-document/form-profile-travel-document.component.js
(function (angular) {
var template = '\
        <div class="form-holder">\
            <form name="profileTravelDocument" ng-submit="$ctrl.submit(profileTravelDocument)" role="form" novalidate>\
                <p class="form-heading mb-16" translate>LANGM_JS_TILE_TITLE_TRAVEL_DOCUMENT</p>\
                \
                <div class="form-width-limiter">\
                    <ith-document-type-field\
                        form="profileTravelDocument"\
                        name="docType"\
                        model="$ctrl.model.idCard.docType"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false">\
                    </ith-document-type-field>\
                    \
                    <ith-select-field\
                        form="profileTravelDocument"\
                        name="issueCountry"\
                        label="{{ \'LANGM_JS_TRAVEL_DOCUMENT_ISSUE_COUNTRY\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_DOCUMENT_ISSUE_COUNTRY_PLACEHOLDER\' | translate }}"\
                        data="PreferencesDataService.countries"\
                        options="c.code as c.name for c in $ctrl.data"\
                        disabled="$ctrl.isDuringSubmit"\
                        model="$ctrl.model.idCard.issueCountry"\
                        required="true">\
                    </ith-select-field>\
                    \
                    <ith-document-number-field\
                        form="profileTravelDocument"\
                        name="number"\
                        model="$ctrl.model.idCard.number"\
                        prevent-asterisks="!$ctrl.isIdCardExists"\
                        disabled="$ctrl.isDuringSubmit">\
                    </ith-document-number-field>\
                    \
                    <ith-passport-field\
                        form="profileTravelDocument"\
                        name="issueDate"\
                        label="{{ (\'LANGM_JS_TRAVEL_DOCUMENT_ISSUE\' | translate) }}"\
                        date="$ctrl.model.idCard.issueDate"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false">\
                    </ith-passport-field>\
                    \
                    <ith-passport-field\
                        form="profileTravelDocument"\
                        name="expiration"\
                        label="{{ (\'LANGM_JS_TRAVEL_DOCUMENT_EXPIRATION\' | translate) }}"\
                        date="$ctrl.model.idCard.expiration"\
                        type="expiration"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="true">\
                    </ith-passport-field>\
                    \
                    <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                        <translate>LANGM_JS_SUBMIT</translate>\
                    </ith-loading-submit>\
                </div>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, Person, ProfileSettingsService, PostSubmitService) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;

        this.model = new Person();
        this.model.srvSet(PreferencesDataService.accountOwner.srvObj());

        this.isIdCardExists = !!this.model.getIdCard().id;

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;

                ProfileSettingsService
                    .setProfileDocsOnly(self.model)
                    .then(function (response) {
                        PreferencesDataService.updateAccountOwnerDoc(response);
                        self.isDuringSubmit = false;
                        PostSubmitService.postSubmitHandler($scope, '.travel-document-scroll-anchor');
                    });
            }
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'bil.Person',
        'ProfileSettingsService',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('formProfileTravelDocument', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/account-settings/travel-document/travel-document.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24 travel-document-scroll-anchor">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_TRAVEL_DOCUMENT</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_TRAVEL_DOCUMENT</p>\
            \
            <passport-info \
                ng-if="PreferencesDataService.accountOwner.getIdCard().number" \
                person="PreferencesDataService.accountOwner"\
            ></passport-info>\
            \
            <div class="mt-16">\
                <expandable>\
                    <form-profile-travel-document></form-profile-travel-document>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService) {
        $scope.PreferencesDataService = PreferencesDataService;
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('travelDocument', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/back-button.component.js
(function (angular) {
var template = '\
        <div class="back-button">\
            <button type="button" class="back-button__button" ng-click="$ctrl.click()">\
                <svg-icon id="preferences-back-button"></svg-icon>\
            </button>\
            <p class="back-button__text" translate>\
                <ng-transclude></ng-transclude>\
            </p>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('backButton', {
            template: template,
            transclude: true,
            controller: controller,
            bindings: {
                click: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/categories.const.js
var constant = {
    ACCOUNT_SETTINGS: 'account-settings',
    PAYMENT_METHODS: 'payment-methods',
    TRAVEL_BUDDIES: 'travel-buddies',
    PRIVACY_AND_SECURITY: 'privacy-and-security'
};

angular
    .module('user')
    .constant('CATEGORIES', constant);
;

// Source: ../shared/public_html/assets/js/user/preferences/category-header.component.js
(function (angular) {
var template = '\
        <div class="category-header">\
            <div class="category-header__top-section">\
                <svg-icon id="{{ $ctrl.iconId }}"></svg-icon>\
                <p class="category-header__title" translate>{{ $ctrl.titleText }}</p>\
            </div>\
            <p class="category-header__description" translate>{{ $ctrl.description }}</p>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('categoryHeader', {
            template: template,
            controller: controller,
            bindings: {
                iconId: '@',
                titleText: '@',
                description: '@'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/expandable.component.js
(function (angular) {
var template = '\
        <div class="expandable">\
            <div \
                class="expandable__button-section" \
                ng-class="{ \'expandable__button-section--spread\': $ctrl.text }"\
            >\
                <p \
                    ng-if="$ctrl.text" \
                    class="tile-text"\
                >\
                    {{ $ctrl.text }}\
                </p>\
                \
                <div ng-if="$ctrl.withMakeDefault">\
                    <preferences-action-button click="$ctrl.makeDefaultClicked()">\
                        {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_MAKE_DEFAULT\' | translate }}\
                    </preferences-action-button>\
                    <span class="vertical-separator"></span>\
                </div>\
                \
                <preferences-action-button ng-if="!$ctrl.withoutButton" click="$ctrl.toggleExpansion({$event: $event})">\
                    {{ $ctrl.resolveButtonText() }}\
                </preferences-action-button>\
                \
                <div ng-if="$ctrl.withDelete">\
                    <span class="vertical-separator"></span>\
                    <preferences-action-button click="$ctrl.deleteClicked()">\
                        {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_DELETE\' | translate }}\
                    </preferences-action-button>\
                </div>\
            </div>\
            \
            <div class="expandable__expandable-section">\
                <ng-transclude></ng-transclude>\
            </div>\
        </div>\
    ';

    var controller = function ($translate, $scope, $element) {
        var self = this;
        this.isExpanded = false;
        // observer to watch for the form errors and adjust height dynamically
        this.observer = null;
        this.targetNode = null;

        this.resolveButtonText = function () {
            var result = 'LANGM_JS_PREFERENCES_ACTION_BTN_EDIT';

            if (this.addType) {
                result = 'LANGM_JS_PREFERENCES_ACTION_BTN_ADD';
            }

            if (this.changePassType) {
                result = 'LANGM_JS_PREFERENCES_ACTION_BTN_CHANGE_PASSWORD';
            }

            if (this.isExpanded) {
                result = 'LANGM_JS_PREFERENCES_ACTION_BTN_CANCEL';
            }

            return $translate.instant(result);
        };

        this.setMaxHeight = function () {
            this.targetNode.style.maxHeight = this.targetNode.scrollHeight + 'px';
        };

        this.resetMaxHeight = function () {
            this.targetNode.style.maxHeight = null;
        };

        this.setOverflowToVisible = function () {
            this.targetNode.style.overflow = 'visible';
        };

        this.setOverflowToHidden = function () {
            this.targetNode.style.overflow = 'hidden';
        };

        this.createObserver = function () {
            var observerConfig = {
                attributes: true,
                childList: true,
                subtree: true
            };

            function observerCallback() {
                self.setMaxHeight();
            }

            return {
                instance: new MutationObserver(observerCallback),
                config: observerConfig
            };
        };

        this.toggleExpansion = function () {
            if (!this.isExpanded) {
                this.setMaxHeight();
                this.observer.instance.observe(this.targetNode, this.observer.config);
            } else {
                this.resetMaxHeight();
                this.observer.instance.disconnect();
            }

            this.isExpanded = !this.isExpanded;
        };

        $scope.$on('expandable.toggleExpansion', function () {
            self.toggleExpansion();

            if (self.withoutButton) {
                return;
            }

            $scope.$apply();
        });

        $scope.$on('expandable.setOverflowToVisible', function () {
            self.setOverflowToVisible();
        });

        $scope.$on('expandable.setOverflowToHidden', function () {
            self.setOverflowToHidden();
        });

        this.$onInit = function () {
            this.targetNode = $element[0].querySelector('.expandable__expandable-section');
            this.observer = this.createObserver();
        };

        this.$onDestroy = function () {
            this.observer.instance.disconnect();
        };
    };

    controller.$inject = [
        '$translate',
        '$scope',
        '$element'
    ];

    angular
        .module('user')
        .component('expandable', {
            template: template,
            controller: controller,
            transclude: true,
            bindings: {
                addType: '<?',
                changePassType: '<?',
                withMakeDefault: '<?',
                makeDefaultClicked: '&?',
                withDelete: '<?',
                withoutButton: '<?',
                deleteClicked: '&?',
                text: '@?',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/languageNames.const.js
var constant = {
    en: 'English',
    pl: 'Polski',
    ro: 'Română',
    hu: 'Magyar',
    es: 'Español',
    it: 'Italiano',
    gr: 'Ελληνικά',
    el: 'Ελληνικά',
    de: 'Deutsch',
    ru: 'Русский',
    bg: 'Български',
    cz: 'Čeština',
    cs: 'Čeština',
    al: 'Shqip',
    hr: 'Hrvatski',
    uk: 'English (UK)',
    sl: 'Slovinsko',
    sk: 'Slovensko'
};

angular
    .module('base')
    .constant('LANG_NAMES', constant);
;

// Source: ../shared/public_html/assets/js/user/preferences/modal-controllers/deleteAccountOwner.controller.js
(function (angular) {
var controller = function (
        $modalInstance,
        $translate,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        AuthService2,
        AuthService,
        AuthGuard
    ) {
        var self = this;

        this.isLoading = false;
        this.isContinued = false;
        this.isUnexpectedError = false;
        this.isIncorrectEmail = false;

        this.formData = {
            email: ''
        };

        this.resolveDescriptionText = function () {
            var text = 'LANGM_JS_MODAL_DESCRIPTION_DELETE_ACCOUNT';

            if (this.isContinued) {
                text = 'LANGM_JS_MODAL_DESCRIPTION_DELETE_ACCOUNT_CONTINUED';
            }

            return $translate.instant(text);
        };

        this.onContinueClick = function () {
            this.isContinued = true;
        };

        this.onCancelClick = function () {
            $modalInstance.dismiss();
        };

        this.deleteAccount = function (ngForm) {
            if (!ngForm.$valid) {
                return;
            }
            this.isLoading = true;

            ProfileSettingsService
                .deleteAccount(this.formData.email)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        AuthService2.logout().then(function () {
                            AuthService.logout().then(function () {
                                AuthGuard.redirectToMainPage();
                            });
                        });

                        return;
                    }

                    if (status === API_STATUSES_PROFILE.INCORRECT_CREDENTIALS) {
                        self.isIncorrectEmail = true;
                        self.isLoading = false;

                        return;
                    }

                    self.isUnexpectedError = true;
                    self.isLoading = false;
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

    };

    controller.$inject = [
        '$modalInstance',
        '$translate',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'AuthService2',
        'AuthService',
        'AuthGuard'
    ];

    angular
        .module('user')
        .controller('DeleteAccountOwner', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/preferences/modal-controllers/deleteBilling.controller.js
(function (angular) {
var controller = function (
        $modalInstance,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        billing,
        PreferencesDataService
    ) {
        var self = this;
        this.isLoading = false;

        this.onDeleteClick = function () {
            this.isLoading = true;

            ProfileSettingsService
                .deleteBilling(billing.id)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        PreferencesDataService.removeBilling(billing);
                        $modalInstance.dismiss();
                    }
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        this.onCancelClick = function () {
            $modalInstance.dismiss();
        };

    };

    controller.$inject = [
        '$modalInstance',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'billing',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .controller('DeleteBilling', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/preferences/modal-controllers/deleteBuddy.controller.js
(function (angular) {
var controller = function (
        $modalInstance,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        buddy,
        PreferencesDataService
    ) {
        var self = this;
        this.isLoading = false;

        this.onDeleteClick = function () {
            this.isLoading = true;

            ProfileSettingsService
                .deletePassenger(buddy.id)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        PreferencesDataService.removeBuddy(buddy);
                        $modalInstance.dismiss();
                    }
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };

        this.onCancelClick = function () {
            $modalInstance.dismiss();
        };

    };

    controller.$inject = [
        '$modalInstance',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'buddy',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .controller('DeleteBuddy', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/preferences/modal-controllers/deleteCreditCard.controller.js
(function (angular) {
var controller = function (
        $modalInstance,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        creditCard,
        PreferencesDataService
    ) {
        var self = this;
        this.isLoading = false;

        this.isActive = function () {
            return PreferencesDataService.preferredPaymentMethod
                && (creditCard.id === PreferencesDataService.preferredPaymentMethod.id);
        };

        this.onDeleteClick = function () {
            this.isLoading = true;

            if (this.isActive()) {
                PreferencesDataService.setPreferredPaymentMethod(null);
            }

            PreferencesDataService.deleteCreditCard(creditCard);
            $modalInstance.dismiss();
        };

        this.onCancelClick = function () {
            $modalInstance.dismiss();
        };

    };

    controller.$inject = [
        '$modalInstance',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'creditCard',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .controller('DeleteCreditCard', controller);

})(angular);
;

// Source: ../shared/public_html/assets/js/user/preferences/modal-loading-button.component.js
(function (angular) {
var template = '\
        <button \
            class="profile-button profile-button--red" \
            ng-disabled="$ctrl.disabled"\
            ng-click="$ctrl.clickHandler($event)"\
        >\
            <span ng-if="!$ctrl.isLoading">\
                <ng-transclude></ng-transclude>\
            </span>\
            <span \
                ng-if="$ctrl.isLoading" \
                class="profile-button__spinner"\
            ></span>\
        </button>\
    ';

    var controller = function () {
        this.clickHandler = function ($event) {
            this.click({$event: $event});
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('modalLoadingButton', {
            template: template,
            controller: controller,
            transclude: true,
            bindings: {
                isLoading: '<?',
                disabled: '<?',
                click: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/passport-info.component.js
(function (angular) {
var template = '\
        <p class="tile-text mt-12">\
            <span class="tile-text--bold">{{ $ctrl.person.getIdCard().number }}</span>\
            <span ng-if="$ctrl.getDocTypeName()">({{ $ctrl.getDocTypeName() }})</span>\
        </p>\
        <p class="tile-text mt-4">\
            <span class="tile-text--bold">{{ $ctrl.person.getIdCard().expiration }}</span>\
            (<translate>LANGM_JS_TRAVEL_DOCUMENT_EXPIRATION</translate>)\
        </p>\
    ';

    var controller = function ($scope, $translate) {

        this.getDocTypeName = function () {
            var text = '';

            if (this.person.getIdCard().docType === 'PASSPORT') {
                text = $translate.instant('LANGM_JS_CHECKIN_DOC_PASSPORT');
            }

            if (this.person.getIdCard().docType === 'GOV_ID') {
                text = $translate.instant('LANGM_JS_CHECKIN_DOC_ID');
            }

            return text;
        };
    };

    controller.$inject = [
        '$scope',
        '$translate'
    ];

    angular
        .module('user')
        .component('passportInfo', {
            template: template,
            controller: controller,
            bindings: {
                person: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/payment-methods/form-cc.component.js
(function (angular) {
var template = '\
        <div class="form-holder form-width-limiter">\
            <form name="creditCardForm" id="creditCardForm" ng-submit="$ctrl.submit(creditCardForm)" novalidate>\
                <ith-cc-input-field\
                    element-id="cardNumber"\
                    name="cardNumber"\
                    form="creditCardForm"\
                    model="$ctrl.model.number"\
                    cc-type="$ctrl.model.type"\
                    cc-id="$ctrl.model.id"\
                    disabled="$ctrl.isDuringSubmit">\
                </ith-cc-input-field>\
                \
                <ith-input-field\
                    element-id="cardHolderName"\
                    type="text"\
                    name="cardHolder"\
                    placeholder="{{ \'LANGM_JS_CC_FULL_CARDHOLDER_NAME_PLACEHOLDER\' | translate }}"\
                    label="{{ \'LANGM_JS_CC_FULL_CARDHOLDER_NAME\' | translate }}"\
                    required="true"\
                    form="creditCardForm"\
                    model="$ctrl.model.fullName"\
                    min-length=2\
                    max-length=255\
                    disabled="$ctrl.isDuringSubmit"\
                    autocomplete="cc-full-name">\
                </ith-input-field>\
                \
                <div class="row cc-security-columns">\
                    <div class="col col-xs-6">\
                        <ith-cc-exp-input-field\
                            element-id="expDateForm"\
                            name="expiryDate"\
                            form="creditCardForm"\
                            model="$ctrl.model.newExp"\
                            tooltip-image="$ctrl.getCreditCardImage(\'front\')"\
                            disabled="$ctrl.isDuringSubmit">\
                        </ith-cc-exp-input-field>\
                    </div>\
                    \
                    <div class="col col-xs-6">\
                        <ith-cc-cvc-input-field\
                            element-id="cvcCode"\
                            name="cvc"\
                            form="creditCardForm"\
                            model="$ctrl.model.cvc"\
                            tooltip-image="$ctrl.getCreditCardImage(\'back\')"\
                            disabled="$ctrl.isDuringSubmit">\
                        </ith-cc-cvc-input-field>\
                    </div>\
                </div>\
                \
                <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                    <translate>LANGM_JS_SUBMIT</translate>\
                </ith-loading-submit>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, CreditCard, ProfileSettingsService, appConfig) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;
        this.model = new CreditCard();

        this.getCreditCardImage = function (side) {
            return side + '_tooltip_' + appConfig.getLanguageCode() + '.png';
        };

        this.resetForm = function () {
            self.model = new CreditCard();
            $scope.creditCardForm.$setUntouched();
            $scope.creditCardForm.$setPristine();
        };

        this.onNewCardAdded = function () {
            this.resetForm();
            setTimeout(function () {
                var cards = Array.from(document.getElementsByClassName('payment-method--card'));

                cards[cards.length - 1].scrollIntoView({behavior: 'smooth'});
                $scope.$emit('expandable.toggleExpansion');
            }, 100);
        };

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;
                PreferencesDataService.addCreditCard({
                    cardNumber: form.cardNumber.$modelValue,
                    cardHolder: form.cardHolder.$modelValue,
                    expiryDate: form.expiryDate.$modelValue,
                    cvc: form.cvc.$modelValue,
                });
                self.onNewCardAdded();
                self.isDuringSubmit = false;
            }
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'bok.CreditCard',
        'ProfileSettingsService',
        'appConfig'
    ];

    angular
        .module('user')
        .component('formCc', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/payment-methods/payment-card.component.js
(function (angular) {
var template = '\
        <div \
            class="payment-method payment-method--card" \
            ng-click="$ctrl.clickHandler({ $event: $event })"\
        >\
            <div class="payment-method__info-section">\
                <radio-indicator is-active="$ctrl.isActive()"></radio-indicator>\
                \
                <p class="payment-method__card-section">\
                    <svg-icon id="cc"></svg-icon>\
                    <span>•••• {{ $ctrl.getCardNumberFormatted() }}</span>\
                    <span>{{ $ctrl.getExpiryDateFormatted() }}</span>\
                </p>\
            </div>\
            \
            <preferences-action-button click="$ctrl.deleteClickHandler($event)">\
                {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_DELETE\' | translate }}\
            </preferences-action-button>\
        </div>\
    ';

    var controller = function ($modal, PreferencesDataService) {
        this.clickHandler = function ($event) {
            PreferencesDataService.setPreferredPaymentMethod(this.creditCard);
        };

        this.isActive = function () {
            return PreferencesDataService.preferredPaymentMethod
                && (this.creditCard.id === PreferencesDataService.preferredPaymentMethod.id);
        };

        this.deleteClickHandler = function ($event) {
            $event.stopPropagation();
            $modal.open({
                templateUrl: 'deleteCreditCard.html',
                controller: 'DeleteCreditCard',
                controllerAs: '$ctrl',
                size: 'md',
                backdrop: 'static',
                windowClass: 'profile-modal-wrapper',
                resolve: {
                    creditCard: this.creditCard
                }
            });
        };

        this.getCardNumberFormatted = function () {
            return this.creditCard.cardNumber.slice(-4);
        };

        this.getExpiryDateFormatted = function () {
            return this.creditCard.expiryDate.replace(/\//g, '/20');
        };
    };

    controller.$inject = [
        '$modal',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('paymentCard', {
            template: template,
            controller: controller,
            bindings: {
                'creditCard': '<',
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/payment-methods/payment-cards.component.js
(function (angular) {
var template = '\
        <div class="tile-box tile-box--no-py">\
            <payment-card ng-repeat="card in PreferencesDataService.creditCards"\
                credit-card="card"\
            ></payment-card>\
            \
            <div class="mt-16 mb-16">\
                <expandable \
                    add-type="true" \
                    text="{{ \'LANGM_JS_PREFERENCES_ADD_CARD\' | translate }}"\
                >\
                    <form-cc></form-cc>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService) {
        $scope.PreferencesDataService = PreferencesDataService;
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('paymentCards', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/payment-methods/payment-methods.component.js
(function (angular) {
var template = '\
        <div class="category-container">\
            <back-button click="$ctrl.backButtonClicked()">\
                LANGM_JS_PREFERENCES\
            </back-button>\
            <div class="category-container__main">\
                <div class="category-container__left-col">\
                    <category-header \
                        icon-id="preferences-payment-methods-inverted" \
                        title-text="LANGM_JS_TILE_TITLE_PAYMENT_METHODS" \
                        description="LANGM_JS_TILE_DESCRIPTION_PAYMENT_METHODS"\
                    >\
                    </category-header>\
                </div>\
                \
                <div class="category-container__right-col">\
                    <p class="tile-heading mb-16" translate>LANGM_JS_PREFERENCES_PAYMENT_CARDS</p>\
                    <payment-cards></payment-cards>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('paymentMethods', {
            template: template,
            controller: controller,
            bindings: {
                backButtonClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/payment-methods/radio-indicator.component.js
(function (angular) {
var template = '\
        <div \
            class="radio-indicator" \
            ng-class="{ \'radio-indicator--active\': $ctrl.isActive }"\
        >\
            <span class="radio-indicator__inner"></span>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('radioIndicator', {
            template: template,
            controller: controller,
            bindings: {
                isActive: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/preferences-action-button.component.js
(function (angular) {
var template = '\
        <button type="button" class="preferences-action-button" ng-click="$ctrl.clickHandler($event)">\
            <ng-transclude></ng-transclude>\
        </button>\
    ';

    var controller = function () {
        this.clickHandler = function ($event) {
            this.click({$event: $event});
        };
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('preferencesActionButton', {
            template: template,
            controller: controller,
            transclude: true,
            bindings: {
                click: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/preferences-start-tile.component.js
(function (angular) {
var template = '\
        <div class="preferences-start-tile">\
            <div class="preferences-start-tile__icon-section">\
                <svg-icon id="{{ $ctrl.iconId }}"></svg-icon>\
            </div>\
            <div class="preferences-start-tile__content-section">\
                <p class="preferences-start-tile__title" translate>{{ $ctrl.name }}</p>\
                <p class="preferences-start-tile__description" translate>{{ $ctrl.description }}</p>\
                \
                <div class="preferences-start-tile__button-section">\
                    <preferences-action-button ng-if="preferencesDataService.isInitialized" click="$ctrl.click()">\
                        {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_MANAGE\' | translate }}\
                    </preferences-action-button>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService) {
        $scope.preferencesDataService = PreferencesDataService;

        this.click = function () {
            this.clicked();
        };
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('preferencesStartTile', {
            template: template,
            controller: controller,
            bindings: {
                iconId: '@',
                name: '@',
                description: '@',
                clicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/privacy-and-security/change-account-password.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24 change-password-holder">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_SIGN_IN_DETAILS</p>\
            \
            <div class="tile-text-with-icon mt-12">\
                <svg-icon id="envelope"></svg-icon>\
                <p class="tile-text">{{ UserSessionData.getEmail() }}</p>\
            </div>\
            \
            <div class="mt-16">\
                <expandable change-pass-type="true">\
                    <form-change-password></form-change-password>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService, UserSessionData) {
        $scope.PreferencesDataService = PreferencesDataService;
        $scope.UserSessionData = UserSessionData;
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService',
        'UserSessionData'
    ];

    angular
        .module('user')
        .component('changeAccountPassword', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/privacy-and-security/delete-account.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_DELETE_ACCOUNT</p>\
            <p class="tile-description mt-4" translate>LANGM_JS_TILE_DESCRIPTION_DELETE_ACCOUNT</p>\
            \
            <div class="tile-flex-end-section mt-16">\
                <preferences-action-button click="$ctrl.deleteAccountClicked()">\
                    {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_DELETE_ACCOUNT\' | translate }}\
                </preferences-action-button>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, $modal, PreferencesDataService) {
        $scope.PreferencesDataService = PreferencesDataService;

        this.deleteAccountClicked = function () {
            $modal.open({
                templateUrl: 'deleteAccountOwner.html',
                controller: 'DeleteAccountOwner',
                controllerAs: '$ctrl',
                size: 'md',
                backdrop: 'static',
                windowClass: 'profile-modal-wrapper',
            });
        }
    };

    controller.$inject = [
        '$scope',
        '$modal',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('deleteAccount', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/privacy-and-security/form-change-password.component.js
(function (angular) {
var template = '\
        <div class="form-holder form-width-limiter">\
            <form\
                name="changePasswordForm"\
                ng-submit="$ctrl.changePassword(changePasswordForm)"\
                role="form"\
                novalidate\
            >\
                <ith-input-field\
                    ng-if="PreferencesDataService.isOldPasswordExists"\
                    type="password"\
                    name="password"\
                    placeholder="{{ \'LANGM_JS_OLDPASS_CHAN_PLACE\' | translate }}"\
                    label="{{ \'LANGM_JS_OLD_PASS\' | translate }}"\
                    required="true"\
                    form="changePasswordForm"\
                    model="$ctrl.formData.oldPassword"\
                    backend-error="$ctrl.errors.oldPassword"\
                    disabled="$ctrl.isLoading">\
                </ith-input-field>\
                \
                <ith-password-fields\
                    element-id="resetPass"\
                    form="changePasswordForm"\
                    password="$ctrl.formData.newPassword"\
                    password-backend-error="$ctrl.errors.newPassword"\
                    password-confirm="$ctrl.formData.confirmNewPassword"\
                    password-confirm-backend-error="$ctrl.errors.confirmNewPassword"\
                    disabled="$ctrl.isLoading">\
                </ith-password-fields>\
                \
                <ith-loading-submit is-loading="$ctrl.isLoading">\
                    <translate>LANGM_JS_PREFERENCES_ACTION_BTN_SUBMIT</translate>\
                </ith-loading-submit>\
            </form>\
        </div>\
    ';

    var controller = function (
        $scope,
        $translate,
        PreferencesDataService,
        ProfileSettingsService,
        API_STATUSES_PROFILE,
        PostSubmitService
    ) {
        $scope.PreferencesDataService = PreferencesDataService;

        var self = this;

        this.isLoading = false;

        this.formData = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        };

        this.errors = {};

        var resetForm = function () {
            self.formData.oldPassword = '';
            self.formData.newPassword = '';
            self.formData.confirmNewPassword = '';
            $scope.changePasswordForm.$setUntouched();
            $scope.changePasswordForm.$setPristine();
        };

        this.changePassword = function (ngForm) {
            if (!ngForm.$valid) {
                return;
            }

            this.isLoading = true;

            ProfileSettingsService
                .changePassword(this.formData.oldPassword, this.formData.newPassword)
                .then(function (status) {
                    if (status === API_STATUSES_PROFILE.OK) {
                        PreferencesDataService.setIsOldPasswordExists(true);
                        PostSubmitService.postSubmitHandler($scope, '.change-password-holder');
                        resetForm();

                        return;
                    }

                    if (status === API_STATUSES_PROFILE.USER_NOT_EXISTS) {
                        self.errors = {
                            oldPassword: $translate.instant('LANGM_JS_WRONG_PASSWORD')
                        };
                    }
                })
                .finally(function () {
                    self.isLoading = false;
                });
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'ProfileSettingsService',
        'API_STATUSES_PROFILE',
        'PostSubmitService',
    ];

    angular
        .module('user')
        .component('formChangePassword', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/privacy-and-security/privacy-and-security.component.js
(function (angular) {
var template = '\
        <div class="category-container">\
            <back-button click="$ctrl.backButtonClicked()">\
                LANGM_JS_PREFERENCES\
            </back-button>\
            <div class="category-container__main">\
                <div class="category-container__left-col">\
                    <category-header \
                        icon-id="preferences-privacy-and-security-inverted" \
                        title-text="LANGM_JS_TILE_TITLE_PRIVACY_AND_SECURITY" \
                        description="LANGM_JS_TILE_DESCRIPTION_PRIVACY_AND_SECURITY"\
                    >\
                    </category-header>\
                </div>\
                <div class="category-container__right-col">\
                    <change-account-password></change-account-password>\
                    <privacy-policy></privacy-policy>\
                    <delete-account></delete-account>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('privacyAndSecurity', {
            template: template,
            controller: controller,
            bindings: {
                backButtonClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/privacy-and-security/privacy-policy.component.js
(function (angular) {
var template = '\
        <div class="tile-box mt-24">\
            <p class="tile-heading" translate>LANGM_JS_TILE_TITLE_PRIVACY_POLICY</p>\
            \
            <p class="tile-text mt-4" translate>LANGM_JS_TILE_DESCRIPTION_PRIVACY_POLICY</p>\
            \
            <p \
                class="tile-text tile-link mt-4"\
                translate\
            >\
                LANGM_JS_PRIVACY_POLICY\
            </p>\
        </div>\
    ';

    var controller = function () {
    };

    controller.$inject = [];

    angular
        .module('user')
        .component('privacyPolicy', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/travel-buddies/add-travel-buddy.component.js
(function (angular) {
var template = '\
        <div class="tile-box">\
            <expandable \
                add-type="true" \
                text="{{ \'LANGM_JS_PREFERENCES_ADD_TRAVEL_BUDDY\' | translate }}"\
            >\
                <form-travel-buddy></form-travel-buddy>\
            </expandable>\
        </div>\
    ';

    var controller = function () {

    };

    controller.$inject = [];

    angular
        .module('user')
        .component('addTravelBuddy', {
            template: template,
            controller: controller,
            bindings: {
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/travel-buddies/form-travel-buddy.component.js
(function (angular) {
var template = '\
        <div class="form-holder">\
            <form name="travelBuddyForm" ng-submit="$ctrl.submit(travelBuddyForm)" role="form" novalidate>\
                <p class="form-heading mb-16" translate>LANGM_JS_PREFERENCES_TRAVEL_BUDDY</p>\
                \
                <div class="form-width-limiter">\
                    <ith-name-input-field\
                        form="travelBuddyForm"\
                        name="firstName"\
                        model="$ctrl.modelBuddy.firstName"\
                        element-id="firstName"\
                        placeholder="{{ \'LANGM_JS_FIRST_NAME_PLACEHOLDER\' | translate }}"\
                        label="{{ \'LANGM_JS_FIRST_NAME\' | translate }}"\
                        disabled="$ctrl.isDuringSubmit"\>\
                    </ith-name-input-field>\
                    \
                    <ith-name-input-field\
                        form="travelBuddyForm"\
                        name="lastName"\
                        model="$ctrl.modelBuddy.lastName"\
                        element-id="lastName"\
                        placeholder="{{ \'LANGM_JS_LAST_NAME_PLACEHOLDER\' | translate }}"\
                        label="{{ \'LANGM_JS_LAST_NAME\' | translate }}"\
                        disabled="$ctrl.isDuringSubmit"\>\
                    </ith-name-input-field>\
                    \
                    <ith-select-field\
                        form="travelBuddyForm"\
                        name="gender"\
                        model="$ctrl.modelBuddy.gender"\
                        label="{{ \'LANGM_JS_PAX_GENDER\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_GENDER_PLACEHOLDER\' | translate }}"\
                        data="$ctrl.genderSelectData"\
                        options="c.type as c.name for c in $ctrl.data"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false"\>\
                    </ith-select-field>\
                    \
                    <ith-birthdate-field\
                        form="travelBuddyForm"\
                        name="birth"\
                        date="$ctrl.modelBuddy.birthDate"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="true">\
                    </ith-birthdate-field>\
                    \
                    <ith-select-field\
                            form="travelBuddyForm"\
                            name="nationality"\
                            model="$ctrl.modelBuddy.nationality"\
                            label="{{ \'LANGM_JS_PAX_NATIONALITY\' | translate }}"\
                            placeholder="{{ \'LANGM_JS_NATIONALITY_PLACEHOLDER\' | translate }}"\
                            data="PreferencesDataService.countries"\
                            options="c.code as c.name for c in $ctrl.data"\
                            disabled="$ctrl.isDuringSubmit"\
                            required="true">\
                    </ith-select-field>\
                </div>\
                \
                <p class="form-heading mt-24 mb-16" translate>LANGM_JS_TILE_TITLE_TRAVEL_DOCUMENT</p>\
                \
                <div class="form-width-limiter">\
                    <ith-document-type-field\
                        form="travelBuddyForm"\
                        name="docType"\
                        model="$ctrl.modelBuddy.getIdCard().docType"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false">\
                    </ith-document-type-field>\
                    \
                    <ith-select-field\
                        form="travelBuddyForm"\
                        name="issueCountry"\
                        label="{{ \'LANGM_JS_TRAVEL_DOCUMENT_ISSUE_COUNTRY\' | translate }}"\
                        placeholder="{{ \'LANGM_JS_DOCUMENT_ISSUE_COUNTRY_PLACEHOLDER\' | translate }}"\
                        data="PreferencesDataService.countries"\
                        options="c.code as c.name for c in $ctrl.data"\
                        disabled="$ctrl.isDuringSubmit"\
                        model="$ctrl.modelBuddy.getIdCard().issueCountry"\
                        required="true">\
                    </ith-select-field>\
                    \
                    <ith-document-number-field\
                        form="travelBuddyForm"\
                        name="number"\
                        model="$ctrl.modelBuddy.getIdCard().number"\
                        prevent-asterisks="!$ctrl.isIdCardExists"\
                        disabled="$ctrl.isDuringSubmit">\
                    </ith-document-number-field>\
                    \
                    <ith-passport-field\
                        form="travelBuddyForm"\
                        name="issueDate"\
                        label="{{ (\'LANGM_JS_TRAVEL_DOCUMENT_ISSUE\' | translate) }}"\
                        date="$ctrl.modelBuddy.getIdCard().issueDate"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="false">\
                    </ith-passport-field>\
                    \
                    <ith-passport-field\
                        form="travelBuddyForm"\
                        name="expiration"\
                        label="{{ (\'LANGM_JS_TRAVEL_DOCUMENT_EXPIRATION\' | translate) }}"\
                        date="$ctrl.modelBuddy.getIdCard().expiration"\
                        type="expiration"\
                        disabled="$ctrl.isDuringSubmit"\
                        required="true">\
                    </ith-passport-field>\
                    \
                    <ith-loading-submit is-loading="$ctrl.isDuringSubmit">\
                        <translate>LANGM_JS_SUBMIT</translate>\
                    </ith-loading-submit>\
                </div>\
            </form>\
        </div>\
    ';

    var controller = function ($scope, $translate, PreferencesDataService, Person, ProfileSettingsService, PostSubmitService) {
        var self = this;

        $scope.PreferencesDataService = PreferencesDataService;

        this.isDuringSubmit = false;
        this.modelBuddy = new Person();
        this.isIdCardExists = false;

        if (this.editMode && this.buddy) {
            this.modelBuddy.srvSet(this.buddy.srvObj());
            this.isIdCardExists = true;
        }

        this.resetForm = function () {
            self.modelBuddy = new Person();
            $scope.travelBuddyForm.$setUntouched();
            $scope.travelBuddyForm.$setPristine();
        };

        this.genderSelectData = [
            {
                type: 'male',
                name: $translate.instant('LANGM_JS_GENDER_MALE')
            },
            {
                type: 'female',
                name: $translate.instant('LANGM_JS_GENDER_FEMALE')
            },
        ].map(function (item) {
            return {
                type: item.type,
                name: item.name
            };
        });

        this.submit = function (form) {
            if (form.$valid) {
                self.isDuringSubmit = true;
                var index = null;

                ProfileSettingsService.setPassenger(self.modelBuddy)
                    .then(function (response) {
                        // add new buddy case
                        if (!self.editMode) {
                            PreferencesDataService.addBuddy(response);
                            self.resetForm();
                            PostSubmitService.advancedPostSubmitHandler($scope, 'travel-buddy-scroll-anchor', index);
                        }

                        // edit existing buddy case
                        if (self.editMode) {
                            PreferencesDataService.editBuddy(response);
                            index = PreferencesDataService.travelBuddies.findIndex(function (b) {
                                return b.id === self.buddy.id;
                            });
                            PostSubmitService.advancedPostSubmitHandler($scope, 'travel-buddy-scroll-anchor', index);
                        }
                    })
                    .finally(function () {
                        self.isDuringSubmit = false;
                    });
            }
        };
    };

    controller.$inject = [
        '$scope',
        '$translate',
        'PreferencesDataService',
        'bil.Person',
        'ProfileSettingsService',
        'PostSubmitService'
    ];

    angular
        .module('user')
        .component('formTravelBuddy', {
            template: template,
            controller: controller,
            bindings: {
                editMode: '<?',
                buddy: '<?'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/travel-buddies/passenger-tile-component.js
(function (angular) {
var template = '\
        <div class="tile-box passenger-tile">\
            <div class="travel-buddy-scroll-anchor"></div>\
            <div \
                ng-if="$ctrl.person.firstName" \
                class="tile-space-between"\
            >\
                <p class="tile-heading">{{ $ctrl.person.getFullName() }}</p>\
                 <preferences-action-button \
                     click="$ctrl.removeBuddyClickHandler({$event: $event})"\
                 >\
                    {{ \'LANGM_JS_PREFERENCES_ACTION_BTN_REMOVE\' | translate }}\
                 </preferences-action-button>\
             </div>\
            \
            <div class="tile-separator"></div>\
            \
            <p class="tile-text tile-text--bold mt-16 travel-document-scroll-anchor" translate>\
                LANGM_JS_TILE_TITLE_TRAVEL_DOCUMENT\
            </p>\
            \
            <passport-info \
                ng-if="$ctrl.person.getIdCard().number" \
                person="$ctrl.person"\
            ></passport-info>\
            \
            <div class="mt-16">\
                <expandable>\
                    <form-travel-buddy \
                        buddy="$ctrl.person" \
                        edit-mode="true"\
                    ></form-travel-buddy>\
                </expandable>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, $modal, UserSessionData) {
        $scope.UserSessionData = UserSessionData;

        this.removeBuddyClickHandler = function () {
            $modal.open({
                templateUrl: 'deleteBuddy.html',
                controller: 'DeleteBuddy',
                controllerAs: '$ctrl',
                size: 'md',
                backdrop: 'static',
                windowClass: 'profile-modal-wrapper',
                resolve: {
                    buddy: this.person
                }
            });
        };
    };

    controller.$inject = [
        '$scope',
        '$modal',
        'UserSessionData'
    ];

    angular
        .module('user')
        .component('passengerTile', {
            template: template,
            controller: controller,
            bindings: {
                person: '<'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/travel-buddies/travel-buddies.component.js
(function (angular) {
var template = '\
        <div class="category-container">\
            <back-button click="$ctrl.backButtonClicked()">\
                LANGM_JS_PREFERENCES\
            </back-button>\
            <div class="category-container__main">\
                <div class="category-container__left-col">\
                    <category-header \
                        icon-id="preferences-travel-buddies-inverted" \
                        title-text="LANGM_JS_TILE_TITLE_TRAVEL_BUDDIES" \
                        description="LANGM_JS_TILE_DESCRIPTION_TRAVEL_BUDDIES"\
                    >\
                    </category-header>\
                </div>\
                <div class="category-container__right-col category-container__right-col--travel-buddies">\
                    <p class="tile-heading mb-16" translate>LANGM_JS_TILE_TITLE_TRAVEL_BUDDIES</p>\
                    \
                    <div class="passenger-tiles-holder">\
                        <passenger-tile\
                            ng-repeat="buddy in PreferencesDataService.travelBuddies"\
                            person="buddy"\
                        >\
                        </passenger-tile>\
                        \
                        <add-travel-buddy></add-travel-buddy>\
                    </div>\
                </div>\
            </div>\
        </div>\
    ';

    var controller = function ($scope, PreferencesDataService) {
        $scope.PreferencesDataService = PreferencesDataService;
    };

    controller.$inject = [
        '$scope',
        'PreferencesDataService'
    ];

    angular
        .module('user')
        .component('travelBuddies', {
            template: template,
            controller: controller,
            bindings: {
                backButtonClicked: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/preferences/upgrade-rewards-banner.component.js
(function (angular) {
var template = '\
        <a \
            class="upgrade-rewards-banner" \
            href="#"\
        >\
            <div class="upgrade-rewards-banner__top-svg">\
                <svg-icon id="upgrade-rewards-1"></svg-icon>\
            </div>\
            \
            <p class="upgrade-rewards-banner__text">\
                <span translate>LANGM_JS_UPGRADE_REWARDS_SENTENCE_PART_ONE</span>\
                <span\
                     class="upgrade-rewards-banner__bold-text"\
                     translate\
                 >\
                     LANGM_JS_UPGRADE_REWARDS\
                 </span>\
                <span translate>LANGM_JS_UPGRADE_REWARDS_SENTENCE_PART_TWO</span>\
            </p>\
            \
            <div class="upgrade-rewards-banner__bottom-svg">\
                <svg-icon id="upgrade-rewards-2"></svg-icon>\
            </div>\
            \
        </a>\
    ';

    var controller = function () {

    };

    controller.$inject = [

    ];

    angular
        .module('user')
        .component('upgradeRewardsBanner', {
            template: template,
            transclude: true,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/CheckInService.js
(function(angular) {
var CheckInServiceFactory = function (ApiTools) {
        
        /**
         * The API endpoints configuration
         *
         * Each endpoint is a configuration object which must have following properties:
         *
         * - {String}   url        The URL to the API with optional parameters as :parameterName
         * - {String}   method     The one of HTTP verbs (POST, GET...)
         * - {Function} respParser The function called by SearchAPI before returning results to caller.
         *                         It always receives two arguments the SearchAPI instance and the server JSON response
         *                         object. It must return whatever should be returned to the SearchAPI caller.
         *                         Returning $q.reject from this function will trigger error handler on calling code.
         *                         https://en.vola.ro/profile/save_traveler
         */
        var endpoints = {
            index: {
                url: '/boarding_pass/index/',
                method: 'POST',
                respParser: defaultParser
            },

            checkinInfo: {
                url: '/api/checkIn/information/',
                method: 'GET',
                respParser: defaultParser
            }, 

            checkinSave: {
                url: '/api/checkIn/savePaxData/',
                method: 'POST',
                respParser: defaultParser
            },

            getCountries: {
                url: '/api/countries/get/',
                method: 'GET',
                respParser: defaultParser
            }
        };

        /**
         * @class UserService
         * @constructor
         */
        var CheckInService = function () {

        };

        CheckInService.prototype = /** @lends UserService.prototype */ {
            /**
             * Create Function
             *
             * @param {String} username
             * @param {String} password
             * @return {Promise}
             */
            index: function (data) {
                var tempChange = (JSON.parse(JSON.stringify(endpoints.index)));
                tempChange.url = endpoints.index.url + data.id;
                tempChange.respParser = defaultParser;
                return ApiTools.fetch(this, tempChange, data);
            },

            /**
             * Returns check-in information by a flight token.
             *
             * @param  {String}  token The flight token
             * @return {Promise}
             */
            getInformation: function (token) {
                var checkinInfo = angular.copy(endpoints.checkinInfo);
                checkinInfo.url += token;
                return ApiTools.fetch(this, checkinInfo);
            },

            /**
             * Saves check-in information in backend.
             *
             * @param  {String}  token
             * @param  {Object}  data
             * @return {Promise}
             */
            saveInformation: function (token, data) {
                var checkinSave = angular.copy(endpoints.checkinSave);
                checkinSave.url += token;
                return ApiTools.fetch(this, checkinSave, data);
            },

            /**
             * Returns country list from backend.
             *
             * @returns {Promise}
             */
            getCountries: function () {
                return ApiTools.fetch(this, endpoints.getCountries);
            },

            /**
             * Self check-in in profile switch
             *
             * @return {Boolean}
             */      
            isSelfCheckinEnabled: function () {
                return true;
            }
        };

        CheckInService.prototype.constructor = CheckInService;

        /**
         * Parse response fro login
         *
         * @param {Object} response
         * @return {Object}
         */
        function defaultParser(response) {
            return response.response;
        }

        return new CheckInService();
    };

    CheckInServiceFactory.$inject = [
        'ApiTools'
    ];

    angular
        .module('user')
        .factory('CheckInService', CheckInServiceFactory);
	
}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/PostSubmitService.js
(function (angular) {
var Service = function () {
        var DELAY = 100;

        Service.prototype.postSubmitHandler = function ($scope, selector, broadcast) {
            setTimeout(function () {
                document
                    .querySelector(selector)
                    .scrollIntoView({behavior: 'smooth'});

                if (!broadcast) {
                    $scope.$emit('expandable.toggleExpansion');
                }

                if (broadcast) {
                    $scope.$broadcast('expandable.toggleExpansion');
                }
            }, DELAY);
        };

        Service.prototype.advancedPostSubmitHandler = function ($scope, cssClass, index) {
            setTimeout(function () {
                var billingItems = Array.from(
                    document.getElementsByClassName(cssClass)
                );

                var element = null;

                if (index === null) { // new item added case
                    element = billingItems[billingItems.length - 1];
                }

                if (index !== null) {
                    element = billingItems[index];
                }

                element.scrollIntoView({behavior: 'smooth'});
                $scope.$emit('expandable.toggleExpansion');
            }, DELAY);
        };
    };

    Service.$inject = [];

    angular
        .module('user')
        .service('PostSubmitService', Service);
}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/PreferencesDataService.js
(function (angular) {
var Service = function (AuthValuesConverter, UserResponsesAdapterService, API_STATUSES_PROFILE, PreferredAirportService) {
        this.isInitialized = false;

        this.accountOwner = null;
        this.isEmailVerified = true;
        this.isOldPasswordExists = true;
        this.preferredAirport = PreferredAirportService.get();
        this.preferredPaymentMethod = null;
        this.creditCards = [{
            id: '1', cardNumber: '1234567890121234', cardHolder: 'Card Holder', expiryDate: '09/26', cvc: '000',
        }, {
            id: '2', cardNumber: '1234567890123456', cardHolder: 'Card Holder', expiryDate: '12/28', cvc: '000',
        }];

        this.travelBuddies = [];
        this.billings = [];
        this.countries = null;

        Service.prototype.setCountries = function (countries) {
            this.countries = countries;
        };

        Service.prototype.setIsInitialized = function (isInitialized) {
            this.isInitialized = isInitialized;
        };

        // account owner

        Service.prototype.setIsEmailVerified = function (isEmailVerified) {
            this.isEmailVerified = isEmailVerified;
        };

        Service.prototype.setIsOldPasswordExists = function (value) {
            this.isOldPasswordExists = value;
        };

        Service.prototype.setAccountOwner = function (response) {
            var accountOwner = {};

            accountOwner = UserResponsesAdapterService.transformPassengerData(response.response);
            this.accountOwner = AuthValuesConverter.getPersonInstance(accountOwner);
        };

        Service.prototype.setPreferredAirport = function (airport) {
            this.preferredAirport = airport;
        };

        Service.prototype.setPreferredPaymentMethod = function (payMethod) {
            this.preferredPaymentMethod = payMethod;
        };

        Service.prototype.addCreditCard = function (card) {
            this.creditCards.push({
                id: Math.random().toString(),
                cardNumber: card.cardNumber,
                cardHolder: card.cardHolder,
                expiryDate: card.expiryDate,
                cvc: card.cvc,
            });
        };

        Service.prototype.deleteCreditCard = function (card) {
            this.creditCards = this.creditCards.filter(function (c) {
                return c.id !== card.id;
            });
        };

        Service.prototype.updatePersonalDetails = function (response) {
            var resp = response.response.data;

            this.accountOwner.id = resp.id;
            this.accountOwner.firstName = resp.first_name;
            this.accountOwner.lastName = resp.last_name;
            this.accountOwner.gender = resp.gender;
            this.accountOwner.birthDate = resp.birth_date;
            this.accountOwner.nationality = resp.nationalities[0].code;
            this.accountOwner.phone.number = resp.phone;
            this.accountOwner.phone.prefix = resp.phone_prefix;
        };

        Service.prototype.updateAccountOwnerDoc = function (response) {
            var resp = response.response.data;

            this.accountOwner.idCard.docType = resp.type;
            this.accountOwner.idCard.issueCountry = resp.country;
            this.accountOwner.idCard.number = resp.doc_number;
            this.accountOwner.idCard.issueDate = resp.release_date;
            this.accountOwner.idCard.expiration = resp.expiration_date;
        };

        // travel buddies

        Service.prototype.setTravelBuddies = function (response) {
            var buddies = response.response.map(function (buddy) {
                return UserResponsesAdapterService.transformPassengerData(buddy);
            });
            buddies = AuthValuesConverter.getTravelBuddiesArray(buddies);

            this.travelBuddies = buddies;
        };

        Service.prototype.addBuddy = function (response) {
            var responseBuddy = UserResponsesAdapterService.transformPassengerData(response.response);
            var buddy = AuthValuesConverter.getPersonInstance(responseBuddy);

            this.travelBuddies.push(buddy);
        };

        Service.prototype.editBuddy = function (response) {
            var responseBuddy = UserResponsesAdapterService.transformPassengerData(response.response);
            var index = this.travelBuddies.findIndex(function (b) {
                return b.id === responseBuddy.id;
            });

            this.travelBuddies[index].srvSet(responseBuddy);
        };

        Service.prototype.removeBuddy = function (buddy) {
            this.travelBuddies = this.travelBuddies.filter(function (b) {
                return b.id !== buddy.id;
            });
        };

        // billings

        Service.prototype.setBillings = function (response) {
            var billings = response.response.map(function (billing) {
                return UserResponsesAdapterService.transformBillingData(billing);
            });
            billings = AuthValuesConverter.getBillingsArray(billings);

            this.billings = billings;
        };

        Service.prototype.editBilling = function (response) {
            var responseBilling = UserResponsesAdapterService.transformBillingData(response.response);
            var index = this.billings.findIndex(function (b) {
                return b.id === responseBilling.id;
            });

            this.billings[index].srvSet(responseBilling);
        };

        Service.prototype.addBilling = function (response) {
            var responseBilling = UserResponsesAdapterService.transformBillingData(response.response);
            var billing = AuthValuesConverter.getBillingInstance(responseBilling);

            this.billings.push(billing);
        };

        Service.prototype.removeBilling = function (billing) {
            this.billings = this.billings.filter(function (b) {
                return b.id !== billing.id;
            });
        };
    };

    Service.$inject = [
        'AuthValuesConverter',
        'UserResponsesAdapterService',
        'API_STATUSES_PROFILE',
        'PreferredAirportService'
    ];

    angular
        .module('user')
        .service('PreferencesDataService', Service);
}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/PreferredAirportService.js
(function (angular) {
var Service = function ($localStorage) {
        this.key = 'preferredAirport';

        Service.prototype.get = function () {
            if ($localStorage[this.key]) {
                return JSON.parse($localStorage[this.key]);
            }

            return null;
        };

        Service.prototype.set = function (location) {
            return $localStorage[this.key] = JSON.stringify(location);
        };
    };

    Service.$inject = [
        '$localStorage'
    ];

    angular
        .module('user')
        .service('PreferredAirportService', Service);
}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/PriceFormatterService.js
(function (angular) {

    var service = function () {
        this.formatPrice = function (amount, currencyCode) {
            if (!amount || !currencyCode) {
                return '';
            }

            const symbols = {
                EUR: '€',
                RON: 'RON',
                PLN: 'zł',
                GBP: '£',
                HUF: 'Ft',
                USD: '$',
                BGN: 'BGN',
                CZK: 'Kč'
            };

            const currencySymbol = symbols[currencyCode] || currencyCode;

            if (currencyCode === 'USD' || currencyCode === 'GBP') {
                return currencySymbol + amount;
            }

            return amount + ' ' + currencySymbol;
        };
    };

    service.$inject = [];

    angular
        .module('base')
        .service('PriceFormatterService', service);

}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/UserResponsesAdapterService.js
(function (angular) {
var Service = function (AuthValuesConverter) {
        this.transformPassengerData = function (response) {
            var passenger = response.passenger || {};
            var document = response.document;

            return {
                'type': passenger.type,
                'id': passenger.id,
                'first_name': passenger.first_name,
                'last_name': passenger.last_name,
                'nationality': passenger.nationalities && passenger.nationalities[0] ? passenger.nationalities[0].code : '',
                'birth_date': passenger.birth_date,
                'gender': passenger.gender,

                'phone_prefix': passenger.phone_prefix,
                'phone_number': passenger.phone,
                'phone': {
                    'prefix': passenger.phone_prefix,
                    'number': passenger.phone
                },
                'id_card': document
                    ? {
                        'doc_type': document.type,
                        'number': document.doc_number,
                        'issue_country': document.country,
                        'issued': document.release_date,
                        'expiration': document.expiration_date,
                        'id': document.id
                    }
                    : null
            };
        };

        this.transformBillingData = function (response) {
            return {
                type: response.type,
                id: response.id,
                name: response.company_name,
                vat_number: response.nip,
                first_name: response.first_name,
                last_name: response.last_name,
                address: {
                    street: response.address,
                    city: response.city,
                    country: response.country,
                    zipCode: response.postcode
                }
            };
        };
    };

    Service.$inject = [];

    angular
        .module('user')
        .service('UserResponsesAdapterService', Service);
}(angular));
;

// Source: ../shared/public_html/assets/js/user/services/UserService.js
angular.module('user')

/**
 * @name UserService
 *
 * @description UserService
 */
.factory('UserService',
['ApiTools','WarmUpSrv','$q', '$http', 'Dictionaries', 'appConfig',
function UserServiceFactory(ApiTools, WormUpSrv, $q, $http, Dictionaries, appConfig) {
var
    /**
     * The API endpoints configuration
     *
     * Each endpoint is a configuration object which must have following properties:
     *
     * - {String}   url        The URL to the API with optional parameters as :parameterName
     * - {String}   method     The one of HTTP verbs (POST, GET...)
     * - {Function} respParser The function called by SearchAPI before returning results to caller.
     *                         It always receives two arguments the SearchAPI instance and the server JSON response
     *                         object. It must return whatever should be returned to the SearchAPI caller.
     *                         Returning $q.reject from this function will trigger error handler on calling code.
     *                         https://en.vola.ro/profile/save_traveler
     */
    endpoints = {
      register: {url: appConfig.getUriPrefix() + '/profile/register', method: 'POST', respParser: defaultParser},
      forgotPass: {url: appConfig.getUriPrefix() + '/profile/forgot_password', method: 'POST', respParser: defaultParser},
      passengersData: {url: appConfig.getUriPrefix() + '/profile/my_data', method: 'POST', respParser: defaultParser},
      passengersDataGetter: {url: appConfig.getUriPrefix() + '/profile/my_data', method: 'GET', respParser: defaultParser},
      changePassword: {url: appConfig.getUriPrefix() + '/profile/change_password', method: 'POST', respParser: defaultParser},
      changePassport: {url: appConfig.getUriPrefix() + '/profile/passport_info', method: 'POST', respParser: defaultParser},
      removeTraveler: {url: appConfig.getUriPrefix() + '/profile/deleteTraveler', method: 'POST', respParser: defaultParser},
      addTraveler: {url: appConfig.getUriPrefix() + '/profile/save_traveler', method: 'POST', respParser: defaultParser},
      saveCustomer: {url: appConfig.getUriPrefix() + '/profile/saveMyData', method: 'POST', respParser: defaultParser},
      addBilling: {url: appConfig.getUriPrefix() + '/profile/billing_info/', method: 'POST', respParser: defaultParser},
      deleteBilling: {url: appConfig.getUriPrefix() + '/profile/delete_billing', method: 'POST', respParser: defaultParser},
      defaultBilling: {url: appConfig.getUriPrefix() + '/profile/default_billing/', method: 'POST', respParser: defaultParser},
      searchHistory: { url: appConfig.getUriPrefix() + '/profile/archiveSearches/', method: 'POST', respParser: defaultParser},
      userPreferences: {url: appConfig.getUriPrefix() + '/profile/preferences/', method: 'POST', respParser: defaultParser},
      userPreferencesGetter: {url: appConfig.getUriPrefix() + '/profile/preferences/', method: 'GET', respParser: defaultParser},
      saveSeat: {url: appConfig.getUriPrefix() + '/profile/saveSeat', method: 'POST', respParser: defaultParser},
      saveLang: {url: appConfig.getUriPrefix() + '/profile/saveLang', method: 'POST', respParser: defaultParser},
      saveCurrency: {url: appConfig.getUriPrefix() + '/profile/saveCurrency', method: 'POST', respParser: defaultParser},
      deleteFFCard: {url: appConfig.getUriPrefix() + '/profile/deleteFFCard/', method: 'POST', respParser: defaultParser},
      cashBack: {url: appConfig.getUriPrefix() + '/profile/coupons/', method: 'POST', respParser: defaultParser},
      profileDelete: {url: appConfig.getUriPrefix() + '/profile/profileDelete/', method: 'POST', respParser: defaultParser},
      myBookings: {url: appConfig.getUriPrefix() + '/profile/', method: 'POST', respParser: dictionaryParser},
      removeArchive: {url: appConfig.getUriPrefix() + '/userSearches/clearUserSearches', method: 'POST', respParser: defaultParser},
      modifyRes: {url: appConfig.getUriPrefix() + '/profile/modifyReservation', method: 'POST', respParser: defaultParser},
      cancelRes: {url: appConfig.getUriPrefix() + '/profile/cancelReservation', method: 'POST', respParser: defaultParser},
      reConfirmation: {url: appConfig.getUriPrefix() + '/profile/resendConfirmation', method: 'POST', respParser: defaultParser},
      checkForgotPasswordToken: { url: appConfig.getUriPrefix() + '/profile/getForgotPassTokenError', method: 'GET', respParser: defaultParser },
      locationPictures: { url: appConfig.getUriPrefix() + '/api/images/countryCodes', method: 'POST' },

      // /profile/cancelReservation/
      // /profile/modifyReservation/
      // profile/resendConfirmation

      // https://en.vola.ro/userSearches/clearUserSearches?searchId=27195602
      // userSearches/clearUserSearches
      // profile/default_billing/280577
      // https://en.vola.ro/profile/billing_info/0
    },

    /**
     * @class UserService
     * @constructor
     */
    UserService = function () {

    };

  UserService.prototype = /** @lends UserService.prototype */
  {

    getPassengersDataUrl: function(){
      return endpoints.passengersData.url;
    },
    getUserPreferencesUrl: function(){
      return endpoints.userPreferences.url;
    },

    /**
     * Create Function
     *
     * @param {String} username
     * @param {String} password
     * @return {Promise}
     */
    Create: function (data) {
      return ApiTools.fetch(this, endpoints.register, {
        data: data,
        save: 1
      });
    },

    /**
     * Passenger Data
     * @param data
     * @returns {Promise}
     */
    passengersData: function () {
      return ApiTools.fetch(this, endpoints.passengersData, {});
    },

    /**
     * Passenger Data
     *
     * @returns {Promise}
     */
    getPassengersData: function (timeout) {//requesterObj, apiEndpoint, reqData, reqUrlData, timeout
      timeout = typeof timeout !== 'undefined' ?  timeout : null;
      return ApiTools.fetch(this, endpoints.passengersDataGetter, null, {}, timeout);
    },

    /**
     * Passenger Data cached
     *
     * @returns {Promise}
     */
    getPassengersDataAndCache: function (timeout) {//requesterObj, apiEndpoint, reqData, reqUrlData, timeout
      timeout = typeof timeout !== 'undefined' ?  timeout : null;
      return ApiTools.fetchCache(this, endpoints.passengersDataGetter, null, {}, timeout);
    },
    /**
     * Passenger preferences
     *
     * @returns {Promise}
     */
    getUserPreferences: function (timeout) {
      timeout = typeof timeout !== 'undefined' ?  timeout : null;
      return ApiTools.fetch(this, endpoints.userPreferencesGetter, null, {}, timeout);
    },

    /**
     * Passenger preferences cached
     *
     * @returns {Promise}
     */
    getUserPreferencesAndCache: function (timeout) {
      timeout = typeof timeout !== 'undefined' ?  timeout : null;
      return ApiTools.fetchCache(this, endpoints.userPreferencesGetter, null, {}, timeout);
    },

    /**
     * Forgot Password
     * @param data
     * @returns {Promise}
     * @constructor
     */
    ForgotPass: function (data) {
      return ApiTools.fetch(this, endpoints.forgotPass, {
        email: data.email,
        save: 1
      });
    },

    /**
     * Forgot Pass step 2 change password
     * @param data
     * @returns {Promise}
     * @constructor
     */
    ForgotPassToken: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.forgotPass)));
      tempChange.url = endpoints.forgotPass.url;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    checkForgotPassToken: function (token) {
      endpoints.checkForgotPasswordToken.url += '/' + token
      return ApiTools.fetch(this, endpoints.checkForgotPasswordToken);
    },

    /**
     * Change Password
     * @param data
     * @returns {Promise}
     * @constructor
     */
    ChangePassword: function (data) {
      data.save = 1;
      return ApiTools.fetch(this, endpoints.changePassword, data);
    },

    /**
     * Change Passport
     * @param data
     * @returns {Promise}
     * @constructor
     */
    ChangePassport: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.changePassport)));
      tempChange.url = tempChange.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    /**
     * Delete Travel Buddy
     * @param id
     * @returns {Promise}
     * @constructor
     */
    DeleteTraveler: function (id) {
      return $http.post(endpoints.removeTraveler.url + '/' + id , {});
    },

    /**
     * Add Traveler
     * @param data
     * @returns {Promise}
     * @constructor
     */
    AddTraveler: function (data) {
      data.save = 1;
      return ApiTools.fetch(this, endpoints.addTraveler, data);
    },

    /**
     * Save Customer
     * @param data
     * @returns {Promise}
     * @constructor
     */
    SaveCustomer: function (data) {
      data.save = 1;
      return ApiTools.fetch(this, endpoints.saveCustomer, data);
    },

    /**
     * Add Billing
     * @param data
     * @returns {Promise}
     * @constructor
     */
    AddBilling: function (data) {

      if (!data.id) {
        data.id = 0;
      }

      var tempChange = (JSON.parse(JSON.stringify(endpoints.addBilling)));
      tempChange.url = tempChange.url + '/' + data.id;
      tempChange.respParser = defaultParser;

      return ApiTools.fetch(this, tempChange, data);
    },

    /**
     * Delete Billing
     * @param id
     * @returns {Promise}
     * @constructor
     */
    DeleteBilling: function (id) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.deleteBilling)));
      tempChange.url = tempChange.url + '/' + id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, {});
    },

    /**
     * Delete Billing
     * @param data.
     * @returns {Promise}
     * @constructor
     */
    editBilling: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.addBilling)));
      tempChange.url = tempChange.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    /**
     * Set Default billing
     * @param data
     * @returns {Promise}
     */
    defaultBilling: function (data) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.defaultBilling)));
      tempChange.url = tempChange.url + '/' + data.id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, data);
    },

    /**
     * Search History
     * @returns {Promise}
     */
    searchHistory: function () {
      var data=WormUpSrv.getByKey('archiveSearches',true);
      if(data){
        var deferred = $q.defer();
        deferred.resolve(data);
        return deferred.promise;

      }else{
        return ApiTools.fetch(this, endpoints.searchHistory, {});
      }


    },
    /**
     * user Proferences
     * @param data
     * @returns {Promise}
     */
    userPreferences: function (data) {
      return ApiTools.fetch(this, endpoints.userPreferences, data);
    },

    /**
     * Save Seat
     * @param data
     * @returns {Promise}
     */
    saveSeat: function (data) {
      return ApiTools.fetch(this, endpoints.saveSeat, data);
    },

    /**
     * Save lang
     * @param data
     * @returns {Promise}
     */
    saveLang: function (data) {
      return ApiTools.fetch(this, endpoints.saveLang, data);
    },

    /**
     * Save currency
     * @param data
     * @returns {Promise}
     */
    saveCurrency: function (data) {
      return ApiTools.fetch(this, endpoints.saveCurrency, data);
    },

    /**
     * Delete FF Card
     * @param data
     * @returns {Promise}
     */
    deleteFFCard: function (data) {
      return ApiTools.fetch(this, endpoints.deleteFFCard, data);
    },
    /**
     * Delete FF Card
     * @param data
     * @returns {Promise}
     */
    cashBack: function (data) {
      return ApiTools.fetch(this, endpoints.cashBack, data);
    },
    /**
     * Delete FF Card
     * @param data
     * @returns {Promise}
     */
    profileDelete: function (data) {
      return ApiTools.fetch(this, endpoints.profileDelete, data);
    },

    /**
     * myBookings
     * @param data
     * @returns {Promise}
     */
    myBookings: function (data) {
      return ApiTools.fetch(this, endpoints.myBookings, data);
    },

    getLocationPictures: function (data) {
      var req = endpoints.locationPictures;

      req.data = data;

      return $http(req)
    },

    /**
     * Remove Archive
     * @param data
     * @returns {Promise}
     */
    removeArchive: function (id) {
      id = typeof id !== 'undefined' ? id : '';

      if (id != '') {
        var tempChange = (JSON.parse(JSON.stringify(endpoints.removeArchive)));
        tempChange.url = tempChange.url + '?searchId=' + id;
        tempChange.respParser = defaultParser;
      }
      else {
        var tempChange = endpoints.removeArchive;
      }

      return ApiTools.fetch(this, tempChange, {ngData: 1});
    },

    /**
     * Cancel Reservation
     * @param id
     * @returns {Promise}
     */
    cancelRes: function (id) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.cancelRes)));
      tempChange.url = tempChange.url + '/' + id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, {});
    },
    /**
     * Modify Reservation
     * @param id
     * @returns {Promise}
     */
    modifyRes: function (id) {
      var tempChange = (JSON.parse(JSON.stringify(endpoints.modifyRes)));
      tempChange.url = tempChange.url + '/' + id;
      tempChange.respParser = defaultParser;
      return ApiTools.fetch(this, tempChange, {});
    },

    /**
     * Resend Confirmation
     * @param data
     * @returns {Promise}
     */
    reConfirmation: function (data) {
      return ApiTools.fetch(this, endpoints.reConfirmation, data);
    }
  };

  UserService.prototype.constructor = UserService;

  /**
   * Parse response fro login
   *
   * @param {Object} response
   * @return {Object}
   */
  function defaultParser(response) {
    return response.response;
  }

  /**
   * Parse API response and add data to dictionaries
   *
   * @param  {Object} response
   * @return {Object}
   */
  function dictionaryParser(response) {
    Dictionaries.addDictionary(response.response, appConfig.getLanguageCode());
    return response.response;
  }

  return new UserService();
}]);
;

// Source: ../shared/public_html/assets/js/user/services/UserServiceV2.js
(function (angular) {
var UserServiceV2 = function ($q, JwtTokenService, ProfileServiceClient, UserSessionData, FlightBooking) {
        var buildPassengerData = function (passenger, document) {
            return {
                birth_date: passenger.birth_date || '',
                first_name: passenger.first_name || '',
                id: passenger.id || '',
                last_name: passenger.last_name || '',
                nationality: passenger.nationalities && passenger.nationalities[0] ? passenger.nationalities[0].code : '',
                type: passenger.type || '',
                id_card: document
                    ? {
                        doc_type: document.type,
                        number: document.doc_number,
                        issue_country: document.country,
                        issued: document.release_date,
                        expiration: document.expiration_date
                    }
                    : null
            };
        };

        var buildCustomer = function (response) {
            var customer = response.data;
            var passenger = customer.passenger || {};
            var document = customer.document || {};
            var result = {};

            result = {
                contact: {
                    email: UserSessionData.getEmail(),
                    phone: {
                        prefix: passenger.phone_prefix || '',
                        number: passenger.phone || ''
                    }
                },
                person: buildPassengerData(passenger, document)
            };

            return result;
        };

        var buildBuddies = function (response) {
            var buddies = response.data;
            var result = [];

            buddies.forEach(function (buddy) {
                var passenger = buddy.passenger;
                var document = buddy.document;

                result.push(buildPassengerData(passenger, document));
            });

            return result;
        };

        var buildBillings = function (response) {
            var billings = response.data;
            var result = [];

            billings.forEach(function (billing) {
                result.push({
                    address: {
                        city: billing.city,
                        country: billing.country,
                        street: billing.address,
                        zipCode: billing.postcode
                    },
                    name: billing.company_name,
                    vat_number: billing.nip,
                    type: billing.type,
                    id: billing.id,
                    first_name: billing.first_name,
                    last_name: billing.last_name
                });
            });

            return result;
        };

        /**
         * @returns {Promise<any>}
         */
        this.getPassengersData = function (withoutDepDate) {
            var token = JwtTokenService.getAuthJwtToken();
            var queryParams = null;

            if (!withoutDepDate) {
                queryParams = '?departure_date=' + FlightBooking.flightDetails.getDepDate();
            }

            var requests = [
                ProfileServiceClient.getProfile(token, queryParams),
                ProfileServiceClient.getPassengers(token, queryParams),
                ProfileServiceClient.getBillings(token)
            ];

            return $q.all(requests);
        };

        /**
         * Adapter of the new response structure
         * @param {Object} response
         * @returns {Object}
         */
        this.adaptResponse = function (response) {
            var newResp = {};

            newResp.customer = buildCustomer(response[0]);
            newResp.buddies = buildBuddies(response[1]);
            newResp.billing = buildBillings(response[2]);

            return newResp;
        };

        this.getBillings = function () {
            var token = JwtTokenService.getAuthJwtToken();

            return ProfileServiceClient.getBillings(token);
        };

        this.adaptBillingsResponse = function (response) {
            return buildBillings(response);
        };
    };

    UserServiceV2.$inject = [
        '$q',
        'JwtTokenService',
        'ProfileServiceClient',
        'UserSessionData',
        'bok.FlightBooking'
    ];

    angular
        .module('user')
        .service('UserServiceV2', UserServiceV2);
}(angular));
;

// Source: ../shared/public_html/assets/js/user/sub-nav.component.js
(function (angular) {
var template = '\
        <div class="sub-nav">\
            <div ng-if="$ctrl.isLeftOverlayVisible" class="sub-nav__overlay sub-nav__overlay--left"></div>\
            \
            <div class="sub-nav__scrollable">\
                <a \
                    ng-repeat="link in $ctrl.links"\
                    href="{{ link.url }}"\
                    class="sub-nav__link"\
                    ng-class="{\'sub-nav__link--active\': link.isActive}"\
                    >\
                    {{ link.title }}\
                </a>\
            </div>\
            \
            <div ng-if="$ctrl.isRightOverlayVisible" class="sub-nav__overlay sub-nav__overlay--right"></div>\
        </div>\
    ';

    var controller = function ($scope, $state, $translate) {
        this.isLeftOverlayVisible = false;
        this.isRightOverlayVisible = false;
        this.activeUrl = $state.current.url || '';
        this.links = [
            {
                url: '/ngProfile',
                isActive: false,
                title: $translate.instant('LANGM_JS_MY_BOOKINGS')
            },
            // {
            //     url: '#',
            //     isActive: false,
            //     title: $translate.instant('LANGM_JS_UPGRADE_REWARDS')
            // },
            {
                url: '/ngProfile/cashBack',
                isActive: false,
                title: $translate.instant('LANGM_JS_COUPONS')
            },
            {
                url: '/ngProfile/preferences',
                isActive: false,
                title: $translate.instant('LANGM_JS_PREFERENCES')
            }
        ];
        var self = this;

        this.setActiveLink = function () {
            this.activeUrl = $state.current.url;

            var match = this.links.find(function (link) {
                return link.url === self.activeUrl;
            });

            match.isActive = true;
        };

        this.scrollIntoActiveLink = function () {
            var activeElement = document.querySelector('.sub-nav__link--active');

            activeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        };

        this.handleOverlays = function (e) {
            var parent = document.querySelector('.sub-nav__scrollable');
            var firstChild = parent.querySelector('a:first-child');
            var lastChild = parent.querySelector('a:last-child');
            var parentLeft = Math.floor(parent.getBoundingClientRect().left);
            var parentRight = Math.floor(parent.getBoundingClientRect().right);
            var firstChildLeft = Math.floor(firstChild.getBoundingClientRect().left);
            var lastChildRight = Math.floor(lastChild.getBoundingClientRect().right);

            $scope.$evalAsync(function () {
                self.isLeftOverlayVisible = firstChildLeft < parentLeft;
                self.isRightOverlayVisible = lastChildRight > parentRight;
            });
        };

        this.$onInit = function () {
            document
                .querySelector('.sub-nav__scrollable')
                .addEventListener('scroll', this.handleOverlays);

            this.setActiveLink();
            setTimeout(function () {
                self.handleOverlays();
                self.scrollIntoActiveLink();
            }, 1000);
        };

        this.$onDestroy = function () {
            document
                .querySelector('.sub-nav__scrollable')
                .removeEventListener('scroll', this.handleOverlays);
        };

    };

    controller.$inject = [
        '$scope',
        '$state',
        '$translate'
    ];

    angular
        .module('user')
        .component('subNav', {
            template: template,
            controller: controller,
            bindings: {}
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/user/verify-email/verify-email.component.js
(function (angular) {
var template = '\
        <button\
            type="button"\
            class="btn btn-outline btn-verify-email"\
            ng-class="{ \'btn-verify-email--loading\': $ctrl.isLoading }"\
            ng-click="$ctrl.clickHandler()"\
        >\
            <span class="btn-verify-email__text">\
                <translate>LANGM_JS_VERIFY_EMAIL</translate>\
            </span>\
            <span class="btn-verify-email__spinner"></span>\
        </button>\
    ';

    var controller = function () {
        this.clickHandler = function () {
            if (!this.isLoading) {
                this.click();
            }
        }
    };

    angular
        .module('user')
        .component('verifyEmail', {
            template: template,
            controller: controller,
            bindings: {
                isLoading: '<',
                click: '&'
            }
        });

}(angular));
;

// Source: ../shared/public_html/assets/js/widgets/segment-alert/segment-alert.component.js
(function(angular) {
/**
     * @name        segmentAlertComponent
     * @description The alert component for train and bus segments.
     */

    var segmentAlertComponent = {
        selector: 'segment-alert-component',
        templateUrl: "/tpl/show/jsShared/templates/widgets/segment-alert/segment-alert",
        controller: 'SegmentAlertController',
        bindings: {
            'segmentType': '<',
            'arr': '<',
            'dep': '<'
        }
    };

    angular.module('ITH.Widgets.SegmentAlertComponent')
        .component('segmentAlertComponent', segmentAlertComponent);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/segment-alert/segment-alert.controller.js
(function(angular) {
/**
     * @name        SegmentAlertController
     * @description The alerts controllers for train and bus segments.
     */
    var SegmentAlertController = function() {
        this.isShouldBeDisplay = false;
        this.$onInit = function() {

            switch (this.segmentType) {
                case 'bus':
                    this.lang = 'LANGM_JS_RESERVATION_WARN_BUS';
                    this.isShouldBeDisplay = true;
                    break;
                case 'train':

                    this.lang = 'LANGM_JS_RESERVATION_WARN_TRAIN';
                    this.isShouldBeDisplay = true;
                    break;
                default:
                    break;
            }
        }
    };

    angular.module('ITH.Widgets.SegmentAlertComponent')
        .controller('SegmentAlertController', SegmentAlertController);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/segment-refuel-alert/segment-refuel-alert.component.js
(function(angular) {
/**
     * @name        segmentRefuelAlertComponent
     * @description The refuel alert component.
     */

    var segmentRefuelAlert = {
        selector: 'segment-refuel-alert',
        templateUrl: "/tpl/show/jsShared/templates/widgets/segment-refuel-alert/segment-refuel-alert",
        bindings: {
            'refuelAirport': '<',
            'duration': '<'
        },
        controller: 'SegmentRefuelAlertController'
    };

    angular.module('ITH.Widgets.SegmentRefuelAlert')
        .component('segmentRefuelAlert', segmentRefuelAlert);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/segment-refuel-alert/segment-refuel-alert.controller.js
(function(angular) {
/**
     * @name        SegmentRefuelAlertController
     * @description The alert ctrl for train and bus segments.
     */
    var SegmentRefuelAlertController = function () {
      this.showDuration = function () {
        var minutes, hours, duration = this.duration || 0;

        if (duration < 60) {
          return duration + 'm';
        } else {
          hours = Math.floor(duration / 60);
          minutes = duration % 60;
          return hours + 'h ' + minutes + 'm';
        }
      }

    };

    angular.module('ITH.Widgets.SegmentAlertComponent')
        .controller('SegmentRefuelAlertController', SegmentRefuelAlertController);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/segment-type-carrier-image/segment-type-carrier-image.component.js
(function(angular) {
/**
     * @name        SegmentTypeCarrierImageComponent
     * @description The type carrier image for train and bus segments.
     */

    var segmentTypeCarrierImage = {
        selector: 'segment-type-carrier-image',
        templateUrl: '/tpl/show/jsShared/templates/widgets/segment-type-carrier-image/segment-type-carrier-image',
        controller: 'SegmentTypeCarrierImageController',
        bindings: {
            carrier:'<',
            segmentType: '<'
        }
    };

    angular.module('ITH.Widgets.SegmentTypeCarrierImage')
        .component('segmentTypeCarrierImage', segmentTypeCarrierImage);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/segment-type-carrier-image/segment-type-carrier-image.controller.js
(function(angular) {
/**
     * @name        SegmentTypeCarrierImageController
     * @description The type carrier image ctrl for train and bus segments.
     */
    var SegmentTypeCarrierImageController = function (AppConfig) {
        /**
         * Flag for flight type image
         *
         * @param {Boolean}
         */
        this.isFly = false;

        this.getImgVersion = AppConfig.getJsCacheBuster;

        this.$onInit = function () {
            switch (this.segmentType) {
                case 'bus':
                    this.svgUrl = '/assets/img/ui/icons/svg/bun_icon.svg';
                    break;

                case 'train':
                    this.svgUrl = '/assets/img/ui/icons/svg/train_icon.svg';
                    break;

                default:
                    this.isFly = true;
                    break;
            }
        };
    };

    SegmentTypeCarrierImageController.$inject = ['appConfig'];

    angular
        .module('ITH.Widgets.SegmentTypeCarrierImage')
        .controller('SegmentTypeCarrierImageController', SegmentTypeCarrierImageController);

})(angular);




;

// Source: ../shared/public_html/assets/js/widgets/toggle/toggle.component.js
(function(angular) {
/**
     * @name        ithToggle
     * @description Toggle switch component
     * @author  Dominik Kajzar <dominik.kajzar@fru.change   */
    var ithToggle = {
        template:
                        '<div ng-bind="::($ctrl.label | translate)"' +
                       'change class="ith-toggle-label"></div>' +
                        '<label class="toggle">' +
                            '<span class="boolean" ng-class="{on:$ctrl.value}">' +
                            '<span class="toggler"></span>' +
                            '</span>' +
                            '<span ng-bind="::($ctrl.label | translate)"' +
                            ' class="ith-toggle-label"></span>' +
                            '<input type="checkbox" ng-model="$ctrl.value" ng-change="$ctrl.changeInput()"> ' +
                            '<div class="toggle-slider round"></div> ' +
                        '</label>',
        controller: 'ithToggleController',
        bindings: {
            label: '@',
            onUpdate: '&',
            value: '<'
        }
    };

    angular.module('ITH.Widgets.Toggle')
        .component('ithToggle', ithToggle);
})(angular);;

// Source: ../shared/public_html/assets/js/widgets/toggle/toggle.controller.js
(function(angular) {
/**
     * @name        ithToggleController
     * @description
     * @constructor Toggle switch component
     * @author  Dominik Kajzar <dominik.kajzar@fru.pl>
     */
    var ithToggleController = function() {

        this.$onInit = function(){
            this.value = this.value || false;
        }
        /**
         *
         * @type {ithToggleController}
         */
        this.changeInput = function(){
            this.onUpdate({
                    $event: {value: this.value}
                }
            );
        }
    };

    ithToggleController.$inject = [];

    angular.module('ITH.Widgets.Toggle')
        .controller('ithToggleController', ithToggleController);

})(angular);
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/box/box.component.js
(function(angular) {
var IthContactFormBoxComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/box',
        controller: function () {
            /**
             * Returns title icon url
             *
             * @returns {String}
             */
            this.getIconUrl = function () {
                return '/assets/img/ui/contact-form/' + this.icon + '.svg';
            };
        },
        transclude: true,
        bindings: {
            title: '@',
            icon: '@'
        }
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactFormBox', IthContactFormBoxComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/contact-form-chat.component.js
(function(angular) {
var IthContactFormChatComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/chat-box',
        controller: 'ContactFormChatController',
        bindings: {
            chatDriver: '<'
        }
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactFormChat', IthContactFormChatComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/contact-form-chat.controller.js
(function(angular) {
var IthContactFormChatController = function ($scope, DefaultChatBoxDriver, ZammadChatBoxDriver, ManyChatBoxDriver, MessengerLinkDriver, AppConfig) {
        /**
         * Controller reference
         *
         * @type {IthContactFormChatController}
         */
        var ctrl = this;

        /**
         * Chat driver
         *
         * @type {DefaultChatBoxDriver}
         */
        this.chatDriver = new DefaultChatBoxDriver();

        this.isZammad = function () {
            try {
                return AppConfig.getWebsiteSettings().chat.zammadChat.enabled === true;
            }
            catch (e) {
                return false;
            }
        };

        this.isManyChat = function () {
            try {
                return AppConfig.getWebsiteSettings().chat.manyChat.enabled === true;
            }
            catch (e) {
                return false;
            }
        };

        this.isMessengerLink = function () {
            try {
                return AppConfig.getWebsiteSettings().chat.messengerLink.enabled === true;
            }
            catch (e) {
                return false;
            }
        };

        this.initChatDriver = function () {
            if (this.isZammad()) {
                this.chatDriver = new ZammadChatBoxDriver();
                return;
            }

            if (this.isMessengerLink()) {
                this.chatDriver = new MessengerLinkDriver();
                return;
            }

            if (this.isManyChat()) {
                this.chatDriver = new ManyChatBoxDriver();
                return;
            }
        };

        this.$onInit = function () {
            this.initChatDriver();
            this.chatDriver.load();
            this.chatDriver.onTopicChange();

            $scope.$on('selectTopic', function () {
                ctrl.chatDriver.onTopicChange.bind(ctrl.chatDriver);
                ctrl.chatDriver.onTopicChange();
            });
        };

        this.$onDestroy = function () {
            this.chatDriver.shutdown();
        };
    };

    IthContactFormChatController.$inject = [
        '$scope',
        'DefaultChatBoxDriver',
        'ZammadChatBoxDriver',
        'ManyChatBoxDriver',
        'MessengerLinkDriver',
        'appConfig'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .controller('ContactFormChatController', IthContactFormChatController);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/drivers/default-driver.factory.js
(function(angular) {
var IthDefaultChatBoxDriver = function () {
        /**
         * @constructor
         */
        var ChatBoxDriver = function () { };

        ChatBoxDriver.prototype.load = function () {};

        /**
         * Checks if chat is loading
         *
         * @returns {Boolean}
         */
        ChatBoxDriver.prototype.isLoading = function () {
            return false;
        };

        /**
         * Checks if chat is available
         *
         * @returns {Boolean}
         */
        ChatBoxDriver.prototype.isAvailable = function () {
            return false;
        };

        /**
         * Checks if chat is triggerable
         *
         * @returns {Boolean}
         */
        ChatBoxDriver.prototype.isTriggerable = function () {
            return false;
        };

        /**
         * Opens the chat
         */
        ChatBoxDriver.prototype.openChat = function () { };

        /**
         * Method called on contact form topic change
         */
        ChatBoxDriver.prototype.onTopicChange = function () { };

        /**
         * Returns chat icon file name
         *
         * @returns {String}
         */
        ChatBoxDriver.prototype.getIcon = function () {
            return 'contact-wechat-box-icon';
        };

        /**
         * Method called on destroy
         */
        ChatBoxDriver.prototype.shutdown = function () { };

        /**
         * @constructor
         */
        ChatBoxDriver.prototype.constructor = ChatBoxDriver;

        return ChatBoxDriver;
    };

    angular
        .module('ITH.Shared.Zammad')
        .factory('DefaultChatBoxDriver', IthDefaultChatBoxDriver);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/drivers/manychat-driver.factory.js
(function (angular) {

    var IthManyChatBoxDriver = function (DefaultChatBoxDriver, ScriptInject, AppConfig, $q) {
        /**
         * @constructor
         */
        var ManyChatBoxDriver = function () {
            this.states = {
                isLoading: false,
                isAvailable: true
            };
        };

        ManyChatBoxDriver.prototype = Object.create(DefaultChatBoxDriver.prototype);

        ManyChatBoxDriver.prototype.load = function () {
            var self = this;

            this.states.isLoading = true;

            $q
                .all([
                    ScriptInject.inject('manychat-script', AppConfig.getWebsiteSettings().chat.manyChat.jsUrl),
                    ScriptInject.inject('manychat-widget', AppConfig.getWebsiteSettings().chat.manyChat.widgetUrl)
                ])
                .then(function () {
                    self.states.isAvailable = true;
                })
                .catch(function () {
                    self.states.isAvailable = false;
                })
                .finally(function () {
                    self.states.isLoading = false;
                });
        };

        ManyChatBoxDriver.prototype.isLoading = function () {
            return this.states.isLoading;
        };

        ManyChatBoxDriver.prototype.isAvailable = function () {
            return this.states.isAvailable;
        };

        ManyChatBoxDriver.prototype.isTriggerable = function () {
            return false;
        };

        ManyChatBoxDriver.prototype.getIcon = function () {
            return 'contact-wechat-box-icon';
        };

        /**
         * @constructor
         */
        ManyChatBoxDriver.prototype.constructor = ManyChatBoxDriver;

        return ManyChatBoxDriver;
    };

    IthManyChatBoxDriver.$inject = [
        'DefaultChatBoxDriver',
        'ScriptInject',
        'appConfig',
        '$q'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('ManyChatBoxDriver', IthManyChatBoxDriver);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/drivers/messenger-link-driver.factory.js
(function (angular) {

    var IthMessengerLinkDriver = function (DefaultChatBoxDriver, AppConfig) {
        /**
         * @constructor
         */
        var MessengerLinkDriver = function () {
        };

        MessengerLinkDriver.prototype = Object.create(DefaultChatBoxDriver.prototype);

        MessengerLinkDriver.prototype.isAvailable = function () {
            return true;
        };

        MessengerLinkDriver.prototype.isTriggerable = function () {
            return true;
        };

        MessengerLinkDriver.prototype.openChat = function () {
            window.location.href = AppConfig.getWebsiteSettings().chat.messengerLink.link;
        };

        /**
         * @constructor
         */
        MessengerLinkDriver.prototype.constructor = MessengerLinkDriver;

        return MessengerLinkDriver;
    };

    IthMessengerLinkDriver.$inject = [
        'DefaultChatBoxDriver',
        'appConfig'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('MessengerLinkDriver', IthMessengerLinkDriver);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/chat-box/drivers/zammad-driver.factory.js
(function(angular) {

    var IthZammadChatBoxDriver = function ($document, $interval, $window, DefaultChatBoxDriver, AppConfig, ScriptInject) {
        /**
         * Returns Zammad chat button element
         *
         * @returns {HTMLElement}
         */
        var getChatButton = function () {
            return $document[0].querySelector('.zammad-chat-floating-button');
        };

        /**
         * Zammad chat states
         *
         * @type {Object}
         */
        var states = {
            LOADING: 'loading',
            OFFLINE: 'offline',
            ONLINE: 'online'
        };

        /**
         * Reloads chat button
         *
         * @param {Object} ctx
         */
        var reloadChatButton = function (ctx) {
            ctx.chatState = states.LOADING;
            var chatButton = getChatButton();

            if (chatButton === null || $window.getComputedStyle(chatButton).display === 'none') {
                ctx.chatState = states.OFFLINE;
                return;
            }

            ctx.chatState = states.ONLINE;
        };

        /**
         * @constructor
         */
        var ZammadChatBoxDriver = function () {
            /**
             * Chat state
             *
             * @type {String}
             */
            this.chatState = states.LOADING;

            this.polling = $interval(function () {
                reloadChatButton(this);
            }.bind(this), 2000);
        };

        ZammadChatBoxDriver.prototype = Object.create(DefaultChatBoxDriver.prototype);

        /**
         * Loads Zammad Chat
         */
        ZammadChatBoxDriver.prototype.load = function () {
            var settings = AppConfig.getWebsiteSettings().chat.zammadChat;

            if (settings.enabled === false) {
                this.chatState = states.OFFLINE;
                return;
            }

            if ($window.zammadDriverInit) {
                return;
            }

            $window.zammadDriverInit = true;

            ScriptInject
                .inject('jquery', 'https://code.jquery.com/jquery-3.5.1.min.js')
                .then(function () {
                    ScriptInject
                        .inject('zammad-chat', settings.jsUrl)
                        .then(function () {
                            new ZammadChat({
                                background: '#275cbd',
                                fontSize: '12px',
                                flat: true,
                                chatId: settings.chatId,
                                show: false,
                                host: settings.wsUrl
                            });
                        });
                });
        };

        /**
         * Checks if state is loading
         *
         * @returns {Boolean}
         */
        ZammadChatBoxDriver.prototype.isLoading = function () {
            return this.chatState === states.LOADING;
        };

        /**
         * Checks if state is available
         *
         * @returns {Boolean}
         */
        ZammadChatBoxDriver.prototype.isAvailable = function () {
            return this.chatState === states.ONLINE;
        };

        /**
         * Checks if chat is triggerable
         *
         * @returns {Boolean}
         */
        ZammadChatBoxDriver.prototype.isTriggerable = function () {
            return true;
        };

        /**
         * Opens the chat window
         */
        ZammadChatBoxDriver.prototype.openChat = function () {
            var chatButton = getChatButton();

            if ($window.getComputedStyle(chatButton).display === 'none') {
                reloadChatButton(this);
                return;
            }

            chatButton.click();
        };

        /**
         * Called when form topic is changed
         */
        ZammadChatBoxDriver.prototype.onTopicChange = function () {
            reloadChatButton(this);
        };

        /**
         * Returns chat icon file name
         *
         * @returns {String}
         */
        ZammadChatBoxDriver.prototype.getIcon = function () {
            return 'contact-chat-box-icon';
        };

        /**
         * Method called on destroy
         */
        ZammadChatBoxDriver.prototype.shutdown = function () {
            $interval.cancel(this.polling);
            $window.zammadDriverInit = false;
        };

        /**
         * @constructor
         */
        ZammadChatBoxDriver.prototype.constructor = ZammadChatBoxDriver;

        return ZammadChatBoxDriver;
    };

    IthZammadChatBoxDriver.$inject = [
        '$document',
        '$interval',
        '$window',
        'DefaultChatBoxDriver',
        'appConfig',
        'ScriptInject'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('ZammadChatBoxDriver', IthZammadChatBoxDriver);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/configs/fru-config.service.js
(function(angular) {
var config = function (CONTACT_FORM_TOPIC_IDS) {
        return [
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_NEW_BOOKING,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_NEW_BOOKING'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_ADDITIONAL_SERVICES,
                showInProfile: true,
                orderInProfile: 2,
                lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES',
                subtopics: [
                    {
                        index: 1,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_BAGGAGE'
                    },
                    {
                        index: 2,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_PRIORITY'
                    },
                    {
                        index: 3,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_SEATS'
                    },
                    {
                        index: 4,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_SPORT'
                    },
                    {
                        index: 5,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_PETS'
                    },
                    {
                        index: 6,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_OTHER'
                    }
                ]
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_CHECKIN,
                showInProfile: true,
                orderInProfile: 3,
                lang: 'LANGM_JS_CONTACT_CHECKIN'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_PAYMENT,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_PAYMENT'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_CHANGE_OR_CANCEL,
                showInProfile: true,
                orderInProfile: 1,
                lang: 'LANGM_JS_CONTACT_FLIGHT_CHANGE_OR_CANCEL'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_REFUND,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_REFUND'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_CANCELLED,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_FLIGHT_CANCELLED'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_STATUS,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_FLIGHT_STATUS'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_COMPLAINT,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_COMPLAINT',
                showSubtopicDescription: false,
                subtopics: [
                    {
                        index: 1,
                        lang: 'LANGM_JS_CONTACT_COMPLAINT_BAGGAGE_MISTAKE'
                    },
                    {
                        index: 2,
                        lang: 'LANGM_JS_CONTACT_COMPLAINT_CHECKIN_MISTAKE'
                    },
                    {
                        index: 3,
                        lang: 'LANGM_JS_CONTACT_COMPLAINT_SERVICE'
                    },
                    {
                        index: 4,
                        lang: 'LANGM_JS_CONTACT_COMPLAINT_OTHER'
                    }
                ]
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_TRAVEL_CONDITIONS,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_TRAVEL_CONDITIONS'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_OTHER,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_OTHER'
            }
        ];
    };

    config.$inject = [
        'CONTACT_FORM_TOPIC_IDS'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .service('FRU_FORM_CONFIG', config);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/configs/vola-config.service.js
(function (angular) {
var config = function (CONTACT_FORM_TOPIC_IDS) {
        return [
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_NEW_BOOKING,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_NEW_BOOKING'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_ADDITIONAL_SERVICES,
                showInProfile: true,
                orderInProfile: 2,
                lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES',
                subtopics: [
                    {
                        index: 1,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_BAGGAGE'
                    },
                    {
                        index: 2,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_PRIORITY'
                    },
                    {
                        index: 3,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_SEATS'
                    },
                    {
                        index: 4,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_SPORT'
                    },
                    {
                        index: 5,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_PETS'
                    },
                    {
                        index: 6,
                        lang: 'LANGM_JS_CONTACT_ADDITIONAL_SERVICES_OTHER'
                    }
                ]
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_CHECKIN,
                showInProfile: true,
                orderInProfile: 3,
                lang: 'LANGM_JS_CONTACT_CHECKIN'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_PAYMENT,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_PAYMENT'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_CHANGE_OR_CANCEL,
                showInProfile: true,
                orderInProfile: 1,
                lang: 'LANGM_JS_CONTACT_FLIGHT_CHANGE_OR_CANCEL'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_REFUND,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_REFUND'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_CANCELLED,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_FLIGHT_CANCELLED'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_FLIGHT_STATUS,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_FLIGHT_STATUS'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_COMPLAINT,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_COMPLAINT',
                showSubtopicDescription: false
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_TRAVEL_CONDITIONS,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_TRAVEL_CONDITIONS'
            },
            {
                topicId: CONTACT_FORM_TOPIC_IDS.FORM_OTHER,
                showInProfile: false,
                lang: 'LANGM_JS_CONTACT_OTHER'
            }
        ];
    };

    config.$inject = [
        'CONTACT_FORM_TOPIC_IDS'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .service('VOLA_FORM_CONFIG', config);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/contact-form-email-topic-ids.constant.js
(function() {
/**
     * Contact form topic enum
     *
     * @type {Object}
     */
    var CONTACT_FORM_TOPIC_IDS = {
        FORM_NEW_BOOKING: 'form_new_booking',
        FORM_ADDITIONAL_SERVICES: 'form_additional_services',
        FORM_CHECKIN: 'form_checkin',
        FORM_PAYMENT: 'form_payment',
        FORM_FLIGHT_CHANGE_OR_CANCEL: 'form_change_or_cancel',
        FORM_SCHEDULE_CHANGES: 'form_schedule_changes',
        FORM_REFUND: 'form_refund',
        FORM_FLIGHT_STATUS: 'form_flight_status',
        FORM_FLIGHT_CANCELLED: 'form_flight_cancelled',
        FORM_COMPLAINT: 'form_complaint',
        FORM_OTHER: 'form_other',
        FORM_TRAVEL_CONDITIONS: 'form_travel_conditions'
    };

    angular
        .module('ITH.Shared.Zammad')
        .constant('CONTACT_FORM_TOPIC_IDS', CONTACT_FORM_TOPIC_IDS);

}());
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/contact-form-email.component.js
(function(angular, underscore) {
var ContactFormEmailController = function ($anchorScroll, $rootScope, $scope, $location, ContactFormTopics, ZammadPayload, ZammadApi, AppConfig, CONTACT_FORM_TOPIC_IDS, FRU_FORM_CONFIG, VOLA_FORM_CONFIG, DateUtils) {
        /**
         * Self reference
         *
         * @type {ContactFormEmailController}
         */
        var ctrl = this;

        /**
         * UI flags
         *
         * @type {Object}
         */
        this.flags = {
            /**
             * Is user selecting a topic?
             *
             * @type {Boolean}
             */
            isSelectingTopic: false,

            /**
             * Is form being sent?
             *
             * @type {Boolean}
             */
            isSending: false,

            /**
             * Was there an validation error thrown by API?
             *
             * @type {Boolean}
             */
            isValidationError: false,

            /**
             * Was there an error thrown by API?
             *
             * @type {Boolean}
             */
            isError: false,

            /**
             * Was form sent successfuly?
             *
             * @type {Boolean}
             */
            isSuccess: false,

            unregisterContactVerificationEvent: null
        };

        this.dateRange = DateUtils.getFutureDate(2);

        /**
         * Topic menu items class
         *
         * @type {ContactFormTopics}
         */
        this.topicMenuItems = null;

        /**
         * Object containing the form data
         *
         * @type {Object}
         */
        this.contactFormData = {
            topicId: null,
            subtopicId: 1,
            bookingNumber: '',
            name: '',
            email: '',
            telephone: '',
            message: '',
            departureDate: ''
        };

        /**
         * Object containing validation errors sent by API
         *
         * @type {Object}
         */
        this.backendValidation = {};

        /**
         * Opens the list of topics
         */
        this.openTopicSelector = function () {
            ctrl.contactFormData.topicId = '';
            ctrl.flags.isSelectingTopic = true;
        };

        /**
         * Selects a topic by id
         *
         * @param {String} topicId
         */
        this.selectTopic = function (topicId) {
            ctrl.contactFormData.topicId = topicId;
            ctrl.contactFormData.subtopicId = 1;
            ctrl.flags.isSelectingTopic = false;

            $rootScope.$broadcast('selectTopic');
        };

        /**
         * Checks if there are any backend validation errors
         *
         * @returns {Boolean}
         */
        this.hasBackendValidationErrors = function () {
            var hasErrors = false;

            Object.values(ctrl.backendValidation).forEach(function (error) {
                if (error !== null && error !== '') {
                    hasErrors = true;
                }
            });

            return hasErrors;
        };

        /**
         * Checks if a topic id is selected
         *
         * @param {String} topicId
         * @returns {Boolean}
         */
        this.isTopicSelected = function (topicId) {
            return ctrl.contactFormData.topicId === topicId;
        };

        /**
         * Returns topic lang by topic id
         *
         * @param {String} topicId
         * @returns {String}
         */
        this.getTopicLangById = function (topicId) {
            var item = ctrl.getTopicMenuItem(topicId);

            if (!item) {
                return null;
            }

            return ctrl.getTopicMenuItem(topicId).lang;
        };

        /**
         * Returns subtopic lang by topic id and subtopic id
         *
         * @param {String} topicId
         * @param {String} subtopicId
         * @returns {String}
         */
        this.getSubtopicLangById = function (topicId, subtopicId) {
            return ctrl.getSubtopicMenuItem(topicId, subtopicId).getLang();
        };

        /**
         * Returns topic menu item
         *
         * @param {String} topicId
         * @returns {Object}
         */
        this.getTopicMenuItem = function (topicId) {
            return underscore.find(ctrl.topicMenuItems.get(), function (topicMenuItem) {
                return topicMenuItem.getId() === topicId;
            });
        };

        /**
         * Returns subtopic menu item
         *
         * @param {String} topicId
         * @param {String} subtopicId
         * @returns {Object}
         */
        this.getSubtopicMenuItem = function (topicId, subtopicId) {
            var subtopics = ctrl.getSubtopics(topicId);
            return underscore.find(subtopics, function (subtopic) {
                return subtopic.getId() === subtopicId;
            });
        };

        /**
         * Returns array of subtopics for a topic
         *
         * @param {String} topicId
         * @returns {Object[]}
         */
        this.getSubtopics = function (topicId) {
            if (!ctrl.hasSubtopics(topicId)) {
                return [];
            }

            return ctrl.getTopicMenuItem(topicId).getSubtopics();
        };

        /**
         * Checks if a topic has subtopics
         *
         * @param {String} topicId
         * @returns {Boolean}
         */
        this.hasSubtopics = function (topicId) {
            if (!topicId) {
                return false;
            }

            return ctrl.getTopicMenuItem(topicId).getSubtopics().length > 0;
        };

        /**
         * Returns form title lang
         *
         * @returns {String}
         */
        this.getTitleLang = function () {
            return ctrl.getTopicLangById(ctrl.contactFormData.topicId) + '_TITLE';
        };

        /**
         * Returns form description lang
         *
         * @returns {String}
         */
        this.getDescriptionLang = function () {
            return ctrl.getTopicLangById(ctrl.contactFormData.topicId) + '_DESC';
        };

        /**
         * Returns subtopic description lang
         *
         * @returns {String}
         */
        this.getSubtopicDescriptionLang = function () {
            if (!ctrl.hasSubtopics(ctrl.contactFormData.topicId)) {
                return '';
            }

            return ctrl.getSubtopicLangById(ctrl.contactFormData.topicId, ctrl.contactFormData.subtopicId) + '_DESC';
        };

        /**
         * Checks if subtopic descriptions should be shown
         *
         * @returns {Boolean}
         */
        this.showSubtopicDescriptionLang = function () {
            return (
                ctrl.hasSubtopics(ctrl.contactFormData.topicId) &&
                ctrl.getTopicMenuItem(ctrl.contactFormData.topicId).showSubtopicDescription === true
            );
        };

        /**
         * Decides if subtopic select should be displayed
         *
         * @returns {Boolean}
         */
        this.shouldShowSubtopic = function () {
            return ctrl.hasSubtopics(ctrl.contactFormData.topicId);
        };

        /**
         * Decides if booking number field should be displayed
         *
         * @returns {Boolean}
         */
        this.shouldShowBookingNumber = function () {
            return ctrl.contactFormData.topicId !== CONTACT_FORM_TOPIC_IDS.FORM_NEW_BOOKING;
        };

        /**
         * Decides if departure date field should be displayed
         *
         * @returns {Boolean}
         */
        this.shouldShowDepartureDate = function () {
            return ctrl.contactFormData.topicId !== CONTACT_FORM_TOPIC_IDS.FORM_NEW_BOOKING;
        };

        /**
         * Submits the contact form
         *
         * @param {Event} event
         * @param {NgForm} contactForm
         */
        this.submitContactForm = function (event, contactForm) {
            event.preventDefault();

            if (!contactForm.$valid) {
                return;
            }

            var subtopicName = '';

            var departureDate = '';
            if (ctrl.shouldShowDepartureDate()) {
                departureDate = ctrl.contactFormData.departureDate + ' 00:00:00';
            }

            var bookingNumber = ctrl.shouldShowBookingNumber() ? ctrl.contactFormData.bookingNumber : '';

            if (ctrl.shouldShowSubtopic()) {
                var subtopic = ctrl.getSubtopicMenuItem(ctrl.contactFormData.topicId, ctrl.contactFormData.subtopicId);
                subtopicName = subtopic.getName();
            }

            var payload = ZammadPayload.getTicketPayload(
                ctrl.contactFormData.topicId,
                subtopicName,
                ctrl.contactFormData.name,
                ctrl.contactFormData.email,
                ctrl.contactFormData.telephone,
                departureDate,
                bookingNumber,
                ctrl.contactFormData.message
            );

            ctrl.flags.isSending = true;
            ctrl.flags.isError = false;
            ctrl.flags.isValidationError = false;
            ctrl.backendValidation = {};

            ZammadApi
                .createTicket(payload)
                .then(function () {
                    ctrl.flags.isSuccess = true;
                    $anchorScroll('contact-form-top');
                    $scope.$emit('contact-form-email-ticket-created');
                })
                .catch(function (error) {
                    if (error.status === 422) {
                        ctrl.flags.isValidationError = true;
                        ctrl.backendValidation = error.data.errors;
                        return;
                    }

                    ctrl.flags.isError = true;
                })
                .finally(function () {
                    ctrl.flags.isSending = false;
                });

            return false;
        };

        this.$onInit = function () {
            var queryParams = $location.search();
            var jumpToTopic = queryParams.hasOwnProperty('topic') && Object.values(CONTACT_FORM_TOPIC_IDS).includes(queryParams['topic']);
            var contactFormConfig = AppConfig.isFru() ? FRU_FORM_CONFIG : VOLA_FORM_CONFIG;

            if (this.isProfile) {
                contactFormConfig = underscore.sortBy(
                    underscore
                        .filter(contactFormConfig, function (entry) {
                            return entry.showInProfile === true;
                        }),
                    'orderInProfile'
                );
            }

            this.topicMenuItems = new ContactFormTopics(contactFormConfig);

            if (jumpToTopic) {
                // Select query param topic
                this.selectTopic(queryParams['topic']);
            }

            if (!jumpToTopic) {
                // Select first topic
                this.selectTopic(this.topicMenuItems.get()[0].id);
            }

            this.flags.unregisterContactVerificationEvent = $rootScope
                .$on('contact-verification-done', function (event, data) {
                    ctrl.contactFormData.bookingNumber = data.pnr;
                });

            this.flags.unregisterContactProfilePrefillEvent = $rootScope
                .$on('contact-profile-prefill', function (event, data) {
                    ctrl.contactFormData.bookingNumber = data.bookingNumber;
                    ctrl.contactFormData.name = data.name;
                    ctrl.contactFormData.email = data.email;
                    ctrl.contactFormData.telephone = data.telephone;
                    ctrl.contactFormData.departureDate = data.departureDate;
                });
        };

        this.$onDestroy = function () {
            this.flags.unregisterContactVerificationEvent();
            this.flags.unregisterContactProfilePrefillEvent();
        };
    };

    ContactFormEmailController.$inject = [
        '$anchorScroll',
        '$rootScope',
        '$scope',
        '$location',
        'ContactFormTopics',
        'ZammadPayload',
        'ZammadApi',
        'appConfig',
        'CONTACT_FORM_TOPIC_IDS',
        'FRU_FORM_CONFIG',
        'VOLA_FORM_CONFIG',
        'DateUtils'
    ];

    var IthContactFormEmailComponent = {
        controller: ContactFormEmailController,
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/email-form',
        bindings: {
            isProfile: '<?'
        }
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactFormEmail', IthContactFormEmailComponent);

}(angular, _));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/contact-form.component.js
(function(angular) {
var controller = function ($rootScope) {
        var states = {
            INIT: 'init',
            METHODS: 'methods'
        };

        var ctrl = this;

        this.flags = {
            currentState: states.INIT,
            allowedMethods: [],
            bookingNumber: '',
            unregisterContactVerificationEvent: null
        };

        this.isInit = function () {
            return this.flags.currentState === states.INIT;
        };

        this.isMethods = function () {
            return this.flags.currentState === states.METHODS;
        };

        this.goToMethods = function () {
            this.flags.currentState = states.METHODS;
        };

        this.isPhoneAllowed = function () {
            return this.flags.allowedMethods.indexOf('phone') !== -1;
        };

        this.isChatAllowed = function () {
            return (
                this.flags.allowedMethods.indexOf('phone') !== -1 ||
                this.flags.allowedMethods.indexOf('chat') !== -1
            );
        };

        this.$onInit = function () {
            this.flags.unregisterContactVerificationEvent = $rootScope
                .$on('contact-verification-done', function (event, data) {
                    ctrl.flags.allowedMethods = data.methods;
                    ctrl.flags.bookingNumber = data.pnr;
                    ctrl.goToMethods();
                });
        };

        this.$onDestroy = function () {
            this.flags.unregisterContactVerificationEvent();
        };
    };

    controller.$inject = ['$rootScope'];

    var IthContactFormComponent = {
        controller: controller,
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/contact-page'
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactForm', IthContactFormComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/contact-phone.component.js
(function(angular) {
var controller = function ($rootScope, ZammadApi) {
        var ctrl = this;

        /**
         *
         */
        this.formData = {
            bookingNumber: '',
            telephone: ''
        };

        this.flags = {
            isSubmitting: false,
            isSuccess: false,
            backendErrors: {},
            unregisterContactVerificationEvent: null
        };

        this.submit = function (event, form) {
            event.preventDefault();

            if (!form.$valid) {
                return;
            }

            this.flags.isSubmitting = true;

            ZammadApi
                .callMeBack(this.formData.bookingNumber, this.formData.telephone)
                .then(function () {
                    ctrl.flags.isSuccess = true;
                })
                .catch(function (error) {
                    if (error.status === 422) {
                        ctrl.flags.backendErrors = error.data.errors;
                    }
                })
                .finally(function () {
                    ctrl.flags.isSubmitting = false;
                });
        };

        this.$onInit = function () {
            this.flags.unregisterContactVerificationEvent = $rootScope
                .$on('contact-verification-done', function (event, data) {
                    ctrl.formData.bookingNumber = data.pnr;
                });
        };

        this.$onDestroy = function () {
            this.flags.unregisterContactVerificationEvent();
        };
    };

    controller.$inject = ['$rootScope', 'ZammadApi'];

    var IthContactPhoneComponent = {
        controller: controller,
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/phone-form',
        bindings: {
            bookingNumber: '<'
        }
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactPhone', IthContactPhoneComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/models/contact-form-subtopic.factory.js
(function(angular) {
/**
     * Factory for the subtopic object
     */
    var ContactFormSubtopicFactory = function ($translate) {
        /**
         * @constructor
         *
         * @param {String} id
         * @param {String} lang
         */
        var ContactFormSubtopic = function (id, lang) {
            this.id = id;
            this.lang = lang;
        };

        ContactFormSubtopic.prototype.constructor = ContactFormSubtopic;

        /**
         * Returns subtopic id
         *
         * @returns {String}
         */
        ContactFormSubtopic.prototype.getId = function () {
            return this.id;
        };

        /**
         * Returns subtopic lang
         *
         * @returns {String}
         */
        ContactFormSubtopic.prototype.getLang = function () {
            return this.lang;
        };

        /**
         * Returns subtopic translated lang
         *
         * @returns {String}
         */
        ContactFormSubtopic.prototype.getName = function () {
            return $translate.instant(this.getLang());
        };

        return ContactFormSubtopic;
    };

    ContactFormSubtopicFactory.$inject = [
        '$translate'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('ContactFormSubtopic', ContactFormSubtopicFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/models/contact-form-topic.factory.js
(function() {
/**
     * Factory for the form topic object
     */
    var ContactFormTopicFactory = function ($translate, ContactFormSubtopic) {
        /**
         * @constructor
         *
         * @param {String} id
         * @param {String} lang
         */
        var ContactFormTopic = function (id, lang) {
            this.id = id;
            this.lang = lang;
            this.subtopics = [];
            this.showSubtopicDescription = true;
        };

        ContactFormTopic.prototype.constructor = ContactFormTopic;

        /**
         * Returns topic id
         *
         * @returns {String}
         */
        ContactFormTopic.prototype.getId = function () {
            return this.id;
        };

        /**
         * Returns topic lang
         *
         * @returns {String}
         */
        ContactFormTopic.prototype.getLang = function () {
            return this.lang;
        };

        /**
         * Returns topic lang translated
         *
         * @returns {String}
         */
        ContactFormTopic.prototype.getName = function () {
            return $translate.instant(this.getLang());
        };

        /**
         * Returns subtopics array
         *
         * @returns {ContactFormSubtopic[]}
         */
        ContactFormTopic.prototype.getSubtopics = function () {
            return this.subtopics;
        };

        /**
         * Adds a subtopic
         *
         * @param {String} id
         * @param {String} lang
         * @returns {ContactFormTopic}
         */
        ContactFormTopic.prototype.addSubtopic = function (id, lang) {
            this.subtopics.push(new ContactFormSubtopic(id, lang));
            return this;
        };

        /**
         * Toggles subtopic descriptions onn or off
         *
         * @param {Boolean} value
         * @returns {ContactFormTopic}
         */
        ContactFormTopic.prototype.toggleSubtopicDescription = function (value) {
            this.showSubtopicDescription = value;
            return this;
        };

        return ContactFormTopic;
    };

    ContactFormTopicFactory.$inject = [
        '$translate',
        'ContactFormSubtopic'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('ContactFormTopic', ContactFormTopicFactory);

}());
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/models/contact-form-topics.factory.js
(function(angular) {
/**
     * Factory for the topics object
     */
    var ContactFormTopicsFactory = function (ContactFormTopic) {
        /**
         * Returns a topic instance
         *
         * @param {Object} topicData
         * @returns {ContactFormTopic}
         */
        var getTopicInstance = function (topicData) {
            var topicInstance = new ContactFormTopic(
                topicData.topicId,
                topicData.lang
            );

            if (topicData.hasOwnProperty('subtopics') && topicData.subtopics.length) {
                angular.forEach(topicData.subtopics, function (subtopicData) {
                    topicInstance.addSubtopic(
                        subtopicData.index,
                        subtopicData.lang
                    );
                });
            }

            if (topicData.hasOwnProperty('showSubtopicDescription')) {
                topicInstance.toggleSubtopicDescription(topicData.showSubtopicDescription);
            }

            return topicInstance;
        };

        /**
         * @param {Array} config
         * @constructor
         */
        var ContactFormTopics = function (config) {
            /**
             * Self reference
             *
             * @type {ContactFormTopics}
             */
            var self = this;

            /**
             * Array of topics
             *
             * @type {Array}
             */
            self.list = [];

            angular.forEach(config, function (topicData) {
                self.list.push(getTopicInstance(topicData));
            });
        };

        ContactFormTopics.prototype.constructor = ContactFormTopics;

        /**
         * Returns the topics array
         *
         * @returns {ContactFormTopic[]}
         */
        ContactFormTopics.prototype.get = function () {
            return this.list;
        };

        return ContactFormTopics;
    };

    ContactFormTopicsFactory.$inject = [
        'ContactFormTopic'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .factory('ContactFormTopics', ContactFormTopicsFactory);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/contact-form/verification-form.component.js
(function(angular) {
var controller = function ($rootScope, ZammadApi, $location) {
        var ctrl = this;

        /**
         *
         */
        this.verifyFormData = {
            pnr: ''
        };

        this.flags = {
            isSubmitting: false,
            backendErrors: {}
        };

        this.verifiedPnr = null;

        /**
         *
         * @param {Event} event
         * @param {NgForm} contactVerificationForm
         * @returns
         */
        this.submit = function (event, contactVerificationForm) {
            event.preventDefault();

            if (!contactVerificationForm.$valid) {
                return;
            }

            this.verifyPnr();

            return false;
        };

        this.verifyPnr = function () {
            this.flags.isSubmitting = true;
            this.verifiedPnr = null;

            $rootScope.$broadcast('contact-verification-done', {
                pnr: null,
                methods: []
            });

            ZammadApi
                .checkPnr(this.verifyFormData.pnr)
                .then(function (response) {
                    ctrl.verifiedPnr = ctrl.verifyFormData.pnr;

                    $rootScope.$broadcast('contact-verification-done', {
                        pnr: ctrl.verifyFormData.pnr,
                        methods: response.data.response.assistance
                    });
                })
                .catch(function (error) {
                    if (error.status === 422) {
                        ctrl.flags.backendErrors = error.data.response.errors;
                    }
                })
                .finally(function () {
                    ctrl.flags.isSubmitting = false;
                });
        };

        this.$onInit = function () {
            var queryParams = $location.search();

            if (queryParams.hasOwnProperty('reservation_number') && queryParams['reservation_number']) {
                this.verifyFormData.pnr = queryParams['reservation_number'];
                this.verifyPnr();
            }
        };
    };

    controller.$inject = ['$rootScope', 'ZammadApi', '$location'];

    var IthContactVerificationFormComponent = {
        controller: controller,
        templateUrl: '/tpl/show/jsShared/templates/base/components/contact-form/verification-form',
        bindings: {
            isPhoneAllowed: '&',
            isChatAllowed: '&'
        }
    };

    angular
        .module('ITH.Shared.Zammad')
        .component('ithContactVerificationForm', IthContactVerificationFormComponent);

}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/zammad-payload.service.js
(function(angular) {
var ZammadPayloadService = function (appConfig) {
        /**
         * Returns ticket payload for the notifier service
         *
         * @param {String} topicId
         * @param {String} subtopicName
         * @param {String} name
         * @param {String} email
         * @param {String} telephone
         * @param {String} dueDate, format: "Y-m-d H:i:s"
         * @param {String} bookingNumber
         * @param {String} message
         */
        this.getTicketPayload = function (topicId, subtopicName, name, email, telephone, dueDate, bookingNumber, message) {
            /**
             * Generates an UUID v4
             *
             * @returns {String}
             */
            function uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
            return {
                type: topicId,
                locale: 'en',
                targets: [
                    {
                        id: 'zammad',
                        resource_id: uuidv4(),
                        customer_name: name,
                        customer_email: email,
                        customer_telephone: telephone,
                        due_date: dueDate,
                        pnr: bookingNumber,
                        sender: 'Customer',
                        market_code: appConfig.getMarket(),
                        language_code: appConfig.getLanguageCode(),
                        variables: {
                            message_content: message,
                            subtopic: subtopicName,
                            pnr: bookingNumber,
                            customer_name: name,
                            customer_telephone: telephone
                        }
                    }
                ]
            };
        };
    };
    ZammadPayloadService.$inject = ['appConfig'];
    angular
        .module('ITH.Shared.Zammad')
        .service('ZammadPayload', ZammadPayloadService);
}(angular));
;

// Source: ../shared/public_html/assets/js/zammad/zammad.api.js
(function(angular) {
var ZammadApiService = function ($http, AppConfig) {
        /**
         * Checks what types of assistance this email has access to
         *
         * @param {String} email
         * @returns
         */
        this.checkPnr = function (pnr) {
            return $http({
                method: 'POST',
                url: 'api/contact/verifyAssistance',
                data: {
                    pnr: pnr
                }
            });
        };

        /**
         * Requests call me back option
         *
         * @param {String} pnr
         * @param {String} phone
         * @returns
         */
        this.callMeBack = function (pnr, phone) {
            return $http({
                method: 'POST',
                url: 'api/contact/orderAssistance',
                data: {
                    pnr: pnr,
                    phone: phone
                }
            });
        };

        /**
         * Creates a ticket in Zammad
         *
         * @param {Object} payload
         * @returns {Promise}
         */
        this.createTicket = function (payload) {
            return $http({
                method: 'POST',
                url: AppConfig.getWebsiteSettings().contactForm.endpoint,
                data: payload
            });
        };
    };

    ZammadApiService.$inject = [
        '$http',
        'appConfig'
    ];

    angular
        .module('ITH.Shared.Zammad')
        .service('ZammadApi', ZammadApiService);

}(angular));
;

// Source: public_html/assets/js/app/govola.mod.js
/* global angular: false */

/**
 * Main application module
 */

var injection = [
  'dbStates',
  'base',
  'flight',
  'faq',
  'calendar',
  'landingPages',
  'cityHelper',
  'ITH.vola.campaigns.anniversary',
  'ITH.vola.campaigns.ieftinuarie',
  'flightDetails',
  'funnel'
];

if(typeof _js_app_config_ === 'undefined' || !_js_app_config_.jsMinified) {
  injection.push('insurance');
  injection.push('ui.router');
}

angular.module('vola', injection).run([
  '$rootScope', 'StaticPageHelper', 'appConfig', '$state', '$location',
  function ($rootScope, StaticPageHelper, AppConfig, $state, $location) {
    $rootScope.$on('$stateChangeStart', function (event, toState) {
      var isAnimated = (
        toState.name === 'homepage' ||
        $location.url() === '/bg-bg' ||
        toState.url === '/bg-bg' ||
        $location.url() === '/bg-bg/' ||
        toState.url === '/bg-bg/' ||
        toState.name === 'landingPages' ||
        toState.name === 'bg-bg_landingPages' ||
        toState.name === 'bg-bg_ngStaticPageShow' ||
        toState.url.includes('kontakt') ||
        $location.url().includes('kontakt')
      );

      document.querySelector('#h-logo-et34s-id').src = isAnimated
        ? '/assets/img-static/logo-inverse-bg.svg'
        : '/assets/img-static/logo-inverse.svg';
    });
  }]);
;

// Source: public_html/assets/js/app/components/campaigns/anniversary/_anniversary.mod.js
(function(angular) {
/**
     * Vola.ro 10 years anniversary campaign
     *
     * @author Bogdan Floares <bogdan.floares@vola.ro>
     */
    angular.module('ITH.vola.campaigns.anniversary', [
        'ITH.Shared.Flight.PriceTrends'
    ]);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/anniversary/anniversary-banner.component.js
(function(angular) {
var templateUrl = function ($element, $attrs) {
        var uri = '';

        switch ($attrs.zone) {
            case 'search':
            case 'ty': uri = 'default-banner'; break;
            default: uri = $attrs.zone + '-banner'; break;
        }

        return '/tpl/show/jsShared/templates/campaigns/anniversary/' + uri;
    };

    templateUrl.$inject = [
        '$element',
        '$attrs'
    ];

    /**
     * @name        campaignsAnniversaryBanner
     * @description A responsive component that shows information related to vola's 10 years anniversary campaign
     * @author      Bogdan Floares <bogdan.floares@vola.ro>
     */
    var campaignsAnniversaryBanner = {
        templateUrl: templateUrl,
        controller: 'IthAnniversaryBannerController',
        bindings: {
            zone: '@',
            header: '@',
            info: '@',
            gaEvent: '@'
        }
    };

    angular
        .module('ITH.vola.campaigns.anniversary')
        .component('ithAnniversaryBanner', campaignsAnniversaryBanner);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/anniversary/anniversary-banner.controller.js
(function(angular) {
/**
     * @name        IthAnniversaryBannerController
     * @description A controller responsible for sending Google Analytics events on banner clicks
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthAnniversaryBannerController = function (IthAnniversaryService, IthIeftinuarieService, IthPriceTrendsHelper, AppConfig) {
        /**
         * Reference to campagin service.
         *
         * @type {IthAnniversaryService}
         */
        this.campaignService = IthAnniversaryService;

        /**
         * Opens the modal with the campaign information.
         */
        this.openInfoModal = function () {
            IthAnniversaryService.openInfoModal('vola-mkt-campaign-modal-box');
        };

        /**
         * Checks if this banner is activated (should be deactivated if Ieftinuarie campaign is active).
         *
         * @returns {Boolean}
         */
        this.isActivated = function () {
            return (
                IthAnniversaryService.isCampaignActive() &&
                !IthIeftinuarieService.isCampaignActive() &&
                !IthPriceTrendsHelper.isCampaignActive()
            );
        };

        /**
         * Checks to see if banner is shown on funnel end (pax details / ty page).
         * @returns {Boolean}
         */
        this.isOnFunnelEnd = function () {
            return (this.zone === 'pax' || this.zone === 'ty');
        };

        /**
         * Flag for ieftinuarie campaign
         *
         * @type {Boolean}
         */
        this.isIeftinuarieActive = function () {
            return AppConfig.getIeftinuarieConfig() === true;
        };
    };

    IthAnniversaryBannerController.$inject = [
        'IthAnniversaryService',
        'IthIeftinuarieService',
        'PricegroupMarkerHelper',
        'appConfig'
    ];

    angular
        .module('ITH.vola.campaigns.anniversary')
        .controller('IthAnniversaryBannerController', IthAnniversaryBannerController);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/anniversary/anniversary-modal.controller.js
(function(angular) {
/**
     * @name        IthAnniversaryModalController
     * @description A controller responsible for behaviour inside the promotion modal
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthAnniversaryModalController = function ($scope, textBoxName) {
        /**
         * Event-Listner for browser back button (while this modal is open).
         */
        $scope.$on('$locationChangeStart', function (event) {
            // Prevent the browser default action (going back)
            event.preventDefault();

            // Close modal
            $scope.$close();
        });

        $scope.textBoxName = textBoxName;
    };

    IthAnniversaryModalController.$inject = [
        '$scope',
        'textBoxName'
    ];

    angular
        .module('ITH.vola.campaigns.anniversary')
        .controller('IthAnniversaryModalController', IthAnniversaryModalController);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/anniversary/anniversary.service.js
(function(angular) {
var IthAnniversaryService = function ($modal, AppConfig) {
        /**
         * Opens the campaign modal.
         */
        this.openInfoModal = function (textBoxName) {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/campaigns/anniversary/modal',
                controller: 'IthAnniversaryModalController',
                windowClass: 'anniversary-modal',
                resolve: {
                    textBoxName: function () {
                        return textBoxName;
                    }
                }
            });
        };

        /**
         * Decides if campaign is visible or not.
         *
         * @returns {Boolean}
         */
        this.isCampaignActive = function () {
            return true;
        };
    };

    IthAnniversaryService.$inject = [
        '$modal',
        'appConfig'
    ];

    angular
        .module('ITH.vola.campaigns.anniversary')
        .service('IthAnniversaryService', IthAnniversaryService);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/_ieftinuarie.mod.js
(function (angular) {
/**
     * Vola.ro Ieftinuarie campaign module.
     *
     * @author Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    angular.module('ITH.vola.campaigns.ieftinuarie', []);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-chart.component.js
(function (angular) {
/**
     * @name        IeftinuarieChartComponent
     * @description Component that shows a chart for Ieftinuarie campaign.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IeftinuarieChartComponent = {
        bindings: {
            graphData: '<',
            formatter: '@'
        },
        template: '<div class="ieftinuarie__chart" line-area-chart ng-model="$ctrl.graphData" point-label-formatter="{{ $ctrl.formatter }}"></div>'
    };

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .component('ithIeftinuarieChart', IeftinuarieChartComponent);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-graph-modal.controller.js
(function (angular) {
/**
     * @name        IthIeftinuarieGraphModalController
     * @description A controller responsible for showing a graph for Ieftinuarie campaign.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthIeftinuarieGraphModalController = function ($scope, IthIeftinuarieService, pricegroupPrice) {
        /**
         * Data needed for the graph component
         *
         * @type {Object[]}
         */
        $scope.graphData = IthIeftinuarieService.getGraphData(pricegroupPrice);
    };

    IthIeftinuarieGraphModalController.$inject = [
        '$scope',
        'IthIeftinuarieService',
        'pricegroupPrice'
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .controller('IthIeftinuarieGraphModalController', IthIeftinuarieGraphModalController);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-hp-chart-banner.component.js
(function(angular) {
/**
     * @name        hpChartBannerComponent
     * @description Component that displays a chart banner with data for popular routes during the January campaign
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var hpChartBannerComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/ieftinuarie/hp-chart-banner',
        controller: 'IthIeftinuarieHpChartBannerController'
    };

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .component('ithIeftinuarieHpChartBanner', hpChartBannerComponent);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-hp-chart-banner.controller.js
(function(angular, moment) {
/**
     * Data displayed in the banner
     *
     * @type {Object}
     */
    var staticBannerData = {
        /**
         * Array of city codes
         *
         * @type {Array}
         */
        cityCodes: ['LON', 'ROM', 'PAR', 'BCN', 'BRU'],

        /**
         * Array of months that will be displayed (Jan-Dec)
         *
         * @type {Array}
         */
        months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],

        /**
         * Chart data object for each city code by month
         *
         * @type {Object}
         */
        charts: {
            LON: [0, 19, 35, 23, 31, 47, 59, 29, 18, 38, 60, 32],
            ROM: [0, 24, 41, 44, 44, 62, 72, 58, 32, 31, 29, 19],
            PAR: [0, 20, 25, 34, 41, 53, 36, 28, 24, 21, 28, 15],
            BCN: [0, 21, 23, 29, 32, 38, 58, 40, 14, 26, 57, 22],
            BRU: [0, 22, 47, 54, 64, 74, 59, 53, 43, 42, 41, 23]
        }
    };

    /**
     * Translations for the cities in the banner
     *
     * @type {Object}
     */
    var translations = {
        en: {
            LON: 'London',
            ROM: 'Rome',
            PAR: 'Paris',
            BCN: 'Barcelona',
            BRU: 'Brussels'
        },
        ro: {
            LON: 'Londra',
            ROM: 'Roma',
            PAR: 'Paris',
            BCN: 'Barcelona',
            BRU: 'Bruxelles'
        }
    };

    /**
     * @name        IthIeftinuarieHpChartBannerController
     * @description Controller responsible for providing data for the homepage chart banner.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthIeftinuarieHpChartBannerController = function ($timeout, IthIeftinuarieService, AppConfig) {
        /**
         * Currently selected city
         *
         * @type {String}
         */
        var currentCity = null;

        /**
         * Current chart data
         *
         * @type {Object}
         */
        var currentData = {};

        /**
         * Returns the chart labels translated by momentjs library
         *
         * @returns {String[]}
         */
        var getChartLabels = function () {
            var translatedMonths = [];

            angular.forEach(staticBannerData.months, function (monthNumber) {
                translatedMonths.push(moment().month(monthNumber).format('MMM'));
            });

            return translatedMonths;
        };

        /**
         * Decides if this element is active (if January campaign is active)
         *
         * @returns {Boolean}
         */
        this.isActive = function () {
            return IthIeftinuarieService.isCampaignActive();
        };

        /**
         * Sets current city and coputes chart data for it
         *
         * @param {String} cityCode
         */
        this.setCity = function (cityCode) {
            currentCity = cityCode;

            currentData = {
                labels: getChartLabels(),
                series: [staticBannerData.charts[cityCode]]
            };
        };

        /**
         * Returns city codes displayes in the banner
         *
         * @returns {String[]}
         */
        this.getCities = function () {
            return staticBannerData.cityCodes;
        };

        /**
         * Returns currently active city code
         *
         * @returns {String}
         */
        this.getCurrentCity = function () {
            return currentCity;
        };

        /**
         * Returns translated city name by city code
         *
         * @param   {String} cityCode
         * @returns {String}
         */
        this.getCityName = function (cityCode) {
            return translations[AppConfig.getLanguageCode()][cityCode];
        };

        /**
         * Returns the chart data for current city
         *
         * @returns {Object}
         */
        this.getCurrentChartData = function () {
            return currentData;
        };

        /**
         * On init handler
         */
        this.$onInit = function () {
            var self = this;
            // Delay page to avoid chartist plugin error on page load
            $timeout(function () {
                self.setCity(staticBannerData.cityCodes[0]);
            }, 100);
        };
    };

    IthIeftinuarieHpChartBannerController.$inject = [
        '$timeout',
        'IthIeftinuarieService',
        'appConfig'
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .controller('IthIeftinuarieHpChartBannerController', IthIeftinuarieHpChartBannerController);

}(angular, moment));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-pax-banner.component.js
(function (angular) {
/**
     * @name        IeftinuariePaxBannerComponent
     * @description Component that shows Ieftinuarie discount of current price group.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var paxBannerComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/ieftinuarie/pax-banner',
        controller: 'IthIeftinuariePaxBannerController'
    };

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .component('ithIeftinuariePaxBanner', paxBannerComponent);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-pax-banner.controller.js
(function (angular) {
/**
     * @name        IthIeftinuariePaxBannerController
     * @description A controller responsible for showing Ieftinuarie discounts for some price groups.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthIeftinuariePaxBannerController = function (IthIeftinuarieService, IthAnniversaryService) {
        /**
         * Reference to campagin service.
         *
         * @type {IthIeftinuarieService}
         */
        this.campaignService = IthIeftinuarieService;

        /**
         * Opens the graph modal.
         *
         * @param {String} flightType
         */
        this.openInfoModal = function () {
            IthAnniversaryService.openInfoModal('vola-mkt-ieftinuarie-modal-box');
        };
    };

    IthIeftinuariePaxBannerController.$inject = [
        'IthIeftinuarieService',
        'IthAnniversaryService'
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .controller('IthIeftinuariePaxBannerController', IthIeftinuariePaxBannerController);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-pricegroup-marker.component.js
(function (angular) {
/**
     * @name        IeftinuariePricegroupMarkerComponent
     * @description Component that shows Ieftinuarie discount of current price group.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var pricegroupMarkerComponent = {
        templateUrl: '/tpl/show/jsShared/templates/base/components/ieftinuarie/pricegroup',
        controller: 'IthIeftinuariePricegroupMarkerController',
        bindings: {
            price: '<',
            index: '<'
        }
    };

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .component('ithIeftinuariePricegroupMarker', pricegroupMarkerComponent);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie-pricegroup-marker.controller.js
(function (angular) {
/**
     * @name        IthIeftinuariePricegroupMarkerController
     * @description A controller responsible for showing Ieftinuarie discounts for some price groups
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthIeftinuariePricegroupMarkerController = function (IthIeftinuarieService, $modal) {
        /**
         * Reference to campagin service.
         *
         * @type {IthIeftinuarieService}
         */
        this.campaignService = IthIeftinuarieService;

        /**
         * Opens the graph modal.
         *
         * @param {String} flightType
         */
        this.openGraphModal = function (price) {
            $modal.open({
                templateUrl: '/tpl/show/jsShared/templates/base/components/ieftinuarie/graph-modal',
                controller: 'IthIeftinuarieGraphModalController',
                windowClass: 'ieftinuarie-chart-modal',
                resolve: {
                    pricegroupPrice: function () {
                        return price;
                    }
                }
            });
        };
    };

    IthIeftinuariePricegroupMarkerController.$inject = [
        'IthIeftinuarieService',
        '$modal'
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .controller('IthIeftinuariePricegroupMarkerController', IthIeftinuariePricegroupMarkerController);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie.api.js
(function (angular) {
/**
     * @name        IeftinuarieApiService
     * @description Service responsible for making API calls to the Ieftinuarie endpoint.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IeftinuarieApiService = function (ApiTools) {
        /**
         * Endoints object
         * @type {Object}
         */
        var endpoints = {
            /**
             * Ieftinuarie reference prices API endpoint
             * @type {Object}
             */
            apiReferencePrices: {
                url: '/api/marketing/referencePrices/',
                method: 'GET',
                respParser: function (response) {
                    return response.response;
                }
            }
        };

        /**
         * Makes backend request to bring back departure flight prices for an array of months
         *
         * @param {String}   origCity
         * @param {String}   destCity
         * @param {String}   depDate
         * @param {Number}   owRt
         * @return {Promise}
         */
        this.getData = function (origCity, destCity, depDate, owRt) {
            var endpoint = angular.copy(endpoints.apiReferencePrices);
            endpoint.url += origCity + '/' + destCity + '/' + owRt + '/' + depDate;
            return ApiTools.fetchCache(this, endpoint);
        };

        return this;
    };

    IeftinuarieApiService.$inject = [
        'ApiTools',
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .service('IeftinuarieApiService', IeftinuarieApiService);

}(angular));
;

// Source: public_html/assets/js/app/components/campaigns/ieftinuarie/ieftinuarie.service.js
(function (angular, underscore, moment) {
/**
     * @name        IthIeftinuarieService
     * @description Service responsible for handling business logic for Ieftinuarie campaign.
     * @author      Angelin Sirbu <angelin.sirbu@vola.ro>
     */
    var IthIeftinuarieService = function (AppConfig, IeftinuarieApiService) {
        /**
         * Only discounts that are lower than this are considered discounts.
         *
         * @type {Number}
         */
        var discountTreshold = -2;

        /**
         * Reference prices for the campaign.
         *
         * @type {Object[]}
         */
        var referencePrices = [];

        /**
         * Reference prices are considered until this date.
         *
         * @type {Number}
         */
        var referenceDepMonth = 0;

        /**
         * Checks if there are reference prices set.
         *
         * @returns {Boolean}
         */
        var hasReferencePrices = function () {
            return referencePrices.length > 0;
        };

        /**
         * Returns data only until departure date.
         *
         * @returns {Object[]}
         */
        var getFilteredData = function () {
            // Get months until departure (included)
            var rangeResults = underscore.filter(referencePrices, function (pricing) {
                return parseInt(pricing.month) <= referenceDepMonth;
            });

            return rangeResults;
        };

        /**
         * Checks if future prices (until departure month) are bigger.
         *
         * @param   {Number}  price
         * @returns {Boolean}
         */
        var futurePricesAreBigger = function (price) {
            var filteredData = getFilteredData();

            // Find prices smaller that the price group price
            var minimumPriceData = underscore.find(filteredData, function (entry) {
                return entry.price < price;
            });

            return minimumPriceData === undefined;
        };

        /**
         * Margin of price on this route.
         *
         * @returns {Number}
         */
        var getPriceMargin = function () {
            var filteredData = getFilteredData();

            // Find month reference price
            var monthReferencePrice = underscore.find(filteredData, function (pricing) {
                return parseInt(pricing.month) === referenceDepMonth;
            });

            return monthReferencePrice !== undefined ? parseFloat(monthReferencePrice.price) : Math.infinity;
        };

        /**
         * Calculates rounded percent based on two values.
         *
         * @returns {Number}
         */
        var calculateRoundedPercent = function (value1, value2) {
            return Math.round((parseFloat(value1) - parseFloat(value2)) / parseFloat(value2) * 100);
        };

        /**
         * Determines if marker should be shown on price group.
         *
         * @returns {Boolean}
         */
        this.showMarker = function (price) {
            return this.isCampaignActive() && hasReferencePrices() && futurePricesAreBigger(price) && this.getIeftinuarieDiscount(price) < discountTreshold;
        };

        /**
         * Decides if campaign message fallback is shown on the price group.
         *
         * @param   {Number}  price
         * @param   {Number}  index
         * @returns {Boolean}
         */
        this.showCampaignMessage = function (price, index) {
            return !this.showMarker(price) && this.isCampaignActive() && (index < 10 || index === undefined);
        };

        /**
         * Returns amount of discount based on price.
         *
         * @param   {Number} price
         * @returns {String}
         */
        this.getIeftinuarieDiscount = function (price) {
            var priceMargin = getPriceMargin();
            return calculateRoundedPercent(price, priceMargin);
        };

        /**
         * Returns reference prices by flight type and until departure month.
         *
         * @param   {Number} pricegroupPrice
         * @returns {Object[]}
         */
        this.getGraphData = function (pricegroupPrice) {
            // Consider only until dep date month
            var untilDepartureData = underscore.filter(referencePrices, function (pricing) {
                return parseInt(pricing.month) <= parseInt(referenceDepMonth);
            });

            // Build in chartist format
            var chartistData = {
                labels: ['Ian'],
                series: [[0]]
            };

            var months = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec'];

            underscore.each(untilDepartureData, function (pricing) {
                var monthName = months[pricing.month];
                var monthPercentDifference = -1 * calculateRoundedPercent(pricegroupPrice, pricing.price);
                chartistData.labels.push(monthName);
                chartistData.series[0].push(monthPercentDifference);
            });

            return chartistData;
        };

        /**
         * Decides if campaign is visible or not.
         *
         * @returns {Boolean}
         */
        this.isCampaignActive = function () {
            return AppConfig.getIeftinuarieConfig();
        };

        /**
         * Loads reference prices from API
         *
         * @param {SearchQueryParams} searchQueryParams
         */
        this.loadReferencePrices = function (searchQueryParams) {
            if (!this.isCampaignActive()) {
                return;
            }

            // Reset reference prices
            referencePrices = [];

            // Prepare params
            var origCity = searchQueryParams.getDepCityCode();
            var destCity = searchQueryParams.getDesCityCode();
            var depDate = searchQueryParams.getDepDate();
            var owRt = searchQueryParams.isOneWay() ? 1 : 0;
            referenceDepMonth = moment(depDate).month();

            IeftinuarieApiService
                .getData(origCity, destCity, depDate, owRt)
                .then(function (success) {
                    // Set reference prices
                    referencePrices = success.data;
                });
        };
    };

    IthIeftinuarieService.$inject = [
        'appConfig',
        'IeftinuarieApiService'
    ];

    angular
        .module('ITH.vola.campaigns.ieftinuarie')
        .service('IthIeftinuarieService', IthIeftinuarieService);

}(angular, _, moment));
;

// Source: public_html/assets/js/app/config.js
angular.module('vola')

/* Configure $http service to combine processing of multiple http responses
 received at around the same time via $rootScope.$applyAsync. This can result in
 significant performance improvement for bigger applications that make many HTTP
 requests concurrently (common during application bootstrap). */
    .config(['$httpProvider', '$compileProvider', function ($httpProvider, $compileProvider) {
        $httpProvider.useApplyAsync(true);
        if (_js_app_config_.env_name !== 'local') $compileProvider.debugInfoEnabled(false);
    }])

    /**
     * Provide JavaScript error logging to server
     */
    .config(['$provide', function ($provide) {

        var seenErrors = [];

        /**
         * Decorate $exceptionHandler with new functionality
         */
        $provide.decorator("$exceptionHandler",
            ['$delegate', '$injector',
                function ($delegate, $injector) {
                    return function (exception, cause) {

                        var
                            /**
                             * Decide to send JS error to server or not.
                             *
                             * @type {boolean}
                             */
                            sendError,

                            /**
                             * The string representation of the error.
                             *
                             * Used also as array index.
                             *
                             * @type {string}
                             */
                            errorStr = exception.toString();

                        if (seenErrors.indexOf(errorStr) != -1) {
                            // Do nothing when we already seen this error.
                            // Potential problem is we may not log the exceptions that are thrown by
                            // long lived application.
                            sendError = false;
                        } else {
                            seenErrors.push(errorStr);
                            sendError = true;
                        }

                        // Reset seen errors. If we have a lot of them there is something wrong and we want to know about it.
                        if (seenErrors.length > 10000) {
                            seenErrors = [];
                        }

                        $delegate(exception, cause);
                        var errorLogService = $injector.get("ErrorLogService");

                        if (sendError) {
                            errorLogService.sendErrorLog(exception, cause);
                        }
                    };
                }]);
    }])

.run(['$rootScope', function ($rootScope) {
$rootScope.affiliate = 'vola';
}])
.constant('CONST', {
    CARRIER: {
        WIZZ_AIR: ['W6', 'W6W'],
        RYANAIR: ['FR'],
        BLUEAIR: ['0B'],
    },
    LUGGAGE: {
        CABIN_DEFAULT: 'BAG2.1',
        PRIORITY_BAG: 'BAG2.2',
        PRIORITY_REPLACEMENT_BAG: 'BAG2.3',
    },
    RESPONSE: {
        VERSION: {
            CONFIRMATION: 1,
            PAYMENT: 2,
            PRICE_DIFF: 3,
            BASIC_REDIRECT: 4,
            TOKEN_PAYU: 'TokenPayU',
            MOBILPAY: 'MobilPay',
            PAYMENT_INIT: 'PaymentInitFlow'
        }
    }
});
;

// Source: public_html/assets/js/app/controllers/HomeCtrl.js
angular.module('base')

/**
 * @name        HomeCtrl
 * @description Controls the homepage
 */
.controller('HomeCtrl',
['$scope', '$controller',
function HomeCtrl($scope, $controller) {
angular.extend(this, $controller('NgStaticPageCtrl', {$scope: $scope}));
}]);
